// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"1Glst":[function(require,module,exports,__globalThis) {
//import 'react-toastify/dist/ReactToastify.css';
//import "primereact/resources/themes/lara-light-cyan/theme.css";
// Straight Exports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRoot", ()=>(0, _client.createRoot));
parcelHelpers.export(exports, "createElement", ()=>(0, _react.createElement));
parcelHelpers.export(exports, "createContext", ()=>(0, _react.createContext));
parcelHelpers.export(exports, "useEffect", ()=>(0, _react.useEffect));
parcelHelpers.export(exports, "useReducer", ()=>(0, _react.useReducer));
parcelHelpers.export(exports, "useContext", ()=>(0, _react.useContext));
parcelHelpers.export(exports, "useCallback", ()=>(0, _react.useCallback));
parcelHelpers.export(exports, "useRef", ()=>(0, _react.useRef));
parcelHelpers.export(exports, "useMemo", ()=>(0, _react.useMemo));
parcelHelpers.export(exports, "useState", ()=>(0, _react.useState));
parcelHelpers.export(exports, "createRef", ()=>(0, _react.createRef));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouterDom.useParams));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouterDom.useNavigate));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouterDom.useLocation));
parcelHelpers.export(exports, "useSearchParams", ()=>(0, _reactRouterDom.useSearchParams));
parcelHelpers.export(exports, "BrowserRouter", ()=>(0, _reactRouterDom.BrowserRouter));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouterDom.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouterDom.Route));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouterDom.Routes));
parcelHelpers.export(exports, "Link", ()=>(0, _reactRouterDom.Link));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouterDom.matchPath));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouterDom.generatePath));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouterDom.useMatch));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouterDom.Navigate));
parcelHelpers.export(exports, "Button", ()=>(0, _reactBootstrap.Button));
parcelHelpers.export(exports, "Card", ()=>(0, _reactBootstrap.Card));
parcelHelpers.export(exports, "Alert", ()=>(0, _reactBootstrap.Alert));
parcelHelpers.export(exports, "Modal", ()=>(0, _reactBootstrap.Modal));
parcelHelpers.export(exports, "Col", ()=>(0, _reactBootstrap.Col));
parcelHelpers.export(exports, "Form", ()=>(0, _reactBootstrap.Form));
parcelHelpers.export(exports, "Row", ()=>(0, _reactBootstrap.Row));
parcelHelpers.export(exports, "Image", ()=>(0, _reactBootstrap.Image));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _reactBootstrap.Dropdown));
parcelHelpers.export(exports, "Badge", ()=>(0, _reactBootstrap.Badge));
parcelHelpers.export(exports, "Accordion", ()=>(0, _reactBootstrap.Accordion));
parcelHelpers.export(exports, "Tabs", ()=>(0, _reactBootstrap.Tabs));
parcelHelpers.export(exports, "Tab", ()=>(0, _reactBootstrap.Tab));
parcelHelpers.export(exports, "Table", ()=>(0, _reactBootstrap.Table));
parcelHelpers.export(exports, "ToastContainer", ()=>(0, _reactToastify.ToastContainer));
parcelHelpers.export(exports, "toast", ()=>(0, _reactToastify.toast));
parcelHelpers.export(exports, "JoditEditor", ()=>(0, _joditReactDefault.default));
parcelHelpers.export(exports, "PrimeReactProvider", ()=>(0, _api.PrimeReactProvider));
//export { Provider as ReduxProvider } from 'react-redux';
parcelHelpers.export(exports, "Swal", ()=>(0, _sweetalert2Default.default)) // Forwards
;
parcelHelpers.export(exports, "stringifyQueryString", ()=>stringifyQueryString);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _client = require("react-dom/client");
var _react = require("react");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _reactRouterDom = require("react-router-dom");
var _reactBootstrap = require("react-bootstrap");
var _reactToastify = require("react-toastify");
var _joditReact = require("jodit-react");
var _joditReactDefault = parcelHelpers.interopDefault(_joditReact);
var _api = require("primereact/api");
var _sweetalert2 = require("sweetalert2");
var _sweetalert2Default = parcelHelpers.interopDefault(_sweetalert2);
const { stringify: stringifyQueryString, parse: parseQueryString } = (0, _queryStringDefault.default);

},{"react-dom/client":"hx7eL","react":"9njXz","query-string":"h6dFx","react-router-dom":"6bTrz","react-bootstrap":"f5rnA","react-toastify":"9WKTx","jodit-react":"gUiuP","primereact/api":"bZDMG","sweetalert2":"a8sNt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hx7eL":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"iz332"}],"iz332":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var process = require("83aa8abb4638fd84");
"use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, assign = Object.assign, prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = getOwnHostContext(fiber), nextRootInstance = getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, nextRootInstance);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function onCommitRoot(root) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
        injectedHook.onCommitFiberRoot(rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionLane = 128, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194176) && (nextTransitionLane = 128);
    return lane;
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node) {
    var valueField = isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    node._valueTracker || (node._valueTracker = trackValueOnNode(node));
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$283;
    if (canUseDOM) {
        var isSupported$jscomp$inline_418 = "oninput" in document;
        if (!isSupported$jscomp$inline_418) {
            var element$jscomp$inline_419 = document.createElement("div");
            element$jscomp$inline_419.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_418 = "function" === typeof element$jscomp$inline_419.oninput;
        }
        JSCompiler_inline_result$jscomp$283 = isSupported$jscomp$inline_418;
    } else JSCompiler_inline_result$jscomp$283 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = getNodeForCharacterOffset(containerInfo, start);
                var endMarker = getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {}, CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            track(instance);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 3:
        case 27:
            rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            rootOrSingletonContext = !1;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            nextHydratableInstance = null;
        }
    } else nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function noop$3() {}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$3, noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === SuspenseException) throw Error(formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === SuspenseException) throw Error(formatProdErrorMessage(483));
                    throw thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var thenableState$1 = null, thenableIndexCounter$1 = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && (shellBoundary = fiber);
        }
    } else reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var renderLanes = 0, currentlyRenderingFiber$1 = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber$1 = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber$1 = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber$1.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber$1.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber$1.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
var createFunctionComponentUpdateQueue;
createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function useThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index);
    index = currentlyRenderingFiber$1;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber$1.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber$1.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber$1, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushEffect(9, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 60) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        onActionError(actionQueue, node, error$60);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber$1;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && (currentlyRenderingFiber$1.flags |= 2048, pushEffect(9, actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = currentlyRenderingFiber$1.updateQueue;
    null === create && (create = createFunctionComponentUpdateQueue(), currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushEffect(hookFlags, create, inst, deps) : (currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = pushEffect(1 | hookFlags, create, inst, deps));
}
function mountEffect(create, deps) {
    mountEffectImpl(8390656, 8, create, deps);
}
function updateEffect(create, deps) {
    updateEffectImpl(2048, 8, create, deps);
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber$1.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber$1.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function noop$2() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop$2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$63 = enqueueUpdate(provider, fiber, lane);
                null !== root$63 && (scheduleUpdateOnFiber(root$63, provider, lane), entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber$1 || null !== alternate && alternate === currentlyRenderingFiber$1;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError
};
ContextOnlyDispatcher.useCacheRefresh = throwInvalidHookError;
ContextOnlyDispatcher.useMemoCache = throwInvalidHookError;
ContextOnlyDispatcher.useHostTransitionStatus = throwInvalidHookError;
ContextOnlyDispatcher.useFormState = throwInvalidHookError;
ContextOnlyDispatcher.useActionState = throwInvalidHookError;
ContextOnlyDispatcher.useOptimistic = throwInvalidHookError;
var HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 60) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushEffect(9, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber$1);
    }
};
HooksDispatcherOnMount.useMemoCache = useMemoCache;
HooksDispatcherOnMount.useHostTransitionStatus = useHostTransitionStatus;
HooksDispatcherOnMount.useFormState = mountActionState;
HooksDispatcherOnMount.useActionState = mountActionState;
HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId
};
HooksDispatcherOnUpdate.useCacheRefresh = updateRefresh;
HooksDispatcherOnUpdate.useMemoCache = useMemoCache;
HooksDispatcherOnUpdate.useHostTransitionStatus = useHostTransitionStatus;
HooksDispatcherOnUpdate.useFormState = updateActionState;
HooksDispatcherOnUpdate.useActionState = updateActionState;
HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = updateWorkInProgressHook();
    return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
};
var HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId
};
HooksDispatcherOnRerender.useCacheRefresh = updateRefresh;
HooksDispatcherOnRerender.useMemoCache = useMemoCache;
HooksDispatcherOnRerender.useHostTransitionStatus = useHostTransitionStatus;
HooksDispatcherOnRerender.useFormState = rerenderActionState;
HooksDispatcherOnRerender.useActionState = rerenderActionState;
HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = updateWorkInProgressHook();
    if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
        process.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            if (isHydrating) {
                var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== treeContextProvider ? {
                            id: treeContextId,
                            overflow: treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = showFallback);
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            }
            "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(nextInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                pushProvider(workInProgress, CacheContext, nextProps);
                nextProps !== init.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError(lazyComponent);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for(nextHydratableInstance = getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !0, renderLanes = mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[internalInstanceKey] = workInProgress, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes, current), markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (lazyComponent = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || isHydrating ? reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if (init = lazyComponent = nextHydratableInstance) lazyComponent = canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild), rootOrSingletonContext = !1, init = !0) : init = !1;
                init || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = init);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, lazyComponent.value), reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return prepareToReadContext(workInProgress), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, nextProps = createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, init)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), pushProvider(workInProgress, CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, pushProvider(workInProgress, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
var valueCursor = createCursor(null), currentlyRenderingFiber = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, shouldFireAfterActiveInstanceBlur = !1;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
    resolvedPrevProps = shouldFireAfterActiveInstanceBlur;
    shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevProps;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? safelyAttachRef(finishedWork, finishedWork.return) : safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            detachDeletedInstance(deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = hostParent;
            var prevHostParentIsContainer$119 = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParentIsContainer;
            hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    finishedRoot = hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (nearestMountedAncestor = hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), retryIfBlockedOn(nearestMountedAncestor)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[internalInstanceKey] = finishedWork;
                    hoistableRoot[internalPropsKey] = currentResource;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = offscreenSubtreeIsHidden;
            type = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = nodeName || node;
            offscreenSubtreeWasHidden = type || nextNode;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = type;
            offscreenSubtreeIsHidden = nodeName;
            commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = offscreenSubtreeIsHidden || offscreenSubtreeWasHidden, null === current || nextNode || root || recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if (isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error(formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = getHostSibling(finishedWork);
                        insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && (setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = getHostSibling(finishedWork);
                        insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = getHostSibling(finishedWork);
                        insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error(formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case REACT_OFFSCREEN_TYPE:
            return createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_PROVIDER_TYPE:
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error(formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error(formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        resource = suspenseHandlerStackCursor.current;
        if (null !== resource && ((workInProgressRootRenderLanes & 4194176) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary)) throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== hydrationErrors && (queueRecoverableErrors(hydrationErrors), hydrationErrors = null));
            bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? (markUpdate(workInProgress), null !== renderLanes ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[internalInstanceKey] = workInProgress;
                    current[internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch(setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else null !== hydrationErrors && (queueRecoverableErrors(hydrationErrors), hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = now(), workInProgress.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, rootDoesHavePassiveEffects = !1, rootWithPendingPassiveEffects = null, pendingPassiveEffectsLanes = 0, pendingPassiveEffectsRemainingLanes = 0, pendingPassiveTransitions = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
        var actionScopeLane = currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
}
function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && 2 === workInProgressSuspendedReason || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) markRootSuspended(root$jscomp$0, lanes, 0, !workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + 300 - now(), 10 < renderWasConcurrent)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function queueRecoverableErrors(errors) {
    null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = errors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: noop
        }, accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork(commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194176) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === workInProgressSuspendedReason && workInProgressRoot === root && (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : 1) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        handleThrow(root, thrownValue$166);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrent() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = ReactSharedInternals.T, previousUpdateLanePriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, ReactSharedInternals.T = null, commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        ReactSharedInternals.T = prevTransition, ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do flushPassiveEffects();
    while (null !== rootWithPendingPassiveEffects);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= concurrentlyUpdatedLanes;
    markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || rootDoesHavePassiveEffects || (rootDoesHavePassiveEffects = !0, pendingPassiveEffectsRemainingLanes = remainingLanes, pendingPassiveTransitions = transitions, scheduleCallback$1(NormalPriority$1, function() {
        flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = ReactSharedInternals.T, ReactSharedInternals.T = null, spawnedLane = ReactDOMSharedInternals.p, ReactDOMSharedInternals.p = 2, updatedLanes = executionContext, executionContext |= 4, commitBeforeMutationEffects(root, finishedWork), commitMutationEffectsOnFiber(finishedWork, root), restoreSelection(selectionInformation, root.containerInfo), _enabled = !!eventsEnabled, selectionInformation = eventsEnabled = null, root.current = finishedWork, commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), requestPaint(), executionContext = updatedLanes, ReactDOMSharedInternals.p = spawnedLane, ReactSharedInternals.T = transitions) : root.current = finishedWork;
    rootDoesHavePassiveEffects ? (rootDoesHavePassiveEffects = !1, rootWithPendingPassiveEffects = root, pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
    onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== (pendingPassiveEffectsLanes & 3) && flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
    flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPassiveEffects() {
    if (null !== rootWithPendingPassiveEffects) {
        var root$170 = rootWithPendingPassiveEffects, remainingLanes = pendingPassiveEffectsRemainingLanes;
        pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            ReactSharedInternals.T = null;
            if (null === rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = pendingPassiveTransitions;
                pendingPassiveTransitions = null;
                var root = rootWithPendingPassiveEffects, lanes = pendingPassiveEffectsLanes;
                rootWithPendingPassiveEffects = null;
                pendingPassiveEffectsLanes = 0;
                if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
                var prevExecutionContext = executionContext;
                executionContext |= 4;
                commitPassiveUnmountOnFiber(root.current);
                commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                executionContext = prevExecutionContext;
                flushSyncWorkAcrossRoots_impl(0, !1);
                if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                    injectedHook.onPostCommitFiberRoot(rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateTask(processRootScheduleInMicrotask));
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$172, root$172 === workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if (flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPassiveEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateTask(cb) {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, cb) : cb();
    });
}
function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1439 = 0; i$jscomp$inline_1439 < simpleEventPluginEvents.length; i$jscomp$inline_1439++){
    var eventName$jscomp$inline_1440 = simpleEventPluginEvents[i$jscomp$inline_1439], domEventName$jscomp$inline_1441 = eventName$jscomp$inline_1440.toLowerCase(), capitalizedEvent$jscomp$inline_1442 = eventName$jscomp$inline_1440[0].toUpperCase() + eventName$jscomp$inline_1440.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1441, "on" + capitalizedEvent$jscomp$inline_1442);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = getParent(inCapturePhase);
                                reactEventName = getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function noop$1() {}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            track(domElement);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    retryIfBlockedOn(suspenseInstance);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$242 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$242 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, markNodeAsHoistable(instance$248), instance$248;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$248)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var suspendedState = null;
function noop() {}
function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = requestUpdateLane(), root = enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && scheduleUpdateOnFiber(root, nearestMounted, lane);
                            markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && flushPassiveEffects();
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1686 = React.version;
if ("19.0.0" !== isomorphicReactPackageVersion$jscomp$inline_1686) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    findFiberByHostInstance: getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2166.isDisabled && hook$jscomp$inline_2166.supportsFiber) try {
        rendererID = hook$jscomp$inline_2166.inject(internals$jscomp$inline_2165), injectedHook = hook$jscomp$inline_2166;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    markRootUpdated$1(initialChildren, isStrictMode);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.0.0";

},{"83aa8abb4638fd84":"5jT8D","934b50a50c275743":"eTyLO","56d30b16d84cc622":"9njXz","d42dbe4aacaa6df4":"2ApDx"}],"5jT8D":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"eTyLO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c2333c22ee790411");

},{"c2333c22ee790411":"bpSkb"}],"bpSkb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, requestHostCallback();
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostCallback() {
    isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
}
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_continueExecution = function() {
    isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, requestHostCallback());
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_getFirstCallbackNode = function() {
    return peek(taskQueue);
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, requestHostCallback()));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"9njXz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"iBVvr"}],"iBVvr":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var process = require("f617887c825dec26");
"use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
        process.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.0.0";

},{"f617887c825dec26":"5jT8D"}],"2ApDx":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"iI5OW"}],"iI5OW":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.0.0";

},{"6a05e75e64e4f862":"9njXz"}],"h6dFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
exports.default = _baseJs;

},{"./base.js":"ldO3X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ldO3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extract", ()=>extract);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
parcelHelpers.export(exports, "stringifyUrl", ()=>stringifyUrl);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "exclude", ()=>exclude);
var _decodeUriComponent = require("decode-uri-component");
var _decodeUriComponentDefault = parcelHelpers.interopDefault(_decodeUriComponent);
var _filterObj = require("filter-obj");
var _splitOnFirst = require("split-on-first");
var _splitOnFirstDefault = parcelHelpers.interopDefault(_splitOnFirst);
const isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = (string)=>encodeURIComponent(string).replaceAll(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '[',
                            encode(index, options),
                            ']=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '[]=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            ':list=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSeparator = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                encode(key, options),
                                keyValueSeparator,
                                encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '=',
                            encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : decode(value, options).split(options.arrayFormatSeparator);
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return (0, _decodeUriComponentDefault.default)(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function parseValue(value, options, type) {
    if (type === 'string' && typeof value === 'string') return value;
    if (typeof type === 'function' && typeof value === 'string') return type(value);
    if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) return value.toLowerCase() === 'true';
    if (type === 'number' && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return Number(value);
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return Number(value);
    return value;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function parse(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false,
        types: Object.create(null),
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== 'string') return returnValue;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return returnValue;
    for (const parameter of query.split('&')){
        if (parameter === '') continue;
        const parameter_ = options.decode ? parameter.replaceAll('+', ' ') : parameter;
        let [key, value] = (0, _splitOnFirstDefault.default)(parameter_, '=');
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === 'object' && value !== null && options.types[key] !== 'string') for (const [key2, value2] of Object.entries(value)){
            const type = options.types[key] ? options.types[key].replace('[]', '') : undefined;
            value[key2] = parseValue(value2, options, type);
        }
        else if (typeof value === 'object' && value !== null && options.types[key] === 'string') returnValue[key] = Object.values(value).join(options.arrayFormatSeparator);
        else returnValue[key] = parseValue(value, options, options.types[key]);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === 'object' && !Array.isArray(value) ? keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function stringify(object, options) {
    if (!object) return '';
    options = {
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return encode(key, options) + '=' + encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
}
function parseUrl(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, _splitOnFirstDefault.default)(url, '#');
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split('?')?.[0] ?? '',
        query: parse(extract(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: decode(hash, options)
        } : {}
    };
}
function stringifyUrl(object, options) {
    options = {
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true,
        ...options
    };
    const url = removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = extract(object.url);
    const query = {
        ...parse(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = stringify(query, options);
    queryString &&= `?${queryString}`;
    let hash = getHash(object.url);
    if (typeof object.fragmentIdentifier === 'string') {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function pick(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false,
        ...options
    };
    const { url, query, fragmentIdentifier } = parseUrl(input, options);
    return stringifyUrl({
        url,
        query: (0, _filterObj.includeKeys)(query, filter),
        fragmentIdentifier
    }, options);
}
function exclude(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return pick(input, exclusionFilter, options);
}

},{"decode-uri-component":"diofT","filter-obj":"d7zD9","split-on-first":"3Kl5z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diofT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>decodeUriComponent);
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match(singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join('');
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    let match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    return input;
}
function decodeUriComponent(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiucr":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"d7zD9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "includeKeys", ()=>includeKeys);
parcelHelpers.export(exports, "excludeKeys", ()=>excludeKeys);
function includeKeys(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function excludeKeys(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return includeKeys(object, (key)=>!set.has(key));
    }
    return includeKeys(object, (key, value, object)=>!predicate(key, value, object));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Kl5z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>splitOnFirst);
function splitOnFirst(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (string === '' || separator === '') return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6bTrz":[function(require,module,exports,__globalThis) {
/**
 * react-router-dom v7.1.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HydratedRouter", ()=>(0, _dom.HydratedRouter));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _dom.RouterProvider));
var _dom = require("react-router/dom");
var _reactRouter = require("react-router");
parcelHelpers.exportAll(_reactRouter, exports);

},{"react-router/dom":false,"react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iaz4C":[function(require,module,exports,__globalThis) {
/**
 * react-router v7.1.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Await", ()=>(0, _chunkK6AXKMTTMjs.Await));
parcelHelpers.export(exports, "BrowserRouter", ()=>(0, _chunkK6AXKMTTMjs.BrowserRouter));
parcelHelpers.export(exports, "Form", ()=>(0, _chunkK6AXKMTTMjs.Form));
parcelHelpers.export(exports, "HashRouter", ()=>(0, _chunkK6AXKMTTMjs.HashRouter));
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>(0, _chunkK6AXKMTTMjs.IDLE_BLOCKER));
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>(0, _chunkK6AXKMTTMjs.IDLE_FETCHER));
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>(0, _chunkK6AXKMTTMjs.IDLE_NAVIGATION));
parcelHelpers.export(exports, "Link", ()=>(0, _chunkK6AXKMTTMjs.Link));
parcelHelpers.export(exports, "Links", ()=>(0, _chunkK6AXKMTTMjs.Links));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _chunkK6AXKMTTMjs.MemoryRouter));
parcelHelpers.export(exports, "Meta", ()=>(0, _chunkK6AXKMTTMjs.Meta));
parcelHelpers.export(exports, "NavLink", ()=>(0, _chunkK6AXKMTTMjs.NavLink));
parcelHelpers.export(exports, "Navigate", ()=>(0, _chunkK6AXKMTTMjs.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _chunkK6AXKMTTMjs.Action));
parcelHelpers.export(exports, "Outlet", ()=>(0, _chunkK6AXKMTTMjs.Outlet));
parcelHelpers.export(exports, "PrefetchPageLinks", ()=>(0, _chunkK6AXKMTTMjs.PrefetchPageLinks));
parcelHelpers.export(exports, "Route", ()=>(0, _chunkK6AXKMTTMjs.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _chunkK6AXKMTTMjs.Router));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _chunkK6AXKMTTMjs.RouterProvider));
parcelHelpers.export(exports, "Routes", ()=>(0, _chunkK6AXKMTTMjs.Routes));
parcelHelpers.export(exports, "Scripts", ()=>(0, _chunkK6AXKMTTMjs.Scripts));
parcelHelpers.export(exports, "ScrollRestoration", ()=>(0, _chunkK6AXKMTTMjs.ScrollRestoration));
parcelHelpers.export(exports, "ServerRouter", ()=>(0, _chunkK6AXKMTTMjs.ServerRouter));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _chunkK6AXKMTTMjs.StaticRouter));
parcelHelpers.export(exports, "StaticRouterProvider", ()=>(0, _chunkK6AXKMTTMjs.StaticRouterProvider));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _chunkK6AXKMTTMjs.DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _chunkK6AXKMTTMjs.DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _chunkK6AXKMTTMjs.ErrorResponseImpl));
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>(0, _chunkK6AXKMTTMjs.FetchersContext));
parcelHelpers.export(exports, "UNSAFE_FrameworkContext", ()=>(0, _chunkK6AXKMTTMjs.FrameworkContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _chunkK6AXKMTTMjs.LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _chunkK6AXKMTTMjs.NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RemixErrorBoundary", ()=>(0, _chunkK6AXKMTTMjs.RemixErrorBoundary));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _chunkK6AXKMTTMjs.RouteContext));
parcelHelpers.export(exports, "UNSAFE_ServerMode", ()=>(0, _chunkK6AXKMTTMjs.ServerMode));
parcelHelpers.export(exports, "UNSAFE_SingleFetchRedirectSymbol", ()=>(0, _chunkK6AXKMTTMjs.SingleFetchRedirectSymbol));
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>(0, _chunkK6AXKMTTMjs.ViewTransitionContext));
parcelHelpers.export(exports, "UNSAFE_createBrowserHistory", ()=>(0, _chunkK6AXKMTTMjs.createBrowserHistory));
parcelHelpers.export(exports, "UNSAFE_createClientRoutes", ()=>(0, _chunkK6AXKMTTMjs.createClientRoutes));
parcelHelpers.export(exports, "UNSAFE_createClientRoutesWithHMRRevalidationOptOut", ()=>(0, _chunkK6AXKMTTMjs.createClientRoutesWithHMRRevalidationOptOut));
parcelHelpers.export(exports, "UNSAFE_createRouter", ()=>(0, _chunkK6AXKMTTMjs.createRouter));
parcelHelpers.export(exports, "UNSAFE_decodeViaTurboStream", ()=>(0, _chunkK6AXKMTTMjs.decodeViaTurboStream));
parcelHelpers.export(exports, "UNSAFE_deserializeErrors", ()=>(0, _chunkK6AXKMTTMjs.deserializeErrors));
parcelHelpers.export(exports, "UNSAFE_getPatchRoutesOnNavigationFunction", ()=>(0, _chunkK6AXKMTTMjs.getPatchRoutesOnNavigationFunction));
parcelHelpers.export(exports, "UNSAFE_getSingleFetchDataStrategy", ()=>(0, _chunkK6AXKMTTMjs.getSingleFetchDataStrategy));
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>(0, _chunkK6AXKMTTMjs.invariant));
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>(0, _chunkK6AXKMTTMjs.mapRouteProperties));
parcelHelpers.export(exports, "UNSAFE_shouldHydrateRouteLoader", ()=>(0, _chunkK6AXKMTTMjs.shouldHydrateRouteLoader));
parcelHelpers.export(exports, "UNSAFE_useFogOFWarDiscovery", ()=>(0, _chunkK6AXKMTTMjs.useFogOFWarDiscovery));
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>(0, _chunkK6AXKMTTMjs.useScrollRestoration));
parcelHelpers.export(exports, "createBrowserRouter", ()=>(0, _chunkK6AXKMTTMjs.createBrowserRouter));
parcelHelpers.export(exports, "createCookie", ()=>(0, _chunkK6AXKMTTMjs.createCookie));
parcelHelpers.export(exports, "createCookieSessionStorage", ()=>(0, _chunkK6AXKMTTMjs.createCookieSessionStorage));
parcelHelpers.export(exports, "createHashRouter", ()=>(0, _chunkK6AXKMTTMjs.createHashRouter));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _chunkK6AXKMTTMjs.createMemoryRouter));
parcelHelpers.export(exports, "createMemorySessionStorage", ()=>(0, _chunkK6AXKMTTMjs.createMemorySessionStorage));
parcelHelpers.export(exports, "createPath", ()=>(0, _chunkK6AXKMTTMjs.createPath));
parcelHelpers.export(exports, "createRequestHandler", ()=>(0, _chunkK6AXKMTTMjs.createRequestHandler));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _chunkK6AXKMTTMjs.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _chunkK6AXKMTTMjs.createRoutesFromElements));
parcelHelpers.export(exports, "createRoutesStub", ()=>(0, _chunkK6AXKMTTMjs.createRoutesStub));
parcelHelpers.export(exports, "createSearchParams", ()=>(0, _chunkK6AXKMTTMjs.createSearchParams));
parcelHelpers.export(exports, "createSession", ()=>(0, _chunkK6AXKMTTMjs.createSession));
parcelHelpers.export(exports, "createSessionStorage", ()=>(0, _chunkK6AXKMTTMjs.createSessionStorage));
parcelHelpers.export(exports, "createStaticHandler", ()=>(0, _chunkK6AXKMTTMjs.createStaticHandler));
parcelHelpers.export(exports, "createStaticRouter", ()=>(0, _chunkK6AXKMTTMjs.createStaticRouter));
parcelHelpers.export(exports, "data", ()=>(0, _chunkK6AXKMTTMjs.data));
parcelHelpers.export(exports, "generatePath", ()=>(0, _chunkK6AXKMTTMjs.generatePath));
parcelHelpers.export(exports, "isCookie", ()=>(0, _chunkK6AXKMTTMjs.isCookie));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _chunkK6AXKMTTMjs.isRouteErrorResponse));
parcelHelpers.export(exports, "isSession", ()=>(0, _chunkK6AXKMTTMjs.isSession));
parcelHelpers.export(exports, "matchPath", ()=>(0, _chunkK6AXKMTTMjs.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _chunkK6AXKMTTMjs.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _chunkK6AXKMTTMjs.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _chunkK6AXKMTTMjs.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _chunkK6AXKMTTMjs.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _chunkK6AXKMTTMjs.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _chunkK6AXKMTTMjs.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _chunkK6AXKMTTMjs.resolvePath));
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>(0, _chunkK6AXKMTTMjs.HistoryRouter));
parcelHelpers.export(exports, "unstable_setDevServerHooks", ()=>(0, _chunkK6AXKMTTMjs.setDevServerHooks));
parcelHelpers.export(exports, "unstable_usePrompt", ()=>(0, _chunkK6AXKMTTMjs.usePrompt));
parcelHelpers.export(exports, "useActionData", ()=>(0, _chunkK6AXKMTTMjs.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _chunkK6AXKMTTMjs.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _chunkK6AXKMTTMjs.useAsyncValue));
parcelHelpers.export(exports, "useBeforeUnload", ()=>(0, _chunkK6AXKMTTMjs.useBeforeUnload));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _chunkK6AXKMTTMjs.useBlocker));
parcelHelpers.export(exports, "useFetcher", ()=>(0, _chunkK6AXKMTTMjs.useFetcher));
parcelHelpers.export(exports, "useFetchers", ()=>(0, _chunkK6AXKMTTMjs.useFetchers));
parcelHelpers.export(exports, "useFormAction", ()=>(0, _chunkK6AXKMTTMjs.useFormAction));
parcelHelpers.export(exports, "useHref", ()=>(0, _chunkK6AXKMTTMjs.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _chunkK6AXKMTTMjs.useInRouterContext));
parcelHelpers.export(exports, "useLinkClickHandler", ()=>(0, _chunkK6AXKMTTMjs.useLinkClickHandler));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _chunkK6AXKMTTMjs.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _chunkK6AXKMTTMjs.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _chunkK6AXKMTTMjs.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _chunkK6AXKMTTMjs.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _chunkK6AXKMTTMjs.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _chunkK6AXKMTTMjs.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _chunkK6AXKMTTMjs.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _chunkK6AXKMTTMjs.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _chunkK6AXKMTTMjs.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _chunkK6AXKMTTMjs.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _chunkK6AXKMTTMjs.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _chunkK6AXKMTTMjs.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _chunkK6AXKMTTMjs.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _chunkK6AXKMTTMjs.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _chunkK6AXKMTTMjs.useRoutes));
parcelHelpers.export(exports, "useSearchParams", ()=>(0, _chunkK6AXKMTTMjs.useSearchParams));
parcelHelpers.export(exports, "useSubmit", ()=>(0, _chunkK6AXKMTTMjs.useSubmit));
parcelHelpers.export(exports, "useViewTransitionState", ()=>(0, _chunkK6AXKMTTMjs.useViewTransitionState));
var _chunkK6AXKMTTMjs = require("./chunk-K6AXKMTT.mjs");

},{"./chunk-K6AXKMTT.mjs":"73Vkp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"73Vkp":[function(require,module,exports,__globalThis) {
/**
 * react-router v7.1.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromElements);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "SingleFetchRedirectSymbol", ()=>SingleFetchRedirectSymbol);
parcelHelpers.export(exports, "getSingleFetchDataStrategy", ()=>getSingleFetchDataStrategy);
parcelHelpers.export(exports, "decodeViaTurboStream", ()=>decodeViaTurboStream);
parcelHelpers.export(exports, "RemixErrorBoundary", ()=>RemixErrorBoundary);
parcelHelpers.export(exports, "createClientRoutesWithHMRRevalidationOptOut", ()=>createClientRoutesWithHMRRevalidationOptOut);
parcelHelpers.export(exports, "createClientRoutes", ()=>createClientRoutes);
parcelHelpers.export(exports, "shouldHydrateRouteLoader", ()=>shouldHydrateRouteLoader);
parcelHelpers.export(exports, "getPatchRoutesOnNavigationFunction", ()=>getPatchRoutesOnNavigationFunction);
parcelHelpers.export(exports, "useFogOFWarDiscovery", ()=>useFogOFWarDiscovery);
parcelHelpers.export(exports, "FrameworkContext", ()=>FrameworkContext);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "PrefetchPageLinks", ()=>PrefetchPageLinks);
parcelHelpers.export(exports, "Meta", ()=>Meta);
parcelHelpers.export(exports, "Scripts", ()=>Scripts);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "StaticRouterProvider", ()=>StaticRouterProvider);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler2);
parcelHelpers.export(exports, "createStaticRouter", ()=>createStaticRouter);
parcelHelpers.export(exports, "ServerRouter", ()=>ServerRouter);
parcelHelpers.export(exports, "createRoutesStub", ()=>createRoutesStub);
parcelHelpers.export(exports, "createCookie", ()=>createCookie);
parcelHelpers.export(exports, "isCookie", ()=>isCookie);
parcelHelpers.export(exports, "ServerMode", ()=>ServerMode);
parcelHelpers.export(exports, "setDevServerHooks", ()=>setDevServerHooks);
parcelHelpers.export(exports, "createRequestHandler", ()=>createRequestHandler);
parcelHelpers.export(exports, "createSession", ()=>createSession);
parcelHelpers.export(exports, "isSession", ()=>isSession);
parcelHelpers.export(exports, "createSessionStorage", ()=>createSessionStorage);
parcelHelpers.export(exports, "createCookieSessionStorage", ()=>createCookieSessionStorage);
parcelHelpers.export(exports, "createMemorySessionStorage", ()=>createMemorySessionStorage);
parcelHelpers.export(exports, "deserializeErrors", ()=>deserializeErrors2);
// lib/components.tsx
var _react = require("react");
var _turboStream = require("turbo-stream");
// lib/server-runtime/cookies.ts
var _cookie = require("cookie");
// lib/server-runtime/headers.ts
var _setCookieParser = require("set-cookie-parser");
var $69e80b198dcf27ee$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-K6AXKMTT.mjs"
});
var global = arguments[3];
var Action = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})(Action || {});
var PopStateEventType = "popstate";
function createMemoryHistory(options = {}) {
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname, search, hash } = window2.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? parsePath(to) : to,
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    };
    return location;
}
function createPath({ pathname = "/", search = "", hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        href = href.replace(/ $/, "%20");
        invariant(base, `No window.location.(origin|href) available to create URL for href: ${href}`);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, `Cannot specify children on an index route`);
        invariant(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if (isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function matchRoutes(routes, locationArg, basename = "/") {
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName, isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive = false, end = true) {
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, `The URL path "${value}" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function resolvePath(to, fromPathname = "/") {
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function getResolveToMatches(matches) {
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = {
            ...toArg
        };
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers
    });
};
var redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var ErrorResponseImpl = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET",
    ...validMutationMethodsArr
];
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location, delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            // matches, errors, fetchers go through as-is
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }, {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path, submission, error } = normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...getActionDataForCommit(pendingActionResult),
            loaderData,
            errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData
                    } : {}
                }, {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches,
            loaderData,
            errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(void 0));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset
        });
        redirect2 = findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset
            });
        }
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, getDoneFetcher(void 0));
            return;
        }
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission, fetcherSubmission, preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation({ currentLocation, nextLocation, historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch: fetch2,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || defaultMapRouteProperties;
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext, skipLoaderErrorBubbling, dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        return {
            location,
            basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId, requestContext, dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if (isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
function getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    let parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: createPath(parsedPath),
        submission
    };
}
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if (isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, {
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = shouldRevalidateLoader(fetcherMatch, {
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>isSameRoute(aChild, bChild)));
}
async function loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function defaultDataStrategy({ matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad,
            resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new ErrorResponseImpl(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if (isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status
            };
            result = new ErrorResponseImpl(result.init?.status || 500, void 0, result.data);
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : void 0
        };
    }
    if (isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, { pathname, routeId, method, type, message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath({
        ...parsedPath,
        hash: ""
    });
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: void 0,
        json: void 0,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod,
        formAction,
        formEncType,
        formData: void 0,
        json,
        text: void 0
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise,
        //@ts-ignore
        resolve,
        //@ts-ignore
        reject
    };
}
var DataRouterContext = _react.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = _react.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var ViewTransitionContext = _react.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = _react.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = _react.createContext(null);
AwaitContext.displayName = "Await";
var NavigationContext = _react.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = _react.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = _react.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
function useHref(to, { relative } = {}) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename, navigator: navigator2 } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return _react.useContext(LocationContext).location;
}
function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname } = useLocation();
    return _react.useMemo(()=>matchPath(pattern, decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) _react.useLayoutEffect(cb);
}
function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, navigator: navigator2 } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback((to, options = {})=>{
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = _react.createContext(null);
function useOutletContext() {
    return _react.useContext(OutletContext);
}
function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /* @__PURE__ */ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to, { relative } = {}) {
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return _react.useMemo(()=>resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2 } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ _react.createElement(LocationContext.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ _react.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ _react.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ _react.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ _react.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function RenderedRoute({ routeContext, match, children }) {
    let dataRouterContext = _react.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        invariant(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ _react.createElement(RenderedRoute, {
                match,
                routeContext: {
                    outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    let state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function useRevalidator() {
    let dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return _react.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function useMatches() {
    let { matches, loaderData } = useDataRouterState("useMatches" /* UseMatches */ );
    return _react.useMemo(()=>matches.map((m)=>convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    let state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    let state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    let state = useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value?._data;
}
function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value?._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    let { router } = useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(async (to, options = {})=>{
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var ENABLE_DEV_WARNINGS2 = true;
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS2) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: _react.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: _react.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: _react.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        future: opts?.future,
        history: createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function RouterProvider({ router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(/* @__PURE__ */ new Map());
    let setState = _react.useCallback((newState, { deletedFetchers, flushSync, viewTransitionOpts })=>{
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else _react.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                _react.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator: navigator2,
            static: false,
            basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ _react.createElement(Router, {
        basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state
    })))))), null);
}
var MemoizedDataRoutes = _react.memo(DataRoutes);
function DataRoutes({ routes, future, state }) {
    return useRoutesImpl(routes, void 0, state, future);
}
function MemoryRouter({ basename, children, initialEntries, initialIndex }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function Navigate({ to, replace: replace2, state, relative }) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = _react.useContext(NavigationContext);
    warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    let path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state,
            relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(_props) {
    invariant(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function Router({ basename: basenameProp = "/", children = null, location: locationProp, navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    invariant(!useInRouterContext(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ _react.createElement(LocationContext.Provider, {
        children,
        value: locationContext
    }));
}
function Routes({ children, location }) {
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await({ children, errorElement, resolve }) {
    return /* @__PURE__ */ _react.createElement(AwaitErrorBoundary, {
        resolve,
        errorElement
    }, /* @__PURE__ */ _react.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children
        });
        throw promise;
    }
};
function ResolveAwait({ children }) {
    let data2 = useAsyncValue();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, toRender);
}
function createRoutesFromChildren(children, parentPath = []) {
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!_react.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${defaultEncType}"`);
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await require(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $69e80b198dcf27ee$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = getCurrentPageModulePreloadHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
async function prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...route.css.map((href)=>({
            rel: "stylesheet",
            href
        })));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    let matchingLinks = styleLinks.filter((link)=>(!link.media || window.matchMedia(link.media).matches) && !document.querySelector(`link[rel="stylesheet"][href="${link.href}"]`));
    await Promise.all(matchingLinks.map(prefetchStyleLink));
}
async function prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifestPatch) {
    return dedupeHrefs(matches.map((match)=>{
        let route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function getCurrentPageModulePreloadHrefs(matches, manifest) {
    return dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    let el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, (match)=>ESCAPE_LOOKUP[match]);
}
function createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
function StreamTransfer({ context, identifier, reader, textDecoder, nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done, value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ _react.createElement("script", {
        nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ _react.createElement(_react.Fragment, null, scriptTag, /* @__PURE__ */ _react.createElement("script", {
        nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ _react.createElement(_react.Fragment, null, scriptTag, /* @__PURE__ */ _react.createElement(_react.Suspense, null, /* @__PURE__ */ _react.createElement(StreamTransfer, {
        context,
        identifier: identifier + 1,
        reader,
        textDecoder,
        nonce
    })));
}
function getSingleFetchDataStrategy(manifest, routeModules, getRouter) {
    return async ({ request, matches, fetcherKey })=>{
        if (request.method !== "GET") return singleFetchActionStrategy(request, matches);
        if (fetcherKey) return singleFetchLoaderFetcherStrategy(request, matches);
        return singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches);
    };
}
async function singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = singleFetchUrl(request.url);
            let init = await createRequestInit(request);
            let { data: data2, status } = await fetchAndDecode(url, init);
            actionStatus = status;
            return unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if (isResponse(result.result) || isRouteErrorResponse(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: data(result.result, actionStatus)
        }
    };
}
async function singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = createDeferred2();
    let url = stripIndexParam(singleFetchUrl(request.url));
    let init = await createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = stripIndexParam(singleFetchUrl(request.url));
        let init = await createRequestInit(request);
        return fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await fetchAndDecode(singleLoaderUrl, init);
        return unwrapSingleFetchResults(data2, routeId);
    });
}
function stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new ErrorResponseImpl(404, "Not Found", true);
    invariant2(res.body, "No response body to decode");
    try {
        let decoded = await decodeViaTurboStream(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function decodeViaTurboStream(body, global2) {
    return (0, _turboStream.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [SingleFetchRedirectSymbol]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[SingleFetchRedirectSymbol];
    if (redirect2) return unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        throw redirect(result.redirect, {
            status: result.status,
            headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise,
        //@ts-ignore
        resolve,
        //@ts-ignore
        reject
    };
}
var RemixErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ _react.createElement(RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function RemixRootDefaultErrorBoundary({ error, isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ _react.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ _react.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp
    }, /* @__PURE__ */ _react.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ _react.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell({ title, renderScripts, isOutsideRemixApp, children }) {
    let { routeModules } = useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ _react.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ _react.createElement("head", null, /* @__PURE__ */ _react.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ _react.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ _react.createElement("title", null, title)), /* @__PURE__ */ _react.createElement("body", null, /* @__PURE__ */ _react.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ _react.createElement(Scripts, null) : null)));
}
function RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ _react.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ _react.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(HydrateFallback, null))
        } : {
            HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary,
        HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        let fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        let msg2 = `You cannot call ${fn2} in SPA Mode (routeId: "${route.id}")`;
        console.error(msg2);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg2), true);
    }
    let fn = type === "action" ? "serverAction()" : "serverLoader()";
    let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, isSpaMode, parentId = "", routesByParentId = groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request, params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) {
                            if (isSpaMode) return null;
                            return fetchServerLoader(singleFetch);
                        }
                        return routeModule.clientLoader({
                            request,
                            params,
                            async serverLoader () {
                                preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route, routeModule, isSpaMode);
            dataRoute.action = ({ request, params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request,
                        params,
                        async serverAction () {
                            preventInvalidServerHandlerCall("action", route, isSpaMode);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = ({ request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            dataRoute.lazy = async ()=>{
                let mod = await loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                preventInvalidServerHandlerCall("action", route, isSpaMode);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = createClientRoutes(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModule = await loadRouteModule(route, routeModules);
    await prefetchStyleLinks(route, routeModule);
    return {
        Component: getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = matchRoutes(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function getPatchRoutesOnNavigationFunction(manifest, routeModules, isSpaMode, basename) {
    if (!isFogOfWarEnabled(isSpaMode)) return void 0;
    return async ({ path, patch })=>{
        if (discoveredPaths.has(path)) return;
        await fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, isSpaMode, basename, patch);
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, isSpaMode) {
    _react.useEffect(()=>{
        if (!isFogOfWarEnabled(isSpaMode) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let url = new URL(path, window.location.origin);
            if (!discoveredPaths.has(url.pathname)) nextPaths.add(url.pathname);
        }
        async function fetchPatches() {
            let lazyPaths = Array.from(nextPaths.keys()).filter((path)=>{
                if (discoveredPaths.has(path)) {
                    nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>registerElement(el));
        fetchPatches();
        let debouncedFetchPatches = debounce(fetchPatches, 100);
        function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
        let observer = new MutationObserver((records)=>{
            let elements = /* @__PURE__ */ new Set();
            records.forEach((r)=>{
                [
                    r.target,
                    ...r.addedNodes
                ].forEach((node)=>{
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>elements.add(el));
                });
            });
            elements.forEach((el)=>registerElement(el));
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > URL_LIMIT) {
        nextPaths.clear();
        return;
    }
    let res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    else if (res.status >= 400) throw new Error(await res.text());
    let serverPatches = await res.json();
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>addToFifoQueue(p, discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, isSpaMode, parentId)));
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    let context = _react.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    let context = _react.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = _react.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    let context = _react.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = _react.useContext(FrameworkContext);
    let [maybePrefetch, setMaybePrefetch] = _react.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = _react.useState(false);
    let { onFocus, onBlur, onMouseEnter, onMouseLeave, onTouchStart } = theirElementProps;
    let ref = _react.useRef(null);
    _react.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    _react.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function Links() {
    let { isSpaMode, manifest, routeModules, criticalCss } = useFrameworkContext();
    let { errors, matches: routerMatches } = useDataRouterStateContext();
    let matches = getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = _react.useMemo(()=>getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, criticalCss ? /* @__PURE__ */ _react.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key, link })=>isPageLinkDescriptor(link) ? /* @__PURE__ */ _react.createElement(PrefetchPageLinks, {
            key,
            ...link
        }) : /* @__PURE__ */ _react.createElement("link", {
            key,
            ...link
        })));
}
function PrefetchPageLinks({ page, ...dataLinkProps }) {
    let { router } = useDataRouterContext2();
    let matches = _react.useMemo(()=>matchRoutes(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ _react.createElement(PrefetchPageLinksImpl, {
        page,
        matches,
        ...dataLinkProps
    });
}
function useKeyedPrefetchLinks(matches) {
    let { manifest, routeModules } = useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = _react.useState([]);
    _react.useEffect(()=>{
        let interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function PrefetchPageLinksImpl({ page, matches: nextMatches, ...linkProps }) {
    let location = useLocation();
    let { manifest, routeModules } = useFrameworkContext();
    let { loaderData, matches } = useDataRouterStateContext();
    let newMatchesForData = _react.useMemo(()=>getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = _react.useMemo(()=>getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = _react.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = _react.useMemo(()=>getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ _react.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ _react.createElement("link", {
            key: href,
            rel: "modulepreload",
            href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key, link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ _react.createElement("link", {
            key,
            ...link
        })));
}
function Meta() {
    let { isSpaMode, routeModules } = useFrameworkContext();
    let { errors, matches: routerMatches, loaderData } = useDataRouterStateContext();
    let location = useLocation();
    let _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params,
            location,
            matches,
            error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName, ...rest } = metaProps;
            if (!isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ _react.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ _react.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ _react.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ _react.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ _react.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function Scripts(props) {
    let { manifest, serverHandoffString, isSpaMode, renderMeta } = useFrameworkContext();
    let { router, static: isStatic, staticContext } = useDataRouterContext2();
    let { matches: routerMatches } = useDataRouterStateContext();
    let enableFogOfWar = isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = getActiveMatches(routerMatches, null, isSpaMode);
    _react.useEffect(()=>{
        isHydrated = true;
    }, []);
    let initialScripts = _react.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, index)=>`import * as route${index} from ${JSON.stringify(manifest.routes[match.route.id].module)};`).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify(getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ _react.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let routePreloads = matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    let preloads = isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return isHydrated ? null : /* @__PURE__ */ _react.createElement(_react.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ _react.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ _react.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), dedupe(preloads).map((path)=>/* @__PURE__ */ _react.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser) window.__reactRouterVersion = "7.1.1";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        future: opts?.future,
        history: createBrowserHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || parseHydrationData(),
        routes,
        mapRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        future: opts?.future,
        history: createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || parseHydrationData(),
        routes,
        mapRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: deserializeErrors(state.errors)
    };
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function BrowserRouter({ basename, children, window: window2 }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HashRouter({ basename, children, window: window2 }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HistoryRouter({ basename, children, history }) {
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var Link = _react.forwardRef(function LinkWithRef({ onClick, discover = "render", prefetch = "none", relative, reloadDocument, replace: replace2, state, target, to, preventScrollReset, viewTransition, ...rest }, forwardedRef) {
    let { basename } = _react.useContext(NavigationContext);
    let isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = useHref(to, {
        relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = usePrefetchBehavior(prefetch, rest);
    let internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ _react.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ _react.createElement(_react.Fragment, null, link, /* @__PURE__ */ _react.createElement(PrefetchPageLinks, {
        page: href
    })) : link;
});
Link.displayName = "Link";
var NavLink = _react.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children, ...rest }, ref) {
    let path = useResolvedPath(to, {
        relative: rest.relative
    });
    let location = useLocation();
    let routerState = _react.useContext(DataRouterStateContext);
    let { navigator: navigator2, basename } = _react.useContext(NavigationContext);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ _react.createElement(Link, {
        ...rest,
        "aria-current": ariaCurrent,
        className,
        ref,
        style,
        to,
        viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = _react.forwardRef(({ discover = "render", fetcherKey, navigate, reloadDocument, replace: replace2, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition, ...props }, forwardedRef)=>{
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace: replace2,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /* @__PURE__ */ _react.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
Form.displayName = "Form";
function ScrollRestoration({ getKey, storageKey, ...props }) {
    let remixContext = _react.useContext(FrameworkContext);
    let { basename } = _react.useContext(NavigationContext);
    let location = useLocation();
    let matches = useMatches();
    useScrollRestoration({
        getKey,
        storageKey
    });
    let ssrKey = _react.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ _react.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function useDataRouterContext3(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to, { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = {}) {
    let navigate = useNavigate();
    let location = useLocation();
    let path = useResolvedPath(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            navigate(to, {
                replace: replace2,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = useLocation();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = useNavigate();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = ()=>`__${String(++fetcherId)}__`;
function useSubmit() {
    let { router } = useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename } = _react.useContext(NavigationContext);
    let currentRouteId = useRouteId();
    return _react.useCallback(async (target, options = {})=>{
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action, { relative } = {}) {
    let { basename } = _react.useContext(NavigationContext);
    let routeContext = _react.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...useResolvedPath(action ? action : ".", {
            relative
        })
    };
    let location = useLocation();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher({ key } = {}) {
    let { router } = useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext(RouteContext);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    invariant(fetcherData, `useFetcher must be used inside a FetchersContext`);
    invariant(route, `useFetcher must be used inside a RouteContext`);
    invariant(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = _react.useId();
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = _react.useCallback(async (href, opts)=>{
        invariant(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm2 = _react.forwardRef((props, ref)=>{
            return /* @__PURE__ */ _react.createElement(Form, {
                ...props,
                navigate: false,
                fetcherKey,
                ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>({
            Form: FetcherForm,
            submit,
            load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    let state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key
        }));
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration({ getKey, storageKey } = {}) {
    let { router } = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename } = _react.useContext(NavigationContext);
    let location = useLocation();
    let matches = useMatches();
    let navigation = useNavigation();
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        _react.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        _react.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt({ when, message }) {
    let blocker = useBlocker(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to, opts = {}) {
    let vtContext = _react.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename } = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = useResolvedPath(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter({ basename, children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function StaticRouterProvider({ context, router, hydrate = true, nonce }) {
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        let json = htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state } = dataRouterContext.router;
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ _react.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ _react.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ _react.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ _react.createElement(DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state
    })))))), hydrateScript ? /* @__PURE__ */ _react.createElement("script", {
        suppressHydrationWarning: true,
        nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function DataRoutes2({ routes, future, state }) {
    return useRoutesImpl(routes, void 0, state, future);
}
function serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (isRouteErrorResponse(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref,
        encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, {
        ...opts,
        mapRouteProperties
    });
}
function createStaticRouter(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref,
        encodeLocation,
        getFetcher () {
            return IDLE_FETCHER;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return IDLE_BLOCKER;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    let href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    let encoded = ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function htmlEscape(str) {
    return str.replace(ESCAPE_REGEX2, (match)=>ESCAPE_LOOKUP2[match]);
}
function ServerRouter({ context, url, nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest, routeModules, criticalCss, serverHandoffString } = context;
    let routes = createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && shouldHydrateRouteLoader(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = createStaticRouter(routes, context.staticHandlerContext);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(FrameworkContext.Provider, {
        value: {
            manifest,
            routeModules,
            criticalCss,
            serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ _react.createElement(RemixErrorBoundary, {
        location: router.state.location
    }, /* @__PURE__ */ _react.createElement(StaticRouterProvider, {
        router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ _react.createElement(_react.Suspense, null, /* @__PURE__ */ _react.createElement(StreamTransfer, {
        context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce
    })) : null);
}
function createRoutesStub(routes, context = {}) {
    return function RoutesTestStub({ initialEntries, initialIndex, hydrationData, future }) {
        let routerRef = _react.useRef();
        let remixContextRef = _react.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            let patched = processRoutes(// @ts-expect-error loader/action context types don't match :/
            convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = createMemoryRouter(patched, {
                initialEntries,
                initialIndex,
                hydrationData
            });
        }
        return /* @__PURE__ */ _react.createElement(FrameworkContext.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ _react.createElement(RouterProvider, {
            router: routerRef.current
        }));
    };
}
function processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader, action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || Outlet,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var encoder = new TextEncoder();
var sign = async (value, secret)=>{
    let data2 = encoder.encode(value);
    let key = await createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = encoder.encode(value);
    let key = await createKey2(secret, [
        "verify"
    ]);
    let signature = byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var createCookie = (name, cookieOptions = {})=>{
    let { secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, _cookie.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, _cookie.serialize)(name, value === "" ? "" : await encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var isCookie = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function encodeCookieValue(value, secrets) {
    let encoded = encodeData(value);
    if (secrets.length > 0) encoded = await sign(encoded, secrets[0]);
    return encoded;
}
async function decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await unsign(value, secret);
            if (unsignedValue !== false) return decodeData(unsignedValue);
        }
        return null;
    }
    return decodeData(value);
}
function encodeData(value) {
    return btoa(myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent(myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + hex(code, 2);
            else result += "%u" + hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function warnOnceAboutExpiresCookie(name, expires) {
    warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var ServerMode = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})(ServerMode || {});
function isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: sanitizeError(error, serverMode)
        });
    }, {});
}
function serializeError(error, serverMode) {
    let sanitized = sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (isRouteErrorResponse(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function matchServerRoutes(routes, pathname, basename) {
    let matches = matchRoutes(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function callRouteHandler(handler, args) {
    let result = await handler({
        request: stripRoutesParam(stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if (isDataWithResponseInit(result) && result.init && result.init.status && isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function createRoutes(manifest, parentId = "", routesByParentId = groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: createRoutes(manifest, route.id, routesByParentId)
        }));
}
function createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await decodeViaTurboStream(stream, global);
                    let data2 = decoded.value;
                    invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function escapeHtml2(html) {
    return html.replace(ESCAPE_REGEX3, (match)=>ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function createServerHandoffString(serverHandoff) {
    return escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var globalDevServerHooksKey = "__reactRouterDevServerHooks";
function setDevServerHooks(devServerHooks) {
    globalThis[globalDevServerHooksKey] = devServerHooks;
}
function getDevServerHooks() {
    return globalThis[globalDevServerHooksKey];
}
function getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders, actionData, loaderHeaders, loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id } = match.route;
        let route = build.routes[id];
        invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) prependCookies(errorHeaders, headers2);
            prependCookies(actionHeaders, headers2);
            prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders,
            parentHeaders,
            actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) prependCookies(errorHeaders, headers);
        prependCookies(actionHeaders, headers);
        prependCookies(loaderHeaders, headers);
        prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, _setCookieParser.splitCookiesString)(parentSetCookieString);
        cookies.forEach((cookie)=>{
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var SINGLE_FETCH_REDIRECT_STATUS = 202;
function getSingleFetchDataStrategy2({ isActionDataRequest, loadRouteIds } = {}) {
    return async ({ request, matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if (isResponse(result)) return {
            result: getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = getDocumentHeaders(build, context);
        if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!isRouteErrorResponse(err) || err.error) handleError(err);
            });
            context.errors = sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: getSingleFetchDataStrategy2({
                loadRouteIds
            })
        });
        if (isResponse(result)) return {
            result: {
                [SingleFetchRedirectSymbol]: getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = getDocumentHeaders(build, context);
        if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [SingleFetchRedirectSymbol]: getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!isRouteErrorResponse(err) || err.error) handleError(err);
            });
            context.errors = sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, _turboStream.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name, message, stack } = serverMode === "production" /* Production */  ? sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof ErrorResponseImpl) {
                    let { data: data3, status, statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && SingleFetchRedirectSymbol in value) return [
                    "SingleFetchRedirect",
                    value[SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function derive(build, mode) {
    let routes = createRoutes(build.routes);
    let dataRoutes = createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        isRouteErrorResponse(error) && error.error ? error.error : error);
    });
    return {
        routes,
        dataRoutes,
        serverMode,
        staticHandler,
        errorHandler
    };
}
var createRequestHandler = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params,
                request
            });
        };
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
            let singleFetchMatches = matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request
                });
                if (isRedirectResponse(response)) {
                    let result = getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [SingleFetchRedirectSymbol]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response(encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: SINGLE_FETCH_REDIRECT_STATUS,
                        headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result, headers, status } = request.method !== "GET" ? await singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (status === 304) return new Response(null, {
        status: 304,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response(encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if (isResponse(context)) return context;
    let headers = getDocumentHeaders(build, context);
    if (context.statusCode === 304) return new Response(null, {
        status: 304,
        headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!isRouteErrorResponse(err) || err.error) handleError(err);
        });
        context.errors = sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss,
        serverHandoffString: createServerHandoffString({
            basename: build.basename,
            criticalCss,
            future: build.future,
            isSpaMode: build.isSpaMode
        }),
        serverHandoffStream: encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        isSpaMode: build.isSpaMode,
        serializeError: (err)=>serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if (isResponse(error)) try {
            let data2 = await unwrapResponse(error);
            errorForSecondRender = new ErrorResponseImpl(error.status, error.statusText, data2);
        } catch (e) {}
        context = getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: createServerHandoffString({
                basename: build.basename,
                future: build.future,
                isSpaMode: build.isSpaMode
            }),
            serverHandoffStream: encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId,
            requestContext: loadContext
        });
        invariant3(isResponse(response), "Expected a Response to be returned from resource route handler");
        return response;
    } catch (error) {
        if (isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if (isRouteErrorResponse(error)) {
            if (error) handleError(error);
            return errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return returnLastResortErrorResponse(error, serverMode);
    }
}
function errorResponseToJson(errorResponse, serverMode) {
    return Response.json(serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function flash(name) {
    return `__flash_${name}__`;
}
var createSession = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has(flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set(flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var isSession = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function createSessionStorage({ cookie: cookieArg, createData, readData, updateData, deleteData }) {
    let cookie = isCookie(cookieArg) ? cookieArg : createCookie(cookieArg?.name || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return createSession(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function warnOnceAboutSigningSessionCookie(cookie) {
    warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function createCookieSessionStorage({ cookie: cookieArg } = {}) {
    let cookie = isCookie(cookieArg) ? cookieArg : createCookie(cookieArg?.name || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return createSession(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function createMemorySessionStorage({ cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return createSessionStorage({
        cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/dom/ssr/errors.ts
function deserializeErrors2(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}

},{"react":"9njXz","turbo-stream":"97bNa","cookie":"637i7","set-cookie-parser":"8NO3i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97bNa":[function(require,module,exports,__globalThis) {
// src/utils.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encode", ()=>encode);
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// src/flatten.ts
function flatten(input) {
    const { indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return UNDEFINED;
    if (input === null) return NULL;
    if (Number.isNaN(input)) return NAN;
    if (input === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    stringify.call(this, input, index);
    return index;
}
function stringify(input, index) {
    const { deferred, plugins, postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flatten.call(this, k)}":${flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? flatten.call(this, input2[i]) : HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) str[index2] = `["${TYPE_DATE}",${input2.getTime()}]`;
                        else if (input2 instanceof URL) str[index2] = `["${TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${TYPE_SET}",${[
                                ...input2
                            ].map((val)=>flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    flatten.call(this, k),
                                    flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if (isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// src/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    const { hydrated, values } = this;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    const { hydrated, values, deferred, plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case UNDEFINED:
                set(void 0);
                continue;
            case NULL:
                set(null);
                continue;
            case NAN:
                set(NaN);
                continue;
            case POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new Deferred();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && globalObj && globalObj[errorType] ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// src/turbo-stream.ts
async function decode(readable, options) {
    const { plugins } = options ?? {};
    const done = new Deferred();
    const reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins
    };
    const decoded = await decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: unflatten.call(this, line)
    };
}
async function decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function encode(input, options) {
    const { plugins, postPlugins, signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins,
        postPlugins,
        signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id2 = flatten.call(encoder, resolved);
                        if (Array.isArray(id2)) {
                            controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:[["${TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:${id2}
`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:[${values}]
`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id2 = flatten.call(encoder, reason);
                        if (Array.isArray(id2)) {
                            controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:[["${TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:${id2}
`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:[${values}]
`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
function raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"637i7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;
exports.serialize = serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const __toString = Object.prototype.toString;
const NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function parse(str, options) {
    const obj = new NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = startIndex(str, index, eqIdx);
        const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function isDate(val) {
    return __toString.call(val) === "[object Date]";
}

},{}],"8NO3i":[function(require,module,exports,__globalThis) {
"use strict";
var defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter(isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function parse(input, options) {
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter(isNonEmptyString).map(function(str) {
        return parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter(isNonEmptyString).reduce(function(cookies, str) {
            var cookie = parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;

},{}],"f5rnA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "AccordionContext", ()=>(0, _accordionContextDefault.default));
parcelHelpers.export(exports, "AccordionCollapse", ()=>(0, _accordionCollapseDefault.default));
parcelHelpers.export(exports, "AccordionButton", ()=>(0, _accordionButtonDefault.default));
parcelHelpers.export(exports, "useAccordionButton", ()=>(0, _accordionButton.useAccordionButton));
parcelHelpers.export(exports, "AccordionBody", ()=>(0, _accordionBodyDefault.default));
parcelHelpers.export(exports, "AccordionHeader", ()=>(0, _accordionHeaderDefault.default));
parcelHelpers.export(exports, "AccordionItem", ()=>(0, _accordionItemDefault.default));
parcelHelpers.export(exports, "Alert", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "AlertHeading", ()=>(0, _alertHeadingDefault.default));
parcelHelpers.export(exports, "AlertLink", ()=>(0, _alertLinkDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbDefault.default));
parcelHelpers.export(exports, "BreadcrumbItem", ()=>(0, _breadcrumbItemDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
parcelHelpers.export(exports, "ButtonToolbar", ()=>(0, _buttonToolbarDefault.default));
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "CardBody", ()=>(0, _cardBodyDefault.default));
parcelHelpers.export(exports, "CardFooter", ()=>(0, _cardFooterDefault.default));
parcelHelpers.export(exports, "CardGroup", ()=>(0, _cardGroupDefault.default));
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "CardImg", ()=>(0, _cardImgDefault.default));
parcelHelpers.export(exports, "CardImgOverlay", ()=>(0, _cardImgOverlayDefault.default));
parcelHelpers.export(exports, "CardLink", ()=>(0, _cardLinkDefault.default));
parcelHelpers.export(exports, "CardSubtitle", ()=>(0, _cardSubtitleDefault.default));
parcelHelpers.export(exports, "CardText", ()=>(0, _cardTextDefault.default));
parcelHelpers.export(exports, "CardTitle", ()=>(0, _cardTitleDefault.default));
parcelHelpers.export(exports, "Carousel", ()=>(0, _carouselDefault.default));
parcelHelpers.export(exports, "CarouselCaption", ()=>(0, _carouselCaptionDefault.default));
parcelHelpers.export(exports, "CarouselItem", ()=>(0, _carouselItemDefault.default));
parcelHelpers.export(exports, "CloseButton", ()=>(0, _closeButtonDefault.default));
parcelHelpers.export(exports, "Col", ()=>(0, _colDefault.default));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdownDefault.default));
parcelHelpers.export(exports, "DropdownButton", ()=>(0, _dropdownButtonDefault.default));
parcelHelpers.export(exports, "DropdownDivider", ()=>(0, _dropdownDividerDefault.default));
parcelHelpers.export(exports, "DropdownHeader", ()=>(0, _dropdownHeaderDefault.default));
parcelHelpers.export(exports, "DropdownItem", ()=>(0, _dropdownItemDefault.default));
parcelHelpers.export(exports, "DropdownItemText", ()=>(0, _dropdownItemTextDefault.default));
parcelHelpers.export(exports, "DropdownMenu", ()=>(0, _dropdownMenuDefault.default));
parcelHelpers.export(exports, "DropdownToggle", ()=>(0, _dropdownToggleDefault.default));
parcelHelpers.export(exports, "Fade", ()=>(0, _fadeDefault.default));
parcelHelpers.export(exports, "Figure", ()=>(0, _figureDefault.default));
parcelHelpers.export(exports, "FigureCaption", ()=>(0, _figureCaptionDefault.default));
parcelHelpers.export(exports, "FigureImage", ()=>(0, _figureImageDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormControl", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "FormCheck", ()=>(0, _formCheckDefault.default));
parcelHelpers.export(exports, "FormFloating", ()=>(0, _formFloatingDefault.default));
parcelHelpers.export(exports, "FloatingLabel", ()=>(0, _floatingLabelDefault.default));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "FormLabel", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "FormText", ()=>(0, _formTextDefault.default));
parcelHelpers.export(exports, "FormSelect", ()=>(0, _formSelectDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "InputGroup", ()=>(0, _inputGroupDefault.default));
parcelHelpers.export(exports, "ListGroup", ()=>(0, _listGroupDefault.default));
parcelHelpers.export(exports, "ListGroupItem", ()=>(0, _listGroupItemDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalBody", ()=>(0, _modalBodyDefault.default));
parcelHelpers.export(exports, "ModalDialog", ()=>(0, _modalDialogDefault.default));
parcelHelpers.export(exports, "ModalFooter", ()=>(0, _modalFooterDefault.default));
parcelHelpers.export(exports, "ModalHeader", ()=>(0, _modalHeaderDefault.default));
parcelHelpers.export(exports, "ModalTitle", ()=>(0, _modalTitleDefault.default));
parcelHelpers.export(exports, "Nav", ()=>(0, _navDefault.default));
parcelHelpers.export(exports, "Navbar", ()=>(0, _navbarDefault.default));
parcelHelpers.export(exports, "NavbarBrand", ()=>(0, _navbarBrandDefault.default));
parcelHelpers.export(exports, "NavbarCollapse", ()=>(0, _navbarCollapseDefault.default));
parcelHelpers.export(exports, "NavbarOffcanvas", ()=>(0, _navbarOffcanvasDefault.default));
parcelHelpers.export(exports, "NavbarText", ()=>(0, _navbarTextDefault.default));
parcelHelpers.export(exports, "NavbarToggle", ()=>(0, _navbarToggleDefault.default));
parcelHelpers.export(exports, "NavDropdown", ()=>(0, _navDropdownDefault.default));
parcelHelpers.export(exports, "NavItem", ()=>(0, _navItemDefault.default));
parcelHelpers.export(exports, "NavLink", ()=>(0, _navLinkDefault.default));
parcelHelpers.export(exports, "Offcanvas", ()=>(0, _offcanvasDefault.default));
parcelHelpers.export(exports, "OffcanvasBody", ()=>(0, _offcanvasBodyDefault.default));
parcelHelpers.export(exports, "OffcanvasHeader", ()=>(0, _offcanvasHeaderDefault.default));
parcelHelpers.export(exports, "OffcanvasTitle", ()=>(0, _offcanvasTitleDefault.default));
parcelHelpers.export(exports, "OffcanvasToggling", ()=>(0, _offcanvasTogglingDefault.default));
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlayDefault.default));
parcelHelpers.export(exports, "OverlayTrigger", ()=>(0, _overlayTriggerDefault.default));
parcelHelpers.export(exports, "PageItem", ()=>(0, _pageItemDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "Placeholder", ()=>(0, _placeholderDefault.default));
parcelHelpers.export(exports, "PlaceholderButton", ()=>(0, _placeholderButtonDefault.default));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "PopoverBody", ()=>(0, _popoverBodyDefault.default));
parcelHelpers.export(exports, "PopoverHeader", ()=>(0, _popoverHeaderDefault.default));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBarDefault.default));
parcelHelpers.export(exports, "Ratio", ()=>(0, _ratioDefault.default));
parcelHelpers.export(exports, "Row", ()=>(0, _rowDefault.default));
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinnerDefault.default));
parcelHelpers.export(exports, "SplitButton", ()=>(0, _splitButtonDefault.default));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssrproviderDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabContainer", ()=>(0, _tabContainerDefault.default));
parcelHelpers.export(exports, "TabContent", ()=>(0, _tabContentDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TabPane", ()=>(0, _tabPaneDefault.default));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "Toast", ()=>(0, _toastDefault.default));
parcelHelpers.export(exports, "ToastBody", ()=>(0, _toastBodyDefault.default));
parcelHelpers.export(exports, "ToastContainer", ()=>(0, _toastContainerDefault.default));
parcelHelpers.export(exports, "ToastHeader", ()=>(0, _toastHeaderDefault.default));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButtonDefault.default));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroupDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipDefault.default));
var _accordion = require("./Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _accordionBody = require("./AccordionBody");
var _accordionBodyDefault = parcelHelpers.interopDefault(_accordionBody);
var _accordionHeader = require("./AccordionHeader");
var _accordionHeaderDefault = parcelHelpers.interopDefault(_accordionHeader);
var _accordionItem = require("./AccordionItem");
var _accordionItemDefault = parcelHelpers.interopDefault(_accordionItem);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alertHeading = require("./AlertHeading");
var _alertHeadingDefault = parcelHelpers.interopDefault(_alertHeading);
var _alertLink = require("./AlertLink");
var _alertLinkDefault = parcelHelpers.interopDefault(_alertLink);
var _anchor = require("./Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _breadcrumb = require("./Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _breadcrumbItem = require("./BreadcrumbItem");
var _breadcrumbItemDefault = parcelHelpers.interopDefault(_breadcrumbItem);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonToolbar = require("./ButtonToolbar");
var _buttonToolbarDefault = parcelHelpers.interopDefault(_buttonToolbar);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardGroup = require("./CardGroup");
var _cardGroupDefault = parcelHelpers.interopDefault(_cardGroup);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _carousel = require("./Carousel");
var _carouselDefault = parcelHelpers.interopDefault(_carousel);
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownButton = require("./DropdownButton");
var _dropdownButtonDefault = parcelHelpers.interopDefault(_dropdownButton);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownItemText = require("./DropdownItemText");
var _dropdownItemTextDefault = parcelHelpers.interopDefault(_dropdownItemText);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _figure = require("./Figure");
var _figureDefault = parcelHelpers.interopDefault(_figure);
var _figureCaption = require("./FigureCaption");
var _figureCaptionDefault = parcelHelpers.interopDefault(_figureCaption);
var _figureImage = require("./FigureImage");
var _figureImageDefault = parcelHelpers.interopDefault(_figureImage);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _formFloating = require("./FormFloating");
var _formFloatingDefault = parcelHelpers.interopDefault(_formFloating);
var _floatingLabel = require("./FloatingLabel");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _formSelect = require("./FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _inputGroup = require("./InputGroup");
var _inputGroupDefault = parcelHelpers.interopDefault(_inputGroup);
var _listGroup = require("./ListGroup");
var _listGroupDefault = parcelHelpers.interopDefault(_listGroup);
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navbar = require("./Navbar");
var _navbarDefault = parcelHelpers.interopDefault(_navbar);
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarCollapse = require("./NavbarCollapse");
var _navbarCollapseDefault = parcelHelpers.interopDefault(_navbarCollapse);
var _navbarOffcanvas = require("./NavbarOffcanvas");
var _navbarOffcanvasDefault = parcelHelpers.interopDefault(_navbarOffcanvas);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _navbarToggle = require("./NavbarToggle");
var _navbarToggleDefault = parcelHelpers.interopDefault(_navbarToggle);
var _navDropdown = require("./NavDropdown");
var _navDropdownDefault = parcelHelpers.interopDefault(_navDropdown);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _offcanvas = require("./Offcanvas");
var _offcanvasDefault = parcelHelpers.interopDefault(_offcanvas);
var _offcanvasBody = require("./OffcanvasBody");
var _offcanvasBodyDefault = parcelHelpers.interopDefault(_offcanvasBody);
var _offcanvasHeader = require("./OffcanvasHeader");
var _offcanvasHeaderDefault = parcelHelpers.interopDefault(_offcanvasHeader);
var _offcanvasTitle = require("./OffcanvasTitle");
var _offcanvasTitleDefault = parcelHelpers.interopDefault(_offcanvasTitle);
var _offcanvasToggling = require("./OffcanvasToggling");
var _offcanvasTogglingDefault = parcelHelpers.interopDefault(_offcanvasToggling);
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _overlayTrigger = require("./OverlayTrigger");
var _overlayTriggerDefault = parcelHelpers.interopDefault(_overlayTrigger);
var _pageItem = require("./PageItem");
var _pageItemDefault = parcelHelpers.interopDefault(_pageItem);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _placeholder = require("./Placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _placeholderButton = require("./PlaceholderButton");
var _placeholderButtonDefault = parcelHelpers.interopDefault(_placeholderButton);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _progressBar = require("./ProgressBar");
var _progressBarDefault = parcelHelpers.interopDefault(_progressBar);
var _ratio = require("./Ratio");
var _ratioDefault = parcelHelpers.interopDefault(_ratio);
var _row = require("./Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _spinner = require("./Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _splitButton = require("./SplitButton");
var _splitButtonDefault = parcelHelpers.interopDefault(_splitButton);
var _ssrprovider = require("./SSRProvider");
var _ssrproviderDefault = parcelHelpers.interopDefault(_ssrprovider);
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabContainer = require("./TabContainer");
var _tabContainerDefault = parcelHelpers.interopDefault(_tabContainer);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _tabs = require("./Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _toast = require("./Toast");
var _toastDefault = parcelHelpers.interopDefault(_toast);
var _toastBody = require("./ToastBody");
var _toastBodyDefault = parcelHelpers.interopDefault(_toastBody);
var _toastContainer = require("./ToastContainer");
var _toastContainerDefault = parcelHelpers.interopDefault(_toastContainer);
var _toastHeader = require("./ToastHeader");
var _toastHeaderDefault = parcelHelpers.interopDefault(_toastHeader);
var _toggleButton = require("./ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);

},{"./Accordion":"ilLKW","./AccordionContext":false,"./AccordionCollapse":false,"./AccordionButton":false,"./AccordionBody":false,"./AccordionHeader":false,"./AccordionItem":false,"./Alert":"lgAuB","./AlertHeading":false,"./AlertLink":false,"./Anchor":false,"./Badge":"lFInU","./Breadcrumb":false,"./BreadcrumbItem":false,"./Button":"2TJC6","./ButtonGroup":false,"./ButtonToolbar":false,"./Card":"6wRtx","./CardBody":false,"./CardFooter":false,"./CardGroup":false,"./CardHeader":false,"./CardImg":false,"./CardImgOverlay":false,"./CardLink":false,"./CardSubtitle":false,"./CardText":false,"./CardTitle":false,"./Carousel":false,"./CarouselCaption":false,"./CarouselItem":false,"./CloseButton":false,"./Col":"aPBtB","./Collapse":false,"./Container":false,"./Dropdown":"gNoAC","./DropdownButton":false,"./DropdownDivider":false,"./DropdownHeader":false,"./DropdownItem":false,"./DropdownItemText":false,"./DropdownMenu":false,"./DropdownToggle":false,"./Fade":false,"./Figure":false,"./FigureCaption":false,"./FigureImage":false,"./Form":"j4K62","./FormControl":false,"./FormCheck":false,"./FormFloating":false,"./FloatingLabel":false,"./FormGroup":false,"./FormLabel":false,"./FormText":false,"./FormSelect":false,"./Image":"7wCS3","./InputGroup":false,"./ListGroup":false,"./ListGroupItem":false,"./Modal":"dAasA","./ModalBody":false,"./ModalDialog":false,"./ModalFooter":false,"./ModalHeader":false,"./ModalTitle":false,"./Nav":false,"./Navbar":false,"./NavbarBrand":false,"./NavbarCollapse":false,"./NavbarOffcanvas":false,"./NavbarText":false,"./NavbarToggle":false,"./NavDropdown":false,"./NavItem":false,"./NavLink":false,"./Offcanvas":false,"./OffcanvasBody":false,"./OffcanvasHeader":false,"./OffcanvasTitle":false,"./OffcanvasToggling":false,"./Overlay":false,"./OverlayTrigger":false,"./PageItem":false,"./Pagination":false,"./Placeholder":false,"./PlaceholderButton":false,"./Popover":false,"./PopoverBody":false,"./PopoverHeader":false,"./ProgressBar":false,"./Ratio":false,"./Row":"gBOje","./Spinner":false,"./SplitButton":false,"./SSRProvider":false,"./Stack":false,"./Tab":"l1HB0","./TabContainer":false,"./TabContent":false,"./Table":"kqOLP","./TabPane":false,"./Tabs":"3ESNf","./ThemeProvider":false,"./Toast":false,"./ToastBody":false,"./ToastContainer":false,"./ToastHeader":false,"./ToggleButton":false,"./ToggleButtonGroup":false,"./Tooltip":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ilLKW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _themeProvider = require("./ThemeProvider");
var _accordionBody = require("./AccordionBody");
var _accordionBodyDefault = parcelHelpers.interopDefault(_accordionBody);
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionHeader = require("./AccordionHeader");
var _accordionHeaderDefault = parcelHelpers.interopDefault(_accordionHeader);
var _accordionItem = require("./AccordionItem");
var _accordionItemDefault = parcelHelpers.interopDefault(_accordionItem);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Accordion = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', activeKey, bsPrefix, className, onSelect, flush, alwaysOpen, ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        activeKey: 'onSelect'
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion');
    const contextValue = (0, _react.useMemo)(()=>({
            activeEventKey: activeKey,
            onSelect,
            alwaysOpen
        }), [
        activeKey,
        onSelect,
        alwaysOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...controlledProps,
            className: (0, _classnamesDefault.default)(className, prefix, flush && `${prefix}-flush`)
        })
    });
});
Accordion.displayName = 'Accordion';
exports.default = Object.assign(Accordion, {
    Button: (0, _accordionButtonDefault.default),
    Collapse: (0, _accordionCollapseDefault.default),
    Item: (0, _accordionItemDefault.default),
    Header: (0, _accordionHeaderDefault.default),
    Body: (0, _accordionBodyDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","uncontrollable":"c40ge","./ThemeProvider":"t5pcW","./AccordionBody":"hyg0i","./AccordionButton":"jQxqx","./AccordionCollapse":"iDw8C","./AccordionContext":"hDBzM","./AccordionHeader":"jzDUD","./AccordionItem":"e6Rs5","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Een2":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"c40ge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolled", ()=>(0, _hookDefault.default));
parcelHelpers.export(exports, "useUncontrolledProp", ()=>(0, _hook.useUncontrolledProp));
parcelHelpers.export(exports, "uncontrollable", ()=>(0, _uncontrollableDefault.default));
var _hook = require("./hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _uncontrollable = require("./uncontrollable");
var _uncontrollableDefault = parcelHelpers.interopDefault(_uncontrollable);

},{"./hook":"3IxN9","./uncontrollable":"6dISo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IxN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolledProp", ()=>useUncontrolledProp);
parcelHelpers.export(exports, "default", ()=>useUncontrolled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("./utils");
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    var wasPropRef = (0, _react.useRef)(propValue !== undefined);
    var _useState = (0, _react.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[_utils.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            _utils.defaultKey(fieldName),
            fieldName
        ].map(_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, _extendsDefault.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","./utils":"ecpNS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAOJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGdYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecpNS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uncontrolledPropTypes", ()=>uncontrolledPropTypes);
parcelHelpers.export(exports, "isProp", ()=>isProp);
parcelHelpers.export(exports, "defaultKey", ()=>defaultKey);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ parcelHelpers.export(exports, "canAcceptRef", ()=>canAcceptRef);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var noop = function noop() {};
function readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function uncontrolledPropTypes(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[defaultKey(prop)] = noop;
        var handler;
    });
    return propTypes;
}
function isProp(props, prop) {
    return props[prop] !== undefined;
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function canAcceptRef(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

},{"invariant":"eNRZI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNRZI":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"6dISo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uncontrollable);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _utils = require("./utils");
var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function uncontrollable(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = _utils.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map(_utils.defaultKey);
    !(canAcceptRef || !methods.length) && (0, _invariantDefault.default)(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, _extendsDefault.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[_utils.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, _extendsDefault.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!_utils.isProp(props, key) && _utils.isProp(prevProps, key)) nextState.values[key] = props[_utils.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, _reactDefault.default).Component);
    (0, _reactLifecyclesCompat.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, _extendsDefault.default)({
        innerRef: function innerRef() {}
    }, _utils.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, _reactDefault.default).forwardRef) {
        WrappedComponent = (0, _reactDefault.default).forwardRef(function(props, ref) {
            return (0, _reactDefault.default).createElement(UncontrolledComponent, (0, _extendsDefault.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return uncontrollable(newComponent, (0, _extendsDefault.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","react-lifecycles-compat":"9jQEY","invariant":"eNRZI","./utils":"ecpNS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cnxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UMxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9jQEY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"t5pcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_BREAKPOINTS", ()=>DEFAULT_BREAKPOINTS);
parcelHelpers.export(exports, "DEFAULT_MIN_BREAKPOINT", ()=>DEFAULT_MIN_BREAKPOINT);
parcelHelpers.export(exports, "useBootstrapPrefix", ()=>useBootstrapPrefix);
parcelHelpers.export(exports, "useBootstrapBreakpoints", ()=>useBootstrapBreakpoints);
parcelHelpers.export(exports, "useBootstrapMinBreakpoint", ()=>useBootstrapMinBreakpoint);
parcelHelpers.export(exports, "useIsRTL", ()=>useIsRTL);
parcelHelpers.export(exports, "createBootstrapComponent", ()=>createBootstrapComponent);
parcelHelpers.export(exports, "ThemeConsumer", ()=>Consumer);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DEFAULT_BREAKPOINTS = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/ _react.createContext({
    prefixes: {},
    breakpoints: DEFAULT_BREAKPOINTS,
    minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const { Consumer, Provider } = ThemeContext;
function ThemeProvider({ prefixes = {}, breakpoints = DEFAULT_BREAKPOINTS, minBreakpoint = DEFAULT_MIN_BREAKPOINT, dir, children }) {
    const contextValue = (0, _react.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints,
            minBreakpoint,
            dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: contextValue,
        children: children
    });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
    const { prefixes } = (0, _react.useContext)(ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
    const { breakpoints } = (0, _react.useContext)(ThemeContext);
    return breakpoints;
}
function useBootstrapMinBreakpoint() {
    const { minBreakpoint } = (0, _react.useContext)(ThemeContext);
    return minBreakpoint;
}
function useIsRTL() {
    const { dir } = (0, _react.useContext)(ThemeContext);
    return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix, forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ _react.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
exports.default = ThemeProvider;

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dlk8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"NFgXB"}],"NFgXB":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"hyg0i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionItemContext = require("./AccordionItemContext");
var _accordionItemContextDefault = parcelHelpers.interopDefault(_accordionItemContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AccordionBody = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix, className, onEnter, onEntering, onEntered, onExit, onExiting, onExited, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-body');
    const { eventKey } = (0, _react.useContext)((0, _accordionItemContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionCollapseDefault.default), {
        eventKey: eventKey,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, bsPrefix)
        })
    });
});
AccordionBody.displayName = 'AccordionBody';
exports.default = AccordionBody;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./AccordionCollapse":"iDw8C","./AccordionItemContext":"71yBl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDw8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
/**
 * This component accepts all of [`Collapse`'s props](/docs/utilities/transitions#collapse-1).
 */ const AccordionCollapse = /*#__PURE__*/ _react.forwardRef(({ as: Component = 'div', bsPrefix, className, children, eventKey, ...props }, ref)=>{
    const { activeEventKey } = (0, _react.useContext)((0, _accordionContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-collapse');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
        ref: ref,
        in: (0, _accordionContext.isAccordionItemSelected)(activeEventKey, eventKey),
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            children: _react.Children.only(children)
        })
    });
});
AccordionCollapse.displayName = 'AccordionCollapse';
exports.default = AccordionCollapse;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./Collapse":"juTQl","./AccordionContext":"hDBzM","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juTQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("react-transition-group/Transition");
var _utils = require("@restart/ui/utils");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
const MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, _cssDefault.default)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, _cssDefault.default)(elem, margins[1]), 10);
}
const collapseStyles = {
    [(0, _transition.EXITED)]: 'collapse',
    [(0, _transition.EXITING)]: 'collapsing',
    [(0, _transition.ENTERING)]: 'collapsing',
    [(0, _transition.ENTERED)]: 'collapse show'
};
const Collapse = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ onEnter, onEntering, onEntered, onExit, onExiting, className, children, dimension = 'height', in: inProp = false, timeout = 300, mountOnEnter = false, unmountOnExit = false, appear = false, getDimensionValue = getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, _triggerBrowserReflowDefault.default)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, _utils.getChildRef)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
// @ts-ignore
exports.default = Collapse;

},{"classnames":"5Een2","dom-helpers/css":"2nGUd","react":"9njXz","react-transition-group/Transition":"6LVcl","@restart/ui/utils":"lH0qp","./transitionEndListener":"cbuHm","./createChainedFunction":"i4IJD","./triggerBrowserReflow":"cZXZ6","./TransitionWrapper":"jxF2v","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nGUd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getComputedStyle = require("./getComputedStyle");
var _getComputedStyleDefault = parcelHelpers.interopDefault(_getComputedStyle);
var _hyphenateStyle = require("./hyphenateStyle");
var _hyphenateStyleDefault = parcelHelpers.interopDefault(_hyphenateStyle);
var _isTransform = require("./isTransform");
var _isTransformDefault = parcelHelpers.interopDefault(_isTransform);
function style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, _hyphenateStyleDefault.default)(property)) || (0, _getComputedStyleDefault.default)(node).getPropertyValue((0, _hyphenateStyleDefault.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, _hyphenateStyleDefault.default)(key));
        else if ((0, _isTransformDefault.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, _hyphenateStyleDefault.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
exports.default = style;

},{"./getComputedStyle":"jBpff","./hyphenateStyle":"hWlqW","./isTransform":"308as","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jBpff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
function getComputedStyle(node, psuedoElement) {
    return (0, _ownerWindowDefault.default)(node).getComputedStyle(node, psuedoElement);
}

},{"./ownerWindow":"foj4A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"foj4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    var doc = (0, _ownerDocumentDefault.default)(node);
    return doc && doc.defaultView || window;
}

},{"./ownerDocument":"dYqIu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYqIu":[function(require,module,exports,__globalThis) {
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWlqW":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hyphenateStyleName);
var _hyphenate = require("./hyphenate");
var _hyphenateDefault = parcelHelpers.interopDefault(_hyphenate);
var msPattern = /^ms-/;
function hyphenateStyleName(string) {
    return (0, _hyphenateDefault.default)(string).replace(msPattern, '-ms-');
}

},{"./hyphenate":"4Twlo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Twlo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hyphenate);
var rUpper = /([A-Z])/g;
function hyphenate(string) {
    return string.replace(rUpper, '-$1').toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"308as":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTransform);
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
    return !!(value && supportedTransforms.test(value));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LVcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./config":"7vGu2","./utils/PropTypes":"8gMVu","./TransitionGroupContext":"162y0","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnNSm":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"aLk8j"}],"aLk8j":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"di8d9"}],"di8d9":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"7vGu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"162y0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V7Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lH0qp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEscKey", ()=>isEscKey);
parcelHelpers.export(exports, "getReactVersion", ()=>getReactVersion);
parcelHelpers.export(exports, "getChildRef", ()=>getChildRef);
var _react = require("react");
function isEscKey(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function getReactVersion() {
    const parts = _react.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function getChildRef(element) {
    if (!element || typeof element === 'function') return null;
    const { major } = getReactVersion();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbuHm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEndListener);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _transitionEnd = require("dom-helpers/transitionEnd");
var _transitionEndDefault = parcelHelpers.interopDefault(_transitionEnd);
function parseDuration(node, property) {
    const str = (0, _cssDefault.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
    const duration = parseDuration(element, 'transitionDuration');
    const delay = parseDuration(element, 'transitionDelay');
    const remove = (0, _transitionEndDefault.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

},{"dom-helpers/css":"2nGUd","dom-helpers/transitionEnd":"cOav3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOav3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEnd);
var _css = require("./css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _listen = require("./listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _triggerEvent = require("./triggerEvent");
var _triggerEventDefault = parcelHelpers.interopDefault(_triggerEvent);
function parseDuration(node) {
    var str = (0, _cssDefault.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, _triggerEventDefault.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, _listenDefault.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function transitionEnd(element, handler, duration, padding) {
    if (duration == null) duration = parseDuration(element) || 0;
    var removeEmulate = emulateTransitionEnd(element, duration, padding);
    var remove = (0, _listenDefault.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

},{"./css":"2nGUd","./listen":"bQcJW","./triggerEvent":"93u22","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQcJW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addEventListener = require("./addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _removeEventListener = require("./removeEventListener");
var _removeEventListenerDefault = parcelHelpers.interopDefault(_removeEventListener);
function listen(node, eventName, handler, options) {
    (0, _addEventListenerDefault.default)(node, eventName, handler, options);
    return function() {
        (0, _removeEventListenerDefault.default)(node, eventName, handler, options);
    };
}
exports.default = listen;

},{"./addEventListener":"avJ0E","./removeEventListener":"5Dy7j","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avJ0E":[function(require,module,exports,__globalThis) {
/* eslint-disable no-return-assign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optionsSupported", ()=>optionsSupported);
parcelHelpers.export(exports, "onceSupported", ()=>onceSupported);
var _canUseDOM = require("./canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var optionsSupported = false;
var onceSupported = false;
try {
    var options = {
        get passive () {
            return optionsSupported = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return onceSupported = optionsSupported = true;
        }
    };
    if (0, _canUseDOMDefault.default) {
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !onceSupported) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!onceSupported && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
exports.default = addEventListener;

},{"./canUseDOM":"5QOsw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5QOsw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Dy7j":[function(require,module,exports,__globalThis) {
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
exports.default = removeEventListener;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93u22":[function(require,module,exports,__globalThis) {
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>triggerEvent);
function triggerEvent(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4IJD":[function(require,module,exports,__globalThis) {
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
exports.default = createChainedFunction;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZXZ6":[function(require,module,exports,__globalThis) {
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>triggerBrowserReflow);
function triggerBrowserReflow(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jxF2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("react-transition-group/Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children, childRef, ...props }, ref)=>{
    const nodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, _safeFindDOMNodeDefault.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, _react.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, _react.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, _react.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, _react.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, _react.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, _react.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionDefault.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
            ref: attachRef
        })
    });
});
exports.default = TransitionWrapper;

},{"react":"9njXz","react-transition-group/Transition":"6LVcl","@restart/hooks/useMergedRefs":"cU99Q","./safeFindDOMNode":"c96Ll","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cU99Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _react = require("react");
const toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function mergeRefs(refA, refB) {
    const a = toFnRef(refA);
    const b = toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function useMergedRefs(refA, refB) {
    return (0, _react.useMemo)(()=>mergeRefs(refA, refB), [
        refA,
        refB
    ]);
}
exports.default = useMergedRefs;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c96Ll":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>safeFindDOMNode);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function safeFindDOMNode(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, _reactDomDefault.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

},{"react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDBzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAccordionItemSelected", ()=>isAccordionItemSelected);
var _react = require("react");
"use client";
function isAccordionItemSelected(activeEventKey, eventKey) {
    return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/ _react.createContext({});
context.displayName = 'AccordionContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71yBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext({
    eventKey: ''
});
context.displayName = 'AccordionItemContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQxqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAccordionButton", ()=>useAccordionButton);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionItemContext = require("./AccordionItemContext");
var _accordionItemContextDefault = parcelHelpers.interopDefault(_accordionItemContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function useAccordionButton(eventKey, onClick) {
    const { activeEventKey, onSelect, alwaysOpen } = (0, _react.useContext)((0, _accordionContextDefault.default));
    return (e)=>{
        /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */ let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;
        if (alwaysOpen) {
            if (Array.isArray(activeEventKey)) {
                if (activeEventKey.includes(eventKey)) eventKeyPassed = activeEventKey.filter((k)=>k !== eventKey);
                else eventKeyPassed = [
                    ...activeEventKey,
                    eventKey
                ];
            } else // activeEventKey is undefined.
            eventKeyPassed = [
                eventKey
            ];
        }
        onSelect == null || onSelect(eventKeyPassed, e);
        onClick == null || onClick(e);
    };
}
const AccordionButton = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', bsPrefix, className, onClick, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-button');
    const { eventKey } = (0, _react.useContext)((0, _accordionItemContextDefault.default));
    const accordionOnClick = useAccordionButton(eventKey, onClick);
    const { activeEventKey } = (0, _react.useContext)((0, _accordionContextDefault.default));
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        onClick: accordionOnClick,
        ...props,
        "aria-expanded": Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : eventKey === activeEventKey,
        className: (0, _classnamesDefault.default)(className, bsPrefix, !(0, _accordionContext.isAccordionItemSelected)(activeEventKey, eventKey) && 'collapsed')
    });
});
AccordionButton.displayName = 'AccordionButton';
exports.default = AccordionButton;

},{"react":"9njXz","classnames":"5Een2","./AccordionContext":"hDBzM","./AccordionItemContext":"71yBl","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzDUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AccordionHeader = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'h2', 'aria-controls': ariaControls, bsPrefix, className, children, onClick, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionButtonDefault.default), {
            onClick: onClick,
            "aria-controls": ariaControls,
            children: children
        })
    });
});
AccordionHeader.displayName = 'AccordionHeader';
exports.default = AccordionHeader;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./AccordionButton":"jQxqx","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6Rs5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _accordionItemContext = require("./AccordionItemContext");
var _accordionItemContextDefault = parcelHelpers.interopDefault(_accordionItemContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AccordionItem = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix, className, eventKey, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-item');
    const contextValue = (0, _react.useMemo)(()=>({
            eventKey
        }), [
        eventKey
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionItemContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, bsPrefix)
        })
    });
});
AccordionItem.displayName = 'AccordionItem';
exports.default = AccordionItem;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./AccordionItemContext":"71yBl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgAuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _themeProvider = require("./ThemeProvider");
var _alertHeading = require("./AlertHeading");
var _alertHeadingDefault = parcelHelpers.interopDefault(_alertHeading);
var _alertLink = require("./AlertLink");
var _alertLinkDefault = parcelHelpers.interopDefault(_alertLink);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Alert = /*#__PURE__*/ _react.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix, show = true, closeLabel = 'Close alert', closeVariant, className, children, variant = 'primary', onClose, dismissible, transition = (0, _fadeDefault.default), ...props } = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'alert');
    const handleClose = (0, _useEventCallbackDefault.default)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, _fadeDefault.default) : transition;
    const alert = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
Alert.displayName = 'Alert';
exports.default = Object.assign(Alert, {
    Link: (0, _alertLinkDefault.default),
    Heading: (0, _alertHeadingDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","uncontrollable":"c40ge","@restart/hooks/useEventCallback":"3MIRo","./ThemeProvider":"t5pcW","./AlertHeading":"j3fCL","./AlertLink":"ev0gV","./Fade":"fXf7Q","./CloseButton":"dT7Bb","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3MIRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventCallback);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useEventCallback(fn) {
    const ref = (0, _useCommittedRefDefault.default)(fn);
    return (0, _react.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

},{"react":"9njXz","./useCommittedRef":"ak3vi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ak3vi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function useCommittedRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
exports.default = useCommittedRef;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j3fCL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH4 = (0, _divWithClassNameDefault.default)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
const AlertHeading = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
AlertHeading.displayName = 'AlertHeading';
exports.default = AlertHeading;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","./divWithClassName":"7vB9M","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vB9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _jsxRuntime = require("react/jsx-runtime");
exports.default = (className)=>/*#__PURE__*/ _react.forwardRef((p, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, _classnamesDefault.default)(p.className, className)
        }));

},{"react":"9njXz","classnames":"5Een2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ev0gV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AlertLink = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = (0, _anchorDefault.default), ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
AlertLink.displayName = 'AlertLink';
exports.default = AlertLink;

},{"react":"9njXz","classnames":"5Een2","@restart/ui/Anchor":"f7VPb","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7VPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrivialHref", ()=>isTrivialHref);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/anchor-has-content */ var _react = require("react");
var _hooks = require("@restart/hooks");
var _button = require("./Button");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const Anchor = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { onKeyDown } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [buttonProps] = (0, _button.useButtonProps)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, _hooks.useEventCallback)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if (isTrivialHref(props.href) || props.role === 'button') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
Anchor.displayName = 'Anchor';
exports.default = Anchor;

},{"react":"9njXz","@restart/hooks":"eXoLy","./Button":"jYGKr","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXoLy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>(0, _useCallbackRefDefault.default));
parcelHelpers.export(exports, "useCommittedRef", ()=>(0, _useCommittedRefDefault.default));
parcelHelpers.export(exports, "useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "useEventListener", ()=>(0, _useEventListenerDefault.default));
parcelHelpers.export(exports, "useGlobalListener", ()=>(0, _useGlobalListenerDefault.default));
parcelHelpers.export(exports, "useInterval", ()=>(0, _useIntervalDefault.default));
parcelHelpers.export(exports, "useRafInterval", ()=>(0, _useRafIntervalDefault.default));
parcelHelpers.export(exports, "useMergeState", ()=>(0, _useMergeStateDefault.default));
parcelHelpers.export(exports, "useMergeStateFromProps", ()=>(0, _useMergeStateFromPropsDefault.default));
parcelHelpers.export(exports, "useMounted", ()=>(0, _useMountedDefault.default));
parcelHelpers.export(exports, "usePrevious", ()=>(0, _usePreviousDefault.default));
parcelHelpers.export(exports, "useImage", ()=>(0, _useImageDefault.default));
parcelHelpers.export(exports, "useResizeObserver", ()=>(0, _useResizeObserverDefault.default));
var _useCallbackRef = require("./useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useEventListener = require("./useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _useGlobalListener = require("./useGlobalListener");
var _useGlobalListenerDefault = parcelHelpers.interopDefault(_useGlobalListener);
var _useInterval = require("./useInterval");
var _useIntervalDefault = parcelHelpers.interopDefault(_useInterval);
var _useRafInterval = require("./useRafInterval");
var _useRafIntervalDefault = parcelHelpers.interopDefault(_useRafInterval);
var _useMergeState = require("./useMergeState");
var _useMergeStateDefault = parcelHelpers.interopDefault(_useMergeState);
var _useMergeStateFromProps = require("./useMergeStateFromProps");
var _useMergeStateFromPropsDefault = parcelHelpers.interopDefault(_useMergeStateFromProps);
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _usePrevious = require("./usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useImage = require("./useImage");
var _useImageDefault = parcelHelpers.interopDefault(_useImage);
var _useResizeObserver = require("./useResizeObserver");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);

},{"./useCallbackRef":"jw9sZ","./useCommittedRef":"eY6zG","./useEventCallback":"c26h1","./useEventListener":"hnYlw","./useGlobalListener":"9QsA9","./useInterval":"5Kexb","./useRafInterval":"i5oFz","./useMergeState":"8PAc7","./useMergeStateFromProps":"aUm9L","./useMounted":"3668D","./usePrevious":"3j5PE","./useImage":"2rpOv","./useResizeObserver":"6ahxy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jw9sZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef() {
    return (0, _react.useState)(null);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eY6zG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function useCommittedRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
exports.default = useCommittedRef;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c26h1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventCallback);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useEventCallback(fn) {
    const ref = (0, _useCommittedRefDefault.default)(fn);
    return (0, _react.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

},{"react":"9njXz","./useCommittedRef":"eY6zG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnYlw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventListener);
var _react = require("react");
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
function useEventListener(eventTarget, event, listener, capture = false) {
    const handler = (0, _useEventCallbackDefault.default)(listener);
    (0, _react.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

},{"react":"9njXz","./useEventCallback":"c26h1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9QsA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGlobalListener);
var _useEventListener = require("./useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _react = require("react");
function useGlobalListener(event, handler, capture = false) {
    const documentTarget = (0, _react.useCallback)(()=>document, []);
    return (0, _useEventListenerDefault.default)(documentTarget, event, handler, capture);
}

},{"./useEventListener":"hnYlw","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Kexb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, _useCommittedRefDefault.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, _useCommittedRefDefault.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, _react.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
exports.default = useInterval;

},{"react":"9njXz","./useCommittedRef":"eY6zG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5oFz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, _useCommittedRefDefault.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, _useCommittedRefDefault.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, _react.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
exports.default = useRafInterval;

},{"react":"9njXz","./useCommittedRef":"eY6zG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8PAc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergeState);
var _react = require("react");
function useMergeState(initialState) {
    const [state, setState] = (0, _react.useState)(initialState);
    const updater = (0, _react.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUm9L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergeStateFromProps);
var _useMergeState = require("./useMergeState");
var _useMergeStateDefault = parcelHelpers.interopDefault(_useMergeState);
function useMergeStateFromProps(props, gDSFP, initialState) {
    const [state, setState] = (0, _useMergeStateDefault.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

},{"./useMergeState":"8PAc7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3668D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMounted);
var _react = require("react");
function useMounted() {
    const mounted = (0, _react.useRef)(true);
    const isMounted = (0, _react.useRef)(()=>mounted.current);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3j5PE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePrevious);
var _react = require("react");
function usePrevious(value) {
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2rpOv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useImage);
var _react = require("react");
function useImage(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, _react.useState)({
        image: null,
        error: null
    });
    (0, _react.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image,
                error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ahxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
var _useIsomorphicEffect = require("./useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
const targetMap = new WeakMap();
let resizeObserver;
function getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return resizeObserver = resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function useResizeObserver(element) {
    const [rect, setRect] = (0, _react.useState)(null);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (!element) return;
        getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

},{"react":"9njXz","./useIsomorphicEffect":"8bm5s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8bm5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var global = arguments[3];
const isReactNative = typeof global !== 'undefined' && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ exports.default = isDOM || isReactNative ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYGKr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrivialHref", ()=>isTrivialHref);
parcelHelpers.export(exports, "useButtonProps", ()=>useButtonProps);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "disabled"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function isTrivialHref(href) {
    return !href || href.trim() === '#';
}
function useButtonProps({ tagName, disabled, href, target, rel, role, onClick, tabIndex = 0, type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const Button = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [buttonProps, { tagName: Component }] = useButtonProps(Object.assign({
        tagName: asProp,
        disabled
    }, props));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
Button.displayName = 'Button';
exports.default = Button;

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fXf7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _transition = require("react-transition-group/Transition");
var _utils = require("@restart/ui/utils");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
const fadeStyles = {
    [(0, _transition.ENTERING)]: 'show',
    [(0, _transition.ENTERED)]: 'show'
};
const Fade = /*#__PURE__*/ _react.forwardRef(({ className, children, transitionClasses = {}, onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, _react.useCallback)((node, isAppearing)=>{
        (0, _triggerBrowserReflowDefault.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        ...props,
        onEnter: handleEnter,
        childRef: (0, _utils.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ _react.cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
            })
    });
});
Fade.displayName = 'Fade';
exports.default = Fade;

},{"classnames":"5Een2","react":"9njXz","react-transition-group/Transition":"6LVcl","@restart/ui/utils":"lH0qp","./transitionEndListener":"cbuHm","./triggerBrowserReflow":"cZXZ6","./TransitionWrapper":"jxF2v","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dT7Bb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, _propTypesDefault.default).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, _propTypesDefault.default).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, _propTypesDefault.default).oneOf([
        'white'
    ])
};
const CloseButton = /*#__PURE__*/ _react.forwardRef(({ className, variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, _classnamesDefault.default)('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
exports.default = CloseButton;

},{"prop-types":"bnNSm","react":"9njXz","classnames":"5Een2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lFInU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Badge = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, bg = 'primary', pill = false, text, className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
Badge.displayName = 'Badge';
exports.default = Badge;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2TJC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _button = require("@restart/ui/Button");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Button = /*#__PURE__*/ _react.forwardRef(({ as, bsPrefix, variant = 'primary', size, active = false, disabled = false, className, ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn');
    const [buttonProps, { tagName }] = (0, _button.useButtonProps)({
        tagName: as,
        disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, _classnamesDefault.default)(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
Button.displayName = 'Button';
exports.default = Button;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/Button":"jYGKr","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wRtx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Card = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, bg, text, border, body = false, children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBodyDefault.default), {
            children: children
        }) : children
    });
});
Card.displayName = 'Card';
exports.default = Object.assign(Card, {
    Img: (0, _cardImgDefault.default),
    Title: (0, _cardTitleDefault.default),
    Subtitle: (0, _cardSubtitleDefault.default),
    Body: (0, _cardBodyDefault.default),
    Link: (0, _cardLinkDefault.default),
    Text: (0, _cardTextDefault.default),
    Header: (0, _cardHeaderDefault.default),
    Footer: (0, _cardFooterDefault.default),
    ImgOverlay: (0, _cardImgOverlayDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./CardBody":"hq2rx","./CardFooter":"cHRZt","./CardHeader":"csAMr","./CardImg":"1I73B","./CardImgOverlay":"iz6al","./CardLink":"aAZtG","./CardSubtitle":"iXmsL","./CardText":"js8fa","./CardTitle":"4OwFJ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hq2rx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardBody.displayName = 'CardBody';
exports.default = CardBody;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHRZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardFooter = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardFooter.displayName = 'CardFooter';
exports.default = CardFooter;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"csAMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _cardHeaderContext = require("./CardHeaderContext");
var _cardHeaderContextDefault = parcelHelpers.interopDefault(_cardHeaderContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-header');
    const contextValue = (0, _react.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, prefix)
        })
    });
});
CardHeader.displayName = 'CardHeader';
exports.default = CardHeader;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./CardHeaderContext":"lHQZO","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHQZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'CardHeaderContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1I73B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardImg = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix, className, variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
CardImg.displayName = 'CardImg';
exports.default = CardImg;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iz6al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardImgOverlay = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardImgOverlay.displayName = 'CardImgOverlay';
exports.default = CardImgOverlay;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAZtG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardLink = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardLink.displayName = 'CardLink';
exports.default = CardLink;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXmsL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH6 = (0, _divWithClassNameDefault.default)('h6');
const CardSubtitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardSubtitle.displayName = 'CardSubtitle';
exports.default = CardSubtitle;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","./divWithClassName":"7vB9M","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"js8fa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardText.displayName = 'CardText';
exports.default = CardText;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OwFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH5 = (0, _divWithClassNameDefault.default)('h5');
const CardTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardTitle.displayName = 'CardTitle';
exports.default = CardTitle;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","./divWithClassName":"7vB9M","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPBtB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCol", ()=>useCol);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function useCol({ as, bsPrefix, className, ...props }) {
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'col');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span, offset, order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, _classnamesDefault.default)(className, ...spans, ...classes)
        },
        {
            as,
            bsPrefix,
            spans
        }
    ];
}
const Col = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className, ...colProps }, { as: Component = 'div', bsPrefix, spans }] = useCol(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, !spans.length && bsPrefix)
    });
});
Col.displayName = 'Col';
exports.default = Col;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gNoAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdown = require("@restart/ui/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _uncontrollable = require("uncontrollable");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownItemText = require("./DropdownItemText");
var _dropdownItemTextDefault = parcelHelpers.interopDefault(_dropdownItemText);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _themeProvider = require("./ThemeProvider");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Dropdown = /*#__PURE__*/ _react.forwardRef((pProps, ref)=>{
    const { bsPrefix, drop = 'down', show, className, align = 'start', onSelect, onToggle, focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose = true, ...props } = (0, _uncontrollable.useUncontrolled)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, _react.useContext)((0, _inputGroupContextDefault.default));
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, _useEventCallbackDefault.default)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, _dropdownMenu.getDropdownMenuPlacement)(alignEnd, drop, isRTL);
    const contextValue = (0, _react.useMemo)(()=>({
            align,
            drop,
            isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, _classnamesDefault.default)(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
Dropdown.displayName = 'Dropdown';
exports.default = Object.assign(Dropdown, {
    Toggle: (0, _dropdownToggleDefault.default),
    Menu: (0, _dropdownMenuDefault.default),
    Item: (0, _dropdownItemDefault.default),
    ItemText: (0, _dropdownItemTextDefault.default),
    Divider: (0, _dropdownDividerDefault.default),
    Header: (0, _dropdownHeaderDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","@restart/ui/Dropdown":"cMilE","uncontrollable":"c40ge","@restart/hooks/useEventCallback":"3MIRo","./DropdownContext":"1OlZ9","./DropdownDivider":"dv1O6","./DropdownHeader":"fxhzi","./DropdownItem":"8Sdmp","./DropdownItemText":"aEmjc","./DropdownMenu":"8cCR3","./DropdownToggle":"gk26n","./InputGroupContext":"4oqFY","./ThemeProvider":"t5pcW","./types":"esAMz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMilE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _addEventListener = require("dom-helpers/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _usePrevious = require("@restart/hooks/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useForceUpdate = require("@restart/hooks/useForceUpdate");
var _useForceUpdateDefault = parcelHelpers.interopDefault(_useForceUpdate);
var _useEventListener = require("@restart/hooks/useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _dataKey = require("./DataKey");
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
var _jsxRuntime = require("react/jsx-runtime");
function useRefWithUpdate() {
    const forceUpdate = (0, _useForceUpdateDefault.default)();
    const ref = (0, _react.useRef)(null);
    const attachRef = (0, _react.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function Dropdown({ defaultShow, show: rawShow, onSelect, onToggle: rawOnToggle, itemSelector = `* [${(0, _dataKey.dataAttr)('dropdown-item')}]`, focusFirstItemOnShow, placement = 'bottom-start', children }) {
    const window = (0, _useWindowDefault.default)();
    const [show, onToggle] = (0, _uncontrollable.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, _usePreviousDefault.default)(show);
    const lastSourceEvent = (0, _react.useRef)(null);
    const focusInDropdown = (0, _react.useRef)(false);
    const onSelectCtx = (0, _react.useContext)((0, _selectableContextDefault.default));
    const toggle = (0, _react.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, _useEventCallbackDefault.default)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, _react.useMemo)(()=>({
            toggle,
            placement,
            show,
            menuElement,
            toggleElement,
            setMenu,
            setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, _useEventCallbackDefault.default)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, _useEventCallbackDefault.default)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, _dropdownToggle.isRoleMenu)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, _querySelectorAllDefault.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, _react.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, _react.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, _querySelectorAllDefault.default)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, _useEventListenerDefault.default)((0, _react.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, _addEventListenerDefault.default)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownContextDefault.default).Provider, {
            value: context,
            children: children
        })
    });
}
Dropdown.displayName = 'Dropdown';
Dropdown.Menu = (0, _dropdownMenuDefault.default);
Dropdown.Toggle = (0, _dropdownToggleDefault.default);
Dropdown.Item = (0, _dropdownItemDefault.default);
exports.default = Dropdown;

},{"dom-helpers/querySelectorAll":"gZHK3","dom-helpers/addEventListener":"avJ0E","react":"9njXz","uncontrollable":"74N91","@restart/hooks/usePrevious":"3j5PE","@restart/hooks/useForceUpdate":"j5gAr","@restart/hooks/useEventListener":"hnYlw","@restart/hooks/useEventCallback":"c26h1","./DropdownContext":"hxKWL","./DropdownMenu":"iWmjp","./DropdownToggle":"7snx4","./DropdownItem":"hheT8","./SelectableContext":"7v5if","./DataKey":"bOKZf","./useWindow":"kl9Hc","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZHK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>qsa);
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function qsa(element, selector) {
    return toArray(element.querySelectorAll(selector));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74N91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultKey", ()=>defaultKey);
parcelHelpers.export(exports, "useUncontrolledProp", ()=>useUncontrolledProp);
parcelHelpers.export(exports, "useUncontrolled", ()=>useUncontrolled);
var _react = require("react");
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    const wasPropRef = (0, _react.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, _react.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = defaultKey(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = _objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map(_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j5gAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForceUpdate);
var _react = require("react");
function useForceUpdate() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, _react.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hxKWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const DropdownContext = /*#__PURE__*/ _react.createContext(null);
exports.default = DropdownContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWmjp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @memberOf Dropdown
 * @param {object}  options
 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
 */ parcelHelpers.export(exports, "useDropdownMenu", ()=>useDropdownMenu);
var _react = require("react");
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _usePopper = require("./usePopper");
var _usePopperDefault = parcelHelpers.interopDefault(_usePopper);
var _useClickOutside = require("./useClickOutside");
var _useClickOutsideDefault = parcelHelpers.interopDefault(_useClickOutside);
var _mergeOptionsWithPopperConfig = require("./mergeOptionsWithPopperConfig");
var _mergeOptionsWithPopperConfigDefault = parcelHelpers.interopDefault(_mergeOptionsWithPopperConfig);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "usePopper"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const noop = ()=>{};
function useDropdownMenu(options = {}) {
    const context = (0, _react.useContext)((0, _dropdownContextDefault.default));
    const [arrowElement, attachArrowRef] = (0, _useCallbackRefDefault.default)();
    const hasShownRef = (0, _react.useRef)(false);
    const { flip, offset, rootCloseEvent, fixed = false, placement: placementOverride, popperConfig = {}, enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement, setMenu, menuElement, toggleElement } = context || {};
    const popper = (0, _usePopperDefault.default)(toggleElement, menuElement, (0, _mergeOptionsWithPopperConfigDefault.default)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset,
        flip,
        fixed,
        arrowElement,
        popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show,
        placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, _useClickOutsideDefault.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function DropdownMenu(_ref) {
    let { children, usePopper: usePopperProp = true } = _ref, options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [props, meta] = useDropdownMenu(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(props, meta)
    });
}
DropdownMenu.displayName = 'DropdownMenu';
/** @component */ exports.default = DropdownMenu;

},{"react":"9njXz","@restart/hooks/useCallbackRef":"jw9sZ","./DropdownContext":"hxKWL","./usePopper":"7MsdQ","./useClickOutside":"4Hdqf","./mergeOptionsWithPopperConfig":"5mUS1","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MsdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _dequal = require("dequal");
var _useSafeState = require("@restart/hooks/useSafeState");
var _useSafeStateDefault = parcelHelpers.interopDefault(_useSafeState);
var _popper = require("./popper");
const _excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state })=>()=>{
            const { reference, popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state })=>{
        var _popper$getAttribute;
        const { popper, reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled = true, placement = 'bottom', strategy = 'absolute', modifiers = EMPTY_MODIFIERS } = _ref, config = _objectWithoutPropertiesLoose(_ref, _excluded);
    const prevModifiers = (0, _react.useRef)(modifiers);
    const popperInstanceRef = (0, _react.useRef)();
    const update = (0, _react.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, _react.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, _useSafeStateDefault.default)((0, _react.useState)({
        placement,
        update,
        forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, _react.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state,
                    styles,
                    attributes,
                    update,
                    forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, _react.useMemo)(()=>{
        if (!(0, _dequal.dequal)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, _react.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement,
            strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, _popper.createPopper)(referenceElement, popperElement, Object.assign({}, config, {
            placement,
            strategy,
            modifiers: [
                ...nextModifiers,
                ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
exports.default = usePopper;

},{"react":"9njXz","dequal":"6p9iP","@restart/hooks/useSafeState":"lPcEZ","./popper":"fpAki","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6p9iP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dequal", ()=>dequal);
var has = Object.prototype.hasOwnProperty;
function find(iter, tar, key) {
    for (key of iter.keys()){
        if (dequal(key, tar)) return key;
    }
}
function dequal(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!dequal(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lPcEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function useSafeState(state) {
    const isMounted = (0, _useMountedDefault.default)();
    return [
        state[0],
        (0, _react.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
exports.default = useSafeState;

},{"react":"9njXz","./useMounted":"3668D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fpAki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "placements", ()=>(0, _enums.placements));
var _arrow = require("@popperjs/core/lib/modifiers/arrow");
var _arrowDefault = parcelHelpers.interopDefault(_arrow);
var _computeStyles = require("@popperjs/core/lib/modifiers/computeStyles");
var _computeStylesDefault = parcelHelpers.interopDefault(_computeStyles);
var _eventListeners = require("@popperjs/core/lib/modifiers/eventListeners");
var _eventListenersDefault = parcelHelpers.interopDefault(_eventListeners);
var _flip = require("@popperjs/core/lib/modifiers/flip");
var _flipDefault = parcelHelpers.interopDefault(_flip);
var _hide = require("@popperjs/core/lib/modifiers/hide");
var _hideDefault = parcelHelpers.interopDefault(_hide);
var _offset = require("@popperjs/core/lib/modifiers/offset");
var _offsetDefault = parcelHelpers.interopDefault(_offset);
var _popperOffsets = require("@popperjs/core/lib/modifiers/popperOffsets");
var _popperOffsetsDefault = parcelHelpers.interopDefault(_popperOffsets);
var _preventOverflow = require("@popperjs/core/lib/modifiers/preventOverflow");
var _preventOverflowDefault = parcelHelpers.interopDefault(_preventOverflow);
var _enums = require("@popperjs/core/lib/enums");
var _popperBase = require("@popperjs/core/lib/popper-base");
const createPopper = (0, _popperBase.popperGenerator)({
    defaultModifiers: [
        (0, _hideDefault.default),
        (0, _popperOffsetsDefault.default),
        (0, _computeStylesDefault.default),
        (0, _eventListenersDefault.default),
        (0, _offsetDefault.default),
        (0, _flipDefault.default),
        (0, _preventOverflowDefault.default),
        (0, _arrowDefault.default)
    ]
});

},{"@popperjs/core/lib/modifiers/arrow":"5Trmz","@popperjs/core/lib/modifiers/computeStyles":"jvHvj","@popperjs/core/lib/modifiers/eventListeners":"5tT8s","@popperjs/core/lib/modifiers/flip":"8WVPr","@popperjs/core/lib/modifiers/hide":"6kFua","@popperjs/core/lib/modifiers/offset":"2lcLd","@popperjs/core/lib/modifiers/popperOffsets":"hVDuj","@popperjs/core/lib/modifiers/preventOverflow":"jUko2","@popperjs/core/lib/enums":false,"@popperjs/core/lib/popper-base":"c5XtZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Trmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"5S4fc","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/contains.js":"eGlaM","../dom-utils/getOffsetParent.js":"bLvkb","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/within.js":"cdkh1","../utils/mergePaddingObject.js":"43lYJ","../utils/expandToHashMap.js":"16QKI","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5S4fc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVkdf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bweSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XyXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"1bDAn","../utils/math.js":"8B7aS","./getWindow.js":"3ynkX","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bDAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ynkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B7aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAhTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fpMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGlaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLvkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"3ynkX","./getNodeName.js":"jyQUh","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./isTableElement.js":"btBRX","./getParentNode.js":"k0cfu","../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyQUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uZSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"jyQUh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0cfu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"jyQUh","./getDocumentElement.js":"gcVmr","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcVmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avEhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdkh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43lYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gtdyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtdyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16QKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvHvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"gVkdf","../dom-utils/getOffsetParent.js":"bLvkb","../dom-utils/getWindow.js":"3ynkX","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getComputedStyle.js":"5uZSa","../utils/getBasePlacement.js":"5S4fc","../utils/getVariation.js":"4BYPr","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BYPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tT8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WVPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"htgah","../utils/getBasePlacement.js":"5S4fc","../utils/getOppositeVariationPlacement.js":"3n1hw","../utils/detectOverflow.js":"6v2ts","../utils/computeAutoPlacement.js":"clJeY","../enums.js":"gVkdf","../utils/getVariation.js":"4BYPr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htgah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v2ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"YPNSr","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getBoundingClientRect.js":"4XyXs","./computeOffsets.js":"gnv44","./rectToClientRect.js":"5PWlE","../enums.js":"gVkdf","../dom-utils/instanceOf.js":"1bDAn","./mergePaddingObject.js":"43lYJ","./expandToHashMap.js":"16QKI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YPNSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"gVkdf","./getViewportRect.js":"2wQ5y","./getDocumentRect.js":"3LAyO","./listScrollParents.js":"1qClO","./getOffsetParent.js":"bLvkb","./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./getBoundingClientRect.js":"4XyXs","./getParentNode.js":"k0cfu","./contains.js":"eGlaM","./getNodeName.js":"jyQUh","../utils/rectToClientRect.js":"5PWlE","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wQ5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"3ynkX","./getDocumentElement.js":"gcVmr","./getWindowScrollBarX.js":"kaNJ3","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaNJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"4XyXs","./getDocumentElement.js":"gcVmr","./getWindowScroll.js":"btekq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btekq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LAyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./getWindowScrollBarX.js":"kaNJ3","./getWindowScroll.js":"btekq","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qClO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"1igW6","./getParentNode.js":"k0cfu","./getWindow.js":"3ynkX","./isScrollParent.js":"eD7m7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1igW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"k0cfu","./isScrollParent.js":"eD7m7","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD7m7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"5uZSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PWlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnv44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"5S4fc","./getVariation.js":"4BYPr","./getMainAxisFromPlacement.js":"avEhJ","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clJeY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"4BYPr","../enums.js":"gVkdf","./detectOverflow.js":"6v2ts","./getBasePlacement.js":"5S4fc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kFua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"gVkdf","../utils/detectOverflow.js":"6v2ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lcLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"5S4fc","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVDuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"gnv44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUko2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"gVkdf","../utils/getBasePlacement.js":"5S4fc","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/getAltAxis.js":"l4M4a","../utils/within.js":"cdkh1","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/getOffsetParent.js":"bLvkb","../utils/detectOverflow.js":"6v2ts","../utils/getVariation.js":"4BYPr","../utils/getFreshSideObject.js":"gtdyp","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4M4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5XtZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "createPopper", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");

},{"./createPopper.js":"b4uCU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4uCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4mQXp","./dom-utils/getLayoutRect.js":"bweSm","./dom-utils/listScrollParents.js":"1qClO","./dom-utils/getOffsetParent.js":"bLvkb","./utils/orderModifiers.js":"4RWkj","./utils/debounce.js":"gcfKw","./utils/mergeByName.js":"kcmZR","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mQXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","./getNodeScroll.js":"8P5ka","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","./getWindowScrollBarX.js":"kaNJ3","./getDocumentElement.js":"gcVmr","./isScrollParent.js":"eD7m7","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P5ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"btekq","./getWindow.js":"3ynkX","./instanceOf.js":"1bDAn","./getHTMLElementScroll.js":"hYXUH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYXUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RWkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcfKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcmZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Hdqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRefTarget", ()=>getRefTarget);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
const noop = ()=>{};
function isLeftClickEvent(event) {
    return event.button === 0;
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = (ref)=>ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function useClickOutside(ref, onClickOutside = noop, { disabled, clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, _react.useRef)(false);
    const waitingForTrigger = (0, _react.useRef)(false);
    const handleMouseCapture = (0, _react.useCallback)((e)=>{
        const currentTarget = getRefTarget(ref);
        (0, _warningDefault.default)(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0, _containsDefault.default)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, _useEventCallbackDefault.default)((e)=>{
        const currentTarget = getRefTarget(ref);
        if (currentTarget && (0, _containsDefault.default)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, _useEventCallbackDefault.default)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, _react.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, _ownerDocumentDefault.default)(getRefTarget(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if (InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, _listenDefault.default)(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, _listenDefault.default)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, _listenDefault.default)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, _listenDefault.default)(el, 'mousemove', noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
exports.default = useClickOutside;

},{"dom-helpers/contains":"9MLeA","dom-helpers/listen":"bQcJW","dom-helpers/ownerDocument":"dYqIu","react":"9njXz","@restart/hooks/useEventCallback":"c26h1","warning":"4kUCc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9MLeA":[function(require,module,exports,__globalThis) {
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
function contains(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kUCc":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"5mUS1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toModifierMap", ()=>toModifierMap);
parcelHelpers.export(exports, "toModifierArray", ()=>toModifierArray);
parcelHelpers.export(exports, "default", ()=>mergeOptionsWithPopperConfig);
function toModifierMap(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function toModifierArray(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function mergeOptionsWithPopperConfig({ enabled, enableEvents, placement, flip, offset, fixed, containerPadding, arrowElement, popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = toModifierMap(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement,
        enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: toModifierArray(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7snx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRoleMenu", ()=>isRoleMenu);
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */ parcelHelpers.export(exports, "useDropdownToggle", ()=>useDropdownToggle);
var _react = require("react");
var _ssr = require("./ssr");
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _jsxRuntime = require("react/jsx-runtime");
const isRoleMenu = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const noop = ()=>{};
function useDropdownToggle() {
    const id = (0, _ssr.useSSRSafeId)();
    const { show = false, toggle = noop, setToggle, menuElement } = (0, _react.useContext)((0, _dropdownContextDefault.default)) || {};
    const handleClick = (0, _react.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id,
        ref: setToggle || noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && isRoleMenu(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show,
            toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function DropdownToggle({ children }) {
    const [props, meta] = useDropdownToggle();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(props, meta)
    });
}
DropdownToggle.displayName = 'DropdownToggle';
/** @component */ exports.default = DropdownToggle;

},{"react":"9njXz","./ssr":"kaaZ9","./DropdownContext":"hxKWL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaaZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSSRSafeId", ()=>(0, _ssr.useSSRSafeId));
parcelHelpers.export(exports, "useIsSSR", ()=>(0, _ssr.useIsSSR));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssr.SSRProvider));
var _ssr = require("@react-aria/ssr");

},{"@react-aria/ssr":"20GRK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20GRK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssrproviderMjs.SSRProvider));
parcelHelpers.export(exports, "useSSRSafeId", ()=>(0, _ssrproviderMjs.useSSRSafeId));
parcelHelpers.export(exports, "useIsSSR", ()=>(0, _ssrproviderMjs.useIsSSR));
var _ssrproviderMjs = require("./SSRProvider.mjs");

},{"./SSRProvider.mjs":"bm2XX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bm2XX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRProvider", ()=>$b5e257d569688ac6$export$9f8ac96af4b1b2ae);
parcelHelpers.export(exports, "useIsSSR", ()=>$b5e257d569688ac6$export$535bd6ca7f90a273);
parcelHelpers.export(exports, "useSSRSafeId", ()=>$b5e257d569688ac6$export$619500959fc48b26);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $b5e257d569688ac6$var$SSRContext = (0, _reactDefault.default).createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = (0, _reactDefault.default).createContext(false);
// This is only used in React < 18.
function $b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    let counter = $b5e257d569688ac6$var$useCounter(cur === $b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, _react.useState)(true);
    let value = (0, _react.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, _react.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement($b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $b5e257d569688ac6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, _reactDefault.default)['useId'] === 'function') {
        if (!$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    }
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    let ref = (0, _react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, _reactDefault.default).useId();
    let [didSSR] = (0, _react.useState)($b5e257d569688ac6$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof (0, _reactDefault.default)['useId'] === 'function' ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, _reactDefault.default)['useSyncExternalStore'] === 'function') return (0, _reactDefault.default)['useSyncExternalStore']($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)($b5e257d569688ac6$var$IsSSRContext);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hheT8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */ parcelHelpers.export(exports, "useDropdownItem", ()=>useDropdownItem);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dataKey = require("./DataKey");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useDropdownItem({ key, href, active, disabled, onClick }) {
    const onSelectCtx = (0, _react.useContext)((0, _selectableContextDefault.default));
    const navContext = (0, _react.useContext)((0, _navContextDefault.default));
    const { activeKey } = navContext || {};
    const eventKey = (0, _selectableContext.makeEventKey)(key, href);
    const isActive = active == null && key != null ? (0, _selectableContext.makeEventKey)(activeKey) === eventKey : active;
    const handleClick = (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, _dataKey.dataAttr)('dropdown-item')]: ''
        },
        {
            isActive
        }
    ];
}
const DropdownItem = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { eventKey, disabled, onClick, active, as: Component = (0, _buttonDefault.default) } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [dropdownItemProps] = useDropdownItem({
        key: eventKey,
        href: props.href,
        disabled,
        onClick,
        active
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
DropdownItem.displayName = 'DropdownItem';
exports.default = DropdownItem;

},{"react":"9njXz","@restart/hooks/useEventCallback":"c26h1","./SelectableContext":"7v5if","./NavContext":"67k7w","./Button":"jYGKr","./DataKey":"bOKZf","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7v5if":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeEventKey", ()=>makeEventKey);
var _react = require("react");
const SelectableContext = /*#__PURE__*/ _react.createContext(null);
const makeEventKey = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
exports.default = SelectableContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67k7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const NavContext = /*#__PURE__*/ _react.createContext(null);
NavContext.displayName = 'NavContext';
exports.default = NavContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOKZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATTRIBUTE_PREFIX", ()=>ATTRIBUTE_PREFIX);
parcelHelpers.export(exports, "PROPERTY_PREFIX", ()=>PROPERTY_PREFIX);
parcelHelpers.export(exports, "dataAttr", ()=>dataAttr);
parcelHelpers.export(exports, "dataProp", ()=>dataProp);
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
    return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
    return `${PROPERTY_PREFIX}${property}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kl9Hc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WindowProvider", ()=>WindowProvider);
parcelHelpers.export(exports, "default", ()=>useWindow);
var _react = require("react");
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
const Context = /*#__PURE__*/ (0, _react.createContext)((0, _canUseDOMDefault.default) ? window : undefined);
const WindowProvider = Context.Provider;
function useWindow() {
    return (0, _react.useContext)(Context);
}

},{"react":"9njXz","dom-helpers/canUseDOM":"5QOsw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1OlZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const DropdownContext = /*#__PURE__*/ _react.createContext({});
DropdownContext.displayName = 'DropdownContext';
exports.default = DropdownContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dv1O6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownDivider = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'hr', role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        role: role,
        ...props
    });
});
DropdownDivider.displayName = 'DropdownDivider';
exports.default = DropdownDivider;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxhzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownHeader = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        role: role,
        ...props
    });
});
DropdownHeader.displayName = 'DropdownHeader';
exports.default = DropdownHeader;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Sdmp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdownItem = require("@restart/ui/DropdownItem");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownItem = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, eventKey, disabled = false, onClick, active, as: Component = (0, _anchorDefault.default), ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, _dropdownItem.useDropdownItem)({
        key: eventKey,
        href: props.href,
        disabled,
        onClick,
        active
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
DropdownItem.displayName = 'DropdownItem';
exports.default = DropdownItem;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/DropdownItem":"hheT8","@restart/ui/Anchor":"f7VPb","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aEmjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownItemText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
DropdownItemText.displayName = 'DropdownItemText';
exports.default = DropdownItemText;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8cCR3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDropdownMenuPlacement", ()=>getDropdownMenuPlacement);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdownMenu = require("@restart/ui/DropdownMenu");
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _themeProvider = require("./ThemeProvider");
var _useWrappedRefWithWarning = require("./useWrappedRefWithWarning");
var _useWrappedRefWithWarningDefault = parcelHelpers.interopDefault(_useWrappedRefWithWarning);
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function getDropdownMenuPlacement(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const DropdownMenu = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, align, rootCloseEvent, flip = true, show: showProps, renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig, variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, _react.useContext)((0, _navbarContextDefault.default));
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop, isRTL } = (0, _react.useContext)((0, _dropdownContextDefault.default));
    align = align || contextAlign;
    const isInputGroup = (0, _react.useContext)((0, _inputGroupContextDefault.default));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
    const [menuProps, { hasShown, popper, show, toggle }] = (0, _dropdownMenu.useDropdownMenu)({
        flip,
        rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig,
        placement
    });
    menuProps.ref = (0, _useMergedRefsDefault.default)((0, _useWrappedRefWithWarningDefault.default)(ref, 'DropdownMenu'), menuProps.ref);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, _classnamesDefault.default)(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
DropdownMenu.displayName = 'DropdownMenu';
exports.default = DropdownMenu;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/DropdownMenu":"iWmjp","@restart/hooks/useIsomorphicEffect":"7BtXW","@restart/hooks/useMergedRefs":"cU99Q","warning":"4kUCc","./DropdownContext":"1OlZ9","./InputGroupContext":"4oqFY","./NavbarContext":"a9ajw","./ThemeProvider":"t5pcW","./useWrappedRefWithWarning":"lrJmu","./types":"esAMz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7BtXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var global = arguments[3];
const isReactNative = typeof global !== 'undefined' && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ exports.default = isDOM || isReactNative ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4oqFY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'InputGroupContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9ajw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// TODO: check
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'NavbarContext';
exports.default = context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lrJmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWrappedRefWithWarning);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _react = require("react");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
function useWrappedRefWithWarning(ref, componentName) {
    return ref;
}

},{"invariant":"eNRZI","react":"9njXz","@restart/hooks/useMergedRefs":"cU99Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esAMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignPropType", ()=>alignPropType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const alignDirection = (0, _propTypesDefault.default).oneOf([
    'start',
    'end'
]);
const alignPropType = (0, _propTypesDefault.default).oneOfType([
    alignDirection,
    (0, _propTypesDefault.default).shape({
        sm: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        md: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        lg: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        xl: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        xxl: alignDirection
    }),
    (0, _propTypesDefault.default).object
]);

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gk26n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _dropdownContext = require("@restart/ui/DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownToggle = require("@restart/ui/DropdownToggle");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _themeProvider = require("./ThemeProvider");
var _useWrappedRefWithWarning = require("./useWrappedRefWithWarning");
var _useWrappedRefWithWarningDefault = parcelHelpers.interopDefault(_useWrappedRefWithWarning);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownToggle = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, split, className, childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, _buttonDefault.default), ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, _react.useContext)((0, _dropdownContextDefault.default));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, _dropdownToggle.useDropdownToggle)();
    toggleProps.ref = (0, _useMergedRefsDefault.default)(toggleProps.ref, (0, _useWrappedRefWithWarningDefault.default)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        className: (0, _classnamesDefault.default)(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
DropdownToggle.displayName = 'DropdownToggle';
exports.default = DropdownToggle;

},{"@restart/hooks/useMergedRefs":"cU99Q","@restart/ui/DropdownContext":"hxKWL","@restart/ui/DropdownToggle":"7snx4","classnames":"5Een2","react":"9njXz","./Button":"2TJC6","./ThemeProvider":"t5pcW","./useWrappedRefWithWarning":"lrJmu","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j4K62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formFloating = require("./FormFloating");
var _formFloatingDefault = parcelHelpers.interopDefault(_formFloating);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _formRange = require("./FormRange");
var _formRangeDefault = parcelHelpers.interopDefault(_formRange);
var _formSelect = require("./FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _floatingLabel = require("./FloatingLabel");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, _propTypesDefault.default).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, _propTypesDefault.default).bool,
    as: (0, _propTypesDefault.default).elementType
};
const Form = /*#__PURE__*/ _react.forwardRef(({ className, validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, validated && 'was-validated')
    }));
Form.displayName = 'Form';
Form.propTypes = propTypes;
exports.default = Object.assign(Form, {
    Group: (0, _formGroupDefault.default),
    Control: (0, _formControlDefault.default),
    Floating: (0, _formFloatingDefault.default),
    Check: (0, _formCheckDefault.default),
    Switch: (0, _switchDefault.default),
    Label: (0, _formLabelDefault.default),
    Text: (0, _formTextDefault.default),
    Range: (0, _formRangeDefault.default),
    Select: (0, _formSelectDefault.default),
    FloatingLabel: (0, _floatingLabelDefault.default)
});

},{"classnames":"5Een2","prop-types":"bnNSm","react":"9njXz","./FormCheck":"htLFH","./FormControl":"9lN0O","./FormFloating":"jCzko","./FormGroup":"gsqum","./FormLabel":"55u89","./FormRange":"7rmLr","./FormSelect":"f1nIg","./FormText":"lxOxd","./Switch":"4SYah","./FloatingLabel":"4JRQj","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htLFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _formCheckInput = require("./FormCheckInput");
var _formCheckInputDefault = parcelHelpers.interopDefault(_formCheckInput);
var _formCheckLabel = require("./FormCheckLabel");
var _formCheckLabelDefault = parcelHelpers.interopDefault(_formCheckLabel);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _elementChildren = require("./ElementChildren");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheck = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, bsSwitchPrefix, inline = false, reverse = false, disabled = false, isValid = false, isInvalid = false, feedbackTooltip = false, feedback, feedbackType, className, style, title = '', type = 'checkbox', label, children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, _themeProvider.useBootstrapPrefix)(bsSwitchPrefix, 'form-switch');
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    const innerFormContext = (0, _react.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, _elementChildren.hasChildOfType)(children, (0, _formCheckLabelDefault.default));
    const input = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formContextDefault.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: style,
            className: (0, _classnamesDefault.default)(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckLabelDefault.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _feedbackDefault.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
FormCheck.displayName = 'FormCheck';
exports.default = Object.assign(FormCheck, {
    Input: (0, _formCheckInputDefault.default),
    Label: (0, _formCheckLabelDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","./Feedback":"emJBq","./FormCheckInput":"aMgAd","./FormCheckLabel":"fw9o6","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","./ElementChildren":"1QKQY","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emJBq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, _propTypesDefault.default).string,
    /** Display feedback as a tooltip. */ tooltip: (0, _propTypesDefault.default).bool,
    as: (0, _propTypesDefault.default).elementType
};
const Feedback = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className, type = 'valid', tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
exports.default = Feedback;

},{"classnames":"5Een2","react":"9njXz","prop-types":"bnNSm","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMgAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheckInput = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, className, type = 'checkbox', isValid = false, isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, _classnamesDefault.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
FormCheckInput.displayName = 'FormCheckInput';
exports.default = FormCheckInput;

},{"classnames":"5Een2","react":"9njXz","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4PwAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// TODO
const FormContext = /*#__PURE__*/ _react.createContext({});
exports.default = FormContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fw9o6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheckLabel = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, htmlFor, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, _classnamesDefault.default)(className, bsPrefix)
    });
});
FormCheckLabel.displayName = 'FormCheckLabel';
exports.default = FormCheckLabel;

},{"classnames":"5Een2","react":"9njXz","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1QKQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "hasChildOfType", ()=>hasChildOfType);
var _react = require("react");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function map(children, func) {
    let index = 0;
    return _react.Children.map(children, (child)=>/*#__PURE__*/ _react.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function forEach(children, func) {
    let index = 0;
    _react.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ _react.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function hasChildOfType(children, type) {
    return _react.Children.toArray(children).some((child)=>/*#__PURE__*/ _react.isValidElement(child) && child.type === type);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9lN0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormControl = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, type, size, htmlSize, id, className, isValid = false, isInvalid = false, plaintext, readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, _classnamesDefault.default)(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
FormControl.displayName = 'FormControl';
exports.default = Object.assign(FormControl, {
    Feedback: (0, _feedbackDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","warning":"4kUCc","./Feedback":"emJBq","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCzko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormFloating = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
FormFloating.displayName = 'FormFloating';
exports.default = FormFloating;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsqum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
const FormGroup = /*#__PURE__*/ _react.forwardRef(({ controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, _react.useMemo)(()=>({
            controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formContextDefault.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
FormGroup.displayName = 'FormGroup';
exports.default = FormGroup;

},{"react":"9njXz","./FormContext":"4PwAV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"55u89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormLabel = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix, column = false, visuallyHidden = false, className, htmlFor, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, _classnamesDefault.default)(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colDefault.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
FormLabel.displayName = 'FormLabel';
exports.default = FormLabel;

},{"classnames":"5Een2","react":"9njXz","warning":"4kUCc","./Col":"aPBtB","./FormContext":"4PwAV","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7rmLr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormRange = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, id, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        id: id || controlId
    });
});
FormRange.displayName = 'FormRange';
exports.default = FormRange;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./FormContext":"4PwAV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1nIg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormSelect = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, htmlSize, className, isValid = false, isInvalid = false, id, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
FormSelect.displayName = 'FormSelect';
exports.default = FormSelect;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./FormContext":"4PwAV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lxOxd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormText = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix, className, as: Component = 'small', muted, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, muted && 'text-muted')
    });
});
FormText.displayName = 'FormText';
exports.default = FormText;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SYah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _jsxRuntime = require("react/jsx-runtime");
const Switch = /*#__PURE__*/ _react.forwardRef((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckDefault.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
Switch.displayName = 'Switch';
exports.default = Object.assign(Switch, {
    Input: (0, _formCheckDefault.default).Input,
    Label: (0, _formCheckDefault.default).Label
});

},{"react":"9njXz","./FormCheck":"htLFH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4JRQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FloatingLabel = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, controlId, label, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formGroupDefault.default), {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
FloatingLabel.displayName = 'FloatingLabel';
exports.default = FloatingLabel;

},{"classnames":"5Een2","react":"9njXz","./FormGroup":"gsqum","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7wCS3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propTypes", ()=>propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const propTypes = {
    /**
   * @default 'img'
   */ bsPrefix: (0, _propTypesDefault.default).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, _propTypesDefault.default).bool
};
const Image = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, fluid = false, rounded = false, roundedCircle = false, thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
Image.displayName = 'Image';
exports.default = Image;

},{"classnames":"5Een2","react":"9njXz","prop-types":"bnNSm","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAasA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _addEventListener = require("dom-helpers/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _removeEventListener = require("dom-helpers/removeEventListener");
var _removeEventListenerDefault = parcelHelpers.interopDefault(_removeEventListener);
var _scrollbarSize = require("dom-helpers/scrollbarSize");
var _scrollbarSizeDefault = parcelHelpers.interopDefault(_scrollbarSize);
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useWillUnmount = require("@restart/hooks/useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
var _transitionEnd = require("dom-helpers/transitionEnd");
var _transitionEndDefault = parcelHelpers.interopDefault(_transitionEnd);
var _react = require("react");
var _modal = require("@restart/ui/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _bootstrapModalManager = require("./BootstrapModalManager");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function DialogTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        timeout: null
    });
}
function BackdropTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const Modal = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, style, dialogClassName, contentClassName, children, dialogAs: Dialog = (0, _modalDialogDefault.default), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, /* BaseModal props */ show = false, animation = true, backdrop = true, keyboard = true, onEscapeKeyDown, onShow, onHide, container, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, onEntered, onExit, onExiting, onEnter, onEntering, onExited, backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, _react.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, _react.useState)(false);
    const waitingForMouseUpRef = (0, _react.useRef)(false);
    const ignoreBackdropClickRef = (0, _react.useRef)(false);
    const removeStaticModalAnimationRef = (0, _react.useRef)(null);
    const [modal, setModalRef] = (0, _useCallbackRefDefault.default)();
    const mergedRef = (0, _useMergedRefsDefault.default)(ref, setModalRef);
    const handleHide = (0, _useEventCallbackDefault.default)(onHide);
    const isRTL = (0, _themeProvider.useIsRTL)();
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
    const modalContext = (0, _react.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, _bootstrapModalManager.getSharedManager)({
            isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, _canUseDOMDefault.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, _ownerDocumentDefault.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSizeDefault.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, _scrollbarSizeDefault.default)() : undefined
        });
    }
    const handleWindowResize = (0, _useEventCallbackDefault.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, _useWillUnmountDefault.default)(()=>{
        (0, _removeEventListenerDefault.default)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, _transitionEndDefault.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, _addEventListenerDefault.default)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, _removeEventListenerDefault.default)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, _react.useCallback)((backdropProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...backdropProps,
            className: (0, _classnamesDefault.default)(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, _classnamesDefault.default)(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContextDefault.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? DialogTransition : undefined,
            backdropTransition: animation ? BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
Modal.displayName = 'Modal';
exports.default = Object.assign(Modal, {
    Body: (0, _modalBodyDefault.default),
    Header: (0, _modalHeaderDefault.default),
    Title: (0, _modalTitleDefault.default),
    Footer: (0, _modalFooterDefault.default),
    Dialog: (0, _modalDialogDefault.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

},{"classnames":"5Een2","dom-helpers/addEventListener":"avJ0E","dom-helpers/canUseDOM":"5QOsw","dom-helpers/ownerDocument":"dYqIu","dom-helpers/removeEventListener":"5Dy7j","dom-helpers/scrollbarSize":"5JWeg","@restart/hooks/useCallbackRef":"grmD6","@restart/hooks/useEventCallback":"3MIRo","@restart/hooks/useMergedRefs":"cU99Q","@restart/hooks/useWillUnmount":"hRbyz","dom-helpers/transitionEnd":"cOav3","react":"9njXz","@restart/ui/Modal":"5Yzsg","./BootstrapModalManager":"kAoPB","./Fade":"fXf7Q","./ModalBody":"kdcAl","./ModalContext":"5jB7t","./ModalDialog":"hgJO8","./ModalFooter":"j8rD6","./ModalHeader":"fIJA9","./ModalTitle":"jXE6T","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JWeg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scrollbarSize);
var _canUseDOM = require("./canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var size;
function scrollbarSize(recalc) {
    if (!size && size !== 0 || recalc) {
        if (0, _canUseDOMDefault.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return size;
}

},{"./canUseDOM":"5QOsw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grmD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef() {
    return (0, _react.useState)(null);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRbyz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWillUnmount);
var _useUpdatedRef = require("./useUpdatedRef");
var _useUpdatedRefDefault = parcelHelpers.interopDefault(_useUpdatedRef);
var _react = require("react");
function useWillUnmount(fn) {
    const onUnmount = (0, _useUpdatedRefDefault.default)(fn);
    (0, _react.useEffect)(()=>()=>onUnmount.current(), []);
}

},{"./useUpdatedRef":"fBxt4","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fBxt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatedRef);
var _react = require("react");
function useUpdatedRef(value) {
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Yzsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */ var _activeElement = require("dom-helpers/activeElement");
var _activeElementDefault = parcelHelpers.interopDefault(_activeElement);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _useMounted = require("@restart/hooks/useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _useWillUnmount = require("@restart/hooks/useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
var _usePrevious = require("@restart/hooks/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _modalManager = require("./ModalManager");
var _modalManagerDefault = parcelHelpers.interopDefault(_modalManager);
var _useWaitForDOMRef = require("./useWaitForDOMRef");
var _useWaitForDOMRefDefault = parcelHelpers.interopDefault(_useWaitForDOMRef);
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
var _imperativeTransition = require("./ImperativeTransition");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function getManager(window) {
    if (!manager) manager = new (0, _modalManagerDefault.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return manager;
}
function useModalManager(provided) {
    const window = (0, _useWindowDefault.default)();
    const modalManager = provided || getManager(window);
    const modal = (0, _react.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, _react.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, _react.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const Modal = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { show = false, role = 'dialog', className, style, children, backdrop = true, keyboard = true, onBackdropClick, onEscapeKeyDown, transition, runTransition, backdropTransition, runBackdropTransition, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, renderDialog, renderBackdrop = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow, onHide = ()=>{}, onExit, onExited, onExiting, onEnter, onEntering, onEntered } = _ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const ownerWindow = (0, _useWindowDefault.default)();
    const container = (0, _useWaitForDOMRefDefault.default)(containerRef);
    const modal = useModalManager(providedManager);
    const isMounted = (0, _useMountedDefault.default)();
    const prevShow = (0, _usePreviousDefault.default)(show);
    const [exited, setExited] = (0, _react.useState)(!show);
    const lastFocusRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, _canUseDOMDefault.default) && !prevShow && show) lastFocusRef.current = (0, _activeElementDefault.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, _useEventCallbackDefault.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, _listenDefault.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, _listenDefault.default)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, _activeElementDefault.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, _containsDefault.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, _useEventCallbackDefault.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, _react.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, _react.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, _useWillUnmountDefault.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, _useEventCallbackDefault.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, _activeElementDefault.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, _containsDefault.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, _useEventCallbackDefault.default)((e)=>{
        if (keyboard && (0, _utils.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, _react.useRef)();
    const removeKeydownListenerRef = (0, _react.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style,
        className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ _react.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, _imperativeTransition.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit,
        onExiting,
        onExited: handleHidden,
        onEnter,
        onEntering,
        onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, _imperativeTransition.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
Modal.displayName = 'Modal';
exports.default = Object.assign(Modal, {
    Manager: (0, _modalManagerDefault.default)
});

},{"dom-helpers/activeElement":"h7UXc","dom-helpers/contains":"9MLeA","dom-helpers/canUseDOM":"5QOsw","dom-helpers/listen":"bQcJW","react":"9njXz","react-dom":"2ApDx","@restart/hooks/useMounted":"3668D","@restart/hooks/useWillUnmount":"bPMnG","@restart/hooks/usePrevious":"3j5PE","@restart/hooks/useEventCallback":"c26h1","./ModalManager":"94NM8","./useWaitForDOMRef":"jJO5R","./useWindow":"kl9Hc","./ImperativeTransition":"iWxJ1","./utils":"lH0qp","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7UXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>activeElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function activeElement(doc) {
    if (doc === void 0) doc = (0, _ownerDocumentDefault.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

},{"./ownerDocument":"dYqIu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPMnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWillUnmount);
var _useUpdatedRef = require("./useUpdatedRef");
var _useUpdatedRefDefault = parcelHelpers.interopDefault(_useUpdatedRef);
var _react = require("react");
function useWillUnmount(fn) {
    const onUnmount = (0, _useUpdatedRefDefault.default)(fn);
    (0, _react.useEffect)(()=>()=>onUnmount.current(), []);
}

},{"./useUpdatedRef":"fvFQD","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvFQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatedRef);
var _react = require("react");
function useUpdatedRef(value) {
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"94NM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPEN_DATA_ATTRIBUTE", ()=>OPEN_DATA_ATTRIBUTE);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _dataKey = require("./DataKey");
var _getScrollbarWidth = require("./getScrollbarWidth");
var _getScrollbarWidthDefault = parcelHelpers.interopDefault(_getScrollbarWidth);
const OPEN_DATA_ATTRIBUTE = (0, _dataKey.dataAttr)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class ModalManager {
    constructor({ ownerDocument, handleContainerOverflow = true, isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, _getScrollbarWidthDefault.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, _cssDefault.default)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
        (0, _cssDefault.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute(OPEN_DATA_ATTRIBUTE);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
exports.default = ModalManager;

},{"dom-helpers/css":"2nGUd","./DataKey":"bOKZf","./getScrollbarWidth":"hQums","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQums":[function(require,module,exports,__globalThis) {
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBodyScrollbarWidth);
function getBodyScrollbarWidth(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJO5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveContainerRef", ()=>resolveContainerRef);
parcelHelpers.export(exports, "default", ()=>useWaitForDOMRef);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _react = require("react");
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
const resolveContainerRef = (ref, document)=>{
    if (!(0, _canUseDOMDefault.default)) return null;
    if (ref == null) return (document || (0, _ownerDocumentDefault.default)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function useWaitForDOMRef(ref, onResolved) {
    const window = (0, _useWindowDefault.default)();
    const [resolvedRef, setRef] = (0, _react.useState)(()=>resolveContainerRef(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = resolveContainerRef(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, _react.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, _react.useEffect)(()=>{
        const nextRef = resolveContainerRef(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

},{"dom-helpers/ownerDocument":"dYqIu","dom-helpers/canUseDOM":"5QOsw","react":"9njXz","./useWindow":"kl9Hc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWxJ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransition", ()=>useTransition);
parcelHelpers.export(exports, "default", ()=>ImperativeTransition);
parcelHelpers.export(exports, "renderTransition", ()=>renderTransition);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noopTransition = require("./NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _rtgtransition = require("./RTGTransition");
var _rtgtransitionDefault = parcelHelpers.interopDefault(_rtgtransition);
var _jsxRuntime = require("react/jsx-runtime");
function useTransition({ in: inProp, onTransition }) {
    const ref = (0, _react.useRef)(null);
    const isInitialRef = (0, _react.useRef)(true);
    const handleTransition = (0, _useEventCallbackDefault.default)(onTransition);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function ImperativeTransition({ children, in: inProp, onExited, onEntered, transition }) {
    const [exited, setExited] = (0, _react.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = useTransition({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, _useMergedRefsDefault.default)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ref: combinedRef
    });
}
function renderTransition(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtgtransitionDefault.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImperativeTransition, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noopTransitionDefault.default), Object.assign({}, props));
}

},{"@restart/hooks/useMergedRefs":"eqVs8","@restart/hooks/useEventCallback":"c26h1","@restart/hooks/useIsomorphicEffect":"8bm5s","react":"9njXz","./NoopTransition":"8Sbaq","./RTGTransition":"902WH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqVs8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _react = require("react");
const toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function mergeRefs(refA, refB) {
    const a = toFnRef(refA);
    const b = toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function useMergedRefs(refA, refB) {
    return (0, _react.useMemo)(()=>mergeRefs(refA, refB), [
        refA,
        refB
    ]);
}
exports.default = useMergedRefs;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Sbaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _react = require("react");
function NoopTransition({ children, in: inProp, onExited, mountOnEnter, unmountOnExit }) {
    const ref = (0, _react.useRef)(null);
    const hasEnteredRef = (0, _react.useRef)(inProp);
    const handleExited = (0, _useEventCallbackDefault.default)(onExited);
    (0, _react.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, _useMergedRefsDefault.default)(ref, children.ref);
    const child = /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
exports.default = NoopTransition;

},{"@restart/hooks/useEventCallback":"c26h1","@restart/hooks/useMergedRefs":"eqVs8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"902WH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useRTGTransitionProps = require("./useRTGTransitionProps");
var _useRTGTransitionPropsDefault = parcelHelpers.interopDefault(_useRTGTransitionProps);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "component"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const RTGTransition = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const transitionProps = (0, _useRTGTransitionPropsDefault.default)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
exports.default = RTGTransition;

},{"react":"9njXz","./useRTGTransitionProps":"djLnS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"djLnS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRTGTransitionProps);
var _react = require("react");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _utils = require("./utils");
const _excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useRTGTransitionProps(_ref) {
    let { onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const nodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(nodeRef, (0, _utils.getChildRef)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, _react.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, _react.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, _react.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, _react.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, _react.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, _react.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

},{"react":"9njXz","@restart/hooks/useMergedRefs":"eqVs8","./utils":"lH0qp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAoPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSharedManager", ()=>getSharedManager);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _modalManager = require("@restart/ui/ModalManager");
var _modalManagerDefault = parcelHelpers.interopDefault(_modalManager);
const Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends (0, _modalManagerDefault.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, _cssDefault.default)(element, {
            [prop]: `${parseFloat((0, _cssDefault.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, _cssDefault.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, _addClassDefault.default)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, _querySelectorAllDefault.default)(container, Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, _querySelectorAllDefault.default)(container, Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, _querySelectorAllDefault.default)(container, Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, _removeClassDefault.default)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, _querySelectorAllDefault.default)(container, Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, _querySelectorAllDefault.default)(container, Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, _querySelectorAllDefault.default)(container, Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let sharedManager;
function getSharedManager(options) {
    if (!sharedManager) sharedManager = new BootstrapModalManager(options);
    return sharedManager;
}
exports.default = BootstrapModalManager;

},{"dom-helpers/addClass":"16v5y","dom-helpers/css":"2nGUd","dom-helpers/querySelectorAll":"gZHK3","dom-helpers/removeClass":"cUvLe","@restart/ui/ModalManager":"94NM8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16v5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"3I5QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5QN":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUvLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdcAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalBody.displayName = 'ModalBody';
exports.default = ModalBody;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jB7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const ModalContext = /*#__PURE__*/ _react.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
exports.default = ModalContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgJO8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalDialog = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, contentClassName, centered, size, fullscreen, children, scrollable, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _classnamesDefault.default)(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
ModalDialog.displayName = 'ModalDialog';
exports.default = ModalDialog;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8rD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalFooter = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalFooter.displayName = 'ModalFooter';
exports.default = ModalFooter;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fIJA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _abstractModalHeader = require("./AbstractModalHeader");
var _abstractModalHeaderDefault = parcelHelpers.interopDefault(_abstractModalHeader);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, closeLabel = 'Close', closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _abstractModalHeaderDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
ModalHeader.displayName = 'ModalHeader';
exports.default = ModalHeader;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","./AbstractModalHeader":"9nfuk","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nfuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AbstractModalHeader = /*#__PURE__*/ _react.forwardRef(({ closeLabel = 'Close', closeVariant, closeButton = false, onHide, children, ...props }, ref)=>{
    const context = (0, _react.useContext)((0, _modalContextDefault.default));
    const handleClick = (0, _useEventCallbackDefault.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
exports.default = AbstractModalHeader;

},{"react":"9njXz","@restart/hooks/useEventCallback":"3MIRo","./CloseButton":"dT7Bb","./ModalContext":"5jB7t","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXE6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH4 = (0, _divWithClassNameDefault.default)('h4');
const ModalTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalTitle.displayName = 'ModalTitle';
exports.default = ModalTitle;

},{"react":"9njXz","classnames":"5Een2","./divWithClassName":"7vB9M","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXM49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _nav = require("@restart/ui/Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _cardHeaderContext = require("./CardHeaderContext");
var _cardHeaderContextDefault = parcelHelpers.interopDefault(_cardHeaderContext);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Nav = /*#__PURE__*/ _react.forwardRef((uncontrolledProps, ref)=>{
    const { as = 'div', bsPrefix: initialBsPrefix, variant, fill = false, justify = false, navbar, navbarScroll, className, activeKey, ...props } = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, _react.useContext)((0, _navbarContextDefault.default));
    const cardHeaderContext = (0, _react.useContext)((0, _cardHeaderContextDefault.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, _classnamesDefault.default)(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
Nav.displayName = 'Nav';
exports.default = Object.assign(Nav, {
    Item: (0, _navItemDefault.default),
    Link: (0, _navLinkDefault.default)
});

},{"classnames":"5Een2","react":"9njXz","uncontrollable":"c40ge","@restart/ui/Nav":"aBPog","./ThemeProvider":"t5pcW","./NavbarContext":"a9ajw","./CardHeaderContext":"lHQZO","./NavItem":"7IC9t","./NavLink":"kAcSd","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBPog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _react = require("react");
var _useForceUpdate = require("@restart/hooks/useForceUpdate");
var _useForceUpdateDefault = parcelHelpers.interopDefault(_useForceUpdate);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _dataKey = require("./DataKey");
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const EVENT_KEY_ATTR = (0, _dataKey.dataAttr)('event-key');
const Nav = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect, activeKey, role, onKeyDown } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, _useForceUpdateDefault.default)();
    const needsRefocusRef = (0, _react.useRef)(false);
    const parentOnSelect = (0, _react.useContext)((0, _selectableContextDefault.default));
    const tabContext = (0, _react.useContext)((0, _tabContextDefault.default));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, _react.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, _querySelectorAllDefault.default)(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, _dataKey.dataProp)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, _react.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, _useMergedRefsDefault.default)(ref, listNode);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navContextDefault.default).Provider, {
            value: {
                role,
                // used by NavLink to determine it's role
                activeKey: (0, _selectableContext.makeEventKey)(activeKey),
                getControlledId: getControlledId || noop,
                getControllerId: getControllerId || noop
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
Nav.displayName = 'Nav';
exports.default = Object.assign(Nav, {
    Item: (0, _navItemDefault.default)
});

},{"dom-helpers/querySelectorAll":"gZHK3","react":"9njXz","@restart/hooks/useForceUpdate":"j5gAr","@restart/hooks/useMergedRefs":"eqVs8","./NavContext":"67k7w","./SelectableContext":"7v5if","./TabContext":"2mDhT","./DataKey":"bOKZf","./NavItem":"bche0","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2mDhT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const TabContext = /*#__PURE__*/ _react.createContext(null);
exports.default = TabContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bche0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNavItem", ()=>useNavItem);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dataKey = require("./DataKey");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "active",
    "eventKey"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useNavItem({ key, onClick, active, id, role, disabled }) {
    const parentOnSelect = (0, _react.useContext)((0, _selectableContextDefault.default));
    const navContext = (0, _react.useContext)((0, _navContextDefault.default));
    const tabContext = (0, _react.useContext)((0, _tabContextDefault.default));
    let isActive = active;
    const props = {
        role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, _dataKey.dataAttr)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive
        }
    ];
}
const NavItem = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { as: Component = (0, _buttonDefault.default), active, eventKey } = _ref, options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [props, meta] = useNavItem(Object.assign({
        key: (0, _selectableContext.makeEventKey)(eventKey, options.href),
        active
    }, options));
    // @ts-ignore
    props[(0, _dataKey.dataAttr)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
NavItem.displayName = 'NavItem';
exports.default = NavItem;

},{"react":"9njXz","@restart/hooks/useEventCallback":"c26h1","./NavContext":"67k7w","./SelectableContext":"7v5if","./Button":"jYGKr","./DataKey":"bOKZf","./TabContext":"2mDhT","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IC9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavItem = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
NavItem.displayName = 'NavItem';
exports.default = NavItem;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAcSd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _navItem = require("@restart/ui/NavItem");
var _selectableContext = require("@restart/ui/SelectableContext");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavLink = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, as: Component = (0, _anchorDefault.default), active, eventKey, disabled = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, _navItem.useNavItem)({
        key: (0, _selectableContext.makeEventKey)(eventKey, props.href),
        active,
        disabled,
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, _classnamesDefault.default)(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
NavLink.displayName = 'NavLink';
exports.default = NavLink;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/Anchor":"f7VPb","@restart/ui/NavItem":"bche0","@restart/ui/SelectableContext":"7v5if","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBOje":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Row = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'row');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, decoratedBsPrefix, ...classes)
    });
});
Row.displayName = 'Row';
exports.default = Row;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l1HB0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tabContainer = require("./TabContainer");
var _tabContainerDefault = parcelHelpers.interopDefault(_tabContainer);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
/* eslint-disable react/no-unused-prop-types */ const propTypes = {
    eventKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, _propTypesDefault.default).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, _propTypesDefault.default).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, _propTypesDefault.default).object
};
const Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
Tab.propTypes = propTypes;
exports.default = Object.assign(Tab, {
    Container: (0, _tabContainerDefault.default),
    Content: (0, _tabContentDefault.default),
    Pane: (0, _tabPaneDefault.default)
});

},{"prop-types":"bnNSm","./TabContainer":"1ZuK5","./TabContent":"9NUjK","./TabPane":"4esm2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ZuK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _tabs = require("@restart/ui/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _getTabTransitionComponent = require("./getTabTransitionComponent");
var _getTabTransitionComponentDefault = parcelHelpers.interopDefault(_getTabTransitionComponent);
var _jsxRuntime = require("react/jsx-runtime");
const TabContainer = ({ transition, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
        ...props,
        transition: (0, _getTabTransitionComponentDefault.default)(transition)
    });
TabContainer.displayName = 'TabContainer';
exports.default = TabContainer;

},{"react":"9njXz","@restart/ui/Tabs":"weroK","./getTabTransitionComponent":"eJheb","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"weroK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _ssr = require("./ssr");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabPanel = require("./TabPanel");
var _tabPanelDefault = parcelHelpers.interopDefault(_tabPanel);
var _jsxRuntime = require("react/jsx-runtime");
const Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey, transition, mountOnEnter, unmountOnExit, children } = props;
    const [activeKey, onSelect] = (0, _uncontrollable.useUncontrolledProp)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, _ssr.useSSRSafeId)(userId);
    const generateChildId = (0, _react.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, _react.useMemo)(()=>({
            onSelect,
            activeKey,
            transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContextDefault.default).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
Tabs.Panel = (0, _tabPanelDefault.default);
exports.default = Tabs;

},{"react":"9njXz","uncontrollable":"74N91","./ssr":"kaaZ9","./TabContext":"2mDhT","./SelectableContext":"7v5if","./TabPanel":"ebPcg","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebPcg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTabPanel", ()=>useTabPanel);
var _react = require("react");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _noopTransition = require("./NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], _excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], _excluded3 = [
    "as"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useTabPanel(_ref) {
    let { active, eventKey, mountOnEnter, transition, unmountOnExit, role = 'tabpanel', onEnter, onEntering, onEntered, onExit, onExiting, onExited } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const context = (0, _react.useContext)((0, _tabContextDefault.default));
    if (!context) return [
        Object.assign({}, props, {
            role
        }),
        {
            eventKey,
            isActive: active,
            mountOnEnter,
            transition,
            unmountOnExit,
            onEnter,
            onEntering,
            onEntered,
            onExit,
            onExiting,
            onExited
        }
    ];
    const { activeKey, getControlledId, getControllerId } = context, rest = _objectWithoutPropertiesLoose(context, _excluded2);
    const key = (0, _selectableContext.makeEventKey)(eventKey);
    return [
        Object.assign({}, props, {
            role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey,
            isActive: active == null && key != null ? (0, _selectableContext.makeEventKey)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter,
            onEntering,
            onEntered,
            onExit,
            onExiting,
            onExited
        }
    ];
}
const TabPanel = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = _objectWithoutPropertiesLoose(_ref2, _excluded3);
    const [tabPanelProps, { isActive, onEnter, onEntering, onEntered, onExit, onExiting, onExited, mountOnEnter, unmountOnExit, transition: Transition = (0, _noopTransitionDefault.default) }] = useTabPanel(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
TabPanel.displayName = 'TabPanel';
exports.default = TabPanel;

},{"react":"9njXz","./TabContext":"2mDhT","./SelectableContext":"7v5if","./NoopTransition":"8Sbaq","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eJheb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTabTransitionComponent);
var _noopTransition = require("@restart/ui/NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
function getTabTransitionComponent(transition) {
    if (typeof transition === 'boolean') return transition ? (0, _fadeDefault.default) : (0, _noopTransitionDefault.default);
    return transition;
}

},{"@restart/ui/NoopTransition":"8Sbaq","./Fade":"fXf7Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9NUjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const TabContent = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
TabContent.displayName = 'TabContent';
exports.default = TabContent;

},{"react":"9njXz","classnames":"5Een2","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4esm2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _selectableContext = require("@restart/ui/SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabContext = require("@restart/ui/TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _tabPanel = require("@restart/ui/TabPanel");
var _themeProvider = require("./ThemeProvider");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _getTabTransitionComponent = require("./getTabTransitionComponent");
var _getTabTransitionComponentDefault = parcelHelpers.interopDefault(_getTabTransitionComponent);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const TabPane = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, transition, ...props }, ref)=>{
    const [{ className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive, onEnter, onEntering, onEntered, onExit, onExiting, onExited, mountOnEnter, unmountOnExit, transition: Transition = (0, _fadeDefault.default) }] = (0, _tabPanel.useTabPanel)({
        ...props,
        transition: (0, _getTabTransitionComponentDefault.default)(transition)
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, _classnamesDefault.default)(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
TabPane.displayName = 'TabPane';
exports.default = TabPane;

},{"classnames":"5Een2","react":"9njXz","@restart/ui/SelectableContext":"7v5if","@restart/ui/TabContext":"2mDhT","@restart/ui/TabPanel":"ebPcg","./ThemeProvider":"t5pcW","./Fade":"fXf7Q","./getTabTransitionComponent":"eJheb","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kqOLP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Table = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, striped, bordered, borderless, hover, size, variant, responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'table');
    const classes = (0, _classnamesDefault.default)(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
exports.default = Table;

},{"classnames":"5Een2","react":"9njXz","./ThemeProvider":"t5pcW","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ESNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _tabs = require("@restart/ui/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _elementChildren = require("./ElementChildren");
var _getTabTransitionComponent = require("./getTabTransitionComponent");
var _getTabTransitionComponentDefault = parcelHelpers.interopDefault(_getTabTransitionComponent);
var _jsxRuntime = require("react/jsx-runtime");
function getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, _elementChildren.forEach)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function renderTab(child) {
    const { title, eventKey, disabled, tabClassName, tabAttrs, id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItemDefault.default), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navLinkDefault.default), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const Tabs = (props)=>{
    const { id, onSelect, transition, mountOnEnter = false, unmountOnExit = false, variant = 'tabs', children, activeKey = getDefaultActiveKey(children), ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabsDefault.default), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, _getTabTransitionComponentDefault.default)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, _elementChildren.map)(children, renderTab)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContentDefault.default), {
                children: (0, _elementChildren.map)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabPaneDefault.default), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
Tabs.displayName = 'Tabs';
exports.default = Tabs;

},{"react":"9njXz","uncontrollable":"c40ge","@restart/ui/Tabs":"weroK","./Nav":"iXM49","./NavLink":"kAcSd","./NavItem":"7IC9t","./TabContent":"9NUjK","./TabPane":"4esm2","./ElementChildren":"1QKQY","./getTabTransitionComponent":"eJheb","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WKTx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bounce", ()=>lt);
parcelHelpers.export(exports, "Flip", ()=>uo);
parcelHelpers.export(exports, "Icons", ()=>W);
parcelHelpers.export(exports, "Slide", ()=>mo);
parcelHelpers.export(exports, "ToastContainer", ()=>Lt);
parcelHelpers.export(exports, "Zoom", ()=>po);
parcelHelpers.export(exports, "collapseToast", ()=>Z);
parcelHelpers.export(exports, "cssTransition", ()=>$);
parcelHelpers.export(exports, "toast", ()=>y);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
"use client";
function Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var L = (t)=>typeof t == "number" && !isNaN(t), N = (t)=>typeof t == "string", P = (t)=>typeof t == "function", mt = (t)=>N(t) || L(t), B = (t)=>N(t) || P(t) ? t : null, pt = (t, o)=>t === !1 || L(t) && t > 0 ? t : o, z = (t)=>(0, _react.isValidElement)(t) || N(t) || P(t) || L(t);
function Z(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, _react.useRef)(0);
        return (0, _react.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, _react.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? Z(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, a);
    };
}
function J(t, o) {
    return {
        content: tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function tt(t, o, e = !1) {
    return (0, _react.isValidElement)(t) && !N(t.type) ? (0, _react.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, _reactDefault.default).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, _reactDefault.default).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, _clsxDefault.default)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, _clsxDefault.default)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, _reactDefault.default).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, _reactDefault.default).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, _reactDefault.default).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var Xt = 1, at = ()=>`${Xt++}`;
function _t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e(J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: B(n.className || d.toastClassName),
                progressClassName: B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e(J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var I = new Map, F = [], st = new Set, Vt = (t)=>st.forEach((o)=>o(t)), bt = ()=>I.size > 0;
function Qt() {
    F.forEach((t)=>nt(t.content, t.options)), F = [];
}
var vt = (t, { containerId: o })=>{
    var e;
    return (e = I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function X(t, o) {
    var r;
    if (o) return !!((r = I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function ht(t) {
    if (!bt()) {
        F = F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || mt(t)) I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = I.get(t.containerId);
        o ? o.removeToast(t.id) : I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var Ct = (t = {})=>{
    I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function nt(t, o) {
    z(t) && (bt() || F.push({
        content: t,
        options: o
    }), I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function xt(t) {
    var o;
    (o = I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function rt(t, o) {
    I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = _t(o, t, Vt);
            I.set(o, r);
            let s = r.observe(e);
            return Qt(), ()=>{
                s(), I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function Pt(t) {
    return st.add(t), ()=>{
        st.delete(t);
    };
}
function Wt(t) {
    return t && (N(t.toastId) || L(t.toastId)) ? t.toastId : at();
}
function U(t, o) {
    return nt(t, o), o.toastId;
}
function V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: Wt(o)
    };
}
function Q(t) {
    return (o, e)=>U(o, V(t, e));
}
function y(t, o) {
    return U(t, V("default", o));
}
y.loading = (t, o)=>U(t, V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = N(o) ? y.loading(o, s) : y.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            y.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = N(g) ? {
            render: g
        } : g;
        return l ? y.update(l, {
            ...x,
            ...C
        }) : y(C.render, {
            ...x,
            ...C
        }), v;
    }, c = P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
y.promise = Gt;
y.success = Q("success");
y.info = Q("info");
y.error = Q("error");
y.warning = Q("warning");
y.warn = y.warning;
y.dark = (t, o)=>U(t, V("default", {
        theme: "dark",
        ...o
    }));
function qt(t) {
    ht(t);
}
y.dismiss = qt;
y.clearWaitingQueue = Ct;
y.isActive = X;
y.update = (t, o = {})=>{
    let e = vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, U(a, l);
    }
};
y.done = (t)=>{
    y.update(t, {
        progress: 1
    });
};
y.onChange = Pt;
y.play = (t)=>rt(!0, t);
y.pause = (t)=>rt(!1, t);
function It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, _react.useRef)(Et(t)).current;
    r(t);
    let s = (a = (0, _react.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: X,
        count: s == null ? void 0 : s.length
    };
}
function At(t) {
    let [o, e] = (0, _react.useState)(!1), [r, s] = (0, _react.useState)(!1), l = (0, _react.useRef)(null), a = (0, _react.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, _react.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var Ot = typeof window != "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function ao(t) {
    return (0, _reactDefault.default).createElement(G, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function so(t) {
    return (0, _reactDefault.default).createElement(G, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function no(t) {
    return (0, _reactDefault.default).createElement(G, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function ro(t) {
    return (0, _reactDefault.default).createElement(G, {
        ...t
    }, (0, _reactDefault.default).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function io() {
    return (0, _reactDefault.default).createElement("div", {
        className: "Toastify__spinner"
    });
}
var W = {
    info: so,
    warning: ao,
    success: no,
    error: ro,
    spinner: io
}, lo = (t)=>t in W;
function Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || (P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, _react.isValidElement)(r) ? s = (0, _react.cloneElement)(r, l) : e ? s = W.spinner() : lo(o) && (s = W[o](l))), s;
}
var wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, _clsxDefault.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, _clsxDefault.default)(D, E), ft = Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || (P(a) ? H = a(j) : (0, _react.isValidElement)(a) ? H = (0, _react.cloneElement)(a, j) : H = yt(j)), (0, _reactDefault.default).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, _reactDefault.default).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, _reactDefault.default).createElement("div", {
        className: (0, _clsxDefault.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), tt(d, t, !o), H, !t.customProgressBar && (0, _reactDefault.default).createElement(gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), lt = $(K("bounce", !0)), mo = $(K("slide", !0)), po = $(K("zoom")), uo = $(K("flip"));
var _o = {
    position: "top-right",
    transition: lt,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function Lt(t) {
    let o = {
        ..._o,
        ...t
    }, e = t.stacked, [r, s] = (0, _react.useState)(!0), l = (0, _react.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, _clsxDefault.default)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, _clsxDefault.default)(p, B(T));
    }
    function E() {
        e && (s(!0), y.play());
    }
    return Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, _react.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), y.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), y.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, _reactDefault.default).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), y.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, _reactDefault.default).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, _reactDefault.default).createElement(wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}

},{"react":"9njXz","clsx":"d2NWs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d2NWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUiuP":[function(require,module,exports,__globalThis) {
/*! For license information please see jodit-react.js.LICENSE.txt */ var process = require("5e7d119fdf429a8d");
!function(e, t) {
    module.exports = t(require("b01e18314089337f"));
}(self, (e)=>(()=>{
        "use strict";
        var t = {
            616: (e, t, o)=>{
                o.d(t, {
                    A: ()=>g
                });
                var n = o(772), r = o.n(n), i = o(333), a = o.n(i), l = o(504), s = o.n(l), c = new URL(o(523), o.b), u = new URL(o(789), o.b), d = new URL(o(65), o.b), f = a()(r()), p = s()(c), h = s()(u), v = s()(d);
                f.push([
                    e.id,
                    `.jodit-ui-group{display:inline-flex;flex:0 0 auto;flex-shrink:0;flex-wrap:wrap;max-width:100%}.jodit-ui-group_line_true{display:flex;justify-content:stretch}.jodit-ui-group_separated_true:not(:last-child):not(.jodit-ui-group_before-spacer_true):after{border-left:0;border-right:1px solid var(--jd-color-border);content:"";cursor:default;margin:2px;padding:0}.jodit-ui-group:last-child{border-bottom:0}.jodit-ui-list{display:flex;flex-direction:column}.jodit-ui-list_mode_vertical .jodit-ui-group{background-color:transparent;border:0;flex-direction:column}.jodit-ui-list_mode_vertical .jodit-toolbar-button{height:auto;min-height:var(--jd-button-size)}.jodit-ui-list_mode_vertical .jodit-toolbar-button__button{cursor:pointer;height:auto;min-height:var(--jd-button-size);width:100%}.jodit-ui-list_mode_vertical .jodit-toolbar-button__text:not(:empty){justify-content:left}.jodit-ui-separator{border-left:0;border-right:1px solid var(--jd-color-border);cursor:default;margin:2px;padding:0}.jodit-ui-break{border-top:1px solid var(--jd-color-border);flex-basis:100%;height:0!important;width:0}.jodit-ui-spacer{flex:1}.jodit-ui-button-icon-text__icon{display:none}.jodit-ui-button-icon-text__icon:not(:empty){display:inline-flex}.jodit-ui-button-icon-text__text{display:none}.jodit-ui-button-icon-text__text:not(:empty){display:inline-flex;flex-grow:1;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);justify-content:center;overflow:hidden;text-overflow:ellipsis}.jodit-ui-button-icon-text_context_menu .jodit-ui-button-icon-text__text{justify-content:left;padding-left:var(--jd-padding-default);position:relative}.jodit-ui-button-icon-text_context_menu .jodit-ui-button-icon-text__text:before{border-left:1px solid var(--jd-color-border);content:"";height:35px;left:0;position:absolute;top:calc(var(--jd-padding-default)*-1)}.jodit-ui-button-icon-text__icon:not(:empty)+.jodit-ui-button-icon-text__text:not(:empty){margin-left:var(--jd-padding-default)}.jodit-ui-button-icon-text__icon:empty+.jodit-ui-button-icon-text__text:not(:empty){padding:0 var(--jd-padding-default)}.jodit-ui-button-clear,.jodit-ui-button_clear{appearance:none;background:0 0;border:0;box-shadow:none;box-sizing:border-box;font-style:normal;outline:0;padding:0;position:relative;text-align:center;text-decoration:none;text-transform:none;user-select:none}.jodit-ui-button-sizes{height:34px;min-width:34px}.jodit-ui-button-sizes .jodit-icon{height:14px;width:14px}.jodit-ui-button-sizes button{appearance:none;height:34px;min-width:34px;padding:0}.jodit-ui-button-sizes_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button-sizes_size_tiny{height:16px;min-width:16px}.jodit-ui-button-sizes_size_tiny .jodit-icon{height:8px;width:8px}.jodit-ui-button-sizes_size_tiny button{appearance:none;height:16px;min-width:16px;padding:0}.jodit-ui-button-sizes_size_tiny_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button-sizes_size_xsmall{height:22px;min-width:22px}.jodit-ui-button-sizes_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-ui-button-sizes_size_xsmall button{appearance:none;height:22px;min-width:22px;padding:0}.jodit-ui-button-sizes_size_xsmall_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button-sizes_size_small{height:28px;min-width:28px}.jodit-ui-button-sizes_size_small .jodit-icon{height:12px;width:12px}.jodit-ui-button-sizes_size_small button{appearance:none;height:28px;min-width:28px;padding:0}.jodit-ui-button-sizes_size_small_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button-sizes_size_large{height:40px;min-width:40px}.jodit-ui-button-sizes_size_large .jodit-icon{height:16px;width:16px}.jodit-ui-button-sizes_size_large button{appearance:none;height:40px;min-width:40px;padding:0}.jodit-ui-button-sizes_size_large_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button-variants_variant_outline{border:1px solid var(--jd-color-border)}.jodit-ui-button-variants_variant_default{background-color:#e3e3e3;color:#212529}.jodit-ui-button-variants_variant_default svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_default [disabled]{opacity:.7}.jodit-ui-button-variants_variant_default:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button-variants_variant_default:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_default:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button-variants_variant_default:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_default:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button-variants_variant_primary{background-color:#007bff;color:#fff}.jodit-ui-button-variants_variant_primary svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_primary [disabled]{opacity:.7}.jodit-ui-button-variants_variant_primary:hover:not([disabled]){background-color:#0069d9;color:#fff}.jodit-ui-button-variants_variant_primary:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_primary:active:not([disabled]){background-color:#0062cc;color:#fff}.jodit-ui-button-variants_variant_primary:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_primary:focus:not([disabled]){outline:1px dashed #0062cc}.jodit-ui-button-variants_variant_secondary{background-color:#d8d8d8;border-radius:0;color:#212529}.jodit-ui-button-variants_variant_secondary svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_secondary [disabled]{opacity:.7}.jodit-ui-button-variants_variant_secondary:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button-variants_variant_secondary:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_secondary:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button-variants_variant_secondary:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_secondary:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button-variants_variant_success{background-color:#28a745;color:#fff}.jodit-ui-button-variants_variant_success svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_success [disabled]{opacity:.7}.jodit-ui-button-variants_variant_success:hover:not([disabled]){background-color:#218838;color:#fff}.jodit-ui-button-variants_variant_success:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_success:active:not([disabled]){background-color:#1e7e34;color:#fff}.jodit-ui-button-variants_variant_success:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_success:focus:not([disabled]){outline:1px dashed #1e7e34}.jodit-ui-button-variants_variant_danger{background-color:#dc3545;color:#fff}.jodit-ui-button-variants_variant_danger svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_danger [disabled]{opacity:.7}.jodit-ui-button-variants_variant_danger:hover:not([disabled]){background-color:#c82333;color:#fff}.jodit-ui-button-variants_variant_danger:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_danger:active:not([disabled]){background-color:#bd2130;color:#fff}.jodit-ui-button-variants_variant_danger:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_danger:focus:not([disabled]){outline:1px dashed #bd2130}.jodit-ui-button-style{border-radius:var(--jd-border-radius-default);padding:0 var(--jd-padding-default)}.jodit-ui-button,.jodit-ui-button-style{align-items:center;color:var(--jd-color-text-icons);display:inline-flex;justify-content:center}.jodit-ui-button{appearance:none;background:0 0;border:0;border-radius:var(--jd-border-radius-default);box-shadow:none;box-sizing:border-box;cursor:pointer;font-style:normal;height:34px;min-width:34px;outline:0;padding:0;padding:0 var(--jd-padding-default);position:relative;text-align:center;text-decoration:none;text-transform:none;user-select:none}.jodit-ui-button:focus-visible:not([disabled]),.jodit-ui-button:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-ui-button:active:not([disabled]),.jodit-ui-button[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-ui-button[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-ui-button[disabled]{opacity:.3;pointer-events:none}.jodit-ui-button .jodit-icon{height:14px;width:14px}.jodit-ui-button button{appearance:none;height:34px;min-width:34px;padding:0}.jodit-ui-button_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button_size_tiny{height:16px;min-width:16px}.jodit-ui-button_size_tiny .jodit-icon{height:8px;width:8px}.jodit-ui-button_size_tiny button{appearance:none;height:16px;min-width:16px;padding:0}.jodit-ui-button_size_tiny_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button_size_xsmall{height:22px;min-width:22px}.jodit-ui-button_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-ui-button_size_xsmall button{appearance:none;height:22px;min-width:22px;padding:0}.jodit-ui-button_size_xsmall_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button_size_small{height:28px;min-width:28px}.jodit-ui-button_size_small .jodit-icon{height:12px;width:12px}.jodit-ui-button_size_small button{appearance:none;height:28px;min-width:28px;padding:0}.jodit-ui-button_size_small_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button_size_large{height:40px;min-width:40px}.jodit-ui-button_size_large .jodit-icon{height:16px;width:16px}.jodit-ui-button_size_large button{appearance:none;height:40px;min-width:40px;padding:0}.jodit-ui-button_size_large_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-ui-button__icon{display:none}.jodit-ui-button__icon:not(:empty){display:inline-flex}.jodit-ui-button__text{display:none}.jodit-ui-button__text:not(:empty){display:inline-flex;flex-grow:1;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);justify-content:center;overflow:hidden;text-overflow:ellipsis}.jodit-ui-button_context_menu .jodit-ui-button__text{justify-content:left;padding-left:var(--jd-padding-default);position:relative}.jodit-ui-button_context_menu .jodit-ui-button__text:before{border-left:1px solid var(--jd-color-border);content:"";height:35px;left:0;position:absolute;top:calc(var(--jd-padding-default)*-1)}.jodit-ui-button__icon:not(:empty)+.jodit-ui-button__text:not(:empty){margin-left:var(--jd-padding-default)}.jodit-ui-button__icon:empty+.jodit-ui-button__text:not(:empty){padding:0 var(--jd-padding-default)}.jodit-ui-button:focus:not([disabled]){outline:1px dashed var(--jd-color-background-selection)}.jodit-ui-button_variant_outline{border:1px solid var(--jd-color-border)}.jodit-ui-button_variant_default{background-color:#e3e3e3;color:#212529}.jodit-ui-button_variant_default svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_default [disabled]{opacity:.7}.jodit-ui-button_variant_default:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button_variant_default:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_default:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button_variant_default:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_default:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button_variant_primary{background-color:#007bff;color:#fff}.jodit-ui-button_variant_primary svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_primary [disabled]{opacity:.7}.jodit-ui-button_variant_primary:hover:not([disabled]){background-color:#0069d9;color:#fff}.jodit-ui-button_variant_primary:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_primary:active:not([disabled]){background-color:#0062cc;color:#fff}.jodit-ui-button_variant_primary:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_primary:focus:not([disabled]){outline:1px dashed #0062cc}.jodit-ui-button_variant_secondary{background-color:#d8d8d8;border-radius:0;color:#212529}.jodit-ui-button_variant_secondary svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_secondary [disabled]{opacity:.7}.jodit-ui-button_variant_secondary:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button_variant_secondary:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_secondary:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button_variant_secondary:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_secondary:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button_variant_success{background-color:#28a745;color:#fff}.jodit-ui-button_variant_success svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_success [disabled]{opacity:.7}.jodit-ui-button_variant_success:hover:not([disabled]){background-color:#218838;color:#fff}.jodit-ui-button_variant_success:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_success:active:not([disabled]){background-color:#1e7e34;color:#fff}.jodit-ui-button_variant_success:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_success:focus:not([disabled]){outline:1px dashed #1e7e34}.jodit-ui-button_variant_danger{background-color:#dc3545;color:#fff}.jodit-ui-button_variant_danger svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_danger [disabled]{opacity:.7}.jodit-ui-button_variant_danger:hover:not([disabled]){background-color:#c82333;color:#fff}.jodit-ui-button_variant_danger:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_danger:active:not([disabled]){background-color:#bd2130;color:#fff}.jodit-ui-button_variant_danger:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_danger:focus:not([disabled]){outline:1px dashed #bd2130}.jodit-ui-button-group{margin-bottom:var(--jd-padding-default)}.jodit-ui-button-group__label{color:var(--jd-color-label);display:block;font-size:.8em;margin-bottom:calc(var(--jd-padding-default)/4)}.jodit-ui-button-group__options{display:flex;justify-content:flex-start}.jodit-ui-button-group .jodit-ui-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.jodit-ui-button-group .jodit-ui-button+.jodit-ui-button{border-bottom-left-radius:0;border-left:1px solid var(--jd-color-button-background-hover-opacity40);border-top-left-radius:0}.jodit-ui-button-group .jodit-ui-button[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover);border-left:0;box-shadow:inset 0 0 3px 0 var(--jd-color-dark);color:var(--jd-color-dark);outline:0}.jodit-ui-button-group .jodit-ui-button[aria-pressed=true]:not([disabled])+.jodit-ui-button{border:0}:root{--jd-tooltip-color:#fff;--jd-tooltip-background-color:rgba(0,0,0,.7);--jd-tooltip-sfx-shadow:rgba(0,0,0,.15);--jd-tooltip-border-width:0;--jd-tooltip-border-color:#e5e5e5}.jodit-ui-tooltip{animation-fill-mode:forwards;animation-timing-function:ease-out;background-clip:padding-box;background-color:var(--jd-tooltip-background-color);border-radius:4px;box-shadow:0 0 0 var(--jd-tooltip-border-width) var(--jd-tooltip-border-color),0 8px 20px var(--jd-tooltip-border-width) var(--jd-tooltip-sfx-shadow);color:var(--jd-tooltip-color);font-family:var(--jd-font-default);font-size:var(--jd-font-size-small);line-height:1.4;max-width:120px;opacity:0;outline:none;pointer-events:none;position:fixed;text-rendering:optimizelegibility;transform:translate(-50%,calc(var(--jd-padding-default)/2));transition:opacity .2s ease 0s;user-select:none;white-space:normal;width:auto;z-index:var(--jd-z-index-tooltip)}@media (max-width:768px){.jodit-ui-tooltip{display:none}}.jodit-ui-tooltip__content{padding:calc(var(--jd-padding-default)/2) calc(var(--jd-padding-default)*1.5)}.jodit-ui-tooltip.jodit-ui-tooltip_visible_true{opacity:1}.jodit-ui-block{align-items:center;display:flex;justify-content:stretch;margin-bottom:var(--jd-padding-default)}.jodit-ui-block_width_full{width:100%}.jodit-ui-block_align_full{justify-content:space-between}.jodit-ui-block_align_right{justify-content:flex-end}.jodit-ui-block_padding_true{padding:var(--jd-padding-default)}.jodit-ui-label{color:var(--jd-color-label);display:block;font-size:.8em;margin-bottom:calc(var(--jd-padding-default)/4)}.jodit-ui-input{display:flex;flex-direction:column;margin-bottom:var(--jd-padding-default)}.jodit-ui-input__input{appearance:none;background-color:var(--jd-color-white);border:0;border-radius:0;box-sizing:border-box;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);height:var(--jd-input-height);line-height:1.2;outline:none;padding:0 var(--jd-padding-default);width:100%}.jodit-ui-input__input[disabled]{background-color:#f0f0f0;color:var(--jd-color-border)}.jodit-ui-input__input_has-error_true{border-color:var(--jd-color-red)}.jodit-ui-input__input:focus{outline:0}.jodit-ui-input_theme_dark .jodit-ui-input__input{background-color:var(--jd-color-gray)}.jodit-ui-input_has-error_true .jodit-ui-input__input{border-color:var(--jd-color-red)}.jodit-ui-input__error,.jodit-ui-input__label{color:var(--jd-color-label);display:block;font-size:.8em;margin-bottom:calc(var(--jd-padding-default)/4)}.jodit-ui-input__error,.jodit-ui-input_has-error_true .jodit-ui-input__label{color:var(--jd-color-error)}.jodit-ui-input__wrapper{align-items:center;background-color:var(--jd-color-white);border:1px solid var(--jd-color-border);display:flex;justify-content:stretch;min-width:200px}@media (max-width:480px){.jodit-ui-input__wrapper{min-width:140px}}.jodit-ui-input_theme_dark .jodit-ui-input__wrapper{background-color:var(--jd-color-gray);border-color:var(--jd-color-border)}.jodit-ui-input_focused_true .jodit-ui-input__wrapper{border-color:var(--jd-color-border-selected)}.jodit-ui-input__icon:not(:empty){align-items:center;display:flex;padding:0 var(--jd-padding-default)}.jodit-ui-input__icon:not(:empty) svg{height:16px;width:16px;fill:var(--jd-color-border)}.jodit-ui-input__icon:not(:empty)+.jodit-ui-input__input{padding-left:0}.jodit-ui-input__clear{align-items:center;display:flex;opacity:.8;padding:0 var(--jd-padding-default) 0 0}.jodit-ui-input__clear:active{opacity:1;transform:scale(1.1)}.jodit-ui-input__clear svg{height:12px;width:12px;fill:var(--jd-color-border)}.jodit-ui-input_theme_dark .jodit-ui-input__clear svg,.jodit-ui-input_theme_dark .jodit-ui-input__icon svg{fill:var(--jd-color-dark)}.jodit-ui-block .jodit-ui-input{margin-bottom:0}.jodit-ui-select{display:flex;flex-direction:column;margin-bottom:var(--jd-padding-default)}.jodit-ui-select__input{appearance:none;background-color:var(--jd-color-white);border:0;border-radius:0;box-sizing:border-box;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);height:var(--jd-input-height);line-height:1.2;outline:none;padding:0 var(--jd-padding-default);width:100%}.jodit-ui-select__input[disabled]{background-color:#f0f0f0;color:var(--jd-color-border)}.jodit-ui-select__input_has-error_true{border-color:var(--jd-color-red)}.jodit-ui-select__input:focus{outline:0}.jodit-ui-select_theme_dark .jodit-ui-select__input{background-color:var(--jd-color-gray)}.jodit-ui-select_has-error_true .jodit-ui-select__input{border-color:var(--jd-color-red)}.jodit-ui-select__error,.jodit-ui-select__label{color:var(--jd-color-label);display:block;font-size:.8em;margin-bottom:calc(var(--jd-padding-default)/4)}.jodit-ui-select__error,.jodit-ui-select_has-error_true .jodit-ui-select__label{color:var(--jd-color-error)}.jodit-ui-select__wrapper{align-items:center;background-color:var(--jd-color-white);border:1px solid var(--jd-color-border);display:flex;justify-content:stretch;min-width:200px}@media (max-width:480px){.jodit-ui-select__wrapper{min-width:140px}}.jodit-ui-select_theme_dark .jodit-ui-select__wrapper{background-color:var(--jd-color-gray);border-color:var(--jd-color-border)}.jodit-ui-select_focused_true .jodit-ui-select__wrapper{border-color:var(--jd-color-border-selected)}.jodit-ui-select__icon:not(:empty){align-items:center;display:flex;padding:0 var(--jd-padding-default)}.jodit-ui-select__icon:not(:empty) svg{height:16px;width:16px;fill:var(--jd-color-border)}.jodit-ui-select__icon:not(:empty)+.jodit-ui-select__input{padding-left:0}.jodit-ui-select__clear{align-items:center;display:flex;opacity:.8;padding:0 var(--jd-padding-default) 0 0}.jodit-ui-select__clear:active{opacity:1;transform:scale(1.1)}.jodit-ui-select__clear svg{height:12px;width:12px;fill:var(--jd-color-border)}.jodit-ui-select_theme_dark .jodit-ui-select__clear svg,.jodit-ui-select_theme_dark .jodit-ui-select__icon svg{fill:var(--jd-color-dark)}.jodit-ui-select__input{background-image:url(${p});background-position:98% 50%;background-repeat:no-repeat;padding-right:calc(var(--jd-padding-default)*2)}.jodit-ui-select_size_tiny{margin-bottom:0}.jodit-ui-select_size_tiny .jodit-ui-select__input{--jd-height:calc(var(--jd-input-height)/1.8);height:var(--jd-height);line-height:var(--jd-height)}.jodit-ui-select_variant_outline .jodit-ui-select__wrapper{border:0}.jodit-ui-select_variant_outline .jodit-ui-select__wrapper select{outline:0}.jodit-ui-select_width_auto{width:auto}.jodit-ui-select_width_auto .jodit-ui-select__wrapper{min-width:auto}.jodit-ui-text-area{display:flex;flex-direction:column;margin-bottom:var(--jd-padding-default);width:100%}.jodit-ui-text-area__input{appearance:none;background-color:var(--jd-color-white);border:0;border-radius:0;box-sizing:border-box;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);height:var(--jd-input-height);line-height:1.2;outline:none;padding:0 var(--jd-padding-default);width:100%}.jodit-ui-text-area__input[disabled]{background-color:#f0f0f0;color:var(--jd-color-border)}.jodit-ui-text-area__input_has-error_true{border-color:var(--jd-color-red)}.jodit-ui-text-area__input:focus{outline:0}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__input{background-color:var(--jd-color-gray)}.jodit-ui-text-area_has-error_true .jodit-ui-text-area__input{border-color:var(--jd-color-red)}.jodit-ui-text-area__error,.jodit-ui-text-area__label{color:var(--jd-color-label);display:block;font-size:.8em;margin-bottom:calc(var(--jd-padding-default)/4)}.jodit-ui-text-area__error,.jodit-ui-text-area_has-error_true .jodit-ui-text-area__label{color:var(--jd-color-error)}.jodit-ui-text-area__wrapper{align-items:center;background-color:var(--jd-color-white);border:1px solid var(--jd-color-border);display:flex;justify-content:stretch;min-width:200px}@media (max-width:480px){.jodit-ui-text-area__wrapper{min-width:140px}}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__wrapper{background-color:var(--jd-color-gray);border-color:var(--jd-color-border)}.jodit-ui-text-area_focused_true .jodit-ui-text-area__wrapper{border-color:var(--jd-color-border-selected)}.jodit-ui-text-area__icon:not(:empty){align-items:center;display:flex;padding:0 var(--jd-padding-default)}.jodit-ui-text-area__icon:not(:empty) svg{height:16px;width:16px;fill:var(--jd-color-border)}.jodit-ui-text-area__icon:not(:empty)+.jodit-ui-text-area__input{padding-left:0}.jodit-ui-text-area__clear{align-items:center;display:flex;opacity:.8;padding:0 var(--jd-padding-default) 0 0}.jodit-ui-text-area__clear:active{opacity:1;transform:scale(1.1)}.jodit-ui-text-area__clear svg{height:12px;width:12px;fill:var(--jd-color-border)}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__clear svg,.jodit-ui-text-area_theme_dark .jodit-ui-text-area__icon svg{fill:var(--jd-color-dark)}.jodit-ui-text-area__wrapper{flex:1}.jodit-ui-text-area__input{height:100%;min-height:60px;padding:var(--jd-padding-default)}.jodit-ui-checkbox{align-items:center;display:flex;flex-direction:row-reverse;justify-content:flex-end;margin-bottom:var(--jd-padding-default)}.jodit-ui-checkbox__input{margin-right:var(--jd-padding-default)}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__wrapper{display:inline-block;height:34px;margin-right:var(--jd-padding-default);position:relative;width:60px}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__wrapper input{height:0;opacity:0;width:0}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__switch-slider{background-color:#ccc;border-radius:34px;cursor:pointer;inset:0;position:absolute;transition:.4s}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__switch-slider:before{background-color:#fff;border-radius:50%;bottom:4px;content:"";height:26px;left:4px;position:absolute;transition:.4s;width:26px}.jodit-ui-checkbox_switch_true.jodit-ui-checkbox_checked_true .jodit-ui-checkbox__switch-slider{background-color:#2196f3}.jodit-ui-checkbox_switch_true.jodit-ui-checkbox_checked_true .jodit-ui-checkbox__switch-slider:before{transform:translateX(26px)}.jodit-ui-checkbox_switch_true.jodit-ui-checkbox_focused_true .jodit-ui-checkbox__switch-slider{box-shadow:0 0 1px #2196f3}.jodit-ui-block .jodit-ui-checkbox{margin-bottom:0}.jodit-ui-file-input{overflow:hidden;position:relative}.jodit-ui-file-input__input{bottom:0;cursor:pointer;font-size:400px;margin:0 calc(var(--jd-padding-default)*-1) 0 0;opacity:0;padding:0;position:absolute;right:0;top:0}:root{--jd-popup-box-shadow:0 4px 1px -2px rgba(76,76,76,.2),0 3px 3px 0 rgba(76,76,76,.15),0 1px 4px 0 rgba(76,76,76,.13);--jd-popup-max-height:max(50vh,350px)}.jodit-popup{background:0 0;border:0;box-shadow:var(--jd-popup-box-shadow);display:inline-block;float:none;height:auto;margin:0;max-width:none;outline:0;padding:0;position:static;position:fixed;transform:translateZ(0);width:auto;z-index:var(--jd-z-index-popup)}.jodit-popup__content{background:var(--jd-color-background-default);font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);max-height:var(--jd-popup-max-height,400px);overflow:auto;padding:var(--jd-padding-default);overflow-scrolling:touch}.jodit-popup_padding_false .jodit-popup__content{padding:0}.jodit-popup_max-height_false .jodit-popup__content{max-height:fit-content}@keyframes a{30%{opacity:.6}60%{opacity:0}to{opacity:.6}}.jodit-progress-bar{border-radius:1px;height:2px;left:0;opacity:.7;position:absolute;top:0;z-index:2147483647}.jodit-progress-bar div{background:var(--jd-color-background-progress);height:2px;position:relative;transition:width .5s ease-out,opacity .5s linear;will-change:width,opacity}.jodit-progress-bar div:after,.jodit-progress-bar div:before{animation:a 2s ease-out 0s infinite;border-radius:100%;box-shadow:var(--jd-color-background-progress) 1px 0 6px 1px;content:"";display:inline-block;height:2px;opacity:.6;position:absolute;top:0}.jodit-progress-bar div:before{right:-80px;width:180px;clip:rect(-6px,90px,14px,-6px)}.jodit-progress-bar div:after{right:0;width:20px;clip:rect(-6px,22px,14px,var(--jd-padding-default))}:root{--jd-em-color-border:#b6d4fe;--jd-em-color-bg:#cfe2ff;--jd-em-color-color:#084298;--jd-em-border-radius:0.375rem;--jd-em-padding:0.5rem 1rem;--jd-em-font-size:1rem}.jodit-ui-messages{bottom:0;height:0;overflow:visible;position:absolute;right:0;width:0;z-index:3}.jodit-ui-message{background:var(--jd-em-color-bg);border:1px solid var(--jd-em-color-border);border-radius:var(--jd-em-border-radius);bottom:0;color:var(--jd-em-color-color);cursor:pointer;display:block;font-size:var(--jd-em-font-size);opacity:0;padding:var(--jd-em-padding);position:absolute;right:calc(var(--jd-padding-default)/2);transition:opacity .1s linear,bottom .3s linear,transform .1s ease-out;white-space:pre}.jodit-ui-message_active_true{opacity:1}.jodit-ui-message:active{transform:scale(.76)}.jodit-ui-message_variant_secondary{--jd-em-color-border:#d3d6d8;--jd-em-color-bg:#e2e3e5;--jd-em-color-color:#41464b}.jodit-ui-message_variant_danger,.jodit-ui-message_variant_error,.jodit-ui-message_variant_secondary{background:var(--jd-em-color-bg);border-color:var(--jd-em-color-border);color:var(--jd-em-color-color)}.jodit-ui-message_variant_danger,.jodit-ui-message_variant_error{--jd-em-color-border:#f5c2c7;--jd-em-color-bg:#f8d7da;--jd-em-color-color:#842029}.jodit-ui-message_variant_success{--jd-em-color-border:#badbcc;--jd-em-color-bg:#d1e7dd;--jd-em-color-color:#0f5132;background:var(--jd-em-color-bg);border-color:var(--jd-em-color-border);color:var(--jd-em-color-color)}.jodit-toolbar-collection,.jodit-toolbar-editor-collection{display:flex;flex-direction:column}.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent calc(var(--jd-button-size) - 1px),var(--jd-color-border) var(--jd-button-size));position:relative}.jodit-toolbar-collection_mode_horizontal:after,.jodit-toolbar-editor-collection_mode_horizontal:after{background-color:var(--jd-color-background-default);bottom:0;content:"";display:block;height:1px;left:0;position:absolute;width:100%}.jodit-toolbar-collection_size_tiny,.jodit-toolbar-editor-collection_size_tiny{--jd-button-icon-size:8px}.jodit-toolbar-collection_size_tiny.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-collection_size_tiny.jodit-toolbar-editor-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_tiny.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_tiny.jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent 19px,var(--jd-color-border) 20px)}.jodit-toolbar-collection_size_xsmall,.jodit-toolbar-editor-collection_size_xsmall{--jd-button-icon-size:10px}.jodit-toolbar-collection_size_xsmall.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-collection_size_xsmall.jodit-toolbar-editor-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_xsmall.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_xsmall.jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent 25px,var(--jd-color-border) 26px)}.jodit-toolbar-collection_size_small,.jodit-toolbar-editor-collection_size_small{--jd-button-icon-size:12px}.jodit-toolbar-collection_size_small.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-collection_size_small.jodit-toolbar-editor-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_small.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_small.jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent 31px,var(--jd-color-border) 32px)}.jodit-toolbar-collection_size_middle,.jodit-toolbar-editor-collection_size_middle{--jd-button-icon-size:14px}.jodit-toolbar-collection_size_middle.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-collection_size_middle.jodit-toolbar-editor-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_middle.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_middle.jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent 37px,var(--jd-color-border) 38px)}.jodit-toolbar-collection_size_large,.jodit-toolbar-editor-collection_size_large{--jd-button-icon-size:16px}.jodit-toolbar-collection_size_large.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-collection_size_large.jodit-toolbar-editor-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_large.jodit-toolbar-collection_mode_horizontal,.jodit-toolbar-editor-collection_size_large.jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent 43px,var(--jd-color-border) 44px)}.jodit-toolbar-collection_mode_vertical .jodit-ui-group,.jodit-toolbar-editor-collection_mode_vertical .jodit-ui-group{background-color:transparent;border:0;flex-direction:column}.jodit-toolbar-collection_mode_vertical .jodit-toolbar-button,.jodit-toolbar-editor-collection_mode_vertical .jodit-toolbar-button{height:auto;min-height:var(--jd-button-size)}.jodit-toolbar-collection_mode_vertical .jodit-toolbar-button__button,.jodit-toolbar-editor-collection_mode_vertical .jodit-toolbar-button__button{cursor:pointer;height:auto;min-height:var(--jd-button-size);width:100%}.jodit-toolbar-collection_mode_vertical .jodit-toolbar-button__text:not(:empty),.jodit-toolbar-editor-collection_mode_vertical .jodit-toolbar-button__text:not(:empty){justify-content:left}.jodit-toolbar-collection .jodit-toolbar-button,.jodit-toolbar-collection .jodit-toolbar-content,.jodit-toolbar-collection .jodit-toolbar-select,.jodit-toolbar-editor-collection .jodit-toolbar-button,.jodit-toolbar-editor-collection .jodit-toolbar-content,.jodit-toolbar-editor-collection .jodit-toolbar-select{margin:var(--jd-margin-v) 1px;padding:0}.jodit-dialog .jodit-toolbar-collection_mode_horizontal,.jodit-dialog .jodit-toolbar-editor-collection_mode_horizontal{background-image:none}:root{--jd-button-trigger-size:14px}.jodit-toolbar-button{align-items:center;border:1px solid transparent;border-radius:var(--jd-border-radius-default);display:flex;height:34px;justify-content:center;min-width:34px;overflow:hidden}.jodit-toolbar-button__icon{display:none}.jodit-toolbar-button__icon:not(:empty){display:inline-flex}.jodit-toolbar-button__text{display:none}.jodit-toolbar-button__text:not(:empty){display:inline-flex;flex-grow:1;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);justify-content:center;overflow:hidden;text-overflow:ellipsis}.jodit-toolbar-button_context_menu .jodit-toolbar-button__text{justify-content:left;padding-left:var(--jd-padding-default);position:relative}.jodit-toolbar-button_context_menu .jodit-toolbar-button__text:before{border-left:1px solid var(--jd-color-border);content:"";height:35px;left:0;position:absolute;top:calc(var(--jd-padding-default)*-1)}.jodit-toolbar-button__icon:not(:empty)+.jodit-toolbar-button__text:not(:empty){margin-left:var(--jd-padding-default)}.jodit-toolbar-button__icon:empty+.jodit-toolbar-button__text:not(:empty){padding:0 var(--jd-padding-default);padding:0}.jodit-toolbar-button .jodit-icon{height:14px;width:14px}.jodit-toolbar-button button{appearance:none;height:34px;min-width:34px;padding:0}.jodit-toolbar-button_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-button_size_tiny{height:16px;min-width:16px}.jodit-toolbar-button_size_tiny .jodit-icon{height:8px;width:8px}.jodit-toolbar-button_size_tiny button{appearance:none;height:16px;min-width:16px;padding:0}.jodit-toolbar-button_size_tiny_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-button_size_xsmall{height:22px;min-width:22px}.jodit-toolbar-button_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-toolbar-button_size_xsmall button{appearance:none;height:22px;min-width:22px;padding:0}.jodit-toolbar-button_size_xsmall_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-button_size_small{height:28px;min-width:28px}.jodit-toolbar-button_size_small .jodit-icon{height:12px;width:12px}.jodit-toolbar-button_size_small button{appearance:none;height:28px;min-width:28px;padding:0}.jodit-toolbar-button_size_small_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-button_size_large{height:40px;min-width:40px}.jodit-toolbar-button_size_large .jodit-icon{height:16px;width:16px}.jodit-toolbar-button_size_large button{appearance:none;height:40px;min-width:40px;padding:0}.jodit-toolbar-button_size_large_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-button__button{align-items:center;appearance:none;background:0 0;border:0;border-radius:var(--jd-border-radius-default);box-shadow:none;box-sizing:border-box;color:var(--jd-color-text-icons);cursor:pointer;display:inline-flex;font-style:normal;justify-content:center;outline:0;padding:0;padding:0 var(--jd-padding-default);position:relative;text-align:center;text-decoration:none;text-transform:none;user-select:none}.jodit-toolbar-button__button:focus-visible:not([disabled]),.jodit-toolbar-button__button:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-toolbar-button__button:active:not([disabled]),.jodit-toolbar-button__button[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-toolbar-button__button[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-toolbar-button__button[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-button__trigger{align-items:center;border-radius:0 var(--jd-border-radius-default) var(--jd-border-radius-default) 0;cursor:pointer;display:flex;height:100%;justify-content:center;opacity:.4;--jd-button-trigger-size:14px;width:calc(var(--jd-button-trigger-size, 14px) + 2px)}.jodit-toolbar-button__trigger:focus-visible:not([disabled]),.jodit-toolbar-button__trigger:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-toolbar-button__trigger:active:not([disabled]),.jodit-toolbar-button__trigger[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-toolbar-button__trigger[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-toolbar-button__trigger[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-button__trigger svg{width:calc(var(--jd-button-trigger-size, 14px) - 4px)}.jodit-toolbar-button_size_tiny .jodit-toolbar-button__trigger{--jd-button-trigger-size:8px;width:calc(var(--jd-button-trigger-size, 8px) + 2px)}.jodit-toolbar-button_size_tiny .jodit-toolbar-button__trigger svg{width:calc(var(--jd-button-trigger-size, 8px) - 4px)}.jodit-toolbar-button_size_xsmall .jodit-toolbar-button__trigger{--jd-button-trigger-size:10px;width:calc(var(--jd-button-trigger-size, 10px) + 2px)}.jodit-toolbar-button_size_xsmall .jodit-toolbar-button__trigger svg{width:calc(var(--jd-button-trigger-size, 10px) - 4px)}.jodit-toolbar-button_size_small .jodit-toolbar-button__trigger{--jd-button-trigger-size:12px;width:calc(var(--jd-button-trigger-size, 12px) + 2px)}.jodit-toolbar-button_size_small .jodit-toolbar-button__trigger svg{width:calc(var(--jd-button-trigger-size, 12px) - 4px)}.jodit-toolbar-button_size_large .jodit-toolbar-button__trigger{--jd-button-trigger-size:16px;width:calc(var(--jd-button-trigger-size, 16px) + 2px)}.jodit-toolbar-button_size_large .jodit-toolbar-button__trigger svg{width:calc(var(--jd-button-trigger-size, 16px) - 4px)}.jodit-toolbar-button_with-trigger_true .jodit-toolbar-button__button{border-radius:var(--jd-border-radius-default) 0 0 var(--jd-border-radius-default)}.jodit-toolbar-button_with-trigger_true:hover:not([disabled]){border-color:var(--jd-color-border)}.jodit-toolbar-button_stroke_false svg{stroke:none}.jodit-toolbar-content{align-items:center;appearance:none;background:0 0;border:1px solid transparent;border-radius:var(--jd-border-radius-default);box-shadow:none;box-sizing:border-box;color:var(--jd-color-text-icons);cursor:pointer;display:inline-flex;font-style:normal;height:34px;justify-content:center;min-width:34px;outline:0;padding:0;position:relative;text-align:center;text-decoration:none;text-transform:none;user-select:none}.jodit-toolbar-content:focus-visible:not([disabled]),.jodit-toolbar-content:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-toolbar-content:active:not([disabled]),.jodit-toolbar-content[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-toolbar-content[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-toolbar-content[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-content .jodit-icon{height:14px;width:14px}.jodit-toolbar-content button{appearance:none;height:34px;min-width:34px;padding:0}.jodit-toolbar-content_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-content_size_tiny{height:16px;min-width:16px}.jodit-toolbar-content_size_tiny .jodit-icon{height:8px;width:8px}.jodit-toolbar-content_size_tiny button{appearance:none;height:16px;min-width:16px;padding:0}.jodit-toolbar-content_size_tiny_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-content_size_xsmall{height:22px;min-width:22px}.jodit-toolbar-content_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-toolbar-content_size_xsmall button{appearance:none;height:22px;min-width:22px;padding:0}.jodit-toolbar-content_size_xsmall_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-content_size_small{height:28px;min-width:28px}.jodit-toolbar-content_size_small .jodit-icon{height:12px;width:12px}.jodit-toolbar-content_size_small button{appearance:none;height:28px;min-width:28px;padding:0}.jodit-toolbar-content_size_small_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-content_size_large{height:40px;min-width:40px}.jodit-toolbar-content_size_large .jodit-icon{height:16px;width:16px}.jodit-toolbar-content_size_large button{appearance:none;height:40px;min-width:40px;padding:0}.jodit-toolbar-content_size_large_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-content__icon{display:none}.jodit-toolbar-content__icon:not(:empty){display:inline-flex}.jodit-toolbar-content__text{display:none}.jodit-toolbar-content__text:not(:empty){display:inline-flex;flex-grow:1;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);justify-content:center;overflow:hidden;text-overflow:ellipsis}.jodit-toolbar-content_context_menu .jodit-toolbar-content__text{justify-content:left;padding-left:var(--jd-padding-default);position:relative}.jodit-toolbar-content_context_menu .jodit-toolbar-content__text:before{border-left:1px solid var(--jd-color-border);content:"";height:35px;left:0;position:absolute;top:calc(var(--jd-padding-default)*-1)}.jodit-toolbar-content__icon:not(:empty)+.jodit-toolbar-content__text:not(:empty){margin-left:var(--jd-padding-default)}.jodit-toolbar-content__icon:empty+.jodit-toolbar-content__text:not(:empty){padding:0 var(--jd-padding-default)}.jodit-toolbar-content:focus:not([disabled]){outline:1px dashed var(--jd-color-background-selection)}.jodit-toolbar-content_variant_outline{border:1px solid var(--jd-color-border)}.jodit-toolbar-content_variant_default{background-color:#e3e3e3;color:#212529}.jodit-toolbar-content_variant_default svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_default [disabled]{opacity:.7}.jodit-toolbar-content_variant_default:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-toolbar-content_variant_default:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_default:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-toolbar-content_variant_default:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_default:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-toolbar-content_variant_primary{background-color:#007bff;color:#fff}.jodit-toolbar-content_variant_primary svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_primary [disabled]{opacity:.7}.jodit-toolbar-content_variant_primary:hover:not([disabled]){background-color:#0069d9;color:#fff}.jodit-toolbar-content_variant_primary:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_primary:active:not([disabled]){background-color:#0062cc;color:#fff}.jodit-toolbar-content_variant_primary:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_primary:focus:not([disabled]){outline:1px dashed #0062cc}.jodit-toolbar-content_variant_secondary{background-color:#d8d8d8;border-radius:0;color:#212529}.jodit-toolbar-content_variant_secondary svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_secondary [disabled]{opacity:.7}.jodit-toolbar-content_variant_secondary:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-toolbar-content_variant_secondary:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_secondary:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-toolbar-content_variant_secondary:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_secondary:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-toolbar-content_variant_success{background-color:#28a745;color:#fff}.jodit-toolbar-content_variant_success svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_success [disabled]{opacity:.7}.jodit-toolbar-content_variant_success:hover:not([disabled]){background-color:#218838;color:#fff}.jodit-toolbar-content_variant_success:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_success:active:not([disabled]){background-color:#1e7e34;color:#fff}.jodit-toolbar-content_variant_success:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_success:focus:not([disabled]){outline:1px dashed #1e7e34}.jodit-toolbar-content_variant_danger{background-color:#dc3545;color:#fff}.jodit-toolbar-content_variant_danger svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_danger [disabled]{opacity:.7}.jodit-toolbar-content_variant_danger:hover:not([disabled]){background-color:#c82333;color:#fff}.jodit-toolbar-content_variant_danger:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_danger:active:not([disabled]){background-color:#bd2130;color:#fff}.jodit-toolbar-content_variant_danger:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_danger:focus:not([disabled]){outline:1px dashed #bd2130}.jodit-toolbar-content:hover:not([disabled]){background-color:transparent;opacity:1;outline:0}.jodit-toolbar-select{--jd-color-button-background-hover-opacity40:hsla(0,0%,86%,.2);--jd-color-button-background-hover-opacity60:hsla(0,0%,86%,.1);align-items:center;border:1px solid transparent;border-radius:var(--jd-border-radius-default);cursor:pointer;display:flex;height:34px;justify-content:center;justify-content:space-between;min-width:34px;min-width:100px;overflow:hidden}.jodit-toolbar-select__icon{display:none}.jodit-toolbar-select__icon:not(:empty){display:inline-flex}.jodit-toolbar-select__text{display:none}.jodit-toolbar-select__text:not(:empty){display:inline-flex;flex-grow:1;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);justify-content:center;overflow:hidden;text-overflow:ellipsis}.jodit-toolbar-select_context_menu .jodit-toolbar-select__text{justify-content:left;padding-left:var(--jd-padding-default);position:relative}.jodit-toolbar-select_context_menu .jodit-toolbar-select__text:before{border-left:1px solid var(--jd-color-border);content:"";height:35px;left:0;position:absolute;top:calc(var(--jd-padding-default)*-1)}.jodit-toolbar-select__icon:not(:empty)+.jodit-toolbar-select__text:not(:empty){margin-left:var(--jd-padding-default)}.jodit-toolbar-select__icon:empty+.jodit-toolbar-select__text:not(:empty){padding:0 var(--jd-padding-default);padding:0}.jodit-toolbar-select .jodit-icon{height:14px;width:14px}.jodit-toolbar-select button{appearance:none;height:34px;min-width:34px;padding:0}.jodit-toolbar-select_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-select_size_tiny{height:16px;min-width:16px}.jodit-toolbar-select_size_tiny .jodit-icon{height:8px;width:8px}.jodit-toolbar-select_size_tiny button{appearance:none;height:16px;min-width:16px;padding:0}.jodit-toolbar-select_size_tiny_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-select_size_xsmall{height:22px;min-width:22px}.jodit-toolbar-select_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-toolbar-select_size_xsmall button{appearance:none;height:22px;min-width:22px;padding:0}.jodit-toolbar-select_size_xsmall_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-select_size_small{height:28px;min-width:28px}.jodit-toolbar-select_size_small .jodit-icon{height:12px;width:12px}.jodit-toolbar-select_size_small button{appearance:none;height:28px;min-width:28px;padding:0}.jodit-toolbar-select_size_small_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-select_size_large{height:40px;min-width:40px}.jodit-toolbar-select_size_large .jodit-icon{height:16px;width:16px}.jodit-toolbar-select_size_large button{appearance:none;height:40px;min-width:40px;padding:0}.jodit-toolbar-select_size_large_text-icons_true button{padding:0 var(--jd-padding-default)}.jodit-toolbar-select__button{align-items:center;appearance:none;background:0 0;border:0;border-radius:var(--jd-border-radius-default);box-shadow:none;box-sizing:border-box;color:var(--jd-color-text-icons);cursor:pointer;display:inline-flex;font-style:normal;justify-content:center;outline:0;padding:0;padding:0 var(--jd-padding-default);position:relative;text-align:center;text-decoration:none;text-transform:none;user-select:none}.jodit-toolbar-select__button:focus-visible:not([disabled]),.jodit-toolbar-select__button:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-toolbar-select__button:active:not([disabled]),.jodit-toolbar-select__button[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-toolbar-select__button[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-toolbar-select__button[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-select__trigger{align-items:center;border-radius:0 var(--jd-border-radius-default) var(--jd-border-radius-default) 0;cursor:pointer;display:flex;height:100%;justify-content:center;opacity:.4;--jd-button-trigger-size:14px;width:calc(var(--jd-button-trigger-size, 14px) + 2px)}.jodit-toolbar-select__trigger:focus-visible:not([disabled]),.jodit-toolbar-select__trigger:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-toolbar-select__trigger:active:not([disabled]),.jodit-toolbar-select__trigger[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-toolbar-select__trigger[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-toolbar-select__trigger[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-select__trigger svg{width:calc(var(--jd-button-trigger-size, 14px) - 4px)}.jodit-toolbar-select_size_tiny .jodit-toolbar-select__trigger{--jd-button-trigger-size:8px;width:calc(var(--jd-button-trigger-size, 8px) + 2px)}.jodit-toolbar-select_size_tiny .jodit-toolbar-select__trigger svg{width:calc(var(--jd-button-trigger-size, 8px) - 4px)}.jodit-toolbar-select_size_xsmall .jodit-toolbar-select__trigger{--jd-button-trigger-size:10px;width:calc(var(--jd-button-trigger-size, 10px) + 2px)}.jodit-toolbar-select_size_xsmall .jodit-toolbar-select__trigger svg{width:calc(var(--jd-button-trigger-size, 10px) - 4px)}.jodit-toolbar-select_size_small .jodit-toolbar-select__trigger{--jd-button-trigger-size:12px;width:calc(var(--jd-button-trigger-size, 12px) + 2px)}.jodit-toolbar-select_size_small .jodit-toolbar-select__trigger svg{width:calc(var(--jd-button-trigger-size, 12px) - 4px)}.jodit-toolbar-select_size_large .jodit-toolbar-select__trigger{--jd-button-trigger-size:16px;width:calc(var(--jd-button-trigger-size, 16px) + 2px)}.jodit-toolbar-select_size_large .jodit-toolbar-select__trigger svg{width:calc(var(--jd-button-trigger-size, 16px) - 4px)}.jodit-toolbar-select_with-trigger_true .jodit-toolbar-button__button{border-radius:var(--jd-border-radius-default) 0 0 var(--jd-border-radius-default)}.jodit-toolbar-select_with-trigger_true:hover:not([disabled]){border-color:var(--jd-color-border)}.jodit-toolbar-select_stroke_false svg{stroke:none}.jodit-toolbar-select:focus-visible:not([disabled]),.jodit-toolbar-select:hover:not([disabled]){background-color:var(--jd-color-button-background-hover);opacity:1;outline:0}.jodit-toolbar-select:active:not([disabled]),.jodit-toolbar-select[aria-pressed=true]:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity40);outline:0}.jodit-toolbar-select[aria-pressed=true]:hover:not([disabled]){background-color:var(--jd-color-button-background-hover-opacity60)}.jodit-toolbar-select[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-select__text:not(:empty){justify-content:left}.jodit-toolbar-select__button{flex:1}.jodit-toolbar__box:not(:empty){--jd-color-background-default:var(--jd-color-panel);background-color:var(--jd-color-background-default);border-bottom:1px solid var(--jd-color-border);border-radius:var(--jd-border-radius-default) var(--jd-border-radius-default) 0 0;overflow:hidden}.jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after{background-color:var(--jd-color-panel)}.jodit-dialog{border:0;box-sizing:border-box;display:none;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);height:0;position:absolute;width:0;will-change:left,top,width,height}.jodit-dialog_moved_true{user-select:none}.jodit-dialog *{box-sizing:border-box}.jodit-dialog .jodit_elfinder,.jodit-dialog .jodit_elfinder *{box-sizing:initial}.jodit-dialog__overlay{background-color:rgba(0,0,0,.5);display:none;height:100%;left:0;overflow:auto;position:fixed;text-align:center;top:0;white-space:nowrap;width:100%;z-index:var(--jd-z-index-dialog-overlay)}.jodit-dialog_static_true .jodit-dialog__overlay{display:none}.jodit-dialog_active_true,.jodit-dialog_modal_true .jodit-dialog__overlay{display:block}.jodit-dialog__panel{background-color:#fff;display:flex;flex-flow:column nowrap;left:0;max-height:100%;max-width:100%;min-height:100px;min-width:200px;position:fixed;top:0;z-index:var(--jd-z-index-dialog);--jd-box-shadow-blur:calc(var(--jd-padding-default)*2);--jd-box-shadow-1:0 var(--jd-padding-default) var(--jd-box-shadow-blur) rgba(0,0,0,.19);box-shadow:var(--jd-box-shadow-1),0 6px 6px rgba(0,0,0,.23);text-align:left;white-space:normal}@media (max-width:480px){.jodit-dialog:not(.jodit-dialog_adaptive_false) .jodit-dialog__panel{height:100%!important;left:0!important;max-width:100%;top:0!important;width:100%!important}}.jodit-dialog_static_true{box-sizing:border-box;display:block;height:auto;position:relative;width:auto;z-index:inherit}.jodit-dialog_static_true .jodit-dialog__panel{border:1px solid var(--jd-color-border);box-shadow:none;left:auto!important;position:relative;top:auto!important;width:100%!important;z-index:inherit}.jodit-dialog_theme_dark,.jodit-dialog_theme_dark .jodit-dialog__panel{background-color:var(--jd-dark-background-darknes);color:var(--jd-dark-text-color)}.jodit-dialog__header{border-bottom:1px solid var(--jd-color-border);cursor:move;display:flex;justify-content:space-between;min-height:50px;text-align:left}.jodit-dialog__header-title,.jodit-dialog__header-toolbar{align-items:center;display:flex;flex-shrink:3;font-size:18px;font-weight:400;line-height:48px;margin:0;padding:0 var(--jd-padding-default);vertical-align:top}@media (max-width:480px){.jodit-dialog__header-toolbar{padding-left:0}}.jodit-dialog__header-button{color:#222;flex-basis:48px;font-size:28px;height:48px;line-height:48px;text-align:center;text-decoration:none;transition:background-color .2s ease 0s}.jodit-dialog__header-button:hover{background-color:var(--jd-color-background-button-hover)}.jodit-dialog__header .jodit_toolbar{background:transparent;border:0;box-shadow:none}.jodit-dialog__header .jodit_toolbar>li.jodit-toolbar-button .jodit-input{padding-left:var(--jd-padding-default);width:auto}@media (max-width:480px){.jodit-dialog:not(.jodit-dialog_adaptive_false) .jodit-dialog__header{flex-direction:column}}.jodit-dialog_slim_true .jodit-dialog__header{min-height:10px}.jodit-dialog_slim_true .jodit-dialog__header-title,.jodit-dialog_slim_true .jodit-dialog__header-toolbar{padding:0 calc(var(--jd-padding-default)/4)}.jodit-dialog_theme_dark .jodit-dialog__header{border-color:var(--jd-color-dark)}.jodit-dialog_fullsize_true .jodit-dialog__header{cursor:default}.jodit-dialog__content{flex:1;min-height:100px;overflow:auto}.jodit-dialog__content .jodit-form__group{margin-bottom:calc(var(--jd-padding-default)*1.5);padding:0 var(--jd-padding-default)}.jodit-dialog__content .jodit-form__group:first-child{margin-top:var(--jd-padding-default)}.jodit-dialog__content .jodit-form__group .jodit-input_group{border-collapse:separate;display:table;width:100%}.jodit-dialog__content .jodit-form__group .jodit-input_group>*{display:table-cell;height:34px;vertical-align:middle}.jodit-dialog__content .jodit-form__group .jodit-input_group>input{margin:0!important}.jodit-dialog__content .jodit-form__group .jodit-input_group>input:not([class*=col-]){width:100%}.jodit-dialog__content .jodit-form__group .jodit-input_group-buttons{font-size:0;vertical-align:middle;white-space:nowrap;width:1%}.jodit-dialog__content .jodit-form__group .jodit-input_group-buttons>.jodit-button{border:1px solid var(--jd-color-border);border-radius:0;height:34px;line-height:34px;margin-left:-1px}.jodit-dialog__footer{display:none;flex-wrap:nowrap;justify-content:space-between;padding:var(--jd-padding-default)}.jodit-dialog__footer button{margin-right:calc(var(--jd-padding-default)/2)}.jodit-dialog__footer button:last-child{margin-right:0}.jodit-dialog__column{display:flex}.jodit-dialog__resizer{display:none;position:relative}.jodit-dialog__resizer svg{bottom:0;cursor:nwse-resize;height:12px;overflow:hidden;position:absolute;right:0;width:12px;fill:var(--jd-color-gray-dark);user-select:none}.jodit-dialog_resizable_true .jodit-dialog__resizer{display:block}@media (max-width:480px){.jodit-dialog__resizer{display:none}}.jodit-dialog_prompt{max-width:300px;min-width:200px;padding:var(--jd-padding-default);word-break:break-all}.jodit-dialog_prompt label{display:block;margin-bottom:calc(var(--jd-padding-default)/2)}.jodit-dialog_alert{max-width:300px;min-width:200px;padding:var(--jd-padding-default);word-break:break-all}.jodit-dialog_footer_true .jodit-dialog__footer{display:flex}.jodit_fullsize .jodit-dialog__panel{height:100%!important;inset:0!important;width:100%!important}.jodit_fullsize .jodit-dialog__panel .jodit-dialog__resizer{display:none}.jodit-dialog .jodit-ui-messages{z-index:var(--jd-z-index-dialog)}.jodit-context-menu{background:0 0;border:0;box-shadow:var(--jd-popup-box-shadow);display:inline-block;float:none;height:auto;margin:0;max-width:none;outline:0;padding:0;position:static;position:fixed;transform:translateZ(0);width:auto;z-index:var(--jd-z-index-popup);z-index:var(--jd-z-index-context-menu)}.jodit-context-menu,.jodit-context-menu__content{font-family:var(--jd-font-default);font-size:var(--jd-font-size-default)}.jodit-context-menu__content{background:var(--jd-color-background-default);max-height:var(--jd-popup-max-height,400px);overflow:auto;padding:var(--jd-padding-default);overflow-scrolling:touch}.jodit-context-menu_padding_false .jodit-context-menu__content{padding:0}.jodit-context-menu_max-height_false .jodit-context-menu__content{max-height:fit-content}.jodit-context-menu .jodit-ui-button{display:flex}.jodit-context-menu button{width:100%}.jodit-context-menu_theme_dark{background-color:var(--jd-dark-background-color)}:root{--jd-image-editor-resizer-border-color:#05ff00;--jd-image-editor-resizer-target-size:padding-default;--jd-image-editor-resizer-target-border-color:#383838;--jd-image-editor-resizer-target-bg-color:#8c7878}.jodit-image-editor{height:100%;overflow:hidden;padding:var(--jd-padding-default);width:100%}@media (max-width:768px){.jodit-image-editor{height:auto}}.jodit-image-editor>div,.jodit-image-editor>div>div{height:100%}@media (max-width:768px){.jodit-image-editor>div,.jodit-image-editor>div>div{height:auto;min-height:200px}}.jodit-image-editor *{box-sizing:border-box}.jodit-image-editor .jodit-image-editor__slider-title{background-color:#f9f9f9;border-bottom:1px solid hsla(0,0%,62%,.31);color:#333;cursor:pointer;font-weight:700;line-height:1em;padding:.8em 1em;text-overflow:ellipsis;text-shadow:#f3f3f3 0 1px 0;user-select:none;white-space:nowrap}.jodit-image-editor .jodit-image-editor__slider-title svg{display:inline-block;margin-right:var(--jd-padding-default);vertical-align:middle;width:16px}.jodit-image-editor .jodit-image-editor__slider-content{display:none}.jodit-image-editor .jodit-image-editor__slider.jodit-image-editor_active .jodit-image-editor__slider-title{background-color:#5d5d5d;color:#fff;text-shadow:#000 0 1px 0}.jodit-image-editor .jodit-image-editor__slider.jodit-image-editor_active .jodit-image-editor__slider-title svg{fill:#fff}.jodit-image-editor .jodit-image-editor__slider.jodit-image-editor_active .jodit-image-editor__slider-content{display:block}.jodit-image-editor__area{background-color:#eee;background-image:linear-gradient(45deg,var(--jd-color-border) 25%,transparent 25%,transparent 75%,var(--jd-color-border) 75%,var(--jd-color-border)),linear-gradient(45deg,var(--jd-color-border) 25%,transparent 25%,transparent 75%,var(--jd-color-border) 75%,var(--jd-color-border));background-position:0 0,15px 15px;background-size:30px 30px;display:none;height:100%;overflow:hidden;position:relative;user-select:none;width:100%}.jodit-image-editor__area.jodit-image-editor_active{display:block}.jodit-image-editor__area .jodit-image-editor__box{height:100%;overflow:hidden;pointer-events:none;position:relative;z-index:1}.jodit-image-editor__area .jodit-image-editor__box img{max-height:100%;max-width:100%;user-select:none}.jodit-image-editor__area .jodit-image-editor__croper,.jodit-image-editor__area .jodit-image-editor__resizer{background-repeat:no-repeat;border:1px solid #fff;box-shadow:0 0 11px #000;height:100px;left:20px;pointer-events:none;position:absolute;top:var(--jd-padding-default);width:100px;z-index:2}.jodit-image-editor__area .jodit-image-editor__croper i.jodit_bottomright,.jodit-image-editor__area .jodit-image-editor__resizer i.jodit_bottomright{background-color:var(--jd-image-editor-resizer-target-bg-color);border:1px solid var(--jd-image-editor-resizer-target-border-color);border-radius:50%;bottom:calc(var(--jd-padding-default)*-1);box-shadow:0 0 11px #000;cursor:se-resize;display:inline-block;height:20px;pointer-events:all;position:absolute;right:calc(var(--jd-padding-default)*-1);width:20px;z-index:4}.jodit-image-editor__area .jodit-image-editor__croper i.jodit_bottomright:active,.jodit-image-editor__area .jodit-image-editor__resizer i.jodit_bottomright:active{border:1px solid #ff0}.jodit-image-editor__area.jodit-image-editor__area_crop{background:#eee;height:100%;line-height:100%;position:relative;text-align:center}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box{height:100%;line-height:100%;overflow:visible;pointer-events:all;text-align:left}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box img{height:100%;max-height:100%;max-width:100%;width:100%}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box:after{background:hsla(0,0%,100%,.3);content:"";inset:0;margin:auto;position:absolute;z-index:1}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box .jodit-image-editor__croper{cursor:move;pointer-events:all}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box .jodit-image-editor__croper i.jodit-image-editor__sizes{background:rgba(0,0,0,.2);border-radius:.4em;bottom:-30px;color:#fff;display:block;font-size:12px;left:100%;padding:9px 6px;position:absolute;text-align:center;text-shadow:none;white-space:pre}.jodit-image-editor__area.jodit-image-editor__area_crop.jodit-image-editor_active{align-items:center;display:flex;justify-content:center}.jodit-file-browser-files{display:none;height:100%;overflow-anchor:auto;position:relative;vertical-align:top}.jodit-file-browser-files .jodit-button{border-radius:0}.jodit-file-browser-files_loading_true:before{content:"";height:100%;left:0;position:absolute;top:0;width:100%}.jodit-file-browser-files_loading_true:after{animation:b 2s ease-out 0s infinite;background:url(${h}) no-repeat 50%;background-size:100% 100%;content:"";display:inline-block;height:var(--jd-icon-loader-size);left:50%;margin-left:calc(var(--jd-icon-loader-size)/-2);margin-top:calc(var(--jd-icon-loader-size)/-2);opacity:.7;position:absolute;top:50%;vertical-align:middle;width:var(--jd-icon-loader-size);will-change:transform}.jodit-file-browser-files::-webkit-scrollbar{width:calc(var(--jd-padding-default)/2)}.jodit-file-browser-files::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.jodit-file-browser-files::-webkit-scrollbar-thumb{background-color:#a9a9a9;outline:1px solid #708090}.jodit-file-browser-files_active_true{align-content:flex-start;display:flex;flex-wrap:wrap;overflow-y:auto;padding:calc(var(--jd-padding-default)/2);width:100%}.jodit-file-browser-files__item{align-items:center;border:1px solid var(--jd-color-border);display:flex;font-size:0;height:var(--jd-col-size);justify-content:center;margin:calc(var(--jd-padding-default)/2);overflow:hidden;position:relative;text-align:center;transition:border .1s linear,bottom .1s linear;width:var(--jd-col-size)}@media (max-width:480px){.jodit-file-browser-files__item{width:calc(50% - var(--jd-padding-default))}}.jodit-file-browser-files__item img{max-width:100%}.jodit-file-browser-files__item:hover{border-color:#433b5c}.jodit-file-browser-files__item_active_true{background-color:var(--jd-color-border-active);border-color:var(--jd-color-border-selected)}.jodit-file-browser-files__item_active_true .jodit-file-browser-files__item-info{background-color:var(--jd-color-border-active);color:#fff;text-shadow:none}.jodit-file-browser-files__item-info{background-color:var(--jd-info-background);bottom:0;color:#333;font-size:14px;left:0;line-height:16px;opacity:.85;overflow:visible;padding:.3em .6em;position:absolute;right:0;text-align:left;text-shadow:#eee 0 1px 0;transition:opacity .4s ease;white-space:normal}.jodit-file-browser-files__item-info>span{display:block;font-size:.75em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.jodit-file-browser-files__item-info>span.jodit-file-browser-files__item-info-filename{font-size:.9em;font-weight:700}.jodit-file-browser-files__item:hover:not(.jodit-file-browser-files__item_active_true) .jodit-file-browser-files__item-info{bottom:-100px}.jodit-file-browser-files_view_list{scroll-behavior:smooth}.jodit-file-browser-files_view_list a{border-width:0 0 1px;display:block;height:26px;line-height:26px;margin:0;text-align:left;white-space:nowrap;width:100%}.jodit-file-browser-files_view_list a img{display:inline-block;margin-left:4px;max-width:16px;min-width:16px;vertical-align:middle}.jodit-file-browser-files_view_list a .jodit-file-browser-files__item-info{background-color:transparent;display:inline-block;font-size:0;height:100%;line-height:inherit;margin-left:4px;padding:0;position:static;vertical-align:middle;width:calc(100% - 20px)}.jodit-file-browser-files_view_list a .jodit-file-browser-files__item-info>span{display:inline-block;font-size:12px;height:100%}.jodit-file-browser-files_view_list a .jodit-file-browser-files__item-info-filename{width:50%}.jodit-file-browser-files_view_list a .jodit-file-browser-files__item-info-filechanged,.jodit-file-browser-files_view_list a .jodit-file-browser-files__item-info-filesize{width:25%}.jodit-file-browser-files_view_list a:hover{background-color:#433b5c}.jodit-file-browser-files_view_list a:hover .jodit-file-browser-files__item-info{color:#fff;text-shadow:none}.jodit-file-browser-files_view_list a:before{content:"";display:inline-block;height:100%;vertical-align:middle}:root{--jd-color-folder-title:#b1b1b1}.jodit-file-browser-tree{--jd-color-background-filebrowser-folders:#3f3f3f;display:none;height:100%;overflow-anchor:auto;position:relative;vertical-align:top}.jodit-file-browser-tree .jodit-button{border-radius:0}.jodit-file-browser-tree_loading_true:before{content:"";height:100%;left:0;position:absolute;top:0;width:100%}.jodit-file-browser-tree_loading_true:after{animation:b 2s ease-out 0s infinite;background:url(${h}) no-repeat 50%;background-size:100% 100%;content:"";display:inline-block;height:var(--jd-icon-loader-size);left:50%;margin-left:calc(var(--jd-icon-loader-size)/-2);margin-top:calc(var(--jd-icon-loader-size)/-2);opacity:.7;position:absolute;top:50%;vertical-align:middle;width:var(--jd-icon-loader-size);will-change:transform}.jodit-file-browser-tree::-webkit-scrollbar{width:calc(var(--jd-padding-default)/2)}.jodit-file-browser-tree::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.jodit-file-browser-tree::-webkit-scrollbar-thumb{background-color:#a9a9a9;outline:1px solid #708090}.jodit-file-browser-tree_active_true{background-color:var(--jd-color-background-filebrowser-folders);display:flex;flex-direction:column;max-width:290px;min-width:200px;overflow-y:auto;width:var(--jd-first-column);z-index:2}@media (max-width:480px){.jodit-file-browser-tree_active_true{height:100px;max-width:100%;width:auto}}.jodit-file-browser-tree_active_true::-webkit-scrollbar{width:calc(var(--jd-padding-default)/2)}.jodit-file-browser-tree_active_true::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.jodit-file-browser-tree_active_true::-webkit-scrollbar-thumb{background-color:hsla(0,0%,50%,.5);outline:1px solid #708090}.jodit-file-browser-tree__item{align-items:center;border-bottom:1px solid #474747;color:var(--jd-color-folder-title);display:flex;justify-content:space-between;min-height:38px;padding:calc(var(--jd-padding-default)/2) var(--jd-padding-default);position:relative;text-decoration:none;transition:background-color .2s ease 0s;word-break:break-all}.jodit-file-browser-tree__item-title{color:var(--jd-color-folder-title);flex:1}.jodit-file-browser-tree__item .jodit-icon_folder{align-items:center;display:flex;height:calc(var(--jd-icon-size) + 4px);justify-content:center;margin-left:calc(var(--jd-padding-default)/2);opacity:.3;width:calc(var(--jd-icon-size) + 4px)}.jodit-file-browser-tree__item .jodit-icon_folder svg{height:var(--jd-icon-size);width:var(--jd-icon-size);fill:var(--jd-color-folder-title)!important;stroke:var(--jd-color-folder-title)!important}.jodit-file-browser-tree__item .jodit-icon_folder:hover{background:#696969}.jodit-file-browser-tree__item:hover{background-color:var(--jd-color-background-button-hover)}.jodit-file-browser-tree__item:hover-title{color:var(--jd-color-text)}.jodit-file-browser-tree__item:hover i.jodit-icon_folder{opacity:.6}.jodit-file-browser-tree__source-title{background:#5a5a5a;border-bottom:1px solid #484848;color:#969696;display:block;font-size:12px;padding:2px 4px;position:relative;user-select:none;word-break:break-all}a+.jodit-file-browser-tree__source-title{margin-top:var(--jd-padding-default)}:root{--jd-first-column:31%;--jd-cols:4;--jd-info-background:#e9e9e9;--jd-icon-size:12px;--jd-col-size:150px}.jodit-file-browser{display:flex;font-family:var(--jd-font-default);height:100%}.jodit-file-browser_no-files_true{padding:var(--jd-padding-default)}@media (max-width:480px){.jodit-file-browser{flex-flow:column-reverse}}.jodit-dialog .jodit-dialog__header-title.jodit-file-browser__title-box{align-items:center;display:flex;padding-left:var(--jd-padding-default)}.jodit-file-browser-preview{align-items:center;display:flex;height:100%;justify-content:center;margin:auto;max-height:100%;max-width:min(100%,1000px);min-height:min(100%,500px);min-width:400px;position:relative;text-align:center}@media (max-width:768px){.jodit-file-browser-preview{height:100%;max-height:100%;max-width:100%;min-height:auto;min-width:auto}}.jodit-file-browser-preview__box{align-items:center;display:flex;flex-grow:1;justify-content:center}.jodit-file-browser-preview__navigation{cursor:pointer;height:100%;left:0;position:absolute;top:0}.jodit-file-browser-preview__navigation_arrow_next{left:auto;right:0}.jodit-file-browser-preview__navigation svg{height:45px;position:relative;top:50%;width:45px;fill:#9e9ba7;transform:translateY(-50%);transition:fill .3s linear}.jodit-file-browser-preview__navigation:hover svg{fill:#000}.jodit-file-browser-preview img{max-height:100%;max-width:100%}.jodit-status-bar{align-items:center;background-color:var(--jd-color-panel);border-radius:0 0 var(--jd-border-radius-default) var(--jd-border-radius-default);color:var(--jd-color-text-icons);display:flex;font-size:var(--jd-font-size-small);height:20px;justify-content:flex-start;overflow:hidden;padding:0 calc(var(--jd-padding-default)/2);text-transform:uppercase}.jodit-status-bar_resize-handle_true{padding-right:14px}.jodit-status-bar:before{content:"";flex:auto;order:1}.jodit-status-bar .jodit-status-bar__item{line-height:1.5714em;margin:0 var(--jd-padding-default) 0 0;order:0;padding:0}.jodit-status-bar .jodit-status-bar__item,.jodit-status-bar .jodit-status-bar__item>span{font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);font-size:var(--jd-font-size-small)}.jodit-status-bar .jodit-status-bar__item.jodit-status-bar__item-right{margin:0 0 0 var(--jd-padding-default);order:2}.jodit-status-bar .jodit-status-bar__item a{border-radius:3px;cursor:default;text-decoration:none}.jodit-status-bar .jodit-status-bar__item a:hover{background-color:var(--jd-color-background-gray);text-decoration:none}.jodit-status-bar a.jodit-status-bar-link{cursor:pointer}.jodit-status-bar a.jodit-status-bar-link,.jodit-status-bar a.jodit-status-bar-link:hover,.jodit-status-bar a.jodit-status-bar-link:visited{background-color:transparent;color:var(--jd-color-text-icons)}.jodit-status-bar a.jodit-status-bar-link:hover{text-decoration:underline}.jodit-workplace+.jodit-status-bar:not(:empty){border-top:1px solid var(--jd-color-border)}.jodit_disabled .jodit-status-bar{opacity:.4}.jodit-drag-and-drop__file-box,.jodit_uploadfile_button{border:1px dashed var(--jd-color-gray);margin:var(--jd-padding-default) 0;overflow:hidden;padding:25px 0;position:relative;text-align:center;width:100%}.jodit-drag-and-drop__file-box:hover,.jodit_uploadfile_button:hover{background-color:var(--jd-color-background-button-hover)}.jodit-drag-and-drop__file-box input,.jodit_uploadfile_button input{cursor:pointer;font-size:400px;inset:0;margin:0;opacity:0;padding:0;position:absolute}@media (max-width:768px){.jodit-drag-and-drop__file-box{max-width:100%;min-width:var(--jd-width-input-min);width:auto}}.jodit-about{padding:20px}.jodit-about a{color:#459ce7;text-decoration:none}.jodit-about a:focus,.jodit-about a:hover{color:#23527c;outline:0;text-decoration:underline}.jodit-about div{margin-bottom:calc(var(--jd-padding-default)/2)}:root{--jd-anl-color-new-line:var(--jd-color-border);--jd-anl-handle-size:20px;--jd-anl-handle-offset:calc(100% - var(--jd-anl-handle-size))}.jodit-add-new-line{display:block;height:1px;outline:none;position:fixed;top:0;z-index:1}.jodit-add-new-line,.jodit-add-new-line *{box-sizing:border-box}.jodit-add-new-line:after{background-color:var(--jd-anl-color-new-line);content:"";display:block;height:1px;width:100%}.jodit-add-new-line span{align-items:center;background:var(--jd-color-background-button-hover-opacity30);border:1px solid var(--jd-anl-color-new-line);cursor:pointer;display:flex;height:var(--jd-anl-handle-size);justify-content:center;left:var(--jd-anl-handle-offset);position:absolute;top:0;transform:translateY(-50%);width:var(--jd-anl-handle-size)}.jodit-add-new-line span:hover{background:var(--jd-color-background-button-hover)}.jodit-add-new-line svg{width:calc(var(--jd-anl-handle-size)/2);fill:var(--jd-anl-color-new-line)}.jodit-source__mode .jodit-add-new-line{display:none!important}:root{--jd-color-picker-cell-size:24px}.jodit-color-picker{margin:0;text-align:left;user-select:none}.jodit-color-picker__group{display:flex;flex-wrap:wrap;margin-bottom:calc(var(--jd-padding-default)/2);max-width:calc(var(--jd-color-picker-cell-size)*10);white-space:normal}.jodit-color-picker__color-item{border:1px solid transparent;display:block;height:var(--jd-color-picker-cell-size);text-align:center;text-decoration:none;vertical-align:middle;width:var(--jd-color-picker-cell-size)}.jodit-color-picker__color-item:hover{border-color:#000}.jodit-color-picker__color-item:active,.jodit-color-picker__color-item_active_true{border:2px solid var(--jd-color-border-selected)}.jodit-color-picker__native svg{display:inline-block;height:16px;margin-right:4px;width:16px}.jodit-color-picker__native input{appearance:none;border:none;height:18px;padding:0;width:18px}.jodit-color-picker__native input[type=color]::-webkit-color-swatch-wrapper{padding:0}.jodit-color-picker__native input input[type=color]::-webkit-color-swatch{border:none}.jodit-tabs{--jd-box-shadow-tabs:0 0 #0000,0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1);font-family:var(--jd-font-default);font-size:var(--jd-font-size-default)}.jodit-tabs .jodit-tabs__buttons{background-color:var(--jd-color-background-light-gray);border-radius:var(--jd-border-radius-default);display:flex;justify-content:center;margin-bottom:var(--jd-padding-default);margin-top:calc(var(--jd-padding-default)/2);padding:calc(var(--jd-padding-default)/2)}.jodit-tabs .jodit-tabs__buttons .jodit-ui-button{color:var(--jd-color-placeholder)}.jodit-tabs .jodit-tabs__buttons .jodit-ui-button svg{fill:var(--jd-color-placeholder)}.jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]),.jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]){box-shadow:var(--jd-box-shadow-tabs);color:var(--jd-color-text-icons)}.jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]),.jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]) .jodit-ui-button__text,.jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]),.jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]) .jodit-ui-button__text{background-color:var(--jd-color-background-default)}.jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]) svg,.jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]) svg{fill:var(--jd-color-text-icons)}.jodit-tabs .jodit-tabs__buttons>*{cursor:pointer;margin-left:calc(var(--jd-padding-default)/2)}.jodit-tabs .jodit-tabs__buttons>:only-of-type{width:100%}.jodit-tabs .jodit-tabs__buttons>:first-child{margin-left:0}@media (max-width:480px){.jodit-tabs .jodit-tabs__buttons{display:block}.jodit-tabs .jodit-tabs__buttons>*{margin-left:0;width:100%}}.jodit-tabs__button{max-width:210px;min-width:80px}.jodit-tabs__button .jodit-ui-button__text{flex:1;justify-content:space-around;white-space:nowrap}.jodit-tabs__button_columns_3{width:33.33333%}.jodit-tabs__button_columns_2{width:50%}.jodit-tabs .jodit-tabs__wrapper .jodit-tab{display:none}.jodit-tabs .jodit-tabs__wrapper .jodit-tab.jodit-tab_active{display:block}.jodit-tabs .jodit-tabs__wrapper .jodit-tab.jodit-tab_empty{min-height:100px;min-width:220px}.jodit-dialog_theme_dark .jodit-tabs .jodit-tabs__buttons,.jodit_theme_dark .jodit-tabs .jodit-tabs__buttons{background-color:var(--jd-dark-background-color);border-radius:var(--jd-border-radius-default)}.jodit-dialog_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]) .jodit-ui-button__text,.jodit-dialog_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]) .jodit-ui-button__text,.jodit_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]) .jodit-ui-button__text,.jodit_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]) .jodit-ui-button__text{color:var(--jd-dark-toolbar-color)}.jodit-dialog_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]) svg,.jodit-dialog_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]) svg,.jodit_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button:active:not([disabled]) svg,.jodit_theme_dark .jodit-tabs .jodit-tabs__buttons .jodit-ui-button[aria-pressed=true]:not([disabled]) svg{fill:var(--jd-color-text-icons)}.jodit_fullsize-box_true{overflow:visible!important;position:static!important;z-index:var(--jd-z-index-full-size)!important}body.jodit_fullsize-box_true,html.jodit_fullsize-box_true{height:0!important;overflow:hidden!important;width:0!important}html.jodit_fullsize-box_true{position:fixed!important}.jodit_fullsize{inset:0;max-width:none!important;position:absolute;z-index:var(--jd-z-index-full-size)}.jodit_fullsize .toolbar{width:100%!important}.jodit_fullsize .jodit__area,.jodit_fullsize .jodit_editor{height:100%}.jodit-ui-image-position-tab__lockMargin>svg,.jodit-ui-image-position-tab__lockSize>svg,.jodit-ui-image-properties-form__lockMargin>svg,.jodit-ui-image-properties-form__lockSize>svg{display:inline-block;height:var(--jd-icon-middle-size);overflow:hidden;width:var(--jd-icon-middle-size);fill:var(--jd-color-dark);line-height:var(--jd-icon-middle-size);transform-origin:0 0!important;vertical-align:middle}.jodit-ui-image-position-tab__view-box,.jodit-ui-image-properties-form__view-box{padding:var(--jd-padding-default)}.jodit-ui-image-position-tab__imageView,.jodit-ui-image-properties-form__imageView{align-items:center;background-color:var(--jd-color-background-light-gray);display:flex;height:var(--jd-width-default);justify-content:center;margin:0 0 var(--jd-padding-default);padding:0}.jodit-ui-image-position-tab__imageView img,.jodit-ui-image-properties-form__imageView img{max-height:100%;max-width:100%}.jodit-ui-image-position-tab__imageSizes.jodit-form__group,.jodit-ui-image-properties-form__imageSizes.jodit-form__group{align-items:center;flex-direction:row;margin:0;min-width:auto;padding:0}.jodit-ui-image-position-tab__imageSizes.jodit-form__group a,.jodit-ui-image-properties-form__imageSizes.jodit-form__group a{cursor:pointer;display:inline-block}.jodit-ui-image-position-tab .jodit-form__group,.jodit-ui-image-properties-form .jodit-form__group{padding:0}.jodit-ui-image-position-tab__tabsBox,.jodit-ui-image-properties-form__tabsBox{padding:0 var(--jd-padding-default)}.jodit-dialog_theme_dark .jodit-ui-image-properties-form__imageView,.jodit_theme_dark .jodit-ui-image-properties-form__imageView{background-color:var(--jd-dark-background-color)}.jodit-ui-image-properties-form_lock_true:before{background-color:var(--jd-color-button-background-hover-opacity60);content:"";height:100%;left:0;position:absolute;top:0;width:100%;z-index:3}.jodit-ui-image-properties-form_lock_true:after{animation:b 2s ease-out 0s infinite;background:url(${h}) no-repeat 50%;background-size:100% 100%;background-size:var(--jd-icon-loader-size);content:"";display:inline-block;height:var(--jd-icon-loader-size);left:50%;margin-left:-10px;margin-top:-10px;position:absolute;top:50%;vertical-align:middle;width:var(--jd-icon-loader-size);will-change:transform}.jodit-popup-inline__container{min-width:700px;z-index:1300}.jodit-paste-storage{max-width:600px;padding:var(--jd-padding-default)}@media (max-width:768px){.jodit-paste-storage{max-width:100%}}.jodit-paste-storage>div{border:1px solid var(--jd-color-border);max-height:300px;max-width:100%}.jodit-paste-storage>div:first-child{margin-bottom:var(--jd-padding-default)}.jodit-paste-storage>div:first-child a{border:1px solid transparent;box-sizing:border-box;color:var(--jd-color-default);display:block;margin:0;max-width:100%;outline:none;overflow:hidden;padding:calc(var(--jd-padding-default)/2);text-decoration:none;text-overflow:ellipsis;white-space:pre}.jodit-paste-storage>div:first-child a.jodit_active{background-color:var(--jd-dark-background-color);color:var(--jd-color-white)}.jodit-paste-storage>div:first-child a:focus{outline:none}.jodit-paste-storage>div:last-child{overflow:auto;padding:var(--jd-padding-default)}.jodit-paste-storage>div:last-child li,.jodit-paste-storage>div:last-child ul{margin:0}.jodit-placeholder{color:var(--jd-color-placeholder);display:block;left:0;padding:var(--jd-padding-default);pointer-events:none;position:absolute;top:0;user-select:none!important;width:100%;z-index:1}.jodit__preview-box table{border:none;border-collapse:collapse;empty-cells:show;margin-bottom:1em;margin-top:1em;max-width:100%}.jodit__preview-box table tr{user-select:none}.jodit__preview-box table tr td,.jodit__preview-box table tr th{border:1px solid var(--jd-color-border);min-width:2em;padding:.4em;user-select:text;vertical-align:middle}.jodit-table-resizer{cursor:col-resize;margin-left:calc(var(--jd-padding-default)/-2);padding-left:calc(var(--jd-padding-default)/2);padding-right:calc(var(--jd-padding-default)/2);position:absolute;z-index:3}.jodit-table-resizer:after{border:0;content:"";display:block;height:100%;width:0}.jodit-table-resizer_moved{background-color:var(--jd-color-background-selection);z-index:2}.jodit-table-resizer_moved:after{border-right:1px solid moved}[data-jodit_iframe_wrapper]{display:block;position:relative;user-select:none}[data-jodit_iframe_wrapper] iframe{position:relative}[data-jodit_iframe_wrapper]:after{background:transparent;content:"";cursor:pointer;display:block;inset:0;position:absolute;z-index:1}[data-jodit_iframe_wrapper][data-jodit-wrapper_active=true] iframe{z-index:2}.jodit_lock [data-jodit-wrapper_active=true] iframe{z-index:1}:root{--jd-viewer-width:70px;--jd-viewer-height:24px;--jd-resizer-handle-size:10px;--jd-resizer-border-color:#98c1f1;--jd-resizer-handle-color:#5ba4f3;--jd-resizer-handle-hover-color:#537ebb}.jodit-resizer{font-size:0;height:100px;left:0;outline:3px solid var(--jd-resizer-border-color);pointer-events:none;position:absolute;top:0;width:100px}.jodit-resizer,.jodit-resizer *{box-sizing:border-box}.jodit-resizer>span{background-color:var(--jd-color-placeholder);color:var(--jd-color-white);display:inline-block;font-size:12px;height:var(--jd-viewer-height);left:50%;line-height:var(--jd-viewer-height);margin-left:calc(var(--jd-viewer-width)/-2);margin-top:calc(var(--jd-viewer-height)/-2);opacity:0;overflow:visible;position:absolute;text-align:center;top:50%;transition:opacity .2s linear;width:var(--jd-viewer-width)}.jodit-resizer>div{background-color:var(--jd-resizer-handle-color);display:inline-block;height:var(--jd-resizer-handle-size);pointer-events:all;position:absolute;width:var(--jd-resizer-handle-size);z-index:4}.jodit-resizer>div:hover{background-color:var(--jd-resizer-handle-hover-color)}.jodit-resizer>div:first-child{cursor:nwse-resize;left:calc(var(--jd-resizer-handle-size)/-2);top:calc(var(--jd-resizer-handle-size)/-2)}.jodit-resizer>div:nth-child(2){cursor:nesw-resize;right:calc(var(--jd-resizer-handle-size)/-2);top:calc(var(--jd-resizer-handle-size)/-2)}.jodit-resizer>div:nth-child(3){bottom:calc(var(--jd-resizer-handle-size)/-2);cursor:nwse-resize;right:calc(var(--jd-resizer-handle-size)/-2)}.jodit-resizer>div:nth-child(4){bottom:calc(var(--jd-resizer-handle-size)/-2);cursor:nesw-resize;left:calc(var(--jd-resizer-handle-size)/-2)}@media (max-width:768px){.jodit-resizer>div :root{--jd-resizer-handle-size:calc(var(--jd-resizer-handle-size)*2)}}:root{--jd-height-search:30px;--jd-width-search:320px;--jd-width-search-input-box:60%;--jd-width-search-count-box:15%;--jd-transform-button-active:0.95;--jd-timeout-button-active:0.1s}.jodit-ui-search{height:0;position:absolute;right:0;top:0;width:0}.jodit-ui-search_sticky_true{position:fixed}.jodit-ui-search__box{background-color:var(--jd-color-panel);border:solid var(--jd-color-border);border-width:0 0 1px 1px;display:flex;max-width:100vw;padding:calc(var(--jd-padding-default)/2);position:absolute;right:0;width:var(--jd-width-search)}.jodit-ui-search__box input{background-color:transparent;border:0;height:100%;margin:0;outline:none;padding:0 var(--jd-padding-default);width:100%}.jodit-ui-search__box input[data-ref=replace]{display:none}.jodit-ui-search__box input:not(:focus)+input:not(:focus){border-top:1px solid var(--jd-color-border)}.jodit-ui-search__buttons,.jodit-ui-search__counts,.jodit-ui-search__inputs{height:var(--jd-height-search)}.jodit-ui-search__inputs{padding-right:calc(var(--jd-padding-default)/2);width:var(--jd-width-search-input-box)}.jodit-ui-search__counts{border-left:1px solid var(--jd-color-border);color:var(--jd-color-border);width:var(--jd-width-search-count-box)}.jodit-ui-search__buttons,.jodit-ui-search__counts{align-items:center;display:flex;justify-content:center}.jodit-ui-search__buttons{flex:1;padding-left:0}.jodit-ui-search__buttons button{background-color:transparent;border:1px solid transparent;height:100%;margin-right:1%;width:32%}.jodit-ui-search__buttons button[data-ref=replace-btn]{border:1px solid var(--jd-color-border);display:none;margin-top:2px;width:100%}.jodit-ui-search__buttons button:hover{background-color:var(--jd-color-background-button-hover)}.jodit-ui-search__buttons button:focus{border:1px solid var(--jd-color-background-selection-opacity50)}.jodit-ui-search__buttons button:active{border:1px solid var(--jd-color-background-selection);transform:scale(var(--jd-transform-button-active))}.jodit-ui-search_empty-query_true [data-ref=next],.jodit-ui-search_empty-query_true [data-ref=prev]{opacity:.5}.jodit-ui-search_replace_true .jodit-ui-search__counts,.jodit-ui-search_replace_true .jodit-ui-search__inputs{height:calc(var(--jd-height-search)*2)}.jodit-ui-search_replace_true .jodit-ui-search__counts input,.jodit-ui-search_replace_true .jodit-ui-search__inputs input{height:50%;transition:background-color var(--jd-timeout-button-active) linear}.jodit-ui-search_replace_true .jodit-ui-search__counts input:focus,.jodit-ui-search_replace_true .jodit-ui-search__inputs input:focus{box-shadow:inset 0 0 3px 0 var(--jd-color-border)}.jodit-ui-search_replace_true .jodit-ui-search__counts input[data-ref=replace],.jodit-ui-search_replace_true .jodit-ui-search__inputs input[data-ref=replace]{display:block}.jodit-ui-search_replace_true .jodit-ui-search__buttons{flex-wrap:wrap}.jodit-ui-search_replace_true .jodit-ui-search__buttons button[data-ref=replace-btn]{display:block}::highlight(jodit-search-result),[jd-tmp-selection]{background-color:var(--jd-color-background-selection);color:var(--jd-color-text-selection)}.jodit-container:not(.jodit_inline){min-height:100px}.jodit-container:not(.jodit_inline) .jodit-workplace{display:flex;flex-direction:column;height:auto;min-height:50px;overflow:hidden}.jodit-container:not(.jodit_inline) .jodit-editor__resize{position:relative}.jodit-container:not(.jodit_inline) .jodit-editor__resize svg{bottom:0;cursor:nwse-resize;height:12px;overflow:hidden;position:absolute;right:0;width:12px;fill:var(--jd-color-gray-dark);user-select:none}.jodit-source{background-color:var(--jd-color-source-area);display:none;flex:auto;overflow:auto;position:relative}.jodit-source,.jodit-source .jodit-source__mirror-fake{min-height:100%}.jodit-source *{font:12px/normal Monaco,Menlo,Ubuntu Mono,Consolas,source-code-pro,monospace}.jodit-container.jodit-source__mode .jodit-wysiwyg,.jodit-container.jodit-source__mode .jodit-wysiwyg_iframe{display:none!important}.jodit-container.jodit-source__mode .jodit-source{display:block!important}.jodit-container.jodit_split_mode .jodit-workplace{flex-flow:row nowrap}.jodit-container.jodit_split_mode .jodit-source,.jodit-container.jodit_split_mode .jodit-wysiwyg,.jodit-container.jodit_split_mode .jodit-wysiwyg_iframe{display:block!important;flex:1;width:50%}.jodit-source__mirror{background:var(--jd-color-source-area);border:0;box-shadow:none;box-sizing:border-box;color:#f0f0f0;height:100%;line-height:1.5;font:12px/normal Monaco,Menlo,Ubuntu Mono,Consolas,source-code-pro,monospace;margin:0;min-height:100%;outline:none;overflow:auto;padding:var(--jd-padding-default);resize:none;tab-size:2em;white-space:pre-wrap;width:100%;z-index:2}.jodit-source__mirror::selection{background:var(--jd-color-selection-area)}.jodit_sticky-dummy_toolbar{display:none}.jodit_sticky>.jodit-toolbar__box{border-bottom:1px solid var(--jd-color-border);left:auto;position:fixed;position:sticky;top:0;z-index:3}.jodit_sticky .jodit_sticky-dummy_toolbar{display:block}.jodit-symbols{padding:var(--jd-padding-default);width:460px}.jodit-symbols__container{display:flex}.jodit-symbols__container_table{width:88%}.jodit-symbols__container_preview{width:12%}.jodit-symbols__preview{border:1px solid var(--jd-color-border);font-size:34px;padding:20px 0;text-align:center}.jodit-symbols__table{border:0;border-spacing:0;table-layout:fixed}.jodit-symbols__table td{padding:0}.jodit-symbols__table td a{border:1px solid transparent;box-sizing:border-box;color:var(--jd-color-text);cursor:pointer;display:inline-block;font-size:16px;height:calc(var(--jd-height-element-default)*1.2);line-height:calc(var(--jd-height-element-default)*1.2);text-align:center;text-decoration:none;vertical-align:top;width:calc(var(--jd-width-element-default)*1.2)}.jodit-symbols__table td a:focus,.jodit-symbols__table td a:hover{outline:2px solid var(--jd-color-border)}.jodit-ui-ai-assistant{min-width:460px;padding:var(--jd-padding-default);width:100%}@media (max-width:768px){.jodit-ui-ai-assistant{min-width:100%}}.jodit-ui-ai-assistant__body{margin-bottom:10px}.jodit-ui-ai-assistant__prompt-row{align-items:flex-start;display:flex;margin-bottom:10px}.jodit-ui-ai-assistant__prompt-row-label{margin-right:10px}.jodit-ui-ai-assistant__prompt-row-input{flex:1;margin-right:10px}.jodit-ui-ai-assistant__prompt-row .jodit-icon_ai_assistant{cursor:pointer;height:22px;width:22px}.jodit-ui-ai-assistant__prompt-row .jodit-ui-button{margin-right:10px}.jodit-ui-ai-assistant__prompt-row .jodit-ui-button_ai_assistant{margin-right:0;margin-top:20px}.jodit-ui-ai-assistant__results{border-color:var(--jd-color-label);border-style:solid;border-width:1px;height:300px;line-height:1.5;max-width:460px;min-height:300px;min-width:100%;overflow:auto;padding:var(--jd-padding-default);position:relative}.jodit-ui-ai-assistant__results p{margin:0 0 10px}.jodit-ui-ai-assistant__close{cursor:pointer;padding:10px;position:absolute;right:0;top:0}.jodit-ui-ai-assistant_hide_true{display:none}.jodit-ui-ai-assistant__spinner:before{animation:b .6s linear infinite;border:1px solid #ccc;border-radius:50%;border-top-color:#8817c3;box-sizing:border-box;content:"";height:30px;left:50%;margin-left:-15px;margin-top:-15px;position:absolute;top:50%;width:30px}.jodit-ui-ai-assistant__error{color:var(--jd-color-error)}.jodit-context table,.jodit-wysiwyg table{border:none;border-collapse:collapse;empty-cells:show;margin-bottom:1em;margin-top:1em;max-width:100%}.jodit-context table tr,.jodit-wysiwyg table tr{user-select:none}.jodit-context table tr td,.jodit-context table tr th,.jodit-wysiwyg table tr td,.jodit-wysiwyg table tr th{border:1px solid var(--jd-color-border);min-width:2em;padding:.4em;user-select:text;vertical-align:middle}.jodit-form__inserter{--jd-color-table-cell-background-hover:var(--jd-color-button-background-hover)}.jodit-form__inserter .jodit-form__table-creator-box{display:flex}@media (max-width:768px){.jodit-form__inserter .jodit-form__table-creator-box{flex-direction:column}}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container{font-size:0;margin:0;min-width:180px;padding:0}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container>div>span{border:1px solid var(--jd-color-border);box-sizing:border-box;cursor:pointer;display:inline-block;height:var(--jd-height-element-default);margin-bottom:2px;margin-left:2px;vertical-align:top;width:var(--jd-width-element-default)}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container>div>span:first-child{margin-left:0}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container>div>span.jodit_hovered{background:var(--jd-color-table-cell-background-hover);border-color:var(--jd-color-table-cell-background-hover)}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__options{font-size:var(--jd-font-size-default)}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__options label{padding-top:0;text-align:left}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__options label input{margin-right:var(--jd-padding-default)}.jodit-form__inserter label{font-size:14px;margin:0;padding:8px;text-align:center}.jodit-xpath{align-items:center;display:flex;margin-left:calc(var(--jd-padding-default)/-2)}.jodit-xpath__item{display:flex;height:var(--jd-font-size-small);line-height:calc(var(--jd-font-size-small) - 1px)}.jodit-xpath__item a{color:var(--jd-color-default);font-size:var(--jd-font-size-small);margin-left:2px;outline:0;padding:0 3px}:root{--jd-color-white:#fff;--jd-color-gray:#dadada;--jd-color-gray-dark:#a5a5a5;--jd-color-dark:#4c4c4c;--jd-color-blue:#b5d6fd;--jd-color-light-blue:rgba(181,214,253,.5);--jd-color-red:#ff3b3b;--jd-color-light-red:rgba(255,59,59,.4);--jd-color-default:var(--jd-color-dark);--jd-color-text:#222;--jd-color-label:var(--jd-color-gray-dark);--jd-color-error:var(--jd-color-red);--jd-color-border:var(--jd-color-gray);--jd-color-border-dark:var(--jd-color-dark);--jd-color-border-selected:#1e88e5;--jd-color-border-active:#b5b5b5;--jd-color-selection:var(--jd-color-dark);--jd-color-selection-area:#bdbdbd;--jd-color-separator:var(--jd-color-border);--jd-color-placeholder:var(--jd-color-gray-dark);--jd-color-panel:#f9f9f9;--jd-color-resizer:#c8c8c8;--jd-color-background-default:var(--jd-color-white);--jd-color-background-light-gray:#f5f5f6;--jd-color-background-gray:var(--jd-color-gray);--jd-color-background-gray-hover:#f8f8f8;--jd-color-background-button-hover:#ecebe9;--jd-color-background-button-hover-opacity30:hsla(40,7%,92%,.3);--jd-color-background-progress:#b91f1f;--jd-color-background-active:#2196f3;--jd-color-background-selection:#b5d6fd;--jd-color-text-selection:var(--jd-color-white);--jd-color-background-selection-opacity50:rgba(181,214,253,.995);--jd-color-source-area:#323232;--jd-color-button-background-hover:#dcdcdc;--jd-color-button-background-hover-opacity40:hsla(0,0%,86%,.4);--jd-color-button-background-hover-opacity60:hsla(0,0%,86%,.6);--jd-font-default:-apple-system,blinkmacsystemfont,"Segoe UI",roboto,oxygen-sans,ubuntu,cantarell,"Helvetica Neue",sans-serif;--jd-font-size-default:14px;--jd-font-size-small:11px;--jd-color-text-icons:rgba(0,0,0,.75);--jd-color-icon:var(--jd-color-dark);--jd-padding-default:8px;--jd-border-radius-default:3px;--jd-icon-tiny-size:8px;--jd-icon-xsmall-size:10px;--jd-icon-small-size:12px;--jd-icon-middle-size:14px;--jd-icon-large-size:16px;--jd-z-index-full-size:100000;--jd-z-index-popup:10000001;--jd-z-index-dialog-overlay:20000003;--jd-z-index-dialog:20000004;--jd-z-index-context-menu:30000005;--jd-z-index-tooltip:30000006;--jd-icon-loader-size:48px;--jd-width-element-default:18px;--jd-height-element-default:18px;--jd-dark-background-color:#575757;--jd-dark-background-ligher:silver;--jd-dark-background-darknes:#353535;--jd-dark-border-color:#444;--jd-dark-text-color:#d1cccc;--jd-dark-text-color-opacity80:hsla(0,5%,81%,.8);--jd-dark-text-color-opacity50:hsla(0,5%,81%,.5);--jd-dark-icon-color:silver;--jd-dark-toolbar-color:#5f5c5c;--jd-dark-toolbar-seperator-color1:rgba(81,81,81,.41);--jd-dark-toolbar-seperator-color2:#686767;--jd-dark-toolbar-seperator-color-opacity80:hsla(0,0%,41%,.8);--jd-dark-toolbar-seperator-color3:hsla(0,0%,41%,.75);--jd-dark-color-border-selected:#152f5f;--jd-width-default:180px;--jd-width-input-min:var(--jd-width-default);--jd-input-height:32px;--jd-button-icon-size:14px;--jd-margin-v:2px;--jd-button-df-size:calc((var(--jd-button-icon-size) - 4px)*2);--jd-button-size:calc(var(--jd-button-icon-size) + var(--jd-button-df-size) + var(--jd-margin-v)*2);--jd-focus-input-box-shadow:0 0 0 0.05rem rgba(0,123,255,.25)}.jodit-wysiwyg{outline:0}.jodit-wysiwyg ::selection,.jodit-wysiwyg::selection{background:#b5d6fd;color:#4c4c4c}.jodit-container:not(.jodit_inline) .jodit-wysiwyg{margin:0;outline:0;overflow-x:auto;padding:8px;position:relative}.jodit-container:not(.jodit_inline) .jodit-wysiwyg img{max-width:100%;position:relative}.jodit-container:not(.jodit_inline) .jodit-wysiwyg jodit-media{position:relative}.jodit-container:not(.jodit_inline) .jodit-wysiwyg jodit-media *{position:relative;z-index:0}.jodit-container:not(.jodit_inline) .jodit-wysiwyg jodit-media:before{content:"";inset:0;position:absolute;z-index:1}:root{--jd-switche-width:60px;--jd-switche-height:32px;--jd-switche-slider-margin:4px;--jd-switche-slider-size:calc(var(--jd-switche-height) - var(--jd-switche-slider-margin)*2)}.jodit-form{color:var(--jd-color-default);font-family:var(--jd-font-default);font-size:var(--jd-font-size-default)}.jodit-form.jodit_error{border-color:var(--jd-color-error);box-shadow:inset 0 0 3px 0 hsla(0,0%,74%,.3)}@media (max-width:768px){.jodit-form{min-width:150px}}.jodit-form button{background:#d6d6d6;border:none;color:var(--jd-color-dark);cursor:pointer;font-size:16px;height:36px;line-height:1;margin-bottom:var(--jd-padding-default);margin-top:var(--jd-padding-default);outline:none;padding:var(--jd-padding-default);text-decoration:none;transition:background .2s ease 0s}.jodit-form button:hover{background-color:var(--jd-color-background-button-hover);color:var(--jd-color-dark)}.jodit-form button:active{background:var(--jd-color-background-button-hover);color:var(--jd-color-dark)}.jodit-form label{align-items:center;display:flex;margin-bottom:var(--jd-padding-default);text-align:left;white-space:nowrap}.jodit-form label:last-child{margin-bottom:0}.jodit-form .jodit-form__center{justify-content:center}.jodit .jodit-input,.jodit .jodit-select,.jodit .jodit-textarea{appearance:none;background-color:var(--jd-color-white);border:1px solid var(--jd-color-border);border-radius:0;box-sizing:border-box;font-family:var(--jd-font-default);font-size:var(--jd-font-size-default);height:var(--jd-input-height);line-height:1.2;outline:none;padding:0 var(--jd-padding-default);width:100%}.jodit .jodit-input[disabled],.jodit .jodit-select[disabled],.jodit .jodit-textarea[disabled]{background-color:#f0f0f0;color:var(--jd-color-border)}.jodit .jodit-input_has-error_true,.jodit .jodit-select_has-error_true,.jodit .jodit-textarea_has-error_true{border-color:var(--jd-color-red)}.jodit .jodit-input:focus{border-color:#66afe9;outline:0}.jodit-checkbox{border:0;cursor:pointer;height:16px;margin:0 calc(var(--jd-padding-default)/2) 0 0;outline:none;padding:0;position:relative;width:16px;z-index:2}.jodit-select{background-image:url(${v});background-position:98% 50%;background-repeat:no-repeat;padding-right:calc(var(--jd-padding-default)*2)}.jodit-textarea{height:auto}.jodit-form__group,.jodit-textarea{min-width:var(--jd-width-input-min)}.jodit-form__group{display:flex;flex-direction:column;margin-bottom:var(--jd-padding-default)}.jodit-form__group label{margin-bottom:calc(var(--jd-padding-default)/2)}.jodit-button{align-items:center;background-color:var(--jd-color-background-gray);border:0;border-radius:.25rem;color:var(--jd-color-default);cursor:pointer;display:inline-flex;height:calc(var(--jd-padding-default)*4);justify-content:center;line-height:1;margin:0;padding:0 var(--jd-padding-default);position:relative;text-decoration:none;user-select:none;width:auto}.jodit-button svg{display:inline-block;height:24px;width:24px}.jodit-button svg+span{margin-left:calc(var(--jd-padding-default)/2)}.jodit-button:active,.jodit-button:focus{outline:0}.jodit-button.disabled{opacity:.7}.jodit-buttons{display:flex;flex-wrap:nowrap;justify-content:space-between;margin-bottom:var(--jd-padding-default)}.jodit-button .jodit_icon,.jodit-button svg,.jodit-dialog__header .jodit_icon,.jodit-dialog__header svg{display:inline-block;height:16px;vertical-align:middle;width:16px}.jodit-switcher-wrapper{align-items:center;display:flex}.jodit-switcher-wrapper .jodit-switcher+span{margin-left:var(--jd-padding-default)}.jodit-switcher{display:inline-block;height:var(--jd-switche-height);position:relative;width:var(--jd-switche-width)}.jodit-switcher input{height:0;opacity:0;width:0}.jodit-switcher .jodit-switcher__slider{background-color:var(--jd-color-gray);border-radius:var(--jd-switche-height);cursor:pointer;inset:0;position:absolute;transition:.4s}.jodit-switcher .jodit-switcher__slider:before{background-color:#fff;border-radius:50%;bottom:var(--jd-switche-slider-margin);content:"";height:var(--jd-switche-slider-size);left:var(--jd-switche-slider-margin);position:absolute;transition:.4s;width:var(--jd-switche-slider-size)}input:checked+.jodit-switcher__slider{background-color:var(--jd-color-background-active)}input:checked+.jodit-switcher__slider:before{transform:translateX(calc(var(--jd-switche-width) - var(--jd-switche-slider-margin)*2 - var(--jd-switche-slider-size)))}input:focus+.jodit-switcher__slider{box-shadow:0 0 1px var(--jd-color-background-active)}.jodit-button-group{display:flex}.jodit-button-group input{display:none}.jodit-button-group button{display:flex;flex:1;justify-content:center;text-align:center}.jodit-button-group button+button{margin-left:-1px}.jodit-button-group button:first-child,.jodit-button-group input:first-child+button{border-bottom-right-radius:0;border-right:0;border-top-right-radius:0}.jodit-button-group button:last-child,.jodit-button-group input:last-child+button{border-bottom-left-radius:0;border-left:0;border-top-left-radius:0}.jodit-button-group input[type=checkbox]:checked+button,.jodit-button-group input[type=checkbox]:not(:checked)+button+button{background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.3),0 1px 2px rgba(0,0,0,.05)}.jodit_text_icons .jodit_icon{font-size:var(--jd-font-size-default);width:auto}.jodit_text_icons .jodit_icon:first-letter{text-transform:uppercase}.jodit_text_icons .jodit-tabs .jodit-tabs__buttons>a{font-family:var(--jd-font-default);width:auto}.jodit_text_icons .jodit-tabs .jodit-tabs__buttons>a i{width:auto}.jodit_text_icons.jodit-dialog .jodit-button,.jodit_text_icons.jodit-dialog .jodit-dialog__header a{color:var(--jd-color-text-icons);font-family:var(--jd-font-default);padding:var(--jd-padding-default);width:auto}.jodit_text_icons.jodit-dialog .jodit-button .jodit_icon,.jodit_text_icons.jodit-dialog .jodit-dialog__header a .jodit_icon{width:auto}.jodit-grid{display:flex;width:100%}.jodit-grid.jodit-grid_column{flex-direction:column}@media (max-width:480px){.jodit-grid.jodit-grid_xs-column{flex-direction:column}}.jodit-grid [class*=jodit_col-]{flex:1 1 auto}.jodit-grid .jodit_col-lg-5-5{width:100%}.jodit-grid .jodit_col-lg-4-5{width:80%}.jodit-grid .jodit_col-lg-3-5{width:60%}.jodit-grid .jodit_col-lg-2-5{width:40%}.jodit-grid .jodit_col-lg-1-5{width:20%}.jodit-grid .jodit_col-lg-4-4{width:100%}.jodit-grid .jodit_col-lg-3-4{width:75%}.jodit-grid .jodit_col-lg-2-4{width:50%}.jodit-grid .jodit_col-lg-1-4{width:25%}@media (max-width:992px){.jodit-grid .jodit_col-md-5-5{width:100%}.jodit-grid .jodit_col-md-4-5{width:80%}.jodit-grid .jodit_col-md-3-5{width:60%}.jodit-grid .jodit_col-md-2-5{width:40%}.jodit-grid .jodit_col-md-1-5{width:20%}.jodit-grid .jodit_col-md-4-4{width:100%}.jodit-grid .jodit_col-md-3-4{width:75%}.jodit-grid .jodit_col-md-2-4{width:50%}.jodit-grid .jodit_col-md-1-4{width:25%}}@media (max-width:768px){.jodit-grid .jodit_col-sm-5-5{width:100%}.jodit-grid .jodit_col-sm-4-5{width:80%}.jodit-grid .jodit_col-sm-3-5{width:60%}.jodit-grid .jodit_col-sm-2-5{width:40%}.jodit-grid .jodit_col-sm-1-5{width:20%}.jodit-grid .jodit_col-sm-4-4{width:100%}.jodit-grid .jodit_col-sm-3-4{width:75%}.jodit-grid .jodit_col-sm-2-4{width:50%}.jodit-grid .jodit_col-sm-1-4{width:25%}}@media (max-width:480px){.jodit-grid .jodit_col-xs-5-5{width:100%}.jodit-grid .jodit_col-xs-4-5{width:80%}.jodit-grid .jodit_col-xs-3-5{width:60%}.jodit-grid .jodit_col-xs-2-5{width:40%}.jodit-grid .jodit_col-xs-1-5{width:20%}.jodit-grid .jodit_col-xs-4-4{width:100%}.jodit-grid .jodit_col-xs-3-4{width:75%}.jodit-grid .jodit_col-xs-2-4{width:50%}.jodit-grid .jodit_col-xs-1-4{width:25%}}@keyframes b{to{transform:rotate(1turn)}}.jodit-icon_loader{animation:b 2s ease-out 0s infinite;background:url(${h}) no-repeat 50%;background-size:100% 100%;display:inline-block;height:var(--jd-icon-loader-size);vertical-align:middle;width:var(--jd-icon-loader-size);will-change:transform}.jodit-icon{background:50% no-repeat;background-size:contain;height:14px;overflow:visible;width:14px;fill:var(--jd-color-icon);transform-origin:0 0!important}.jodit-icon,.jodit-icon_close{stroke:var(--jd-color-icon)}svg.jodit-icon{height:auto;isolation:isolate}.jodit-icon_text{font-size:14px}.jodit,.jodit *,.jodit-container,.jodit-container *{box-sizing:border-box}.jodit .jodit-workplace,.jodit-container .jodit-workplace{overflow:auto;position:relative}.jodit .jodit-workplace .jodit-wysiwyg,.jodit .jodit-workplace .jodit-wysiwyg_iframe,.jodit-container .jodit-workplace .jodit-wysiwyg,.jodit-container .jodit-workplace .jodit-wysiwyg_iframe{height:100%;width:100%}.jodit-wysiwyg [contenteditable=false]{cursor:default}.jodit-container:not(.jodit_inline){background-color:var(--jd-color-background-light-gray);border:1px solid var(--jd-color-border);border-radius:var(--jd-border-radius-default)}.jodit-container:not(.jodit_inline) .jodit-workplace{background-color:var(--jd-color-background-default);border:0 solid var(--jd-color-border);max-height:100%}.jodit-container:not(.jodit_inline).jodit_disabled{background:var(--jd-color-background-gray)}.jodit-container:not(.jodit_inline).jodit_disabled .jodit-workplace{opacity:.4}.jodit_disabled,.jodit_lock{user-select:none!important}.jodit_hidden{display:none!important}.jodit_vertical_middle{align-items:center;display:flex}.jodit-box{background:0 0;border:0;float:none;height:auto;margin:0;max-width:none;outline:0;padding:0;position:static;width:auto}.jodit-dialog_theme_dark,.jodit_theme_dark{--jd-color-border:#6b6b6b;--jd-color-text:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal,.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal,.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal,.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal{background-image:repeating-linear-gradient(transparent 0,transparent calc(var(--jd-button-size) - 1px),var(--jd-color-border) var(--jd-button-size))}.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal:after,.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after,.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal:after,.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after{background-color:var(--jd-color-border)}.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty),.jodit_theme_dark .jodit-toolbar__box:not(:empty){border-color:var(--jd-color-border)}.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after,.jodit_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after{background-color:var(--jd-color-border)}.jodit-dialog_theme_dark .jodit-ui-group_separated_true:not(:last-child,.jodit-ui-group_before-spacer_true):after,.jodit_theme_dark .jodit-ui-group_separated_true:not(:last-child,.jodit-ui-group_before-spacer_true):after{border-right-color:var(--jd-color-border)}.jodit-dialog_theme_dark.jodit-container,.jodit_theme_dark.jodit-container{background-color:var(--jd-dark-background-color);border-color:var(--jd-color-border)}.jodit-dialog_theme_dark.jodit-container.jodit_disabled,.jodit_theme_dark.jodit-container.jodit_disabled{background-color:var(--jd-dark-background-color)}.jodit-dialog_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace,.jodit_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace{border-color:var(--jd-dark-background-color)}.jodit-dialog_theme_dark .jodit-popup__content,.jodit_theme_dark .jodit-popup__content{background:var(--jd-dark-background-color)}.jodit-dialog_theme_dark .jodit-toolbar-button,.jodit-dialog_theme_dark .jodit-toolbar-select,.jodit-dialog_theme_dark .jodit-ui-button,.jodit_theme_dark .jodit-toolbar-button,.jodit_theme_dark .jodit-toolbar-select,.jodit_theme_dark .jodit-ui-button{--jd-color-icon:var(--jd-dark-icon-color)}.jodit-dialog_theme_dark .jodit-toolbar-button__text,.jodit-dialog_theme_dark .jodit-toolbar-select__text,.jodit-dialog_theme_dark .jodit-ui-button__text,.jodit_theme_dark .jodit-toolbar-button__text,.jodit_theme_dark .jodit-toolbar-select__text,.jodit_theme_dark .jodit-ui-button__text{color:var(--jd-color-text)}.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon,.jodit-dialog_theme_dark .jodit-toolbar-button svg,.jodit-dialog_theme_dark .jodit-toolbar-button__trigger,.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon,.jodit-dialog_theme_dark .jodit-toolbar-select svg,.jodit-dialog_theme_dark .jodit-toolbar-select__trigger,.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon,.jodit-dialog_theme_dark .jodit-ui-button svg,.jodit-dialog_theme_dark .jodit-ui-button__trigger,.jodit_theme_dark .jodit-toolbar-button .jodit-icon,.jodit_theme_dark .jodit-toolbar-button svg,.jodit_theme_dark .jodit-toolbar-button__trigger,.jodit_theme_dark .jodit-toolbar-select .jodit-icon,.jodit_theme_dark .jodit-toolbar-select svg,.jodit_theme_dark .jodit-toolbar-select__trigger,.jodit_theme_dark .jodit-ui-button .jodit-icon,.jodit_theme_dark .jodit-ui-button svg,.jodit_theme_dark .jodit-ui-button__trigger{fill:var(--jd-color-icon);stroke:var(--jd-color-icon)}.jodit-dialog_theme_dark .jodit-toolbar-button:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-button__button:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-select:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-select__button:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-ui-button:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-ui-button__button:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]),.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-select:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-select__button:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]),.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]),.jodit_theme_dark .jodit-ui-button:hover:not([disabled]),.jodit_theme_dark .jodit-ui-button__button:hover:not([disabled]),.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]),.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]){--jd-color-text:var(--jd-dark-background-color);--jd-color-icon:var(--jd-dark-background-color);background-color:var(--jd-dark-background-ligher);color:var(--jd-dark-background-color)}.jodit-dialog_theme_dark .jodit-status-bar,.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty),.jodit_theme_dark .jodit-status-bar,.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty){background-color:var(--jd-dark-toolbar-color);border-color:var(--jd-color-border);color:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-status-bar,.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item a,.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item span,.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link,.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover,.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited,.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty),.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item a,.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item span,.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link,.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover,.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited,.jodit_theme_dark .jodit-status-bar,.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item a,.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item span,.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link,.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover,.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited,.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty),.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item a,.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item span,.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link,.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover,.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited{color:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty),.jodit_theme_dark .jodit-toolbar__box:not(:empty){background:var(--jd-dark-toolbar-color)}.jodit-dialog_theme_dark .jodit-icon-close,.jodit_theme_dark .jodit-icon-close{stroke:var(--jd-dark-icon-color)}.jodit-dialog_theme_dark .jodit-wysiwyg,.jodit-dialog_theme_dark .jodit-wysiwyg_iframe,.jodit_theme_dark .jodit-wysiwyg,.jodit_theme_dark .jodit-wysiwyg_iframe{background-color:var(--jd-dark-background-color);color:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-form input[type=text],.jodit-dialog_theme_dark .jodit-form input[type=url],.jodit-dialog_theme_dark .jodit-form textarea,.jodit_theme_dark .jodit-form input[type=text],.jodit_theme_dark .jodit-form input[type=url],.jodit_theme_dark .jodit-form textarea{background-color:var(--jd-dark-toolbar-seperator-color1);border-color:var(--jd-dark-toolbar-seperator-color2);color:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-form button,.jodit_theme_dark .jodit-form button{background-color:var(--jd-dark-toolbar-seperator-color3);color:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-placeholder,.jodit_theme_dark .jodit-placeholder{color:var(--jd-dark-text-color-opacity80)}.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box,.jodit-dialog_theme_dark .jodit_uploadfile_button,.jodit_theme_dark .jodit-drag-and-drop__file-box,.jodit_theme_dark .jodit_uploadfile_button{color:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box:hover,.jodit-dialog_theme_dark .jodit_uploadfile_button:hover,.jodit_theme_dark .jodit-drag-and-drop__file-box:hover,.jodit_theme_dark .jodit_uploadfile_button:hover{background-color:var(--jd-dark-toolbar-seperator-color3)}.jodit-dialog_theme_dark .jodit-add-new-line:before,.jodit_theme_dark .jodit-add-new-line:before{border-top-color:var(--jd-dark-toolbar-seperator-color2)}.jodit-dialog_theme_dark .jodit-add-new-line span,.jodit_theme_dark .jodit-add-new-line span{background:var(--jd-dark-toolbar-seperator-color3);border-color:var(--jd-dark-toolbar-seperator-color2)}.jodit-dialog_theme_dark .jodit-add-new-line span svg,.jodit_theme_dark .jodit-add-new-line span svg{fill:var(--jd-dark-text-color)}.jodit-dialog_theme_dark .jodit-resizer>i,.jodit_theme_dark .jodit-resizer>i{background:var(--jd-dark-toolbar-seperator-color3);border-color:var(--jd-dark-icon-color)}.jodit-dialog_theme_dark .jodit-input,.jodit-dialog_theme_dark .jodit-select,.jodit_theme_dark .jodit-input,.jodit_theme_dark .jodit-select{background-color:var(--jd-dark-background-ligher);border-color:var(--jd-dark-border-color);color:var(--jd-dark-border-color)}.jodit-dialog_theme_dark.jodit-dialog,.jodit_theme_dark.jodit-dialog{background-color:var(--jd-dark-background-color)}.jodit-dialog_theme_dark.jodit-dialog .jodit-dialog__header,.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item,.jodit_theme_dark.jodit-dialog .jodit-dialog__header,.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item{border-color:var(--jd-dark-border-color)}.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info,.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info{background-color:var(--jd-dark-text-color)}`,
                    ""
                ]);
                const g = f;
            },
            72: (e)=>{
                var t = [];
                function o(e) {
                    for(var o = -1, n = 0; n < t.length; n++)if (t[n].identifier === e) {
                        o = n;
                        break;
                    }
                    return o;
                }
                function n(e, n) {
                    for(var i = {}, a = [], l = 0; l < e.length; l++){
                        var s = e[l], c = n.base ? s[0] + n.base : s[0], u = i[c] || 0, d = "".concat(c, " ").concat(u);
                        i[c] = u + 1;
                        var f = o(d), p = {
                            css: s[1],
                            media: s[2],
                            sourceMap: s[3],
                            supports: s[4],
                            layer: s[5]
                        };
                        if (-1 !== f) t[f].references++, t[f].updater(p);
                        else {
                            var h = r(p, n);
                            n.byIndex = l, t.splice(l, 0, {
                                identifier: d,
                                updater: h,
                                references: 1
                            });
                        }
                        a.push(d);
                    }
                    return a;
                }
                function r(e, t) {
                    var o = t.domAPI(t);
                    return o.update(e), function(t) {
                        if (t) {
                            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
                            o.update(e = t);
                        } else o.remove();
                    };
                }
                e.exports = function(e, r) {
                    var i = n(e = e || [], r = r || {});
                    return function(e) {
                        e = e || [];
                        for(var a = 0; a < i.length; a++){
                            var l = o(i[a]);
                            t[l].references--;
                        }
                        for(var s = n(e, r), c = 0; c < i.length; c++){
                            var u = o(i[c]);
                            0 === t[u].references && (t[u].updater(), t.splice(u, 1));
                        }
                        i = s;
                    };
                };
            },
            659: (e)=>{
                var t = {};
                e.exports = function(e, o) {
                    var n = function(e) {
                        if (void 0 === t[e]) {
                            var o = document.querySelector(e);
                            if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
                                o = o.contentDocument.head;
                            } catch (e) {
                                o = null;
                            }
                            t[e] = o;
                        }
                        return t[e];
                    }(e);
                    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    n.appendChild(o);
                };
            },
            540: (e)=>{
                e.exports = function(e) {
                    var t = document.createElement("style");
                    return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
                };
            },
            56: (e, t, o)=>{
                e.exports = function(e) {
                    var t = o.nc;
                    t && e.setAttribute("nonce", t);
                };
            },
            825: (e)=>{
                e.exports = function(e) {
                    if ("undefined" == typeof document) return {
                        update: function() {},
                        remove: function() {}
                    };
                    var t = e.insertStyleElement(e);
                    return {
                        update: function(o) {
                            !function(e, t, o) {
                                var n = "";
                                o.supports && (n += "@supports (".concat(o.supports, ") {")), o.media && (n += "@media ".concat(o.media, " {"));
                                var r = void 0 !== o.layer;
                                r && (n += "@layer".concat(o.layer.length > 0 ? " ".concat(o.layer) : "", " {")), n += o.css, r && (n += "}"), o.media && (n += "}"), o.supports && (n += "}");
                                var i = o.sourceMap;
                                i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(n, e, t.options);
                            }(t, e, o);
                        },
                        remove: function() {
                            !function(e) {
                                if (null === e.parentNode) return !1;
                                e.parentNode.removeChild(e);
                            }(t);
                        }
                    };
                };
            },
            113: (e)=>{
                e.exports = function(e, t) {
                    if (t.styleSheet) t.styleSheet.cssText = e;
                    else {
                        for(; t.firstChild;)t.removeChild(t.firstChild);
                        t.appendChild(document.createTextNode(e));
                    }
                };
            },
            333: (e)=>{
                e.exports = function(e) {
                    var t = [];
                    return t.toString = function() {
                        return this.map(function(t) {
                            var o = "", n = void 0 !== t[5];
                            return t[4] && (o += "@supports (".concat(t[4], ") {")), t[2] && (o += "@media ".concat(t[2], " {")), n && (o += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), o += e(t), n && (o += "}"), t[2] && (o += "}"), t[4] && (o += "}"), o;
                        }).join("");
                    }, t.i = function(e, o, n, r, i) {
                        "string" == typeof e && (e = [
                            [
                                null,
                                e,
                                void 0
                            ]
                        ]);
                        var a = {};
                        if (n) for(var l = 0; l < this.length; l++){
                            var s = this[l][0];
                            null != s && (a[s] = !0);
                        }
                        for(var c = 0; c < e.length; c++){
                            var u = [].concat(e[c]);
                            n && a[u[0]] || (void 0 !== i && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = i), o && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = o) : u[2] = o), r && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = r) : u[4] = "".concat(r)), t.push(u));
                        }
                    }, t;
                };
            },
            504: (e)=>{
                e.exports = function(e, t) {
                    return t || (t = {}), e ? (e = String(e.__esModule ? e.default : e), /^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), t.hash && (e += t.hash), /["'() \t\n]|(%20)/.test(e) || t.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e) : e;
                };
            },
            772: (e)=>{
                e.exports = function(e) {
                    return e[1];
                };
            },
            789: (e)=>{
                e.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAABRsSURBVHja7F1/aJfVGn/33RgUg8FiNfK2WCykyS7GLoYyUbwYipZMumgLo+iPS9HlXhSHkRXdislESxMz0mapuaFo2myjkfnNlTQ2FJdTu8NvLVcrdbpcfGvxrfs823m/vXt3fjznvOedzr0PPJzzPe+7d+97Ps95nuc851fGAw884CD98ccfI1Jqmc3UpEyQz4FkMqRTgYshn8fymZ57SyGbzf5mENIOz9+ngE9Atg/SLkhPQHoWeEDn3SmpSZlJnvf7ypUrTpb7IyMjY+gGN6WWmaY84l2T3c+u58D1csjOgvwsyBdBvsDRo2zgMl/ZNM59vcAJ4Dj8nzikLa5QmBLv28YCfPd3li7gPHBMwKdcEwhCJgN6FoLOWJtUgiWovALG04FXsbI44xbgw8AplbaU/Q+ZQNgGf0gA/JWhC1aQyle1eN91rPRKKKuEsjzZvSph0m2RiutpIYRrfZC8B+l7kB6jgq0CnQIy9X39v2NYQW5FeUFQlQVN/aALyiYBPw/5M5B+Dvw02vMggqcDukEl57F3xHf9H747+4bA5oD6dzqaYEgAqIDbBl9RhvZ4H/B5yL+IDp3oXhmwNkm3lTLn80VIz+O3QFqm2/rHwgeI6QDOa006LZ3Q4lHNNwK3AVeYAD4WgmHQUivYNzWyb7xufICYaavXVbuKZ6MXfwRVJ+TnXW+Am/oMnNaO3/Y5pPitcyh/a6LqtXwAt+J01LVFEzAJ0jpIj7JunJYd1wHchnBQHUSC3Uan8WPgPVgHlBiBCcAkH4Da2i2DjwGZlcy5W0K17zLwVb9NgaY4iJpawJs+BCnWwUo3SKXT4oOAP8IHCFsIfMCguj8JaQ2kOaaA227d10ALuIR1gHVxErjctPtHBd8btSR3A4MIgSePAZxqVPeQlthq7ZRuZVABCVkLuGkJpGgKsY4ybfUEVO84qhsoAzSgrUfHZ1UQVe99B6o2oMYdwg7latAq5iROGoueQExW6UE0gCe/ANIh9SZ6jqkWsN3STZ0rHWEgpkNmEvILxqQbSAXaAPxqSBswQkbpbpo6fGPR0m3GBYjBIIwqNjCTEAr4wkBQUA0AjKNrdZCu0okAqgQhTKCDhFxV91BNgsDuYx3WQZptG3xtDUCJEDKvthGuLVEJlq4gUMyAylfQERadPrhKOHTmB3Ces4RFEXNsgW8UClbZcEhxqPQIpHOord2k1ZsAH4YvYNJXN3EgWX4Ocw4LbIEvDQSJfADJtULWxSuj+BBUP4DaC6D0DkyFg6JKTVo/5brvXqzbo2zSi3af3/9bGgrW1Ar5kH4MXEzVHEHVf5CuYZC4fti9AoI/gXX8Eda5Tp9f9I4xWWsnOoc5zNMv1okjmKp/vzay3epNJ4+YmALdoWBPWTHksc5zTU1AekqYt7LcWTruTYTZQdmQHoB0GuXv/de8L8e7xrsuA8kPNtx3AZIOxp3APc7wvD6kvi+//DLh3nvPPfegWs1jf4dBGGxpOA+hlOXzgw7VBjEBnDKcs4jzDOZDOmjqD2SJQFGBx9JaSOcQ7xVO2RIJhf86AfB+Z3huHs7Ra2pra+ugtubTp0+jMLgC0e6/ftddd6EgzMO5iGwSaq4NITCdLczy6GzXAj8KnDIxAaM0AKeViwCtgbRSNgGUJwQyDaACngO4w6S/CXgb8KEvvvgiFUaw59y5c64mWXvnnXdmsijdYxjpdP6cXh6oS0g1Bb48zpFEzValA3663pcuXaoleSzFltBIlWhRmWx+v6yMcQJ4PU7A/Oyzz/qca0R33HEHrjlAEJa73rns24JqA0keTUGTjglIJpNOxsMPP6wLfiGkx53hxRbcewwXc1BAx0u4gGMNcP2nn36acq4juv322ytZ5K7UlhBo5LER3AvcTXU60wKgYbsyWTCi3LTV6wLvKesGrvrkk0/qneucCgoKHoJkHbxvYRAhMMij/zMbVzZRTMAvv/wycj4AoRv4Mk7oII4HkLp+vC6drwxt/FrgKeMBfKTe3t69UMFTgPG9B3WcQdMeBsvjhJJqnYGqjMrKSmr/tZxNWAi87o9i+1l5O6SPNjc3dzrjlPLz83HyC/aWpqk0gWZUUHZtJvxuUZmAtAYgtHycr/a6qIXz2DQI5OH1UDRjPIOPdOHChU6o+JmQXW+68JYS4vUB/bozvN5RGAImdwPZA3AC51RKrMAfyBHFGCRBnz4oe7ypqemgc4PQxYsX0YytuOWWW3BRaa3DWd0U1A/w/Z4KvBx4jcoExAitE6dzPStr3RR/QKQ5fOUJ4PsaGxtvGPC9dOnSJfyu+7ALa9MJFPx+lkU05YNBBDVdg0uwKc4eAWCZ83cC8jM+/PDDLucGpr6+Pvy+GWz/ASs9AMFvd7ax1ATEFOBjmLdSBraN3gBwHHhmQ0NDrzMB6PLly73MUYubOs3EiB/GJebyTEB6QogCnGrV6KAFR7AVeP4HH3ww4EwgunLlCn7vfACi1UQDqMb5PWUvm5qAB3HESXNomKz2GaOHv/DAgQNJZwJSf38/fvdC3J5G1iPQnf3jK5sGvx80MQHP69hxHWZ/2wN8//vvv3/BmcD0008/XWCaoEcUJ6C0eoUWeFbXBOBCzTKKJ2/YExgEXrRv374eJyLn6tWrWA+LAJRBy+o/rQUQUx0TsFwzRKzLK/bu3dseQf8nDQwMYH2sCOL0ibx9Vr6cagIKmf0nxe8pguC7vn/Pnj2bIshH088//4z1st+m+veUI6ZFFBOwLGj/XqIh0O4/HkEtJgDmcZ4/EED9e69VKk0ACoDN1u/jqrq6uv4IZjElk0msnypbwPs0wTKVCUBnYbLuMC5REA7v3r37vQhikhBgPTWrTAEFeB9NZt3C0SbAr/6DdPM4jF7/PyNotUzBU26vgAo8x+7zri3jmgAgnOJdKYrVB9QEb+zcubMrgpVOv/76K9bXGzrACwTJfw1D+9k8EzAXOE8GviEPAK+JIDXSAlhvA7yWTWztvMfiXM65PBNQrgLfUBi2v/vuu70RnPo0ODjYC0BtN3D2VNfLR5gAz04eRn17yb0p4A0RlIEI6y+la/MV1xf4fYACSEtDiP031dbWRrY/AP32229dAGCTrs1XrHHEaesFXh+gXCfooyEM2yIIrdC2ADZ/1D1eM+CagHLJ5ExTxrl9hyLsrDiDWI99EjApgPvLRwhAmQh4HV/Axwe3bt06GMEXnFKpFK4tOBgQcH95WdoEAE01nc8Xi8VEArA3gs4q7VWpfsHaCpEg4GrnoeXhOEKUw3u4yZYqbGo4Lk2KR5hZpcOsXjO9GIm0AYFycTErmoDJVLWu0Tto3bJly0CEmT36/fffkzh/UKfVE3yLkix3Xx+v5FjYaaslgiwUZxDrdbrm38guF6EAFFKAF5kEwcFPrRFcoVCrIdAiKsSlYUWqFi/zBwTXOiKsQqGOIKe1cQRmSAPkmYIv0ADY9Yuif+GYgC5Wv9kB1L6X8lAA8k3BFwhB94YNG1IRXPYJutwpINwBpNjSI/O5AhDQGUxEUIVKCRMBEGiFIQG4yX+Daf+fPacvwihUM2Czfm/KcgMLtjZZhudEY//hks2VVJlZ7tJvi5SMMApVA9gMsOVkXYvDFiO6fggFACUqJ6qKcaMBbD5uAH2AlE0fIKJxRSnUAGizcykePtWzjOo1VA2gpa0V2CVRALBbURDwQV4qiGAKVQDyLZ571JfFum0lFqTJvScvgilUytPxAxSY9boawMbD3OtFEUahaoAinQap0gA4JSzhPswSFz733HOZEVT2KZlMYr0WesGV7KpOoQRqgG6DVi4rx5EqjFWfjSCz3vqLHd9IoGyYnoBjNwpAwhBoWXlpJAChCECpv66p5ycJBCSBcwI7daZ7E83FtAiuUGgaT/WLACaYhk4MBCVk0UDKWb2c3+URVqFogOm8OqccqMW5d+Dmm29OuGsDOyw7gmUvvfRSFBCySFevXsX6LBO1cIoG8NEQ5u7KoFbLi0Kz3fODI7JGeHbwTSJADcxCq1cAWnR39yYIQUWEmVX1X2G6SYTgnhavABwL0uoF91dUV1dnR9AFp/7+fjysq0IGvIEGODYkAOwa7t/XYXl3kDzgBRF8Vgg3eczT2SqGYP97vBoA83ELrd6/WPSJCDsr6v8Jw91BRdfS6za9ewQ1qVo9RQv47plXU1NTHEFoTpcvX8aTwueJgKdoAI4wpE8Y9e4SdtgdGLK4S1gm8L8jGAO1fqy/TNmiUE1hQIwPj9AADOQk7ugRdJ9ADj+2bt26aI6AAV26dAnr7THqnsFEYTgEnBRtFl0fwk6hOcCrIjiNaBXOAKIcuq3hG4w4fTXma+lNOEHEZFs4hcA8+eqrr0a+gAZdvHgRbf+TsrMDDMxBr2v/eT7A0L5+8HN7AKdPFhncHMGqZftfB84Wga0yBwKtsN1hk4B5PsCIrd0C2HwRz924cWNlBK2afvzxx0rX89c5Qo4gCNv85bwDI7r8XUKqynfL/KmHazZt2pQbQSymH374AffuqeEB7gWXCrzHFCCmXf5niE4NWxPkJFAJ41GmtRHMUtWP9TNJdYScgQZYo3NoFEYF21WmgAq8776KzZs3Px1BPZq+//57rJcKXhg3oClo90b/qCeHvqLjA2j6B+u2bNlSFkH+J3333XdlAMo6ntq3cJroK6K4gOzgyP2oBaj2nqIdPGXYKzjw5ptvToqgd5yenh5U+Qcgmy07UdxQA7QD7xfFClSnh68Oelag6H5n+Fj6j9566638iQz++fPn8wGMRq/dV4EviwVwrq0W9QpUJsAdINof5LRQxfNLgBu2bt06IaePffvttzjDp8EZ3r6dDL7sQEkfyAdVW82rjo9H/hdkB2y2ft89eEB149tvvz2hlqh/8803OazlTzMFX6ENcKLvU7LgEMUEuIc9vqLb+inBJE8ezyo+un379gkxaPT111/jdx4FEGbJwOd1A2VdQ9896Pj1qIJDMSJI6yHpNGnpGlHFqVgp77zzzg29tjCRSBQx8KfKWrmJBvDkO4HXU3oI7pQwFUDpc/8s9ABk14uB23bs2HFDTiU7d+7cAqj4NrbESxtojeAQYjWoOnyaqwF4AsFSnDm81lT1y2YZ+cpwLmHDzp07a3bt2nVDTCrt6urKBq5hDl8eBXCTHgGjtWxTaVK8IEYFjKWrvVPIdU8VE2kMgUCsBD6ye/fukvEM/ldffVUCFX4EsitVtl3UYjU0wDHg1dQIodQJFJShKXgE0j5dLaACn6MJkKcDH6+rq6uur68fV72EM2fO5Jw9e7YasseBp5u0cKoQsDxO9Vrqqn6R2hdGAjWEoBvSR03B9wPNA95HGDVcBXxqz549D40H8E+fPo3vecoZntGTreqzmwgBRyDw2Plu3TBxxmuvvcYFUQYwy+OQ5UoV6DITQzEJnGsdbLSyfvHixdfVptSnTp2qZMJaqtsVVtWbAiP0zap498ryt956q5OxYcMGyj/gpbhbxS5IlwSJBQQYYsZVzWtREBYtWnTN9ic+efIkOq1LmM9SZDKplioQgrJ6ZpZTVODd32kBIEoZL0UvvdFdCBoUfGo8gXM0/UHgHTireeHChaFrhePHj+N0dzxqdxnwg2xwS0vD6YIvwAOnd89nvhkZeJduu+02J2Pjxo0UKZO9GM7w+cjdFMIgCmiqAXj39bO5DPFYLNY8b948ayeXtLW1lbIT1mcxzjVZUGtqCjh44Bj/34H7ZXjJhCItAAHAd1Mc0fvcPYAqCPhBhIHDF5jP0MF2QkmwE02HTMjs2bPTpqOlpSXPVeHABSwoVcLsOebzTWZH2fADOClO7ZqB3yfDTWUSUACyiHZG9UJY0SiNH7PKIjsiqt6BooegIhTMOYxHUTweN3q26EAN/wkr3t+qvEaKczbvxzoXPcf7brL/a9oNFKXYPZzpnUpGlX6dbqHIDIRNlIWXsuibbjdQkGLdzoQ0YfJ/uJFAamsndllw19HZzDlxVGFmkcqilFnSEFotnnKNOlZPGQX0lWOdzoa01xR47nCwDtBEpwbHoedj94wy0KSKCOoIQhgaQrXZgkoYdMCXPAvrcr57WITuXEHlcLCu00cQGjza7BEcRjbRAFSNQAXXVAh0zuY1BV/Q2r3pekixnz+oGRomvVtMV9Vr3I/98RXAC73LzoM4grIWb1sIxgp8iSnAOlsIKdZhynB8QG8wiKIBDPyCQ5C9F0cRKY6gDFwZ2DaFIEzwCS3e3b/nXlzKras1dFr/KA2go/5FLVRwfzdzDtfodgupZoFqGohbqIYGPsH+Yx3NxF6V7D2omkXlmMZM1T8PDMXfoUl4BruKkHaaaANbtj2MnoEJ+L6/72RdvGe8Kt9kjqBOj4SsAUyvce7BCSV/Ba6C/EBYXcSg5oIKtqkj5ikbgLSKqfwWaheRWqZ6j1gIAFPuQW2AI3lTIN0b1CSonMSwYgCU6wqQ8NunsOHcQcozVKZIVwhiKjVuMEihY0YwevgPSDG0eUy3ezjWYOsEhRRAHWPf/A93Egc1MKTj+FGEIGZhIEgJiMzPYPlmHNxgjmLTtRSCsOw+o2YWzcNvbTYIBVsVgrQGsAW+6cCSJx9nUcS/QbrfVAjCDgQZ/P1+yOM33Q9pPMizqCaAKgSxsMCntk6B2sdVyYsh/QvwC7hriY4QhCkUGi0e3/kF/AYow29pJ8YArJkAihDEwgRfVyNw8rif7X+B74Y8qs03nOGNDq0IgQ3Afff0sXecAfm72bv3UFoxpdWbtH7V32cFcfgoLcyCEKQdJ9zVHNL/AM9ijOP808MYD/CP7UvuO8ZGP+OMB3nP4T1PNfYvey/KXAPKd2XpevA27iWYANk9g8yZamblOa5A4FQtZ/jEsjybWsBTaX1sQkbcA/iACAQd0E2EQgU8RUiyKC02qGnQjS6qwPP9LQJwiLFLuUwQcBuaIiYQuBjTPc8wk/32VtYJFq104xQnmLlJMPuNNr3fUEuQQtDUVm8DeNcc/F+AAQBKd8HaIWdjwQAAAABJRU5ErkJggg==";
            },
            523: (e)=>{
                e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8xIiBkYXRhLW5hbWU9IkxheWVyIDEiIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NH08L3N0eWxlPjwvZGVmcz48dGl0bGU+YXJyb3dzPC90aXRsZT48cGF0aCBkPSJNMCAwaDQuOTV2MTBIMHoiIHN0eWxlPSJmaWxsOiNmZmYiLz48cGF0aCBkPSJtMS40MSA0LjY3IDEuMDctMS40OSAxLjA2IDEuNDl6TTMuNTQgNS4zMyAyLjQ4IDYuODIgMS40MSA1LjMzeiIgY2xhc3M9ImNscy0yIi8+PC9zdmc+";
            },
            65: (e)=>{
                e.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 id=%27Layer_1%27 data-name=%27Layer 1%27 viewBox=%270 0 4.95 10%27%3E%3Cdefs%3E%3Cstyle%3E.cls-2{fill:%23444}%3C/style%3E%3C/defs%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d=%27M0 0h4.95v10H0z%27 style=%27fill:%23fff%27/%3E%3Cpath d=%27m1.41 4.67 1.07-1.49 1.06 1.49zM3.54 5.33 2.48 6.82 1.41 5.33z%27 class=%27cls-2%27/%3E%3C/svg%3E";
            },
            442: (t)=>{
                t.exports = e;
            }
        }, o = {};
        function n(e) {
            var r = o[e];
            if (void 0 !== r) return r.exports;
            var i = o[e] = {
                id: e,
                exports: {}
            };
            return t[e](i, i.exports, n), i.exports;
        }
        n.m = t, n.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return n.d(t, {
                a: t
            }), t;
        }, n.d = (e, t)=>{
            for(var o in t)n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
                enumerable: !0,
                get: t[o]
            });
        }, n.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), n.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.b = document.baseURI || self.location.href, n.nc = void 0;
        var r = {};
        n.r(r), n.d(r, {
            Jodit: ()=>vz,
            default: ()=>mz
        });
        var i = {};
        n.r(i), n.d(i, {
            ACCURACY: ()=>Gt,
            APP_VERSION: ()=>st,
            BASE_PATH: ()=>yo,
            BASE_PATH_IS_MIN: ()=>_o,
            BR: ()=>Xt,
            CLIPBOARD_ID: ()=>ko,
            COMMAND_KEYS: ()=>Jt,
            EMULATE_DBLCLICK_TIMEOUT: ()=>ao,
            ES: ()=>ct,
            FAT_MODE: ()=>ht,
            HOMEPAGE: ()=>vt,
            INSEPARABLE_TAGS: ()=>Pt,
            INSERT_AS_HTML: ()=>lo,
            INSERT_AS_TEXT: ()=>co,
            INSERT_CLEAR_HTML: ()=>so,
            INSERT_ONLY_TEXT: ()=>uo,
            INVISIBLE_SPACE: ()=>bt,
            INVISIBLE_SPACE_REG_EXP: ()=>_t,
            INVISIBLE_SPACE_REG_EXP_END: ()=>jt,
            INVISIBLE_SPACE_REG_EXP_START: ()=>wt,
            IS_BLOCK: ()=>zt,
            IS_ES_MODERN: ()=>ut,
            IS_ES_NEXT: ()=>dt,
            IS_IE: ()=>to,
            IS_INLINE: ()=>Et,
            IS_MAC: ()=>po,
            IS_PROD: ()=>ft,
            IS_TEST: ()=>pt,
            KEY_ALIASES: ()=>ho,
            KEY_ALT: ()=>Nt,
            KEY_BACKSPACE: ()=>Lt,
            KEY_DELETE: ()=>Ut,
            KEY_DOWN: ()=>Vt,
            KEY_ENTER: ()=>Bt,
            KEY_ESC: ()=>Dt,
            KEY_F3: ()=>Yt,
            KEY_LEFT: ()=>Ht,
            KEY_META: ()=>At,
            KEY_RIGHT: ()=>qt,
            KEY_SPACE: ()=>Wt,
            KEY_TAB: ()=>Mt,
            KEY_UP: ()=>Ft,
            LIST_TAGS: ()=>Tt,
            MARKER_CLASS: ()=>io,
            MODE_SOURCE: ()=>$t,
            MODE_SPLIT: ()=>eo,
            MODE_WYSIWYG: ()=>Qt,
            NBSP_SPACE: ()=>yt,
            NEARBY: ()=>Kt,
            NO_EMPTY_TAGS: ()=>Rt,
            PARAGRAPH: ()=>Zt,
            PASSIVE_EVENTS: ()=>xo,
            SAFE_COUNT_CHANGE_CALL: ()=>fo,
            SET_TEST: ()=>gt,
            SOURCE_CONSUMER: ()=>So,
            SPACE_REG_EXP: ()=>kt,
            SPACE_REG_EXP_END: ()=>xt,
            SPACE_REG_EXP_START: ()=>St,
            TEMP_ATTR: ()=>jo,
            TEXT_HTML: ()=>no,
            TEXT_PLAIN: ()=>oo,
            TEXT_RTF: ()=>ro,
            TOKENS: ()=>mt,
            globalDocument: ()=>Ct,
            globalWindow: ()=>Ot,
            lang: ()=>wo
        });
        var a = {};
        n.r(a), n.d(a, {
            $$: ()=>Qr,
            CamelCaseToKebabCase: ()=>Tn,
            ConfigDeepFlatten: ()=>wr,
            ConfigFlatten: ()=>jr,
            ConfigProto: ()=>_r,
            ConnectionError: ()=>Ar,
            LimitedStack: ()=>si,
            NUMBER_FIELDS_REG: ()=>In,
            OptionsError: ()=>Hr,
            abort: ()=>Cr,
            alignElement: ()=>Nn,
            alreadyLoadedList: ()=>Fn,
            appendScriptAsync: ()=>Vn,
            appendStyleAsync: ()=>Wn,
            applyStyles: ()=>Ai,
            asArray: ()=>Ii,
            assert: ()=>$n,
            attr: ()=>er,
            browser: ()=>tr,
            buildQuery: ()=>or,
            call: ()=>dr,
            callPromise: ()=>pr,
            camelCase: ()=>An,
            cleanFromWord: ()=>Li,
            clearAlign: ()=>Dn,
            clearCenterAlign: ()=>Mn,
            clearTimeout: ()=>xi,
            cns: ()=>Gr,
            colorToHex: ()=>zn,
            completeUrl: ()=>Hn,
            connection: ()=>qr,
            convertMediaUrlToVideoEmbed: ()=>Sr,
            css: ()=>Ln,
            cssPath: ()=>ti,
            ctrlKey: ()=>xr,
            dataBind: ()=>cr,
            defaultLanguage: ()=>Or,
            error: ()=>Fr,
            fastClone: ()=>lr,
            fuzzySearchIndex: ()=>na,
            get: ()=>Do,
            getClassName: ()=>Ur,
            getContentWidth: ()=>Zi,
            getDataTransfer: ()=>mr,
            getScrollParent: ()=>Qi,
            getXPathByElement: ()=>$r,
            hAlignElement: ()=>Bn,
            hasBrowserColorPicker: ()=>qo,
            hasContainer: ()=>$o,
            htmlspecialchars: ()=>Mi,
            humanSizeToBytes: ()=>Yr,
            i18n: ()=>aa,
            inView: ()=>ri,
            innerWidth: ()=>$i,
            isAbort: ()=>zr,
            isAbortError: ()=>Vo,
            isArray: ()=>Ao,
            isAtom: ()=>ir,
            isBoolean: ()=>Wo,
            isDestructable: ()=>Qo,
            isEqual: ()=>Ko,
            isFastEqual: ()=>Go,
            isFunction: ()=>Ro,
            isHTML: ()=>Jo,
            isHtmlFromWord: ()=>Xo,
            isInitable: ()=>Zo,
            isInt: ()=>tn,
            isJoditObject: ()=>nn,
            isLicense: ()=>rn,
            isMarker: ()=>an,
            isNativeFunction: ()=>Po,
            isNumber: ()=>ln,
            isNumeric: ()=>en,
            isPlainObject: ()=>cn,
            isPromise: ()=>un,
            isSet: ()=>dn,
            isString: ()=>Lo,
            isStringArray: ()=>Mo,
            isURL: ()=>fn,
            isValidName: ()=>pn,
            isViewObject: ()=>hn,
            isVoid: ()=>Bo,
            isWindow: ()=>sn,
            kebabCase: ()=>En,
            keepNames: ()=>Wr,
            keys: ()=>vr,
            loadImage: ()=>hr,
            loadNext: ()=>Un,
            loadNextStyle: ()=>Yn,
            markAsAtomic: ()=>ar,
            markDeprecated: ()=>Jr,
            markOwner: ()=>fr,
            memorizeExec: ()=>gr,
            nl2br: ()=>Bi,
            normalizeColor: ()=>Wi,
            normalizeCssNumericValue: ()=>Pn,
            normalizeCssValue: ()=>Rn,
            normalizeKeyAliases: ()=>Ui,
            normalizeLicense: ()=>Yi,
            normalizePath: ()=>Ki,
            normalizeRelativePath: ()=>Gi,
            normalizeSize: ()=>Ji,
            normalizeUrl: ()=>Xi,
            offset: ()=>ta,
            options: ()=>Vr,
            parseQuery: ()=>kr,
            position: ()=>oa,
            previewBox: ()=>ni,
            refs: ()=>ei,
            reset: ()=>Ho,
            resolveElement: ()=>oi,
            safeHTML: ()=>Di,
            sanitizeHTMLElement: ()=>Ni,
            scrollIntoViewIfNeeded: ()=>ii,
            set: ()=>ai,
            setTimeout: ()=>Si,
            size: ()=>ea,
            splitArray: ()=>Pi,
            sprintf: ()=>ia,
            stringify: ()=>Yo,
            stripTags: ()=>Vi,
            toArray: ()=>Fo,
            trim: ()=>vn,
            trimChars: ()=>gn,
            trimInv: ()=>mn,
            ucfirst: ()=>ra
        });
        var l = {};
        n.r(l), n.d(l, {
            autobind: ()=>To,
            cache: ()=>vi,
            cacheHTML: ()=>gi,
            cached: ()=>hi,
            component: ()=>ji,
            debounce: ()=>$a,
            derive: ()=>nl,
            getPropertyDescriptor: ()=>Oa,
            hook: ()=>rl,
            idle: ()=>al,
            nonenumerable: ()=>ll,
            persistent: ()=>sl,
            throttle: ()=>el,
            wait: ()=>ul,
            watch: ()=>Ca
        });
        var s = {};
        n.r(s), n.d(s, {
            required: ()=>ec,
            url: ()=>tc
        });
        var c = {};
        n.r(c), n.d(c, {
            Ajax: ()=>_l,
            Alert: ()=>ff,
            Async: ()=>Ti,
            Button: ()=>Es,
            CommitStyle: ()=>zv,
            Component: ()=>Ua,
            Confirm: ()=>pf,
            ContextMenu: ()=>Sf,
            Create: ()=>Su,
            Dialog: ()=>df,
            Dom: ()=>pi,
            EventEmitter: ()=>ja,
            EventHandlersStore: ()=>ma,
            Eventify: ()=>_n,
            FileBrowser: ()=>Mp,
            Helpers: ()=>a,
            History: ()=>lh,
            Icon: ()=>Ol,
            ImageEditor: ()=>ip,
            LazyWalker: ()=>Cn,
            Plugin: ()=>Wp,
            PluginSystem: ()=>ha,
            Popup: ()=>gu,
            ProgressBar: ()=>wu,
            Prompt: ()=>hf,
            Response: ()=>vl,
            STATUSES: ()=>Io,
            Selection: ()=>Av,
            Snapshot: ()=>Qp,
            StatusBar: ()=>hh,
            Table: ()=>wh,
            ToolbarButton: ()=>jd,
            ToolbarCollection: ()=>sd,
            ToolbarContent: ()=>zd,
            ToolbarEditorCollection: ()=>qd,
            ToolbarSelect: ()=>Ld,
            UIBlock: ()=>$s,
            UIButton: ()=>zs,
            UIButtonGroup: ()=>Ms,
            UIButtonState: ()=>Cs,
            UICheckbox: ()=>Xc,
            UIElement: ()=>Al,
            UIFileInput: ()=>ru,
            UIForm: ()=>Ec,
            UIGroup: ()=>Ul,
            UIInput: ()=>fc,
            UIList: ()=>ys,
            UIMessages: ()=>Wu,
            UISelect: ()=>wc,
            UISeparator: ()=>Zl,
            UISpacer: ()=>ns,
            UITextArea: ()=>Nc,
            UITooltip: ()=>Ks,
            Uploader: ()=>Dh,
            View: ()=>$u,
            ViewComponent: ()=>Qa,
            ViewWithToolbar: ()=>ef,
            defaultNameSpace: ()=>ga,
            observable: ()=>Pa
        });
        var u = {};
        n.r(u), n.d(u, {
            angle_down: ()=>Zv,
            angle_left: ()=>Qv,
            angle_right: ()=>$v,
            angle_up: ()=>eg,
            bin: ()=>tg,
            cancel: ()=>og,
            center: ()=>ng,
            check: ()=>rg,
            chevron: ()=>ig,
            dots: ()=>ag,
            eye: ()=>lg,
            file: ()=>sg,
            folder: ()=>cg,
            info_circle: ()=>ug,
            left: ()=>dg,
            lock: ()=>fg,
            ok: ()=>pg,
            pencil: ()=>hg,
            plus: ()=>vg,
            resize_handler: ()=>gg,
            right: ()=>mg,
            save: ()=>bg,
            settings: ()=>yg,
            unlock: ()=>_g,
            update: ()=>jg,
            upload: ()=>wg,
            valign: ()=>kg
        });
        var d = {};
        n.r(d), n.d(d, {
            removeExtraBr: ()=>Ub
        });
        var f = {};
        n.r(f), n.d(f, {
            checkBlockNesting: ()=>Yb
        });
        var p = {};
        n.r(p), n.d(p, {
            allowAttributes: ()=>Dy,
            fillEmptyParagraph: ()=>Hy,
            removeEmptyTextNode: ()=>Fy,
            removeInvTextNodes: ()=>qy,
            replaceOldTags: ()=>Vy,
            sanitizeAttributes: ()=>Wy,
            tryRemoveNode: ()=>Uy
        });
        var h = {};
        n.r(h), n.d(h, {
            ar: ()=>i_,
            cs_cz: ()=>a_,
            de: ()=>l_,
            es: ()=>s_,
            fa: ()=>c_,
            fi: ()=>u_,
            fr: ()=>d_,
            he: ()=>f_,
            hu: ()=>p_,
            id: ()=>h_,
            it: ()=>v_,
            ja: ()=>g_,
            ko: ()=>m_,
            mn: ()=>b_,
            nl: ()=>y_,
            pl: ()=>__,
            pt_br: ()=>j_,
            ru: ()=>w_,
            tr: ()=>k_,
            zh_cn: ()=>S_,
            zh_tw: ()=>x_
        });
        var v = {};
        n.r(v), n.d(v, {
            default: ()=>yw
        });
        var g = {};
        n.r(g), n.d(g, {
            default: ()=>_w
        });
        var m = {};
        n.r(m), n.d(m, {
            default: ()=>jw
        });
        var b = {};
        n.r(b), n.d(b, {
            default: ()=>ww
        });
        var y = {};
        n.r(y), n.d(y, {
            default: ()=>kw
        });
        var _ = {};
        n.r(_), n.d(_, {
            default: ()=>Sw
        });
        var j = {};
        n.r(j), n.d(j, {
            default: ()=>xw
        });
        var w = {};
        n.r(w), n.d(w, {
            default: ()=>Ow
        });
        var k = {};
        n.r(k), n.d(k, {
            default: ()=>Cw
        });
        var S = {};
        n.r(S), n.d(S, {
            default: ()=>zw
        });
        var x = {};
        n.r(x), n.d(x, {
            default: ()=>Ew
        });
        var O = {};
        n.r(O), n.d(O, {
            default: ()=>Tw
        });
        var C = {};
        n.r(C), n.d(C, {
            default: ()=>Iw
        });
        var z = {};
        n.r(z), n.d(z, {
            default: ()=>Pw
        });
        var E = {};
        n.r(E), n.d(E, {
            default: ()=>Rw
        });
        var T = {};
        n.r(T), n.d(T, {
            default: ()=>Aw
        });
        var I = {};
        n.r(I), n.d(I, {
            default: ()=>Lw
        });
        var P = {};
        n.r(P), n.d(P, {
            default: ()=>Mw
        });
        var R = {};
        n.r(R), n.d(R, {
            default: ()=>Bw
        });
        var A = {};
        n.r(A), n.d(A, {
            default: ()=>Dw
        });
        var L = {};
        n.r(L), n.d(L, {
            default: ()=>Nw
        });
        var M = {};
        n.r(M), n.d(M, {
            default: ()=>Hw
        });
        var B = {};
        n.r(B), n.d(B, {
            ar: ()=>v,
            cs_cz: ()=>g,
            de: ()=>m,
            es: ()=>b,
            fa: ()=>y,
            fi: ()=>_,
            fr: ()=>j,
            he: ()=>w,
            hu: ()=>k,
            id: ()=>S,
            it: ()=>x,
            ja: ()=>O,
            ko: ()=>C,
            mn: ()=>z,
            nl: ()=>E,
            pl: ()=>T,
            pt_br: ()=>I,
            ru: ()=>P,
            tr: ()=>R,
            ua: ()=>A,
            zh_cn: ()=>L,
            zh_tw: ()=>M
        });
        var D = {};
        n.r(D), n.d(D, {
            default: ()=>Ox
        });
        var N = {};
        n.r(N), n.d(N, {
            default: ()=>Cx
        });
        var H = {};
        n.r(H), n.d(H, {
            default: ()=>zx
        });
        var F = {};
        n.r(F), n.d(F, {
            default: ()=>Ex
        });
        var q = {};
        n.r(q), n.d(q, {
            default: ()=>Tx
        });
        var V = {};
        n.r(V), n.d(V, {
            default: ()=>Ix
        });
        var W = {};
        n.r(W), n.d(W, {
            default: ()=>Px
        });
        var U = {};
        n.r(U), n.d(U, {
            default: ()=>Rx
        });
        var Y = {};
        n.r(Y), n.d(Y, {
            default: ()=>Ax
        });
        var K = {};
        n.r(K), n.d(K, {
            default: ()=>Lx
        });
        var G = {};
        n.r(G), n.d(G, {
            default: ()=>Mx
        });
        var J = {};
        n.r(J), n.d(J, {
            default: ()=>Bx
        });
        var X = {};
        n.r(X), n.d(X, {
            default: ()=>Dx
        });
        var Z = {};
        n.r(Z), n.d(Z, {
            default: ()=>Nx
        });
        var Q = {};
        n.r(Q), n.d(Q, {
            default: ()=>Hx
        });
        var $ = {};
        n.r($), n.d($, {
            default: ()=>Fx
        });
        var ee = {};
        n.r(ee), n.d(ee, {
            default: ()=>qx
        });
        var te = {};
        n.r(te), n.d(te, {
            default: ()=>Vx
        });
        var oe = {};
        n.r(oe), n.d(oe, {
            default: ()=>Wx
        });
        var ne = {};
        n.r(ne), n.d(ne, {
            default: ()=>Ux
        });
        var re = {};
        n.r(re), n.d(re, {
            default: ()=>Yx
        });
        var ie = {};
        n.r(ie), n.d(ie, {
            default: ()=>Kx
        });
        var ae = {};
        n.r(ae), n.d(ae, {
            default: ()=>Gx
        });
        var le = {};
        n.r(le), n.d(le, {
            ar: ()=>D,
            cs_cz: ()=>N,
            de: ()=>H,
            es: ()=>F,
            fa: ()=>q,
            fi: ()=>V,
            fr: ()=>W,
            he: ()=>U,
            hu: ()=>Y,
            id: ()=>K,
            it: ()=>G,
            ja: ()=>J,
            ko: ()=>X,
            mn: ()=>Z,
            nl: ()=>Q,
            no: ()=>$,
            pl: ()=>ee,
            pt_br: ()=>te,
            ru: ()=>oe,
            tr: ()=>ne,
            ua: ()=>re,
            zh_cn: ()=>ie,
            zh_tw: ()=>ae
        });
        var se = {};
        n.r(se), n.d(se, {
            default: ()=>fO
        });
        var ce = {};
        n.r(ce), n.d(ce, {
            default: ()=>pO
        });
        var ue = {};
        n.r(ue), n.d(ue, {
            default: ()=>hO
        });
        var de = {};
        n.r(de), n.d(de, {
            default: ()=>vO
        });
        var fe = {};
        n.r(fe), n.d(fe, {
            default: ()=>gO
        });
        var pe = {};
        n.r(pe), n.d(pe, {
            default: ()=>mO
        });
        var he = {};
        n.r(he), n.d(he, {
            default: ()=>bO
        });
        var ve = {};
        n.r(ve), n.d(ve, {
            default: ()=>yO
        });
        var ge = {};
        n.r(ge), n.d(ge, {
            default: ()=>_O
        });
        var me = {};
        n.r(me), n.d(me, {
            default: ()=>jO
        });
        var be = {};
        n.r(be), n.d(be, {
            default: ()=>wO
        });
        var ye = {};
        n.r(ye), n.d(ye, {
            default: ()=>kO
        });
        var _e = {};
        n.r(_e), n.d(_e, {
            default: ()=>SO
        });
        var je = {};
        n.r(je), n.d(je, {
            default: ()=>xO
        });
        var we = {};
        n.r(we), n.d(we, {
            default: ()=>OO
        });
        var ke = {};
        n.r(ke), n.d(ke, {
            default: ()=>CO
        });
        var Se = {};
        n.r(Se), n.d(Se, {
            default: ()=>zO
        });
        var xe = {};
        n.r(xe), n.d(xe, {
            default: ()=>EO
        });
        var Oe = {};
        n.r(Oe), n.d(Oe, {
            default: ()=>TO
        });
        var Ce = {};
        n.r(Ce), n.d(Ce, {
            default: ()=>IO
        });
        var ze = {};
        n.r(ze), n.d(ze, {
            default: ()=>PO
        });
        var Ee = {};
        n.r(Ee), n.d(Ee, {
            default: ()=>RO
        });
        var Te = {};
        n.r(Te), n.d(Te, {
            ar: ()=>se,
            cs_cz: ()=>ce,
            de: ()=>ue,
            es: ()=>de,
            fa: ()=>fe,
            fi: ()=>pe,
            fr: ()=>he,
            he: ()=>ve,
            hu: ()=>ge,
            id: ()=>me,
            it: ()=>be,
            ja: ()=>ye,
            ko: ()=>_e,
            mn: ()=>je,
            nl: ()=>we,
            pl: ()=>ke,
            pt_br: ()=>Se,
            ru: ()=>xe,
            tr: ()=>Oe,
            ua: ()=>Ce,
            zh_cn: ()=>ze,
            zh_tw: ()=>Ee
        });
        var Ie = {};
        n.r(Ie), n.d(Ie, {
            default: ()=>GO
        });
        var Pe = {};
        n.r(Pe), n.d(Pe, {
            default: ()=>JO
        });
        var Re = {};
        n.r(Re), n.d(Re, {
            en: ()=>Ie,
            es: ()=>Pe
        });
        var Ae = {};
        n.r(Ae), n.d(Ae, {
            default: ()=>BC
        });
        var Le = {};
        n.r(Le), n.d(Le, {
            default: ()=>DC
        });
        var Me = {};
        n.r(Me), n.d(Me, {
            default: ()=>NC
        });
        var Be = {};
        n.r(Be), n.d(Be, {
            default: ()=>HC
        });
        var De = {};
        n.r(De), n.d(De, {
            default: ()=>FC
        });
        var Ne = {};
        n.r(Ne), n.d(Ne, {
            default: ()=>qC
        });
        var He = {};
        n.r(He), n.d(He, {
            default: ()=>VC
        });
        var Fe = {};
        n.r(Fe), n.d(Fe, {
            default: ()=>WC
        });
        var qe = {};
        n.r(qe), n.d(qe, {
            default: ()=>UC
        });
        var Ve = {};
        n.r(Ve), n.d(Ve, {
            default: ()=>YC
        });
        var We = {};
        n.r(We), n.d(We, {
            default: ()=>KC
        });
        var Ue = {};
        n.r(Ue), n.d(Ue, {
            default: ()=>GC
        });
        var Ye = {};
        n.r(Ye), n.d(Ye, {
            default: ()=>JC
        });
        var Ke = {};
        n.r(Ke), n.d(Ke, {
            default: ()=>XC
        });
        var Ge = {};
        n.r(Ge), n.d(Ge, {
            default: ()=>ZC
        });
        var Je = {};
        n.r(Je), n.d(Je, {
            default: ()=>QC
        });
        var Xe = {};
        n.r(Xe), n.d(Xe, {
            default: ()=>$C
        });
        var Ze = {};
        n.r(Ze), n.d(Ze, {
            default: ()=>ez
        });
        var Qe = {};
        n.r(Qe), n.d(Qe, {
            default: ()=>tz
        });
        var $e = {};
        n.r($e), n.d($e, {
            default: ()=>oz
        });
        var et = {};
        n.r(et), n.d(et, {
            default: ()=>nz
        });
        var tt = {};
        n.r(tt), n.d(tt, {
            default: ()=>rz
        });
        var ot = {};
        n.r(ot), n.d(ot, {
            default: ()=>iz
        });
        var nt = {};
        n.r(nt), n.d(nt, {
            ar: ()=>Ae,
            cs_cz: ()=>Le,
            de: ()=>Me,
            es: ()=>Be,
            fa: ()=>De,
            fi: ()=>Ne,
            fr: ()=>He,
            he: ()=>Fe,
            hu: ()=>qe,
            id: ()=>Ve,
            it: ()=>We,
            ja: ()=>Ue,
            ko: ()=>Ye,
            mn: ()=>Ke,
            nl: ()=>Ge,
            no: ()=>Je,
            pl: ()=>Xe,
            pt_br: ()=>Ze,
            ru: ()=>Qe,
            tr: ()=>$e,
            ua: ()=>et,
            zh_cn: ()=>tt,
            zh_tw: ()=>ot
        });
        var rt = n(442), it = n.n(rt);
        function at(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        var lt, st = "4.6.2", ct = "es2020", ut = !0, dt = !0, ft = !0, pt = !1, ht = !0, vt = "https://xdsoft.net/jodit/", gt = function() {
            return pt = !0;
        }, mt = {}, bt = "\ufeff", yt = "\xa0", _t = function() {
            return /[\uFEFF]/g;
        }, jt = function() {
            return /[\uFEFF]+$/g;
        }, wt = function() {
            return /^[\uFEFF]+/g;
        }, kt = function() {
            return /[\s\n\t\r\uFEFF\u200b]+/g;
        }, St = function() {
            return /^[\s\n\t\r\uFEFF\u200b]+/g;
        }, xt = function() {
            return /[\s\n\t\r\uFEFF\u200b]+$/g;
        }, Ot = "undefined" != typeof window ? window : void 0, Ct = "undefined" != typeof document ? document : void 0, zt = /^(ADDRESS|ARTICLE|ASIDE|BLOCKQUOTE|CANVAS|DD|DFN|DIV|DL|DT|FIELDSET|FIGCAPTION|FIGURE|FOOTER|FORM|H[1-6]|HEADER|HGROUP|HR|LI|MAIN|NAV|NOSCRIPT|OUTPUT|P|PRE|RUBY|SCRIPT|STYLE|OBJECT|OL|SECTION|IFRAME|JODIT|JODIT-MEDIA|UL|TR|TD|TH|TBODY|THEAD|TFOOT|TABLE|BODY|HTML|VIDEO)$/i, Et = /^(STRONG|SPAN|I|EM|B|SUP|SUB|A|U)$/i, Tt = new Set([
            "ul",
            "ol"
        ]), It = [
            "img",
            "video",
            "svg",
            "iframe",
            "script",
            "input",
            "textarea",
            "link",
            "jodit",
            "jodit-media"
        ], Pt = new Set((lt = It, function(e) {
            if (Array.isArray(e)) return at(e);
        }(lt) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(lt) || function(e, t) {
            if (e) {
                if ("string" == typeof e) return at(e, t);
                var o = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? at(e, t) : void 0;
            }
        }(lt) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }()).concat([
            "br",
            "hr"
        ])), Rt = new Set(It), At = "Meta", Lt = "Backspace", Mt = "Tab", Bt = "Enter", Dt = "Escape", Nt = "Alt", Ht = "ArrowLeft", Ft = "ArrowUp", qt = "ArrowRight", Vt = "ArrowDown", Wt = "Space", Ut = "Delete", Yt = "F3", Kt = 5, Gt = 10, Jt = [
            At,
            Lt,
            Ut,
            Ft,
            Vt,
            qt,
            Ht,
            Bt,
            Dt,
            Yt,
            Mt
        ], Xt = "br", Zt = "p", Qt = 1, $t = 2, eo = 3, to = "undefined" != typeof navigator && (-1 !== navigator.userAgent.indexOf("MSIE") || /rv:11.0/i.test(navigator.userAgent)), oo = to ? "text" : "text/plain", no = to ? "html" : "text/html", ro = to ? "rtf" : "text/rtf", io = "jodit-selection_marker", ao = 300, lo = "insert_as_html", so = "insert_clear_html", co = "insert_as_text", uo = "insert_only_text", fo = 10, po = void 0 !== Ot && /Mac|iPod|iPhone|iPad/.test(Ot.navigator.platform), ho = {
            add: "+",
            break: "pause",
            cmd: "meta",
            command: "meta",
            ctl: "control",
            ctrl: "control",
            del: "delete",
            down: "arrowdown",
            esc: "escape",
            ins: "insert",
            left: "arrowleft",
            mod: po ? "meta" : "control",
            opt: "alt",
            option: "alt",
            return: "enter",
            right: "arrowright",
            space: "space",
            spacebar: "space",
            up: "arrowup",
            win: "meta",
            windows: "meta"
        }, vo = function(e) {
            var t = e.split("/"), o = !1;
            return /\.js/.test(t[t.length - 1]) ? {
                basePath: t.slice(0, t.length - 1).join("/") + "/",
                isMin: o
            } : {
                basePath: e,
                isMin: o
            };
        }, go = function() {
            if ("undefined" == typeof document) return {
                basePath: "",
                isMin: Boolean(!1)
            };
            var e = Ct.currentScript;
            if (e) return vo(e.src);
            var t = Ct.querySelectorAll("script[src]");
            return t && t.length ? vo(t[t.length - 1].src) : vo(Ot.location.href);
        }(), mo = go.basePath, bo = go.isMin, yo = mo, _o = bo, jo = "data-jodit-temp", wo = {}, ko = "clipboard", So = "source-consumer", xo = new Set([
            "touchstart",
            "touchend",
            "scroll",
            "mousewheel",
            "mousemove",
            "touchmove"
        ]);
        function Oo(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Co(e) {
            return Co = "function" == typeof Symbol && "symbol" === Oo(Symbol.iterator) ? function(e) {
                return void 0 === e ? "undefined" : Oo(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : void 0 === e ? "undefined" : Oo(e);
            }, Co(e);
        }
        function zo(e, t, o) {
            var n = o.value;
            if ("function" != typeof n) throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(Co(n)));
            var r = !1;
            return {
                configurable: !0,
                get: function() {
                    if (r || this === e.prototype || this.hasOwnProperty(t) || "function" != typeof n) return n;
                    var o = n.bind(this);
                    return r = !0, Object.defineProperty(this, t, {
                        configurable: !0,
                        get: function() {
                            return o;
                        },
                        set: function(e) {
                            n = e, delete this[t];
                        }
                    }), r = !1, o;
                },
                set: function(e) {
                    n = e;
                }
            };
        }
        function Eo(e) {
            var t;
            return "undefined" != typeof Reflect && "function" == typeof Reflect.ownKeys ? t = Reflect.ownKeys(e.prototype) : (t = Object.getOwnPropertyNames(e.prototype), "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(e.prototype)))), t.forEach(function(t) {
                if ("constructor" !== t) {
                    var o = Object.getOwnPropertyDescriptor(e.prototype, t);
                    "function" == typeof o.value && Object.defineProperty(e.prototype, t, zo(e, t, o));
                }
            }), e;
        }
        function To() {
            return 1 === arguments.length ? Eo.apply(void 0, arguments) : zo.apply(void 0, arguments);
        }
        var Io = {
            beforeInit: "beforeInit",
            ready: "ready",
            beforeDestruct: "beforeDestruct",
            destructed: "destructed"
        };
        function Po(e) {
            var t;
            return Boolean(e) && "function" === (void 0 === e ? "undefined" : (t = e, t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t)).toLowerCase() && (e === Function.prototype || /^\s*function\s*(\b[a-z$_][a-z0-9$_]*\b)*\s*\((|([a-z$_][a-z0-9$_]*)(\s*,[a-z$_][a-z0-9$_]*)*)\)\s*{\s*\[native code]\s*}\s*$/i.test(String(e)));
        }
        function Ro(e) {
            return "function" == typeof e;
        }
        function Ao(e) {
            return Array.isArray(e);
        }
        function Lo(e) {
            return "string" == typeof e;
        }
        function Mo(e) {
            return Ao(e) && Lo(e[0]);
        }
        function Bo(e) {
            return null == e;
        }
        function Do(e, t) {
            if (!Lo(e) || !e.length) return null;
            var o = e.split("."), n = t;
            try {
                var r = !0, i = !1, a = void 0;
                try {
                    for(var l, s = o[Symbol.iterator](); !(r = (l = s.next()).done); r = !0){
                        var c = l.value;
                        if (Bo(n[c])) return null;
                        n = n[c];
                    }
                } catch (e) {
                    i = !0, a = e;
                } finally{
                    try {
                        r || null == s.return || s.return();
                    } finally{
                        if (i) throw a;
                    }
                }
            } catch (e) {
                return null;
            }
            return Bo(n) ? null : n;
        }
        var No = {};
        function Ho(e) {
            var t, o;
            if (!(e in No)) {
                var n = Ct.createElement("iframe");
                try {
                    if (n.src = "about:blank", Ct.body.appendChild(n), !n.contentWindow) return null;
                    var r = Do(e, n.contentWindow), i = Do(e.split(".").slice(0, -1).join("."), n.contentWindow);
                    Ro(r) && (No[e] = r.bind(i));
                } catch (e) {
                    if (!ft) throw e;
                } finally{
                    null === (t = n.parentNode) || void 0 === t || t.removeChild(n);
                }
            }
            return null !== (o = No[e]) && void 0 !== o ? o : null;
        }
        var Fo = function() {
            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
            var n;
            return (Po(Array.from) ? Array.from : null !== (n = Ho("Array.from")) && void 0 !== n ? n : Array.from).apply(Array, t);
        };
        function qo() {
            var e = !0;
            try {
                var t = Ct.createElement("input");
                t.type = "color", t.value = "!", e = "color" === t.type && "!" !== t.value;
            } catch (t) {
                e = !1;
            }
            return e;
        }
        function Vo(e) {
            var t, o;
            return Boolean(e) && (t = e, null != (o = DOMException) && "undefined" != typeof Symbol && o[Symbol.hasInstance] ? !!o[Symbol.hasInstance](t) : t instanceof o) && "AbortError" === e.name;
        }
        function Wo(e) {
            return "boolean" == typeof e;
        }
        function Uo(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Yo(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if ("object" !== (void 0 === e ? "undefined" : Uo(e))) return String(e);
            var o = new Set(t.excludeKeys), n = new WeakMap;
            return JSON.stringify(e, function(e, t) {
                if (!o.has(e)) {
                    if ("object" === (void 0 === t ? "undefined" : Uo(t)) && null != t) {
                        if (n.get(t)) return "[refObject]";
                        n.set(t, !0);
                    }
                    return t;
                }
            }, t.prettify);
        }
        function Ko(e, t) {
            return e === t || Yo(e) === Yo(t);
        }
        function Go(e, t) {
            return e === t;
        }
        var Jo = function(e) {
            return Lo(e) && /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/m.test(e.replace(/[\r\n]/g, ""));
        };
        function Xo(e) {
            return -1 !== e.search(/<meta.*?Microsoft Excel\s[\d].*?>/) || -1 !== e.search(/<meta.*?Microsoft Word\s[\d].*?>/) || -1 !== e.search(/style="[^"]*mso-/) && -1 !== e.search(/<font/);
        }
        function Zo(e) {
            return !Bo(e) && Ro(e.init);
        }
        function Qo(e) {
            return !Bo(e) && Ro(e.destruct);
        }
        function $o(e) {
            return !Bo(e) && pi.isElement(e.container);
        }
        function en(e) {
            if (Lo(e)) {
                if (!e.match(/^([+-])?[0-9]+(\.?)([0-9]+)?(e[0-9]+)?$/)) return !1;
                e = parseFloat(e);
            }
            return "number" == typeof e && !isNaN(e) && isFinite(e);
        }
        function tn(e) {
            return Lo(e) && en(e) && (e = parseFloat(e)), "number" == typeof e && Number.isFinite(e) && !(e % 1);
        }
        function on(e, t) {
            return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t;
        }
        function nn(e) {
            return Boolean(e && on(e, Object) && Ro(e.constructor) && ("undefined" != typeof Jodit && on(e, Jodit) || e.isJodit));
        }
        var rn = function(e) {
            return Lo(e) && 23 === e.length && /^[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}$/i.test(e);
        };
        function an(e) {
            return pi.isNode(e) && pi.isTag(e, "span") && e.hasAttribute("data-" + io);
        }
        function ln(e) {
            return "number" == typeof e && !isNaN(e) && isFinite(e);
        }
        function sn(e) {
            return null != e && e === e.window;
        }
        function cn(e) {
            return !(!e || "object" !== (void 0 === e ? "undefined" : function(e) {
                return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
            }(e)) || e.nodeType || sn(e) || e.constructor && !({}).hasOwnProperty.call(e.constructor.prototype, "isPrototypeOf"));
        }
        function un(e) {
            return e && "function" == typeof e.then;
        }
        function dn(e) {
            return Boolean(e) && Ro(e.has) && Ro(e.add) && Ro(e.delete);
        }
        function fn(e) {
            if (e.includes(" ")) return !1;
            if ("undefined" != typeof URL) try {
                var t = new URL(e);
                return [
                    "https:",
                    "http:",
                    "ftp:",
                    "file:",
                    "rtmp:"
                ].includes(t.protocol);
            } catch (e) {
                return !1;
            }
            var o = Ct.createElement("a");
            return o.href = e, Boolean(o.hostname);
        }
        function pn(e) {
            return !!e.length && !/[^0-9A-Za-zа-яА-ЯЁё\w\-_. ]/.test(e) && e.trim().length > 0;
        }
        function hn(e) {
            var t, o;
            return Boolean(e && (t = e, null != (o = Object) && "undefined" != typeof Symbol && o[Symbol.hasInstance] ? !!o[Symbol.hasInstance](t) : t instanceof o) && Ro(e.constructor) && e.isView);
        }
        function vn(e) {
            return e.replace(xt(), "").replace(St(), "");
        }
        function gn(e, t) {
            return e.replace(RegExp("[".concat(t, "]+$")), "").replace(RegExp("^[".concat(t, "]+")), "");
        }
        function mn(e) {
            return e.replace(jt(), "").replace(wt(), "");
        }
        function bn(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function yn(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var _n = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.__map = new Map;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "on",
                    value: function(e, t) {
                        var o;
                        return this.__map.has(e) || this.__map.set(e, new Set), null === (o = this.__map.get(e)) || void 0 === o || o.add(t), this;
                    }
                },
                {
                    key: "off",
                    value: function(e, t) {
                        var o;
                        return this.__map.has(e) && (null === (o = this.__map.get(e)) || void 0 === o || o.delete(t)), this;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.__map.clear();
                    }
                },
                {
                    key: "emit",
                    value: function(e) {
                        for(var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)o[n - 1] = arguments[n];
                        var r, i;
                        return this.__map.has(e) && (null === (r = this.__map.get(e)) || void 0 === r || r.forEach(function(e) {
                            i = e.apply(void 0, function(e) {
                                return function(e) {
                                    if (Array.isArray(e)) return bn(e);
                                }(e) || function(e) {
                                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                                }(e) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return bn(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? bn(e, t) : void 0;
                                    }
                                }(e) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(o));
                        })), i;
                    }
                }
            ], o && yn(t.prototype, o), e;
        }();
        function jn(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function wn(e, t, o) {
            return wn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = kn(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, wn(e, t, o || e);
        }
        function kn(e) {
            return kn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, kn(e);
        }
        function Sn(e, t) {
            return Sn = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Sn(e, t);
        }
        function xn(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function On() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (On = function() {
                return !!e;
            })();
        }
        var Cn = function(e) {
            function t(e) {
                var o, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = kn(t), function(e, t) {
                        return !t || "object" !== xn(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, On() ? Reflect.construct(t, o || [], kn(e).constructor) : t.apply(e, o));
                }(this, t)).async = e, o.options = n, o.workNodes = null, o.hadAffect = !1, o.isWorked = !1, o.isFinished = !1, o.idleId = 0, o.__schedulerController = null, o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Sn(e, t);
            }(t, e), o = t, n = [
                {
                    key: "setWork",
                    value: function(e) {
                        return this.isWorked && this.break(), this.workNodes = pi.eachGen(e, !this.options.reverse), this.isFinished = !1, this._requestStarting(), this;
                    }
                },
                {
                    key: "_requestStarting",
                    value: function() {
                        this.__schedulerController = new AbortController, this.async.schedulerPostTask(this.__workPerform, {
                            delay: this.options.timeout,
                            signal: this.__schedulerController.signal
                        }).catch(function() {
                            return null;
                        });
                    }
                },
                {
                    key: "break",
                    value: function(e) {
                        this.isWorked && (this.stop(), this.emit("break", e));
                    }
                },
                {
                    key: "end",
                    value: function() {
                        this.isWorked && (this.stop(), this.emit("end", this.hadAffect), this.hadAffect = !1);
                    }
                },
                {
                    key: "stop",
                    value: function() {
                        this.isWorked = !1, this.isFinished = !0, this.workNodes = null, this.async.cancelIdleCallback(this.idleId);
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        wn(kn(t.prototype), "destruct", this).call(this), this.stop();
                    }
                },
                {
                    key: "__workPerform",
                    value: function() {
                        var e;
                        if (this.workNodes) {
                            this.isWorked = !0;
                            for(var t = 0, o = null !== (e = this.options.timeoutChunkSize) && void 0 !== e ? e : 50; !this.isFinished && t <= o;){
                                var n = this.workNodes.next();
                                if (t += 1, this.visitNode(n.value) && (this.hadAffect = !0), n.done) return void this.end();
                            }
                        } else this.end();
                        this.isFinished || this._requestStarting();
                    }
                },
                {
                    key: "visitNode",
                    value: function(e) {
                        var t;
                        return !(!e || void 0 !== this.options.whatToShow && e.nodeType !== this.options.whatToShow) && null !== (t = this.emit("visit", e)) && void 0 !== t && t;
                    }
                }
            ], jn(o.prototype, n), t;
        }(_n);
        !function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : xn(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        }([
            To
        ], Cn.prototype, "__workPerform", null);
        var zn = function(e) {
            if ("rgba(0, 0, 0, 0)" === e || "" === e) return !1;
            if (!e) return "#000000";
            if ("#" === e.substr(0, 1)) return e;
            var t = /([\s\n\t\r]*?)rgb\((\d+), (\d+), (\d+)\)/.exec(e) || /([\s\n\t\r]*?)rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/.exec(e);
            if (!t) return "#000000";
            for(var o = parseInt(t[2], 10), n = parseInt(t[3], 10), r = (parseInt(t[4], 10) | n << 8 | o << 16).toString(16).toUpperCase(); r.length < 6;)r = "0" + r;
            return t[1] + "#" + r;
        }, En = function(e) {
            return e.replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
        }, Tn = function(e) {
            return e.replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }, In = /^(left|top|bottom|right|width|min|max|height|margin|padding|fontsize|font-size)/i;
        function Pn(e, t) {
            return !Bo(t) && In.test(e) && en(t.toString()) ? parseInt(t.toString(), 10) + "px" : t;
        }
        function Rn(e, t) {
            if ("font-weight" === En(e)) {
                switch(t.toString().toLowerCase()){
                    case "700":
                    case "bold":
                        return 700;
                    case "400":
                    case "normal":
                        return 400;
                    case "900":
                    case "heavy":
                        return 900;
                }
                return en(t) ? Number(t) : t;
            }
            return /color/i.test(e) && /^rgb/i.test(t.toString()) && zn(t.toString()) || t;
        }
        var An = function(e) {
            return e.replace(/([-_])(.)/g, function(e, t, o) {
                return o.toUpperCase();
            });
        };
        function Ln(e, t, o) {
            var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            if (Wo(o) && (n = o, o = void 0), cn(t) || void 0 !== o) {
                var r = function(e, t, o) {
                    void 0 === (o = Pn(t, o)) || null != o && Ln(e, t, !0) === Rn(t, o) || (e.style[t] = o);
                };
                if (cn(t)) for(var i = Object.keys(t), a = 0; a < i.length; a += 1)r(e, An(i[a]), t[i[a]]);
                else r(e, An(t), o);
                return "";
            }
            var l = En(t), s = e.ownerDocument || document, c = !!s && (s.defaultView || s.parentWindow), u = e.style[t], d = "";
            return void 0 !== u && "" !== u ? d = u : c && !n && (d = c.getComputedStyle(e).getPropertyValue(l)), In.test(t) && /^[-+]?[0-9.]+px$/.test(d.toString()) && (d = parseInt(d.toString(), 10)), Rn(t, d);
        }
        var Mn = function(e) {
            "block" === Ln(e, "display") && Ln(e, "display", "");
            var t = e.style;
            "auto" === t.marginLeft && "auto" === t.marginRight && (t.marginLeft = "", t.marginRight = "");
        };
        function Bn(e, t) {
            t && "normal" !== t ? "center" !== t ? (Ln(e, "float", t), Mn(e)) : Ln(e, {
                float: "",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
            }) : (Ln(e, "float") && -1 !== [
                "right",
                "left"
            ].indexOf(Ln(e, "float").toString().toLowerCase()) && Ln(e, "float", ""), Mn(e));
        }
        function Dn(e) {
            pi.each(e, function(e) {
                pi.isHTMLElement(e) && e.style.textAlign && (e.style.textAlign = "", e.style.cssText.trim().length || e.removeAttribute("style"));
            });
        }
        function Nn(e, t) {
            if (pi.isNode(t) && pi.isElement(t)) switch(Dn(t), e.toLowerCase()){
                case "justifyfull":
                    t.style.textAlign = "justify";
                    break;
                case "justifyright":
                    t.style.textAlign = "right";
                    break;
                case "justifyleft":
                    t.style.textAlign = "left";
                    break;
                case "justifycenter":
                    t.style.textAlign = "center";
            }
        }
        var Hn = function(e) {
            return "file:" === Ot.location.protocol && /^\/\//.test(e) && (e = "https:" + e), e;
        }, Fn = new Map, qn = function(e) {
            return function(t, o) {
                if (Fn.has(o)) return Fn.get(o);
                var n = e(t, o);
                return Fn.set(o, n), n;
            };
        }, Vn = qn(function(e, t) {
            return e.async.promise(function(o, n) {
                if (e.isInDestruct) return n();
                var r = e.c.element("script", {
                    type: "text/javascript",
                    crossorigin: "anonymous",
                    referrerpolicy: "no-referrer",
                    async: !0,
                    src: Hn(t)
                });
                e.e.one(r, "error", n).one(r, "load", o), e.od.body.appendChild(r);
            });
        }), Wn = qn(function(e, t) {
            return e.async.promise(function(o, n) {
                if (e.isInDestruct) return n();
                var r = e.c.element("link");
                r.rel = "stylesheet", r.media = "all", r.crossOrigin = "anonymous", !e.isInDestruct && e.e.on(r, "load", function() {
                    return o(r);
                }).on(r, "error", n), r.href = Hn(t), e.o.shadowRoot ? e.o.shadowRoot.appendChild(r) : e.od.body.appendChild(r);
            });
        });
        function Un(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
            return Lo(t[o]) ? Vn(e, t[o]).then(function() {
                return Un(e, t, o + 1);
            }) : Promise.resolve();
        }
        function Yn(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
            return Lo(t[o]) ? Wn(e, t[o]).then(function() {
                return Yn(e, t, o + 1);
            }) : Promise.resolve();
        }
        function Kn(e, t, o) {
            return Kn = Zn() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Jn(r, o.prototype), r;
            }, Kn.apply(null, arguments);
        }
        function Gn(e) {
            return Gn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Gn(e);
        }
        function Jn(e, t) {
            return Jn = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Jn(e, t);
        }
        function Xn(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Xn = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Kn(e, arguments, Gn(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Jn(n, e);
            }, Xn(e);
        }
        function Zn() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Zn = function() {
                return !!e;
            })();
        }
        var Qn = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Gn(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Zn() ? Reflect.construct(t, o || [], Gn(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).name = "AssertionError", o;
            }
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Jn(e, t);
            }(t, e), t;
        }(Xn(Error));
        function $n(e, t) {
            if (!e) throw new Qn("Assertion failed: ".concat(t));
        }
        function er(e, t, o) {
            if (!e || !Ro(e.getAttribute)) return null;
            if (!Lo(t)) return Object.keys(t).forEach(function(o) {
                var n = t[o];
                cn(n) && "style" === o ? Ln(e, n) : ("className" === o && (o = "class"), er(e, o, n));
            }), null;
            var n = Tn(t);
            if (/^-/.test(n)) {
                var r = er(e, "data".concat(n));
                if (r) return r;
                n = n.substr(1);
            }
            if (void 0 !== o) {
                if (null != o) {
                    var i = o.toString();
                    return "IMG" !== e.nodeName || "width" !== n && "height" !== n || (i = i.replace("px", "")), e.setAttribute(n, i), i;
                }
                e.hasAttribute(n) && e.removeAttribute(n);
            }
            return e.getAttribute(n);
        }
        var tr = function(e) {
            var t = navigator.userAgent.toLowerCase(), o = /(firefox)[\s/]([\w.]+)/.exec(t) || /(chrome)[\s/]([\w.]+)/.exec(t) || /(webkit)[\s/]([\w.]+)/.exec(t) || /(opera)(?:.*version)[\s/]([\w.]+)/.exec(t) || /(msie)[\s]([\w.]+)/.exec(t) || /(trident)\/([\w.]+)/.exec(t) || t.indexOf("compatible") < 0 || [];
            return "version" === e ? o[2] : "webkit" === e ? "chrome" === o[1] || "webkit" === o[1] : "ff" === e ? "firefox" === o[1] : "msie" === e ? "trident" === o[1] || "msie" === o[1] : o[1] === e;
        }, or = function(e, t) {
            var o = [], n = encodeURIComponent;
            for(var r in e)if (Object.prototype.hasOwnProperty.call(e, r)) {
                var i = t ? t + "[" + r + "]" : r, a = e[r];
                o.push(cn(a) ? or(a, i) : n(i) + "=" + n(a));
            }
            return o.join("&");
        };
        function nr(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var rr = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.cache = !0, this.defaultTimeout = 100, this.namespace = "", this.safeMode = !1, this.width = "auto", this.height = "auto", this.safePluginsList = [
                    "about",
                    "enter",
                    "backspace",
                    "size",
                    "bold",
                    "hotkeys"
                ], this.license = "", this.preset = "custom", this.presets = {
                    inline: {
                        inline: !0,
                        toolbar: !1,
                        toolbarInline: !0,
                        toolbarInlineForSelection: !0,
                        showXPathInStatusbar: !1,
                        showCharsCounter: !1,
                        showWordsCounter: !1,
                        showPlaceholder: !1
                    }
                }, this.ownerDocument = Ct, this.ownerWindow = Ot, this.shadowRoot = null, this.zIndex = 0, this.readonly = !1, this.disabled = !1, this.activeButtonsInReadOnly = [
                    "source",
                    "fullsize",
                    "print",
                    "about",
                    "dots",
                    "selectall"
                ], this.allowCommandsInReadOnly = [
                    "selectall",
                    "preview",
                    "print"
                ], this.toolbarButtonSize = "middle", this.allowTabNavigation = !1, this.inline = !1, this.theme = "default", this.saveModeInStorage = !1, this.editorClassName = !1, this.className = !1, this.style = !1, this.containerStyle = !1, this.styleValues = {}, this.triggerChangeEvent = !0, this.direction = "", this.language = "auto", this.debugLanguage = !1, this.i18n = !1, this.tabIndex = -1, this.toolbar = !0, this.statusbar = !0, this.showTooltip = !0, this.showTooltipDelay = 200, this.useNativeTooltip = !1, this.defaultActionOnPaste = lo, this.enter = Zt, this.iframe = !1, this.editHTMLDocumentMode = !1, this.enterBlock = "br" !== this.enter ? this.enter : Zt, this.defaultMode = Qt, this.useSplitMode = !1, this.colors = {
                    greyscale: [
                        "#000000",
                        "#434343",
                        "#666666",
                        "#999999",
                        "#B7B7B7",
                        "#CCCCCC",
                        "#D9D9D9",
                        "#EFEFEF",
                        "#F3F3F3",
                        "#FFFFFF"
                    ],
                    palette: [
                        "#980000",
                        "#FF0000",
                        "#FF9900",
                        "#FFFF00",
                        "#00F0F0",
                        "#00FFFF",
                        "#4A86E8",
                        "#0000FF",
                        "#9900FF",
                        "#FF00FF"
                    ],
                    full: [
                        "#E6B8AF",
                        "#F4CCCC",
                        "#FCE5CD",
                        "#FFF2CC",
                        "#D9EAD3",
                        "#D0E0E3",
                        "#C9DAF8",
                        "#CFE2F3",
                        "#D9D2E9",
                        "#EAD1DC",
                        "#DD7E6B",
                        "#EA9999",
                        "#F9CB9C",
                        "#FFE599",
                        "#B6D7A8",
                        "#A2C4C9",
                        "#A4C2F4",
                        "#9FC5E8",
                        "#B4A7D6",
                        "#D5A6BD",
                        "#CC4125",
                        "#E06666",
                        "#F6B26B",
                        "#FFD966",
                        "#93C47D",
                        "#76A5AF",
                        "#6D9EEB",
                        "#6FA8DC",
                        "#8E7CC3",
                        "#C27BA0",
                        "#A61C00",
                        "#CC0000",
                        "#E69138",
                        "#F1C232",
                        "#6AA84F",
                        "#45818E",
                        "#3C78D8",
                        "#3D85C6",
                        "#674EA7",
                        "#A64D79",
                        "#85200C",
                        "#990000",
                        "#B45F06",
                        "#BF9000",
                        "#38761D",
                        "#134F5C",
                        "#1155CC",
                        "#0B5394",
                        "#351C75",
                        "#733554",
                        "#5B0F00",
                        "#660000",
                        "#783F04",
                        "#7F6000",
                        "#274E13",
                        "#0C343D",
                        "#1C4587",
                        "#073763",
                        "#20124D",
                        "#4C1130"
                    ]
                }, this.colorPickerDefaultTab = "background", this.imageDefaultWidth = 300, this.removeButtons = [], this.disablePlugins = [], this.extraPlugins = [], this.extraButtons = [], this.extraIcons = {}, this.createAttributes = {
                    table: {
                        style: "border-collapse:collapse;width: 100%;"
                    }
                }, this.sizeLG = 900, this.sizeMD = 700, this.sizeSM = 400, this.buttons = [
                    {
                        group: "font-style",
                        buttons: []
                    },
                    {
                        group: "list",
                        buttons: []
                    },
                    {
                        group: "font",
                        buttons: []
                    },
                    "---",
                    {
                        group: "script",
                        buttons: []
                    },
                    {
                        group: "media",
                        buttons: []
                    },
                    "\n",
                    {
                        group: "state",
                        buttons: []
                    },
                    {
                        group: "clipboard",
                        buttons: []
                    },
                    {
                        group: "insert",
                        buttons: []
                    },
                    {
                        group: "indent",
                        buttons: []
                    },
                    {
                        group: "color",
                        buttons: []
                    },
                    {
                        group: "form",
                        buttons: []
                    },
                    "---",
                    {
                        group: "history",
                        buttons: []
                    },
                    {
                        group: "search",
                        buttons: []
                    },
                    {
                        group: "source",
                        buttons: []
                    },
                    {
                        group: "other",
                        buttons: []
                    },
                    {
                        group: "info",
                        buttons: []
                    }
                ], this.events = {}, this.textIcons = !1, this.popupRoot = null, this.showBrowserColorPicker = !0;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "defaultOptions",
                    get: function() {
                        return e.__defaultOptions || (e.__defaultOptions = new e), e.__defaultOptions;
                    }
                }
            ], o && nr(t, o), e;
        }();
        function ir(e) {
            return e && e.isAtom;
        }
        function ar(e) {
            return Object.defineProperty(e, "isAtom", {
                enumerable: !1,
                value: !0,
                configurable: !1
            }), e;
        }
        function lr(e) {
            return JSON.parse(Yo(e));
        }
        rr.prototype.controls = {};
        var sr = new WeakMap, cr = function(e, t, o) {
            var n = sr.get(e);
            if (!n) {
                n = {}, sr.set(e, n);
                var r = null;
                hn(e.j) && (r = e.j.e), hn(e) && (r = e.e), r && r.on("beforeDestruct", function() {
                    sr.delete(e);
                });
            }
            return void 0 === o ? n[t] : (n[t] = o, o);
        };
        function ur(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function dr(e) {
            for(var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)o[n - 1] = arguments[n];
            return e.apply(void 0, function(e) {
                return function(e) {
                    if (Array.isArray(e)) return ur(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return ur(e, t);
                        var o = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? ur(e, t) : void 0;
                    }
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }(o));
        }
        function fr(e, t) {
            er(t, "data-editor_id", e.id), !t.component && Object.defineProperty(t, "jodit", {
                value: e
            });
        }
        function pr(e, t) {
            return un(e) ? e.then(function(e) {
                return e;
            }, function() {
                return null;
            }).finally(t) : null == t ? void 0 : t();
        }
        var hr = function(e, t) {
            return t.async.promise(function(o, n) {
                var r = new Image, i = function() {
                    t.e.off(r), null == n || n();
                }, a = function() {
                    t.e.off(r), o(r);
                };
                t.e.one(r, "load", a).one(r, "error", i).one(r, "abort", i), r.src = e, r.complete && a();
            });
        }, vr = function(e) {
            if (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) return Object.keys(e);
            var t = [];
            for(var o in e)t.push(o);
            return t;
        }, gr = function(e, t, o, n) {
            var r, i = o.control, a = "button".concat(i.command), l = null !== (r = i.args && i.args[0]) && void 0 !== r ? r : cr(e, a);
            if (Bo(l)) return !1;
            cr(e, a, l), n && (l = n(l)), e.execCommand(i.command, !1, null != l ? l : void 0);
        }, mr = function(e) {
            if (e.clipboardData) return e.clipboardData;
            try {
                return e.dataTransfer || new DataTransfer;
            } catch (e) {
                return null;
            }
        };
        function br(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function yr(e) {
            return function(e) {
                if (Array.isArray(e)) return br(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return br(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? br(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function _r(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
            if (Object.getPrototypeOf(e) !== Object.prototype) return e;
            var n = rr.defaultOptions;
            if (Lo(e.preset)) {
                if (void 0 !== n.presets[e.preset]) {
                    var r = n.presets[e.preset];
                    Object.keys(r).forEach(function(t) {
                        Bo(e[t]) && (e[t] = r[t]);
                    });
                }
                delete e.preset;
            }
            var i = {};
            return Object.keys(e).forEach(function(n) {
                var r = e[n], a = t ? t[n] : null;
                cn(r) && cn(a) && !ir(r) ? i[n] = _r(r, a, o + 1) : 0 !== o && Ao(r) && !ir(r) && Ao(a) ? i[n] = yr(r).concat(yr(a.slice(r.length))) : i[n] = r;
            }), Object.setPrototypeOf(i, t), i;
        }
        function jr(e) {
            return vr(e, !1).reduce(function(t, o) {
                return t[o] = e[o], t;
            }, {});
        }
        function wr(e) {
            return vr(e, !1).reduce(function(t, o) {
                return t[o] = cn(e[o]) ? wr(e[o]) : e[o], t;
            }, {});
        }
        var kr = function(e) {
            for(var t = {}, o = e.substring(1).split("&"), n = 0; n < o.length; n += 1){
                var r = o[n].split("=");
                t[decodeURIComponent(r[0])] = decodeURIComponent(r[1] || "");
            }
            return t;
        }, Sr = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = t.width, n = void 0 === o ? 400 : o, r = t.height, i = void 0 === r ? 345 : r;
            if (!fn(e)) return e;
            var a = Ct.createElement("a"), l = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
            a.href = e, n || (n = 400), i || (i = 345);
            var s = a.protocol || "";
            switch(a.hostname){
                case "www.vimeo.com":
                case "vimeo.com":
                    return l.test(e) ? e.replace(l, '<iframe width="' + n + '" height="' + i + '" src="' + s + '//player.vimeo.com/video/$1" frameborder="0" allowfullscreen></iframe>') : e;
                case "youtube.com":
                case "www.youtube.com":
                case "youtu.be":
                case "www.youtu.be":
                    var c = a.search ? kr(a.search) : {
                        v: a.pathname.substring(1)
                    };
                    return /^embed\/.*/.test(c.v) && (c.v = c.v.substring(6)), c.v ? '<iframe width="' + n + '" height="' + i + '" src="' + s + "//www.youtube.com/embed/" + c.v + '" frameborder="0" allowfullscreen></iframe>' : e;
            }
            return e;
        }, xr = function(e) {
            if ("undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Mac OS X")) {
                if (e.metaKey && !e.altKey) return !0;
            } else if (e.ctrlKey && !e.altKey) return !0;
            return !1;
        }, Or = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "en";
            return "auto" !== e && Lo(e) ? e : Ct.documentElement && Ct.documentElement.lang ? Ct.documentElement.lang : navigator.language ? navigator.language.substring(0, 2) : t;
        };
        function Cr() {
            return new DOMException(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Aborted", "AbortError");
        }
        var zr = Vo;
        function Er(e, t, o) {
            return Er = Rr() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Ir(r, o.prototype), r;
            }, Er.apply(null, arguments);
        }
        function Tr(e) {
            return Tr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Tr(e);
        }
        function Ir(e, t) {
            return Ir = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Ir(e, t);
        }
        function Pr(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Pr = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Er(e, arguments, Tr(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Ir(n, e);
            }, Pr(e);
        }
        function Rr() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Rr = function() {
                return !!e;
            })();
        }
        var Ar = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), o = function(e, t, o) {
                    return t = Tr(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Rr() ? Reflect.construct(t, o || [], Tr(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ]), Object.setPrototypeOf(o, t.prototype), o;
            }
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ir(e, t);
            }(t, e), t;
        }(Pr(Error));
        function Lr(e, t, o) {
            return Lr = Nr() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Br(r, o.prototype), r;
            }, Lr.apply(null, arguments);
        }
        function Mr(e) {
            return Mr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Mr(e);
        }
        function Br(e, t) {
            return Br = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Br(e, t);
        }
        function Dr(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Dr = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Lr(e, arguments, Mr(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Br(n, e);
            }, Dr(e);
        }
        function Nr() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Nr = function() {
                return !!e;
            })();
        }
        var Hr = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), o = function(e, t, o) {
                    return t = Mr(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Nr() ? Reflect.construct(t, o || [], Mr(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ]), Object.setPrototypeOf(o, t.prototype), o;
            }
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Br(e, t);
            }(t, e), t;
        }(Dr(TypeError));
        function Fr(e) {
            return new TypeError(e);
        }
        function qr(e) {
            return new Ar(e);
        }
        function Vr(e) {
            return new Hr(e);
        }
        var Wr = new Map, Ur = function(e) {
            var t;
            if (Ro(e.className)) return e.className();
            var o = (null === (t = e.constructor) || void 0 === t ? void 0 : t.originalConstructor) || e.constructor;
            if (Wr.has(o)) return Wr.get(o);
            if (o.name) return o.name;
            var n = new RegExp(/^\s*function\s*(\S*)\s*\(/), r = o.toString().match(n);
            return r ? r[1] : "";
        }, Yr = function(e) {
            if (/^[0-9.]+$/.test(e.toString())) return parseFloat(e);
            var t = e.substr(-2, 2).toUpperCase(), o = [
                "KB",
                "MB",
                "GB",
                "TB"
            ], n = parseFloat(e.substr(0, e.length - 2));
            return -1 !== o.indexOf(t) ? n * Math.pow(1024, o.indexOf(t) + 1) : parseInt(e, 10);
        };
        function Kr(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        var Gr = console;
        function Jr(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [
                ""
            ], o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            return function() {
                for(var n = arguments.length, r = new Array(n), i = 0; i < n; i++)r[i] = arguments[i];
                var a;
                return Gr.warn('Method "'.concat(t[0], '" deprecated.') + (t[1] ? ' Use "'.concat(t[1], '" instead') : "")), (a = e).call.apply(a, [
                    o
                ].concat(function(e) {
                    return function(e) {
                        if (Array.isArray(e)) return Kr(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return Kr(e, t);
                            var o = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Kr(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(r)));
            };
        }
        var Xr = 1, Zr = function() {
            return ++Xr;
        };
        function Qr(e, t) {
            var o;
            if (dt || !/:scope/.test(e) || !to || t && t.nodeType === Node.DOCUMENT_NODE) o = t.querySelectorAll(e);
            else {
                var n = t.id, r = n || "_selector_id_" + String(Math.random()).slice(2) + Zr();
                e = e.replace(/:scope/g, "#" + r), !n && t.setAttribute("id", r), o = t.parentNode.querySelectorAll(e), n || t.removeAttribute("id");
            }
            return [].slice.call(o);
        }
        var $r = function(e, t) {
            if (!e || e.nodeType !== Node.ELEMENT_NODE) return "";
            if (!e.parentNode || t === e) return "";
            if (e.id) return "//*[@id='" + e.id + "']";
            var o = [].filter.call(e.parentNode.childNodes, function(t) {
                return t.nodeName === e.nodeName;
            });
            return $r(e.parentNode, t) + "/" + e.nodeName.toLowerCase() + (o.length > 1 ? "[" + (Fo(o).indexOf(e) + 1) + "]" : "");
        }, ei = function(e) {
            return "container" in e && (e = e.container), Qr("[ref],[data-ref]", e).reduce(function(e, t) {
                var o = er(t, "-ref");
                return o && Lo(o) && (e[An(o)] = t, e[o] = t), e;
            }, {});
        }, ti = function(e) {
            if (!pi.isElement(e)) return null;
            for(var t = [], o = e; o && o.nodeType === Node.ELEMENT_NODE;){
                var n = o.nodeName.toLowerCase();
                if (o.id) {
                    n += "#" + o.id, t.unshift(n);
                    break;
                }
                var r = o, i = 1;
                do (r = r.previousElementSibling) && r.nodeName.toLowerCase() === n && i++;
                while (r);
                n += ":nth-of-type(" + i + ")", t.unshift(n), o = o.parentNode;
            }
            return t.join(" > ");
        };
        function oi(e, t) {
            var o, n = e;
            if (Lo(e)) try {
                n = t.querySelector(e);
            } catch (t) {
                throw Fr('String "' + e + '" should be valid HTML selector');
            }
            if (!n || "object" != (void 0 === n ? "undefined" : (o = n) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) || !pi.isElement(n) || !n.cloneNode) throw Fr('Element "' + e + '" should be string or HTMLElement instance');
            return n;
        }
        function ni(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "px", n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, r = [], i = function(e, t) {
                var o = [];
                try {
                    Qr("img", e.editor).forEach(function(n) {
                        var r = [
                            er(n, "width"),
                            er(n, "height"),
                            n.src
                        ];
                        er(n, {
                            width: n.offsetWidth + t,
                            height: n.offsetHeight + t
                        });
                        var i = e.createInside.a();
                        e.ed.body.appendChild(i), i.href = n.src, n.src = i.href, pi.safeRemove(i), o.push(function() {
                            var e;
                            n.src = null !== (e = r[2]) && void 0 !== e ? e : "", er(n, {
                                width: r[0] || null,
                                height: r[1] || null
                            });
                        });
                    });
                } catch (e) {
                    throw o.forEach(function(e) {
                        return e();
                    }), o.length = 0, e;
                }
                return o;
            }(e, o);
            try {
                var a = e.e.fire("beforePreviewBox", t, o);
                if (null != a) return a;
                var l = e.c.div("jodit__preview-box jodit-context");
                n && n.appendChild(l), Ln(l, {
                    position: "relative",
                    padding: 16
                });
                var s = e.value || "<div style='position: absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);color:#ccc;'>".concat(e.i18n("Empty"), "</div>");
                if (e.iframe) {
                    var c = e.create.element("iframe");
                    Ln(c, {
                        minWidth: 800,
                        minHeight: 600,
                        border: 0
                    }), l.appendChild(c);
                    var u = c.contentWindow;
                    if (u && (e.e.fire("generateDocumentStructure.iframe", u.document, e), l = u.document.body, "function" == typeof ResizeObserver)) {
                        var d = !1, f = u.document.body, p = new ResizeObserver(e.async.debounce(function() {
                            p.unobserve(f), c.style.height = "".concat(f.offsetHeight + 20, "px"), e.async.requestAnimationFrame(function() {
                                !d && p.observe(f);
                            });
                        }, 100)), h = function() {
                            d = !0, p.unobserve(f), p.disconnect(), e.e.off("beforeDestruct", h);
                        };
                        r.push(h), e.e.on("beforeDestruct", h);
                    }
                } else Ln(l, {
                    minWidth: 1024,
                    minHeight: 600,
                    border: 0
                });
                var v = function(t, o) {
                    var n = Lo(o) ? e.c.div() : o;
                    Lo(o) && (n.innerHTML = o);
                    for(var r = 0; r < n.childNodes.length; r += 1){
                        var i = n.childNodes[r];
                        if (pi.isElement(i)) {
                            for(var a = t.ownerDocument.createElement(i.nodeName), l = 0; l < i.attributes.length; l += 1)er(a, i.attributes[l].nodeName, i.attributes[l].nodeValue);
                            0 === i.childNodes.length || pi.isTag(i, "table") ? "SCRIPT" === i.nodeName ? i.textContent && (a.textContent = i.textContent) : i.innerHTML && (a.innerHTML = i.innerHTML) : v(a, i);
                            try {
                                t.appendChild(a);
                            } catch (e) {}
                        } else try {
                            t.appendChild(i.cloneNode(!0));
                        } catch (e) {}
                    }
                };
                return v(l, s), e.e.fire("afterPreviewBox", l), [
                    l,
                    function() {
                        r.forEach(function(e) {
                            return e();
                        });
                    }
                ];
            } finally{
                i.forEach(function(e) {
                    return e();
                });
            }
        }
        function ri(e, t, o) {
            for(var n = e.getBoundingClientRect(), r = e, i = n.top, a = n.height; r && r !== t && r.parentNode;){
                if (!(i <= (n = (r = r.parentNode).getBoundingClientRect()).bottom)) return !1;
                if (i + a <= n.top) return !1;
            }
            return i <= (o.documentElement && o.documentElement.clientHeight || 0);
        }
        function ii(e, t, o) {
            pi.isHTMLElement(e) && !ri(e, t, o) && (t.clientHeight !== t.scrollHeight && (t.scrollTop = e.offsetTop), ri(e, t, o) || e.scrollIntoView());
        }
        function ai(e, t, o) {
            if (Lo(e) && e.length) {
                for(var n = e.split("."), r = o, i = n[0], a = 0; a < n.length - 1; a += 1)Ao(r[i = n[a]]) || cn(r[i]) || (r[i] = en(n[a + 1]) ? [] : {}), r = r[i];
                r && (r[n[n.length - 1]] = t);
            }
        }
        function li(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var si = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.limit = t, this.stack = [];
            }
            var t, o;
            return t = e, o = [
                {
                    key: "push",
                    value: function(e) {
                        return this.stack.push(e), this.stack.length > this.limit && this.stack.shift(), this;
                    }
                },
                {
                    key: "pop",
                    value: function() {
                        return this.stack.pop();
                    }
                },
                {
                    key: "find",
                    value: function(e) {
                        return this.stack.find(e);
                    }
                }
            ], li(t.prototype, o), e;
        }();
        function ci(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function ui(e, t) {
            return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t;
        }
        function di(e, t) {
            var o, n, r, i, a = {
                label: 0,
                sent: function() {
                    if (1 & r[0]) throw r[1];
                    return r[1];
                },
                trys: [],
                ops: []
            };
            return i = {
                next: l(0),
                throw: l(1),
                return: l(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                return this;
            }), i;
            function l(i) {
                return function(l) {
                    return function(i) {
                        if (o) throw new TypeError("Generator is already executing.");
                        for(; a;)try {
                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                            switch(n = 0, r && (i = [
                                2 & i[0],
                                r.value
                            ]), i[0]){
                                case 0:
                                case 1:
                                    r = i;
                                    break;
                                case 4:
                                    return a.label++, {
                                        value: i[1],
                                        done: !1
                                    };
                                case 5:
                                    a.label++, n = i[1], i = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    i = a.ops.pop(), a.trys.pop();
                                    continue;
                                default:
                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                        a = 0;
                                        continue;
                                    }
                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                        a.label = i[1];
                                        break;
                                    }
                                    if (6 === i[0] && a.label < r[1]) {
                                        a.label = r[1], r = i;
                                        break;
                                    }
                                    if (r && a.label < r[2]) {
                                        a.label = r[2], a.ops.push(i);
                                        break;
                                    }
                                    r[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                            }
                            i = t.call(e, a);
                        } catch (e) {
                            i = [
                                6,
                                e
                            ], n = 0;
                        } finally{
                            o = r = 0;
                        }
                        if (5 & i[0]) throw i[1];
                        return {
                            value: i[0] ? i[1] : void 0,
                            done: !0
                        };
                    }([
                        i,
                        l
                    ]);
                };
            }
        }
        function fi(e) {
            var t = "function" == typeof Symbol && Symbol.iterator, o = t && e[t], n = 0;
            if (o) return o.call(e);
            if (e && "number" == typeof e.length) return {
                next: function() {
                    return e && n >= e.length && (e = void 0), {
                        value: e && e[n++],
                        done: !e
                    };
                }
            };
            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        var pi = function() {
            function e() {
                throw function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), new Error("Dom is static module");
            }
            var t, o;
            return t = e, o = [
                {
                    key: "detach",
                    value: function(e) {
                        for(; e && e.firstChild;)e.removeChild(e.firstChild);
                    }
                },
                {
                    key: "wrapNextInline",
                    value: function(t, o, n) {
                        var r, i = t, a = t;
                        n.s.save();
                        var l = !1;
                        do l = !1, !(r = a.nextSibling) || e.isBlock(r) || e.isTag(r, "br") || (l = !0, a = r);
                        while (l);
                        return e.__wrapElements(o, n, i, a);
                    }
                },
                {
                    key: "__wrapElements",
                    value: function(e, t, o, n) {
                        var r = Lo(e) ? t.createInside.element(e) : e;
                        o.parentNode && o.parentNode.insertBefore(r, o);
                        for(var i = o; i && (i = o.nextSibling, r.appendChild(o), o !== n && i);)o = i;
                        return t.s.restore(), r;
                    }
                },
                {
                    key: "wrapInline",
                    value: function(t, o, n) {
                        var r, i = t, a = t;
                        n.s.save();
                        var l = !1;
                        do l = !1, (r = i.previousSibling) && !e.isBlock(r) && (l = !0, i = r);
                        while (l);
                        do l = !1, (r = a.nextSibling) && !e.isBlock(r) && (l = !0, a = r);
                        while (l);
                        return e.__wrapElements(o, n, i, a);
                    }
                },
                {
                    key: "wrap",
                    value: function(t, o, n) {
                        var r = Lo(o) ? n.element(o) : o;
                        if (e.isNode(t)) {
                            if (!t.parentNode) throw Fr("Element should be in DOM");
                            t.parentNode.insertBefore(r, t), r.appendChild(t);
                        } else {
                            var i = t.extractContents();
                            t.insertNode(r), r.appendChild(i);
                        }
                        return r;
                    }
                },
                {
                    key: "unwrap",
                    value: function(t) {
                        var o = t.parentNode;
                        if (o) {
                            for(; t.firstChild;)o.insertBefore(t.firstChild, t);
                            e.safeRemove(t);
                        }
                    }
                },
                {
                    key: "between",
                    value: function(e, t, o) {
                        for(var n = e; n && n !== t && (e === n || !o(n));){
                            var r = n.firstChild || n.nextSibling;
                            if (!r) {
                                for(; n && !n.nextSibling;)n = n.parentNode;
                                r = null == n ? void 0 : n.nextSibling;
                            }
                            n = r;
                        }
                    }
                },
                {
                    key: "replace",
                    value: function(t, o, n) {
                        var r, i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                        if (Jo(o) && ($n(n, "Need create instance for new tag"), o = n.fromHTML(o)), Lo(o) ? ($n(n, "Need create instance for new tag"), r = n.element(o)) : r = o, !a) for(; t.firstChild;)r.appendChild(t.firstChild);
                        return i && e.isElement(t) && e.isElement(r) && Fo(t.attributes).forEach(function(e) {
                            r.setAttribute(e.name, e.value);
                        }), t.parentNode && t.parentNode.replaceChild(r, t), r;
                    }
                },
                {
                    key: "isEmptyTextNode",
                    value: function(t) {
                        return e.isText(t) && (!t.nodeValue || 0 === t.nodeValue.replace(_t(), "").trim().length);
                    }
                },
                {
                    key: "isEmptyContent",
                    value: function(t) {
                        return e.each(t, function(t) {
                            return e.isEmptyTextNode(t);
                        });
                    }
                },
                {
                    key: "isContentEditable",
                    value: function(t, o) {
                        return e.isNode(t) && !e.closest(t, function(t) {
                            return e.isElement(t) && "false" === t.getAttribute("contenteditable");
                        }, o);
                    }
                },
                {
                    key: "isEmpty",
                    value: function(t) {
                        var o, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Rt;
                        if (!t) return !0;
                        o = Ro(n) ? n : function(e) {
                            return n.has(e.nodeName.toLowerCase());
                        };
                        var r = function(e) {
                            return null == e.nodeValue || 0 === vn(e.nodeValue).length;
                        };
                        return e.isText(t) ? r(t) : !(e.isElement(t) && o(t)) && e.each(t, function(t) {
                            if (e.isText(t) && !r(t) || e.isElement(t) && o(t)) return !1;
                        });
                    }
                },
                {
                    key: "isNode",
                    value: function(e) {
                        return Boolean(e && Lo(e.nodeName) && "number" == typeof e.nodeType && e.childNodes && Ro(e.appendChild));
                    }
                },
                {
                    key: "isCell",
                    value: function(t) {
                        return e.isNode(t) && ("TD" === t.nodeName || "TH" === t.nodeName);
                    }
                },
                {
                    key: "isList",
                    value: function(t) {
                        return e.isTag(t, Tt);
                    }
                },
                {
                    key: "isLeaf",
                    value: function(t) {
                        return e.isTag(t, "li");
                    }
                },
                {
                    key: "isImage",
                    value: function(t) {
                        return e.isNode(t) && /^(img|svg|picture|canvas)$/i.test(t.nodeName);
                    }
                },
                {
                    key: "isBlock",
                    value: function(t) {
                        var o;
                        return !Bo(t) && "object" == (void 0 === t ? "undefined" : (o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && e.isNode(t) && zt.test(t.nodeName);
                    }
                },
                {
                    key: "isText",
                    value: function(e) {
                        return Boolean(e && e.nodeType === Node.TEXT_NODE);
                    }
                },
                {
                    key: "isComment",
                    value: function(e) {
                        return Boolean(e && e.nodeType === Node.COMMENT_NODE);
                    }
                },
                {
                    key: "isElement",
                    value: function(t) {
                        var o;
                        if (!e.isNode(t)) return !1;
                        var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                        return Boolean(n && t.nodeType === Node.ELEMENT_NODE);
                    }
                },
                {
                    key: "isFragment",
                    value: function(t) {
                        var o;
                        if (!e.isNode(t)) return !1;
                        var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                        return Boolean(n && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE);
                    }
                },
                {
                    key: "isHTMLElement",
                    value: function(t) {
                        var o;
                        if (!e.isNode(t)) return !1;
                        var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                        return Boolean(n && ui(t, n.HTMLElement));
                    }
                },
                {
                    key: "isInlineBlock",
                    value: function(t) {
                        return e.isElement(t) && !/^(BR|HR)$/i.test(t.tagName) && -1 !== [
                            "inline",
                            "inline-block"
                        ].indexOf(Ln(t, "display").toString());
                    }
                },
                {
                    key: "canSplitBlock",
                    value: function(t) {
                        return !Bo(t) && e.isHTMLElement(t) && e.isBlock(t) && !/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName) && void 0 !== t.style && !/^(fixed|absolute)/i.test(t.style.position);
                    }
                },
                {
                    key: "last",
                    value: function(e, t) {
                        var o = null == e ? void 0 : e.lastChild;
                        if (!o) return null;
                        do {
                            if (t(o)) return o;
                            var n = o.lastChild;
                            if (n || (n = o.previousSibling), !n && o.parentNode !== e) {
                                do o = o.parentNode;
                                while (o && !(null == o ? void 0 : o.previousSibling) && o.parentNode !== e);
                                n = null == o ? void 0 : o.previousSibling;
                            }
                            o = n;
                        }while (o);
                        return null;
                    }
                },
                {
                    key: "prev",
                    value: function(t, o, n) {
                        var r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        return e.find(t, o, n, !1, r);
                    }
                },
                {
                    key: "next",
                    value: function(t, o, n) {
                        var r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        return e.find(t, o, n, !0, r);
                    }
                },
                {
                    key: "prevWithClass",
                    value: function(t, o) {
                        return e.prev(t, function(t) {
                            return e.isElement(t) && t.classList.contains(o);
                        }, t.parentNode);
                    }
                },
                {
                    key: "nextWithClass",
                    value: function(t, o) {
                        return e.next(t, function(t) {
                            return e.isElement(t) && t.classList.contains(o);
                        }, t.parentNode);
                    }
                },
                {
                    key: "find",
                    value: function(e, t, o) {
                        for(var n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], i = this.nextGen(e, o, n, r), a = i.next(); !a.done;){
                            if (t(a.value)) return a.value;
                            a = i.next();
                        }
                        return null;
                    }
                },
                {
                    key: "nextGen",
                    value: function(e, t) {
                        var o, n, r, i, a, l = arguments;
                        return di(this, function(s) {
                            switch(s.label){
                                case 0:
                                    o = !(l.length > 2 && void 0 !== l[2]) || l[2], n = !(l.length > 3 && void 0 !== l[3]) || l[3], r = [], i = e, s.label = 1;
                                case 1:
                                    for(a = o ? i.nextSibling : i.previousSibling; a;)r.unshift(a), a = o ? a.nextSibling : a.previousSibling;
                                    return [
                                        5,
                                        fi(this.runInStack(e, r, o, n))
                                    ];
                                case 2:
                                    s.sent(), i = i.parentNode, s.label = 3;
                                case 3:
                                    if (i && i !== t) return [
                                        3,
                                        1
                                    ];
                                    s.label = 4;
                                case 4:
                                    return [
                                        2,
                                        null
                                    ];
                            }
                        });
                    }
                },
                {
                    key: "each",
                    value: function(e, t) {
                        for(var o = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], n = this.eachGen(e, o), r = n.next(); !r.done;){
                            if (!1 === t(r.value)) return !1;
                            r = n.next();
                        }
                        return !0;
                    }
                },
                {
                    key: "eachGen",
                    value: function(e) {
                        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        return this.runInStack(e, [
                            e
                        ], t);
                    }
                },
                {
                    key: "runInStack",
                    value: function(e, t, o) {
                        var n, r, i, a = arguments;
                        return di(this, function(l) {
                            switch(l.label){
                                case 0:
                                    n = !(a.length > 3 && void 0 !== a[3]) || a[3], l.label = 1;
                                case 1:
                                    if (!t.length) return [
                                        3,
                                        4
                                    ];
                                    if (r = t.pop(), n) for(i = o ? r.lastChild : r.firstChild; i;)t.push(i), i = o ? i.previousSibling : i.nextSibling;
                                    return e === r ? [
                                        3,
                                        3
                                    ] : [
                                        4,
                                        r
                                    ];
                                case 2:
                                    l.sent(), l.label = 3;
                                case 3:
                                    return [
                                        3,
                                        1
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }
                },
                {
                    key: "findWithCurrent",
                    value: function(t, o, n) {
                        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "nextSibling", i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "firstChild", a = t;
                        do {
                            if (o(a)) return a || null;
                            if (i && a && a[i]) {
                                var l = e.findWithCurrent(a[i], o, a, r, i);
                                if (l) return l;
                            }
                            for(; a && !a[r] && a !== n;)a = a.parentNode;
                            a && a[r] && a !== n && (a = a[r]);
                        }while (a && a !== n);
                        return null;
                    }
                },
                {
                    key: "findSibling",
                    value: function(t) {
                        for(var o = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(t) {
                            return !e.isEmptyTextNode(t);
                        }, r = e.sibling(t, o); r && !n(r);)r = e.sibling(r, o);
                        return r && n(r) ? r : null;
                    }
                },
                {
                    key: "findNotEmptySibling",
                    value: function(t, o) {
                        return e.findSibling(t, o, function(t) {
                            var o;
                            return !e.isEmptyTextNode(t) && Boolean(!e.isText(t) || (null === (o = t.nodeValue) || void 0 === o ? void 0 : o.length) && vn(t.nodeValue));
                        });
                    }
                },
                {
                    key: "findNotEmptyNeighbor",
                    value: function(t, o, n) {
                        return dr(o ? e.prev : e.next, t, function(t) {
                            return Boolean(t && (!(e.isText(t) || e.isComment(t)) || vn((null == t ? void 0 : t.nodeValue) || "").length));
                        }, n);
                    }
                },
                {
                    key: "sibling",
                    value: function(e, t) {
                        return t ? e.previousSibling : e.nextSibling;
                    }
                },
                {
                    key: "up",
                    value: function(e, t, o) {
                        var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], r = e;
                        if (!r) return null;
                        do {
                            if (t(r)) return r;
                            if (r === o || !r.parentNode) break;
                            r = r.parentNode;
                        }while (r && r !== o);
                        return r === o && n && t(r) ? r : null;
                    }
                },
                {
                    key: "closest",
                    value: function(t, o, n) {
                        var r, i = function(e) {
                            return e.toLowerCase();
                        };
                        if (Ro(o)) r = o;
                        else if (Ao(o) || dn(o)) {
                            var a = dn(o) ? o : new Set(o.map(i));
                            r = function(e) {
                                return Boolean(e && a.has(i(e.nodeName)));
                            };
                        } else r = function(e) {
                            return Boolean(e && i(o) === i(e.nodeName));
                        };
                        return e.up(t, r, n);
                    }
                },
                {
                    key: "furthest",
                    value: function(e, t, o) {
                        for(var n = null, r = null == e ? void 0 : e.parentElement; r && r !== o;)t(r) && (n = r), r = null == r ? void 0 : r.parentElement;
                        return n;
                    }
                },
                {
                    key: "appendChildFirst",
                    value: function(e, t) {
                        var o = e.firstChild;
                        o ? o !== t && e.insertBefore(t, o) : e.appendChild(t);
                    }
                },
                {
                    key: "after",
                    value: function(e, t) {
                        var o = e.parentNode;
                        o && (o.lastChild === e ? o.appendChild(t) : o.insertBefore(t, e.nextSibling));
                    }
                },
                {
                    key: "before",
                    value: function(e, t) {
                        var o = e.parentNode;
                        o && o.insertBefore(t, e);
                    }
                },
                {
                    key: "prepend",
                    value: function(e, t) {
                        e.insertBefore(t, e.firstChild);
                    }
                },
                {
                    key: "append",
                    value: function(e, t) {
                        var o = this;
                        Ao(t) ? t.forEach(function(t) {
                            o.append(e, t);
                        }) : e.appendChild(t);
                    }
                },
                {
                    key: "moveContent",
                    value: function(t, o) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function() {
                            return !0;
                        }, i = (t.ownerDocument || Ct).createDocumentFragment();
                        Fo(t.childNodes).filter(function(t) {
                            return !!r(t) || (e.safeRemove(t), !1);
                        }).forEach(function(e) {
                            i.appendChild(e);
                        }), n && o.firstChild ? o.insertBefore(i, o.firstChild) : o.appendChild(i);
                    }
                },
                {
                    key: "isOrContains",
                    value: function(e, t) {
                        return e === t ? !(arguments.length > 2 && void 0 !== arguments[2] && arguments[2]) : Boolean(t && e && this.up(t, function(t) {
                            return t === e;
                        }, e, !0));
                    }
                },
                {
                    key: "safeRemove",
                    value: function() {
                        for(var t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                        o.forEach(function(t) {
                            return e.isNode(t) && t.parentNode && t.parentNode.removeChild(t);
                        });
                    }
                },
                {
                    key: "safeInsertNode",
                    value: function(t, o) {
                        t.collapsed || t.deleteContents();
                        var n = e.isFragment(o) ? o.lastChild : o;
                        t.startContainer === t.endContainer && t.collapsed && e.isTag(t.startContainer, Pt) ? e.after(t.startContainer, o) : (t.insertNode(o), n && t.setStartBefore(n)), t.collapse(!0), [
                            o.nextSibling,
                            o.previousSibling
                        ].forEach(function(t) {
                            return e.isText(t) && !t.nodeValue && e.safeRemove(t);
                        });
                    }
                },
                {
                    key: "hide",
                    value: function(e) {
                        e && (cr(e, "__old_display", e.style.display), e.style.display = "none");
                    }
                },
                {
                    key: "show",
                    value: function(e) {
                        if (e) {
                            var t = cr(e, "__old_display");
                            "none" === e.style.display && (e.style.display = t || "");
                        }
                    }
                },
                {
                    key: "isTag",
                    value: function(e, t) {
                        if (!this.isElement(e)) return !1;
                        var o = e.tagName.toLowerCase(), n = e.tagName.toUpperCase();
                        if (ui(t, Set)) return t.has(o) || t.has(n);
                        if (Array.isArray(t)) throw new TypeError("Dom.isTag does not support array");
                        return o === t || n === t;
                    }
                },
                {
                    key: "markTemporary",
                    value: function(e, t) {
                        return t && er(e, t), er(e, jo, !0), e;
                    }
                },
                {
                    key: "isTemporary",
                    value: function(t) {
                        return !!e.isElement(t) && (an(t) || "true" === er(t, jo));
                    }
                },
                {
                    key: "replaceTemporaryFromString",
                    value: function(e) {
                        return e.replace(/<([a-z]+)[^>]+data-jodit-temp[^>]+>(.+?)<\/\1>/gi, "$2");
                    }
                },
                {
                    key: "temporaryList",
                    value: function(e) {
                        return Qr("[".concat(jo, "]"), e);
                    }
                }
            ], o && ci(t, o), e;
        }();
        function hi(e, t) {
            var o = Object.getOwnPropertyDescriptor(e, t);
            return !o || Ro(o.get) ? null : o.value;
        }
        function vi(e, t, o) {
            var n = o.get;
            if (!n) throw Fr("Getter property descriptor expected");
            o.get = function() {
                ft || this.isInDestruct && console.error("Trying to access property in destructed component");
                var e = n.call(this);
                return e && !0 === e.noCache || Object.defineProperty(this, t, {
                    configurable: o.configurable,
                    enumerable: o.enumerable,
                    writable: !1,
                    value: e
                }), e;
            };
        }
        function gi(e, t, o) {
            var n = o.value;
            if (!Ro(n)) throw Fr("Handler must be a Function");
            var r = !0, i = new WeakMap;
            o.value = function() {
                for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
                var a;
                if (r && i.has(this.constructor)) return null === (a = i.get(this.constructor)) || void 0 === a ? void 0 : a.cloneNode(!0);
                var l = n.apply(this, t);
                return r && pi.isElement(l) && i.set(this.constructor, l), r ? l.cloneNode(!0) : l;
            }, e.hookStatus(Io.ready, function(e) {
                var t = hn(e) ? e : e.jodit;
                r = Boolean(t.options.cache);
            });
        }
        function mi(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function bi(e) {
            return bi = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, bi(e);
        }
        function yi(e, t) {
            return yi = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, yi(e, t);
        }
        function _i() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (_i = function() {
                return !!e;
            })();
        }
        function ji(e) {
            var t = function(e) {
                function t() {
                    for(var e = arguments.length, o = new Array(e), n = 0; n < e; n++)o[n] = arguments[n];
                    var r, i, a;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), (r = function(e, t, o) {
                        return t = bi(t), function(e, t) {
                            var o;
                            return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return e;
                            }(e) : t;
                        }(e, _i() ? Reflect.construct(t, o || [], bi(e).constructor) : t.apply(e, o));
                    }(this, t, function(e) {
                        return function(e) {
                            if (Array.isArray(e)) return mi(e);
                        }(e) || function(e) {
                            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                        }(e) || function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return mi(e, t);
                                var o = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? mi(e, t) : void 0;
                            }
                        }(e) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }(o))).constructor === t && (i = r, (null != (a = t) && "undefined" != typeof Symbol && a[Symbol.hasInstance] ? a[Symbol.hasInstance](i) : i instanceof a) || Object.setPrototypeOf(r, t.prototype), r.setStatus("ready")), r;
                }
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && yi(e, t);
                }(t, e), t;
            }(e);
            return t;
        }
        function wi(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function ki(e) {
            return function(e) {
                if (Array.isArray(e)) return wi(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return wi(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? wi(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Si(e, t) {
            for(var o = arguments.length, n = new Array(o > 2 ? o - 2 : 0), r = 2; r < o; r++)n[r - 2] = arguments[r];
            var i, a;
            return t ? (i = Ot).setTimeout.apply(i, [
                e,
                t
            ].concat(ki(n))) : ((a = e).call.apply(a, [
                null
            ].concat(ki(n))), 0);
        }
        function xi(e) {
            Ot.clearTimeout(e);
        }
        function Oi(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Ci(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function zi(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function Ei(e) {
            return function(e) {
                if (Array.isArray(e)) return Oi(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return Oi(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Oi(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        var Ti = function() {
            function e() {
                var t, o, n, r, i, a = this;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.timers = new Map, this.__callbacks = new Map, this.__queueMicrotaskNative = null !== (t = null === queueMicrotask || void 0 === queueMicrotask ? void 0 : queueMicrotask.bind(window)) && void 0 !== t ? t : Promise.resolve().then.bind(Promise.resolve()), this.promisesRejections = new Set, this.__requestsIdle = new Set, this.__controllers = new Set, this.__requestsRaf = new Set, this.__requestIdleCallbackNative = null !== (n = null === (o = window.requestIdleCallback) || void 0 === o ? void 0 : o.bind(window)) && void 0 !== n ? n : function(e, t) {
                    var o, n = Date.now();
                    return a.setTimeout(function() {
                        e({
                            didTimeout: !1,
                            timeRemaining: function() {
                                return Math.max(0, 50 - (Date.now() - n));
                            }
                        });
                    }, null !== (o = null == t ? void 0 : t.timeout) && void 0 !== o ? o : 1);
                }, this.__cancelIdleCallbackNative = null !== (i = null === (r = window.cancelIdleCallback) || void 0 === r ? void 0 : r.bind(window)) && void 0 !== i ? i : function(e) {
                    a.clearTimeout(e);
                }, this.isDestructed = !1;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "delay",
                    value: function(e) {
                        var t = this;
                        return this.promise(function(o) {
                            return t.setTimeout(o, e);
                        });
                    }
                },
                {
                    key: "setTimeout",
                    value: function(e, t) {
                        for(var o = arguments.length, n = new Array(o > 2 ? o - 2 : 0), r = 2; r < o; r++)n[r - 2] = arguments[r];
                        if (this.isDestructed) return 0;
                        var i = {};
                        Bo(t) && (t = 0), ln(t) || (t = (i = t).timeout || 0), i.label && this.clearLabel(i.label);
                        var a = Si.apply(void 0, [
                            e,
                            t
                        ].concat(Ei(n))), l = i.label || a;
                        return this.timers.set(l, a), this.__callbacks.set(l, e), a;
                    }
                },
                {
                    key: "updateTimeout",
                    value: function(e, t) {
                        if ($n(e && this.timers.has(e), "Label does not exist"), !e || !this.timers.has(e)) return null;
                        var o = this.__callbacks.get(e);
                        return $n(Ro(o), "Callback is not a function"), this.setTimeout(o, {
                            label: e,
                            timeout: t
                        });
                    }
                },
                {
                    key: "clearLabel",
                    value: function(e) {
                        e && this.timers.has(e) && (xi(this.timers.get(e)), this.timers.delete(e), this.__callbacks.delete(e));
                    }
                },
                {
                    key: "clearTimeout",
                    value: function(e) {
                        if (Lo(e)) return this.clearLabel(e);
                        xi(e), this.timers.delete(e), this.__callbacks.delete(e);
                    }
                },
                {
                    key: "debounce",
                    value: function(e, t) {
                        var o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = this, r = 0, i = !1, a = [], l = function() {
                            for(var t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                            if (!i) {
                                r = 0;
                                var l = e.apply(void 0, Ei(o));
                                if (i = !0, a.length) {
                                    var s = function() {
                                        a.forEach(function(e) {
                                            return e();
                                        }), a.length = 0;
                                    };
                                    un(l) ? l.finally(s) : s();
                                }
                            }
                        }, s = function() {
                            for(var a = arguments.length, s = new Array(a), c = 0; c < a; c++)s[c] = arguments[c];
                            i = !1, t ? (!r && o && l.apply(void 0, Ei(s)), xi(r), r = n.setTimeout(function() {
                                return l.apply(void 0, Ei(s));
                            }, Ro(t) ? t() : t), n.timers.set(e, r)) : l.apply(void 0, Ei(s));
                        };
                        return cn(t) && t.promisify ? function() {
                            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
                            var r = n.promise(function(e) {
                                a.push(e);
                            }).catch(function(e) {
                                if (Vo(e)) return null;
                                throw e;
                            });
                            return s.apply(void 0, Ei(t)), r;
                        } : s;
                    }
                },
                {
                    key: "microDebounce",
                    value: function(e) {
                        var t, o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this, r = !1, i = !0;
                        return function() {
                            for(var a = arguments.length, l = new Array(a), s = 0; s < a; s++)l[s] = arguments[s];
                            t = l, r ? i = !0 : (i = !0, o && (i = !1, e.apply(void 0, Ei(t))), r = !0, n.__queueMicrotaskNative(function() {
                                r = !1, n.isDestructed || i && e.apply(void 0, Ei(t));
                            }));
                        };
                    }
                },
                {
                    key: "throttle",
                    value: function(e, t) {
                        var o, n, r, i = this, a = null;
                        return function() {
                            for(var l = arguments.length, s = new Array(l), c = 0; c < l; c++)s[c] = arguments[c];
                            o = !0, r = s, t ? a || (n = function() {
                                o ? (e.apply(void 0, Ei(r)), o = !1, a = i.setTimeout(n, Ro(t) ? t() : t), i.timers.set(n, a)) : a = null;
                            })() : e.apply(void 0, Ei(r));
                        };
                    }
                },
                {
                    key: "promise",
                    value: function(e) {
                        var t = this, o = function() {}, n = new Promise(function(n, r) {
                            o = function() {
                                return r(Cr("Abort async"));
                            }, t.promisesRejections.add(o), e(n, r);
                        });
                        return n.finally || "undefined" == typeof process || dt || (n.finally = function(e) {
                            return n.then(e).catch(e), n;
                        }), n.finally(function() {
                            t.promisesRejections.delete(o);
                        }).catch(function() {
                            return null;
                        }), n.rejectCallback = o, n;
                    }
                },
                {
                    key: "promiseState",
                    value: function(e) {
                        var t = this;
                        if (e.status) return e.status;
                        if (!Promise.race) return new Promise(function(o) {
                            e.then(function(e) {
                                return o("fulfilled"), e;
                            }, function(e) {
                                throw o("rejected"), e;
                            }), t.setTimeout(function() {
                                o("pending");
                            }, 100);
                        });
                        var o = {};
                        return Promise.race([
                            e,
                            o
                        ]).then(function(e) {
                            return e === o ? "pending" : "fulfilled";
                        }, function() {
                            return "rejected";
                        });
                    }
                },
                {
                    key: "requestIdleCallback",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                            timeout: 100
                        }, o = this.__requestIdleCallbackNative(e, t);
                        return this.__requestsIdle.add(o), o;
                    }
                },
                {
                    key: "requestIdlePromise",
                    value: function(e) {
                        var t = this;
                        return this.promise(function(o) {
                            var n = t.requestIdleCallback(function() {
                                return o(n);
                            }, e);
                        });
                    }
                },
                {
                    key: "schedulerPostTask",
                    value: function(e) {
                        var t = this, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                            delay: 0,
                            priority: "user-visible"
                        }, n = new AbortController;
                        if (o.signal && o.signal.addEventListener("abort", function() {
                            return n.abort();
                        }), this.__controllers.add(n), void 0 !== globalThis.scheduler) {
                            var r = globalThis.scheduler.postTask(e, function(e, t) {
                                return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                                    var t = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var o = Object.getOwnPropertySymbols(e);
                                        t.push.apply(t, o);
                                    }
                                    return t;
                                })(Object(t)).forEach(function(o) {
                                    Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
                                }), e;
                            }(function(e) {
                                for(var t = 1; t < arguments.length; t++){
                                    var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                                    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                        return Object.getOwnPropertyDescriptor(o, e).enumerable;
                                    }))), n.forEach(function(t) {
                                        zi(e, t, o[t]);
                                    });
                                }
                                return e;
                            }({}, o), {
                                signal: n.signal
                            }));
                            return r.finally(function() {
                                t.__controllers.delete(n);
                            }).catch(function() {
                                return null;
                            }), r;
                        }
                        return this.promise(function(r, i) {
                            var a = t.setTimeout(function() {
                                try {
                                    r(e());
                                } catch (e) {
                                    i(e);
                                }
                                t.__controllers.delete(n);
                            }, o.delay || 1);
                            n.signal.addEventListener("abort", function() {
                                t.clearTimeout(a), t.__controllers.delete(n), i(Cr());
                            });
                        });
                    }
                },
                {
                    key: "schedulerYield",
                    value: function() {
                        return this.schedulerPostTask(function() {}, {
                            priority: "user-visible"
                        });
                    }
                },
                {
                    key: "cancelIdleCallback",
                    value: function(e) {
                        return this.__requestsIdle.delete(e), this.__cancelIdleCallbackNative(e);
                    }
                },
                {
                    key: "requestAnimationFrame",
                    value: function(e) {
                        var t = requestAnimationFrame(e);
                        return this.__requestsRaf.add(t), t;
                    }
                },
                {
                    key: "cancelAnimationFrame",
                    value: function(e) {
                        this.__requestsRaf.delete(e), cancelAnimationFrame(e);
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        var e = this;
                        this.__requestsIdle.forEach(function(t) {
                            return e.cancelIdleCallback(t);
                        }), this.__requestsRaf.forEach(function(t) {
                            return e.cancelAnimationFrame(t);
                        }), this.__controllers.forEach(function(e) {
                            return e.abort();
                        }), this.timers.forEach(function(t) {
                            return xi(e.timers.get(t));
                        }), this.timers.clear(), this.promisesRejections.forEach(function(e) {
                            return e();
                        }), this.promisesRejections.clear();
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.clear(), this.isDestructed = !0;
                    }
                }
            ], o && Ci(t.prototype, o), e;
        }(), Ii = function(e) {
            return Ao(e) ? e : [
                e
            ];
        };
        function Pi(e) {
            return Array.isArray(e) ? e : e.split(/[,\s]+/);
        }
        function Ri(e) {
            return e.replace(/mso-[a-z-]+:[\s]*[^;]+;/gi, "").replace(/mso-[a-z-]+:[\s]*[^";']+$/gi, "").replace(/border[a-z-]*:[\s]*[^;]+;/gi, "").replace(/([0-9.]+)(pt|cm)/gi, function(e, t, o) {
                switch(o.toLowerCase()){
                    case "pt":
                        return (1.328 * parseFloat(t)).toFixed(0) + "px";
                    case "cm":
                        return (.02645833 * parseFloat(t)).toFixed(0) + "px";
                }
                return e;
            });
        }
        function Ai(e) {
            if (-1 === e.indexOf("<html ")) return e;
            e = (e = e.substring(e.indexOf("<html "), e.length)).substring(0, e.lastIndexOf("</html>") + 7);
            var t = Ct.createElement("iframe");
            t.style.display = "none", Ct.body.appendChild(t);
            var o = "";
            try {
                var n = t.contentDocument || (t.contentWindow ? t.contentWindow.document : null);
                if (n) {
                    n.open(), n.write(e), n.close();
                    try {
                        for(var r = function(e) {
                            for(var t = function(e) {
                                if ("" === o[e].selectorText) return "continue";
                                Qr(o[e].selectorText, n.body).forEach(function(t) {
                                    t.style.cssText = Ri(o[e].style.cssText + ";" + t.style.cssText);
                                });
                            }, o = n.styleSheets[e].cssRules, r = 0; r < o.length; r += 1)t(r);
                        }, i = 0; i < n.styleSheets.length; i += 1)r(i);
                    } catch (e) {
                        if (!ft) throw e;
                    }
                    pi.each(n.body, function(e) {
                        if (pi.isElement(e)) {
                            var t = e, o = t.getAttribute("style");
                            o && (t.style.cssText = Ri(o)), t.hasAttribute("style") && !t.getAttribute("style") && t.removeAttribute("style");
                        }
                    }), o = n.firstChild ? vn(n.body.innerHTML) : "";
                }
            } catch (e) {} finally{
                pi.safeRemove(t);
            }
            return o && (e = o), vn(e.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, ""));
        }
        function Li(e) {
            -1 !== e.indexOf("<html ") && (e = (e = e.substring(e.indexOf("<html "), e.length)).substring(0, e.lastIndexOf("</html>") + 7));
            var t = "";
            try {
                var o = Ct.createElement("div");
                o.innerHTML = e;
                var n = [];
                o.firstChild && pi.each(o, function(e) {
                    if (e) switch(e.nodeType){
                        case Node.ELEMENT_NODE:
                            switch(e.nodeName){
                                case "STYLE":
                                case "LINK":
                                case "META":
                                    n.push(e);
                                    break;
                                case "W:SDT":
                                case "W:SDTPR":
                                case "FONT":
                                    pi.unwrap(e);
                                    break;
                                default:
                                    Fo(e.attributes).forEach(function(t) {
                                        -1 === [
                                            "src",
                                            "href",
                                            "rel",
                                            "content"
                                        ].indexOf(t.name.toLowerCase()) && e.removeAttribute(t.name);
                                    });
                            }
                            break;
                        case Node.TEXT_NODE:
                            break;
                        default:
                            n.push(e);
                    }
                }), pi.safeRemove.apply(null, n), t = o.innerHTML;
            } catch (e) {}
            return t && (e = t), (e = e.split(/(\n)/).filter(vn).join("\n")).replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, "");
        }
        function Mi(e) {
            var t = Ct.createElement("div");
            return t.textContent = e, t.innerHTML;
        }
        function Bi(e) {
            return e.replace(/\r\n|\r|\n/g, "<br/>");
        }
        function Di(e, t) {
            (pi.isElement(e) || pi.isFragment(e)) && (t.removeOnError && (Ni(e), Qr("[onerror]", e).forEach(function(e) {
                return Ni(e, t);
            })), t.safeJavaScriptLink && (Ni(e), Qr('a[href^="javascript"]', e).forEach(function(e) {
                return Ni(e, t);
            })));
        }
        function Ni(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                safeJavaScriptLink: !0,
                removeOnError: !0
            }, o = t.safeJavaScriptLink, n = t.removeOnError;
            if (!pi.isElement(e)) return !1;
            var r = !1;
            n && e.hasAttribute("onerror") && (er(e, "onerror", null), r = !0);
            var i = e.getAttribute("href");
            return o && i && 0 === i.trim().indexOf("javascript") && (er(e, "href", location.protocol + "//" + i), r = !0), r;
        }
        var Hi = new Set([
            "div",
            "p",
            "br",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr"
        ]), Fi = new Set([
            "script",
            "style"
        ]), qi = new Set([
            "br",
            "hr",
            "input"
        ]);
        function Vi(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = t.createElement("div");
            return Lo(e) ? n.innerHTML = e : n.appendChild(e), Qr("*", n).forEach(function(e) {
                var n = e.parentNode;
                if (n) {
                    if (o && pi.isTag(e, o)) {
                        var r = e.nodeName.toLowerCase(), i = pi.isTag(e, qi) ? "%%%jodit-single-".concat(r, "%%%") : "%%%jodit-".concat(r, "%%%").concat(Vi(e.innerHTML, t, o), "%%%/jodit-").concat(r, "%%%");
                        return pi.before(e, t.createTextNode(i)), void pi.safeRemove(e);
                    }
                    if (pi.isTag(e, Fi)) pi.safeRemove(e);
                    else if (pi.isTag(e, Hi)) {
                        var a = e.nextSibling;
                        pi.isText(a) && /^\s/.test(a.nodeValue || "") || a && n.insertBefore(t.createTextNode(" "), a);
                    }
                }
            }), vn(n.innerText).replace(/%%%(\/)?jodit(-single)?-([\w\n]+)%%%/g, function(e, t, o, n) {
                return "<".concat(t ? "/" : "").concat(n, ">");
            });
        }
        var Wi = function(e) {
            var t = [
                "#"
            ], o = zn(e);
            if (!o) return !1;
            if (3 === (o = (o = vn(o.toUpperCase())).substring(1)).length) {
                for(var n = 0; n < 3; n += 1)t.push(o[n]), t.push(o[n]);
                return t.join("");
            }
            return o.length > 6 && (o = o.slice(0, 6)), "#" + o;
        };
        function Ui(e) {
            var t = {}, o = {
                meta: 1,
                ctrl: 2,
                control: 2,
                alt: 3,
                shift: 4,
                space: 5
            };
            return e.replace(/\+\+/g, "+add").split(/[\s]*\+[\s]*/).map(function(e) {
                return vn(e.toLowerCase());
            }).map(function(e) {
                return ho[e] || e;
            }).sort(function(e, t) {
                return o[e] && !o[t] ? -1 : !o[e] && o[t] ? 1 : o[e] && o[t] ? o[e] - o[t] : e > t ? 1 : -1;
            }).filter(function(e) {
                return !t[e] && "" !== e && (t[e] = !0);
            }).join("+");
        }
        var Yi = function(e) {
            for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8, o = []; e.length;)o.push(e.substr(0, t)), e = e.substr(t);
            return o[1] = o[1].replace(/./g, "*"), o[2] = o[2].replace(/./g, "*"), o.join("-");
        }, Ki = function() {
            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
            return t.filter(function(e) {
                return vn(e).length;
            }).map(function(e, o) {
                return e = e.replace(/([^:])[\\/]+/g, "$1/"), o && (e = e.replace(/^\//, "")), o !== t.length - 1 && (e = e.replace(/\/$/, "")), e;
            }).join("/");
        }, Gi = function(e) {
            return e.split("/").reduce(function(e, t) {
                switch(t){
                    case "":
                    case ".":
                        break;
                    case "..":
                        e.pop();
                        break;
                    default:
                        e.push(t);
                }
                return e;
            }, []).join("/") + (e.endsWith("/") ? "/" : "");
        }, Ji = function(e, t) {
            return /^[0-9]+$/.test(e.toString()) ? e + t : e.toString();
        }, Xi = function() {
            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
            return t.filter(function(e) {
                return e.length;
            }).map(function(e) {
                return e.replace(/\/$/, "");
            }).join("/").replace(/([^:])[\\/]+/g, "$1/");
        }, Zi = function(e, t) {
            var o = function(e) {
                return parseInt(e, 10);
            }, n = t.getComputedStyle(e);
            return e.offsetWidth - o(n.getPropertyValue("padding-left") || "0") - o(n.getPropertyValue("padding-right") || "0");
        };
        function Qi(e) {
            if (!e) return null;
            var t = pi.isHTMLElement(e), o = t && Ln(e, "overflowY");
            return t && "visible" !== o && "hidden" !== o && e.scrollHeight >= e.clientHeight ? e : Qi(e.parentNode) || Ct.scrollingElement || Ct.body;
        }
        var $i = function(e, t) {
            var o = t.getComputedStyle(e);
            return e.clientWidth - (parseFloat(o.paddingLeft || "0") + parseFloat(o.paddingRight || "0"));
        };
        function ea(e) {
            return Lo(e) || Ao(e) ? e.length : cn(e) ? Object.keys(e).length : 0;
        }
        var ta = function(e, t, o) {
            var n, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            try {
                n = e.getBoundingClientRect();
            } catch (e) {
                n = {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: 0,
                    height: 0
                };
            }
            var i, a, l = o.body, s = o.documentElement || {
                clientTop: 0,
                clientLeft: 0,
                scrollTop: 0,
                scrollLeft: 0
            }, c = o.defaultView || o.parentWindow, u = c.pageYOffset || s.scrollTop || l.scrollTop, d = c.pageXOffset || s.scrollLeft || l.scrollLeft, f = s.clientTop || l.clientTop || 0, p = s.clientLeft || l.clientLeft || 0, h = t.iframe;
            if (!r && t && t.options && t.o.iframe && h) {
                var v = ta(h, t, t.od, !0), g = v.top, m = v.left;
                i = n.top + g, a = n.left + m;
            } else i = n.top + u - f, a = n.left + d - p;
            return {
                top: Math.round(i),
                left: Math.round(a),
                width: n.width,
                height: n.height
            };
        };
        function oa(e, t) {
            var o, n, r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = e.getBoundingClientRect(), a = i.left, l = i.top;
            if (nn(t) && t.iframe && t.ed.body.contains(e) && !r) {
                var s = oa(t.iframe, t, !0);
                a += s.left, l += s.top;
            }
            return {
                left: Math.round(a),
                top: Math.round(l),
                width: Math.round(null !== (o = e.offsetWidth) && void 0 !== o ? o : i.width),
                height: Math.round(null !== (n = e.offsetHeight) && void 0 !== n ? n : i.height)
            };
        }
        function na(e, t) {
            var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, n = 0, r = 0, i = -1, a = 0, l = 0;
            for(r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0; n < e.length && r < t.length;)e[n].toLowerCase() === t[r].toLowerCase() ? (n++, a++, l = 0, -1 === i && (i = r)) : n > 0 && (l >= o && t[r] !== bt ? (n = 0, i = -1, a = 0, l = 0, r--) : (l++, a++)), r++;
            return n === e.length ? [
                i,
                a
            ] : [
                -1,
                0
            ];
        }
        function ra(e) {
            return e.length ? e[0].toUpperCase() + e.substring(1) : "";
        }
        var ia = function(e, t) {
            if (!t || !t.length) return e;
            for(var o = /%([sd])/g, n = o.exec(e), r = e, i = 0; n && void 0 !== t[i];)r = r.replace(n[0], t[i].toString()), i += 1, n = o.exec(e);
            return r;
        };
        function aa(e, t, o) {
            if (!Lo(e)) throw Fr("i18n: Need string in first argument");
            if (!e.length) return e;
            var n = Boolean(null == o ? void 0 : o.debugLanguage), r = {}, i = function(e) {
                return t && t.length ? ia(e, t) : e;
            }, a = Or(rr.defaultOptions.language, rr.defaultOptions.language), l = Or(null == o ? void 0 : o.language, a), s = function(t) {
                if (t) {
                    if (Lo(t[e])) return i(t[e]);
                    var o = e.toLowerCase();
                    if (Lo(t[o])) return i(t[o]);
                    var n = ra(e);
                    return Lo(t[n]) ? i(t[n]) : void 0;
                }
            };
            void 0 !== wo[l] ? r = wo[l] : n || (r = void 0 !== wo[a] ? wo[a] : wo.en);
            var c = null == o ? void 0 : o.i18n;
            if (c && c[l]) {
                var u = s(c[l]);
                if (u) return u;
            }
            return s(r) || (!n && wo.en && Lo(wo.en[e]) && wo.en[e] ? i(wo.en[e]) : n ? "{" + e + "}" : (ft || "en" === l || console.warn('i18n need "'.concat(e, '" in "').concat(l, '"')), i(e)));
        }
        function la(e) {
            return En(e).toLowerCase();
        }
        function sa(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        var ca = new Set;
        function ua() {
            var e;
            return e = function(e, t) {
                var o;
                return function(e, t) {
                    var o, n, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: l(0),
                        throw: l(1),
                        return: l(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function l(i) {
                        return function(l) {
                            return function(i) {
                                if (o) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                    switch(n = 0, r && (i = [
                                        2 & i[0],
                                        r.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            r = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < r[1]) {
                                                a.label = r[1], r = i;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(i);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = t.call(e, a);
                                } catch (e) {
                                    i = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    o = r = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                l
                            ]);
                        };
                    }
                }(this, function(n) {
                    return o = da(e, t, !1), ca.has(o) ? [
                        2
                    ] : (ca.add(o), [
                        2,
                        Wn(e, o)
                    ]);
                });
            }, ua = function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        sa(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        sa(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            }, ua.apply(this, arguments);
        }
        function da(e, t, o) {
            t = En(t);
            var n = e.minified ? ".min" : "";
            return e.basePath + "plugins/" + t + "/" + t + n + "." + (o ? "js" : "css");
        }
        function fa(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function pa(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var ha = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.__items = new Map;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "size",
                    get: function() {
                        return this.__items.size;
                    }
                },
                {
                    key: "add",
                    value: function(e, t) {
                        this.__items.set(la(e), t), qa.fire("plugin:".concat(e, ":ready"));
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        return this.__items.get(la(e));
                    }
                },
                {
                    key: "remove",
                    value: function(e) {
                        this.__items.delete(la(e));
                    }
                },
                {
                    key: "__getFullPluginsList",
                    value: function(e) {
                        var t = [];
                        return this.__items.forEach(function(o, n) {
                            e && !e.has(n) || t.push([
                                n,
                                o
                            ]);
                        }), t;
                    }
                },
                {
                    key: "__init",
                    value: function(e) {
                        var t = this, o = function(e) {
                            return {
                                extraList: e.o.extraPlugins.map(function(e) {
                                    return Lo(e) ? {
                                        name: e
                                    } : e;
                                }),
                                disableList: new Set(Pi(e.o.disablePlugins).map(la)),
                                filter: e.o.safeMode ? new Set(e.o.safePluginsList) : null
                            };
                        }(e), n = o.extraList, r = o.disableList, i = o.filter, a = new Map, l = {}, s = new Set;
                        e.__plugins = l;
                        var c = function() {
                            if (!e.isInDestruct) {
                                var o = !1;
                                t.__getFullPluginsList(i).forEach(function(t) {
                                    var n = function(e, t) {
                                        return function(e) {
                                            if (Array.isArray(e)) return e;
                                        }(e) || function(e, t) {
                                            var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                            if (null != o) {
                                                var n, r, i = [], a = !0, l = !1;
                                                try {
                                                    for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                                } catch (e) {
                                                    l = !0, r = e;
                                                } finally{
                                                    try {
                                                        a || null == o.return || o.return();
                                                    } finally{
                                                        if (l) throw r;
                                                    }
                                                }
                                                return i;
                                            }
                                        }(e, t) || function(e, t) {
                                            if (e) {
                                                if ("string" == typeof e) return fa(e, t);
                                                var o = Object.prototype.toString.call(e).slice(8, -1);
                                                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? fa(e, t) : void 0;
                                            }
                                        }(e, t) || function() {
                                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }();
                                    }(t, 2), i = n[0], c = n[1];
                                    if (!r.has(i) && !a.has(i)) {
                                        var u = null == c ? void 0 : c.requires;
                                        if (u && Ao(u) && u.length) {
                                            if (u.some(function(e) {
                                                return r.has(e);
                                            })) return;
                                            if (!u.every(function(e) {
                                                return a.has(e);
                                            })) return void s.add(i);
                                        }
                                        o = !0;
                                        var d = function(e, t) {
                                            try {
                                                try {
                                                    return Ro(t) ? new t(e) : t;
                                                } catch (o) {
                                                    if (Ro(t) && !t.prototype) return t(e);
                                                }
                                            } catch (e) {
                                                if (console.error(e), !ft) throw e;
                                            }
                                            return null;
                                        }(e, c);
                                        if (!d) return a.set(i, null), void s.delete(i);
                                        (function(e, t, o, n, r, i) {
                                            if (Zo(n)) try {
                                                n.init(e);
                                            } catch (e) {
                                                if (console.error(e), !ft) throw e;
                                            }
                                            r.set(t, n), i.delete(t), n.hasStyle && (function(e, t) {
                                                return ua.apply(this, arguments);
                                            })(e, t).catch(function(e) {
                                                !ft && console.error(e);
                                            }), n.styles && (Ha(e, t, "style").innerHTML = n.styles);
                                        })(e, i, 0, d, a, s), l[i] = d;
                                    }
                                }), o && (e.e.fire("updatePlugins"), c());
                            }
                        };
                        n && n.length && function(e, t, o, n) {
                            try {
                                var r = o.filter(function(t) {
                                    return !e.has(la(t.name));
                                });
                                r.length && function(e, t, o) {
                                    t.map(function(t) {
                                        var n = t.url || da(e, t.name, !0);
                                        return Vn(e, n).then(o).catch(function() {
                                            return null;
                                        });
                                    });
                                }(t, r, n);
                            } catch (e) {
                                if (!ft) throw e;
                            }
                        }(this.__items, e, n, c), c(), function(e, t) {
                            e.e.on("beforeDestruct", function() {
                                Object.keys(t).forEach(function(o) {
                                    var n = t[o];
                                    Qo(n) && n.destruct(e), delete t[o];
                                }), delete e.__plugins;
                            });
                        }(e, l), !ft && s.size && console.warn("After init plugin waiting list is not clean:", s);
                    }
                },
                {
                    key: "wait",
                    value: function(e) {
                        var t = this;
                        return new Promise(function(o) {
                            if (t.get(e)) return o();
                            var n = function() {
                                o(), qa.off("plugin:".concat(e, ":ready"), n);
                            };
                            qa.on("plugin:".concat(e, ":ready"), n);
                        });
                    }
                }
            ], o && pa(t.prototype, o), e;
        }();
        function va(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var ga = "JoditEventDefaultNamespace", ma = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.__store = new Map;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "get",
                    value: function(e, t) {
                        if (this.__store.has(t)) {
                            var o = this.__store.get(t);
                            return $n(o, "-"), o[e];
                        }
                    }
                },
                {
                    key: "indexOf",
                    value: function(e, t, o) {
                        var n = this.get(e, t);
                        if (n) {
                            for(var r = 0; r < n.length; r += 1)if (n[r].originalCallback === o) return r;
                        }
                        return !1;
                    }
                },
                {
                    key: "namespaces",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = Fo(this.__store.keys());
                        return e ? t.filter(function(e) {
                            return e !== ga;
                        }) : t;
                    }
                },
                {
                    key: "events",
                    value: function(e) {
                        var t = this.__store.get(e);
                        return t ? Object.keys(t) : [];
                    }
                },
                {
                    key: "set",
                    value: function(e, t, o) {
                        var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], r = this.__store.get(t);
                        r || (r = {}, this.__store.set(t, r)), void 0 === r[e] && (r[e] = []), n ? r[e].unshift(o) : r[e].push(o);
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        this.__store.clear();
                    }
                },
                {
                    key: "clearEvents",
                    value: function(e, t) {
                        var o = this.__store.get(e);
                        o && o[t] && (delete o[t], Object.keys(o).length || this.__store.delete(e));
                    }
                },
                {
                    key: "isEmpty",
                    value: function() {
                        return 0 === this.__store.size;
                    }
                }
            ], o && va(t.prototype, o), e;
        }();
        function ba(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function ya(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function _a(e) {
            return function(e) {
                if (Array.isArray(e)) return ba(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return ba(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? ba(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        var ja = function() {
            function e(t) {
                var o = this;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.__domEventsMap = new Map, this.__mutedEvents = new Set, this.__key = "__JoditEventEmitterNamespaces", this.__doc = Ct, this.__prepareEvent = function(e) {
                    e.cancelBubble || (e.composed && Ro(e.composedPath) && e.composedPath()[0] && Object.defineProperty(e, "target", {
                        value: e.composedPath()[0],
                        configurable: !0,
                        enumerable: !0
                    }), e.type.match(/^touch/) && e.changedTouches && e.changedTouches.length && [
                        "clientX",
                        "clientY",
                        "pageX",
                        "pageY"
                    ].forEach(function(t) {
                        Object.defineProperty(e, t, {
                            value: e.changedTouches[0][t],
                            configurable: !0,
                            enumerable: !0
                        });
                    }), e.originalEvent || (e.originalEvent = e), "paste" === e.type && void 0 === e.clipboardData && o.__doc.defaultView.clipboardData && Object.defineProperty(e, "clipboardData", {
                        get: function() {
                            return o.__doc.defaultView.clipboardData;
                        },
                        configurable: !0,
                        enumerable: !0
                    }));
                }, this.currents = [], this.__stopped = [], this.__isDestructed = !1, t && (this.__doc = t), this.__key += (new Date).getTime();
            }
            var t, o;
            return t = e, o = [
                {
                    key: "mute",
                    value: function(e) {
                        return this.__mutedEvents.add(null != e ? e : "*"), this;
                    }
                },
                {
                    key: "isMuted",
                    value: function(e) {
                        return !(!e || !this.__mutedEvents.has(e)) || this.__mutedEvents.has("*");
                    }
                },
                {
                    key: "unmute",
                    value: function(e) {
                        return this.__mutedEvents.delete(null != e ? e : "*"), this;
                    }
                },
                {
                    key: "__eachEvent",
                    value: function(e, t) {
                        var o = this;
                        Pi(e).map(function(e) {
                            return e.trim();
                        }).forEach(function(e) {
                            var n = e.split("."), r = n[1] || ga;
                            t.call(o, n[0], r);
                        });
                    }
                },
                {
                    key: "__getStore",
                    value: function(e) {
                        if (!e) throw Fr("Need subject");
                        if (void 0 === e[this.__key]) {
                            var t = new ma;
                            Object.defineProperty(e, this.__key, {
                                enumerable: !1,
                                configurable: !0,
                                writable: !0,
                                value: t
                            });
                        }
                        return e[this.__key];
                    }
                },
                {
                    key: "__removeStoreFromSubject",
                    value: function(e) {
                        void 0 !== e[this.__key] && Object.defineProperty(e, this.__key, {
                            enumerable: !1,
                            configurable: !0,
                            writable: !0,
                            value: void 0
                        });
                    }
                },
                {
                    key: "__triggerNativeEvent",
                    value: function(e, t) {
                        var o = this.__doc.createEvent("HTMLEvents");
                        Lo(t) ? o.initEvent(t, !0, !0) : (o.initEvent(t.type, t.bubbles, t.cancelable), [
                            "screenX",
                            "screenY",
                            "clientX",
                            "clientY",
                            "target",
                            "srcElement",
                            "currentTarget",
                            "timeStamp",
                            "which",
                            "keyCode"
                        ].forEach(function(e) {
                            Object.defineProperty(o, e, {
                                value: t[e],
                                enumerable: !0
                            });
                        }), Object.defineProperty(o, "originalEvent", {
                            value: t,
                            enumerable: !0
                        })), e.dispatchEvent(o);
                    }
                },
                {
                    key: "current",
                    get: function() {
                        return this.currents[this.currents.length - 1];
                    }
                },
                {
                    key: "on",
                    value: function(e, t, o, n) {
                        var r, i, a, l, s = this;
                        if (Lo(e) || Mo(e) ? (r = this, i = e, a = t, l = o) : (r = e, i = t, a = o, l = n), !Lo(i) && !Mo(i) || 0 === i.length) throw Fr("Need events names");
                        if (!Ro(a)) throw Fr("Need event handler");
                        if (Ao(r)) return r.forEach(function(e) {
                            s.on(e, i, a, l);
                        }), this;
                        var c = r, u = this.__getStore(c), d = this, f = function(e) {
                            for(var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)o[n - 1] = arguments[n];
                            var r;
                            if (!d.isMuted(e)) return a && (r = a).call.apply(r, [
                                this
                            ].concat(_a(o)));
                        };
                        return wa(c) && (f = function(e) {
                            if (!d.isMuted(e.type)) return d.__prepareEvent(e), a && !1 === a.call(this, e) ? (e.preventDefault(), e.stopImmediatePropagation(), !1) : void 0;
                        }), this.__eachEvent(i, function(e, t) {
                            var o, n;
                            if (0 === e.length) throw Fr("Need event name");
                            if (!1 === u.indexOf(e, t, a)) {
                                var r = {
                                    event: e,
                                    originalCallback: a,
                                    syntheticCallback: f
                                };
                                if (u.set(e, t, r, null == l ? void 0 : l.top), wa(c)) {
                                    var i = xo.has(e) ? {
                                        passive: !0,
                                        capture: null !== (o = null == l ? void 0 : l.capture) && void 0 !== o && o
                                    } : null !== (n = null == l ? void 0 : l.capture) && void 0 !== n && n;
                                    f.options = i, c.addEventListener(e, f, i), s.__memoryDOMSubjectToHandler(c, f);
                                }
                            }
                        }), this;
                    }
                },
                {
                    key: "__memoryDOMSubjectToHandler",
                    value: function(e, t) {
                        var o = this.__domEventsMap.get(e) || new Set;
                        o.add(t), this.__domEventsMap.set(e, o);
                    }
                },
                {
                    key: "__unmemoryDOMSubjectToHandler",
                    value: function(e, t) {
                        var o = this.__domEventsMap, n = o.get(e) || new Set;
                        n.delete(t), n.size ? o.set(e, n) : o.delete(e);
                    }
                },
                {
                    key: "one",
                    value: function(e, t, o, n) {
                        var r, i, a, l, s = this;
                        Lo(e) || Mo(e) ? (r = this, i = e, a = t, l = o) : (r = e, i = t, a = o, l = n);
                        var c = function() {
                            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
                            return s.off(r, i, c), a.apply(void 0, _a(t));
                        };
                        return this.on(r, i, c, l), this;
                    }
                },
                {
                    key: "off",
                    value: function(e, t, o) {
                        var n, r, i, a = this;
                        if (Lo(e) || Mo(e) ? (n = this, r = e, i = t) : (n = e, r = t, i = o), Ao(n)) return n.forEach(function(e) {
                            a.off(e, r, i);
                        }), this;
                        var l = n, s = this.__getStore(l);
                        if (!Lo(r) && !Mo(r) || 0 === r.length) return s.namespaces().forEach(function(e) {
                            a.off(l, "." + e);
                        }), this.__removeStoreFromSubject(l), this;
                        var c = function(e) {
                            var t;
                            wa(l) && (l.removeEventListener(e.event, e.syntheticCallback, null !== (t = e.syntheticCallback.options) && void 0 !== t && t), a.__unmemoryDOMSubjectToHandler(l, e.syntheticCallback));
                        }, u = function(e, t) {
                            if ("" !== e) {
                                var o = s.get(e, t);
                                if (o && o.length) {
                                    if (Ro(i)) {
                                        var n = s.indexOf(e, t, i);
                                        !1 !== n && (c(o[n]), o.splice(n, 1), o.length || s.clearEvents(t, e));
                                    } else o.forEach(c), o.length = 0, s.clearEvents(t, e);
                                }
                            } else s.events(t).forEach(function(e) {
                                "" !== e && u(e, t);
                            });
                        };
                        return this.__eachEvent(r, function(e, t) {
                            t === ga ? s.namespaces().forEach(function(t) {
                                u(e, t);
                            }) : u(e, t);
                        }), s.isEmpty() && this.__removeStoreFromSubject(l), this;
                    }
                },
                {
                    key: "stopPropagation",
                    value: function(e, t) {
                        var o = this, n = Lo(e) ? this : e, r = Lo(e) ? e : t;
                        if ("string" != typeof r) throw Fr("Need event names");
                        var i = this.__getStore(n);
                        this.__eachEvent(r, function(e, t) {
                            var r = i.get(e, t);
                            r && o.__stopped.push(r), t === ga && i.namespaces(!0).forEach(function(t) {
                                return o.stopPropagation(n, e + "." + t);
                            });
                        });
                    }
                },
                {
                    key: "__removeStop",
                    value: function(e) {
                        if (e) {
                            var t = this.__stopped.indexOf(e);
                            -1 !== t && this.__stopped.splice(0, t + 1);
                        }
                    }
                },
                {
                    key: "__isStopped",
                    value: function(e) {
                        return void 0 !== e && -1 !== this.__stopped.indexOf(e);
                    }
                },
                {
                    key: "fire",
                    value: function(e, t) {
                        for(var o, n, r = this, i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), l = 2; l < i; l++)a[l - 2] = arguments[l];
                        var s = Lo(e) ? this : e, c = Lo(e) ? e : t, u = Lo(e) ? [
                            t
                        ].concat(_a(a)) : a;
                        if (!wa(s) && !Lo(c)) throw Fr("Need events names");
                        var d = this.__getStore(s);
                        return !Lo(c) && wa(s) ? this.__triggerNativeEvent(s, t) : this.__eachEvent(c, function(e, t) {
                            if (wa(s)) r.__triggerNativeEvent(s, e);
                            else {
                                var i = d.get(e, t);
                                if (i) try {
                                    _a(i).every(function(t) {
                                        var a;
                                        return !r.__isStopped(i) && (r.currents.push(e), n = (a = t.syntheticCallback).call.apply(a, [
                                            s,
                                            e
                                        ].concat(_a(u))), r.currents.pop(), void 0 !== n && (o = n), !0);
                                    });
                                } finally{
                                    r.__removeStop(i);
                                }
                                t !== ga || wa(s) || d.namespaces().filter(function(e) {
                                    return e !== t;
                                }).forEach(function(t) {
                                    var n = r.fire.apply(r, [
                                        s,
                                        e + "." + t
                                    ].concat(_a(u)));
                                    void 0 !== n && (o = n);
                                });
                            }
                        }), o;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        var e = this;
                        this.__isDestructed || (this.__isDestructed = !0, this.__domEventsMap.forEach(function(t, o) {
                            e.off(o);
                        }), this.__domEventsMap.clear(), this.__mutedEvents.clear(), this.currents.length = 0, this.__stopped.length = 0, this.off(this), this.__getStore(this).clear(), this.__removeStoreFromSubject(this));
                    }
                }
            ], o && ya(t.prototype, o), e;
        }();
        function wa(e) {
            return Ro(e.addEventListener);
        }
        function ka(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Sa(e, t) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, t) {
                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != o) {
                    var n, r, i = [], a = !0, l = !1;
                    try {
                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                    } catch (e) {
                        l = !0, r = e;
                    } finally{
                        try {
                            a || null == o.return || o.return();
                        } finally{
                            if (l) throw r;
                        }
                    }
                    return i;
                }
            }(e, t) || xa(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function xa(e, t) {
            if (e) {
                if ("string" == typeof e) return ka(e, t);
                var o = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? ka(e, t) : void 0;
            }
        }
        function Oa(e, t) {
            var o;
            do o = Object.getOwnPropertyDescriptor(e, t), e = Object.getPrototypeOf(e);
            while (!o && e);
            return o;
        }
        function Ca(e, t) {
            return function(o, n) {
                var r;
                if (!Ro(o[n])) throw Fr("Handler must be a Function");
                var i = null === (r = null == t ? void 0 : t.immediately) || void 0 === r || r, a = null == t ? void 0 : t.context, l = function(t) {
                    var r = hn(t) ? t : t.jodit, l = function(e) {
                        for(var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)r[i - 1] = arguments[i];
                        var a;
                        if (!t.isInDestruct) return (a = t)[n].apply(a, [
                            e
                        ].concat(function(e) {
                            return function(e) {
                                if (Array.isArray(e)) return ka(e);
                            }(e) || function(e) {
                                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                            }(e) || xa(e) || function() {
                                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }();
                        }(r)));
                    };
                    i || (l = t.async.microDebounce(l, !0)), Pi(e).forEach(function(e) {
                        if (/:/.test(e)) {
                            var n = Sa(e.split(":"), 2), i = n[0], s = n[1], c = a;
                            return i.length && (c = t.get(i)), Ro(c) && (c = c(t)), r.events.on(c || t, s, l), c || r.events.on(s, l), void t.hookStatus("beforeDestruct", function() {
                                r.events.off(c || t, s, l).off(s, l);
                            });
                        }
                        var u = e.split("."), d = Sa(u, 1)[0], f = u.slice(1), p = t[d];
                        cn(p) && Pa(p).on("change.".concat(f.join(".")), l);
                        var h = Oa(o, d);
                        Object.defineProperty(t, d, {
                            configurable: !0,
                            set: function(e) {
                                var o = p;
                                o !== e && (p = e, h && h.set && h.set.call(t, e), cn(p) && (p = Pa(p)).on("change.".concat(f.join(".")), l), l(d, o, p));
                            },
                            get: function() {
                                return h && h.get ? h.get.call(t) : p;
                            }
                        });
                    });
                };
                Ro(o.hookStatus) ? o.hookStatus(Io.ready, l) : l(o);
            };
        }
        function za(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Ea(e) {
            return function(e) {
                if (Array.isArray(e)) return za(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return za(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? za(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        var Ta = Symbol("observable-object");
        function Ia(e) {
            return void 0 !== e[Ta];
        }
        function Pa(e) {
            if (Ia(e)) return e;
            var t = {}, o = {}, n = function(t, r) {
                return Ao(t) ? (t.map(function(e) {
                    return n(e, r);
                }), e) : (o[t] || (o[t] = []), o[t].push(r), e);
            }, r = function(n) {
                for(var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), l = 1; l < i; l++)a[l - 1] = arguments[l];
                if (Ao(n)) n.map(function(e) {
                    return r.apply(void 0, [
                        e
                    ].concat(Ea(a)));
                });
                else try {
                    var s;
                    !t[n] && o[n] && (t[n] = !0, o[n].forEach(function(t) {
                        return (s = t).call.apply(s, [
                            e
                        ].concat(Ea(a)));
                    }));
                } finally{
                    t[n] = !1;
                }
            }, i = function(t) {
                var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], a = {};
                Ia(t) || (Object.defineProperty(t, Ta, {
                    enumerable: !1,
                    value: !0
                }), Object.keys(t).forEach(function(n) {
                    var l = n, s = o.concat(l).filter(function(e) {
                        return e.length;
                    });
                    a[l] = t[l];
                    var c = Oa(t, l);
                    Object.defineProperty(t, l, {
                        set: function(t) {
                            var o = a[l];
                            if (!Go(a[l], t)) {
                                r([
                                    "beforeChange",
                                    "beforeChange.".concat(s.join("."))
                                ], l, t), cn(t) && i(t, s), c && c.set ? c.set.call(e, t) : a[l] = t;
                                var n = [];
                                r([
                                    "change"
                                ].concat(Ea(s.reduce(function(e, t) {
                                    return n.push(t), e.push("change.".concat(n.join("."))), e;
                                }, []))), s.join("."), o, (null == t ? void 0 : t.valueOf) ? t.valueOf() : t);
                            }
                        },
                        get: function() {
                            return c && c.get ? c.get.call(e) : a[l];
                        },
                        enumerable: !0,
                        configurable: !0
                    }), cn(a[l]) && i(a[l], s);
                }), Object.defineProperty(e, "on", {
                    value: n
                }));
            };
            return i(e), e;
        }
        var Ra = {}, Aa = 1, La = new Set, Ma = new ha, Ba = {}, Da = function(e) {
            Object.keys(e).forEach(function(t) {
                wo[t] ? Object.assign(wo[t], e[t]) : wo[t] = e[t];
            });
        }, Na = new WeakMap;
        function Ha(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "div", n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], r = Lo(t) ? t : t ? Ur(t.prototype) : "jodit-utils", i = Na.get(e) || {}, a = r + o, l = hn(e) ? e : e.j, s = null;
            if (!i[a]) {
                var c = l.c;
                if (s = Fa(l.o, l.container, e.od.body), n && nn(e) && e.od !== e.ed) {
                    c = e.createInside;
                    var u = "style" === o ? e.ed.head : e.ed.body;
                    s = nn(e) && e.o.shadowRoot ? e.o.shadowRoot : u;
                }
                var d = c.element(o, {
                    className: "jodit jodit-".concat(En(r), "-container jodit-box")
                });
                d.classList.add("jodit_theme_".concat(l.o.theme || "default")), s.appendChild(d), i[a] = d, e.hookStatus("beforeDestruct", function() {
                    l.events.off(d), pi.safeRemove(d), delete i[a], Object.keys(i).length && Na.delete(e);
                }), Na.set(e, i), l.events.fire("getContainer", d);
            }
            return i[a].classList.remove("jodit_theme_default", "jodit_theme_dark"), i[a].classList.add("jodit_theme_".concat(l.o.theme || "default")), i[a];
        }
        function Fa(e, t, o) {
            var n, r, i;
            return null !== (i = null !== (r = null !== (n = e.popupRoot) && void 0 !== n ? n : e.shadowRoot) && void 0 !== r ? r : pi.closest(t, function(e) {
                return pi.isHTMLElement(e) && (pi.isTag(e, "dialog") || [
                    "fixed",
                    "absolute"
                ].includes(Ln(e, "position")));
            }, o)) && void 0 !== i ? i : o;
        }
        var qa = new ja;
        function Va(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Wa = new Map, Ua = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.async = new Ti, this.ownerWindow = window, this.__componentStatus = Io.beforeInit, this.uid = "jodit-uid-" + function() {
                    function e() {
                        return Aa += 10 * (Math.random() + 1), Math.round(Aa).toString(16);
                    }
                    for(var t = e(); La.has(t);)t = e();
                    return La.add(t), t;
                }();
            }
            var t, o, n;
            return t = e, o = [
                {
                    key: "componentName",
                    get: function() {
                        return this.__componentName || (this.__componentName = "jodit-" + En((Ro(this.className) ? this.className() : "") || Ur(this))), this.__componentName;
                    }
                },
                {
                    key: "getFullElName",
                    value: function(e, t, o) {
                        var n = [
                            this.componentName
                        ];
                        return e && (e = e.replace(/[^a-z0-9-]/gi, "-"), n.push("__".concat(e))), t && (n.push("_", t), n.push("_", Bo(o) ? "true" : o.toString())), n.join("");
                    }
                },
                {
                    key: "ownerDocument",
                    get: function() {
                        return this.ow.document;
                    }
                },
                {
                    key: "od",
                    get: function() {
                        return this.ownerDocument;
                    }
                },
                {
                    key: "ow",
                    get: function() {
                        return this.ownerWindow;
                    }
                },
                {
                    key: "get",
                    value: function(e, t) {
                        return Do(e, t || this);
                    }
                },
                {
                    key: "isReady",
                    get: function() {
                        return this.componentStatus === Io.ready;
                    }
                },
                {
                    key: "isDestructed",
                    get: function() {
                        return this.componentStatus === Io.destructed;
                    }
                },
                {
                    key: "isInDestruct",
                    get: function() {
                        return Io.beforeDestruct === this.componentStatus || Io.destructed === this.componentStatus;
                    }
                },
                {
                    key: "bindDestruct",
                    value: function(e) {
                        var t = this;
                        return e.hookStatus(Io.beforeDestruct, function() {
                            return !t.isInDestruct && t.destruct();
                        }), this;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.setStatus(Io.destructed), this.async && (this.async.destruct(), this.async = void 0), Wa.get(this) && Wa.delete(this), this.ownerWindow = void 0;
                    }
                },
                {
                    key: "componentStatus",
                    get: function() {
                        return this.__componentStatus;
                    },
                    set: function(e) {
                        this.setStatus(e);
                    }
                },
                {
                    key: "setStatus",
                    value: function(e) {
                        return this.setStatusComponent(e, this);
                    }
                },
                {
                    key: "setStatusComponent",
                    value: function(e, t) {
                        if (e !== this.__componentStatus) {
                            t === this && (this.__componentStatus = e);
                            var o = Object.getPrototypeOf(this);
                            o && Ro(o.setStatusComponent) && o.setStatusComponent(e, t);
                            var n = Wa.get(this), r = null == n ? void 0 : n[e];
                            r && r.length && r.forEach(function(e) {
                                return e(t);
                            });
                        }
                    }
                },
                {
                    key: "hookStatus",
                    value: function(e, t) {
                        var o = Wa.get(this);
                        o || (o = {}, Wa.set(this, o)), o[e] || (o[e] = []), o[e].push(t);
                    }
                }
            ], n = [
                {
                    key: "isInstanceOf",
                    value: function(e, t) {
                        var o, n;
                        return o = e, null != (n = t) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? !!n[Symbol.hasInstance](o) : o instanceof n;
                    }
                }
            ], o && Va(t.prototype, o), n && Va(t, n), e;
        }();
        function Ya(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Ka(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ga(e, t, o) {
            return Ga = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ja(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Ga(e, t, o || e);
        }
        function Ja(e) {
            return Ja = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Ja(e);
        }
        function Xa(e, t) {
            return Xa = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Xa(e, t);
        }
        function Za() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Za = function() {
                return !!e;
            })();
        }
        Ua.STATUSES = Io;
        var Qa = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Ja(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Za() ? Reflect.construct(t, o || [], Ja(e).constructor) : t.apply(e, o));
                }(this, t)).setParentView(e), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Xa(e, t);
            }(t, e), o = t, n = [
                {
                    key: "j",
                    get: function() {
                        return this.jodit;
                    }
                },
                {
                    key: "defaultTimeout",
                    get: function() {
                        return this.j.defaultTimeout;
                    }
                },
                {
                    key: "i18n",
                    value: function(e) {
                        for(var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)o[n - 1] = arguments[n];
                        var r;
                        return (r = this.j).i18n.apply(r, [
                            e
                        ].concat(function(e) {
                            return function(e) {
                                if (Array.isArray(e)) return Ya(e);
                            }(e) || function(e) {
                                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                            }(e) || function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return Ya(e, t);
                                    var o = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Ya(e, t) : void 0;
                                }
                            }(e) || function() {
                                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }();
                        }(o)));
                    }
                },
                {
                    key: "setParentView",
                    value: function(e) {
                        return this.jodit = e, e.components.add(this), this;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.j.components.delete(this), Ga(Ja(t.prototype), "destruct", this).call(this);
                    }
                }
            ], n && Ka(o.prototype, n), t;
        }(Ua);
        function $a(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "debounce";
            return function(n, r) {
                var i = n[r];
                if (!Ro(i)) throw Fr("Handler must be a Function");
                return n.hookStatus(Io.ready, function(n) {
                    var i = n.async;
                    $n(null != i, "Component ".concat(n.componentName || n.constructor.name, ' should have "async:IAsync" field'));
                    var a = Ro(e) ? e(n) : e, l = ln(a) || cn(a) ? a : n.defaultTimeout;
                    Object.defineProperty(n, r, {
                        configurable: !0,
                        value: i[o](n[r].bind(n), l, t)
                    });
                }), {
                    configurable: !0,
                    get: function() {
                        return i.bind(this);
                    }
                };
            };
        }
        function el(e) {
            return $a(e, arguments.length > 1 && void 0 !== arguments[1] && arguments[1], "throttle");
        }
        function tl(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function ol(e) {
            return function(e) {
                if (Array.isArray(e)) return tl(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return tl(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? tl(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function nl() {
            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
            return function(e) {
                for(var o = e.prototype, n = 0; n < t.length; n++)for(var r = function(e) {
                    var t = a[e], n = Object.getOwnPropertyDescriptor(i.prototype, t);
                    null != n && Ro(n.value) && !Ro(o[t]) && Object.defineProperty(o, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: function() {
                            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
                            var r;
                            return (r = n.value).call.apply(r, [
                                this
                            ].concat(ol(t)));
                        }
                    });
                }, i = t[n], a = Object.getOwnPropertyNames(i.prototype), l = 0; l < a.length; l++)r(l);
            };
        }
        function rl(e) {
            return function(t, o) {
                if (!Ro(t[o])) throw Fr("Handler must be a Function");
                t.hookStatus(e, function(e) {
                    e[o].call(e);
                });
            };
        }
        function il(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function al() {
            return function(e, t) {
                if (!Ro(e[t])) throw Fr("Handler must be a Function");
                e.hookStatus(Io.ready, function(e) {
                    var o, n = e.async, r = e[t];
                    e[t] = function() {
                        for(var t = arguments.length, i = new Array(t), a = 0; a < t; a++)i[a] = arguments[a];
                        return n.requestIdleCallback((o = r).bind.apply(o, [
                            e
                        ].concat(function(e) {
                            return function(e) {
                                if (Array.isArray(e)) return il(e);
                            }(e) || function(e) {
                                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                            }(e) || function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return il(e, t);
                                    var o = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? il(e, t) : void 0;
                                }
                            }(e) || function() {
                                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }();
                        }(i))));
                    };
                });
            };
        }
        var ll = function(e, t) {
            !1 !== (Object.getOwnPropertyDescriptor(e, t) || {}).enumerable && Object.defineProperty(e, t, {
                enumerable: !1,
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !1,
                        writable: !0,
                        value: e
                    });
                }
            });
        };
        function sl(e, t) {
            e.hookStatus(Io.ready, function(e) {
                var o = hn(e) ? e : e.jodit, n = "".concat(o.options.namespace).concat(e.componentName, "_prop_").concat(t), r = e[t];
                Object.defineProperty(e, t, {
                    get: function() {
                        var e;
                        return null !== (e = o.storage.get(n)) && void 0 !== e ? e : r;
                    },
                    set: function(e) {
                        o.storage.set(n, e);
                    }
                });
            });
        }
        function cl(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function ul(e) {
            return function(t, o) {
                if (!Ro(t[o])) throw Fr("Handler must be a Function");
                t.hookStatus(Io.ready, function(t) {
                    var n = t.async, r = t[o], i = 0;
                    Object.defineProperty(t, o, {
                        configurable: !0,
                        value: function o() {
                            for(var a = arguments.length, l = new Array(a), s = 0; s < a; s++)l[s] = arguments[s];
                            n.clearTimeout(i), e(t) ? r.apply(t, l) : i = n.setTimeout(function() {
                                return o.apply(void 0, function(e) {
                                    return function(e) {
                                        if (Array.isArray(e)) return cl(e);
                                    }(e) || function(e) {
                                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                                    }(e) || function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return cl(e, t);
                                            var o = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? cl(e, t) : void 0;
                                        }
                                    }(e) || function() {
                                        throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }(l));
                            }, 10);
                        }
                    });
                });
            };
        }
        function dl(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function fl(e) {
            return function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        dl(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        dl(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            };
        }
        function pl(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function hl(e, t) {
            var o, n, r, i, a = {
                label: 0,
                sent: function() {
                    if (1 & r[0]) throw r[1];
                    return r[1];
                },
                trys: [],
                ops: []
            };
            return i = {
                next: l(0),
                throw: l(1),
                return: l(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                return this;
            }), i;
            function l(i) {
                return function(l) {
                    return function(i) {
                        if (o) throw new TypeError("Generator is already executing.");
                        for(; a;)try {
                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                            switch(n = 0, r && (i = [
                                2 & i[0],
                                r.value
                            ]), i[0]){
                                case 0:
                                case 1:
                                    r = i;
                                    break;
                                case 4:
                                    return a.label++, {
                                        value: i[1],
                                        done: !1
                                    };
                                case 5:
                                    a.label++, n = i[1], i = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    i = a.ops.pop(), a.trys.pop();
                                    continue;
                                default:
                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                        a = 0;
                                        continue;
                                    }
                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                        a.label = i[1];
                                        break;
                                    }
                                    if (6 === i[0] && a.label < r[1]) {
                                        a.label = r[1], r = i;
                                        break;
                                    }
                                    if (r && a.label < r[2]) {
                                        a.label = r[2], a.ops.push(i);
                                        break;
                                    }
                                    r[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                            }
                            i = t.call(e, a);
                        } catch (e) {
                            i = [
                                6,
                                e
                            ], n = 0;
                        } finally{
                            o = r = 0;
                        }
                        if (5 & i[0]) throw i[1];
                        return {
                            value: i[0] ? i[1] : void 0,
                            done: !0
                        };
                    }([
                        i,
                        l
                    ]);
                };
            }
        }
        rr.prototype.defaultAjaxOptions = {
            successStatuses: [
                200,
                201,
                202
            ],
            method: "GET",
            url: "",
            data: null,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            headers: {
                "X-REQUESTED-WITH": "XMLHttpRequest"
            },
            withCredentials: !1,
            xhr: function() {
                return new XMLHttpRequest;
            }
        };
        var vl = function() {
            function e(t, o, n, r) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.request = t, this.status = o, this.statusText = n, this.body = r;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "url",
                    get: function() {
                        return this.request.url;
                    }
                },
                {
                    key: "json",
                    value: function() {
                        var e = this;
                        return fl(function() {
                            return hl(this, function(t) {
                                return [
                                    2,
                                    JSON.parse(e.body)
                                ];
                            });
                        })();
                    }
                },
                {
                    key: "text",
                    value: function() {
                        return Promise.resolve(this.body);
                    }
                },
                {
                    key: "blob",
                    value: function() {
                        var e = this;
                        return fl(function() {
                            return hl(this, function(t) {
                                return [
                                    2,
                                    e.body
                                ];
                            });
                        })();
                    }
                }
            ], pl(t.prototype, o), e;
        }();
        function gl(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function ml(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function bl(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function yl(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        var _l = function() {
            function e(t) {
                var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : rr.prototype.defaultAjaxOptions;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.__async = new Ti, this.__isFulfilled = !1, this.__activated = !1, this.__isDestructed = !1, this.options = _r(t || {}, o), this.xhr = this.o.xhr ? this.o.xhr() : new XMLHttpRequest;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "className",
                    value: function() {
                        return "Ajax";
                    }
                },
                {
                    key: "__buildParams",
                    value: function(e, t) {
                        var o, n;
                        return cn(e) && this.options.contentType && this.options.contentType.includes("application/json") ? JSON.stringify(e) : Ro(this.o.queryBuild) ? this.o.queryBuild.call(this, e, t) : Lo(e) || (o = e, null != (n = Ot.FormData) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? n[Symbol.hasInstance](o) : o instanceof n) || "object" === (void 0 === e ? "undefined" : yl(e)) && null != e && Ro(e.append) ? e : or(e);
                    }
                },
                {
                    key: "o",
                    get: function() {
                        return this.options;
                    }
                },
                {
                    key: "abort",
                    value: function() {
                        if (this.__isFulfilled) return this;
                        try {
                            this.__isFulfilled = !0, this.xhr.abort();
                        } catch (e) {}
                        return this;
                    }
                },
                {
                    key: "send",
                    value: function() {
                        this.__activated = !0;
                        var e = this.xhr, t = this.o, o = this.prepareRequest(), n = this;
                        return this.__async.promise(function() {
                            var r, i = (r = function(r, i) {
                                var a, l, s, c, u, d, f;
                                return function(e, t) {
                                    var o, n, r, i, a = {
                                        label: 0,
                                        sent: function() {
                                            if (1 & r[0]) throw r[1];
                                            return r[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                    return i = {
                                        next: l(0),
                                        throw: l(1),
                                        return: l(2)
                                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                        return this;
                                    }), i;
                                    function l(i) {
                                        return function(l) {
                                            return function(i) {
                                                if (o) throw new TypeError("Generator is already executing.");
                                                for(; a;)try {
                                                    if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                    switch(n = 0, r && (i = [
                                                        2 & i[0],
                                                        r.value
                                                    ]), i[0]){
                                                        case 0:
                                                        case 1:
                                                            r = i;
                                                            break;
                                                        case 4:
                                                            return a.label++, {
                                                                value: i[1],
                                                                done: !1
                                                            };
                                                        case 5:
                                                            a.label++, n = i[1], i = [
                                                                0
                                                            ];
                                                            continue;
                                                        case 7:
                                                            i = a.ops.pop(), a.trys.pop();
                                                            continue;
                                                        default:
                                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                                a = 0;
                                                                continue;
                                                            }
                                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                                a.label = i[1];
                                                                break;
                                                            }
                                                            if (6 === i[0] && a.label < r[1]) {
                                                                a.label = r[1], r = i;
                                                                break;
                                                            }
                                                            if (r && a.label < r[2]) {
                                                                a.label = r[2], a.ops.push(i);
                                                                break;
                                                            }
                                                            r[2] && a.ops.pop(), a.trys.pop();
                                                            continue;
                                                    }
                                                    i = t.call(e, a);
                                                } catch (e) {
                                                    i = [
                                                        6,
                                                        e
                                                    ], n = 0;
                                                } finally{
                                                    o = r = 0;
                                                }
                                                if (5 & i[0]) throw i[1];
                                                return {
                                                    value: i[0] ? i[1] : void 0,
                                                    done: !0
                                                };
                                            }([
                                                i,
                                                l
                                            ]);
                                        };
                                    }
                                }(this, function(p) {
                                    switch(p.label){
                                        case 0:
                                            return l = function() {
                                                n.__isFulfilled = !0, i(qr("Connection error"));
                                            }, s = function() {
                                                n.__isFulfilled = !0, r(new vl(o, e.status, e.statusText, e.responseType ? e.response : e.responseText));
                                            }, e.onload = s, e.onabort = function() {
                                                n.__isFulfilled = !0, i(Cr("Abort connection"));
                                            }, e.onerror = l, e.ontimeout = l, t.responseType && (e.responseType = t.responseType), e.onprogress = function(e) {
                                                var t, o, r = 0;
                                                e.lengthComputable && (r = e.loaded / e.total * 100), null === (o = (t = n.options).onProgress) || void 0 === o || o.call(t, r);
                                            }, e.onreadystatechange = function() {
                                                var o, r;
                                                null === (r = (o = n.options).onProgress) || void 0 === r || r.call(o, 10), e.readyState === XMLHttpRequest.DONE && (t.successStatuses.includes(e.status) ? s() : e.statusText && (n.__isFulfilled = !0, i(qr(e.statusText))));
                                            }, e.withCredentials = null !== (a = t.withCredentials) && void 0 !== a && a, c = o.url, u = o.data, d = o.method, e.open(d, c, !0), t.contentType && e.setRequestHeader && e.setRequestHeader("Content-type", t.contentType), Ro(f = t.headers) ? [
                                                4,
                                                f.call(n)
                                            ] : [
                                                3,
                                                2
                                            ];
                                        case 1:
                                            f = p.sent(), p.label = 2;
                                        case 2:
                                            return f && e.setRequestHeader && Object.keys(f).forEach(function(t) {
                                                e.setRequestHeader(t, f[t]);
                                            }), n.__async.setTimeout(function() {
                                                e.send(u ? n.__buildParams(u) : void 0);
                                            }, 0), [
                                                2
                                            ];
                                    }
                                });
                            }, function() {
                                var e = this, t = arguments;
                                return new Promise(function(o, n) {
                                    var i = r.apply(e, t);
                                    function a(e) {
                                        gl(i, o, n, a, l, "next", e);
                                    }
                                    function l(e) {
                                        gl(i, o, n, a, l, "throw", e);
                                    }
                                    a(void 0);
                                });
                            });
                            return function(e, t) {
                                return i.apply(this, arguments);
                            };
                        }());
                    }
                },
                {
                    key: "prepareRequest",
                    value: function() {
                        if (!this.o.url) throw Fr("Need URL for AJAX request");
                        var t = this.o.url, o = this.o.data, n = (this.o.method || "get").toLowerCase();
                        if ("get" === n && o && cn(o)) {
                            var r = t.indexOf("?");
                            if (-1 !== r) {
                                var i = kr(t);
                                t = t.substring(0, r) + "?" + or(function(e) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                                        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                            return Object.getOwnPropertyDescriptor(o, e).enumerable;
                                        }))), n.forEach(function(t) {
                                            bl(e, t, o[t]);
                                        });
                                    }
                                    return e;
                                }({}, i, o));
                            } else t += "?" + or(this.o.data);
                        }
                        var a = {
                            url: t,
                            method: n,
                            data: o
                        };
                        return e.log.splice(100), e.log.push(a), a;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.__isDestructed || (this.__isDestructed = !0, this.__activated && !this.__isFulfilled && (this.abort(), this.__isFulfilled = !0), this.__async.destruct());
                    }
                }
            ], o && ml(t.prototype, o), e;
        }();
        function jl(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        _l.log = [], function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : yl(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        }([
            To
        ], _l.prototype, "destruct", null);
        var wl = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e);
            }
            var t, o;
            return t = e, o = [
                {
                    key: "getElm",
                    value: function(e) {
                        return this.container.querySelector(".".concat(this.getFullElName(e)));
                    }
                },
                {
                    key: "getElms",
                    value: function(e) {
                        return Fo(this.container.querySelectorAll(".".concat(this.getFullElName(e))));
                    }
                }
            ], jl(t.prototype, o), e;
        }();
        function kl(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Sl = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e);
            }
            var t, o;
            return t = e, o = [
                {
                    key: "afterSetMod",
                    value: function(e, t) {}
                },
                {
                    key: "setMod",
                    value: function(e, t, o) {
                        e = e.toLowerCase();
                        var n = this.mods[e];
                        if (n === t) return this;
                        var r = "".concat(this.componentName, "_").concat(e, "_"), i = (o || this.container).classList;
                        return null != n && i.remove("".concat(r).concat(n.toString().toLowerCase())), !Bo(t) && "" !== t && i.add("".concat(r).concat(t.toString().toLowerCase())), this.mods[e] = t, this.afterSetMod(e, t), this;
                    }
                },
                {
                    key: "getMod",
                    value: function(e) {
                        var t;
                        return null !== (t = this.mods[e]) && void 0 !== t ? t : null;
                    }
                }
            ], kl(t.prototype, o), e;
        }();
        function xl(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Ol = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e);
            }
            var t, o;
            return t = e, o = [
                {
                    key: "getIcon",
                    value: function(t) {
                        if (/<svg/i.test(t)) return t;
                        var o = e.icons[t] || e.icons[t.replace(/-/g, "_")] || e.icons[t.replace(/_/g, "-")] || e.icons[An(t)] || e.icons[En(t)] || e.icons[t.toLowerCase()];
                        return ft || o || console.warn('Icon "'.concat(t, '" not found')), o;
                    }
                },
                {
                    key: "exists",
                    value: function(e) {
                        return void 0 !== this.getIcon(e);
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "<span></span>";
                        return this.getIcon(e) || t;
                    }
                },
                {
                    key: "set",
                    value: function(e, t) {
                        return this.icons[e.replace("_", "-")] = t, this;
                    }
                },
                {
                    key: "makeIcon",
                    value: function(t, o) {
                        var n, r, i, a;
                        if (o) {
                            var l, s, c = o.name, u = o.iconURL, d = o.fill, f = c.replace(/[^a-zA-Z0-9]/g, "_");
                            /<svg/.test(c) || (s = null === (r = (n = t.o).getIcon) || void 0 === r ? void 0 : r.call(n, c, f));
                            var p = "".concat(c).concat(u).concat(d).concat(null != s ? s : "");
                            if (t.o.cache && this.__cache.has(p)) return null === (i = this.__cache.get(p)) || void 0 === i ? void 0 : i.cloneNode(!0);
                            if (u) Ln(l = t.c.span(), "backgroundImage", "url(" + u.replace("{basePath}", (null == t ? void 0 : t.basePath) || "") + ")");
                            else {
                                var h = s || e.get(c, "") || (null === (a = t.o.extraIcons) || void 0 === a ? void 0 : a[c]);
                                h && (l = t.c.fromHTML(h.trim()), /^<svg/i.test(c) || l.classList.add("jodit-icon_" + f));
                            }
                            return l && (l.classList.add("jodit-icon"), l.style.fill = d, t.o.cache && this.__cache.set(p, l.cloneNode(!0))), l;
                        }
                    }
                }
            ], o && xl(t, o), e;
        }();
        function Cl(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function zl(e, t, o) {
            return zl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = El(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, zl(e, t, o || e);
        }
        function El(e) {
            return El = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, El(e);
        }
        function Tl(e, t) {
            return Tl = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Tl(e, t);
        }
        function Il(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Pl() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Pl = function() {
                return !!e;
            })();
        }
        Ol.icons = {}, Ol.__cache = new Map;
        var Rl, Al = Rl = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = El(t), function(e, t) {
                        return !t || "object" !== Il(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Pl() ? Reflect.construct(t, o || [], El(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).name = "", n.__parentElement = null, n.mods = {}, n.container = n.createContainer(o), Object.defineProperty(n.container, "component", {
                    value: n,
                    configurable: !0
                }), n;
            }
            var o, n, r;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Tl(e, t);
            }(t, e), o = t, n = [
                {
                    key: "parentElement",
                    get: function() {
                        return this.__parentElement;
                    },
                    set: function(e) {
                        var t = this;
                        this.__parentElement = e, e && e.hookStatus("beforeDestruct", function() {
                            return t.destruct();
                        }), this.updateParentElement(this);
                    }
                },
                {
                    key: "bubble",
                    value: function(e) {
                        for(var t = this.parentElement; t;)e(t), t = t.parentElement;
                        return this;
                    }
                },
                {
                    key: "updateParentElement",
                    value: function(e) {
                        var t;
                        return null === (t = this.__parentElement) || void 0 === t || t.updateParentElement(e), this;
                    }
                },
                {
                    key: "get",
                    value: function(e, o) {
                        return zl(El(t.prototype), "get", this).call(this, e, o) || this.getElm(e);
                    }
                },
                {
                    key: "closest",
                    value: function(e) {
                        for(var t = "object" === (void 0 === e ? "undefined" : Il(e)) ? function(t) {
                            return t === e;
                        } : function(t) {
                            return Ua.isInstanceOf(t, e);
                        }, o = this.__parentElement; o;){
                            if (t(o)) return o;
                            o = !o.parentElement && o.container.parentElement ? Rl.closestElement(o.container.parentElement, Rl) : o.parentElement;
                        }
                        return null;
                    }
                },
                {
                    key: "update",
                    value: function() {}
                },
                {
                    key: "appendTo",
                    value: function(e) {
                        return e.appendChild(this.container), this;
                    }
                },
                {
                    key: "clearName",
                    value: function(e) {
                        return e.replace(/[^a-zA-Z0-9]/g, "_");
                    }
                },
                {
                    key: "render",
                    value: function(e) {
                        return this.j.c.div(this.componentName);
                    }
                },
                {
                    key: "createContainer",
                    value: function(e) {
                        var t = this.render(e);
                        if (Lo(t)) {
                            var o = this.parseTemplate(t);
                            return o.classList.add(this.componentName), o;
                        }
                        return t;
                    }
                },
                {
                    key: "parseTemplate",
                    value: function(e) {
                        var t = this;
                        return this.j.c.fromHTML(e.replace(/\*([^*]+?)\*/g, function(e, t) {
                            return Ol.get(t) || "";
                        }).replace(/&_/g, this.componentName + "_").replace(/~([^~]+?)~/g, function(e, o) {
                            return t.i18n(o);
                        }));
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return pi.safeRemove(this.container), this.parentElement = null, zl(El(t.prototype), "destruct", this).call(this);
                    }
                }
            ], r = [
                {
                    key: "closestElement",
                    value: function(e, t) {
                        var o = pi.up(e, function(e) {
                            if (e) {
                                var o = e.component;
                                return o && Ua.isInstanceOf(o, t);
                            }
                            return !1;
                        });
                        return o ? null == o ? void 0 : o.component : null;
                    }
                }
            ], n && Cl(o.prototype, n), r && Cl(o, r), t;
        }(Qa);
        function Ll(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Ml(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Bl(e, t, o) {
            return Bl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Dl(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Bl(e, t, o || e);
        }
        function Dl(e) {
            return Dl = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Dl(e);
        }
        function Nl(e, t) {
            return Nl = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Nl(e, t);
        }
        function Hl(e) {
            return function(e) {
                if (Array.isArray(e)) return Ll(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return Ll(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Ll(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Fl(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ql() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ql = function() {
                return !!e;
            })();
        }
        Al = Rl = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Il(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            nl(Sl, wl)
        ], Al);
        var Vl, Wl = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Fl(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Ul = Vl = function(e) {
            function t(e, o, n) {
                var r;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (r = function(e, t, o) {
                    return t = Dl(t), function(e, t) {
                        return !t || "object" !== Fl(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ql() ? Reflect.construct(t, o || [], Dl(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    n
                ])).options = n, r.syncMod = !1, r.elements = [], r.buttonSize = "middle", null == o || o.forEach(function(e) {
                    return e && r.append(e);
                }), (null == n ? void 0 : n.name) && (r.name = n.name), r;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Nl(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIGroup";
                    }
                },
                {
                    key: "allChildren",
                    get: function() {
                        for(var e = [], t = Hl(this.elements); t.length;){
                            var o, n = t.shift();
                            if (Ao(n)) (o = t).push.apply(o, Hl(n));
                            else if (Ua.isInstanceOf(n, Vl)) {
                                var r;
                                (r = t).push.apply(r, Hl(n.elements));
                            } else n && e.push(n);
                        }
                        return e;
                    }
                },
                {
                    key: "update",
                    value: function() {
                        this.elements.forEach(function(e) {
                            return e.update();
                        }), this.setMod("size", this.buttonSize);
                    }
                },
                {
                    key: "append",
                    value: function(e, t) {
                        var o = this;
                        if (Ao(e)) return e.forEach(function(e) {
                            return o.append(e, t);
                        }), this;
                        if (this.elements.push(e), e.name && e.container.classList.add(this.getFullElName(e.name)), t) {
                            var n = this.getElm(t);
                            $n(null != n, "Element does not exist"), n.appendChild(e.container);
                        } else this.appendChildToContainer(e.container);
                        return e.parentElement = this, this;
                    }
                },
                {
                    key: "afterSetMod",
                    value: function(e, t) {
                        this.syncMod && this.elements.forEach(function(o) {
                            return o.setMod(e, t);
                        });
                    }
                },
                {
                    key: "appendChildToContainer",
                    value: function(e) {
                        this.container.appendChild(e);
                    }
                },
                {
                    key: "remove",
                    value: function(e) {
                        var t = this.elements.indexOf(e);
                        return -1 !== t && (this.elements.splice(t, 1), pi.safeRemove(e.container), e.parentElement = null), this;
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        return this.elements.forEach(function(e) {
                            return e.destruct();
                        }), this.elements.length = 0, this;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.clear(), Bl(Dl(t.prototype), "destruct", this).call(this);
                    }
                }
            ], n && Ml(o.prototype, n), t;
        }(Al);
        function Yl(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Kl(e) {
            return Kl = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Kl(e);
        }
        function Gl(e, t) {
            return Gl = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Gl(e, t);
        }
        function Jl(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Xl() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Xl = function() {
                return !!e;
            })();
        }
        Wl([
            Ca("buttonSize")
        ], Ul.prototype, "update", null), Ul = Vl = Wl([
            ji
        ], Ul);
        var Zl = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = Kl(o = t), function(e, t) {
                    return !t || "object" !== Jl(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, Xl() ? Reflect.construct(o, n || [], Kl(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Gl(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UISeparator";
                    }
                }
            ], Yl(o.prototype, n), t;
        }(Al);
        function Ql(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function $l(e) {
            return $l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, $l(e);
        }
        function es(e, t) {
            return es = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, es(e, t);
        }
        function ts(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function os() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (os = function() {
                return !!e;
            })();
        }
        Zl = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Jl(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Zl);
        var ns = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = $l(o = t), function(e, t) {
                    return !t || "object" !== ts(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, os() ? Reflect.construct(o, n || [], $l(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && es(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UISpacer";
                    }
                }
            ], Ql(o.prototype, n), t;
        }(Al);
        function rs(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function is(e) {
            return function(e) {
                if (Array.isArray(e)) return rs(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return rs(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? rs(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        ns = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : ts(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], ns);
        var as = function(e) {
            return Ao(e.buttons);
        };
        function ls(e, t) {
            var o = t.getRegisteredButtonGroups();
            return new Set(e.reduce(function(e, t) {
                var n;
                return as(t) ? e = e.concat(is(t.buttons).concat(is(null !== (n = o[t.group]) && void 0 !== n ? n : []))) : e.push(t), e;
            }, []));
        }
        function ss(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function cs(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function us(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    cs(e, t, o[t]);
                });
            }
            return e;
        }
        function ds(e, t) {
            var o;
            return t || (t = rr.defaultOptions.controls), Lo(e) ? o = fs(e, t) || {
                name: e,
                command: e,
                tooltip: e
            } : void 0 !== t[(o = us({
                name: "empty"
            }, jr(e))).name] && (o = us({}, jr(t[o.name]), jr(o))), o;
        }
        function fs(e, t) {
            var o = function(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != o) {
                        var n, r, i = [], a = !0, l = !1;
                        try {
                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                        } catch (e) {
                            l = !0, r = e;
                        } finally{
                            try {
                                a || null == o.return || o.return();
                            } finally{
                                if (l) throw r;
                            }
                        }
                        return i;
                    }
                }(e, t) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return ss(e, t);
                        var o = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? ss(e, t) : void 0;
                    }
                }(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }(e.split(/\./), 2), n = o[0], r = o[1], i = t;
            return null != r ? void 0 !== t[n] && (i = t[n]) : r = n, i[r] ? us({
                name: r
            }, jr(i[r])) : void 0;
        }
        function ps(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function hs(e) {
            return hs = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, hs(e);
        }
        function vs(e, t) {
            return vs = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, vs(e, t);
        }
        function gs(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ms() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ms = function() {
                return !!e;
            })();
        }
        var bs = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : gs(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, ys = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = hs(t), function(e, t) {
                        return !t || "object" !== gs(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ms() ? Reflect.construct(t, o || [], hs(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).mode = "horizontal", o.removeButtons = [], o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && vs(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIList";
                    }
                },
                {
                    key: "__onChangeMode",
                    value: function() {
                        this.setMod("mode", this.mode);
                    }
                },
                {
                    key: "makeGroup",
                    value: function() {
                        return new Ul(this.jodit);
                    }
                },
                {
                    key: "buttons",
                    get: function() {
                        return this.allChildren.filter(function(e) {
                            return Ua.isInstanceOf(e, zs);
                        });
                    }
                },
                {
                    key: "getButtonsNames",
                    value: function() {
                        return this.buttons.map(function(e) {
                            var t, o;
                            return t = e, (null != (o = zs) && "undefined" != typeof Symbol && o[Symbol.hasInstance] ? !!o[Symbol.hasInstance](t) : t instanceof o) && e.state.name || "";
                        }).filter(function(e) {
                            return "" !== e;
                        });
                    }
                },
                {
                    key: "setRemoveButtons",
                    value: function(e) {
                        return this.removeButtons = e || [], this;
                    }
                },
                {
                    key: "build",
                    value: function(e) {
                        var t = this, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        e = Pi(e), this.clear();
                        var n, r = !1, i = this.makeGroup();
                        this.append(i), i.setMod("line", !0);
                        var a = function(e) {
                            var a = null;
                            switch(e.name){
                                case "\n":
                                    (i = t.makeGroup()).setMod("line", !0), n = t.makeGroup(), i.append(n), t.append(i);
                                    break;
                                case "|":
                                    r || (r = !0, a = new Zl(t.j));
                                    break;
                                case "---":
                                    n.setMod("before-spacer", !0);
                                    var l = new ns(t.j);
                                    i.append(l), n = t.makeGroup(), i.append(n), r = !1;
                                    break;
                                default:
                                    r = !1, a = "select" === e.component ? t.makeSelect(e, o) : t.makeButton(e, o);
                            }
                            a && (n || (n = t.makeGroup(), i.append(n)), n.append(a));
                        }, l = function(e) {
                            var o;
                            return !t.removeButtons.includes(e.name) && (!e.isVisible || (null === (o = e.isVisible) || void 0 === o ? void 0 : o.call(e, t.j, e)));
                        };
                        return e.forEach(function(e) {
                            if (as(e)) {
                                var o = e.buttons.filter(function(e) {
                                    return e;
                                });
                                o.length && ((n = t.makeGroup()).setMod("separated", !0).setMod("group", e.group), i.append(n), (function(e, t) {
                                    var o = Ao(e) ? e : vr(e, !1).map(function(t) {
                                        return _r({
                                            name: t
                                        }, e[t] || {});
                                    });
                                    return o.map(function(e) {
                                        return ds(e, t || rr.defaultOptions.controls);
                                    });
                                })(o, t.j.o.controls).filter(l).forEach(a));
                            } else {
                                n || (n = t.makeGroup(), i.append(n));
                                var r = ds(e, t.j.o.controls);
                                l(r) && a(r);
                            }
                        }), this.update(), this;
                    }
                },
                {
                    key: "makeSelect",
                    value: function(e, t) {
                        throw new Error("Not implemented behaviour");
                    }
                },
                {
                    key: "makeButton",
                    value: function(e, t) {
                        return new zs(this.j, {
                            name: e.name
                        });
                    }
                }
            ], n && ps(o.prototype, n), t;
        }(Ul);
        function _s(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function js(e, t, o) {
            return js = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = ws(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, js(e, t, o || e);
        }
        function ws(e) {
            return ws = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ws(e);
        }
        function ks(e, t) {
            return ks = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, ks(e, t);
        }
        function Ss(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function xs() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (xs = function() {
                return !!e;
            })();
        }
        bs([
            Ca("mode"),
            rl("ready")
        ], ys.prototype, "__onChangeMode", null), ys = bs([
            ji
        ], ys);
        var Os = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Ss(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Cs = function() {
            return {
                size: "middle",
                type: "button",
                role: "button",
                name: "",
                value: "",
                variant: "initial",
                disabled: !1,
                activated: !1,
                icon: {
                    name: "empty",
                    fill: "",
                    iconURL: ""
                },
                tooltip: "",
                text: "",
                tabIndex: void 0
            };
        }, zs = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = ws(t), function(e, t) {
                        return !t || "object" !== Ss(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, xs() ? Reflect.construct(t, o || [], ws(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).isButton = !0, n.state = Cs(), n.actionHandlers = [], n.button = n.container, n.updateSize(), n.onChangeSize(), n.onChangeStatus(), o && n.hookStatus(Io.ready, function() {
                    n.setState(o);
                }), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ks(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIButton";
                    }
                },
                {
                    key: "setState",
                    value: function(e) {
                        return Object.assign(this.state, e), this;
                    }
                },
                {
                    key: "text",
                    get: function() {
                        var e = this.getElm("text");
                        return $n(e, "Text element not found"), e;
                    }
                },
                {
                    key: "icon",
                    get: function() {
                        var e = this.getElm("icon");
                        return $n(e, "Icon element not found"), e;
                    }
                },
                {
                    key: "onChangeSize",
                    value: function() {
                        this.setMod("size", this.state.size);
                    }
                },
                {
                    key: "onChangeType",
                    value: function() {
                        er(this.container, "type", this.state.type);
                    }
                },
                {
                    key: "onChangeRole",
                    value: function() {
                        er(this.container, "role", this.state.role);
                    }
                },
                {
                    key: "updateSize",
                    value: function() {
                        var e = this.closest(ys);
                        e && (this.state.size = e.buttonSize);
                    }
                },
                {
                    key: "onChangeStatus",
                    value: function() {
                        this.setMod("variant", this.state.variant);
                    }
                },
                {
                    key: "onChangeText",
                    value: function() {
                        this.text.textContent = this.jodit.i18n(this.state.text);
                    }
                },
                {
                    key: "onChangeTextSetMode",
                    value: function() {
                        this.setMod("text-icons", Boolean(this.state.text.trim().length));
                    }
                },
                {
                    key: "onChangeDisabled",
                    value: function() {
                        er(this.container, "disabled", this.state.disabled || null);
                    }
                },
                {
                    key: "onChangeActivated",
                    value: function() {
                        er(this.container, "aria-pressed", this.state.activated);
                    }
                },
                {
                    key: "onChangeName",
                    value: function() {
                        this.container.classList.add("".concat(this.componentName, "_").concat(this.clearName(this.state.name))), this.name = this.state.name, er(this.container, "data-ref", this.state.name), er(this.container, "ref", this.state.name);
                    }
                },
                {
                    key: "onChangeTooltip",
                    value: function() {
                        this.get("j.o.useNativeTooltip") && er(this.container, "title", this.state.tooltip), er(this.container, "aria-label", this.state.tooltip);
                    }
                },
                {
                    key: "onChangeTabIndex",
                    value: function() {
                        er(this.container, "tabindex", this.state.tabIndex);
                    }
                },
                {
                    key: "onChangeIcon",
                    value: function() {
                        var e = this.get("j.o.textIcons");
                        if (!(!0 === e || Ro(e) && e(this.state.name))) {
                            pi.detach(this.icon);
                            var t = Ol.makeIcon(this.j, this.state.icon);
                            t && this.icon.appendChild(t);
                        }
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        this.container.focus();
                    }
                },
                {
                    key: "isFocused",
                    value: function() {
                        var e = this.od.activeElement;
                        return Boolean(e && pi.isOrContains(this.container, e));
                    }
                },
                {
                    key: "createContainer",
                    value: function() {
                        var e = this.componentName, t = this.j.c.element("button", {
                            class: e,
                            type: "button",
                            role: "button",
                            ariaPressed: !1
                        }), o = this.j.c.span(e + "__icon"), n = this.j.c.span(e + "__text");
                        return t.appendChild(o), t.appendChild(n), t;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.j.e.off(this.container), js(ws(t.prototype), "destruct", this).call(this);
                    }
                },
                {
                    key: "onAction",
                    value: function(e) {
                        return this.actionHandlers.push(e), this;
                    }
                },
                {
                    key: "__onActionFire",
                    value: function(e) {
                        var t = this;
                        e.buffer = {
                            actionTrigger: this
                        }, this.actionHandlers.forEach(function(o) {
                            return o.call(t, e);
                        });
                    }
                }
            ], _s(o.prototype, n), t;
        }(Al);
        function Es(e, t, o, n) {
            var r = new zs(e);
            return r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1, Lo(t) ? (r.state.icon.name = t, r.state.name = t, n && (r.state.variant = n), o && (r.state.text = o)) : r.setState(t), r;
        }
        function Ts(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Is(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ps(e) {
            return Ps = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Ps(e);
        }
        function Rs(e, t) {
            return Rs = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Rs(e, t);
        }
        function As(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Ls() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Ls = function() {
                return !!e;
            })();
        }
        Os([
            vi
        ], zs.prototype, "text", null), Os([
            vi
        ], zs.prototype, "icon", null), Os([
            Ca("state.size", {
                immediately: !1
            })
        ], zs.prototype, "onChangeSize", null), Os([
            Ca("state.type", {
                immediately: !1
            })
        ], zs.prototype, "onChangeType", null), Os([
            Ca("state.role", {
                immediately: !1
            })
        ], zs.prototype, "onChangeRole", null), Os([
            Ca("parentElement")
        ], zs.prototype, "updateSize", null), Os([
            Ca("state.variant", {
                immediately: !1
            })
        ], zs.prototype, "onChangeStatus", null), Os([
            Ca("state.text", {
                immediately: !1
            })
        ], zs.prototype, "onChangeText", null), Os([
            Ca("state.text", {
                immediately: !1
            })
        ], zs.prototype, "onChangeTextSetMode", null), Os([
            Ca("state.disabled")
        ], zs.prototype, "onChangeDisabled", null), Os([
            Ca("state.activated")
        ], zs.prototype, "onChangeActivated", null), Os([
            Ca("state.name", {
                immediately: !1
            })
        ], zs.prototype, "onChangeName", null), Os([
            Ca("state.tooltip", {
                immediately: !1
            })
        ], zs.prototype, "onChangeTooltip", null), Os([
            Ca("state.tabIndex", {
                immediately: !1
            })
        ], zs.prototype, "onChangeTabIndex", null), Os([
            Ca("state.icon", {
                immediately: !1
            })
        ], zs.prototype, "onChangeIcon", null), Os([
            gi
        ], zs.prototype, "createContainer", null), Os([
            Ca("button:click")
        ], zs.prototype, "__onActionFire", null), zs = Os([
            ji
        ], zs);
        var Ms = function(e) {
            function t(e) {
                var o, n, r, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                    radio: !0
                };
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Ps(t), function(e, t) {
                        return !t || "object" !== As(t) && "function" != typeof t ? Ts(e) : t;
                    }(e, Ls() ? Reflect.construct(t, o || [], Ps(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    null === (n = i.options) || void 0 === n ? void 0 : n.map(function(t) {
                        var n = new zs(e, {
                            text: t.text,
                            value: t.value,
                            variant: "primary"
                        });
                        return n.onAction(function() {
                            Ts(o).select(t.value);
                        }), n;
                    }),
                    i
                ])).options = i, o.select(null !== (r = i.value) && void 0 !== r ? r : 0), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Rs(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIButtonGroup";
                    }
                },
                {
                    key: "render",
                    value: function(e) {
                        return '<div>\n\t\t\t<div class="&__label">~'.concat(e.label, '~</div>\n\t\t\t<div class="&__options"></div>\n\t\t</div>');
                    }
                },
                {
                    key: "appendChildToContainer",
                    value: function(e) {
                        var t = this.getElm("options");
                        $n(null != t, "Options does not exist"), t.appendChild(e);
                    }
                },
                {
                    key: "select",
                    value: function(e) {
                        var t, o, n = this;
                        this.elements.forEach(function(t, o) {
                            o === e || t.state.value === e ? t.state.activated = !0 : n.options.radio && (t.state.activated = !1);
                        });
                        var r = this.elements.filter(function(e) {
                            return e.state.activated;
                        }).map(function(e) {
                            return {
                                text: e.state.text,
                                value: e.state.value
                            };
                        });
                        this.jodit.e.fire(this, "select", r), null === (o = (t = this.options).onChange) || void 0 === o || o.call(t, r);
                    }
                }
            ], n && Is(o.prototype, n), t;
        }(Ul);
        function Bs(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ds(e, t, o) {
            return Ds = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ns(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Ds(e, t, o || e);
        }
        function Ns(e) {
            return Ns = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Ns(e);
        }
        function Hs(e, t) {
            return Hs = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Hs(e, t);
        }
        function Fs(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function qs() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (qs = function() {
                return !!e;
            })();
        }
        Ms = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : As(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Ms);
        var Vs, Ws = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Fs(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Us = [
            "scroll.tooltip",
            "joditCloseDialog",
            "mouseleave.tooltip"
        ], Ys = [
            "escape.tooltip",
            "change.tooltip",
            "changePlace.tooltip",
            "afterOpenPopup.tooltip",
            "hidePopup.tooltip",
            "beforePopupClose.tooltip",
            "closeAllPopups.tooltip"
        ], Ks = Vs = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Ns(t), function(e, t) {
                        return !t || "object" !== Fs(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, qs() ? Reflect.construct(t, o || [], Ns(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).__isOpened = !1, o.__attachedContainers = new Set, o.__listenClose = !1, o.__currentTarget = null, o.__delayShowTimeout = 0, o.__hideTimeout = 0, e.o.textIcons || !e.o.showTooltip || e.o.useNativeTooltip || (o.j.e.on("getContainer", function(e) {
                    o.__onAttach(e);
                }), e.hookStatus(Io.ready, function() {
                    o.__onAttach(o.j.container);
                })), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Hs(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UITooltip";
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return '<div><div class="&__content"></div></div>';
                    }
                },
                {
                    key: "__onAttach",
                    value: function(e) {
                        Ha(this.j, Vs).appendChild(this.container), this.__attachedContainers.add(e), this.__attachedContainers.add(this.j.container), this.j.e.on(e, "mouseenter.tooltip", this.__onMouseEnter, {
                            capture: !0
                        }).on(e, "mouseleave.tooltip", this.__onMouseLeave, {
                            capture: !0
                        }).on(this.j.container, "mouseleave.tooltip", this.__onMouseLeave, {
                            capture: !0
                        });
                    }
                },
                {
                    key: "__addListenersOnEnter",
                    value: function() {
                        if (!this.__listenClose) {
                            this.__listenClose = !0;
                            var e = this.j;
                            e.e.on(e.ow, Us, this.__hide).on(Ys, this.__hide);
                        }
                    }
                },
                {
                    key: "__removeListenersOnLeave",
                    value: function() {
                        if (this.__listenClose) {
                            this.__listenClose = !1;
                            var e = this.j;
                            e.e.off(e.ow, Us, this.__hide).off(Ys, this.__hide);
                        }
                    }
                },
                {
                    key: "__onMouseLeave",
                    value: function(e) {
                        this.__currentTarget === e.target && (this.__hideDelay(), this.__currentTarget = null);
                    }
                },
                {
                    key: "__onMouseEnter",
                    value: function(e) {
                        if (pi.isHTMLElement(e.target)) {
                            var t = er(e.target, "aria-label");
                            if (t && !Boolean(er(e.target, "disabled")) && e.target.className.includes("jodit")) {
                                this.__currentTarget = e.target;
                                var o = e.target;
                                this.__open(function() {
                                    var e = oa(o);
                                    return {
                                        x: e.left + e.width / 2,
                                        y: e.top + e.height
                                    };
                                }, t);
                            }
                        }
                    }
                },
                {
                    key: "__open",
                    value: function(e, t) {
                        var o = this;
                        this.__addListenersOnEnter(), this.__isOpened = !0, this.j.async.clearTimeout(this.__hideTimeout), this.j.async.clearTimeout(this.__delayShowTimeout);
                        var n = this.j.o.showTooltipDelay || this.j.defaultTimeout;
                        n ? this.__delayShowTimeout = this.j.async.setTimeout(function() {
                            return o.__show(e, t);
                        }, n) : this.__show(e, t);
                    }
                },
                {
                    key: "__show",
                    value: function(e, t) {
                        this.setMod("visible", !0), this.getElm("content").innerHTML = t;
                        var o = e();
                        Ln(this.container, {
                            left: o.x,
                            top: o.y
                        });
                    }
                },
                {
                    key: "__hide",
                    value: function() {
                        this.j.async.clearTimeout(this.__delayShowTimeout), this.j.async.clearTimeout(this.__hideTimeout), this.__removeListenersOnLeave(), this.__isOpened && (this.__isOpened = !1, this.setMod("visible", !1), this.getElm("content").innerHTML = "", Ln(this.container, {
                            left: -5000
                        }));
                    }
                },
                {
                    key: "__hideDelay",
                    value: function() {
                        this.j.async.clearTimeout(this.__delayShowTimeout), this.j.async.clearTimeout(this.__hideTimeout), this.__isOpened && (this.__hideTimeout = this.async.setTimeout(this.__hide, this.j.defaultTimeout));
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        var e = this;
                        this.__attachedContainers.forEach(function(t) {
                            e.j.e.off(t, "mouseenter.tooltip", e.__onMouseEnter).off(t, "mouseleave.tooltip", e.__onMouseLeave);
                        }), this.__hide(), Ds(Ns(t.prototype), "destruct", this).call(this);
                    }
                }
            ], Bs(o.prototype, n), t;
        }(Al);
        function Gs(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Js(e) {
            return Js = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Js(e);
        }
        function Xs(e, t) {
            return Xs = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Xs(e, t);
        }
        function Zs(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Qs() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Qs = function() {
                return !!e;
            })();
        }
        Ws([
            To
        ], Ks.prototype, "__onMouseLeave", null), Ws([
            To
        ], Ks.prototype, "__onMouseEnter", null), Ws([
            To
        ], Ks.prototype, "__hide", null), Ws([
            To
        ], Ks.prototype, "__hideDelay", null), Ks = Vs = Ws([
            ji
        ], Ks);
        var $s = function(e) {
            function t(e, o) {
                var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    align: "left"
                };
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Js(t), function(e, t) {
                        return !t || "object" !== Zs(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Qs() ? Reflect.construct(t, o || [], Js(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    o
                ])).options = r, n.setMod("align", n.options.align || "left"), n.setMod("width", n.options.width || ""), n.options.mod && n.setMod(n.options.mod, !0), n.options.className && n.container.classList.add(n.options.className), er(n.container, "data-ref", r.ref), er(n.container, "ref", r.ref), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Xs(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIBlock";
                    }
                }
            ], Gs(o.prototype, n), t;
        }(Ul);
        $s = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Zs(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], $s);
        var ec = function(e) {
            return !!vn(e.value).length || (e.error = "Please fill out this field", !1);
        }, tc = function(e) {
            return !!fn(vn(e.value)) || (e.error = "Please enter a web address", !1);
        }, oc = function(e) {
            return !!vn(e.value).length || (e.error = "Please fill out this field", !1);
        };
        function nc(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function rc(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function ic(e, t, o) {
            return ic = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = ac(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, ic(e, t, o || e);
        }
        function ac(e) {
            return ac = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ac(e);
        }
        function lc(e, t) {
            return lc = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, lc(e, t);
        }
        function sc(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function cc() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (cc = function() {
                return !!e;
            })();
        }
        var uc, dc = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : sc(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, fc = uc = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = ac(t), function(e, t) {
                        return !t || "object" !== sc(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, cc() ? Reflect.construct(t, o || [], ac(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    o
                ])).label = n.j.c.span(n.getFullElName("label")), n.icon = n.j.c.span(n.getFullElName("icon")), n.clearButton = n.j.c.span(n.getFullElName("clear"), Ol.get("cancel")), n.state = function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                            return Object.getOwnPropertyDescriptor(o, e).enumerable;
                        }))), n.forEach(function(t) {
                            rc(e, t, o[t]);
                        });
                    }
                    return e;
                }({}, uc.defaultState), n.__errorBox = n.j.c.span(n.getFullElName("error")), n.validators = new Set([]), void 0 !== (null == o ? void 0 : o.value) && (o.value = o.value.toString()), Object.assign(n.state, o), void 0 !== n.state.clearButton && (n.j.e.on(n.clearButton, "click", function(e) {
                    e.preventDefault(), n.nativeInput.value = "", n.j.e.fire(n.nativeInput, "input"), n.focus();
                }).on(n.nativeInput, "input", function() {
                    n.state.clearButton = Boolean(n.value.length);
                }), n.state.clearButton = Boolean(n.value.length)), n.j.e.on(n.nativeInput, "focus blur", function() {
                    n.onChangeFocus();
                }).on(n.nativeInput, "input change", n.onChangeValue), n.onChangeState(), n.onChangeClassName(), n.onChangeStateValue(), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && lc(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIInput";
                    }
                },
                {
                    key: "onChangeClear",
                    value: function() {
                        this.state.clearButton ? pi.after(this.nativeInput, this.clearButton) : pi.safeRemove(this.clearButton);
                    }
                },
                {
                    key: "onChangeClassName",
                    value: function(e, t) {
                        t && this.container.classList.remove(t), this.state.className && this.container.classList.add(this.state.className);
                    }
                },
                {
                    key: "onChangeState",
                    value: function() {
                        this.name = this.state.name;
                        var e = this.nativeInput, t = this.state, o = t.name, n = t.icon, r = t.type, i = t.ref, a = t.required, l = t.placeholder, s = t.autocomplete, c = t.label;
                        er(e, "name", o), er(e, "type", r), er(e, "data-ref", i || o), er(e, "ref", i || o), er(e, "required", a || null), er(e, "autocomplete", s ? null : "off"), er(e, "placeholder", l ? this.j.i18n(l) : ""), n && Ol.exists(n) ? (pi.before(e, this.icon), this.icon.innerHTML = Ol.get(n)) : pi.safeRemove(this.icon), c ? (pi.before(this.wrapper, this.label), this.label.innerText = this.j.i18n(c)) : pi.safeRemove(this.label), this.updateValidators();
                    }
                },
                {
                    key: "updateValidators",
                    value: function() {
                        var e, t = this;
                        this.validators.clear(), this.state.required && this.validators.add(ec), null === (e = this.state.validators) || void 0 === e || e.forEach(function(e) {
                            var o = s[e];
                            o && t.validators.add(o);
                        });
                    }
                },
                {
                    key: "error",
                    set: function(e) {
                        this.setMod("has-error", Boolean(e)), e ? (this.__errorBox.innerText = this.j.i18n(e, this.j.i18n(this.state.label || "")), this.container.appendChild(this.__errorBox)) : pi.safeRemove(this.__errorBox);
                    }
                },
                {
                    key: "value",
                    get: function() {
                        return this.nativeInput.value;
                    },
                    set: function(e) {
                        this.value !== e && (this.nativeInput.value = e, this.onChangeValue());
                    }
                },
                {
                    key: "onChangeStateValue",
                    value: function() {
                        var e = this.state.value.toString();
                        e !== this.value && (this.value = e);
                    }
                },
                {
                    key: "onChangeValue",
                    value: function() {
                        var e, t, o = this.value;
                        this.state.value !== o && (this.state.value = o, this.j.e.fire(this, "change", o), null === (t = (e = this.state).onChange) || void 0 === t || t.call(e, o));
                    }
                },
                {
                    key: "validate",
                    value: function() {
                        var e = this;
                        this.error = "";
                        var t = Fo(this.validators).every(function(t) {
                            return t(e);
                        });
                        return this.__markInputInvalid(), t;
                    }
                },
                {
                    key: "__markInputInvalid",
                    value: function() {
                        var e, t, o, n;
                        this.error ? (this.nativeInput.setAttribute("aria-invalid", "true"), null === (t = (e = this.nativeInput).setCustomValidity) || void 0 === t || t.call(e, this.error)) : (this.nativeInput.removeAttribute("aria-invalid"), null === (n = (o = this.nativeInput).setCustomValidity) || void 0 === n || n.call(o, ""));
                    }
                },
                {
                    key: "createContainer",
                    value: function(e) {
                        var o = ic(ac(t.prototype), "createContainer", this).call(this);
                        this.wrapper = this.j.c.div(this.getFullElName("wrapper")), this.nativeInput || (this.nativeInput = this.createNativeInput());
                        var n = this.nativeInput;
                        return n.classList.add(this.getFullElName("input")), this.wrapper.appendChild(n), o.appendChild(this.wrapper), er(n, "dir", this.j.o.direction || "auto"), o;
                    }
                },
                {
                    key: "createNativeInput",
                    value: function(e) {
                        return this.j.create.element("input");
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        this.nativeInput.focus();
                    }
                },
                {
                    key: "isFocused",
                    get: function() {
                        return this.nativeInput === this.j.od.activeElement;
                    }
                },
                {
                    key: "onChangeFocus",
                    value: function() {
                        this.setMod("focused", this.isFocused);
                    }
                }
            ], n && nc(o.prototype, n), t;
        }(Al);
        function pc(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function hc(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function vc(e, t, o) {
            return vc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = gc(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, vc(e, t, o || e);
        }
        function gc(e) {
            return gc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, gc(e);
        }
        function mc(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    hc(e, t, o[t]);
                });
            }
            return e;
        }
        function bc(e, t) {
            return bc = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, bc(e, t);
        }
        function yc(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function _c() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (_c = function() {
                return !!e;
            })();
        }
        fc.defaultState = {
            className: "",
            autocomplete: !0,
            name: "",
            value: "",
            icon: "",
            label: "",
            ref: "",
            type: "text",
            placeholder: "",
            required: !1,
            validators: []
        }, dc([
            Ca("state.clearButton")
        ], fc.prototype, "onChangeClear", null), dc([
            Ca("state.className")
        ], fc.prototype, "onChangeClassName", null), dc([
            Ca([
                "state.name",
                "state.type",
                "state.label",
                "state.placeholder",
                "state.autocomplete",
                "state.icon"
            ], {
                immediately: !1
            }),
            $a()
        ], fc.prototype, "onChangeState", null), dc([
            Ca("state.value")
        ], fc.prototype, "onChangeStateValue", null), dc([
            To
        ], fc.prototype, "onChangeValue", null), fc = uc = dc([
            ji
        ], fc);
        var jc, wc = jc = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = gc(t), function(e, t) {
                        return !t || "object" !== yc(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, _c() ? Reflect.construct(t, o || [], gc(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    o
                ])).state = mc({}, jc.defaultState), Object.assign(n.state, o), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && bc(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UISelect";
                    }
                },
                {
                    key: "createContainer",
                    value: function(e) {
                        var o, n = vc(gc(t.prototype), "createContainer", this).call(this, e), r = this.j, i = this.nativeInput, a = function() {
                            return r.create.element("option");
                        };
                        if (void 0 !== e.placeholder) {
                            var l = a();
                            l.value = "", l.text = r.i18n(e.placeholder), i.add(l);
                        }
                        return null === (o = e.options) || void 0 === o || o.forEach(function(e) {
                            var t = a();
                            t.value = e.value.toString(), t.text = r.i18n(e.text), i.add(t);
                        }), e.size && e.size > 0 && er(i, "size", e.size), e.multiple && er(i, "multiple", ""), n;
                    }
                },
                {
                    key: "createNativeInput",
                    value: function() {
                        return this.j.create.element("select");
                    }
                },
                {
                    key: "updateValidators",
                    value: function() {
                        vc(gc(t.prototype), "updateValidators", this).call(this), this.state.required && (this.validators.delete(ec), this.validators.add(oc));
                    }
                }
            ], pc(o.prototype, n), t;
        }(fc);
        function kc(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Sc(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function xc(e) {
            return xc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, xc(e);
        }
        function Oc(e, t) {
            return Oc = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Oc(e, t);
        }
        function Cc(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function zc() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (zc = function() {
                return !!e;
            })();
        }
        wc.defaultState = function(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }(mc({}, fc.defaultState), {
            options: [],
            size: 1,
            multiple: !1
        }), wc = jc = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : yc(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], wc);
        var Ec = function(e) {
            function t() {
                for(var e = arguments.length, o = new Array(e), n = 0; n < e; n++)o[n] = arguments[n];
                var r, i, a;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (null === (i = (r = function(e, t, o) {
                    return t = xc(t), function(e, t) {
                        return !t || "object" !== Cc(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, zc() ? Reflect.construct(t, o || [], xc(e).constructor) : t.apply(e, o));
                }(this, t, function(e) {
                    return function(e) {
                        if (Array.isArray(e)) return kc(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return kc(e, t);
                            var o = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? kc(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(o))).options) || void 0 === i ? void 0 : i.className) && r.container.classList.add(null === (a = r.options) || void 0 === a ? void 0 : a.className), r;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Oc(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIForm";
                    }
                },
                {
                    key: "submit",
                    value: function() {
                        this.j.e.fire(this.container, "submit");
                    }
                },
                {
                    key: "validate",
                    value: function() {
                        var e = this.allChildren.filter(function(e) {
                            return Ua.isInstanceOf(e, fc);
                        }), t = !0, o = !1, n = void 0;
                        try {
                            for(var r, i = e[Symbol.iterator](); !(t = (r = i.next()).done); t = !0)if (!r.value.validate()) return !1;
                        } catch (e) {
                            o = !0, n = e;
                        } finally{
                            try {
                                t || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        var a = this.allChildren.filter(function(e) {
                            return Ua.isInstanceOf(e, wc);
                        }), l = !0, s = !1, c = void 0;
                        try {
                            for(var u, d = a[Symbol.iterator](); !(l = (u = d.next()).done); l = !0)if (!u.value.validate()) return !1;
                        } catch (e) {
                            s = !0, c = e;
                        } finally{
                            try {
                                l || null == d.return || d.return();
                            } finally{
                                if (s) throw c;
                            }
                        }
                        return !0;
                    }
                },
                {
                    key: "onSubmit",
                    value: function(e) {
                        var t = this;
                        return this.j.e.on(this.container, "submit", function() {
                            var o = t.allChildren.filter(function(e) {
                                return Ua.isInstanceOf(e, fc);
                            });
                            return !!t.validate() && (e(o.reduce(function(e, t) {
                                return e[t.state.name] = t.value, e;
                            }, {})), !1);
                        }), this;
                    }
                },
                {
                    key: "createContainer",
                    value: function() {
                        var e = this.j.c.element("form");
                        return e.classList.add(this.componentName), er(e, "dir", this.j.o.direction || "auto"), er(e, "novalidate", ""), e;
                    }
                }
            ], n && Sc(o.prototype, n), t;
        }(Ul);
        function Tc(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ic(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function Pc(e) {
            return Pc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Pc(e);
        }
        function Rc(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    Ic(e, t, o[t]);
                });
            }
            return e;
        }
        function Ac(e, t) {
            return Ac = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Ac(e, t);
        }
        function Lc(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Mc() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Mc = function() {
                return !!e;
            })();
        }
        Ec = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Cc(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Ec);
        var Bc, Dc = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Lc(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Nc = Bc = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Pc(t), function(e, t) {
                        return !t || "object" !== Lc(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Mc() ? Reflect.construct(t, o || [], Pc(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    o
                ])).state = Rc({}, Bc.defaultState), Object.assign(n.state, o), !1 === n.state.resizable && (n.nativeInput.style.resize = "none"), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ac(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UITextArea";
                    }
                },
                {
                    key: "createNativeInput",
                    value: function(e) {
                        return this.j.create.element("textarea");
                    }
                },
                {
                    key: "onChangeStateSize",
                    value: function() {
                        var e = this.state, t = e.size, o = e.resizable;
                        this.nativeInput.style.resize = o ? "auto" : "none", this.nativeInput.rows = null != t ? t : 5;
                    }
                }
            ], n && Tc(o.prototype, n), t;
        }(fc);
        function Hc(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Fc(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function qc(e) {
            return qc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, qc(e);
        }
        function Vc(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    Fc(e, t, o[t]);
                });
            }
            return e;
        }
        function Wc(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }
        function Uc(e, t) {
            return Uc = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Uc(e, t);
        }
        function Yc(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Kc() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Kc = function() {
                return !!e;
            })();
        }
        Nc.defaultState = function(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }(Rc({}, fc.defaultState), {
            size: 5,
            resizable: !0
        }), Dc([
            Ca([
                "state.size",
                "state.resizable"
            ])
        ], Nc.prototype, "onChangeStateSize", null), Nc = Bc = Dc([
            ji
        ], Nc);
        var Gc, Jc = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Yc(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Xc = Gc = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = qc(t), function(e, t) {
                        return !t || "object" !== Yc(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Kc() ? Reflect.construct(t, o || [], qc(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    Wc(Vc({}, o), {
                        type: "checkbox"
                    })
                ])).state = Vc({}, Gc.defaultState), Object.assign(n.state, o), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Uc(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UICheckbox";
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return this.j.c.element("label", {
                            className: this.componentName
                        });
                    }
                },
                {
                    key: "onChangeChecked",
                    value: function() {
                        this.value = this.state.checked.toString(), this.nativeInput.checked = this.state.checked, this.setMod("checked", this.state.checked);
                    }
                },
                {
                    key: "onChangeNativeCheckBox",
                    value: function() {
                        this.state.checked = this.nativeInput.checked;
                    }
                },
                {
                    key: "onChangeSwitch",
                    value: function() {
                        this.setMod("switch", this.state.switch);
                        var e = this.getElm("switch-slider");
                        this.state.switch ? (e || (e = this.j.c.div(this.getFullElName("switch-slider"))), pi.after(this.nativeInput, e)) : pi.safeRemove(e);
                    }
                }
            ], Hc(o.prototype, n), t;
        }(fc);
        function Zc(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Qc(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function $c(e) {
            return $c = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, $c(e);
        }
        function eu(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    Qc(e, t, o[t]);
                });
            }
            return e;
        }
        function tu(e, t) {
            return tu = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, tu(e, t);
        }
        function ou(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function nu() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (nu = function() {
                return !!e;
            })();
        }
        Xc.defaultState = Wc(Vc({}, fc.defaultState), {
            checked: !1,
            switch: !1
        }), Jc([
            Ca("state.checked"),
            rl("ready")
        ], Xc.prototype, "onChangeChecked", null), Jc([
            Ca("nativeInput:change")
        ], Xc.prototype, "onChangeNativeCheckBox", null), Jc([
            Ca("state.switch"),
            rl("ready")
        ], Xc.prototype, "onChangeSwitch", null), Xc = Gc = Jc([
            ji
        ], Xc);
        var ru = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = $c(t), function(e, t) {
                        return !t || "object" !== ou(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, nu() ? Reflect.construct(t, o || [], $c(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    eu({
                        type: "file"
                    }, o)
                ])).state = function(e, t) {
                    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                        var t = Object.keys(e);
                        if (Object.getOwnPropertySymbols) {
                            var o = Object.getOwnPropertySymbols(e);
                            t.push.apply(t, o);
                        }
                        return t;
                    })(Object(t)).forEach(function(o) {
                        Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
                    }), e;
                }(eu({}, fc.defaultState), {
                    type: "file",
                    onlyImages: !0
                }), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && tu(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIFileInput";
                    }
                },
                {
                    key: "createContainer",
                    value: function(e) {
                        this.button = new zs(this.j, {
                            tooltip: e.tooltip,
                            icon: {
                                name: "plus"
                            }
                        });
                        var t = this.button.container;
                        this.nativeInput || (this.nativeInput = this.createNativeInput(e));
                        var o = this.nativeInput;
                        return o.classList.add(this.getFullElName("input")), t.classList.add(this.componentName), t.appendChild(o), t;
                    }
                },
                {
                    key: "createNativeInput",
                    value: function(e) {
                        return this.j.create.fromHTML('<input\n\t\t\ttype="file"\n\t\t\taccept="'.concat(e.onlyImages ? "image/*" : "*", '"\n\t\t\ttabindex="-1"\n\t\t\tdir="auto"\n\t\t\tmultiple=""\n\t\t/>'));
                    }
                }
            ], n && Zc(o.prototype, n), t;
        }(fc);
        function iu(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function au(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function lu(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function su(e, t, o) {
            return su = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = cu(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, su(e, t, o || e);
        }
        function cu(e) {
            return cu = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, cu(e);
        }
        function uu(e, t) {
            return uu = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, uu(e, t);
        }
        function du(e, t) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, t) {
                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != o) {
                    var n, r, i = [], a = !0, l = !1;
                    try {
                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                    } catch (e) {
                        l = !0, r = e;
                    } finally{
                        try {
                            a || null == o.return || o.return();
                        } finally{
                            if (l) throw r;
                        }
                    }
                    return i;
                }
            }(e, t) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return iu(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? iu(e, t) : void 0;
                }
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function fu(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function pu() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (pu = function() {
                return !!e;
            })();
        }
        ru = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : ou(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], ru);
        var hu = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : fu(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, vu = [
            "escape",
            "cut",
            "delete",
            "backSpaceAfterDelete",
            "beforeCommandDelete"
        ], gu = function(e) {
            function t(e) {
                var o, n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = cu(t), function(e, t) {
                        return !t || "object" !== fu(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, pu() ? Reflect.construct(t, o || [], cu(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).smart = n, o.isOpened = !1, o.strategy = "leftBottom", o.viewBound = function() {
                    return {
                        left: 0,
                        top: 0,
                        width: o.ow.innerWidth,
                        height: o.ow.innerHeight
                    };
                }, o.__childrenPopups = new Set, er(o.container, "role", "popup"), o;
            }
            var o, n, r;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && uu(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "Popup";
                    }
                },
                {
                    key: "appendChildToContainer",
                    value: function(e) {
                        var t = this.getElm("content");
                        $n(t, "Content element should exist"), t.appendChild(e);
                    }
                },
                {
                    key: "updateParentElement",
                    value: function(e) {
                        var o = this;
                        return e !== this && Ua.isInstanceOf(e, t) && (this.__childrenPopups.forEach(function(t) {
                            !e.closest(t) && t.isOpened && t.close();
                        }), this.__childrenPopups.has(e) || this.j.e.on(e, "beforeClose", function() {
                            o.__childrenPopups.delete(e);
                        }), this.__childrenPopups.add(e)), su(cu(t.prototype), "updateParentElement", this).call(this, e);
                    }
                },
                {
                    key: "setContent",
                    value: function(e) {
                        if (this.allChildren.length) throw new Error("Remove children");
                        if (Ua.isInstanceOf(e, Al)) this.append(e);
                        else {
                            var t = Lo(e) ? this.j.c.fromHTML(e) : e;
                            this.appendChildToContainer(t);
                        }
                        return this.updatePosition(), this;
                    }
                },
                {
                    key: "open",
                    value: function(e) {
                        var o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = arguments.length > 2 ? arguments[2] : void 0;
                        if (fr(this.jodit, this.container), this.container.classList.add("jodit_theme_".concat(this.jodit.o.theme)), this.__calculateZIndex(), this.isOpened = !0, this.__addGlobalListeners(), this.__targetBound = o ? this.getKeepBound(e) : e, n) n.appendChild(this.container);
                        else {
                            var r = Ha(this.jodit, t);
                            n !== this.container.parentElement && r.appendChild(this.container);
                        }
                        return this.updatePosition(), this.j.e.fire(this, "afterOpen"), this.j.e.fire("afterOpenPopup", this), this;
                    }
                },
                {
                    key: "__calculateZIndex",
                    value: function() {
                        var e = this;
                        if (!this.container.style.zIndex) {
                            var t = function(t) {
                                var o = t.container.style.zIndex || t.o.zIndex;
                                return !!o && (e.setZIndex(1 + parseInt(o.toString(), 10)), !0);
                            };
                            if (!t(this.j)) for(var o = this.parentElement; o;){
                                if (t(o.j)) return;
                                if (o.container.style.zIndex) return void this.setZIndex(1 + parseInt(o.container.style.zIndex.toString(), 10));
                                if (!o.parentElement && o.container.parentElement) {
                                    var n = Al.closestElement(o.container.parentElement, Al);
                                    if (n) {
                                        o = n;
                                        continue;
                                    }
                                }
                                o = o.parentElement;
                            }
                        }
                    }
                },
                {
                    key: "getKeepBound",
                    value: function(e) {
                        var t = this, o = e(), n = this.od.elementFromPoint(o.left, o.top);
                        if (!n) return e;
                        var r = pi.isHTMLElement(n) ? n : n.parentElement, i = oa(r, this.j);
                        return function() {
                            var o = e(), n = oa(r, t.j);
                            return function(e, t) {
                                return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                                    var t = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var o = Object.getOwnPropertySymbols(e);
                                        t.push.apply(t, o);
                                    }
                                    return t;
                                })(Object(t)).forEach(function(o) {
                                    Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
                                }), e;
                            }(function(e) {
                                for(var t = 1; t < arguments.length; t++){
                                    var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                                    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                        return Object.getOwnPropertyDescriptor(o, e).enumerable;
                                    }))), n.forEach(function(t) {
                                        lu(e, t, o[t]);
                                    });
                                }
                                return e;
                            }({}, o), {
                                top: o.top + (n.top - i.top),
                                left: o.left + (n.left - i.left)
                            });
                        };
                    }
                },
                {
                    key: "updatePosition",
                    value: function() {
                        if (!this.isOpened) return this;
                        var e = du(this.__calculatePosition(this.__targetBound(), this.viewBound(), oa(this.container, this.j)), 2), t = e[0], o = e[1];
                        return this.setMod("strategy", o), Ln(this.container, {
                            left: t.left,
                            top: t.top
                        }), this.__childrenPopups.forEach(function(e) {
                            return e.updatePosition();
                        }), this;
                    }
                },
                {
                    key: "__throttleUpdatePosition",
                    value: function() {
                        this.updatePosition();
                    }
                },
                {
                    key: "__calculatePosition",
                    value: function(e, o, n) {
                        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.strategy, i = {
                            left: e.left,
                            right: e.left - (n.width - e.width)
                        }, a = {
                            bottom: e.top + e.height,
                            top: e.top - n.height
                        }, l = Object.keys(i).reduce(function(e, t) {
                            return e.concat(Object.keys(a).map(function(e) {
                                return "".concat(t).concat(ra(e));
                            }));
                        }, []), s = function(e) {
                            var t = du(En(e).split("-"), 2), o = t[0], r = t[1];
                            return {
                                left: i[o],
                                top: a[r],
                                width: n.width,
                                height: n.height
                            };
                        }, c = function(e) {
                            var o;
                            return o = t.boxInView(s(r), e) ? r : l.find(function(o) {
                                if (t.boxInView(s(o), e)) return o;
                            }) || null, o;
                        }, u = c(oa(this.j.container, this.j));
                        return u && t.boxInView(s(u), o) || (u = c(o) || u || r), [
                            s(u),
                            u
                        ];
                    }
                },
                {
                    key: "close",
                    value: function() {
                        return this.isOpened ? (this.isOpened = !1, this.__childrenPopups.forEach(function(e) {
                            return e.close();
                        }), this.j.e.fire(this, "beforeClose"), this.j.e.fire("beforePopupClose", this), this.__removeGlobalListeners(), pi.safeRemove(this.container), this) : this;
                    }
                },
                {
                    key: "__closeOnOutsideClick",
                    value: function(e) {
                        this.isOpened && !this.isOwnClick(e) && this.close();
                    }
                },
                {
                    key: "isOwnClick",
                    value: function(e) {
                        if (!e.target) return !1;
                        var o = Al.closestElement(e.target, t);
                        return Boolean(o && (this === o || o.closest(this)));
                    }
                },
                {
                    key: "__addGlobalListeners",
                    value: function() {
                        var e = this, t = this.__throttleUpdatePosition, o = this.ow;
                        qa.on("closeAllPopups", this.close), this.smart && this.j.e.on(vu, this.close).on("mousedown touchstart", this.__closeOnOutsideClick).on(o, "mousedown touchstart", this.__closeOnOutsideClick), this.j.e.on("closeAllPopups", this.close).on("resize", t).on(this.container, "scroll mousewheel", t).on(o, "scroll", t).on(o, "resize", t), pi.up(this.j.container, function(o) {
                            o && e.j.e.on(o, "scroll mousewheel", t);
                        });
                    }
                },
                {
                    key: "__removeGlobalListeners",
                    value: function() {
                        var e = this, t = this.__throttleUpdatePosition, o = this.ow;
                        qa.off("closeAllPopups", this.close), this.smart && this.j.e.off(vu, this.close).off("mousedown touchstart", this.__closeOnOutsideClick).off(o, "mousedown touchstart", this.__closeOnOutsideClick), this.j.e.off("closeAllPopups", this.close).off("resize", t).off(this.container, "scroll mousewheel", t).off(o, "scroll", t).off(o, "resize", t), this.j.container.isConnected && pi.up(this.j.container, function(o) {
                            o && e.j.e.off(o, "scroll mousewheel", t);
                        });
                    }
                },
                {
                    key: "setZIndex",
                    value: function(e) {
                        this.container.style.zIndex = e.toString();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return '<div>\n\t\t\t<div class="&__content"></div>\n\t\t</div>';
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.close(), su(cu(t.prototype), "destruct", this).call(this);
                    }
                }
            ], r = [
                {
                    key: "boxInView",
                    value: function(e, t) {
                        return e.top - t.top >= -2 && e.left - t.left >= -2 && t.top + t.height - (e.top + e.height) >= -2 && t.left + t.width - (e.left + e.width) >= -2;
                    }
                }
            ], n && au(o.prototype, n), r && au(o, r), t;
        }(Ul);
        function mu(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function bu(e, t, o) {
            return bu = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = yu(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, bu(e, t, o || e);
        }
        function yu(e) {
            return yu = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, yu(e);
        }
        function _u(e, t) {
            return _u = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, _u(e, t);
        }
        function ju() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ju = function() {
                return !!e;
            })();
        }
        hu([
            To
        ], gu.prototype, "updatePosition", null), hu([
            el(10),
            To
        ], gu.prototype, "__throttleUpdatePosition", null), hu([
            To
        ], gu.prototype, "close", null), hu([
            To
        ], gu.prototype, "__closeOnOutsideClick", null);
        var wu = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = yu(o = t), function(e, t) {
                    var o;
                    return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, ju() ? Reflect.construct(o, n || [], yu(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && _u(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ProgressBar";
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return "<div><div></div></div>";
                    }
                },
                {
                    key: "show",
                    value: function() {
                        return (this.j.workplace || this.j.container).appendChild(this.container), this;
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        return pi.safeRemove(this.container), this;
                    }
                },
                {
                    key: "progress",
                    value: function(e) {
                        return this.container.style.width = e.toFixed(2) + "%", this;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.hide(), bu(yu(t.prototype), "destruct", this).call(this);
                    }
                }
            ], mu(o.prototype, n), t;
        }(Al);
        function ku(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Su = function() {
            function e(t, o) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.document = t, this.createAttributes = o;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "doc",
                    get: function() {
                        return Ro(this.document) ? this.document() : this.document;
                    }
                },
                {
                    key: "element",
                    value: function(e, t, o) {
                        var n = this, r = this.doc.createElement(e.toLowerCase());
                        return this.applyCreateAttributes(r), t && (cn(t) ? er(r, t) : o = t), o && Ii(o).forEach(function(e) {
                            return r.appendChild(Lo(e) ? n.fromHTML(e) : e);
                        }), r;
                    }
                },
                {
                    key: "div",
                    value: function(e, t, o) {
                        var n = this.element("div", t, o);
                        return e && (n.className = e), n;
                    }
                },
                {
                    key: "sandbox",
                    value: function() {
                        var e, t = this.element("iframe", {
                            sandbox: "allow-same-origin"
                        });
                        this.doc.body.appendChild(t);
                        var o = null === (e = t.contentWindow) || void 0 === e ? void 0 : e.document;
                        if ($n(o, "iframe.contentWindow.document"), !o) throw Error("Iframe error");
                        return o.open(), o.write("<!DOCTYPE html><html><head></head><body></body></html>"), o.close(), [
                            o.body,
                            t
                        ];
                    }
                },
                {
                    key: "span",
                    value: function(e, t, o) {
                        var n = this.element("span", t, o);
                        return e && (n.className = e), n;
                    }
                },
                {
                    key: "a",
                    value: function(e, t, o) {
                        var n = this.element("a", t, o);
                        return e && (n.className = e), n;
                    }
                },
                {
                    key: "text",
                    value: function(e) {
                        return this.doc.createTextNode(e);
                    }
                },
                {
                    key: "fake",
                    value: function() {
                        return this.text(bt);
                    }
                },
                {
                    key: "fragment",
                    value: function() {
                        return this.doc.createDocumentFragment();
                    }
                },
                {
                    key: "fromHTML",
                    value: function(e, t) {
                        var o = this.div();
                        o.innerHTML = e.toString();
                        var n = o.firstChild === o.lastChild && o.firstChild ? o.firstChild : o;
                        if (pi.safeRemove(n), t) {
                            var r = ei(n);
                            Object.keys(t).forEach(function(e) {
                                var o = r[e];
                                o && !1 === t[e] && pi.hide(o);
                            });
                        }
                        return n;
                    }
                },
                {
                    key: "applyCreateAttributes",
                    value: function(e) {
                        if (this.createAttributes) {
                            var t = this.createAttributes;
                            if (t && t[e.tagName.toLowerCase()]) {
                                var o = t[e.tagName.toLowerCase()];
                                Ro(o) ? o(e) : cn(o) && er(e, o);
                            }
                        }
                    }
                }
            ], o && ku(t.prototype, o), e;
        }();
        function xu(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Ou, Cu = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.rootKey = t;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "set",
                    value: function(e, t) {
                        try {
                            var o = localStorage.getItem(this.rootKey), n = o ? JSON.parse(o) : {};
                            n[e] = t, localStorage.setItem(this.rootKey, JSON.stringify(n));
                        } catch (e) {}
                        return this;
                    }
                },
                {
                    key: "delete",
                    value: function(e) {
                        try {
                            localStorage.removeItem(this.rootKey);
                        } catch (e) {}
                        return this;
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        try {
                            var t = localStorage.getItem(this.rootKey), o = t ? JSON.parse(t) : {};
                            return void 0 !== o[e] ? o[e] : void 0;
                        } catch (e) {}
                    }
                },
                {
                    key: "exists",
                    value: function(e) {
                        return null != this.get(e);
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        try {
                            localStorage.removeItem(this.rootKey);
                        } catch (e) {}
                        return this;
                    }
                }
            ], o && xu(t.prototype, o), e;
        }();
        function zu(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Eu = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.data = new Map;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "set",
                    value: function(e, t) {
                        return this.data.set(e, t), this;
                    }
                },
                {
                    key: "delete",
                    value: function(e) {
                        return this.data.delete(e), this;
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        return this.data.get(e);
                    }
                },
                {
                    key: "exists",
                    value: function(e) {
                        return this.data.has(e);
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        return this.data.clear(), this;
                    }
                }
            ], o && zu(t.prototype, o), e;
        }();
        function Tu(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Iu = "Jodit_", Pu = function() {
            function e(t, o) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.provider = t, this.prefix = Iu, o && (this.prefix += o);
            }
            var t, o, n;
            return t = e, o = [
                {
                    key: "set",
                    value: function(e, t) {
                        return this.provider.set(An(this.prefix + e), t), this;
                    }
                },
                {
                    key: "delete",
                    value: function(e) {
                        return this.provider.delete(An(this.prefix + e)), this;
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        return this.provider.get(An(this.prefix + e));
                    }
                },
                {
                    key: "exists",
                    value: function(e) {
                        return this.provider.exists(An(this.prefix + e));
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        return this.provider.clear(), this;
                    }
                }
            ], n = [
                {
                    key: "makeStorage",
                    value: function() {
                        var t, o = arguments.length > 1 ? arguments[1] : void 0;
                        return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (void 0 === Ou && (Ou = function() {
                            var e = "___Jodit___" + Math.random().toString();
                            try {
                                localStorage.setItem(e, "1");
                                var t = "1" === localStorage.getItem(e);
                                return localStorage.removeItem(e), t;
                            } catch (e) {}
                            return !1;
                        }()), Ou) && (t = new Cu(Iu + o)), t || (t = new Eu), new e(t, o);
                    }
                }
            ], o && Tu(t.prototype, o), n && Tu(t, n), e;
        }();
        function Ru(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Au(e) {
            return Au = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Au(e);
        }
        function Lu(e, t) {
            return Lu = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Lu(e, t);
        }
        function Mu(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Bu() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Bu = function() {
                return !!e;
            })();
        }
        var Du = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Au(t), function(e, t) {
                        return !t || "object" !== Mu(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Bu() ? Reflect.construct(t, o || [], Au(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).setMod("active", !0), n.setMod("variant", o.variant), n.container.textContent = o.text, n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Lu(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIMessage";
                    }
                }
            ], Ru(o.prototype, n), t;
        }(Al);
        function Nu(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Hu(e) {
            return Hu = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Hu(e);
        }
        function Fu(e, t) {
            return Fu = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Fu(e, t);
        }
        function qu(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Vu() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Vu = function() {
                return !!e;
            })();
        }
        Du = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Mu(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Du);
        var Wu = function(e) {
            function t(e, o) {
                var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    defaultTimeout: 3e3,
                    defaultOffset: 5
                };
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Hu(t), function(e, t) {
                        return !t || "object" !== qu(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Vu() ? Reflect.construct(t, o || [], Hu(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).__box = o, n.options = r, n.__messages = new Set, n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Fu(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIMessages";
                    }
                },
                {
                    key: "info",
                    value: function(e, t) {
                        this.__message(e, "info", t);
                    }
                },
                {
                    key: "success",
                    value: function(e, t) {
                        this.__message(e, "success", t);
                    }
                },
                {
                    key: "error",
                    value: function(e, t) {
                        this.__message(e, "error", t);
                    }
                },
                {
                    key: "message",
                    value: function(e, t, o) {
                        this.__message(e, t, o);
                    }
                },
                {
                    key: "__message",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "info", o = arguments.length > 2 ? arguments[2] : void 0, n = e + ":" + t;
                        if (this.__messages.has(n)) this.async.updateTimeout(n, o || this.options.defaultTimeout);
                        else {
                            if (!this.__box) throw new Error("Container is not defined: " + n);
                            this.__box.appendChild(this.container);
                            var r = new Du(this.j, {
                                text: e,
                                variant: t
                            });
                            this.append(r), this.__calcOffsets(), this.__messages.add(n);
                            var i = this.__getRemoveCallback(r, n);
                            this.j.e.on(r.container, "pointerdown", i), this.async.setTimeout(i, {
                                label: n,
                                timeout: o || this.options.defaultTimeout
                            });
                        }
                    }
                },
                {
                    key: "__getRemoveCallback",
                    value: function(e, t) {
                        var o = this, n = function(r) {
                            r && r.preventDefault(), e.isInDestruct || (o.async.clearTimeout(t), o.j.e.off(e.container, "pointerdown", n), o.__messages.delete(t), e.setMod("active", !1), o.async.setTimeout(function() {
                                o.remove(e), e.destruct(), o.__calcOffsets();
                            }, 300));
                        };
                        return n;
                    }
                },
                {
                    key: "__calcOffsets",
                    value: function() {
                        var e = this, t = 5;
                        this.elements.forEach(function(o) {
                            Ln(o.container, "bottom", t + "px"), t += o.container.offsetHeight + e.options.defaultOffset;
                        });
                    }
                }
            ], n && Nu(o.prototype, n), t;
        }(Ul);
        function Uu(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Yu(e, t, o) {
            return Yu = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ku(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Yu(e, t, o || e);
        }
        function Ku(e) {
            return Ku = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Ku(e);
        }
        function Gu(e, t) {
            return Gu = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Gu(e, t);
        }
        function Ju(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Xu() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Xu = function() {
                return !!e;
            })();
        }
        Wu = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : qu(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Wu);
        var Zu, Qu = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Ju(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, $u = Zu = function(e) {
            function t(e) {
                var o, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Ku(t), function(e, t) {
                        return !t || "object" !== Ju(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Xu() ? Reflect.construct(t, o || [], Ku(e).constructor) : t.apply(e, o));
                }(this, t)).isJodit = n, o.isView = !0, o.parent = null, o.mods = {}, o.components = new Set, o.OPTIONS = Zu.defaultOptions, o.__isFullSize = !1, o.__whoLocked = "", o.isLockedNotBy = function(e) {
                    return o.isLocked && o.__whoLocked !== e;
                }, o.__modulesInstances = new Map, o.id = (new Date).getTime().toString(), o.initOptions(e), o.initOwners(), o.events = new ja(o.od), o.create = new Su(o.od), o.container = o.c.div("jodit ".concat(o.componentName)), o;
            }
            var o, n, r;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Gu(e, t);
            }(t, e), o = t, n = [
                {
                    key: "basePath",
                    get: function() {
                        return this.o.basePath ? this.o.basePath : yo;
                    }
                },
                {
                    key: "minified",
                    get: function() {
                        return void 0 !== this.o.minified ? this.o.minified : _o;
                    }
                },
                {
                    key: "defaultTimeout",
                    get: function() {
                        return Bo(this.o.defaultTimeout) ? 100 : this.o.defaultTimeout;
                    }
                },
                {
                    key: "buffer",
                    get: function() {
                        return Pu.makeStorage();
                    }
                },
                {
                    key: "message",
                    get: function() {
                        return this.getMessageModule(this.container);
                    }
                },
                {
                    key: "getMessageModule",
                    value: function(e) {
                        return new Wu(this, e);
                    }
                },
                {
                    key: "storage",
                    get: function() {
                        return Pu.makeStorage(!0, this.id);
                    }
                },
                {
                    key: "c",
                    get: function() {
                        return this.create;
                    }
                },
                {
                    key: "container",
                    get: function() {
                        return this.__container;
                    },
                    set: function(e) {
                        this.__container = e;
                    }
                },
                {
                    key: "e",
                    get: function() {
                        return this.events;
                    }
                },
                {
                    key: "progressbar",
                    get: function() {
                        return new wu(this);
                    }
                },
                {
                    key: "options",
                    get: function() {
                        return this.__options;
                    },
                    set: function(e) {
                        this.__options = e;
                    }
                },
                {
                    key: "o",
                    get: function() {
                        return this.options;
                    }
                },
                {
                    key: "i18n",
                    value: function(e) {
                        for(var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)o[n - 1] = arguments[n];
                        return aa(e, o, this.options);
                    }
                },
                {
                    key: "toggleFullSize",
                    value: function(e) {
                        void 0 === e && (e = !this.__isFullSize), e !== this.__isFullSize && (this.__isFullSize = e, this.e.fire("toggleFullSize", e));
                    }
                },
                {
                    key: "isLocked",
                    get: function() {
                        return "" !== this.__whoLocked;
                    }
                },
                {
                    key: "lock",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "any";
                        return !this.isLocked && (this.__whoLocked = e, !0);
                    }
                },
                {
                    key: "unlock",
                    value: function() {
                        return !!this.isLocked && (this.__whoLocked = "", !0);
                    }
                },
                {
                    key: "isFullSize",
                    get: function() {
                        return this.__isFullSize;
                    }
                },
                {
                    key: "getVersion",
                    value: function() {
                        return Zu.version;
                    }
                },
                {
                    key: "initOptions",
                    value: function(e) {
                        this.options = _r(e || {}, _r(this.options || {}, Zu.defaultOptions));
                    }
                },
                {
                    key: "initOwners",
                    value: function() {
                        var e;
                        this.ownerWindow = null !== (e = this.o.ownerWindow) && void 0 !== e ? e : window;
                    }
                },
                {
                    key: "attachEvents",
                    value: function(e) {
                        var t = this;
                        if (e) {
                            var o = null == e ? void 0 : e.events;
                            o && Object.keys(o).forEach(function(e) {
                                return t.e.on(e, o[e]);
                            });
                        }
                    }
                },
                {
                    key: "getInstance",
                    value: function(e, t) {
                        var o = Ro(e) ? e.prototype.className() : e, n = this.e.fire(An("getInstance_" + o), t);
                        if (n) return n;
                        var r, i, a = Ro(e) ? e : Ba[o], l = this.__modulesInstances;
                        if (!Ro(a)) throw Fr("Need real module name");
                        if (!l.has(o)) {
                            var s = (r = a.prototype, (null != (i = Qa) && "undefined" != typeof Symbol && i[Symbol.hasInstance] ? i[Symbol.hasInstance](r) : r instanceof i) ? new a(this, t) : new a(t));
                            this.components.add(s), l.set(o, s);
                        }
                        return l.get(o);
                    }
                },
                {
                    key: "addDisclaimer",
                    value: function(e) {
                        this.container.appendChild(e);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.e.fire(Io.beforeDestruct, this), this.components.forEach(function(e) {
                            Qo(e) && !e.isInDestruct && e.destruct();
                        }), this.components.clear();
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        var e, o, n;
                        this.isDestructed || (null === (e = hi(this, "progressbar")) || void 0 === e || e.destruct(), null === (o = hi(this, "message")) || void 0 === o || o.destruct(), this.events && (this.events.destruct(), this.events = void 0), null === (n = hi(this, "buffer")) || void 0 === n || n.clear(), pi.safeRemove(this.container), Yu(Ku(t.prototype), "destruct", this).call(this));
                    }
                }
            ], r = [
                {
                    key: "getVersion",
                    value: function() {
                        return Zu.version;
                    }
                }
            ], n && Uu(o.prototype, n), r && Uu(o, r), t;
        }(Ua);
        function ed(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function td(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function od(e, t, o) {
            return od = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = nd(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, od(e, t, o || e);
        }
        function nd(e) {
            return nd = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, nd(e);
        }
        function rd(e, t) {
            return rd = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, rd(e, t);
        }
        function id(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ad() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ad = function() {
                return !!e;
            })();
        }
        $u.ES = ct, $u.version = st, $u.esNext = dt, $u.esModern = ut, Qu([
            vi
        ], $u.prototype, "buffer", null), Qu([
            vi
        ], $u.prototype, "message", null), Qu([
            vi
        ], $u.prototype, "storage", null), Qu([
            vi
        ], $u.prototype, "c", null), Qu([
            vi
        ], $u.prototype, "e", null), Qu([
            vi
        ], $u.prototype, "progressbar", null), Qu([
            rl(Io.beforeDestruct)
        ], $u.prototype, "beforeDestruct", null), ($u = Zu = Qu([
            nl(Sl, wl)
        ], $u)).defaultOptions = {
            extraButtons: [],
            cache: !0,
            textIcons: !1,
            namespace: "",
            removeButtons: [],
            zIndex: 100002,
            defaultTimeout: 100,
            fullsize: !1,
            showTooltip: !0,
            useNativeTooltip: !1,
            buttons: [],
            globalFullSize: !0,
            language: "auto"
        };
        var ld = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : id(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, sd = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = nd(t), function(e, t) {
                        return !t || "object" !== id(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ad() ? Reflect.construct(t, o || [], nd(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).__listenEvents = "updatePlugins updateToolbar changeStack mousedown mouseup keydown change afterInit readonly afterResize selectionchange changeSelection focus afterSetMode touchstart focus blur", o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && rd(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ToolbarCollection";
                    }
                },
                {
                    key: "firstButton",
                    get: function() {
                        return function(e, t) {
                            return function(e) {
                                if (Array.isArray(e)) return e;
                            }(e) || function(e, t) {
                                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (null != o) {
                                    var n, r, i = [], a = !0, l = !1;
                                    try {
                                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                    } catch (e) {
                                        l = !0, r = e;
                                    } finally{
                                        try {
                                            a || null == o.return || o.return();
                                        } finally{
                                            if (l) throw r;
                                        }
                                    }
                                    return i;
                                }
                            }(e, t) || function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return ed(e, t);
                                    var o = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? ed(e, t) : void 0;
                                }
                            }(e, t) || function() {
                                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }();
                        }(this.buttons, 1)[0] || null;
                    }
                },
                {
                    key: "makeButton",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        return Wd(this.j, e, t);
                    }
                },
                {
                    key: "makeSelect",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        return function(e, t) {
                            return new Ld(e, t, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null);
                        }(this.j, e, t);
                    }
                },
                {
                    key: "shouldBeActive",
                    value: function(e) {}
                },
                {
                    key: "shouldBeDisabled",
                    value: function(e) {}
                },
                {
                    key: "getTarget",
                    value: function(e) {
                        return e.target || null;
                    }
                },
                {
                    key: "__immediateUpdate",
                    value: function() {
                        this.isDestructed || this.j.isLocked || (od(nd(t.prototype), "update", this).call(this), this.j.e.fire("afterUpdateToolbar", this));
                    }
                },
                {
                    key: "update",
                    value: function() {
                        this.__immediateUpdate();
                    }
                },
                {
                    key: "setDirection",
                    value: function(e) {
                        this.container.style.direction = e, this.container.setAttribute("dir", e);
                    }
                },
                {
                    key: "__initEvents",
                    value: function() {
                        this.j.e.on(this.__listenEvents, this.update).on("afterSetMode focus", this.__immediateUpdate);
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        this.container.remove();
                    }
                },
                {
                    key: "show",
                    value: function() {
                        this.appendTo(this.j.toolbarContainer);
                    }
                },
                {
                    key: "showInline",
                    value: function(e) {
                        throw Fr("The method is not implemented for this class.");
                    }
                },
                {
                    key: "build",
                    value: function(e) {
                        var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = this.j.e.fire("beforeToolbarBuild", e);
                        return n && (e = n), od(nd(t.prototype), "build", this).call(this, e, o), this;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.isDestructed || (this.j.e.off(this.__listenEvents, this.update).off("afterSetMode focus", this.__immediateUpdate), od(nd(t.prototype), "destruct", this).call(this));
                    }
                }
            ], n && td(o.prototype, n), t;
        }(ys);
        function cd(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function ud(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function dd(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function fd(e, t, o) {
            return fd = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = pd(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, fd(e, t, o || e);
        }
        function pd(e) {
            return pd = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, pd(e);
        }
        function hd(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    dd(e, t, o[t]);
                });
            }
            return e;
        }
        function vd(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }
        function gd(e, t) {
            return gd = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, gd(e, t);
        }
        function md(e) {
            return function(e) {
                if (Array.isArray(e)) return cd(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return cd(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? cd(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function bd(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function yd() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (yd = function() {
                return !!e;
            })();
        }
        ld([
            To
        ], sd.prototype, "__immediateUpdate", null), ld([
            $a(function(e) {
                return e.j.defaultTimeout;
            }, !0)
        ], sd.prototype, "update", null), ld([
            rl("ready")
        ], sd.prototype, "__initEvents", null), sd = ld([
            ji
        ], sd);
        var _d = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : bd(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, jd = function(e) {
            function t(e, o) {
                var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = pd(t), function(e, t) {
                        return !t || "object" !== bd(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, yd() ? Reflect.construct(t, o || [], pd(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).control = o, n.target = r, n.state = vd(hd({}, Cs()), {
                    theme: "toolbar",
                    currentValue: "",
                    hasTrigger: !1
                }), n.openedPopup = null;
                var i = n.getElm("button");
                $n(i, "Element button should exists"), n.button = i, Object.defineProperty(i, "component", {
                    value: n,
                    configurable: !0
                });
                var a = n.getElm("trigger");
                return $n(a, "Element trigger should exists"), n.trigger = a, a.remove(), e.e.on([
                    n.button,
                    n.trigger
                ], "mousedown", function(e) {
                    return e.preventDefault();
                }), n.onAction(n.onClick), n.hookStatus(Io.ready, function() {
                    n.__initFromControl(), n.update();
                }), o.mods && Object.keys(o.mods).forEach(function(e) {
                    o.mods && n.setMod(e, o.mods[e]);
                }), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && gd(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ToolbarButton";
                    }
                },
                {
                    key: "toolbar",
                    get: function() {
                        return this.closest(sd);
                    }
                },
                {
                    key: "update",
                    value: function() {
                        var e, t, o = this.control, n = this.state, r = this.closest(sd);
                        if (r) {
                            var i = null === (e = o.value) || void 0 === e ? void 0 : e.call(o, r.jodit, this);
                            void 0 !== i && (n.value = i), n.disabled = this.__calculateDisabledStatus(r), n.activated = this.__calculateActivatedStatus(r), null === (t = o.update) || void 0 === t || t.call(o, r.jodit, this);
                        }
                    }
                },
                {
                    key: "__calculateActivatedStatus",
                    value: function(e) {
                        var t, o;
                        return !(nn(this.j) && !this.j.editorIsActive) && (!!(null === (o = (t = this.control).isActive) || void 0 === o ? void 0 : o.call(t, this.j, this)) || Boolean(e && e.shouldBeActive(this)));
                    }
                },
                {
                    key: "__calculateDisabledStatus",
                    value: function(e) {
                        var t, o;
                        return !!this.j.o.disabled || !(!this.j.o.readonly || this.j.o.activeButtonsInReadOnly && this.j.o.activeButtonsInReadOnly.includes(this.control.name)) || !!(null === (o = (t = this.control).isDisabled) || void 0 === o ? void 0 : o.call(t, this.j, this)) || Boolean(e && e.shouldBeDisabled(this));
                    }
                },
                {
                    key: "onChangeActivated",
                    value: function() {
                        er(this.button, "aria-pressed", this.state.activated), fd(pd(t.prototype), "onChangeActivated", this).call(this);
                    }
                },
                {
                    key: "onChangeText",
                    value: function() {
                        Ro(this.control.template) ? this.text.innerHTML = this.control.template(this.j, this.control.name, this.j.i18n(this.state.text)) : fd(pd(t.prototype), "onChangeText", this).call(this), this.setMod("text-icons", Boolean(this.text.innerText.trim().length));
                    }
                },
                {
                    key: "onChangeTabIndex",
                    value: function() {
                        er(this.button, "tabindex", this.state.tabIndex);
                    }
                },
                {
                    key: "createContainer",
                    value: function() {
                        var e = this.componentName, o = this.j.c.span(e), n = fd(pd(t.prototype), "createContainer", this).call(this);
                        er(o, "role", "listitem"), n.classList.remove(e), n.classList.add(e + "__button"), Object.defineProperty(n, "component", {
                            value: this
                        }), o.appendChild(n);
                        var r = this.j.c.fromHTML('<span role="trigger" class="'.concat(e, '__trigger">').concat(Ol.get("chevron"), "</span>"));
                        return n.appendChild(r), o;
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        var e;
                        null === (e = this.container.querySelector("button")) || void 0 === e || e.focus();
                    }
                },
                {
                    key: "onChangeHasTrigger",
                    value: function() {
                        this.state.hasTrigger ? this.container.appendChild(this.trigger) : pi.safeRemove(this.trigger), this.setMod("with-trigger", this.state.hasTrigger || null);
                    }
                },
                {
                    key: "onChangeDisabled",
                    value: function() {
                        var e = this.state.disabled ? "disabled" : null;
                        er(this.trigger, "disabled", e), er(this.button, "disabled", e), er(this.container, "disabled", e);
                    }
                },
                {
                    key: "__initFromControl",
                    value: function() {
                        var e, t = this.control, o = this.state;
                        this.updateSize(), o.name = t.name;
                        var n = this.j.o.textIcons;
                        if (!0 === n || Ro(n) && n(t.name) || t.template) o.icon = Cs().icon, o.text = t.text || t.name;
                        else {
                            if (t.iconURL) o.icon.iconURL = t.iconURL;
                            else {
                                var r = t.icon || t.name;
                                o.icon.name = Ol.exists(r) || (null === (e = this.j.o.extraIcons) || void 0 === e ? void 0 : e[r]) ? r : "";
                            }
                            t.iconURL || o.icon.name || (o.text = t.text || t.name);
                        }
                        t.tooltip && (o.tooltip = this.j.i18n(Ro(t.tooltip) ? t.tooltip(this.j, t, this) : t.tooltip)), o.hasTrigger = Boolean(t.list || t.popup && t.exec);
                    }
                },
                {
                    key: "onTriggerClick",
                    value: function(e) {
                        var t, o, n, r = this;
                        if (this.openedPopup) this.__closePopup();
                        else {
                            var i = this.control;
                            if (e.buffer = {
                                actionTrigger: this
                            }, i.list) return this.__openControlList(i);
                            if (Ro(i.popup)) {
                                var a = this.openPopup();
                                a.parentElement = this;
                                try {
                                    if (!1 !== this.j.e.fire(An("before-".concat(i.name, "-open-popup")), this.target, i, a)) {
                                        var l = null !== (n = null !== (o = null === (t = this.toolbar) || void 0 === t ? void 0 : t.getTarget(this)) && void 0 !== o ? o : this.target) && void 0 !== n ? n : null, s = i.popup(this.j, l, this.__closePopup, this);
                                        s ? a.setContent(Lo(s) ? this.j.c.fromHTML(s) : s).open(function() {
                                            return oa(r.container);
                                        }, !1, this.j.o.allowTabNavigation ? this.container : void 0) : this.__closePopup();
                                    }
                                } catch (e) {
                                    throw this.__closePopup(), e;
                                }
                                this.j.e.fire(An("after-".concat(i.name, "-open-popup")), a.container);
                            }
                        }
                    }
                },
                {
                    key: "__openControlList",
                    value: function(e) {
                        var t, o = this, n = null !== (t = this.jodit.options.controls) && void 0 !== t ? t : {}, r = function(e) {
                            return fs(e, n);
                        }, i = e.list, a = this.openPopup(), l = Vd(this.j);
                        a.parentElement = this, l.parentElement = a, l.mode = "vertical";
                        var s = function(t, n) {
                            if (Lo(n) && r(n)) return hd({
                                name: n.toString()
                            }, r(n));
                            if (Lo(t) && r(t)) return hd({
                                name: t.toString()
                            }, r(t), "object" === (void 0 === n ? "undefined" : bd(n)) ? n : {});
                            (function(e) {
                                return cn(e) && "title" in e && "value" in e;
                            })(t) && (n = t.value, t = t.title);
                            var i = e.childTemplate, a = {
                                name: t.toString(),
                                template: i && function(e, t, n) {
                                    return i(e, t, n, o);
                                },
                                exec: e.childExec ? function(t, o, n) {
                                    var r;
                                    return null === (r = e.childExec) || void 0 === r ? void 0 : r.call(e, t, o, vd(hd({}, n), {
                                        parentControl: e
                                    }));
                                } : e.exec,
                                data: e.data,
                                command: e.command,
                                isActive: e.isChildActive,
                                value: e.value,
                                isDisabled: e.isChildDisabled,
                                mode: e.mode,
                                args: md(e.args ? e.args : []).concat([
                                    t,
                                    n
                                ])
                            };
                            return Lo(n) && (a.text = n), a;
                        };
                        l.build(Ao(i) ? i.map(s) : vr(i, !1).map(function(e) {
                            return s(e, i[e]);
                        }), this.target), a.setContent(l).open(function() {
                            return oa(o.container);
                        }, !1, this.j.o.allowTabNavigation ? this.container : void 0), this.state.activated = !0;
                    }
                },
                {
                    key: "onOutsideClick",
                    value: function(e) {
                        this.openedPopup && (e && pi.isNode(e.target) && (pi.isOrContains(this.container, e.target) || this.openedPopup.isOwnClick(e)) || this.__closePopup());
                    }
                },
                {
                    key: "openPopup",
                    value: function() {
                        return this.__closePopup(), this.openedPopup = new gu(this.j, !1), this.j.e.on(this.ow, "mousedown touchstart", this.onOutsideClick).on("escape closeAllPopups", this.onOutsideClick), this.openedPopup;
                    }
                },
                {
                    key: "__closePopup",
                    value: function() {
                        this.openedPopup && (this.j.e.off(this.ow, "mousedown touchstart", this.onOutsideClick).off("escape closeAllPopups", this.onOutsideClick), this.state.activated = !1, this.openedPopup.close(), this.openedPopup.destruct(), this.openedPopup = null);
                    }
                },
                {
                    key: "onClick",
                    value: function(e) {
                        var t, o, n, r, i, a, l, s = this.control;
                        if (Ro(s.exec)) {
                            var c = null !== (n = null !== (o = null === (t = this.toolbar) || void 0 === t ? void 0 : t.getTarget(this)) && void 0 !== o ? o : this.target) && void 0 !== n ? n : null, u = s.exec(this.j, c, {
                                control: s,
                                originalEvent: e,
                                button: this
                            });
                            if (!1 !== u && !0 !== u && (null === (i = null === (r = this.j) || void 0 === r ? void 0 : r.e) || void 0 === i || i.fire("synchro"), this.parentElement && this.parentElement.update(), null === (l = null === (a = this.j) || void 0 === a ? void 0 : a.e) || void 0 === l || l.fire("closeAllPopups afterExec")), !1 !== u) return;
                        }
                        return s.list ? this.__openControlList(s) : Ro(s.popup) ? this.onTriggerClick(e) : void ((s.command || s.name) && (dr(nn(this.j) ? this.j.execCommand.bind(this.j) : this.j.od.execCommand.bind(this.j.od), s.command || s.name, !1, s.args && s.args[0]), this.j.e.fire("closeAllPopups")));
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.__closePopup(), fd(pd(t.prototype), "destruct", this).call(this);
                    }
                }
            ], n && ud(o.prototype, n), t;
        }(zs);
        function wd(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function kd(e, t, o) {
            return kd = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Sd(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, kd(e, t, o || e);
        }
        function Sd(e) {
            return Sd = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Sd(e);
        }
        function xd(e, t) {
            return xd = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, xd(e, t);
        }
        function Od(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Cd() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Cd = function() {
                return !!e;
            })();
        }
        _d([
            gi
        ], jd.prototype, "createContainer", null), _d([
            Ca("state.hasTrigger", {
                immediately: !1
            })
        ], jd.prototype, "onChangeHasTrigger", null), _d([
            Ca("trigger:click")
        ], jd.prototype, "onTriggerClick", null), _d([
            To
        ], jd.prototype, "onOutsideClick", null), _d([
            To
        ], jd.prototype, "__closePopup", null), jd = _d([
            ji
        ], jd);
        var zd = function(e) {
            function t(e, o) {
                var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Sd(t), function(e, t) {
                        return !t || "object" !== Od(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Cd() ? Reflect.construct(t, o || [], Sd(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).control = o, n.target = r, n.container.classList.add("".concat(n.componentName, "_").concat(n.clearName(o.name))), er(n.container, "role", "content"), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && xd(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ToolbarContent";
                    }
                },
                {
                    key: "update",
                    value: function() {
                        var e = this.control.getContent(this.j, this);
                        (Lo(e) || e.parentNode !== this.container) && (pi.detach(this.container), this.container.appendChild(Lo(e) ? this.j.create.fromHTML(e) : e)), kd(Sd(t.prototype), "update", this).call(this);
                    }
                },
                {
                    key: "createContainer",
                    value: function() {
                        return this.j.c.span(this.componentName);
                    }
                }
            ], wd(o.prototype, n), t;
        }(zs);
        function Ed(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Td(e, t, o) {
            return Td = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Id(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Td(e, t, o || e);
        }
        function Id(e) {
            return Id = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Id(e);
        }
        function Pd(e, t) {
            return Pd = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Pd(e, t);
        }
        function Rd(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Ad() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Ad = function() {
                return !!e;
            })();
        }
        zd = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Od(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], zd);
        var Ld = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = Id(o = t), function(e, t) {
                    return !t || "object" !== Rd(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, Ad() ? Reflect.construct(o, n || [], Id(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Pd(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ToolbarSelect";
                    }
                },
                {
                    key: "update",
                    value: function() {
                        var e, o, n;
                        Td(Id(t.prototype), "update", this).call(this), this.state.icon.name = "";
                        var r = this.control, i = r.list, a = r.data;
                        if (i) {
                            var l = this.state.value || (a && Lo(a.currentValue) ? a.currentValue : void 0);
                            l || (l = Object.keys(i)[0]);
                            var s = (cn(i) && i[l.toString()] || l).toString();
                            this.state.text = null !== (n = null === (o = (e = this.control).textTemplate) || void 0 === o ? void 0 : o.call(e, this.jodit, s)) && void 0 !== n ? n : s;
                        }
                    }
                }
            ], n && Ed(o.prototype, n), t;
        }(jd);
        function Md(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Bd(e, t, o) {
            return Bd = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Dd(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Bd(e, t, o || e);
        }
        function Dd(e) {
            return Dd = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Dd(e);
        }
        function Nd(e, t) {
            return Nd = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Nd(e, t);
        }
        function Hd(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Fd() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Fd = function() {
                return !!e;
            })();
        }
        Ld = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Rd(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Ld);
        var qd = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Dd(t), function(e, t) {
                        return !t || "object" !== Hd(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Fd() ? Reflect.construct(t, o || [], Dd(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).checkActiveStatus = function(e, t) {
                    var n = 0, r = 0;
                    return Object.keys(e).forEach(function(i) {
                        var a = e[i];
                        Ro(a) ? a(o.j, Ln(t, i).toString()) && (n += 1) : -1 !== a.indexOf(Ln(t, i).toString()) && (n += 1), r += 1;
                    }), r === n;
                }, o.prependInvisibleInput(o.container), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Nd(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ToolbarEditorCollection";
                    }
                },
                {
                    key: "shouldBeDisabled",
                    value: function(e) {
                        var o = Bd(Dd(t.prototype), "shouldBeDisabled", this).call(this, e);
                        if (void 0 !== o) return o;
                        var n = void 0 === e.control.mode ? Qt : e.control.mode;
                        return !(n === eo || n === this.j.getRealMode());
                    }
                },
                {
                    key: "shouldBeActive",
                    value: function(e) {
                        var o = this, n = Bd(Dd(t.prototype), "shouldBeActive", this).call(this, e);
                        if (void 0 !== n) return n;
                        var r, i = this.j.selection ? this.j.s.current() : null;
                        if (!i) return !1;
                        if (e.control.tags) {
                            var a = e.control.tags;
                            if (r = i, pi.up(r, function(e) {
                                if (e && -1 !== a.indexOf(e.nodeName.toLowerCase())) return !0;
                            }, this.j.editor)) return !0;
                        }
                        if (e.control.css) {
                            var l = e.control.css;
                            if (r = i, pi.up(r, function(e) {
                                if (e && !pi.isText(e) && !pi.isComment(e)) return o.checkActiveStatus(l, e);
                            }, this.j.editor)) return !0;
                        }
                        return !1;
                    }
                },
                {
                    key: "getTarget",
                    value: function(e) {
                        return e.target || this.j.s.current() || null;
                    }
                },
                {
                    key: "prependInvisibleInput",
                    value: function(e) {
                        var t = this.j.create.element("input", {
                            tabIndex: -1,
                            disabled: !0,
                            style: "width: 0; height:0; position: absolute; visibility: hidden;"
                        });
                        pi.appendChildFirst(e, t);
                    }
                },
                {
                    key: "showInline",
                    value: function(e) {
                        this.jodit.e.fire("showInlineToolbar", e);
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        this.jodit.e.fire("hidePopup"), Bd(Dd(t.prototype), "hide", this).call(this), this.jodit.e.fire("toggleToolbar");
                    }
                },
                {
                    key: "show",
                    value: function() {
                        Bd(Dd(t.prototype), "show", this).call(this), this.jodit.e.fire("toggleToolbar");
                    }
                }
            ], n && Md(o.prototype, n), t;
        }(sd);
        function Vd(e, t) {
            var o = nn(e) ? new qd(e) : new sd(e);
            return e.o.textIcons && o.container.classList.add("jodit_text_icons"), t && (o.parentElement = t), e.o.toolbarButtonSize && (o.buttonSize = e.o.toolbarButtonSize), o;
        }
        function Wd(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            if (Ro(t.getContent)) return new zd(e, t, o);
            var n = new jd(e, t, o);
            return n.state.tabIndex = e.o.allowTabNavigation ? 0 : -1, n;
        }
        function Ud(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Yd(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Kd(e, t, o) {
            return Kd = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Gd(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Kd(e, t, o || e);
        }
        function Gd(e) {
            return Gd = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Gd(e);
        }
        function Jd(e, t) {
            return Jd = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Jd(e, t);
        }
        function Xd(e) {
            return function(e) {
                if (Array.isArray(e)) return Ud(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return Ud(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Ud(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Zd(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Qd() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Qd = function() {
                return !!e;
            })();
        }
        qd = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Hd(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], qd);
        var $d = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Zd(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, ef = function(e) {
            function t(e) {
                var o, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Gd(t), function(e, t) {
                        return !t || "object" !== Zd(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Qd() ? Reflect.construct(t, o || [], Gd(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    n
                ])).toolbar = Vd(o), o.__defaultToolbarContainer = o.c.div("jodit-toolbar__box"), o.registeredButtons = new Set, o.groupToButtons = {}, o.isJodit = !1, o.__tooltip = new Ks(o), o.isJodit = n, o.e.on("beforeToolbarBuild", o.beforeToolbarBuild), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Jd(e, t);
            }(t, e), o = t, n = [
                {
                    key: "toolbarContainer",
                    get: function() {
                        return this.o.fullsize || !Lo(this.o.toolbar) && !pi.isHTMLElement(this.o.toolbar) ? (this.o.toolbar && pi.appendChildFirst(this.container, this.__defaultToolbarContainer), this.__defaultToolbarContainer) : oi(this.o.toolbar, this.o.shadowRoot || this.od);
                    }
                },
                {
                    key: "setPanel",
                    value: function(e) {
                        this.o.toolbar = e, this.buildToolbar();
                    }
                },
                {
                    key: "buildToolbar",
                    value: function() {
                        var e;
                        if (this.o.toolbar) {
                            var t = this.o.buttons ? Pi(this.o.buttons) : [];
                            null === (e = this.toolbar) || void 0 === e || e.setRemoveButtons(this.o.removeButtons).build(t.concat(this.o.extraButtons || [])).appendTo(this.toolbarContainer);
                        }
                    }
                },
                {
                    key: "getRegisteredButtonGroups",
                    value: function() {
                        return this.groupToButtons;
                    }
                },
                {
                    key: "registerButton",
                    value: function(e) {
                        var t;
                        this.registeredButtons.add(e);
                        var o = null !== (t = e.group) && void 0 !== t ? t : "other";
                        return this.groupToButtons[o] || (this.groupToButtons[o] = []), null != e.position ? this.groupToButtons[o][e.position] = e.name : this.groupToButtons[o].push(e.name), this;
                    }
                },
                {
                    key: "unregisterButton",
                    value: function(e) {
                        var t;
                        this.registeredButtons.delete(e);
                        var o = null !== (t = e.group) && void 0 !== t ? t : "other", n = this.groupToButtons[o];
                        if (n) {
                            var r = n.indexOf(e.name);
                            -1 !== r && n.splice(r, 1), 0 === n.length && delete this.groupToButtons[o];
                        }
                        return this;
                    }
                },
                {
                    key: "beforeToolbarBuild",
                    value: function(e) {
                        var t = this;
                        if (Object.keys(this.groupToButtons).length) return e.map(function(e) {
                            return as(e) && e.group && t.groupToButtons[e.group] ? {
                                group: e.group,
                                buttons: Xd(e.buttons).concat(Xd(t.groupToButtons[e.group]))
                            } : e;
                        });
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.isDestructed || (this.setStatus(Io.beforeDestruct), this.e.off("beforeToolbarBuild", this.beforeToolbarBuild), this.__tooltip.destruct(), this.toolbar.destruct(), this.toolbar = void 0, Kd(Gd(t.prototype), "destruct", this).call(this));
                    }
                }
            ], Yd(o.prototype, n), t;
        }($u);
        function tf(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function of(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function nf(e, t, o) {
            return nf = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = rf(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, nf(e, t, o || e);
        }
        function rf(e) {
            return rf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, rf(e);
        }
        function af(e, t) {
            return af = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, af(e, t);
        }
        function lf(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function sf() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (sf = function() {
                return !!e;
            })();
        }
        $d([
            Ca(":rebuildToolbar")
        ], ef.prototype, "buildToolbar", null), $d([
            To
        ], ef.prototype, "beforeToolbarBuild", null);
        var cf, uf = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : lf(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        };
        rr.prototype.dialog = {
            namespace: "",
            extraButtons: [],
            resizable: !0,
            draggable: !0,
            buttons: [
                "dialog.close"
            ],
            removeButtons: [],
            toolbarButtonSize: "middle",
            zIndex: "inherit"
        }, rr.prototype.controls.dialog = {
            close: {
                icon: "cancel",
                exec: function(e) {
                    e.close();
                }
            }
        };
        var df = cf = function(e) {
            function t() {
                var e, o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = rf(t), function(e, t) {
                        return !t || "object" !== lf(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, sf() ? Reflect.construct(t, o || [], rf(e).constructor) : t.apply(e, o));
                }(this, t, [
                    o
                ])).destroyAfterClose = !1, e.moved = !1, e.resizable = !1, e.draggable = !1, e.startX = 0, e.startY = 0, e.startPoint = {
                    x: 0,
                    y: 0,
                    w: 0,
                    h: 0
                }, e.lockSelect = function() {
                    e.setMod("moved", !0);
                }, e.unlockSelect = function() {
                    e.setMod("moved", !1);
                }, e.__onResize = function() {
                    e.options && e.o.resizable && !e.moved && e.isOpened && !e.offsetX && !e.offsetY && e.setPosition();
                }, e.isModal = !1, e.isOpened = !1;
                var n = e;
                n.options = _r(o, _r(rr.prototype.dialog, cf.defaultOptions)), pi.safeRemove(n.container);
                var r = e.getFullElName.bind(e);
                n.container = e.c.fromHTML('<div class="jodit jodit-dialog '.concat(e.componentName, '">\n\t\t\t\t<div class="').concat(r("overlay"), '"></div>\n\t\t\t\t<div class="').concat(e.getFullElName("panel"), '">\n\t\t\t\t\t<div class="').concat(r("header"), '">\n\t\t\t\t\t\t<div class="').concat(r("header-title"), '"></div>\n\t\t\t\t\t\t<div class="').concat(r("header-toolbar"), '"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="').concat(r("content"), '"></div>\n\t\t\t\t\t<div class="').concat(r("footer"), '"></div>\n\t\t\t\t\t<div class="').concat(r("resizer"), '">').concat(Ol.get("resize_handler"), "</div>\n\t\t\t\t</div>\n\t\t\t</div>")), "rtl" === n.options.direction && (n.container.style.direction = "rtl", n.container.setAttribute("dir", "rtl")), e.o.zIndex && (e.container.style.zIndex = e.o.zIndex.toString()), er(n.container, "role", "dialog"), Object.defineProperty(n.container, "component", {
                    value: e
                }), n.setMod("theme", n.o.theme || "default").setMod("resizable", Boolean(n.o.resizable));
                var i = n.getElm("panel");
                $n(null != i, "Panel element does not exist");
                var a = n.getElm("resizer");
                $n(null != a, "Resizer element does not exist");
                var l = n.getElm("header-title");
                $n(null != l, "header-title element does not exist");
                var s = n.getElm("content");
                $n(null != s, "Content element does not exist");
                var c = n.getElm("footer");
                $n(null != c, "Footer element does not exist");
                var u = n.getElm("header-toolbar");
                $n(null != u, "header-toolbar element does not exist"), e.dialog = i, e.resizer = a, e.dialogbox_header = l, e.dialogbox_content = s, e.dialogbox_footer = c, e.dialogbox_toolbar = u, Ln(n.dialog, {
                    maxWidth: n.options.maxWidth,
                    minHeight: n.options.minHeight,
                    minWidth: n.options.minWidth
                });
                var d = n.getElm("header");
                d && n.e.on(d, "pointerdown touchstart", n.__onHeaderMouseDown), n.e.on(n.resizer, "mousedown touchstart", n.__onResizerMouseDown);
                var f = Ma.get("fullsize");
                if (Ro(f) && f(n), e.e.on(n.container, "close_dialog", n.close).on(e.ow, "keydown", e.__onEsc).on(e.ow, "resize", e.__onResize), e.o.closeOnClickOverlay) {
                    var p = n.getElm("overlay");
                    $n(null != p, "Overlay element does not exist"), e.e.on(p, "click", n.close);
                }
                return e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && af(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "Dialog";
                    }
                },
                {
                    key: "destination",
                    get: function() {
                        var e = this.o, t = e.popupRoot, o = e.shadowRoot;
                        return t || o || this.od.body;
                    }
                },
                {
                    key: "setElements",
                    value: function(e, t) {
                        var o = this, n = [];
                        Ii(t).forEach(function(t) {
                            if (Ao(t)) {
                                var r = o.c.div(o.getFullElName("column"));
                                return n.push(r), e.appendChild(r), o.setElements(r, t);
                            }
                            var i;
                            i = Lo(t) ? o.c.fromHTML(t) : $o(t) ? t.container : t, n.push(i), i.parentNode !== e && e.appendChild(i);
                        }), Fo(e.childNodes).forEach(function(t) {
                            -1 === n.indexOf(t) && e.removeChild(t);
                        });
                    }
                },
                {
                    key: "__onMouseUp",
                    value: function() {
                        (this.draggable || this.resizable) && (this.__removeGlobalResizeListeners(), this.draggable = !1, this.resizable = !1, this.unlockSelect(), this.e && (this.__removeGlobalResizeListeners(), this.e.fire(this, "endResize endMove")));
                    }
                },
                {
                    key: "__onHeaderMouseDown",
                    value: function(e) {
                        var t = e.target;
                        !this.o.draggable || t && t.nodeName.match(/^(INPUT|SELECT)$/) || (this.draggable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.x = Ln(this.dialog, "left"), this.startPoint.y = Ln(this.dialog, "top"), this.setMaxZIndex(), e.cancelable && e.preventDefault(), this.lockSelect(), this.__addGlobalResizeListeners(), this.e && (this.e.fire(this, "startMove"), this.e.fire("closeAllPopups")));
                    }
                },
                {
                    key: "__onMouseMove",
                    value: function(e) {
                        this.draggable && this.o.draggable && (this.setPosition(this.startPoint.x + e.clientX - this.startX, this.startPoint.y + e.clientY - this.startY), this.e && this.e.fire(this, "move", e.clientX - this.startX, e.clientY - this.startY), e.stopImmediatePropagation()), this.resizable && this.o.resizable && (this.setSize(this.startPoint.w + e.clientX - this.startX, this.startPoint.h + e.clientY - this.startY), this.e && this.e.fire(this, "resizeDialog", e.clientX - this.startX, e.clientY - this.startY));
                    }
                },
                {
                    key: "__onEsc",
                    value: function(e) {
                        if (this.o.closeOnEsc && this.isOpened && e.key === Dt && !0 !== this.getMod("static")) {
                            var t = this.getMaxZIndexDialog();
                            t ? t.close() : this.close(), e.stopImmediatePropagation();
                        }
                    }
                },
                {
                    key: "__onResizerMouseDown",
                    value: function(e) {
                        this.resizable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.w = this.dialog.offsetWidth, this.startPoint.h = this.dialog.offsetHeight, this.lockSelect(), this.__addGlobalResizeListeners(), this.e && this.e.fire(this, "startResize");
                    }
                },
                {
                    key: "__addGlobalResizeListeners",
                    value: function() {
                        var e = this;
                        e.e.on(e.ow, "pointermove touchmove", e.__onMouseMove).on(e.ow, "pointerup touchend", e.__onMouseUp);
                    }
                },
                {
                    key: "__removeGlobalResizeListeners",
                    value: function() {
                        var e = this;
                        e.e.off(e.ow, "mousemove pointermove", e.__onMouseMove).off(e.ow, "mouseup pointerup", e.__onMouseUp);
                    }
                },
                {
                    key: "setSize",
                    value: function(e, t) {
                        return null == e && (e = this.dialog.offsetWidth), null == t && (t = this.dialog.offsetHeight), Ln(this.dialog, {
                            width: e,
                            height: t
                        }), this;
                    }
                },
                {
                    key: "calcAutoSize",
                    value: function() {
                        return this.setSize("auto", "auto"), this.setSize(), this;
                    }
                },
                {
                    key: "setPosition",
                    value: function(e, t) {
                        var o = this.ow.innerWidth, n = this.ow.innerHeight, r = o / 2 - this.dialog.offsetWidth / 2, i = n / 2 - this.dialog.offsetHeight / 2;
                        return r < 0 && (r = 0), i < 0 && (i = 0), void 0 !== e && void 0 !== t && (this.offsetX = e, this.offsetY = t, this.moved = Math.abs(e - r) > 100 || Math.abs(t - i) > 100), this.dialog.style.left = (e || r) + "px", this.dialog.style.top = (t || i) + "px", this;
                    }
                },
                {
                    key: "setHeader",
                    value: function(e) {
                        return this.setElements(this.dialogbox_header, e), this;
                    }
                },
                {
                    key: "setContent",
                    value: function(e) {
                        return this.setElements(this.dialogbox_content, e), this;
                    }
                },
                {
                    key: "setFooter",
                    value: function(e) {
                        return this.setElements(this.dialogbox_footer, e), this.setMod("footer", Boolean(e)), this;
                    }
                },
                {
                    key: "getZIndex",
                    value: function() {
                        return parseInt(Ln(this.container, "zIndex"), 10) || 0;
                    }
                },
                {
                    key: "getMaxZIndexDialog",
                    value: function() {
                        var e, t, o = 0, n = this;
                        return Qr(".jodit-dialog", this.destination).forEach(function(r) {
                            e = r.component, t = parseInt(Ln(r, "zIndex"), 10), e.isOpened && !isNaN(t) && t > o && (n = e, o = t);
                        }), n;
                    }
                },
                {
                    key: "setMaxZIndex",
                    value: function() {
                        if (!this.getMod("static")) {
                            var e = 20000004, t = 0;
                            Qr(".jodit-dialog", this.destination).forEach(function(o) {
                                t = parseInt(Ln(o, "zIndex"), 10), e = Math.max(isNaN(t) ? 0 : t, e);
                            }), this.container.style.zIndex = (e + 1).toString();
                        }
                    }
                },
                {
                    key: "toggleFullSize",
                    value: function(e) {
                        Bo(e) && (e = !this.getMod("fullsize")), this.setMod("fullsize", e), nf(rf(t.prototype), "toggleFullSize", this).call(this, e);
                    }
                },
                {
                    key: "open",
                    value: function(e, t, o, n) {
                        if (qa.fire("closeAllPopups hideHelpers"), !1 === this.e.fire(this, "beforeOpen")) return this;
                        Wo(e) && (o = e), Wo(t) && (n = t), this.destroyAfterClose = !0 === o;
                        var r = Wo(e) ? void 0 : e, i = Wo(t) ? void 0 : t;
                        return void 0 !== i && this.setHeader(i), r && this.setContent(r), this.setMod("active", !0), this.isOpened = !0, this.setModal(n), this.destination.appendChild(this.container), !0 !== this.getMod("static") ? (this.setPosition(this.offsetX, this.offsetY), this.setMaxZIndex()) : this.container.style.removeProperty("z-index"), this.o.fullsize && this.toggleFullSize(!0), this.e.fire("afterOpen", this), this;
                    }
                },
                {
                    key: "setModal",
                    value: function(e) {
                        return this.isModal = Boolean(e), this.setMod("modal", this.isModal), this;
                    }
                },
                {
                    key: "close",
                    value: function() {
                        if (this.isDestructed || !this.isOpened || !0 === this.getMod("static")) return this;
                        var e = this.e;
                        return !1 === e.fire(this, "beforeClose") || !1 === e.fire("beforeClose", this) || (this.setMod("active", !1), this.isOpened = !1, this.isFullSize && this.toggleFullSize(!1), pi.safeRemove(this.container), this.__removeGlobalResizeListeners(), e.fire(this, "afterClose"), e.fire(this.ow, "joditCloseDialog"), this.destroyAfterClose && this.destruct()), this;
                    }
                },
                {
                    key: "buildToolbar",
                    value: function() {
                        this.o.buttons && this.toolbar.build(Pi(this.o.buttons)).setMod("mode", "header").appendTo(this.dialogbox_toolbar);
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.isInDestruct || (this.setStatus(Io.beforeDestruct), this.isOpened && this.close(), this.events && (this.__removeGlobalResizeListeners(), this.events.off(this.container, "close_dialog", self.close).off(this.ow, "keydown", this.__onEsc).off(this.ow, "resize", this.__onResize)), nf(rf(t.prototype), "destruct", this).call(this));
                    }
                }
            ], n && tf(o.prototype, n), t;
        }(ef);
        function ff(e, t, o) {
            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "jodit-dialog_alert";
            Ro(t) && (o = t, t = void 0);
            var r, i = (null != (r = df) && "undefined" != typeof Symbol && r[Symbol.hasInstance] ? r[Symbol.hasInstance](this) : this instanceof r) ? this : new df({
                closeOnClickOverlay: !0
            }), a = i.c.div(n), l = Es(i, "ok", "Ok");
            return Ii(e).forEach(function(e) {
                a.appendChild(pi.isNode(e) ? e : i.c.fromHTML(e));
            }), l.onAction(function() {
                o && Ro(o) && !1 === o(i) || i.close();
            }), i.setFooter([
                l
            ]), i.open(a, t || "&nbsp;", !0, !0), l.focus(), i;
        }
        function pf(e, t, o) {
            var n, r = (null != (n = df) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? n[Symbol.hasInstance](this) : this instanceof n) ? this : new df({
                closeOnClickOverlay: !0
            }), i = r.c.fromHTML('<form class="jodit-dialog_prompt"></form>'), a = r.c.element("label");
            Ro(t) && (o = t, t = void 0), a.appendChild(r.c.fromHTML(e)), i.appendChild(a);
            var l = function(e) {
                return function() {
                    o && !1 === o(e) || r.close();
                };
            }, s = Es(r, "cancel", "Cancel"), c = Es(r, "ok", "Yes");
            return s.onAction(l(!1)), c.onAction(l(!0)), r.e.on(i, "submit", function() {
                return l(!0)(), !1;
            }), r.setFooter([
                c,
                s
            ]), r.open(i, t || "&nbsp;", !0, !0), c.focus(), r;
        }
        function hf(e, t, o, n, r) {
            var i, a = (null != (i = df) && "undefined" != typeof Symbol && i[Symbol.hasInstance] ? i[Symbol.hasInstance](this) : this instanceof i) ? this : new df({
                closeOnClickOverlay: !0
            }), l = Es(a, "cancel", "Cancel"), s = Es(a, "ok", "Ok"), c = a.c.element("form", {
                class: "jodit-dialog_prompt"
            }), u = a.c.element("input", {
                autofocus: !0,
                class: "jodit-input"
            }), d = a.c.element("label");
            Ro(t) && (o = t, t = void 0), n && er(u, "placeholder", n), d.appendChild(a.c.text(e)), c.appendChild(d), c.appendChild(u), l.onAction(a.close);
            var f = function() {
                o && Ro(o) && !1 === o(u.value) || a.close();
            };
            return s.onAction(f), a.e.on(c, "submit", function() {
                return f(), !1;
            }), a.setFooter([
                s,
                l
            ]), a.open(c, t || "&nbsp;", !0, !0), u.focus(), void 0 !== r && r.length && (u.value = r, u.select()), a;
        }
        function vf(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function gf(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        uf([
            To
        ], df.prototype, "__onMouseUp", null), uf([
            To
        ], df.prototype, "__onHeaderMouseDown", null), uf([
            To
        ], df.prototype, "__onMouseMove", null), uf([
            To
        ], df.prototype, "__onEsc", null), uf([
            To
        ], df.prototype, "__onResizerMouseDown", null), uf([
            To
        ], df.prototype, "close", null), uf([
            rl("ready")
        ], df.prototype, "buildToolbar", null), (df = cf = uf([
            ji
        ], df)).defaultOptions = function(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }(function(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    of(e, t, o[t]);
                });
            }
            return e;
        }({}, $u.defaultOptions), {
            closeOnClickOverlay: !1,
            closeOnEsc: !0
        });
        var mf = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e);
            }
            var t, o;
            return t = e, o = [
                {
                    key: "dlg",
                    value: function(e) {
                        var t = Fa(this.o, this.container, this.od.body), o = new df(function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                                }))), n.forEach(function(t) {
                                    gf(e, t, o[t]);
                                });
                            }
                            return e;
                        }({
                            language: this.o.language,
                            shadowRoot: this.o.shadowRoot,
                            popupRoot: t,
                            ownerWindow: this.o.ownerWindow,
                            defaultTimeout: this.o.defaultTimeout,
                            direction: this.o.direction,
                            theme: this.o.theme,
                            globalFullSize: this.o.globalFullSize
                        }, e));
                        return fr(this, o.container), o.parent = this, o.bindDestruct(this);
                    }
                },
                {
                    key: "confirm",
                    value: function(e, t, o) {
                        return e = bf(e, this), t = bf(t, this), pf.call(this.dlg({
                            closeOnClickOverlay: !0
                        }), e, t, o);
                    }
                },
                {
                    key: "prompt",
                    value: function(e, t, o, n, r) {
                        return e = bf(e, this), t = bf(t, this), n = bf(n, this), hf.call(this.dlg({
                            closeOnClickOverlay: !0
                        }), e, t, o, n, r);
                    }
                },
                {
                    key: "alert",
                    value: function(e, t, o, n) {
                        return e = bf(e, this), t = bf(t, this), ff.call(this.dlg({
                            closeOnClickOverlay: !0
                        }), e, t, o, n);
                    }
                }
            ], o && vf(t.prototype, o), e;
        }();
        function bf(e, t) {
            return Lo(e) && !Jo(e) && (e = t.i18n(e)), e;
        }
        function yf(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function _f(e) {
            return _f = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, _f(e);
        }
        function jf(e, t) {
            return jf = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, jf(e, t);
        }
        function wf(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function kf() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (kf = function() {
                return !!e;
            })();
        }
        var Sf = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = _f(o = t), function(e, t) {
                    return !t || "object" !== wf(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, kf() ? Reflect.construct(o, n || [], _f(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && jf(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ContextMenu";
                    }
                },
                {
                    key: "show",
                    value: function(e, t, o) {
                        var n = this, r = this;
                        r.clear(), Ao(o) && (o.forEach(function(e) {
                            if (e) {
                                var t = Es(n.jodit, e.icon || "empty", e.title);
                                n.jodit && t.setParentView(n.jodit), t.setMod("context", "menu"), t.onAction(function(t) {
                                    var o;
                                    return null === (o = e.exec) || void 0 === o || o.call(r, t), r.clear(), r.close(), !1;
                                }), n.append(t);
                            }
                        }), this.open(function() {
                            return {
                                left: e,
                                top: t,
                                width: 0,
                                height: 0
                            };
                        }, !0));
                    }
                }
            ], yf(o.prototype, n), t;
        }(gu);
        function xf(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Of(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function Cf(e) {
            return e.files.setMod("active", !0), e.files.setMod("loading", !0), e.dataProvider.items(e.state.currentPath, e.state.currentSource, {
                sortBy: e.state.sortBy,
                onlyImages: e.state.onlyImages,
                filterWord: e.state.filterWord
            }).then(function(t) {
                t && (e.state.elements = t, e.state.activeElements = []);
            }).catch(e.status).finally(function() {
                return e.files.setMod("loading", !1);
            });
        }
        function zf(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function Ef(e) {
            return Tf.apply(this, arguments);
        }
        function Tf() {
            var e;
            return e = function(e) {
                var t, o;
                return function(e, t) {
                    var o, n, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: l(0),
                        throw: l(1),
                        return: l(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function l(i) {
                        return function(l) {
                            return function(i) {
                                if (o) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                    switch(n = 0, r && (i = [
                                        2 & i[0],
                                        r.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            r = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < r[1]) {
                                                a.label = r[1], r = i;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(i);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = t.call(e, a);
                                } catch (e) {
                                    i = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    o = r = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                l
                            ]);
                        };
                    }
                }(this, function(n) {
                    return e.tree.setMod("active", !0), pi.detach(e.tree.container), t = Cf(e), e.o.showFoldersPanel ? (e.tree.setMod("loading", !0), o = e.dataProvider.tree(e.state.currentPath, e.state.currentSource).then(function(t) {
                        e.state.sources = t;
                    }).catch(e.status).finally(function() {
                        return e.tree.setMod("loading", !1);
                    }), [
                        2,
                        Promise.all([
                            o,
                            t
                        ])
                    ]) : (e.tree.setMod("active", !1), [
                        2,
                        t
                    ]);
                });
            }, Tf = function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        zf(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        zf(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            }, Tf.apply(this, arguments);
        }
        Sf = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : wf(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji
        ], Sf), rr.prototype.filebrowser = {
            namespace: "",
            cache: !0,
            extraButtons: [],
            filter: function(e, t) {
                return t = t.toLowerCase(), Lo(e) ? -1 !== e.toLowerCase().indexOf(t) : Lo(e.name) ? -1 !== e.name.toLowerCase().indexOf(t) : !Lo(e.file) || -1 !== e.file.toLowerCase().indexOf(t);
            },
            sortBy: "changed-desc",
            sort: function(e, t, o) {
                var n = function(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != o) {
                            var n, r, i = [], a = !0, l = !1;
                            try {
                                for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                            } catch (e) {
                                l = !0, r = e;
                            } finally{
                                try {
                                    a || null == o.return || o.return();
                                } finally{
                                    if (l) throw r;
                                }
                            }
                            return i;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return xf(e, t);
                            var o = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? xf(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(o.toLowerCase().split("-"), 2), r = n[0], i = "asc" === n[1], a = function(e, t) {
                    return e < t ? i ? -1 : 1 : e > t ? i ? 1 : -1 : 0;
                };
                if (Lo(e)) return a(e.toLowerCase(), t.toLowerCase());
                if (void 0 === e[r] || "name" === r) return Lo(e.name) ? a(e.name.toLowerCase(), t.name.toLowerCase()) : Lo(e.file) ? a(e.file.toLowerCase(), t.file.toLowerCase()) : 0;
                switch(r){
                    case "changed":
                        var l = new Date(e.changed).getTime(), s = new Date(t.changed).getTime();
                        return i ? l - s : s - l;
                    case "size":
                        var c = Yr(e.size), u = Yr(t.size);
                        return i ? c - u : u - c;
                }
                return 0;
            },
            editImage: !0,
            preview: !0,
            showPreviewNavigation: !0,
            showSelectButtonInPreview: !0,
            contextMenu: !0,
            howLongShowMsg: 3e3,
            createNewFolder: !0,
            deleteFolder: !0,
            renameFolder: !0,
            moveFolder: !0,
            moveFile: !0,
            permissionsPresets: {
                allowFileDownload: void 0,
                allowFileMove: void 0,
                allowFileRemove: void 0,
                allowFileRename: void 0,
                allowFileUpload: void 0,
                allowFileUploadRemote: void 0,
                allowFiles: void 0,
                allowFolderCreate: void 0,
                allowFolderMove: void 0,
                allowFolderRemove: void 0,
                allowFolderRename: void 0,
                allowFolderTree: void 0,
                allowFolders: void 0,
                allowGeneratePdf: void 0,
                allowImageCrop: void 0,
                allowImageResize: void 0
            },
            showFoldersPanel: !0,
            storeLastOpenedFolder: !0,
            width: 859,
            height: 400,
            buttons: [
                "filebrowser.upload",
                "filebrowser.remove",
                "filebrowser.update",
                "filebrowser.select",
                "filebrowser.edit",
                "|",
                "filebrowser.tiles",
                "filebrowser.list",
                "|",
                "filebrowser.filter",
                "|",
                "filebrowser.sort"
            ],
            removeButtons: [],
            fullsize: !1,
            showTooltip: !0,
            view: null,
            isSuccess: function(e) {
                return e.success;
            },
            getMessage: function(e) {
                return void 0 !== e.data.messages && Ao(e.data.messages) ? e.data.messages.join(" ") : "";
            },
            showFileName: !0,
            showFileSize: !0,
            showFileChangeTime: !0,
            saveStateInStorage: {
                storeLastOpenedFolder: !0,
                storeView: !0,
                storeSortBy: !0
            },
            pixelOffsetLoadNewChunk: 200,
            getThumbTemplate: function(e, t, o) {
                var n = this.options, r = this.files.getFullElName("item"), i = n.showFileName, a = n.showFileSize && e.size, l = n.showFileChangeTime && e.time, s = "";
                void 0 !== e.file && (s = e.file);
                var c = '<div class="'.concat(r, '-info">').concat(i ? '<span class="'.concat(r, '-info-filename">').concat(s, "</span>") : "").concat(a ? '<span class="'.concat(r, '-info-filesize">').concat(e.size, "</span>") : "").concat(l ? '<span class="'.concat(r, '-info-filechanged">').concat(l, "</span>") : "", "</div>");
                return '<a\n\t\t\tdata-jodit-file-browser-item="true"\n\t\t\tdata-is-file="'.concat(e.isImage ? 0 : 1, '"\n\t\t\tdraggable="true"\n\t\t\tclass="').concat(r, '"\n\t\t\thref="').concat(e.fileURL, '"\n\t\t\tdata-source="').concat(o, '"\n\t\t\tdata-path="').concat(e.path, '"\n\t\t\tdata-name="').concat(s, '"\n\t\t\ttitle="').concat(s, '"\n\t\t\tdata-url="').concat(e.fileURL, '">\n\t\t\t\t<img\n\t\t\t\t\tdata-is-file="').concat(e.isImage ? 0 : 1, '"\n\t\t\t\t\tdata-src="').concat(e.fileURL, '"\n\t\t\t\t\tsrc="').concat(e.imageURL, '"\n\t\t\t\t\talt="').concat(s, '"\n\t\t\t\t\tloading="lazy"\n\t\t\t\t/>\n\t\t\t\t').concat(i || a || l ? c : "", "\n\t\t\t</a>");
            },
            ajax: function(e, t) {
                return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        t.push.apply(t, o);
                    }
                    return t;
                })(Object(t)).forEach(function(o) {
                    Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
                }), e;
            }(function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                        return Object.getOwnPropertyDescriptor(o, e).enumerable;
                    }))), n.forEach(function(t) {
                        Of(e, t, o[t]);
                    });
                }
                return e;
            }({}, rr.prototype.defaultAjaxOptions), {
                url: "",
                data: {},
                cache: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                method: "POST",
                processData: !0,
                headers: {},
                prepareData: function(e) {
                    return e;
                },
                process: function(e) {
                    return e;
                }
            }),
            create: {
                data: {
                    action: "folderCreate"
                }
            },
            getLocalFileByUrl: {
                data: {
                    action: "getLocalFileByUrl"
                }
            },
            resize: {
                data: {
                    action: "imageResize"
                }
            },
            crop: {
                data: {
                    action: "imageCrop"
                }
            },
            fileMove: {
                data: {
                    action: "fileMove"
                }
            },
            folderMove: {
                data: {
                    action: "folderMove"
                }
            },
            fileRename: {
                data: {
                    action: "fileRename"
                }
            },
            folderRename: {
                data: {
                    action: "folderRename"
                }
            },
            fileRemove: {
                data: {
                    action: "fileRemove"
                }
            },
            folderRemove: {
                data: {
                    action: "folderRemove"
                }
            },
            items: {
                data: {
                    action: "files"
                }
            },
            folder: {
                data: {
                    action: "folders"
                }
            },
            permissions: {
                data: {
                    action: "permissions"
                }
            }
        }, rr.prototype.controls.filebrowser = {
            upload: {
                icon: "plus",
                tooltip: "Upload file",
                isInput: !0,
                isDisabled: function(e) {
                    return !e.dataProvider.canI("FileUpload");
                },
                getContent: function(e, t) {
                    var o = new ru(e, {
                        tooltip: t.control.tooltip,
                        onlyImages: e.state.onlyImages
                    });
                    return e.e.fire("bindUploader.filebrowser", o.container), o.container;
                }
            },
            remove: {
                icon: "bin",
                tooltip: "Remove file",
                isDisabled: function(e) {
                    return !e.state.activeElements.length || !e.dataProvider.canI("FileRemove");
                },
                exec: function(e) {
                    e.e.fire("fileRemove.filebrowser");
                }
            },
            update: {
                tooltip: "Update file list",
                exec: function(e) {
                    e.e.fire("update.filebrowser");
                }
            },
            select: {
                tooltip: "Select file",
                icon: "check",
                isDisabled: function(e) {
                    return !e.state.activeElements.length;
                },
                exec: function(e) {
                    e.e.fire("select.filebrowser");
                }
            },
            edit: {
                tooltip: "Edit image",
                icon: "pencil",
                isDisabled: function(e) {
                    var t = e.state.activeElements;
                    return 1 !== t.length || !t[0].isImage || !(e.dataProvider.canI("ImageCrop") || e.dataProvider.canI("ImageResize"));
                },
                exec: function(e) {
                    e.e.fire("edit.filebrowser");
                }
            },
            tiles: {
                tooltip: "Tiles view",
                icon: "th",
                isActive: function(e) {
                    return "tiles" === e.state.view;
                },
                exec: function(e) {
                    e.e.fire("view.filebrowser", "tiles");
                }
            },
            list: {
                tooltip: "List view",
                icon: "th-list",
                isActive: function(e) {
                    return "list" === e.state.view;
                },
                exec: function(e) {
                    e.e.fire("view.filebrowser", "list");
                }
            },
            filter: {
                isInput: !0,
                getContent: function(e, t) {
                    var o = t.container.querySelector(".jodit-input");
                    if (o) return o;
                    var n = e.c.element("input", {
                        class: "jodit-input",
                        placeholder: e.i18n("Filter")
                    });
                    return n.value = e.state.filterWord, e.e.on(n, "keydown mousedown", e.async.debounce(function() {
                        e.e.fire("filter.filebrowser", n.value);
                    }, e.defaultTimeout)), n;
                }
            },
            sort: {
                isInput: !0,
                getContent: function(e) {
                    var t = e.c.fromHTML('<select class="jodit-input jodit-select">' + '<option value="changed-asc">'.concat(e.i18n("Sort by changed"), " (\u2B06)</option>") + '<option value="changed-desc">'.concat(e.i18n("Sort by changed"), " (\u2B07)</option>") + '<option value="name-asc">'.concat(e.i18n("Sort by name"), " (\u2B06)</option>") + '<option value="name-desc">'.concat(e.i18n("Sort by name"), " (\u2B07)</option>") + '<option value="size-asc">'.concat(e.i18n("Sort by size"), " (\u2B06)</option>") + '<option value="size-desc">'.concat(e.i18n("Sort by size"), " (\u2B07)</option>") + "</select>");
                    return t.value = e.state.sortBy, e.e.on("sort.filebrowser", function(e) {
                        t.value !== e && (t.value = e);
                    }).on(t, "change", function() {
                        e.e.fire("sort.filebrowser", t.value);
                    }), t;
                }
            }
        };
        var If = new WeakMap, Pf = function(e) {
            var t = If.get(e);
            return t || (t = {}, If.set(e, t)), t;
        };
        function Rf(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Af = function() {
            function e(t) {
                var o = this;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.data = t, Object.keys(t).forEach(function(e) {
                    o[e] = t[e];
                });
            }
            var t, o, n;
            return t = e, o = [
                {
                    key: "path",
                    get: function() {
                        return Ki(this.data.source.path ? this.data.source.path + "/" : "/");
                    }
                },
                {
                    key: "imageURL",
                    get: function() {
                        var e = this.time || (new Date).getTime().toString(), t = this.data, o = t.thumbIsAbsolute, n = t.source, r = t.thumb, i = t.file, a = r || i;
                        return o && a ? a : Xi(n.baseurl, n.path, a || "") + "?_tmst=" + encodeURIComponent(e);
                    }
                },
                {
                    key: "fileURL",
                    get: function() {
                        var e = this.data.name, t = this.data, o = t.file, n = t.fileIsAbsolute, r = t.source;
                        return void 0 !== o && (e = o), n && e ? e : Xi(r.baseurl, r.path, e || "");
                    }
                },
                {
                    key: "time",
                    get: function() {
                        var e = this.data.changed;
                        return e && ("number" == typeof e ? new Date(e).toLocaleString() : e) || "";
                    }
                },
                {
                    key: "uniqueHashKey",
                    get: function() {
                        var e = this.data, t = [
                            e.sourceName,
                            e.name,
                            e.file,
                            this.time,
                            e.thumb
                        ].join("_");
                        return t.toLowerCase().replace(/[^0-9a-z\-.]/g, "-");
                    }
                },
                {
                    key: "toJSON",
                    value: function() {
                        return this.data;
                    }
                }
            ], n = [
                {
                    key: "create",
                    value: function(t) {
                        var o, n;
                        return o = t, (null != (n = e) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? n[Symbol.hasInstance](o) : o instanceof n) ? t : new e(t);
                    }
                }
            ], o && Rf(t.prototype, o), n && Rf(t, n), e;
        }();
        function Lf(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function Mf(e) {
            return function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        Lf(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        Lf(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            };
        }
        function Bf(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Df(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function Nf(e, t) {
            var o, n, r, i, a = {
                label: 0,
                sent: function() {
                    if (1 & r[0]) throw r[1];
                    return r[1];
                },
                trys: [],
                ops: []
            };
            return i = {
                next: l(0),
                throw: l(1),
                return: l(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                return this;
            }), i;
            function l(i) {
                return function(l) {
                    return function(i) {
                        if (o) throw new TypeError("Generator is already executing.");
                        for(; a;)try {
                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                            switch(n = 0, r && (i = [
                                2 & i[0],
                                r.value
                            ]), i[0]){
                                case 0:
                                case 1:
                                    r = i;
                                    break;
                                case 4:
                                    return a.label++, {
                                        value: i[1],
                                        done: !1
                                    };
                                case 5:
                                    a.label++, n = i[1], i = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    i = a.ops.pop(), a.trys.pop();
                                    continue;
                                default:
                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                        a = 0;
                                        continue;
                                    }
                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                        a.label = i[1];
                                        break;
                                    }
                                    if (6 === i[0] && a.label < r[1]) {
                                        a.label = r[1], r = i;
                                        break;
                                    }
                                    if (r && a.label < r[2]) {
                                        a.label = r[2], a.ops.push(i);
                                        break;
                                    }
                                    r[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                            }
                            i = t.call(e, a);
                        } catch (e) {
                            i = [
                                6,
                                e
                            ], n = 0;
                        } finally{
                            o = r = 0;
                        }
                        if (5 & i[0]) throw i[1];
                        return {
                            value: i[0] ? i[1] : void 0,
                            done: !0
                        };
                    }([
                        i,
                        l
                    ]);
                };
            }
        }
        var Hf = "default", Ff = new Set([
            "allowFiles",
            "allowFileMove",
            "allowFileUpload",
            "allowFileUploadRemote",
            "allowFileRemove",
            "allowFileRename",
            "allowFolders",
            "allowFolderMove",
            "allowFolderCreate",
            "allowFolderRemove",
            "allowFolderRename",
            "allowImageResize",
            "allowImageCrop"
        ]), qf = function() {
            function e(t, o) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.parent = t, this.options = o, this.__currentPermissions = null, this.__ajaxInstances = new Map, this.progressHandler = function(e) {};
            }
            var t, o;
            return t = e, o = [
                {
                    key: "o",
                    get: function() {
                        return this.options;
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        var t = this, o = this.__ajaxInstances;
                        if (o.has(e)) {
                            var n = o.get(e);
                            null == n || n.abort(), o.delete(e);
                        }
                        var r = _r(void 0 !== this.options[e] ? this.options[e] : {}, _r({
                            onProgress: this.progressHandler
                        }, this.o.ajax));
                        r.prepareData && (r.data = r.prepareData.call(this, r.data));
                        var i = new _l(r);
                        o.set(e, i);
                        var a = i.send();
                        return a.finally(function() {
                            i.destruct(), o.delete(e), t.progressHandler(100);
                        }).catch(function() {
                            return null;
                        }), a.then(function(e) {
                            return e.json();
                        }).then(function(e) {
                            if (e && !t.isSuccess(e)) throw new Error(t.getMessage(e));
                            return e;
                        });
                    }
                },
                {
                    key: "onProgress",
                    value: function(e) {
                        this.progressHandler = e;
                    }
                },
                {
                    key: "permissions",
                    value: function(e, t) {
                        var o = this;
                        return Mf(function() {
                            return Nf(this, function(n) {
                                return o.o.permissions ? (o.o.permissions.data.path = e, o.o.permissions.data.source = t, o.o.permissions.url ? [
                                    2,
                                    o.get("permissions").then(function(e) {
                                        if (o.parent.isInDestruct) throw Cr();
                                        var t = o.o.permissions.process;
                                        if (t || (t = o.o.ajax.process), t) {
                                            var n = t.call(self, e);
                                            n.data.permissions && (o.parent.events.fire(o, "changePermissions", o.__currentPermissions, n.data.permissions), o.__currentPermissions = n.data.permissions);
                                        }
                                        return o.__currentPermissions;
                                    })
                                ] : [
                                    2,
                                    null
                                ]) : [
                                    2,
                                    null
                                ];
                            });
                        })();
                    }
                },
                {
                    key: "canI",
                    value: function(e) {
                        var t = "allow" + e;
                        if (!ft && !Ff.has(t)) throw Fr("Wrong action " + e);
                        var o = this.o.permissionsPresets[t];
                        return void 0 !== o ? o : null == this.__currentPermissions || void 0 === this.__currentPermissions[t] || this.__currentPermissions[t];
                    }
                },
                {
                    key: "__items",
                    value: function(e, t, o, n) {
                        var r = this, i = this.options;
                        return i.items ? (i.items.data.path = e, i.items.data.source = t, i.items.data.mods = o, this.get("items").then(function(e) {
                            var t = r.o.items.process;
                            return t || (t = r.o.ajax.process), t && (e = t.call(self, e)), n(e);
                        })) : Promise.reject(Error("Set Items api options"));
                    }
                },
                {
                    key: "items",
                    value: function(e, t) {
                        var o = this, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return this.__items(e, t, n, function(e) {
                            return o.generateItemsList(e.data.sources, n);
                        });
                    }
                },
                {
                    key: "itemsEx",
                    value: function(e, t) {
                        var o = this, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return this.__items(e, t, n, function(e) {
                            var t;
                            return {
                                items: o.generateItemsList(e.data.sources, n),
                                loadedTotal: (t = e.data.sources, t.reduce(function(e, t) {
                                    return e + t.files.length;
                                }, 0))
                            };
                        });
                    }
                },
                {
                    key: "generateItemsList",
                    value: function(e) {
                        var t = this, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [];
                        return e.forEach(function(e) {
                            if (e.files && e.files.length) {
                                var r = t.o.sort;
                                Ro(r) && o.sortBy && e.files.sort(function(e, t) {
                                    return r(e, t, o.sortBy);
                                }), e.files.forEach(function(r) {
                                    (function(e) {
                                        var n;
                                        return !(null === (n = o.filterWord) || void 0 === n ? void 0 : n.length) || void 0 === t.o.filter || t.o.filter(e, o.filterWord);
                                    })(r) && function(e) {
                                        return "folder" === e.type || !o.onlyImages || void 0 === e.isImage || e.isImage;
                                    }(r) && n.push(Af.create(function(e, t) {
                                        return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                                            var t = Object.keys(e);
                                            if (Object.getOwnPropertySymbols) {
                                                var o = Object.getOwnPropertySymbols(e);
                                                t.push.apply(t, o);
                                            }
                                            return t;
                                        })(Object(t)).forEach(function(o) {
                                            Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
                                        }), e;
                                    }(function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                                            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                                return Object.getOwnPropertyDescriptor(o, e).enumerable;
                                            }))), n.forEach(function(t) {
                                                Df(e, t, o[t]);
                                            });
                                        }
                                        return e;
                                    }({}, r), {
                                        sourceName: e.name,
                                        source: e
                                    })));
                                });
                            }
                        }), n;
                    }
                },
                {
                    key: "tree",
                    value: function(e, t) {
                        var o = this;
                        return Mf(function() {
                            return Nf(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return e = Gi(e), o.o.folder ? [
                                            4,
                                            o.permissions(e, t)
                                        ] : [
                                            2,
                                            Promise.reject(Error("Set Folder Api options"))
                                        ];
                                    case 1:
                                        return n.sent(), o.o.folder.data.path = e, o.o.folder.data.source = t, [
                                            2,
                                            o.get("folder").then(function(e) {
                                                var t = o.o.folder.process;
                                                return t || (t = o.o.ajax.process), t && (e = t.call(self, e)), e.data.sources;
                                            })
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "getPathByUrl",
                    value: function(e) {
                        var t = this;
                        return ai("options.getLocalFileByUrl.data.url", e, this), this.get("getLocalFileByUrl").then(function(e) {
                            if (t.isSuccess(e)) return e.data;
                            throw Fr(t.getMessage(e));
                        });
                    }
                },
                {
                    key: "createFolder",
                    value: function(e, t, o) {
                        var n = this, r = this.o.create;
                        if (!r) throw Fr("Set Create api options");
                        return r.data.source = o, r.data.path = t, r.data.name = e, this.get("create").then(function(e) {
                            if (n.isSuccess(e)) return !0;
                            throw Fr(n.getMessage(e));
                        });
                    }
                },
                {
                    key: "move",
                    value: function(e, t, o, n) {
                        var r = this, i = n ? "fileMove" : "folderMove", a = this.options[i];
                        if (!a) throw Fr("Set Move api options");
                        return a.data.from = e, a.data.path = t, a.data.source = o, this.get(i).then(function(e) {
                            if (r.isSuccess(e)) return !0;
                            throw Fr(r.getMessage(e));
                        });
                    }
                },
                {
                    key: "remove",
                    value: function(e, t, o, n) {
                        var r = this, i = this.o[e];
                        if (!i) throw Fr('Set "'.concat(e, '" api options'));
                        return i.data.path = t, i.data.name = o, i.data.source = n, this.get(e).then(function(e) {
                            return i.process && (e = i.process.call(r, e)), r.getMessage(e);
                        });
                    }
                },
                {
                    key: "fileRemove",
                    value: function(e, t, o) {
                        return this.remove("fileRemove", e, t, o);
                    }
                },
                {
                    key: "folderRemove",
                    value: function(e, t, o) {
                        return this.remove("folderRemove", e, t, o);
                    }
                },
                {
                    key: "rename",
                    value: function(e, t, o, n, r) {
                        var i = this, a = this.o[e];
                        if (!a) throw Fr('Set "'.concat(e, '" api options'));
                        return a.data.path = t, a.data.name = o, a.data.newname = n, a.data.source = r, this.get(e).then(function(e) {
                            return a.process && (e = a.process.call(self, e)), i.getMessage(e);
                        });
                    }
                },
                {
                    key: "folderRename",
                    value: function(e, t, o, n) {
                        return this.rename("folderRename", e, t, o, n);
                    }
                },
                {
                    key: "fileRename",
                    value: function(e, t, o, n) {
                        return this.rename("fileRename", e, t, o, n);
                    }
                },
                {
                    key: "changeImage",
                    value: function(e, t, o, n, r, i) {
                        this.o[e] || (this.o[e] = {
                            data: {}
                        });
                        var a = this.o[e];
                        return void 0 === a.data && (a.data = {
                            action: e
                        }), a.data.newname = r || n, i && (a.data.box = i), a.data.path = t, a.data.name = n, a.data.source = o, this.get(e).then(function() {
                            return !0;
                        });
                    }
                },
                {
                    key: "crop",
                    value: function(e, t, o, n, r) {
                        return this.changeImage("crop", e, t, o, n, r);
                    }
                },
                {
                    key: "resize",
                    value: function(e, t, o, n, r) {
                        return this.changeImage("resize", e, t, o, n, r);
                    }
                },
                {
                    key: "getMessage",
                    value: function(e) {
                        return this.options.getMessage(e);
                    }
                },
                {
                    key: "isSuccess",
                    value: function(e) {
                        return this.options.isSuccess(e);
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.__ajaxInstances.forEach(function(e) {
                            return e.destruct();
                        }), this.__ajaxInstances.clear();
                    }
                }
            ], o && Bf(t.prototype, o), e;
        }();
        const Vf = qf = function(e, t, o, n) {
            var r, i, a = arguments.length, l = a < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" == ("undefined" == typeof Reflect ? "undefined" : (i = Reflect) && "undefined" != typeof Symbol && i.constructor === Symbol ? "symbol" : typeof i) && "function" == typeof Reflect.decorate) l = Reflect.decorate(e, t, o, n);
            else for(var s = e.length - 1; s >= 0; s--)(r = e[s]) && (l = (a < 3 ? r(l) : a > 3 ? r(t, o, l) : r(t, o)) || l);
            return a > 3 && l && Object.defineProperty(t, o, l), l;
        }([
            To
        ], qf);
        function Wf(e, t, o) {
            return e.dataProvider.fileRemove(e.state.currentPath, t, o).then(function(o) {
                e.status(o || e.i18n('File "%s" was deleted', t), !0);
            }).catch(e.status);
        }
        rr.prototype.imageeditor = {
            min_width: 20,
            min_height: 20,
            closeAfterSave: !1,
            width: "85%",
            height: "85%",
            crop: !0,
            resize: !0,
            resizeUseRatio: !0,
            resizeMinWidth: 20,
            resizeMinHeight: 20,
            cropUseRatio: !0,
            cropDefaultWidth: "70%",
            cropDefaultHeight: "70%"
        }, Ol.set("crop", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M621 1280h595v-595zm-45-45l595-595h-595v595zm1152 77v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"/> </svg> ').set("resize", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <g transform="translate(-251.000000, -443.000000)"> <g transform="translate(215.000000, 119.000000)"/> <path d="M252,448 L256,448 L256,444 L252,444 L252,448 Z M257,448 L269,448 L269,446 L257,446 L257,448 Z M257,464 L269,464 L269,462 L257,462 L257,464 Z M270,444 L270,448 L274,448 L274,444 L270,444 Z M252,462 L252,466 L256,466 L256,462 L252,462 Z M270,462 L270,466 L274,466 L274,462 L270,462 Z M254,461 L256,461 L256,449 L254,449 L254,461 Z M270,461 L272,461 L272,449 L270,449 L270,461 Z"/> </g> </svg> ');
        var Uf = "jodit-image-editor", Yf = Ol.get.bind(Ol), Kf = function(e) {
            return e ? arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "jodti-image-editor_active" : "";
        };
        function Gf(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Jf(e, t, o) {
            return Jf = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Xf(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Jf(e, t, o || e);
        }
        function Xf(e) {
            return Xf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Xf(e);
        }
        function Zf(e, t) {
            return Zf = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Zf(e, t);
        }
        function Qf(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function $f() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return ($f = function() {
                return !!e;
            })();
        }
        var ep, tp = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Qf(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, op = "jodit-image-editor", np = "resize", rp = "crop", ip = ep = function(e) {
            function t(e) {
                var o;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Xf(t), function(e, t) {
                        return !t || "object" !== Qf(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, $f() ? Reflect.construct(t, o || [], Xf(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).resizeUseRatio = !0, o.cropUseRatio = !0, o.clicked = !1, o.start_x = 0, o.start_y = 0, o.top_x = 0, o.top_y = 0, o.width = 0, o.height = 0, o.activeTab = np, o.naturalWidth = 0, o.naturalHeight = 0, o.ratio = 0, o.new_h = 0, o.new_w = 0, o.diff_x = 0, o.diff_y = 0, o.cropBox = {
                    x: 0,
                    y: 0,
                    w: 0,
                    h: 0
                }, o.resizeBox = {
                    w: 0,
                    h: 0
                }, o.calcCropBox = function() {
                    var e = o.crop_box.parentNode, t = .8 * e.offsetWidth, n = .8 * e.offsetHeight, r = t, i = n, a = o.naturalWidth, l = o.naturalHeight;
                    t > a && n > l ? (r = a, i = l) : o.ratio > t / n ? (r = t, i = l * (t / a)) : (r = a * (n / l), i = n), Ln(o.crop_box, {
                        width: r,
                        height: i
                    });
                }, o.showCrop = function() {
                    if (o.cropImage) {
                        o.calcCropBox();
                        var e = o.cropImage.offsetWidth || o.image.offsetWidth || o.image.naturalWidth;
                        o.new_w = ep.calcValueByPercent(e, o.o.cropDefaultWidth);
                        var t = o.cropImage.offsetHeight || o.image.offsetHeight || o.image.naturalHeight;
                        o.cropUseRatio ? o.new_h = o.new_w / o.ratio : o.new_h = ep.calcValueByPercent(t, o.o.cropDefaultHeight), Ln(o.cropHandler, {
                            backgroundImage: "url(" + er(o.cropImage, "src") + ")",
                            width: o.new_w,
                            height: o.new_h,
                            left: e / 2 - o.new_w / 2,
                            top: t / 2 - o.new_h / 2
                        }), o.j.e.fire(o.cropHandler, "updatesize");
                    }
                }, o.updateCropBox = function() {
                    if (o.cropImage) {
                        var e = o.cropImage.offsetWidth / o.naturalWidth, t = o.cropImage.offsetHeight / o.naturalHeight;
                        o.cropBox.x = Ln(o.cropHandler, "left") / e, o.cropBox.y = Ln(o.cropHandler, "top") / t, o.cropBox.w = o.cropHandler.offsetWidth / e, o.cropBox.h = o.cropHandler.offsetHeight / t, o.sizes.textContent = o.cropBox.w.toFixed(0) + "x" + o.cropBox.h.toFixed(0);
                    }
                }, o.updateResizeBox = function() {
                    o.resizeBox.w = o.image.offsetWidth || o.naturalWidth, o.resizeBox.h = o.image.offsetHeight || o.naturalHeight;
                }, o.setHandlers = function() {
                    var e = o, t = ei(o.editor), n = t.widthInput, r = t.heightInput;
                    e.j.e.on([
                        e.editor.querySelector(".jodit_bottomright"),
                        e.cropHandler
                    ], "mousedown.".concat(op), o.onResizeHandleMouseDown).on(o.j.ow, "resize.".concat(op), function() {
                        o.j.e.fire(e.resizeHandler, "updatesize"), e.showCrop(), o.j.e.fire(e.cropHandler, "updatesize");
                    }), e.j.e.on(Fo(o.editor.querySelectorAll(".".concat(op, "__slider-title"))), "click", o.onTitleModeClick).on([
                        n,
                        r
                    ], "input", o.onChangeSizeInput);
                    var i = ei(o.editor), a = i.keepAspectRatioResize, l = i.keepAspectRatioCrop;
                    a && a.addEventListener("change", function() {
                        o.resizeUseRatio = a.checked;
                    }), l && l.addEventListener("change", function() {
                        o.cropUseRatio = l.checked;
                    }), e.j.e.on(e.resizeHandler, "updatesize", function() {
                        Ln(e.resizeHandler, {
                            top: 0,
                            left: 0,
                            width: e.image.offsetWidth || e.naturalWidth,
                            height: e.image.offsetHeight || e.naturalHeight
                        }), o.updateResizeBox();
                    }).on(e.cropHandler, "updatesize", function() {
                        if (e.cropImage) {
                            var t = Ln(e.cropHandler, "left"), o = Ln(e.cropHandler, "top"), n = e.cropHandler.offsetWidth, r = e.cropHandler.offsetHeight;
                            t < 0 && (t = 0), o < 0 && (o = 0), t + n > e.cropImage.offsetWidth && (n = e.cropImage.offsetWidth - t, e.cropUseRatio && (r = n / e.ratio)), o + r > e.cropImage.offsetHeight && (r = e.cropImage.offsetHeight - o, e.cropUseRatio && (n = r * e.ratio)), Ln(e.cropHandler, {
                                width: n,
                                height: r,
                                left: t,
                                top: o,
                                backgroundPosition: -t - 1 + "px " + (-o - 1) + "px",
                                backgroundSize: e.cropImage.offsetWidth + "px " + e.cropImage.offsetHeight + "px"
                            }), e.updateCropBox();
                        }
                    }), Object.values(e.buttons).forEach(function(t) {
                        t.onAction(function() {
                            var o = {
                                action: e.activeTab,
                                box: e.activeTab === np ? e.resizeBox : e.cropBox
                            };
                            switch(t){
                                case e.buttons.saveas:
                                    e.j.prompt("Enter new name", "Save in new file", function(t) {
                                        if (!vn(t)) return e.j.alert("The name should not be empty"), !1;
                                        e.onSave(t, o, e.hide, function(t) {
                                            e.j.alert(t.message);
                                        });
                                    });
                                    break;
                                case e.buttons.save:
                                    e.onSave(void 0, o, e.hide, function(t) {
                                        e.j.alert(t.message);
                                    });
                                    break;
                                case e.buttons.reset:
                                    e.activeTab === np ? (Ln(e.image, {
                                        width: null,
                                        height: null
                                    }), n.value = e.naturalWidth.toString(), r.value = e.naturalHeight.toString(), e.j.e.fire(e.resizeHandler, "updatesize")) : e.showCrop();
                            }
                        });
                    });
                }, o.options = e && e.o && e.o.imageeditor ? e.o.imageeditor : rr.defaultOptions.imageeditor;
                var n = o.options;
                o.resizeUseRatio = n.resizeUseRatio, o.cropUseRatio = n.cropUseRatio, o.buttons = {
                    reset: Es(o.j, "update", "Reset"),
                    save: Es(o.j, "save", "Save"),
                    saveas: Es(o.j, "save", "Save as ...")
                }, o.activeTab = n.resize ? np : rp, o.editor = function(e, t) {
                    var o = e.i18n.bind(e), n = function(e, t) {
                        return '<div class="jodit-form__group">\n\t\t\t<label class="jodit-switcher-wrapper">\n\t\t\t\t<span class=\'jodit-switcher\'>\n\t\t\t\t\t<input '.concat(Kf(!(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], "checked"), ' data-ref="').concat(t, '" type="checkbox"/>\n\t\t\t\t\t<span class="jodit-switcher__slider"></span>\n\t\t\t\t</span>\n\t\t\t\t<span>').concat(o(e), "</span>\n\t\t\t</label>\n\t</div>");
                    };
                    return e.create.fromHTML('<form class="'.concat(Uf, ' jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-3-4 jodit_col-sm-5-5">\n\t\t\t').concat(t.resize ? '<div class="'.concat(Uf, "__area ").concat(Uf, "__area_resize ").concat(Uf, '_active">\n\t\t\t\t\t\t\t<div data-ref="resizeBox" class="').concat(Uf, '__box"></div>\n\t\t\t\t\t\t\t<div class="').concat(Uf, '__resizer">\n\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>') : "", "\n\t\t\t").concat(t.crop ? '<div class="'.concat(Uf, "__area ").concat(Uf, "__area_crop ").concat(Kf(!t.resize), '">\n\t\t\t\t\t\t\t<div data-ref="cropBox" class="').concat(Uf, '__box">\n\t\t\t\t\t\t\t\t<div class="').concat(Uf, '__croper">\n\t\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t\t\t<i class="').concat(Uf, '__sizes"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>') : "", '\n\t\t\t</div>\n\t\t\t<div class="jodit_col-lg-1-4 jodit_col-sm-5-5">\n\t\t\t').concat(t.resize ? '<div data-area="resize" class="'.concat(Uf, "__slider ").concat(Uf, '_active">\n\t\t\t\t\t\t\t<div class="').concat(Uf, '__slider-title">\n\t\t\t\t\t\t\t\t').concat(Yf("resize"), "\n\t\t\t\t\t\t\t\t").concat(o("Resize"), '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="').concat(Uf, '__slider-content">\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t').concat(o("Width"), '\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="widthInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t').concat(o("Height"), '\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="heightInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t').concat(n("Keep Aspect Ratio", "keepAspectRatioResize"), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : "", "\n\t\t\t").concat(t.crop ? '<div data-area="crop" class="'.concat(Uf, "__slider ").concat(Kf(!t.resize), '\'">\n\t\t\t\t\t\t\t<div class="').concat(Uf, '__slider-title">\n\t\t\t\t\t\t\t\t').concat(Yf("crop"), "\n\t\t\t\t\t\t\t\t").concat(o("Crop"), '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="').concat(Uf, '__slider-content">\n\t\t\t\t\t\t\t\t').concat(n("Keep Aspect Ratio", "keepAspectRatioCrop"), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : "", "\n\t\t\t</div>\n\t\t</div>\n\t</form>"));
                }(o.j, o.options);
                var r = ei(o.editor), i = r.resizeBox, a = r.cropBox;
                return o.resize_box = i, o.crop_box = a, o.sizes = o.editor.querySelector(".".concat(op, "__area.").concat(op, "__area_crop .jodit-image-editor__sizes")), o.resizeHandler = o.editor.querySelector(".".concat(op, "__resizer")), o.cropHandler = o.editor.querySelector(".".concat(op, "__croper")), o._dialog = o.j.dlg({
                    buttons: [
                        "fullsize",
                        "dialog.close"
                    ]
                }), o._dialog.setContent(o.editor), o._dialog.setSize(o.o.width, o.o.height), o._dialog.setHeader([
                    o.buttons.reset,
                    o.buttons.save,
                    o.buttons.saveas
                ]), o.setHandlers(), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Zf(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "ImageEditor";
                    }
                },
                {
                    key: "o",
                    get: function() {
                        return this.options;
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        this._dialog.close();
                    }
                },
                {
                    key: "open",
                    value: function(e, t) {
                        var o = this;
                        return this.j.async.promise(function(n) {
                            var r = (new Date).getTime();
                            o.image = o.j.c.element("img"), Qr("img,.jodit-icon_loader", o.resize_box).forEach(pi.safeRemove), Qr("img,.jodit-icon_loader", o.crop_box).forEach(pi.safeRemove), Ln(o.cropHandler, "background", "transparent"), o.onSave = t, o.resize_box.appendChild(o.j.c.element("i", {
                                class: "jodit-icon_loader"
                            })), o.crop_box.appendChild(o.j.c.element("i", {
                                class: "jodit-icon_loader"
                            })), /\?/.test(e) ? e += "&_tst=" + r : e += "?_tst=" + r, o.image.setAttribute("src", e), o._dialog.open();
                            var i = ei(o.editor), a = i.widthInput, l = i.heightInput, s = function() {
                                o.isDestructed || (o.image.removeEventListener("load", s), o.naturalWidth = o.image.naturalWidth, o.naturalHeight = o.image.naturalHeight, a.value = o.naturalWidth.toString(), l.value = o.naturalHeight.toString(), o.ratio = o.naturalWidth / o.naturalHeight, o.resize_box.appendChild(o.image), o.cropImage = o.image.cloneNode(!0), o.crop_box.appendChild(o.cropImage), pi.safeRemove.apply(null, Qr(".jodit-icon_loader", o.editor)), o.activeTab === rp && o.showCrop(), o.j.e.fire(o.resizeHandler, "updatesize"), o.j.e.fire(o.cropHandler, "updatesize"), o._dialog.setPosition(), o.j.e.fire("afterImageEditor"), n(o._dialog));
                            };
                            o.image.addEventListener("load", s), o.image.complete && s();
                        });
                    }
                },
                {
                    key: "onTitleModeClick",
                    value: function(e) {
                        var t = this, o = e.target, n = null == o ? void 0 : o.parentElement;
                        if (n) {
                            Qr(".".concat(op, "__slider,.").concat(op, "__area"), t.editor).forEach(function(e) {
                                return e.classList.remove("".concat(op, "_active"));
                            }), n.classList.add("".concat(op, "_active")), this.activeTab = er(n, "-area") || np;
                            var r = t.editor.querySelector(".".concat(op, "__area.").concat(op, "__area_") + t.activeTab);
                            r && r.classList.add("".concat(op, "_active")), t.activeTab === rp && t.showCrop();
                        }
                    }
                },
                {
                    key: "onChangeSizeInput",
                    value: function(e) {
                        var t, o = this, n = e.target, r = ei(this.editor), i = r.widthInput, a = r.heightInput, l = "widthInput" === er(n, "data-ref"), s = parseInt(n.value, 10), c = l ? o.o.min_width : o.o.min_height, u = l ? o.o.min_height : o.o.min_width;
                        s > c && (Ln(o.image, l ? "width" : "height", s), o.resizeUseRatio && (t = l ? Math.round(s / o.ratio) : Math.round(s * o.ratio)) > u && (Ln(o.image, l ? "height" : "width", t), l ? a.value = t.toString() : i.value = t.toString())), this.j.e.fire(o.resizeHandler, "updatesize");
                    }
                },
                {
                    key: "onResizeHandleMouseDown",
                    value: function(e) {
                        var t = this;
                        t.target = e.target, e.preventDefault(), e.stopImmediatePropagation(), t.clicked = !0, t.start_x = e.clientX, t.start_y = e.clientY, t.activeTab === rp ? (t.top_x = Ln(t.cropHandler, "left"), t.top_y = Ln(t.cropHandler, "top"), t.width = t.cropHandler.offsetWidth, t.height = t.cropHandler.offsetHeight) : (t.width = t.image.offsetWidth, t.height = t.image.offsetHeight), t.j.e.on(this.j.ow, "mousemove", this.onGlobalMouseMove).one(this.j.ow, "mouseup", this.onGlobalMouseUp);
                    }
                },
                {
                    key: "onGlobalMouseUp",
                    value: function(e) {
                        this.clicked && (this.clicked = !1, e.stopImmediatePropagation(), this.j.e.off(this.j.ow, "mousemove", this.onGlobalMouseMove));
                    }
                },
                {
                    key: "onGlobalMouseMove",
                    value: function(e) {
                        var t = this;
                        if (t.clicked) {
                            var o = ei(this.editor), n = o.widthInput, r = o.heightInput;
                            t.diff_x = e.clientX - t.start_x, t.diff_y = e.clientY - t.start_y, t.activeTab === np && t.resizeUseRatio || t.activeTab === rp && t.cropUseRatio ? t.diff_x ? (t.new_w = t.width + t.diff_x, t.new_h = Math.round(t.new_w / t.ratio)) : (t.new_h = t.height + t.diff_y, t.new_w = Math.round(t.new_h * t.ratio)) : (t.new_w = t.width + t.diff_x, t.new_h = t.height + t.diff_y), t.activeTab === np ? (t.new_w > t.o.resizeMinWidth && (Ln(t.image, "width", t.new_w + "px"), n.value = t.new_w.toString()), t.new_h > t.o.resizeMinHeight && (Ln(t.image, "height", t.new_h + "px"), r.value = t.new_h.toString()), this.j.e.fire(t.resizeHandler, "updatesize")) : (t.target !== t.cropHandler ? (t.top_x + t.new_w > t.cropImage.offsetWidth && (t.new_w = t.cropImage.offsetWidth - t.top_x), t.top_y + t.new_h > t.cropImage.offsetHeight && (t.new_h = t.cropImage.offsetHeight - t.top_y), Ln(t.cropHandler, {
                                width: t.new_w,
                                height: t.new_h
                            })) : (t.top_x + t.diff_x + t.cropHandler.offsetWidth > t.cropImage.offsetWidth && (t.diff_x = t.cropImage.offsetWidth - t.top_x - t.cropHandler.offsetWidth), Ln(t.cropHandler, "left", t.top_x + t.diff_x), t.top_y + t.diff_y + t.cropHandler.offsetHeight > t.cropImage.offsetHeight && (t.diff_y = t.cropImage.offsetHeight - t.top_y - t.cropHandler.offsetHeight), Ln(t.cropHandler, "top", t.top_y + t.diff_y)), this.j.e.fire(t.cropHandler, "updatesize"));
                        }
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.isDestructed || (this._dialog && !this._dialog.isInDestruct && this._dialog.destruct(), pi.safeRemove(this.editor), this.j.e && this.j.e.off(this.j.ow, "mousemove", this.onGlobalMouseMove).off(this.j.ow, "mouseup", this.onGlobalMouseUp).off(this.ow, ".".concat(op)).off(".".concat(op)), Jf(Xf(t.prototype), "destruct", this).call(this));
                    }
                }
            ], n && Gf(o.prototype, n), t;
        }(Qa);
        function ap(e, t, o, n, r, i) {
            var a = this;
            return this.getInstance("ImageEditor", this.o).open(e, function(e, l, s, c) {
                return dr("resize" === l.action ? a.dataProvider.resize : a.dataProvider.crop, o, n, t, e, l.box).then(function(e) {
                    e && (s(), r && r());
                }).catch(function(e) {
                    c(e), i && i(e);
                });
            });
        }
        function lp(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function sp(e) {
            return function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        lp(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        lp(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            };
        }
        ip.calcValueByPercent = function(e, t) {
            var o, n = t.toString(), r = parseFloat(e.toString());
            return (o = /^[-+]?[0-9]+(px)?$/.exec(n)) ? parseInt(n, 10) : (o = /^([-+]?[0-9.]+)%$/.exec(n)) ? Math.round(r * (parseFloat(o[1]) / 100)) : r || 0;
        }, tp([
            To
        ], ip.prototype, "hide", null), tp([
            To
        ], ip.prototype, "open", null), tp([
            To
        ], ip.prototype, "onTitleModeClick", null), tp([
            $a(),
            To
        ], ip.prototype, "onChangeSizeInput", null), tp([
            To
        ], ip.prototype, "onResizeHandleMouseDown", null), tp([
            To
        ], ip.prototype, "onGlobalMouseUp", null), tp([
            el(10)
        ], ip.prototype, "onGlobalMouseMove", null), ip = ep = tp([
            ji
        ], ip);
        var cp = "jodit-file-browser-preview", up = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "next", t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "right";
            return '<div class="'.concat(cp, "__navigation ").concat(cp, "__navigation_arrow_").concat(e, '">') + "" + Ol.get("angle-" + t) + "</a>";
        };
        function dp(e) {
            if (!e.o.contextMenu) return function() {};
            var t = new Sf(e);
            return function(o) {
                var n = pp(o.target, e.container);
                if (n) {
                    var r = n, i = e.options, a = function(e) {
                        return er(r, e) || "";
                    };
                    return e.async.setTimeout(function() {
                        var l = hp(n, Pf(e));
                        l && (e.state.activeElements = [
                            l
                        ], t.show(o.clientX, o.clientY, [
                            !("1" === a("data-is-file") || !i.editImage || !e.dataProvider.canI("ImageResize") && !e.dataProvider.canI("ImageCrop")) && {
                                icon: "pencil",
                                title: "Edit",
                                exec: function() {
                                    return ap.call(e, a("href"), a("data-name"), a("data-path"), a("data-source"));
                                }
                            },
                            !!e.dataProvider.canI("FileRename") && {
                                icon: "italic",
                                title: "Rename",
                                exec: function() {
                                    e.e.fire("fileRename.filebrowser", a("data-name"), a("data-path"), a("data-source"));
                                }
                            },
                            !!e.dataProvider.canI("FileRemove") && {
                                icon: "bin",
                                title: "Delete",
                                exec: sp(function() {
                                    var t;
                                    return function(e, t) {
                                        var o, n, r, i, a = {
                                            label: 0,
                                            sent: function() {
                                                if (1 & r[0]) throw r[1];
                                                return r[1];
                                            },
                                            trys: [],
                                            ops: []
                                        };
                                        return i = {
                                            next: l(0),
                                            throw: l(1),
                                            return: l(2)
                                        }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                            return this;
                                        }), i;
                                        function l(i) {
                                            return function(l) {
                                                return function(i) {
                                                    if (o) throw new TypeError("Generator is already executing.");
                                                    for(; a;)try {
                                                        if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                        switch(n = 0, r && (i = [
                                                            2 & i[0],
                                                            r.value
                                                        ]), i[0]){
                                                            case 0:
                                                            case 1:
                                                                r = i;
                                                                break;
                                                            case 4:
                                                                return a.label++, {
                                                                    value: i[1],
                                                                    done: !1
                                                                };
                                                            case 5:
                                                                a.label++, n = i[1], i = [
                                                                    0
                                                                ];
                                                                continue;
                                                            case 7:
                                                                i = a.ops.pop(), a.trys.pop();
                                                                continue;
                                                            default:
                                                                if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                                    a = 0;
                                                                    continue;
                                                                }
                                                                if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                                    a.label = i[1];
                                                                    break;
                                                                }
                                                                if (6 === i[0] && a.label < r[1]) {
                                                                    a.label = r[1], r = i;
                                                                    break;
                                                                }
                                                                if (r && a.label < r[2]) {
                                                                    a.label = r[2], a.ops.push(i);
                                                                    break;
                                                                }
                                                                r[2] && a.ops.pop(), a.trys.pop();
                                                                continue;
                                                        }
                                                        i = t.call(e, a);
                                                    } catch (e) {
                                                        i = [
                                                            6,
                                                            e
                                                        ], n = 0;
                                                    } finally{
                                                        o = r = 0;
                                                    }
                                                    if (5 & i[0]) throw i[1];
                                                    return {
                                                        value: i[0] ? i[1] : void 0,
                                                        done: !0
                                                    };
                                                }([
                                                    i,
                                                    l
                                                ]);
                                            };
                                        }
                                    }(this, function(o) {
                                        switch(o.label){
                                            case 0:
                                                return o.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]), [
                                                    4,
                                                    Wf(e, a("data-name"), a("data-source"))
                                                ];
                                            case 1:
                                                return o.sent(), [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                return t = o.sent(), [
                                                    2,
                                                    e.status(t)
                                                ];
                                            case 3:
                                                return e.state.activeElements = [], [
                                                    2,
                                                    Ef(e).catch(e.status)
                                                ];
                                        }
                                    });
                                })
                            },
                            !!i.preview && {
                                icon: "eye",
                                title: "Preview",
                                exec: function() {
                                    var t = e.dlg({
                                        buttons: [
                                            "fullsize",
                                            "dialog.close"
                                        ]
                                    }), o = e.c.div(cp, '<div class="jodit-icon_loader"></div>'), n = e.c.div(cp + "__box"), l = e.c.fromHTML(up()), s = e.c.fromHTML(up("prev", "left")), c = function(a) {
                                        var c = e.c.element("img");
                                        c.setAttribute("src", a);
                                        var u = function() {
                                            var a;
                                            e.isInDestruct || (e.e.off(c, "load"), pi.detach(o), i.showPreviewNavigation && (pi.prevWithClass(r, e.files.getFullElName("item")) && o.appendChild(s), pi.nextWithClass(r, e.files.getFullElName("item")) && o.appendChild(l)), o.appendChild(n), n.appendChild(c), t.setPosition(), null === (a = null == e ? void 0 : e.events) || void 0 === a || a.fire("previewOpenedAndLoaded"));
                                        };
                                        e.e.on(c, "load", u), c.complete && u();
                                    };
                                    e.e.on([
                                        l,
                                        s
                                    ], "click", function() {
                                        if (!(r = this === l ? pi.nextWithClass(r, e.files.getFullElName("item")) : pi.prevWithClass(r, e.files.getFullElName("item")))) throw Fr("Need element");
                                        pi.detach(o), pi.detach(n), o.innerHTML = '<div class="jodit-icon_loader"></div>', c(a("href"));
                                    }), e.e.on("beforeDestruct", function() {
                                        t.destruct();
                                    }), t.container.classList.add(cp + "__dialog"), t.setContent(o), t.setPosition(), t.open(), c(a("href")), e.events.on("beforeDestruct", function() {
                                        t.destruct();
                                    }).fire("previewOpened");
                                }
                            },
                            {
                                icon: "upload",
                                title: "Download",
                                exec: function() {
                                    var t = a("href");
                                    t && e.ow.open(t);
                                }
                            }
                        ]));
                    }, e.defaultTimeout), e.e.on("beforeClose", function() {
                        t.close();
                    }).on("beforeDestruct", function() {
                        return t.destruct();
                    }), o.stopPropagation(), o.preventDefault(), !1;
                }
            };
        }
        function fp(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        var pp = function(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "a";
            return pi.closest(e, function(e) {
                return pi.isTag(e, o);
            }, t);
        }, hp = function(e, t) {
            return t[e.dataset.key || ""].item;
        };
        function vp() {
            var e = this, t = !1, o = Pf(this), n = this;
            n.e.on(n.tree.container, "dragstart", function(e) {
                var o = pp(e.target, n.container);
                o && n.o.moveFolder && (t = o);
            }).on(n.tree.container, "drop", function(o) {
                if ((n.o.moveFile || n.o.moveFolder) && t) {
                    var r = er(t, "-path") || "";
                    if (!n.o.moveFolder && t.classList.contains(e.tree.getFullElName("item"))) return !1;
                    if (t.classList.contains(e.files.getFullElName("item")) && (r += er(t, "-name"), !n.o.moveFile)) return !1;
                    var i = pp(o.target, n.container);
                    if (!i) return;
                    n.dataProvider.move(r, er(i, "-path") || "", er(i, "-source") || "", t.classList.contains(e.files.getFullElName("item"))).then(function() {
                        return Ef(e);
                    }).catch(n.status), t = !1;
                }
            }).on(n.files.container, "contextmenu", dp(n)).on(n.files.container, "click", function(t) {
                xr(t) || (e.state.activeElements = []);
            }).on(n.files.container, "click", function(e) {
                var t = pp(e.target, n.container);
                if (t) {
                    var r = hp(t, o);
                    if (r) return xr(e) ? n.state.activeElements = (function(e) {
                        return function(e) {
                            if (Array.isArray(e)) return fp(e);
                        }(e) || function(e) {
                            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                        }(e) || function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return fp(e, t);
                                var o = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? fp(e, t) : void 0;
                            }
                        }(e) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    })(n.state.activeElements).concat([
                        r
                    ]) : n.state.activeElements = [
                        r
                    ], e.stopPropagation(), !1;
                }
            }).on(n.files.container, "dragstart", function(e) {
                if (n.o.moveFile) {
                    var o = pp(e.target, n.container);
                    if (!o) return;
                    t = o;
                }
            }).on(n.container, "drop", function(e) {
                return e.preventDefault();
            });
        }
        function gp(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function mp() {
            var e = this, t = this.state, o = this.dataProvider, n = this;
            n.e.on("view.filebrowser", function(e) {
                e !== t.view && (t.view = e);
            }).on("sort.filebrowser", function(e) {
                e !== t.sortBy && (t.sortBy = e, Cf(n));
            }).on("filter.filebrowser", function(e) {
                e !== t.filterWord && (t.filterWord = e, Cf(n));
            }).on("openFolder.filebrowser", function(e) {
                var t;
                t = ".." === e.name ? e.path.split("/").filter(function(e) {
                    return e.length;
                }).slice(0, -1).join("/") : Ki(e.path, e.name), n.state.currentPath = t, n.state.currentSource = "." === e.name ? Hf : e.source;
            }).on("removeFolder.filebrowser", function(e) {
                n.confirm("Are you sure?", "Delete", function(t) {
                    t && o.folderRemove(e.path, e.name, e.source).then(function(e) {
                        return n.status(e, !0), Ef(n);
                    }).catch(n.status);
                });
            }).on("renameFolder.filebrowser", function(e) {
                n.prompt("Enter new name", "Rename", function(t) {
                    if (!pn(t)) return n.status(n.i18n("Enter new name")), !1;
                    o.folderRename(e.path, e.name, t, e.source).then(function(e) {
                        return n.state.activeElements = [], n.status(e, !0), Ef(n);
                    }).catch(n.status);
                }, "type name", e.name);
            }).on("addFolder.filebrowser", function(e) {
                n.prompt("Enter Directory name", "Create directory", function(t) {
                    o.createFolder(t, e.path, e.source).then(function() {
                        return Ef(n);
                    }).catch(n.status);
                }, "type name");
            }).on("fileRemove.filebrowser", function() {
                n.state.activeElements.length && n.confirm("Are you sure?", "", function(e) {
                    if (e) {
                        var t = [];
                        n.state.activeElements.forEach(function(e) {
                            t.push(Wf(n, e.file || e.name || "", e.sourceName));
                        }), n.state.activeElements = [], Promise.all(t).then(function() {
                            return Ef(n).catch(n.status);
                        }, n.status);
                    }
                });
            }).on("edit.filebrowser", function() {
                if (1 === n.state.activeElements.length) {
                    var t = function(e, t) {
                        return function(e) {
                            if (Array.isArray(e)) return e;
                        }(e) || function(e, t) {
                            var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                            if (null != o) {
                                var n, r, i = [], a = !0, l = !1;
                                try {
                                    for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                } catch (e) {
                                    l = !0, r = e;
                                } finally{
                                    try {
                                        a || null == o.return || o.return();
                                    } finally{
                                        if (l) throw r;
                                    }
                                }
                                return i;
                            }
                        }(e, t) || function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return gp(e, t);
                                var o = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? gp(e, t) : void 0;
                            }
                        }(e, t) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }(e.state.activeElements, 1)[0];
                    ap.call(n, t.fileURL, t.file || "", t.path, t.sourceName);
                }
            }).on("fileRename.filebrowser", function(e, t, r) {
                1 === n.state.activeElements.length && n.prompt("Enter new name", "Rename", function(i) {
                    if (!pn(i)) return n.status(n.i18n("Enter new name")), !1;
                    o.fileRename(t, e, i, r).then(function(e) {
                        n.state.activeElements = [], n.status(e, !0), Cf(n);
                    }).catch(n.status);
                }, "type name", e);
            }).on("update.filebrowser", function() {
                Ef(e).then(e.status, e.status);
            });
        }
        function bp() {
            var e = this, t = Pf(this), o = this, n = o.state, r = o.files, i = o.create, a = o.options;
            n.on([
                "change.currentPath",
                "change.currentSource"
            ], this.async.debounce(function() {
                e.o.saveStateInStorage && e.o.saveStateInStorage.storeLastOpenedFolder && e.storage.set("currentPath", e.state.currentPath).set("currentSource", e.state.currentSource), Ef(e).catch(e.status);
            }, this.defaultTimeout)).on("beforeChange.activeElements", function() {
                n.activeElements.forEach(function(e) {
                    var o = e.uniqueHashKey, n = t[o].elm;
                    n && n.classList.remove(r.getFullElName("item", "active", !0));
                });
            }).on("change.activeElements", function() {
                e.e.fire("changeSelection"), n.activeElements.forEach(function(e) {
                    var o = e.uniqueHashKey, n = t[o].elm;
                    n && n.classList.add(r.getFullElName("item", "active", !0));
                });
            }).on("change.view", function() {
                r.setMod("view", n.view), e.o.saveStateInStorage && e.o.saveStateInStorage.storeView && e.storage.set("view", n.view);
            }).on("change.sortBy", function() {
                e.o.saveStateInStorage && e.o.saveStateInStorage.storeSortBy && e.storage.set("sortBy", n.sortBy);
            }).on("change.elements", this.async.debounce(function() {
                pi.detach(r.container), n.elements.length ? n.elements.forEach(function(o) {
                    e.files.container.appendChild(function(o) {
                        var n = o.uniqueHashKey;
                        if (t[n]) return t[n].elm;
                        var r = i.fromHTML(a.getThumbTemplate.call(e, o, o.source, o.sourceName.toString()));
                        return r.dataset.key = n, t[n] = {
                            item: o,
                            elm: r
                        }, t[n].elm;
                    }(o));
                }) : r.container.appendChild(i.div(e.componentName + "_no-files_true", e.i18n("There are no files")));
            }, this.defaultTimeout)).on("change.sources", this.async.debounce(function() {
                pi.detach(e.tree.container), n.sources.forEach(function(t) {
                    var o = t.name;
                    if (o && "default" !== o && e.tree.container.appendChild(i.div(e.tree.getFullElName("source-title"), o)), t.folders.forEach(function(n) {
                        var r = i.a(e.tree.getFullElName("item"), {
                            draggable: "draggable",
                            href: "#",
                            "data-path": Ki(t.path, n + "/"),
                            "data-name": n,
                            "data-source": o,
                            "data-source-path": t.path
                        }, i.span(e.tree.getFullElName("item-title"), n)), l = function(r) {
                            return function(i) {
                                e.e.fire("".concat(r, ".filebrowser"), {
                                    name: n,
                                    path: Ki(t.path + "/"),
                                    source: o
                                }), i.stopPropagation(), i.preventDefault();
                            };
                        };
                        if (e.e.on(r, "click", l("openFolder")), e.tree.container.appendChild(r), ".." !== n && "." !== n) {
                            if (a.renameFolder && e.dataProvider.canI("FolderRename")) {
                                var s = Es(e, {
                                    icon: {
                                        name: "pencil"
                                    },
                                    name: "rename",
                                    tooltip: "Rename",
                                    size: "tiny"
                                });
                                s.onAction(l("renameFolder")), r.appendChild(s.container);
                            }
                            if (a.deleteFolder && e.dataProvider.canI("FolderRemove")) {
                                var c = Es(e, {
                                    icon: {
                                        name: "cancel"
                                    },
                                    name: "remove",
                                    tooltip: "Delete",
                                    size: "tiny"
                                });
                                c.onAction(l("removeFolder")), r.appendChild(c.container);
                            }
                        }
                    }), a.createNewFolder && e.dataProvider.canI("FolderCreate")) {
                        var n = Es(e, "plus", "Add folder", "secondary");
                        n.onAction(function() {
                            e.e.fire("addFolder", {
                                path: Ki(t.path + "/"),
                                source: o
                            });
                        }), e.tree.append(n);
                    }
                });
            }, this.defaultTimeout));
        }
        function yp(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function _p(e) {
            return _p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, _p(e);
        }
        function jp(e, t) {
            return jp = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, jp(e, t);
        }
        function wp() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (wp = function() {
                return !!e;
            })();
        }
        var kp = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = _p(o = t), function(e, t) {
                    var o;
                    return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, wp() ? Reflect.construct(o, n || [], _p(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && jp(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "FileBrowserFiles";
                    }
                }
            ], yp(o.prototype, n), t;
        }(Ul);
        function Sp(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function xp(e) {
            return xp = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, xp(e);
        }
        function Op(e, t) {
            return Op = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Op(e, t);
        }
        function Cp() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Cp = function() {
                return !!e;
            })();
        }
        var zp = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = xp(o = t), function(e, t) {
                    var o;
                    return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, Cp() ? Reflect.construct(o, n || [], xp(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Op(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "FileBrowserTree";
                    }
                }
            ], Sp(o.prototype, n), t;
        }(Ul);
        function Ep(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Tp(e, t, o) {
            return Tp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ip(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Tp(e, t, o || e);
        }
        function Ip(e) {
            return Ip = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Ip(e);
        }
        function Pp(e, t) {
            return Pp = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Pp(e, t);
        }
        function Rp(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Ap() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Ap = function() {
                return !!e;
            })();
        }
        var Lp = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Rp(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Mp = function(e) {
            function t(e) {
                var o;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Ip(t), function(e, t) {
                        return !t || "object" !== Rp(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Ap() ? Reflect.construct(t, o || [], Ip(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).browser = o.c.div(o.componentName), o.status_line = o.c.div(o.getFullElName("status")), o.tree = new zp(o), o.files = new kp(o), o.state = Pa({
                    currentPath: "",
                    currentSource: Hf,
                    currentBaseUrl: "",
                    activeElements: [],
                    elements: [],
                    sources: [],
                    view: "tiles",
                    sortBy: "changed-desc",
                    filterWord: "",
                    onlyImages: !1
                }), o.errorHandler = function(e) {
                    var t, n;
                    Vo(e) || (t = e, (null != (n = Error) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? n[Symbol.hasInstance](t) : t instanceof n) ? o.status(o.i18n(e.message)) : o.status(o.dataProvider.getMessage(e)));
                }, o.close = function() {
                    o._dialog.close();
                }, o.__prevButtons = [], o.attachEvents(e);
                var n = o;
                n.options = _r(e || {}, rr.defaultOptions.filebrowser), n.browser.component = o, n.container = n.browser, n.o.showFoldersPanel && n.browser.appendChild(n.tree.container), n.browser.appendChild(n.files.container), n.browser.appendChild(n.status_line), mp.call(n), vp.call(n), bp.call(n), [
                    "getLocalFileByUrl",
                    "crop",
                    "resize",
                    "create",
                    "fileMove",
                    "folderMove",
                    "fileRename",
                    "folderRename",
                    "fileRemove",
                    "folderRemove",
                    "folder",
                    "items",
                    "permissions"
                ].forEach(function(e) {
                    null != o.options[e] && (o.options[e] = _r(o.options[e], o.o.ajax));
                });
                var r = o.o.saveStateInStorage || {
                    storeLastOpenedFolder: !1,
                    storeView: !1,
                    storeSortBy: !1
                }, i = r.storeView, a = r.storeSortBy, l = r.storeLastOpenedFolder, s = i && o.storage.get("view");
                s && null == o.o.view ? n.state.view = "list" === s ? "list" : "tiles" : n.state.view = "list" === n.o.view ? "list" : "tiles", n.files.setMod("view", n.state.view);
                var c = a && n.storage.get("sortBy");
                if (c) {
                    var u = c.split("-");
                    n.state.sortBy = [
                        "changed",
                        "name",
                        "size"
                    ].includes(u[0]) ? c : "changed-desc";
                } else n.state.sortBy = n.o.sortBy || "changed-desc";
                if (l) {
                    var d = n.storage.get("currentPath"), f = n.storage.get("currentSource");
                    n.state.currentPath = null != d ? d : "", n.state.currentSource = null != f ? f : "";
                }
                return n.initUploader(n), n.setStatus(Io.ready), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Pp(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "FileBrowser";
                    }
                },
                {
                    key: "dataProvider",
                    get: function() {
                        return function(e, t) {
                            return new Vf(e, t);
                        }(this, this.options);
                    }
                },
                {
                    key: "onSelect",
                    value: function(e) {
                        var t = this;
                        return function() {
                            if (t.state.activeElements.length) {
                                var o = [], n = [];
                                t.state.activeElements.forEach(function(e) {
                                    var t = e.fileURL;
                                    t && (o.push(t), n.push(e.isImage || !1));
                                }), t.close();
                                var r = {
                                    baseurl: "",
                                    files: o,
                                    isImages: n
                                };
                                Ro(e) && e(r), t.close();
                            }
                            return !1;
                        };
                    }
                },
                {
                    key: "_dialog",
                    get: function() {
                        var e, t = this, o = this.dlg({
                            minWidth: Math.min(700, screen.width),
                            minHeight: 300,
                            buttons: null !== (e = this.o.headerButtons) && void 0 !== e ? e : [
                                "fullsize",
                                "dialog.close"
                            ]
                        });
                        return [
                            "beforeClose",
                            "afterClose",
                            "beforeOpen"
                        ].forEach(function(e) {
                            return o.events.on(o, e, function() {
                                return t.e.fire(e);
                            });
                        }), o.setSize(this.o.width, this.o.height), o;
                    }
                },
                {
                    key: "storage",
                    get: function() {
                        return Pu.makeStorage(Boolean(this.o.saveStateInStorage), this.componentName);
                    }
                },
                {
                    key: "isOpened",
                    get: function() {
                        return this._dialog.isOpened && "none" !== this.browser.style.display;
                    }
                },
                {
                    key: "status",
                    value: function(e, t) {
                        e && !Vo(e) && (Lo(e) || (e = e.message), Lo(e) && vn(e).length && this.message.message(e, t ? "success" : "error", this.o.howLongShowMsg));
                    }
                },
                {
                    key: "open",
                    value: function() {
                        var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.o.defaultCallback, o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        return this.state.onlyImages = o, this.async.promise(function(o, n) {
                            var r;
                            if (!e.o.items || !e.o.items.url) throw Fr("Need set options.filebrowser.ajax.url");
                            var i = 0;
                            e.e.off(e.files.container, "dblclick").on(e.files.container, "dblclick", e.onSelect(t)).on(e.files.container, "touchstart", function() {
                                var o = (new Date).getTime();
                                o - i < ao && e.onSelect(t)(), i = o;
                            }).off("select.filebrowser").on("select.filebrowser", e.onSelect(t));
                            var a = e.c.div();
                            null === (r = e.toolbar) || void 0 === r || r.appendTo(a), e.__updateToolbarButtons(), e._dialog.open(e.browser, a), e.e.fire("sort.filebrowser", e.state.sortBy), Ef(e).then(o, n).finally(function() {
                                var t;
                                e.isInDestruct || null === (t = null == e ? void 0 : e.e) || void 0 === t || t.fire("fileBrowserReady.filebrowser");
                            });
                        }).catch(function(e) {
                            if (!Vo(e) && !ft) throw e;
                        });
                    }
                },
                {
                    key: "__getButtons",
                    value: function() {
                        var e, t = this;
                        return (null !== (e = this.o.buttons) && void 0 !== e ? e : []).filter(function(e) {
                            if (!Lo(e)) return !0;
                            switch(e){
                                case "filebrowser.upload":
                                    return t.dataProvider.canI("FileUpload");
                                case "filebrowser.edit":
                                    return t.dataProvider.canI("ImageResize") || t.dataProvider.canI("ImageCrop");
                                case "filebrowser.remove":
                                    return t.dataProvider.canI("FileRemove");
                            }
                            return !0;
                        });
                    }
                },
                {
                    key: "initUploader",
                    value: function(e) {
                        var t, o = this, n = this, r = _r((null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.uploader) || {}, rr.defaultOptions.uploader), i = function() {
                            return Cf(o);
                        };
                        n.uploader = n.getInstance("Uploader", r), n.uploader.setPath(n.state.currentPath).setSource(n.state.currentSource).bind(n.browser, i, n.errorHandler), this.state.on([
                            "change.currentPath",
                            "change.currentSource"
                        ], function() {
                            o.uploader.setPath(o.state.currentPath).setSource(o.state.currentSource);
                        }), n.e.on("bindUploader.filebrowser", function(e) {
                            n.uploader.bind(e, i, n.errorHandler);
                        });
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        var e;
                        this.isInDestruct || (null === (e = hi(this, "_dialog")) || void 0 === e || e.destruct(), Tp(Ip(t.prototype), "destruct", this).call(this), this.events && this.e.off(".filebrowser"), this.uploader && this.uploader.destruct());
                    }
                },
                {
                    key: "__updateToolbarButtons",
                    value: function() {
                        var e, t = this.__getButtons();
                        (function(e, t) {
                            if (e.length !== t.length) return !1;
                            for(var o = 0; o < e.length; o++)if (e[o] !== t[o]) return !1;
                            return !0;
                        })(this.__prevButtons, t) || (this.__prevButtons = t, null === (e = this.toolbar) || void 0 === e || e.build(t));
                    }
                }
            ], n && Ep(o.prototype, n), t;
        }(ef);
        function Bp(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Dp(e, t, o) {
            return Dp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Np(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Dp(e, t, o || e);
        }
        function Np(e) {
            return Np = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Np(e);
        }
        function Hp(e, t) {
            return Hp = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Hp(e, t);
        }
        function Fp(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function qp() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (qp = function() {
                return !!e;
            })();
        }
        Lp([
            vi
        ], Mp.prototype, "dataProvider", null), Lp([
            vi
        ], Mp.prototype, "_dialog", null), Lp([
            vi
        ], Mp.prototype, "storage", null), Lp([
            To
        ], Mp.prototype, "status", null), Lp([
            To
        ], Mp.prototype, "open", null), Lp([
            Ca("dataProvider:changePermissions")
        ], Mp.prototype, "__updateToolbarButtons", null), Mp = Lp([
            nl(mf)
        ], Mp);
        var Vp = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Fp(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Wp = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Np(t), function(e, t) {
                        return !t || "object" !== Fp(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, qp() ? Reflect.construct(t, o || [], Np(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).buttons = [], o.hasStyle = !1, o.__inited = !1, e.e.on("afterPluginSystemInit", o.__afterPluginSystemInit).on("afterInit", o.__afterInit).on("beforeDestruct", o.__beforeDestruct), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Hp(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "Plugin";
                    }
                },
                {
                    key: "__afterPluginSystemInit",
                    value: function() {
                        var e = this.j, t = this.buttons;
                        t && nn(e) && t.forEach(function(t) {
                            e.registerButton(t);
                        });
                    }
                },
                {
                    key: "__afterInit",
                    value: function() {
                        this.__inited = !0, this.setStatus(Io.ready), this.afterInit(this.jodit);
                    }
                },
                {
                    key: "init",
                    value: function(e) {
                        this.jodit.isReady && (this.afterInit(this.jodit), this.__afterPluginSystemInit(), this.jodit.e.fire("rebuildToolbar"));
                    }
                },
                {
                    key: "__beforeDestruct",
                    value: function() {
                        var e;
                        if (!this.isInDestruct) {
                            var o = this.j;
                            if (o.e.off("afterPluginSystemInit", this.__afterPluginSystemInit).off("afterInit", this.__afterInit).off("beforeDestruct", this.destruct), this.setStatus(Io.beforeDestruct), !this.__inited) return Dp(Np(t.prototype), "destruct", this).call(this);
                            nn(o) && (null === (e = this.buttons) || void 0 === e || e.forEach(function(e) {
                                null == o || o.unregisterButton(e);
                            })), this.beforeDestruct(this.j), Dp(Np(t.prototype), "destruct", this).call(this);
                        }
                    }
                }
            ], Bp(o.prototype, n), t;
        }(Qa);
        function Up(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        Wp.requires = [], Vp([
            To
        ], Wp.prototype, "__afterPluginSystemInit", null), Vp([
            To
        ], Wp.prototype, "__afterInit", null), Vp([
            To
        ], Wp.prototype, "__beforeDestruct", null);
        var Yp = function() {
            function e(t, o, n, r) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.oldValue = t, this.newValue = o, this.history = n, this.tick = r;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "undo",
                    value: function() {
                        this.history.snapshot.restore(this.oldValue);
                    }
                },
                {
                    key: "redo",
                    value: function() {
                        this.history.snapshot.restore(this.newValue);
                    }
                }
            ], Up(t.prototype, o), e;
        }();
        function Kp(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Gp(e, t, o) {
            return Gp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Jp(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Gp(e, t, o || e);
        }
        function Jp(e) {
            return Jp = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Jp(e);
        }
        function Xp(e, t) {
            return Xp = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Xp(e, t);
        }
        function Zp() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Zp = function() {
                return !!e;
            })();
        }
        var Qp = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Jp(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Zp() ? Reflect.construct(t, o || [], Jp(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).__isBlocked = !1, e.__levelOfTransaction = 0, e;
            }
            var o, n, r;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Xp(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "Snapshot";
                    }
                },
                {
                    key: "calcHierarchyLadder",
                    value: function(e) {
                        var o = [];
                        if (!e || !e.parentNode || !pi.isOrContains(this.j.editor, e)) return [];
                        for(; e && e !== this.j.editor;)e && !t.isIgnoredNode(e) && o.push(t.countNodesBeforeInParent(e)), e = e.parentNode;
                        return o.reverse();
                    }
                },
                {
                    key: "getElementByLadder",
                    value: function(e) {
                        var t, o = this.j.editor;
                        for(t = 0; o && t < e.length; t += 1)o = o.childNodes[e[t]];
                        return o;
                    }
                },
                {
                    key: "isBlocked",
                    get: function() {
                        return this.__isBlocked;
                    }
                },
                {
                    key: "__block",
                    value: function(e) {
                        this.__isBlocked = e;
                    }
                },
                {
                    key: "transaction",
                    value: function(e) {
                        this.__block(!0), this.__levelOfTransaction += 1;
                        try {
                            e();
                        } catch (e) {
                            if (!ft) throw e;
                        } finally{
                            this.__levelOfTransaction -= 1, 0 === this.__levelOfTransaction && this.__block(!1);
                        }
                    }
                },
                {
                    key: "make",
                    value: function() {
                        var e = {
                            html: "",
                            range: {
                                startContainer: [],
                                startOffset: 0,
                                endContainer: [],
                                endOffset: 0
                            }
                        };
                        e.html = this.__getCleanedEditorValue(this.j.editor);
                        var o = this.j.s.sel;
                        if (o && o.rangeCount) {
                            var n = o.getRangeAt(0), r = this.calcHierarchyLadder(n.startContainer), i = this.calcHierarchyLadder(n.endContainer), a = t.strokeOffset(n.startContainer, n.startOffset), l = t.strokeOffset(n.endContainer, n.endOffset);
                            r.length || n.startContainer === this.j.editor || (a = 0), i.length || n.endContainer === this.j.editor || (l = 0), e.range = {
                                startContainer: r,
                                startOffset: a,
                                endContainer: i,
                                endOffset: l
                            };
                        }
                        return e;
                    }
                },
                {
                    key: "restore",
                    value: function(e) {
                        var t = this;
                        this.transaction(function() {
                            var o = t.storeScrollState();
                            t.__getCleanedEditorValue(t.j.editor) !== e.html && (t.j.value = e.html), t.restoreOnlySelection(e), t.restoreScrollState(o);
                        });
                    }
                },
                {
                    key: "storeScrollState",
                    value: function() {
                        return [
                            this.j.ow.scrollY,
                            this.j.editor.scrollTop
                        ];
                    }
                },
                {
                    key: "restoreScrollState",
                    value: function(e) {
                        var t = this.j, o = t.ow;
                        o.scrollTo(o.scrollX, e[0]), t.editor.scrollTop = e[1];
                    }
                },
                {
                    key: "restoreOnlySelection",
                    value: function(e) {
                        try {
                            if (e.range) {
                                var t = this.j.ed.createRange();
                                t.setStart(this.getElementByLadder(e.range.startContainer), e.range.startOffset), t.setEnd(this.getElementByLadder(e.range.endContainer), e.range.endOffset), this.j.s.selectRange(t);
                            }
                        } catch (e) {
                            this.j.editor.lastChild && this.j.s.setCursorAfter(this.j.editor.lastChild), ft || console.warn("Broken snapshot", e);
                        }
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.__block(!1), Gp(Jp(t.prototype), "destruct", this).call(this);
                    }
                },
                {
                    key: "__getCleanedEditorValue",
                    value: function(e) {
                        var t = e.cloneNode(!0);
                        return pi.temporaryList(t).forEach(pi.unwrap), t.innerHTML;
                    }
                }
            ], r = [
                {
                    key: "equal",
                    value: function(e, t) {
                        return e.html === t.html && JSON.stringify(e.range) === JSON.stringify(t.range);
                    }
                },
                {
                    key: "countNodesBeforeInParent",
                    value: function(e) {
                        if (!e.parentNode) return 0;
                        for(var t = e.parentNode.childNodes, o = 0, n = null, r = 0; r < t.length; r += 1){
                            if (!n || this.isIgnoredNode(t[r]) || pi.isText(n) && pi.isText(t[r]) || (o += 1), t[r] === e) return o;
                            n = t[r];
                        }
                        return 0;
                    }
                },
                {
                    key: "strokeOffset",
                    value: function(e, t) {
                        for(; pi.isText(e);)e = e.previousSibling, pi.isText(e) && e.nodeValue && (t += e.nodeValue.length);
                        return t;
                    }
                },
                {
                    key: "isIgnoredNode",
                    value: function(e) {
                        return pi.isText(e) && !e.nodeValue || pi.isTemporary(e);
                    }
                }
            ], n && Kp(o.prototype, n), r && Kp(o, r), t;
        }(Qa);
        function $p(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var eh = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.size = t, this.commands = [], this.stackPosition = -1;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "length",
                    get: function() {
                        return this.commands.length;
                    }
                },
                {
                    key: "clearRedo",
                    value: function() {
                        this.commands.length = this.stackPosition + 1;
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        this.commands.length = 0, this.stackPosition = -1;
                    }
                },
                {
                    key: "push",
                    value: function(e) {
                        this.clearRedo(), this.commands.push(e), this.stackPosition += 1, this.commands.length > this.size && (this.commands.shift(), this.stackPosition -= 1);
                    }
                },
                {
                    key: "replace",
                    value: function(e) {
                        this.commands[this.stackPosition] = e;
                    }
                },
                {
                    key: "current",
                    value: function() {
                        return this.commands[this.stackPosition];
                    }
                },
                {
                    key: "undo",
                    value: function() {
                        return !!this.canUndo() && (this.commands[this.stackPosition] && this.commands[this.stackPosition].undo(), this.stackPosition -= 1, !0);
                    }
                },
                {
                    key: "redo",
                    value: function() {
                        return !!this.canRedo() && (this.stackPosition += 1, this.commands[this.stackPosition] && this.commands[this.stackPosition].redo(), !0);
                    }
                },
                {
                    key: "canUndo",
                    value: function() {
                        return this.stackPosition >= 0;
                    }
                },
                {
                    key: "canRedo",
                    value: function() {
                        return this.stackPosition < this.commands.length - 1;
                    }
                }
            ], $p(t.prototype, o), e;
        }();
        function th(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function oh(e, t, o) {
            return oh = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = nh(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, oh(e, t, o || e);
        }
        function nh(e) {
            return nh = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, nh(e);
        }
        function rh(e, t) {
            return rh = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, rh(e, t);
        }
        function ih(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ah() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ah = function() {
                return !!e;
            })();
        }
        rr.prototype.history = {
            enable: !0,
            maxHistoryLength: 1 / 0,
            timeout: 1e3
        };
        var lh = function(e) {
            function t(e) {
                var o, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new eh(e.o.history.maxHistoryLength), r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Qp(e);
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = nh(t), function(e, t) {
                        return !t || "object" !== ih(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ah() ? Reflect.construct(t, o || [], nh(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).updateTick = 0, o.__stack = n, o.snapshot = r, e.o.history.enable && e.e.on("afterAddPlace.history", function() {
                    o.isInDestruct || (o.startValue = o.snapshot.make(), e.events.on("internalChange internalUpdate", function() {
                        o.startValue = o.snapshot.make();
                    }).on(e.editor, [
                        "changeSelection",
                        "selectionstart",
                        "selectionchange",
                        "mousedown",
                        "mouseup",
                        "keydown",
                        "keyup"
                    ].map(function(e) {
                        return e + ".history";
                    }).join(" "), function() {
                        o.startValue.html === o.j.getNativeEditorValue() && (o.startValue = o.snapshot.make());
                    }).on(o, "change.history", o.onChange));
                }), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && rh(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "History";
                    }
                },
                {
                    key: "redo",
                    value: function() {
                        this.__stack.redo() && (this.startValue = this.snapshot.make(), this.fireChangeStack());
                    }
                },
                {
                    key: "canRedo",
                    value: function() {
                        return this.__stack.canRedo();
                    }
                },
                {
                    key: "undo",
                    value: function() {
                        this.__stack.undo() && (this.startValue = this.snapshot.make(), this.fireChangeStack());
                    }
                },
                {
                    key: "canUndo",
                    value: function() {
                        return this.__stack.canUndo();
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        this.startValue = this.snapshot.make(), this.__stack.clear(), this.fireChangeStack();
                    }
                },
                {
                    key: "length",
                    get: function() {
                        return this.__stack.length;
                    }
                },
                {
                    key: "startValue",
                    get: function() {
                        return this.__startValue;
                    },
                    set: function(e) {
                        this.__startValue = e;
                    }
                },
                {
                    key: "__upTick",
                    value: function() {
                        this.updateTick += 1;
                    }
                },
                {
                    key: "onChange",
                    value: function() {
                        this.__processChanges();
                    }
                },
                {
                    key: "__processChanges",
                    value: function() {
                        !this.snapshot.isBlocked && this.j.o.history.enable && this.updateStack();
                    }
                },
                {
                    key: "updateStack",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = this.snapshot.make();
                        if (!Qp.equal(t, this.startValue)) {
                            var o = new Yp(this.startValue, t, this, this.updateTick);
                            if (e) {
                                var n = this.__stack.current();
                                n && this.updateTick === n.tick && this.__stack.replace(o);
                            } else this.__stack.push(o);
                            this.startValue = t, this.fireChangeStack();
                        }
                    }
                },
                {
                    key: "fireChangeStack",
                    value: function() {
                        var e;
                        this.j && !this.j.isInDestruct && (null === (e = this.j.events) || void 0 === e || e.fire("changeStack"));
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.isInDestruct || (this.j.events && this.j.e.off(".history"), this.snapshot.destruct(), oh(nh(t.prototype), "destruct", this).call(this));
                    }
                }
            ], n && th(o.prototype, n), t;
        }(Qa);
        function sh(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function ch(e, t, o) {
            return ch = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = uh(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, ch(e, t, o || e);
        }
        function uh(e) {
            return uh = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, uh(e);
        }
        function dh(e, t) {
            return dh = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, dh(e, t);
        }
        function fh(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ph() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ph = function() {
                return !!e;
            })();
        }
        !function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : ih(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        }([
            $a()
        ], lh.prototype, "onChange", null);
        var hh = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = uh(t), function(e, t) {
                        return !t || "object" !== fh(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ph() ? Reflect.construct(t, o || [], uh(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).target = o, n.mods = {}, n.container = e.c.div("jodit-status-bar"), o.appendChild(n.container), n.hide(), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && dh(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "StatusBar";
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        this.container.classList.add("jodit_hidden");
                    }
                },
                {
                    key: "show",
                    value: function() {
                        this.container.classList.remove("jodit_hidden");
                    }
                },
                {
                    key: "isShown",
                    get: function() {
                        return !this.container.classList.contains("jodit_hidden");
                    }
                },
                {
                    key: "getHeight",
                    value: function() {
                        var e, t;
                        return null !== (t = null === (e = this.container) || void 0 === e ? void 0 : e.offsetHeight) && void 0 !== t ? t : 0;
                    }
                },
                {
                    key: "findEmpty",
                    value: function() {
                        for(var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = this.getElms(e ? "item-right" : "item"), o = 0; o < t.length; o += 1)if (!t[o].innerHTML.trim().length) return t[o];
                    }
                },
                {
                    key: "append",
                    value: function(e) {
                        var t, o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.findEmpty(o) || this.j.c.div(this.getFullElName("item"));
                        o && n.classList.add(this.getFullElName("item-right")), n.appendChild(e), null === (t = this.container) || void 0 === t || t.appendChild(n), this.j.o.statusbar && this.show(), this.j.e.fire("resize");
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.isInDestruct || (this.setStatus(Io.beforeDestruct), pi.safeRemove(this.container), ch(uh(t.prototype), "destruct", this).call(this));
                    }
                }
            ], n && sh(o.prototype, n), t;
        }(Qa);
        function vh(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function gh(e, t, o) {
            return gh = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = mh(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, gh(e, t, o || e);
        }
        function mh(e) {
            return mh = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, mh(e);
        }
        function bh(e, t) {
            return bh = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, bh(e, t);
        }
        function yh(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function _h() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (_h = function() {
                return !!e;
            })();
        }
        hh = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : fh(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            ji,
            nl(Sl, wl)
        ], hh);
        var jh = new WeakMap, wh = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = mh(t), function(e, t) {
                        return !t || "object" !== yh(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, _h() ? Reflect.construct(t, o || [], mh(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).selected = new Set, e;
            }
            var o, n, r;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && bh(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "Table";
                    }
                },
                {
                    key: "__recalculateStyles",
                    value: function() {
                        var e = Ha(this.j, t, "style", !0), o = [];
                        this.selected.forEach(function(e) {
                            var t = ti(e);
                            t && o.push(t);
                        }), e.innerHTML = o.length ? o.join(",") + "{".concat(this.jodit.options.table.selectionCellStyle, "}") : "";
                    }
                },
                {
                    key: "addSelection",
                    value: function(e) {
                        this.selected.add(e), this.__recalculateStyles();
                        var o = pi.closest(e, "table", this.j.editor);
                        if (o) {
                            var n = t.__selectedByTable.get(o) || new Set;
                            n.add(e), t.__selectedByTable.set(o, n);
                        }
                    }
                },
                {
                    key: "removeSelection",
                    value: function(e) {
                        this.selected.delete(e), this.__recalculateStyles();
                        var o = pi.closest(e, "table", this.j.editor);
                        if (o) {
                            var n = t.__selectedByTable.get(o);
                            n && (n.delete(e), n.size || t.__selectedByTable.delete(o));
                        }
                    }
                },
                {
                    key: "getAllSelectedCells",
                    value: function() {
                        return Fo(this.selected);
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        return this.selected.clear(), gh(mh(t.prototype), "destruct", this).call(this);
                    }
                },
                {
                    key: "getRowsCount",
                    value: function(e) {
                        return t.__getRowsCount(e);
                    }
                },
                {
                    key: "getColumnsCount",
                    value: function(e) {
                        return t.__getColumnsCount(e);
                    }
                },
                {
                    key: "formalMatrix",
                    value: function(e, o) {
                        return t.__formalMatrix(e, o);
                    }
                },
                {
                    key: "formalCoordinate",
                    value: function(e, o) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return t.__formalCoordinate(e, o, n);
                    }
                },
                {
                    key: "appendRow",
                    value: function(e, o, n) {
                        return t.__appendRow(e, o, n, this.j.createInside);
                    }
                },
                {
                    key: "removeRow",
                    value: function(e, o) {
                        return t.__removeRow(e, o);
                    }
                },
                {
                    key: "appendColumn",
                    value: function(e, o) {
                        var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = t.__formalMatrix(e);
                        if (!n && pi.isCell(o.previousElementSibling)) return this.appendColumn(e, o.previousElementSibling, !0);
                        for(var i = n ? o.cellIndex + ((o.colSpan || 1) - 1) : o.cellIndex, a = n ? i + 1 : i, l = 0; l < r.length;){
                            var s = r[l];
                            if (s[i] !== s[a] || i === a) {
                                var c = this.j.createInside.element("td");
                                n ? pi.after(s[i], c) : pi.before(s[i], c), s[i].rowSpan > 1 && (c.rowSpan = s[i].rowSpan);
                            } else s[i].colSpan += 1;
                            l += s[i].rowSpan || 1;
                        }
                    }
                },
                {
                    key: "removeColumn",
                    value: function(e, o) {
                        return t.__removeColumn(e, o);
                    }
                },
                {
                    key: "getSelectedBound",
                    value: function(e, o) {
                        return t.__getSelectedBound(e, o);
                    }
                },
                {
                    key: "normalizeTable",
                    value: function(e) {
                        return t.__normalizeTable(e);
                    }
                },
                {
                    key: "mergeSelected",
                    value: function(e) {
                        return t.__mergeSelected(e, this.j);
                    }
                },
                {
                    key: "splitHorizontal",
                    value: function(e) {
                        return t.__splitHorizontal(e, this.j);
                    }
                },
                {
                    key: "splitVertical",
                    value: function(e) {
                        return t.__splitVertical(e, this.j);
                    }
                },
                {
                    key: "setColumnWidthByDelta",
                    value: function(e, o, n, r, i) {
                        return t.__setColumnWidthByDelta(e, o, n, r, i);
                    }
                }
            ], r = [
                {
                    key: "__getSelectedCellsByTable",
                    value: function(e) {
                        var o = t.__selectedByTable.get(e);
                        return o ? Fo(o) : [];
                    }
                },
                {
                    key: "__getRowsCount",
                    value: function(e) {
                        return e.rows.length;
                    }
                },
                {
                    key: "__getColumnsCount",
                    value: function(e) {
                        return t.__formalMatrix(e).reduce(function(e, t) {
                            return Math.max(e, t.length);
                        }, 0);
                    }
                },
                {
                    key: "__formalMatrix",
                    value: function(e, t) {
                        for(var o = [
                            []
                        ], n = Fo(e.rows), r = function(e, n) {
                            void 0 === o[n] && (o[n] = []);
                            for(var r, i, a = e.colSpan, l = e.rowSpan, s = 0; o[n][s];)s += 1;
                            for(i = 0; i < l; i += 1)for(r = 0; r < a; r += 1){
                                if (void 0 === o[n + i] && (o[n + i] = []), t && !1 === t(e, n + i, s + r, a, l)) return !1;
                                o[n + i][s + r] = e;
                            }
                        }, i = 0; i < n.length; i += 1)for(var a = Fo(n[i].cells), l = 0; l < a.length; l += 1)if (!1 === r(a[l], i)) return o;
                        return o;
                    }
                },
                {
                    key: "__formalCoordinate",
                    value: function(e, o) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = 0, i = 0, a = 1, l = 1;
                        return t.__formalMatrix(e, function(e, t, s, c, u) {
                            if (o === e) return r = t, i = s, a = c || 1, l = u || 1, n && (i += (c || 1) - 1, r += (u || 1) - 1), !1;
                        }), [
                            r,
                            i,
                            a,
                            l
                        ];
                    }
                },
                {
                    key: "__appendRow",
                    value: function(e, o, n, r) {
                        var i, a;
                        if (o) a = o.cloneNode(!0), Qr("td,th", o).forEach(function(e) {
                            var t = er(e, "rowspan");
                            if (t && parseInt(t, 10) > 1) {
                                var o = parseInt(t, 10) - 1;
                                er(e, "rowspan", o > 1 ? o : null);
                            }
                        }), Qr("td,th", a).forEach(function(e) {
                            e.innerHTML = "";
                        });
                        else {
                            var l = t.__getColumnsCount(e);
                            a = r.element("tr");
                            for(var s = 0; s < l; s += 1)a.appendChild(r.element("td"));
                        }
                        n && o && o.nextSibling ? o.parentNode && o.parentNode.insertBefore(a, o.nextSibling) : !n && o ? o.parentNode && o.parentNode.insertBefore(a, o) : ((null === (i = e.getElementsByTagName("tbody")) || void 0 === i ? void 0 : i[0]) || e).appendChild(a);
                    }
                },
                {
                    key: "__removeRow",
                    value: function(e, o) {
                        var n, r = t.__formalMatrix(e), i = e.rows[o];
                        r[o].forEach(function(t, a) {
                            if (n = !1, o - 1 >= 0 && r[o - 1][a] === t) n = !0;
                            else if (r[o + 1] && r[o + 1][a] === t) {
                                if (t.parentNode === i && t.parentNode.nextSibling) {
                                    n = !0;
                                    for(var l = a + 1; r[o + 1][l] === t;)l += 1;
                                    var s = pi.next(t.parentNode, function(e) {
                                        return pi.isTag(e, "tr");
                                    }, e);
                                    s && (r[o + 1][l] ? s.insertBefore(t, r[o + 1][l]) : s.appendChild(t));
                                }
                            } else pi.safeRemove(t);
                            if (n && (t.parentNode === i || t !== r[o][a - 1])) {
                                var c = t.rowSpan;
                                er(t, "rowspan", c - 1 > 1 ? c - 1 : null);
                            }
                        }), pi.safeRemove(i);
                    }
                },
                {
                    key: "__removeColumn",
                    value: function(e, o) {
                        var n, r = t.__formalMatrix(e);
                        r.forEach(function(e, t) {
                            var i = e[o];
                            if (n = !1, o - 1 >= 0 && r[t][o - 1] === i || o + 1 < e.length && r[t][o + 1] === i ? n = !0 : pi.safeRemove(i), n && (t - 1 < 0 || i !== r[t - 1][o])) {
                                var a = i.colSpan;
                                er(i, "colspan", a - 1 > 1 ? (a - 1).toString() : null);
                            }
                        });
                    }
                },
                {
                    key: "__getSelectedBound",
                    value: function(e, o) {
                        var n, r, i, a = [
                            [
                                1 / 0,
                                1 / 0
                            ],
                            [
                                0,
                                0
                            ]
                        ], l = t.__formalMatrix(e);
                        for(n = 0; n < l.length; n += 1)for(r = 0; l[n] && r < l[n].length; r += 1)o.includes(l[n][r]) && (a[0][0] = Math.min(n, a[0][0]), a[0][1] = Math.min(r, a[0][1]), a[1][0] = Math.max(n, a[1][0]), a[1][1] = Math.max(r, a[1][1]));
                        for(n = a[0][0]; n <= a[1][0]; n += 1)for(i = 1, r = a[0][1]; r <= a[1][1]; r += 1){
                            for(; l[n] && l[n][r - i] && l[n][r] === l[n][r - i];)a[0][1] = Math.min(r - i, a[0][1]), a[1][1] = Math.max(r - i, a[1][1]), i += 1;
                            for(i = 1; l[n] && l[n][r + i] && l[n][r] === l[n][r + i];)a[0][1] = Math.min(r + i, a[0][1]), a[1][1] = Math.max(r + i, a[1][1]), i += 1;
                            for(i = 1; l[n - i] && l[n][r] === l[n - i][r];)a[0][0] = Math.min(n - i, a[0][0]), a[1][0] = Math.max(n - i, a[1][0]), i += 1;
                            for(i = 1; l[n + i] && l[n][r] === l[n + i][r];)a[0][0] = Math.min(n + i, a[0][0]), a[1][0] = Math.max(n + i, a[1][0]), i += 1;
                        }
                        return a;
                    }
                },
                {
                    key: "__normalizeTable",
                    value: function(e) {
                        var o = [], n = t.__formalMatrix(e);
                        t.__removeExtraColspans(n, o), t.__removeExtraRowspans(n, o);
                        for(var r = 0; r < n.length; r += 1)for(var i = 0; i < n[r].length; i += 1)void 0 !== n[r][i] && (n[r][i].hasAttribute("rowspan") && 1 === n[r][i].rowSpan && er(n[r][i], "rowspan", null), n[r][i].hasAttribute("colspan") && 1 === n[r][i].colSpan && er(n[r][i], "colspan", null), n[r][i].hasAttribute("class") && !er(n[r][i], "class") && er(n[r][i], "class", null));
                        t.__unmark(o);
                    }
                },
                {
                    key: "__removeExtraColspans",
                    value: function(e, o) {
                        for(var n = 0; n < e[0].length; n += 1){
                            for(var r = 1e6, i = !1, a = 0; a < e.length; a += 1)if (void 0 !== e[a][n]) {
                                if (e[a][n].colSpan < 2) {
                                    i = !0;
                                    break;
                                }
                                r = Math.min(r, e[a][n].colSpan);
                            }
                            if (!i) for(var l = 0; l < e.length; l += 1)void 0 !== e[l][n] && t.__mark(e[l][n], "colspan", e[l][n].colSpan - r + 1, o);
                        }
                    }
                },
                {
                    key: "__removeExtraRowspans",
                    value: function(e, o) {
                        var n = 0, r = 0;
                        for(n = 0; n < e.length; n += 1){
                            var i = 1e6, a = !1;
                            for(r = 0; r < e[n].length; r += 1)if (void 0 !== e[n][r]) {
                                if (e[n][r].rowSpan < 2) {
                                    a = !0;
                                    break;
                                }
                                i = Math.min(i, e[n][r].rowSpan);
                            }
                            if (!a) for(r = 0; r < e[n].length; r += 1)void 0 !== e[n][r] && t.__mark(e[n][r], "rowspan", e[n][r].rowSpan - i + 1, o);
                        }
                    }
                },
                {
                    key: "__mergeSelected",
                    value: function(e, o) {
                        var n, r = [], i = t.__getSelectedBound(e, t.__getSelectedCellsByTable(e)), a = 0, l = null, s = 0, c = 0, u = 0, d = new Set, f = [];
                        i && (i[0][0] - i[1][0] || i[0][1] - i[1][1]) && (t.__formalMatrix(e, function(e, p, h, v, g) {
                            if (p >= i[0][0] && p <= i[1][0] && h >= i[0][1] && h <= i[1][1]) {
                                if (n = e, d.has(n)) return;
                                d.add(n), p === i[0][0] && n.style.width && (a += n.offsetWidth), "" !== vn(e.innerHTML.replace(/<br(\/)?>/g, "")) && r.push(e.innerHTML), v > 1 && (c += v - 1), g > 1 && (u += g - 1), l ? (t.__mark(n, "remove", 1, f), kh(o).removeSelection(n)) : (l = e, s = h);
                            }
                        }), c = i[1][1] - i[0][1] + 1, u = i[1][0] - i[0][0] + 1, l && (c > 1 && t.__mark(l, "colspan", c, f), u > 1 && t.__mark(l, "rowspan", u, f), a && (t.__mark(l, "width", (a / e.offsetWidth * 100).toFixed(Gt) + "%", f), s && t.__setColumnWidthByDelta(e, s, 0, !0, f)), l.innerHTML = r.join("<br/>"), kh(o).addSelection(l), d.delete(l), t.__unmark(f), t.__normalizeTable(e), Fo(e.rows).forEach(function(e) {
                            e.cells.length || pi.safeRemove(e);
                        })));
                    }
                },
                {
                    key: "__splitHorizontal",
                    value: function(e, o) {
                        var n, r, i, a, l, s = [];
                        t.__getSelectedCellsByTable(e).forEach(function(c) {
                            (r = o.createInside.element("td")).appendChild(o.createInside.element("br")), i = o.createInside.element("tr"), n = t.__formalCoordinate(e, c), c.rowSpan < 2 ? (t.__formalMatrix(e, function(e, o, r) {
                                n[0] === o && n[1] !== r && e !== c && t.__mark(e, "rowspan", e.rowSpan + 1, s);
                            }), pi.after(pi.closest(c, "tr", e), i), i.appendChild(r)) : (t.__mark(c, "rowspan", c.rowSpan - 1, s), t.__formalMatrix(e, function(t, o, r) {
                                o > n[0] && o < n[0] + c.rowSpan && n[1] > r && t.parentNode.rowIndex === o && (l = t), n[0] < o && t === c && (a = e.rows[o]);
                            }), l ? pi.after(l, r) : a.insertBefore(r, a.firstChild)), c.colSpan > 1 && t.__mark(r, "colspan", c.colSpan, s), t.__unmark(s), kh(o).removeSelection(c);
                        }), this.__normalizeTable(e);
                    }
                },
                {
                    key: "__splitVertical",
                    value: function(e, o) {
                        var n, r, i, a = [];
                        t.__getSelectedCellsByTable(e).forEach(function(l) {
                            n = t.__formalCoordinate(e, l), l.colSpan < 2 ? t.__formalMatrix(e, function(e, o, r) {
                                n[1] === r && n[0] !== o && e !== l && t.__mark(e, "colspan", e.colSpan + 1, a);
                            }) : t.__mark(l, "colspan", l.colSpan - 1, a), (r = o.createInside.element("td")).appendChild(o.createInside.element("br")), l.rowSpan > 1 && t.__mark(r, "rowspan", l.rowSpan, a);
                            var s = l.offsetWidth;
                            pi.after(l, r), i = s / e.offsetWidth / 2, t.__mark(l, "width", (100 * i).toFixed(Gt) + "%", a), t.__mark(r, "width", (100 * i).toFixed(Gt) + "%", a), t.__unmark(a), kh(o).removeSelection(l);
                        }), t.__normalizeTable(e);
                    }
                },
                {
                    key: "__setColumnWidthByDelta",
                    value: function(e, o, n, r, i) {
                        for(var a = t.__formalMatrix(e), l = 0, s = 0; s < a.length; s += 1){
                            var c = a[s][o];
                            if (!(c.colSpan > 1 && a.length > 1)) {
                                var u = (c.offsetWidth + n) / e.offsetWidth * 100;
                                t.__mark(c, "width", u.toFixed(Gt) + "%", i), l = s;
                                break;
                            }
                        }
                        for(var d = l + 1; d < a.length; d += 1){
                            var f = a[d][o];
                            t.__mark(f, "width", null, i);
                        }
                        r || t.__unmark(i);
                    }
                },
                {
                    key: "__mark",
                    value: function(e, t, o, n) {
                        var r;
                        n.push(e);
                        var i = null !== (r = jh.get(e)) && void 0 !== r ? r : {};
                        i[t] = void 0 === o ? 1 : o, jh.set(e, i);
                    }
                },
                {
                    key: "__unmark",
                    value: function(e) {
                        e.forEach(function(e) {
                            var t = jh.get(e);
                            t && (Object.keys(t).forEach(function(o) {
                                var n = t[o];
                                switch(o){
                                    case "remove":
                                        pi.safeRemove(e);
                                        break;
                                    case "rowspan":
                                        er(e, "rowspan", ln(n) && n > 1 ? n : null);
                                        break;
                                    case "colspan":
                                        er(e, "colspan", ln(n) && n > 1 ? n : null);
                                        break;
                                    case "width":
                                        null == n ? (e.style.removeProperty("width"), er(e, "style") || er(e, "style", null)) : e.style.width = n.toString();
                                }
                                delete t[o];
                            }), jh.delete(e));
                        });
                    }
                }
            ], n && vh(o.prototype, n), r && vh(o, r), t;
        }(Qa);
        wh.__selectedByTable = new WeakMap, function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : yh(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        }([
            $a()
        ], wh.prototype, "__recalculateStyles", null);
        var kh = function(e) {
            return e.getInstance("Table", e.o);
        };
        function Sh(e) {
            for(var t = atob(e.split(",")[1]), o = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; i < t.length; i += 1)r[i] = t.charCodeAt(i);
            return new Blob([
                r
            ], {
                type: o
            });
        }
        var xh = new WeakMap;
        function Oh(e, t) {
            var o = function(e, t) {
                if (Ro(e.o.buildData)) return e.o.buildData.call(e, t);
                var o, n, r = e.ow.FormData;
                if (void 0 !== r) {
                    if (o = t, null != (n = r) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? n[Symbol.hasInstance](o) : o instanceof n) return t;
                    if (Lo(t)) return t;
                    var i = new r, a = t;
                    return Object.keys(a).forEach(function(e) {
                        i.append(e, a[e]);
                    }), i;
                }
                return t;
            }(e, t), n = function(t) {
                var o = new _l({
                    xhr: function() {
                        var t = new XMLHttpRequest;
                        return void 0 !== e.j.ow.FormData && t.upload ? (e.j.progressbar.show().progress(10), t.upload.addEventListener("progress", function(t) {
                            if (t.lengthComputable) {
                                var o = t.loaded / t.total;
                                o *= 100, e.j.progressbar.show().progress(o), o >= 100 && e.j.progressbar.hide();
                            }
                        }, !1)) : e.j.progressbar.hide(), t;
                    },
                    method: e.o.method || "POST",
                    data: t,
                    url: Ro(e.o.url) ? e.o.url(t) : e.o.url,
                    headers: e.o.headers,
                    queryBuild: e.o.queryBuild,
                    contentType: e.o.contentType.call(e, t),
                    withCredentials: e.o.withCredentials || !1
                }), n = xh.get(e);
                return n || (n = new Set, xh.set(e, n)), n.add(o), e.j.e.one("beforeDestruct", o.destruct), o.send().then(function(e) {
                    return e.json();
                }).catch(function(e) {
                    return {
                        success: !1,
                        data: {
                            messages: [
                                e
                            ]
                        }
                    };
                }).finally(function() {
                    o.destruct(), null == n || n.delete(o);
                });
            };
            return un(o) ? o.then(n).catch(function(t) {
                e.o.error.call(e, t);
            }) : n(o);
        }
        function Ch(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function zh(e, t) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, t) {
                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != o) {
                    var n, r, i = [], a = !0, l = !1;
                    try {
                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                    } catch (e) {
                        l = !0, r = e;
                    } finally{
                        try {
                            a || null == o.return || o.return();
                        } finally{
                            if (l) throw r;
                        }
                    }
                    return i;
                }
            }(e, t) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return Ch(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Ch(e, t) : void 0;
                }
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Eh(e, t, o, n, r) {
            if (!t) return Promise.reject(Fr("Need files"));
            var i = e.o, a = Fo(t);
            if (!a.length) return Promise.reject(Fr("Need files"));
            var l = [];
            if (i.insertImageAsBase64URI && function(e, t, o, n, r, i) {
                var a, l, s = function() {
                    if ((a = e[l]) && a.type) {
                        var s = a.type.match(/\/([a-z0-9]+)/i), c = s[1] ? s[1].toLowerCase() : "";
                        if (!t.includes(c)) return "continue";
                        var u = new FileReader;
                        o.push(n.j.async.promise(function(e, t) {
                            u.onerror = t, u.onloadend = function() {
                                var t = {
                                    baseurl: "",
                                    files: [
                                        u.result
                                    ],
                                    isImages: [
                                        !0
                                    ]
                                };
                                (Ro(r) ? r : i).call(n, t), e(t);
                            }, u.readAsDataURL(a);
                        })), e[l] = null;
                    }
                };
                for(l = 0; l < e.length; l += 1)s();
            }(a, i.imagesExtensions, l, e, o, i.defaultHandlerSuccess), a = a.filter(function(e) {
                return e;
            }), a.length) {
                var s, c = new FormData;
                c.append(i.pathVariableName, e.path), c.append("source", e.source);
                for(var u = 0; u < a.length; u += 1)if (s = a[u]) {
                    var d = /\.\w+$/.test(s.name), f = s.type.match(/\/([a-z0-9]+)/i), p = f && f[1] ? f[1].toLowerCase() : "", h = a[u].name || Math.random().toString().replace(".", "");
                    if (!d && p) {
                        var v = p;
                        [
                            "jpeg",
                            "jpg"
                        ].includes(v) && (v = "jpeg|jpg"), new RegExp(".(" + v + ")$", "i").test(h) || (h += "." + p);
                    }
                    var g = zh(i.processFileName.call(e, i.filesVariableName(u), a[u], h), 3), m = g[0], b = g[1], y = g[2];
                    c.append(m, b, y);
                }
                r && r(c), i.data && cn(i.data) && Object.keys(i.data).forEach(function(e) {
                    c.append(e, i.data[e]);
                }), i.prepareData.call(e, c), l.push(Oh(e, c).then(function(t) {
                    return i.isSuccess.call(e, t) ? ((Ro(o) ? o : i.defaultHandlerSuccess).call(e, i.process.call(e, t)), t) : ((Ro(n) ? n : i.defaultHandlerError).call(e, Fr(i.getMessage.call(e, t))), t);
                }).then(function() {
                    e.j.events && e.j.e.fire("filesWereUploaded");
                }));
            }
            return Promise.all(l);
        }
        function Th(e) {
            return Boolean(e && e.files && e.files.length > 0);
        }
        function Ih(e) {
            return Boolean(e && e.items && e.items.length > 0);
        }
        function Ph(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Rh(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ah(e, t, o) {
            return Ah = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Lh(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Ah(e, t, o || e);
        }
        function Lh(e) {
            return Lh = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Lh(e);
        }
        function Mh(e, t) {
            return Mh = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Mh(e, t);
        }
        function Bh() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Bh = function() {
                return !!e;
            })();
        }
        rr.prototype.enableDragAndDropFileToEditor = !0, rr.prototype.uploader = {
            url: "",
            insertImageAsBase64URI: !1,
            imagesExtensions: [
                "jpg",
                "png",
                "jpeg",
                "gif"
            ],
            headers: null,
            data: null,
            filesVariableName: function(e) {
                return "files[".concat(e, "]");
            },
            withCredentials: !1,
            pathVariableName: "path",
            format: "json",
            method: "POST",
            prepareData: function(e) {
                return e;
            },
            isSuccess: function(e) {
                return e.success;
            },
            getMessage: function(e) {
                return void 0 !== e.data.messages && Ao(e.data.messages) ? e.data.messages.join(" ") : "";
            },
            processFileName: function(e, t, o) {
                return [
                    e,
                    t,
                    o
                ];
            },
            process: function(e) {
                return e.data;
            },
            error: function(e) {
                this.j.message.error(e.message, 4e3);
            },
            getDisplayName: function(e, t) {
                return e + t;
            },
            defaultHandlerSuccess: function(e) {
                var t = this, o = this.j || this;
                nn(o) && e.files && e.files.length && e.files.forEach(function(n, r) {
                    var i = function(e, t) {
                        return function(e) {
                            if (Array.isArray(e)) return e;
                        }(e) || function(e, t) {
                            var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                            if (null != o) {
                                var n, r, i = [], a = !0, l = !1;
                                try {
                                    for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                } catch (e) {
                                    l = !0, r = e;
                                } finally{
                                    try {
                                        a || null == o.return || o.return();
                                    } finally{
                                        if (l) throw r;
                                    }
                                }
                                return i;
                            }
                        }(e, t) || function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return Ph(e, t);
                                var o = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Ph(e, t) : void 0;
                            }
                        }(e, t) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }(e.isImages && e.isImages[r] ? [
                        "img",
                        "src"
                    ] : [
                        "a",
                        "href"
                    ], 2), a = i[0], l = i[1], s = o.createInside.element(a);
                    s.setAttribute(l, e.baseurl + n), "a" === a && (s.textContent = o.o.uploader.getDisplayName.call(t, e.baseurl, n)), "img" === a ? o.s.insertImage(s, null, o.o.imageDefaultWidth) : o.s.insertNode(s);
                });
            },
            defaultHandlerError: function(e) {
                this.j.message.error(e.message);
            },
            contentType: function(e) {
                return (void 0 === this.ow.FormData || "string" == typeof e) && "application/x-www-form-urlencoded; charset=UTF-8";
            }
        };
        var Dh = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Lh(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Bh() ? Reflect.construct(t, o || [], Lh(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).path = "", n.source = "default", n.options = _r(o || {}, _r(rr.defaultOptions.uploader, nn(e) ? e.o.uploader : {})), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Mh(e, t);
            }(t, e), o = t, n = [
                {
                    key: "j",
                    get: function() {
                        return this.jodit;
                    }
                },
                {
                    key: "className",
                    value: function() {
                        return "Uploader";
                    }
                },
                {
                    key: "o",
                    get: function() {
                        return this.options;
                    }
                },
                {
                    key: "setPath",
                    value: function(e) {
                        return this.path = e, this;
                    }
                },
                {
                    key: "setSource",
                    value: function(e) {
                        return this.source = e, this;
                    }
                },
                {
                    key: "bind",
                    value: function(e, t, o) {
                        var n = function() {
                            e.classList.remove("jodit_drag_hover");
                        }, r = this, i = function(e) {
                            var i, a, l, s = e.clipboardData, c = function(e) {
                                a && (e.append("extension", l), e.append("mimetype", a.type));
                            };
                            if (!to && Th(s)) return Eh(r, s.files, t, o).finally(n), !1;
                            if (to && !dt) return function(e, t, o, n, r) {
                                if (t && (!t.types.length || t.types[0] !== oo)) {
                                    var i = e.j.c.div("", {
                                        tabindex: -1,
                                        style: "left: -9999px; top: 0; width: 0; height: 100%;line-height: 140%; overflow: hidden; position: fixed; z-index: 2147483647; word-break: break-all;",
                                        contenteditable: !0
                                    });
                                    Ha(e.j, e.constructor).appendChild(i);
                                    var a = nn(e.j) ? e.j.s.save() : null;
                                    i.focus(), e.j.async.setTimeout(function() {
                                        var t = i.firstChild;
                                        if (pi.safeRemove(i), t && t.hasAttribute("src")) {
                                            var l = er(t, "src") || "";
                                            a && nn(e.j) && e.j.s.restore(), Eh(e, [
                                                Sh(l)
                                            ], o, n).finally(r);
                                        }
                                    }, e.j.defaultTimeout);
                                }
                            }(r, s, t, o, n);
                            if (Ih(s)) {
                                var u = s.items;
                                for(i = 0; i < u.length; i += 1)if ("file" === u[i].kind && "image/png" === u[i].type) {
                                    if (a = u[i].getAsFile()) {
                                        var d = a.type.match(/\/([a-z0-9]+)/i);
                                        l = d[1] ? d[1].toLowerCase() : "", Eh(r, [
                                            a
                                        ], t, o, c).finally(n);
                                    }
                                    e.preventDefault();
                                    break;
                                }
                            }
                        };
                        r.j && r.j.editor !== e ? r.j.e.on(e, "paste", i) : r.j.e.on("beforePaste", i), this.attachEvents(e, t, o, n);
                    }
                },
                {
                    key: "attachEvents",
                    value: function(e, t, o, n) {
                        var r = this;
                        r.j.e.on(e, "dragend dragover dragenter dragleave drop", function(e) {
                            e.preventDefault();
                        }).on(e, "dragover", function(t) {
                            (Th(t.dataTransfer) || Ih(t.dataTransfer)) && (e.classList.add("jodit_drag_hover"), t.preventDefault());
                        }).on(e, "dragend dragleave", function(t) {
                            e.classList.remove("jodit_drag_hover"), Th(t.dataTransfer) && t.preventDefault();
                        }).on(e, "drop", function(i) {
                            e.classList.remove("jodit_drag_hover"), Th(i.dataTransfer) && (i.preventDefault(), i.stopImmediatePropagation(), Eh(r, i.dataTransfer.files, t, o).finally(n));
                        });
                        var i = e.querySelector("input[type=file]");
                        i && r.j.e.on(i, "change", function() {
                            Eh(r, i.files, t, o).then(function() {
                                i.value = "", /safari/i.test(navigator.userAgent) || (i.type = "", i.type = "file");
                            }).finally(n);
                        });
                    }
                },
                {
                    key: "uploadRemoteImage",
                    value: function(e, t, o) {
                        var n = this, r = n.o, i = Ro(o) ? o : r.defaultHandlerError;
                        Oh(n, {
                            action: "fileUploadRemote",
                            url: e
                        }).then(function(e) {
                            r.isSuccess.call(n, e) ? (Ro(t) ? t : r.defaultHandlerSuccess).call(n, r.process.call(n, e)) : i.call(n, Fr(r.getMessage.call(n, e)));
                        }).catch(function(e) {
                            return i.call(n, e);
                        });
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.setStatus(Io.beforeDestruct);
                        var e = xh.get(this);
                        e && (e.forEach(function(e) {
                            try {
                                e.destruct();
                            } catch (e) {}
                        }), e.clear()), Ah(Lh(t.prototype), "destruct", this).call(this);
                    }
                }
            ], n && Rh(o.prototype, n), t;
        }(Qa), Nh = "wrap", Hh = "unwrap", Fh = "change", qh = "unset", Vh = "initial", Wh = "replace", Uh = "commitStyle";
        function Yh(e, t, o) {
            var n = o.s.createRange(), r = an(t.previousSibling) ? t.previousSibling : t;
            n.setStartBefore(e), n.setEndBefore(r), Kh(e, n, !0);
            var i = an(t.nextSibling) ? t.nextSibling : t;
            n.setStartAfter(i), n.setEndAfter(e), Kh(e, n, !1);
        }
        function Kh(e, t, o) {
            var n = t.extractContents();
            n.textContent && vn(n.textContent).length || !n.firstChild || pi.unwrap(n.firstChild), e.parentNode && dr(o ? pi.before : pi.after, e, n);
        }
        function Gh(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var Jh = function() {
            function e(t, o) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.transitions = o, this.silent = !0, this.__previewsStates = new Set, this.setState(t);
            }
            var t, o;
            return t = e, o = [
                {
                    key: "setState",
                    value: function(e) {
                        $n(!this.__previewsStates.has(e), "Circled states"), this.__previewsStates.add(e), this.__state = e;
                    }
                },
                {
                    key: "getState",
                    value: function() {
                        return this.__state;
                    }
                },
                {
                    key: "disableSilent",
                    value: function() {
                        this.silent = !1;
                    }
                },
                {
                    key: "dispatch",
                    value: function(e, t) {
                        var o = this.transitions[this.getState()][e];
                        if (o) {
                            var n = o.call(this, t);
                            return $n(n && n !== t, "Action should return new value"), $n(Lo(n.next), "Value should contain the next state"), $n(n.next !== this.getState(), "The new state should not be equal to the old one."), this.setState(n.next), ft || this.silent || console.log("State: ".concat(this.getState())), n;
                        }
                        throw new Error("invalid action: ".concat(this.getState(), ".").concat(e.toString()));
                    }
                }
            ], Gh(t.prototype, o), e;
        }();
        function Xh(e) {
            return Boolean(e && !pi.isEmptyTextNode(e) && !pi.isTemporary(e) && !an(e));
        }
        function Zh(e, t) {
            return Boolean(!pi.isTag(e, "font") && pi.isHTMLElement(e) && Object.keys(t).every(function(o) {
                var n = Ln(e, o, !0);
                return "" === n && ("" === t[o] || null == t[o]) || !Bo(n) && "" !== n && !Bo(t[o]) && Rn(o, t[o]).toString().toLowerCase() === n.toString().toLowerCase();
            }));
        }
        if (Ct) {
            var Qh = Ct.createElement("div");
            Qh.style.color = "red", $n(Zh(Qh, {
                color: "red"
            }), "Style test"), $n(Zh(Qh, {
                fontSize: null
            }), "Style test"), $n(Zh(Qh, {
                fontSize: ""
            }), "Style test");
        }
        function $h(e, t) {
            return Boolean(!pi.isTag(e, "font") && pi.isHTMLElement(e) && Object.keys(t).every(function(t) {
                return "" !== Ln(e, t, !0);
            }));
        }
        if (Ct) {
            var ev = Ct.createElement("div");
            ev.style.color = "red", $n($h(ev, {
                color: "red"
            }), "Style test"), $n(!$h(ev, {
                font: "Arial",
                color: "red"
            }), "Style test"), $n(!$h(ev, {
                border: "1px solid #ccc"
            }), "Style test");
        }
        function tv(e, t, o) {
            var n, r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
            if (!t || !Xh(t)) return !1;
            var i = e.element, a = e.elementIsDefault, l = e.options;
            if (pi.isList(t) && e.elementIsList) return !0;
            var s = pi.isTag(t, i);
            return !(!s || a && o) || !(!Boolean((null === (n = l.attributes) || void 0 === n ? void 0 : n.style) && (r ? Zh(t, l.attributes.style) : $h(t, l.attributes.style))) || e.elementIsList) || !s && !o && a && pi.isInlineBlock(t);
        }
        function ov(e, t, o) {
            return pi.closest(t, function(t) {
                return tv(e, t, !0, !1);
            }, o);
        }
        function nv(e, t, o) {
            var n = t.parentNode;
            return n === o || !pi.isHTMLElement(n) || pi.next(t, Xh, n) || pi.prev(t, Xh, n) ? null : e.isElementCommit && e.elementIsBlock && !pi.isBlock(n) ? nv(e, n, o) : !tv(e, n, !1) || pi.isBlock(n) && !e.elementIsBlock ? e.isElementCommit && !pi.isBlock(n) ? nv(e, n, o) : null : n;
        }
        var rv = "toggleAttributes";
        function iv(e, t, o, n) {
            var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
            if (!r && e.isApplied(t, rv)) return n;
            !r && e.setApplied(t, rv);
            var i = e.options.attributes;
            return i && ea(i) > 0 && Object.keys(i).forEach(function(a) {
                var l = i[a];
                switch(a){
                    case "style":
                        n = function(e, t, o, n, r, i) {
                            return $n(cn(o) && ea(o), "Style must be an object"), Object.keys(o).forEach(function(a) {
                                var l = n.style.getPropertyValue(En(a)), s = o[a];
                                if ("" !== l || null != s) {
                                    if (function(e, t, o) {
                                        var n = e.create.element(t.tagName.toLowerCase());
                                        n.style.cssText = t.style.cssText;
                                        var r = function(e) {
                                            var t;
                                            if (void 0 !== cr(e, "shadowRoot")) return cr(e, "shadowRoot");
                                            var o = Ha(e), n = Ct.createElement("iframe");
                                            Ln(n, {
                                                width: 0,
                                                height: 0,
                                                position: "absolute",
                                                border: 0
                                            }), n.src = "about:blank", o.appendChild(n);
                                            var r = null === (t = n.contentWindow) || void 0 === t ? void 0 : t.document, i = r ? r.body : e.od.body;
                                            return cr(e, "shadowRoot", i), i;
                                        }(e);
                                        r.appendChild(n);
                                        var i = Ln(n, o);
                                        return pi.safeRemove(n), i;
                                    }(t, n, a) === Rn(a, s)) {
                                        if (!l) return;
                                        return !r && Ln(n, a, null), void (i = av(e, n, i = qh));
                                    }
                                    i = Fh, r || (Ln(n, a, s), i = av(e, n, i));
                                }
                            }), i;
                        }(e, o, l, t, r, n);
                        break;
                    case "className":
                    case "class":
                        n = function(e, t, o, n, r) {
                            $n(Lo(t), "Class name must be a string");
                            var i = e.e.fire.bind(e.e, "".concat(Uh, "AfterToggleAttribute"));
                            return o.classList.contains(t.toString()) ? (n = qh, r || (o.classList.remove(t), 0 === o.classList.length && (er(o, "class", null), i(n, o, "class", null)))) : (n = Fh, r || (o.classList.add(t), i(n, o, "class", t))), n;
                        }(o, l, t, n, r);
                        break;
                    default:
                        n = function(e, t, o, n, r, i) {
                            $n(Lo(t) || ln(t) || Wo(t) || null == t, "Attribute value must be a string or number or boolean or null");
                            var a = e.e.fire.bind(e.e, "".concat(Uh, "AfterToggleAttribute"));
                            return er(o, n) === t ? (!r && er(o, n, null), i = qh, !r && a(i, o, n, t), i) : (i = Fh, r || (er(o, n, t), a(i, o, n, t)), i);
                        }(o, l, t, a, r, n);
                }
            }), n;
        }
        function av(e, t, o) {
            return er(t, "style") || (er(t, "style", null), t.tagName.toLowerCase() === e.defaultTag && (pi.unwrap(t), o = Hh)), o;
        }
        function lv(e, t, o) {
            var n = o.e.fire("".concat(Uh, "BeforeWrapList"), Wh, t, e), r = null != n ? n : pi.replace(t, "li", o.createInside), i = r.previousElementSibling, a = r.nextElementSibling, l = pi.isTag(i, e.element) ? i : null;
            return null != l || (l = pi.isTag(a, e.element) ? a : null), pi.isList(l) && function(e, t) {
                return !e.attributes.length && !ea(t) || !ea(t) || ($n(t, "Attrs must be a non-empty object"), Object.keys(t).every(function(o) {
                    return "class" === o || "className" === o ? e.classList.contains(t[o]) : "style" === o ? Zh(e, t[o]) : er(e, o) === t[o];
                }));
            }(l, e.options.attributes) || (iv(e, l = o.createInside.element(e.element), o, Vh), pi.before(r, l)), i === l ? pi.append(l, r) : pi.prepend(l, r), pi.isTag(l.nextElementSibling, e.element) && function(e, t) {
                return e.attributes.length === t.attributes.length && Array.from(e.attributes).every(function(e) {
                    return t.hasAttribute(e.name) && t.getAttribute(e.name) === e.value;
                });
            }(l, l.nextElementSibling) && (pi.append(l, Array.from(l.nextElementSibling.childNodes)), pi.safeRemove(l.nextElementSibling)), o.e.fire("".concat(Uh, "AfterWrapList"), Nh, l, e), l;
        }
        function sv(e, t, o, n) {
            if (!t) return n;
            var r = t.parentElement;
            if (!r) return n;
            var i = o.e.fire("".concat(Uh, "BeforeToggleList"), n, e, r);
            if (void 0 !== i) return i;
            var a = o.e.fire.bind(o.e, "".concat(Uh, "AfterToggleList"));
            if (n !== Hh) {
                var l = iv(e, t.parentElement, o, Vh, !0) === Fh;
                if (n === Wh || l || r.tagName.toLowerCase() !== e.element) {
                    var s = lv(e, cv(Wh, r, t, o, e), o);
                    return a(Wh, s, e), Wh;
                }
            }
            var c = cv(Hh, r, t, o, e);
            return a(Hh, c, e), Hh;
        }
        function cv(e, t, o, n, r) {
            var i = n.e.fire("".concat(Uh, "BeforeUnwrapList"), e, t, r);
            return i ? ($n(pi.isHTMLElement(i), "".concat(Uh, "BeforeUnwrapList hook must return HTMLElement")), i) : (Yh(t, o, n), $n(pi.isHTMLElement(o.parentElement), "Element should be inside the list"), pi.unwrap(o.parentElement), pi.replace(o, "br" !== n.o.enter.toLowerCase() ? n.o.enter : n.createInside.fragment(), n.createInside));
        }
        var uv = new Set([
            "td",
            "th",
            "tr",
            "tbody",
            "table",
            "li",
            "ul",
            "ol"
        ]);
        function dv(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function fv(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    dv(e, t, o[t]);
                });
            }
            return e;
        }
        function pv(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }
        var hv, vv = "START", gv = "ELEMENT", mv = "UNWRAP", bv = "UNWRAP_CHILDREN", yv = "CHANGE", _v = "REPLACE_DEFAULT", jv = "LIST", wv = "TOGGLE_LIST", kv = "WRAP", Sv = "EXTRACT", xv = "END", Ov = (dv(hv = {}, vv, {
            exec: function(e) {
                var t, o, n = e.element, r = e.jodit, i = e.style, a = e.mode, l = e.collapsed;
                if (t = n, o = r.editor, Boolean(pi.closest(t, [
                    "style",
                    "script"
                ], o)) || !l && pi.isEmptyContent(n)) return pv(fv({}, e), {
                    next: xv
                });
                var s = nv(i, n, r.editor) || function(e, t) {
                    for(var o = t.firstChild; o && !Xh(o);)if (!(o = o.nextSibling)) return null;
                    return o && !pi.next(o, Xh, t) && tv(e, o, !1) ? o : null;
                }(i, n);
                if (s) return pv(fv({}, e), {
                    next: gv,
                    element: s
                });
                var c = ov(i, n, r.editor);
                return i.elementIsList && pi.isList(c) ? pv(fv({}, e), {
                    next: jv
                }) : pv(fv({}, e), c ? {
                    next: Sv
                } : {
                    next: a !== Hh ? bv : xv
                });
            }
        }), dv(hv, jv, {
            exec: function(e) {
                var t = e.element, o = e.jodit, n = e.mode;
                if (n !== Vh && n !== Hh && n !== Wh) return pv(fv({}, e), {
                    next: xv
                });
                var r = pi.closest(t, "li", o.editor);
                if (!r) return pv(fv({}, e), {
                    next: xv
                });
                var i = pi.closest(t, Tt, o.editor);
                return pv(fv({}, e), i ? {
                    element: r,
                    next: wv
                } : {
                    next: xv
                });
            }
        }), dv(hv, wv, {
            exec: function(e) {
                return pv(fv({}, e), {
                    mode: sv(e.style, e.element, e.jodit, e.mode),
                    next: xv
                });
            }
        }), dv(hv, Sv, {
            exec: function(e) {
                var t = e.element, o = e.jodit, n = e.style, r = ov(n, t, o.editor);
                return $n(r, "This place should have an element"), n.elementIsBlock || Yh(r, t, o), pv(fv({}, e), {
                    element: r,
                    next: gv
                });
            }
        }), dv(hv, bv, {
            exec: function(e) {
                var t = e.element;
                return function(e, t) {
                    var o, n, r = [], i = [], a = null === (o = e.options.attributes) || void 0 === o ? void 0 : o.style;
                    if (t.firstChild) for(var l = function() {
                        var t = c.value;
                        !tv(e, t, !0) || a && !$h(t, a) ? a && function(e, t) {
                            var o, n, r = e.element, i = e.options;
                            if (!t || !Xh(t)) return !1;
                            var a = t.nodeName.toLowerCase() === r, l = Boolean((null === (o = i.attributes) || void 0 === o ? void 0 : o.style) && $h(t, null === (n = i.attributes) || void 0 === n ? void 0 : n.style));
                            return a && l;
                        }(e, t) ? (void 0 === n && (n = !1), i.push(function() {
                            Ln(t, Object.keys(a).reduce(function(e, t) {
                                return e[t] = null, e;
                            }, {})), er(t, "style") || er(t, "style", null), er(t, "style") || t.nodeName.toLowerCase() !== e.element || r.push(t);
                        })) : pi.isEmptyTextNode(t) || void 0 === n && (n = !1) : (void 0 === n && (n = !0), r.push(t)), c = s.next();
                    }, s = pi.eachGen(t), c = s.next(); !c.done;)l();
                    return i.forEach(function(e) {
                        return e();
                    }), r.forEach(pi.unwrap), Boolean(n);
                }(e.style, t) ? pv(fv({}, e), {
                    mode: Hh,
                    next: xv
                }) : pv(fv({}, e), {
                    next: kv
                });
            }
        }), dv(hv, kv, {
            exec: function(e) {
                var t = e.element, o = e.jodit, n = e.style, r = function(e, t, o) {
                    var n = function(e, t, o) {
                        return e.elementIsBlock ? pi.up(t, function(e) {
                            return pi.isBlock(e) && !pi.isTag(e, uv);
                        }, o.editor) || function(e, t, o) {
                            var n = o.editor, r = o.createInside, i = function(e) {
                                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "previousSibling", r = e, i = e; i && !an(i) && !pi.isTag(i, o.o.enter) && (r = i, i = i[t] ? i[t] : i.parentNode && !pi.isBlock(i.parentNode) && i.parentNode !== n ? i.parentNode : null, !pi.isBlock(i)););
                                return r;
                            }, a = i(t), l = i(t, "nextSibling"), s = o.s.createRange();
                            s.setStartBefore(a), s.setEndAfter(l);
                            var c = s.extractContents(), u = r.element(e.element);
                            return u.appendChild(c), pi.safeInsertNode(s, u), e.elementIsBlock && pi.isEmpty(u) && !pi.isTag(u.firstElementChild, "br") && u.appendChild(r.element("br")), u;
                        }(e, t, o) : (er(t, "size", null), t);
                    }(e, t, o);
                    return e.elementIsList ? lv(e, n, o) : pi.replace(n, e.element, o.createInside, !0);
                }(n, t, o);
                return pv(fv({}, e), {
                    next: n.elementIsList ? xv : yv,
                    mode: Nh,
                    element: r
                });
            }
        }), dv(hv, gv, {
            exec: function(e) {
                var t = e.style, o = e.element;
                return iv(t, o, e.jodit, Vh, !0) !== Vh ? pv(fv({}, e), {
                    next: yv
                }) : pi.isTag(o, t.element) ? pv(fv({}, e), {
                    next: mv
                }) : pv(fv({}, e), {
                    next: xv
                });
            }
        }), dv(hv, yv, {
            exec: function(e) {
                var t = e.style, o = e.element, n = e.jodit, r = e.mode, i = iv(t, o, n, e.mode);
                return r !== Nh && i === qh && !o.attributes.length && pi.isTag(o, t.element) ? pv(fv({}, e), {
                    next: mv
                }) : pv(fv({}, e), {
                    mode: i,
                    next: xv
                });
            }
        }), dv(hv, mv, {
            exec: function(e) {
                return e.element.attributes.length && pi.isTag(e.element, e.style.element) ? pv(fv({}, e), {
                    next: _v
                }) : (pi.unwrap(e.element), pv(fv({}, e), {
                    mode: Hh,
                    next: xv
                }));
            }
        }), dv(hv, _v, {
            exec: function(e) {
                return pi.replace(e.element, e.style.defaultTag, e.jodit.createInside, !0), pv(fv({}, e), {
                    mode: Wh,
                    next: xv
                });
            }
        }), dv(hv, xv, {
            exec: function(e) {
                return e;
            }
        }), hv);
        function Cv(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        var zv = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.options = t, this.__applyMap = new WeakMap;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "isApplied",
                    value: function(e, t) {
                        var o = this.__applyMap.get(e);
                        return !!o && o[t];
                    }
                },
                {
                    key: "setApplied",
                    value: function(e, t) {
                        var o, n = null !== (o = this.__applyMap.get(e)) && void 0 !== o ? o : {};
                        n[t] = !0, this.__applyMap.set(e, n);
                    }
                },
                {
                    key: "elementIsList",
                    get: function() {
                        return Boolean(this.options.element && Tt.has(this.options.element));
                    }
                },
                {
                    key: "element",
                    get: function() {
                        return this.options.element || this.defaultTag;
                    }
                },
                {
                    key: "elementIsBlock",
                    get: function() {
                        return Boolean(this.options.element && zt.test(this.options.element));
                    }
                },
                {
                    key: "isElementCommit",
                    get: function() {
                        return Boolean(this.options.element && this.options.element !== this.options.defaultTag);
                    }
                },
                {
                    key: "defaultTag",
                    get: function() {
                        return this.options.defaultTag ? this.options.defaultTag : this.elementIsBlock ? "p" : "span";
                    }
                },
                {
                    key: "elementIsDefault",
                    get: function() {
                        return this.element === this.defaultTag;
                    }
                },
                {
                    key: "apply",
                    value: function(e) {
                        var t = this.options.hooks, o = t ? Object.keys(t) : [];
                        try {
                            o.forEach(function(o) {
                                e.e.on(An(Uh + "_" + o), t[o]);
                            }), function(e, t) {
                                var o, n = e.s;
                                null === (o = e.editor.firstChild) || void 0 === o || o.normalize();
                                var r = n.fakes(), i = e.s.wrapInTagGen(r), a = i.next();
                                if (!a.done) {
                                    for(var l = {
                                        collapsed: n.isCollapsed(),
                                        mode: Vh,
                                        element: a.value,
                                        next: vv,
                                        jodit: e,
                                        style: t
                                    }; a && !a.done;){
                                        var s = new Jh(vv, Ov);
                                        for(l.element = a.value; s.getState() !== xv;)l = s.dispatch("exec", l);
                                        a = i.next();
                                    }
                                    n.restoreFakes(r);
                                }
                            }(e, this);
                        } finally{
                            o.forEach(function(o) {
                                e.e.off(An(Uh + "_" + o), t[o]);
                            }), this.__applyMap = new WeakMap;
                        }
                        e.synchronizeValues(), e.e.fire("afterCommitStyle", this);
                    }
                }
            ], o && Cv(t.prototype, o), e;
        }();
        function Ev(e, t, o) {
            for(var n = pi.findSibling(t, o), r = pi.findSibling(t, !o); pi.isElement(n) && !pi.isTag(n, Pt) && pi.isContentEditable(n, e.editor) && (!r || !pi.closest(t, pi.isElement, e.editor));)o || !n.firstChild ? n.appendChild(t) : pi.before(n.firstChild, t), n = pi.sibling(t, o), r = pi.sibling(t, !o);
        }
        function Tv(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Iv(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Pv(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        var Rv = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Pv(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Av = function() {
            function e(t) {
                var o = this;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.jodit = t, t.e.on("removeMarkers", function() {
                    o.removeMarkers();
                });
            }
            var t, o;
            return t = e, o = [
                {
                    key: "j",
                    get: function() {
                        return this.jodit;
                    }
                },
                {
                    key: "errorNode",
                    value: function(e) {
                        if (!pi.isNode(e)) throw Fr("Parameter node must be instance of Node");
                    }
                },
                {
                    key: "area",
                    get: function() {
                        return this.j.editor;
                    }
                },
                {
                    key: "win",
                    get: function() {
                        return this.j.ew;
                    }
                },
                {
                    key: "doc",
                    get: function() {
                        return this.j.ed;
                    }
                },
                {
                    key: "sel",
                    get: function() {
                        return this.j.o.shadowRoot && Ro(this.j.o.shadowRoot.getSelection) ? this.j.o.shadowRoot.getSelection() : this.win.getSelection();
                    }
                },
                {
                    key: "range",
                    get: function() {
                        var e = this.sel;
                        return e && e.rangeCount ? e.getRangeAt(0) : this.createRange();
                    }
                },
                {
                    key: "isInsideArea",
                    get: function() {
                        var e = this.sel, t = (null == e ? void 0 : e.rangeCount) ? e.getRangeAt(0) : null;
                        return !(!t || !pi.isOrContains(this.area, t.startContainer));
                    }
                },
                {
                    key: "createRange",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = this.doc.createRange();
                        return e && this.selectRange(t), t;
                    }
                },
                {
                    key: "remove",
                    value: function() {
                        var e = this.sel, t = this.current();
                        if (e && t) for(var o = 0; o < e.rangeCount; o += 1)e.getRangeAt(o).deleteContents(), e.getRangeAt(o).collapse(!0);
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        var e, t;
                        (null === (e = this.sel) || void 0 === e ? void 0 : e.rangeCount) && (null === (t = this.sel) || void 0 === t || t.removeAllRanges());
                    }
                },
                {
                    key: "removeNode",
                    value: function(e) {
                        if (!pi.isOrContains(this.j.editor, e, !0)) throw Fr("Selection.removeNode can remove only editor's children");
                        pi.safeRemove(e), this.j.e.fire("afterRemoveNode", e);
                    }
                },
                {
                    key: "insertCursorAtPoint",
                    value: function(e, t) {
                        var o = this;
                        this.removeMarkers();
                        try {
                            var n = this.createRange();
                            return function() {
                                if (o.doc.caretPositionFromPoint) {
                                    var r = o.doc.caretPositionFromPoint(e, t);
                                    if (r) return void n.setStart(r.offsetNode, r.offset);
                                }
                                if (o.doc.caretRangeFromPoint) {
                                    var i = o.doc.caretRangeFromPoint(e, t);
                                    $n(i, "Incorrect caretRangeFromPoint behaviour"), n.setStart(i.startContainer, i.startOffset);
                                }
                            }(), n.collapse(!0), this.selectRange(n), !0;
                        } catch (e) {}
                        return !1;
                    }
                },
                {
                    key: "hasMarkers",
                    get: function() {
                        return Boolean(this.markers.length);
                    }
                },
                {
                    key: "markers",
                    get: function() {
                        return Qr("span[data-" + io + "]", this.area);
                    }
                },
                {
                    key: "removeMarkers",
                    value: function() {
                        pi.safeRemove.apply(null, this.markers);
                    }
                },
                {
                    key: "marker",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 ? arguments[1] : void 0, o = null;
                        t && (o = t.cloneRange()).collapse(e);
                        var n = this.j.createInside.span();
                        return n.id = io + "_" + Number(new Date) + "_" + String(Math.random()).slice(2), n.style.lineHeight = "0", n.style.display = "none", pi.markTemporary(n), er(n, "data-" + io, e ? "start" : "end"), n.appendChild(this.j.createInside.text(bt)), o && pi.isOrContains(this.area, e ? o.startContainer : o.endContainer) && o.insertNode(n), n;
                    }
                },
                {
                    key: "restore",
                    value: function() {
                        var e = !1, t = function(e) {
                            return "span[data-".concat(io, "=").concat(e ? "start" : "end", "]");
                        }, o = this.area.querySelector(t(!0)), n = this.area.querySelector(t(!1));
                        if (o) {
                            if (e = this.createRange(), n) e.setStartAfter(o), pi.safeRemove(o), e.setEndBefore(n), pi.safeRemove(n);
                            else {
                                var r = o.previousSibling;
                                pi.isText(r) ? e.setStart(r, r.nodeValue ? r.nodeValue.length : 0) : e.setStartBefore(o), pi.safeRemove(o), e.collapse(!0);
                            }
                            e && this.selectRange(e);
                        }
                    }
                },
                {
                    key: "fakes",
                    value: function() {
                        var e = this.sel;
                        if (!e || !e.rangeCount) return [];
                        var t = e.getRangeAt(0);
                        $n(t, "Range is null");
                        var o = t.cloneRange();
                        o.collapse(!0);
                        var n = this.j.createInside.fake();
                        pi.safeInsertNode(o, n), t.setStartBefore(n);
                        var r = [
                            n
                        ];
                        if (!t.collapsed) {
                            var i = t.cloneRange();
                            i.collapse(!1);
                            var a = this.j.createInside.fake();
                            pi.safeInsertNode(i, a), t.setEndAfter(a), r.push(a);
                        }
                        return this.selectRange(t), r;
                    }
                },
                {
                    key: "restoreFakes",
                    value: function(e) {
                        var t, o, n, r, i = e.filter(function(e) {
                            return e.isConnected;
                        });
                        if (i.length) {
                            var a = function(e, t) {
                                return function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != o) {
                                        var n, r, i = [], a = !0, l = !1;
                                        try {
                                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                        } catch (e) {
                                            l = !0, r = e;
                                        } finally{
                                            try {
                                                a || null == o.return || o.return();
                                            } finally{
                                                if (l) throw r;
                                            }
                                        }
                                        return i;
                                    }
                                }(e, t) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return Tv(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Tv(e, t) : void 0;
                                    }
                                }(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(i, 2), l = a[0], s = a[1], c = this.createRange();
                            c.setStartAfter(l), s && c.setEndBefore(s), this.selectRange(c), (null === (t = l.parentNode) || void 0 === t ? void 0 : t.firstChild) !== (null === (o = l.parentNode) || void 0 === o ? void 0 : o.lastChild) && pi.safeRemove(l), (null === (n = null == s ? void 0 : s.parentNode) || void 0 === n ? void 0 : n.firstChild) !== (null === (r = null == s ? void 0 : s.parentNode) || void 0 === r ? void 0 : r.lastChild) && pi.safeRemove(s);
                        }
                    }
                },
                {
                    key: "save",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        if (this.hasMarkers) return [];
                        var t = this.sel;
                        if (!t || !t.rangeCount) return [];
                        for(var o = [], n = t.rangeCount, r = [], i = 0; i < n; i += 1)if (r[i] = t.getRangeAt(i), r[i].collapsed) {
                            var a = this.marker(!0, r[i]);
                            o[i] = {
                                startId: a.id,
                                collapsed: !0,
                                startMarker: a.outerHTML
                            };
                        } else {
                            var l = this.marker(!0, r[i]), s = this.marker(!1, r[i]);
                            o[i] = {
                                startId: l.id,
                                endId: s.id,
                                collapsed: !1,
                                startMarker: l.outerHTML,
                                endMarker: s.outerHTML
                            };
                        }
                        if (!e) {
                            t.removeAllRanges();
                            for(var c = n - 1; c >= 0; --c){
                                var u = this.doc.getElementById(o[c].startId);
                                if (u) {
                                    if (o[c].collapsed) r[c].setStartAfter(u), r[c].collapse(!0);
                                    else if (r[c].setStartBefore(u), o[c].endId) {
                                        var d = this.doc.getElementById(o[c].endId);
                                        d && r[c].setEndAfter(d);
                                    }
                                    try {
                                        t.addRange(r[c].cloneRange());
                                    } catch (e) {}
                                }
                            }
                        }
                        return o;
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        var e, t, o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                            preventScroll: !0
                        };
                        if (!this.isFocused()) {
                            var n = Qi(this.j.container), r = null == n ? void 0 : n.scrollTop;
                            this.j.iframe && "complete" === this.doc.readyState && this.j.iframe.focus(o), this.win.focus(), this.area.focus(o), r && (null == n ? void 0 : n.scrollTo) && n.scrollTo(0, r);
                            var i = this.sel, a = (null == i ? void 0 : i.rangeCount) ? null == i ? void 0 : i.getRangeAt(0) : null;
                            if (!a || !pi.isOrContains(this.area, a.startContainer)) {
                                var l = this.createRange();
                                l.setStart(this.area, 0), l.collapse(!0), this.selectRange(l, !1);
                            }
                            return this.j.editorIsActive || null === (t = null === (e = this.j) || void 0 === e ? void 0 : e.events) || void 0 === t || t.fire("focus"), !0;
                        }
                        return !1;
                    }
                },
                {
                    key: "isCollapsed",
                    value: function() {
                        for(var e = this.sel, t = 0; e && t < e.rangeCount; t += 1)if (!e.getRangeAt(t).collapsed) return !1;
                        return !0;
                    }
                },
                {
                    key: "isFocused",
                    value: function() {
                        return this.doc.hasFocus && this.doc.hasFocus() && this.area === this.doc.activeElement;
                    }
                },
                {
                    key: "current",
                    value: function() {
                        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        if (this.j.getRealMode() !== Qt) return null;
                        var t = this.sel;
                        if (!t || 0 === t.rangeCount) return null;
                        var o = t.getRangeAt(0), n = o.startContainer, r = !1;
                        if (pi.isTag(n, "br") && t.isCollapsed) return n;
                        if (!pi.isText(n)) {
                            var i = function(e, t, o, n, r, i) {
                                if ((e = t.startContainer.childNodes[t.startOffset]) || (e = t.startContainer.childNodes[t.startOffset - 1], o = !0), e && n && !pi.isText(e)) {
                                    if (!o && pi.isText(e.previousSibling)) e = e.previousSibling;
                                    else if (r) for(var a = i(e); a;){
                                        if (a && pi.isText(a)) {
                                            e = a;
                                            break;
                                        }
                                        a = i(a);
                                    }
                                }
                                if (e && !n && !pi.isText(e)) {
                                    var l = e, s = e;
                                    do l = l.firstChild, s = s.lastChild;
                                    while (l && s && !pi.isText(l));
                                    l === s && l && pi.isText(l) && (e = l);
                                }
                                return {
                                    node: e,
                                    rightMode: o
                                };
                            }(n, o, r, t.isCollapsed, e, function(e) {
                                return r ? e.lastChild : e.firstChild;
                            });
                            n = i.node, r = i.rightMode;
                        }
                        return n && pi.isOrContains(this.area, n) ? n : null;
                    }
                },
                {
                    key: "insertNode",
                    value: function(e) {
                        var t = this, o = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                        this.errorNode(e);
                        var r = pi.isFragment(e) ? e.lastChild : e;
                        this.j.e.fire("safeHTML", e), !this.isFocused() && this.j.isEditorMode() && (this.focus(), this.restore());
                        var i = this.sel;
                        this.j.history.snapshot.transaction(function() {
                            if (t.isCollapsed() || t.j.execCommand("Delete"), t.j.e.fire("beforeInsertNode", e), i && i.rangeCount) {
                                var n = i.getRangeAt(0);
                                pi.isOrContains(t.area, n.commonAncestorContainer) ? pi.safeInsertNode(n, e) : t.area.appendChild(e);
                            } else t.area.appendChild(e);
                            var a = function(e) {
                                if (pi.isBlock(e)) {
                                    var o = e.lastChild;
                                    if (o) return a(o);
                                }
                                t.setCursorAfter(e);
                            };
                            o && (pi.isFragment(e) ? r && a(r) : a(e)), t.j.o.scrollToPastedContent && ii(null != r ? r : e, t.j.editor, t.doc);
                        }), n && this.j.events && this.j.__imdSynchronizeValues(), this.j.events && this.j.e.fire("afterInsertNode", pi.isFragment(e) ? r : e);
                    }
                },
                {
                    key: "insertHTML",
                    value: function(e) {
                        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        if ("" !== e) {
                            var o = this.j.createInside.div(), n = this.j.createInside.fragment();
                            if (!this.isFocused() && this.j.isEditorMode() && (this.focus(), this.restore()), pi.isNode(e) ? o.appendChild(e) : o.innerHTML = e.toString(), (this.j.isEditorMode() || !1 !== this.j.e.fire("insertHTML", o.innerHTML)) && o.lastChild) {
                                for(; o.firstChild;)o.firstChild, n.appendChild(o.firstChild);
                                this.insertNode(n, t, !1), this.j.__imdSynchronizeValues();
                            }
                        }
                    }
                },
                {
                    key: "insertImage",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = Lo(e) ? this.j.createInside.element("img") : e;
                        if (Lo(e) && n.setAttribute("src", e), null != o) {
                            var r = o.toString();
                            r && "auto" !== r && String(r).indexOf("px") < 0 && String(r).indexOf("%") < 0 && (r += "px"), er(n, "width", r);
                        }
                        t && "object" === (void 0 === t ? "undefined" : Pv(t)) && Ln(n, t);
                        var i = function() {
                            (n.naturalHeight < n.offsetHeight || n.naturalWidth < n.offsetWidth) && (n.style.width = "", n.style.height = ""), n.removeEventListener("load", i);
                        };
                        this.j.e.on(n, "load", i), n.complete && i(), this.insertNode(n), this.j.e.fire("afterInsertImage", n);
                    }
                },
                {
                    key: "eachSelection",
                    value: function(e) {
                        var t, o = this, n = this.sel;
                        if (n && n.rangeCount) {
                            var r = n.getRangeAt(0), i = r.commonAncestorContainer;
                            pi.isHTMLElement(i) || (i = i.parentElement);
                            var a = [], l = r.startOffset, s = i.childNodes.length, c = l < s ? l : s - 1, u = r.startContainer === this.area ? i.childNodes[c] : r.startContainer, d = r.endContainer === this.area ? i.childNodes[r.endOffset - 1] : r.endContainer;
                            pi.isText(u) && u === r.startContainer && r.startOffset === (null === (t = u.nodeValue) || void 0 === t ? void 0 : t.length) && u.nextSibling && (u = u.nextSibling), pi.isText(d) && d === r.endContainer && 0 === r.endOffset && d.previousSibling && (d = d.previousSibling);
                            var f = function(e) {
                                !e || e === i || pi.isEmptyTextNode(e) || an(e) || a.push(e);
                            };
                            f(u), u !== d && pi.isOrContains(i, u, !0) && pi.find(u, function(e) {
                                return f(e), e === d || e && e.contains && e.contains(d);
                            }, i, !0, !1);
                            var p = function(t) {
                                if (pi.isOrContains(o.j.editor, t, !0)) {
                                    if (t.nodeName.match(/^(UL|OL)$/)) return Fo(t.childNodes).forEach(p);
                                    if (pi.isTag(t, "li")) {
                                        if (t.firstChild) t = t.firstChild;
                                        else {
                                            var n = o.j.createInside.text(bt);
                                            t.appendChild(n), t = n;
                                        }
                                    }
                                    e(t);
                                }
                            };
                            0 === a.length && (pi.isEmptyTextNode(u) && a.push(u), u.firstChild && a.push(u.firstChild)), a.forEach(p);
                        }
                    }
                },
                {
                    key: "cursorInTheEdge",
                    value: function(e, t) {
                        var o, n = this, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = !e, a = null === (o = this.sel) || void 0 === o ? void 0 : o.getRangeAt(0);
                        if (null != r || (r = this.current(!1)), !a || !r || !pi.isOrContains(t, r, !0)) return null;
                        var l = e ? a.startContainer : a.endContainer, s = e ? a.startOffset : a.endOffset, c = function(e) {
                            return Boolean(e && !pi.isTag(e, "br") && !pi.isEmptyTextNode(e) && !pi.isTemporary(e) && !(pi.isElement(e) && !0 === n.j.e.fire("isInvisibleForCursor", e)));
                        };
                        if (pi.isText(l)) {
                            if (function(e, t, o, n) {
                                var r, i = (null === (r = e.nodeValue) || void 0 === r ? void 0 : r.length) ? e.nodeValue : "";
                                if (n && i.replace(jt(), "").length > t) return !0;
                                var a = wt().exec(i);
                                return o && (a && a[0].length < t || !a && t > 0);
                            }(l, s, e, i)) return !1;
                        } else {
                            var u = Fo(l.childNodes);
                            if (i) {
                                if (u.slice(s).some(c)) return !1;
                            } else if (u.slice(0, s).some(c)) return !1;
                        }
                        for(var d = r; d && d !== t;){
                            var f = pi.sibling(d, e);
                            if (f) {
                                if ((d = f) && c(d)) return !1;
                            } else d = d.parentNode;
                        }
                        return !0;
                    }
                },
                {
                    key: "cursorOnTheLeft",
                    value: function(e, t) {
                        return this.cursorInTheEdge(!0, e, t);
                    }
                },
                {
                    key: "cursorOnTheRight",
                    value: function(e, t) {
                        return this.cursorInTheEdge(!1, e, t);
                    }
                },
                {
                    key: "setCursorAfter",
                    value: function(e) {
                        return this.setCursorNearWith(e, !1);
                    }
                },
                {
                    key: "setCursorBefore",
                    value: function(e) {
                        return this.setCursorNearWith(e, !0);
                    }
                },
                {
                    key: "setCursorNearWith",
                    value: function(e, t) {
                        var o, n, r = this;
                        if (this.errorNode(e), !pi.up(e, function(e) {
                            return e === r.area || e && e.parentNode === r.area;
                        }, this.area)) throw Fr("Node element must be in editor");
                        var i = this.createRange(), a = null;
                        return pi.isText(e) ? t ? i.setStart(e, 0) : i.setEnd(e, null !== (n = null === (o = e.nodeValue) || void 0 === o ? void 0 : o.length) && void 0 !== n ? n : 0) : (a = this.j.createInside.fake(), t ? i.setStartBefore(e) : i.setEndAfter(e), i.collapse(t), pi.safeInsertNode(i, a), i.selectNode(a)), i.collapse(t), this.selectRange(i), a;
                    }
                },
                {
                    key: "setCursorIn",
                    value: function(e) {
                        var t = this, o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        if (this.errorNode(e), !pi.up(e, function(e) {
                            return e === t.area || e && e.parentNode === t.area;
                        }, this.area)) throw Fr("Node element must be in editor");
                        var n = this.createRange(), r = e, i = e;
                        do {
                            if (pi.isText(r) || pi.isTag(r, Pt)) break;
                            i = r, r = o ? r.firstChild : r.lastChild;
                        }while (r);
                        if (!r) {
                            var a = this.j.createInside.text(bt);
                            pi.isTag(i, Pt) ? r = i : (i.appendChild(a), i = a);
                        }
                        var l = r || i;
                        return pi.isTag(l, Pt) ? (o || pi.isTag(l, "br") ? n.setStartBefore(l) : n.setEndAfter(l), n.collapse(o)) : (n.selectNodeContents(l), n.collapse(o)), this.selectRange(n), i;
                    }
                },
                {
                    key: "selectRange",
                    value: function(e) {
                        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], o = this.sel;
                        return t && !this.isFocused() && this.focus(), o && (o.removeAllRanges(), o.addRange(e)), this.j.e.fire("changeSelection"), this;
                    }
                },
                {
                    key: "select",
                    value: function(e) {
                        var t = this, o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        if (this.errorNode(e), !pi.up(e, function(e) {
                            return e === t.area || e && e.parentNode === t.area;
                        }, this.area)) throw Fr("Node element must be in editor");
                        var n = this.createRange();
                        return n[o ? "selectNodeContents" : "selectNode"](e), this.selectRange(n);
                    }
                },
                {
                    key: "html",
                    get: function() {
                        var e = this.sel;
                        if (e && e.rangeCount > 0) {
                            var t = e.getRangeAt(0).cloneContents(), o = this.j.createInside.div();
                            return o.appendChild(t), o.innerHTML;
                        }
                        return "";
                    }
                },
                {
                    key: "wrapInTagGen",
                    value: function(e) {
                        var t, o, n, r, i, a, l, s, c, u, d;
                        return function(e, t) {
                            var o, n, r, i, a = {
                                label: 0,
                                sent: function() {
                                    if (1 & r[0]) throw r[1];
                                    return r[1];
                                },
                                trys: [],
                                ops: []
                            };
                            return i = {
                                next: l(0),
                                throw: l(1),
                                return: l(2)
                            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                return this;
                            }), i;
                            function l(i) {
                                return function(l) {
                                    return function(i) {
                                        if (o) throw new TypeError("Generator is already executing.");
                                        for(; a;)try {
                                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                            switch(n = 0, r && (i = [
                                                2 & i[0],
                                                r.value
                                            ]), i[0]){
                                                case 0:
                                                case 1:
                                                    r = i;
                                                    break;
                                                case 4:
                                                    return a.label++, {
                                                        value: i[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    a.label++, n = i[1], i = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    i = a.ops.pop(), a.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                        a = 0;
                                                        continue;
                                                    }
                                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                        a.label = i[1];
                                                        break;
                                                    }
                                                    if (6 === i[0] && a.label < r[1]) {
                                                        a.label = r[1], r = i;
                                                        break;
                                                    }
                                                    if (r && a.label < r[2]) {
                                                        a.label = r[2], a.ops.push(i);
                                                        break;
                                                    }
                                                    r[2] && a.ops.pop(), a.trys.pop();
                                                    continue;
                                            }
                                            i = t.call(e, a);
                                        } catch (e) {
                                            i = [
                                                6,
                                                e
                                            ], n = 0;
                                        } finally{
                                            o = r = 0;
                                        }
                                        if (5 & i[0]) throw i[1];
                                        return {
                                            value: i[0] ? i[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        i,
                                        l
                                    ]);
                                };
                            }
                        }(this, function(f) {
                            switch(f.label){
                                case 0:
                                    return this.isCollapsed() ? (t = this.jodit.createInside.element("font", bt), this.insertNode(t, !1, !1), e && e[0] && t.appendChild(e[0]), [
                                        4,
                                        t
                                    ]) : [
                                        3,
                                        2
                                    ];
                                case 1:
                                    return f.sent(), pi.unwrap(t), [
                                        2
                                    ];
                                case 2:
                                    Qr("*[style*=font-size]", this.area).forEach(function(e) {
                                        er(e, "data-font-size", e.style.fontSize.toString()), e.style.removeProperty("font-size");
                                    }), this.j.nativeExecCommand("fontsize", !1, "7"), Qr("*[data-font-size]", this.area).forEach(function(e) {
                                        var t = er(e, "data-font-size");
                                        t && (e.style.fontSize = t, er(e, "data-font-size", null));
                                    }), o = Qr('font[size="7"]', this.area), n = !0, r = !1, i = void 0, f.label = 3;
                                case 3:
                                    f.trys.push([
                                        3,
                                        8,
                                        9,
                                        10
                                    ]), a = o[Symbol.iterator](), f.label = 4;
                                case 4:
                                    return (n = (l = a.next()).done) ? [
                                        3,
                                        7
                                    ] : (s = l.value, c = s.firstChild, u = s.lastChild, c && c === u && an(c) ? (pi.unwrap(s), [
                                        3,
                                        6
                                    ]) : (c && an(c) && pi.before(s, c), u && an(u) && pi.after(s, u), [
                                        4,
                                        s
                                    ]));
                                case 5:
                                    f.sent(), pi.unwrap(s), f.label = 6;
                                case 6:
                                    return n = !0, [
                                        3,
                                        4
                                    ];
                                case 7:
                                    return [
                                        3,
                                        10
                                    ];
                                case 8:
                                    return d = f.sent(), r = !0, i = d, [
                                        3,
                                        10
                                    ];
                                case 9:
                                    try {
                                        n || null == a.return || a.return();
                                    } finally{
                                        if (r) throw i;
                                    }
                                    return [
                                        7
                                    ];
                                case 10:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }
                },
                {
                    key: "wrapInTag",
                    value: function(e) {
                        var t = [], o = !0, n = !1, r = void 0;
                        try {
                            for(var i, a = this.wrapInTagGen()[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                var l = i.value;
                                try {
                                    if (l.firstChild && l.firstChild === l.lastChild && an(l.firstChild)) continue;
                                    Ro(e) ? e(l) : t.push(pi.replace(l, e, this.j.createInside));
                                } finally{
                                    var s = l.parentNode;
                                    s && (pi.unwrap(l), pi.isEmpty(s) && pi.unwrap(s));
                                }
                            }
                        } catch (e) {
                            n = !0, r = e;
                        } finally{
                            try {
                                o || null == a.return || a.return();
                            } finally{
                                if (n) throw r;
                            }
                        }
                        return t;
                    }
                },
                {
                    key: "commitStyle",
                    value: function(e) {
                        $n(ea(e) > 0, "Need to pass at least one option"), new zv(e).apply(this.j);
                    }
                },
                {
                    key: "splitSelection",
                    value: function(e, t) {
                        if (!this.isCollapsed()) return null;
                        var o = this.createRange(), n = this.range;
                        o.setStartBefore(e);
                        var r = this.cursorOnTheRight(e, t), i = this.cursorOnTheLeft(e, t), a = this.j.createInside.element("br"), l = this.j.createInside.fake(), s = l.cloneNode();
                        try {
                            if (r || i) {
                                t ? pi.before(t, a) : pi.safeInsertNode(n, a);
                                var c = function(e, t) {
                                    for(var o = t(e); o;){
                                        var n = t(o);
                                        if (!o || !pi.isTag(o, "br") && !pi.isEmptyTextNode(o)) break;
                                        pi.safeRemove(o), o = n;
                                    }
                                };
                                c(a, function(e) {
                                    return e.nextSibling;
                                }), c(a, function(e) {
                                    return e.previousSibling;
                                }), pi.after(a, s), pi.before(a, l), r ? (o.setEndBefore(a), n.setEndBefore(a)) : (o.setEndAfter(a), n.setEndAfter(a));
                            } else o.setEnd(n.startContainer, n.startOffset);
                            var u = o.extractContents(), d = function(e) {
                                return pi.each(e, function(e) {
                                    return pi.isEmptyTextNode(e) && pi.safeRemove(e);
                                });
                            };
                            $n(e.parentNode, "Splitting fails");
                            try {
                                if (d(u), d(e), e.parentNode.insertBefore(u, e), !t && r && (null == a ? void 0 : a.parentNode)) {
                                    var f = this.createRange();
                                    f.setStartBefore(a), this.selectRange(f);
                                }
                            } catch (e) {
                                if (!ft) throw e;
                            }
                            var p = function(e) {
                                var t, o, n;
                                (null === (t = null == e ? void 0 : e.parentNode) || void 0 === t ? void 0 : t.firstChild) === (null === (o = null == e ? void 0 : e.parentNode) || void 0 === o ? void 0 : o.lastChild) && (null === (n = null == e ? void 0 : e.parentNode) || void 0 === n || n.appendChild(a.cloneNode()));
                            };
                            p(l), p(s);
                        } finally{
                            pi.safeRemove(l), pi.safeRemove(s);
                        }
                        return e.previousElementSibling;
                    }
                },
                {
                    key: "expandSelection",
                    value: function() {
                        var e = this;
                        if (this.isCollapsed()) return this;
                        var t = this.range, o = t.cloneRange();
                        if (!pi.isOrContains(this.j.editor, t.commonAncestorContainer, !0)) return this;
                        var n = function(o) {
                            var n = e.j.createInside.fake(), r = t.cloneRange();
                            return r.collapse(o), pi.safeInsertNode(r, n), function(e, t, o) {
                                for(var n = e; n && n !== o;){
                                    if (pi.findSibling(n, t)) return;
                                    if (pi.isBlock(n.parentElement)) break;
                                    (n = n.parentElement) && n !== o && (t ? pi.before(n, e) : pi.after(n, e));
                                }
                            }(n, o, e.j.editor), n;
                        }, r = n(!0), i = n(!1);
                        o.setStartAfter(r), o.setEndBefore(i);
                        var a = pi.findSibling(r, !1), l = pi.findSibling(i, !0);
                        if (a !== l) {
                            var s = pi.isElement(a) && pi.isOrContains(a, i), c = !s && pi.isElement(l) && pi.isOrContains(l, r);
                            if (s || c) {
                                for(var u = s ? a : l, d = u; pi.isElement(u);)(u = s ? u.firstElementChild : u.lastElementChild) && (s ? pi.isOrContains(u, i) : pi.isOrContains(u, r)) && (d = u);
                                s ? o.setStart(d, 0) : o.setEnd(d, d.childNodes.length);
                            }
                        }
                        if (this.selectRange(o), pi.safeRemove(r, i), this.isCollapsed()) throw Fr("Selection is collapsed");
                        return this;
                    }
                }
            ], o && Iv(t.prototype, o), e;
        }();
        function Lv(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Mv(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Bv(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function Dv(e, t, o) {
            return Dv = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Nv(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Dv(e, t, o || e);
        }
        function Nv(e) {
            return Nv = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Nv(e);
        }
        function Hv(e, t) {
            return !t || "object" !== Vv(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Fv(e, t) {
            return Fv = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Fv(e, t);
        }
        function qv(e) {
            return function(e) {
                if (Array.isArray(e)) return Lv(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return Lv(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Lv(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Vv(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Wv() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Wv = function() {
                return !!e;
            })();
        }
        Rv([
            To
        ], Av.prototype, "createRange", null), Rv([
            To
        ], Av.prototype, "focus", null), Rv([
            To
        ], Av.prototype, "setCursorAfter", null), Rv([
            To
        ], Av.prototype, "setCursorBefore", null), Rv([
            To
        ], Av.prototype, "setCursorIn", null);
        var Uv, Yv = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Vv(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Kv = "data-jodit-default-style-display", Gv = "data-jodit-default-classes", Jv = Uv = function(e) {
            function t(e, o) {
                var n;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = Nv(t), Hv(e, Wv() ? Reflect.construct(t, o || [], Nv(e).constructor) : t.apply(e, o));
                }(this, t, [
                    o,
                    !0
                ])).isJodit = !0, n.commands = new Map, n.__selectionLocked = null, n.__wasReadOnly = !1, n.editorIsActive = !1, n.__mode = Qt, n.__callChangeCount = 0, n.__isSilentChange = !1, n.__elementToPlace = new Map;
                try {
                    var r = oi(e, n.o.shadowRoot || n.od);
                    if (Uv.isJoditAssigned(r)) return Hv(n, r.component);
                } catch (e) {
                    if (!ft) throw e;
                    throw n.destruct(), e;
                }
                return n.setStatus(Io.beforeInit), n.id = er(oi(e, n.o.shadowRoot || n.od), "id") || (new Date).getTime().toString(), Ra[n.id] = n, n.attachEvents(o), n.e.on(n.ow, "resize", function() {
                    n.e && n.e.fire("resize");
                }), n.e.on("prepareWYSIWYGEditor", n.__prepareWYSIWYGEditor), n.selection = new Av(n), pr(n.beforeInitHook(), function() {
                    if (!n.isInDestruct) {
                        n.e.fire("beforeInit", n), Ma.__init(n), n.e.fire("afterPluginSystemInit", n), n.e.on("changePlace", function() {
                            n.setReadOnly(n.o.readonly), n.setDisabled(n.o.disabled);
                        }), n.places.length = 0;
                        var t = n.addPlace(e, o);
                        Ra[n.id] = n, pr(t, function() {
                            n.isInDestruct || (n.e && n.e.fire("afterInit", n), pr(n.afterInitHook()), n.setStatus(Io.ready), n.e.fire("afterConstructor", n));
                        });
                    }
                }), n;
            }
            var o, n, r;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Fv(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "Jodit";
                    }
                },
                {
                    key: "waitForReady",
                    value: function() {
                        var e = this;
                        return this.isReady ? Promise.resolve(this) : this.async.promise(function(t) {
                            e.hookStatus("ready", function() {
                                return t(e);
                            });
                        });
                    }
                },
                {
                    key: "text",
                    get: function() {
                        if (this.editor) return this.editor.innerText || "";
                        var e = this.createInside.div();
                        return e.innerHTML = this.getElementValue(), e.innerText || "";
                    }
                },
                {
                    key: "defaultTimeout",
                    get: function() {
                        return ln(this.o.defaultTimeout) ? this.o.defaultTimeout : rr.defaultOptions.defaultTimeout;
                    }
                },
                {
                    key: "createInside",
                    get: function() {
                        var e = this;
                        return new Su(function() {
                            return e.ed;
                        }, this.o.createAttributes);
                    }
                },
                {
                    key: "__setPlaceField",
                    value: function(e, t) {
                        this.currentPlace || (this.currentPlace = {}, this.places = [
                            this.currentPlace
                        ]), this.currentPlace[e] = t;
                    }
                },
                {
                    key: "element",
                    get: function() {
                        return this.currentPlace.element;
                    }
                },
                {
                    key: "editor",
                    get: function() {
                        return this.currentPlace.editor;
                    },
                    set: function(e) {
                        this.__setPlaceField("editor", e);
                    }
                },
                {
                    key: "container",
                    get: function() {
                        return this.currentPlace.container;
                    },
                    set: function(e) {
                        this.__setPlaceField("container", e);
                    }
                },
                {
                    key: "workplace",
                    get: function() {
                        return this.currentPlace.workplace;
                    }
                },
                {
                    key: "message",
                    get: function() {
                        return this.getMessageModule(this.workplace);
                    }
                },
                {
                    key: "statusbar",
                    get: function() {
                        return this.currentPlace.statusbar;
                    }
                },
                {
                    key: "iframe",
                    get: function() {
                        return this.currentPlace.iframe;
                    },
                    set: function(e) {
                        this.__setPlaceField("iframe", e);
                    }
                },
                {
                    key: "history",
                    get: function() {
                        return this.currentPlace.history;
                    }
                },
                {
                    key: "editorWindow",
                    get: function() {
                        return this.currentPlace.editorWindow;
                    },
                    set: function(e) {
                        this.__setPlaceField("editorWindow", e);
                    }
                },
                {
                    key: "ew",
                    get: function() {
                        return this.editorWindow;
                    }
                },
                {
                    key: "editorDocument",
                    get: function() {
                        return this.currentPlace.editorWindow.document;
                    }
                },
                {
                    key: "ed",
                    get: function() {
                        return this.editorDocument;
                    }
                },
                {
                    key: "options",
                    get: function() {
                        return this.currentPlace.options;
                    },
                    set: function(e) {
                        this.__setPlaceField("options", e);
                    }
                },
                {
                    key: "s",
                    get: function() {
                        return this.selection;
                    }
                },
                {
                    key: "uploader",
                    get: function() {
                        return this.getInstance("Uploader", this.o.uploader);
                    }
                },
                {
                    key: "filebrowser",
                    get: function() {
                        var e = this, t = _r({
                            defaultTimeout: e.defaultTimeout,
                            uploader: e.o.uploader,
                            language: e.o.language,
                            license: e.o.license,
                            theme: e.o.theme,
                            shadowRoot: e.o.shadowRoot,
                            defaultCallback: function(t) {
                                t.files && t.files.length && t.files.forEach(function(o, n) {
                                    var r = t.baseurl + o;
                                    t.isImages && t.isImages[n] ? e.s.insertImage(r, null, e.o.imageDefaultWidth) : e.s.insertNode(e.createInside.fromHTML("<a href='".concat(r, "' title='").concat(r, "'>").concat(r, "</a>")));
                                });
                            }
                        }, this.o.filebrowser);
                        return e.getInstance("FileBrowser", t);
                    }
                },
                {
                    key: "mode",
                    get: function() {
                        return this.__mode;
                    },
                    set: function(e) {
                        this.setMode(e);
                    }
                },
                {
                    key: "getNativeEditorValue",
                    value: function() {
                        var e = this.e.fire("beforeGetNativeEditorValue");
                        return Lo(e) ? e : this.editor ? this.editor.innerHTML : this.getElementValue();
                    }
                },
                {
                    key: "setNativeEditorValue",
                    value: function(e) {
                        var t = {
                            value: e
                        };
                        this.e.fire("beforeSetNativeEditorValue", t) || this.editor && (this.editor.innerHTML = t.value);
                    }
                },
                {
                    key: "value",
                    get: function() {
                        return this.getEditorValue();
                    },
                    set: function(e) {
                        this.setEditorValue(e), this.history.__processChanges();
                    }
                },
                {
                    key: "synchronizeValues",
                    value: function() {
                        this.__imdSynchronizeValues();
                    }
                },
                {
                    key: "__imdSynchronizeValues",
                    value: function() {
                        this.setEditorValue();
                    }
                },
                {
                    key: "getEditorValue",
                    value: function() {
                        var e, t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], o = arguments.length > 1 ? arguments[1] : void 0;
                        if (void 0 !== (e = this.e.fire("beforeGetValueFromEditor", o))) return e;
                        e = this.getNativeEditorValue().replace(_t(), ""), t && (e = e.replace(/<span[^>]+id="jodit-selection_marker_[^>]+><\/span>/g, "")), "<br>" === e && (e = "");
                        var n = {
                            value: e
                        };
                        return this.e.fire("afterGetValueFromEditor", n, o), n.value;
                    }
                },
                {
                    key: "setEditorValue",
                    value: function(e) {
                        var t = this.e.fire("beforeSetValueToEditor", e);
                        if (!1 !== t) {
                            if (Lo(t) && (e = t), this.editor) {
                                if (!Lo(e) && !Bo(e)) throw Fr("value must be string");
                                Bo(e) || this.getNativeEditorValue() === e || this.setNativeEditorValue(e), this.e.fire("postProcessSetEditorValue");
                                var o = this.getElementValue(), n = this.getEditorValue();
                                if (!this.__isSilentChange && o !== n && this.__callChangeCount < fo) {
                                    this.__setElementValue(n), this.__callChangeCount += 1, !ft && this.__callChangeCount > 4 && console.warn("Too many recursive changes", n, o);
                                    try {
                                        this.history.__upTick(), this.e.fire("change", n, o), this.e.fire(this.history, "change", n, o);
                                    } finally{
                                        this.__callChangeCount = 0;
                                    }
                                }
                            } else void 0 !== e && this.__setElementValue(e);
                        }
                    }
                },
                {
                    key: "updateElementValue",
                    value: function() {
                        this.__setElementValue(this.getEditorValue());
                    }
                },
                {
                    key: "getElementValue",
                    value: function() {
                        return void 0 !== this.element.value ? this.element.value : this.element.innerHTML;
                    }
                },
                {
                    key: "__setElementValue",
                    value: function(e) {
                        var t = this;
                        if (!Lo(e)) throw Fr("value must be string");
                        if (this.element !== this.container && e !== this.getElementValue()) {
                            var o = {
                                value: e
                            };
                            pr(this.e.fire("beforeSetElementValue", o), function() {
                                void 0 !== t.element.value ? t.element.value = o.value : t.element.innerHTML = o.value, t.e.fire("afterSetElementValue", o);
                            });
                        }
                    }
                },
                {
                    key: "registerCommand",
                    value: function(e, t, o) {
                        var n = e.toLowerCase(), r = this.commands.get(n);
                        if (void 0 === r && (r = [], this.commands.set(n, r)), r.push(t), !Ro(t)) {
                            var i = this.o.commandToHotkeys[n] || this.o.commandToHotkeys[e] || t.hotkeys;
                            i && this.registerHotkeyToCommand(i, n, null == o ? void 0 : o.stopPropagation);
                        }
                        return this;
                    }
                },
                {
                    key: "registerHotkeyToCommand",
                    value: function(e, t) {
                        var o = this, n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = Ii(e).map(Ui).map(function(e) {
                            return e + ".hotkey";
                        }).join(" ");
                        this.e.off(r).on(r, function(e, r) {
                            return r && (r.shouldStop = null == n || n), o.execCommand(t);
                        });
                    }
                },
                {
                    key: "execCommand",
                    value: function(e, t, o) {
                        for(var n = arguments.length, r = new Array(n > 3 ? n - 3 : 0), i = 3; i < n; i++)r[i - 3] = arguments[i];
                        var a;
                        if (this.s.isFocused() || this.s.focus(), !this.o.readonly || this.o.allowCommandsInReadOnly.includes(e)) {
                            var l, s;
                            if (e = e.toLowerCase(), !1 !== (l = (a = this.e).fire.apply(a, [
                                "beforeCommand".concat(ra(e)),
                                t,
                                o
                            ].concat(qv(r)))) && (l = (s = this.e).fire.apply(s, [
                                "beforeCommand",
                                e,
                                t,
                                o
                            ].concat(qv(r)))), !1 !== l && (l = this.__execCustomCommands.apply(this, [
                                e,
                                t,
                                o
                            ].concat(qv(r)))), !1 !== l) {
                                this.s.focus();
                                try {
                                    l = this.nativeExecCommand(e, t, o);
                                } catch (e) {
                                    if (!ft) throw e;
                                }
                            }
                            return this.e.fire("afterCommand", e, t, o), this.__imdSynchronizeValues(), l;
                        }
                    }
                },
                {
                    key: "nativeExecCommand",
                    value: function(e, t, o) {
                        this.__isSilentChange = !0;
                        try {
                            return this.ed.execCommand(e, t, o);
                        } finally{
                            this.__isSilentChange = !1;
                        }
                    }
                },
                {
                    key: "__execCustomCommands",
                    value: function(e, t, o) {
                        for(var n = this, r = arguments.length, i = new Array(r > 3 ? r - 3 : 0), a = 3; a < r; a++)i[a - 3] = arguments[a];
                        e = e.toLowerCase();
                        var l, s = this.commands.get(e);
                        if (void 0 !== s) return s.forEach(function(r) {
                            var a, s = (a = Ro(r) ? r : r.exec).call.apply(a, [
                                n,
                                e,
                                t,
                                o
                            ].concat(qv(i)));
                            void 0 !== s && (l = s);
                        }), l;
                    }
                },
                {
                    key: "lock",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "any";
                        return !!Dv(Nv(t.prototype), "lock", this).call(this, e) && (this.__selectionLocked = this.s.save(), this.s.clear(), this.editor.classList.add("jodit_lock"), this.e.fire("lock", !0), !0);
                    }
                },
                {
                    key: "unlock",
                    value: function() {
                        return !!Dv(Nv(t.prototype), "unlock", this).call(this) && (this.editor.classList.remove("jodit_lock"), this.__selectionLocked && this.s.restore(), this.e.fire("lock", !1), !0);
                    }
                },
                {
                    key: "getMode",
                    value: function() {
                        return this.mode;
                    }
                },
                {
                    key: "isEditorMode",
                    value: function() {
                        return this.getRealMode() === Qt;
                    }
                },
                {
                    key: "getRealMode",
                    value: function() {
                        if (this.getMode() !== eo) return this.getMode();
                        var e = this.od.activeElement;
                        return e && (e === this.iframe || pi.isOrContains(this.editor, e) || pi.isOrContains(this.toolbar.container, e)) ? Qt : $t;
                    }
                },
                {
                    key: "setMode",
                    value: function(e) {
                        var t = this, o = this.getMode(), n = {
                            mode: parseInt(e.toString(), 10)
                        }, r = [
                            "jodit-wysiwyg_mode",
                            "jodit-source__mode",
                            "jodit_split_mode"
                        ];
                        !1 !== this.e.fire("beforeSetMode", n) && (this.__mode = [
                            $t,
                            Qt,
                            eo
                        ].includes(n.mode) ? n.mode : Qt, this.o.saveModeInStorage && this.storage.set("jodit_default_mode", this.mode), r.forEach(function(e) {
                            t.container.classList.remove(e);
                        }), this.container.classList.add(r[this.mode - 1]), o !== this.getMode() && this.e.fire("afterSetMode"));
                    }
                },
                {
                    key: "toggleMode",
                    value: function() {
                        var e = this.getMode();
                        [
                            $t,
                            Qt,
                            this.o.useSplitMode ? eo : 9
                        ].includes(e + 1) ? e += 1 : e = Qt, this.setMode(e);
                    }
                },
                {
                    key: "setDisabled",
                    value: function(e) {
                        this.o.disabled = e;
                        var t = this.__wasReadOnly;
                        this.setReadOnly(e || t), this.__wasReadOnly = t, this.editor && (this.editor.setAttribute("aria-disabled", e.toString()), this.container.classList.toggle("jodit_disabled", e), this.e.fire("disabled", e));
                    }
                },
                {
                    key: "getDisabled",
                    value: function() {
                        return this.o.disabled;
                    }
                },
                {
                    key: "setReadOnly",
                    value: function(e) {
                        this.__wasReadOnly !== e && (this.__wasReadOnly = e, this.o.readonly = e, e ? this.editor && this.editor.removeAttribute("contenteditable") : this.editor && this.editor.setAttribute("contenteditable", "true"), this.e && this.e.fire("readonly", e));
                    }
                },
                {
                    key: "getReadOnly",
                    value: function() {
                        return this.o.readonly;
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        this.getMode() !== $t && this.s.focus();
                    }
                },
                {
                    key: "isFocused",
                    get: function() {
                        return this.s.isFocused();
                    }
                },
                {
                    key: "beforeInitHook",
                    value: function() {}
                },
                {
                    key: "afterInitHook",
                    value: function() {}
                },
                {
                    key: "initOptions",
                    value: function(e) {
                        this.options = _r(e || {}, rr.defaultOptions);
                    }
                },
                {
                    key: "initOwners",
                    value: function() {
                        this.editorWindow = this.o.ownerWindow, this.ownerWindow = this.o.ownerWindow;
                    }
                },
                {
                    key: "addPlace",
                    value: function(e, t) {
                        var o = this, n = oi(e, this.o.shadowRoot || this.od);
                        this.attachEvents(t), n.attributes && Fo(n.attributes).forEach(function(e) {
                            var n = e.name, r = e.value;
                            void 0 === rr.defaultOptions[n] || t && void 0 !== t[n] || (-1 !== [
                                "readonly",
                                "disabled"
                            ].indexOf(n) && (r = "" === r || "true" === r), /^[0-9]+(\.)?([0-9]+)?$/.test(r.toString()) && (r = Number(r)), o.options[n] = r);
                        });
                        var r = this.c.div("jodit-container");
                        r.classList.add("jodit"), r.classList.add("jodit-container"), r.classList.add("jodit_theme_".concat(this.o.theme || "default")), Xv(this.o.className, r), this.o.containerStyle && Ln(r, this.o.containerStyle);
                        var i = this.o.styleValues;
                        Object.keys(i).forEach(function(e) {
                            var t = En(e);
                            r.style.setProperty("--jd-".concat(t), i[e]);
                        }), r.setAttribute("contenteditable", "false");
                        var a = null;
                        this.o.inline && (-1 === [
                            "TEXTAREA",
                            "INPUT"
                        ].indexOf(n.nodeName) && (r = n, n.setAttribute(Gv, n.className.toString()), a = r.innerHTML, r.innerHTML = ""), r.classList.add("jodit_inline"), r.classList.add("jodit-container")), n !== r && (n.style.display && n.setAttribute(Kv, n.style.display), n.style.display = "none");
                        var l = this.c.div("jodit-workplace", {
                            contenteditable: !1
                        });
                        r.appendChild(l), n.parentNode && n !== r && n.parentNode.insertBefore(r, n), Object.defineProperty(n, "component", {
                            enumerable: !1,
                            configurable: !0,
                            value: this
                        });
                        var s = this.c.div("jodit-wysiwyg", {
                            contenteditable: !0,
                            "aria-disabled": !1,
                            tabindex: this.o.tabIndex
                        });
                        l.appendChild(s);
                        var c = {
                            editor: s,
                            element: n,
                            container: r,
                            workplace: l,
                            statusbar: new hh(this, r),
                            options: this.isReady ? _r(t || {}, rr.defaultOptions) : this.options,
                            history: new lh(this),
                            editorWindow: this.ow
                        };
                        this.__elementToPlace.set(s, c), this.setCurrentPlace(c), this.places.push(c), this.setNativeEditorValue(this.getElementValue());
                        var u = this.__initEditor(a), d = this.options;
                        return pr(u, function() {
                            d.enableDragAndDropFileToEditor && d.uploader && (d.uploader.url || d.uploader.insertImageAsBase64URI) && o.uploader.bind(o.editor), o.__elementToPlace.get(o.editor) || o.__elementToPlace.set(o.editor, c), o.e.fire("afterAddPlace", c);
                        });
                    }
                },
                {
                    key: "addDisclaimer",
                    value: function(e) {
                        this.workplace.appendChild(e);
                    }
                },
                {
                    key: "setCurrentPlace",
                    value: function(e) {
                        this.currentPlace !== e && (this.isEditorMode() || this.setMode(Qt), this.currentPlace = e, this.buildToolbar(), this.isReady && this.e.fire("changePlace", e));
                    }
                },
                {
                    key: "__initEditor",
                    value: function(e) {
                        var t = this;
                        return pr(this.__createEditor(), function() {
                            if (!t.isInDestruct) {
                                if (t.element !== t.container) {
                                    var o = t.getElementValue();
                                    o !== t.getEditorValue() && t.setEditorValue(o);
                                } else null != e && t.setEditorValue(e);
                                var n = t.o.defaultMode;
                                if (t.o.saveModeInStorage) {
                                    var r = t.storage.get("jodit_default_mode");
                                    "string" == typeof r && (n = parseInt(r, 10));
                                }
                                t.setMode(n), t.o.readonly && (t.__wasReadOnly = !1, t.setReadOnly(!0)), t.o.disabled && t.setDisabled(!0);
                                try {
                                    t.ed.execCommand("defaultParagraphSeparator", !1, t.o.enter.toLowerCase());
                                } catch (e) {}
                            }
                        });
                    }
                },
                {
                    key: "__createEditor",
                    value: function() {
                        var e = this, t = this.editor, o = this.e.fire("createEditor", this);
                        return pr(o, function() {
                            e.isInDestruct || ((!1 === o || un(o)) && pi.safeRemove(t), Xv(e.o.editorClassName, e.editor), e.o.style && Ln(e.editor, e.o.style), e.e.on("synchro", function() {
                                e.setEditorValue();
                            }).on("focus", function() {
                                e.editorIsActive = !0;
                            }).on("blur", function() {
                                return e.editorIsActive = !1;
                            }), e.__prepareWYSIWYGEditor(), e.o.triggerChangeEvent && e.e.on("change", e.async.debounce(function() {
                                e.e && e.e.fire(e.element, "change");
                            }, e.defaultTimeout)));
                        });
                    }
                },
                {
                    key: "__prepareWYSIWYGEditor",
                    value: function() {
                        var e = this, t = this.editor;
                        if (this.o.direction) {
                            var o = "rtl" === this.o.direction.toLowerCase() ? "rtl" : "ltr";
                            this.editor.style.direction = o, this.editor.setAttribute("dir", o), this.container.style.direction = o, this.container.setAttribute("dir", o), this.toolbar.setDirection(o);
                        }
                        this.e.on(t, "mousedown touchstart focus", function() {
                            var o = e.__elementToPlace.get(t);
                            o && e.setCurrentPlace(o);
                        }).on(t, "compositionend", this.synchronizeValues).on(t, "selectionchange selectionstart keydown keyup input keypress dblclick mousedown mouseup click copy cut dragstart drop dragover paste resize touchstart touchend focus blur", function(t) {
                            var o, n;
                            if (!e.o.readonly && !e.__isSilentChange && (o = t, (!(null != (n = e.ew.KeyboardEvent) && "undefined" != typeof Symbol && n[Symbol.hasInstance] ? n[Symbol.hasInstance](o) : o instanceof n) || !t.isComposing) && e.e && e.e.fire)) {
                                if (!1 === e.e.fire(t.type, t)) return !1;
                                e.synchronizeValues();
                            }
                        });
                    }
                },
                {
                    key: "fetch",
                    value: function(e, t) {
                        var o = this, n = new _l(function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                                }))), n.forEach(function(t) {
                                    Bv(e, t, o[t]);
                                });
                            }
                            return e;
                        }({
                            url: e
                        }, t), this.o.defaultAjaxOptions), r = function() {
                            o.e.off("beforeDestruct", r), o.progressbar.progress(100).hide(), n.destruct();
                        };
                        this.e.one("beforeDestruct", r), this.progressbar.show().progress(30);
                        var i = n.send();
                        return i.finally(r).catch(function() {
                            return null;
                        }), i;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        var e, o, n = this;
                        if (!this.isInDestruct) {
                            this.setStatus(Io.beforeDestruct), this.__elementToPlace.clear(), null === (e = hi(this, "storage")) || void 0 === e || e.clear(), null === (o = hi(this, "buffer")) || void 0 === o || o.clear(), this.commands.clear(), this.__selectionLocked = null, this.e.off(this.ow, "resize"), this.e.off(this.ow), this.e.off(this.od), this.e.off(this.od.body);
                            var r = this.editor ? this.getEditorValue() : "";
                            this.places.forEach(function(e) {
                                var t = e.container, o = e.workplace, i = e.statusbar, a = e.element, l = e.iframe, s = e.editor, c = e.history;
                                if (a) {
                                    if (a !== t) {
                                        if (a.hasAttribute(Kv)) {
                                            var u = er(a, Kv);
                                            u && (a.style.display = u, a.removeAttribute(Kv));
                                        } else a.style.display = "";
                                    } else a.hasAttribute(Gv) && (a.className = er(a, Gv) || "", a.removeAttribute(Gv));
                                    a.hasAttribute("style") && !er(a, "style") && a.removeAttribute("style"), i.destruct(), n.e.off(t), n.e.off(a), n.e.off(s), pi.safeRemove(o), pi.safeRemove(s), t !== a && pi.safeRemove(t), Object.defineProperty(a, "component", {
                                        enumerable: !1,
                                        configurable: !0,
                                        value: null
                                    }), pi.safeRemove(l), t === a && (a.innerHTML = r), c.destruct();
                                }
                            }), this.places.length = 0, this.currentPlace = {}, delete Ra[this.id], Dv(Nv(t.prototype), "destruct", this).call(this);
                        }
                    }
                }
            ], r = [
                {
                    key: "ready",
                    get: function() {
                        return new Promise(function(e) {
                            qa.on("joditready", e);
                        });
                    }
                },
                {
                    key: "atom",
                    value: function(e) {
                        return ar(e);
                    }
                },
                {
                    key: "make",
                    value: function(e, t) {
                        return new this(e, t);
                    }
                },
                {
                    key: "isJoditAssigned",
                    value: function(e) {
                        return e && nn(e.component) && !e.component.isInDestruct;
                    }
                },
                {
                    key: "defaultOptions",
                    get: function() {
                        return rr.defaultOptions;
                    }
                }
            ], n && Mv(o.prototype, n), r && Mv(o, r), t;
        }(ef);
        function Xv(e, t) {
            e && e.split(/\s+/).forEach(function(e) {
                return t.classList.add(e);
            });
        }
        Jv.fatMode = ht, Jv.plugins = Ma, Jv.modules = Ba, Jv.ns = Ba, Jv.decorators = {}, Jv.constants = i, Jv.instances = Ra, Jv.lang = wo, Jv.core = {
            Plugin: Wp
        }, Yv([
            vi
        ], Jv.prototype, "createInside", null), Yv([
            vi
        ], Jv.prototype, "message", null), Yv([
            vi
        ], Jv.prototype, "s", null), Yv([
            vi
        ], Jv.prototype, "uploader", null), Yv([
            vi
        ], Jv.prototype, "filebrowser", null), Yv([
            el()
        ], Jv.prototype, "synchronizeValues", null), Yv([
            Ca(":internalChange")
        ], Jv.prototype, "updateElementValue", null), Yv([
            To
        ], Jv.prototype, "__prepareWYSIWYGEditor", null), Jv = Uv = Yv([
            nl(mf)
        ], Jv);
        const Zv = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg> ', Qv = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg> ', $v = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg> ', eg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg> ', tg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/> </svg> ', og = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"> <g stroke="none" stroke-width="1"> <path d="M14,1.4 L12.6,0 L7,5.6 L1.4,0 L0,1.4 L5.6,7 L0,12.6 L1.4,14 L7,8.4 L12.6,14 L14,12.6 L8.4,7 L14,1.4 Z"/> </g> </svg> ', ng = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"/> </svg> ', rg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"/> </svg> ', ig = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 10 10"> <path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/> </svg> ', ag = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24" > <circle cx="12" cy="12" r="2.2"/> <circle cx="12" cy="5" r="2.2"/> <circle cx="12" cy="19" r="2.2"/> </svg> ', lg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"/> </svg> ', sg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 512v-472q22 14 36 28l408 408q14 14 28 36h-472zm-128 32q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"/> </svg> ', cg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"/> </svg> ', ug = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"/> </svg> ', dg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg> ', fg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"/></svg> ', pg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 32 32"> <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"/> </svg> ', hg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"/></svg> ', vg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/></svg> ', gg = '<svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg"> <path d="M5.9814 11.8049C5.59087 11.4144 5.59087 10.7812 5.9814 10.3907L10.224 6.14806C10.6146 5.75754 11.2477 5.75754 11.6383 6.14806C12.0288 6.53859 12.0288 7.17175 11.6383 7.56228L7.39561 11.8049C7.00509 12.1954 6.37192 12.1954 5.9814 11.8049Z"/> <path d="M0.707107 12.0208C0.316582 11.6303 0.316582 10.9971 0.707107 10.6066L10.6066 0.707121C10.9971 0.316597 11.6303 0.316596 12.0208 0.707121C12.4113 1.09764 12.4113 1.73081 12.0208 2.12133L2.12132 12.0208C1.7308 12.4114 1.09763 12.4114 0.707107 12.0208Z"/> </svg> ', mg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg> ', bg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"/> </svg> ', yg = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path stroke="null" d="m42.276011,26.302547c0.098397,-0.76605 0.172194,-1.54407 0.172194,-2.33406s-0.073797,-1.56801 -0.172194,-2.33406l5.202718,-3.961917c0.467384,-0.359086 0.602679,-1.005441 0.29519,-1.532101l-4.919828,-8.29489c-0.307489,-0.51469 -0.947067,-0.730142 -1.500548,-0.51469l-6.125186,2.405877c-1.266856,-0.945594 -2.656707,-1.747553 -4.157255,-2.357999l-0.922468,-6.343855c-0.110696,-0.562568 -0.614979,-1.005441 -1.229957,-1.005441l-9.839656,0c-0.614979,0 -1.119261,0.442873 -1.217657,1.005441l-0.922468,6.343855c-1.500548,0.610446 -2.890399,1.400436 -4.157255,2.357999l-6.125186,-2.405877c-0.553481,-0.203482 -1.193058,0 -1.500548,0.51469l-4.919828,8.29489c-0.307489,0.51469 -0.172194,1.161045 0.29519,1.532101l5.190419,3.961917c-0.098397,0.76605 -0.172194,1.54407 -0.172194,2.33406s0.073797,1.56801 0.172194,2.33406l-5.190419,3.961917c-0.467384,0.359086 -0.602679,1.005441 -0.29519,1.532101l4.919828,8.29489c0.307489,0.51469 0.947067,0.730142 1.500548,0.51469l6.125186,-2.405877c1.266856,0.945594 2.656707,1.747553 4.157255,2.357999l0.922468,6.343855c0.098397,0.562568 0.602679,1.005441 1.217657,1.005441l9.839656,0c0.614979,0 1.119261,-0.442873 1.217657,-1.005441l0.922468,-6.343855c1.500548,-0.610446 2.890399,-1.400436 4.157255,-2.357999l6.125186,2.405877c0.553481,0.203482 1.193058,0 1.500548,-0.51469l4.919828,-8.29489c0.307489,-0.51469 0.172194,-1.161045 -0.29519,-1.532101l-5.190419,-3.961917zm-18.277162,6.044617c-4.759934,0 -8.609699,-3.746465 -8.609699,-8.378677s3.849766,-8.378677 8.609699,-8.378677s8.609699,3.746465 8.609699,8.378677s-3.849766,8.378677 -8.609699,8.378677z"/> </svg> ', _g = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"/> </svg> ', jg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/> </svg> ', wg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"/> </svg> ', kg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"/> </svg> ', Sg = {};
        var xg = {};
        xg = {
            ar: {
                "Type something": "\u0625\u0628\u062F\u0623 \u0641\u064A \u0627\u0644\u0643\u062A\u0627\u0628\u0629...",
                "About Jodit": "\u062D\u0648\u0644 \u062C\u0648\u062F\u064A\u062A",
                "Jodit Editor": "\u0645\u062D\u0631\u0631 \u062C\u0648\u062F\u064A\u062A",
                "Jodit User's Guide": "\u062F\u0644\u064A\u0644 \u0645\u0633\u062A\u062E\u062F\u0645 \u062C\u0648\u062F\u064A\u062A",
                "contains detailed help for using": "\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0645\u0633\u0627\u0639\u062F\u0629 \u0645\u0641\u0635\u0644\u0629 \u0644\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
                "For information about the license, please go to our website:": "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0648\u0644 \u0627\u0644\u062A\u0631\u062E\u064A\u0635\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u0645\u0648\u0642\u0639\u0646\u0627:",
                "Buy full version": "\u0634\u0631\u0627\u0621 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "\u062D\u0642\u0648\u0642 \u0627\u0644\u0637\u0628\u0639 \u0648\u0627\u0644\u0646\u0634\u0631 \xa9 XDSoft.net - Chupurnov Valeriy. \u0643\u0644 \u0627\u0644\u062D\u0642\u0648\u0642 \u0645\u062D\u0641\u0648\u0638\u0629.",
                Anchor: "\u0645\u0650\u0631\u0652\u0633\u0627\u0629",
                "Open in new tab": "\u0641\u062A\u062D \u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u062C\u062F\u064A\u062F\u0629",
                "Open in fullsize": "\u0641\u062A\u062D \u0627\u0644\u0645\u062D\u0631\u0631 \u0641\u064A \u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
                "Clear Formatting": "\u0645\u0633\u062D \u0627\u0644\u062A\u0646\u0633\u064A\u0642",
                "Fill color or set the text color": "\u0645\u0644\u0621 \u0627\u0644\u0644\u0648\u0646 \u0623\u0648 \u062A\u0639\u064A\u064A\u0646 \u0644\u0648\u0646 \u0627\u0644\u0646\u0635",
                Redo: "\u0625\u0639\u0627\u062F\u0629",
                Undo: "\u062A\u0631\u0627\u062C\u0639",
                Bold: "\u0639\u0631\u064A\u0636",
                Italic: "\u0645\u0627\u0626\u0644",
                "Insert Unordered List": "\u0625\u062F\u0631\u0627\u062C \u0642\u0627\u0626\u0645\u0629 \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0629",
                "Insert Ordered List": "\u0625\u062F\u0631\u0627\u062C \u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u062A\u0628\u0629",
                "Align Center": "\u0645\u062D\u0627\u0630\u0627\u0629 \u0644\u0644\u0648\u0633\u0637",
                "Align Justify": "\u0645\u062D\u0627\u0630\u0627\u0629 \u0645\u062B\u0628\u062A\u0629",
                "Align Left": "\u0645\u062D\u0627\u0630\u0627\u0629 \u0644\u0644\u064A\u0633\u0627\u0631",
                "Align Right": "\u0645\u062D\u0627\u0630\u0627\u0629 \u0644\u0644\u064A\u0645\u064A\u0646",
                "Insert Horizontal Line": "\u0625\u062F\u0631\u0627\u062C \u062E\u0637 \u0623\u0641\u0642\u064A",
                "Insert Image": "\u0625\u062F\u0631\u0627\u062C \u0635\u0648\u0631\u0629",
                "Insert file": "\u0627\u062F\u062E\u0627\u0644 \u0627\u0644\u0645\u0644\u0641",
                "Insert youtube/vimeo video": "\u0625\u062F\u0631\u0627\u062C \u0641\u064A\u062F\u064A\u0648 \u064A\u0648\u062A\u064A\u0648\u0628/\u0641\u064A\u0645\u064A\u0648 ",
                "Insert link": "\u0625\u062F\u0631\u0627\u062C \u0631\u0627\u0628\u0637",
                "Font size": "\u062D\u062C\u0645 \u0627\u0644\u062E\u0637",
                "Font family": "\u0646\u0648\u0639 \u0627\u0644\u062E\u0637",
                "Insert format block": "\u0625\u062F\u0631\u0627\u062C \u0643\u062A\u0644\u0629 \u062A\u0646\u0633\u064A\u0642",
                Normal: "\u0639\u0627\u062F\u064A",
                "Heading 1": "\u0639\u0646\u0648\u0627\u0646 1",
                "Heading 2": "\u0639\u0646\u0648\u0627\u0646 2",
                "Heading 3": "\u0639\u0646\u0648\u0627\u0646 3",
                "Heading 4": "\u0639\u0646\u0648\u0627\u0646 4",
                Quote: "\u0625\u0642\u062A\u0628\u0627\u0633",
                Code: "\u0643\u0648\u062F",
                Insert: "\u0625\u062F\u0631\u0627\u062C",
                "Insert table": "\u0625\u062F\u0631\u0627\u062C \u062C\u062F\u0648\u0644",
                "Decrease Indent": "\u062A\u0642\u0644\u064A\u0644 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                "Increase Indent": "\u0632\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                "Select Special Character": "\u062A\u062D\u062F\u064A\u062F \u0623\u062D\u0631\u0641 \u062E\u0627\u0635\u0629",
                "Insert Special Character": "\u0625\u062F\u0631\u0627\u062C \u062D\u0631\u0641 \u062E\u0627\u0635",
                "Paint format": "\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0631\u0633\u0645",
                "Change mode": "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0648\u0636\u0639",
                Margins: "\u0647\u0648\u0627\u0645\u0634",
                top: "\u0623\u0639\u0644\u0649",
                right: "\u064A\u0645\u064A\u0646",
                bottom: "\u0623\u0633\u0641\u0644",
                left: "\u064A\u0633\u0627\u0631",
                Styles: "\u0627\u0644\u0623\u0646\u0645\u0627\u0637",
                Classes: "\u0627\u0644\u0637\u0628\u0642\u0627\u062A",
                Align: "\u0645\u062D\u0627\u0630\u0627\u0629",
                Right: "\u0627\u0644\u064A\u0645\u064A\u0646",
                Center: "\u0627\u0644\u0648\u0633\u0637",
                Left: "\u0627\u0644\u064A\u0633\u0627\u0631",
                "--Not Set--": "--\u063A\u064A\u0631 \u0645\u0636\u0628\u0648\u0637--",
                Src: "Src",
                Title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
                Alternative: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u062F\u064A\u0644",
                Link: "\u0627\u0644\u0631\u0627\u0628\u0637",
                "Open link in new tab": "\u0627\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u062C\u062F\u064A\u062F\u0629",
                Image: "\u0627\u0644\u0635\u0648\u0631\u0629",
                file: "\u0645\u0644\u0641",
                Advanced: "\u0645\u062A\u0642\u062F\u0645",
                "Image properties": "\u062E\u0635\u0627\u0626\u0635 \u0627\u0644\u0635\u0648\u0631\u0629",
                Cancel: "\u0625\u0644\u063A\u0627\u0621",
                Ok: "\u062D\u0633\u0646\u0627",
                "File Browser": "\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
                "Error on load list": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0641\u064A \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 ",
                "Error on load folders": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0641\u064A \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
                "Are you sure?": "\u0647\u0644 \u0623\u0646\u062A \u0648\u0627\u062B\u0642\u061F",
                "Enter Directory name": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F",
                "Create directory": "\u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0644\u062F",
                "type name": "\u0623\u0643\u062A\u0628 \u0625\u0633\u0645",
                "Drop image": "\u0625\u0633\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
                "Drop file": "\u0625\u0633\u0642\u0627\u0637 \u0627\u0644\u0645\u0644\u0641",
                "or click": "\u0623\u0648 \u0623\u0646\u0642\u0631",
                "Alternative text": "\u0627\u0644\u0646\u0635 \u0627\u0644\u0628\u062F\u064A\u0644",
                Upload: "\u0631\u0641\u0639",
                Browse: "\u062A\u0635\u0641\u062D",
                Background: "\u0627\u0644\u062E\u0644\u0641\u064A\u0629",
                Text: "\u0646\u0635",
                Top: "\u0623\u0639\u0644\u0649",
                Middle: "\u0627\u0644\u0648\u0633\u0637",
                Bottom: "\u0627\u0644\u0623\u0633\u0641\u0644",
                "Insert column before": "\u0625\u062F\u0631\u0627\u062C \u0639\u0645\u0648\u062F \u0642\u0628\u0644",
                "Insert column after": "\u0625\u062F\u0631\u0627\u062C \u0639\u0645\u0648\u062F \u0628\u0639\u062F",
                "Insert row above": "\u0625\u062F\u0631\u0627\u062C \u0635\u0641 \u0623\u0639\u0644\u0649",
                "Insert row below": "\u0625\u062F\u0631\u0627\u062C \u0635\u0641 \u0623\u0633\u0641\u0644",
                "Delete table": "\u062D\u0630\u0641 \u0627\u0644\u062C\u062F\u0648\u0644",
                "Delete row": "\u062D\u0630\u0641 \u0627\u0644\u0635\u0641",
                "Delete column": "\u062D\u0630\u0641 \u0627\u0644\u0639\u0645\u0648\u062F",
                "Empty cell": "\u062E\u0644\u064A\u0629 \u0641\u0627\u0631\u063A\u0629",
                "Chars: %d": "%d \u062D\u0631\u0641",
                "Words: %d": "%d \u0643\u0644\u0627\u0645",
                "Strike through": "\u0627\u0636\u0631\u0628 \u0645\u0646 \u062E\u0644\u0627\u0644",
                Underline: "\u0623\u0643\u062F",
                superscript: "\u062D\u0631\u0641 \u0641\u0648\u0642\u064A",
                subscript: "\u0645\u062E\u0637\u0648\u0637\u0629",
                "Cut selection": "\u0642\u0637\u0639 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631",
                "Select all": "\u0627\u062E\u062A\u0631 \u0627\u0644\u0643\u0644",
                Break: "\u0627\u0633\u062A\u0631\u0627\u062D\u0629",
                "Search for": "\u0627\u0644\u0628\u062D\u062B \u0639\u0646",
                "Replace with": "\u0627\u0633\u062A\u0628\u062F\u0644 \u0628",
                Replace: "\u0645\u062D\u0644",
                Paste: "\u0645\u0639\u062C\u0648\u0646",
                "Choose Content to Paste": "\u0627\u062E\u062A\u0631 \u0645\u062D\u062A\u0648\u0649 \u0644\u0644\u0635\u0642",
                source: "\u0645\u0635\u062F\u0631",
                bold: "\u0628\u0627\u0644\u062E\u0637 \u0627\u0644\u0639\u0631\u064A\u0636",
                italic: "\u0645\u0627\u0626\u0644",
                brush: "\u0634\u063A\u0644",
                link: "\u0635\u0644\u0629",
                undo: "\u0625\u0644\u063A\u0627\u0621",
                redo: "\u0643\u0631\u0631",
                table: "\u0637\u0627\u0648\u0644\u0629",
                image: "\u0635\u0648\u0631\u0629",
                eraser: "\u0646\u0638\u064A\u0641",
                paragraph: "\u0641\u0642\u0631\u0629",
                fontsize: "\u062D\u062C\u0645 \u0627\u0644\u062E\u0637",
                video: "\u0641\u064A\u062F\u064A\u0648",
                font: "\u0627\u0644\u062E\u0637",
                about: "\u062D\u0648\u0644 \u0627\u0644\u0645\u062D\u0631\u0631",
                print: "\u0637\u0628\u0627\u0639\u0629",
                underline: "\u0623\u0643\u062F",
                strikethrough: "\u0634\u0637\u0628",
                indent: "\u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                outdent: "\u0646\u062A\u0648\u0621",
                fullsize: "\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629",
                shrink: "\u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u062A\u0642\u0644\u064A\u062F\u064A",
                hr: "\u0627\u0644\u062E\u0637",
                ul: "\u0642\u0627\u0626\u0645\u0629",
                ol: "\u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u0642\u0645\u0629",
                cut: "\u0642\u0637\u0639",
                selectall: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0643\u0644",
                "Embed code": "\u0642\u0627\u0646\u0648\u0646",
                "Open link": "\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637",
                "Edit link": "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0627\u0628\u0637",
                "No follow": "\u0633\u0645\u0629 Nofollow",
                Unlink: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0631\u0627\u0628\u0637",
                Update: "\u062A\u062D\u062F\u064A\u062B",
                pencil: "\u0644\u062A\u062D\u0631\u064A\u0631",
                Eye: "\u0645\u0631\u0627\u062C\u0639\u0629",
                " URL": "URL",
                Edit: "\u062A\u062D\u0631\u064A\u0631",
                "Horizontal align": "\u0645\u062D\u0627\u0630\u0627\u0629 \u0623\u0641\u0642\u064A\u0629",
                Filter: "\u0641\u0644\u062A\u0631",
                "Sort by changed": "\u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u062A\u063A\u064A\u064A\u0631",
                "Sort by name": "\u0628\u0627\u0644\u0627\u0633\u0645",
                "Sort by size": "\u062D\u0633\u0628 \u0627\u0644\u062D\u062C\u0645",
                "Add folder": "\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F",
                Reset: "\u0625\u0639\u0627\u062F\u0629",
                Save: "\u0627\u062D\u062A\u0641\u0638",
                "Save as ...": "\u062D\u0641\u0638 \u0628\u0627\u0633\u0645",
                Resize: "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u062C\u0645",
                Crop: "\u062D\u062C\u0645 \u0627\u0644\u0642\u0637\u0639",
                Width: "\u0639\u0631\u0636",
                Height: "\u0627\u0631\u062A\u0641\u0627\u0639",
                "Keep Aspect Ratio": "\u062D\u0627\u0641\u0638 \u0639\u0644\u0649 \u0627\u0644\u0646\u0633\u0628",
                Yes: "\u0623\u0646",
                No: "\u0644\u0627",
                Remove: "\u062D\u0630\u0641",
                Select: "\u062A\u0645\u064A\u0632",
                "Select %s": "\u062A\u0645\u064A\u0632 %s",
                "Vertical align": "\u0645\u062D\u0627\u0630\u0627\u0629 \u0639\u0645\u0648\u062F\u064A\u0629",
                Split: "\u0627\u0646\u0634\u0642\u060C \u0645\u0632\u0642",
                Merge: "\u0627\u0630\u0647\u0628",
                "Add column": "\u0623\u0636\u0641 \u0627\u0644\u0639\u0645\u0648\u062F",
                "Add row": "\u0627\u0636\u0641 \u0633\u0637\u0631",
                "License: %s": "\u0631\u062E\u0635\u0629 %s",
                Delete: "\u062D\u0630\u0641",
                "Split vertical": "\u0627\u0646\u0642\u0633\u0627\u0645 \u0639\u0645\u0648\u062F\u064A",
                "Split horizontal": "\u062A\u0642\u0633\u064A\u0645 \u0623\u0641\u0642\u064A",
                Border: "\u0627\u0644\u062D\u062F\u0648\u062F",
                "Your code is similar to HTML. Keep as HTML?": "\u064A\u0634\u0628\u0647 \u0627\u0644\u0643\u0648\u062F \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 HTML. \u062A\u0628\u0642\u064A \u0643\u0645\u0627 HTML\u061F",
                "Paste as HTML": "\u0627\u0644\u0635\u0642 \u0643 HTML",
                Keep: "\u0627\u062D\u062A\u0641\u0638",
                "Insert as Text": "\u0625\u062F\u0631\u0627\u062C \u0643\u0646\u0635",
                "Insert only Text": "\u0625\u062F\u0631\u0627\u062C \u0627\u0644\u0646\u0635 \u0641\u0642\u0637",
                "You can only edit your own images. Download this image on the host?": "\u064A\u0645\u0643\u0646\u0643 \u0641\u0642\u0637 \u062A\u062D\u0631\u064A\u0631 \u0635\u0648\u0631\u0643 \u0627\u0644\u062E\u0627\u0635\u0629. \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0636\u064A\u0641\u061F",
                "The image has been successfully uploaded to the host!": "\u062A\u0645 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629 \u0628\u0646\u062C\u0627\u062D \u0639\u0644\u0649 \u0627\u0644\u062E\u0627\u062F\u0645!",
                palette: "\u0644\u0648\u062D\u0629",
                "There are no files": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062F\u0644\u064A\u0644.",
                Rename: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629",
                "Enter new name": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u062C\u062F\u064A\u062F",
                preview: "\u0645\u0639\u0627\u064A\u0646\u0629",
                download: "\u062A\u062D\u0645\u064A\u0644",
                "Paste from clipboard": "\u0644\u0635\u0642 \u0645\u0646 \u0627\u0644\u062D\u0627\u0641\u0638\u0629",
                "Your browser doesn't support direct access to the clipboard.": "\u0645\u062A\u0635\u0641\u062D\u0643 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629.",
                "Copy selection": "\u0646\u0633\u062E \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
                copy: "\u0646\u0633\u062E",
                "Border radius": "\u062F\u0627\u0626\u0631\u0629 \u0646\u0635\u0641 \u0642\u0637\u0631\u0647\u0627 \u0627\u0644\u062D\u062F\u0648\u062F",
                "Show all": "\u0639\u0631\u0636 \u0643\u0644",
                Apply: "\u062A\u0637\u0628\u064A\u0642",
                "Please fill out this field": "\u064A\u0631\u062C\u0649 \u0645\u0644\u0621 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0627\u0644",
                "Please enter a web address": "\u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 \u0648\u064A\u0628",
                Default: "\u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
                Circle: "\u062F\u0627\u0626\u0631\u0629",
                Dot: "\u0646\u0642\u0637\u0629",
                Quadrate: "\u0627\u0644\u0645\u0631\u0628\u0639\u0629",
                Find: "\u0627\u0644\u0628\u062D\u062B",
                "Find Previous": "\u062A\u062C\u062F \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
                "Find Next": "\u062A\u062C\u062F \u0627\u0644\u062A\u0627\u0644\u064A",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u0644\u0644\u0635\u0642 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0642\u0627\u062F\u0645 \u0645\u0646 Microsoft Word/Excel \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0647\u0644 \u062A\u0631\u064A\u062F \u0623\u0646 \u062A\u0628\u0642\u064A \u0634\u0643\u0644 \u0623\u0648 \u062A\u0646\u0638\u064A\u0641\u0647 \u061F ",
                "Word Paste Detected": "\u0643\u0644\u0645\u0629 \u0644\u0635\u0642 \u0627\u0644\u0643\u0634\u0641 \u0639\u0646",
                Clean: "\u0646\u0638\u064A\u0641\u0629",
                "Insert className": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0641\u0635\u0644",
                "Press Alt for custom resizing": "\u0627\u0636\u063A\u0637 \u0627\u0644\u0628\u062F\u064A\u0644 \u0644\u062A\u063A\u064A\u064A\u0631 \u062D\u062C\u0645 \u0645\u062E\u0635\u0635",
                "Line height": "\u0627\u0631\u062A\u0641\u0627\u0639 \u0627\u0644\u062E\u0637",
                spellcheck: "\u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u0625\u0645\u0644\u0627\u0626\u064A",
                "Speech Recognize": "\u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0643\u0644\u0627\u0645"
            },
            cs_cz: {
                "Type something": "Napi\u0161 n\u011Bco",
                "About Jodit": "O Jodit",
                "Jodit Editor": "Editor Jodit",
                "Free Non-commercial Version": "Verze pro nekomer\u010Dn\xed pou\u017Eit\xed",
                "Jodit User's Guide": "Jodit U\u017Eivatelsk\xe1 p\u0159\xedru\u010Dka",
                "contains detailed help for using": "obsahuje detailn\xed n\xe1pov\u011Bdu",
                "For information about the license, please go to our website:": "Pro informace o licenci, pros\xedm, p\u0159ejd\u011Bte na na\u0161i str\xe1nku:",
                "Buy full version": "Koupit plnou verzi",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. V\u0161echna pr\xe1va vyhrazena.",
                Anchor: "Anchor",
                "Open in new tab": "Otev\u0159\xedt v nov\xe9 z\xe1lo\u017Ece",
                "Open in fullsize": "Otev\u0159\xedt v celoobrazovkov\xe9m re\u017Eimu",
                "Clear Formatting": "Vy\u010Distit form\xe1tov\xe1n\xed",
                "Fill color or set the text color": "Barva v\xfdpln\u011B a p\xedsma",
                Redo: "Vp\u0159ed",
                Undo: "Zp\u011Bt",
                Bold: "Tu\u010Dn\xe9",
                Italic: "Kurz\xedva",
                "Insert Unordered List": "Odr\xe1\u017Eky",
                "Insert Ordered List": "\u010C\xedslovan\xfd seznam",
                "Align Center": "Zarovnat na st\u0159ed",
                "Align Justify": "Zarovnat do bloku",
                "Align Left": "Zarovnat vlevo",
                "Align Right": "Zarovnat vpravo",
                "Insert Horizontal Line": "Vlo\u017Eit horizont\xe1ln\xed linku",
                "Insert Image": "Vlo\u017Eit obr\xe1zek",
                "Insert file": "Vlo\u017Eit soubor",
                "Insert youtube/vimeo video": "Vlo\u017Eit video (YT/Vimeo)",
                "Insert link": "Vlo\u017Eit odkaz",
                "Font size": "Velikost p\xedsma",
                "Font family": "Typ p\xedsma",
                "Insert format block": "Form\xe1tovat blok",
                Normal: "Norm\xe1ln\xed text",
                "Heading 1": "Nadpis 1",
                "Heading 2": "Nadpis 2",
                "Heading 3": "Nadpis 3",
                "Heading 4": "Nadpis 4",
                Quote: "Cit\xe1t",
                Code: "K\xf3d",
                Insert: "Vlo\u017Eit",
                "Insert table": "Vlo\u017Eit tabulku",
                "Decrease Indent": "Zmen\u0161it odsazen\xed",
                "Increase Indent": "Zv\u011Bt\u0161it odsazen\xed",
                "Select Special Character": "Vybrat speci\xe1ln\xed symbol",
                "Insert Special Character": "Vlo\u017Eit speci\xe1ln\xed symbol",
                "Paint format": "Pou\u017E\xedt form\xe1t",
                "Change mode": "Zm\u011Bnit m\xf3d",
                Margins: "Okraje",
                top: "horn\xed",
                right: "prav\xfd",
                bottom: "spodn\xed",
                left: "lev\xfd",
                Styles: "Styly",
                Classes: "T\u0159\xeddy",
                Align: "Zarovn\xe1n\xed",
                Right: "Vpravo",
                Center: "Na st\u0159ed",
                Left: "Vlevo",
                "--Not Set--": "--nenastaveno--",
                Src: "src",
                Title: "Titulek",
                Alternative: "Alternativn\xed text (alt)",
                Link: "Link",
                "Open link in new tab": "Otev\u0159\xedt link v nov\xe9 z\xe1lo\u017Ece",
                Image: "Obr\xe1zek",
                file: "soubor",
                Advanced: "Roz\u0161\xed\u0159en\xe9",
                "Image properties": "Vlastnosti obr\xe1zku",
                Cancel: "Zp\u011Bt",
                Ok: "Ok",
                "Your code is similar to HTML. Keep as HTML?": "V\xe1\u0161 text se podob\xe1 HTML. Vlo\u017Eit ho jako HTML?",
                "Paste as HTML": "Vlo\u017Eit jako HTML",
                Keep: "Ponechat origin\xe1l",
                Clean: "Vy\u010Distit",
                "Insert as Text": "Vlo\u017Eit jako TEXT",
                "Insert only Text": "Vlo\u017Eit pouze TEXT",
                "Word Paste Detected": "Detekov\xe1n fragment z Wordu nebo Excelu",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Obsah, kter\xfd vkl\xe1d\xe1te, je pravd\u011Bpodobn\u011B z Microsoft Word / Excel. Chcete ponechat form\xe1t nebo vlo\u017Eit pouze text?",
                "File Browser": "Prohl\xed\u017Ee\u010D soubor\u016F",
                "Error on load list": "Chyba p\u0159i na\u010D\xedt\xe1n\xed seznamu soubor\u016F",
                "Error on load folders": "Chyba p\u0159i na\u010D\xedt\xe1n\xed slo\u017Eek",
                "Are you sure?": "Jste si jist\xfd(\xe1)?",
                "Enter Directory name": "N\xe1zev slo\u017Eky",
                "Create directory": "Vytvo\u0159it slo\u017Eku",
                "type name": "n\xe1zev",
                "Drop image": "P\u0159et\xe1hn\u011Bte sem obr\xe1zek",
                "Drop file": "P\u0159et\xe1hn\u011Bte sem soubor",
                "or click": "nebo klikn\u011Bte",
                "Alternative text": "Alternativn\xed text",
                Browse: "Server",
                Upload: "Nahr\xe1t",
                Background: "Pozad\xed",
                Text: "Text",
                Top: "Nahoru",
                Middle: "Na st\u0159ed",
                Bottom: "Dolu",
                "Insert column before": "Vlo\u017Eit sloupec p\u0159ed",
                "Insert column after": "Vlo\u017Eit sloupec za",
                "Insert row above": "Vlo\u017Eit \u0159\xe1dek nad",
                "Insert row below": "Vlo\u017Eit \u0159\xe1dek pod",
                "Delete table": "Vymazat tabulku",
                "Delete row": "Vymazat \u0159\xe1dku",
                "Delete column": "Vymazat sloupec",
                "Empty cell": "Vy\u010Distit bu\u0148ku",
                source: "HTML",
                bold: "tu\u010Dn\u011B",
                italic: "kurz\xedva",
                brush: "\u0161t\u011Btec",
                link: "odkaz",
                undo: "zp\u011Bt",
                redo: "vp\u0159ed",
                table: "tabulka",
                image: "obr\xe1zek",
                eraser: "guma",
                paragraph: "odstavec",
                fontsize: "velikost p\xedsma",
                video: "video",
                font: "p\xedsmo",
                about: "\u043E editoru",
                print: "tisk",
                underline: "podtr\u017Eeno",
                strikethrough: "p\u0159e\u0161krtnuto",
                indent: "zv\u011Bt\u0161it odsazen\xed",
                outdent: "zmen\u0161it odsazen\xed",
                fullsize: "celoobrazovkov\xfd re\u017Eim",
                shrink: "smrsknout",
                hr: "Linka",
                ul: "Odr\xe1\u017Eka",
                ol: "\u010C\xedslovan\xfd seznam",
                cut: "Vyjmout",
                selectall: "Ozna\u010Dit v\u0161e",
                "Embed code": "K\xf3d",
                "Open link": "Otev\u0159\xedt odkaz",
                "Edit link": "Upravit odkaz",
                "No follow": "Atribut no-follow",
                Unlink: "Odstranit odkaz",
                Eye: "Zobrazit",
                pencil: "Chcete-li upravit",
                Update: "Aktualizovat",
                " URL": "URL",
                Edit: "Editovat",
                "Horizontal align": "Horizont\xe1ln\xed zarovn\xe1n\xed",
                Filter: "Filtr",
                "Sort by changed": "Dle posledn\xed zm\u011Bny",
                "Sort by name": "Dle n\xe1zvu",
                "Sort by size": "Dle velikosti",
                "Add folder": "P\u0159idat slo\u017Eku",
                Reset: "Reset",
                Save: "Ulo\u017Eit",
                "Save as ...": "Ulo\u017Eit jako...",
                Resize: "Zm\u011Bnit rozm\u011Br",
                Crop: "O\u0159ezat",
                Width: "\u0160\xed\u0159ka",
                Height: "V\xfd\u0161ka",
                "Keep Aspect Ratio": "Ponechat pom\u011Br",
                Yes: "Ano",
                No: "Ne",
                Remove: "Vyjmout",
                Select: "Ozna\u010Dit",
                "Chars: %d": "Znaky: %d",
                "Words: %d": "Slova: %d",
                All: "V\u0161e",
                "Select %s": "Ozna\u010Dit %s",
                "Select all": "Ozna\u010Dit v\u0161e",
                "Vertical align": "Vertik\xe1ln\xed zarovn\xe1n\xed",
                Split: "Rozd\u011Blit",
                "Split vertical": "Rozd\u011Blit vertik\xe1ln\u011B",
                "Split horizontal": "Rozd\u011Blit horizont\xe1ln\u011B",
                Merge: "Spojit",
                "Add column": "P\u0159idat sloupec",
                "Add row": "P\u0159idat \u0159\xe1dek",
                Delete: "Vymazat",
                Border: "Okraj",
                "License: %s": "Licence: %s",
                "Strike through": "P\u0159e\u0161krtnuto",
                Underline: "Podtr\u017Eeno",
                superscript: "Horn\xed index",
                subscript: "Doln\xed index",
                "Cut selection": "Vyjmout ozna\u010Den\xe9",
                Break: "Zalomen\xed",
                "Search for": "Najdi",
                "Replace with": "Nahradit za",
                Replace: "Vym\u011B\u0148te",
                Paste: "Vlo\u017Eit",
                "Choose Content to Paste": "Vyber obsah pro vlo\u017Een\xed",
                "You can only edit your own images. Download this image on the host?": "M\u016F\u017Eete upravovat pouze sv\xe9 obr\xe1zky. Na\u010D\xedst obr\xe1zek?",
                "The image has been successfully uploaded to the host!": "Obr\xe1zek byl \xfasp\u011B\u0161n\u011B nahr\xe1n!",
                palette: "paleta",
                "There are no files": "V tomto adres\xe1\u0159i nejsou \u017E\xe1dn\xe9 soubory.",
                Rename: "p\u0159ejmenovat",
                "Enter new name": "Zadejte nov\xfd n\xe1zev",
                preview: "n\xe1hled",
                download: "Sta\u017Een\xed",
                "Paste from clipboard": "Vlo\u017Eit ze schr\xe1nky",
                "Your browser doesn't support direct access to the clipboard.": "V\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje p\u0159\xedm\xfd p\u0159\xedstup do schr\xe1nky.",
                "Copy selection": "Kop\xedrovat v\xfdb\u011Br",
                copy: "kop\xedrov\xe1n\xed",
                "Border radius": "Border radius",
                "Show all": "Zobrazit v\u0161echny",
                Apply: "Plat\xed",
                "Please fill out this field": "Pros\xedm, vypl\u0148te toto pole",
                "Please enter a web address": "Pros\xedm, zadejte webovou adresu",
                Default: "V\xfdchoz\xed",
                Circle: "Kruh",
                Dot: "Dot",
                Quadrate: "Quadrate",
                Find: "Naj\xedt",
                "Find Previous": "Naj\xedt P\u0159edchoz\xed",
                "Find Next": "Naj\xedt Dal\u0161\xed",
                "Insert className": "Vlo\u017Ete n\xe1zev t\u0159\xeddy",
                "Press Alt for custom resizing": "Stiskn\u011Bte Alt pro vlastn\xed zm\u011Bnu velikosti"
            },
            de: {
                "Type something": "Bitte geben Sie einen Text ein",
                Advanced: "Fortgeschritten",
                "About Jodit": "\xdcber Jodit",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Das Jodit Benutzerhandbuch",
                "contains detailed help for using": "beinhaltet ausf\xfchrliche Informationen wie Sie den Editor verwenden k\xf6nnen.",
                "For information about the license, please go to our website:": "F\xfcr Informationen zur Lizenz, besuchen Sie bitte unsere Web-Pr\xe4senz:",
                "Buy full version": "Vollversion kaufen",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.",
                Anchor: "Anker",
                "Open in new tab": "In neuer Registerkarte \xf6ffnen",
                "Open in fullsize": "Editor in voller Gr\xf6\xdfe \xf6ffnen",
                "Clear Formatting": "Formatierung l\xf6schen",
                "Fill color or set the text color": "F\xfcllfarbe oder Textfarbe \xe4ndern",
                Redo: "Wiederholen",
                Undo: "R\xfcckg\xe4ngig machen",
                Bold: "Fett",
                Italic: "Kursiv",
                "Insert Unordered List": "Unsortierte Liste einf\xfcgen",
                "Insert Ordered List": "Nummerierte Liste einf\xfcgen",
                "Align Center": "Mittig ausrichten",
                "Align Justify": "Blocksatz",
                "Align Left": "Links ausrichten",
                "Align Right": "Rechts ausrichten",
                "Insert Horizontal Line": "Horizontale Linie einf\xfcgen",
                "Insert Image": "Bild einf\xfcgen",
                "Insert file": "Datei einf\xfcgen",
                "Insert youtube/vimeo video": "Youtube/vimeo Video einf\xfcgen",
                "Insert link": "Link einf\xfcgen",
                "Font size": "Schriftgr\xf6\xdfe",
                "Font family": "Schriftfamilie",
                "Insert format block": "Formatblock einf\xfcgen",
                Normal: "Normal",
                "Heading 1": "\xdcberschrift 1",
                "Heading 2": "\xdcberschrift 2",
                "Heading 3": "\xdcberschrift 3",
                "Heading 4": "\xdcberschrift 4",
                Quote: "Zitat",
                Code: "Code",
                Insert: "Einf\xfcgen",
                "Insert table": "Tabelle einf\xfcgen",
                "Decrease Indent": "Einzug verkleinern",
                "Increase Indent": "Einzug vergr\xf6\xdfern",
                "Select Special Character": "Sonderzeichen ausw\xe4hlen",
                "Insert Special Character": "Sonderzeichen einf\xfcgen",
                "Paint format": "Format kopieren",
                "Change mode": "\xc4nderungsmodus",
                Margins: "R\xe4nder",
                top: "Oben",
                right: "Rechts",
                bottom: "Unten",
                left: "Links",
                Styles: "CSS Stil",
                Classes: "CSS Klassen",
                Align: "Ausrichtung",
                Right: "Rechts",
                Center: "Zentriert",
                Left: "Links",
                "--Not Set--": "Keine",
                Src: "Pfad",
                Title: "Titel",
                Alternative: "Alternativer Text",
                Link: "Link",
                "Open link in new tab": "Link in neuem Tab \xf6ffnen",
                Image: "Bild",
                file: "Datei",
                "Image properties": "Bildeigenschaften",
                Cancel: "Abbrechen",
                Ok: "OK",
                "Your code is similar to HTML. Keep as HTML?": "Ihr Text \xe4hnelt HTML-Code. Als HTML beibehalten?",
                "Paste as HTML": "Als HTML einf\xfcgen?",
                Keep: "Original speichern",
                Clean: "S\xe4ubern",
                "Insert as Text": "Als Text einf\xfcgen",
                "Word Paste Detected": "In Word formatierter Text erkannt",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Der Inhalt, den Sie einf\xfcgen, stammt aus einem Microsoft Word / Excel-Dokument. M\xf6chten Sie das Format erhalten oder bereinigen?",
                "Insert only Text": "Nur Text einf\xfcgen",
                "File Browser": "Dateibrowser",
                "Error on load list": "Fehler beim Laden der Liste",
                "Error on load folders": "Fehler beim Laden der Ordner",
                "Are you sure?": "Sind Sie sicher?",
                "Enter Directory name": "Geben Sie den Verzeichnisnamen ein",
                "Create directory": "Verzeichnis erstellen",
                "type name": "Typname",
                "Drop image": "Bild hier hinziehen",
                "Drop file": "Datei l\xf6schen",
                "or click": "oder hier klicken",
                "Alternative text": "Alternativtext",
                Browse: "Ausw\xe4hlen",
                Upload: "Hochladen",
                Background: "Hintergrund",
                Text: "Text",
                Top: "Oben",
                Middle: "Mittig",
                Bottom: "Unten",
                "Insert column before": "Spalte davor einf\xfcgen",
                "Insert column after": "Spalte danach einf\xfcgen",
                "Insert row above": "Zeile oberhalb einf\xfcgen",
                "Insert row below": "Zeile unterhalb einf\xfcgen",
                "Delete table": "Tabelle l\xf6schen",
                "Delete row": "Zeile l\xf6schen",
                "Delete column": "Spalte l\xf6schen",
                "Empty cell": "Zelle leeren",
                Delete: "L\xf6schen",
                "Strike through": "Durchstreichen",
                Underline: "Unterstreichen",
                Break: "Pause",
                "Search for": "Suche nach",
                "Replace with": "Ersetzen durch",
                Replace: "Ersetzen",
                Edit: "Bearbeiten",
                "Vertical align": "Vertikale Ausrichtung",
                "Horizontal align": "Horizontale Ausrichtung",
                Filter: "Filter",
                "Sort by changed": "Sortieren nach ge\xe4ndert",
                "Sort by name": "Nach Name sortieren",
                "Sort by size": "Nach Gr\xf6\xdfe sortiert",
                "Add folder": "Ordner hinzuf\xfcgen",
                "Split vertical": "Vertikal unterteilen",
                "Split horizontal": "Horizontal unterteilen",
                Split: "Unterteilen",
                Merge: "Vereinen",
                "Add column": "Spalte hinzuf\xfcgen",
                "Add row": "Zeile hinzuf\xfcgen",
                Border: "Rand",
                "Embed code": "Code einbetten",
                Update: "Aktualisieren",
                superscript: "Hochstellen",
                subscript: "Tiefstellen",
                "Cut selection": "Auswahl ausschneiden",
                Paste: "Einf\xfcgen",
                "Choose Content to Paste": "W\xe4hlen Sie den Inhalt zum Einf\xfcgen aus",
                "Chars: %d": "Zeichen: %d",
                "Words: %d": "W\xf6rter: %d",
                All: "Alles markieren",
                "Select %s": "Markieren: %s",
                "Select all": "Alles markieren",
                source: "HTML",
                bold: "Fett gedruckt",
                italic: "Kursiv",
                brush: "B\xfcrste",
                link: "Verkn\xfcpfung",
                undo: "R\xfcckg\xe4ngig machen",
                redo: "Wiederholen",
                table: "Tabelle",
                image: "Bild",
                eraser: "Radiergummi",
                paragraph: "Absatz",
                fontsize: "Schriftgr\xf6\xdfe",
                video: "Video",
                font: "Schriftart",
                about: "\xdcber",
                print: "Drucken",
                underline: "Unterstreichen",
                strikethrough: "Durchstreichen",
                indent: "Einzug",
                outdent: "Herausstellen",
                fullsize: "Vollgr\xf6\xdfe",
                shrink: "Schrumpfen",
                hr: "die Linie",
                ul: "Liste von",
                ol: "Nummerierte Liste",
                "Lower Alpha": "Standard, Alphabet (klein)",
                "Upper Alpha": "Standard, Alphabet (gross)",
                "Lower Roman": "R\xf6misch (klein)",
                "Upper Roman": "R\xf6misch (gross)",
                "Lower Greek": "Griechisch",
                cut: "Schneiden",
                selectall: "W\xe4hlen Sie Alle aus",
                "Open link": "Link \xf6ffnen",
                "Edit link": "Link bearbeiten",
                "No follow": "Nofollow-Attribut",
                Unlink: "Link entfernen",
                Eye: "Ansehen",
                pencil: "Bearbeiten",
                " URL": "URL",
                Reset: "Wiederherstellen",
                Save: "Speichern",
                "Save as ...": "Speichern als",
                Resize: "Gr\xf6\xdfe \xe4ndern",
                Crop: "Gr\xf6\xdfe anpassen",
                Width: "Breite",
                Height: "H\xf6he",
                "Keep Aspect Ratio": "Seitenverh\xe4ltnis beibehalten",
                Yes: "Ja",
                No: "Nein",
                Remove: "Entfernen",
                Select: "Markieren",
                "You can only edit your own images. Download this image on the host?": "Sie k\xf6nnen nur Ihre eigenen Bilder bearbeiten. Dieses Bild auf den Host herunterladen?",
                "The image has been successfully uploaded to the host!": "Das Bild wurde erfolgreich auf den Server hochgeladen!",
                palette: "Palette",
                "There are no files": "In diesem Verzeichnis befinden sich keine Dateien.",
                Rename: "Umbenennen",
                "Enter new name": "Geben Sie einen neuen Namen ein",
                preview: "Vorschau",
                download: "Herunterladen",
                "Paste from clipboard": "Aus Zwischenablage einf\xfcgen",
                "Your browser doesn't support direct access to the clipboard.": "Ihr Browser unterst\xfctzt keinen direkten Zugriff auf die Zwischenablage.",
                "Copy selection": "Auswahl kopieren",
                copy: "Kopieren",
                "Border radius": "Radius f\xfcr abgerundete Ecken",
                "Show all": "Alle anzeigen",
                Apply: "Anwenden",
                "Please fill out this field": "Bitte f\xfcllen Sie dieses Feld aus",
                "Please enter a web address": "Bitte geben Sie eine Web-Adresse ein",
                Default: "Standard",
                Circle: "Kreis",
                Dot: "Punkte",
                Quadrate: "Quadrate",
                Find: "Suchen",
                "Find Previous": "Suche vorherige",
                "Find Next": "Weitersuchen",
                "Insert className": "className (CSS) einf\xfcgen",
                "Press Alt for custom resizing": "Dr\xfccken Sie Alt f\xfcr benutzerdefinierte Gr\xf6\xdfenanpassung"
            },
            en: {
                "Type something": "Start writing...",
                pencil: "Edit",
                Quadrate: "Square"
            },
            es: {
                "Type something": "Escriba algo...",
                Advanced: "Avanzado",
                "About Jodit": "Acerca de Jodit",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Gu\xeda de usuario Jodit",
                "contains detailed help for using": "contiene ayuda detallada para el uso.",
                "For information about the license, please go to our website:": "Para informaci\xf3n sobre la licencia, por favor visite nuestro sitio:",
                "Buy full version": "Compre la versi\xf3n completa",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.",
                Anchor: "Anclar",
                "Open in new tab": "Abrir en nueva pesta\xf1a",
                "Open in fullsize": "Abrir editor en pantalla completa",
                "Clear Formatting": "Limpiar formato",
                "Fill color or set the text color": "Color de relleno o de letra",
                Redo: "Rehacer",
                Undo: "Deshacer",
                Bold: "Negrita",
                Italic: "Cursiva",
                "Insert Unordered List": "Insertar lista no ordenada",
                "Insert Ordered List": "Insertar lista ordenada",
                "Align Center": "Alinear Centrado",
                "Align Justify": "Alinear Justificado",
                "Align Left": "Alinear Izquierda",
                "Align Right": "Alinear Derecha",
                "Insert Horizontal Line": "Insertar l\xednea horizontal",
                "Insert Image": "Insertar imagen",
                "Insert file": "Insertar archivo",
                "Insert youtube/vimeo video": "Insertar video de Youtube/vimeo",
                "Insert link": "Insertar v\xednculo",
                "Font size": "Tama\xf1o de letra",
                "Font family": "Familia de letra",
                "Insert format block": "Insertar bloque",
                Normal: "Normal",
                "Heading 1": "Encabezado 1",
                "Heading 2": "Encabezado 2",
                "Heading 3": "Encabezado 3",
                "Heading 4": "Encabezado 4",
                Quote: "Cita",
                Code: "C\xf3digo",
                Insert: "Insertar",
                "Insert table": "Insertar tabla",
                "Decrease Indent": "Disminuir sangr\xeda",
                "Increase Indent": "Aumentar sangr\xeda",
                "Select Special Character": "Seleccionar caracter especial",
                "Insert Special Character": "Insertar caracter especial",
                "Paint format": "Copiar formato",
                "Change mode": "Cambiar modo",
                Margins: "M\xe1rgenes",
                top: "arriba",
                right: "derecha",
                bottom: "abajo",
                left: "izquierda",
                Styles: "Estilos CSS",
                Classes: "Clases CSS",
                Align: "Alinear",
                Right: "Derecha",
                Center: "Centrado",
                Left: "Izquierda",
                "--Not Set--": "--No Establecido--",
                Src: "Fuente",
                Title: "T\xedtulo",
                Alternative: "Texto Alternativo",
                Filter: "Filtrar",
                Link: "V\xednculo",
                "Open link in new tab": "Abrir v\xednculo en nueva pesta\xf1a",
                Image: "Imagen",
                file: "Archivo",
                "Image properties": "Propiedades de imagen",
                Cancel: "Cancelar",
                Ok: "Aceptar",
                "Your code is similar to HTML. Keep as HTML?": "El c\xf3digo es similar a HTML. \xbfMantener como HTML?",
                "Paste as HTML": "Pegar como HTML?",
                Keep: "Mantener",
                Clean: "Limpiar",
                "Insert as Text": "Insertar como texto",
                "Word Paste Detected": "Pegado desde Word detectado",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "El contenido pegado proviene de un documento de Microsoft Word/Excel. \xbfDesea mantener el formato o limpiarlo?",
                "Insert only Text": "Insertar solo texto",
                "File Browser": "Buscar archivo",
                "Error on load list": "Error al cargar la lista",
                "Error on load folders": "Error al cargar las carpetas",
                "Are you sure?": "\xbfEst\xe1 seguro?",
                "Enter Directory name": "Entre nombre de carpeta",
                "Create directory": "Crear carpeta",
                "type name": "Entre el nombre",
                "Drop image": "Soltar imagen",
                "Drop file": "Soltar archivo",
                "or click": "o click",
                "Alternative text": "Texto alternativo",
                Browse: "Buscar",
                Upload: "Subir",
                Background: "Fondo",
                Text: "Texto",
                Top: "Arriba",
                Middle: "Centro",
                Bottom: "Abajo",
                "Insert column before": "Insertar columna antes",
                "Insert column after": "Interar columna despu\xe9s",
                "Insert row above": "Insertar fila arriba",
                "Insert row below": "Insertar fila debajo",
                "Delete table": "Borrar tabla",
                "Delete row": "Borrar fila",
                "Delete column": "Borrar columna",
                "Empty cell": "Vaciar celda",
                Delete: "Borrar",
                "Strike through": "Tachado",
                Underline: "Subrayado",
                Break: "Pausa",
                "Search for": "Buscar",
                "Replace with": "Reemplazar con",
                Replace: "Reemplazar",
                Edit: "Editar",
                "Vertical align": "Alineaci\xf3n vertical",
                "Horizontal align": "Alineaci\xf3n horizontal",
                "Sort by changed": "Ordenar por fecha modificaci\xf3n",
                "Sort by name": "Ordenar por nombre",
                "Sort by size": "Ordenar por tama\xf1o",
                "Add folder": "Agregar carpeta",
                Split: "Dividir",
                "Split vertical": "Dividir vertical",
                "Split horizontal": "Dividir horizontal",
                Merge: "Mezclar",
                "Add column": "Agregar columna",
                "Add row": "Agregar fila",
                Border: "Borde",
                "Embed code": "Incluir c\xf3digo",
                Update: "Actualizar",
                superscript: "super\xedndice",
                subscript: "sub\xedndice",
                "Cut selection": "Cortar selecci\xf3n",
                Paste: "Pegar",
                "Choose Content to Paste": "Seleccionar contenido para pegar",
                "Chars: %d": "Caracteres: %d",
                "Words: %d": "Palabras: %d",
                All: "Todo",
                "Select %s": "Seleccionar: %s",
                "Select all": "Seleccionar todo",
                source: "HTML",
                bold: "negrita",
                italic: "cursiva",
                brush: "Brocha",
                link: "V\xednculo",
                undo: "deshacer",
                redo: "rehacer",
                table: "Tabla",
                image: "Imagen",
                eraser: "Borrar",
                paragraph: "P\xe1rrafo",
                fontsize: "Tama\xf1o de letra",
                video: "Video",
                font: "Letra",
                about: "Acerca de",
                print: "Imprimir",
                underline: "subrayar",
                strikethrough: "tachar",
                indent: "sangr\xeda",
                outdent: "quitar sangr\xeda",
                fullsize: "Tama\xf1o completo",
                shrink: "encoger",
                hr: "l\xednea horizontal",
                ul: "lista sin ordenar",
                ol: "lista ordenada",
                cut: "Cortar",
                selectall: "Seleccionar todo",
                "Open link": "Abrir v\xednculo",
                "Edit link": "Editar v\xednculo",
                "No follow": "No seguir",
                Unlink: "Desvincular",
                Eye: "Ver",
                pencil: "Para editar",
                " URL": "URL",
                Reset: "Resetear",
                Save: "Guardar",
                "Save as ...": "Guardar como...",
                Resize: "Redimensionar",
                Crop: "Recortar",
                Width: "Ancho",
                Height: "Alto",
                "Keep Aspect Ratio": "Mantener relaci\xf3n de aspecto",
                Yes: "Si",
                No: "No",
                Remove: "Quitar",
                Select: "Seleccionar",
                "You can only edit your own images. Download this image on the host?": "Solo puedes editar tus propias im\xe1genes. \xbfDescargar esta imagen en el servidor?",
                "The image has been successfully uploaded to the host!": "\xa1La imagen se ha subido correctamente al servidor!",
                palette: "paleta",
                "There are no files": "No hay archivos en este directorio.",
                Rename: "renombrar",
                "Enter new name": "Ingresa un nuevo nombre",
                preview: "avance",
                download: "Descargar",
                "Paste from clipboard": "Pegar desde el portapapeles",
                "Your browser doesn't support direct access to the clipboard.": "Su navegador no soporta el acceso directo en el portapapeles.",
                "Copy selection": "Selecci\xf3n de copia",
                copy: "copia",
                "Border radius": "Radio frontera",
                "Show all": "Mostrar todos los",
                Apply: "Aplicar",
                "Please fill out this field": "Por favor, rellene este campo",
                "Please enter a web address": "Por favor, introduzca una direcci\xf3n web",
                Default: "Predeterminado",
                Circle: "C\xedrculo",
                Dot: "Punto",
                Quadrate: "Cuadro",
                "Lower Alpha": "Letra Min\xfascula",
                "Lower Greek": "Griego Min\xfascula",
                "Lower Roman": "Romano Min\xfascula",
                "Upper Alpha": "Letra May\xfascula",
                "Upper Roman": "Romano May\xfascula",
                Find: "Encontrar",
                "Find Previous": "Buscar Anterior",
                "Find Next": "Buscar Siguiente",
                "Insert className": "Insertar nombre de clase",
                "Press Alt for custom resizing": "Presione Alt para cambiar el tama\xf1o personalizado"
            },
            fi: {
                "Type something": "Kirjoita jotain...",
                Advanced: "Avanzado",
                "About Jodit": "Tietoja Jodit:ista",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Jodit k\xe4ytt\xe4j\xe4n ohje",
                "contains detailed help for using": "sis\xe4lt\xe4\xe4 tarkempaa tietoa k\xe4ytt\xe4miseen",
                "For information about the license, please go to our website:": "Tietoa lisensoinnista, vieraile verkkosivuillamme:",
                "Buy full version": "Osta t\xe4ysi versio",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Kaikki oikeudet pid\xe4tet\xe4\xe4n.",
                Anchor: "Ankkuri",
                "Open in new tab": "Avaa uudessa v\xe4lilehdess\xe4",
                "Open in fullsize": "Avaa t\xe4ysikokoisena",
                "Clear Formatting": "Poista muotoilu",
                "Fill color or set the text color": "T\xe4yt\xe4 v\xe4rill\xe4 tai aseta tekstin v\xe4ri",
                Redo: "Tee uudelleen",
                Undo: "Peruuta",
                Bold: "Lihavoitu",
                Italic: "Kursiivi",
                "Insert Unordered List": "Lis\xe4\xe4 j\xe4rjest\xe4m\xe4t\xf6n lista",
                "Insert Ordered List": "Lis\xe4\xe4 j\xe4rjestetty lista",
                "Align Center": "Asemoi keskelle",
                "Align Justify": "Asemoi tasav\xe4lein",
                "Align Left": "Asemoi vasemmalle",
                "Align Right": "Asemoi oikealle",
                "Insert Horizontal Line": "Lis\xe4\xe4 vaakasuuntainen viiva",
                "Insert Image": "Lis\xe4\xe4 kuva",
                "Insert file": "Lis\xe4\xe4 tiedosto",
                "Insert youtube/vimeo video": "Lis\xe4\xe4 Youtube-/vimeo- video",
                "Insert link": "Lis\xe4\xe4 linkki",
                "Font size": "Kirjasimen koko",
                "Font family": "Kirjasimen nimi",
                "Insert format block": "Lis\xe4\xe4 muotoilualue",
                Normal: "Normaali",
                "Heading 1": "Otsikko 1",
                "Heading 2": "Otsikko 2",
                "Heading 3": "Otsikko 3",
                "Heading 4": "Otsikko 4",
                Quote: "Lainaus",
                Code: "Koodi",
                Insert: "Lis\xe4\xe4",
                "Insert table": "Lis\xe4\xe4 taulukko",
                "Decrease Indent": "Pienenn\xe4 sisennyst\xe4",
                "Increase Indent": "Lis\xe4\xe4 sisennyst\xe4",
                "Select Special Character": "Valitse erikoismerkki",
                "Insert Special Character": "Lis\xe4\xe4 erikoismerkki",
                "Paint format": "Maalaa muotoilu",
                "Change mode": "Vaihda tilaa",
                Margins: "Marginaalit",
                top: "yl\xf6s",
                right: "oikealle",
                bottom: "alas",
                left: "vasemmalle",
                Styles: "CSS-tyylit",
                Classes: "CSS-luokat",
                Align: "Asemointi",
                Right: "Oikea",
                Center: "Keskell\xe4",
                Left: "Vasen",
                "--Not Set--": "--Ei asetettu--",
                Src: "Fuente",
                Title: "Otsikko",
                Alternative: "Vaihtoehtoinen teksti",
                Filter: "Suodatin",
                Link: "Linkki",
                "Open link in new tab": "Avaa uudessa v\xe4lilehdess\xe4",
                Image: "Kuva",
                file: "Tiedosto",
                "Image properties": "Kuvan ominaisuudet",
                Cancel: "Peruuta",
                Ok: "Ok",
                "Your code is similar to HTML. Keep as HTML?": "Koodi on HTML:n tapaista. S\xe4ilytet\xe4\xe4nk\xf6 HTML?",
                "Paste as HTML": "Liit\xe4 HTML:n\xe4?",
                Keep: "S\xe4ilyt\xe4",
                Clean: "Tyhjenn\xe4",
                "Insert as Text": "Lis\xe4\xe4 tekstin\xe4",
                "Word Paste Detected": "Word liitt\xe4minen havaittu",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Liitetty sis\xe4lt\xf6 tulee Microsoft Word-/Excel- tiedostosta. Haluatko s\xe4ilytt\xe4\xe4 muotoilun vai poistaa sen?",
                "Insert only Text": "Lis\xe4\xe4 vain teksti",
                "File Browser": "Tiedostoselain",
                "Error on load list": "Virhe listan latauksessa",
                "Error on load folders": "Virhe kansioiden latauksessa",
                "Are you sure?": "Oletko varma?",
                "Enter Directory name": "Sy\xf6t\xe4 hakemiston nimi",
                "Create directory": "Luo hakemisto",
                "type name": "Sy\xf6t\xe4 nimi",
                "Drop image": "Pudota kuva",
                "Drop file": "Pudota tiedosto",
                "or click": "tai klikkaa",
                "Alternative text": "Vaihtoehtoinen teksti",
                Browse: "Selaa",
                Upload: "Lataa",
                Background: "Tausta",
                Text: "Teksti",
                Top: "Yl\xf6s",
                Middle: "Keskelle",
                Bottom: "Alas",
                "Insert column before": "Lis\xe4\xe4 sarake ennen",
                "Insert column after": "Lis\xe4\xe4 sarake j\xe4lkeen",
                "Insert row above": "Lis\xe4\xe4 rivi yl\xf6s",
                "Insert row below": "Lis\xe4\xe4 rivi alle",
                "Delete table": "Poista taulukko",
                "Delete row": "Poista rivi",
                "Delete column": "Poista sarake",
                "Empty cell": "Tyhjenn\xe4 solu",
                Delete: "Poista",
                "Strike through": "Yliviivaus",
                Underline: "Alleviivaus",
                Break: "Vaihto",
                "Search for": "Etsi arvoa",
                "Replace with": "Korvaa arvolla",
                Replace: "Korvaa",
                Edit: "Muokkaa",
                "Vertical align": "Pystyasemointi",
                "Horizontal align": "Vaaka-asemointi",
                "Sort by changed": "J\xe4rjest\xe4 muuttuneilla",
                "Sort by name": "J\xe4rjest\xe4 nimell\xe4",
                "Sort by size": "J\xe4rjest\xe4 koolla",
                "Add folder": "Lis\xe4\xe4 kansio",
                Split: "Jaa",
                "Split vertical": "Jaa pystysuuntaisesti",
                "Split horizontal": "Jaa vaakasuuntaisesti",
                Merge: "Yhdist\xe4",
                "Add column": "Lis\xe4\xe4 sarake",
                "Add row": "Lis\xe4\xe4 rivi",
                Border: "Reuna",
                "Embed code": "Sis\xe4llyt\xe4 koodi",
                Update: "P\xe4ivit\xe4",
                superscript: "yl\xe4viite",
                subscript: "alaviite",
                "Cut selection": "Leikkaa valinta",
                Paste: "Liit\xe4",
                "Choose Content to Paste": "Valitse liitett\xe4v\xe4 sis\xe4lt\xf6",
                "Chars: %d": "Merkit: %d",
                "Words: %d": "Sanat: %d",
                All: "Kaikki",
                "Select %s": "Valitse: %s",
                "Select all": "Valitse kaikki",
                source: "HTML",
                bold: "lihavoitu",
                italic: "kursiivi",
                brush: "sivellin",
                link: "linkki",
                undo: "peruuta",
                redo: "tee uudelleen",
                table: "taulukko",
                image: "kuva",
                eraser: "pyyhekumi",
                paragraph: "kappale",
                fontsize: "tekstin koko",
                video: "video",
                font: "kirjasin",
                about: "tietoja",
                print: "tulosta",
                underline: "alleviivaa",
                strikethrough: "yliviivaa",
                indent: "sisenn\xe4",
                outdent: "pienenn\xe4 sisennyst\xe4",
                fullsize: "t\xe4ysikokoinen",
                shrink: "pienenn\xe4",
                hr: "vaakaviiva",
                ul: "j\xe4rjestetty lista",
                ol: "j\xe4rjest\xe4m\xe4t\xf6n lista",
                cut: "leikkaa",
                selectall: "valitse kaikki",
                "Open link": "Avaa linkki",
                "Edit link": "Muokkaa linkki\xe4",
                "No follow": "\xc4l\xe4 seuraa",
                Unlink: "Pura linkki",
                Eye: "Ver",
                pencil: "Muokkaa",
                " URL": "URL",
                Reset: "Nollaa",
                Save: "Tallenna",
                "Save as ...": "Tallenna nimell\xe4 ...",
                Resize: "Muuta kokoa",
                Crop: "Rajaa",
                Width: "Leveys",
                Height: "Korkeus",
                "Keep Aspect Ratio": "S\xe4ilyt\xe4 kuvasuhde",
                Yes: "Kyll\xe4",
                No: "Ei",
                Remove: "Poista",
                Select: "Valitse",
                "You can only edit your own images. Download this image on the host?": "Voit muokata vain omia kuvia. Lataa t\xe4m\xe4 kuva palvelimelle?",
                "The image has been successfully uploaded to the host!": "Kuva on onnistuneesti ladattu palvelimelle!",
                palette: "paletti",
                "There are no files": "Tiedostoja ei ole",
                Rename: "Nime\xe4 uudelleen",
                "Enter new name": "Sy\xf6t\xe4 uusi nimi",
                preview: "esikatselu",
                download: "Lataa",
                "Paste from clipboard": "Liit\xe4 leikep\xf6yd\xe4lt\xe4",
                "Your browser doesn't support direct access to the clipboard.": "Selaimesi ei tue suoraa p\xe4\xe4sy\xe4 leikep\xf6yd\xe4lle.",
                "Copy selection": "Kopioi valinta",
                copy: "kopioi",
                "Border radius": "Reunan py\xf6ristys",
                "Show all": "N\xe4yt\xe4 kaikki",
                Apply: "K\xe4yt\xe4",
                "Please fill out this field": "T\xe4yt\xe4 t\xe4m\xe4 kentt\xe4",
                "Please enter a web address": "Annan web-osoite",
                Default: "Oletus",
                Circle: "Ympyr\xe4",
                Dot: "Piste",
                Quadrate: "Neli\xf6",
                "Lower Alpha": "Pieni aakkosellinen",
                "Lower Greek": "Pieni kreikkalainen",
                "Lower Roman": "Pieni roomalainen",
                "Upper Alpha": "Suuri aakkosellinen",
                "Upper Roman": "Suuri roomalainen",
                Find: "Hae",
                "Find Previous": "Hae edellinen",
                "Find Next": "Hae seuraava",
                "Insert className": "Lis\xe4\xe4 luokkanimi",
                "Press Alt for custom resizing": "Paina Alt muokattuun koon muuttamiseen",
                "Class name": "Luokan nimi"
            },
            fr: {
                "Type something": "Ecrivez ici",
                "About Jodit": "A propos de Jodit",
                "Jodit Editor": "Editeur Jodit",
                "Jodit User's Guide": "Guide de l'utilisateur",
                "contains detailed help for using": "Aide d\xe9taill\xe9e \xe0 l'utilisation",
                "For information about the license, please go to our website:": "Consulter la licence sur notre site web:",
                "Buy full version": "Acheter la version compl\xe8te",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Tous droits r\xe9serv\xe9s.",
                Anchor: "Ancre",
                "Open in new tab": "Ouvrir dans un nouvel onglet",
                "Open in fullsize": "Ouvrir l'\xe9diteur en pleine page",
                "Clear Formatting": "Supprimer le formattage",
                "Fill color or set the text color": "Modifier la couleur du fond ou du texte",
                Redo: "Refaire",
                Undo: "D\xe9faire",
                Bold: "Gras",
                Italic: "Italique",
                "Insert Unordered List": "Liste non ordonn\xe9e",
                "Insert Ordered List": "Liste ordonn\xe9e",
                "Align Center": "Centrer",
                "Align Justify": "Justifier",
                "Align Left": "Aligner \xe0 gauche ",
                "Align Right": "Aligner \xe0 droite",
                "Insert Horizontal Line": "Ins\xe9rer une ligne horizontale",
                "Insert Image": "Ins\xe9rer une image",
                "Insert file": "Ins\xe9rer un fichier",
                "Insert youtube/vimeo video": "Ins\xe9rer une vid\xe9o",
                "Insert link": "Ins\xe9rer un lien",
                "Font size": "Taille des caract\xe8res",
                "Font family": "Famille des caract\xe8res",
                "Insert format block": "Bloc formatt\xe9",
                Normal: "Normal",
                "Heading 1": "Titre 1",
                "Heading 2": "Titre 2",
                "Heading 3": "Titre 3",
                "Heading 4": "Titre 4",
                Quote: "Citation",
                Code: "Code",
                Insert: "Ins\xe9rer",
                "Insert table": "Ins\xe9rer un tableau",
                "Decrease Indent": "Diminuer le retrait",
                "Increase Indent": "Retrait plus",
                "Select Special Character": "S\xe9lectionnez un caract\xe8re sp\xe9cial",
                "Insert Special Character": "Ins\xe9rer un caract\xe8re sp\xe9cial",
                "Paint format": "Cloner le format",
                "Change mode": "Mode wysiwyg <-> code html",
                Margins: "Marges",
                top: "haut",
                right: "droite",
                bottom: "Bas",
                left: "gauche",
                Styles: "Styles",
                Classes: "Classes",
                Align: "Alignement",
                Right: "Droite",
                Center: "Centre",
                Left: "Gauche",
                "--Not Set--": "--Non disponible--",
                Src: "Source",
                Title: "Titre",
                Alternative: "Alternative",
                Filter: "Filtre",
                Link: "Lien",
                "Open link in new tab": "Ouvrir le lien dans un nouvel onglet",
                Image: "Image",
                file: "fichier",
                Advanced: "Avanc\xe9",
                "Image properties": "Propri\xe9t\xe9s de l'image",
                Cancel: "Annuler",
                Ok: "OK",
                "Your code is similar to HTML. Keep as HTML?": "Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?",
                "Paste as HTML": "Coller en HTML?",
                Keep: "Sauvegarder l'original",
                Clean: "Nettoyer",
                "Insert as Text": "Coller en tant que texte",
                "Word Paste Detected": "C'est peut-\xeatre un fragment de Word ou Excel",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Le contenu que vous ins\xe9rez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?",
                "Insert only Text": "Coller le texte seulement",
                "File Browser": "Explorateur de fichiers",
                "Error on load list": "Erreur de liste de chargement",
                "Error on load folders": "Erreur de dossier de chargement",
                "Are you sure?": "Etes-vous s\xfbrs ?",
                "Enter Directory name": "Entrer le nom de dossier",
                "Create directory": "Cr\xe9er un dossier",
                "type name": "type de fichier",
                "Drop image": "Coller une image",
                "Drop file": "D\xe9poser un fichier",
                "or click": "ou cliquer",
                "Alternative text": "Texte de remplacemement",
                Browse: "Chercher",
                Upload: "Charger",
                Background: "Arri\xe8re-plan",
                Border: "Bordure",
                Text: "Texte",
                Top: "Haut",
                Middle: "Milieu",
                Bottom: "Bas",
                "Insert column before": "Ins\xe9rer une colonne avant",
                "Insert column after": "Ins\xe9rer une colonne apr\xe8s",
                "Insert row above": "Ins\xe9rer une ligne au dessus",
                "Insert row below": "Ins\xe9rer une ligne en dessous",
                "Delete table": "Supprimer le tableau",
                "Delete row": "Supprimer la ligne",
                "Delete column": "Supprimer la colonne",
                "Empty cell": "Vider la cellule",
                "Chars: %d": "Symboles: %d",
                "Words: %d": "Mots: %d",
                Split: "Split",
                "Split vertical": "Split vertical",
                "Split horizontal": "Split horizontal",
                "Strike through": "Barrer",
                Underline: "Souligner",
                superscript: "exposant",
                subscript: "indice",
                "Cut selection": "Couper la s\xe9lection",
                "Select all": "Tout s\xe9lectionner",
                Break: "Pause",
                "Search for": "Rechercher",
                "Replace with": "Remplacer par",
                Replace: "Remplacer",
                Paste: "Coller",
                "Choose Content to Paste": "Choisissez le contenu \xe0 coller",
                source: "la source",
                bold: "gras",
                italic: "italique",
                brush: "pinceau",
                link: "lien",
                undo: "annuler",
                redo: "refaire",
                table: "tableau",
                image: "image",
                eraser: "gomme",
                paragraph: "clause",
                fontsize: "taille de police",
                video: "Video",
                font: "police",
                about: "\xe0 propos de l'\xe9diteur",
                print: "impression",
                underline: "soulign\xe9",
                strikethrough: "barr\xe9",
                indent: "indentation",
                outdent: "retrait",
                fullsize: "taille r\xe9elle",
                shrink: "taille conventionnelle",
                hr: "la ligne",
                ul: "Liste",
                ol: "Liste num\xe9rot\xe9e",
                cut: "Couper",
                selectall: "S\xe9lectionner tout",
                "Open link": "Ouvrir le lien",
                "Edit link": "Modifier le lien",
                "No follow": "Attribut Nofollow",
                Unlink: "Supprimer le lien",
                Eye: "Voir",
                pencil: "Pour \xe9diter",
                " URL": "URL",
                Reset: "Restaurer",
                Save: "Sauvegarder",
                "Save as ...": "Enregistrer sous",
                Resize: "Changer la taille",
                Crop: "Taille de garniture",
                Width: "Largeur",
                Height: "Hauteur",
                "Keep Aspect Ratio": "Garder les proportions",
                Yes: "Oui",
                No: "Non",
                Remove: "Supprimer",
                Select: "Mettre en \xe9vidence",
                "Select %s": "Mettre en \xe9vidence: %s",
                Update: "Mettre \xe0 jour",
                "Vertical align": "Alignement vertical",
                Merge: "aller",
                "Add column": "Ajouter une colonne",
                "Add row": "Ajouter une rang\xe9e",
                Delete: "Effacer",
                "Horizontal align": "Alignement horizontal",
                "Sort by changed": "Trier par modification",
                "Sort by name": "Trier par nom",
                "Sort by size": "Trier par taille",
                "Add folder": "Cr\xe9er le dossier",
                "You can only edit your own images. Download this image on the host?": "Vous ne pouvez \xe9diter que vos propres images. T\xe9l\xe9chargez cette image sur l'h\xf4te?",
                "The image has been successfully uploaded to the host!": "L'image a \xe9t\xe9 t\xe9l\xe9charg\xe9e avec succ\xe8s sur le serveur!",
                palette: "Palette",
                "There are no files": "Il n'y a aucun fichier dans ce r\xe9pertoire.",
                Rename: "renommer",
                "Enter new name": "Entrez un nouveau nom",
                preview: "Aper\xe7u",
                download: "T\xe9l\xe9charger",
                "Paste from clipboard": "Coller \xe0 partir du presse-papiers",
                "Your browser doesn't support direct access to the clipboard.": "Votre navigateur ne prend pas en charge l'acc\xe8s direct au presse-papiers.",
                "Copy selection": "Copier la s\xe9lection",
                copy: "copie",
                "Border radius": "Rayon des bordures",
                "Show all": "Afficher tous",
                Apply: "Appliquer",
                "Please fill out this field": "Veuillez remplir ce champ",
                "Please enter a web address": "Veuillez entrer une adresse web",
                Default: "Par d\xe9faut",
                Circle: "Cercle",
                Dot: "Point",
                Quadrate: "Quadratique",
                Find: "Trouver",
                "Find Previous": "Pr\xe9c\xe9dent",
                "Find Next": "Suivant",
                "Insert className": "Ins\xe9rer un nom de classe",
                "Press Alt for custom resizing": "Appuyez sur Alt pour un redimensionnement personnalis\xe9"
            },
            he: {
                "Type something": "\u05D4\u05E7\u05DC\u05D3 \u05DE\u05E9\u05D4\u05D5...",
                Advanced: "\u05DE\u05EA\u05E7\u05D3\u05DD",
                "About Jodit": "About Jodit",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Jodit User's Guide",
                "contains detailed help for using": "contains detailed help for using.",
                "For information about the license, please go to our website:": "For information about the license, please go to our website:",
                "Buy full version": "Buy full version",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                Anchor: "\u05DE\u05E7\u05D5\u05DD \u05E2\u05D9\u05D2\u05D5\u05DF",
                "Open in new tab": "\u05E4\u05EA\u05D7 \u05D1\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D4 \u05D7\u05D3\u05E9\u05D4",
                "Open in fullsize": "\u05E4\u05EA\u05D7 \u05D0\u05EA \u05D4\u05E2\u05D5\u05E8\u05DA \u05D1\u05D7\u05DC\u05D5\u05DF \u05D7\u05D3\u05E9",
                "Clear Formatting": "\u05E0\u05E7\u05D4 \u05E2\u05D9\u05E6\u05D5\u05D1",
                "Fill color or set the text color": "\u05E9\u05E0\u05D4 \u05E6\u05D1\u05E2 \u05D8\u05E7\u05E1\u05D8 \u05D0\u05D5 \u05E8\u05E7\u05E2",
                Redo: "\u05D1\u05E6\u05E2 \u05E9\u05D5\u05D1",
                Undo: "\u05D1\u05D8\u05DC",
                Bold: "\u05DE\u05D5\u05D3\u05D2\u05E9",
                Italic: "\u05E0\u05D8\u05D5\u05D9",
                "Insert Unordered List": "\u05D4\u05DB\u05E0\u05E1 \u05E8\u05E9\u05D9\u05DE\u05EA \u05EA\u05D1\u05DC\u05D9\u05D8\u05D9\u05DD",
                "Insert Ordered List": "\u05D4\u05DB\u05E0\u05E1 \u05E8\u05E9\u05D9\u05DE\u05D4 \u05DE\u05DE\u05D5\u05E1\u05E4\u05E8\u05EA",
                "Align Center": "\u05DE\u05E8\u05DB\u05D6",
                "Align Justify": "\u05D9\u05E9\u05E8 ",
                "Align Left": "\u05D9\u05E9\u05E8 \u05DC\u05E9\u05DE\u05D0\u05DC",
                "Align Right": "\u05D9\u05E9\u05E8 \u05DC\u05D9\u05DE\u05D9\u05DF",
                "Insert Horizontal Line": "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
                "Insert Image": "\u05D4\u05DB\u05E0\u05E1 \u05EA\u05DE\u05D5\u05E0\u05D4",
                "Insert file": "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D5\u05D1\u05E5",
                "Insert youtube/vimeo video": "\u05D4\u05DB\u05E0\u05E1 \u05E1\u05E8\u05D8\u05D5\u05DF \u05D5\u05D9\u05D3\u05D0\u05D5 \u05DEYouTube/Vimeo",
                "Insert link": "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D9\u05E9\u05D5\u05E8",
                "Font size": "\u05D2\u05D5\u05D3\u05DC \u05D2\u05D5\u05E4\u05DF",
                "Font family": "\u05D2\u05D5\u05E4\u05DF",
                "Insert format block": "\u05DE\u05E2\u05D5\u05E6\u05D1 \u05DE\u05E8\u05D0\u05E9",
                Normal: "\u05E8\u05D2\u05D9\u05DC",
                "Heading 1": "\u05DB\u05D5\u05EA\u05E8\u05EA 1",
                "Heading 2": "\u05DB\u05D5\u05EA\u05E8\u05EA 2",
                "Heading 3": "\u05DB\u05D5\u05EA\u05E8\u05EA 3",
                "Heading 4": "\u05DB\u05D5\u05EA\u05E8\u05EA 4",
                Quote: "\u05E6\u05D9\u05D8\u05D5\u05D8",
                Code: "\u05E7\u05D5\u05D3",
                Insert: "\u05D4\u05DB\u05E0\u05E1",
                "Insert table": "\u05D4\u05DB\u05E0\u05E1 \u05D8\u05D1\u05DC\u05D4",
                "Decrease Indent": "\u05D4\u05E7\u05D8\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4",
                "Increase Indent": "\u05D4\u05D2\u05D3\u05DC \u05DB\u05E0\u05D9\u05E1\u05D4",
                "Select Special Character": "\u05D1\u05D7\u05E8 \u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3",
                "Insert Special Character": "\u05D4\u05DB\u05E0\u05E1 \u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3",
                "Paint format": "\u05D4\u05E2\u05EA\u05E7 \u05E2\u05D9\u05E6\u05D5\u05D1",
                "Change mode": "\u05D4\u05D7\u05DC\u05E3 \u05DE\u05E6\u05D1",
                Margins: "\u05E8\u05D9\u05D5\u05D5\u05D7",
                top: "\u05E2\u05DC\u05D9\u05D5\u05DF",
                right: "\u05D9\u05DE\u05D9\u05DF",
                bottom: "\u05EA\u05D7\u05EA\u05D5\u05DF",
                left: "\u05E9\u05DE\u05D0\u05DC",
                Styles: "\u05E2\u05D9\u05E6\u05D5\u05D1 CSS",
                Classes: "\u05DE\u05D7\u05DC\u05E7\u05EA CSS",
                Align: "\u05D9\u05D9\u05E9\u05D5\u05E8",
                Right: "\u05D9\u05DE\u05D9\u05DF",
                Center: "\u05DE\u05E8\u05DB\u05D6",
                Left: "\u05E9\u05DE\u05D0\u05DC",
                "--Not Set--": "--\u05DC\u05D0 \u05E0\u05E7\u05D1\u05E2--",
                Src: "\u05DE\u05E7\u05D5\u05E8",
                Title: "\u05DB\u05D5\u05EA\u05E8\u05EA",
                Alternative: "\u05DB\u05D9\u05EA\u05D5\u05D1 \u05D7\u05DC\u05D5\u05E4\u05D9",
                Link: "\u05E7\u05D9\u05E9\u05D5\u05E8",
                "Open link in new tab": "\u05E4\u05EA\u05D7 \u05D1\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D4 \u05D7\u05D3\u05E9\u05D4",
                Image: "\u05EA\u05DE\u05D5\u05E0\u05D4",
                file: "\u05E7\u05D5\u05D1\u05E5",
                "Image properties": "\u05DE\u05D0\u05E4\u05D9\u05D9\u05E0\u05D9 \u05EA\u05DE\u05D5\u05E0\u05D4",
                Cancel: "\u05D1\u05D9\u05D8\u05D5\u05DC",
                Ok: "\u05D0\u05D9\u05E9\u05D5\u05E8",
                "Your code is similar to HTML. Keep as HTML?": "\u05D4\u05E7\u05D5\u05D3 \u05D3\u05D5\u05DE\u05D4 \u05DCHTML, \u05D4\u05D0\u05DD \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05DBHTML",
                "Paste as HTML": "\u05D4\u05D3\u05D1\u05E7 \u05DBHTML",
                Keep: "\u05D4\u05E9\u05D0\u05E8",
                Clean: "\u05E0\u05E7\u05D4",
                "Insert as Text": "\u05D4\u05DB\u05E0\u05E1 \u05DB\u05D8\u05E7\u05E1\u05D8",
                "Word Paste Detected": '\u05D6\u05D5\u05D4\u05EA\u05D4 \u05D4\u05D3\u05D1\u05E7\u05D4 \u05DE"\u05D5\u05D5\u05E8\u05D3"',
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u05D4\u05EA\u05D5\u05DB\u05DF \u05D4\u05DE\u05D5\u05D3\u05D1\u05E7 \u05DE\u05D2\u05D9\u05E2 \u05DE\u05DE\u05E1\u05DE\u05DA \u05D5\u05D5\u05E8\u05D3/\u05D0\u05E7\u05E1\u05DC. \u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DA \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05D0\u05EA \u05D4\u05E2\u05D9\u05E6\u05D5\u05D1 \u05D0\u05D5 \u05DC\u05E0\u05E7\u05D5\u05EA\u05D5",
                "Insert only Text": "\u05D4\u05DB\u05E0\u05E1 \u05D8\u05E7\u05E1\u05D8 \u05D1\u05DC\u05D1\u05D3",
                "File Browser": "\u05E1\u05D9\u05D9\u05E8 \u05D4\u05E7\u05D1\u05E6\u05D9\u05DD",
                "Error on load list": "\u05E9\u05D2\u05D9\u05D0\u05D4  \u05D1\u05D6\u05DE\u05DF \u05D8\u05E2\u05D9\u05E0\u05EA \u05E8\u05E9\u05D9\u05DE\u05D4",
                "Error on load folders": "\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05D6\u05DE\u05DF \u05D8\u05E2\u05D9\u05E0\u05EA \u05EA\u05E7\u05D9\u05D5\u05EA",
                "Are you sure?": "\u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7?",
                "Enter Directory name": "\u05D4\u05DB\u05E0\u05E1 \u05E9\u05DD \u05EA\u05E7\u05D9\u05D4",
                "Create directory": "\u05E6\u05D5\u05E8 \u05EA\u05E7\u05D9\u05D4",
                "type name": "\u05E1\u05D5\u05D2 \u05D4\u05E7\u05D5\u05D1\u05E5",
                "Drop image": "\u05D4\u05E1\u05E8 \u05EA\u05DE\u05D5\u05E0\u05D4",
                "Drop file": "\u05D4\u05E1\u05E8 \u05E7\u05D5\u05D1\u05E5",
                "or click": "\u05D0\u05D5 \u05DC\u05D7\u05E5",
                "Alternative text": "\u05DB\u05D9\u05EA\u05D5\u05D1 \u05D7\u05DC\u05D5\u05E4\u05D9",
                Browse: "\u05E1\u05D9\u05D9\u05E8",
                Upload: "\u05D4\u05E2\u05DC\u05D4",
                Background: "\u05E8\u05E7\u05E2",
                Text: "\u05D8\u05E7\u05E1\u05D8",
                Top: "\u05E2\u05DC\u05D9\u05D5\u05DF",
                Middle: "\u05DE\u05E8\u05DB\u05D6",
                Bottom: "\u05EA\u05D7\u05EA\u05D5\u05DF",
                "Insert column before": "\u05D4\u05DB\u05E0\u05E1 \u05E2\u05DE\u05D5\u05D3\u05D4 \u05DC\u05E4\u05E0\u05D9",
                "Insert column after": "\u05D4\u05DB\u05E0\u05E1 \u05E2\u05DE\u05D5\u05D3\u05D4 \u05D0\u05D7\u05E8\u05D9",
                "Insert row above": "\u05D4\u05DB\u05E0\u05E1 \u05E9\u05D5\u05E8\u05D4 \u05DE\u05E2\u05DC",
                "Insert row below": "\u05D4\u05DB\u05E0\u05E1 \u05E9\u05D5\u05E8\u05D4 \u05DE\u05EA\u05D7\u05EA",
                "Delete table": "\u05DE\u05D7\u05E7 \u05D8\u05D1\u05DC\u05D4",
                "Delete row": "\u05DE\u05D7\u05E7 \u05E9\u05D5\u05E8\u05D4",
                "Delete column": "\u05DE\u05D7\u05E7 \u05E2\u05DE\u05D5\u05D3\u05D4",
                "Empty cell": "\u05E8\u05D5\u05E7\u05DF \u05EA\u05D0",
                Delete: "\u05DE\u05D7\u05E7",
                "Strike through": "\u05E7\u05D5 \u05D7\u05D5\u05E6\u05D4",
                Underline: "\u05E7\u05D5 \u05EA\u05D7\u05EA\u05D5\u05DF",
                Break: "\u05E9\u05D1\u05D9\u05E8\u05EA \u05E9\u05D5\u05E8\u05D4",
                "Search for": "\u05D7\u05E4\u05E9",
                "Replace with": "\u05D4\u05D7\u05DC\u05E3 \u05D1",
                Replace: "\u05DC\u05D4\u05D7\u05DC\u05D9\u05E3",
                Edit: "\u05E2\u05E8\u05D5\u05DA",
                "Vertical align": "\u05D9\u05D9\u05E9\u05D5\u05E8 \u05D0\u05E0\u05DB\u05D9",
                "Horizontal align": "\u05D9\u05D9\u05E9\u05D5\u05E8 \u05D0\u05D5\u05E4\u05E7\u05D9",
                Filter: "\u05E1\u05E0\u05DF",
                "Sort by changed": "\u05DE\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E9\u05D9\u05E0\u05D5\u05D9",
                "Sort by name": "\u05DE\u05D9\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E9\u05DD",
                "Sort by size": "\u05DE\u05D9\u05D9\u05DF \u05DC\u05E4\u05D9 \u05D2\u05D5\u05D3\u05DC",
                "Add folder": "\u05D4\u05D5\u05E1\u05E3 \u05EA\u05E7\u05D9\u05D9\u05D4",
                Split: "\u05E4\u05D9\u05E6\u05D5\u05DC",
                "Split vertical": "\u05E4\u05D9\u05E6\u05D5\u05DC \u05D0\u05E0\u05DB\u05D9",
                "Split horizontal": "\u05E4\u05D9\u05E6\u05D5\u05DC \u05D0\u05D5\u05E4\u05E7\u05D9",
                Merge: "\u05DE\u05D6\u05D2",
                "Add column": "\u05D4\u05D5\u05E1\u05E3 \u05E2\u05DE\u05D5\u05D3\u05D4",
                "Add row": "\u05D4\u05D5\u05E1\u05E3 \u05E9\u05D5\u05E8\u05D4",
                Border: "\u05DE\u05E1\u05D2\u05E8\u05EA",
                "Embed code": "\u05D4\u05D5\u05E1\u05E3 \u05E7\u05D5\u05D3",
                Update: "\u05E2\u05D3\u05DB\u05DF",
                superscript: "superscript",
                subscript: "subscript",
                "Cut selection": "\u05D2\u05D6\u05D5\u05E8 \u05D1\u05D7\u05D9\u05E8\u05D4",
                Paste: "\u05D4\u05D3\u05D1\u05E7",
                "Choose Content to Paste": "\u05D1\u05D7\u05E8 \u05EA\u05D5\u05DB\u05DF \u05DC\u05D4\u05D3\u05D1\u05E7\u05D4",
                "Chars: %d": "\u05EA\u05D5\u05D5\u05D9\u05DD: %d",
                "Words: %d": "\u05DE\u05D9\u05DC\u05D9\u05DD: %d",
                All: "\u05D4\u05DB\u05DC",
                "Select %s": "\u05E0\u05D1\u05D7\u05E8: %s",
                "Select all": "\u05D1\u05D7\u05E8 \u05D4\u05DB\u05DC",
                source: "HTML",
                bold: "\u05DE\u05D5\u05D3\u05D2\u05E9",
                italic: "\u05E0\u05D8\u05D5\u05D9",
                brush: "\u05DE\u05D1\u05E8\u05E9\u05EA",
                link: "\u05E7\u05D9\u05E9\u05D5\u05E8",
                undo: "\u05D1\u05D8\u05DC",
                redo: "\u05D1\u05E6\u05E2 \u05E9\u05D5\u05D1",
                table: "\u05D8\u05D1\u05DC\u05D4",
                image: "\u05EA\u05DE\u05D5\u05E0\u05D4",
                eraser: "\u05DE\u05D7\u05E7",
                paragraph: "\u05E4\u05E1\u05E7\u05D4",
                fontsize: "\u05D2\u05D5\u05D3\u05DC \u05D2\u05D5\u05E4\u05DF",
                video: "\u05D5\u05D9\u05D3\u05D0\u05D5",
                font: "\u05D2\u05D5\u05E4\u05DF",
                about: "\u05E2\u05DC\u05D9\u05E0\u05D5",
                print: "\u05D4\u05D3\u05E4\u05E1",
                underline: "\u05E7\u05D5 \u05EA\u05D7\u05EA\u05D5\u05DF",
                strikethrough: "\u05E7\u05D5 \u05D7\u05D5\u05E6\u05D4",
                indent: "\u05D4\u05D2\u05D3\u05DC \u05DB\u05E0\u05D9\u05E1\u05D4",
                outdent: "\u05D4\u05E7\u05D8\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4",
                fullsize: "\u05D2\u05D5\u05D3\u05DC \u05DE\u05DC\u05D0",
                shrink: "\u05DB\u05D5\u05D5\u05E5",
                hr: "\u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
                ul: "\u05E8\u05E9\u05D9\u05DE\u05EA \u05EA\u05D1\u05DC\u05D9\u05D8\u05D9\u05DD",
                ol: "\u05E8\u05E9\u05D9\u05DE\u05D4 \u05DE\u05DE\u05D5\u05E1\u05E4\u05E8\u05EA",
                cut: "\u05D7\u05EA\u05D5\u05DA",
                selectall: "\u05D1\u05D7\u05E8 \u05D4\u05DB\u05DC",
                "Open link": "\u05E4\u05EA\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8",
                "Edit link": "\u05E2\u05E8\u05D5\u05DA \u05E7\u05D9\u05E9\u05D5\u05E8",
                "No follow": "\u05DC\u05DC\u05D0 \u05DE\u05E2\u05E7\u05D1",
                Unlink: "\u05D1\u05D8\u05DC \u05E7\u05D9\u05E9\u05D5\u05E8",
                Eye: "\u05D4\u05E6\u05D2",
                pencil: "\u05DB\u05D3\u05D9 \u05DC\u05E2\u05E8\u05D5\u05DA",
                " URL": "\u05DB\u05EA\u05D5\u05D1\u05EA",
                Reset: "\u05D0\u05E4\u05E1",
                Save: "\u05E9\u05DE\u05D5\u05E8",
                "Save as ...": "\u05E9\u05DE\u05D5\u05E8 \u05D1\u05E9\u05DD...",
                Resize: "\u05E9\u05E0\u05D4 \u05D2\u05D5\u05D3\u05DC",
                Crop: "\u05D7\u05EA\u05D5\u05DA",
                Width: "\u05E8\u05D5\u05D7\u05D1",
                Height: "\u05D2\u05D5\u05D1\u05D4",
                "Keep Aspect Ratio": "\u05E9\u05DE\u05D5\u05E8 \u05D9\u05D7\u05E1",
                Yes: "\u05DB\u05DF",
                No: "\u05DC\u05D0",
                Remove: "\u05D4\u05E1\u05E8",
                Select: "\u05D1\u05D7\u05E8",
                "You can only edit your own images. Download this image on the host?": "\u05E8\u05E7 \u05E7\u05D1\u05E6\u05D9\u05DD \u05D4\u05DE\u05E9\u05D5\u05D9\u05D9\u05DB\u05D9\u05DD \u05E9\u05DC\u05DA \u05E0\u05D9\u05EA\u05E0\u05D9\u05DD \u05DC\u05E2\u05E8\u05D9\u05DB\u05D4. \u05D4\u05D0\u05DD \u05DC\u05D4\u05D5\u05E8\u05D9\u05D3 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D1\u05E5?",
                "The image has been successfully uploaded to the host!": "\u05D4\u05EA\u05DE\u05D5\u05E0\u05D4 \u05E2\u05DC\u05EA\u05D4 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4!",
                palette: "\u05DC\u05D5\u05D7",
                "There are no files": "\u05D0\u05D9\u05DF \u05E7\u05D1\u05E6\u05D9\u05DD \u05D1\u05E1\u05E4\u05E8\u05D9\u05D4 \u05D6\u05D5.",
                Rename: "\u05D4\u05D5\u05E0\u05D2\u05E8\u05D9\u05EA",
                "Enter new name": "\u05D4\u05D6\u05DF \u05E9\u05DD \u05D7\u05D3\u05E9",
                preview: "\u05EA\u05E6\u05D5\u05D2\u05D4 \u05DE\u05E7\u05D3\u05D9\u05DE\u05D4",
                download: "\u05D4\u05D5\u05E8\u05D3",
                "Paste from clipboard": "\u05DC\u05D4\u05D3\u05D1\u05D9\u05E7 \u05DE\u05D4\u05DC\u05D5\u05D7",
                "Your browser doesn't support direct access to the clipboard.": "\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA \u05DC\u05D0 \u05EA\u05D5\u05DE\u05DA \u05D2\u05D9\u05E9\u05D4 \u05D9\u05E9\u05D9\u05E8\u05D4 \u05DC\u05DC\u05D5\u05D7.",
                "Copy selection": "\u05D4\u05E2\u05EA\u05E7 \u05D1\u05D7\u05D9\u05E8\u05D4",
                copy: "\u05D4\u05E2\u05EA\u05E7",
                "Border radius": "\u05E8\u05D3\u05D9\u05D5\u05E1 \u05D4\u05D2\u05D1\u05D5\u05DC",
                "Show all": "\u05D4\u05E6\u05D2 \u05D0\u05EA \u05DB\u05DC",
                Apply: "\u05D4\u05D7\u05DC",
                "Please fill out this field": "\u05E0\u05D0 \u05DC\u05DE\u05DC\u05D0 \u05E9\u05D3\u05D4 \u05D6\u05D4",
                "Please enter a web address": "\u05D0\u05E0\u05D0 \u05D4\u05D6\u05DF \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05E0\u05D8\u05E8\u05E0\u05D8",
                Default: "\u05D1\u05E8\u05D9\u05E8\u05EA \u05D4\u05DE\u05D7\u05D3\u05DC",
                Circle: "\u05DE\u05E2\u05D2\u05DC",
                Dot: "\u05E0\u05E7\u05D5\u05D3\u05D4",
                Quadrate: "\u05D4\u05E8\u05D9\u05D1\u05D5\u05E2 \u05D4\u05D6\u05D4",
                Find: "\u05DC\u05DE\u05E6\u05D5\u05D0",
                "Find Previous": "\u05DE\u05E6\u05D0 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3\u05DD",
                "Find Next": "\u05D7\u05E4\u05E9 \u05D0\u05EA \u05D4\u05D1\u05D0",
                "Insert className": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DB\u05D9\u05EA\u05D4",
                "Press Alt for custom resizing": "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05D0\u05DC\u05D8 \u05DC\u05E9\u05D9\u05E0\u05D5\u05D9 \u05D2\u05D5\u05D3\u05DC \u05DE\u05D5\u05EA\u05D0\u05DD \u05D0\u05D9\u05E9\u05D9\u05EA"
            },
            hu: {
                "Type something": "\xcdrjon be valamit",
                Advanced: "Halad\xf3",
                "About Jodit": "Joditr\xf3l",
                "Jodit Editor": "Jodit Editor",
                "Free Non-commercial Version": "Ingyenes v\xe1ltozat",
                "Jodit User's Guide": "Jodit \xfatmutat\xf3",
                "contains detailed help for using": "tov\xe1bbi seg\xedts\xe9get tartalmaz",
                "For information about the license, please go to our website:": "Tov\xe1bbi licence inform\xe1ci\xf3k\xe9rt l\xe1togassa meg a weboldalunkat:",
                "Buy full version": "Teljes verzi\xf3 megv\xe1s\xe1rl\xe1sa",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Minden jog fenntartva.",
                Anchor: "Horgony",
                "Open in new tab": "Megnyit\xe1s \xfaj lapon",
                "Open in fullsize": "Megnyit\xe1s teljes m\xe9retben",
                "Clear Formatting": "Form\xe1z\xe1s t\xf6rl\xe9se",
                "Fill color or set the text color": "H\xe1tt\xe9r/sz\xf6veg sz\xedn",
                Redo: "\xdajra",
                Undo: "Visszavon",
                Bold: "F\xe9lk\xf6v\xe9r",
                Italic: "D\u0151lt",
                "Insert Unordered List": "Pontozott lista",
                "Insert Ordered List": "Sz\xe1mozott lista",
                "Align Center": "K\xf6z\xe9pre z\xe1rt",
                "Align Justify": "Sorkiz\xe1rt",
                "Align Left": "Balra z\xe1rt",
                "Align Right": "Jobbra z\xe1rt",
                "Insert Horizontal Line": "V\xedzszintes vonal besz\xfar\xe1sa",
                "Insert Image": "K\xe9p besz\xfar\xe1s",
                "Insert file": "F\xe1jl besz\xfar\xe1s",
                "Insert youtube/vimeo video": "Youtube vide\xf3 besz\xfar\xe1sa",
                "Insert link": "Link besz\xfar\xe1s",
                "Font size": "Bet\u0171m\xe9ret",
                "Font family": "Bet\u0171t\xedpus",
                "Insert format block": "Form\xe1zott blokk besz\xfar\xe1sa",
                Normal: "Norm\xe1l",
                "Heading 1": "Fejl\xe9c 1",
                "Heading 2": "Fejl\xe9c 2",
                "Heading 3": "Fejl\xe9c 3",
                "Heading 4": "Fejl\xe9c 4",
                Quote: "Id\xe9zet",
                Code: "K\xf3d",
                Insert: "Besz\xfar",
                "Insert table": "T\xe1bl\xe1zat besz\xfar\xe1sa",
                "Decrease Indent": "Beh\xfaz\xe1s cs\xf6kkent\xe9se",
                "Increase Indent": "Beh\xfaz\xe1s n\xf6vel\xe9se",
                "Select Special Character": "Speci\xe1lis karakter kiv\xe1laszt\xe1sa",
                "Insert Special Character": "Speci\xe1lis karakter besz\xfar\xe1sa",
                "Paint format": "K\xe9p form\xe1z\xe1sa",
                "Change mode": "N\xe9zet v\xe1lt\xe1sa",
                Print: "Nyomtat\xe1s",
                Margins: "Szeg\xe9lyek",
                top: "fels\u0151",
                right: "jobb",
                bottom: "als\xf3",
                left: "bal",
                Styles: "CSS st\xedlusok",
                Classes: "CSS oszt\xe1lyok",
                Align: "Igaz\xedt\xe1s",
                Right: "Jobbra",
                Center: "K\xf6z\xe9pre",
                Left: "Balra",
                "--Not Set--": "Nincs",
                Src: "Forr\xe1s",
                Title: "C\xedm",
                Alternative: "Helyettes\xedt\u0151 sz\xf6veg",
                Link: "Link",
                "Open link in new tab": "Link megnyit\xe1sa \xfaj lapon",
                Image: "K\xe9p",
                file: "F\xe1jl",
                "Image properties": "K\xe9p tulajdons\xe1gai",
                Cancel: "M\xe9gsem",
                Ok: "OK",
                "Your code is similar to HTML. Keep as HTML?": "A beillesztett sz\xf6veg HTML-nek t\u0171nik. Megtartsuk HTML-k\xe9nt?",
                "Paste as HTML": "Besz\xfar\xe1s HTML-k\xe9nt",
                Keep: "Megtart\xe1s",
                Clean: "Elvet\xe9s",
                "Insert as Text": "Besz\xfar\xe1s sz\xf6vegk\xe9nt",
                "Word Paste Detected": "Word-b\u0151l m\xe1solt sz\xf6veg",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "A beillesztett tartalom Microsoft Word/Excel dokumentumb\xf3l sz\xe1rmazik. Meg szeretn\xe9 tartani a form\xe1tum\xe1t?",
                "Insert only Text": "Csak sz\xf6veg beilleszt\xe9se",
                "File Browser": "F\xe1jl tall\xf3z\xf3",
                "Error on load list": "Hiba a lista bet\xf6lt\xe9se k\xf6zben",
                "Error on load folders": "Hiba a mapp\xe1k bet\xf6lt\xe9se k\xf6zben",
                "Are you sure?": "Biztosan ezt szeretn\xe9?",
                "Enter Directory name": "\xcdrjon be egy mappanevet",
                "Create directory": "Mappa l\xe9trehoz\xe1sa",
                "type name": "\xedrjon be bevet",
                "Drop image": "H\xfazza ide a k\xe9pet",
                "Drop file": "H\xfazza ide a f\xe1jlt",
                "or click": "vagy kattintson",
                "Alternative text": "Helyettes\xedt\u0151 sz\xf6veg",
                Browse: "Tall\xf3z",
                Upload: "Felt\xf6lt",
                Background: "H\xe1tt\xe9r",
                Text: "Sz\xf6veg",
                Top: "Fent",
                Middle: "K\xf6z\xe9pen",
                Bottom: "Lent",
                "Insert column before": "Oszlop besz\xfar\xe1s el\xe9",
                "Insert column after": "Oszlop besz\xfar\xe1s ut\xe1na",
                "Insert row above": "Sor besz\xfar\xe1s f\xf6l\xe9",
                "Insert row below": "Sor besz\xfar\xe1s al\xe1",
                "Delete table": "T\xe1bl\xe1zat t\xf6rl\xe9se",
                "Delete row": "Sor t\xf6rl\xe9se",
                "Delete column": "Oszlop t\xf6rl\xe9se",
                "Empty cell": "Cella tartalm\xe1nak t\xf6rl\xe9se",
                Delete: "T\xf6rl\xe9s",
                "Strike through": "\xc1th\xfazott",
                Underline: "Al\xe1h\xfazott",
                Break: "Sz\xfcnet",
                "Search for": "Keres\xe9s",
                "Replace with": "Csere erre",
                Replace: "Cser\xe9lje ki",
                Edit: "Szerkeszt",
                "Vertical align": "F\xfcgg\u0151leges igaz\xedt\xe1s",
                "Horizontal align": "V\xedzszintes igaz\xedt\xe1s",
                Filter: "Sz\u0171r\u0151",
                "Sort by changed": "Rendez\xe9s m\xf3dos\xedt\xe1s szerint",
                "Sort by name": "Rendez\xe9s n\xe9v szerint",
                "Sort by size": "Rendez\xe9s m\xe9ret szerint",
                "Add folder": "Mappa hozz\xe1ad\xe1s",
                "Split vertical": "F\xfcgg\u0151leges feloszt\xe1s",
                "Split horizontal": "V\xedzszintes feloszt\xe1s",
                Merge: "\xd6sszevon\xe1s",
                "Add column": "Oszlop hozz\xe1ad\xe1s",
                "Add row": "Sor hozz\xe1ad\xe1s",
                Border: "Szeg\xe9ly",
                "Embed code": "Be\xe1gyazott k\xf3d",
                Update: "Friss\xedt",
                superscript: "Fels\u0151 index",
                subscript: "Als\xf3 index",
                "Cut selection": "Kiv\xe1g\xe1s",
                Paste: "Beilleszt\xe9s",
                "Choose Content to Paste": "V\xe1lasszon tartalmat a beilleszt\xe9shez",
                Split: "Feloszt\xe1s",
                "Chars: %d": "Karakterek sz\xe1ma: %d",
                "Words: %d": "Szavak sz\xe1ma: %d",
                All: "\xd6sszes",
                "Select %s": "Kijel\xf6l: %s",
                "Select all": "\xd6sszes kijel\xf6l\xe9se",
                source: "HTML",
                bold: "F\xe9lk\xf6v\xe9r",
                italic: "D\u0151lt",
                brush: "Ecset",
                link: "Link",
                undo: "Visszavon",
                redo: "\xdajra",
                table: "T\xe1bl\xe1zat",
                image: "K\xe9p",
                eraser: "T\xf6rl\xe9s",
                paragraph: "Paragr\xe1fus",
                fontsize: "Bet\u0171m\xe9ret",
                video: "Vide\xf3",
                font: "Bet\u0171",
                about: "R\xf3lunk",
                print: "Nyomtat",
                underline: "Al\xe1h\xfazott",
                strikethrough: "\xc1th\xfazott",
                indent: "Beh\xfaz\xe1s",
                outdent: "Aussenseiter",
                fullsize: "Teljes m\xe9ret",
                shrink: "\xd6sszenyom",
                hr: "Egyenes vonal",
                ul: "Lista",
                ol: "Sz\xe1mozott lista",
                cut: "Kiv\xe1g",
                selectall: "\xd6sszes kijel\xf6l\xe9se",
                "Open link": "Link megnyit\xe1sa",
                "Edit link": "Link szerkeszt\xe9se",
                "No follow": "Nincs k\xf6vet\xe9s",
                Unlink: "Link lev\xe1laszt\xe1sa",
                Eye: "fel\xfclvizsg\xe1lat",
                pencil: "Szerkeszt\xe9s",
                " URL": "URL",
                Reset: "Vissza\xe1ll\xedt",
                Save: "Ment\xe9s",
                "Save as ...": "Ment\xe9s m\xe1sk\xe9nt...",
                Resize: "\xc1tm\xe9retez\xe9s",
                Crop: "Kiv\xe1g",
                Width: "Sz\xe9less\xe9g",
                Height: "Magass\xe1g",
                "Keep Aspect Ratio": "K\xe9par\xe1ny megtart\xe1sa",
                Yes: "Igen",
                No: "Nem",
                Remove: "Elt\xe1vol\xedt",
                Select: "Kijel\xf6l",
                "You can only edit your own images. Download this image on the host?": "Csak a saj\xe1t k\xe9peit tudja szerkeszteni. Let\xf6lti ezt a k\xe9pet?",
                "The image has been successfully uploaded to the host!": "K\xe9p sikeresen felt\xf6ltve!",
                palette: "Palette",
                "There are no files": "Er zijn geen bestanden in deze map.",
                Rename: "\xe1tnevez\xe9s",
                "Enter new name": "Adja meg az \xfaj nevet",
                preview: "el\u0151n\xe9zet",
                download: "Let\xf6lt\xe9s",
                "Paste from clipboard": "Illessze be a v\xe1g\xf3lap",
                "Your browser doesn't support direct access to the clipboard.": "A b\xf6ng\xe9sz\u0151 nem t\xe1mogatja a k\xf6zvetlen hozz\xe1f\xe9r\xe9st biztos\xedt a v\xe1g\xf3lapra.",
                "Copy selection": "M\xe1sol\xe1s kiv\xe1laszt\xe1sa",
                copy: "m\xe1sol\xe1s",
                "Border radius": "Hat\xe1r sug\xe1r",
                "Show all": "\xd6sszes",
                Apply: "Alkalmazni",
                "Please fill out this field": "K\xe9rj\xfck, t\xf6ltse ki ezt a mez\u0151t,",
                "Please enter a web address": "K\xe9rj\xfck, \xedrja be a webc\xedmet",
                Default: "Alap\xe9rtelmezett",
                Circle: "K\xf6r",
                Dot: "Pont",
                Quadrate: "Quadrate",
                Find: "Tal\xe1lni",
                "Find Previous": "Megtal\xe1lja El\u0151z\u0151",
                "Find Next": "K\xf6vetkez\u0151 Keres\xe9se",
                "Insert className": "Helyezze be az oszt\xe1ly nev\xe9t",
                "Press Alt for custom resizing": "Nyomja meg az Alt egy\xe9ni \xe1tm\xe9retez\xe9s"
            },
            id: {
                "Type something": "Ketik sesuatu",
                "About Jodit": "Tentang Jodit",
                "Jodit Editor": "Editor Jodit",
                "Free Non-commercial Version": "Versi Bebas Non-komersil",
                "Jodit User's Guide": "Panduan Pengguna Jodit",
                "contains detailed help for using": "mencakup detail bantuan penggunaan",
                "For information about the license, please go to our website:": "Untuk informasi tentang lisensi, silakan kunjungi website:",
                "Buy full version": "Beli versi lengkap",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Hak Cipta \xa9 XDSoft.net - Chupurnov Valeriy. Hak cipta dilindungi undang-undang.",
                Anchor: "Tautan",
                "Open in new tab": "Buka di tab baru",
                "Open in fullsize": "Buka editor dalam ukuran penuh",
                "Clear Formatting": "Hapus Pemformatan",
                "Fill color or set the text color": "Isi warna atau atur warna teks",
                Redo: "Ulangi",
                Undo: "Batalkan",
                Bold: "Tebal",
                Italic: "Miring",
                "Insert Unordered List": "Sisipkan Daftar Tidak Berurut",
                "Insert Ordered List": "Sisipkan Daftar Berurut",
                "Align Center": "Tengah",
                "Align Justify": "Penuh",
                "Align Left": "Kiri",
                "Align Right": "Kanan",
                "Insert Horizontal Line": "Sisipkan Garis Horizontal",
                "Insert Image": "Sisipkan Gambar",
                "Insert file": "Sisipkan Berkas",
                "Insert youtube/vimeo video": "Sisipkan video youtube/vimeo",
                "Insert link": "Sisipkan tautan",
                "Font size": "Ukuran font",
                "Font family": "Keluarga font",
                "Insert format block": "Sisipkan blok format",
                Normal: "Normal",
                "Heading 1": "Heading 1",
                "Heading 2": "Heading 2",
                "Heading 3": "Heading 3",
                "Heading 4": "Heading 4",
                Quote: "Kutip",
                Code: "Kode",
                Insert: "Sisipkan",
                "Insert table": "Sisipkan tabel",
                "Decrease Indent": "Kurangi Indentasi",
                "Increase Indent": "Tambah Indentasi",
                "Select Special Character": "Pilih Karakter Spesial",
                "Insert Special Character": "Sisipkan Karakter Spesial",
                "Paint format": "Formar warna",
                "Change mode": "Ubah mode",
                Margins: "Batas",
                top: "atas",
                right: "kanan",
                bottom: "bawah",
                left: "kiri",
                Styles: "Gaya",
                Classes: "Class",
                Align: "Rata",
                Right: "Kanan",
                Center: "Tengah",
                Left: "Kiri",
                "--Not Set--": "--Tidak diset--",
                Src: "Src",
                Title: "Judul",
                Alternative: "Teks alternatif",
                Link: "Tautan",
                "Open link in new tab": "Buka tautan di tab baru",
                Image: "Gambar",
                file: "berkas",
                Advanced: "Lanjutan",
                "Image properties": "Properti gambar",
                Cancel: "Batal",
                Ok: "Ya",
                "Your code is similar to HTML. Keep as HTML?": "Kode Anda cenderung ke HTML. Biarkan sebagai HTML?",
                "Paste as HTML": "Paste sebagai HTML",
                Keep: "Jaga",
                Clean: "Bersih",
                "Insert as Text": "Sisipkan sebagai teks",
                "Insert only Text": "Sisipkan hanya teks",
                "Word Paste Detected": "Terdeteksi paste dari Word",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Konten dipaste dari dokumen Microsoft Word/Excel. Apakah Anda ingin tetap menjaga format atau membersihkannya?",
                "File Browser": "Penjelajah Berkas",
                "Error on load list": "Error ketika memuat list",
                "Error on load folders": "Error ketika memuat folder",
                "Are you sure?": "Apakah Anda yakin?",
                "Enter Directory name": "Masukkan nama Direktori",
                "Create directory": "Buat direktori",
                "type name": "ketik nama",
                "Drop image": "Letakkan gambar",
                "Drop file": "Letakkan berkas",
                "or click": "atau klik",
                "Alternative text": "Teks alternatif",
                Browse: "Jelajahi",
                Upload: "Unggah",
                Background: "Latar Belakang",
                Text: "Teks",
                Top: "Atas",
                Middle: "Tengah",
                Bottom: "Bawah",
                "Insert column before": "Sisipkan kolom sebelumnya",
                "Insert column after": "Sisipkan kolom setelahnya",
                "Insert row above": "Sisipkan baris di atasnya",
                "Insert row below": "Sisipkan baris di bawahnya",
                "Delete table": "Hapus tabel",
                "Delete row": "Hapus baris",
                "Delete column": "Hapus kolom",
                "Empty cell": "Kosongkan cell",
                source: "sumber",
                bold: "tebal",
                italic: "miring",
                brush: "sikat",
                link: "tautan",
                undo: "batalkan",
                redo: "ulangi",
                table: "tabel",
                image: "gambar",
                eraser: "penghapus",
                paragraph: "paragraf",
                fontsize: "ukuran font",
                video: "video",
                font: "font",
                about: "tentang",
                print: "cetak",
                underline: "garis bawah",
                strikethrough: "coret",
                indent: "menjorok ke dalam",
                outdent: "menjorok ke luar",
                fullsize: "ukuran penuh",
                shrink: "menyusut",
                hr: "hr",
                ul: "ul",
                ol: "ol",
                cut: "potong",
                selectall: "Pilih semua",
                "Embed code": "Kode embed",
                "Open link": "Buka tautan",
                "Edit link": "Edit tautan",
                "No follow": "No follow",
                Unlink: "Hapus tautan",
                Eye: "Mata",
                pencil: "pensil",
                Update: "Perbarui",
                " URL": "URL",
                Edit: "Edit",
                "Horizontal align": "Perataan horizontal",
                Filter: "Filter",
                "Sort by changed": "Urutkan berdasarkan perubahan",
                "Sort by name": "Urutkan berdasarkan nama",
                "Sort by size": "Urutkan berdasarkan ukuran",
                "Add folder": "Tambah folder",
                Reset: "Reset",
                Save: "Simpan",
                "Save as ...": "Simpan sebagai...",
                Resize: "Ubah ukuran",
                Crop: "Crop",
                Width: "Lebar",
                Height: "Tinggi",
                "Keep Aspect Ratio": "Jaga aspek rasio",
                Yes: "Ya",
                No: "Tidak",
                Remove: "Copot",
                Select: "Pilih",
                "Chars: %d": "Karakter: %d",
                "Words: %d": "Kata: %d",
                All: "Semua",
                "Select %s": "Pilih %s",
                "Select all": "Pilih semua",
                "Vertical align": "Rata vertikal",
                Split: "Bagi",
                "Split vertical": "Bagi secara vertikal",
                "Split horizontal": "Bagi secara horizontal",
                Merge: "Gabungkan",
                "Add column": "Tambah kolom",
                "Add row": "tambah baris",
                Delete: "Hapus",
                Border: "Bingkai",
                "License: %s": "Lisensi: %s",
                "Strike through": "Coret",
                Underline: "Garis Bawah",
                superscript: "Superskrip",
                subscript: "Subskrip",
                "Cut selection": "Potong pilihan",
                Break: "Berhenti",
                "Search for": "Mencari",
                "Replace with": "Ganti dengan",
                Replace: "Mengganti",
                Paste: "Paste",
                "Choose Content to Paste": "Pilih konten untuk dipaste",
                "You can only edit your own images. Download this image on the host?": "Anda hanya dapat mengedit gambar Anda sendiri. Unduh gambar ini di host?",
                "The image has been successfully uploaded to the host!": "Gambar telah sukses diunggah ke host!",
                palette: "palet",
                "There are no files": "Tidak ada berkas",
                Rename: "ganti nama",
                "Enter new name": "Masukkan nama baru",
                preview: "pratinjau",
                download: "Unduh",
                "Paste from clipboard": "Paste dari clipboard",
                "Your browser doesn't support direct access to the clipboard.": "Browser anda tidak mendukung akses langsung ke clipboard.",
                "Copy selection": "Copy seleksi",
                copy: "copy",
                "Border radius": "Border radius",
                "Show all": "Tampilkan semua",
                Apply: "Menerapkan",
                "Please fill out this field": "Silahkan mengisi kolom ini",
                "Please enter a web address": "Silahkan masukkan alamat web",
                Default: "Default",
                Circle: "Lingkaran",
                Dot: "Dot",
                Quadrate: "Kuadrat",
                Find: "Menemukan",
                "Find Previous": "Menemukan Sebelumnya",
                "Find Next": "Menemukan Berikutnya",
                "Insert className": "Masukkan nama kelas",
                "Press Alt for custom resizing": "Tekan Alt untuk mengubah ukuran kustom"
            },
            it: {
                "Type something": "Scrivi qualcosa...",
                Advanced: "Avanzato",
                "About Jodit": "A proposito di Jodit",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Guida utente di Jodit",
                "contains detailed help for using": "contiene una guida dettagliata per l'uso.",
                "For information about the license, please go to our website:": "Per informazioni sulla licenza, si prega di visitare il nostro sito web:",
                "Buy full version": "Acquista la versione completa",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Tutti i diritti riservati.",
                Anchor: "Link",
                "Open in new tab": "Apri in una nuova scheda",
                "Open in fullsize": "Apri l'editor a schermo intero",
                "Clear Formatting": "Pulisci Formattazione",
                "Fill color or set the text color": "Colore di sfondo o del testo",
                Redo: "Ripristina",
                Undo: "Annulla",
                Bold: "Grassetto",
                Italic: "Corsivo",
                "Insert Unordered List": "Inserisci lista non ordinata",
                "Insert Ordered List": "Inserisci lista ordinata",
                "Align Center": "Allinea al centro",
                "Align Justify": "Allineamento Giustificato",
                "Align Left": "Allinea a Sinistra",
                "Align Right": "Allinea a Destra",
                "Insert Horizontal Line": "Inserisci una linea orizzontale",
                "Insert Image": "Inserisci immagine",
                "Insert file": "Inserisci un file",
                "Insert youtube/vimeo video": "Inserisci video Youtube/Vimeo",
                "Insert link": "Inserisci link",
                "Font size": "Dimensione carattere",
                "Font family": "Tipo di font",
                "Insert format block": "Inserisci blocco",
                Normal: "Normale",
                "Heading 1": "Intestazione 1",
                "Heading 2": "Intestazione 2",
                "Heading 3": "Intestazione 3",
                "Heading 4": "Intestazione 4",
                Quote: "Citazione",
                Code: "Codice",
                Insert: "Inserisci",
                "Insert table": "Inserisci tabella",
                "Decrease Indent": "Riduci il rientro",
                "Increase Indent": "Aumenta il rientro",
                "Select Special Character": "Seleziona un carattere speciale",
                "Insert Special Character": "Inserisci un carattere speciale",
                "Paint format": "Copia formato",
                "Change mode": "Cambia modalita'",
                Margins: "Margini",
                top: "su",
                right: "destra",
                bottom: "gi\xf9",
                left: "sinistra",
                Styles: "Stili CSS",
                Classes: "Classi CSS",
                Align: "Allinea",
                Right: "Destra",
                Center: "Centro",
                Left: "Sinistra",
                "--Not Set--": "--Non Impostato--",
                Src: "Fonte",
                Title: "Titolo",
                Alternative: "Testo Alternativo",
                Link: "Link",
                "Open link in new tab": "Apri il link in una nuova scheda",
                Image: "Immagine",
                file: "Archivio",
                "Image properties": "Propriet\xe0 dell'immagine",
                Cancel: "Annulla",
                Ok: "Accetta",
                "Your code is similar to HTML. Keep as HTML?": "Il codice \xe8 simile all'HTML. Mantieni come HTML?",
                "Paste as HTML": "Incolla come HTML",
                Keep: "Mantieni",
                Clean: "Pulisci",
                "Insert as Text": "Inserisci come testo",
                "Word Paste Detected": "Incolla testo da Word rilevato",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Il contenuto incollato proviene da un documento Microsoft Word / Excel. Vuoi mantenere il formato o pulirlo?",
                "Insert only Text": "Inserisci solo il testo",
                "File Browser": "Cerca file",
                "Error on load list": "Errore durante il caricamento dell'elenco",
                "Error on load folders": "Errore durante il caricamento delle cartelle",
                "Are you sure?": "Sei sicuro?",
                "Enter Directory name": "Inserisci il nome della cartella",
                "Create directory": "Crea cartella",
                "type name": "Digita il nome",
                "Drop image": "Cancella immagine",
                "Drop file": "Cancella file",
                "or click": "o clicca",
                "Alternative text": "Testo alternativo",
                Browse: "Sfoglia",
                Upload: "Carica",
                Background: "Sfondo",
                Text: "Testo",
                Top: "Su",
                Middle: "Centro",
                Bottom: "Sotto",
                "Insert column before": "Inserisci la colonna prima",
                "Insert column after": "Inserisci la colonna dopo",
                "Insert row above": "Inserisci la riga sopra",
                "Insert row below": "Inserisci la riga sotto",
                "Delete table": "Elimina tabella",
                "Delete row": "Elimina riga",
                "Delete column": "Elimina colonna",
                "Empty cell": "Cella vuota",
                Delete: "Cancella",
                "Strike through": "Barrato",
                Underline: "Sottolineato",
                Break: "Pausa",
                "Search for": "Cerca per",
                "Replace with": "Sostituisci con",
                Replace: "Sostituisci",
                Edit: "Modifica",
                "Vertical align": "Allineamento verticala",
                "Horizontal align": "Allineamento orizzontale",
                Filter: "Filtro",
                "Sort by changed": "Ordina per data di modifica",
                "Sort by name": "Ordina per nome",
                "Sort by size": "Ordina per dimensione",
                "Add folder": "Aggiungi cartella",
                Split: "Dividi",
                "Split vertical": "Dividi verticalmente",
                "Split horizontal": "Dividi orizzontale",
                Merge: "Fondi",
                "Add column": "Aggiungi colonna",
                "Add row": "Aggiungi riga",
                Border: "Bordo",
                "Embed code": "Includi codice",
                Update: "Aggiorna",
                superscript: "indice",
                subscript: "pedice",
                "Cut selection": "Taglia selezione",
                Paste: "Incolla",
                "Choose Content to Paste": "Seleziona il contenuto da incollare",
                "Chars: %d": "Caratteri: %d",
                "Words: %d": "Parole: %d",
                All: "Tutto",
                "Select %s": "Seleziona: %s",
                "Select all": "Seleziona tutto",
                source: "risorsa",
                bold: "Grassetto",
                italic: "Corsivo",
                brush: "Pennello",
                link: "Link",
                undo: "Annulla",
                redo: "Ripristina",
                table: "Tabella",
                image: "Immagine",
                eraser: "Gomma",
                paragraph: "Paragrafo",
                fontsize: "Dimensione del carattere",
                video: "Video",
                font: "Font",
                about: "Approposito di",
                print: "Stampa",
                underline: "Sottolineato",
                strikethrough: "Barrato",
                indent: "aumenta rientro",
                outdent: "riduci rientro",
                fullsize: "espandi",
                shrink: "comprimi",
                hr: "linea orizzontale",
                ul: "lista non ordinata",
                ol: "lista ordinata",
                cut: "Taglia",
                selectall: "Seleziona tutto",
                "Open link": "Apri link",
                "Edit link": "Modifica link",
                "No follow": "Non seguire",
                Unlink: "Rimuovi link",
                Eye: "Recensione",
                pencil: "Per modificare",
                " URL": " URL",
                Reset: "Reset",
                Save: "Salva",
                "Save as ...": "Salva con nome...",
                Resize: "Ridimensiona",
                Crop: "Ritaglia",
                Width: "Larghezza",
                Height: "Altezza",
                "Keep Aspect Ratio": "Mantieni le proporzioni",
                Yes: "Si",
                No: "No",
                Remove: "Rimuovi",
                Select: "Seleziona",
                "You can only edit your own images. Download this image on the host?": "Puoi modificare solo le tue immagini. Vuoi scaricare questa immagine dal server?",
                "The image has been successfully uploaded to the host!": "L'immagine \xe8 stata caricata correttamente sul server!",
                palette: "tavolozza",
                "There are no files": "Non ci sono file in questa directory.",
                Rename: "Rinomina",
                "Enter new name": "Inserisci un nuovo nome",
                preview: "anteprima",
                download: "Scarica",
                "Paste from clipboard": "Incolla dagli appunti",
                "Your browser doesn't support direct access to the clipboard.": "Il tuo browser non supporta l'accesso diretto agli appunti.",
                "Copy selection": "Copia selezione",
                copy: "copia",
                "Border radius": "Border radius",
                "Show all": "Mostra tutti",
                Apply: "Applica",
                "Please fill out this field": "Si prega di compilare questo campo",
                "Please enter a web address": "Si prega di inserire un indirizzo web",
                Default: "Default",
                Circle: "Cerchio",
                Dot: "Punto",
                Quadrate: "Quadrato",
                "Lower Alpha": "Lettera Minuscola",
                "Lower Greek": "Lettera Greca Minuscola",
                "Lower Roman": "Numero Romano Minuscolo",
                "Upper Alpha": "Lettera Maiuscola",
                "Upper Roman": "Numero Romano Maiuscolo",
                Find: "Trova",
                "Find Previous": "Trova Precedente",
                "Find Next": "Trova Successivo",
                "Insert className": "Inserisci il nome della classe",
                "Press Alt for custom resizing": "Premere Alt per il ridimensionamento personalizzato"
            },
            ja: {
                "Type something": "\u306A\u306B\u304B\u30BF\u30A4\u30D7\u3057\u3066\u304F\u3060\u3055\u3044",
                Advanced: "\u9AD8\u5EA6\u306A\u8A2D\u5B9A",
                "About Jodit": "Jodit\u306B\u3064\u3044\u3066",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Jodit \u30E6\u30FC\u30B6\u30FC\u30BA\u30FB\u30AC\u30A4\u30C9",
                "contains detailed help for using": "\u8A73\u3057\u3044\u4F7F\u3044\u65B9",
                "For information about the license, please go to our website:": "\u30E9\u30A4\u30BB\u30F3\u30B9\u8A73\u7D30\u306B\u3064\u3044\u3066\u306FJodit Web\u30B5\u30A4\u30C8\u3092\u78BA\u8A8D\u304F\u3060\u3055\u3044\uFF1A",
                "Buy full version": "\u30D5\u30EB\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u8CFC\u5165",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                Anchor: "Anchor",
                "Open in new tab": "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
                "Open in fullsize": "\u30A8\u30C7\u30A3\u30BF\u30FC\u306E\u30B5\u30A4\u30BA\uFF08\u30D5\u30EB/\u30CE\u30FC\u30DE\u30EB\uFF09",
                "Clear Formatting": "\u66F8\u5F0F\u3092\u30AF\u30EA\u30A2",
                "Fill color or set the text color": "\u30C6\u30AD\u30B9\u30C8\u306E\u8272",
                Redo: "\u3084\u308A\u76F4\u3057",
                Undo: "\u5143\u306B\u623B\u3059",
                Bold: "\u592A\u5B57",
                Italic: "\u659C\u4F53",
                "Insert Unordered List": "\u7B87\u6761\u66F8\u304D",
                "Insert Ordered List": "\u756A\u53F7\u4ED8\u304D\u30EA\u30B9\u30C8",
                "Align Center": "\u4E2D\u592E\u63C3\u3048",
                "Align Justify": "\u4E21\u7AEF\u63C3\u3048",
                "Align Left": "\u5DE6\u63C3\u3048",
                "Align Right": "\u53F3\u63C3\u3048",
                "Insert Horizontal Line": "\u533A\u5207\u308A\u7DDA\u3092\u633F\u5165",
                "Insert Image": "\u753B\u50CF\u3092\u633F\u5165",
                "Insert file": "\u30D5\u30A1\u30A4\u30EB\u3092\u633F\u5165",
                "Insert youtube/vimeo video": "Youtube/Vimeo \u52D5\u753B",
                "Insert link": "\u30EA\u30F3\u30AF\u3092\u633F\u5165",
                "Font size": "\u30D5\u30A9\u30F3\u30C8\u30B5\u30A4\u30BA",
                "Font family": "\u30D5\u30A9\u30F3\u30C8",
                "Insert format block": "\u30C6\u30AD\u30B9\u30C8\u306E\u30B9\u30BF\u30A4\u30EB",
                Normal: "\u6307\u5B9A\u306A\u3057",
                "Heading 1": "\u30BF\u30A4\u30C8\u30EB1",
                "Heading 2": "\u30BF\u30A4\u30C8\u30EB2",
                "Heading 3": "\u30BF\u30A4\u30C8\u30EB3",
                "Heading 4": "\u30BF\u30A4\u30C8\u30EB4",
                Quote: "\u5F15\u7528",
                Code: "\u30B3\u30FC\u30C9",
                Insert: "\u633F\u5165",
                "Insert table": "\u8868\u3092\u633F\u5165",
                "Decrease Indent": "\u30A4\u30F3\u30C7\u30F3\u30C8\u6E1B",
                "Increase Indent": "\u30A4\u30F3\u30C7\u30F3\u30C8\u5897",
                "Select Special Character": "\u7279\u6B8A\u6587\u5B57\u3092\u9078\u629E",
                "Insert Special Character": "\u7279\u6B8A\u6587\u5B57\u3092\u633F\u5165",
                "Paint format": "\u66F8\u5F0F\u3092\u8CBC\u4ED8\u3051",
                "Change mode": "\u7DE8\u96C6\u30E2\u30FC\u30C9\u5207\u66FF\u3048",
                Margins: "\u30DE\u30FC\u30B8\u30F3",
                top: "\u4E0A",
                right: "\u53F3",
                bottom: "\u4E0B",
                left: "\u5DE6",
                Styles: "\u30B9\u30BF\u30A4\u30EB",
                Classes: "\u30AF\u30E9\u30B9",
                Align: "\u914D\u7F6E",
                Right: "\u53F3\u5BC4\u305B",
                Center: "\u4E2D\u592E\u5BC4\u305B",
                Left: "\u5DE6\u5BC4\u305B",
                "--Not Set--": "\u6307\u5B9A\u306A\u3057",
                Src: "\u30BD\u30FC\u30B9",
                Title: "\u30BF\u30A4\u30C8\u30EB",
                Alternative: "\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8",
                Link: "\u30EA\u30F3\u30AF",
                "Open link in new tab": "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
                Image: "\u753B\u50CF",
                file: "\u30D5\u30A1\u30A4\u30EB",
                "Image properties": "\u753B\u50CF\u306E\u30D7\u30ED\u30D1\u30C6\u30A3\u30FC",
                Cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
                Ok: "\u78BA\u5B9A",
                "Your code is similar to HTML. Keep as HTML?": "HTML\u30B3\u30FC\u30C9\u3092\u4FDD\u6301\u3057\u307E\u3059\u304B\uFF1F",
                "Paste as HTML": "HTML\u3067\u8CBC\u4ED8\u3051",
                Keep: "HTML\u3092\u4FDD\u6301",
                Clean: "Clean",
                "Insert as Text": "HTML\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u3059\u308B",
                "Word Paste Detected": "Word Paste Detected",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?",
                "Insert only Text": "\u30C6\u30AD\u30B9\u30C8\u3060\u3051",
                "File Browser": "File Browser",
                "Error on load list": "Error on load list",
                "Error on load folders": "Error on load folders",
                "Are you sure?": "Are you sure?",
                "Enter Directory name": "Enter Directory name",
                "Create directory": "Create directory",
                "type name": "type name",
                "Drop image": "\u3053\u3053\u306B\u753B\u50CF\u3092\u30C9\u30ED\u30C3\u30D7",
                "Drop file": "\u3053\u3053\u306B\u30D5\u30A1\u30A4\u30EB\u3092\u30C9\u30ED\u30C3\u30D7",
                "or click": "or \u30AF\u30EA\u30C3\u30AF",
                "Alternative text": "\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8",
                Browse: "\u30D6\u30E9\u30A6\u30BA",
                Upload: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
                Background: "\u80CC\u666F",
                Text: "\u6587\u5B57",
                Top: "\u4E0A",
                Middle: "\u4E2D\u592E",
                Bottom: "\u4E0B",
                "Insert column before": "\u5DE6\u306B\u5217\u3092\u633F\u5165",
                "Insert column after": "\u53F3\u306B\u5217\u3092\u633F\u5165",
                "Insert row above": "\u4E0A\u306B\u884C\u3092\u633F\u5165",
                "Insert row below": "\u4E0B\u306B\u884C\u3092\u633F\u5165",
                "Delete table": "\u8868\u3092\u524A\u9664",
                "Delete row": "\u884C\u3092\u524A\u9664",
                "Delete column": "\u5217\u3092\u524A\u9664",
                "Empty cell": "\u30BB\u30EB\u3092\u7A7A\u306B\u3059\u308B",
                "Chars: %d": "\u6587\u5B57\u6570: %d",
                "Words: %d": "\u5358\u8A9E\u6570: %d",
                "Strike through": "\u53D6\u308A\u6D88\u3057\u7DDA",
                Underline: "\u4E0B\u7DDA",
                superscript: "\u4E0A\u4ED8\u304D\u6587\u5B57",
                subscript: "\u4E0B\u4ED8\u304D\u6587\u5B57",
                "Cut selection": "\u5207\u308A\u53D6\u308A",
                "Select all": "\u3059\u3079\u3066\u9078\u629E",
                Break: "Pause",
                "Search for": "\u691C\u7D22",
                "Replace with": "\u7F6E\u63DB",
                Replace: "\u4EA4\u63DB",
                Paste: "\u8CBC\u4ED8\u3051",
                "Choose Content to Paste": "\u9078\u629E\u3057\u305F\u5185\u5BB9\u3092\u8CBC\u4ED8\u3051",
                All: "\u5168\u90E8",
                source: "source",
                bold: "bold",
                italic: "italic",
                brush: "brush",
                link: "link",
                undo: "undo",
                redo: "redo",
                table: "table",
                image: "image",
                eraser: "eraser",
                paragraph: "paragraph",
                fontsize: "fontsize",
                video: "video",
                font: "font",
                about: "about",
                print: "print",
                underline: "underline",
                strikethrough: "strikethrough",
                indent: "indent",
                outdent: "outdent",
                fullsize: "fullsize",
                shrink: "shrink",
                hr: "\u5206\u5272\u7DDA",
                ul: "\u7B87\u6761\u66F8\u304D",
                ol: "\u756A\u53F7\u4ED8\u304D\u30EA\u30B9\u30C8",
                cut: "\u5207\u308A\u53D6\u308A",
                selectall: "\u3059\u3079\u3066\u9078\u629E",
                "Open link": "\u30EA\u30F3\u30AF\u3092\u958B\u304F",
                "Edit link": "\u30EA\u30F3\u30AF\u3092\u7DE8\u96C6",
                "No follow": "No follow",
                Unlink: "\u30EA\u30F3\u30AF\u89E3\u9664",
                Eye: "\u30B5\u30A4\u30C8\u3092\u78BA\u8A8D",
                " URL": "URL",
                Reset: "\u30EA\u30BB\u30C3\u30C8",
                Save: "\u4FDD\u5B58",
                "Save as ...": "Save as ...",
                Resize: "\u30EA\u30B5\u30A4\u30BA",
                Crop: "Crop",
                Width: "\u5E45",
                Height: "\u9AD8\u3055",
                "Keep Aspect Ratio": "\u7E26\u6A2A\u6BD4\u3092\u4FDD\u6301",
                Yes: "\u306F\u3044",
                No: "\u3044\u3044\u3048",
                Remove: "\u79FB\u9664",
                Select: "\u9078\u629E",
                "Select %s": "\u9078\u629E: %s",
                Update: "\u66F4\u65B0",
                "Vertical align": "\u5782\u76F4\u65B9\u5411\u306E\u914D\u7F6E",
                Merge: "\u30BB\u30EB\u306E\u7D50\u5408",
                "Add column": "\u5217\u3092\u8FFD\u52A0",
                "Add row": "\u884C\u3092\u8FFD\u52A0",
                Border: "\u5883\u754C\u7DDA",
                "Embed code": "\u57CB\u3081\u8FBC\u307F\u30B3\u30FC\u30C9",
                Delete: "\u524A\u9664",
                Edit: "\u7DE8\u96C6",
                "Horizontal align": "\u6C34\u5E73\u65B9\u5411\u306E\u914D\u7F6E",
                Filter: "Filter",
                "Sort by changed": "Sort by changed",
                "Sort by name": "Sort by name",
                "Sort by size": "Sort by size",
                "Add folder": "Add folder",
                Split: "\u5206\u5272",
                "Split vertical": "\u30BB\u30EB\u306E\u5206\u5272\uFF08\u5782\u76F4\u65B9\u5411\uFF09",
                "Split horizontal": "\u30BB\u30EB\u306E\u5206\u5272\uFF08\u6C34\u5E73\u65B9\u5411\uFF09",
                "You can only edit your own images. Download this image on the host?": "You can only edit your own images. Download this image on the host?",
                "The image has been successfully uploaded to the host!": "The image has been successfully uploaded to the host!",
                palette: "\u30D1\u30EC\u30C3\u30C8",
                pencil: "\u925B\u7B46",
                "There are no files": "There are no files",
                Rename: "Rename",
                "Enter new name": "Enter new name",
                preview: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                download: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
                "Paste from clipboard": "\u8CBC\u308A\u4ED8\u3051",
                "Your browser doesn't support direct access to the clipboard.": "\u304A\u4F7F\u3044\u306E\u30D6\u30E9\u30A6\u30B6\u306F\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u3092\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093",
                "Copy selection": "\u30B3\u30D4\u30FC",
                copy: "copy",
                "Border radius": "\u89D2\u306E\u4E38\u307F",
                "Show all": "\u5168\u3066\u8868\u793A",
                Apply: "\u9069\u7528",
                "Please fill out this field": "\u307E\u3060\u3053\u306E\u5206\u91CE",
                "Please enter a web address": "\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u30A6\u30A7\u30D6\u30A2\u30C9\u30EC\u30B9",
                Default: "\u30C7\u30D5\u30A9\u30EB\u30C8",
                Circle: "\u767D\u4E38",
                Dot: "\u9ED2\u4E38",
                Quadrate: "\u56DB\u89D2",
                Find: "\u898B",
                "Find Previous": "\u63A2\u524D",
                "Find Next": "\u7531\u6765",
                "Lower Alpha": "\u82F1\u5C0F\u6587\u5B57",
                "Lower Greek": "\u30AE\u30EA\u30B7\u30E3\u6587\u5B57",
                "Lower Roman": "\u30ED\u30FC\u30DE\u6570\u5B57\u5C0F\u6587\u5B57",
                "Upper Alpha": "\u82F1\u5927\u6587\u5B57",
                "Upper Roman": "\u30ED\u30FC\u30DE\u6570\u5B57\u5927\u6587\u5B57",
                "Insert className": "\u30AF\u30E9\u30B9\u540D\u3092\u633F\u5165",
                "Press Alt for custom resizing": "\u30AB\u30B9\u30BF\u30E0\u30B5\u30A4\u30BA\u5909\u66F4\u306E\u305F\u3081\u306EAlt\u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059"
            },
            ko: {
                "Type something": "\uBB34\uC5C7\uC774\uB4E0 \uC785\uB825\uD558\uC138\uC694",
                "About Jodit": "Jodit\uC5D0 \uB300\uD558\uC5EC",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Jodit \uC0AC\uC6A9\uC790 \uC548\uB0B4\uC11C",
                "contains detailed help for using": "\uC790\uC138\uD55C \uB3C4\uC6C0\uB9D0\uC774 \uB4E4\uC5B4\uC788\uC5B4\uC694",
                "For information about the license, please go to our website:": "\uB77C\uC774\uC13C\uC2A4\uC5D0 \uAD00\uD574\uC11C\uB294 Jodit \uC6F9 \uC0AC\uC774\uD2B8\uB97C \uBC29\uBB38\uD574\uC8FC\uC138\uC694\uFF1A",
                "Buy full version": "\uD480 \uBC84\uC804 \uAD6C\uC785\uD558\uAE30",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "\xa9 XDSoft.net - Chupurnov Valeriy. \uC5D0\uAC8C \uC800\uC791\uAD8C\uACFC \uBAA8\uB4E0 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
                Anchor: "Anchor",
                "Open in new tab": "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
                "Open in fullsize": "\uC804\uCCB4 \uD06C\uAE30\uB85C \uBCF4\uAE30",
                "Clear Formatting": "\uC11C\uC2DD \uC9C0\uC6B0\uAE30",
                "Fill color or set the text color": "\uAE00\uC528 \uC0C9\uC0C1",
                Redo: "\uC7AC\uC2E4\uD589",
                Undo: "\uC2E4\uD589 \uCDE8\uC18C",
                Bold: "\uAD75\uAC8C",
                Italic: "\uAE30\uC6B8\uC784",
                "Insert Unordered List": "\uAE00\uBA38\uB9AC \uBAA9\uB85D",
                "Insert Ordered List": "\uBC88\uD638 \uBAA9\uB85D",
                "Align Center": "\uAC00\uC6B4\uB370 \uC815\uB82C",
                "Align Justify": "\uC591\uCABD \uC815\uB82C",
                "Align Left": "\uC67C\uCABD \uC815\uB82C",
                "Align Right": "\uC624\uB978\uCABD \uC815\uB82C",
                "Insert Horizontal Line": "\uC218\uD3C9 \uAD6C\uBD84\uC120 \uB123\uAE30",
                "Insert Image": "\uC774\uBBF8\uC9C0 \uB123\uAE30",
                "Insert file": "\uD30C\uC77C \uB123\uAE30",
                "Insert youtube/vimeo video": "Youtube/Vimeo \uB3D9\uC601\uC0C1",
                "Insert link": "\uB9C1\uD06C \uB123\uAE30",
                "Font size": "\uAE00\uAF34 \uD06C\uAE30",
                "Font family": "\uAE00\uAF34",
                "Insert format block": "\uBE14\uB85D \uC694\uC18C \uB123\uAE30",
                Normal: "\uC77C\uBC18 \uD14D\uC2A4\uD2B8",
                "Heading 1": "\uC81C\uBAA9 1",
                "Heading 2": "\uC81C\uBAA9 2",
                "Heading 3": "\uC81C\uBAA9 3",
                "Heading 4": "\uC81C\uBAA9 4",
                Quote: "\uC778\uC6A9",
                Code: "\uCF54\uB4DC",
                Insert: "\uBD99\uC5EC \uB123\uAE30",
                "Insert table": "\uD14C\uC774\uBE14",
                "Decrease Indent": "\uB4E4\uC5EC\uC4F0\uAE30 \uAC10\uC18C",
                "Increase Indent": "\uB4E4\uC5EC\uC4F0\uAE30 \uC99D\uAC00",
                "Select Special Character": "\uD2B9\uC218\uBB38\uC790 \uC120\uD0DD",
                "Insert Special Character": "\uD2B9\uC218\uBB38\uC790 \uC785\uB825",
                "Paint format": "\uD398\uC778\uD2B8 \uD615\uC2DD",
                "Change mode": "\uD3B8\uC9D1\uBAA8\uB4DC \uBCC0\uACBD",
                Margins: "\uB9C8\uC9C4",
                top: "\uC704",
                right: "\uC624\uB978\uCABD",
                bottom: "\uC544\uB798",
                left: "\uC67C\uCABD",
                Styles: "\uC2A4\uD0C0\uC77C",
                Classes: "\uD074\uB798\uC2A4",
                Align: "\uC815\uB82C",
                Right: "\uC624\uB978\uCABD\uC73C\uB85C",
                Center: "\uAC00\uC6B4\uB370\uB85C",
                Left: "\uC67C\uCABD\uC73C\uB85C",
                "--Not Set--": "--\uC9C0\uC815 \uC548 \uD568--",
                Src: "\uACBD\uB85C(src)",
                Title: "\uC81C\uBAA9",
                Alternative: "\uB300\uCCB4 \uD14D\uC2A4\uD2B8(alt)",
                Link: "\uB9C1\uD06C",
                "Open link in new tab": "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
                file: "\uD30C\uC77C",
                Advanced: "\uACE0\uAE09",
                "Image properties": "\uC774\uBBF8\uC9C0 \uC18D\uC131",
                Cancel: "\uCDE8\uC18C",
                Ok: "\uD655\uC778",
                "Your code is similar to HTML. Keep as HTML?": "HTML \uCF54\uB4DC\uB85C \uAC10\uC9C0\uD588\uC5B4\uC694. \uCF54\uB4DC\uC778\uCC44\uB85C \uBD99\uC5EC\uB123\uC744\uAE4C\uC694?",
                "Paste as HTML": "HTML\uB85C \uBD99\uC5EC\uB123\uAE30",
                Keep: "\uC6D0\uBCF8 \uC720\uC9C0",
                Clean: "\uC9C0\uC6B0\uAE30",
                "Insert as Text": "\uD14D\uC2A4\uD2B8\uB85C \uB123\uAE30",
                "Insert only Text": "\uD14D\uC2A4\uD2B8\uB9CC \uB123\uAE30",
                "Word Paste Detected": "Word \uBD99\uC5EC\uB123\uAE30 \uAC10\uC9C0",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Microsoft Word/Excel \uBB38\uC11C\uB85C \uAC10\uC9C0\uD588\uC5B4\uC694. \uC11C\uC2DD\uC744 \uC720\uC9C0\uD55C\uCC44\uB85C \uBD99\uC5EC\uB123\uC744\uAE4C\uC694?",
                "File Browser": "\uD30C\uC77C \uD0D0\uC0C9\uAE30",
                "Error on load list": "\uBAA9\uB85D \uBD88\uB7EC\uC624\uAE30 \uC5D0\uB7EC",
                "Error on load folders": "\uD3F4\uB354 \uBD88\uB7EC\uC624\uAE30",
                "Are you sure?": "\uC815\uB9D0 \uC9C4\uD589\uD560\uAE4C\uC694?",
                "Enter Directory name": "\uB514\uB809\uD1A0\uB9AC \uC774\uB984 \uC785\uB825",
                "Create directory": "\uB514\uB809\uD1A0\uB9AC \uC0DD\uC131",
                "type name": "\uC774\uB984 \uC785\uB825",
                "Drop image": "\uC774\uBBF8\uC9C0 \uB4DC\uB798\uADF8",
                "Drop file": "\uD30C\uC77C \uB4DC\uB798\uADF8",
                "or click": "\uD639\uC740 \uD074\uB9AD",
                "Alternative text": "\uB300\uCCB4 \uD14D\uC2A4\uD2B8",
                Browse: "\uD0D0\uC0C9",
                Upload: "\uC5C5\uB85C\uB4DC",
                Background: "\uBC30\uACBD",
                Text: "\uD14D\uC2A4\uD2B8",
                Top: "\uC704",
                Middle: "\uC911\uC559",
                Bottom: "\uC544\uB798",
                "Insert column before": "\uC774\uC804 \uC5F4\uC5D0 \uC0BD\uC785",
                "Insert column after": "\uB2E4\uC74C \uC5F4\uC5D0 \uC0BD\uC785",
                "Insert row above": "\uC704 \uD589\uC5D0 \uC0BD\uC785",
                "Insert row below": "\uC544\uB798 \uD589\uC5D0 \uC0BD\uC785",
                "Delete table": "\uD14C\uC774\uBE14 \uC0AD\uC81C",
                "Delete row": "\uD589 \uC0AD\uC81C",
                "Delete column": "\uC5F4 \uC0AD\uC81C",
                "Empty cell": "\uBE48 \uC140",
                source: "HTML \uC18C\uC2A4",
                bold: "\uBCFC\uB4DC",
                italic: "\uC774\uD0E4\uB9AD",
                brush: "\uBE0C\uB7EC\uC2DC",
                link: "\uB9C1\uD06C",
                undo: "\uC2E4\uD589 \uCDE8\uC18C",
                redo: "\uC7AC\uC2E4\uD589",
                table: "\uD14C\uC774\uBE14",
                image: "\uC774\uBBF8\uC9C0",
                eraser: "\uC9C0\uC6B0\uAC1C",
                paragraph: "\uBB38\uB2E8",
                fontsize: "\uAE00\uAF34 \uD06C\uAE30",
                video: "\uBE44\uB514\uC624",
                font: "\uAE00\uAF34",
                about: "\uD3B8\uC9D1\uAE30 \uC815\uBCF4",
                print: "\uD504\uB9B0\uD2B8",
                underline: "\uBC11\uC904",
                strikethrough: "\uCDE8\uC18C\uC120",
                indent: "\uB4E4\uC5EC\uC4F0\uAE30",
                outdent: "\uB0B4\uC5B4\uC4F0\uAE30",
                fullsize: "\uC804\uCCB4 \uD654\uBA74",
                shrink: "\uC77C\uBC18 \uD654\uBA74",
                hr: "\uAD6C\uBD84\uC120",
                ul: "\uAE00\uBA38\uB9AC \uBAA9\uB85D",
                ol: "\uBC88\uD638 \uBAA9\uB85D",
                cut: "\uC798\uB77C\uB0B4\uAE30",
                selectall: "\uBAA8\uB450 \uC120\uD0DD",
                "Embed code": "Embed \uCF54\uB4DC",
                "Open link": "\uB9C1\uD06C \uC5F4\uAE30",
                "Edit link": "\uB9C1\uD06C \uD3B8\uC9D1",
                "No follow": "No follow",
                Unlink: "\uB9C1\uD06C \uC81C\uAC70",
                Eye: "\uC0AC\uC774\uD2B8 \uD655\uC778",
                pencil: "\uC5F0\uD544",
                Update: "\uAC31\uC2E0",
                " URL": "URL",
                Edit: "\uD3B8\uC9D1",
                "Horizontal align": "\uC218\uD3C9 \uC815\uB82C",
                Filter: "\uD544\uD130",
                "Sort by changed": "\uBCC0\uACBD\uC77C \uC815\uB82C",
                "Sort by name": "\uC774\uB984 \uC815\uB82C",
                "Sort by size": "\uD06C\uAE30 \uC815\uB82C",
                "Add folder": "\uC0C8 \uD3F4\uB354",
                Reset: "\uCD08\uAE30\uD654",
                Save: "\uC800\uC7A5",
                "Save as ...": "\uC0C8\uB85C \uC800\uC7A5\uD558\uAE30 ...",
                Resize: "\uB9AC\uC0AC\uC774\uC988",
                Crop: "\uD06C\uB86D",
                Width: "\uAC00\uB85C \uAE38\uC774",
                Height: "\uC138\uB85C \uB192\uC774",
                "Keep Aspect Ratio": "\uBE44\uC728 \uC720\uC9C0\uD558\uAE30",
                Yes: "\uB124",
                No: "\uC544\uB2C8\uC624",
                Remove: "\uC81C\uAC70",
                Select: "\uC120\uD0DD",
                "Chars: %d": "\uBB38\uC790\uC218: %d",
                "Words: %d": "\uB2E8\uC5B4\uC218: %d",
                All: "\uBAA8\uB450",
                "Select all": "\uBAA8\uB450 \uC120\uD0DD",
                "Select %s": "\uC120\uD0DD: %s",
                "Vertical align": "\uC218\uC9C1 \uC815\uB82C",
                Split: "\uBD84\uD560",
                "Split vertical": "\uC138\uB85C \uC140 \uBD84\uD560",
                "Split horizontal": "\uAC00\uB85C \uC140 \uBD84\uD560",
                Merge: "\uC140 \uBCD1\uD569",
                "Add column": "\uC5F4 \uCD94\uAC00",
                "Add row": "\uD589 \uCD94\uAC00",
                Delete: "\uC0AD\uC81C",
                Border: "\uC678\uACFD\uC120",
                "License: %s": "\uB77C\uC774\uC13C\uC2A4: %s",
                "Strike through": "\uCDE8\uC18C\uC120",
                Underline: "\uBC11\uC904",
                superscript: "\uC717\uCCA8\uC790",
                subscript: "\uC544\uB798\uCCA8\uC790",
                "Cut selection": "\uC120\uD0DD \uC798\uB77C\uB0B4\uAE30",
                Break: "\uAD6C\uBD84\uC790",
                "Search for": "\uAC80\uC0C9",
                "Replace with": "\uB300\uCCB4\uD558\uAE30",
                Replace: "\uB300\uCCB4",
                Paste: "\uBD99\uC5EC\uB123\uAE30",
                "Choose Content to Paste": "\uBD99\uC5EC\uB123\uC744 \uB0B4\uC6A9 \uC120\uD0DD",
                "You can only edit your own images. Download this image on the host?": "\uC678\uBD80 \uC774\uBBF8\uC9C0\uB294 \uD3B8\uC9D1\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC678\uBD80 \uC774\uBBF8\uC9C0\uB97C \uB2E4\uC6B4\uB85C\uB4DC \uD560\uAE4C\uC694?",
                "The image has been successfully uploaded to the host!": "\uC774\uBBF8\uC9C0\uB97C \uBB34\uC0AC\uD788 \uC5C5\uB85C\uB4DC \uD588\uC5B4\uC694!",
                palette: "\uD314\uB808\uD2B8",
                "There are no files": "\uD30C\uC77C\uC774 \uC5C6\uC5B4\uC694",
                Rename: "\uC774\uB984 \uBCC0\uACBD",
                "Enter new name": "\uC0C8 \uC774\uB984 \uC785\uB825",
                preview: "\uBBF8\uB9AC\uBCF4\uAE30",
                download: "\uB2E4\uC6B4\uB85C\uB4DC",
                "Paste from clipboard": "\uD074\uB9BD\uBCF4\uB4DC \uBD99\uC5EC\uB123\uAE30",
                "Your browser doesn't support direct access to the clipboard.": "\uC0AC\uC6A9\uC911\uC778 \uBE0C\uB77C\uC6B0\uC800\uAC00 \uD074\uB9BD\uBCF4\uB4DC \uC811\uADFC\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694.",
                "Copy selection": "\uC120\uD0DD \uBCF5\uC0AC",
                copy: "\uBCF5\uC0AC",
                "Border radius": "\uB465\uADFC \uD14C\uB450\uB9AC",
                "Show all": "\uBAA8\uB450 \uBCF4\uAE30",
                Apply: "\uC801\uC6A9",
                "Please fill out this field": "\uC774 \uD56D\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694!",
                "Please enter a web address": "\uC6F9 URL\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
                Default: "\uAE30\uBCF8",
                Circle: "\uC6D0",
                Dot: "\uC810",
                Quadrate: "\uC815\uC0AC\uAC01\uD615",
                Find: "\uCC3E\uAE30",
                "Find Previous": "\uC774\uC804 \uCC3E\uAE30",
                "Find Next": "\uB2E4\uC74C \uCC3E\uAE30",
                "Insert className": "className \uC785\uB825",
                "Press Alt for custom resizing": "\uC0AC\uC6A9\uC790 \uC9C0\uC815 \uD06C\uAE30 \uC870\uC815\uC5D0 \uB300 \uD55C \uACE0\uB3C4 \uB204\uB974\uC2ED\uC2DC\uC624"
            },
            mn: {
                "Type something": "\u0411\u0438\u0447\u044D\u044D\u0434 \u04AF\u0437\u044D\u044D\u0440\u044D\u0439",
                Advanced: "\u0414\u044D\u0432\u0448\u0438\u043B\u0442\u044D\u0442",
                "About Jodit": "Jodit-\u044B\u043D \u0442\u0430\u043B\u0430\u0430\u0440 ",
                "Jodit Editor": "Jodit \u043F\u0440\u043E\u0433\u0440\u0430\u043C",
                "Jodit User's Guide": "Jodit \u0433\u0430\u0440\u044B\u043D \u0430\u0432\u043B\u0430\u0433\u0430",
                "contains detailed help for using": "\u0445\u044D\u0440\u044D\u0433\u043B\u044D\u044D\u043D\u0438\u0439 \u0442\u0430\u043B\u0430\u0430\u0440 \u0434\u044D\u043B\u0433\u044D\u0440\u044D\u043D\u0433\u04AF\u0439 \u043C\u044D\u0434\u044D\u044D\u043B\u043B\u0438\u0439\u0433 \u0430\u0433\u0443\u0443\u043B\u043D\u0430",
                "For information about the license, please go to our website:": "\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u0439\u043D \u043C\u044D\u0434\u044D\u044D\u043B\u043B\u0438\u0439\u0433 \u043C\u0430\u043D\u0430\u0439 \u0432\u044D\u0431 \u0445\u0443\u0443\u0434\u0430\u0441\u043D\u0430\u0430\u0441 \u0430\u0432\u043D\u0430 \u0443\u0443:",
                "Buy full version": "\u0411\u04AF\u0440\u044D\u043D \u0445\u0443\u0432\u0438\u043B\u0431\u0430\u0440 \u0445\u0443\u0434\u0430\u043B\u0434\u0430\u043D \u0430\u0432\u0430\u0445",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "\u0417\u043E\u0445\u0438\u043E\u0433\u0447\u0438\u0439\u043D \u044D\u0440\u0445 \u0445\u0430\u043C\u0433\u0430\u0430\u043B\u0430\u0433\u0434\u0441\u0430\u043D \xa9 XDSoft.net - Chupurnov Valeriy. \u0411\u04AF\u0445 \u044D\u0440\u0445\u0438\u0439\u0433 \u044D\u0437\u044D\u043C\u0448\u0438\u043D\u044D.",
                Anchor: "\u0425\u043E\u043B\u0431\u043E\u043E \u0431\u0430\u0440\u0438\u0445",
                "Open in new tab": "\u0428\u0438\u043D\u044D \u0442\u0430\u0431\u0430\u0430\u0440 \u043D\u044D\u044D\u0445",
                "Open in fullsize": "\u0411\u04AF\u0442\u044D\u043D \u0434\u044D\u043B\u0433\u044D\u0446\u044D\u044D\u0440 \u043D\u044D\u044D\u0445",
                "Clear Formatting": "\u0424\u043E\u0440\u043C\u0430\u0442\u044B\u0433 \u0430\u0440\u0438\u043B\u0433\u0430\u0445",
                "Fill color or set the text color": "\u04E8\u043D\u0433\u04E9\u04E9\u0440 \u0431\u0443\u0434\u0430\u0445 \u044D\u0441\u0432\u044D\u043B \u0442\u0435\u043A\u0441\u0442\u0438\u0439\u043D \u04E9\u043D\u0433\u04E9 \u0441\u043E\u043D\u0433\u043E\u0445",
                Redo: "\u0414\u0430\u0445\u0438\u0445",
                Undo: "\u0411\u0443\u0446\u0430\u0430\u0445",
                Bold: "\u0422\u043E\u0434",
                Italic: "\u041D\u0430\u043B\u0443\u0443",
                "Insert Unordered List": "\u0422\u044D\u043C\u0434\u044D\u0433\u0442 \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442 \u043D\u044D\u043C\u044D\u0445",
                "Insert Ordered List": "\u0414\u0443\u0433\u0430\u0430\u0440\u0442 \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442 \u043D\u044D\u043C\u044D\u0445",
                "Align Center": "\u0413\u043E\u043B\u043B\u043E\u0436 \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                "Align Justify": "\u0422\u044D\u0433\u0448\u0438\u0442\u0433\u044D\u043D \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                "Align Left": "\u0417\u04AF\u04AF\u043D\u0434 \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                "Align Right": "\u0411\u0430\u0440\u0443\u0443\u043D\u0434 \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                "Insert Horizontal Line": "\u0425\u044D\u0432\u0442\u044D\u044D \u0437\u0443\u0440\u0430\u0430\u0441 \u043D\u044D\u043C\u044D\u0445",
                "Insert Image": "\u0417\u0443\u0440\u0430\u0433 \u043D\u044D\u043C\u044D\u0445",
                "Insert file": "\u0424\u0430\u0439\u043B \u043D\u044D\u043C\u044D\u0445",
                "Insert youtube/vimeo video": "Youtube/Vimeo \u0432\u0438\u0434\u0435\u043E \u043D\u044D\u043C\u044D\u0445",
                "Insert link": "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u043D\u044D\u043C\u044D\u0445",
                "Font size": "\u0424\u043E\u043D\u0442\u044B\u043D \u0445\u044D\u043C\u0436\u044D\u044D",
                "Font family": "\u0424\u043E\u043D\u0442\u044B\u043D \u0431\u04AF\u043B",
                "Insert format block": "\u0411\u043B\u043E\u043A \u043D\u044D\u043C\u044D\u0445",
                Normal: "\u0425\u044D\u0432\u0438\u0439\u043D",
                "Heading 1": "\u0413\u0430\u0440\u0447\u0438\u0433 1",
                "Heading 2": "\u0413\u0430\u0440\u0447\u0438\u0433 2",
                "Heading 3": "\u0413\u0430\u0440\u0447\u0438\u0433 3",
                "Heading 4": "\u0413\u0430\u0440\u0447\u0438\u0433 4",
                Quote: "\u0418\u0448\u043B\u044D\u043B",
                Code: "\u041A\u043E\u0434",
                Insert: "\u041E\u0440\u0443\u0443\u043B\u0430\u0445",
                "Insert table": "\u0425\u04AF\u0441\u043D\u044D\u0433\u0442 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                "Decrease Indent": "\u0414\u043E\u0433\u043E\u043B\u044B\u043D \u0437\u0430\u0439 \u0445\u0430\u0441\u0430\u0445",
                "Increase Indent": "\u0414\u043E\u0433\u043E\u043B\u044B\u043D \u0437\u0430\u0439 \u043D\u044D\u043C\u044D\u0445",
                "Select Special Character": "\u0422\u0443\u0441\u0433\u0430\u0439 \u0442\u044D\u043C\u0434\u044D\u0433\u0442 \u0441\u043E\u043D\u0433\u043E\u0445",
                "Insert Special Character": "\u0422\u0443\u0441\u0433\u0430\u0439 \u0442\u044D\u043C\u0434\u044D\u0433\u0442 \u043D\u044D\u043C\u044D\u0445",
                "Paint format": "\u0417\u0443\u0440\u0433\u0438\u0439\u043D \u0444\u043E\u0440\u043C\u0430\u0442",
                "Change mode": "\u0413\u043E\u0440\u0438\u043C \u04E9\u04E9\u0440\u0447\u043B\u04E9\u0445",
                Margins: "\u0426\u0430\u0430\u0441\u043D\u044B \u0437\u0430\u0439",
                top: "\u0414\u044D\u044D\u0440\u044D\u044D\u0441",
                right: "\u0411\u0430\u0440\u0443\u0443\u043D\u0430\u0430\u0441",
                bottom: "\u0414\u043E\u043E\u0440\u043E\u043E\u0441",
                left: "\u0417\u04AF\u04AF\u043D\u044D\u044D\u0441",
                Styles: "CSS \u0441\u0442\u0438\u043B\u044C",
                Classes: "CSS \u0430\u043D\u0433\u0438",
                Align: "\u0411\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                Right: "\u0411\u0430\u0440\u0443\u0443\u043D",
                Center: "\u0422\u04E9\u0432",
                Left: "\u0417\u04AF\u04AF\u043D",
                "--Not Set--": "--\u0422\u043E\u0434\u043E\u0440\u0445\u043E\u0439\u0433\u04AF\u0439--",
                Src: "\u042D\u0445 \u04AF\u04AF\u0441\u0432\u044D\u0440",
                Title: "\u0413\u0430\u0440\u0447\u0438\u0433",
                Alternative: "\u0410\u043B\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432 \u0442\u0435\u043A\u0441\u0442",
                Link: "\u0425\u043E\u043B\u0431\u043E\u043E\u0441",
                "Open link in new tab": "\u0425\u043E\u043B\u0431\u043E\u043E\u0441\u044B\u0433 \u0448\u0438\u043D\u044D \u0445\u0430\u0432\u0442\u0441\u0430\u043D\u0434 \u043D\u044D\u044D\u0445",
                Image: "\u0417\u0443\u0440\u0430\u0433",
                file: "\u0424\u0430\u0439\u043B",
                "Image properties": "\u0417\u0443\u0440\u0433\u0438\u0439\u043D \u04AF\u0437\u04AF\u04AF\u043B\u044D\u043B\u0442",
                Cancel: "\u0426\u0443\u0446\u043B\u0430\u0445",
                Ok: "Ok",
                "Your code is similar to HTML. Keep as HTML?": "\u0422\u0430\u043D\u044B \u043A\u043E\u0434 HTML \u043A\u043E\u0434\u0442\u043E\u0439 \u0430\u0434\u0438\u043B \u0431\u0430\u0439\u043D\u0430. HTML \u0444\u043E\u0440\u043C\u0430\u0442\u0430\u0430\u0440 \u04AF\u0440\u0433\u044D\u043B\u0436\u043B\u04AF\u04AF\u043B\u044D\u0445 \u04AF\u04AF?",
                "Paste as HTML": "HTML \u0431\u0430\u0439\u0434\u043B\u0430\u0430\u0440 \u0431\u0443\u0443\u043B\u0433\u0430\u0445",
                Keep: "\u0425\u0430\u0434\u0433\u0430\u043B\u0430\u0445",
                Clean: "\u0426\u044D\u0432\u044D\u0440\u043B\u044D\u0445",
                "Insert as Text": "\u0422\u0435\u043A\u0441\u0442 \u0431\u0430\u0439\u0434\u043B\u0430\u0430\u0440 \u043D\u044D\u043C\u044D\u0445",
                "Word Paste Detected": "Word \u0431\u0430\u0439\u0434\u043B\u0430\u0430\u0440 \u0431\u0443\u0443\u043B\u0433\u0430\u0441\u0430\u043D \u0431\u0430\u0439\u043D\u0430",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u0411\u0443\u0443\u043B\u0433\u0430\u0441\u0430\u043D \u0430\u0433\u0443\u0443\u043B\u0433\u0430 Microsoft Word/Excel \u0444\u043E\u0440\u043C\u0430\u0442\u0442\u0430\u0439 \u0431\u0430\u0439\u043D\u0430. \u042D\u043D\u044D \u0444\u043E\u0440\u043C\u0430\u0442\u044B\u0433 \u0445\u044D\u0432\u044D\u044D\u0440 \u0445\u0430\u0434\u0433\u0430\u043B\u0430\u0445 \u0443\u0443 \u044D\u0441\u0432\u044D\u043B \u0430\u0440\u0438\u043B\u0433\u0430\u0445 \u0443\u0443?",
                "Insert only Text": "\u0417\u04E9\u0432\u0445\u04E9\u043D \u0442\u0435\u043A\u0441\u0442 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                "File Browser": "\u0424\u0430\u0439\u043B\u044B\u043D \u0446\u043E\u043D\u0445",
                "Error on load list": "\u0416\u0430\u0433\u0441\u0430\u0430\u043B\u0442 \u0442\u0430\u0442\u0430\u0445 \u04AF\u0435\u0434 \u0430\u043B\u0434\u0430\u0430 \u0433\u0430\u0440\u043B\u0430\u0430",
                "Error on load folders": "\u0425\u0430\u0432\u0442\u0430\u0441 \u0442\u0430\u0442\u0430\u0445 \u04AF\u0435\u0434 \u0430\u043B\u0434\u0430\u0430 \u0433\u0430\u0440\u043B\u0430\u0430",
                "Are you sure?": "\u0418\u0442\u0433\u044D\u043B\u0442\u044D\u0439 \u0431\u0430\u0439\u043D\u0430 \u0443\u0443?",
                "Enter Directory name": "\u0425\u0430\u0432\u0442\u0441\u044B\u043D \u043D\u044D\u0440 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                "Create directory": "\u0425\u0430\u0432\u0442\u0430\u0441 \u04AF\u04AF\u0441\u0433\u044D\u0445",
                "type name": "\u041D\u044D\u0440 \u0431\u0438\u0447\u0438\u0445",
                "Drop image": "\u0417\u0443\u0440\u0430\u0433 \u0431\u0443\u0443\u043B\u0433\u0430\u0445",
                "Drop file": "\u0424\u0430\u0439\u043B \u0431\u0443\u0443\u043B\u0433\u0430\u0445",
                "or click": "\u044D\u0441\u0432\u044D\u043B \u0442\u043E\u0432\u0448",
                "Alternative text": "\u0410\u043B\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432 \u0442\u0435\u043A\u0441\u0442",
                Browse: "\u04AE\u0437\u044D\u0445",
                Upload: "\u0411\u0430\u0439\u0440\u0448\u0443\u0443\u043B\u0430\u0445",
                Background: "\u0410\u0440\u044B\u043D \u0437\u0443\u0440\u0430\u0433",
                Text: "\u0422\u0435\u043A\u0441\u0442",
                Top: "\u0414\u044D\u044D\u0440",
                Middle: "\u0414\u0443\u043D\u0434",
                Bottom: "\u0414\u043E\u043E\u0440",
                "Insert column before": "\u0423\u0440\u0434 \u043D\u044C \u0431\u0430\u0433\u0430\u043D\u0430 \u043D\u044D\u043C\u044D\u0445",
                "Insert column after": "\u0410\u0440\u0434 \u043D\u044C \u0431\u0430\u0433\u0430\u043D\u0430 \u043D\u044D\u043C\u044D\u0445",
                "Insert row above": "\u0414\u044D\u044D\u0440 \u043D\u044C \u043C\u04E9\u0440 \u043D\u044D\u043C\u044D\u0445",
                "Insert row below": "\u0414\u043E\u043E\u0440 \u043D\u044C \u043C\u04E9\u0440 \u043D\u044D\u043C\u044D\u0445",
                "Delete table": "\u0425\u04AF\u0441\u043D\u044D\u0433\u0442 \u0443\u0441\u0442\u0433\u0430\u0445",
                "Delete row": "\u041C\u04E9\u0440 \u0443\u0441\u0442\u0433\u0430\u0445",
                "Delete column": "\u0411\u0430\u0433\u0430\u043D\u0430 \u0443\u0441\u0442\u0433\u0430\u0445",
                "Empty cell": "\u041D\u04AF\u0434 \u0446\u044D\u0432\u044D\u0440\u043B\u044D\u0445",
                Delete: "\u0423\u0441\u0442\u0433\u0430\u0445",
                "Strike through": "\u0414\u044D\u044D\u0433\u04AF\u04AF\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                Underline: "\u0414\u043E\u043E\u0433\u0443\u0443\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                Break: "\u041C\u04E9\u0440\u0438\u0439\u0433 \u0442\u0430\u0441\u043B\u0430\u0445",
                "Search for": "\u0425\u0430\u0439\u0445",
                "Replace with": "\u04AE\u04AF\u0433\u044D\u044D\u0440 \u0441\u043E\u043B\u0438\u0445",
                Replace: "\u0421\u043E\u043B\u0438\u0445",
                Edit: "\u0417\u0430\u0441\u0430\u0445",
                "Vertical align": "\u0411\u043E\u0441\u043E\u043E \u044D\u0433\u043D\u04AF\u04AF\u043B\u044D\u0445",
                "Horizontal align": "\u0425\u044D\u0432\u0442\u044D\u044D \u044D\u0433\u043D\u04AF\u04AF\u043B\u044D\u0445",
                Filter: "\u0428\u04AF\u04AF\u0445",
                "Sort by changed": "\u0421\u04AF\u04AF\u043B\u0434 \u04E9\u04E9\u0440\u0447\u043B\u04E9\u0433\u0434\u0441\u04E9\u043D\u04E9\u04E9\u0440 \u0436\u0430\u0433\u0441\u0430\u0430\u0445",
                "Sort by name": "\u041D\u044D\u0440\u044D\u044D\u0440 \u0436\u0430\u0433\u0441\u0430\u0430\u0445",
                "Sort by size": "\u0425\u044D\u043C\u0436\u044D\u044D\u0433\u044D\u044D\u0440 \u0436\u0430\u0433\u0441\u0430\u0430\u0445",
                "Add folder": "\u0425\u0430\u0432\u0442\u0430\u0441 \u043D\u044D\u043C\u044D\u0445",
                Split: "\u0417\u0430\u0434\u043B\u0430\u0445",
                "Split vertical": "\u0411\u0430\u0433\u0430\u043D\u0430\u0430\u0440 \u0437\u0430\u0434\u043B\u0430\u0445",
                "Split horizontal": "\u041C\u04E9\u0440\u04E9\u04E9\u0440 \u0437\u0430\u0434\u043B\u0430\u0445",
                Merge: "\u041D\u044D\u0433\u0442\u0433\u044D\u0445",
                "Add column": "\u0411\u0430\u0433\u0430\u043D\u0430 \u043D\u044D\u043C\u044D\u0445",
                "Add row": "\u041C\u04E9\u0440 \u043D\u044D\u043C\u044D\u0445",
                Border: "\u0425\u04AF\u0440\u044D\u044D",
                "Embed code": "\u041A\u043E\u0434 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                Update: "\u0428\u0438\u043D\u044D\u0447\u043B\u044D\u0445",
                superscript: "\u0414\u044D\u044D\u0434 \u0438\u043D\u0434\u0435\u043A\u0441",
                subscript: "\u0414\u043E\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441",
                "Cut selection": "\u0421\u043E\u043D\u0433\u043E\u043B\u0442\u044B\u0433 \u0442\u0430\u0441\u043B\u0430\u0445",
                Paste: "\u0411\u0443\u0443\u043B\u0433\u0430\u0445",
                "Choose Content to Paste": "\u0411\u0443\u0443\u043B\u0433\u0430\u0445 \u0430\u0433\u0443\u0443\u043B\u0433\u0430\u0430 \u0441\u043E\u043D\u0433\u043E\u043D\u043E \u0443\u0443",
                "Chars: %d": "\u0422\u044D\u043C\u0434\u044D\u0433\u0442: %d",
                "Words: %d": "\u04AE\u0433: %d",
                All: "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433",
                "Select %s": "\u0421\u043E\u043D\u0433\u043E: %s",
                "Select all": "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0441\u043E\u043D\u0433\u043E",
                source: "\u042D\u0445 \u04AF\u04AF\u0441\u0432\u044D\u0440",
                bold: "\u0422\u043E\u0434",
                italic: "\u041D\u0430\u043B\u0443\u0443",
                brush: "\u0411\u0443\u0434\u0430\u0445",
                link: "\u0425\u043E\u043B\u0431\u043E\u043E\u0441",
                undo: "\u0411\u0443\u0446\u0430\u0430\u0445",
                redo: "\u0414\u0430\u0445\u0438\u0445",
                table: "\u0425\u04AF\u0441\u043D\u044D\u0433\u0442",
                image: "\u0417\u0443\u0440\u0430\u0433",
                eraser: "\u0411\u0430\u043B\u043B\u0443\u0443\u0440",
                paragraph: "\u041F\u0430\u0440\u0430\u0433\u0440\u0430\u0444",
                fontsize: "\u0424\u043E\u043D\u0442\u044B\u043D \u0445\u044D\u043C\u0436\u044D\u044D",
                video: "\u0412\u0438\u0434\u0435\u043E",
                font: "\u0424\u043E\u043D\u0442",
                about: "\u0422\u0443\u0445\u0430\u0439",
                print: "\u0425\u044D\u0432\u043B\u044D\u0445",
                underline: "\u0414\u043E\u043E\u0433\u0443\u0443\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                strikethrough: "\u0414\u044D\u044D\u0433\u04AF\u04AF\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                indent: "\u0414\u043E\u0433\u043E\u043B \u043D\u044D\u043C\u044D\u0445",
                outdent: "\u0414\u043E\u0433\u043E\u043B \u0431\u0430\u0433\u0430\u0441\u0433\u0430\u0445",
                fullsize: "\u0411\u04AF\u0442\u044D\u043D \u0434\u044D\u043B\u0433\u044D\u0446",
                shrink: "\u0411\u0430\u0433\u0430\u0441\u0433\u0430",
                hr: "\u0425\u0430\u0430\u043B\u0442",
                ul: "\u0422\u044D\u043C\u0434\u044D\u0433\u0442 \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442",
                ol: "\u0414\u0443\u0433\u0430\u0430\u0440\u043B\u0430\u0441\u0430\u043D \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442",
                cut: "\u0422\u0430\u0441\u043B\u0430\u0445",
                selectall: "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0441\u043E\u043D\u0433\u043E",
                "Open link": "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u043D\u044D\u044D\u0445",
                "Edit link": "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u0437\u0430\u0441\u0430\u0445",
                "No follow": "Nofollow \xf6zelli\u011Fi",
                Unlink: "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u0441\u0430\u043B\u0433\u0430\u0445",
                Eye: "\u041D\u04AF\u0434",
                pencil: "\u0417\u0430\u0441\u0430\u0445",
                " URL": "URL",
                Reset: "\u0411\u0443\u0446\u0430\u0430\u0445",
                Save: "\u0425\u0430\u0434\u0433\u0430\u043B\u0430\u0445",
                "Save as ...": "\u04E8\u04E9\u0440\u04E9\u04E9\u0440 \u0445\u0430\u0434\u0433\u0430\u043B\u0430\u0445",
                Resize: "\u0425\u044D\u043C\u0436\u044D\u044D\u0433 \u04E9\u04E9\u0440\u0447\u0438\u043B",
                Crop: "\u0422\u0430\u0439\u0440\u0430\u0445",
                Width: "\u04E8\u0440\u0433\u04E9\u043D",
                Height: "\u04E8\u043D\u0434\u04E9\u0440",
                "Keep Aspect Ratio": "\u0425\u0430\u0440\u044C\u0446\u0430\u0430\u0433 \u0445\u0430\u0434\u0433\u0430\u043B",
                Yes: "\u0422\u0438\u0439\u043C",
                No: "\u04AE\u0433\u04AF\u0439",
                Remove: "\u0410\u0440\u0438\u043B\u0433\u0430",
                Select: "\u0421\u043E\u043D\u0433\u043E",
                "You can only edit your own images. Download this image on the host?": "\u0422\u0430 \u0437\u04E9\u0432\u0445\u04E9\u043D \u04E9\u04E9\u0440\u0438\u0439\u043D \u0437\u0443\u0440\u0433\u0443\u0443\u0434\u0430\u0430 \u044F\u043D\u0437\u043B\u0430\u0445 \u0431\u043E\u043B\u043E\u043C\u0436\u0442\u043E\u0439. \u042D\u043D\u044D \u0437\u0443\u0440\u0433\u0438\u0439\u0433 \u04E9\u04E9\u0440 \u043B\u04AF\u04AF\u0433\u044D\u044D \u0442\u0430\u0442\u043C\u0430\u0430\u0440 \u0431\u0430\u0439\u043D\u0430 \u0443\u0443?",
                "The image has been successfully uploaded to the host!": "\u0417\u0443\u0440\u0433\u0438\u0439\u0433 \u0445\u043E\u0441\u0442 \u0440\u0443\u0443 \u0430\u043C\u0436\u0438\u043B\u0442\u0442\u0430\u0439 \u0445\u0430\u0434\u0433\u0430\u043B\u0441\u0430\u043D",
                palette: "\u041F\u0430\u043B\u0435\u0442",
                "There are no files": "\u042D\u043D\u0434 \u044F\u043C\u0430\u0440 \u043D\u044D\u0433 \u0444\u0430\u0439\u043B \u0430\u043B\u0433\u0430",
                Rename: "\u0428\u0438\u043D\u044D\u044D\u0440 \u043D\u044D\u0440\u043B\u044D\u0445",
                "Enter new name": "\u0428\u0438\u043D\u044D \u043D\u044D\u0440 \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443",
                preview: "\u0423\u0440\u044C\u0434\u0447\u0438\u043B\u0430\u043D \u0445\u0430\u0440\u0430\u0445",
                download: "\u0422\u0430\u0442\u0430\u0445",
                "Paste from clipboard": "\u0421\u0430\u043C\u0431\u0430\u0440\u0430\u0430\u0441 \u0445\u0443\u0443\u043B\u0430\u0445 ",
                "Your browser doesn't support direct access to the clipboard.": "\u042D\u043D\u044D \u0432\u044D\u0431 \u0445\u04E9\u0442\u0447\u04E9\u04E9\u0441 \u0441\u0430\u043C\u0431\u0430\u0440\u0442 \u0445\u0430\u043D\u0434\u0430\u0445 \u044D\u0440\u0445 \u0430\u043B\u0433\u0430.",
                "Copy selection": "\u0421\u043E\u043D\u0433\u043E\u043B\u0442\u044B\u0433 \u0445\u0443\u0443\u043B",
                copy: "\u0425\u0443\u0443\u043B\u0430\u0445",
                "Border radius": "\u0425\u04AF\u0440\u044D\u044D\u043D\u0438\u0439 \u0440\u0430\u0434\u0438\u0443\u0441",
                "Show all": "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0445\u0430\u0440\u0443\u0443\u043B\u0430\u0445",
                Apply: "\u0425\u044D\u0440\u044D\u0433\u0436\u04AF\u04AF\u043B",
                "Please fill out this field": "\u042D\u043D\u044D \u0442\u0430\u043B\u0431\u0430\u0440\u044B\u0433 \u0431\u04E9\u0433\u043B\u04E9\u043D\u04E9 \u04AF\u04AF",
                "Please enter a web address": "\u0412\u044D\u0431 \u0445\u0430\u044F\u0433\u0430\u0430 \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443",
                Default: "\u04AE\u043D\u0434\u0441\u044D\u043D",
                Circle: "\u0414\u0443\u0433\u0443\u0439",
                Dot: "\u0426\u044D\u0433",
                Quadrate: "\u0414\u04E9\u0440\u0432\u04E9\u043B\u0436\u0438\u043D",
                Find: "\u0425\u0430\u0439\u0445",
                "Find Previous": "\u04E8\u043C\u043D\u04E9\u0445\u0438\u0439\u0433 \u043E\u043B",
                "Find Next": "\u0414\u0430\u0440\u0430\u0430\u0433\u0438\u0439\u043D\u0445\u0438\u0439\u0433 \u043E\u043B",
                "Insert className": "\u0411\u04AF\u043B\u0433\u0438\u0439\u043D \u043D\u044D\u0440\u044D\u044D \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443",
                "Press Alt for custom resizing": "\u0425\u044D\u043C\u0436\u044D\u044D\u0441\u0438\u0439\u0433 \u0448\u0438\u043D\u044D\u044D\u0440 \u04E9\u04E9\u0447\u0440\u043B\u04E9\u0445\u0438\u0439\u043D \u0442\u0443\u043B\u0434 Alt \u0442\u043E\u0432\u0447\u0438\u043D \u0434\u044D\u044D\u0440 \u0434\u0430\u0440\u043D\u0430 \u0443\u0443"
            },
            nl: {
                "Type something": "Begin met typen..",
                Advanced: "Geavanceerd",
                "About Jodit": "Over Jodit",
                "Jodit Editor": "Jodit Editor",
                "Free Non-commercial Version": "Gratis niet-commerci\xeble versie",
                "Jodit User's Guide": "Jodit gebruikershandleiding",
                "contains detailed help for using": "bevat gedetailleerde informatie voor gebruik.",
                "For information about the license, please go to our website:": "Voor informatie over de licentie, ga naar onze website:",
                "Buy full version": "Volledige versie kopen",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Alle rechten voorbehouden.",
                Anchor: "Anker",
                "Open in new tab": "Open in nieuwe tab",
                "Open in fullsize": "Editor in volledig scherm openen",
                "Clear Formatting": "Opmaak verwijderen",
                "Fill color or set the text color": "Vulkleur of tekstkleur aanpassen",
                Redo: "Opnieuw",
                Undo: "Ongedaan maken",
                Bold: "Vet",
                Italic: "Cursief",
                "Insert Unordered List": "Geordende list invoegen",
                "Insert Ordered List": "Ongeordende lijst invoegen",
                "Align Center": "Centreren",
                "Align Justify": "Uitlijnen op volledige breedte",
                "Align Left": "Links uitlijnen",
                "Align Right": "Rechts uitlijnen",
                "Insert Horizontal Line": "Horizontale lijn invoegen",
                "Insert Image": "Afbeelding invoegen",
                "Insert file": "Bestand invoegen",
                "Insert youtube/vimeo video": "Youtube/Vimeo video invoegen",
                "Insert link": "Link toevoegen",
                "Font size": "Tekstgrootte",
                "Font family": "Lettertype",
                "Insert format block": "Format blok invoegen",
                Normal: "Normaal",
                "Heading 1": "Koptekst 1",
                "Heading 2": "Koptekst 2",
                "Heading 3": "Koptekst 3",
                "Heading 4": "Koptekst 4",
                Quote: "Citaat",
                Code: "Code",
                Insert: "Invoegen",
                "Insert table": "Tabel invoegen",
                "Decrease Indent": "Inspringing verkleinen",
                "Increase Indent": "Inspringing vergroten",
                "Select Special Character": "Symbool selecteren",
                "Insert Special Character": "Symbool invoegen",
                "Paint format": "Opmaak kopieren",
                "Change mode": "Modus veranderen",
                Margins: "Marges",
                top: "Boven",
                right: "Rechts",
                bottom: "Onder",
                left: "Links",
                Styles: "CSS styles",
                Classes: "CSS classes",
                Align: "Uitlijning",
                Right: "Rechts",
                Center: "Gecentreerd",
                Left: "Links",
                "--Not Set--": "--Leeg--",
                Src: "Src",
                Title: "Titel",
                Alternative: "Alternatieve tekst",
                Link: "Link",
                "Open link in new tab": "Link in nieuwe tab openen",
                Image: "Afbeelding",
                file: "Bestand",
                "Image properties": "Afbeeldingseigenschappen",
                Cancel: "Annuleren",
                Ok: "OK",
                "Your code is similar to HTML. Keep as HTML?": "Deze code lijkt op HTML. Als HTML behouden?",
                "Paste as HTML": "Invoegen als HTML",
                Keep: "Origineel behouden",
                Clean: "Opschonen",
                "Insert as Text": "Als tekst invoegen",
                "Word Paste Detected": "Word-tekst gedetecteerd",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "De geplakte tekst is afkomstig van een Microsoft Word/Excel document. Wil je de opmaak behouden of opschonen?",
                "Insert only Text": "Als onopgemaakte tekst invoegen",
                "File Browser": "Bestandsbrowser",
                "Error on load list": "Fout bij het laden van de lijst",
                "Error on load folders": "Fout bij het laden van de mappenlijst",
                "Are you sure?": "Weet je het zeker?",
                "Enter Directory name": "Geef de map een naam",
                "Create directory": "Map aanmaken",
                "type name": "Type naam",
                "Drop image": "Sleep hier een afbeelding naartoe",
                "Drop file": "Sleep hier een bestand naartoe",
                "or click": "of klik",
                "Alternative text": "Alternatieve tekst",
                Browse: "Bladeren",
                Upload: "Uploaden",
                Background: "Achtergrond",
                Text: "Tekst",
                Top: "Boven",
                Middle: "Midden",
                Bottom: "Onder",
                "Insert column before": "Kolom invoegen (voor)",
                "Insert column after": "Kolom invoegen (na)",
                "Insert row above": "Rij invoegen (boven)",
                "Insert row below": "Rij invoegen (onder)",
                "Delete table": "Tabel verwijderen",
                "Delete row": "Rij verwijderen",
                "Delete column": "Kolom verwijderen",
                "Empty cell": "Cel leegmaken",
                Delete: "Verwijderen",
                "Strike through": "Doorstrepen",
                Underline: "Onderstrepen",
                Break: "Enter",
                "Search for": "Zoek naar",
                "Replace with": "Vervangen door",
                Replace: "Vervangen",
                Edit: "Bewerken",
                "Vertical align": "Verticaal uitlijnen",
                "Horizontal align": "Horizontaal uitlijnen",
                Filter: "Filteren",
                "Sort by changed": "Sorteren op wijzigingsdatum",
                "Sort by name": "Sorteren op naam",
                "Sort by size": "Sorteren op grootte",
                "Add folder": "Map toevoegen",
                Split: "Splitsen",
                "Split vertical": "Verticaal splitsen",
                "Split horizontal": "Horizontaal splitsen",
                Merge: "Samenvoegen",
                "Add column": "Kolom toevoegen",
                "Add row": "Rij toevoegen",
                Border: "Rand",
                "Embed code": "Embed code",
                Update: "Updaten",
                superscript: "Superscript",
                subscript: "Subscript",
                "Cut selection": "Selectie knippen",
                Paste: "Plakken",
                "Choose Content to Paste": "Kies content om te plakken",
                "Chars: %d": "Tekens: %d",
                "Words: %d": "Woorden: %d",
                All: "Alles",
                "Select %s": "Selecteer: %s",
                "Select all": "Selecteer alles",
                source: "Broncode",
                bold: "vet",
                italic: "cursief",
                brush: "kwast",
                link: "link",
                undo: "ongedaan maken",
                redo: "opnieuw",
                table: "tabel",
                image: "afbeelding",
                eraser: "gum",
                paragraph: "paragraaf",
                fontsize: "lettergrootte",
                video: "video",
                font: "lettertype",
                about: "over",
                print: "afdrukken",
                underline: "onderstreept",
                strikethrough: "doorgestreept",
                indent: "inspringen",
                outdent: "minder inspringen",
                fullsize: "volledige grootte",
                shrink: "kleiner maken",
                hr: "horizontale lijn",
                ul: "lijst",
                ol: "genummerde lijst",
                cut: "knip",
                selectall: "alles selecteren",
                "Open link": "Link openen",
                "Edit link": "Link aanpassen",
                "No follow": "Niet volgen",
                Unlink: "link verwijderen",
                Eye: "Recensie",
                pencil: "Om te bewerken",
                " URL": " URL",
                Reset: "Herstellen",
                Save: "Opslaan",
                "Save as ...": "Opslaan als ...",
                Resize: "Grootte aanpassen",
                Crop: "Bijknippen",
                Width: "Breedte",
                Height: "Hoogte",
                "Keep Aspect Ratio": "Verhouding behouden",
                Yes: "Ja",
                No: "Nee",
                Remove: "Verwijderen",
                Select: "Selecteren",
                "You can only edit your own images. Download this image on the host?": "Je kunt alleen je eigen afbeeldingen aanpassen. Deze afbeelding downloaden?",
                "The image has been successfully uploaded to the host!": "De afbeelding is succesvol ge\xfcploadet!",
                palette: "Palette",
                "There are no files": "Er zijn geen bestanden in deze map.",
                Rename: "Hernoemen",
                "Enter new name": "Voer een nieuwe naam in",
                preview: "Voorvertoning",
                download: "Download",
                "Paste from clipboard": "Plakken van klembord",
                "Your browser doesn't support direct access to the clipboard.": "Uw browser ondersteunt geen directe toegang tot het klembord.",
                "Copy selection": "Selectie kopi\xebren",
                copy: "kopi\xebren",
                "Border radius": "Border radius",
                "Show all": "Toon alle",
                Apply: "Toepassen",
                "Please fill out this field": "Vul dit veld in",
                "Please enter a web address": "Voer een webadres in",
                Default: "Standaard",
                Circle: "Cirkel",
                Dot: "Punt",
                Quadrate: "Kwadraat",
                Find: "Zoeken",
                "Find Previous": "Vorige Zoeken",
                "Find Next": "Volgende Zoeken",
                "Insert className": "Voeg de klassenaam in",
                "Press Alt for custom resizing": "Druk op Alt voor aangepaste grootte"
            },
            no: {
                "Type something": "Skriv noe",
                "About Jodit": "Om Jodit",
                "Jodit Editor": "Jodit-redigerer",
                "Jodit User's Guide": "Jodit brukerveiledning",
                "contains detailed help for using": "Inneholder detaljert hjelp for bruk",
                "For information about the license, please go to our website:": "For informasjon om lisensen, bes\xf8k v\xe5r nettside:",
                "Buy full version": "Kj\xf8p fullversjon",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Opphavsrett \xa9 XDSoft.net - Chupurnov Valeriy. Alle rettigheter forbeholdt.",
                Anchor: "Anker",
                "Open in new tab": "\xc5pne i ny fane",
                "Open in fullsize": "\xc5pne i fullskjerm",
                "Clear Formatting": "Fjern formatering",
                "Fill color or set the text color": "Endre bakgrunns- eller tekstfarge",
                Redo: "Gj\xf8r om",
                Undo: "Angre",
                Bold: "Fet",
                Italic: "Kursiv",
                "Insert Unordered List": "Sett inn punktliste",
                "Insert Ordered List": "Sett inn nummerert liste",
                "Align Center": "Midtstill",
                "Align Justify": "Juster",
                "Align Left": "Venstrejuster",
                "Align Right": "H\xf8yrejuster",
                "Insert Horizontal Line": "Sett inn horisontal linje",
                "Insert Image": "Sett inn bilde",
                "Insert file": "Sett inn fil",
                "Insert youtube/vimeo video": "Sett inn YouTube/Vimeo-video",
                "Insert link": "Sett inn lenke",
                "Font size": "Skriftst\xf8rrelse",
                "Font family": "Skriftfamilie",
                "Insert format block": "Sett inn formateringsblokk",
                Normal: "Normal",
                "Heading 1": "Overskrift 1",
                "Heading 2": "Overskrift 2",
                "Heading 3": "Overskrift 3",
                "Heading 4": "Overskrift 4",
                Quote: "Sitat",
                Code: "Kode",
                Insert: "Sett inn",
                "Insert table": "Sett inn tabell",
                "Decrease Indent": "Reduser innrykk",
                "Increase Indent": "\xd8k innrykk",
                "Select Special Character": "Velg spesialtegn",
                "Insert Special Character": "Sett inn spesialtegn",
                "Paint format": "Kopier format",
                "Change mode": "Bytt modus (WYSIWYG/HTML)",
                Margins: "Marger",
                top: "topp",
                right: "h\xf8yre",
                bottom: "bunn",
                left: "venstre",
                Styles: "Stiler",
                Classes: "Klasser",
                Align: "Justering",
                Right: "H\xf8yre",
                Center: "Senter",
                Left: "Venstre",
                "--Not Set--": "--Ikke satt--",
                Src: "Kilde",
                Title: "Tittel",
                Alternative: "Alternativ",
                Filter: "Filter",
                Link: "Lenke",
                "Open link in new tab": "\xc5pne lenke i ny fane",
                Image: "Bilde",
                file: "fil",
                Advanced: "Avansert",
                "Image properties": "Bildeegenskaper",
                Cancel: "Avbryt",
                Ok: "OK",
                "Your code is similar to HTML. Keep as HTML?": "Koden din ligner HTML. Beholde som HTML?",
                "Paste as HTML": "Lim inn som HTML",
                Keep: "Behold",
                Clean: "Rens",
                "Insert as Text": "Lim inn som tekst",
                "Word Paste Detected": "Word-innliming oppdaget",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Innholdet du limer inn kommer fra et Microsoft Word/Excel-dokument. Vil du beholde formatet eller rense det?",
                "Insert only Text": "Lim inn kun tekst",
                "File Browser": "Filutforsker",
                "Error on load list": "Feil ved lasting av liste",
                "Error on load folders": "Feil ved lasting av mapper",
                "Are you sure?": "Er du sikker?",
                "Enter Directory name": "Skriv inn mappenavn",
                "Create directory": "Opprett mappe",
                "type name": "skriv navn",
                "Drop image": "Slipp bilde",
                "Drop file": "Slipp fil",
                "or click": "eller klikk",
                "Alternative text": "Alternativ tekst",
                Browse: "Bla gjennom",
                Upload: "Last opp",
                Background: "Bakgrunn",
                Border: "Kantlinje",
                Text: "Tekst",
                Top: "Topp",
                Middle: "Midt",
                Bottom: "Bunn",
                "Insert column before": "Sett inn kolonne f\xf8r",
                "Insert column after": "Sett inn kolonne etter",
                "Insert row above": "Sett inn rad over",
                "Insert row below": "Sett inn rad under",
                "Delete table": "Slett tabell",
                "Delete row": "Slett rad",
                "Delete column": "Slett kolonne",
                "Empty cell": "T\xf8m celle",
                "Chars: %d": "Tegn: %d",
                "Words: %d": "Ord: %d",
                Split: "Del",
                "Split vertical": "Del vertikalt",
                "Split horizontal": "Del horisontalt",
                "Strike through": "Gjennomstreking",
                Underline: "Understreking",
                superscript: "hevet skrift",
                subscript: "senket skrift",
                "Cut selection": "Klipp ut markering",
                "Select all": "Velg alt",
                Break: "Pause",
                "Search for": "S\xf8k etter",
                "Replace with": "Erstatt med",
                Replace: "Erstatt",
                Paste: "Lim inn",
                "Choose Content to Paste": "Velg innhold \xe5 lime inn",
                source: "kilde",
                bold: "fet",
                italic: "kursiv",
                brush: "pensel",
                link: "lenke",
                undo: "angre",
                redo: "gj\xf8r om",
                table: "tabell",
                image: "bilde",
                eraser: "viskel\xe6r",
                paragraph: "avsnitt",
                fontsize: "skriftst\xf8rrelse",
                video: "video",
                font: "skrift",
                about: "om redigeringsverkt\xf8yet",
                print: "skriv ut",
                underline: "understreking",
                strikethrough: "gjennomstreking",
                indent: "innrykk",
                outdent: "reduser innrykk",
                fullsize: "full st\xf8rrelse",
                shrink: "krympe",
                hr: "linje",
                ul: "punktliste",
                ol: "nummerert liste",
                cut: "klipp ut",
                selectall: "velg alt",
                "Open link": "\xc5pne lenke",
                "Edit link": "Rediger lenke",
                "No follow": "Ingen oppf\xf8lging",
                Unlink: "Fjern lenke",
                Eye: "Forh\xe5ndsvisning",
                pencil: "Rediger",
                " URL": "URL",
                Reset: "Tilbakestill",
                Save: "Lagre",
                "Save as ...": "Lagre som ...",
                Resize: "Endre st\xf8rrelse",
                Crop: "Beskj\xe6r",
                Width: "Bredde",
                Height: "H\xf8yde",
                "Keep Aspect Ratio": "Behold proporsjoner",
                Yes: "Ja",
                No: "Nei",
                Remove: "Fjern",
                Select: "Velg",
                "Select %s": "Velg: %s",
                Update: "Oppdater",
                "Vertical align": "Vertikal justering",
                Merge: "Sl\xe5 sammen",
                "Add column": "Legg til kolonne",
                "Add row": "Legg til rad",
                Delete: "Slett",
                "Horizontal align": "Horisontal justering",
                "Sort by changed": "Sorter etter endring",
                "Sort by name": "Sorter etter navn",
                "Sort by size": "Sorter etter st\xf8rrelse",
                "Add folder": "Legg til mappe",
                palette: "Palett",
                preview: "Forh\xe5ndsvisning",
                "Line height": "Linjeh\xf8yde",
                "Insert className": "Sett inn klassenavn",
                apply: "Bruk",
                edit: "Rediger",
                "Show all": "Vis alle",
                sound: "Lyd",
                "Interim Results": "Forel\xf8pige resultater",
                default: "Standard",
                circle: "Sirkel",
                dot: "Punkt",
                square: "Firkant",
                "Press Alt for custom resizing": "Trykk p\xe5 Alt for \xe5 endre st\xf8rrelse",
                "Copy selection": "Kopier utvalg",
                "Paste from clipboard": "Lim inn fra utklippstavlen",
                Find: "Finne"
            },
            pl: {
                "Type something": "Napisz co\u015B",
                Advanced: "Zaawansowane",
                "About Jodit": "O Jodit",
                "Jodit Editor": "Edytor Jodit",
                "Jodit User's Guide": "Instrukcja Jodit",
                "contains detailed help for using": "zawiera szczeg\xf3\u0142owe informacje dotycz\u0105ce u\u017Cytkowania.",
                "For information about the license, please go to our website:": "Odwied\u017A nasz\u0105 stron\u0119, aby uzyska\u0107 wi\u0119cej informacji na temat licencji:",
                "Buy full version": "Zakup pe\u0142nej wersji",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Wszystkie prawa zastrze\u017Cone.",
                Anchor: "Kotwica",
                "Open in new tab": "Otw\xf3rz w nowej zak\u0142adce",
                "Open in fullsize": "Otw\xf3rz edytor w pe\u0142nym rozmiarze",
                "Clear Formatting": "Wyczy\u015B\u0107 formatowanie",
                "Fill color or set the text color": "Kolor wype\u0142nienia lub ustaw kolor tekstu",
                Redo: "Pon\xf3w",
                Undo: "Cofnij",
                Bold: "Pogrubienie",
                Italic: "Kursywa",
                "Insert Unordered List": "Wstaw list\u0119 wypunktowan\u0105",
                "Insert Ordered List": "Wstaw list\u0119 numeryczn\u0105",
                "Align Center": "Wy\u015Brodkuj",
                "Align Justify": "Wyjustuj",
                "Align Left": "Wyr\xf3wnaj do lewej",
                "Align Right": "Wyr\xf3wnaj do prawej",
                "Insert Horizontal Line": "Wstaw lini\u0119 poziom\u0105",
                "Insert Image": "Wstaw grafik\u0119",
                "Insert file": "Wstaw plik",
                "Insert youtube/vimeo video": "Wstaw film Youtube/vimeo",
                "Insert link": "Wstaw link",
                "Font size": "Rozmiar tekstu",
                "Font family": "Kr\xf3j czcionki",
                "Insert format block": "Wstaw formatowanie",
                Normal: "Normalne",
                "Heading 1": "Nag\u0142\xf3wek 1",
                "Heading 2": "Nag\u0142\xf3wek 2",
                "Heading 3": "Nag\u0142\xf3wek 3",
                "Heading 4": "Nag\u0142\xf3wek 4",
                Quote: "Cytat",
                Code: "Kod",
                Insert: "Wstaw",
                "Insert table": "Wstaw tabel\u0119",
                "Decrease Indent": "Zmniejsz wci\u0119cie",
                "Increase Indent": "Zwi\u0119ksz wci\u0119cie",
                "Select Special Character": "Wybierz znak specjalny",
                "Insert Special Character": "Wstaw znak specjalny",
                "Paint format": "Malarz format\xf3w",
                "Change mode": "Zmie\u0144 tryb",
                Margins: "Marginesy",
                top: "G\xf3rny",
                right: "Prawy",
                bottom: "Dolny",
                left: "Levy",
                Styles: "Style CSS",
                Classes: "Klasy CSS",
                Align: "Wyr\xf3wnanie",
                Right: "Prawa",
                Center: "\u015Brodek",
                Left: "Lewa",
                "--Not Set--": "brak",
                Src: "\u0179r\xf3d\u0142o",
                Title: "Tytu\u0142",
                Alternative: "Tekst alternatywny",
                Link: "Link",
                "Open link in new tab": "Otw\xf3rz w nowej zak\u0142adce",
                Image: "Grafika",
                file: "Plik",
                "Image properties": "W\u0142a\u015Bciwo\u015Bci grafiki",
                Cancel: "Anuluj",
                Ok: "OK",
                "Your code is similar to HTML. Keep as HTML?": "Tw\xf3j kod wygl\u0105da jak HTML. Zachowa\u0107 HTML?",
                "Paste as HTML": "Wklei\u0107 jako HTML?",
                Keep: "Oryginalny tekst",
                Clean: "Wyczy\u015B\u0107",
                "Insert as Text": "Wstaw jako tekst",
                "Word Paste Detected": "Wykryto tekst w formacie Word",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Wklejany tekst pochodzi z dokumentu Microsoft Word/Excel. Chcesz zachowa\u0107 ten format czy wyczy\u015Bci\u0107 go? ",
                "Insert only Text": "Wstaw tylko tre\u015B\u0107",
                "File Browser": "Przegl\u0105darka plik\xf3w",
                "Error on load list": "B\u0142\u0105d \u0142adowania listy plik\xf3w",
                "Error on load folders": "B\u0142\u0105d \u0142adowania folder\xf3w",
                "Are you sure?": "Czy jeste\u015B pewien?",
                "Enter Directory name": "Wprowad\u017A nazw\u0119 folderu",
                "Create directory": "Utw\xf3rz folder",
                "type name": "wprowad\u017A nazw\u0119",
                "Drop image": "Upu\u015B\u0107 plik graficzny",
                "Drop file": "Upu\u015B\u0107 plik",
                "or click": "lub kliknij tu",
                "Alternative text": "Tekst alternatywny",
                Browse: "Przegl\u0105daj",
                Upload: "Wczytaj",
                Background: "T\u0142o",
                Text: "Tre\u015B\u0107",
                Top: "G\xf3ra",
                Middle: "\u015Arodek",
                Bottom: "D\xf3\u0142",
                "Insert column before": "Wstaw kolumn\u0119 przed",
                "Insert column after": "Wstaw kolumn\u0119 po",
                "Insert row above": "Wstaw wiersz przed",
                "Insert row below": "Wstaw wiersz po",
                "Delete table": "Usu\u0144 tabel\u0119",
                "Delete row": "Usu\u0144 wiersz",
                "Delete column": "Usu\u0144 kolumn\u0119",
                "Empty cell": "Wyczy\u015B\u0107 kom\xf3rk\u0119",
                Delete: "Usu\u0144",
                "Strike through": "Przekre\u015Blenie",
                Underline: "Podkre\u015Blenie",
                Break: "Przerwa",
                "Search for": "Szukaj",
                "Replace with": "Zamie\u0144 na",
                Replace: "Wymieni\u0107",
                Edit: "Edytuj",
                "Vertical align": "Wyr\xf3wnywanie w pionie",
                "Horizontal align": "Wyr\xf3wnywanie w poziomie",
                Filter: "Filtruj",
                "Sort by changed": "Sortuj wg zmiany",
                "Sort by name": "Sortuj wg nazwy",
                "Sort by size": "Sortuj wg rozmiaru",
                "Add folder": "Dodaj folder",
                "Split vertical": "Podziel w pionie",
                "Split horizontal": "Podziel w poziomie",
                Split: "Podziel",
                Merge: "Scal",
                "Add column": "Dodaj kolumn\u0119",
                "Add row": "Dodaj wiersz",
                Border: "Obramowanie",
                "Embed code": "Wstaw kod",
                Update: "Aktualizuj",
                superscript: "indeks g\xf3rny",
                subscript: "index dolny",
                "Cut selection": "Wytnij zaznaczenie",
                Paste: "Wklej",
                "Choose Content to Paste": "Wybierz zawarto\u015B\u0107 do wklejenia",
                "Chars: %d": "Znaki: %d",
                "Words: %d": "S\u0142owa: %d",
                All: "Wszystko",
                "Select %s": "Wybierz: %s",
                "Select all": "Wybierz wszystko",
                source: "HTML",
                bold: "pogrubienie",
                italic: "kursywa",
                brush: "p\u0119dzel",
                link: "link",
                undo: "cofnij",
                redo: "pon\xf3w",
                table: "tabela",
                image: "grafika",
                eraser: "wyczy\u015B\u0107",
                paragraph: "akapit",
                fontsize: "rozmiar czcionki",
                video: "wideo",
                font: "czcionka",
                about: "O programie",
                print: "drukuj",
                underline: "podkre\u015Blenie",
                strikethrough: "przekre\u015Blenie",
                indent: "wci\u0119cie",
                outdent: "wyci\u0119cie",
                fullsize: "pe\u0142en rozmiar",
                shrink: "przytnij",
                hr: "linia pozioma",
                ul: "lista",
                ol: "lista numerowana",
                cut: "wytnij",
                selectall: "zaznacz wszystko",
                "Open link": "otw\xf3rz link",
                "Edit link": "edytuj link",
                "No follow": "Atrybut no-follow",
                Unlink: "Usu\u0144 link",
                Eye: "szukaj",
                pencil: "edytuj",
                " URL": "URL",
                Reset: "wyczy\u015B\u0107",
                Save: "zapisz",
                "Save as ...": "zapisz jako",
                Resize: "Zmie\u0144 rozmiar",
                Crop: "Przytnij",
                Width: "Szeroko\u015B\u0107",
                Height: "Wysoko\u015B\u0107",
                "Keep Aspect Ratio": "Zachowaj proporcje",
                Yes: "Tak",
                No: "Nie",
                Remove: "Usu\u0144",
                Select: "Wybierz",
                "You can only edit your own images. Download this image on the host?": "Mo\u017Cesz edytowa\u0107 tylko swoje grafiki. Czy chcesz pobra\u0107 t\u0105 grafik\u0119?",
                "The image has been successfully uploaded to the host!": "Grafika zosta\u0142a pomy\u015Blnienie dodana na serwer",
                palette: "Paleta",
                "There are no files": "Brak plik\xf3w.",
                Rename: "zmie\u0144 nazw\u0119",
                "Enter new name": "Wprowad\u017A now\u0105 nazw\u0119",
                preview: "podgl\u0105d",
                download: "pobierz",
                "Paste from clipboard": "Wklej ze schowka",
                "Your browser doesn't support direct access to the clipboard.": "Twoja przegl\u0105darka nie obs\u0142uguje schowka",
                "Copy selection": "Kopiuj zaznaczenie",
                copy: "kopiuj",
                "Border radius": "Zaokr\u0105glenie kraw\u0119dzi",
                "Show all": "Poka\u017C wszystkie",
                Apply: "Zastosuj",
                "Please fill out this field": "Prosz\u0119 wype\u0142ni\u0107 to pole",
                "Please enter a web address": "Prosz\u0119, wpisz adres sieci web",
                Default: "Domy\u015Blnie",
                Circle: "Ko\u0142o",
                Dot: "Punkt",
                Quadrate: "Kwadrat",
                Find: "Znale\u017A\u0107",
                "Find Previous": "Znale\u017A\u0107 Poprzednie",
                "Find Next": "Znajd\u017A Dalej",
                "Insert className": "Wstaw nazw\u0119 zaj\u0119\u0107",
                "Press Alt for custom resizing": "Naci\u015Bnij Alt, aby zmieni\u0107 rozmiar"
            },
            pt_br: {
                "Type something": "Escreva algo...",
                Advanced: "Avan\xe7ado",
                "About Jodit": "Sobre o Jodit",
                "Jodit Editor": "Editor Jodit",
                "Jodit User's Guide": "Guia de usu\xe1rio Jodit",
                "contains detailed help for using": "cont\xe9m ajuda detalhada para o uso.",
                "For information about the license, please go to our website:": "Para informa\xe7\xe3o sobre a licen\xe7a, por favor visite nosso site:",
                "Buy full version": "Compre a vers\xe3o completa",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Todos os direitos reservados.",
                Anchor: "Link",
                "Open in new tab": "Abrir em nova aba",
                "Open in fullsize": "Abrir editor em tela cheia",
                "Clear Formatting": "Limpar formata\xe7\xe3o",
                "Fill color or set the text color": "Cor de preenchimento ou cor do texto",
                Redo: "Refazer",
                Undo: "Desfazer",
                Bold: "Negrito",
                Italic: "It\xe1lico",
                "Insert Unordered List": "Inserir lista n\xe3o ordenada",
                "Insert Ordered List": "Inserir lista ordenada",
                "Align Center": "Centralizar",
                "Align Justify": "Justificar",
                "Align Left": "Alinhar \xe0 Esquerda",
                "Align Right": "Alinhar \xe0 Direita",
                "Insert Horizontal Line": "Inserir linha horizontal",
                "Insert Image": "Inserir imagem",
                "Insert file": "Inserir arquivo",
                "Insert youtube/vimeo video": "Inserir v\xeddeo do Youtube/vimeo",
                "Insert link": "Inserir link",
                "Font size": "Tamanho da letra",
                "Font family": "Fonte",
                "Insert format block": "Inserir bloco",
                Normal: "Normal",
                "Heading 1": "Cabe\xe7alho 1",
                "Heading 2": "Cabe\xe7alho 2",
                "Heading 3": "Cabe\xe7alho 3",
                "Heading 4": "Cabe\xe7alho 4",
                Quote: "Cita\xe7\xe3o",
                Code: "C\xf3digo",
                Insert: "Inserir",
                "Insert table": "Inserir tabela",
                "Decrease Indent": "Diminuir recuo",
                "Increase Indent": "Aumentar recuo",
                "Select Special Character": "Selecionar caractere especial",
                "Insert Special Character": "Inserir caractere especial",
                "Paint format": "Copiar formato",
                "Change mode": "Mudar modo",
                Margins: "Margens",
                top: "cima",
                right: "direta",
                bottom: "baixo",
                left: "esquerda",
                Styles: "Estilos CSS",
                Classes: "Classes CSS",
                Align: "Alinhamento",
                Right: "Direita",
                Center: "Centro",
                Left: "Esquerda",
                "--Not Set--": "--N\xe3o Estabelecido--",
                Src: "Fonte",
                Title: "T\xedtulo",
                Alternative: "Texto Alternativo",
                Link: "Link",
                "Open link in new tab": "Abrir link em nova aba",
                Image: "Imagem",
                file: "Arquivo",
                "Image properties": "Propriedades da imagem",
                Cancel: "Cancelar",
                Ok: "Ok",
                "Your code is similar to HTML. Keep as HTML?": "Seu c\xf3digo \xe9 similar ao HTML. Manter como HTML?",
                "Paste as HTML": "Colar como HTML?",
                Keep: "Manter",
                Clean: "Limpar",
                "Insert as Text": "Inserir como Texto",
                "Word Paste Detected": "Colado do Word Detectado",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "O conte\xfado colado veio de um documento Microsoft Word/Excel. Voc\xea deseja manter o formato ou limpa-lo?",
                "Insert only Text": "Inserir somente o Texto",
                "File Browser": "Procurar arquivo",
                "Error on load list": "Erro ao carregar a lista",
                "Error on load folders": "Erro ao carregar as pastas",
                "Are you sure?": "Voc\xea tem certeza?",
                "Enter Directory name": "Escreva o nome da pasta",
                "Create directory": "Criar pasta",
                "type name": "Escreva seu nome",
                "Drop image": "Soltar imagem",
                "Drop file": "Soltar arquivo",
                "or click": "ou clique",
                "Alternative text": "Texto alternativo",
                Browse: "Explorar",
                Upload: "Upload",
                Background: "Fundo",
                Text: "Texto",
                Top: "Cima",
                Middle: "Meio",
                Bottom: "Baixo",
                "Insert column before": "Inserir coluna antes",
                "Insert column after": "Inserir coluna depois",
                "Insert row above": "Inserir linha acima",
                "Insert row below": "Inserir linha abaixo",
                "Delete table": "Excluir tabela",
                "Delete row": "Excluir linha",
                "Delete column": "Excluir coluna",
                "Empty cell": "Limpar c\xe9lula",
                Delete: "Excluir",
                "Strike through": "Tachado",
                Underline: "Sublinhar",
                Break: "Pausa",
                "Search for": "Procurar por",
                "Replace with": "Substituir com",
                Replace: "Substituir",
                Edit: "Editar",
                "Vertical align": "Alinhamento vertical",
                "Horizontal align": "Alinhamento horizontal",
                Filter: "filtrar",
                "Sort by changed": "Ordenar por modifica\xe7\xe3o",
                "Sort by name": "Ordenar por nome",
                "Sort by size": "Ordenar por tamanho",
                "Add folder": "Adicionar pasta",
                Split: "Dividir",
                "Split vertical": "Dividir vertical",
                "Split horizontal": "Dividir horizontal",
                Merge: "Mesclar",
                "Add column": "Adicionar coluna",
                "Add row": "Adicionar linha",
                Border: "Borda",
                "Embed code": "Incluir c\xf3digo",
                Update: "Atualizar",
                superscript: "sobrescrito",
                subscript: "subscrito",
                "Cut selection": "Cortar sele\xe7\xe3o",
                Paste: "Colar",
                "Choose Content to Paste": "Escolher conte\xfado para colar",
                "Chars: %d": "Caracteres: %d",
                "Words: %d": "Palavras: %d",
                All: "Tudo",
                "Select %s": "Selecionar: %s",
                "Select all": "Selecionar tudo",
                source: "HTML",
                bold: "negrito",
                italic: "it\xe1lico",
                brush: "pincel",
                link: "link",
                undo: "desfazer",
                redo: "refazer",
                table: "tabela",
                image: "imagem",
                eraser: "apagar",
                paragraph: "par\xe1grafo",
                fontsize: "tamanho da letra",
                video: "v\xeddeo",
                font: "fonte",
                about: "Sobre de",
                print: "Imprimir",
                underline: "sublinhar",
                strikethrough: "tachado",
                indent: "recuar",
                outdent: "diminuir recuo",
                fullsize: "Tamanho completo",
                shrink: "diminuir",
                hr: "linha horizontal",
                ul: "lista n\xe3o ordenada",
                ol: "lista ordenada",
                cut: "Cortar",
                selectall: "Selecionar tudo",
                "Open link": "Abrir link",
                "Edit link": "Editar link",
                "No follow": "N\xe3o siga",
                Unlink: "Remover link",
                Eye: "Visualizar",
                pencil: "Editar",
                " URL": "URL",
                Reset: "Resetar",
                Save: "Salvar",
                "Save as ...": "Salvar como...",
                Resize: "Redimensionar",
                Crop: "Recortar",
                Width: "Largura",
                Height: "Altura",
                "Keep Aspect Ratio": "Manter a propor\xe7\xe3o",
                Yes: "Sim",
                No: "N\xe3o",
                Remove: "Remover",
                Select: "Selecionar",
                "You can only edit your own images. Download this image on the host?": "Voc\xea s\xf3 pode editar suas pr\xf3prias imagens. Baixar essa imagem pro servidor?",
                "The image has been successfully uploaded to the host!": "A imagem foi enviada com sucesso para o servidor!",
                palette: "Palette",
                "There are no files": "N\xe3o h\xe1 arquivos nesse diret\xf3rio.",
                Rename: "H\xfangara",
                "Enter new name": "Digite um novo nome",
                preview: "preview",
                download: "Baixar",
                "Paste from clipboard": "Colar da \xe1rea de transfer\xeancia",
                "Your browser doesn't support direct access to the clipboard.": "O seu navegador n\xe3o oferece suporte a acesso direto para a \xe1rea de transfer\xeancia.",
                "Copy selection": "Selec\xe7\xe3o de c\xf3pia",
                copy: "c\xf3pia",
                "Border radius": "Border radius",
                "Show all": "Mostrar todos os",
                Apply: "Aplicar",
                "Please fill out this field": "Por favor, preencha este campo",
                "Please enter a web address": "Por favor introduza um endere\xe7o web",
                Default: "Padr\xe3o",
                Circle: "C\xedrculo",
                Dot: "Ponto",
                Quadrate: "Quadro",
                "Lower Alpha": "Letra Min\xfascula",
                "Lower Greek": "Grego Min\xfascula",
                "Lower Roman": "Romano Min\xfascula",
                "Upper Alpha": "Letra Mai\xfascula",
                "Upper Roman": "Romano Mai\xfascula",
                Find: "Encontrar",
                "Find Previous": "Encontrar Anteriores",
                "Find Next": "Localizar Pr\xf3xima",
                "Insert className": "Insira o nome da classe",
                "Press Alt for custom resizing": "Pressione Alt para redimensionamento personalizado"
            },
            ru: {
                "Type something": "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0447\u0442\u043E-\u043B\u0438\u0431\u043E",
                "About Jodit": "\u041E Jodit",
                "Jodit Editor": "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 Jodit",
                "Jodit User's Guide": "Jodit \u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
                "contains detailed help for using": "\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043F\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E",
                "For information about the license, please go to our website:": "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043E \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0438 , \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 \u043D\u0430\u0448 \u0441\u0430\u0439\u0442:",
                "Buy full version": "\u041A\u0443\u043F\u0438\u0442\u044C \u043F\u043E\u043B\u043D\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "\u0410\u0432\u0442\u043E\u0440\u0441\u043A\u0438\u0435 \u043F\u0440\u0430\u0432\u0430 \xa9 XDSoft.net - \u0427\u0443\u043F\u0443\u0440\u043D\u043E\u0432 \u0412\u0430\u043B\u0435\u0440\u0438\u0439. \u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B.",
                Anchor: "\u0410\u043D\u043A\u043E\u0440",
                "Open in new tab": "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
                "Open in fullsize": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u0440\u0430\u0437\u043C\u0435\u0440\u0435",
                "Clear Formatting": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
                "Fill color or set the text color": "\u0426\u0432\u0435\u0442 \u0437\u0430\u043B\u0438\u0432\u043A\u0438 \u0438\u043B\u0438 \u0446\u0432\u0435\u0442 \u0442\u0435\u043A\u0441\u0442\u0430",
                Redo: "\u041F\u043E\u0432\u0442\u043E\u0440",
                Undo: "\u041E\u0442\u043C\u0435\u043D\u0430",
                Bold: "\u0416\u0438\u0440\u043D\u044B\u0439",
                Italic: "\u041D\u0430\u043A\u043B\u043E\u043D\u043D\u044B\u0439",
                "Insert Unordered List": "\u0412\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u0430\u0440\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u043F\u0438\u0441\u043A\u0430",
                "Insert Ordered List": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                "Align Center": "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                "Align Justify": "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u0448\u0438\u0440\u0438\u043D\u0435",
                "Align Left": "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u043B\u0435\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                "Align Right": "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u043F\u0440\u0430\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                "Insert Horizontal Line": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0443\u044E \u043B\u0438\u043D\u0438\u044E",
                "Insert Image": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
                "Insert file": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
                "Insert youtube/vimeo video": "\u0412\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0432\u0438\u0434\u0435\u043E",
                "Insert link": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                "Font size": "\u0420\u0430\u0437\u043C\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
                "Font family": "\u0428\u0440\u0438\u0444\u0442",
                "Insert format block": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0431\u043B\u043E\u0447\u043D\u044B\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                Normal: "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442",
                "Heading 1": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 1",
                "Heading 2": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 2",
                "Heading 3": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 3",
                "Heading 4": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 4",
                Quote: "\u0426\u0438\u0442\u0430\u0442\u0430",
                Code: "\u041A\u043E\u0434",
                Insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                "Insert table": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
                "Decrease Indent": "\u0423\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C \u043E\u0442\u0441\u0442\u0443\u043F",
                "Increase Indent": "\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043E\u0442\u0441\u0442\u0443\u043F",
                "Select Special Character": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
                "Insert Special Character": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
                "Paint format": "\u0424\u043E\u0440\u043C\u0430\u0442 \u043A\u0440\u0430\u0441\u043A\u0438",
                "Change mode": "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A",
                Margins: "\u041E\u0442\u0441\u0442\u0443\u043F\u044B",
                top: "\u0441\u0432\u0435\u0440\u0445\u0443",
                right: "\u0441\u043F\u0440\u0430\u0432\u0430",
                bottom: "\u0441\u043D\u0438\u0437\u0443",
                left: "\u0441\u043B\u0435\u0432\u0430",
                Styles: "\u0421\u0442\u0438\u043B\u0438",
                Classes: "\u041A\u043B\u0430\u0441\u0441\u044B",
                Align: "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                Right: "\u041F\u043E \u043F\u0440\u0430\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                Center: "\u041F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                Left: "\u041F\u043E \u043B\u0435\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                "--Not Set--": "--\u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C--",
                Src: "src",
                Title: "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
                Alternative: "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 (alt)",
                Link: "\u0421\u0441\u044B\u043B\u043A\u0430",
                "Open link in new tab": "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
                file: "\u0424\u0430\u0439\u043B",
                Advanced: "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0435",
                "Image properties": "\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                Cancel: "\u041E\u0442\u043C\u0435\u043D\u0430",
                Ok: "\u041E\u043A",
                "Your code is similar to HTML. Keep as HTML?": "\u0412\u0430\u0448 \u0442\u0435\u043A\u0441\u0442, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u043F\u044B\u0442\u0430\u0435\u0442\u0435\u0441\u044C \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0445\u043E\u0436 \u043D\u0430 HTML. \u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0433\u043E \u043A\u0430\u043A HTML?",
                "Paste as HTML": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043A HTML?",
                Keep: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B",
                Clean: "\u041F\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                "Insert as Text": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043A \u0442\u0435\u043A\u0441\u0442",
                "Insert only Text": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u0435\u043A\u0441\u0442",
                "Word Paste Detected": "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u044D\u0442\u043E \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442 Word \u0438\u043B\u0438 Excel",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u041A\u043E\u043D\u0442\u0435\u043D\u0442 \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u0432\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0435 \u043F\u043E\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0438\u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 Microsoft Word / Excel. \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442 \u0438\u043B\u0438 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0435\u0433\u043E?",
                "File Browser": "\u0411\u0440\u0430\u0443\u0437\u0435\u0440 \u0444\u0430\u0439\u043B\u043E\u0432",
                "Error on load list": "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043F\u0438\u0441\u043A\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439",
                "Error on load folders": "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043F\u0438\u0441\u043A\u0430 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u0439",
                "Are you sure?": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?",
                "Enter Directory name": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u0438",
                "Create directory": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u044E",
                "type name": "\u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
                "Drop image": "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0441\u044E\u0434\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
                "Drop file": "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0441\u044E\u0434\u0430 \u0444\u0430\u0439\u043B",
                "or click": "\u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435",
                "Alternative text": "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442",
                Browse: "\u0421\u0435\u0440\u0432\u0435\u0440",
                Upload: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
                Background: "\u0424\u043E\u043D",
                Text: "\u0422\u0435\u043A\u0441\u0442",
                Top: " \u041A \u0432\u0435\u0440\u0445\u0443",
                Middle: "\u041F\u043E \u0441\u0435\u0440\u0435\u0434\u0438\u043D\u0435",
                Bottom: "\u041A \u043D\u0438\u0437\u0443",
                "Insert column before": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 \u0434\u043E",
                "Insert column after": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 \u043F\u043E\u0441\u043B\u0435",
                "Insert row above": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0440\u044F\u0434 \u0432\u044B\u0448\u0435",
                "Insert row below": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0440\u044F\u0434 \u043D\u0438\u0436\u0435",
                "Delete table": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
                "Delete row": "\u0423\u0434\u0430\u043B\u044F\u0442\u044C \u0440\u044F\u0434",
                "Delete column": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446",
                "Empty cell": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u044F\u0447\u0435\u0439\u043A\u0443",
                source: "HTML",
                bold: "\u0436\u0438\u0440\u043D\u044B\u0439",
                italic: "\u043A\u0443\u0440\u0441\u0438\u0432",
                brush: "\u0437\u0430\u043B\u0438\u0432\u043A\u0430",
                link: "\u0441\u0441\u044B\u043B\u043A\u0430",
                undo: "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
                redo: "\u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
                table: "\u0442\u0430\u0431\u043B\u0438\u0446\u0430",
                image: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
                eraser: "\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                paragraph: "\u043F\u0430\u0440\u0430\u0433\u0440\u0430\u0444",
                fontsize: "\u0440\u0430\u0437\u043C\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
                video: "\u0432\u0438\u0434\u0435\u043E",
                font: "\u0448\u0440\u0438\u0444\u0442",
                about: "\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0435",
                print: "\u043F\u0435\u0447\u0430\u0442\u044C",
                underline: "\u043F\u043E\u0434\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044B\u0439",
                strikethrough: "\u043F\u0435\u0440\u0435\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044B\u0439",
                indent: "\u043E\u0442\u0441\u0442\u0443\u043F",
                outdent: "\u0432\u044B\u0441\u0442\u0443\u043F",
                fullsize: "\u0432\u043E \u0432\u0435\u0441\u044C \u044D\u043A\u0440\u0430\u043D",
                shrink: "\u043E\u0431\u044B\u0447\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440",
                hr: "\u043B\u0438\u043D\u0438\u044F",
                ul: "\u0421\u043F\u0438\u0441\u043E\u043A",
                ol: "\u041D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                cut: "\u0412\u044B\u0440\u0435\u0437\u0430\u0442\u044C",
                selectall: "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435",
                "Embed code": "\u041A\u043E\u0434",
                "Open link": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                "Edit link": "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                "No follow": "\u0410\u0442\u0440\u0438\u0431\u0443\u0442 nofollow",
                Unlink: "\u0423\u0431\u0440\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                Eye: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                pencil: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                Update: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
                " URL": "URL",
                Edit: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                "Horizontal align": "\u0413\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                Filter: "\u0424\u0438\u043B\u044C\u0442\u0440",
                "Sort by changed": "\u041F\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044E",
                "Sort by name": "\u041F\u043E \u0438\u043C\u0435\u043D\u0438",
                "Sort by size": "\u041F\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0443",
                "Add folder": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u043F\u043A\u0443",
                Reset: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
                Save: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
                "Save as ...": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043A\u0430\u043A",
                Resize: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440",
                Crop: "\u041E\u0431\u0440\u0435\u0437\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440",
                Width: "\u0428\u0438\u0440\u0438\u043D\u0430",
                Height: "\u0412\u044B\u0441\u043E\u0442\u0430",
                "Keep Aspect Ratio": "\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u0438",
                Yes: "\u0414\u0430",
                No: "\u041D\u0435\u0442",
                Remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                Select: "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C",
                "Chars: %d": "\u0421\u0438\u043C\u0432\u043E\u043B\u043E\u0432: %d",
                "Words: %d": "\u0421\u043B\u043E\u0432: %d",
                All: "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435",
                "Select %s": "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C: %s",
                "Select all": "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435",
                "Vertical align": "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                Split: "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C",
                "Split vertical": "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u043F\u043E \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0438",
                "Split horizontal": "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u043F\u043E \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u0438",
                Merge: "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0432 \u043E\u0434\u043D\u0443",
                "Add column": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446",
                "Add row": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443",
                Delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                Border: "\u0420\u0430\u043C\u043A\u0430",
                "License: %s": "\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u044F: %s",
                "Strike through": "\u041F\u0435\u0440\u0435\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044C",
                Underline: "\u041F\u043E\u0434\u0447\u0435\u0440\u043A\u0438\u0432\u0430\u043D\u0438\u0435",
                superscript: "\u0432\u0435\u0440\u0445\u043D\u0438\u0439 \u0438\u043D\u0434\u0435\u043A\u0441",
                subscript: "\u0438\u043D\u0434\u0435\u043A\u0441",
                "Cut selection": "\u0412\u044B\u0440\u0435\u0437\u0430\u0442\u044C",
                Break: "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C",
                "Search for": "\u041D\u0430\u0439\u0442\u0438",
                "Replace with": "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430",
                Replace: "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C",
                Paste: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                "Choose Content to Paste": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
                "You can only edit your own images. Download this image on the host?": "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u0432\u043E\u0438 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F. \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u044D\u0442\u043E \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448 \u0441\u0435\u0440\u0432\u0435\u0440?",
                "The image has been successfully uploaded to the host!": "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440!",
                palette: "\u043F\u0430\u043B\u0438\u0442\u0440\u0430",
                "There are no files": "\u0412 \u0434\u0430\u043D\u043D\u043E\u043C \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043D\u0435\u0442 \u0444\u0430\u0439\u043B\u043E\u0432",
                Rename: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C",
                "Enter new name": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u043E\u0435 \u0438\u043C\u044F",
                preview: "\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                download: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
                "Paste from clipboard": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437 \u0431\u0443\u0444\u0435\u0440\u0430 \u043E\u0431\u043C\u0435\u043D\u0430",
                "Your browser doesn't support direct access to the clipboard.": "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043F\u0440\u044F\u043C\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0431\u0443\u0444\u0435\u0440\u0443 \u043E\u0431\u043C\u0435\u043D\u0430.",
                "Copy selection": "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435",
                copy: "\u043A\u043E\u043F\u0438\u044F",
                "Border radius": "\u0420\u0430\u0434\u0438\u0443\u0441 \u0433\u0440\u0430\u043D\u0438\u0446\u044B",
                "Show all": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
                Apply: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C",
                "Please fill out this field": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435",
                "Please enter a web address": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0431-\u0430\u0434\u0440\u0435\u0441",
                Default: "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
                Circle: "\u041A\u0440\u0443\u0433",
                Dot: "\u0422\u043E\u0447\u043A\u0430",
                Quadrate: "\u041A\u0432\u0430\u0434\u0440\u0430\u0442",
                Find: "\u041D\u0430\u0439\u0442\u0438",
                "Find Previous": "\u041D\u0430\u0439\u0442\u0438 \u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435",
                "Find Next": "\u041D\u0430\u0439\u0442\u0438 \u0414\u0430\u043B\u0435\u0435",
                "Insert className": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0430\u0441\u0441\u0430",
                "Press Alt for custom resizing": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 Alt \u0434\u043B\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430"
            },
            tr: {
                "Type something": "Bir \u015Feyler yaz",
                Advanced: "Geli\u015Fmi\u015F",
                "About Jodit": "Jodit Hakk\u0131nda",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "Jodit Kullan\u0131m K\u0131lavuzu",
                "contains detailed help for using": "kullan\u0131m i\xe7in detayl\u0131 bilgiler i\xe7erir",
                "For information about the license, please go to our website:": "Lisans hakk\u0131nda bilgi i\xe7in l\xfctfen web sitemize gidin:",
                "Buy full version": "Tam versiyonunu sat\u0131n al",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. T\xfcm haklar\u0131 sakl\u0131d\u0131r.",
                Anchor: "Ba\u011Flant\u0131",
                "Open in new tab": "Yeni sekmede a\xe7",
                "Open in fullsize": "Edit\xf6r\xfc tam ekranda a\xe7",
                "Clear Formatting": "Stili temizle",
                "Fill color or set the text color": "Renk doldur veya yaz\u0131 rengi se\xe7",
                Redo: "Yinele",
                Undo: "Geri Al",
                Bold: "Kal\u0131n",
                Italic: "\u0130talik",
                "Insert Unordered List": "S\u0131ras\u0131z Liste Ekle",
                "Insert Ordered List": "S\u0131ral\u0131 Liste Ekle",
                "Align Center": "Ortala",
                "Align Justify": "Kenarlara Yasla",
                "Align Left": "Sola Yasla",
                "Align Right": "Sa\u011Fa Yasla",
                "Insert Horizontal Line": "Yatay \xc7izgi Ekle",
                "Insert Image": "Resim Ekle",
                "Insert file": "Dosya Ekle",
                "Insert youtube/vimeo video": "Youtube/Vimeo Videosu Ekle",
                "Insert link": "Ba\u011Flant\u0131 Ekle",
                "Font size": "Font Boyutu",
                "Font family": "Font Ailesi",
                "Insert format block": "Blok Ekle",
                Normal: "Normal",
                "Heading 1": "Ba\u015Fl\u0131k 1",
                "Heading 2": "Ba\u015Fl\u0131k 2",
                "Heading 3": "Ba\u015Fl\u0131k 3",
                "Heading 4": "Ba\u015Fl\u0131k 4",
                Quote: "Al\u0131nt\u0131",
                Code: "Kod",
                Insert: "Ekle",
                "Insert table": "Tablo Ekle",
                "Decrease Indent": "Girintiyi Azalt",
                "Increase Indent": "Girintiyi Artt\u0131r",
                "Select Special Character": "\xd6zel Karakter Se\xe7",
                "Insert Special Character": "\xd6zel Karakter Ekle",
                "Paint format": "Resim Bi\xe7imi",
                "Change mode": "Mod De\u011Fi\u015Ftir",
                Margins: "Bo\u015Fluklar",
                top: "\xdcst",
                right: "Sa\u011F",
                bottom: "Alt",
                left: "Sol",
                Styles: "CSS Stilleri",
                Classes: "CSS S\u0131n\u0131flar\u0131",
                Align: "Hizalama",
                Right: "Sa\u011F",
                Center: "Ortal\u0131",
                Left: "Sol",
                "--Not Set--": "Belirsiz",
                Src: "Kaynak",
                Title: "Ba\u015Fl\u0131k",
                Alternative: "Alternatif Yaz\u0131",
                Link: "Link",
                "Open link in new tab": "Ba\u011Flant\u0131y\u0131 yeni sekmede a\xe7",
                Image: "Resim",
                file: "Dosya",
                "Image properties": "Resim \xf6zellikleri",
                Cancel: "\u0130ptal",
                Ok: "Tamam",
                "Your code is similar to HTML. Keep as HTML?": "Kodunuz HTML koduna benziyor. HTML olarak devam etmek ister misiniz?",
                "Paste as HTML": "HTML olarak yap\u0131\u015Ft\u0131r",
                Keep: "Sakla",
                Clean: "Temizle",
                "Insert as Text": "Yaz\u0131 olarak ekle",
                "Word Paste Detected": "Word bi\xe7iminde yap\u0131\u015Ft\u0131rma alg\u0131land\u0131",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Der Inhalt, den Sie einf\xfcgen, stammt aus einem Microsoft Word / Excel-Dokument. M\xf6chten Sie das Format erhalten oder l\xf6schen?",
                "Insert only Text": "Sadece yaz\u0131y\u0131 ekle",
                "File Browser": "Dosya Listeleyici",
                "Error on load list": "Liste y\xfcklenirken hata olu\u015Ftu",
                "Error on load folders": "Klas\xf6rler y\xfcklenirken hata olu\u015Ftur",
                "Are you sure?": "Emin misiniz?",
                "Enter Directory name": "Dizin yolu giriniz",
                "Create directory": "Dizin olu\u015Ftur",
                "type name": "\u0130sim yaz",
                "Drop image": "Resim b\u0131rak",
                "Drop file": "Dosya b\u0131rak",
                "or click": "veya t\u0131kla",
                "Alternative text": "Alternatif yaz\u0131",
                Browse: "G\xf6zat",
                Upload: "Y\xfckle",
                Background: "Arka plan",
                Text: "Yaz\u0131",
                Top: "\xdcst",
                Middle: "Orta",
                Bottom: "A\u015Fa\u011F\u0131",
                "Insert column before": "\xd6ncesine kolon ekle",
                "Insert column after": "Sonras\u0131na kolon ekle",
                "Insert row above": "\xdcst\xfcne sat\u0131r ekle",
                "Insert row below": "Alt\u0131na sat\u0131r ekle",
                "Delete table": "Tabloyu sil",
                "Delete row": "Sat\u0131r\u0131 sil",
                "Delete column": "Kolonu sil",
                "Empty cell": "H\xfccreyi temizle",
                Delete: "Sil",
                "Strike through": "\xdcst\xfc \xe7izili",
                Underline: "Alt \xe7izgi",
                Break: "Sat\u0131r sonu",
                "Search for": "Ara",
                "Replace with": "\u015Eununla de\u011Fi\u015Ftir",
                Replace: "De\u011Fi\u015Ftir",
                Edit: "D\xfczenle",
                "Vertical align": "Dikey hizala",
                "Horizontal align": "Yatay hizala",
                Filter: "Filtre",
                "Sort by changed": "De\u011Fi\u015Fime g\xf6re s\u0131rala",
                "Sort by name": "\u0130sme g\xf6re s\u0131rala",
                "Sort by size": "Boyuta g\xf6re s\u0131rala",
                "Add folder": "Klas\xf6r ekle",
                Split: "Ay\u0131r",
                "Split vertical": "Dikey ay\u0131r",
                "Split horizontal": "Yatay ay\u0131r",
                Merge: "Birle\u015Ftir",
                "Add column": "Kolon ekle",
                "Add row": "Sat\u0131r ekle",
                Border: "Kenarl\u0131k",
                "Embed code": "Kod ekle",
                Update: "G\xfcncelle",
                superscript: "\xdcst yaz\u0131",
                subscript: "Alt yaz\u0131",
                "Cut selection": "Se\xe7ilimi kes",
                Paste: "Yap\u0131\u015Ft\u0131r",
                "Choose Content to Paste": "Yap\u0131\u015Ft\u0131r\u0131lacak i\xe7erik se\xe7",
                "Chars: %d": "Harfler: %d",
                "Words: %d": "Kelimeler: %d",
                All: "T\xfcm\xfc",
                "Select %s": "Se\xe7: %s",
                "Select all": "T\xfcm\xfcn\xfc se\xe7",
                source: "Kaynak",
                bold: "Kal\u0131n",
                italic: "italik",
                brush: "F\u0131r\xe7a",
                link: "Ba\u011Flant\u0131",
                undo: "Geri al",
                redo: "Yinele",
                table: "Tablo",
                image: "Resim",
                eraser: "Silgi",
                paragraph: "Paragraf",
                fontsize: "Font boyutu",
                video: "Video",
                font: "Font",
                about: "Hakk\u0131nda",
                print: "Yazd\u0131r",
                underline: "Alt \xe7izgi",
                strikethrough: "\xdcst\xfc \xe7izili",
                indent: "Girinti",
                outdent: "\xc7\u0131k\u0131nt\u0131",
                fullsize: "Tam ekran",
                shrink: "K\xfc\xe7\xfclt",
                hr: "Ayra\xe7",
                ul: "S\u0131ras\u0131z liste",
                ol: "S\u0131ral\u0131 liste",
                cut: "Kes",
                selectall: "T\xfcm\xfcn\xfc se\xe7",
                "Open link": "Ba\u011Flant\u0131y\u0131 a\xe7",
                "Edit link": "Ba\u011Flant\u0131y\u0131 d\xfczenle",
                "No follow": "Nofollow \xf6zelli\u011Fi",
                Unlink: "Ba\u011Flant\u0131y\u0131 kald\u0131r",
                Eye: "Yorumu",
                pencil: "D\xfczenlemek i\xe7in",
                " URL": "URL",
                Reset: "S\u0131f\u0131rla",
                Save: "Kaydet",
                "Save as ...": "Farkl\u0131 kaydet",
                Resize: "Boyutland\u0131r",
                Crop: "K\u0131rp",
                Width: "Geni\u015Flik",
                Height: "Y\xfckseklik",
                "Keep Aspect Ratio": "En boy oran\u0131n\u0131 koru",
                Yes: "Evet",
                No: "Hay\u0131r",
                Remove: "Sil",
                Select: "Se\xe7",
                "You can only edit your own images. Download this image on the host?": "Sadece kendi resimlerinizi d\xfczenleyebilirsiniz. Bu g\xf6rseli kendi hostunuza indirmek ister misiniz?",
                "The image has been successfully uploaded to the host!": "G\xf6rsel ba\u015Far\u0131yla hostunuza y\xfcklendi",
                palette: "Palet",
                "There are no files": "Bu dizinde dosya yok",
                Rename: "Yeniden isimlendir",
                "Enter new name": "Yeni isim girin",
                preview: "\xd6n izleme",
                download: "\u0130ndir",
                "Paste from clipboard": "Panodan yap\u0131\u015Ft\u0131r ",
                "Your browser doesn't support direct access to the clipboard.": "Taray\u0131c\u0131n\u0131z panoya do\u011Frudan eri\u015Fimi desteklemiyor.",
                "Copy selection": "Se\xe7imi kopyala",
                copy: "Kopyala",
                "Border radius": "S\u0131n\u0131r yar\u0131\xe7ap\u0131",
                "Show all": "T\xfcm\xfcn\xfc G\xf6ster",
                Apply: "Uygula",
                "Please fill out this field": "L\xfctfen bu alan\u0131 doldurun",
                "Please enter a web address": "L\xfctfen bir web adresi girin",
                Default: "Varsay\u0131lan",
                Circle: "Daire",
                Dot: "Nokta",
                Quadrate: "Kare",
                Find: "Bul",
                "Find Previous": "\xd6ncekini Bul",
                "Find Next": "Sonrakini Bul",
                "Insert className": "S\u0131n\u0131f ad\u0131 girin",
                "Press Alt for custom resizing": "\xd6zel yeniden boyutland\u0131rma i\xe7in Alt tu\u015Funa bas\u0131n"
            },
            ua: {
                "Type something": "\u041D\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u0449\u043E\u0441\u044C",
                "About Jodit": "\u041F\u0440\u043E Jodit",
                "Jodit Editor": "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 Jodit",
                "Jodit User's Guide": "Jodit \u0456\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
                "contains detailed help for using": "\u043C\u0456\u0441\u0442\u0438\u0442\u044C \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u0443 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u0449\u043E\u0434\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                "For information about the license, please go to our website:": "\u0429\u043E\u0431 \u0434\u0456\u0437\u043D\u0430\u0442\u0438\u0441\u044C \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043B\u0456\u0446\u0435\u043D\u0437\u0456\u044E , \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044C \u043D\u0430 \u043D\u0430\u0448 \u0441\u0430\u0439\u0442:",
                "Buy full version": "\u041A\u0443\u043F\u0438\u0442\u0438 \u043F\u043E\u0432\u043D\u0443 \u0432\u0435\u0440\u0441\u0456\u044E",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "\u0410\u0432\u0442\u043E\u0440\u0441\u044C\u043A\u0456 \u043F\u0440\u0430\u0432\u0430 \xa9 XDSoft.net - \u0427\u0443\u043F\u0443\u0440\u043D\u043E\u0432 \u0412\u0430\u043B\u0435\u0440\u0456\u0439. \u0412\u0441\u0456 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0445\u0438\u0449\u0435\u043D\u0456.",
                Anchor: "\u0410\u043D\u043A\u043E\u0440",
                "Open in new tab": "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0443 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
                "Open in fullsize": "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0432 \u043F\u043E\u0432\u043D\u043E\u043C\u0443 \u0440\u043E\u0437\u043C\u0456\u0440\u0456",
                "Clear Formatting": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                "Fill color or set the text color": "\u041A\u043E\u043B\u0456\u0440 \u0437\u0430\u043B\u0438\u0432\u043A\u0438 \u0430\u0431\u043E \u043A\u043E\u043B\u0456\u0440 \u0442\u0435\u043A\u0441\u0442\u0430",
                Redo: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
                Undo: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
                Bold: "\u0416\u0438\u0440\u043D\u0438\u0439",
                Italic: "\u041A\u0443\u0440\u0441\u0456\u0432",
                "Insert Unordered List": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043D\u0435\u0432\u043F\u043E\u0440\u044F\u0434\u043A\u043E\u0432\u0430\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                "Insert Ordered List": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                "Align Center": "\u0412\u0438\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u043F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                "Align Justify": "\u0412\u0438\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u043F\u043E \u0448\u0438\u0440\u0438\u043D\u0456",
                "Align Left": "\u0412\u0438\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u043F\u043E \u043B\u0456\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                "Align Right": "\u0412\u0438\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u043F\u043E \u043F\u0440\u0430\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                "Insert Horizontal Line": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0443 \u043B\u0456\u043D\u0456\u044E",
                "Insert Image": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
                "Insert file": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0444\u0430\u0439\u043B",
                "Insert youtube/vimeo video": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0432\u0456\u0434\u0435\u043E",
                "Insert link": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
                "Font size": "\u0420\u043E\u0437\u043C\u0456\u0440 \u0448\u0440\u0438\u0444\u0442\u0443",
                "Font family": "\u0428\u0440\u0438\u0444\u0442",
                "Insert format block": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0431\u043B\u043E\u0447\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442",
                Normal: "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0442\u0435\u043A\u0441\u0442",
                "Heading 1": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 1",
                "Heading 2": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 2",
                "Heading 3": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 3",
                "Heading 4": "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 4",
                Quote: "\u0426\u0438\u0442\u0430\u0442\u0430",
                Code: "\u041A\u043E\u0434",
                Insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
                "Insert table": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044E",
                "Decrease Indent": "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0432\u0456\u0434\u0441\u0442\u0443\u043F",
                "Increase Indent": "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438 \u0432\u0456\u0434\u0441\u0442\u0443\u043F",
                "Select Special Character": "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
                "Insert Special Character": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
                "Paint format": "\u0424\u043E\u0440\u043C\u0430\u0442 \u043A\u0440\u0430\u0441\u043A\u0438",
                "Change mode": "\u0414\u0436\u0435\u0440\u0435\u043B\u043E",
                Margins: "\u0412\u0456\u0434\u0441\u0442\u0443\u043F\u0438",
                top: "\u0437\u0432\u0435\u0440\u0445\u0443",
                right: "\u0441\u043F\u0440\u0430\u0432\u0430",
                bottom: "\u0437\u043D\u0438\u0437\u0443",
                left: "\u0437\u043B\u0456\u0432\u0430",
                Styles: "\u0421\u0442\u0438\u043B\u0456",
                Classes: "\u041A\u043B\u0430\u0441\u0438",
                Align: "\u0412\u0438\u0440\u0456\u0432\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
                Right: "\u041F\u043E \u043F\u0440\u0430\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                Center: "\u041F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                Left: "\u041F\u043E \u043B\u0456\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                "--Not Set--": "--\u043D\u0435 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E--",
                Src: "src",
                Title: "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
                Alternative: "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u0438\u0439 \u0442\u0435\u043A\u0441\u0442 (alt)",
                Link: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
                "Open link in new tab": "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
                file: "\u0424\u0430\u0439\u043B",
                Advanced: "\u0420\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0456",
                "Image properties": "\u0412\u043B\u0430\u0441\u0442\u0438\u0432\u043E\u0441\u0442\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
                Cancel: "\u0412\u0456\u0434\u043C\u0456\u043D\u0430",
                Ok: "\u041E\u043A",
                "Your code is similar to HTML. Keep as HTML?": "\u0422\u0435\u043A\u0441\u0442, \u044F\u043A\u0438\u0439 \u0412\u0438 \u043D\u0430\u043C\u0430\u0433\u0430\u0454\u0442\u0435\u0441\u044C \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0441\u0445\u043E\u0436\u0438\u0439 \u043D\u0430 HTML. \u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0439\u043E\u0433\u043E \u044F\u043A HTML?",
                "Paste as HTML": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0439\u043E\u0433\u043E \u044F\u043A HTML",
                Keep: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B",
                Clean: "\u041F\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
                "Insert as Text": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u044F\u043A \u0442\u0435\u043A\u0441\u0442",
                "Insert only Text": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0442\u0456\u043B\u044C\u043A\u0438 \u0442\u0435\u043A\u0441\u0442",
                "Word Paste Detected": "\u041C\u043E\u0436\u043B\u0438\u0432\u043E \u0446\u0435 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442 Word \u0430\u0431\u043E Excel",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u0412\u0438 \u0432\u0441\u0442\u0430\u0432\u043B\u044F\u0454\u0442\u0435 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 Microsoft Word \u0430\u0431\u043E Excel. \u0411\u0430\u0436\u0430\u0454\u0442\u0435 \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0443\u0432\u0430\u043D\u043D\u044F?",
                "File Browser": "\u0411\u0440\u0430\u0443\u0437\u0435\u0440 \u0444\u0430\u0439\u043B\u0456\u0432",
                "Error on load list": "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456 \u0441\u043F\u0438\u0441\u043A\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
                "Error on load folders": "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456 \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0430\u043F\u043E\u043A",
                "Are you sure?": "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456?",
                "Enter Directory name": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u043F\u0430\u043F\u043A\u0438",
                "Create directory": "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u043F\u043A\u0443",
                "type name": "\u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443",
                "Drop image": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u044E\u0434\u0438",
                "Drop file": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0441\u044E\u0434\u0438",
                "or click": "\u0430\u0431\u043E \u043A\u043B\u0456\u043A\u043D\u0456\u0442\u044C",
                "Alternative text": "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442",
                Browse: "\u0421\u0435\u0440\u0432\u0435\u0440",
                Upload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
                Background: "\u0424\u043E\u043D",
                Text: "\u0422\u0435\u043A\u0441\u0442",
                Top: " \u0412\u0433\u043E\u0440\u0443",
                Middle: "\u041F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                Bottom: "\u0414\u043E\u043D\u0438\u0437\u0443",
                "Insert column before": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C \u0434\u043E",
                "Insert column after": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C \u043F\u0456\u0441\u043B\u044F",
                "Insert row above": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0440\u044F\u0434\u043E\u043A \u0432\u0438\u0449\u0435",
                "Insert row below": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0440\u044F\u0434\u043E\u043A \u043D\u0438\u0436\u0447\u0435",
                "Delete table": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044E",
                "Delete row": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
                "Delete column": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0447\u0438\u043A",
                "Empty cell": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u043B\u0456\u0438\u043D\u043A\u0443",
                source: "HTML",
                bold: "\u0436\u0438\u0440\u043D\u0438\u0439",
                italic: "\u043A\u0443\u0440\u0441\u0456\u0432",
                brush: "\u0437\u0430\u043B\u0438\u0432\u043A\u0430",
                link: "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
                undo: "\u0432\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
                redo: "\u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
                table: "\u0442\u0430\u0431\u043B\u0438\u0446\u044F",
                image: "\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
                eraser: "\u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F",
                paragraph: "\u043F\u0430\u0440\u0430\u0433\u0440\u0430\u0444",
                fontsize: "\u0440\u043E\u0437\u043C\u0456\u0440 \u0448\u0440\u0438\u0444\u0442\u0443",
                video: "\u0432\u0456\u0434\u0435\u043E",
                font: "\u0448\u0440\u0438\u0444\u0442",
                about: "\u043F\u0440\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440",
                print: "\u0434\u0440\u0443\u043A",
                underline: "\u043F\u0456\u0434\u043A\u0440\u0435\u0441\u043B\u0435\u043D\u0438\u0439",
                strikethrough: "\u0437\u0430\u043A\u0440\u0435\u0441\u043B\u0435\u043D\u0438\u0439",
                indent: "\u0432\u0456\u0434\u0441\u0442\u0443\u043F",
                outdent: "\u0437\u0430\u0441\u0442\u0443\u043F",
                fullsize: "\u043D\u0430 \u0432\u0435\u0441\u044C \u0435\u043A\u0440\u0430\u043D",
                shrink: "\u0437\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439 \u0440\u043E\u0437\u043C\u0456\u0440",
                hr: "\u043B\u0456\u043D\u0456\u044F",
                ul: "\u0421\u043F\u0438\u0441\u043E\u043A",
                ol: "\u041D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                cut: "\u0412\u0438\u0440\u0456\u0437\u0430\u0442\u0438",
                selectall: "\u0412\u0438\u0434\u0456\u043B\u0438\u0442\u0438 \u0432\u0441\u0435",
                "Embed code": "\u041A\u043E\u0434",
                "Open link": "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
                "Edit link": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
                "No follow": "\u0410\u0442\u0440\u0438\u0431\u0443\u0442 nofollow",
                Unlink: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
                Eye: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
                pencil: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F",
                Update: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
                " URL": "URL",
                Edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
                "Horizontal align": "\u0413\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0435 \u0432\u0438\u0440\u0456\u0432\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
                Filter: "\u0424\u0456\u043B\u044C\u0442\u0440",
                "Sort by changed": "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0437\u043C\u0456\u043D\u043E\u044E",
                "Sort by name": "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0456\u043C'\u044F\u043C",
                "Sort by size": "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0440\u043E\u0437\u043C\u0456\u0440\u043E\u043C",
                "Add folder": "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0430\u043F\u043A\u0443",
                Reset: "\u0412\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438",
                Save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
                "Save as ...": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u044F\u043A",
                Resize: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u0440\u043E\u0437\u043C\u0456\u0440",
                Crop: "\u041E\u0431\u0440\u0456\u0437\u0430\u0442\u0438 \u0440\u043E\u0437\u043C\u0456\u0440",
                Width: "\u0428\u0438\u0440\u0438\u043D\u0430",
                Height: "\u0412\u0438\u0441\u043E\u0442\u0430",
                "Keep Aspect Ratio": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0456\u0457",
                Yes: "\u0422\u0430\u043A",
                No: "\u041D\u0456",
                Remove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
                Select: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438",
                "Chars: %d": "\u0421\u0438\u043C\u0432\u043E\u043B\u0456\u0432: %d",
                "Words: %d": "\u0421\u043B\u0456\u0432: %d",
                All: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435",
                "Select %s": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438: %s",
                "Select all": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435",
                "Vertical align": "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u0435 \u0432\u0438\u0440\u0456\u0432\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
                Split: "\u0420\u043E\u0437\u0434\u0456\u043B\u0438\u0442\u0438",
                "Split vertical": "\u0420\u043E\u0437\u0434\u0456\u043B\u0438\u0442\u0438 \u043F\u043E \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0456",
                "Split horizontal": "\u0420\u043E\u0437\u0434\u0456\u043B\u0438\u0442\u0438 \u043F\u043E \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u0456",
                Merge: "\u041E\u0431'\u0454\u0434\u043D\u0430\u0442\u0438 \u0432 \u043E\u0434\u043D\u0443",
                "Add column": "\u0414\u043E\u0434\u0430\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0447\u0438\u043A",
                "Add row": "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
                Delete: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
                Border: "\u0420\u0430\u043C\u043A\u0430",
                "License: %s": "\u041B\u0456\u0446\u0435\u043D\u0437\u0456\u044F: %s",
                "Strike through": "\u0417\u0430\u043A\u0440\u0435\u0441\u043B\u0435\u043D\u0438\u0439",
                Underline: "\u041F\u0456\u0434\u043A\u0440\u0435\u0441\u043B\u0435\u043D\u0438\u0439",
                superscript: "\u0432\u0435\u0440\u0445\u043D\u0456\u0439 \u0456\u043D\u0434\u0435\u043A\u0441",
                subscript: "\u0456\u043D\u0434\u0435\u043A\u0441",
                "Cut selection": "\u041E\u0431\u0440\u0456\u0437\u0430\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0435",
                Break: "\u041C\u0435\u0436\u0430",
                "Search for": "\u0428\u0443\u043A\u0430\u0442\u0438",
                "Replace with": "\u0417\u0430\u043C\u0456\u043D\u0438\u0442\u0438 \u043D\u0430",
                Replace: "\u0417\u0430\u043C\u0456\u043D\u0438\u0442\u0438",
                Paste: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
                "Choose Content to Paste": "\u041E\u0431\u0440\u0430\u0442\u0438 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
                "You can only edit your own images. Download this image on the host?": "\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043B\u0438\u0448\u0435 \u0432\u043B\u0430\u0441\u043D\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F. \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0430 \u0432\u0430\u0448 \u0441\u0435\u0440\u0432\u0435\u0440?",
                "The image has been successfully uploaded to the host!": "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440!",
                palette: "\u043F\u0430\u043B\u0456\u0442\u0440\u0430",
                "There are no files": "\u0424\u0430\u0439\u043B\u0438 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456",
                Rename: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043D\u0430\u0437\u0432\u0443",
                "Enter new name": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u043E\u0432\u0435 \u0456\u043C\u044F'",
                preview: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
                download: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
                "Paste from clipboard": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0437 \u0431\u0443\u0444\u0435\u0440\u0430 \u043E\u0431\u043C\u0456\u043D\u0443",
                "Your browser doesn't support direct access to the clipboard.": "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0431\u0443\u0444\u0435\u0440\u0430 \u043E\u0431\u043C\u0456\u043D\u0443.",
                "Copy selection": "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0432\u0438\u0434\u0456\u043B\u0435\u043D\u0435",
                copy: "\u043A\u043E\u043F\u0456\u044F",
                "Border radius": "\u0420\u0430\u0434\u0456\u0443\u0441 \u0440\u0430\u043C\u043A\u0438",
                "Show all": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0435",
                Apply: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
                "Please fill out this field": "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0446\u0435 \u043F\u043E\u043B\u0435",
                "Please enter a web address": "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0435\u0431-\u0430\u0434\u0440\u0435\u0441\u0443",
                Default: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0435\u043D\u043D\u044F\u043C",
                Circle: "\u041A\u043E\u043B\u043E",
                Dot: "\u041A\u0440\u0430\u043F\u043A\u0430",
                Quadrate: "\u041A\u0432\u0430\u0434\u0440\u0430\u0442",
                Find: "\u0417\u043D\u0430\u0439\u0442\u0438",
                "Find Previous": "\u0417\u043D\u0430\u0439\u0442\u0438 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456",
                "Find Next": "\u0417\u043D\u0430\u0439\u0442\u0438 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0456",
                "Insert className": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043A\u043B\u0430\u0441",
                "Press Alt for custom resizing": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Alt \u0434\u043B\u044F \u0437\u043C\u0456\u043D\u0438 \u0440\u043E\u0437\u043C\u0456\u0440\u0443"
            },
            zh_cn: {
                "Type something": "\u8F93\u5165\u4E00\u4E9B\u5185\u5BB9",
                Advanced: "\u9AD8\u7EA7",
                "About Jodit": "\u5173\u4E8EJodit",
                "Jodit Editor": "Jodit Editor",
                "Free Non-commercial Version": "Free Non-commercial Version",
                "Jodit User's Guide": "\u5F00\u53D1\u8005\u6307\u5357",
                "contains detailed help for using": "\u4F7F\u7528\u5E2E\u52A9",
                "For information about the license, please go to our website:": "\u6709\u5173\u8BB8\u53EF\u8BC1\u7684\u4FE1\u606F\uFF0C\u8BF7\u8BBF\u95EE\u6211\u4EEC\u7684\u7F51\u7AD9\uFF1A",
                "Buy full version": "\u8D2D\u4E70\u5B8C\u6574\u7248\u672C",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. \u7248\u6743\u6240\u6709",
                Anchor: "Anchor",
                "Open in new tab": "\u5728\u65B0\u7A97\u53E3\u6253\u5F00",
                "Open in fullsize": "\u5168\u5C4F\u7F16\u8F91",
                "Clear Formatting": "\u6E05\u9664\u6837\u5F0F",
                "Fill color or set the text color": "\u989C\u8272",
                Redo: "\u91CD\u505A",
                Undo: "\u64A4\u9500",
                Bold: "\u7C97\u4F53",
                Italic: "\u659C\u4F53",
                "Insert Unordered List": "\u7B26\u53F7\u5217\u8868",
                "Insert Ordered List": "\u7F16\u53F7",
                "Align Center": "\u5C45\u4E2D",
                "Align Justify": "\u5BF9\u9F50\u6587\u672C",
                "Align Left": "\u5DE6\u5BF9\u9F50",
                "Align Right": "\u53F3\u5BF9\u9F50",
                "Insert Horizontal Line": "\u5206\u5272\u7EBF",
                "Insert Image": "\u56FE\u7247",
                "Insert file": "\u6587\u4EF6",
                "Insert youtube/vimeo video": "\u89C6\u9891",
                "Insert link": "\u94FE\u63A5",
                "Font size": "\u5B57\u53F7",
                "Font family": "\u5B57\u4F53",
                "Insert format block": "\u683C\u5F0F\u5757",
                Normal: "\u9ED8\u8BA4",
                "Heading 1": "\u6807\u98981",
                "Heading 2": "\u6807\u98982",
                "Heading 3": "\u6807\u98983",
                "Heading 4": "\u6807\u98984",
                Quote: "\u5F15\u7528",
                Code: "\u4EE3\u7801",
                Insert: "\u63D2\u5165",
                "Insert table": "\u8868\u683C",
                "Decrease Indent": "\u51CF\u5C11\u7F29\u8FDB",
                "Increase Indent": "\u589E\u52A0\u7F29\u8FDB",
                "Select Special Character": "\u9009\u62E9\u7279\u6B8A\u7B26\u53F7",
                "Insert Special Character": "\u7279\u6B8A\u7B26\u53F7",
                "Paint format": "\u683C\u5F0F\u590D\u5236",
                "Change mode": "\u6539\u53D8\u6A21\u5F0F",
                Margins: "\u5916\u8FB9\u8DDD\uFF08Margins\uFF09",
                top: "top",
                right: "right",
                bottom: "bottom",
                left: "left",
                Styles: "\u6837\u5F0F",
                Classes: "Classes",
                Align: "\u5BF9\u9F50\u65B9\u5F0F",
                Right: "\u5C45\u53F3",
                Center: "\u5C45\u4E2D",
                Left: "\u5C45\u5DE6",
                "--Not Set--": "\u65E0",
                Src: "Src",
                Title: "Title",
                Alternative: "Alternative",
                Link: "Link",
                "Open link in new tab": "\u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
                Image: "\u56FE\u7247",
                file: "file",
                "Image properties": "\u56FE\u7247\u5C5E\u6027",
                Cancel: "\u53D6\u6D88",
                Ok: "\u786E\u5B9A",
                "Your code is similar to HTML. Keep as HTML?": "\u4F60\u7C98\u8D34\u7684\u6587\u672C\u662F\u4E00\u6BB5html\u4EE3\u7801\uFF0C\u662F\u5426\u4FDD\u7559\u6E90\u683C\u5F0F",
                "Paste as HTML": "html\u7C98\u8D34",
                Keep: "\u4FDD\u7559\u6E90\u683C\u5F0F",
                Clean: "\u5339\u914D\u76EE\u6807\u683C\u5F0F",
                "Insert as Text": "\u628Ahtml\u4EE3\u7801\u89C6\u4E3A\u666E\u901A\u6587\u672C",
                "Word Paste Detected": "\u6587\u672C\u7C98\u8D34",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u6B63\u5728\u7C98\u8D34 Word/Excel \u7684\u6587\u672C\uFF0C\u662F\u5426\u4FDD\u7559\u6E90\u683C\u5F0F\uFF1F",
                "Insert only Text": "\u53EA\u4FDD\u7559\u6587\u672C",
                "File Browser": "\u6587\u4EF6\u7BA1\u7406",
                "Error on load list": "\u52A0\u8F7Dlist\u9519\u8BEF",
                "Error on load folders": "\u52A0\u8F7Dfolders\u9519\u8BEF",
                "Are you sure?": "\u4F60\u786E\u5B9A\u5417\uFF1F",
                "Enter Directory name": "\u8F93\u5165\u8DEF\u5F84",
                "Create directory": "\u521B\u5EFA\u8DEF\u5F84",
                "type name": "type name",
                "Drop image": "\u62D6\u52A8\u56FE\u7247\u5230\u6B64",
                "Drop file": "\u62D6\u52A8\u6587\u4EF6\u5230\u6B64",
                "or click": "\u6216\u70B9\u51FB",
                "Alternative text": "Alternative text",
                Browse: "\u6D4F\u89C8",
                Upload: "\u4E0A\u4F20",
                Background: "\u80CC\u666F\u8272",
                Text: "\u6587\u5B57",
                Top: "\u9876\u90E8",
                Middle: "\u4E2D\u95F4",
                Bottom: "\u5E95\u90E8",
                "Insert column before": "\u5728\u4E4B\u524D\u63D2\u5165\u5217",
                "Insert column after": "\u5728\u4E4B\u540E\u63D2\u5165\u5217",
                "Insert row above": "\u5728\u4E4B\u524D\u63D2\u5165\u884C",
                "Insert row below": "\u5728\u4E4B\u540E\u63D2\u5165\u884C",
                "Delete table": "\u5220\u9664\u8868\u683C",
                "Delete row": "\u5220\u9664\u884C",
                "Delete column": "\u5220\u9664\u5217",
                "Empty cell": "\u6E05\u9664\u5185\u5BB9",
                "Chars: %d": "\u5B57\u7B26\u6570: %d",
                "Words: %d": "\u5355\u8BCD\u6570: %d",
                "Strike through": "\u5220\u9664\u7EBF",
                Underline: "\u4E0B\u5212\u7EBF",
                superscript: "\u4E0A\u6807",
                subscript: "\u4E0B\u6807",
                "Cut selection": "\u526A\u5207",
                "Select all": "\u5168\u9009",
                Break: "Break",
                "Search for": "\u67E5\u627E",
                "Replace with": "\u66FF\u6362\u4E3A",
                Replace: "\u66FF\u6362",
                Edit: "\u7F16\u8F91",
                Paste: "\u7C98\u8D34",
                "Choose Content to Paste": "\u9009\u62E9\u5185\u5BB9\u5E76\u7C98\u8D34",
                All: "\u5168\u90E8",
                source: "\u6E90\u7801",
                bold: "\u7C97\u4F53",
                italic: "\u659C\u4F53",
                brush: "\u989C\u8272",
                link: "\u94FE\u63A5",
                undo: "\u64A4\u9500",
                redo: "\u91CD\u505A",
                table: "\u8868\u683C",
                image: "\u56FE\u7247",
                eraser: "\u6A61\u76AE\u64E6",
                paragraph: "\u6BB5\u843D",
                fontsize: "\u5B57\u53F7",
                video: "\u89C6\u9891",
                font: "\u5B57\u4F53",
                about: "\u5173\u4E8E",
                print: "\u6253\u5370",
                underline: "\u4E0B\u5212\u7EBF",
                strikethrough: "\u4E0A\u51FA\u73B0",
                indent: "\u589E\u52A0\u7F29\u8FDB",
                outdent: "\u51CF\u5C11\u7F29\u8FDB",
                fullsize: "\u5168\u5C4F",
                shrink: "\u6536\u7F29",
                hr: "\u5206\u5272\u7EBF",
                ul: "\u65E0\u5E8F\u5217\u8868",
                ol: "\u987A\u5E8F\u5217\u8868",
                cut: "\u526A\u5207",
                selectall: "\u5168\u9009",
                "Open link": "\u6253\u5F00\u94FE\u63A5",
                "Edit link": "\u7F16\u8F91\u94FE\u63A5",
                "No follow": "No follow",
                Unlink: "\u53D6\u6D88\u94FE\u63A5",
                Eye: "\u9884\u89C8",
                " URL": "URL",
                Reset: "\u91CD\u7F6E",
                Save: "\u4FDD\u5B58",
                "Save as ...": "\u4FDD\u5B58\u4E3A",
                Resize: "\u8C03\u6574\u5927\u5C0F",
                Crop: "\u526A\u5207",
                Width: "\u5BBD",
                Height: "\u9AD8",
                "Keep Aspect Ratio": "\u4FDD\u6301\u957F\u5BBD\u6BD4",
                Yes: "\u662F",
                No: "\u4E0D",
                Remove: "\u79FB\u9664",
                Select: "\u9009\u62E9",
                "Select %s": "\u9009\u62E9: %s",
                Update: "\u66F4\u65B0",
                "Vertical align": "\u5782\u76F4\u5BF9\u9F50",
                Merge: "\u5408\u5E76",
                "Add column": "\u6DFB\u52A0\u5217",
                "Add row": "\u6DFB\u52A0\u884C",
                Border: "\u8FB9\u6846",
                "Embed code": "\u5D4C\u5165\u4EE3\u7801",
                Delete: "\u5220\u9664",
                "Horizontal align": "\u6C34\u5E73\u5BF9\u9F50",
                Filter: "\u7B5B\u9009",
                "Sort by changed": "\u4FEE\u6539\u65F6\u95F4\u6392\u5E8F",
                "Sort by name": "\u540D\u79F0\u6392\u5E8F",
                "Sort by size": "\u5927\u5C0F\u6392\u5E8F",
                "Add folder": "\u65B0\u5EFA\u6587\u4EF6\u5939",
                Split: "\u62C6\u5206",
                "Split vertical": "\u5782\u76F4\u62C6\u5206",
                "Split horizontal": "\u6C34\u5E73\u62C6\u5206",
                "You can only edit your own images. Download this image on the host?": "\u4F60\u53EA\u80FD\u7F16\u8F91\u4F60\u81EA\u5DF1\u7684\u56FE\u7247\u3002Download this image on the host?",
                "The image has been successfully uploaded to the host!": "\u56FE\u7247\u4E0A\u4F20\u6210\u529F",
                palette: "\u8C03\u8272\u677F",
                pencil: "\u94C5\u7B14",
                "There are no files": "\u6B64\u76EE\u5F55\u4E2D\u6C92\u6709\u6587\u4EF6\u3002",
                Rename: "\u91CD\u547D\u540D",
                "Enter new name": "\u8F93\u5165\u65B0\u540D\u79F0",
                preview: "\u9884\u89C8",
                download: "\u4E0B\u8F7D",
                "Paste from clipboard": "\u7C98\u8D34\u4ECE\u526A\u8D34\u677F",
                "Your browser doesn't support direct access to the clipboard.": "\u4F60\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u76F4\u63A5\u8BBF\u95EE\u7684\u526A\u8D34\u677F\u3002",
                "Copy selection": "\u590D\u5236\u9009\u4E2D\u5185\u5BB9",
                copy: "\u590D\u5236",
                "Border radius": "\u8FB9\u754C\u534A\u5F84",
                "Show all": "\u663E\u793A\u6240\u6709",
                Apply: "\u5E94\u7528",
                "Please fill out this field": "\u8BF7\u586B\u5199\u8FD9\u4E2A\u5B57\u6BB5",
                "Please enter a web address": "\u8BF7\u8F93\u5165\u4E00\u4E2A\u7F51\u5740",
                Default: "\u9ED8\u8BA4",
                Circle: "\u5706\u5708",
                Dot: "\u70B9",
                Quadrate: "\u65B9\u5F62",
                Find: "\u641C\u7D22",
                "Find Previous": "\u67E5\u627E\u4E0A\u4E00\u4E2A",
                "Find Next": "\u67E5\u627E\u4E0B\u4E00\u4E2A",
                "Insert className": "\u63D2\u5165\u73ED\u7EA7\u540D\u79F0",
                "Press Alt for custom resizing": "\u6309Alt\u81EA\u5B9A\u4E49\u8C03\u6574\u5927\u5C0F"
            },
            zh_tw: {
                "Type something": "\u8F38\u5165\u4E00\u4E9B\u5167\u5BB9",
                Advanced: "\u9032\u968E",
                "About Jodit": "\u95DC\u65BCJodit",
                "Jodit Editor": "Jodit Editor",
                "Jodit User's Guide": "\u958B\u767C\u8005\u6307\u5357",
                "contains detailed help for using": "\u4F7F\u7528\u5E6B\u52A9",
                "For information about the license, please go to our website:": "\u76F8\u95DC\u6388\u6B0A\u689D\u6B3E\u8CC7\u8A0A\uFF0C\u8ACB\u9020\u8A2A\u6211\u5011\u7684\u7DB2\u7AD9\uFF1A",
                "Buy full version": "\u8CFC\u8CB7\u5B8C\u6574\u7248\u672C",
                "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                Anchor: "\u9328\u9EDE",
                "Open in new tab": "\u5728\u65B0\u5206\u9801\u958B\u555F",
                "Open in fullsize": "\u5168\u87A2\u5E55\u7DE8\u8F2F",
                "Clear Formatting": "\u6E05\u9664\u6A23\u5F0F",
                "Fill color or set the text color": "\u984F\u8272",
                Redo: "\u53D6\u6D88\u5FA9\u539F",
                Undo: "\u5FA9\u539F",
                Bold: "\u7C97\u9AD4",
                Italic: "\u659C\u9AD4",
                "Insert Unordered List": "\u9805\u76EE\u7B26\u865F\u6E05\u55AE",
                "Insert Ordered List": "\u7DE8\u865F\u6E05\u55AE",
                "Align Center": "\u7F6E\u4E2D",
                "Align Justify": "\u6587\u5B57\u5C0D\u9F4A",
                "Align Left": "\u9760\u5DE6",
                "Align Right": "\u9760\u53F3",
                "Insert Horizontal Line": "\u5206\u5272\u7DDA",
                "Insert Image": "\u5716\u7247",
                "Insert file": "\u6A94\u6848",
                "Insert youtube/vimeo video": "\u63D2\u5165 youtube/vimeo \u5F71\u7247",
                "Insert link": "\u63D2\u5165\u9023\u7D50",
                "Font size": "\u6587\u5B57\u5927\u5C0F",
                "Font family": "\u5B57\u578B",
                "Insert format block": "\u683C\u5F0F\u5316\u5340\u584A",
                Normal: "\u5167\u6587",
                "Heading 1": "\u6A19\u984C1",
                "Heading 2": "\u6A19\u984C2",
                "Heading 3": "\u6A19\u984C3",
                "Heading 4": "\u6A19\u984C4",
                Quote: "\u5F15\u6587",
                Code: "\u7A0B\u5F0F\u78BC",
                Insert: "\u63D2\u5165",
                "Insert table": "\u8868\u683C",
                "Decrease Indent": "\u6E1B\u5C11\u7E2E\u6392",
                "Increase Indent": "\u589E\u52A0\u7E2E\u6392",
                "Select Special Character": "\u9078\u64C7\u7279\u6B8A\u7B26\u865F",
                "Insert Special Character": "\u7279\u6B8A\u7B26\u865F",
                "Paint format": "\u683C\u5F0F\u8907\u88FD",
                "Change mode": "\u6AA2\u8996\u539F\u59CB\u78BC",
                Margins: "\u908A\u8DDD",
                top: "\u4E0A",
                right: "\u53F3",
                bottom: "\u4E0B",
                left: "\u5DE6",
                Styles: "\u6A23\u5F0F",
                Classes: "Classes",
                Align: "\u5C0D\u9F4A\u65B9\u5F0F",
                Right: "\u9760\u53F3",
                Center: "\u7F6E\u4E2D",
                Left: "\u9760\u5DE6",
                "--Not Set--": "\u7121",
                Src: "Src",
                Title: "Title",
                Alternative: "\u66FF\u4EE3",
                Link: "Link",
                "Open link in new tab": "\u5728\u65B0\u5206\u9801\u958B\u555F\u9023\u7D50",
                Image: "\u5716\u7247",
                file: "\u6A94\u6848",
                "Image properties": "\u5716\u7247\u5C6C\u6027",
                Cancel: "\u53D6\u6D88",
                Ok: "\u78BA\u5B9A",
                "Your code is similar to HTML. Keep as HTML?": "\u60A8\u7684\u7A0B\u5F0F\u78BC\u8207 HTML \u985E\u4F3C\uFF0C\u662F\u5426\u8CBC\u4E0A HTML \u683C\u5F0F\uFF1F",
                "Paste as HTML": "\u8CBC\u4E0A HTML",
                Keep: "\u4FDD\u7559\u539F\u59CB\u683C\u5F0F",
                Clean: "\u6E05\u9664\u683C\u5F0F",
                "Insert as Text": "\u4EE5\u7D14\u6587\u5B57\u8CBC\u4E0A",
                "Word Paste Detected": "\u8CBC\u4E0A Word \u683C\u5F0F",
                "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "\u6B63\u5728\u8CBC\u4E0A Word/Excel \u6587\u4EF6\u7684\u5167\u5BB9\uFF0C\u662F\u5426\u4FDD\u7559\u539F\u59CB\u683C\u5F0F\uFF1F",
                "Insert only Text": "\u50C5\u8CBC\u4E0A\u5167\u6587",
                "File Browser": "\u6A94\u6848\u700F\u89BD",
                "Error on load list": "\u6E05\u55AE\u8F09\u5165\u932F\u8AA4",
                "Error on load folders": "\u8CC7\u6599\u593E\u8F09\u5165\u932F\u8AA4",
                "Are you sure?": "\u60A8\u78BA\u5B9A\u55CE\uFF1F",
                "Enter Directory name": "\u8F38\u5165\u8DEF\u5F91",
                "Create directory": "\u5275\u5EFA\u8DEF\u5F91",
                "type name": "type name",
                "Drop image": "\u62D6\u66F3\u5716\u7247\u81F3\u6B64",
                "Drop file": "\u62D6\u66F3\u6A94\u6848\u81F3\u6B64",
                "or click": "\u6216\u9EDE\u64CA",
                "Alternative text": "\u66FF\u4EE3\u6587\u5B57",
                Browse: "\u700F\u89BD",
                Upload: "\u4E0A\u50B3",
                Background: "\u80CC\u666F\u8272",
                Text: "\u6587\u5B57",
                Top: "\u9802\u90E8",
                Middle: "\u4E2D\u9593",
                Bottom: "\u5E95\u90E8",
                "Insert column before": "\u63D2\u5165\u5DE6\u65B9\u6B04",
                "Insert column after": "\u63D2\u5165\u53F3\u65B9\u6B04",
                "Insert row above": "\u63D2\u5165\u4E0A\u65B9\u5217",
                "Insert row below": "\u63D2\u5165\u4E0B\u65B9\u5217",
                "Delete table": "\u522A\u9664\u8868\u683C",
                "Delete row": "\u522A\u9664\u6574\u5217",
                "Delete column": "\u522A\u9664\u6574\u6B04",
                "Empty cell": "\u6E05\u9664\u5167\u5BB9",
                "Chars: %d": "\u5B57\u5143\u6578: %d",
                "Words: %d": "\u55AE\u5B57\u6578: %d",
                "Strike through": "\u522A\u9664\u7DDA",
                Underline: "\u5E95\u7DDA",
                superscript: "\u4E0A\u6A19",
                subscript: "\u4E0B\u6A19",
                "Cut selection": "\u526A\u4E0B",
                "Select all": "\u5168\u9078",
                Break: "\u65B7\u884C",
                "Search for": "\u5C0B\u627E",
                "Replace with": "\u53D6\u4EE3\u70BA",
                Replace: "\u53D6\u4EE3",
                Paste: "\u8CBC\u4E0A",
                "Choose Content to Paste": "\u9078\u64C7\u5167\u5BB9\u4E26\u8CBC\u4E0A",
                All: "\u5168\u90E8",
                source: "\u539F\u59CB\u78BC",
                bold: "\u7C97\u9AD4",
                italic: "\u659C\u9AD4",
                brush: "\u984F\u8272",
                link: "\u9023\u7D50",
                undo: "\u5FA9\u539F",
                redo: "\u53D6\u6D88\u5FA9\u539F",
                table: "\u8868\u683C",
                image: "\u5716\u7247",
                eraser: "\u6A61\u76AE\u64E6",
                paragraph: "\u6BB5\u843D",
                fontsize: "\u6587\u5B57\u5927\u5C0F",
                video: "\u5F71\u7247",
                font: "\u5B57\u578B",
                about: "\u95DC\u65BC",
                print: "\u5217\u5370",
                underline: "\u5E95\u7DDA",
                strikethrough: "\u522A\u9664\u7DDA",
                indent: "\u589E\u52A0\u7E2E\u6392",
                outdent: "\u6E1B\u5C11\u7E2E\u6392",
                fullsize: "\u5168\u87A2\u5E55",
                shrink: "\u7E2E\u6E1B",
                hr: "\u5206\u9694\u7DDA",
                ul: "\u9805\u76EE\u7B26\u865F\u6E05\u55AE",
                ol: "\u7DE8\u865F\u6E05\u55AE",
                cut: "\u526A\u4E0B",
                selectall: "\u5168\u9078",
                "Open link": "\u6253\u958B\u9023\u7D50",
                "Edit link": "\u7DE8\u8F2F\u9023\u7D50",
                "No follow": "No follow",
                Unlink: "\u53D6\u6D88\u9023\u7D50",
                Eye: "\u67E5\u770B",
                " URL": "URL",
                Reset: "\u91CD\u8A2D",
                Save: "\u5132\u5B58",
                "Save as ...": "\u53E6\u5B58\u70BA...",
                Resize: "\u8ABF\u6574\u5927\u5C0F",
                Crop: "\u88C1\u5207",
                Width: "\u5BEC",
                Height: "\u9AD8",
                "Keep Aspect Ratio": "\u7DAD\u6301\u9577\u5BEC\u6BD4",
                Yes: "\u662F",
                No: "\u5426",
                Remove: "\u79FB\u9664",
                Select: "\u9078\u64C7",
                "Select %s": "\u9078\u64C7: %s",
                Update: "\u66F4\u65B0",
                "Vertical align": "\u5782\u76F4\u5C0D\u9F4A",
                Merge: "\u5408\u4F75",
                "Add column": "\u65B0\u589E\u6B04",
                "Add row": "\u65B0\u589E\u5217",
                Border: "\u908A\u6846",
                "Embed code": "\u5D4C\u5165\u7A0B\u5F0F\u78BC",
                Delete: "\u522A\u9664",
                "Horizontal align": "\u6C34\u5E73\u5C0D\u9F4A",
                Filter: "\u7BE9\u9078",
                "Sort by changed": "\u4FEE\u6539\u6642\u9593\u6392\u5E8F",
                "Sort by name": "\u540D\u7A31\u6392\u5E8F",
                "Sort by size": "\u5927\u5C0F\u6392\u5E8F",
                "Add folder": "\u65B0\u589E\u8CC7\u6599\u593E",
                Split: "\u5206\u5272",
                "Split vertical": "\u5782\u76F4\u5206\u5272",
                "Split horizontal": "\u6C34\u5E73\u5206\u5272",
                "You can only edit your own images. Download this image on the host?": "\u60A8\u53EA\u80FD\u7DE8\u8F2F\u60A8\u81EA\u5DF1\u7684\u5716\u7247\u3002\u662F\u5426\u4E0B\u8F09\u6B64\u5716\u7247?",
                "The image has been successfully uploaded to the host!": "\u5716\u7247\u4E0A\u50B3\u6210\u529F",
                palette: "\u8ABF\u8272\u76E4",
                pencil: "\u925B\u7B46",
                "There are no files": "\u6C92\u6709\u6A94\u6848",
                Rename: "\u91CD\u65B0\u547D\u540D",
                "Enter new name": "\u8F38\u5165\u65B0\u540D\u7A31",
                preview: "\u9810\u89BD",
                download: "\u4E0B\u8F09",
                "Paste from clipboard": "\u5F9E\u526A\u8CBC\u7C3F\u8CBC\u4E0A",
                "Your browser doesn't support direct access to the clipboard.": "\u700F\u89BD\u5668\u7121\u6CD5\u5B58\u53D6\u526A\u8CBC\u7C3F\u3002",
                "Copy selection": "\u8907\u88FD\u5DF2\u9078\u53D6\u9805\u76EE",
                copy: "\u8907\u88FD",
                "Border radius": "\u908A\u6846\u5713\u89D2",
                "Show all": "\u986F\u793A\u5168\u90E8",
                Apply: "\u61C9\u7528",
                "Please fill out this field": "\u8ACB\u8F38\u5165\u6B64\u6B04\u4F4D",
                "Please enter a web address": "\u8ACB\u8F38\u5165\u7DB2\u5740",
                Default: "\u9810\u8A2D",
                Circle: "\u5713\u5708",
                Dot: "\u9EDE",
                Quadrate: "\u65B9\u5F62",
                Find: "\u5C0B\u627E",
                "Find Previous": "\u5C0B\u627E\u4E0A\u4E00\u500B",
                "Find Next": "\u5C0B\u627E\u4E0B\u4E00\u500B",
                "Insert className": "\u63D2\u5165 class \u540D\u7A31",
                "Press Alt for custom resizing": "\u6309\u4F4F Alt \u4EE5\u8ABF\u6574\u81EA\u8A02\u5927\u5C0F"
            }
        };
        var Og = function(e) {
            return e ? e.default || e : {};
        }, Cg = {};
        Ao(Og(Sg)) && Og(Sg).forEach(function(e, t) {
            Cg[t] = e;
        }), Object.keys(xg).forEach(function(e) {
            var t = Og(xg[e]);
            Ao(t) ? (xg[e] = {}, t.forEach(function(t, o) {
                xg[e][Cg[o]] = t;
            })) : xg[e] = t;
        });
        const zg = xg;
        function Eg(e) {
            return function(t) {
                return !0 !== e.e.fire("backSpaceIsMovedIgnore", t);
            };
        }
        function Tg(e, t, o, n) {
            if (t && pi.isElement(o)) {
                pi.moveContent(t, o, !n, Eg(e));
                for(var r = t; r && r !== e.editor && pi.isEmpty(r);){
                    var i = r.parentElement;
                    pi.safeRemove(r), r = i;
                }
                return !0;
            }
            return !1;
        }
        function Ig(e, t, o) {
            var n = pi.findSibling(t, o), r = pi.findSibling(t, !o);
            if (!pi.closest(t, pi.isElement, e.editor) && pi.isList(n) && pi.isList(r) && pi.isTag(n.lastElementChild, "li") && pi.isTag(r.firstElementChild, "li")) {
                var i = e.s, a = i.setCursorBefore, l = i.setCursorAfter, s = n.lastElementChild, c = r.firstElementChild;
                return dr(o ? pi.prepend : pi.append, c, t), pi.moveContent(r, n, !o, Eg(e)), pi.safeRemove(r), dr(o ? pi.append : pi.prepend, s, t), dr(o ? a : l, t), !0;
            }
            return !1;
        }
        function Pg(e, t, o, n) {
            var r, i, a, l = o ? -1 : 1, s = pi.sibling(t, !o), c = pi.sibling(t, o), u = null, d = !1;
            for(c || (c = Rg(t, o, e.editor)); c && (pi.isText(c) || pi.isInlineBlock(c));){
                for(; pi.isInlineBlock(c);)c = o ? null == c ? void 0 : c.lastChild : null == c ? void 0 : c.firstChild;
                if (!c) break;
                if ((null === (r = c.nodeValue) || void 0 === r ? void 0 : r.length) && (a = Ag(c, o, l, s), !c.nodeValue.length && pi.isInlineBlock(c.parentNode) && (c.nodeValue = bt)), (null === (i = c.nodeValue) || void 0 === i ? void 0 : i.length) || (u = c), !Bo(a) && a !== bt) {
                    Lg(o, c, t, n, a, e), d = !0;
                    break;
                }
                var f = Rg(c, o, e.editor);
                u && (pi.safeRemove(u), u = null), c = f;
            }
            return u && (pi.safeRemove(u), u = null), d && (function(e) {
                for(var t = e.parentElement; t && pi.isInlineBlock(t) && pi.isTag(t, "a");){
                    var o = t.parentElement;
                    pi.isEmpty(t) && (pi.after(t, e), pi.safeRemove(t)), t = o;
                }
            }(t), function(e, t) {
                t.parentElement !== e.editor && pi.isBlock(t.parentElement) && pi.each(t.parentElement, pi.isEmptyTextNode) && pi.after(t, e.createInside.element("br"));
            }(e, t), e.s.setCursorBefore(t), pi.isTag(t.previousSibling, "br") && !pi.findNotEmptySibling(t, !1) && pi.after(t, e.createInside.element("br"))), d;
        }
        function Rg(e, t, o) {
            var n = pi.sibling(e, t);
            return !n && e.parentNode && e.parentNode !== o && (n = function(e, t, o) {
                var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], r = function(e) {
                    return t ? e.firstChild : e.lastChild;
                }, i = pi.findNotEmptyNeighbor(e, !t, o);
                if (n && pi.isElement(i) && !pi.isInlineBlock(i)) return null;
                if (i) do {
                    if (!r(i)) return i;
                    i = r(i);
                }while (i);
                return null;
            }(e, !t, o, !0)), n;
        }
        function Ag(e, t, o, n) {
            var r = Fo(e.nodeValue), i = r.length, a = t ? i - 1 : 0;
            if (r[a] === bt) for(; r[a] === bt;)a += o;
            var l = r[a];
            if (r[a + o] === bt) {
                for(a += o; r[a] === bt;)a += o;
                a += t ? 1 : -1;
            }
            return function(e, t, o) {
                var n;
                if (!e || !pi.isText(e) || (t ? /^ / : / $/).test(null !== (n = e.nodeValue) && void 0 !== n ? n : "") || !mn(e.nodeValue || "").length) for(var r = t ? o.length - 1 : 0; (t ? r >= 0 : r < o.length) && " " === o[r]; r += t ? -1 : 1)o[r] = yt;
            }(n, t, r = t && a < 0 ? [] : r.slice(t ? 0 : a + 1, t ? a : i)), e.nodeValue = r.join(""), l;
        }
        function Lg(e, t, o, n, r, i) {
            dr(e ? pi.after : pi.before, t, o), ("sentence" === n || "word" === n && " " !== r && r !== yt) && Pg(i, o, e, n);
        }
        function Mg(e, t, o) {
            var n = !1, r = e.s, i = r.setCursorBefore, a = r.setCursorIn, l = pi.closest(t, pi.isElement, e.editor);
            if (!l || !pi.isEmpty(l)) return !1;
            var s = pi.findNotEmptyNeighbor(t, o, e.editor);
            do {
                if (!l || !pi.isEmpty(l) || pi.isCell(l)) break;
                pi.after(l, t);
                var c = pi.closest(l, function(e) {
                    return pi.isElement(e) && e !== l;
                }, e.editor);
                pi.safeRemove(l), n = !0, l = c;
            }while (l);
            return !(!n || !Ig(e, t, o)) || (!s || pi.isText(s) || pi.isTag(s, Pt) ? i(t) : a(s, !o), n);
        }
        rr.prototype.controls.about = {
            exec: function(e) {
                var t = e.dlg({
                    closeOnClickOverlay: !0
                }), o = e.i18n.bind(e);
                t.setMod("theme", e.o.theme).setHeader(o("About Jodit")).setContent('<div class="jodit-about">\n\t\t\t\t\t<div>'.concat(o("Jodit Editor"), " v.").concat(e.getVersion(), "</div>\n\t\t\t\t\t<div>").concat(o("License: %s", rn(e.o.license) ? Yi(e.o.license) : "MIT"), '</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="').concat(vt, '" target="_blank">').concat(vt, '</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="https://xdsoft.net/jodit/docs/" target="_blank">').concat(o("Jodit User's Guide"), "</a>\n\t\t\t\t\t\t").concat(o("contains detailed help for using"), "\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>").concat(o("Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved."), "</div>\n\t\t\t\t</div>")), Ln(t.dialog, {
                    minHeight: 200,
                    minWidth: 420
                }), t.open(!0, !0);
            },
            tooltip: "About Jodit",
            mode: $t + Qt
        }, Ma.add("about", function(e) {
            e.registerButton({
                name: "about",
                group: "info"
            });
        }), Ol.set("about", '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"> <path d="M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"/> </svg> '), rr.prototype.delete = {
            hotkeys: {
                delete: [
                    "delete",
                    "cmd+backspace"
                ],
                deleteWord: [
                    "ctrl+delete",
                    "cmd+alt+backspace",
                    "ctrl+alt+backspace"
                ],
                deleteSentence: [
                    "ctrl+shift+delete",
                    "cmd+shift+delete"
                ],
                backspace: [
                    "backspace"
                ],
                backspaceWord: [
                    "ctrl+backspace"
                ],
                backspaceSentence: [
                    "ctrl+shift+backspace",
                    "cmd+shift+backspace"
                ]
            }
        };
        var Bg = [
            function(e, t, o) {
                var n = pi.findSibling(t, o);
                return !(!pi.isElement(n) || !pi.isTag(n, Pt) && !pi.isEmpty(n) || (pi.safeRemove(n), pi.isTag(n, "br") && !pi.findNotEmptySibling(t, !1) && pi.after(t, e.createInside.element("br")), e.s.setCursorBefore(t), pi.isTag(n, "br") && Mg(e, t, o), 0));
            },
            function(e, t, o) {
                var n = pi.findSibling(t, o);
                return !n && t.parentElement && t.parentElement !== e.editor && (n = pi.findSibling(t.parentElement, o)), !(!pi.isElement(n) || pi.isContentEditable(n, e.editor) || (dr(o ? pi.before : pi.after, n, t), pi.safeRemove(n), Ev(e, t, o), dr(o ? e.s.setCursorBefore : e.s.setCursorAfter, t), 0));
            },
            Pg,
            function(e, t) {
                var o = t.parentElement;
                return !!pi.isCell(o);
            },
            Mg,
            function(e, t, o) {
                var n = pi.closest(t, pi.isElement, e.editor);
                if (!n) return !1;
                var r = pi.findNotEmptySibling(n, o);
                return !(!r || !pi.isEmpty(r) || (pi.safeRemove(r), e.s.setCursorBefore(t), 0));
            },
            Ig,
            function(e, t, o) {
                for(var n = t, r = n; n && !pi.findNotEmptySibling(n, o) && n.parentElement !== e.editor;)r = n = n.parentElement;
                if (pi.isElement(r) && pi.isContentEditable(r, e.editor)) {
                    var i = pi.findNotEmptySibling(r, o);
                    if (i && (function(e, t, o, n) {
                        var r = pi.isTag(o, Tt), i = pi.isTag(t, Tt), a = function(e, t) {
                            return t ? e.firstElementChild : e.lastElementChild;
                        };
                        return i ? (o = e.createInside.element(e.o.enterBlock), pi.before(t, o), Tg(e, a(t, n), o, n)) : !(!o || !r || i) && Tg(e, t, a(o, !n), n);
                    }(e, r, i, o) || Tg(e, r, i, o))) return e.s.setCursorBefore(t), !0;
                }
                return !1;
            },
            function(e, t, o) {
                var n, r = pi.closest(t, pi.isElement, e.editor), i = e.s;
                if (pi.isLeaf(r) && (null === (n = null == r ? void 0 : r.parentElement) || void 0 === n ? void 0 : n[o ? "firstElementChild" : "lastElementChild"]) === r && i.cursorInTheEdge(o, r)) {
                    var a = r.parentElement, l = e.createInside.element(e.o.enterBlock);
                    return dr(o ? pi.before : pi.after, a, l), pi.moveContent(r, l), pi.safeRemove(r), pi.isEmpty(a) && pi.safeRemove(a), dr(o ? i.setCursorBefore : i.setCursorAfter, t), !0;
                }
                return !1;
            }
        ];
        function Dg(e, t, o) {
            return Dg = Vg() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Fg(r, o.prototype), r;
            }, Dg.apply(null, arguments);
        }
        function Ng(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Hg(e) {
            return Hg = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Hg(e);
        }
        function Fg(e, t) {
            return Fg = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Fg(e, t);
        }
        function qg(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return qg = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Dg(e, arguments, Hg(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Fg(n, e);
            }, qg(e);
        }
        function Vg() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Vg = function() {
                return !!e;
            })();
        }
        var Wg = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = Hg(o = t), function(e, t) {
                    var o;
                    return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, Vg() ? Reflect.construct(o, n || [], Hg(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Fg(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.registerCommand("deleteButton", {
                            exec: function() {
                                return t.onDelete(!1);
                            },
                            hotkeys: e.o.delete.hotkeys.delete
                        }, {
                            stopPropagation: !1
                        }).registerCommand("backspaceButton", {
                            exec: function() {
                                return t.onDelete(!0);
                            },
                            hotkeys: e.o.delete.hotkeys.backspace
                        }, {
                            stopPropagation: !1
                        }).registerCommand("deleteWordButton", {
                            exec: function() {
                                return t.onDelete(!1, "word");
                            },
                            hotkeys: e.o.delete.hotkeys.deleteWord
                        }).registerCommand("backspaceWordButton", {
                            exec: function() {
                                return t.onDelete(!0, "word");
                            },
                            hotkeys: e.o.delete.hotkeys.backspaceWord
                        }).registerCommand("deleteSentenceButton", {
                            exec: function() {
                                return t.onDelete(!1, "sentence");
                            },
                            hotkeys: e.o.delete.hotkeys.deleteSentence
                        }).registerCommand("backspaceSentenceButton", {
                            exec: function() {
                                return t.onDelete(!0, "sentence");
                            },
                            hotkeys: e.o.delete.hotkeys.backspaceSentence
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("afterCommand.delete");
                    }
                },
                {
                    key: "onDelete",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "char", o = this.j, n = o.selection;
                        if (n.isFocused() || n.focus(), function(e) {
                            return !e.s.isCollapsed() && (e.execCommand("Delete"), !0);
                        }(o)) return !1;
                        var r = n.range, i = o.createInside.text(bt);
                        try {
                            if (pi.safeInsertNode(r, i), !pi.isOrContains(o.editor, i)) return;
                            if (o.e.fire("backSpaceBeforeCases", e, i)) return !1;
                            if (Ev(o, i, e), Bg.some(function(n) {
                                if (Ro(n) && n(o, i, e, t)) return ft || console.info("Remove case:", n.name), !0;
                            })) return !1;
                        } catch (e) {
                            throw ft || console.error(e), e;
                        } finally{
                            o.e.fire("backSpaceAfterDelete", e, i), this.safeRemoveEmptyNode(i);
                        }
                        return !1;
                    }
                },
                {
                    key: "safeRemoveEmptyNode",
                    value: function(e) {
                        var t, o, n = this.j.s.range;
                        n.startContainer === e && (e.previousSibling ? pi.isText(e.previousSibling) ? n.setStart(e.previousSibling, null !== (o = null === (t = e.previousSibling.nodeValue) || void 0 === t ? void 0 : t.length) && void 0 !== o ? o : 0) : n.setStartAfter(e.previousSibling) : e.nextSibling && (pi.isText(e.nextSibling) ? n.setStart(e.nextSibling, 0) : n.setStartBefore(e.nextSibling)), n.collapse(!0), this.j.s.selectRange(n)), pi.safeRemove(e);
                    }
                }
            ], n && Ng(o.prototype, n), t;
        }(qg(Wp));
        function Ug(e, t, o) {
            return Ug = Xg() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Gg(r, o.prototype), r;
            }, Ug.apply(null, arguments);
        }
        function Yg(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Kg(e) {
            return Kg = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Kg(e);
        }
        function Gg(e, t) {
            return Gg = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Gg(e, t);
        }
        function Jg(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Jg = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Ug(e, arguments, Kg(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Gg(n, e);
            }, Jg(e);
        }
        function Xg() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Xg = function() {
                return !!e;
            })();
        }
        Wg.requires = [
            "hotkeys"
        ], Ma.add("backspace", Wg);
        var Zg = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = Kg(o = t), function(e, t) {
                    var o;
                    return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, Xg() ? Reflect.construct(o, n || [], Kg(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Gg(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.e.on("afterCommand.delete", function(e) {
                            "delete" === e && t.__afterDeleteCommand();
                        }), e.registerCommand("delete", {
                            exec: this.__onDeleteCommand.bind(this)
                        }, {
                            stopPropagation: !1
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("afterCommand.delete");
                    }
                },
                {
                    key: "__afterDeleteCommand",
                    value: function() {
                        var e = this.j, t = e.s.current();
                        if (t && pi.isTag(t.firstChild, "br") && e.s.removeNode(t.firstChild), !(vn(e.editor.textContent || "") || e.editor.querySelector("img,table,jodit,iframe,hr") || t && pi.closest(t, "table", e.editor))) {
                            e.editor.innerHTML = "";
                            var o = e.s.setCursorIn(e.editor);
                            e.s.removeNode(o);
                        }
                    }
                },
                {
                    key: "__onDeleteCommand",
                    value: function() {
                        var e = this.jodit;
                        if (!e.s.isCollapsed()) {
                            e.s.expandSelection();
                            var t = e.s.range;
                            t.deleteContents();
                            var o = e.createInside.fake();
                            t.insertNode(o);
                            var n = pi.findSibling(o, !0), r = pi.findSibling(o, !1);
                            return this.__moveContentInLeftSibling(o, n, r), t.setStartBefore(o), t.collapse(!0), this.__moveCursorInEditableSibling(e, n, o, t), this.__addBrInEmptyBlock(o, r, t), pi.safeRemove(o), e.s.selectRange(t), !1;
                        }
                    }
                },
                {
                    key: "__moveContentInLeftSibling",
                    value: function(e, t, o) {
                        t = this.__defineRightLeftBox(t), !pi.isList(o) && !pi.isTag(o, "table") && pi.isBlock(o) && pi.isBlock(t) && (pi.append(t, e), pi.moveContent(o, t), pi.safeRemove(o)), pi.isList(o) && pi.isLeaf(o.firstElementChild) && pi.isEmpty(o.firstElementChild) && pi.safeRemove(o.firstElementChild);
                    }
                },
                {
                    key: "__defineRightLeftBox",
                    value: function(e) {
                        if (!pi.isList(e)) return e;
                        var t = e.lastElementChild;
                        return pi.isLeaf(t) || (t = this.j.createInside.element("li"), pi.append(e, t)), t;
                    }
                },
                {
                    key: "__addBrInEmptyBlock",
                    value: function(e, t, o) {
                        var n = this.j;
                        if (e.isConnected && pi.isBlock(e.parentNode) && !e.nextSibling && !e.previousSibling) {
                            var r = n.createInside.element("br");
                            pi.after(e, r), o.setStartBefore(r), o.collapse(!0);
                        }
                        if (pi.isTag(t, "table")) {
                            var i = Qr("td,th", t).shift();
                            pi.isCell(i) && pi.isEmpty(i) && pi.append(i, n.createInside.element("br"));
                        }
                    }
                },
                {
                    key: "__moveCursorInEditableSibling",
                    value: function(e, t, o, n) {
                        var r;
                        if (!t || !pi.isText(t)) {
                            var i = null !== (r = pi.closest(o, pi.isBlock, e.editor)) && void 0 !== r ? r : e.editor, a = pi.prev(o, pi.isText, i);
                            a && (n.setStartAfter(a), n.collapse(!0), pi.safeRemove(o));
                        }
                    }
                }
            ], Yg(o.prototype, n), t;
        }(Jg(Wp));
        function Qg(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        Zg.requires = [
            "backspace"
        ], Ma.add("deleteCommand", Zg), rr.prototype.controls.subscript = {
            tags: [
                "sub"
            ],
            tooltip: "subscript"
        }, rr.prototype.controls.superscript = {
            tags: [
                "sup"
            ],
            tooltip: "superscript"
        }, rr.prototype.controls.bold = {
            tagRegExp: /^(strong|b)$/i,
            tags: [
                "strong",
                "b"
            ],
            css: {
                "font-weight": [
                    "bold",
                    "700"
                ]
            },
            tooltip: "Bold"
        }, rr.prototype.controls.italic = {
            tagRegExp: /^(em|i)$/i,
            tags: [
                "em",
                "i"
            ],
            css: {
                "font-style": "italic"
            },
            tooltip: "Italic"
        }, rr.prototype.controls.underline = {
            tagRegExp: /^(u)$/i,
            tags: [
                "u"
            ],
            css: {
                "text-decoration-line": "underline"
            },
            tooltip: "Underline"
        }, rr.prototype.controls.strikethrough = {
            tagRegExp: /^(s)$/i,
            tags: [
                "s"
            ],
            css: {
                "text-decoration-line": "line-through"
            },
            tooltip: "Strike through"
        }, Ma.add("bold", function(e) {
            var t = function(t) {
                var o, n = rr.defaultOptions.controls[t], r = function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                            return Object.getOwnPropertyDescriptor(o, e).enumerable;
                        }))), n.forEach(function(t) {
                            Qg(e, t, o[t]);
                        });
                    }
                    return e;
                }({}, n.css);
                return Object.keys(r).forEach(function(e) {
                    o || (o = {}), o[e] = Ao(r[e]) ? r[e][0] : r[e];
                }), e.s.commitStyle({
                    element: n.tags ? n.tags[0] : void 0
                }), e.synchronizeValues(), !1;
            };
            [
                "bold",
                "italic",
                "underline",
                "strikethrough"
            ].forEach(function(t) {
                e.registerButton({
                    name: t,
                    group: "font-style"
                });
            }), [
                "superscript",
                "subscript"
            ].forEach(function(t) {
                e.registerButton({
                    name: t,
                    group: "script"
                });
            }), e.registerCommand("bold", {
                exec: t,
                hotkeys: [
                    "ctrl+b",
                    "cmd+b"
                ]
            }).registerCommand("italic", {
                exec: t,
                hotkeys: [
                    "ctrl+i",
                    "cmd+i"
                ]
            }).registerCommand("underline", {
                exec: t,
                hotkeys: [
                    "ctrl+u",
                    "cmd+u"
                ]
            }).registerCommand("strikethrough", {
                exec: t
            }).registerCommand("subscript", {
                exec: t
            }).registerCommand("superscript", {
                exec: t
            });
        }), Ol.set("bold", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"/> </svg> ').set("italic", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"/> </svg> ').set("strikethrough", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"/> </svg> ').set("subscript", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm639 217v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z"/> </svg> ').set("superscript", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm637-679v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z"/> </svg> ').set("underline", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"/> </svg> '), Ol.set("palette", '<svg xmlns=\'http://www.w3.org/2000/svg\' x="0px" y="0px" viewBox="0 0 459 459"> <g> <path d="M229.5,0C102,0,0,102,0,229.5S102,459,229.5,459c20.4,0,38.25-17.85,38.25-38.25c0-10.2-2.55-17.85-10.2-25.5 c-5.1-7.65-10.2-15.3-10.2-25.5c0-20.4,17.851-38.25,38.25-38.25h45.9c71.4,0,127.5-56.1,127.5-127.5C459,91.8,357,0,229.5,0z M89.25,229.5c-20.4,0-38.25-17.85-38.25-38.25S68.85,153,89.25,153s38.25,17.85,38.25,38.25S109.65,229.5,89.25,229.5z M165.75,127.5c-20.4,0-38.25-17.85-38.25-38.25S145.35,51,165.75,51S204,68.85,204,89.25S186.15,127.5,165.75,127.5z M293.25,127.5c-20.4,0-38.25-17.85-38.25-38.25S272.85,51,293.25,51s38.25,17.85,38.25,38.25S313.65,127.5,293.25,127.5z M369.75,229.5c-20.4,0-38.25-17.85-38.25-38.25S349.35,153,369.75,153S408,170.85,408,191.25S390.15,229.5,369.75,229.5z" /> </g> </svg> ');
        var $g = function(e, t, o) {
            var n = "jodit-color-picker", r = Wi(o), i = e.c.div(n), a = e.o.textIcons ? "<span>".concat(e.i18n("palette"), "</span>") : Ol.get("palette"), l = function(e) {
                var t = [];
                return cn(e) ? Object.keys(e).forEach(function(o) {
                    t.push('<div class="'.concat(n, "__group ").concat(n, "__group-").concat(o, '">')), t.push(l(e[o])), t.push("</div>");
                }) : Ao(e) && e.forEach(function(e) {
                    t.push("<span class='".concat(n, "__color-item ").concat(r === e ? n + "__color-item_active_true" : "", "' title=\"").concat(e, '" style="background-color:').concat(e, '" data-color="').concat(e, '"></span>'));
                }), t.join("");
            };
            i.appendChild(e.c.fromHTML('<div class="'.concat(n, '__groups">').concat(l(e.o.colors), "</div>"))), i.appendChild(e.c.fromHTML('<div data-ref="extra" class="'.concat(n, '__extra"></div>')));
            var s = ei(i).extra;
            return e.o.showBrowserColorPicker && qo() && (s.appendChild(e.c.fromHTML('<div class="'.concat(n, '__native">').concat(a, '<input type="color" value="#ffffff"/></div>'))), e.e.on(i, "change", function(e) {
                e.stopPropagation();
                var o = e.target;
                if (o && o.tagName && pi.isTag(o, "input")) {
                    var n = o.value || "";
                    Ro(t) && t(n), e.preventDefault();
                }
            })), e.e.on(i, "mousedown touchend", function(o) {
                o.stopPropagation(), o.preventDefault();
                var r = o.target;
                if (r && r.tagName && !pi.isTag(r, "svg") && !pi.isTag(r, "path") || !r.parentNode || (r = pi.closest(r.parentNode, "span", e.editor)), pi.isTag(r, "span") && r.classList.contains(n + "__color-item")) {
                    var i = er(r, "-color") || "";
                    t && Ro(t) && t(i);
                }
            }), e.e.fire("afterGenerateColorPicker", i, s, t, r), i;
        }, em = function(e, t, o) {
            var n = e.c.div("jodit-tabs"), r = e.c.div("jodit-tabs__wrapper"), i = e.c.div("jodit-tabs__buttons");
            er(i, {
                role: "tablist",
                "aria-orientation": "horizontal"
            });
            var a = {}, l = [], s = "";
            n.appendChild(i), n.appendChild(r);
            var c = function(e) {
                a[e] && (l.forEach(function(e) {
                    e.state.activated = !1;
                }), Object.values(a).forEach(function(e) {
                    return e.tab.classList.remove("jodit-tab_active");
                }), a[e].button.state.activated = !0, a[e].tab.classList.add("jodit-tab_active"));
            };
            t.forEach(function(n) {
                var u = n.icon, d = n.name, f = n.content, p = e.c.div("jodit-tab");
                er(p, {
                    role: "tabpanel"
                });
                var h = Es(e, u || d, d);
                h.state.role = "tab", e.e.on(h.container, "pointerdown", function(e) {
                    return e.preventDefault();
                }), s || (s = d), i.appendChild(h.container), l.push(h), h.container.classList.add("jodit-tabs__button", "jodit-tabs__button_columns_" + t.length), Ro(f) ? p.appendChild(e.c.div("jodit-tab_empty")) : p.appendChild(Ua.isInstanceOf(f, Al) ? f.container : f), r.appendChild(p), h.onAction(function() {
                    return c(d), Ro(f) && !pi.isElement(f) && f.call(e), o && (o.activeTab = d), !1;
                }), a[d] = {
                    button: h,
                    tab: p
                };
            }), Object.values(a).forEach(function(e) {
                e.button.container.style.width = (100 / t.length).toFixed(10) + "%";
            });
            var u = o && o.activeTab && a[o.activeTab] ? o.activeTab : s;
            if (c(u), o) {
                var d = o.activeTab;
                Object.defineProperty(o, "activeTab", {
                    configurable: !0,
                    enumerable: !1,
                    get: function() {
                        return d;
                    },
                    set: function(e) {
                        d = e, c(e);
                    }
                });
            }
            return n;
        }, tm = function(e, t, o, n) {
            var r, i = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], a = [];
            if (t.upload && e.o.uploader && (e.o.uploader.url || e.o.uploader.insertImageAsBase64URI)) {
                var l = e.c.fromHTML('<div class="jodit-drag-and-drop__file-box">' + "<strong>".concat(e.i18n(i ? "Drop image" : "Drop file"), "</strong>") + "<span><br>".concat(e.i18n("or click"), "</span>") + '<input type="file" accept="'.concat(i ? "image/*" : "*", '" tabindex="-1" dir="auto" multiple=""/>') + "</div>");
                e.uploader.bind(l, function(o) {
                    var n = Ro(t.upload) ? t.upload : e.o.uploader.defaultHandlerSuccess;
                    Ro(n) && n.call(e, o), e.e.fire("closeAllPopups");
                }, function(t) {
                    e.message.error(t.message), e.e.fire("closeAllPopups");
                }), a.push({
                    icon: "upload",
                    name: "Upload",
                    content: l
                });
            }
            if (t.filebrowser && (e.o.filebrowser.ajax.url || e.o.filebrowser.items.url) && a.push({
                icon: "folder",
                name: "Browse",
                content: function() {
                    n && n(), t.filebrowser && e.filebrowser.open(t.filebrowser, i);
                }
            }), t.url) {
                var s = new zs(e, {
                    type: "submit",
                    variant: "primary",
                    text: "Insert"
                }), c = new Ec(e, [
                    new fc(e, {
                        required: !0,
                        label: "URL",
                        name: "url",
                        type: "text",
                        placeholder: "https://"
                    }),
                    new fc(e, {
                        name: "text",
                        label: "Alternative text"
                    }),
                    new $s(e, [
                        s
                    ])
                ]);
                r = null, !o || pi.isText(o) || pi.isComment(o) || !pi.isTag(o, "img") && !Qr("img", o).length || (r = "IMG" === o.tagName ? o : Qr("img", o)[0], om(c.container, "input[name=url]", er(r, "src")), om(c.container, "input[name=text]", er(r, "alt")), s.state.text = "Update"), o && pi.isTag(o, "a") && (om(c.container, "input[name=url]", er(o, "href")), om(c.container, "input[name=text]", er(o, "title")), s.state.text = "Update"), c.onSubmit(function(o) {
                    Ro(t.url) && t.url.call(e, o.url, o.text);
                }), a.push({
                    icon: "link",
                    name: "URL",
                    content: c.container
                });
            }
            return em(e, a);
        };
        function om(e, t, o) {
            var n = e.querySelector(t);
            return n ? (o && (n.value = o), n.value) : "";
        }
        function nm(e) {
            if (!e) return !1;
            var t = pi.findSibling(e, !0);
            return !(!t || !pi.isTag(t, "br")) && t;
        }
        function rm(e, t) {
            var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : zt, n = e, r = t.editor;
            do {
                if (!n || n === r) break;
                if (o.test(n.nodeName)) return pi.isLeaf(n) ? n : rm(n.parentNode, t, /^li$/i) || n;
                n = n.parentNode;
            }while (n && n !== r);
            return null;
        }
        function im(e, t, o, n) {
            var r = "br" === o.toLowerCase(), i = t.createInside, a = i.element(o), l = i.element("br");
            return r || a.appendChild(l), n && n.cssText && a.setAttribute("style", n.cssText), pi.after(e, a), pi.before(r ? a : l, e), ii(a, t.editor, t.ed), a;
        }
        function am(e, t, o) {
            return am = fm() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && cm(r, o.prototype), r;
            }, am.apply(null, arguments);
        }
        function lm(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function sm(e) {
            return sm = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, sm(e);
        }
        function cm(e, t) {
            return cm = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, cm(e, t);
        }
        function um(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function dm(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return dm = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return am(e, arguments, sm(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), cm(n, e);
            }, dm(e);
        }
        function fm() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (fm = function() {
                return !!e;
            })();
        }
        Ol.set("brush", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zm512-128q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"/> </svg> '), rr.prototype.controls.brushCell = {
            isVisible: function(e) {
                return !e.o.disablePlugins.includes("color");
            },
            icon: "brush",
            popup: function(e, t, o) {
                if (nn(e)) {
                    var n = e.getInstance("Table", e.o).getAllSelectedCells();
                    if (!n.length) return !1;
                    var r = function(t) {
                        return $g(e, function(r) {
                            n.forEach(function(e) {
                                Ln(e, t, r);
                            }), e.lock(), e.synchronizeValues(), o(), e.unlock();
                        }, Ln(n[0], t));
                    };
                    return em(e, [
                        {
                            name: "Background",
                            content: r("background-color")
                        },
                        {
                            name: "Text",
                            content: r("color")
                        },
                        {
                            name: "Border",
                            content: r("border-color")
                        }
                    ]);
                }
            },
            tooltip: "Background"
        }, rr.prototype.controls.brush = {
            isVisible: function(e) {
                return !e.o.disablePlugins.includes("color");
            },
            update: function(e, t) {
                var o = cr(t, "color"), n = function(o, n) {
                    n && n !== Ln(e.editor, o).toString() && (t.state.icon.fill = n);
                };
                if (o) {
                    var r = cr(t, "color");
                    n("color" === r ? r : "background-color", o);
                } else {
                    var i = e.s.current();
                    if (i && !t.state.disabled) {
                        var a = pi.closest(i, pi.isElement, e.editor) || e.editor;
                        n("color", Ln(a, "color").toString()), n("background-color", Ln(a, "background-color").toString());
                    }
                    t.state.icon.fill = "", t.state.activated = !1;
                }
            },
            popup: function(e, t, o, n) {
                var r = "", i = "", a = [], l = null;
                return t && t !== e.editor && pi.isNode(t) && (pi.isElement(t) && e.s.isCollapsed() && !pi.isTag(t, new Set([
                    "br",
                    "hr"
                ])) && (l = t), pi.up(t, function(e) {
                    if (pi.isHTMLElement(e)) {
                        var t = Ln(e, "color", !0), o = Ln(e, "background-color", !0);
                        if (t) return r = t.toString(), !0;
                        if (o) return i = o.toString(), !0;
                    }
                }, e.editor)), a = [
                    {
                        name: "Background",
                        content: $g(e, function(t) {
                            l ? l.style.backgroundColor = t : e.execCommand("background", !1, t), cr(n, "color", t), cr(n, "color-mode", "background"), o();
                        }, i)
                    },
                    {
                        name: "Text",
                        content: $g(e, function(t) {
                            l ? l.style.color = t : e.execCommand("forecolor", !1, t), cr(n, "color", t), cr(n, "color-mode", "color"), o();
                        }, r)
                    }
                ], "background" !== e.o.colorPickerDefaultTab && (a = a.reverse()), em(e, a, l);
            },
            exec: function(e, t, o) {
                var n = o.button, r = cr(n, "color-mode"), i = cr(n, "color");
                if (!r) return !1;
                if (t && t !== e.editor && pi.isNode(t) && pi.isElement(t)) switch(r){
                    case "color":
                        t.style.color = i;
                        break;
                    case "background":
                        t.style.backgroundColor = i;
                }
                else e.execCommand("background" === r ? r : "forecolor", !1, i);
            },
            tooltip: "Fill color or set the text color"
        }, Ma.add("color", function(e) {
            e.registerButton({
                name: "brush",
                group: "color"
            });
            var t = function(t, o, n) {
                var r = Wi(n);
                switch(t){
                    case "background":
                        e.s.commitStyle({
                            attributes: {
                                style: {
                                    backgroundColor: r || ""
                                }
                            }
                        });
                        break;
                    case "forecolor":
                        e.s.commitStyle({
                            attributes: {
                                style: {
                                    color: r || ""
                                }
                            }
                        });
                }
                return e.synchronizeValues(), !1;
            };
            e.registerCommand("forecolor", t).registerCommand("background", t);
        });
        var pm = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = sm(o = t), function(e, t) {
                    return !t || "object" !== um(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, fm() ? Reflect.construct(o, n || [], sm(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && cm(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this, o = e.o.enter.toLowerCase(), n = o === Xt.toLowerCase();
                        e.o.enterBlock || (e.o.enterBlock = n ? Zt : o), e.registerCommand("enter", function(e, o) {
                            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return t.onEnter(n);
                        });
                    }
                },
                {
                    key: "onEnterKeyDown",
                    value: function(e) {
                        if (e.key === Bt) {
                            var t = this.j, o = t.e.fire("beforeEnter", e);
                            return void 0 !== o ? o : (t.s.isCollapsed() || t.execCommand("Delete"), t.s.focus(), this.onEnter(e), t.e.fire("afterEnter", e), t.synchronizeValues(), !1);
                        }
                    }
                },
                {
                    key: "onEnter",
                    value: function(e) {
                        var t = this.jodit, o = t.createInside.fake();
                        try {
                            pi.safeInsertNode(t.s.range, o), function(e, t) {
                                var o = e.s, n = pi.closest(t, [
                                    "a"
                                ], e.editor);
                                n && (o.cursorOnTheRight(n, t) ? pi.after(n, t) : o.cursorOnTheLeft(n, t) && pi.before(n, t));
                            }(t, o);
                            var n = rm(o, t), r = pi.isLeaf(n);
                            if ((!r || (null == e ? void 0 : e.shiftKey)) && function(e, t, o) {
                                var n = Boolean(pi.closest(e, [
                                    "pre",
                                    "blockquote"
                                ], t.editor)), r = !n && pi.closest(e, [
                                    "td",
                                    "th"
                                ], t.editor);
                                if (t.o.enter.toLowerCase() === Xt.toLowerCase() || r || o && !n || !o && n) {
                                    if (n && function(e) {
                                        var t = nm(nm(e));
                                        return !!t && (pi.safeRemove(nm(e)), pi.safeRemove(t), !0);
                                    }(e)) return !1;
                                    var i = t.createInside.element("br");
                                    if (pi.before(e, i), !pi.findNotEmptySibling(i, !1)) {
                                        var a = i.cloneNode();
                                        pi.after(i, a), pi.before(a, e);
                                    }
                                    return ii(i, t.editor, t.ed), !0;
                                }
                                return !1;
                            }(o, t, null == e ? void 0 : e.shiftKey)) return !1;
                            if (n || function(e, t) {
                                return Boolean(pi.prev(e, function(e) {
                                    return pi.isBlock(e) || pi.isImage(e);
                                }, t.editor));
                            }(o, t) || (n = function(e, t) {
                                var o = e;
                                pi.up(o, function(e) {
                                    e && e.hasChildNodes() && e !== t.editor && (o = e);
                                }, t.editor);
                                var n = pi.wrapInline(o, t.o.enter, t);
                                if (pi.isEmpty(n)) {
                                    var r = t.createInside.element("br");
                                    n.appendChild(r), pi.before(r, e);
                                }
                                return n;
                            }(o, t)), !n) return im(o, t, r ? "li" : t.o.enter), !1;
                            if (!function(e, t, o) {
                                return !!pi.canSplitBlock(o) || (pi.before(e, t.createInside.element("br")), !1);
                            }(o, t, n)) return !1;
                            if (r && this.__isEmptyListLeaf(n)) return function(e, t, o) {
                                var n = pi.closest(o, [
                                    "ol",
                                    "ul"
                                ], t.editor);
                                if (n) {
                                    var r = n.parentElement, i = pi.isLeaf(r), a = i ? r : n, l = t.s.createRange();
                                    l.setStartAfter(o), l.setEndAfter(n);
                                    var s = l.extractContents();
                                    pi.after(a, e), pi.safeRemove(o), Qr("li", n).length || pi.safeRemove(n);
                                    var c = im(e, t, i ? "li" : t.o.enter);
                                    s.querySelector("li") && (i ? c.appendChild(s) : pi.after(c, s));
                                }
                            }(o, t, n), !1;
                            !function(e, t, o) {
                                var n = t.s, r = t.o.enter.toLowerCase(), i = pi.isLeaf(o), a = o.tagName.toLowerCase() === r || i, l = n.cursorOnTheRight(o, e), s = n.cursorOnTheLeft(o, e);
                                if (!a && (l || s)) return l ? pi.after(o, e) : pi.before(o, e), im(e, t, r), void (s && !l && pi.prepend(o, e));
                                ii(n.splitSelection(o, e), t.editor, t.ed);
                            }(o, t, n);
                        } finally{
                            o.isConnected && t.s.setCursorBefore(o), pi.safeRemove(o);
                        }
                    }
                },
                {
                    key: "__isEmptyListLeaf",
                    value: function(e) {
                        var t = this.j.e.fire("enterIsEmptyListLeaf", e);
                        return Wo(t) ? t : pi.isEmpty(e);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("keydown.enter");
                    }
                }
            ], n && lm(o.prototype, n), t;
        }(dm(Wp));
        function hm(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function vm(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function gm(e, t, o) {
            return gm = jm() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && ym(r, o.prototype), r;
            }, gm.apply(null, arguments);
        }
        function mm(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function bm(e) {
            return bm = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, bm(e);
        }
        function ym(e, t) {
            return ym = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, ym(e, t);
        }
        function _m(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return _m = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return gm(e, arguments, bm(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), ym(n, e);
            }, _m(e);
        }
        function jm() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (jm = function() {
                return !!e;
            })();
        }
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : um(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            Ca(":keydown.enter")
        ], pm.prototype, "onEnterKeyDown", null), Ma.add("enter", pm), rr.prototype.defaultFontSizePoints = "px", Ol.set("font", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 4-.5 13t-.5 13q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"/> </svg> ').set("fontsize", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zm-1663-1279l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5.5t107.5.5h293q6 0 21 .5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 .5t14 .5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-.5-16.5.5q-17 0-66.5-.5t-74.5-.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 .5-15.5t.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"/> </svg> '), rr.prototype.controls.fontsize = {
            command: "fontsize",
            data: {
                cssRule: "font-size",
                normalise: function(e, t) {
                    return /pt$/i.test(e) && "pt" === t.o.defaultFontSizePoints ? e.replace(/pt$/i, "") : e;
                }
            },
            list: [
                8,
                9,
                10,
                11,
                12,
                14,
                16,
                18,
                24,
                30,
                32,
                34,
                36,
                48,
                60,
                72,
                96
            ],
            textTemplate: function(e, t) {
                return t + e.o.defaultFontSizePoints;
            },
            childTemplate: function(e, t, o) {
                return "".concat(o).concat(e.o.defaultFontSizePoints);
            },
            tooltip: "Font size",
            value: function(e, t) {
                var o, n = e.s.current();
                if (n) {
                    var r = pi.closest(n, pi.isElement, e.editor);
                    if (r) return Ln(r, (null === (o = t.control.data) || void 0 === o ? void 0 : o.cssRule) || "font-size").toString();
                }
            },
            isChildActive: function(e, t) {
                var o, n, r = t.state.value, i = null !== (n = null === (o = t.control.data) || void 0 === o ? void 0 : o.normalize) && void 0 !== n ? n : function(e) {
                    return e;
                };
                return Boolean(r && t.control.args && i(t.control.args[0].toString()) === i(r.toString()));
            },
            isActive: function(e, t) {
                var o, n, r = t.state.value;
                if (!r) return !1;
                var i = null !== (n = null === (o = t.control.data) || void 0 === o ? void 0 : o.normalize) && void 0 !== n ? n : function(e) {
                    return e;
                }, a = t.control.data.cacheListSet;
                if (!a) {
                    var l = Object.keys(t.control.list).map(i);
                    a = new Set(l), t.control.data.cacheListSet = a;
                }
                return a.has(i(r.toString()));
            }
        }, rr.prototype.controls.font = function(e, t) {
            return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : (function(e) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t.push.apply(t, o);
                }
                return t;
            })(Object(t)).forEach(function(o) {
                Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
            }), e;
        }(function(e) {
            for(var t = 1; t < arguments.length; t++){
                var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(o, e).enumerable;
                }))), n.forEach(function(t) {
                    vm(e, t, o[t]);
                });
            }
            return e;
        }({}, rr.prototype.controls.fontsize), {
            command: "fontname",
            textTemplate: function(e, t) {
                return gn(function(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != o) {
                            var n, r, i = [], a = !0, l = !1;
                            try {
                                for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                            } catch (e) {
                                l = !0, r = e;
                            } finally{
                                try {
                                    a || null == o.return || o.return();
                                } finally{
                                    if (l) throw r;
                                }
                            }
                            return i;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return hm(e, t);
                            var o = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? hm(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(t.split(","), 1)[0], "\"'");
            },
            list: {
                "": "Default",
                "Arial, Helvetica, sans-serif": "Arial",
                "'Courier New', Courier, monospace": "Courier New",
                "Georgia, Palatino, serif": "Georgia",
                "'Lucida Sans Unicode', 'Lucida Grande', sans-serif": "Lucida Sans Unicode",
                "Tahoma, Geneva, sans-serif": "Tahoma",
                "'Times New Roman', Times, serif": "Times New Roman",
                "'Trebuchet MS', Helvetica, sans-serif": "Trebuchet MS",
                "Helvetica, sans-serif": "Helvetica",
                "Impact, Charcoal, sans-serif": "Impact",
                "Verdana, Geneva, sans-serif": "Verdana"
            },
            childTemplate: function(e, t, o) {
                var n = !1;
                try {
                    n = -1 === t.indexOf("dings") && document.fonts.check("16px ".concat(t), o);
                } catch (e) {}
                return '<span data-style="'.concat(t, '" style="').concat(n ? "font-family: ".concat(t, "!important;") : "", '">').concat(o, "</span>");
            },
            data: {
                cssRule: "font-family",
                normalize: function(e) {
                    return e.toLowerCase().replace(/['"]+/g, "").replace(/[^a-z0-9-]+/g, ",");
                }
            },
            tooltip: "Font family"
        }), Ma.add("font", function(e) {
            e.registerButton({
                name: "font",
                group: "font"
            }).registerButton({
                name: "fontsize",
                group: "font"
            });
            var t = function(t, o, n) {
                switch(t){
                    case "fontsize":
                        e.s.commitStyle({
                            attributes: {
                                style: {
                                    fontSize: Ji(n, e.o.defaultFontSizePoints)
                                }
                            }
                        });
                        break;
                    case "fontname":
                        e.s.commitStyle({
                            attributes: {
                                style: {
                                    fontFamily: n
                                }
                            }
                        });
                }
                return e.synchronizeValues(), !1;
            };
            e.registerCommand("fontsize", t).registerCommand("fontname", t);
        }), Ol.set("paragraph", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1534 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"/></svg> '), rr.prototype.controls.paragraph = {
            command: "formatBlock",
            value: function(e, t) {
                var o, n, r = t.control, i = e.s.current(), a = pi.closest(i, pi.isBlock, e.editor);
                return null !== (o = null == a ? void 0 : a.nodeName.toLowerCase()) && void 0 !== o ? o : null === (n = r.data) || void 0 === n ? void 0 : n.currentValue;
            },
            update: function(e, t) {
                var o = t.control;
                if (!e.s.current()) return !1;
                var n = t.state.value, r = o.list;
                return cn(r) && r[n.toString()] && e.o.textIcons && (t.state.text = r[n.toString()].toString()), !1;
            },
            data: {
                currentValue: "p"
            },
            list: {
                p: "Paragraph",
                h1: "Heading 1",
                h2: "Heading 2",
                h3: "Heading 3",
                h4: "Heading 4",
                blockquote: "Quote",
                pre: "Code"
            },
            isChildActive: function(e, t) {
                var o, n;
                return Boolean(t.state.value === (null === (n = null === (o = t.control) || void 0 === o ? void 0 : o.args) || void 0 === n ? void 0 : n[0]));
            },
            isActive: function(e, t) {
                return t.state.value !== e.o.enter && cn(t.control.list) && Boolean(t.control.list[t.state.value]);
            },
            childTemplate: function(e, t, o) {
                return "<".concat(t, ' style="margin:0;padding:0"><span>').concat(e.i18n(o), "</span></").concat(t, ">");
            },
            tooltip: "Insert format block"
        }, Ma.add("formatBlock", function(e) {
            e.registerButton({
                name: "paragraph",
                group: "font"
            }), e.registerCommand("formatblock", function(t, o, n) {
                return e.s.commitStyle({
                    element: n
                }), e.synchronizeValues(), !1;
            });
        }), rr.prototype.commandToHotkeys = {
            removeFormat: [
                "ctrl+shift+m",
                "cmd+shift+m"
            ],
            insertOrderedList: [
                "ctrl+shift+7",
                "cmd+shift+7"
            ],
            insertUnorderedList: [
                "ctrl+shift+8, cmd+shift+8"
            ],
            selectall: [
                "ctrl+a",
                "cmd+a"
            ]
        };
        var wm = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = bm(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, jm() ? Reflect.construct(t, o || [], bm(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).onKeyPress = function(t) {
                    var o = e.specialKeys[t.which], n = (t.key || String.fromCharCode(t.which)).toLowerCase(), r = [
                        o || n
                    ];
                    return [
                        "alt",
                        "ctrl",
                        "shift",
                        "meta"
                    ].forEach(function(e) {
                        t[e + "Key"] && o !== e && r.push(e);
                    }), Ui(r.join("+"));
                }, e.specialKeys = {
                    8: "backspace",
                    9: "tab",
                    10: "return",
                    13: "return",
                    16: "shift",
                    17: "ctrl",
                    18: "alt",
                    19: "pause",
                    20: "capslock",
                    27: "esc",
                    32: "space",
                    33: "pageup",
                    34: "pagedown",
                    35: "end",
                    36: "home",
                    37: "left",
                    38: "up",
                    39: "right",
                    40: "down",
                    45: "insert",
                    46: "del",
                    59: ";",
                    61: "=",
                    91: "meta",
                    96: "0",
                    97: "1",
                    98: "2",
                    99: "3",
                    100: "4",
                    101: "5",
                    102: "6",
                    103: "7",
                    104: "8",
                    105: "9",
                    106: "*",
                    107: "+",
                    109: "-",
                    110: ".",
                    111: "/",
                    112: "f1",
                    113: "f2",
                    114: "f3",
                    115: "f4",
                    116: "f5",
                    117: "f6",
                    118: "f7",
                    119: "f8",
                    120: "f9",
                    121: "f10",
                    122: "f11",
                    123: "f12",
                    144: "numlock",
                    145: "scroll",
                    173: "-",
                    186: ";",
                    187: "=",
                    188: ",",
                    189: "-",
                    190: ".",
                    191: "/",
                    192: "`",
                    219: "[",
                    220: "\\",
                    221: "]",
                    222: "'"
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ym(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        vr(e.o.commandToHotkeys, !1).forEach(function(t) {
                            var o = e.o.commandToHotkeys[t];
                            o && (Ao(o) || Lo(o)) && e.registerHotkeyToCommand(o, t);
                        });
                        var o = !1;
                        e.e.off(".hotkeys").on([
                            e.ow,
                            e.ew
                        ], "keydown.hotkeys", function(e) {
                            if (e.key === Dt) return t.j.e.fire("escape", e);
                        }).on("keydown.hotkeys", function(n) {
                            var r = t.onKeyPress(n), i = {
                                shouldStop: !0
                            };
                            if (!1 === t.j.e.fire(r + ".hotkey", n.type, i)) {
                                if (i.shouldStop) return o = !0, e.e.stopPropagation("keydown"), !1;
                                n.preventDefault();
                            }
                        }, {
                            top: !0
                        }).on("keyup.hotkeys", function() {
                            if (o) return o = !1, e.e.stopPropagation("keyup"), !1;
                        }, {
                            top: !0
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.events && e.e.off(".hotkeys");
                    }
                }
            ], mm(o.prototype, n), t;
        }(_m(Wp));
        function km(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        Ma.add("hotkeys", wm), rr.prototype.iframeBaseUrl = "", rr.prototype.iframeTitle = "Jodit Editor", rr.prototype.iframeDoctype = "<!DOCTYPE html>", rr.prototype.iframeDefaultSrc = "about:blank", rr.prototype.iframeStyle = 'html{margin:0;padding:0;min-height: 100%;}body{box-sizing:border-box;font-size:13px;line-height:1.6;padding:10px;margin:0;background:transparent;color:#000;position:relative;z-index:2;user-select:auto;margin:0px;overflow:auto;outline:none;}table{width:100%;border:none;border-collapse:collapse;empty-cells: show;max-width: 100%;}th,td{padding: 2px 5px;border:1px solid #ccc;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}p{margin-top:0;}.jodit_editor .jodit_iframe_wrapper{display: block;clear: both;user-select: none;position: relative;}.jodit_editor .jodit_iframe_wrapper:after {position:absolute;content:"";z-index:1;top:0;left:0;right: 0;bottom: 0;cursor: pointer;display: block;background: rgba(0, 0, 0, 0);} .jodit_disabled{user-select: none;-o-user-select: none;-moz-user-select: none;-khtml-user-select: none;-webkit-user-select: none;-ms-user-select: none}', rr.prototype.iframeCSSLinks = [], rr.prototype.iframeSandbox = null, Ma.add("iframe", function(e) {
            var t = e.options;
            e.e.on("afterSetMode", function() {
                e.isEditorMode() && e.s.focus();
            }).on("generateDocumentStructure.iframe", function(e, o) {
                var n = e || o.iframe.contentWindow.document;
                if (n.open(), n.write(t.iframeDoctype + '<html dir="'.concat(t.direction, '" class="jodit" lang="').concat(Or(t.language), '">') + "<head>" + "<title>".concat(t.iframeTitle, "</title>") + (t.iframeBaseUrl ? '<base href="'.concat(t.iframeBaseUrl, '"/>') : "") + '</head><body class="jodit-wysiwyg"></body></html>'), n.close(), t.iframeCSSLinks && t.iframeCSSLinks.forEach(function(e) {
                    var t = n.createElement("link");
                    t.setAttribute("rel", "stylesheet"), t.setAttribute("href", e), n.head && n.head.appendChild(t);
                }), t.iframeStyle) {
                    var r = n.createElement("style");
                    r.innerHTML = t.iframeStyle, n.head && n.head.appendChild(r);
                }
            }).on("createEditor", function() {
                if (t.iframe) {
                    var o = e.c.element("iframe");
                    return o.style.display = "block", o.src = "about:blank", o.className = "jodit-wysiwyg_iframe", o.setAttribute("allowtransparency", "true"), o.setAttribute("tabindex", t.tabIndex.toString()), o.setAttribute("frameborder", "0"), null != t.iframeSandbox && o.setAttribute("sandbox", t.iframeSandbox), e.workplace.appendChild(o), e.iframe = o, pr(e.e.fire("generateDocumentStructure.iframe", null, e), function() {
                        if (!e.iframe) return !1;
                        var o = e.iframe.contentWindow.document;
                        e.editorWindow = e.iframe.contentWindow;
                        var n = t.editHTMLDocumentMode, r = function() {
                            er(o.body, "contenteditable", e.getMode() !== $t && !e.getReadOnly() || null);
                        }, i = function(e) {
                            var t = /<body.*<\/body>/im, o = "{%%BODY%%}", n = t.exec(e);
                            return n && (e = e.replace(t, o).replace(/<span([^>]*?)>(.*?)<\/span>/gim, "").replace(/&lt;span([^&]*?)&gt;(.*?)&lt;\/span&gt;/gim, "").replace(o, n[0].replace(/(<body[^>]+?)min-height["'\s]*:[\s"']*[0-9]+(px|%)/im, "$1").replace(/(<body[^>]+?)([\s]*["'])?contenteditable["'\s]*=[\s"']*true["']?/im, "$1").replace(/<(style|script|span)[^>]+jodit[^>]+>.*?<\/\1>/g, "")).replace(/(class\s*=\s*)(['"])([^"']*)(jodit-wysiwyg|jodit)([^"']*\2)/g, "$1$2$3$5").replace(/(<[^<]+?)\sclass="[\s]*"/gim, "$1").replace(/(<[^<]+?)\sstyle="[\s;]*"/gim, "$1").replace(/(<[^<]+?)\sdir="[\s]*"/gim, "$1")), e;
                        };
                        if (n) {
                            var a = e.element.tagName;
                            if ("TEXTAREA" !== a && "INPUT" !== a) throw Fr("If enable `editHTMLDocumentMode` - source element should be INPUT or TEXTAREA");
                            e.e.on("beforeGetNativeEditorValue", function() {
                                return i(e.o.iframeDoctype + o.documentElement.outerHTML);
                            }).on("beforeSetNativeEditorValue", function(t) {
                                var n = t.value;
                                if (e.isLocked) return !1;
                                if (/<(html|body)/i.test(n)) {
                                    var a = o.documentElement.outerHTML;
                                    i(a) !== i(n) && (o.open(), o.write(e.o.iframeDoctype + i(n)), o.close(), e.editor = o.body, e.e.fire("safeHTML", e.editor), r(), e.e.fire("prepareWYSIWYGEditor"), e.e.stopPropagation("beforeSetNativeEditorValue"));
                                } else o.body.innerHTML = n;
                                return !0;
                            }, {
                                top: !0
                            });
                        }
                        if (e.editor = o.body, e.e.on("afterSetMode afterInit afterAddPlace", r), "auto" === t.height) {
                            o.documentElement && (o.documentElement.style.overflowY = "hidden");
                            var l = e.async.throttle(function() {
                                for(var o = arguments.length, n = new Array(o), r = 0; r < o; r++)n[r] = arguments[r];
                                e.async.requestAnimationFrame(function() {
                                    if (e.editor && e.iframe && "auto" === t.height) {
                                        var o = e.ew.getComputedStyle(e.editor), n = parseInt(o.marginTop || "0", 10) + parseInt(o.marginBottom || "0", 10);
                                        Ln(e.iframe, "height", e.editor.offsetHeight + n);
                                    }
                                });
                            }, e.defaultTimeout / 2);
                            if (e.e.on("change afterInit afterSetMode resize", l).on([
                                e.iframe,
                                e.ew,
                                o.documentElement
                            ], "load", l).on(o, "readystatechange DOMContentLoaded", l), "function" == typeof ResizeObserver) {
                                var s = new ResizeObserver(l);
                                s.observe(o.body), e.e.on("beforeDestruct", function() {
                                    s.disconnect();
                                });
                            }
                        }
                        return o.documentElement && e.e.on(o.documentElement, "mousedown touchend", function() {
                            e.s.isFocused() || (e.s.focus(), e.editor === o.body && e.s.setCursorIn(o.body));
                        }).on(e.ew, "mousedown touchstart keydown keyup touchend click mouseup mousemove scroll", function(t) {
                            var o;
                            null === (o = e.events) || void 0 === o || o.fire(e.ow, t);
                        }), !1;
                    });
                }
            });
        }), Ol.set("image", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"/> </svg> '), rr.prototype.controls.image = {
            popup: function(e, t, o) {
                var n = null;
                return t && !pi.isText(t) && pi.isHTMLElement(t) && (pi.isTag(t, "img") || Qr("img", t).length) && (n = pi.isTag(t, "img") ? t : Qr("img", t)[0]), e.s.save(), tm(e, {
                    filebrowser: function(t) {
                        e.s.restore(), t.files && t.files.forEach(function(o) {
                            return e.s.insertImage(t.baseurl + o, null, e.o.imageDefaultWidth);
                        }), o();
                    },
                    upload: !0,
                    url: function() {
                        var t, r = (t = function(t, r) {
                            var i;
                            return function(e, t) {
                                var o, n, r, i, a = {
                                    label: 0,
                                    sent: function() {
                                        if (1 & r[0]) throw r[1];
                                        return r[1];
                                    },
                                    trys: [],
                                    ops: []
                                };
                                return i = {
                                    next: l(0),
                                    throw: l(1),
                                    return: l(2)
                                }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                    return this;
                                }), i;
                                function l(i) {
                                    return function(l) {
                                        return function(i) {
                                            if (o) throw new TypeError("Generator is already executing.");
                                            for(; a;)try {
                                                if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                switch(n = 0, r && (i = [
                                                    2 & i[0],
                                                    r.value
                                                ]), i[0]){
                                                    case 0:
                                                    case 1:
                                                        r = i;
                                                        break;
                                                    case 4:
                                                        return a.label++, {
                                                            value: i[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        a.label++, n = i[1], i = [
                                                            0
                                                        ];
                                                        continue;
                                                    case 7:
                                                        i = a.ops.pop(), a.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                            a = 0;
                                                            continue;
                                                        }
                                                        if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                            a.label = i[1];
                                                            break;
                                                        }
                                                        if (6 === i[0] && a.label < r[1]) {
                                                            a.label = r[1], r = i;
                                                            break;
                                                        }
                                                        if (r && a.label < r[2]) {
                                                            a.label = r[2], a.ops.push(i);
                                                            break;
                                                        }
                                                        r[2] && a.ops.pop(), a.trys.pop();
                                                        continue;
                                                }
                                                i = t.call(e, a);
                                            } catch (e) {
                                                i = [
                                                    6,
                                                    e
                                                ], n = 0;
                                            } finally{
                                                o = r = 0;
                                            }
                                            if (5 & i[0]) throw i[1];
                                            return {
                                                value: i[0] ? i[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            i,
                                            l
                                        ]);
                                    };
                                }
                            }(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return e.s.restore(), /^[a-z\d_-]+(\.[a-z\d_-]+)+/i.test(t) && (t = "//" + t), (i = n || e.createInside.element("img")).setAttribute("src", t), i.setAttribute("alt", r), n ? [
                                            3,
                                            2
                                        ] : [
                                            4,
                                            e.s.insertImage(i, null, e.o.imageDefaultWidth)
                                        ];
                                    case 1:
                                        a.sent(), a.label = 2;
                                    case 2:
                                        return o(), [
                                            2
                                        ];
                                }
                            });
                        }, function() {
                            var e = this, o = arguments;
                            return new Promise(function(n, r) {
                                var i = t.apply(e, o);
                                function a(e) {
                                    km(i, n, r, a, l, "next", e);
                                }
                                function l(e) {
                                    km(i, n, r, a, l, "throw", e);
                                }
                                a(void 0);
                            });
                        });
                        return function(e, t) {
                            return r.apply(this, arguments);
                        };
                    }()
                }, n, o);
            },
            tags: [
                "img"
            ],
            tooltip: "Insert Image"
        }, Ma.add("image", function(e) {
            e.registerButton({
                name: "image",
                group: "media"
            });
        });
        const Sm = [
            {
                name: "eye",
                tooltip: "Open link",
                exec: function(e, t) {
                    var o = er(t, "href");
                    t && o && e.ow.open(o);
                }
            },
            {
                name: "link",
                tooltip: "Edit link",
                icon: "pencil"
            },
            "unlink",
            "brush",
            "file"
        ];
        var xm = function(e) {
            return e.args && Lo(e.args[0]) ? e.args[0].toLowerCase() : "";
        };
        const Om = [
            "brushCell",
            {
                name: "valign",
                list: [
                    "Top",
                    "Middle",
                    "Bottom",
                    "Normal"
                ],
                childTemplate: function(e, t, o) {
                    return o;
                },
                exec: function(e, t, o) {
                    var n = o.control, r = xm(n);
                    e.getInstance("Table", e.o).getAllSelectedCells().forEach(function(e) {
                        Ln(e, "vertical-align", "normal" === r ? "" : r);
                    });
                },
                tooltip: "Vertical align"
            },
            {
                name: "splitv",
                list: {
                    tablesplitv: "Split vertical",
                    tablesplitg: "Split horizontal"
                },
                tooltip: "Split"
            },
            {
                name: "align",
                icon: "left"
            },
            "\n",
            {
                name: "merge",
                command: "tablemerge",
                tooltip: "Merge"
            },
            {
                name: "addcolumn",
                list: {
                    tableaddcolumnbefore: "Insert column before",
                    tableaddcolumnafter: "Insert column after"
                },
                exec: function(e, t, o) {
                    var n = o.control;
                    if (nn(e)) {
                        if (!n.args) return !1;
                        var r = xm(n);
                        e.execCommand(r, !1, t);
                    }
                },
                tooltip: "Add column"
            },
            {
                name: "addrow",
                list: {
                    tableaddrowbefore: "Insert row above",
                    tableaddrowafter: "Insert row below"
                },
                exec: function(e, t, o) {
                    var n = o.control;
                    if (nn(e)) {
                        if (!n.args) return !1;
                        var r = xm(n);
                        e.execCommand(r, !1, t);
                    }
                },
                tooltip: "Add row"
            },
            {
                name: "delete",
                icon: "bin",
                list: {
                    tablebin: "Delete table",
                    tablebinrow: "Delete row",
                    tablebincolumn: "Delete column",
                    tableempty: "Empty cell"
                },
                exec: function(e, t, o) {
                    var n = o.control;
                    if (nn(e)) {
                        if (!n.args) return !1;
                        var r = xm(n);
                        e.execCommand(r, !1, t), e.e.fire("hidePopup");
                    }
                },
                tooltip: "Delete"
            }
        ];
        var Cm = {
            name: "left",
            childTemplate: function(e, t, o) {
                return o;
            },
            list: [
                "Left",
                "Right",
                "Center",
                "Normal"
            ],
            exec: function(e, t, o) {
                var n = o.control;
                if (pi.isTag(t, new Set([
                    "img",
                    "jodit",
                    "jodit-media"
                ]))) {
                    var r = n.args && Lo(n.args[0]) ? n.args[0].toLowerCase() : "";
                    if (!r) return !1;
                    Bn(t, r), pi.isTag(t, new Set([
                        "jodit",
                        "jodit-media"
                    ])) && t.firstElementChild && Bn(t.firstElementChild, r), e.synchronizeValues(), e.e.fire("recalcPositionPopup");
                }
            },
            tooltip: "Horizontal align"
        };
        const zm = [
            {
                name: "delete",
                icon: "bin",
                tooltip: "Delete",
                exec: function(e, t) {
                    t && e.s.removeNode(t);
                }
            },
            {
                name: "pencil",
                exec: function(e, t) {
                    "img" === t.tagName.toLowerCase() && e.e.fire("openImageProperties", t);
                },
                tooltip: "Edit"
            },
            {
                name: "valign",
                list: [
                    "Top",
                    "Middle",
                    "Bottom",
                    "Normal"
                ],
                tooltip: "Vertical align",
                exec: function(e, t, o) {
                    var n = o.control;
                    if (pi.isTag(t, "img")) {
                        var r = n.args && Lo(n.args[0]) ? n.args[0].toLowerCase() : "";
                        if (!r) return !1;
                        Ln(t, "vertical-align", "normal" === r ? "" : r), e.e.fire("recalcPositionPopup");
                    }
                }
            },
            Cm
        ], Em = [
            {
                name: "bin",
                tooltip: "Delete",
                exec: function(e, t) {
                    t && e.s.removeNode(t);
                }
            },
            Cm
        ];
        function Tm(e, t, o) {
            return Tm = Mm() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Rm(r, o.prototype), r;
            }, Tm.apply(null, arguments);
        }
        function Im(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Pm(e) {
            return Pm = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Pm(e);
        }
        function Rm(e, t) {
            return Rm = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Rm(e, t);
        }
        function Am(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Lm(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Lm = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Tm(e, arguments, Pm(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Rm(n, e);
            }, Lm(e);
        }
        function Mm() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Mm = function() {
                return !!e;
            })();
        }
        rr.prototype.toolbarInline = !0, rr.prototype.toolbarInlineForSelection = !1, rr.prototype.toolbarInlineDisableFor = [], rr.prototype.toolbarInlineDisabledButtons = [
            "source"
        ], Ol.set("addcolumn", '<svg viewBox="0 0 18.151 18.151" xmlns="http://www.w3.org/2000/svg"> <g> <path stroke-width="0" d="M6.237,16.546H3.649V1.604h5.916v5.728c0.474-0.122,0.968-0.194,1.479-0.194 c0.042,0,0.083,0.006,0.125,0.006V0H2.044v18.15h5.934C7.295,17.736,6.704,17.19,6.237,16.546z"/> <path stroke-width="0" d="M11.169,8.275c-2.723,0-4.938,2.215-4.938,4.938s2.215,4.938,4.938,4.938s4.938-2.215,4.938-4.938 S13.892,8.275,11.169,8.275z M11.169,16.81c-1.983,0-3.598-1.612-3.598-3.598c0-1.983,1.614-3.597,3.598-3.597 s3.597,1.613,3.597,3.597C14.766,15.198,13.153,16.81,11.169,16.81z"/> <polygon stroke-width="0" points="11.792,11.073 10.502,11.073 10.502,12.578 9.03,12.578 9.03,13.868 10.502,13.868 10.502,15.352 11.792,15.352 11.792,13.868 13.309,13.868 13.309,12.578 11.792,12.578 "/> </g> </svg> ').set("addrow", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 432 432"> <g> <polygon points="203.688,96 0,96 0,144 155.688,144 "/> <polygon points="155.719,288 0,288 0,336 203.719,336 "/> <path d="M97.844,230.125c-3.701-3.703-5.856-8.906-5.856-14.141s2.154-10.438,5.856-14.141l9.844-9.844H0v48h107.719 L97.844,230.125z"/> <polygon points="232,176 232,96 112,216 232,336 232,256 432,256 432,176"/> </g> </svg> ').set("merge", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 312 312"> <g transform="translate(0.000000,312.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M50 3109 c0 -7 -11 -22 -25 -35 l-25 -23 0 -961 0 -961 32 -29 32 -30 501 -2 500 -3 3 -502 2 -502 31 -30 31 -31 958 0 958 0 23 25 c13 13 30 25 37 25 9 0 12 199 12 960 0 686 -3 960 -11 960 -6 0 -24 12 -40 28 l-29 27 -503 5 -502 5 -5 502 -5 503 -28 29 c-15 16 -27 34 -27 40 0 8 -274 11 -960 11 -710 0 -960 -3 -960 -11z m1738 -698 l2 -453 -40 -40 c-22 -22 -40 -43 -40 -47 0 -4 36 -42 79 -85 88 -87 82 -87 141 -23 l26 27 455 -2 454 -3 0 -775 0 -775 -775 0 -775 0 -3 450 -2 449 47 48 47 48 -82 80 c-44 44 -84 80 -87 80 -3 0 -25 -18 -48 -40 l-41 -40 -456 2 -455 3 -3 765 c-1 421 0 771 3 778 3 10 164 12 777 10 l773 -3 3 -454z"/> <path d="M607 2492 c-42 -42 -77 -82 -77 -87 0 -6 86 -96 190 -200 105 -104 190 -197 190 -205 0 -8 -41 -56 -92 -107 -65 -65 -87 -94 -77 -98 8 -3 138 -4 289 -3 l275 3 3 275 c1 151 0 281 -3 289 -4 10 -35 -14 -103 -82 -54 -53 -103 -97 -109 -97 -7 0 -99 88 -206 195 -107 107 -196 195 -198 195 -3 0 -39 -35 -82 -78z"/> <path d="M1470 1639 c-47 -49 -87 -91 -89 -94 -5 -6 149 -165 160 -165 9 0 189 179 189 188 0 12 -154 162 -165 161 -6 0 -48 -41 -95 -90z"/> <path d="M1797 1303 c-9 -8 -9 -568 0 -576 4 -4 50 36 103 88 54 52 101 95 106 95 5 0 95 -85 199 -190 104 -104 194 -190 200 -190 6 0 46 36 90 80 l79 79 -197 196 c-108 108 -197 199 -197 203 0 4 45 52 99 106 55 55 98 103 95 108 -6 10 -568 11 -577 1z"/> </g> </svg> ').set("th", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"/> </svg> ').set("splitg", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 42h4v-4h-4v4zm4-28h-4v4h4v-4zm-4 20h4v-4h-4v4zm8 8h4v-4h-4v4zm-4-36h-4v4h4v-4zm8 0h-4v4h4v-4zm16 0h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm12 28h4v-4h-4v4zm-16 8h4v-4h-4v4zm-16-16h36v-4h-36v4zm32-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-16 16h4v-4h-4v4zm8 8h4v-4h-4v4zm8 0h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg> ').set("splitv", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 18h4v-4h-4v4zm0-8h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm-8 0h4v-4h-4v4zm0 16h4v-4h-4v4zm0-8h4v-4h-4v4zm8-24h4v-4h-4v4zm24 24h4v-4h-4v4zm-16 8h4v-36h-4v36zm16 0h4v-4h-4v4zm0-16h4v-4h-4v4zm0-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-8-8h4v-4h-4v4zm0 32h4v-4h-4v4zm0-16h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg> ').set("th-list", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"/> </svg> '), rr.prototype.popup = {
            a: Sm,
            img: zm,
            cells: Om,
            toolbar: [
                "bold",
                "italic",
                "|",
                "ul",
                "ol",
                "eraser",
                "|",
                "fontsize",
                "brush",
                "paragraph",
                "---",
                "image",
                "table",
                "\n",
                "link",
                "|",
                "align",
                "|",
                "undo",
                "redo",
                "|",
                "copyformat",
                "fullsize",
                "---",
                "dots"
            ],
            jodit: Em,
            iframe: Em,
            "jodit-media": Em,
            selection: [
                "bold",
                "underline",
                "italic",
                "ul",
                "ol",
                "\n",
                "outdent",
                "indent",
                "fontsize",
                "brush",
                "cut",
                "\n",
                "paragraph",
                "link",
                "align",
                "dots"
            ]
        };
        var Bm = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Am(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Dm = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Pm(t), function(e, t) {
                        return !t || "object" !== Am(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Mm() ? Reflect.construct(t, o || [], Pm(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).type = null, e.snapRange = null, e.elmsList = vr(e.j.o.popup, !1).filter(function(t) {
                    return !e.isExcludedTarget(t);
                }), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Rm(e, t);
            }(t, e), o = t, n = [
                {
                    key: "popup",
                    get: function() {
                        return new gu(this.jodit, !1);
                    }
                },
                {
                    key: "toolbar",
                    get: function() {
                        return Vd(this.jodit, this.popup);
                    }
                },
                {
                    key: "onClick",
                    value: function(e) {
                        var t = this, o = this.elmsList, n = pi.isTag(e, "img") ? e : pi.closest(e, o, this.j.editor);
                        if (n && this.canShowPopupForType(n.nodeName.toLowerCase())) return this.showPopup(function() {
                            return oa(n, t.j);
                        }, n.nodeName.toLowerCase(), n), !1;
                    }
                },
                {
                    key: "showPopup",
                    value: function(e, t, o) {
                        if (t = t.toLowerCase(), !this.canShowPopupForType(t)) return !1;
                        if (this.type !== t || o !== this.previousTarget) {
                            this.previousTarget = o;
                            var n, r = this.j.o.popup[t];
                            Ao(n = Ro(r) ? r(this.j, o, this.popup.close) : r) && (this.toolbar.build(n, o), this.toolbar.buttonSize = this.j.o.toolbarButtonSize, n = this.toolbar.container), this.popup.setContent(n), this.type = t;
                        }
                        return this.popup.open(e), !0;
                    }
                },
                {
                    key: "hidePopup",
                    value: function(e) {
                        !this.popup.isOpened || Lo(e) && e !== this.type || this.popup.close();
                    }
                },
                {
                    key: "onOutsideClick",
                    value: function() {
                        this.popup.close();
                    }
                },
                {
                    key: "canShowPopupForType",
                    value: function(e) {
                        var t = this.j.o.popup[e.toLowerCase()];
                        return !(this.j.o.readonly || !this.j.o.toolbarInline || !t || this.isExcludedTarget(e));
                    }
                },
                {
                    key: "isExcludedTarget",
                    value: function(e) {
                        return Pi(this.j.o.toolbarInlineDisableFor).map(function(e) {
                            return e.toLowerCase();
                        }).includes(e.toLowerCase());
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        this.j.e.on("getDiffButtons.mobile", function(o) {
                            if (t.toolbar === o) {
                                var n = t.toolbar.getButtonsNames();
                                return Fo(e.registeredButtons).filter(function(e) {
                                    return !t.j.o.toolbarInlineDisabledButtons.includes(e.name);
                                }).filter(function(e) {
                                    var t = Lo(e) ? e : e.name;
                                    return t && "|" !== t && "\n" !== t && !n.includes(t);
                                });
                            }
                        }).on("hidePopup", this.hidePopup).on("showInlineToolbar", this.showInlineToolbar).on("showPopup", function(e, o, n) {
                            t.showPopup(o, n || (Lo(e) ? e : e.nodeName), Lo(e) ? void 0 : e);
                        }).on("mousedown keydown", this.onSelectionStart).on("change", function() {
                            t.popup.isOpened && t.previousTarget && !t.previousTarget.parentNode && (t.hidePopup(), t.previousTarget = void 0);
                        }).on([
                            this.j.ew,
                            this.j.ow
                        ], "mouseup keyup", this.onSelectionEnd), this.addListenersForElements();
                    }
                },
                {
                    key: "onSelectionStart",
                    value: function() {
                        this.snapRange = this.j.s.range.cloneRange();
                    }
                },
                {
                    key: "onSelectionEnd",
                    value: function(e) {
                        if (!(e && e.target && Al.closestElement(e.target, gu))) {
                            var t = this.snapRange, o = this.j.s.range;
                            t && !o.collapsed && o.startContainer === t.startContainer && o.startOffset === t.startOffset && o.endContainer === t.endContainer && o.endOffset === t.endOffset || this.onSelectionChange();
                        }
                    }
                },
                {
                    key: "onSelectionChange",
                    value: function() {
                        if (this.j.o.toolbarInlineForSelection) {
                            var e = "selection", t = this.j.s.sel, o = this.j.s.range;
                            (null == t ? void 0 : t.isCollapsed) || this.isSelectedTarget(o) ? this.type === e && this.popup.isOpened && this.hidePopup() : this.j.s.current() && this.showPopup(function() {
                                return o.getBoundingClientRect();
                            }, e);
                        }
                    }
                },
                {
                    key: "isSelectedTarget",
                    value: function(e) {
                        var t = e.startContainer;
                        return pi.isElement(t) && t === e.endContainer && pi.isTag(t.childNodes[e.startOffset], new Set(vr(this.j.o.popup, !1))) && e.startOffset === e.endOffset - 1;
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("showPopup").off([
                            this.j.ew,
                            this.j.ow
                        ], "mouseup keyup", this.onSelectionEnd), this.removeListenersForElements();
                    }
                },
                {
                    key: "_eventsList",
                    value: function() {
                        var e = this.elmsList;
                        return e.map(function(e) {
                            return An("click_".concat(e));
                        }).concat(e.map(function(e) {
                            return An("touchstart_".concat(e));
                        })).join(" ");
                    }
                },
                {
                    key: "addListenersForElements",
                    value: function() {
                        this.j.e.on(this._eventsList(), this.onClick);
                    }
                },
                {
                    key: "removeListenersForElements",
                    value: function() {
                        this.j.e.off(this._eventsList(), this.onClick);
                    }
                },
                {
                    key: "showInlineToolbar",
                    value: function(e) {
                        var t = this;
                        this.showPopup(function() {
                            return e || t.j.s.range.getBoundingClientRect();
                        }, "toolbar");
                    }
                }
            ], n && Im(o.prototype, n), t;
        }(Lm(Wp));
        function Nm(e, t, o) {
            return Nm = Um() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && qm(r, o.prototype), r;
            }, Nm.apply(null, arguments);
        }
        function Hm(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Fm(e) {
            return Fm = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Fm(e);
        }
        function qm(e, t) {
            return qm = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, qm(e, t);
        }
        function Vm(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Wm(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Wm = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Nm(e, arguments, Fm(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), qm(n, e);
            }, Wm(e);
        }
        function Um() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Um = function() {
                return !!e;
            })();
        }
        Dm.requires = [
            "select"
        ], Bm([
            vi
        ], Dm.prototype, "popup", null), Bm([
            vi
        ], Dm.prototype, "toolbar", null), Bm([
            To
        ], Dm.prototype, "onClick", null), Bm([
            ul(function(e) {
                return !e.j.isLocked;
            })
        ], Dm.prototype, "showPopup", null), Bm([
            Ca([
                ":clickEditor",
                ":beforeCommandDelete",
                ":backSpaceAfterDelete"
            ]),
            To
        ], Dm.prototype, "hidePopup", null), Bm([
            Ca(":outsideClick")
        ], Dm.prototype, "onOutsideClick", null), Bm([
            To
        ], Dm.prototype, "onSelectionStart", null), Bm([
            To
        ], Dm.prototype, "onSelectionEnd", null), Bm([
            $a(function(e) {
                return e.defaultTimeout;
            })
        ], Dm.prototype, "onSelectionChange", null), Bm([
            To
        ], Dm.prototype, "showInlineToolbar", null), Ma.add("inlinePopup", Dm), rr.prototype.link = {
            formTemplate: function(e) {
                var t = e.o.link, o = t.openInNewTabCheckbox, n = t.noFollowCheckbox, r = t.modeClassName, i = t.selectSizeClassName, a = t.selectMultipleClassName, l = t.selectOptionsClassName;
                return new Ec(e, [
                    new $s(e, [
                        new fc(e, {
                            name: "url",
                            type: "text",
                            ref: "url_input",
                            label: "URL",
                            placeholder: "http://",
                            required: !0
                        })
                    ]),
                    new $s(e, [
                        new fc(e, {
                            name: "content",
                            ref: "content_input",
                            label: "Text"
                        })
                    ], {
                        ref: "content_input_box"
                    }),
                    r ? new $s(e, [
                        "input" === r ? new fc(e, {
                            name: "className",
                            ref: "className_input",
                            label: "Class name"
                        }) : "select" === r ? new wc(e, {
                            name: "className",
                            ref: "className_select",
                            label: "Class name",
                            size: i,
                            multiple: a,
                            options: l
                        }) : null
                    ]) : null,
                    o ? new Xc(e, {
                        name: "target",
                        ref: "target_checkbox",
                        label: "Open in new tab"
                    }) : null,
                    n ? new Xc(e, {
                        name: "nofollow",
                        ref: "nofollow_checkbox",
                        label: "No follow"
                    }) : null,
                    new $s(e, [
                        new zs(e, {
                            name: "unlink",
                            variant: "default",
                            text: "Unlink"
                        }),
                        new zs(e, {
                            name: "insert",
                            type: "submit",
                            variant: "primary",
                            text: "Insert"
                        })
                    ], {
                        align: "full"
                    })
                ]);
            },
            followOnDblClick: !1,
            processVideoLink: !0,
            processPastedLink: !0,
            noFollowCheckbox: !0,
            openInNewTabCheckbox: !0,
            modeClassName: "input",
            selectMultipleClassName: !0,
            preventReadOnlyNavigation: !0,
            selectSizeClassName: 3,
            selectOptionsClassName: [],
            hotkeys: [
                "ctrl+k",
                "cmd+k"
            ]
        }, Ol.set("link", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"/> </svg> ').set("unlink", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"/> </svg> '), rr.prototype.controls.unlink = {
            exec: function(e, t) {
                var o = pi.closest(t, "a", e.editor);
                o && pi.unwrap(o), e.synchronizeValues(), e.e.fire("hidePopup");
            },
            tooltip: "Unlink"
        }, rr.prototype.controls.link = {
            isActive: function(e) {
                var t = e.s.current();
                return Boolean(t && pi.closest(t, "a", e.editor));
            },
            popup: function(e, t, o) {
                return e.e.fire("generateLinkForm.link", t, o);
            },
            tags: [
                "a"
            ],
            tooltip: "Insert link"
        };
        var Ym = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Vm(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Km = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Fm(t), function(e, t) {
                        return !t || "object" !== Vm(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Um() ? Reflect.construct(t, o || [], Fm(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "link",
                        group: "insert"
                    }
                ], e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && qm(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.o.link.followOnDblClick && e.e.on("dblclick.link", this.__onDblClickOnLink), e.e.on(e.editor, "click.link", this.__onClickReadOnlyLink), e.o.link.processPastedLink && e.e.on("processPaste.link", this.onProcessPasteLink), e.e.on("generateLinkForm.link", this.__generateForm), e.registerCommand("openLinkDialog", {
                            exec: function() {
                                var o = e.dlg({
                                    resizable: !1
                                }), n = t.__generateForm(e.s.current(), function() {
                                    o.close();
                                });
                                n.container.classList.add("jodit-dialog_alert"), o.setContent(n), o.open(), e.async.requestIdleCallback(function() {
                                    var e = ei(n.container).url_input;
                                    null == e || e.focus();
                                });
                            },
                            hotkeys: e.o.link.hotkeys
                        });
                    }
                },
                {
                    key: "__onDblClickOnLink",
                    value: function(e) {
                        if (pi.isTag(e.target, "a")) {
                            var t = er(e.target, "href");
                            t && (location.href = t, e.preventDefault());
                        }
                    }
                },
                {
                    key: "onProcessPasteLink",
                    value: function(e, t) {
                        var o, n, r, i, a = this.jodit;
                        if (fn(t) && a.o.link.processPastedLink) {
                            if (a.e.stopPropagation("processPaste"), a.o.link.processVideoLink) {
                                var l = dr(null !== (n = null === (o = a.o.video) || void 0 === o ? void 0 : o.parseUrlToVideoEmbed) && void 0 !== n ? n : Sr, t, {
                                    width: null === (r = a.o.video) || void 0 === r ? void 0 : r.defaultWidth,
                                    height: null === (i = a.o.video) || void 0 === i ? void 0 : i.defaultHeight
                                });
                                if (l !== t) return a.createInside.fromHTML(l);
                            }
                            if (a.s.isCollapsed()) {
                                var s = a.createInside.element("a");
                                return s.setAttribute("href", t), s.textContent = t, a.e.fire("applyLink", a, s, null), s;
                            }
                            return a.s.commitStyle({
                                element: "a",
                                attributes: {
                                    href: t
                                }
                            }), !0;
                        }
                    }
                },
                {
                    key: "__generateForm",
                    value: function(e, t) {
                        var o, n = this.jodit, r = n.i18n.bind(n), i = n.o.link, a = i.openInNewTabCheckbox, l = i.noFollowCheckbox, s = i.formTemplate, c = i.formClassName, u = i.modeClassName, d = s(n), f = Lo(d) ? n.c.fromHTML(d, {
                            target_checkbox_box: a,
                            nofollow_checkbox_box: l
                        }) : d, p = pi.isElement(f) ? f : f.container, h = ei(p), v = h.insert, g = h.unlink, m = h.content_input_box, b = h.target_checkbox, y = h.nofollow_checkbox, _ = h.url_input, j = e, w = pi.isImage(j), k = h.content_input, S = h.className_input, x = h.className_select;
                        k || (k = n.c.element("input", {
                            type: "hidden",
                            ref: "content_input"
                        })), c && p.classList.add(c), w && pi.hide(m);
                        var O = function() {
                            return o ? o.innerText : Vi(n.s.range.cloneContents(), n.ed);
                        };
                        o = !(!e || !pi.closest(e, "a", n.editor)) && pi.closest(e, "a", n.editor), !w && e && (k.value = O()), o ? (_.value = er(o, "href") || "", u && function(e, t, o, n) {
                            switch(e){
                                case "input":
                                    t && (t.value = er(o, "class") || "");
                                    break;
                                case "select":
                                    if (n) {
                                        for(var r = 0; r < n.selectedOptions.length; r++){
                                            var i = n.options.item(r);
                                            i && (i.selected = !1);
                                        }
                                        (er(o, "class") || "").split(" ").forEach(function(e) {
                                            if (e) for(var t = 0; t < n.options.length; t++){
                                                var o = n.options.item(t);
                                                (null == o ? void 0 : o.value) && o.value === e && (o.selected = !0);
                                            }
                                        });
                                    }
                            }
                        }(u, S, o, x), a && b && (b.checked = "_blank" === er(o, "target")), l && y && (y.checked = "nofollow" === er(o, "rel")), v.textContent = r("Update")) : pi.hide(g), n.editor.normalize();
                        var C = n.history.snapshot.make();
                        g && n.e.on(g, "click", function(e) {
                            n.s.restore(), n.history.snapshot.restore(C), o && pi.unwrap(o), n.synchronizeValues(), t(), e.preventDefault();
                        });
                        var z = function() {
                            if (!_.value.trim().length) return _.focus(), _.classList.add("jodit_error"), !1;
                            var e;
                            n.s.restore(), n.s.removeMarkers(), n.editor.normalize(), n.history.snapshot.restore(C);
                            var r = O() !== k.value.trim(), i = n.createInside;
                            if (o && pi.isOrContains(n.editor, o)) e = [
                                o
                            ];
                            else {
                                if (n.s.isCollapsed()) {
                                    var s = i.element("a");
                                    n.s.insertNode(s, !1, !1), e = [
                                        s
                                    ];
                                } else {
                                    var c = n.s.current();
                                    e = pi.isTag(c, "img") ? [
                                        pi.wrap(c, "a", i)
                                    ] : n.s.wrapInTag("a");
                                }
                                e.forEach(function(e) {
                                    return n.s.select(e);
                                });
                            }
                            return e.forEach(function(e) {
                                er(e, "href", _.value), function(e, t, o, n) {
                                    var r;
                                    if (e && (null != t ? t : o)) {
                                        if ("input" === e) "" === t.value && n.hasAttribute("class") && er(n, "class", null), "" !== t.value && er(n, "class", t.value);
                                        else if ("select" === e) {
                                            n.hasAttribute("class") && er(n, "class", null);
                                            for(var i = 0; i < o.selectedOptions.length; i++){
                                                var a = null === (r = o.selectedOptions.item(i)) || void 0 === r ? void 0 : r.value;
                                                a && n.classList.add(a);
                                            }
                                        }
                                    }
                                }(u, S, x, e), w || function(e, t, o, n) {
                                    var r = e.textContent;
                                    t.value.trim().length ? o && (r = t.value) : r = n.value, r !== e.textContent && (e.textContent = r);
                                }(e, k, r, _), a && b && er(e, "target", b.checked ? "_blank" : null), l && y && er(e, "rel", y.checked ? "nofollow" : null), n.e.fire("applyLink", n, e, f);
                            }), n.synchronizeValues(), t(), !1;
                        };
                        return pi.isElement(f) ? n.e.on(f, "submit", function(e) {
                            return e.preventDefault(), e.stopImmediatePropagation(), z(), !1;
                        }) : f.onSubmit(z), f;
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("generateLinkForm.link", this.__generateForm).off("dblclick.link", this.__onDblClickOnLink).off(e.editor, "click.link", this.__onClickReadOnlyLink).off("processPaste.link", this.onProcessPasteLink);
                    }
                },
                {
                    key: "__onClickReadOnlyLink",
                    value: function(e) {
                        var t = this.jodit;
                        t.o.readonly && t.o.link.preventReadOnlyNavigation && pi.isTag(e.target, "a") && e.preventDefault();
                    }
                }
            ], n && Hm(o.prototype, n), t;
        }(Wm(Wp));
        Ym([
            To
        ], Km.prototype, "__onDblClickOnLink", null), Ym([
            To
        ], Km.prototype, "onProcessPasteLink", null), Ym([
            To
        ], Km.prototype, "__generateForm", null), Ym([
            To
        ], Km.prototype, "__onClickReadOnlyLink", null), Ma.add("link", Km);
        var Gm = function(e, t, o) {
            var n, r = o.control, i = "button".concat(r.command), a = null !== (n = r.args && r.args[0]) && void 0 !== n ? n : cr(e, i);
            cr(e, i, a), e.execCommand(r.command, !1, "default" === a ? null : a);
        };
        function Jm(e, t, o) {
            return Jm = tb() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Qm(r, o.prototype), r;
            }, Jm.apply(null, arguments);
        }
        function Xm(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Zm(e) {
            return Zm = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Zm(e);
        }
        function Qm(e, t) {
            return Qm = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Qm(e, t);
        }
        function $m(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function eb(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return eb = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Jm(e, arguments, Zm(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Qm(n, e);
            }, eb(e);
        }
        function tb() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (tb = function() {
                return !!e;
            })();
        }
        Ol.set("ol", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg> ').set("ul", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg> '), rr.prototype.controls.ul = {
            command: "insertUnorderedList",
            tags: [
                "ul"
            ],
            tooltip: "Insert Unordered List",
            list: {
                default: "Default",
                circle: "Circle",
                disc: "Dot",
                square: "Quadrate"
            },
            exec: Gm
        }, rr.prototype.controls.ol = {
            command: "insertOrderedList",
            tags: [
                "ol"
            ],
            tooltip: "Insert Ordered List",
            list: {
                default: "Default",
                "lower-alpha": "Lower Alpha",
                "lower-greek": "Lower Greek",
                "lower-roman": "Lower Roman",
                "upper-alpha": "Upper Alpha",
                "upper-roman": "Upper Roman"
            },
            exec: Gm
        };
        var ob = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Zm(t), function(e, t) {
                        return !t || "object" !== $m(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, tb() ? Reflect.construct(t, o || [], Zm(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "ul",
                        group: "list"
                    },
                    {
                        name: "ol",
                        group: "list"
                    }
                ], e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Qm(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        e.registerCommand("insertUnorderedList", this.onCommand).registerCommand("insertOrderedList", this.onCommand);
                    }
                },
                {
                    key: "onCommand",
                    value: function(e, t, o) {
                        return this.jodit.s.commitStyle({
                            element: "insertunorderedlist" === e ? "ul" : "ol",
                            attributes: {
                                style: {
                                    listStyleType: null != o ? o : null
                                }
                            }
                        }), this.jodit.synchronizeValues(), !1;
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {}
                }
            ], Xm(o.prototype, n), t;
        }(eb(Wp));
        function nb(e, t, o) {
            return nb = cb() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && ab(r, o.prototype), r;
            }, nb.apply(null, arguments);
        }
        function rb(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function ib(e) {
            return ib = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ib(e);
        }
        function ab(e, t) {
            return ab = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, ab(e, t);
        }
        function lb(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function sb(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return sb = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return nb(e, arguments, ib(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), ab(n, e);
            }, sb(e);
        }
        function cb() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (cb = function() {
                return !!e;
            })();
        }
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : $m(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            To
        ], ob.prototype, "onCommand", null), Ma.add("orderedList", ob), rr.prototype.showPlaceholder = !0, rr.prototype.placeholder = "Type something", rr.prototype.useInputsPlaceholder = !0;
        var ub = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = ib(t), function(e, t) {
                        return !t || "object" !== lb(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, cb() ? Reflect.construct(t, o || [], ib(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).addNativeListeners = function() {
                    e.j.e.off(e.j.editor, "input.placeholder keydown.placeholder").on(e.j.editor, "input.placeholder keydown.placeholder", e.toggle);
                }, e.addEvents = function() {
                    var t = e.j;
                    t.o.useInputsPlaceholder && t.element.hasAttribute("placeholder") && (e.placeholderElm.innerHTML = er(t.element, "placeholder") || ""), t.e.fire("placeholder", e.placeholderElm.innerHTML), t.e.off(".placeholder").on("changePlace.placeholder", e.addNativeListeners).on("change.placeholder focus.placeholder keyup.placeholder mouseup.placeholder keydown.placeholder mousedown.placeholder afterSetMode.placeholder changePlace.placeholder", e.toggle).on(window, "load", e.toggle), e.addNativeListeners(), e.toggle();
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ab(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.o.showPlaceholder && (this.placeholderElm = e.c.fromHTML('<span data-ref="placeholder" style="display: none;" class="jodit-placeholder">'.concat(e.i18n(e.o.placeholder), "</span>")), "rtl" === e.o.direction && (this.placeholderElm.style.right = "0px", this.placeholderElm.style.direction = "rtl"), e.e.on("readonly", function(e) {
                            e ? t.hide() : t.toggle();
                        }).on("changePlace", this.addEvents), this.addEvents());
                    }
                },
                {
                    key: "show",
                    value: function() {
                        var e = this.j;
                        if (!e.o.readonly) {
                            var t = 0, o = 0, n = e.s.current(), r = n && pi.closest(n, pi.isBlock, e.editor) || e.editor, i = e.ew.getComputedStyle(r), a = e.ew.getComputedStyle(e.editor);
                            e.workplace.appendChild(this.placeholderElm);
                            var l = e.editor.firstChild;
                            if (pi.isElement(l) && !an(l)) {
                                var s = e.ew.getComputedStyle(l);
                                t = parseInt(s.getPropertyValue("margin-top"), 10), o = parseInt(s.getPropertyValue("margin-left"), 10), this.placeholderElm.style.fontSize = parseInt(s.getPropertyValue("font-size"), 10) + "px", this.placeholderElm.style.lineHeight = s.getPropertyValue("line-height");
                            } else this.placeholderElm.style.fontSize = parseInt(i.getPropertyValue("font-size"), 10) + "px", this.placeholderElm.style.lineHeight = i.getPropertyValue("line-height");
                            Ln(this.placeholderElm, {
                                display: "block",
                                textAlign: i.getPropertyValue("text-align"),
                                paddingTop: parseInt(a.paddingTop, 10) + "px",
                                paddingLeft: parseInt(a.paddingLeft, 10) + "px",
                                paddingRight: parseInt(a.paddingRight, 10) + "px",
                                marginTop: Math.max(parseInt(i.getPropertyValue("margin-top"), 10), t),
                                marginLeft: Math.max(parseInt(i.getPropertyValue("margin-left"), 10), o)
                            });
                        }
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        pi.safeRemove(this.placeholderElm);
                    }
                },
                {
                    key: "toggle",
                    value: function() {
                        var e = this.j;
                        e.editor && !e.isInDestruct && (e.getRealMode() === Qt && function(e) {
                            var t;
                            if (!e.firstChild) return !0;
                            var o = e.firstChild;
                            if (Pt.has(null === (t = o.nodeName) || void 0 === t ? void 0 : t.toLowerCase()) || /^(TABLE)$/i.test(o.nodeName)) return !1;
                            var n = pi.next(o, function(e) {
                                return e && !pi.isEmptyTextNode(e);
                            }, e);
                            return pi.isText(o) && !n ? pi.isEmptyTextNode(o) : !n && pi.each(o, function(e) {
                                return !(pi.isLeaf(e) || pi.isList(e)) && (pi.isEmpty(e) || pi.isTag(e, "br"));
                            });
                        }(e.editor) ? this.show() : this.hide());
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        this.hide(), e.e.off(".placeholder").off(window, "load", this.toggle);
                    }
                }
            ], n && rb(o.prototype, n), t;
        }(sb(Wp));
        function db(e, t, o) {
            return db = gb() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && hb(r, o.prototype), r;
            }, db.apply(null, arguments);
        }
        function fb(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function pb(e) {
            return pb = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, pb(e);
        }
        function hb(e, t) {
            return hb = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, hb(e, t);
        }
        function vb(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return vb = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return db(e, arguments, pb(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), hb(n, e);
            }, vb(e);
        }
        function gb() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (gb = function() {
                return !!e;
            })();
        }
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : lb(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            $a(function(e) {
                return e.defaultTimeout / 10;
            }, !0)
        ], ub.prototype, "toggle", null), Ma.add("placeholder", ub), Ma.add("poweredByJodit", function(e) {
            var t = e.o;
            t.hidePoweredByJodit || t.inline || !(t.showCharsCounter || t.showWordsCounter || t.showXPathInStatusbar) || e.hookStatus("ready", function() {
                e.statusbar.append(e.create.fromHTML('<a\n\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\tstyle="text-transform: uppercase"\n\t\t\t\t\t\tclass="jodit-status-bar-link"\n\t\t\t\t\t\ttarget="_blank"\n\t\t\t\t\t\thref="https://xdsoft.net/jodit/">\n\t\t\t\t\t\t\tPowered by Jodit\n\t\t\t\t\t\t</a>'), !0);
            });
        }), Ol.set("redo", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 14 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"/> </svg> ').set("undo", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"/> </svg> '), rr.prototype.controls.redo = {
            mode: eo,
            isDisabled: function(e) {
                return !e.history.canRedo();
            },
            tooltip: "Redo"
        }, rr.prototype.controls.undo = {
            mode: eo,
            isDisabled: function(e) {
                return !e.history.canUndo();
            },
            tooltip: "Undo"
        };
        var mb = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = pb(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, gb() ? Reflect.construct(t, o || [], pb(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "undo",
                        group: "history"
                    },
                    {
                        name: "redo",
                        group: "history"
                    }
                ], e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && hb(e, t);
            }(t, e), o = t, n = [
                {
                    key: "beforeDestruct",
                    value: function() {}
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = function(t) {
                            return e.history[t](), !1;
                        };
                        e.registerCommand("redo", {
                            exec: t,
                            hotkeys: [
                                "ctrl+y",
                                "ctrl+shift+z",
                                "cmd+y",
                                "cmd+shift+z"
                            ]
                        }), e.registerCommand("undo", {
                            exec: t,
                            hotkeys: [
                                "ctrl+z",
                                "cmd+z"
                            ]
                        });
                    }
                }
            ], fb(o.prototype, n), t;
        }(vb(Wp));
        function bb(e, t, o) {
            return bb = Sb() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && jb(r, o.prototype), r;
            }, bb.apply(null, arguments);
        }
        function yb(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function _b(e) {
            return _b = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, _b(e);
        }
        function jb(e, t) {
            return jb = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, jb(e, t);
        }
        function wb(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function kb(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return kb = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return bb(e, arguments, _b(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), jb(n, e);
            }, kb(e);
        }
        function Sb() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Sb = function() {
                return !!e;
            })();
        }
        Ma.add("redoUndo", mb), rr.prototype.minWidth = 200, rr.prototype.maxWidth = "100%", rr.prototype.minHeight = 200, rr.prototype.maxHeight = "auto", rr.prototype.saveHeightInStorage = !1;
        var xb = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : wb(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Ob = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = _b(t), function(e, t) {
                        return !t || "object" !== wb(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Sb() ? Reflect.construct(t, o || [], _b(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).__resizeWorkspaces = e.j.async.debounce(e.__resizeWorkspaceImd, e.j.defaultTimeout, !0), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && jb(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        e.e.on("setHeight.size", this.__setHeight).on("setWidth.size", this.__setWidth).on("afterInit.size changePlace.size", this.__initialize, {
                            top: !0
                        }).on(e.ow, "load.size", this.__resizeWorkspaces).on("afterInit.size resize.size afterUpdateToolbar.size scroll.size afterResize.size", this.__resizeWorkspaces).on("toggleFullSize.size toggleToolbar.size", this.__resizeWorkspaceImd), this.__initialize();
                    }
                },
                {
                    key: "__initialize",
                    value: function() {
                        var e = this.j;
                        if (!e.o.inline) {
                            var t = e.o.height;
                            if (e.o.saveHeightInStorage && "auto" !== t) {
                                var o = e.storage.get("height");
                                o && (t = o);
                            }
                            Ln(e.editor, {
                                minHeight: "100%"
                            }), Ln(e.container, {
                                minHeight: e.o.minHeight,
                                maxHeight: e.o.maxHeight,
                                minWidth: e.o.minWidth,
                                maxWidth: e.o.maxWidth
                            }), e.isFullSize || (this.__setHeight(t), this.__setWidth(e.o.width));
                        }
                    }
                },
                {
                    key: "__setHeight",
                    value: function(e) {
                        var t = this.j.container, o = t.clientHeight, n = t.clientWidth;
                        if (ln(e)) {
                            var r = this.j.o, i = r.minHeight, a = r.maxHeight;
                            ln(i) && i > e && (e = i), ln(a) && a < e && (e = a);
                        }
                        Ln(this.j.container, "height", e), this.j.o.saveHeightInStorage && this.j.storage.set("height", e), this.__resizeWorkspaceImd({
                            clientHeight: o,
                            clientWidth: n
                        });
                    }
                },
                {
                    key: "__setWidth",
                    value: function(e) {
                        var t = this.j.container, o = t.clientHeight, n = t.clientWidth;
                        if (ln(e)) {
                            var r = this.j.o, i = r.minWidth, a = r.maxWidth;
                            ln(i) && i > e && (e = i), ln(a) && a < e && (e = a);
                        }
                        Ln(this.j.container, "width", e), this.__resizeWorkspaceImd({
                            clientHeight: o,
                            clientWidth: n
                        });
                    }
                },
                {
                    key: "__getNotWorkHeight",
                    value: function() {
                        var e, t;
                        return ((null === (e = this.j.toolbarContainer) || void 0 === e ? void 0 : e.offsetHeight) || 0) + ((null === (t = this.j.statusbar) || void 0 === t ? void 0 : t.getHeight()) || 0) + 2;
                    }
                },
                {
                    key: "__resizeWorkspaceImd",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.j.container, t = e.clientHeight, o = e.clientWidth;
                        if (this.j && !this.j.isDestructed && this.j.o && !this.j.o.inline && this.j.container && this.j.container.parentNode) {
                            var n = (Ln(this.j.container, "minHeight") || 0) - this.__getNotWorkHeight();
                            if (ln(n) && n > 0 && ([
                                this.j.workplace,
                                this.j.iframe,
                                this.j.editor
                            ].map(function(e) {
                                e && Ln(e, "minHeight", n);
                            }), this.j.e.fire("setMinHeight", n)), ln(this.j.o.maxHeight)) {
                                var r = this.j.o.maxHeight - this.__getNotWorkHeight();
                                [
                                    this.j.workplace,
                                    this.j.iframe,
                                    this.j.editor
                                ].map(function(e) {
                                    e && Ln(e, "maxHeight", r);
                                }), this.j.e.fire("setMaxHeight", r);
                            }
                            this.j.container && Ln(this.j.workplace, "height", "auto" !== this.j.o.height || this.j.isFullSize ? this.j.container.offsetHeight - this.__getNotWorkHeight() : "auto");
                            var i = this.j.container, a = i.clientHeight, l = i.clientWidth;
                            t === a && o === l || this.j.e.fire(this.j, "resize");
                        }
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off(e.ow, "load.size", this.__resizeWorkspaces).off(".size");
                    }
                }
            ], n && yb(o.prototype, n), t;
        }(kb(Wp));
        function Cb(e, t, o) {
            return Cb = Pb() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Tb(r, o.prototype), r;
            }, Cb.apply(null, arguments);
        }
        function zb(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Eb(e) {
            return Eb = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Eb(e);
        }
        function Tb(e, t) {
            return Tb = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Tb(e, t);
        }
        function Ib(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Ib = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Cb(e, arguments, Eb(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Tb(n, e);
            }, Ib(e);
        }
        function Pb() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Pb = function() {
                return !!e;
            })();
        }
        xb([
            el()
        ], Ob.prototype, "__initialize", null), xb([
            To
        ], Ob.prototype, "__resizeWorkspaceImd", null), Ob = xb([
            To
        ], Ob), Ma.add("size", Ob), rr.prototype.showCharsCounter = !0, rr.prototype.countHTMLChars = !1, rr.prototype.countTextSpaces = !1, rr.prototype.showWordsCounter = !0;
        var Rb = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Eb(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Pb() ? Reflect.construct(t, o || [], Eb(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).charCounter = null, e.wordCounter = null, e.reInit = function() {
                    e.j.o.showCharsCounter && e.charCounter && e.j.statusbar.append(e.charCounter, !0), e.j.o.showWordsCounter && e.wordCounter && e.j.statusbar.append(e.wordCounter, !0), e.j.e.off("change keyup", e.calc).on("change keyup", e.calc), e.calc();
                }, e.calc = e.j.async.throttle(function() {
                    var t, o = e.j.text;
                    e.j.o.showCharsCounter && e.charCounter && (t = e.j.o.countHTMLChars ? e.j.value : e.j.o.countTextSpaces ? o.replace(_t(), "").replace(/[\r\n]/g, "") : o.replace(kt(), ""), e.charCounter.textContent = e.j.i18n("Chars: %d", t.length)), e.j.o.showWordsCounter && e.wordCounter && (e.wordCounter.textContent = e.j.i18n("Words: %d", o.replace(_t(), "").split(kt()).filter(function(e) {
                        return e.length;
                    }).length));
                }, e.j.defaultTimeout), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Tb(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function() {
                        this.charCounter = this.j.c.span(), this.wordCounter = this.j.c.span(), this.j.e.on("afterInit changePlace afterAddPlace", this.reInit), this.reInit();
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        pi.safeRemove(this.charCounter), pi.safeRemove(this.wordCounter), this.j.e.off("afterInit changePlace afterAddPlace", this.reInit), this.charCounter = null, this.wordCounter = null;
                    }
                }
            ], zb(o.prototype, n), t;
        }(Ib(Wp));
        function Ab(e, t, o) {
            return Ab = Hb() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Bb(r, o.prototype), r;
            }, Ab.apply(null, arguments);
        }
        function Lb(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Mb(e) {
            return Mb = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Mb(e);
        }
        function Bb(e, t) {
            return Bb = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Bb(e, t);
        }
        function Db(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Nb(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Nb = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Ab(e, arguments, Mb(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Bb(n, e);
            }, Nb(e);
        }
        function Hb() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Hb = function() {
                return !!e;
            })();
        }
        Ma.add("stat", Rb), rr.prototype.table = {
            selectionCellStyle: "border: 1px double #1e88e5 !important;",
            useExtraClassesOptions: !1
        }, Ol.set("table", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"/> </svg> '), rr.prototype.controls.table = {
            data: {
                cols: 10,
                rows: 10,
                classList: {
                    "table table-bordered": "Bootstrap Bordered",
                    "table table-striped": "Bootstrap Striped",
                    "table table-dark": "Bootstrap Dark"
                }
            },
            popup: function(e, t, o, n) {
                e.editor.normalize();
                for(var r = e.history.snapshot.make(), i = n.control, a = i.data && i.data.rows ? i.data.rows : 10, l = i.data && i.data.cols ? i.data.cols : 10, s = e.c.fromHTML('<form class="jodit-form jodit-form__inserter"><div class="jodit-form__table-creator-box"><div class="jodit-form__container"></div><div class="jodit-form__options">' + function() {
                    if (!e.o.table.useExtraClassesOptions) return "";
                    var t = [];
                    if (i.data) {
                        var o = i.data.classList;
                        Object.keys(o).forEach(function(e) {
                            t.push('<label class="jodit_vertical_middle"><input class="jodit-checkbox" value="'.concat(e, '" type="checkbox"/>').concat(o[e], "</label>"));
                        });
                    }
                    return t.join("");
                }() + '</div></div><label class="jodit-form__center"><span>1</span> &times; <span>1</span></label></form>'), c = s.querySelectorAll("span")[0], u = s.querySelectorAll("span")[1], d = s.querySelector(".jodit-form__container"), f = s.querySelector(".jodit-form__options"), p = [], h = a * l, v = 0; v < h; v += 1)p[v] || p.push(e.c.element("span", {
                    dataIndex: v
                }));
                if (e.e.on(d, "mousemove", function(e, t) {
                    var o = e.target;
                    if (pi.isTag(o, "span")) {
                        for(var n = void 0 === t || isNaN(t) ? parseInt(er(o, "-index") || "0", 10) : t || 0, r = Math.ceil((n + 1) / l), i = n % l + 1, a = 0; a < p.length; a += 1)i >= a % l + 1 && r >= Math.ceil((a + 1) / l) ? p[a].className = "jodit_hovered" : p[a].className = "";
                        u.textContent = i.toString(), c.textContent = r.toString();
                    }
                }).on(d, "touchstart mousedown", function(t) {
                    var n = t.target;
                    if (t.preventDefault(), t.stopImmediatePropagation(), pi.isTag(n, "span")) {
                        var i = parseInt(er(n, "-index") || "0", 10), a = Math.ceil((i + 1) / l), s = i % l + 1, c = e.createInside, u = c.element("tbody"), d = c.element("table");
                        d.appendChild(u);
                        for(var p, h, v = null, g = 1; g <= a; g += 1){
                            p = c.element("tr");
                            for(var m = 1; m <= s; m += 1)h = c.element("td"), v || (v = h), Ln(h, "width", (100 / s).toFixed(4) + "%"), h.appendChild(c.element("br")), p.appendChild(c.text("\n")), p.appendChild(c.text("\t")), p.appendChild(h);
                            u.appendChild(c.text("\n")), u.appendChild(p);
                        }
                        Qr("input[type=checkbox]:checked", f).forEach(function(e) {
                            e.value.split(/[\s]+/).forEach(function(e) {
                                d.classList.add(e);
                            });
                        }), e.s.restore(), e.s.removeMarkers(), e.editor.normalize(), e.history.snapshot.restore(r);
                        var b = pi.furthest(e.s.current(), pi.isBlock, e.editor);
                        if (b && pi.isEmpty(b)) pi.replace(b, d, void 0, !1, !0);
                        else if (b) {
                            var y = c.text("\n");
                            pi.after(b, y), pi.after(y, d);
                        } else e.s.insertNode(d, !1);
                        v && (e.s.setCursorIn(v), ii(v, e.editor, e.ed)), o();
                    }
                }), n && n.parentElement) {
                    for(var g = 0; g < a; g += 1){
                        for(var m = e.c.div(), b = 0; b < l; b += 1)m.appendChild(p[g * l + b]);
                        d.appendChild(m);
                    }
                    p[0] && (p[0].className = "hovered");
                }
                return s;
            },
            tooltip: "Insert table"
        }, Ma.add("table", function(e) {
            e.registerButton({
                name: "table",
                group: "insert"
            });
        }), rr.prototype.wrapNodes = {
            exclude: new Set([
                "hr",
                "style",
                "br"
            ]),
            emptyBlockAfterInit: !0
        };
        var Fb = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Db(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, qb = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Mb(t), function(e, t) {
                        return !t || "object" !== Db(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Hb() ? Reflect.construct(t, o || [], Mb(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).isSuitableStart = function(t) {
                    var o;
                    return pi.isText(t) && Lo(t.nodeValue) && (/[^\s]/.test(t.nodeValue) || (null === (o = t.parentNode) || void 0 === o ? void 0 : o.firstChild) === t && e.isSuitable(t.nextSibling)) || e.isNotWrapped(t) && !pi.isTemporary(t);
                }, e.isSuitable = function(t) {
                    return pi.isText(t) || e.isNotWrapped(t);
                }, e.isNotWrapped = function(t) {
                    return pi.isElement(t) && !(pi.isBlock(t) || pi.isTag(t, e.j.o.wrapNodes.exclude));
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Bb(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        "br" !== e.o.enter.toLowerCase() && e.e.on("drop.wtn focus.wtn keydown.wtn mousedown.wtn afterInit.wtn backSpaceAfterDelete.wtn", this.preprocessInput, {
                            top: !0
                        }).on("afterInit.wtn postProcessSetEditorValue.wtn afterCommitStyle.wtn backSpaceAfterDelete.wtn", this.postProcessSetEditorValue);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off(".wtn");
                    }
                },
                {
                    key: "postProcessSetEditorValue",
                    value: function() {
                        var e = this.jodit;
                        if (e.isEditorMode()) {
                            for(var t = e.editor.firstChild, o = !1; t;){
                                if (t = Vb(t, e), this.isSuitableStart(t)) {
                                    o || e.s.save(), o = !0;
                                    var n = e.createInside.element(e.o.enter);
                                    for(pi.before(t, n); t && this.isSuitable(t);){
                                        var r = t.nextSibling;
                                        n.appendChild(t), t = r;
                                    }
                                    n.normalize(), t = n;
                                }
                                t = t && t.nextSibling;
                            }
                            o && (e.s.restore(), "afterInit" === e.e.current && e.e.fire("internalChange"));
                        }
                    }
                },
                {
                    key: "preprocessInput",
                    value: function() {
                        var e = this.jodit, t = "afterInit" === e.e.current;
                        if (e.isEditorMode() && !e.editor.firstChild && (e.o.wrapNodes.emptyBlockAfterInit || !t)) {
                            var o = e.createInside.element(e.o.enter), n = e.createInside.element("br");
                            pi.append(o, n), pi.append(e.editor, o), e.s.isFocused() && e.s.setCursorBefore(n), e.e.fire("internalChange");
                        }
                    }
                }
            ], Lb(o.prototype, n), t;
        }(Nb(Wp));
        function Vb(e, t) {
            var o = e, n = e;
            do {
                if (!pi.isElement(n) || !pi.isLeaf(n) || pi.isList(n.parentElement)) break;
                var r = pi.findNotEmptySibling(n, !1);
                pi.isTag(o, "ul") ? o.appendChild(n) : o = pi.wrap(n, "ul", t.createInside), n = r;
            }while (n);
            return o;
        }
        Fb([
            To
        ], qb.prototype, "postProcessSetEditorValue", null), Fb([
            To
        ], qb.prototype, "preprocessInput", null), Ma.add("wrapNodes", qb), rr.prototype.dtd = {
            removeExtraBr: !0,
            checkBlockNesting: !0,
            blockLimits: {
                article: 1,
                aside: 1,
                audio: 1,
                body: 1,
                caption: 1,
                details: 1,
                dir: 1,
                div: 1,
                dl: 1,
                fieldset: 1,
                figcaption: 1,
                figure: 1,
                footer: 1,
                form: 1,
                header: 1,
                hgroup: 1,
                main: 1,
                menu: 1,
                nav: 1,
                ol: 1,
                section: 1,
                table: 1,
                td: 1,
                th: 1,
                tr: 1,
                ul: 1,
                video: 1
            }
        };
        var Wb = new Set([
            "table",
            "pre",
            "blockquote",
            "code"
        ]);
        function Ub(e, t) {
            if (e.o.dtd.removeExtraBr && !pi.isTag(t, "br")) {
                var o = pi.furthest(t, pi.isBlock, e.editor);
                if (o && !pi.isTag(o, Wb)) {
                    var n = pi.isTag(t, "br") ? t : pi.findNotEmptySibling(t, !1);
                    if (!pi.isTag(n, "br")) return;
                    e.s.setCursorBefore(n), pi.safeRemove(n);
                }
            }
        }
        function Yb(e, t) {
            if (pi.isFragment(t) && (t = t.firstChild), e.o.dtd.checkBlockNesting && pi.isBlock(t)) {
                var o = pi.furthest(e.s.current(), pi.isBlock, e.editor);
                o && !e.o.dtd.blockLimits[o.tagName.toLowerCase()] && (e.s.setCursorAfter(o), pi.isEmpty(o) && pi.safeRemove(o));
            }
        }
        function Kb(e, t, o) {
            return Kb = $b() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Xb(r, o.prototype), r;
            }, Kb.apply(null, arguments);
        }
        function Gb(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Jb(e) {
            return Jb = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Jb(e);
        }
        function Xb(e, t) {
            return Xb = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Xb(e, t);
        }
        function Zb(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Qb(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Qb = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Kb(e, arguments, Jb(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Xb(n, e);
            }, Qb(e);
        }
        function $b() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return ($b = function() {
                return !!e;
            })();
        }
        var ey = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Zb(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, ty = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = Jb(o = t), function(e, t) {
                    return !t || "object" !== Zb(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, $b() ? Reflect.construct(o, n || [], Jb(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Xb(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {}
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {}
                },
                {
                    key: "__onBeforeInsertNode",
                    value: function(e) {
                        var t = this;
                        Object.keys(f).forEach(function(o) {
                            f[o](t.j, e);
                        });
                    }
                },
                {
                    key: "__onAfterInsertNode",
                    value: function(e) {
                        var t = this;
                        Object.keys(d).forEach(function(o) {
                            d[o](t.j, e);
                        });
                    }
                }
            ], n && Gb(o.prototype, n), t;
        }(Qb(Wp));
        ey([
            Ca(":beforeInsertNode")
        ], ty.prototype, "__onBeforeInsertNode", null), ey([
            Ca(":afterInsertNode")
        ], ty.prototype, "__onAfterInsertNode", null), Ma.add("dtd", ty), Object.keys(i).forEach(function(e) {
            Jv[e] = i[e];
        });
        var oy = function(e) {
            return "__esModule" !== e;
        };
        Object.keys(u).filter(oy).forEach(function(e) {
            Ol.set(e.replace("_", "-"), u[e]);
        }), Object.keys(c).filter(oy).forEach(function(e) {
            var t, o = c[e], n = Ro(null === (t = o.prototype) || void 0 === t ? void 0 : t.className) ? o.prototype.className() : e;
            Lo(n) ? Jv.modules[n] = o : console.warn("Module name must be a string", e);
        }), Object.keys(l).filter(oy).forEach(function(e) {
            Jv.decorators[e] = l[e];
        }), [
            "Confirm",
            "Alert",
            "Prompt"
        ].forEach(function(e) {
            Jv[e] = c[e];
        }), Object.keys(zg).filter(oy).forEach(function(e) {
            Jv.lang[e] = zg[e];
        });
        var ny = n(72), ry = n.n(ny), iy = n(825), ay = n.n(iy), ly = n(659), sy = n.n(ly), cy = n(56), uy = n.n(cy), dy = n(540), fy = n.n(dy), py = n(113), hy = n.n(py), vy = n(616), gy = {};
        function my(e, t, o) {
            return my = ky() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && _y(r, o.prototype), r;
            }, my.apply(null, arguments);
        }
        function by(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function yy(e) {
            return yy = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, yy(e);
        }
        function _y(e, t) {
            return _y = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, _y(e, t);
        }
        function jy(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function wy(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return wy = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return my(e, arguments, yy(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), _y(n, e);
            }, wy(e);
        }
        function ky() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ky = function() {
                return !!e;
            })();
        }
        gy.styleTagTransform = hy(), gy.setAttributes = uy(), gy.insert = sy().bind(null, "head"), gy.domAPI = ay(), gy.insertStyleElement = fy(), ry()(vy.A, gy), vy.A && vy.A.locals && vy.A.locals, rr.prototype.addNewLine = !0, rr.prototype.addNewLineOnDBLClick = !0, rr.prototype.addNewLineTagsTriggers = [
            "table",
            "iframe",
            "img",
            "hr",
            "pre",
            "jodit"
        ], rr.prototype.addNewLineDeltaShow = 20, Ol.set("enter", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 128 128" xml:space="preserve"> <polygon points="112.4560547,23.3203125 112.4560547,75.8154297 31.4853516,75.8154297 31.4853516,61.953125 16.0131836,72.6357422 0.5410156,83.3164063 16.0131836,93.9990234 31.4853516,104.6796875 31.4853516,90.8183594 112.4560547,90.8183594 112.4560547,90.8339844 127.4589844,90.8339844 127.4589844,23.3203125"/> </svg> ');
        var Sy = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : jy(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, xy = "addnewline", Oy = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = yy(t), function(e, t) {
                        return !t || "object" !== jy(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ky() ? Reflect.construct(t, o || [], yy(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).__line = e.j.c.fromHTML('<div role="button" tabindex="-1" title="'.concat(e.j.i18n("Break"), '" class="jodit-add-new-line"><span>').concat(Ol.get("enter"), "</span></div>")), e.__isMatchedTag = function(t) {
                    return Boolean(t && e.j.o.addNewLineTagsTriggers.includes(t.nodeName.toLowerCase()));
                }, e.__isBeforeContent = !1, e.__lineInFocus = !1, e.__isShown = !1, e.__hideForce = function() {
                    e.__isShown && (e.__isShown = !1, e.j.async.clearTimeout(e.__timeout), e.__lineInFocus = !1, pi.safeRemove(e.__line), e.__line.style.setProperty("--jd-anl-handle-offset", "0"));
                }, e.__canGetFocus = function(e) {
                    return null != e && pi.isBlock(e) && !/^(img|table|iframe|hr)$/i.test(e.nodeName);
                }, e.__onClickLine = function(t) {
                    var o = e.j, n = o.createInside.element(o.o.enter);
                    e.__isBeforeContent && e.__current && e.__current.parentNode ? e.__current === o.editor ? pi.prepend(o.editor, n) : e.__current.parentNode.insertBefore(n, e.__current) : o.editor.appendChild(n), o.s.setCursorIn(n), ii(n, o.editor, o.ed), o.synchronizeValues(), e.__hideForce(), t.preventDefault();
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && _y(e, t);
            }(t, e), o = t, n = [
                {
                    key: "__show",
                    value: function() {
                        this.j.o.readonly || this.j.isLocked || (this.j.async.clearTimeout(this.__timeout), this.__isShown || (this.__isShown = !0, this.j.container.appendChild(this.__line), this.__line.style.width = this.j.container.clientWidth + "px"));
                    }
                },
                {
                    key: "onLock",
                    value: function(e) {
                        e && this.__isShown && this.__hideForce();
                    }
                },
                {
                    key: "__hide",
                    value: function() {
                        this.__isShown && !this.__lineInFocus && (this.__timeout = this.j.async.setTimeout(this.__hideForce, {
                            timeout: 500,
                            label: "add-new-line-hide"
                        }));
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.o.addNewLine && (e.e.on(this.__line, "mousemove", function(e) {
                            e.stopPropagation();
                        }).on(this.__line, "mousedown touchstart", this.__onClickLine).on("change", this.__hideForce).on(this.__line, "mouseenter", function() {
                            t.j.async.clearTimeout(t.__timeout), t.__lineInFocus = !0;
                        }).on(this.__line, "mouseleave", function() {
                            t.__lineInFocus = !1;
                        }).on("changePlace", this.__addEventListeners.bind(this)), this.__addEventListeners());
                    }
                },
                {
                    key: "__addEventListeners",
                    value: function() {
                        var e = this.j;
                        e.e.off(e.editor, "." + xy).off(e.container, "." + xy).off("." + xy).on([
                            e.ow,
                            e.ew,
                            e.editor
                        ], "scroll." + xy, this.__hideForce).on("finishedCleanHTMLWorker." + xy, this.__hideForce).on(e.editor, "click." + xy, this.__hide).on(e.container, "mouseleave." + xy, this.__hide).on(e.editor, "mousemove." + xy, this.__onMouseMove);
                    }
                },
                {
                    key: "onDblClickEditor",
                    value: function(e) {
                        var t = this.j;
                        if (!t.o.readonly && t.o.addNewLineOnDBLClick && e.target === t.editor && t.s.isCollapsed()) {
                            var o = ta(t.editor, t, t.ed), n = e.pageY - t.ew.scrollX, r = t.createInside.element(t.o.enter);
                            Math.abs(n - o.top) < Math.abs(n - (o.height + o.top)) && t.editor.firstChild ? t.editor.insertBefore(r, t.editor.firstChild) : t.editor.appendChild(r), t.s.setCursorIn(r), t.synchronizeValues(), this.__hideForce(), e.preventDefault();
                        }
                    }
                },
                {
                    key: "__onMouseMove",
                    value: function(e) {
                        var t = this.j, o = t.ed.elementFromPoint(e.clientX, e.clientY);
                        if (pi.isHTMLElement(o) && pi.isOrContains(t.editor, o)) {
                            if (t.editor === o || this.__isMatchedTag(o) || (o = pi.closest(o, this.__isMatchedTag, t.editor)), o) {
                                if (this.__isMatchedTag(o)) {
                                    var n = pi.up(o, pi.isBlock, t.editor);
                                    n && n !== t.editor && (o = n);
                                }
                                var r = oa(o, this.j), i = !1, a = e.clientY, l = e.clientX;
                                if (this.j.iframe) {
                                    var s = oa(this.j.iframe, this.j, !0);
                                    a += s.top, l += s.left;
                                }
                                var c = this.j.o.addNewLineDeltaShow;
                                Math.abs(a - r.top) <= c ? (i = r.top, this.__isBeforeContent = !0) : Math.abs(a - (r.top + r.height)) <= c && (i = r.top + r.height, this.__isBeforeContent = !1);
                                var u = t.editor === o;
                                !1 !== i && (u && !this.__isBeforeContent || !u && !dr(this.__isBeforeContent ? pi.prev : pi.next, o, this.__canGetFocus, t.editor)) ? (this.__line.style.top = i + "px", this.__current = o, this.__show(), this.__line.style.setProperty("--jd-anl-handle-offset", l - r.left - 10 + "px")) : (this.__current = !1, this.__hide());
                            } else this.__hide();
                        }
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.j.async.clearTimeout(this.__timeout), this.j.e.off(this.__line).off("changePlace", this.__addEventListeners), pi.safeRemove(this.__line), this.j.e.off([
                            this.j.ow,
                            this.j.ew,
                            this.j.editor
                        ], "." + xy).off(this.j.container, "." + xy).off("." + xy);
                    }
                }
            ], by(o.prototype, n), t;
        }(wy(Wp));
        function Cy(e, t, o) {
            return Cy = Ry() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Iy(r, o.prototype), r;
            }, Cy.apply(null, arguments);
        }
        function zy(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ey(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function Ty(e) {
            return Ty = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Ty(e);
        }
        function Iy(e, t) {
            return Iy = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Iy(e, t);
        }
        function Py(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Py = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Cy(e, arguments, Ty(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Iy(n, e);
            }, Py(e);
        }
        function Ry() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Ry = function() {
                return !!e;
            })();
        }
        Sy([
            Ca(":lock")
        ], Oy.prototype, "onLock", null), Sy([
            To
        ], Oy.prototype, "__hide", null), Sy([
            Ca(":dblclick")
        ], Oy.prototype, "onDblClickEditor", null), Sy([
            el(function(e) {
                return e.defaultTimeout;
            })
        ], Oy.prototype, "__onMouseMove", null), Ma.add("addNewLine", Oy), rr.prototype.controls.classSpan = {
            command: "applyClassName",
            exec: gr,
            list: [
                "enabled",
                "disabled",
                "activated",
                "text-left",
                "text-center",
                "text-right",
                "warning",
                "error"
            ],
            isChildActive: function(e, t) {
                var o = e.s.current();
                if (o) {
                    var n = pi.closest(o, pi.isElement, e.editor) || e.editor;
                    return Boolean(t.control.args && n.classList.contains(t.control.args[0].toString()));
                }
                return !1;
            },
            isActive: function(e, t) {
                var o = e.s.current();
                if (o) {
                    var n = pi.closest(o, pi.isElement, e.editor) || e.editor, r = !1;
                    return t.control.list && Object.keys(t.control.list).forEach(function(e) {
                        n.classList.contains(e) && (r = !0);
                    }), Boolean(n && n !== e.editor && void 0 !== t.control.list && r);
                }
                return !1;
            },
            childTemplate: function(e, t, o) {
                return '<span class="'.concat(t, '">').concat(e.i18n(o), "</span>");
            },
            tooltip: "Insert className"
        };
        var Ay = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Ty(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Ry() ? Reflect.construct(t, o || [], Ty(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "classSpan",
                        group: "script"
                    }
                ], e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Iy(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        e.registerCommand("applyClassName", function(t, o, n) {
                            return e.s.commitStyle({
                                attributes: Ey({}, "class", n)
                            }), !1;
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {}
                }
            ], zy(o.prototype, n), t;
        }(Py(Wp));
        function Ly(e) {
            var t = /([^[]*)\[([^\]]+)]/, o = /[\s]*,[\s]*/, n = /^(.*)[\s]*=[\s]*(.*)$/, r = {};
            return Lo(e) ? (e.split(o).map(function(e) {
                e = vn(e);
                var i = t.exec(e), a = {};
                if (i) {
                    var l = i[2].split(o);
                    i[1] && (l.forEach(function(e) {
                        e = vn(e);
                        var t = n.exec(e);
                        t ? a[t[1]] = t[2] : a[e] = !0;
                    }), r[i[1].toUpperCase()] = a);
                } else r[e.toUpperCase()] = !0;
            }), r) : !!e && (Object.keys(e).forEach(function(t) {
                r[t.toUpperCase()] = e[t];
            }), r);
        }
        function My(e, t) {
            var o = e.s, n = t;
            if (!n) {
                n = e.createInside.fake();
                var r = o.range;
                pi.safeInsertNode(r, n), r.collapse();
            }
            var i = pi.furthest(n, By, e.editor);
            if (i) {
                if (o.cursorOnTheLeft(i)) pi.before(i, n);
                else if (o.cursorOnTheRight(i)) pi.after(i, n);
                else {
                    var a = o.splitSelection(i);
                    a && pi.after(a, n);
                }
            }
            t || (o.setCursorBefore(n), pi.safeRemove(n));
        }
        function By(e) {
            return pi.isInlineBlock(e) && !pi.isTag(e, Pt);
        }
        function Dy(e, t, o, n) {
            if (n && pi.isElement(t) && !0 !== n[t.nodeName]) {
                var r = t.attributes;
                if (r && r.length) {
                    for(var i = [], a = 0; a < r.length; a += 1){
                        var l = n[t.nodeName][r[a].name];
                        (!l || !0 !== l && l !== r[a].value) && i.push(r[a].name);
                    }
                    i.length && (o = !0), i.forEach(function(e) {
                        t.removeAttribute(e);
                    });
                }
            }
            return o;
        }
        Ma.add("classSpan", Ay), Ol.set("class-span", '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M36 4h-24c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-32c0-2.21-1.79-4-4-4zm-24 4h10v16l-5-3-5 3v-16z"/> </svg> '), rr.prototype.cleanHTML = {
            timeout: 300,
            removeEmptyElements: !0,
            fillEmptyParagraph: !0,
            replaceNBSP: !0,
            replaceOldTags: {
                i: "em",
                b: "strong"
            },
            allowTags: !1,
            denyTags: "script",
            useIframeSandbox: !1,
            removeOnError: !0,
            safeJavaScriptLink: !0,
            disableCleanFilter: null
        }, rr.prototype.controls.eraser = {
            command: "removeFormat",
            tooltip: "Clear Formatting"
        }, Ol.set("eraser", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"/> </svg> ');
        var Ny = new Set([
            "table",
            "tbody",
            "thead",
            "tfoot",
            "tr"
        ]);
        function Hy(e, t, o) {
            if (e.o.cleanHTML.fillEmptyParagraph && pi.isBlock(t) && pi.isEmpty(t, Pt) && !pi.isTag(t, Ny)) {
                var n = e.createInside.element("br");
                return t.appendChild(n), !0;
            }
            return o;
        }
        function Fy(e, t, o, n, r, i) {
            return pi.isText(t) && !t.nodeValue ? (t === i && e.s.isCollapsed() && e.s.setCursorAfter(t), pi.safeRemove(t), !0) : o;
        }
        function qy(e, t, o, n, r, i) {
            if (i === t || !pi.isText(t) || null == t.nodeValue) return o;
            if (!_t().test(t.nodeValue)) return o;
            var a = pi.furthest(i, pi.isBlock, e.editor);
            return !a || pi.isOrContains(a, t) ? o : (t.nodeValue = t.nodeValue.replace(_t(), ""), t === i && e.s.isCollapsed() && e.s.setCursorAfter(t), t.nodeValue || pi.safeRemove(t), !0);
        }
        function Vy(e, t, o) {
            var n = function(e, t, o) {
                if (!o || !pi.isHTMLElement(t)) return t;
                var n = o[t.nodeName.toLowerCase()] || o[t.nodeName];
                return n ? pi.replace(t, n, e.createInside, !0, !1) : t;
            }(e, t, e.o.cleanHTML.replaceOldTags);
            return t !== n ? (t = n, !0) : o;
        }
        function Wy(e, t, o) {
            return !(!pi.isElement(t) || !Ni(t, {
                safeJavaScriptLink: e.options.cleanHTML.safeJavaScriptLink,
                removeOnError: e.options.cleanHTML.removeOnError
            })) || o;
        }
        function Uy(e, t, o, n, r, i) {
            return function(e, t, o, n, r) {
                if (!pi.isText(t)) {
                    if (n && !n[t.nodeName]) return !0;
                    if (!n && r && r[t.nodeName]) return !0;
                }
                return !!e.o.cleanHTML.removeEmptyElements && pi.isElement(t) && null != t.nodeName.match(Et) && !pi.isTemporary(t) && 0 === vn(t.innerHTML).length && (null == o || !pi.isOrContains(t, o));
            }(e, t, i, n, r) ? (pi.safeRemove(t), !0) : o;
        }
        var Yy = Object.keys(p);
        function Ky(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Gy(e, t, o) {
            return Gy = e_() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Zy(r, o.prototype), r;
            }, Gy.apply(null, arguments);
        }
        function Jy(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Xy(e) {
            return Xy = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Xy(e);
        }
        function Zy(e, t) {
            return Zy = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Zy(e, t);
        }
        function Qy(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function $y(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return $y = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Gy(e, arguments, Xy(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Zy(n, e);
            }, $y(e);
        }
        function e_() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (e_ = function() {
                return !!e;
            })();
        }
        var t_ = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Qy(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, o_ = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Xy(t), function(e, t) {
                        return !t || "object" !== Qy(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, e_() ? Reflect.construct(t, o || [], Xy(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "eraser",
                        group: "font-style"
                    }
                ], e.currentSelectionNode = null, e.walker = new Cn(e.j.async, {
                    timeout: e.j.o.cleanHTML.timeout
                }), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Zy(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {}
                },
                {
                    key: "isEditMode",
                    get: function() {
                        return !(this.j.isInDestruct || !this.j.isEditorMode() || this.j.getReadOnly());
                    }
                },
                {
                    key: "onChangeCleanHTML",
                    value: function() {
                        if (this.isEditMode) {
                            var e = this.j;
                            this.walker.setWork(e.editor), this.currentSelectionNode = e.s.current();
                        }
                    }
                },
                {
                    key: "startWalker",
                    value: function() {
                        var e = this, t = this.jodit, o = Ly(this.j.o.cleanHTML.allowTags), n = Ly(this.j.o.cleanHTML.denyTags);
                        this.walker.on("visit", function(r) {
                            return function(e, t, o, n, r) {
                                var i = !1, a = e.o.cleanHTML.disableCleanFilter, l = !0, s = !1, c = void 0;
                                try {
                                    for(var u, d = Yy[Symbol.iterator](); !(l = (u = d.next()).done); l = !0){
                                        var f = u.value;
                                        if (!a || !a.has(f)) {
                                            var h = i;
                                            if (i = (0, p[f])(e, t, i, o, n, r), ft || h || !i || console.warn('CleanHTML: Effect "'.concat(f, '"')), !t.isConnected) return !0;
                                        }
                                    }
                                } catch (e) {
                                    s = !0, c = e;
                                } finally{
                                    try {
                                        l || null == d.return || d.return();
                                    } finally{
                                        if (s) throw c;
                                    }
                                }
                                return i;
                            }(t, r, o, n, e.currentSelectionNode);
                        }).on("end", function(t) {
                            e.j.e.fire(t ? "internalChange finishedCleanHTMLWorker" : "finishedCleanHTMLWorker");
                        });
                    }
                },
                {
                    key: "beforeCommand",
                    value: function(e) {
                        if ("removeformat" === e.toLowerCase()) return this.j.s.isCollapsed() ? My(this.j) : function(e) {
                            var t = e.s, o = e.editor, n = e.createInside, r = t.range, i = r.cloneRange(), a = r.cloneRange(), l = n.fake(), s = n.fake();
                            i.collapse(!0), a.collapse(!1), pi.safeInsertNode(i, l), pi.safeInsertNode(a, s), r.setStartBefore(l), r.collapse(!0), t.selectRange(r), My(e, l), r.setEndAfter(s), r.collapse(!1), t.selectRange(r), My(e, s);
                            var c = [];
                            pi.between(l, s, function(e) {
                                By(e) && !pi.isTag(e, "a") && c.push(e), pi.isElement(e) && er(e, "style") && er(e, "style", null);
                            }), c.forEach(function(e) {
                                return pi.unwrap(e);
                            });
                            var u = function(e, t) {
                                if (!pi.findNotEmptySibling(e, t)) {
                                    var n = e.parentNode;
                                    if (n && n !== o && er(n, "style")) return er(n, "style", null), u(n, t), !0;
                                }
                            };
                            u(l, !0) && u(s, !1), r.setStartAfter(l), r.setEndBefore(s), t.selectRange(r), pi.safeRemove(l), pi.safeRemove(s);
                        }(this.j), !1;
                    }
                },
                {
                    key: "onBeforeSetNativeEditorValue",
                    value: function(e) {
                        var t = function(e, t) {
                            return function(e) {
                                if (Array.isArray(e)) return e;
                            }(e) || function(e, t) {
                                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (null != o) {
                                    var n, r, i = [], a = !0, l = !1;
                                    try {
                                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                    } catch (e) {
                                        l = !0, r = e;
                                    } finally{
                                        try {
                                            a || null == o.return || o.return();
                                        } finally{
                                            if (l) throw r;
                                        }
                                    }
                                    return i;
                                }
                            }(e, t) || function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return Ky(e, t);
                                    var o = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Ky(e, t) : void 0;
                                }
                            }(e, t) || function() {
                                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }();
                        }(this.j.o.cleanHTML.useIframeSandbox ? this.j.createInside.sandbox() : [
                            this.j.createInside.div()
                        ], 2), o = t[0], n = t[1];
                        return o.innerHTML = e.value, this.onSafeHTML(o), e.value = o.innerHTML, Di(o, {
                            safeJavaScriptLink: !0,
                            removeOnError: !0
                        }), pi.safeRemove(n), !1;
                    }
                },
                {
                    key: "onSafeHTML",
                    value: function(e) {
                        Di(e, this.j.o.cleanHTML);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.walker.destruct();
                    }
                }
            ], n && Jy(o.prototype, n), t;
        }($y(Wp));
        function n_(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        t_([
            Ca([
                ":change",
                ":afterSetMode",
                ":afterInit",
                ":mousedown",
                ":keydown"
            ])
        ], o_.prototype, "onChangeCleanHTML", null), t_([
            rl("ready")
        ], o_.prototype, "startWalker", null), t_([
            Ca(":beforeCommand")
        ], o_.prototype, "beforeCommand", null), t_([
            Ca(":beforeSetNativeEditorValue")
        ], o_.prototype, "onBeforeSetNativeEditorValue", null), t_([
            Ca(":safeHTML")
        ], o_.prototype, "onSafeHTML", null), Ma.add("cleanHtml", o_), rr.prototype.controls.cut = {
            command: "cut",
            isDisabled: function(e) {
                return e.s.isCollapsed();
            },
            tooltip: "Cut selection"
        }, rr.prototype.controls.copy = {
            command: "copy",
            isDisabled: function(e) {
                return e.s.isCollapsed();
            },
            tooltip: "Copy selection"
        }, rr.prototype.controls.selectall = {
            icon: "select-all",
            command: "selectall",
            tooltip: "Select all"
        }, Ol.set("copy", '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89,6.61H22.31V4.47A2.47,2.47,0,0,0,19.84,2H6.78A2.47,2.47,0,0,0,4.31,4.47V22.92a2.47,2.47,0,0,0,2.47,2.47H9.69V27.2a2.8,2.8,0,0,0,2.8,2.8h12.4a2.8,2.8,0,0,0,2.8-2.8V9.41A2.8,2.8,0,0,0,24.89,6.61ZM6.78,23.52a.61.61,0,0,1-.61-.6V4.47a.61.61,0,0,1,.61-.6H19.84a.61.61,0,0,1,.61.6V6.61h-8a2.8,2.8,0,0,0-2.8,2.8V23.52Zm19,3.68a.94.94,0,0,1-.94.93H12.49a.94.94,0,0,1-.94-.93V9.41a.94.94,0,0,1,.94-.93h12.4a.94.94,0,0,1,.94.93Z"/> <path d="M23.49,13.53h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,17.37h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,21.22h-9.6a.93.93,0,1,0,0,1.86h9.6a.93.93,0,1,0,0-1.86Z"/> </svg> ').set("cut", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zm300 64l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zm-681-260q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zm-85 745q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zm178-613l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zm224 224l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zm704 416l128-64-520-408-177 138q-2 3-13 7z"/> </svg> ').set("paste", '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> <path stroke-width="0" d="M10.5 20H2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1V3l2.03-.4a3 3 0 0 1 5.94 0L13 3v1h1a2 2 0 0 1 2 2v1h-2V6h-1v1H3V6H2v12h5v2h3.5zM8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2 4h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm0 2v8h8v-8h-8z"/> </svg> ').set("select-all", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 18 18"> <g fill-rule="evenodd" stroke="none" stroke-width="1"> <g transform="translate(-381.000000, -381.000000)"> <g transform="translate(381.000000, 381.000000)"> <path d="M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z"/> </g> </g> </g> </svg> ');
        var r_ = function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.buttons = [
                    {
                        name: "cut",
                        group: "clipboard"
                    },
                    {
                        name: "copy",
                        group: "clipboard"
                    },
                    {
                        name: "paste",
                        group: "clipboard"
                    },
                    {
                        name: "selectall",
                        group: "clipboard"
                    }
                ];
            }
            var t, o;
            return t = e, o = [
                {
                    key: "init",
                    value: function(e) {
                        var t;
                        null === (t = this.buttons) || void 0 === t || t.forEach(function(t) {
                            return e.registerButton(t);
                        }), e.e.off("copy.".concat(ko, " cut.").concat(ko)).on("copy.".concat(ko, " cut.").concat(ko), function(t) {
                            var o, n = e.s.html, r = mr(t) || mr(e.ew) || mr(t.originalEvent);
                            r && (r.setData(oo, Vi(n)), r.setData(no, n)), e.buffer.set(ko, n), e.e.fire("pasteStack", {
                                html: n,
                                action: e.o.defaultActionOnPaste || lo
                            }), "cut" === t.type && (e.s.remove(), e.s.focus()), t.preventDefault(), null === (o = null == e ? void 0 : e.events) || void 0 === o || o.fire("afterCopy", n);
                        });
                    }
                },
                {
                    key: "destruct",
                    value: function(e) {
                        var t, o;
                        null === (t = hi(e, "buffer")) || void 0 === t || t.set(ko, ""), null === (o = null == e ? void 0 : e.events) || void 0 === o || o.off("." + ko);
                    }
                }
            ], n_(t.prototype, o), e;
        }();
        Ma.add("clipboard", r_);
        const i_ = {
            "copy-format": "\u0646\u0633\u062E \u0627\u0644\u062A\u0646\u0633\u064A\u0642"
        }, a_ = {
            "copy-format": "Kop\xedrovat form\xe1t"
        }, l_ = {
            "copy-format": "Format kopieren\u0442"
        }, s_ = {
            "copy-format": "Copiar formato"
        }, c_ = {
            "copy-format": "\u06A9\u067E\u06CC \u06A9\u0631\u062F\u0646 \u0642\u0627\u0644\u0628"
        }, u_ = {
            "copy-format": "Kopioi muotoilu"
        }, d_ = {
            "copy-format": "Format de copie"
        }, f_ = {
            "copy-format": "\u05D4\u05E2\u05EA\u05E7 \u05E2\u05D9\u05E6\u05D5\u05D1"
        }, p_ = {
            "copy-format": "Form\xe1tum m\xe1sol\xe1s"
        }, h_ = {
            "copy-format": "salin format"
        }, v_ = {
            "copy-format": "Copia il formato"
        }, g_ = {
            "copy-format": "copyformat"
        }, m_ = {
            "copy-format": "\uBCF5\uC0AC \uD615\uC2DD"
        }, b_ = {
            "copy-format": "\u0424\u043E\u0440\u043C\u0430\u0442 \u0445\u0443\u0443\u043B\u0430\u0445"
        }, y_ = {
            "copy-format": "opmaak kopi\xebren"
        }, __ = {
            "copy-format": "format kopii"
        }, j_ = {
            "copy-format": "Copiar formato"
        }, w_ = {
            "copy-format": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442"
        }, k_ = {
            "copy-format": "Kopyalama Bi\xe7imi"
        }, S_ = {
            "copy-format": "\u590D\u5236\u683C\u5F0F"
        }, x_ = {
            "copy-format": "\u8907\u88FD\u683C\u5F0F"
        };
        var O_ = "copy-format", C_ = [
            "fontWeight",
            "fontStyle",
            "fontSize",
            "color",
            "margin",
            "padding",
            "borderWidth",
            "borderStyle",
            "borderColor",
            "borderRadius",
            "backgroundColor",
            "textDecorationLine",
            "fontFamily"
        ], z_ = function(e, t, o, n) {
            var r = Ln(o, t);
            return r === n[t] && (r = o.parentNode && o !== e.editor && o.parentNode !== e.editor ? z_(e, t, o.parentNode, n) : void 0), r;
        };
        function E_(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function T_(e, t, o) {
            return T_ = M_() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && R_(r, o.prototype), r;
            }, T_.apply(null, arguments);
        }
        function I_(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function P_(e) {
            return P_ = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, P_(e);
        }
        function R_(e, t) {
            return R_ = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, R_(e, t);
        }
        function A_(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function L_(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return L_ = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return T_(e, arguments, P_(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), R_(n, e);
            }, L_(e);
        }
        function M_() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (M_ = function() {
                return !!e;
            })();
        }
        rr.prototype.controls.copyformat = {
            exec: function(e, t, o) {
                var n = o.button;
                if (t) {
                    if (e.buffer.exists(O_)) e.buffer.delete(O_), e.e.off(e.editor, "mouseup." + O_);
                    else {
                        var r = {}, i = pi.up(t, function(e) {
                            return e && !pi.isText(e);
                        }, e.editor) || e.editor, a = e.createInside.span();
                        e.editor.appendChild(a), C_.forEach(function(e) {
                            r[e] = Ln(a, e);
                        }), a !== e.editor && pi.safeRemove(a);
                        var l = function(e, t, o) {
                            var n = {};
                            return t && C_.forEach(function(r) {
                                n[r] = z_(e, r, t, o), r.match(/border(Style|Color)/) && !n.borderWidth && (n[r] = void 0);
                            }), n;
                        }(e, i, r);
                        e.e.on(e.editor, "mouseup." + O_, function() {
                            e.buffer.delete(O_);
                            var t = e.s.current();
                            t && (pi.isTag(t, "img") ? Ln(t, l) : e.s.commitStyle({
                                attributes: {
                                    style: l
                                }
                            })), e.e.off(e.editor, "mouseup." + O_);
                        }), e.buffer.set(O_, !0);
                    }
                    n.update();
                }
            },
            isActive: function(e) {
                return e.buffer.exists(O_);
            },
            tooltip: "Paint format"
        }, Ma.add("copyformat", function(e) {
            e.registerButton({
                name: "copyformat",
                group: "clipboard"
            }), Da(h);
        }), Ol.set("copyformat", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 16 16"> <path stroke-width="0" d="M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"/> </svg> ');
        var B_ = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : A_(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, D_ = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = P_(t), function(e, t) {
                        return !t || "object" !== A_(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, M_() ? Reflect.construct(t, o || [], P_(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).isFragmentFromEditor = !1, e.isCopyMode = !1, e.startDragPoint = {
                    x: 0,
                    y: 0
                }, e.draggable = null, e.bufferRange = null, e.getText = function(e) {
                    var t = mr(e);
                    return t ? t.getData(no) || t.getData(oo) : null;
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && R_(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function() {
                        this.j.e.on([
                            window,
                            this.j.ed,
                            this.j.editor
                        ], "dragstart.DragAndDrop", this.onDragStart);
                    }
                },
                {
                    key: "onDragStart",
                    value: function(e) {
                        var t = e.target;
                        if (this.onDragEnd(), this.isFragmentFromEditor = pi.isOrContains(this.j.editor, t, !0), this.isCopyMode = !this.isFragmentFromEditor || xr(e), this.isFragmentFromEditor) {
                            var o = this.j.s.sel, n = o && o.rangeCount ? o.getRangeAt(0) : null;
                            n && (this.bufferRange = n.cloneRange());
                        } else this.bufferRange = null;
                        this.startDragPoint.x = e.clientX, this.startDragPoint.y = e.clientY, function(e) {
                            return pi.isElement(e) && e.classList.contains(kp.prototype.getFullElName("item"));
                        }(t) && (t = t.querySelector("img")), pi.isTag(t, "img") && (this.draggable = t.cloneNode(!0), cr(this.draggable, "target", t)), this.addDragListeners();
                    }
                },
                {
                    key: "addDragListeners",
                    value: function() {
                        this.j.e.on("dragover", this.onDrag).on("drop.DragAndDrop", this.onDrop).on(window, "dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop", this.onDragEnd);
                    }
                },
                {
                    key: "removeDragListeners",
                    value: function() {
                        this.j.e.off("dragover", this.onDrag).off("drop.DragAndDrop", this.onDrop).off(window, "dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop", this.onDragEnd);
                    }
                },
                {
                    key: "onDrag",
                    value: function(e) {
                        this.draggable && (this.j.e.fire("hidePopup"), this.j.s.insertCursorAtPoint(e.clientX, e.clientY), e.preventDefault(), e.stopPropagation());
                    }
                },
                {
                    key: "onDragEnd",
                    value: function() {
                        this.draggable && (pi.safeRemove(this.draggable), this.draggable = null), this.isCopyMode = !1, this.removeDragListeners();
                    }
                },
                {
                    key: "onDrop",
                    value: function(e) {
                        if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) {
                            if (!this.isFragmentFromEditor && !this.draggable) return this.j.e.fire("paste", e), e.preventDefault(), e.stopPropagation(), !1;
                            var t = this.j.s.sel, o = this.bufferRange || (t && t.rangeCount ? t.getRangeAt(0) : null), n = this.__getWorkFragment(o, e);
                            t && t.removeAllRanges(), this.j.s.insertCursorAtPoint(e.clientX, e.clientY), n && this.__insertFragment.call(this, n, o), e.preventDefault(), e.stopPropagation();
                        }
                        this.isFragmentFromEditor = !1, this.removeDragListeners();
                    }
                },
                {
                    key: "__getWorkFragment",
                    value: function(e, t) {
                        var o = null;
                        if (!this.draggable && e) o = this.isCopyMode ? e.cloneContents() : e.extractContents();
                        else if (this.draggable) {
                            if (this.isCopyMode) {
                                var n = function(e, t) {
                                    return function(e) {
                                        if (Array.isArray(e)) return e;
                                    }(e) || function(e, t) {
                                        var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                        if (null != o) {
                                            var n, r, i = [], a = !0, l = !1;
                                            try {
                                                for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                            } catch (e) {
                                                l = !0, r = e;
                                            } finally{
                                                try {
                                                    a || null == o.return || o.return();
                                                } finally{
                                                    if (l) throw r;
                                                }
                                            }
                                            return i;
                                        }
                                    }(e, t) || function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return E_(e, t);
                                            var o = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? E_(e, t) : void 0;
                                        }
                                    }(e, t) || function() {
                                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }("1" === er(this.draggable, "-is-file") ? [
                                    "a",
                                    "href"
                                ] : [
                                    "img",
                                    "src"
                                ], 2), r = n[0], i = n[1];
                                (o = this.j.createInside.element(r)).setAttribute(i, er(this.draggable, "data-src") || er(this.draggable, "src") || ""), "a" === r && (o.textContent = er(o, i) || "");
                            } else o = cr(this.draggable, "target");
                        } else this.getText(t) && (o = this.j.createInside.fromHTML(this.getText(t)));
                        return o;
                    }
                },
                {
                    key: "__insertFragment",
                    value: function(e, t) {
                        this.j.s.insertNode(e, !1, !1), t && e.firstChild && e.lastChild && (t.setStartBefore(e.firstChild), t.setEndAfter(e.lastChild), this.j.s.selectRange(t), this.j.e.fire("synchro")), pi.isTag(e, "img") && this.j.events && this.j.e.fire("afterInsertImage", e);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.onDragEnd(), this.j.e.off(window, ".DragAndDrop").off(".DragAndDrop").off([
                            window,
                            this.j.ed,
                            this.j.editor
                        ], "dragstart.DragAndDrop", this.onDragStart);
                    }
                }
            ], n && I_(o.prototype, n), t;
        }(L_(Wp));
        function N_(e, t, o) {
            return N_ = U_() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && q_(r, o.prototype), r;
            }, N_.apply(null, arguments);
        }
        function H_(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function F_(e) {
            return F_ = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, F_(e);
        }
        function q_(e, t) {
            return q_ = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, q_(e, t);
        }
        function V_(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function W_(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return W_ = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return N_(e, arguments, F_(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), q_(n, e);
            }, W_(e);
        }
        function U_() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (U_ = function() {
                return !!e;
            })();
        }
        B_([
            To
        ], D_.prototype, "onDragStart", null), B_([
            el(function(e) {
                return e.defaultTimeout / 10;
            })
        ], D_.prototype, "onDrag", null), B_([
            To
        ], D_.prototype, "onDragEnd", null), B_([
            To
        ], D_.prototype, "onDrop", null), Ma.add("dragAndDrop", D_), rr.prototype.draggableTags = [
            "img",
            "jodit-media",
            "jodit"
        ];
        var Y_, K_ = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : V_(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        };
        !function(e) {
            e[e.IDLE = 0] = "IDLE", e[e.WAIT_DRAGGING = 1] = "WAIT_DRAGGING", e[e.DRAGGING = 2] = "DRAGGING";
        }(Y_ || (Y_ = {}));
        var G_ = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = F_(t), function(e, t) {
                        return !t || "object" !== V_(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, U_() ? Reflect.construct(t, o || [], F_(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).dragList = [], e.draggable = null, e.isCopyMode = !1, e.diffStep = 10, e.startX = 0, e.startY = 0, e.state = Y_.IDLE, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && q_(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function() {
                        this.dragList = this.j.o.draggableTags ? Pi(this.j.o.draggableTags).filter(Boolean).map(function(e) {
                            return e.toLowerCase();
                        }) : [], this.dragList.length && this.j.e.on("mousedown dragstart", this.onDragStart);
                    }
                },
                {
                    key: "onDragStart",
                    value: function(e) {
                        var t = this;
                        if ("dragstart" === e.type && this.draggable) return !1;
                        if (!(this.state > Y_.IDLE)) {
                            var o = e.target;
                            if (this.dragList.length && o) {
                                var n = function(e) {
                                    return Boolean(e && t.dragList.includes(e.nodeName.toLowerCase()));
                                }, r = pi.furthest(o, n, this.j.editor) || (n(o) ? o : null);
                                r && (pi.isTag(r.parentElement, "a") && r.parentElement.firstChild === r && r.parentElement.lastChild === r && (r = r.parentElement), this.startX = e.clientX, this.startY = e.clientY, this.isCopyMode = xr(e), this.draggable = r.cloneNode(!0), cr(this.draggable, "target", r), this.state = Y_.WAIT_DRAGGING, this.addDragListeners());
                            }
                        }
                    }
                },
                {
                    key: "onDrag",
                    value: function(e) {
                        var o, n;
                        if (this.draggable && this.state !== Y_.IDLE) {
                            var r = e.clientX, i = e.clientY;
                            if (!(this.state === Y_.WAIT_DRAGGING && Math.sqrt(Math.pow(r - this.startX, 2) + Math.pow(i - this.startY, 2)) < this.diffStep)) {
                                if (this.state === Y_.WAIT_DRAGGING && (this.j.lock("drag-and-drop-element"), this.state = Y_.DRAGGING), this.j.e.fire("hidePopup hideResizer"), !this.draggable.parentNode) {
                                    var a = cr(this.draggable, "target");
                                    Ln(this.draggable, {
                                        zIndex: 1e13,
                                        pointerEvents: "none",
                                        pointer: "drag",
                                        position: "fixed",
                                        opacity: .7,
                                        display: "inline-block",
                                        left: e.clientX,
                                        top: e.clientY,
                                        width: null !== (o = null == a ? void 0 : a.offsetWidth) && void 0 !== o ? o : 100,
                                        height: null !== (n = null == a ? void 0 : a.offsetHeight) && void 0 !== n ? n : 100
                                    }), Ha(this.j, t).appendChild(this.draggable);
                                }
                                Ln(this.draggable, {
                                    left: e.clientX,
                                    top: e.clientY
                                }), this.j.s.insertCursorAtPoint(e.clientX, e.clientY);
                            }
                        }
                    }
                },
                {
                    key: "onDragEnd",
                    value: function() {
                        this.isInDestruct || (this.removeDragListeners(), this.j.unlock(), this.state = Y_.IDLE, this.draggable && (pi.safeRemove(this.draggable), this.draggable = null));
                    }
                },
                {
                    key: "onDrop",
                    value: function() {
                        if (!this.draggable || this.state < Y_.DRAGGING) this.onDragEnd();
                        else {
                            var e = cr(this.draggable, "target");
                            this.onDragEnd(), this.isCopyMode && (e = e.cloneNode(!0));
                            var t = e.parentElement;
                            this.j.s.insertNode(e, !0, !1), t && pi.isEmpty(t) && !pi.isCell(t) && pi.safeRemove(t), pi.isTag(e, "img") && this.j.e && this.j.e.fire("afterInsertImage", e), this.j.e.fire("synchro");
                        }
                    }
                },
                {
                    key: "addDragListeners",
                    value: function() {
                        this.j.e.on(this.j.editor, "mousemove", this.onDrag).on("mouseup", this.onDrop).on([
                            this.j.ew,
                            this.ow
                        ], "mouseup", this.onDragEnd);
                    }
                },
                {
                    key: "removeDragListeners",
                    value: function() {
                        this.j.e.off(this.j.editor, "mousemove", this.onDrag).off("mouseup", this.onDrop).off([
                            this.j.ew,
                            this.ow
                        ], "mouseup", this.onDragEnd);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.onDragEnd(), this.j.e.off("mousedown dragstart", this.onDragStart), this.removeDragListeners();
                    }
                }
            ], H_(o.prototype, n), t;
        }(W_(Wp));
        K_([
            To
        ], G_.prototype, "onDragStart", null), K_([
            el(function(e) {
                return e.defaultTimeout / 10;
            })
        ], G_.prototype, "onDrag", null), K_([
            To
        ], G_.prototype, "onDragEnd", null), K_([
            To
        ], G_.prototype, "onDrop", null), Ma.add("dragAndDropElement", G_), rr.prototype.controls.file = {
            popup: function(e, t, o) {
                var n = function(t) {
                    var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                    e.s.insertNode(e.createInside.fromHTML('<a href="'.concat(t, '" title="').concat(o, '">').concat(o || t, "</a>")));
                }, r = null;
                return t && (pi.isTag(t, "a") || pi.closest(t, "a", e.editor)) && (r = pi.isTag(t, "a") ? t : pi.closest(t, "a", e.editor)), tm(e, {
                    filebrowser: function(e) {
                        e.files && e.files.forEach(function(t) {
                            return n(e.baseurl + t);
                        }), o();
                    },
                    upload: !0,
                    url: function(e, t) {
                        r ? (r.setAttribute("href", e), r.setAttribute("title", t)) : n(e, t), o();
                    }
                }, r, o, !1);
            },
            tags: [
                "a"
            ],
            tooltip: "Insert file"
        }, Ma.add("file", function(e) {
            e.registerButton({
                name: "file",
                group: "media"
            });
        }), rr.prototype.autofocus = !1, rr.prototype.cursorAfterAutofocus = "end", rr.prototype.saveSelectionOnBlur = !0, Ma.add("focus", function(e) {
            e.o.saveSelectionOnBlur && e.e.on("blur", function() {
                e.isEditorMode() && e.s.save(!0);
            }).on("focus", function() {
                e.s.restore();
            });
            var t = function() {
                if (e.s.focus(), "end" === e.o.cursorAfterAutofocus) {
                    var t = pi.last(e.editor, function(e) {
                        return pi.isText(e);
                    });
                    t && e.s.setCursorIn(t, !1);
                }
            };
            e.e.on("afterInit", function() {
                e.o.autofocus && (e.defaultTimeout ? e.async.setTimeout(t, 300) : t());
            }), e.e.on("afterInit afterAddPlace", function() {
                e.e.off(e.editor, "mousedown.autofocus").on(e.editor, "mousedown.autofocus", function(t) {
                    e.isEditorMode() && t.target && pi.isBlock(t.target) && !t.target.childNodes.length && (e.editor === t.target ? e.s.focus() : e.s.setCursorIn(t.target));
                });
            });
        }), rr.prototype.fullsize = !1, rr.prototype.globalFullSize = !0, Ol.set("fullsize", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <path stroke-width="0" d="M22,20.6L3.4,2H8V0H0v8h2V3.4L20.6,22H16v2h8v-8h-2V20.6z M16,0v2h4.7l-6.3,6.3l1.4,1.4L22,3.5V8h2V0H16z M8.3,14.3L2,20.6V16H0v8h8v-2H3.5l6.3-6.3L8.3,14.3z"/> </svg> ').set("shrink", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"/> </svg> '), rr.prototype.controls.fullsize = {
            exec: function(e) {
                e.toggleFullSize();
            },
            update: function(e, t) {
                var o = e.isFullSize ? "shrink" : "fullsize";
                t.state.activated = e.isFullSize, e.o.textIcons ? t.state.text = o : t.state.icon.name = o;
            },
            tooltip: "Open in fullsize",
            mode: $t + Qt
        };
        var J_ = new Set;
        function X_(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function Z_(e, t, o) {
            return Z_ = nj() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && ej(r, o.prototype), r;
            }, Z_.apply(null, arguments);
        }
        function Q_(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function $_(e) {
            return $_ = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, $_(e);
        }
        function ej(e, t) {
            return ej = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, ej(e, t);
        }
        function tj(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function oj(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return oj = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Z_(e, arguments, $_(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), ej(n, e);
            }, oj(e);
        }
        function nj() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (nj = function() {
                return !!e;
            })();
        }
        Ma.add("fullsize", function(e) {
            e.registerButton({
                name: "fullsize"
            });
            var t = !1, o = 0, n = 0, r = !1, i = function() {
                var i = e.container;
                e.events && (t ? (o = Ln(i, "height", !0), n = Ln(i, "width", !0), Ln(i, {
                    height: e.ow.innerHeight,
                    width: e.ow.innerWidth
                }), r = !0) : r && Ln(i, {
                    height: o || "auto",
                    width: n || "auto"
                }));
            }, a = function(o) {
                var n, r = e.container, a = e.events;
                if (r) {
                    if (void 0 === o && (o = !r.classList.contains("jodit_fullsize")), e.setMod("fullsize", o), e.o.fullsize = o, t = o, r.classList.toggle("jodit_fullsize", o), e.toolbar && (nn(e) && (null === (n = e.toolbarContainer) || void 0 === n || n.appendChild(e.toolbar.container)), Ln(e.toolbar.container, "width", "auto")), o ? J_.add(r) : J_.delete(r), e.o.globalFullSize && (1 === J_.size && o || 0 === J_.size && !o)) {
                        for(var l = r.parentNode; l && l.nodeType !== Node.DOCUMENT_NODE && l.nodeType !== Node.DOCUMENT_FRAGMENT_NODE;)l.classList.toggle("jodit_fullsize-box_true", o), l = l.parentNode;
                        i();
                    }
                    a.fire("afterResize");
                }
            };
            e.o.globalFullSize && e.e.on(e.ow, "resize", i), e.e.on("afterInit afterOpen", function() {
                var t;
                e.toggleFullSize(null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.fullsize);
            }).on("toggleFullSize", a).on("beforeDestruct", function() {
                t && a(!1);
            }).on("beforeDestruct", function() {
                e.events && e.e.off(e.ow, "resize", i);
            });
        }), Ol.set("hr", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"/> </svg> '), rr.prototype.controls.hr = {
            command: "insertHorizontalRule",
            tags: [
                "hr"
            ],
            tooltip: "Insert Horizontal Line"
        }, Ma.add("hr", function(e) {
            e.registerButton({
                name: "hr",
                group: "insert"
            }), e.registerCommand("insertHorizontalRule", function() {
                var t = e.createInside.element("hr");
                e.s.insertNode(t, !1, !1);
                var o = pi.closest(t.parentElement, pi.isBlock, e.editor);
                o && pi.isEmpty(o) && o !== e.editor && (pi.after(o, t), pi.safeRemove(o));
                var n = pi.next(t, pi.isBlock, e.editor, !1);
                return n || (n = e.createInside.element(e.o.enter), pi.after(t, n)), e.s.setCursorIn(n), !1;
            });
        }), rr.prototype.imageProcessor = {
            replaceDataURIToBlobIdInView: !0
        };
        var rj = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : tj(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, ij = "__jodit_imageprocessor_binded", aj = ij + "blob-id", lj = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = $_(o = t), function(e, t) {
                    return !t || "object" !== tj(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, nj() ? Reflect.construct(o, n || [], $_(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ej(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {}
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        var t = hi(e, "buffer"), o = null == t ? void 0 : t.get(aj);
                        if (t && o) {
                            var n = Object.keys(o), r = !0, i = !1, a = void 0;
                            try {
                                for(var l, s = n[Symbol.iterator](); !(r = (l = s.next()).done); r = !0){
                                    var c = l.value;
                                    URL.revokeObjectURL(c);
                                }
                            } catch (e) {
                                i = !0, a = e;
                            } finally{
                                try {
                                    r || null == s.return || s.return();
                                } finally{
                                    if (i) throw a;
                                }
                            }
                            t.delete(aj);
                        }
                    }
                },
                {
                    key: "onAfterGetValueFromEditor",
                    value: function(e, t) {
                        if (t !== So) return this.onBeforeSetElementValue(e);
                    }
                },
                {
                    key: "onBeforeSetElementValue",
                    value: function(e) {
                        var t = this.jodit;
                        if (t.o.imageProcessor.replaceDataURIToBlobIdInView) {
                            var o = t.buffer.get(aj);
                            if (o) {
                                var n = Object.keys(o), r = !0, i = !1, a = void 0;
                                try {
                                    for(var l, s = n[Symbol.iterator](); !(r = (l = s.next()).done); r = !0)for(var c = l.value; e.value.includes(c);)e.value = e.value.replace(c, o[c]);
                                } catch (e) {
                                    i = !0, a = e;
                                } finally{
                                    try {
                                        r || null == s.return || s.return();
                                    } finally{
                                        if (i) throw a;
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    key: "afterChange",
                    value: function(e) {
                        var t, o = this;
                        return (t = function() {
                            var e;
                            return function(e, t) {
                                var o, n, r, i, a = {
                                    label: 0,
                                    sent: function() {
                                        if (1 & r[0]) throw r[1];
                                        return r[1];
                                    },
                                    trys: [],
                                    ops: []
                                };
                                return i = {
                                    next: l(0),
                                    throw: l(1),
                                    return: l(2)
                                }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                    return this;
                                }), i;
                                function l(i) {
                                    return function(l) {
                                        return function(i) {
                                            if (o) throw new TypeError("Generator is already executing.");
                                            for(; a;)try {
                                                if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                switch(n = 0, r && (i = [
                                                    2 & i[0],
                                                    r.value
                                                ]), i[0]){
                                                    case 0:
                                                    case 1:
                                                        r = i;
                                                        break;
                                                    case 4:
                                                        return a.label++, {
                                                            value: i[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        a.label++, n = i[1], i = [
                                                            0
                                                        ];
                                                        continue;
                                                    case 7:
                                                        i = a.ops.pop(), a.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                            a = 0;
                                                            continue;
                                                        }
                                                        if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                            a.label = i[1];
                                                            break;
                                                        }
                                                        if (6 === i[0] && a.label < r[1]) {
                                                            a.label = r[1], r = i;
                                                            break;
                                                        }
                                                        if (r && a.label < r[2]) {
                                                            a.label = r[2], a.ops.push(i);
                                                            break;
                                                        }
                                                        r[2] && a.ops.pop(), a.trys.pop();
                                                        continue;
                                                }
                                                i = t.call(e, a);
                                            } catch (e) {
                                                i = [
                                                    6,
                                                    e
                                                ], n = 0;
                                            } finally{
                                                o = r = 0;
                                            }
                                            if (5 & i[0]) throw i[1];
                                            return {
                                                value: i[0] ? i[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            i,
                                            l
                                        ]);
                                    };
                                }
                            }(this, function(t) {
                                return (e = o.jodit).editor ? (Qr("img", e.editor).forEach(function(t) {
                                    cr(t, ij) || (cr(t, ij, !0), t.complete || e.e.on(t, "load", function o() {
                                        var n;
                                        !e.isInDestruct && (null === (n = e.e) || void 0 === n || n.fire("resize")), e.e.off(t, "load", o);
                                    }), t.src && /^data:/.test(t.src) && function(e, t) {
                                        if (e.o.imageProcessor.replaceDataURIToBlobIdInView && "undefined" != typeof ArrayBuffer && "undefined" != typeof URL) {
                                            var o = t.src, n = function(e) {
                                                for(var t = atob(e.split(",")[1]), o = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; i < t.length; i++)r[i] = t.charCodeAt(i);
                                                return new Blob([
                                                    n
                                                ], {
                                                    type: o
                                                });
                                            }(o);
                                            t.src = URL.createObjectURL(n), e.e.fire("internalUpdate");
                                            var r = e.buffer.get(aj) || {};
                                            r[t.src] = o, e.buffer.set(aj, r);
                                        }
                                    }(e, t), e.e.on(t, "mousedown touchstart", function() {
                                        e.s.select(t);
                                    }));
                                }), [
                                    2
                                ]) : [
                                    2
                                ];
                            });
                        }, function() {
                            var e = this, o = arguments;
                            return new Promise(function(n, r) {
                                var i = t.apply(e, o);
                                function a(e) {
                                    X_(i, n, r, a, l, "next", e);
                                }
                                function l(e) {
                                    X_(i, n, r, a, l, "throw", e);
                                }
                                a(void 0);
                            });
                        })();
                    }
                }
            ], n && Q_(o.prototype, n), t;
        }(oj(Wp));
        function sj(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function cj(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function uj(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function dj(e) {
            return dj = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, dj(e);
        }
        function fj(e, t) {
            return fj = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, fj(e, t);
        }
        function pj(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function hj() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (hj = function() {
                return !!e;
            })();
        }
        rj([
            Ca(":afterGetValueFromEditor")
        ], lj.prototype, "onAfterGetValueFromEditor", null), rj([
            Ca(":beforeSetElementValue")
        ], lj.prototype, "onBeforeSetElementValue", null), rj([
            Ca([
                ":change",
                ":afterInit",
                ":changePlace"
            ]),
            $a()
        ], lj.prototype, "afterChange", null), Ma.add("imageProcessor", lj), rr.prototype.image = {
            dialogWidth: 600,
            openOnDblClick: !0,
            editSrc: !0,
            useImageEditor: !0,
            editTitle: !0,
            editAlt: !0,
            editLink: !0,
            editSize: !0,
            editBorderRadius: !0,
            editMargins: !0,
            editClass: !0,
            availableClasses: [],
            editStyle: !0,
            editId: !0,
            editAlign: !0,
            showPreview: !0,
            selectImageAfterClose: !0
        };
        var vj = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : pj(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, gj = function(e) {
            function t(e, o, n) {
                var r;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (r = function(e, t, o) {
                    return t = dj(t), function(e, t) {
                        return !t || "object" !== pj(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, hj() ? Reflect.construct(t, o || [], dj(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).state = o, r.handlers = n, r;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && fj(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIImageMainTab";
                    }
                },
                {
                    key: "appendChildToContainer",
                    value: function() {}
                },
                {
                    key: "render",
                    value: function() {
                        return '<div class="jodit-form__group &__editSrc">\n\t\t\t<label>~Src~</label>\n\t\t\t<div class="jodit-input_group">\n\t\t\t\t<input class="jodit-input &__imageSrc" type="text"/>\n\t\t\t\t<div class="jodit-input_group-buttons &__fixImage">\n\t\t\t\t\t\t<a class="jodit-button &__changeImage">*image*</a>\n\t\t\t\t\t\t<a class="jodit-button &__editImage">*crop*</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editTitle">\n\t\t\t<label>~Title~</label>\n\t\t\t<input type="text" class="jodit-input &__imageTitle"/>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editAlt">\n\t\t\t<label>~Alternative~</label>\n\t\t\t<input type="text" class="jodit-input &__imageAlt"/>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editLink">\n\t\t\t<label>~Link~</label>\n\t\t\t<input type="text" class="jodit-input &__imageLink"/>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editLinkTarget">\n\t\t\t<label class="jodit_vertical_middle">\n\t\t\t\t<input type="checkbox" class="jodit-checkbox &__imageLinkOpenInNewTab"/>\n\t\t\t\t<span>~Open link in new tab~</span>\n\t\t\t</label>\n\t\t</div>';
                    }
                },
                {
                    key: "onStateImageSrcChange",
                    value: function() {
                        var e, t = this;
                        return (e = function() {
                            return function(e, t) {
                                var o, n, r, i, a = {
                                    label: 0,
                                    sent: function() {
                                        if (1 & r[0]) throw r[1];
                                        return r[1];
                                    },
                                    trys: [],
                                    ops: []
                                };
                                return i = {
                                    next: l(0),
                                    throw: l(1),
                                    return: l(2)
                                }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                    return this;
                                }), i;
                                function l(i) {
                                    return function(l) {
                                        return function(i) {
                                            if (o) throw new TypeError("Generator is already executing.");
                                            for(; a;)try {
                                                if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                switch(n = 0, r && (i = [
                                                    2 & i[0],
                                                    r.value
                                                ]), i[0]){
                                                    case 0:
                                                    case 1:
                                                        r = i;
                                                        break;
                                                    case 4:
                                                        return a.label++, {
                                                            value: i[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        a.label++, n = i[1], i = [
                                                            0
                                                        ];
                                                        continue;
                                                    case 7:
                                                        i = a.ops.pop(), a.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                            a = 0;
                                                            continue;
                                                        }
                                                        if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                            a.label = i[1];
                                                            break;
                                                        }
                                                        if (6 === i[0] && a.label < r[1]) {
                                                            a.label = r[1], r = i;
                                                            break;
                                                        }
                                                        if (r && a.label < r[2]) {
                                                            a.label = r[2], a.ops.push(i);
                                                            break;
                                                        }
                                                        r[2] && a.ops.pop(), a.trys.pop();
                                                        continue;
                                                }
                                                i = t.call(e, a);
                                            } catch (e) {
                                                i = [
                                                    6,
                                                    e
                                                ], n = 0;
                                            } finally{
                                                o = r = 0;
                                            }
                                            if (5 & i[0]) throw i[1];
                                            return {
                                                value: i[0] ? i[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            i,
                                            l
                                        ]);
                                    };
                                }
                            }(this, function(e) {
                                return t.getElm("imageSrc").value = t.state.values.imageSrc, [
                                    2
                                ];
                            });
                        }, function() {
                            var t = this, o = arguments;
                            return new Promise(function(n, r) {
                                var i = e.apply(t, o);
                                function a(e) {
                                    cj(i, n, r, a, l, "next", e);
                                }
                                function l(e) {
                                    cj(i, n, r, a, l, "throw", e);
                                }
                                a(void 0);
                            });
                        })();
                    }
                },
                {
                    key: "onImageSrcChange",
                    value: function() {
                        this.state.values.imageSrc = this.getElm("imageSrc").value;
                    }
                },
                {
                    key: "onEditImageClick",
                    value: function(e) {
                        this.handlers.openImageEditor(), e.stopPropagation();
                    }
                },
                {
                    key: "onChangeImageClick",
                    value: function(e) {
                        this.handlers.openImagePopup(this.getElm("changeImage")), e.stopPropagation();
                    }
                },
                {
                    key: "onStateTitleChange",
                    value: function() {
                        this.getElm("imageTitle").value = this.state.values.imageTitle;
                    }
                },
                {
                    key: "onTitleChange",
                    value: function() {
                        this.state.values.imageTitle = this.getElm("imageTitle").value;
                    }
                },
                {
                    key: "onStateAltChange",
                    value: function() {
                        this.getElm("imageAlt").value = this.state.values.imageAlt;
                    }
                },
                {
                    key: "onAltChange",
                    value: function() {
                        this.state.values.imageAlt = this.getElm("imageAlt").value;
                    }
                },
                {
                    key: "onStateImageLinkChange",
                    value: function() {
                        this.getElm("imageLink").value = this.state.values.imageLink;
                    }
                },
                {
                    key: "onImageLinkChange",
                    value: function() {
                        this.state.values.imageLink = this.getElm("imageLink").value;
                    }
                },
                {
                    key: "onStateImageLinkOpenInNewTabChange",
                    value: function() {
                        this.getElm("imageLinkOpenInNewTab").checked = this.state.values.imageLinkOpenInNewTab;
                    }
                },
                {
                    key: "onImageLinkOpenInNewTabChange",
                    value: function() {
                        this.state.values.imageLinkOpenInNewTab = this.getElm("imageLinkOpenInNewTab").checked;
                    }
                },
                {
                    key: "hideFieldByOptions",
                    value: function() {
                        var e = this, t = this.j.o, o = t.image;
                        [
                            [
                                "editSrc",
                                "editSrc"
                            ],
                            [
                                "editTitle",
                                "editTitle"
                            ],
                            [
                                "editAlt",
                                "editAlt"
                            ],
                            [
                                "editLink",
                                "editLink"
                            ],
                            [
                                "editLink",
                                "editLinkTarget"
                            ],
                            [
                                "useImageEditor",
                                "editImage"
                            ]
                        ].forEach(function(t) {
                            var n = function(e, t) {
                                return function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != o) {
                                        var n, r, i = [], a = !0, l = !1;
                                        try {
                                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                        } catch (e) {
                                            l = !0, r = e;
                                        } finally{
                                            try {
                                                a || null == o.return || o.return();
                                            } finally{
                                                if (l) throw r;
                                            }
                                        }
                                        return i;
                                    }
                                }(e, t) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return sj(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? sj(e, t) : void 0;
                                    }
                                }(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(t, 2), r = n[0], i = n[1];
                            Ln(e.getElm(i), "display", o[r] ? null : "none");
                        });
                        var n = this.getElm("changeImage"), r = Boolean(t.filebrowser.ajax.url || t.uploader.url);
                        Ln(n, "display", r ? null : "none");
                        var i = this.getElm("editImage"), a = Boolean(t.filebrowser.ajax.url) && o.useImageEditor;
                        Ln(i, "display", a ? null : "none"), Ln(this.getElm("fixImage"), "display", r || a ? null : "none");
                    }
                }
            ], n && uj(o.prototype, n), t;
        }(Ul);
        vj([
            Ca("state.values.imageSrc")
        ], gj.prototype, "onStateImageSrcChange", null), vj([
            Ca("imageSrc:change")
        ], gj.prototype, "onImageSrcChange", null), vj([
            Ca("editImage:click")
        ], gj.prototype, "onEditImageClick", null), vj([
            Ca("changeImage:click")
        ], gj.prototype, "onChangeImageClick", null), vj([
            Ca("state.values.imageTitle")
        ], gj.prototype, "onStateTitleChange", null), vj([
            Ca("imageTitle:change")
        ], gj.prototype, "onTitleChange", null), vj([
            Ca("state.values.imageAlt")
        ], gj.prototype, "onStateAltChange", null), vj([
            Ca("imageAlt:change")
        ], gj.prototype, "onAltChange", null), vj([
            Ca("state.values.imageLink")
        ], gj.prototype, "onStateImageLinkChange", null), vj([
            Ca("imageLink:change")
        ], gj.prototype, "onImageLinkChange", null), vj([
            Ca("state.values.imageLinkOpenInNewTab")
        ], gj.prototype, "onStateImageLinkOpenInNewTabChange", null), vj([
            Ca("imageLinkOpenInNewTab:change")
        ], gj.prototype, "onImageLinkOpenInNewTabChange", null), vj([
            rl("ready")
        ], gj.prototype, "hideFieldByOptions", null), gj = vj([
            ji
        ], gj);
        var mj = function(e) {
            return /^[-+]?[0-9.]+(px)?$/.test(e.toString()) ? parseFloat(e.toString()) : e;
        }, bj = function(e) {
            return ln(e) ? e ? e + "px" : e.toString() : (e = vn(e), /^[0-9]+$/.test(e) ? e + "px" : e);
        };
        function yj(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function _j(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function jj(e) {
            return jj = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, jj(e);
        }
        function wj(e, t) {
            return wj = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, wj(e, t);
        }
        function kj(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Sj() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Sj = function() {
                return !!e;
            })();
        }
        var xj = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : kj(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Oj = function(e) {
            function t(e, o, n) {
                var r;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (r = function(e, t, o) {
                    return t = jj(t), function(e, t) {
                        return !t || "object" !== kj(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Sj() ? Reflect.construct(t, o || [], jj(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e,
                    {
                        availableClasses: e.o.image.availableClasses
                    }
                ])).state = o, r.handlers = n, r;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && wj(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIImagePositionTab";
                    }
                },
                {
                    key: "render",
                    value: function(e) {
                        var t, o = e.availableClasses;
                        return '<div class="jodit-form__group &__editMargins">\n\t\t\t<label>~Margins~</label>\n\t\t\t<div class="jodit-grid jodit_vertical_middle">\n\t\t\t\t<input class="jodit_col-lg-1-5 jodit-input &__marginTop" type="text" placeholder="~top~"/>\n\t\t\t\t<a style="text-align: center;" class="jodit-properties__lock jodit_col-lg-1-5 &__lockMargin">*lock*</a>\n\t\t\t\t<input disabled="disabled" class="jodit_col-lg-1-5 jodit-input &__marginRight" type="text" placeholder="~right~"/>\n\t\t\t\t<input disabled="disabled" class="jodit_col-lg-1-5 jodit-input &__marginBottom" type="text" placeholder="~bottom~"/>\n\t\t\t\t<input disabled="disabled" class="jodit_col-lg-1-5 jodit-input &__marginLeft" type="text" placeholder="~left~"/>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editAlign">\n\t\t\t<label>~Align~</label>\n\t\t\t<select class="jodit-select &__align">\n\t\t\t\t<option value="">~--Not Set--~</option>\n\t\t\t\t<option value="left">~Left~</option>\n\t\t\t\t<option value="center">~Center~</option>\n\t\t\t\t<option value="right">~Right~</option>\n\t\t\t</select>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editStyle">\n\t\t\t<label>~Styles~</label>\n\t\t\t<input type="text" class="jodit-input &__style"/>\n\t\t</div>\n\t\t<div class="jodit-form__group &__editClass">\n\t\t\t<label>~Classes~</label>\n\t\t\t'.concat((t = [], o && o.length > 0 ? (t.push('<select class="jodit-input jodit-select &__classes">'), o.forEach(function(e) {
                            Lo(e) ? t.push('<option value="'.concat(e, '">').concat(e, "</option>")) : t.push('<option value="'.concat(e[0], '">').concat(e[1], "</option>"));
                        }), t.push("</select>")) : t.push('<input type="text" class="jodit-input &__classes"/>'), t.join("")), '\n\t\t</div>\n\t\t<div class="jodit-form__group &__editId">\n\t\t\t<label>Id</label>\n\t\t\t<input type="text" class="jodit-input &__id"/>\n\t\t</div>\n\t\t<div\n\t\t\tclass="jodit-form__group &__editBorderRadius"\n\t\t>\n\t\t\t<label>~Border radius~</label>\n\t\t\t<input type="number" class="jodit-input &__borderRadius"/>\n\t\t</div>');
                    }
                },
                {
                    key: "onStateAlignChange",
                    value: function() {
                        this.getElm("align").value = this.state.values.align;
                    }
                },
                {
                    key: "onChangeAlign",
                    value: function() {
                        var e = this.getElm("align");
                        this.state.values.align = e.value;
                    }
                },
                {
                    key: "onStateValuesBorderRadiusChange",
                    value: function() {
                        this.getElm("borderRadius").value = this.state.values.borderRadius.toString();
                    }
                },
                {
                    key: "onChangeBorderRadius",
                    value: function() {
                        var e = this.getElm("borderRadius");
                        this.state.values.borderRadius = parseFloat(e.value);
                    }
                },
                {
                    key: "onStateValuesIdChange",
                    value: function() {
                        this.getElm("id").value = this.state.values.id;
                    }
                },
                {
                    key: "onChangeId",
                    value: function() {
                        var e = this.getElm("id");
                        this.state.values.id = e.value;
                    }
                },
                {
                    key: "onStateValuesStyleChange",
                    value: function() {
                        this.getElm("style").value = this.state.values.style;
                    }
                },
                {
                    key: "onChangeStyle",
                    value: function() {
                        var e = this.getElm("style");
                        this.state.values.style = e.value;
                    }
                },
                {
                    key: "onStateValuesClassesChange",
                    value: function() {
                        this.getElm("classes").value = this.state.values.classes;
                    }
                },
                {
                    key: "onChangClasses",
                    value: function() {
                        var e = this.getElm("classes");
                        this.state.values.classes = e.value;
                    }
                },
                {
                    key: "onLockMarginClick",
                    value: function(e) {
                        this.state.marginIsLocked = !this.state.marginIsLocked, e.preventDefault();
                    }
                },
                {
                    key: "onChangeMarginIsLocked",
                    value: function() {
                        var e = this, t = this.getElm("marginBottom"), o = this.getElm("marginRight"), n = this.getElm("marginLeft"), r = this.getElm("lockMargin");
                        if ([
                            o,
                            t,
                            n
                        ].forEach(function(t) {
                            er(t, "disabled", e.state.marginIsLocked || null);
                        }), r.innerHTML = Ol.get(this.state.marginIsLocked ? "lock" : "unlock"), this.state.marginIsLocked) {
                            var i = this.state.values.marginTop;
                            this.state.values.marginRight = i, this.state.values.marginBottom = i, this.state.values.marginLeft = i;
                        }
                    }
                },
                {
                    key: "onStateValuesMarginChange",
                    value: function() {
                        var e = this.getElm("marginTop"), t = this.getElm("marginRight"), o = this.getElm("marginBottom"), n = this.getElm("marginLeft");
                        e.value = this.state.values.marginTop.toString(), t.value = this.state.values.marginRight.toString(), o.value = this.state.values.marginBottom.toString(), n.value = this.state.values.marginLeft.toString();
                    }
                },
                {
                    key: "onChangeMargin",
                    value: function() {
                        var e = this.getElm("marginTop"), t = this.getElm("marginRight"), o = this.getElm("marginBottom"), n = this.getElm("marginLeft");
                        this.state.values.marginTop = mj(e.value), this.state.marginIsLocked ? (this.state.values.marginRight = this.state.values.marginTop, this.state.values.marginBottom = this.state.values.marginTop, this.state.values.marginLeft = this.state.values.marginTop) : (this.state.values.marginRight = mj(t.value), this.state.values.marginBottom = mj(o.value), this.state.values.marginLeft = mj(n.value));
                    }
                },
                {
                    key: "hideFieldByOptions",
                    value: function() {
                        var e = this, t = this.j.o.image;
                        [
                            [
                                "editMargins",
                                "editMargins"
                            ],
                            [
                                "editAlign",
                                "editAlign"
                            ],
                            [
                                "editStyle",
                                "editStyle"
                            ],
                            [
                                "editClass",
                                "editClass"
                            ],
                            [
                                "editId",
                                "editId"
                            ],
                            [
                                "editBorderRadius",
                                "editBorderRadius"
                            ]
                        ].forEach(function(o) {
                            var n = function(e, t) {
                                return function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != o) {
                                        var n, r, i = [], a = !0, l = !1;
                                        try {
                                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                        } catch (e) {
                                            l = !0, r = e;
                                        } finally{
                                            try {
                                                a || null == o.return || o.return();
                                            } finally{
                                                if (l) throw r;
                                            }
                                        }
                                        return i;
                                    }
                                }(e, t) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return yj(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? yj(e, t) : void 0;
                                    }
                                }(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(o, 2), r = n[0], i = n[1];
                            Ln(e.getElm(i), "display", t[r] ? null : "none");
                        });
                    }
                }
            ], n && _j(o.prototype, n), t;
        }(Al);
        function Cj(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function zj(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ej(e, t, o) {
            return Ej = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Tj(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, Ej(e, t, o || e);
        }
        function Tj(e) {
            return Tj = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Tj(e);
        }
        function Ij(e, t) {
            return Ij = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Ij(e, t);
        }
        function Pj(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Rj() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Rj = function() {
                return !!e;
            })();
        }
        xj([
            rl("ready"),
            Ca("state.values.align")
        ], Oj.prototype, "onStateAlignChange", null), xj([
            Ca("align:change")
        ], Oj.prototype, "onChangeAlign", null), xj([
            rl("ready"),
            Ca("state.values.borderRadius")
        ], Oj.prototype, "onStateValuesBorderRadiusChange", null), xj([
            Ca("borderRadius:change")
        ], Oj.prototype, "onChangeBorderRadius", null), xj([
            rl("ready"),
            Ca("state.values.id")
        ], Oj.prototype, "onStateValuesIdChange", null), xj([
            Ca("id:change")
        ], Oj.prototype, "onChangeId", null), xj([
            rl("ready"),
            Ca("state.values.style")
        ], Oj.prototype, "onStateValuesStyleChange", null), xj([
            Ca("style:change")
        ], Oj.prototype, "onChangeStyle", null), xj([
            rl("ready"),
            Ca("state.values.classes")
        ], Oj.prototype, "onStateValuesClassesChange", null), xj([
            Ca("classes:change")
        ], Oj.prototype, "onChangClasses", null), xj([
            Ca("lockMargin:click")
        ], Oj.prototype, "onLockMarginClick", null), xj([
            rl("ready"),
            Ca("state.marginIsLocked")
        ], Oj.prototype, "onChangeMarginIsLocked", null), xj([
            rl("ready"),
            Ca([
                "state.values.marginTop",
                "state.values.marginRight",
                "state.values.marginBottom",
                "state.values.marginLeft"
            ])
        ], Oj.prototype, "onStateValuesMarginChange", null), xj([
            Ca([
                "marginTop:change",
                "marginRight:change",
                "marginBottom:change",
                "marginLeft:change"
            ])
        ], Oj.prototype, "onChangeMargin", null), xj([
            rl("ready")
        ], Oj.prototype, "hideFieldByOptions", null), Oj = xj([
            ji
        ], Oj);
        var Aj = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Pj(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Lj = function(e) {
            function t(e, o, n, r) {
                var i;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (i = function(e, t, o) {
                    return t = Tj(t), function(e, t) {
                        return !t || "object" !== Pj(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Rj() ? Reflect.construct(t, o || [], Tj(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).state = o, i.handlers = r, i.__mainTab = new gj(i.jodit, i.state, i.handlers), i.__positionTab = new Oj(i.jodit, i.state, i.handlers), i.getElm("tabsBox").appendChild(em(e, [
                    {
                        name: "Image",
                        content: i.__mainTab
                    },
                    {
                        name: "Advanced",
                        content: i.__positionTab
                    }
                ], n)), i.setMod("lock-size", i.state.sizeIsLocked), i.append(i.__mainTab).append(i.__positionTab), i;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ij(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIImagePropertiesForm";
                    }
                },
                {
                    key: "appendChildToContainer",
                    value: function() {}
                },
                {
                    key: "getElm",
                    value: function(e) {
                        var o = Ej(Tj(t.prototype), "getElm", this).call(this, e);
                        if (o) return o;
                        var n = !0, r = !1, i = void 0;
                        try {
                            for(var a, l = this.elements[Symbol.iterator](); !(n = (a = l.next()).done); n = !0){
                                var s = a.value.getElm(e);
                                if (s) return s;
                            }
                        } catch (e) {
                            r = !0, i = e;
                        } finally{
                            try {
                                n || null == l.return || l.return();
                            } finally{
                                if (r) throw i;
                            }
                        }
                        return null;
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return '<form>\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-2-5 jodit_col-xs-5-5">\n\t\t\t\t<div class="&__view-box">\n\t\t\t\t\t<div class="&__imageView">\n\t\t\t\t\t\t<img class="&__imageViewSrc" src="" alt=""/>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="jodit-form__group &__imageSizes">\n\t\t\t\t\t\t<input type="text" class="jodit-input &__imageWidth"/>\n\t\t\t\t\t\t<a class="&__lockSize">'.concat(Ol.get("lock"), '</a>\n\t\t\t\t\t\t<input type="text" class="&__imageHeight jodit-input"/>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class="jodit_col-lg-3-5 jodit_col-xs-5-5 &__tabsBox"></div>\n\t\t</div>\n\t</form>');
                    }
                },
                {
                    key: "onChangeSizeIsLocked",
                    value: function() {
                        var e = this.getElm("lockSize"), t = this.getElm("imageWidth");
                        e.innerHTML = Ol.get(this.state.sizeIsLocked ? "lock" : "unlock"), this.setMod("lock-size", this.state.sizeIsLocked), this.j.e.fire(t, "change");
                    }
                },
                {
                    key: "onLockSizeClick",
                    value: function() {
                        this.state.sizeIsLocked = !this.state.sizeIsLocked;
                    }
                },
                {
                    key: "onStateValuesSizeChange",
                    value: function() {
                        var e = this.getElm("imageWidth"), t = this.getElm("imageHeight");
                        e !== this.j.od.activeElement && (e.value = this.state.values.imageWidth.toString()), t !== this.j.od.activeElement && (t.value = this.state.values.imageHeight.toString());
                    }
                },
                {
                    key: "onImageWidthChange",
                    value: function(e) {
                        var t = this.getElm("imageWidth"), o = this.getElm("imageHeight");
                        if (!this.state.sizeIsLocked || !en(t.value) || !en(o.value)) return this.state.values.imageWidth = t.value, void (this.state.values.imageHeight = o.value);
                        var n = parseFloat(t.value), r = parseFloat(o.value);
                        e.target === t ? (this.state.values.imageWidth = n, this.state.values.imageHeight = Math.round(n / this.state.ratio)) : (this.state.values.imageWidth = Math.round(r * this.state.ratio), this.state.values.imageHeight = r);
                    }
                },
                {
                    key: "onStateValuesImageSrcChange",
                    value: function() {
                        var e = this.state.values.imageSrc;
                        if (e) {
                            er(this.getElm("imageViewSrc"), "src", e);
                            var t = new Image;
                            t.src = e, this.state.image = t;
                        }
                    }
                },
                {
                    key: "hideFieldByOptions",
                    value: function() {
                        var e = this, t = this.j.o.image;
                        [
                            [
                                "editSize",
                                "imageSizes"
                            ],
                            [
                                "showPreview",
                                "imageView"
                            ]
                        ].forEach(function(o) {
                            var n = function(e, t) {
                                return function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != o) {
                                        var n, r, i = [], a = !0, l = !1;
                                        try {
                                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                        } catch (e) {
                                            l = !0, r = e;
                                        } finally{
                                            try {
                                                a || null == o.return || o.return();
                                            } finally{
                                                if (l) throw r;
                                            }
                                        }
                                        return i;
                                    }
                                }(e, t) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return Cj(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Cj(e, t) : void 0;
                                    }
                                }(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(o, 2), r = n[0], i = n[1];
                            Ln(e.getElm(i), "display", t[r] ? null : "none");
                        });
                    }
                }
            ], n && zj(o.prototype, n), t;
        }(Ul);
        function Mj(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function Bj(e, t, o, n) {
            var r = new gu(t), i = function() {
                r.close(), r.destruct();
            };
            r.setContent(tm(e, {
                upload: function(e) {
                    e.files && e.files.length && (o.values.imageSrc = e.baseurl + e.files[0]), i();
                },
                filebrowser: function() {
                    var e, t = (e = function(e) {
                        return function(e, t) {
                            var o, n, r, i, a = {
                                label: 0,
                                sent: function() {
                                    if (1 & r[0]) throw r[1];
                                    return r[1];
                                },
                                trys: [],
                                ops: []
                            };
                            return i = {
                                next: l(0),
                                throw: l(1),
                                return: l(2)
                            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                return this;
                            }), i;
                            function l(i) {
                                return function(l) {
                                    return function(i) {
                                        if (o) throw new TypeError("Generator is already executing.");
                                        for(; a;)try {
                                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                            switch(n = 0, r && (i = [
                                                2 & i[0],
                                                r.value
                                            ]), i[0]){
                                                case 0:
                                                case 1:
                                                    r = i;
                                                    break;
                                                case 4:
                                                    return a.label++, {
                                                        value: i[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    a.label++, n = i[1], i = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    i = a.ops.pop(), a.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                        a = 0;
                                                        continue;
                                                    }
                                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                        a.label = i[1];
                                                        break;
                                                    }
                                                    if (6 === i[0] && a.label < r[1]) {
                                                        a.label = r[1], r = i;
                                                        break;
                                                    }
                                                    if (r && a.label < r[2]) {
                                                        a.label = r[2], a.ops.push(i);
                                                        break;
                                                    }
                                                    r[2] && a.ops.pop(), a.trys.pop();
                                                    continue;
                                            }
                                            i = t.call(e, a);
                                        } catch (e) {
                                            i = [
                                                6,
                                                e
                                            ], n = 0;
                                        } finally{
                                            o = r = 0;
                                        }
                                        if (5 & i[0]) throw i[1];
                                        return {
                                            value: i[0] ? i[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        i,
                                        l
                                    ]);
                                };
                            }
                        }(this, function(t) {
                            return e && Ao(e.files) && e.files.length && (o.values.imageSrc = e.files[0], i()), [
                                2
                            ];
                        });
                    }, function() {
                        var t = this, o = arguments;
                        return new Promise(function(n, r) {
                            var i = e.apply(t, o);
                            function a(e) {
                                Mj(i, n, r, a, l, "next", e);
                            }
                            function l(e) {
                                Mj(i, n, r, a, l, "throw", e);
                            }
                            a(void 0);
                        });
                    });
                    return function(e) {
                        return t.apply(this, arguments);
                    };
                }()
            }, o.image, i)).open(function() {
                return oa(n);
            });
        }
        function Dj(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function Nj(e, t, o) {
            return Hj.apply(this, arguments);
        }
        function Hj() {
            var e;
            return e = function(e, t, o) {
                var n, r, i, a, l, s;
                return function(e, t) {
                    var o, n, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: l(0),
                        throw: l(1),
                        return: l(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function l(i) {
                        return function(l) {
                            return function(i) {
                                if (o) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                    switch(n = 0, r && (i = [
                                        2 & i[0],
                                        r.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            r = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < r[1]) {
                                                a.label = r[1], r = i;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(i);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = t.call(e, a);
                                } catch (e) {
                                    i = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    o = r = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                l
                            ]);
                        };
                    }
                }(this, function(c) {
                    switch(c.label){
                        case 0:
                            return [
                                4,
                                e.decode()
                            ];
                        case 1:
                            return c.sent(), n = Ln(e, "width", !0) || er(e, "width") || !1, r = Ln(e, "height", !0) || er(e, "height") || !1, t.imageWidth = !1 !== n ? mj(n) : e.offsetWidth || e.naturalWidth, en(t.imageWidth) ? t.imageHeight = !1 !== r ? mj(r) : e.offsetHeight || e.naturalHeight : t.imageHeight = r || "", i = t.imageWidth, a = t.imageHeight, l = parseFloat(i.toString()), en(i) && en(a) ? !1 === r ? (t.imageHeight = Math.round(l / o.ratio), o.sizeIsLocked = !0, [
                                2
                            ]) : (s = parseFloat(a.toString()), o.sizeIsLocked = Math.abs(l - s * o.ratio) < 1, [
                                2
                            ]) : (o.sizeIsLocked = !1, [
                                2
                            ]);
                    }
                });
            }, Hj = function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        Dj(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        Dj(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            }, Hj.apply(this, arguments);
        }
        function Fj(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function qj() {
            var e;
            return e = function(e, t) {
                var o, n;
                return function(e, t) {
                    var o, n, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: l(0),
                        throw: l(1),
                        return: l(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function l(i) {
                        return function(l) {
                            return function(i) {
                                if (o) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                    switch(n = 0, r && (i = [
                                        2 & i[0],
                                        r.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            r = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < r[1]) {
                                                a.label = r[1], r = i;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(i);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = t.call(e, a);
                                } catch (e) {
                                    i = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    o = r = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                l
                            ]);
                        };
                    }
                }(this, function(r) {
                    return o = t.sourceImage, n = t.values, function(e, t) {
                        e.style.cssFloat && -1 !== [
                            "left",
                            "right"
                        ].indexOf(e.style.cssFloat.toLowerCase()) ? t.align = Ln(e, "float") : "block" === Ln(e, "display") && "auto" === e.style.marginLeft && "auto" === e.style.marginRight ? t.align = "center" : t.align = "";
                    }(o, n), n.borderRadius = parseInt(o.style.borderRadius || "0", 10) || 0, n.id = er(o, "id") || "", n.imageTitle = er(o, "title") || "", n.imageAlt = er(o, "alt") || "", n.style = er(o, "style") || "", n.classes = (er(o, "class") || "").replace(/jodit_focused_image[\s]*/, ""), function(e, t, o) {
                        var n = !0, r = !1;
                        [
                            "marginTop",
                            "marginRight",
                            "marginBottom",
                            "marginLeft"
                        ].forEach(function(o) {
                            var i = e.style.getPropertyValue(En(o));
                            if (!i) return r = !0, void (t[o] = 0);
                            /^[0-9]+(px)?$/.test(i) && (i = parseInt(i, 10)), t[o] = i, (r && t[o] || n && "marginTop" !== o && t[o] !== t.marginTop) && (n = !1);
                        }), o.marginIsLocked = n;
                    }(o, n, t), function(e, t, o) {
                        var n = pi.closest(e.sourceImage, "a", t.editor);
                        n ? (o.imageLink = er(n, "href") || "", o.imageLinkOpenInNewTab = "_blank" === er(n, "target")) : (o.imageLink = "", o.imageLinkOpenInNewTab = !1);
                    }(t, e, n), n.imageSrc = er(o, "src") || "", [
                        2,
                        Nj(o, n, t)
                    ];
                });
            }, qj = function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        Fj(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        Fj(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            }, qj.apply(this, arguments);
        }
        function Vj(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function Wj(e, t, o) {
            return Wj = Xj() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Kj(r, o.prototype), r;
            }, Wj.apply(null, arguments);
        }
        function Uj(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Yj(e) {
            return Yj = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Yj(e);
        }
        function Kj(e, t) {
            return Kj = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Kj(e, t);
        }
        function Gj(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Jj(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Jj = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Wj(e, arguments, Yj(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Kj(n, e);
            }, Jj(e);
        }
        function Xj() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Xj = function() {
                return !!e;
            })();
        }
        Aj([
            rl("ready"),
            Ca("state.sizeIsLocked")
        ], Lj.prototype, "onChangeSizeIsLocked", null), Aj([
            Ca("lockSize:click")
        ], Lj.prototype, "onLockSizeClick", null), Aj([
            rl("ready"),
            Ca([
                "state.values.imageWidth",
                "state.values.imageHeight"
            ])
        ], Lj.prototype, "onStateValuesSizeChange", null), Aj([
            Ca([
                "imageWidth:change",
                "imageHeight:change",
                "imageWidth:keydown",
                "imageHeight:keydown",
                "imageWidth:mousedown",
                "imageHeight:mousedown",
                "imageWidth:paste",
                "imageHeight:paste"
            ]),
            $a()
        ], Lj.prototype, "onImageWidthChange", null), Aj([
            rl("ready"),
            Ca("state.values.imageSrc")
        ], Lj.prototype, "onStateValuesImageSrcChange", null), Aj([
            rl("ready")
        ], Lj.prototype, "hideFieldByOptions", null), Lj = Aj([
            ji
        ], Lj);
        var Zj = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Gj(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Qj = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Yj(t), function(e, t) {
                        return !t || "object" !== Gj(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Xj() ? Reflect.construct(t, o || [], Yj(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).state = {
                    image: new Image,
                    sourceImage: new Image,
                    get ratio () {
                        var e1 = this.image;
                        return e1.naturalWidth / e1.naturalHeight || 1;
                    },
                    sizeIsLocked: !0,
                    marginIsLocked: !0,
                    values: {
                        style: "",
                        imageSrc: "",
                        borderRadius: 0,
                        imageTitle: "",
                        imageAlt: "",
                        imageLink: "",
                        imageLinkOpenInNewTab: !1,
                        imageWidth: 0,
                        imageHeight: 0,
                        marginTop: 0,
                        marginRight: 0,
                        marginBottom: 0,
                        marginLeft: 0,
                        classes: "",
                        id: "",
                        align: ""
                    }
                }, e.activeTabState = {
                    activeTab: "Image"
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Kj(e, t);
            }(t, e), o = t, n = [
                {
                    key: "form",
                    get: function() {
                        var e = this;
                        return new Lj(this.j, this.state, this.activeTabState, {
                            openImageEditor: function() {
                                return function(e, t) {
                                    var o = er(t.image, "src") || "", n = e.c.element("a"), r = function() {
                                        n.host === location.host || e.confirm("You can only edit your own images. Download this image on the host?", function(o) {
                                            o && e.uploader && e.uploader.uploadRemoteImage(n.href.toString(), function(o) {
                                                e.alert("The image has been successfully uploaded to the host!", function() {
                                                    Lo(o.newfilename) && (t.values.imageSrc = o.baseurl + o.newfilename);
                                                });
                                            }, function(t) {
                                                e.alert("There was an error loading %s", t.message);
                                            });
                                        });
                                    };
                                    n.href = o, e.filebrowser.dataProvider.getPathByUrl(n.href.toString()).then(function(r) {
                                        ap.call(e.filebrowser, n.href, r.name, r.path, r.source, function() {
                                            var e = (new Date).getTime();
                                            t.values.imageSrc = o + (-1 !== o.indexOf("?") ? "" : "?") + "&_tmp=" + e.toString();
                                        }, function(t) {
                                            e.alert(t.message);
                                        });
                                    }).catch(function(t) {
                                        e.alert(t.message, r);
                                    });
                                }(e.j, e.state);
                            },
                            openImagePopup: function(t) {
                                return Bj(e.j, e.dialog, e.state, t);
                            }
                        });
                    }
                },
                {
                    key: "dialog",
                    get: function() {
                        var e = this, t = this.j, o = t.dlg({
                            minWidth: Math.min(400, screen.width),
                            minHeight: 590,
                            buttons: [
                                "fullsize",
                                "dialog.close"
                            ]
                        }), n = this.__buttons;
                        return n.check.onAction(function() {
                            (function(e, t, o) {
                                var n = t.values, r = n.style, i = n.imageSrc, a = n.borderRadius, l = n.imageTitle, s = n.imageAlt, c = n.imageLink, u = n.imageWidth, d = n.imageHeight, f = n.marginTop, p = n.marginRight, h = n.marginBottom, v = n.marginLeft, g = n.imageLinkOpenInNewTab, m = n.align, b = n.classes, y = n.id, _ = e.o;
                                _.image.editStyle && er(o, "style", r || null), i ? (er(o, "src", i), o.style.borderRadius = a ? a + "px" : "", er(o, "title", l || null), er(o, "alt", s || null), function(e, t, o, n) {
                                    var r = pi.closest(t, "a", e.editor);
                                    o ? (r || (r = pi.wrap(t, "a", e.createInside)), er(r, "href", o), er(r, "target", n ? "_blank" : null)) : r && r.parentNode && r.parentNode.replaceChild(t, r);
                                }(e, o, c, g), function(e, t, o, n) {
                                    if (t !== e.offsetWidth || o !== e.offsetHeight) {
                                        var r = t ? bj(t) : null, i = o ? bj(o) : null;
                                        Ln(e, {
                                            width: r,
                                            height: r && n ? null : i
                                        }), er(e, "width", r && en(t) && er(e, "width") ? r : null), er(e, "width") && !n || (i = null), er(e, "height", i);
                                    }
                                }(o, u, d, t.sizeIsLocked), e.o.image.editMargins && function(e, t, o, n, r, i, a) {
                                    var l = [
                                        t,
                                        o,
                                        n,
                                        r
                                    ], s = function(e, t) {
                                        var o = Ln(i, e), n = bj(t);
                                        o.toString() !== n.toString() && Ln(i, e, n);
                                    };
                                    if (a) s("margin", t);
                                    else {
                                        var c = [
                                            "margin-top",
                                            "margin-right",
                                            "margin-bottom",
                                            "margin-left"
                                        ];
                                        l.forEach(function(e, t) {
                                            s(c[t], e);
                                        });
                                    }
                                }(0, f, p, h, v, o, t.marginIsLocked), _.image.editClass && er(o, "class", b || null), _.image.editId && er(o, "id", y || null), _.image.editAlign && Bn(o, m)) : pi.safeRemove(o);
                            })(t, e.state, e.state.sourceImage), t.synchronizeValues(), o.close();
                        }), n.remove.onAction(function() {
                            t.s.removeNode(e.state.sourceImage), o.close();
                        }), n.cancel.onAction(function() {
                            o.close();
                        }), o.setHeader(t.i18n("Image properties")), o.setContent(this.form), o.setFooter([
                            [
                                n.cancel,
                                n.remove
                            ],
                            n.check
                        ]), t.e.on(o, "afterClose", function() {
                            e.state.image.parentNode && t.o.image.selectImageAfterClose && t.s.select(e.state.sourceImage);
                        }), o.setSize(t.o.image.dialogWidth), fr(t, o.container), o;
                    }
                },
                {
                    key: "__buttons",
                    get: function() {
                        var e = this.j;
                        return {
                            check: Es(e, "ok", "Apply", "primary"),
                            remove: Es(e, "bin", "Delete"),
                            cancel: Es(e, "cancel", "Cancel")
                        };
                    }
                },
                {
                    key: "open",
                    value: function() {
                        var e = this;
                        return this.activeTabState.activeTab = "Image", this.__lock(), this.dialog.open().setModal(!0).setPosition(), this.async.promise(function(t, o) {
                            return (function(e, t) {
                                return qj.apply(this, arguments);
                            })(e.j, e.state).then(t, o);
                        }).catch(function(t) {
                            Vo(t) || e.dialog.message.error(t.message);
                        }).finally(function() {
                            return e.__unlock();
                        }), !1;
                    }
                },
                {
                    key: "__lock",
                    value: function() {
                        this.dialog.lock(), this.form.setMod("lock", !0), Object.values(this.__buttons).forEach(function(e) {
                            return e.state.disabled = !0;
                        });
                    }
                },
                {
                    key: "__unlock",
                    value: function() {
                        this.dialog.unlock(), this.form.setMod("lock", !1), Object.values(this.__buttons).forEach(function(e) {
                            return e.state.disabled = !1;
                        });
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this, o = this;
                        e.e.on("afterConstructor changePlace", function() {
                            e.e.off(e.editor, ".imageproperties").on(e.editor, "dblclick.imageproperties", function(n) {
                                var r = n.target;
                                if (pi.isTag(r, "img")) {
                                    if (e.o.image.openOnDblClick) {
                                        if (!1 === t.j.e.fire("openOnDblClick", r)) return;
                                        o.state.sourceImage = r, o.state.image = r.cloneNode(!0), e.o.readonly || (n.stopImmediatePropagation(), n.preventDefault(), o.open());
                                    } else n.stopImmediatePropagation(), e.s.select(r);
                                }
                            });
                        }).on("openImageProperties.imageproperties", function(e) {
                            o.state.sourceImage = e, t.state.image = e.cloneNode(!0), t.open();
                        });
                    }
                },
                {
                    key: "onStateValuesImageSrcChange",
                    value: function() {
                        var e, t = this;
                        return (e = function() {
                            var e, o, n, r, i;
                            return function(e, t) {
                                var o, n, r, i, a = {
                                    label: 0,
                                    sent: function() {
                                        if (1 & r[0]) throw r[1];
                                        return r[1];
                                    },
                                    trys: [],
                                    ops: []
                                };
                                return i = {
                                    next: l(0),
                                    throw: l(1),
                                    return: l(2)
                                }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                    return this;
                                }), i;
                                function l(i) {
                                    return function(l) {
                                        return function(i) {
                                            if (o) throw new TypeError("Generator is already executing.");
                                            for(; a;)try {
                                                if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                switch(n = 0, r && (i = [
                                                    2 & i[0],
                                                    r.value
                                                ]), i[0]){
                                                    case 0:
                                                    case 1:
                                                        r = i;
                                                        break;
                                                    case 4:
                                                        return a.label++, {
                                                            value: i[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        a.label++, n = i[1], i = [
                                                            0
                                                        ];
                                                        continue;
                                                    case 7:
                                                        i = a.ops.pop(), a.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                            a = 0;
                                                            continue;
                                                        }
                                                        if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                            a.label = i[1];
                                                            break;
                                                        }
                                                        if (6 === i[0] && a.label < r[1]) {
                                                            a.label = r[1], r = i;
                                                            break;
                                                        }
                                                        if (r && a.label < r[2]) {
                                                            a.label = r[2], a.ops.push(i);
                                                            break;
                                                        }
                                                        r[2] && a.ops.pop(), a.trys.pop();
                                                        continue;
                                                }
                                                i = t.call(e, a);
                                            } catch (e) {
                                                i = [
                                                    6,
                                                    e
                                                ], n = 0;
                                            } finally{
                                                o = r = 0;
                                            }
                                            if (5 & i[0]) throw i[1];
                                            return {
                                                value: i[0] ? i[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            i,
                                            l
                                        ]);
                                    };
                                }
                            }(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (e = t.state, o = e.image, n = e.values, !o.src) return [
                                            2
                                        ];
                                        a.label = 1;
                                    case 1:
                                        return a.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]), t.__lock(), [
                                            4,
                                            o.decode()
                                        ];
                                    case 2:
                                        return a.sent(), t.state.sizeIsLocked && en(n.imageWidth) && (r = parseFloat(n.imageWidth.toString()), n.imageHeight = Math.round(r / t.state.ratio)), t.j.e.fire("updateImageProperties.imageproperties", o), [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return i = a.sent(), t.j.alert(i.message), [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        return t.__unlock(), [
                                            7
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }, function() {
                            var t = this, o = arguments;
                            return new Promise(function(n, r) {
                                var i = e.apply(t, o);
                                function a(e) {
                                    Vj(i, n, r, a, l, "next", e);
                                }
                                function l(e) {
                                    Vj(i, n, r, a, l, "throw", e);
                                }
                                a(void 0);
                            });
                        })();
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        var t, o, n;
                        Object.values(null !== (t = hi(this, "__buttons")) && void 0 !== t ? t : {}).forEach(function(e) {
                            return e.destruct();
                        }), null === (o = hi(this, "dialog")) || void 0 === o || o.destruct(), null === (n = hi(this, "form")) || void 0 === n || n.destruct(), e.e.off(e.editor, ".imageproperties").off(".imageproperties");
                    }
                }
            ], n && Uj(o.prototype, n), t;
        }(Jj(Wp));
        Zj([
            vi
        ], Qj.prototype, "form", null), Zj([
            vi
        ], Qj.prototype, "dialog", null), Zj([
            vi
        ], Qj.prototype, "__buttons", null), Zj([
            Ca("state.image")
        ], Qj.prototype, "onStateValuesImageSrcChange", null), Ma.add("imageProperties", Qj);
        var $j = function(e, t) {
            return "".concat(pi.isCell(t) ? "padding" : "margin").concat("rtl" === e ? "Right" : "Left");
        };
        Ol.set("indent", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zm1440 480v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg> ').set("outdent", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg> '), rr.prototype.controls.indent = {
            tooltip: "Increase Indent"
        }, rr.prototype.controls.outdent = {
            isDisabled: function(e) {
                var t = e.s.current();
                if (t) {
                    var o = pi.closest(t, pi.isBlock, e.editor);
                    if (o) {
                        var n = $j(e.o.direction, o);
                        return !o.style[n] || parseInt(o.style[n], 10) <= 0;
                    }
                }
                return !0;
            },
            tooltip: "Decrease Indent"
        }, rr.prototype.indentMargin = 10;
        var ew = function(e, t, o, n) {
            if (t && !e.has(t)) {
                var r = $j(o.o.direction, t);
                e.add(t);
                var i = t.style[r] ? parseInt(t.style[r], 10) : 0;
                i += o.o.indentMargin * ("outdent" === n ? -1 : 1), t.style[r] = i > 0 ? i + "px" : "", er(t, "style") || er(t, "style", null);
            }
        };
        function tw(e, t, o) {
            return tw = lw() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && rw(r, o.prototype), r;
            }, tw.apply(null, arguments);
        }
        function ow(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function nw(e) {
            return nw = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, nw(e);
        }
        function rw(e, t) {
            return rw = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, rw(e, t);
        }
        function iw(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function aw(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return aw = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return tw(e, arguments, nw(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), rw(n, e);
            }, aw(e);
        }
        function lw() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (lw = function() {
                return !!e;
            })();
        }
        Ma.add("indent", function(e) {
            e.registerButton({
                name: "indent",
                group: "indent"
            }).registerButton({
                name: "outdent",
                group: "indent"
            });
            var t = function(t) {
                var o = new Set, n = e.o, r = n.enter, i = n.enterBlock, a = r.toLowerCase() === Xt, l = e.s.current();
                if (a && e.s.isCollapsed() && l) {
                    var s = pi.wrapNextInline(l, i, e);
                    return ew(o, s, e, t), !1;
                }
                return e.s.eachSelection(function(n) {
                    e.s.save();
                    var l = !!n && pi.up(n, pi.isBlock, e.editor);
                    if (!l && n && (l = dr(a ? pi.wrapNextInline : pi.wrapInline, n, a ? i : r.toLowerCase(), e)), !l) return e.s.restore(), !1;
                    ew(o, l, e, t), e.s.restore();
                }), e.synchronizeValues(), !1;
            };
            e.registerCommand("indent", {
                exec: t,
                hotkeys: [
                    "ctrl+]",
                    "cmd+]"
                ]
            }), e.registerCommand("outdent", {
                exec: t,
                hotkeys: [
                    "ctrl+[",
                    "cmd+["
                ]
            });
        }), Ol.set("justify", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"/> </svg> '), rr.prototype.controls.align = {
            name: "left",
            tooltip: "Align",
            update: function(e, t) {
                var o = t.control, n = e.s.current();
                if (n) {
                    var r = Ln(pi.closest(n, pi.isBlock, e.editor) || e.editor, "text-align").toString();
                    o.defaultValue && -1 !== o.defaultValue.indexOf(r) && (r = "left");
                    var i = o.list, a = o.data;
                    a && a.currentValue !== r && i && (cn(i) ? i[r] : i.includes(r)) && (e.o.textIcons || "select" === o.component ? t.state.text = r : t.state.icon.name = r, a.currentValue = r);
                }
            },
            isActive: function(e, t) {
                var o = e.s.current();
                if (!o || !t.control.defaultValue) return !1;
                var n = pi.closest(o, pi.isBlock, e.editor) || e.editor;
                return -1 === t.control.defaultValue.indexOf(Ln(n, "text-align").toString());
            },
            defaultValue: [
                "left",
                "start",
                "inherit"
            ],
            data: {
                currentValue: "left"
            },
            list: [
                "center",
                "left",
                "right",
                "justify"
            ]
        }, rr.prototype.controls.center = {
            command: "justifyCenter",
            css: {
                "text-align": "center"
            },
            tooltip: "Align Center"
        }, rr.prototype.controls.justify = {
            command: "justifyFull",
            css: {
                "text-align": "justify"
            },
            tooltip: "Align Justify"
        }, rr.prototype.controls.left = {
            command: "justifyLeft",
            css: {
                "text-align": "left"
            },
            tooltip: "Align Left"
        }, rr.prototype.controls.right = {
            command: "justifyRight",
            css: {
                "text-align": "right"
            },
            tooltip: "Align Right"
        }, Ma.add("justify", function(e) {
            e.registerButton({
                name: "align",
                group: "indent"
            });
            var t = function(t) {
                return e.s.focus(), e.s.eachSelection(function(o) {
                    if (o) {
                        var n = pi.up(o, pi.isBlock, e.editor);
                        n || (n = pi.wrapInline(o, e.o.enterBlock, e)), Nn(t, n);
                    }
                }), !1;
            };
            e.registerCommand("justifyfull", t), e.registerCommand("justifyright", t), e.registerCommand("justifyleft", t), e.registerCommand("justifycenter", t);
        });
        var sw = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = nw(o = t), function(e, t) {
                    return !t || "object" !== iw(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, lw() ? Reflect.construct(o, n || [], nw(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && rw(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {}
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {}
                },
                {
                    key: "onKeyDownArrow",
                    value: function(e) {
                        var t;
                        if (e.key === qt && this.j.selection.isCollapsed()) {
                            var o = this.j.selection.range, n = o.endContainer, r = o.endOffset;
                            if (pi.isText(n) && (null === (t = n.nodeValue) || void 0 === t ? void 0 : t.length) === r) {
                                var i = n.parentNode;
                                pi.isInlineBlock(i) && !pi.findNotEmptyNeighbor(i, !1, this.j.editor) && pi.after(i, this.j.createInside.text(yt));
                            }
                        }
                    }
                }
            ], ow(o.prototype, n), t;
        }(aw(Wp));
        function cw(e, t, o) {
            return cw = vw() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && fw(r, o.prototype), r;
            }, cw.apply(null, arguments);
        }
        function uw(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function dw(e) {
            return dw = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, dw(e);
        }
        function fw(e, t) {
            return fw = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, fw(e, t);
        }
        function pw(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function hw(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return hw = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return cw(e, arguments, dw(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), fw(n, e);
            }, hw(e);
        }
        function vw() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (vw = function() {
                return !!e;
            })();
        }
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : iw(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            Ca(":keydown")
        ], sw.prototype, "onKeyDownArrow", null), Ma.add("keyArrowOutside", sw), rr.prototype.limitWords = !1, rr.prototype.limitChars = !1, rr.prototype.limitHTML = !1;
        var gw = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : pw(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, mw = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = dw(o = t), function(e, t) {
                    return !t || "object" !== pw(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, vw() ? Reflect.construct(o, n || [], dw(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && fw(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this, o = e.o, n = o.limitWords, r = o.limitChars;
                        if (e && (n || r)) {
                            var i = null;
                            e.e.off(".limit").on("beforePaste.limit", function() {
                                i = e.history.snapshot.make();
                            }).on("keydown.limit keyup.limit beforeEnter.limit", this.checkPreventKeyPressOrPaste).on("change.limit", this.checkPreventChanging).on("afterPaste.limit", function() {
                                if (t.__shouldDenyInput(!0) && i) return e.history.snapshot.restore(i), e.e.fire("denyPaste.limit"), !1;
                            });
                        }
                    }
                },
                {
                    key: "shouldPreventInsertHTML",
                    value: function(e) {
                        return (!e || !(Jt.includes(e.key) || e.ctrlKey || e.metaKey)) && this.__shouldDenyInput(!1);
                    }
                },
                {
                    key: "__shouldDenyInput",
                    value: function(e) {
                        var t = this.jodit, o = t.o, n = o.limitWords, r = o.limitChars, i = t.o.limitHTML ? t.value : t.text, a = this.__splitWords(i);
                        if (n && bw(a.length, n, e)) return t.e.fire("denyWords.limit limit.limit"), !0;
                        var l = Boolean(r && bw(a.join("").length, r, e));
                        return l && t.e.fire("denyChars.limit limit.limit"), l;
                    }
                },
                {
                    key: "checkPreventKeyPressOrPaste",
                    value: function(e) {
                        if (this.shouldPreventInsertHTML(e)) return !1;
                    }
                },
                {
                    key: "checkPreventChanging",
                    value: function(e, t) {
                        var o = this.jodit;
                        this.__shouldDenyInput(!0) && (o.value = t);
                    }
                },
                {
                    key: "__splitWords",
                    value: function(e) {
                        return e.replace(_t(), "").split(kt()).filter(function(e) {
                            return e.length;
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off(".limit");
                    }
                }
            ], uw(o.prototype, n), t;
        }(hw(Wp));
        function bw(e, t, o) {
            return o ? e > t : e >= t;
        }
        gw([
            To
        ], mw.prototype, "checkPreventKeyPressOrPaste", null), gw([
            To
        ], mw.prototype, "checkPreventChanging", null), Ma.add("limit", mw), rr.prototype.defaultLineHeight = null, Ol.set("line-height", '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path d="M5.09668 6.99707H7.17358L4.17358 3.99707L1.17358 6.99707H3.09668V17.0031H1.15881L4.15881 20.0031L7.15881 17.0031H5.09668V6.99707Z"/> <path d="M22.8412 7H8.84119V5H22.8412V7Z"/> <path d="M22.8412 11H8.84119V9H22.8412V11Z"/> <path d="M8.84119 15H22.8412V13H8.84119V15Z"/> <path d="M22.8412 19H8.84119V17H22.8412V19Z"/> </svg> '), rr.prototype.controls.lineHeight = {
            command: "applyLineHeight",
            tags: [
                "ol"
            ],
            tooltip: "Line height",
            list: [
                1,
                1.1,
                1.2,
                1.3,
                1.4,
                1.5,
                2
            ],
            exec: function(e, t, o) {
                var n = o.control;
                return gr(e, t, {
                    control: n
                }, function(e) {
                    return e;
                });
            }
        };
        const yw = {
            "Line height": "\u0627\u0631\u062A\u0641\u0627\u0639 \u0627\u0644\u062E\u0637"
        }, _w = {
            "Line height": "V\xfd\u0161ka \u010D\xe1ry"
        }, jw = {
            "Line height": "Zeilenh\xf6he"
        }, ww = {
            "Line height": "Altura de la l\xednea"
        }, kw = {
            "Line height": "\u0627\u0631\u062A\u0641\u0627\u0639 \u062E\u0637"
        }, Sw = {
            "Line height": "Rivin korkeus"
        }, xw = {
            "Line height": "Hauteur de ligne"
        }, Ow = {
            "Line height": "\u05D2\u05D5\u05D1\u05D4 \u05E9\u05D5\u05E8\u05D4"
        }, Cw = {
            "Line height": "Vonal magass\xe1ga"
        }, zw = {
            "Line height": "Tinggi baris"
        }, Ew = {
            "Line height": "Altezza linea"
        }, Tw = {
            "Line height": "\u30E9\u30A4\u30F3\u306E\u9AD8\u3055"
        }, Iw = {
            "Line height": "\uC120 \uB192\uC774"
        }, Pw = {
            "Line height": "\u0417\u0443\u0440\u0430\u0430\u0441\u043D\u044B \u04E9\u043D\u0434\u04E9\u0440"
        }, Rw = {
            "Line height": "Lijnhoogte"
        }, Aw = {
            "Line height": "Wysoko\u015B\u0107 linii"
        }, Lw = {
            "Line height": "Altura da linha"
        }, Mw = {
            "Line height": "\u0412\u044B\u0441\u043E\u0442\u0430 \u043B\u0438\u043D\u0438\u0438"
        }, Bw = {
            "Line height": "\xc7izgi y\xfcksekli\u011Fi"
        }, Dw = {
            "Line height": "\u0412\u0438\u0441\u043E\u0442\u0430 \u043B\u0456\u043D\u0456\u0457"
        }, Nw = {
            "Line height": "\u7EBF\u9AD8"
        }, Hw = {
            "Line height": "\u884C\u9AD8"
        };
        function Fw(e, t, o) {
            return Fw = Kw() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Ww(r, o.prototype), r;
            }, Fw.apply(null, arguments);
        }
        function qw(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Vw(e) {
            return Vw = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Vw(e);
        }
        function Ww(e, t) {
            return Ww = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Ww(e, t);
        }
        function Uw(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Yw(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Yw = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Fw(e, arguments, Vw(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Ww(n, e);
            }, Yw(e);
        }
        function Kw() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Kw = function() {
                return !!e;
            })();
        }
        var Gw = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Vw(t), function(e, t) {
                        return !t || "object" !== Uw(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Kw() ? Reflect.construct(t, o || [], Vw(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).buttons = [
                    {
                        name: "lineHeight",
                        group: "font"
                    }
                ], Da(B), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ww(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        Ln(e.editor, {
                            lineHeight: e.o.defaultLineHeight
                        }), e.registerCommand("applyLineHeight", this.applyLineHeight);
                    }
                },
                {
                    key: "applyLineHeight",
                    value: function(e, t, o) {
                        var n, r = this.j, i = r.s, a = r.createInside, l = r.editor, s = r.o;
                        i.isFocused() || i.focus(), i.save();
                        var c = function(e) {
                            var t = pi.closest(e, pi.isBlock, l);
                            t || (t = pi.wrap(e, s.enter, a));
                            var r = Ln(t, "lineHeight");
                            void 0 === n && (n = r.toString() !== o.toString()), Ln(t, "lineHeight", n ? o : null);
                        };
                        try {
                            if (i.isCollapsed()) {
                                var u = a.fake();
                                i.insertNode(u, !1, !1), c(u), pi.safeRemove(u);
                            } else i.eachSelection(c);
                        } finally{
                            i.restore();
                        }
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        Ln(e.editor, {
                            lineHeight: null
                        });
                    }
                }
            ], qw(o.prototype, n), t;
        }(Yw(Wp));
        function Jw(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Xw(e, t, o) {
            if (!t.isInDestruct) {
                (function(e) {
                    return Boolean(e && "drop" === e.type);
                })(e) && t.s.insertCursorAtPoint(e.clientX, e.clientY);
                var n = t.e.fire("beforePasteInsert", o);
                !Bo(n) && (Lo(n) || ln(n) || pi.isNode(n)) && (o = n), Lo(o) && (o = function(e) {
                    var t = (e = e.replace(/<meta[^>]+?>/g, "")).search(/<!--StartFragment-->/i);
                    -1 !== t && (e = e.substring(t + 20));
                    var o = e.search(/<!--EndFragment-->/i);
                    return -1 !== o && (e = e.substring(0, o)), e;
                }(o)), t.s.insertHTML(o);
            }
        }
        function Zw(e, t, o, n, r) {
            if (!1 !== e.e.fire("beforeOpenPasteDialog", t, o, n, r)) {
                var i = e.confirm('<div style="word-break: normal; white-space: normal">'.concat(e.i18n(t), "</div>"), e.i18n(o)), a = r.map(function(t) {
                    var o = t.text, r = t.value;
                    return Es(e, {
                        text: o,
                        name: o.toLowerCase(),
                        tabIndex: 0
                    }).onAction(function() {
                        i.close(), n(r);
                    });
                });
                i.e.one(i, "afterClose", function() {
                    e.s.isFocused() || e.s.focus();
                });
                var l = Es(e, {
                    text: "Cancel",
                    tabIndex: 0
                }).onAction(function() {
                    i.close();
                });
                return i.setFooter((function(e) {
                    return function(e) {
                        if (Array.isArray(e)) return Jw(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return Jw(e, t);
                            var o = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Jw(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                })(a).concat([
                    l
                ])), a[0].focus(), a[0].state.variant = "primary", e.e.fire("afterOpenPasteDialog", i, t, o, n, r), i;
            }
        }
        function Qw(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Uw(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            To
        ], Gw.prototype, "applyLineHeight", null), Ma.add("lineHeight", Gw), rr.prototype.mediaFakeTag = "jodit-media", rr.prototype.mediaInFakeBlock = !0, rr.prototype.mediaBlocks = [
            "video",
            "audio"
        ], Ma.add("media", function(e) {
            var t = "jodit_fake_wrapper", o = e.options, n = o.mediaFakeTag, r = o.mediaBlocks, i = o.mediaInFakeBlock;
            i && e.e.on("afterGetValueFromEditor", function(e) {
                var o = new RegExp("<".concat(n, "[^>]+data-").concat(t, "[^>]+>([^]+?)</").concat(n, ">"), "ig");
                o.test(e.value) && (e.value = e.value.replace(o, "$1"));
            }).on("change afterInit afterSetMode changePlace", e.async.debounce(function() {
                e.isDestructed || e.getMode() === $t || Qr(r.join(","), e.editor).forEach(function(o) {
                    cr(o, t) || (cr(o, t, !0), function(o) {
                        if (o.parentNode && er(o.parentNode, "data-jodit_iframe_wrapper")) o = o.parentNode;
                        else {
                            var r = e.createInside.element(n, function(e, t) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: 1,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = 1, e;
                            }({
                                "data-jodit-temp": 1,
                                contenteditable: !1,
                                draggable: !0
                            }, "data-".concat(t)));
                            er(r, "style", er(o, "style")), r.style.display = "inline-block" === o.style.display ? "inline-block" : "block", r.style.width = o.offsetWidth + "px", r.style.height = o.offsetHeight + "px", o.parentNode && o.parentNode.insertBefore(r, o), r.appendChild(o), o = r;
                        }
                        e.e.off(o, "mousedown.select touchstart.select").on(o, "mousedown.select touchstart.select", function() {
                            e.s.setCursorAfter(o);
                        });
                    }(o));
                });
            }, e.defaultTimeout));
        }), rr.prototype.mobileTapTimeout = 300, rr.prototype.toolbarAdaptive = !0, rr.prototype.buttonsMD = [
            {
                group: "font-style",
                buttons: []
            },
            {
                group: "list",
                buttons: []
            },
            {
                group: "font",
                buttons: []
            },
            "---",
            {
                group: "media",
                buttons: []
            },
            "\n",
            {
                group: "state",
                buttons: []
            },
            {
                group: "insert",
                buttons: []
            },
            {
                group: "indent",
                buttons: []
            },
            {
                group: "color",
                buttons: []
            },
            "---",
            {
                group: "history",
                buttons: []
            },
            {
                group: "other",
                buttons: []
            },
            "|",
            "dots"
        ], rr.prototype.buttonsSM = [
            {
                group: "font-style",
                buttons: []
            },
            {
                group: "list",
                buttons: []
            },
            "---",
            {
                group: "font",
                buttons: []
            },
            "\n",
            {
                group: "state",
                buttons: []
            },
            {
                group: "indent",
                buttons: []
            },
            {
                group: "color",
                buttons: []
            },
            "---",
            {
                group: "history",
                buttons: []
            },
            "|",
            "dots"
        ], rr.prototype.buttonsXS = [
            {
                group: "font-style",
                buttons: []
            },
            {
                group: "list",
                buttons: []
            },
            "---",
            {
                group: "font",
                buttons: []
            },
            {
                group: "color",
                buttons: []
            },
            "---",
            "dots"
        ], rr.prototype.controls.dots = {
            mode: $t + Qt,
            popup: function(e, t, o, n) {
                var r = n.control.data;
                return void 0 === r && (r = {
                    toolbar: Vd(e),
                    rebuild: function() {
                        var t, o;
                        if (n) {
                            var i = e.e.fire("getDiffButtons.mobile", n.closest(sd));
                            if (i && r) {
                                r.toolbar.build(Pi(i));
                                var a = (null === (o = null === (t = e.toolbar) || void 0 === t ? void 0 : t.firstButton) || void 0 === o ? void 0 : o.container.offsetWidth) || 36;
                                r.toolbar.container.style.width = 3 * (a + 4) + "px";
                            }
                        }
                    }
                }, n.control.data = r), r.rebuild(), r.toolbar;
            },
            tooltip: "Show all"
        }, Ma.add("mobile", function(e) {
            var t = 0, o = Pi(e.o.buttons);
            e.o.mobileTapTimeout && e.e.on("touchend", function(o) {
                if (o.changedTouches && o.changedTouches.length) {
                    var n = (new Date).getTime(), r = n - t;
                    r > e.o.mobileTapTimeout && (t = n, r < 1.5 * e.o.mobileTapTimeout && e.s.insertCursorAtPoint(o.clientX, o.clientY));
                }
            }), e.e.on("getDiffButtons.mobile", function(t) {
                if (t === e.toolbar) {
                    var n = ls(Pi(e.o.buttons), e), r = ls(o, e);
                    return Fo(n).reduce(function(e, t) {
                        return r.has(t) || e.push(t), e;
                    }, []);
                }
            }), e.o.toolbarAdaptive && e.e.on("resize afterInit recalcAdaptive changePlace afterAddPlace", function() {
                var t, n;
                if (e.o.toolbar) {
                    var r = (null !== (t = e.container.parentElement) && void 0 !== t ? t : e.container).offsetWidth, i = e.isFullSize || r >= e.o.sizeLG ? Pi(e.o.buttons) : r >= e.o.sizeMD ? Pi(e.o.buttonsMD) : r >= e.o.sizeSM ? Pi(e.o.buttonsSM) : Pi(e.o.buttonsXS);
                    i.toString() !== o.toString() && (o = i, e.e.fire("closeAllPopups"), null === (n = e.toolbar) || void 0 === n || n.setRemoveButtons(e.o.removeButtons).build(o.concat(e.o.extraButtons)));
                }
            }).on(e.ow, "load resize", function() {
                return e.e.fire("recalcAdaptive");
            });
        }), rr.prototype.askBeforePasteHTML = !0, rr.prototype.processPasteHTML = !0, rr.prototype.scrollToPastedContent = !0, rr.prototype.pasteExcludeStripTags = [
            "br",
            "hr"
        ], rr.prototype.pasteHTMLActionList = [
            {
                value: lo,
                text: "Keep"
            },
            {
                value: co,
                text: "Insert as Text"
            },
            {
                value: uo,
                text: "Insert only Text"
            }
        ], rr.prototype.memorizeChoiceWhenPasteFragment = !1, rr.prototype.nl2brInPlainText = !0;
        var $w = "pasteStorage";
        function ek(e, t, o) {
            return ek = ak() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && nk(r, o.prototype), r;
            }, ek.apply(null, arguments);
        }
        function tk(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function ok(e) {
            return ok = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ok(e);
        }
        function nk(e, t) {
            return nk = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, nk(e, t);
        }
        function rk(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ik(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return ik = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return ek(e, arguments, ok(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), nk(n, e);
            }, ik(e);
        }
        function ak() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (ak = function() {
                return !!e;
            })();
        }
        rr.prototype.controls.paste = {
            tooltip: "Paste from clipboard",
            exec: function(e, t, o) {
                var n, r = o.control;
                return (n = function() {
                    var t, o, n, i, a, l, s;
                    return function(e, t) {
                        var o, n, r, i, a = {
                            label: 0,
                            sent: function() {
                                if (1 & r[0]) throw r[1];
                                return r[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return i = {
                            next: l(0),
                            throw: l(1),
                            return: l(2)
                        }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                            return this;
                        }), i;
                        function l(i) {
                            return function(l) {
                                return function(i) {
                                    if (o) throw new TypeError("Generator is already executing.");
                                    for(; a;)try {
                                        if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                        switch(n = 0, r && (i = [
                                            2 & i[0],
                                            r.value
                                        ]), i[0]){
                                            case 0:
                                            case 1:
                                                r = i;
                                                break;
                                            case 4:
                                                return a.label++, {
                                                    value: i[1],
                                                    done: !1
                                                };
                                            case 5:
                                                a.label++, n = i[1], i = [
                                                    0
                                                ];
                                                continue;
                                            case 7:
                                                i = a.ops.pop(), a.trys.pop();
                                                continue;
                                            default:
                                                if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                    a = 0;
                                                    continue;
                                                }
                                                if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                    a.label = i[1];
                                                    break;
                                                }
                                                if (6 === i[0] && a.label < r[1]) {
                                                    a.label = r[1], r = i;
                                                    break;
                                                }
                                                if (r && a.label < r[2]) {
                                                    a.label = r[2], a.ops.push(i);
                                                    break;
                                                }
                                                r[2] && a.ops.pop(), a.trys.pop();
                                                continue;
                                        }
                                        i = t.call(e, a);
                                    } catch (e) {
                                        i = [
                                            6,
                                            e
                                        ], n = 0;
                                    } finally{
                                        o = r = 0;
                                    }
                                    if (5 & i[0]) throw i[1];
                                    return {
                                        value: i[0] ? i[1] : void 0,
                                        done: !0
                                    };
                                }([
                                    i,
                                    l
                                ]);
                            };
                        }
                    }(this, function(c) {
                        switch(c.label){
                            case 0:
                                if (r.name === $w) return e.execCommand("showPasteStorage"), [
                                    2
                                ];
                                if (e.s.focus(), t = "", o = !0, !navigator.clipboard) return [
                                    3,
                                    11
                                ];
                                c.label = 1;
                            case 1:
                                return c.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]), [
                                    4,
                                    navigator.clipboard.read()
                                ];
                            case 2:
                                return (n = c.sent()) && n.length ? [
                                    4,
                                    n[0].getType(oo)
                                ] : [
                                    3,
                                    5
                                ];
                            case 3:
                                return i = c.sent(), [
                                    4,
                                    new Response(i).text()
                                ];
                            case 4:
                                t = c.sent(), c.label = 5;
                            case 5:
                                return o = !1, [
                                    3,
                                    7
                                ];
                            case 6:
                                return a = c.sent(), ft || console.log(a), [
                                    3,
                                    7
                                ];
                            case 7:
                                if (!o) return [
                                    3,
                                    11
                                ];
                                c.label = 8;
                            case 8:
                                return c.trys.push([
                                    8,
                                    10,
                                    ,
                                    11
                                ]), [
                                    4,
                                    navigator.clipboard.readText()
                                ];
                            case 9:
                                return t = c.sent(), o = !1, [
                                    3,
                                    11
                                ];
                            case 10:
                                return l = c.sent(), ft || console.log(l), [
                                    3,
                                    11
                                ];
                            case 11:
                                return o && (t = e.buffer.get(ko) || "", o = 0 === t.length), s = e.value, o ? (e.ed.execCommand("paste"), !(o = s === e.value) && e.e.fire("afterPaste")) : t.length ? (Xw(null, e, t), e.e.fire("afterPaste")) : o && e.alert("Your browser doesn't support direct access to the clipboard.", function() {
                                    e.s.focus();
                                }), [
                                    2
                                ];
                        }
                    });
                }, function() {
                    var e = this, t = arguments;
                    return new Promise(function(o, r) {
                        var i = n.apply(e, t);
                        function a(e) {
                            Qw(i, o, r, a, l, "next", e);
                        }
                        function l(e) {
                            Qw(i, o, r, a, l, "throw", e);
                        }
                        a(void 0);
                    });
                })();
            },
            list: function(e, t, o) {
                return t in e ? Object.defineProperty(e, t, {
                    value: o,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = o, e;
            }({}, $w, "Paste Storage"),
            isChildDisabled: function(e) {
                return e.e.fire("pasteStorageList") < 2;
            }
        };
        var lk = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : rk(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, sk = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = ok(t), function(e, t) {
                        return !t || "object" !== rk(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, ak() ? Reflect.construct(t, o || [], ok(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).pasteStack = new si(20), e._isDialogOpened = !1, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && nk(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.e.on("paste.paste", this.onPaste).on("pasteStack.paste", function(e) {
                            return t.pasteStack.push(e);
                        }), e.o.nl2brInPlainText && this.j.e.on("processPaste.paste", this.onProcessPasteReplaceNl2Br);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("paste.paste", this.onPaste).off("processPaste.paste", this.onProcessPasteReplaceNl2Br).off(".paste");
                    }
                },
                {
                    key: "onPaste",
                    value: function(e) {
                        try {
                            if (!1 === this.customPasteProcess(e) || !1 === this.j.e.fire("beforePaste", e)) return e.preventDefault(), !1;
                            this.defaultPasteProcess(e);
                        } finally{
                            this.j.e.fire("afterPaste", e);
                        }
                    }
                },
                {
                    key: "customPasteProcess",
                    value: function(e) {
                        if (this.j.o.processPasteHTML) {
                            var t = mr(e), o = [
                                null == t ? void 0 : t.getData(oo),
                                null == t ? void 0 : t.getData(no),
                                null == t ? void 0 : t.getData(ro)
                            ], n = !0, r = !1, i = void 0;
                            try {
                                for(var a, l = o[Symbol.iterator](); !(n = (a = l.next()).done); n = !0){
                                    var s = a.value;
                                    if (Jo(s) && (this.j.e.fire("processHTML", e, s, {
                                        plain: o[0],
                                        html: o[1],
                                        rtf: o[2]
                                    }) || this.processHTML(e, s))) return !1;
                                }
                            } catch (e) {
                                r = !0, i = e;
                            } finally{
                                try {
                                    n || null == l.return || l.return();
                                } finally{
                                    if (r) throw i;
                                }
                            }
                        }
                    }
                },
                {
                    key: "defaultPasteProcess",
                    value: function(e) {
                        var t = mr(e), o = (null == t ? void 0 : t.getData(no)) || (null == t ? void 0 : t.getData(oo));
                        if (t && o && "" !== vn(o)) {
                            var n = this.j.e.fire("processPaste", e, o, function(e) {
                                var t = e.types, o = "";
                                if (Ao(t) || "[object DOMStringList]" === ({}).toString.call(t)) for(var n = 0; n < t.length; n += 1)o += t[n] + ";";
                                else o = (t || oo).toString() + ";";
                                return o;
                            }(t));
                            void 0 !== n && (o = n), (Lo(o) || pi.isNode(o)) && this.__insertByType(e, o, this.j.o.defaultActionOnPaste), e.preventDefault(), e.stopPropagation();
                        }
                    }
                },
                {
                    key: "processHTML",
                    value: function(e, t) {
                        var o = this;
                        if (!this.j.o.askBeforePasteHTML) return !1;
                        if (this.j.o.memorizeChoiceWhenPasteFragment) {
                            var n = this.pasteStack.find(function(e) {
                                return e.html === t;
                            });
                            if (n) return this.__insertByType(e, t, n.action || this.j.o.defaultActionOnPaste), !0;
                        }
                        if (this._isDialogOpened) return !0;
                        var r = Zw(this.j, "Your code is similar to HTML. Keep as HTML?", "Paste as HTML", function(n) {
                            o._isDialogOpened = !1, o.__insertByType(e, t, n);
                        }, this.j.o.pasteHTMLActionList);
                        return r && (this._isDialogOpened = !0, r.e.on("beforeClose", function() {
                            o._isDialogOpened = !1;
                        })), !0;
                    }
                },
                {
                    key: "__insertByType",
                    value: function(e, t, o) {
                        if (this.pasteStack.push({
                            html: t,
                            action: o
                        }), Lo(t)) switch(this.j.buffer.set(ko, t), o){
                            case so:
                                t = Li(t);
                                break;
                            case uo:
                                t = Vi(t, this.j.ed, new Set(this.j.o.pasteExcludeStripTags));
                                break;
                            case co:
                                t = Mi(t);
                                break;
                            default:
                                var n = this.j.e.fire("onCustomPasteHTMLOption", o, t, e);
                                "string" == typeof n && (t = n);
                        }
                        Xw(e, this.j, t);
                    }
                },
                {
                    key: "onProcessPasteReplaceNl2Br",
                    value: function(e, t, o) {
                        if (o === oo + ";" && !Jo(t)) return Bi(t);
                    }
                }
            ], n && tk(o.prototype, n), t;
        }(ik(Wp));
        function ck(e, t, o) {
            return ck = vk() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && fk(r, o.prototype), r;
            }, ck.apply(null, arguments);
        }
        function uk(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function dk(e) {
            return dk = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, dk(e);
        }
        function fk(e, t) {
            return fk = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, fk(e, t);
        }
        function pk(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function hk(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return hk = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return ck(e, arguments, dk(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), fk(n, e);
            }, hk(e);
        }
        function vk() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (vk = function() {
                return !!e;
            })();
        }
        lk([
            To
        ], sk.prototype, "onPaste", null), lk([
            To
        ], sk.prototype, "onProcessPasteReplaceNl2Br", null), Ma.add("paste", sk), rr.prototype.askBeforePasteFromWord = !0, rr.prototype.processPasteFromWord = !0, rr.prototype.defaultActionOnPasteFromWord = null, rr.prototype.pasteFromWordActionList = [
            {
                value: lo,
                text: "Keep"
            },
            {
                value: co,
                text: "Clean"
            },
            {
                value: uo,
                text: "Insert only Text"
            }
        ];
        var gk = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = dk(o = t), function(e, t) {
                    return !t || "object" !== pk(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, vk() ? Reflect.construct(o, n || [], dk(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && fk(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {}
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {}
                },
                {
                    key: "processWordHTML",
                    value: function(e, t, o) {
                        var n = this, r = this.j, i = r.o, a = i.processPasteFromWord, l = i.askBeforePasteFromWord, s = i.defaultActionOnPasteFromWord, c = i.defaultActionOnPaste, u = i.pasteFromWordActionList;
                        return !(!a || !Xo(t) || (l ? Zw(r, "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?", "Word Paste Detected", function(r) {
                            n.insertFromWordByType(e, t, r, o);
                        }, u) : this.insertFromWordByType(e, t, s || c, o), 0));
                    }
                },
                {
                    key: "insertFromWordByType",
                    value: function(e, t, o, n) {
                        var r;
                        switch(o){
                            case lo:
                                t = Ai(t);
                                var i = null === (r = this.j.events) || void 0 === r ? void 0 : r.fire("beautifyHTML", t);
                                Lo(i) && (t = i);
                                break;
                            case co:
                                t = Li(t);
                                break;
                            case uo:
                                t = Vi(Li(t));
                        }
                        Xw(e, this.j, t);
                    }
                }
            ], uk(o.prototype, n), t;
        }(hk(Wp));
        function mk(e, t, o) {
            return mk = wk() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && _k(r, o.prototype), r;
            }, mk.apply(null, arguments);
        }
        function bk(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function yk(e) {
            return yk = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, yk(e);
        }
        function _k(e, t) {
            return _k = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, _k(e, t);
        }
        function jk(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return jk = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return mk(e, arguments, yk(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), _k(n, e);
            }, jk(e);
        }
        function wk() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (wk = function() {
                return !!e;
            })();
        }
        gk.requires = [
            "paste"
        ], function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : pk(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        }([
            Ca(":processHTML")
        ], gk.prototype, "processWordHTML", null), Ma.add("pasteFromWord", gk);
        var kk = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = yk(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, wk() ? Reflect.construct(t, o || [], yk(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).currentIndex = 0, e.list = [], e.container = null, e.listBox = null, e.previewBox = null, e.dialog = null, e.paste = function() {
                    if (e.j.s.focus(), e.j.s.insertHTML(e.list[e.currentIndex]), 0 !== e.currentIndex) {
                        var t = e.list[0];
                        e.list[0] = e.list[e.currentIndex], e.list[e.currentIndex] = t;
                    }
                    e.dialog && e.dialog.close(), e.j.synchronizeValues(), e.j.e.fire("afterPaste");
                }, e.onKeyDown = function(t) {
                    var o = e.currentIndex;
                    -1 !== [
                        Ft,
                        Vt,
                        Bt
                    ].indexOf(t.key) && (t.key === Ft && (0 === o ? o = e.list.length - 1 : o -= 1), t.key === Vt && (o === e.list.length - 1 ? o = 0 : o += 1), t.key !== Bt ? (o !== e.currentIndex && e.selectIndex(o), t.stopImmediatePropagation(), t.preventDefault()) : e.paste());
                }, e.selectIndex = function(t) {
                    e.listBox && Fo(e.listBox.childNodes).forEach(function(o, n) {
                        o.classList.remove("jodit_active"), t === n && e.previewBox && (o.classList.add("jodit_active"), e.previewBox.innerHTML = e.list[t], o.focus());
                    }), e.currentIndex = t;
                }, e.showDialog = function() {
                    e.list.length < 2 || (e.dialog || e.createDialog(), e.listBox && (e.listBox.innerHTML = ""), e.previewBox && (e.previewBox.innerHTML = ""), e.list.forEach(function(t, o) {
                        var n = e.j.c.element("a");
                        n.textContent = o + 1 + ". " + t.replace(kt(), ""), e.j.e.on(n, "keydown", e.onKeyDown), er(n, "href", "#"), er(n, "data-index", o.toString()), er(n, "tab-index", "-1"), e.listBox && e.listBox.appendChild(n);
                    }), e.dialog && e.dialog.open(), e.j.async.setTimeout(function() {
                        e.selectIndex(0);
                    }, 100));
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && _k(e, t);
            }(t, e), o = t, n = [
                {
                    key: "createDialog",
                    value: function() {
                        var e = this;
                        this.dialog = this.j.dlg();
                        var t = Es(this.j, "paste", "Paste", "primary");
                        t.onAction(this.paste);
                        var o = Es(this.j, "", "Cancel");
                        o.onAction(this.dialog.close), this.container = this.j.c.div(), this.container.classList.add("jodit-paste-storage"), this.listBox = this.j.c.div(), this.previewBox = this.j.c.div(), this.container.appendChild(this.listBox), this.container.appendChild(this.previewBox), this.dialog.setHeader(this.j.i18n("Choose Content to Paste")), this.dialog.setContent(this.container), this.dialog.setFooter([
                            t,
                            o
                        ]), this.j.e.on(this.listBox, "click dblclick", function(t) {
                            var o = t.target;
                            return pi.isTag(o, "a") && o.hasAttribute("data-index") && e.selectIndex(parseInt(er(o, "-index") || "0", 10)), "dblclick" === t.type && e.paste(), !1;
                        });
                    }
                },
                {
                    key: "afterInit",
                    value: function() {
                        var e = this;
                        this.j.e.off("afterCopy.paste-storage").on("pasteStorageList.paste-storage", function() {
                            return e.list.length;
                        }).on("afterCopy.paste-storage", function(t) {
                            -1 !== e.list.indexOf(t) && e.list.splice(e.list.indexOf(t), 1), e.list.unshift(t), e.list.length > 5 && (e.list.length = 5);
                        }), this.j.registerCommand("showPasteStorage", {
                            exec: this.showDialog,
                            hotkeys: [
                                "ctrl+shift+v",
                                "cmd+shift+v"
                            ]
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.dialog && this.dialog.destruct(), this.j.e.off(".paste-storage"), pi.safeRemove(this.previewBox), pi.safeRemove(this.listBox), pi.safeRemove(this.container), this.container = null, this.listBox = null, this.previewBox = null, this.dialog = null, this.list = [];
                    }
                }
            ], n && bk(o.prototype, n), t;
        }(jk(Wp));
        function Sk(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function xk(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function Ok(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Ck(e, t) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, t) {
                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != o) {
                    var n, r, i = [], a = !0, l = !1;
                    try {
                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                    } catch (e) {
                        l = !0, r = e;
                    } finally{
                        try {
                            a || null == o.return || o.return();
                        } finally{
                            if (l) throw r;
                        }
                    }
                    return i;
                }
            }(e, t) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return xk(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? xk(e, t) : void 0;
                }
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function zk(e, t, o) {
            return zk = Ak() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Ik(r, o.prototype), r;
            }, zk.apply(null, arguments);
        }
        function Ek(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Tk(e) {
            return Tk = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Tk(e);
        }
        function Ik(e, t) {
            return Ik = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Ik(e, t);
        }
        function Pk(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Rk(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Rk = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return zk(e, arguments, Tk(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Ik(n, e);
            }, Rk(e);
        }
        function Ak() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Ak = function() {
                return !!e;
            })();
        }
        Ma.add("pasteStorage", kk), rr.prototype.controls.preview = {
            icon: "eye",
            command: "preview",
            mode: $t + Qt,
            tooltip: "Preview"
        }, Ma.add("preview", function(e) {
            e.registerButton({
                name: "preview"
            }), e.registerCommand("preview", function(t, o, n) {
                var r = e.dlg();
                r.setSize(1024, 600).open("", e.i18n("Preview")).setModal(!0);
                var i = function(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != o) {
                            var n, r, i = [], a = !0, l = !1;
                            try {
                                for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                            } catch (e) {
                                l = !0, r = e;
                            } finally{
                                try {
                                    a || null == o.return || o.return();
                                } finally{
                                    if (l) throw r;
                                }
                            }
                            return i;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return Sk(e, t);
                            var o = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? Sk(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(ni(e, n, "px", r.getElm("content")), 2)[1];
                r.e.on(r, "afterClose", i);
            });
        }), Ol.set("print", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"/> </svg> '), rr.prototype.controls.print = {
            exec: function(e) {
                var t = e.create.element("iframe");
                Object.assign(t.style, {
                    position: "fixed",
                    right: 0,
                    bottom: 0,
                    width: 0,
                    height: 0,
                    border: 0
                }), Ha(e, rr).appendChild(t);
                var o = function() {
                    e.e.off(e.ow, "mousemove", o), pi.safeRemove(t);
                }, n = t.contentWindow;
                if (n) {
                    e.e.on(n, "onbeforeunload onafterprint", o).on(e.ow, "mousemove", o), e.o.iframe ? (e.e.fire("generateDocumentStructure.iframe", n.document, e), n.document.body.innerHTML = e.value) : (n.document.write('<!doctype html><html lang="' + Or(e.o.language) + '"><head><title></title></head><style>' + function(e) {
                        var t = function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.ownerDocument.styleSheets;
                            return Fo(t).map(function(e) {
                                try {
                                    return Fo(e.cssRules);
                                } catch (e) {}
                                return [];
                            }).flat().filter(function(t) {
                                try {
                                    return Boolean(t && e.matches(t.selectorText));
                                } catch (e) {}
                                return !1;
                            });
                        }, o = function() {
                            function o(n, r, i) {
                                var a = this;
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, o), this.css = {};
                                var l = i || {}, s = function(t) {
                                    var o = t.selectorText.split(",").map(function(e) {
                                        return e.trim();
                                    }).sort().join(",");
                                    !1 === Boolean(a.css[o]) && (a.css[o] = {});
                                    for(var n = t.style.cssText.split(/;(?![A-Za-z0-9])/), r = 0; r < n.length; r++)if (n[r]) {
                                        var i = n[r].split(":");
                                        i[0] = i[0].trim(), i[1] = i[1].trim(), a.css[o][i[0]] = i[1].replace(/var\(([^)]+)\)/g, function(t, o) {
                                            var n = Ck(o.split(","), 2), r = n[0], i = n[1];
                                            return (e.ew.getComputedStyle(e.editor).getPropertyValue(r.trim()) || i || t).trim();
                                        });
                                    }
                                };
                                !function() {
                                    for(var o = n.innerHeight, i = r.createTreeWalker(e.editor, NodeFilter.SHOW_ELEMENT, function() {
                                        return NodeFilter.FILTER_ACCEPT;
                                    }); i.nextNode();){
                                        var a = i.currentNode;
                                        if (a.getBoundingClientRect().top < o || l.scanFullPage) {
                                            var c = t(a);
                                            if (c) for(var u = 0; u < c.length; u++)s(c[u]);
                                        }
                                    }
                                }();
                            }
                            var n;
                            return n = [
                                {
                                    key: "generateCSS",
                                    value: function() {
                                        var e = "";
                                        for(var t in this.css)if (!/:not\(/.test(t)) {
                                            for(var o in e += t + " { ", this.css[t])e += o + ": " + this.css[t][o] + "; ";
                                            e += "}\n";
                                        }
                                        return e;
                                    }
                                }
                            ], Ok(o.prototype, n), o;
                        }();
                        try {
                            return new o(e.ew, e.ed, {
                                scanFullPage: !0
                            }).generateCSS();
                        } catch (e) {}
                        return "";
                    }(e) + "</style><body></body></html>"), n.document.close(), ni(e, void 0, "px", n.document.body));
                    var r = n.document.createElement("style");
                    r.innerHTML = "@media print {\n\t\t\t\t\tbody {\n\t\t\t\t\t\t\t-webkit-print-color-adjust: exact;\n\t\t\t\t\t}\n\t\t\t}", n.document.head.appendChild(r), n.focus(), n.print();
                }
            },
            mode: $t + Qt,
            tooltip: "Print"
        }, Ma.add("print", function(e) {
            e.registerButton({
                name: "print"
            });
        }), rr.prototype.tableAllowCellResize = !0;
        var Lk = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Pk(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Mk = "table_processor_observer-resize", Bk = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Tk(t), function(e, t) {
                        return !t || "object" !== Pk(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Ak() ? Reflect.construct(t, o || [], Tk(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).selectMode = !1, e.resizeDelta = 0, e.createResizeHandle = function() {
                    e.resizeHandler || (e.resizeHandler = e.j.c.div("jodit-table-resizer"), e.j.e.on(e.resizeHandler, "mousedown.table touchstart.table", e.onHandleMouseDown).on(e.resizeHandler, "mouseenter.table", function() {
                        e.j.async.clearTimeout(e.hideTimeout);
                    }));
                }, e.hideTimeout = 0, e.drag = !1, e.minX = 0, e.maxX = 0, e.startX = 0, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ik(e, t);
            }(t, e), o = t, n = [
                {
                    key: "module",
                    get: function() {
                        return this.j.getInstance("Table", this.j.o);
                    }
                },
                {
                    key: "isRTL",
                    get: function() {
                        return "rtl" === this.j.o.direction;
                    }
                },
                {
                    key: "showResizeHandle",
                    value: function() {
                        this.j.async.clearTimeout(this.hideTimeout), this.j.workplace.appendChild(this.resizeHandler);
                    }
                },
                {
                    key: "hideResizeHandle",
                    value: function() {
                        var e = this;
                        this.hideTimeout = this.j.async.setTimeout(function() {
                            pi.safeRemove(e.resizeHandler);
                        }, {
                            timeout: this.j.defaultTimeout,
                            label: "hideResizer"
                        });
                    }
                },
                {
                    key: "onHandleMouseDown",
                    value: function(e) {
                        var t = this;
                        if (!this.j.isLocked) {
                            this.drag = !0, this.j.e.on(this.j.ow, "mouseup.resize-cells touchend.resize-cells", this.onMouseUp).on(this.j.ew, "mousemove.table touchmove.table", this.onMouseMove), this.startX = e.clientX, this.j.lock(Mk), this.resizeHandler.classList.add("jodit-table-resizer_moved");
                            var o, n = this.workTable.getBoundingClientRect();
                            if (this.minX = 0, this.maxX = 1e6, null != this.wholeTable) n = this.workTable.parentNode.getBoundingClientRect(), this.minX = n.left, this.maxX = this.minX + n.width;
                            else {
                                var r = this.module.formalCoordinate(this.workTable, this.workCell, !0);
                                this.module.formalMatrix(this.workTable, function(e, n, i) {
                                    r[1] === i && (o = e.getBoundingClientRect(), t.minX = Math.max(o.left + Kt / 2, t.minX)), r[1] + (t.isRTL ? -1 : 1) === i && (o = e.getBoundingClientRect(), t.maxX = Math.min(o.left + o.width - Kt / 2, t.maxX));
                                });
                            }
                            return !1;
                        }
                    }
                },
                {
                    key: "onMouseMove",
                    value: function(e) {
                        if (this.drag) {
                            this.j.e.fire("closeAllPopups");
                            var t = e.clientX, o = ta(this.resizeHandler.parentNode || this.j.od.documentElement, this.j, this.j.od, !0);
                            t < this.minX && (t = this.minX), t > this.maxX && (t = this.maxX), this.resizeDelta = t - this.startX + (this.j.o.iframe ? o.left : 0), this.resizeHandler.style.left = t - (this.j.o.iframe ? 0 : o.left) + "px";
                            var n = this.j.s.sel;
                            n && n.removeAllRanges();
                        }
                    }
                },
                {
                    key: "onMouseUp",
                    value: function(e) {
                        (this.selectMode || this.drag) && (this.selectMode = !1, this.j.unlock()), this.resizeHandler && this.drag && (this.drag = !1, this.j.e.off(this.j.ew, "mousemove.table touchmove.table", this.onMouseMove), this.resizeHandler.classList.remove("jodit-table-resizer_moved"), this.startX !== e.clientX && (null == this.wholeTable ? this.resizeColumns() : this.resizeTable()), this.j.synchronizeValues(), this.j.s.focus());
                    }
                },
                {
                    key: "resizeColumns",
                    value: function() {
                        var e = this.resizeDelta, t = [], o = this.module;
                        o.setColumnWidthByDelta(this.workTable, o.formalCoordinate(this.workTable, this.workCell, !0)[1], e, !0, t);
                        var n = dr(this.isRTL ? pi.prev : pi.next, this.workCell, pi.isCell, this.workCell.parentNode);
                        o.setColumnWidthByDelta(this.workTable, o.formalCoordinate(this.workTable, n)[1], -e, !1, t);
                    }
                },
                {
                    key: "resizeTable",
                    value: function() {
                        var e = this.resizeDelta * (this.isRTL ? -1 : 1), t = this.workTable.offsetWidth, o = Zi(this.workTable.parentNode, this.j.ew), n = !this.wholeTable;
                        if (this.isRTL ? !n : n) this.workTable.style.width = (t + e) / o * 100 + "%";
                        else {
                            var r = this.isRTL ? "marginRight" : "marginLeft", i = parseInt(this.j.ew.getComputedStyle(this.workTable)[r] || "0", 10);
                            this.workTable.style.width = (t - e) / o * 100 + "%", this.workTable.style[r] = (i + e) / o * 100 + "%";
                        }
                    }
                },
                {
                    key: "setWorkCell",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        this.wholeTable = t, this.workCell = e, this.workTable = pi.up(e, function(e) {
                            return pi.isTag(e, "table");
                        }, this.j.editor);
                    }
                },
                {
                    key: "calcHandlePosition",
                    value: function(e, t) {
                        var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, r = ta(t, this.j, this.j.ed);
                        if (o > Kt && o < r.width - Kt) this.hideResizeHandle();
                        else {
                            var i = ta(this.j.workplace, this.j, this.j.od, !0), a = ta(e, this.j, this.j.ed);
                            if (this.resizeHandler.style.left = (o <= Kt ? r.left : r.left + r.width) - i.left + n + "px", Object.assign(this.resizeHandler.style, {
                                height: a.height + "px",
                                top: a.top - i.top + "px"
                            }), this.showResizeHandle(), o <= Kt) {
                                var l = dr(this.isRTL ? pi.next : pi.prev, t, pi.isCell, t.parentNode);
                                this.setWorkCell(l || t, !l || null);
                            } else {
                                var s = dr(this.isRTL ? pi.prev : pi.next, t, pi.isCell, t.parentNode);
                                this.setWorkCell(t, !!s && null);
                            }
                        }
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.o.tableAllowCellResize && e.e.off(this.j.ow, ".resize-cells").off(".resize-cells").on("change.resize-cells afterCommand.resize-cells afterSetMode.resize-cells", function() {
                            Qr("table", e.editor).forEach(t.observe);
                        }).on(this.j.ow, "scroll.resize-cells", function() {
                            if (t.drag) {
                                var o = pi.up(t.workCell, function(e) {
                                    return pi.isTag(e, "table");
                                }, e.editor);
                                if (o) {
                                    var n = o.getBoundingClientRect();
                                    t.resizeHandler.style.top = n.top + "px";
                                }
                            }
                        }).on("beforeSetMode.resize-cells", function() {
                            var o = t.module;
                            o.getAllSelectedCells().forEach(function(t) {
                                o.removeSelection(t), o.normalizeTable(pi.closest(t, "table", e.editor));
                            });
                        });
                    }
                },
                {
                    key: "observe",
                    value: function(e) {
                        var t = this;
                        cr(e, Mk) || (cr(e, Mk, !0), this.j.e.on(e, "mouseleave.resize-cells", function(e) {
                            t.resizeHandler && t.resizeHandler !== e.relatedTarget && t.hideResizeHandle();
                        }).on(e, "mousemove.resize-cells touchmove.resize-cells", this.j.async.throttle(function(o) {
                            if (!t.j.isLocked) {
                                var n = pi.up(o.target, pi.isCell, e);
                                n && t.calcHandlePosition(e, n, o.offsetX);
                            }
                        }, {
                            timeout: this.j.defaultTimeout
                        })), this.createResizeHandle());
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.events && (e.e.off(this.j.ow, ".resize-cells"), e.e.off(".resize-cells"));
                    }
                }
            ], n && Ek(o.prototype, n), t;
        }(Rk(Wp));
        function Dk(e, t, o) {
            return Dk = Wk() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Fk(r, o.prototype), r;
            }, Dk.apply(null, arguments);
        }
        function Nk(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Hk(e) {
            return Hk = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Hk(e);
        }
        function Fk(e, t) {
            return Fk = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Fk(e, t);
        }
        function qk(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Vk(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Vk = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Dk(e, arguments, Hk(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Fk(n, e);
            }, Vk(e);
        }
        function Wk() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Wk = function() {
                return !!e;
            })();
        }
        Lk([
            To
        ], Bk.prototype, "onHandleMouseDown", null), Lk([
            To
        ], Bk.prototype, "onMouseMove", null), Lk([
            To
        ], Bk.prototype, "onMouseUp", null), Lk([
            To
        ], Bk.prototype, "observe", null), Ma.add("resizeCells", Bk), rr.prototype.allowResizeX = !1, rr.prototype.allowResizeY = !0;
        var Uk = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Hk(t), function(e, t) {
                        return !t || "object" !== qk(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Wk() ? Reflect.construct(t, o || [], Hk(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).isResized = !1, e.start = {
                    x: 0,
                    y: 0,
                    w: 0,
                    h: 0
                }, e.handle = e.j.c.div("jodit-editor__resize", Ol.get("resize_handler")), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Fk(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this, o = e.o, n = o.height, r = o.width, i = o.allowResizeX, a = e.o.allowResizeY;
                        "auto" === n && "auto" !== r && (a = !1), "auto" === n && "auto" === r || !i && !a || (e.statusbar.setMod("resize-handle", !0), e.e.on("toggleFullSize.resizeHandler", function() {
                            t.handle.style.display = e.isFullSize ? "none" : "block";
                        }).on(this.handle, "mousedown touchstart", this.onHandleResizeStart).on(e.ow, "mouseup touchend", this.onHandleResizeEnd), e.container.appendChild(this.handle));
                    }
                },
                {
                    key: "onHandleResizeStart",
                    value: function(e) {
                        this.isResized = !0, this.start.x = e.clientX, this.start.y = e.clientY, this.start.w = this.j.container.offsetWidth, this.start.h = this.j.container.offsetHeight, this.j.lock(), this.j.e.on(this.j.ow, "mousemove touchmove", this.onHandleResize), e.preventDefault();
                    }
                },
                {
                    key: "onHandleResize",
                    value: function(e) {
                        this.isResized && (this.j.o.allowResizeY && this.j.e.fire("setHeight", this.start.h + e.clientY - this.start.y), this.j.o.allowResizeX && this.j.e.fire("setWidth", this.start.w + e.clientX - this.start.x), this.j.e.fire("resize"));
                    }
                },
                {
                    key: "onHandleResizeEnd",
                    value: function() {
                        this.isResized && (this.isResized = !1, this.j.e.off(this.j.ow, "mousemove touchmove", this.onHandleResize), this.j.unlock());
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        pi.safeRemove(this.handle), this.j.e.off(this.j.ow, "mouseup touchsend", this.onHandleResizeEnd);
                    }
                }
            ], Nk(o.prototype, n), t;
        }(Vk(Wp));
        function Yk(e, t, o) {
            return Yk = Qk() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Jk(r, o.prototype), r;
            }, Yk.apply(null, arguments);
        }
        function Kk(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Gk(e) {
            return Gk = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Gk(e);
        }
        function Jk(e, t) {
            return Jk = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Jk(e, t);
        }
        function Xk(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function Zk(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return Zk = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Yk(e, arguments, Gk(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Jk(n, e);
            }, Zk(e);
        }
        function Qk() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (Qk = function() {
                return !!e;
            })();
        }
        Uk.requires = [
            "size"
        ], Uk = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : qk(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            To
        ], Uk), Ma.add("resizeHandler", Uk), rr.prototype.allowResizeTags = new Set([
            "img",
            "iframe",
            "table",
            "jodit"
        ]), rr.prototype.resizer = {
            showSize: !0,
            hideSizeTimeout: 1e3,
            forImageChangeAttributes: !0,
            min_width: 10,
            min_height: 10,
            useAspectRatio: new Set([
                "img"
            ])
        };
        var $k = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : Xk(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, eS = "__jodit-resizer_binded", tS = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = Gk(t), function(e, t) {
                        return !t || "object" !== Xk(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, Qk() ? Reflect.construct(t, o || [], Gk(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).LOCK_KEY = "resizer", e.element = null, e.isResizeMode = !1, e.isShown = !1, e.startX = 0, e.startY = 0, e.width = 0, e.height = 0, e.ratio = 0, e.rect = e.j.c.fromHTML('<div title="'.concat(e.j.i18n("Press Alt for custom resizing"), '" class="jodit-resizer">\n\t\t\t\t<div class="jodit-resizer__top-left"></div>\n\t\t\t\t<div class="jodit-resizer__top-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-left"></div>\n\t\t\t\t<span>100x100</span>\n\t\t\t</div>')), e.sizeViewer = e.rect.getElementsByTagName("span")[0], e.pointerX = 0, e.pointerY = 0, e.isAltMode = !1, e.onClickElement = function(t) {
                    e.isResizeMode || e.element === t && e.isShown || (e.element = t, e.show(), pi.isTag(e.element, "img") && !e.element.complete && e.j.e.one(e.element, "load", e.updateSize));
                }, e.updateSize = function() {
                    if (!e.isInDestruct && e.isShown && e.element && e.rect) {
                        var t = e.getWorkplacePosition(), o = ta(e.element, e.j, e.j.ed), n = parseInt(e.rect.style.left || "0", 10), r = parseInt(e.rect.style.top || "0", 10), i = e.rect.offsetWidth, a = e.rect.offsetHeight, l = o.top - t.top, s = o.left - t.left;
                        r === l && n === s && i === e.element.offsetWidth && a === e.element.offsetHeight || (Ln(e.rect, {
                            top: l,
                            left: s,
                            width: e.element.offsetWidth,
                            height: e.element.offsetHeight
                        }), e.j.events && (e.j.e.fire(e.element, "changesize"), isNaN(n) || e.j.e.fire("resize")));
                    }
                }, e.hideSizeViewer = function() {
                    e.sizeViewer.style.opacity = "0";
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Jk(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        Qr("div", this.rect).forEach(function(o) {
                            e.e.on(o, "mousedown.resizer touchstart.resizer", t.onStartResizing.bind(t, o));
                        }), qa.on("hideHelpers", this.hide), e.e.on("readonly", function(e) {
                            e && t.hide();
                        }).on("afterInit changePlace", this.addEventListeners.bind(this)).on("afterGetValueFromEditor.resizer", function(e) {
                            var t = /<jodit[^>]+data-jodit_iframe_wrapper[^>]+>(.*?<iframe[^>]*>.*?<\/iframe>.*?)<\/jodit>/gi;
                            t.test(e.value) && (e.value = e.value.replace(t, "$1"));
                        }), this.addEventListeners(), this.__onChangeEditor();
                    }
                },
                {
                    key: "onEditorClick",
                    value: function(e) {
                        for(var t = e.target, o = this.j, n = o.editor, r = o.options.allowResizeTags; t && t !== n;){
                            if (pi.isTag(t, r)) return this.__bind(t), void this.onClickElement(t);
                            t = t.parentNode;
                        }
                    }
                },
                {
                    key: "__afterInsertImage",
                    value: function(e) {
                        if (!this.j.o.resizer.forImageChangeAttributes) {
                            var t = er(e, "width");
                            t && !Ln(e, "width", !0) && (Ln(e, "width", t), er(e, "width", null));
                        }
                    }
                },
                {
                    key: "addEventListeners",
                    value: function() {
                        var e = this, t = this.j;
                        t.e.off(t.editor, ".resizer").off(t.ow, ".resizer").on(t.editor, "keydown.resizer", function(t) {
                            e.isShown && t.key === Ut && e.element && !pi.isTag(e.element, "table") && e.onDelete(t);
                        }).on(t.ow, "resize.resizer", this.updateSize).on("resize.resizer", this.updateSize).on([
                            t.ow,
                            t.editor
                        ], "scroll.resizer", function() {
                            e.isShown && !e.isResizeMode && e.hide();
                        }).on(t.ow, "keydown.resizer", this.onKeyDown).on(t.ow, "keyup.resizer", this.onKeyUp).on(t.ow, "mouseup.resizer touchend.resizer", this.onClickOutside);
                    }
                },
                {
                    key: "onStartResizing",
                    value: function(e, t) {
                        if (!this.element || !this.element.parentNode) return this.hide(), !1;
                        this.handle = e, t.cancelable && t.preventDefault(), t.stopImmediatePropagation(), this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.ratio = this.width / this.height, this.isResizeMode = !0, this.startX = t.clientX, this.startY = t.clientY, this.pointerX = t.clientX, this.pointerY = t.clientY;
                        var o = this.j;
                        o.e.fire("hidePopup"), o.lock(this.LOCK_KEY), o.e.on(o.ow, "mousemove.resizer touchmove.resizer", this.onResize);
                    }
                },
                {
                    key: "onEndResizing",
                    value: function() {
                        var e = this.j;
                        e.unlock(), this.isResizeMode = !1, this.isAltMode = !1, e.synchronizeValues(), e.e.off(e.ow, "mousemove.resizer touchmove.resizer", this.onResize);
                    }
                },
                {
                    key: "onResize",
                    value: function(e) {
                        if (this.isResizeMode) {
                            if (!this.element) return;
                            var t, o;
                            if (this.pointerX = e.clientX, this.pointerY = e.clientY, this.j.options.iframe) {
                                var n = this.getWorkplacePosition();
                                t = e.clientX + n.left - this.startX, o = e.clientY + n.top - this.startY;
                            } else t = this.pointerX - this.startX, o = this.pointerY - this.startY;
                            var r = this.handle.className, i = 0, a = 0, l = this.j.o.resizer.useAspectRatio;
                            !this.isAltMode && (!0 === l || l && pi.isTag(this.element, l)) ? (t ? (i = this.width + (r.match(/left/) ? -1 : 1) * t, a = Math.round(i / this.ratio)) : (a = this.height + (r.match(/top/) ? -1 : 1) * o, i = Math.round(a * this.ratio)), i > $i(this.j.editor, this.j.ow) && (i = $i(this.j.editor, this.j.ow), a = Math.round(i / this.ratio))) : (i = this.width + (r.match(/left/) ? -1 : 1) * t, a = this.height + (r.match(/top/) ? -1 : 1) * o), i > this.j.o.resizer.min_width && (i < this.rect.parentNode.offsetWidth ? this.applySize(this.element, "width", i) : this.applySize(this.element, "width", "100%")), a > this.j.o.resizer.min_height && this.applySize(this.element, "height", a), this.updateSize(), this.showSizeViewer(this.element.offsetWidth, this.element.offsetHeight), e.stopImmediatePropagation();
                        }
                    }
                },
                {
                    key: "onKeyDown",
                    value: function(e) {
                        this.isAltMode = e.key === Nt, !this.isAltMode && this.isResizeMode && this.onEndResizing();
                    }
                },
                {
                    key: "onKeyUp",
                    value: function() {
                        this.isAltMode && this.isResizeMode && this.element && (this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.ratio = this.width / this.height, this.startX = this.pointerX, this.startY = this.pointerY), this.isAltMode = !1;
                    }
                },
                {
                    key: "onClickOutside",
                    value: function(e) {
                        if (this.isShown) {
                            if (!this.isResizeMode) return this.hide();
                            e.stopImmediatePropagation(), this.onEndResizing();
                        }
                    }
                },
                {
                    key: "getWorkplacePosition",
                    value: function() {
                        return ta(this.rect.parentNode || this.j.od.documentElement, this.j, this.j.od, !0);
                    }
                },
                {
                    key: "applySize",
                    value: function(e, t, o) {
                        var n = pi.isImage(e) && this.j.o.resizer.forImageChangeAttributes;
                        n && er(e, t, o), n && !e.style[t] || Ln(e, t, o);
                    }
                },
                {
                    key: "onDelete",
                    value: function(e) {
                        this.element && ("JODIT" !== this.element.tagName ? this.j.s.select(this.element) : (pi.safeRemove(this.element), this.hide(), e.preventDefault()));
                    }
                },
                {
                    key: "__onChangeEditor",
                    value: function() {
                        this.isShown && (this.element && this.element.parentNode ? this.updateSize() : this.hide()), Qr("iframe", this.j.editor).forEach(this.__bind);
                    }
                },
                {
                    key: "__bind",
                    value: function(e) {
                        var t = this;
                        if (pi.isHTMLElement(e) && this.j.o.allowResizeTags.has(e.tagName.toLowerCase()) && !cr(e, eS)) {
                            var o;
                            if (cr(e, eS, !0), pi.isTag(e, "iframe")) {
                                var n = e;
                                pi.isHTMLElement(e.parentNode) && er(e.parentNode, "-jodit_iframe_wrapper") ? e = e.parentNode : (er(o = this.j.createInside.element("jodit", {
                                    "data-jodit-temp": 1,
                                    contenteditable: !1,
                                    draggable: !0,
                                    "data-jodit_iframe_wrapper": 1
                                }), "style", er(e, "style")), Ln(o, {
                                    display: "inline-block" === e.style.display ? "inline-block" : "block",
                                    width: e.offsetWidth,
                                    height: e.offsetHeight
                                }), e.parentNode && e.parentNode.insertBefore(o, e), o.appendChild(e), this.j.e.on(o, "click", function() {
                                    er(o, "data-jodit-wrapper_active", !0);
                                }), e = o), this.j.e.off(e, "mousedown.select touchstart.select").on(e, "mousedown.select touchstart.select", function() {
                                    t.j.s.select(e);
                                }).off(e, "changesize").on(e, "changesize", function() {
                                    n.setAttribute("width", e.offsetWidth + "px"), n.setAttribute("height", e.offsetHeight + "px");
                                });
                            }
                            this.j.e.on(e, "dragstart", this.hide), !dt && to && this.j.e.on(e, "mousedown", function(t) {
                                pi.isTag(e, "img") && t.preventDefault();
                            });
                        }
                    }
                },
                {
                    key: "showSizeViewer",
                    value: function(e, t) {
                        this.j.o.resizer.showSize && (e < this.sizeViewer.offsetWidth || t < this.sizeViewer.offsetHeight ? this.hideSizeViewer() : (this.sizeViewer.style.opacity = "1", this.sizeViewer.textContent = "".concat(e, " x ").concat(t), this.j.async.setTimeout(this.hideSizeViewer, {
                            timeout: this.j.o.resizer.hideSizeTimeout,
                            label: "hideSizeViewer"
                        })));
                    }
                },
                {
                    key: "show",
                    value: function() {
                        this.j.o.readonly || this.isShown || (this.isShown = !0, this.rect.parentNode || (fr(this.j, this.rect), this.j.workplace.appendChild(this.rect)), this.j.isFullSize && (this.rect.style.zIndex = Ln(this.j.container, "zIndex").toString()), this.updateSize());
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        this.isResizeMode || (this.isResizeMode = !1, this.isShown = !1, this.element = null, pi.safeRemove(this.rect), Qr("[data-jodit-wrapper_active='true']", this.j.editor).forEach(function(e) {
                            return er(e, "data-jodit-wrapper_active", !1);
                        }));
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        this.hide(), qa.off("hideHelpers", this.hide), e.e.off(this.j.ow, ".resizer").off(".resizer");
                    }
                }
            ], n && Kk(o.prototype, n), t;
        }(Zk(Wp));
        function oS(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function nS(e, t, o) {
            return nS = aS() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && rS(r, o.prototype), r;
            }, nS.apply(null, arguments);
        }
        function rS(e, t) {
            return rS = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, rS(e, t);
        }
        function iS(e) {
            return function(e) {
                if (Array.isArray(e)) return oS(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return oS(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? oS(e, t) : void 0;
                }
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function aS() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (aS = function() {
                return !!e;
            })();
        }
        $k([
            Ca(":click")
        ], tS.prototype, "onEditorClick", null), $k([
            Ca(":afterInsertImage")
        ], tS.prototype, "__afterInsertImage", null), $k([
            To
        ], tS.prototype, "onStartResizing", null), $k([
            To
        ], tS.prototype, "onEndResizing", null), $k([
            To
        ], tS.prototype, "onResize", null), $k([
            To
        ], tS.prototype, "onKeyDown", null), $k([
            To
        ], tS.prototype, "onKeyUp", null), $k([
            To
        ], tS.prototype, "onClickOutside", null), $k([
            Ca(":change")
        ], tS.prototype, "__onChangeEditor", null), $k([
            To
        ], tS.prototype, "__bind", null), $k([
            To,
            Ca(":hideResizer")
        ], tS.prototype, "hide", null), Ma.add("resizer", tS), rr.prototype.useSearch = !0, rr.prototype.search = {
            lazyIdleTimeout: 0,
            useCustomHighlightAPI: Ot && void 0 !== Ot.Highlight
        }, Ol.set("search", '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg"> <path clip-rule="evenodd" d="M306.39,154.09c19.628,4.543,35.244,21.259,39.787,39.523 c1.551,8.54,8.998,14.989,17.904,14.989c9.991,0,18.168-8.175,18.168-18.17c0-13.083-10.991-32.98-25.985-47.881 c-14.719-14.537-32.252-24.802-46.695-24.802c-9.991,0-18.172,8.45-18.172,18.446C291.396,145.094,297.847,152.546,306.39,154.09z M56.629,392.312c-14.09,14.08-14.09,36.979,0,51.059c14.08,14.092,36.981,14.092,50.965,0l104.392-104.303 c24.347,15.181,53.062,23.991,83.953,23.991c87.857,0,158.995-71.142,158.995-158.999c0-87.854-71.138-158.995-158.995-158.995 c-87.856,0-158.995,71.141-158.995,158.995c0,30.802,8.819,59.606,23.992,83.953L56.629,392.312z M182.371,204.06 c0-62.687,50.875-113.568,113.568-113.568s113.569,50.881,113.569,113.568c0,62.694-50.876,113.569-113.569,113.569 S182.371,266.754,182.371,204.06z" fill-rule="evenodd"/> </svg> '), rr.prototype.controls.find = {
            tooltip: "Find",
            icon: "search",
            exec: function(e, t, o) {
                var n = o.control;
                switch(n.args && n.args[0]){
                    case "findPrevious":
                        e.e.fire("searchPrevious");
                        break;
                    case "findNext":
                        e.e.fire("searchNext");
                        break;
                    case "replace":
                        e.execCommand("openReplaceDialog");
                        break;
                    default:
                        e.execCommand("openSearchDialog");
                }
            },
            list: {
                search: "Find",
                findNext: "Find Next",
                findPrevious: "Find Previous",
                replace: "Replace"
            },
            childTemplate: function(e, t, o) {
                return o;
            }
        };
        var lS = "jd-tmp-selection";
        function sS(e, t, o, n, r) {
            if (null != t.startContainer.nodeValue && null != t.endContainer.nodeValue && !function(e, t, o) {
                if (e.o.search.useCustomHighlightAPI && Ot && void 0 !== Ot.Highlight) {
                    var n = [
                        t
                    ].concat(iS(o)).map(function(t) {
                        var o = e.selection.createRange();
                        return o.setStart(t.startContainer, t.startOffset), o.setEnd(t.endContainer, t.endOffset), o;
                    }), r = nS(Highlight, iS(n));
                    return CSS.highlights.clear(), CSS.highlights.set("jodit-search-result", r), o.length = 0, !0;
                }
                return !1;
            }(e, t, o)) {
                var i = n.element("span", function(e, t, o) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: o,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = o, e;
                }({}, lS, !0));
                pi.markTemporary(i), function(e, t, o) {
                    var n = e.startContainer.nodeValue, r = 0;
                    if (0 !== e.startOffset) {
                        var i = o.text(n.substring(0, e.startOffset));
                        e.startContainer.nodeValue = n.substring(e.startOffset), pi.before(e.startContainer, i), e.startContainer === e.endContainer && (r = e.startOffset, e.endOffset -= r), e.startOffset = 0;
                    }
                    var a = e.endContainer.nodeValue;
                    if (e.endOffset !== a.length) {
                        var l = o.text(a.substring(e.endOffset));
                        e.endContainer.nodeValue = a.substring(0, e.endOffset), pi.after(e.endContainer, l);
                        var s = !0, c = !1, u = void 0;
                        try {
                            for(var d, f = t[Symbol.iterator](); !(s = (d = f.next()).done); s = !0){
                                var p = d.value;
                                if (p.startContainer !== e.endContainer) break;
                                p.startContainer = l, p.startOffset = p.startOffset - e.endOffset - r, p.endContainer === e.endContainer && (p.endContainer = l, p.endOffset = p.endOffset - e.endOffset - r);
                            }
                        } catch (e) {
                            c = !0, u = e;
                        } finally{
                            try {
                                s || null == f.return || f.return();
                            } finally{
                                if (c) throw u;
                            }
                        }
                        e.endOffset = e.endContainer.nodeValue.length;
                    }
                }(t, o, n);
                var a, l = t.startContainer;
                do {
                    if (!l) break;
                    if (!pi.isText(l) || (a = l.parentNode, pi.isElement(a) && a.hasAttribute(lS)) || pi.wrap(l, i.cloneNode(), n), l === t.endContainer) break;
                    var s = l.firstChild || l.nextSibling;
                    if (!s) {
                        for(; l && !l.nextSibling && l !== r;)l = l.parentNode;
                        s = null == l ? void 0 : l.nextSibling;
                    }
                    l = s;
                }while (l && l !== r);
            }
        }
        function cS(e) {
            return Qr("[".concat(lS, "]"), e);
        }
        function uS(e) {
            cS(e.editor).forEach(function(e) {
                return pi.unwrap(e);
            }), function(e) {
                e.o.search.useCustomHighlightAPI && Ot && void 0 !== Ot.Highlight && CSS.highlights.clear();
            }(e);
        }
        function dS(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function fS(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function pS(e, t) {
            return function(e) {
                if (Array.isArray(e)) return e;
            }(e) || function(e, t) {
                var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != o) {
                    var n, r, i = [], a = !0, l = !1;
                    try {
                        for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                    } catch (e) {
                        l = !0, r = e;
                    } finally{
                        try {
                            a || null == o.return || o.return();
                        } finally{
                            if (l) throw r;
                        }
                    }
                    return i;
                }
            }(e, t) || function(e, t) {
                if (e) {
                    if ("string" == typeof e) return dS(e, t);
                    var o = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? dS(e, t) : void 0;
                }
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        var hS = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : na;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.searchIndex = t, this.queue = [], this.value = "";
            }
            var t, o;
            return t = e, o = [
                {
                    key: "add",
                    value: function(e) {
                        var t, o = (null !== (t = e.nodeValue) && void 0 !== t ? t : "").toLowerCase();
                        if (o.length) {
                            var n = this.value.length;
                            this.queue.push({
                                startIndex: n,
                                endIndex: n + o.length,
                                node: e
                            }), this.value += o;
                        }
                    }
                },
                {
                    key: "ranges",
                    value: function(e) {
                        var t = [], o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = 0, r = 0;
                        do {
                            var i;
                            if (o = (i = pS(this.searchIndex(e, this.value, o), 2))[0], n = i[1], -1 !== o) {
                                for(var a = void 0, l = 0, s = void 0, c = 0, u = r; u < this.queue.length; u += 1)if (!a && this.queue[u].endIndex > o && (a = this.queue[u].node, l = o - this.queue[u].startIndex), a && this.queue[u].endIndex >= o + n) {
                                    s = this.queue[u].node, c = o + n - this.queue[u].startIndex, r = u;
                                    break;
                                }
                                a && s && t.push({
                                    startContainer: a,
                                    startOffset: l,
                                    endContainer: s,
                                    endOffset: c
                                }), o += n;
                            }
                        }while (-1 !== o);
                        return 0 === t.length ? null : t;
                    }
                }
            ], o && fS(t.prototype, o), e;
        }();
        function vS(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function gS(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function mS(e) {
            return mS = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, mS(e);
        }
        function bS(e, t) {
            return bS = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, bS(e, t);
        }
        function yS(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function _S() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (_S = function() {
                return !!e;
            })();
        }
        var jS = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : yS(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, wS = function(e) {
            function t(e) {
                var o, n;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), o = function(e, t, o) {
                    return t = mS(t), function(e, t) {
                        return !t || "object" !== yS(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, _S() ? Reflect.construct(t, o || [], mS(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ]), n = o, o.selInfo = null, o._currentIndex = 0, o.isOpened = !1;
                var r = ei(o.container), i = r.query, a = r.replace, l = r.cancel, s = r.next, c = r.prev, u = r.replaceBtn, d = r.current, f = r.count;
                return o.queryInput = i, o.replaceInput = a, o.closeButton = l, o.replaceButton = u, o.currentBox = d, o.countBox = f, e.e.on(o.closeButton, "pointerdown", function() {
                    return o.close(), !1;
                }).on(o.queryInput, "input", function() {
                    o.currentIndex = 0;
                }).on(o.queryInput, "pointerdown", function() {
                    e.s.isFocused() && (e.s.removeMarkers(), o.selInfo = e.s.save());
                }).on(o.replaceButton, "pointerdown", function() {
                    return e.e.fire(o, "pressReplaceButton"), !1;
                }).on(s, "pointerdown", function() {
                    return e.e.fire("searchNext"), !1;
                }).on(c, "pointerdown", function() {
                    return e.e.fire("searchPrevious"), !1;
                }).on(o.queryInput, "input", function() {
                    o.setMod("empty-query", !vn(o.queryInput.value).length);
                }).on(o.queryInput, "keydown", o.j.async.debounce(function() {
                    var t, o = (t = function(t) {
                        return function(e, t) {
                            var o, n, r, i, a = {
                                label: 0,
                                sent: function() {
                                    if (1 & r[0]) throw r[1];
                                    return r[1];
                                },
                                trys: [],
                                ops: []
                            };
                            return i = {
                                next: l(0),
                                throw: l(1),
                                return: l(2)
                            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                return this;
                            }), i;
                            function l(i) {
                                return function(l) {
                                    return function(i) {
                                        if (o) throw new TypeError("Generator is already executing.");
                                        for(; a;)try {
                                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                            switch(n = 0, r && (i = [
                                                2 & i[0],
                                                r.value
                                            ]), i[0]){
                                                case 0:
                                                case 1:
                                                    r = i;
                                                    break;
                                                case 4:
                                                    return a.label++, {
                                                        value: i[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    a.label++, n = i[1], i = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    i = a.ops.pop(), a.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                        a = 0;
                                                        continue;
                                                    }
                                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                        a.label = i[1];
                                                        break;
                                                    }
                                                    if (6 === i[0] && a.label < r[1]) {
                                                        a.label = r[1], r = i;
                                                        break;
                                                    }
                                                    if (r && a.label < r[2]) {
                                                        a.label = r[2], a.ops.push(i);
                                                        break;
                                                    }
                                                    r[2] && a.ops.pop(), a.trys.pop();
                                                    continue;
                                            }
                                            i = t.call(e, a);
                                        } catch (e) {
                                            i = [
                                                6,
                                                e
                                            ], n = 0;
                                        } finally{
                                            o = r = 0;
                                        }
                                        if (5 & i[0]) throw i[1];
                                        return {
                                            value: i[0] ? i[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        i,
                                        l
                                    ]);
                                };
                            }
                        }(this, function(o) {
                            switch(o.label){
                                case 0:
                                    return t.key === Bt ? [
                                        3,
                                        1
                                    ] : [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return t.preventDefault(), t.stopImmediatePropagation(), [
                                        4,
                                        e.e.fire("searchNext")
                                    ];
                                case 2:
                                    return o.sent() && n.close(), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return e.e.fire(n, "needUpdateCounters"), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }, function() {
                        var e = this, o = arguments;
                        return new Promise(function(n, r) {
                            var i = t.apply(e, o);
                            function a(e) {
                                vS(i, n, r, a, l, "next", e);
                            }
                            function l(e) {
                                vS(i, n, r, a, l, "throw", e);
                            }
                            a(void 0);
                        });
                    });
                    return function(e) {
                        return o.apply(this, arguments);
                    };
                }(), o.j.defaultTimeout)), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && bS(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UISearch";
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return '<div>\n\t\t\t<div class="&__box">\n\t\t\t\t<div class="&__inputs">\n\t\t\t\t\t<input data-ref="query" tabindex="0" placeholder="~Search for~" type="text"/>\n\t\t\t\t\t<input data-ref="replace" tabindex="0" placeholder="~Replace with~" type="text"/>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__counts">\n\t\t\t\t\t<span data-ref="counter-box">\n\t\t\t\t\t\t<span data-ref="current">0</span><span>/</span><span data-ref="count">0</span>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__buttons">\n\t\t\t\t\t<button data-ref="next" tabindex="0" type="button">'.concat(Ol.get("angle-down"), '</button>\n\t\t\t\t\t<button data-ref="prev" tabindex="0" type="button">').concat(Ol.get("angle-up"), '</button>\n\t\t\t\t\t<button data-ref="cancel" tabindex="0" type="button">').concat(Ol.get("cancel"), '</button>\n\t\t\t\t\t<button data-ref="replace-btn" tabindex="0" type="button" class="jodit-ui-button">~Replace~</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>');
                    }
                },
                {
                    key: "currentIndex",
                    get: function() {
                        return this._currentIndex;
                    },
                    set: function(e) {
                        this._currentIndex = e, this.currentBox.innerText = e.toString();
                    }
                },
                {
                    key: "count",
                    set: function(e) {
                        this.countBox.innerText = e.toString();
                    }
                },
                {
                    key: "query",
                    get: function() {
                        return this.queryInput.value;
                    }
                },
                {
                    key: "replace",
                    get: function() {
                        return this.replaceInput.value;
                    }
                },
                {
                    key: "onEditorKeyDown",
                    value: function(e) {
                        if (this.isOpened) {
                            var t = this.j;
                            if (t.getRealMode() === Qt) switch(e.key){
                                case Dt:
                                    this.close();
                                    break;
                                case Yt:
                                    this.queryInput.value && (t.e.fire(e.shiftKey ? "searchPrevious" : "searchNext"), e.preventDefault());
                            }
                        }
                    }
                },
                {
                    key: "open",
                    value: function(e, t) {
                        var o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        this.isOpened || (this.j.workplace.appendChild(this.container), this.isOpened = !0), this.calcSticky(this.j.e.fire("getStickyState.sticky") || !1), this.j.e.fire("hidePopup"), this.setMod("replace", o);
                        var n = null != e ? e : (this.j.s.sel || "").toString();
                        n && (this.queryInput.value = n), t && (this.replaceInput.value = t), this.setMod("empty-query", !n.length), this.j.e.fire(this, "needUpdateCounters"), n ? this.queryInput.select() : this.queryInput.focus();
                    }
                },
                {
                    key: "close",
                    value: function() {
                        this.isOpened && (this.j.s.restore(), pi.safeRemove(this.container), this.isOpened = !1, this.j.e.fire(this, "afterClose"));
                    }
                },
                {
                    key: "calcSticky",
                    value: function(e) {
                        if (this.isOpened) {
                            if (this.setMod("sticky", e), e) {
                                var t = oa(this.j.toolbarContainer);
                                Ln(this.container, {
                                    top: t.top + t.height,
                                    left: t.left + t.width
                                });
                            } else Ln(this.container, {
                                top: null,
                                left: null
                            });
                        }
                    }
                }
            ], n && gS(o.prototype, n), t;
        }(Al);
        function kS(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function SS(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function xS(e) {
            return function() {
                var t = this, o = arguments;
                return new Promise(function(n, r) {
                    var i = e.apply(t, o);
                    function a(e) {
                        SS(i, n, r, a, l, "next", e);
                    }
                    function l(e) {
                        SS(i, n, r, a, l, "throw", e);
                    }
                    a(void 0);
                });
            };
        }
        function OS(e, t, o) {
            return OS = PS() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && ES(r, o.prototype), r;
            }, OS.apply(null, arguments);
        }
        function CS(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function zS(e) {
            return zS = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, zS(e);
        }
        function ES(e, t) {
            return ES = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, ES(e, t);
        }
        function TS(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function IS(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return IS = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return OS(e, arguments, zS(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), ES(n, e);
            }, IS(e);
        }
        function PS() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (PS = function() {
                return !!e;
            })();
        }
        function RS(e, t) {
            var o, n, r, i, a = {
                label: 0,
                sent: function() {
                    if (1 & r[0]) throw r[1];
                    return r[1];
                },
                trys: [],
                ops: []
            };
            return i = {
                next: l(0),
                throw: l(1),
                return: l(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                return this;
            }), i;
            function l(i) {
                return function(l) {
                    return function(i) {
                        if (o) throw new TypeError("Generator is already executing.");
                        for(; a;)try {
                            if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                            switch(n = 0, r && (i = [
                                2 & i[0],
                                r.value
                            ]), i[0]){
                                case 0:
                                case 1:
                                    r = i;
                                    break;
                                case 4:
                                    return a.label++, {
                                        value: i[1],
                                        done: !1
                                    };
                                case 5:
                                    a.label++, n = i[1], i = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    i = a.ops.pop(), a.trys.pop();
                                    continue;
                                default:
                                    if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                        a = 0;
                                        continue;
                                    }
                                    if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                        a.label = i[1];
                                        break;
                                    }
                                    if (6 === i[0] && a.label < r[1]) {
                                        a.label = r[1], r = i;
                                        break;
                                    }
                                    if (r && a.label < r[2]) {
                                        a.label = r[2], a.ops.push(i);
                                        break;
                                    }
                                    r[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                            }
                            i = t.call(e, a);
                        } catch (e) {
                            i = [
                                6,
                                e
                            ], n = 0;
                        } finally{
                            o = r = 0;
                        }
                        if (5 & i[0]) throw i[1];
                        return {
                            value: i[0] ? i[1] : void 0,
                            done: !0
                        };
                    }([
                        i,
                        l
                    ]);
                };
            }
        }
        jS([
            Ca([
                ":keydown",
                "queryInput:keydown"
            ])
        ], wS.prototype, "onEditorKeyDown", null), jS([
            To
        ], wS.prototype, "open", null), jS([
            To
        ], wS.prototype, "close", null), jS([
            Ca(":toggleSticky")
        ], wS.prototype, "calcSticky", null), wS = jS([
            ji
        ], wS);
        var AS = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : TS(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, LS = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = zS(t), function(e, t) {
                        return !t || "object" !== TS(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, PS() ? Reflect.construct(t, o || [], zS(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "find",
                        group: "search"
                    }
                ], e.previousQuery = "", e.drawPromise = null, e.walker = null, e.walkerCount = null, e.cache = {}, e.wrapFrameRequest = 0, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ES(e, t);
            }(t, e), o = t, n = [
                {
                    key: "ui",
                    get: function() {
                        return new wS(this.j);
                    }
                },
                {
                    key: "updateCounters",
                    value: function() {
                        var e = this;
                        return xS(function() {
                            var t;
                            return RS(this, function(o) {
                                switch(o.label){
                                    case 0:
                                        return e.ui.isOpened ? (t = e.ui, [
                                            4,
                                            e.calcCounts(e.ui.query)
                                        ]) : [
                                            2
                                        ];
                                    case 1:
                                        return t.count = o.sent(), [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "onPressReplaceButton",
                    value: function() {
                        this.findAndReplace(this.ui.query), this.updateCounters();
                    }
                },
                {
                    key: "tryScrollToElement",
                    value: function(e) {
                        var t = pi.closest(e, pi.isElement, this.j.editor);
                        t || (t = pi.prev(e, pi.isElement, this.j.editor)), t && t !== this.j.editor && ii(t, this.j.editor, this.j.ed);
                    }
                },
                {
                    key: "calcCounts",
                    value: function(e) {
                        var t = this;
                        return xS(function() {
                            return RS(this, function(o) {
                                switch(o.label){
                                    case 0:
                                        return [
                                            4,
                                            t.findQueryBounds(e, "walkerCount")
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            o.sent().length
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "findQueryBounds",
                    value: function(e, t) {
                        var o = this;
                        return xS(function() {
                            var n;
                            return RS(this, function(r) {
                                return (n = o[t]) && n.break(), n = new Cn(o.j.async, {
                                    timeout: o.j.o.search.lazyIdleTimeout
                                }), o[t] = n, [
                                    2,
                                    o.find(n, e).catch(function(e) {
                                        return !ft && console.error(e), [];
                                    })
                                ];
                            });
                        })();
                    }
                },
                {
                    key: "findAndReplace",
                    value: function(e) {
                        var t = this;
                        return xS(function() {
                            var o, n, r, i, a;
                            return RS(this, function(l) {
                                switch(l.label){
                                    case 0:
                                        return [
                                            4,
                                            t.findQueryBounds(e, "walker")
                                        ];
                                    case 1:
                                        if (!(o = l.sent()).length) return [
                                            2,
                                            !1
                                        ];
                                        if (-1 === (n = t.findCurrentIndexInRanges(o, t.j.s.range)) && (n = 0), !(r = o[n])) return [
                                            3,
                                            6
                                        ];
                                        l.label = 2;
                                    case 2:
                                        return l.trys.push([
                                            2,
                                            ,
                                            4,
                                            5
                                        ]), (i = t.j.ed.createRange()).setStart(r.startContainer, r.startOffset), i.setEnd(r.endContainer, r.endOffset), i.deleteContents(), a = t.j.createInside.text(t.ui.replace), pi.safeInsertNode(i, a), uS(t.j), t.j.s.setCursorAfter(a), t.tryScrollToElement(a), t.cache = {}, t.ui.currentIndex = n, [
                                            4,
                                            t.findAndSelect(e, !0).catch(function(e) {
                                                return !ft && console.error(e), null;
                                            })
                                        ];
                                    case 3:
                                        return l.sent(), [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        return t.j.synchronizeValues(), [
                                            7
                                        ];
                                    case 5:
                                        return t.j.e.fire("afterFindAndReplace"), [
                                            2,
                                            !0
                                        ];
                                    case 6:
                                        return [
                                            2,
                                            !1
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "findAndSelect",
                    value: function(e, t) {
                        var o = this;
                        return xS(function() {
                            var n, r, i, a, l;
                            return RS(this, function(s) {
                                switch(s.label){
                                    case 0:
                                        return [
                                            4,
                                            o.findQueryBounds(e, "walker")
                                        ];
                                    case 1:
                                        if (!(r = s.sent()).length) return [
                                            2,
                                            !1
                                        ];
                                        if (o.previousQuery === e && cS(o.j.editor).length || (null === (n = o.drawPromise) || void 0 === n || n.rejectCallback(), o.j.async.cancelAnimationFrame(o.wrapFrameRequest), uS(o.j), o.drawPromise = o.__drawSelectionRanges(r)), o.previousQuery = e, i = -1 == (i = o.ui.currentIndex - 1) ? 0 : t ? i === r.length - 1 ? 0 : i + 1 : 0 === i ? r.length - 1 : i - 1, o.ui.currentIndex = i + 1, !(a = r[i])) return [
                                            3,
                                            4
                                        ];
                                        l = o.j.ed.createRange();
                                        try {
                                            l.setStart(a.startContainer, a.startOffset), l.setEnd(a.endContainer, a.endOffset), o.j.s.selectRange(l);
                                        } catch (e) {
                                            !ft && console.error(e);
                                        }
                                        return o.tryScrollToElement(a.startContainer), [
                                            4,
                                            o.updateCounters()
                                        ];
                                    case 2:
                                        return s.sent(), [
                                            4,
                                            o.drawPromise
                                        ];
                                    case 3:
                                        return s.sent(), o.j.e.fire("afterFindAndSelect"), [
                                            2,
                                            !0
                                        ];
                                    case 4:
                                        return [
                                            2,
                                            !1
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "findCurrentIndexInRanges",
                    value: function(e, t) {
                        return e.findIndex(function(e) {
                            return e.startContainer === t.startContainer && e.startOffset === t.startOffset && e.endContainer === t.startContainer && e.endOffset === t.endOffset;
                        });
                    }
                },
                {
                    key: "isValidCache",
                    value: function(e) {
                        return xS(function() {
                            return RS(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return [
                                            4,
                                            e
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            t.sent().every(function(e) {
                                                var t, o, n, r;
                                                return e.startContainer.isConnected && e.startOffset <= (null !== (o = null === (t = e.startContainer.nodeValue) || void 0 === t ? void 0 : t.length) && void 0 !== o ? o : 0) && e.endContainer.isConnected && e.endOffset <= (null !== (r = null === (n = e.endContainer.nodeValue) || void 0 === n ? void 0 : n.length) && void 0 !== r ? r : 0);
                                            })
                                        ];
                                }
                            });
                        })();
                    }
                },
                {
                    key: "find",
                    value: function(e, t) {
                        var o = this;
                        return xS(function() {
                            var n, r;
                            return RS(this, function(i) {
                                switch(i.label){
                                    case 0:
                                        return t.length ? (n = o.cache[t], (r = n) ? [
                                            4,
                                            o.isValidCache(n)
                                        ] : [
                                            3,
                                            2
                                        ]) : [
                                            2,
                                            []
                                        ];
                                    case 1:
                                        r = i.sent(), i.label = 2;
                                    case 2:
                                        return r ? [
                                            2,
                                            n
                                        ] : (o.cache[t] = o.j.async.promise(function(n) {
                                            var r = new hS(o.j.o.search.fuzzySearch);
                                            e.on("break", function() {
                                                n([]);
                                            }).on("visit", function(e) {
                                                return pi.isText(e) && r.add(e), !1;
                                            }).on("end", function() {
                                                var e;
                                                n(null !== (e = r.ranges(t)) && void 0 !== e ? e : []);
                                            }).setWork(o.j.editor);
                                        }), [
                                            2,
                                            o.cache[t]
                                        ]);
                                }
                            });
                        })();
                    }
                },
                {
                    key: "__drawSelectionRanges",
                    value: function(e) {
                        var t = this, o = this.j, n = o.async, r = o.createInside, i = o.editor;
                        n.cancelAnimationFrame(this.wrapFrameRequest);
                        var a, l = function(e) {
                            return function(e) {
                                if (Array.isArray(e)) return kS(e);
                            }(e) || function(e) {
                                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                            }(e) || function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return kS(e, t);
                                    var o = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? kS(e, t) : void 0;
                                }
                            }(e) || function() {
                                throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }();
                        }(e), s = 0;
                        return n.promise(function(e) {
                            var o = function() {
                                do (a = l.shift()) && sS(t.j, a, l, r, i), s += 1;
                                while (a && s <= 5);
                                l.length ? t.wrapFrameRequest = n.requestAnimationFrame(o) : e();
                            };
                            o();
                        });
                    }
                },
                {
                    key: "onAfterGetValueFromEditor",
                    value: function(e) {
                        e.value = e.value.replace(RegExp("<span[^>]+".concat(lS, "[^>]+>(.*?)</span>"), "g"), "$1");
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        if (e.o.useSearch) {
                            var o = this, n = this;
                            e.e.on("beforeSetMode.search", function() {
                                t.ui.close();
                            }).on(this.ui, "afterClose", function() {
                                uS(e), t.ui.currentIndex = 0, t.ui.count = 0, t.cache = {}, e.focus();
                            }).on("click", function() {
                                t.ui.currentIndex = 0, uS(e);
                            }).on("change.search", function() {
                                t.cache = {};
                            }).on("keydown.search mousedown.search", e.async.debounce(function() {
                                t.ui.selInfo && (e.s.removeMarkers(), t.ui.selInfo = null), t.ui.isOpened && t.updateCounters();
                            }, e.defaultTimeout)).on("searchNext.search searchPrevious.search", function() {
                                return t.ui.isOpened || t.ui.open(), n.findAndSelect(n.ui.query, "searchNext" === e.e.current).catch(function(e) {
                                    !ft && console.error("Search error", e);
                                });
                            }).on("search.search", function(e) {
                                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                return o.ui.currentIndex = 0, n.findAndSelect(e || "", t).catch(function(e) {
                                    !ft && console.error("Search error", e);
                                });
                            }), e.registerCommand("search", {
                                exec: function(e, t) {
                                    var o = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                                    return t && n.findAndSelect(t, o).catch(function(e) {
                                        !ft && console.error("Search error", e);
                                    }), !1;
                                }
                            }).registerCommand("openSearchDialog", {
                                exec: function(e, t) {
                                    return n.ui.open(t), !1;
                                },
                                hotkeys: [
                                    "ctrl+f",
                                    "cmd+f"
                                ]
                            }).registerCommand("openReplaceDialog", {
                                exec: function(t, o, r) {
                                    return e.o.readonly || n.ui.open(o, r, !0), !1;
                                },
                                hotkeys: [
                                    "ctrl+h",
                                    "cmd+h"
                                ]
                            });
                        }
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        var t;
                        null === (t = hi(this, "ui")) || void 0 === t || t.destruct(), e.e.off(".search");
                    }
                }
            ], n && CS(o.prototype, n), t;
        }(IS(Wp));
        function MS(e, t, o) {
            return MS = qS() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && NS(r, o.prototype), r;
            }, MS.apply(null, arguments);
        }
        function BS(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function DS(e) {
            return DS = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, DS(e);
        }
        function NS(e, t) {
            return NS = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, NS(e, t);
        }
        function HS(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function FS(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return FS = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return MS(e, arguments, DS(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), NS(n, e);
            }, FS(e);
        }
        function qS() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (qS = function() {
                return !!e;
            })();
        }
        AS([
            vi
        ], LS.prototype, "ui", null), AS([
            Ca("ui:needUpdateCounters")
        ], LS.prototype, "updateCounters", null), AS([
            Ca("ui:pressReplaceButton")
        ], LS.prototype, "onPressReplaceButton", null), AS([
            To
        ], LS.prototype, "findQueryBounds", null), AS([
            To
        ], LS.prototype, "findAndReplace", null), AS([
            To
        ], LS.prototype, "findAndSelect", null), AS([
            To
        ], LS.prototype, "find", null), AS([
            Ca(":afterGetValueFromEditor")
        ], LS.prototype, "onAfterGetValueFromEditor", null), Ma.add("search", LS), rr.prototype.select = {
            normalizeSelectionBeforeCutAndCopy: !1,
            normalizeTripleClick: !0
        };
        var VS = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : HS(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, WS = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = DS(t), function(e, t) {
                        return !t || "object" !== HS(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, qS() ? Reflect.construct(t, o || [], DS(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).proxyEventsList = [
                    "click",
                    "mousedown",
                    "touchstart",
                    "mouseup",
                    "touchend"
                ], e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && NS(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        this.proxyEventsList.forEach(function(o) {
                            e.e.on(o + ".select", t.onStartSelection);
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        var t = this;
                        this.proxyEventsList.forEach(function(o) {
                            e.e.on(o + ".select", t.onStartSelection);
                        });
                    }
                },
                {
                    key: "onStartSelection",
                    value: function(e) {
                        for(var t, o = this.j, n = e.target; void 0 === t && n && n !== o.editor;)t = o.e.fire(An(e.type + "_" + n.nodeName.toLowerCase()), n, e), n = n.parentElement;
                        "click" === e.type && void 0 === t && n === o.editor && o.e.fire(e.type + "Editor", n, e);
                    }
                },
                {
                    key: "onOutsideClick",
                    value: function(e) {
                        var t = this, o = e.target;
                        pi.up(o, function(e) {
                            return e === t.j.editor;
                        }) || Al.closestElement(o, gu) || this.j.e.fire("outsideClick", e);
                    }
                },
                {
                    key: "beforeCommandCut",
                    value: function() {
                        var e = this.j.s;
                        if (!e.isCollapsed()) {
                            var t = e.current();
                            t && pi.isOrContains(this.j.editor, t) && this.onCopyNormalizeSelectionBound();
                        }
                    }
                },
                {
                    key: "beforeCommandSelectAll",
                    value: function() {
                        var e = this.j.s;
                        return e.focus(), e.select(this.j.editor, !0), e.expandSelection(), !1;
                    }
                },
                {
                    key: "onTripleClickNormalizeSelection",
                    value: function(e) {
                        if (3 === e.detail && this.j.o.select.normalizeTripleClick) {
                            var t = this.j.s, o = t.range, n = o.startContainer;
                            0 === o.startOffset && pi.isText(n) && t.select(pi.closest(n, pi.isBlock, this.j.editor) || n, !0);
                        }
                    }
                },
                {
                    key: "onCopyNormalizeSelectionBound",
                    value: function(e) {
                        var t = this.j, o = t.s, n = t.editor;
                        t.o.select.normalizeSelectionBeforeCutAndCopy && !o.isCollapsed() && (!e || e.isTrusted && pi.isNode(e.target) && pi.isOrContains(n, e.target)) && this.jodit.s.expandSelection();
                    }
                }
            ], n && BS(o.prototype, n), t;
        }(FS(Wp));
        function US(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function YS(e, t, o) {
            return YS = QS() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && JS(r, o.prototype), r;
            }, YS.apply(null, arguments);
        }
        function KS(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function GS(e) {
            return GS = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, GS(e);
        }
        function JS(e, t) {
            return JS = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, JS(e, t);
        }
        function XS(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function ZS(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return ZS = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return YS(e, arguments, GS(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), JS(n, e);
            }, ZS(e);
        }
        function QS() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (QS = function() {
                return !!e;
            })();
        }
        VS([
            To
        ], WS.prototype, "onStartSelection", null), VS([
            Ca("ow:click")
        ], WS.prototype, "onOutsideClick", null), VS([
            Ca([
                ":beforeCommandCut"
            ])
        ], WS.prototype, "beforeCommandCut", null), VS([
            Ca([
                ":beforeCommandSelectall"
            ])
        ], WS.prototype, "beforeCommandSelectAll", null), VS([
            Ca([
                ":click"
            ])
        ], WS.prototype, "onTripleClickNormalizeSelection", null), VS([
            Ca([
                ":copy",
                ":cut"
            ])
        ], WS.prototype, "onCopyNormalizeSelectionBound", null), Ma.add("select", WS), rr.prototype.tableAllowCellSelection = !0;
        var $S = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : XS(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, ex = "table_processor_observer", tx = "onMoveTableSelectCell", ox = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = GS(t), function(e, t) {
                        return !t || "object" !== XS(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, QS() ? Reflect.construct(t, o || [], GS(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).__selectedCell = null, e.__isSelectionMode = !1, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && JS(e, t);
            }(t, e), o = t, n = [
                {
                    key: "__tableModule",
                    get: function() {
                        return this.j.getInstance(wh, this.j.o);
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.o.tableAllowCellSelection && e.e.on("keydown.select-cells", function(e) {
                            e.key === Mt && t.unselectCells();
                        }).on("beforeCommand.select-cells", this.onExecCommand).on("afterCommand.select-cells", this.onAfterCommand).on([
                            "clickEditor",
                            "mousedownTd",
                            "mousedownTh",
                            "touchstartTd",
                            "touchstartTh"
                        ].map(function(e) {
                            return e + ".select-cells";
                        }).join(" "), this.onStartSelection).on("clickTr clickTbody", function() {
                            var e, o = t.__tableModule.getAllSelectedCells().length;
                            if (o) return o > 1 && (null === (e = t.j.s.sel) || void 0 === e || e.removeAllRanges()), !1;
                        });
                    }
                },
                {
                    key: "onStartSelection",
                    value: function(e) {
                        if (!this.j.o.readonly && (this.unselectCells(), e !== this.j.editor)) {
                            var t = pi.closest(e, "table", this.j.editor);
                            if (e && t) return e.firstChild || e.appendChild(this.j.createInside.element("br")), this.__isSelectionMode = !0, this.__selectedCell = e, this.__tableModule.addSelection(e), this.j.e.on(t, "mousemove.select-cells touchmove.select-cells", this.j.async.throttle(this.__onMove.bind(this, t), {
                                label: tx,
                                timeout: this.j.defaultTimeout / 2
                            })).on(t, "mouseup.select-cells touchend.select-cells", this.__onStopSelection.bind(this, t)), !1;
                        }
                    }
                },
                {
                    key: "onOutsideClick",
                    value: function() {
                        this.__selectedCell = null, this.__onRemoveSelection();
                    }
                },
                {
                    key: "onChange",
                    value: function() {
                        this.j.isLocked || this.__isSelectionMode || this.__onRemoveSelection();
                    }
                },
                {
                    key: "__onMove",
                    value: function(e, t) {
                        var o, n = this;
                        if ((!this.j.o.readonly || this.j.isLocked) && !this.j.isLockedNotBy(ex)) {
                            var r = this.j.ed.elementFromPoint(t.clientX, t.clientY);
                            if (r) {
                                var i = pi.closest(r, [
                                    "td",
                                    "th"
                                ], e);
                                if (i && this.__selectedCell) {
                                    i !== this.__selectedCell && this.j.lock(ex), this.unselectCells();
                                    for(var a = this.__tableModule.getSelectedBound(e, [
                                        i,
                                        this.__selectedCell
                                    ]), l = this.__tableModule.formalMatrix(e), s = a[0][0]; s <= a[1][0]; s += 1)for(var c = a[0][1]; c <= a[1][1]; c += 1)this.__tableModule.addSelection(l[s][c]);
                                    var u;
                                    this.__tableModule.getAllSelectedCells().length > 1 && (null === (o = this.j.s.sel) || void 0 === o || o.removeAllRanges()), this.j.e.fire("hidePopup"), t.stopPropagation(), u = n.j.createInside.fromHTML('<div style="color:rgba(0,0,0,0.01);width:0;height:0">&nbsp;</div>'), i.appendChild(u), n.j.async.setTimeout(function() {
                                        var e;
                                        null === (e = u.parentNode) || void 0 === e || e.removeChild(u);
                                    }, n.j.defaultTimeout / 5);
                                }
                            }
                        }
                    }
                },
                {
                    key: "__onRemoveSelection",
                    value: function(e) {
                        var t;
                        if (!(null === (t = null == e ? void 0 : e.buffer) || void 0 === t ? void 0 : t.actionTrigger) && !this.__selectedCell && this.__tableModule.getAllSelectedCells().length) return this.j.unlock(), this.unselectCells(), void this.j.e.fire("hidePopup", "cells");
                        this.__isSelectionMode = !1, this.__selectedCell = null;
                    }
                },
                {
                    key: "__onStopSelection",
                    value: function(e, t) {
                        var o = this;
                        if (this.__selectedCell) {
                            this.__isSelectionMode = !1, this.j.unlock();
                            var n = this.j.ed.elementFromPoint(t.clientX, t.clientY);
                            if (n) {
                                var r = pi.closest(n, [
                                    "td",
                                    "th"
                                ], e);
                                if (r) {
                                    var i = pi.closest(r, "table", e);
                                    if (!i || i === e) {
                                        var a = this.__tableModule.getSelectedBound(e, [
                                            r,
                                            this.__selectedCell
                                        ]), l = this.__tableModule.formalMatrix(e), s = l[a[1][0]][a[1][1]], c = l[a[0][0]][a[0][1]];
                                        this.j.e.fire("showPopup", e, function() {
                                            var e = oa(c, o.j), t = oa(s, o.j);
                                            return {
                                                left: e.left,
                                                top: e.top,
                                                width: t.left - e.left + t.width,
                                                height: t.top - e.top + t.height
                                            };
                                        }, "cells"), Qr("table", this.j.editor).forEach(function(e) {
                                            o.j.e.off(e, "mousemove.select-cells touchmove.select-cells mouseup.select-cells touchend.select-cells");
                                        }), this.j.async.clearTimeout(tx);
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    key: "unselectCells",
                    value: function(e) {
                        var t = this.__tableModule, o = t.getAllSelectedCells();
                        o.length && o.forEach(function(o) {
                            e && e === o || t.removeSelection(o);
                        });
                    }
                },
                {
                    key: "onExecCommand",
                    value: function(e) {
                        var t = this;
                        if (/table(splitv|splitg|merge|empty|bin|binrow|bincolumn|addcolumn|addrow)/.test(e)) {
                            e = e.replace("table", "");
                            var o = this.__tableModule.getAllSelectedCells();
                            if (o.length) {
                                var n = function(e, t) {
                                    return function(e) {
                                        if (Array.isArray(e)) return e;
                                    }(e) || function(e, t) {
                                        var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                        if (null != o) {
                                            var n, r, i = [], a = !0, l = !1;
                                            try {
                                                for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                            } catch (e) {
                                                l = !0, r = e;
                                            } finally{
                                                try {
                                                    a || null == o.return || o.return();
                                                } finally{
                                                    if (l) throw r;
                                                }
                                            }
                                            return i;
                                        }
                                    }(e, t) || function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return US(e, t);
                                            var o = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? US(e, t) : void 0;
                                        }
                                    }(e, t) || function() {
                                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }(o, 1)[0];
                                if (!n) return;
                                var r = pi.closest(n, "table", this.j.editor);
                                if (!r) return;
                                switch(e){
                                    case "splitv":
                                        this.__tableModule.splitVertical(r);
                                        break;
                                    case "splitg":
                                        this.__tableModule.splitHorizontal(r);
                                        break;
                                    case "merge":
                                        this.__tableModule.mergeSelected(r);
                                        break;
                                    case "empty":
                                        o.forEach(function(e) {
                                            return pi.detach(e);
                                        });
                                        break;
                                    case "bin":
                                        pi.safeRemove(r);
                                        break;
                                    case "binrow":
                                        new Set(o.map(function(e) {
                                            return e.parentNode;
                                        })).forEach(function(e) {
                                            t.__tableModule.removeRow(r, e.rowIndex);
                                        });
                                        break;
                                    case "bincolumn":
                                        var i = new Set;
                                        o.reduce(function(e, t) {
                                            return i.has(t.cellIndex) || (e.push(t), i.add(t.cellIndex)), e;
                                        }, []).forEach(function(e) {
                                            t.__tableModule.removeColumn(r, e.cellIndex);
                                        });
                                        break;
                                    case "addcolumnafter":
                                    case "addcolumnbefore":
                                        this.__tableModule.appendColumn(r, n, "addcolumnafter" === e);
                                        break;
                                    case "addrowafter":
                                    case "addrowbefore":
                                        this.__tableModule.appendRow(r, n.parentNode, "addrowafter" === e);
                                }
                            }
                            return !1;
                        }
                    }
                },
                {
                    key: "onAfterCommand",
                    value: function(e) {
                        /^justify/.test(e) && this.__tableModule.getAllSelectedCells().forEach(function(t) {
                            return Nn(e, t);
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        this.__onRemoveSelection(), e.e.off(".select-cells");
                    }
                }
            ], n && KS(o.prototype, n), t;
        }(ZS(Wp));
        function nx(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        ox.requires = [
            "select"
        ], $S([
            To
        ], ox.prototype, "onStartSelection", null), $S([
            Ca(":outsideClick")
        ], ox.prototype, "onOutsideClick", null), $S([
            Ca(":change")
        ], ox.prototype, "onChange", null), $S([
            To
        ], ox.prototype, "__onRemoveSelection", null), $S([
            To
        ], ox.prototype, "__onStopSelection", null), $S([
            To
        ], ox.prototype, "onExecCommand", null), $S([
            To
        ], ox.prototype, "onAfterCommand", null), Ma.add("selectCells", ox), rr.prototype.beautifyHTML = !to, rr.prototype.sourceEditor = "ace", rr.prototype.sourceEditorNativeOptions = {
            showGutter: !0,
            theme: "ace/theme/idle_fingers",
            mode: "ace/mode/html",
            wrap: !0,
            highlightActiveLine: !0
        }, rr.prototype.sourceEditorCDNUrlsJS = [
            "https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.2/ace.js"
        ], rr.prototype.beautifyHTMLCDNUrlsJS = [
            "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify.min.js",
            "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify-html.min.js"
        ], Ol.set("source", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"/> </svg> '), rr.prototype.controls.source = {
            mode: eo,
            exec: function(e) {
                e.toggleMode();
            },
            isActive: function(e) {
                return e.getRealMode() === $t;
            },
            tooltip: "Change mode"
        };
        var rx = function() {
            function e(t, o, n, r) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.jodit = t, this.container = o, this.toWYSIWYG = n, this.fromWYSIWYG = r, this.className = "", this.isReady = !1;
            }
            var t, o;
            return t = e, o = [
                {
                    key: "j",
                    get: function() {
                        return this.jodit;
                    }
                },
                {
                    key: "onReady",
                    value: function() {
                        this.replaceUndoManager(), this.isReady = !0, this.j.e.fire(this, "ready");
                    }
                },
                {
                    key: "onReadyAlways",
                    value: function(e) {
                        var t;
                        this.isReady ? e() : null === (t = this.j.events) || void 0 === t || t.on(this, "ready", e);
                    }
                }
            ], nx(t.prototype, o), e;
        }();
        function ix(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function ax(e) {
            return ax = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ax(e);
        }
        function lx(e, t) {
            return lx = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, lx(e, t);
        }
        function sx() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (sx = function() {
                return !!e;
            })();
        }
        var cx = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = ax(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, sx() ? Reflect.construct(t, o || [], ax(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).className = "jodit_ace_editor", e.proxyOnBlur = function(t) {
                    e.j.e.fire("blur", t);
                }, e.proxyOnFocus = function(t) {
                    e.j.e.fire("focus", t);
                }, e.proxyOnMouseDown = function(t) {
                    e.j.e.fire("mousedown", t);
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && lx(e, t);
            }(t, e), o = t, n = [
                {
                    key: "aceExists",
                    value: function() {
                        return void 0 !== this.j.ow.ace;
                    }
                },
                {
                    key: "getLastColumnIndex",
                    value: function(e) {
                        return this.instance.session.getLine(e).length;
                    }
                },
                {
                    key: "getLastColumnIndices",
                    value: function() {
                        for(var e = this.instance.session.getLength(), t = [], o = 0, n = 0; n < e; n++)o += this.getLastColumnIndex(n), n > 0 && (o += 1), t[n] = o;
                        return t;
                    }
                },
                {
                    key: "getRowColumnIndices",
                    value: function(e) {
                        var t = this.getLastColumnIndices();
                        if (e <= t[0]) return {
                            row: 0,
                            column: e
                        };
                        for(var o = 1, n = 1; n < t.length; n++)e > t[n] && (o = n + 1);
                        return {
                            row: o,
                            column: e - t[o - 1] - 1
                        };
                    }
                },
                {
                    key: "setSelectionRangeIndices",
                    value: function(e, t) {
                        var o = this.getRowColumnIndices(e), n = this.getRowColumnIndices(t);
                        this.instance.getSelection().setSelectionRange({
                            start: o,
                            end: n
                        });
                    }
                },
                {
                    key: "getIndexByRowColumn",
                    value: function(e, t) {
                        return this.getLastColumnIndices()[e] - this.getLastColumnIndex(e) + t;
                    }
                },
                {
                    key: "init",
                    value: function(e) {
                        var t = this, o = function() {
                            if (void 0 === t.instance && t.aceExists()) {
                                var o = t.j.c.div("jodit-source__mirror-fake");
                                t.container.appendChild(o);
                                var n = e.ow.ace;
                                t.instance = n.edit(o), "rtl" === e.o.direction && (t.instance.setOption("rtlText", !0), t.instance.setOption("rtl", !0)), t.instance.setTheme(e.o.sourceEditorNativeOptions.theme), t.instance.renderer.setShowGutter(e.o.sourceEditorNativeOptions.showGutter), t.instance.getSession().setMode(e.o.sourceEditorNativeOptions.mode), t.instance.setHighlightActiveLine(e.o.sourceEditorNativeOptions.highlightActiveLine), t.instance.getSession().setUseWrapMode(!0), t.instance.setOption("indentedSoftWrap", !1), t.instance.setOption("wrap", e.o.sourceEditorNativeOptions.wrap), t.instance.getSession().setUseWorker(!1), t.instance.$blockScrolling = 1 / 0, t.instance.on("change", t.toWYSIWYG), t.instance.on("focus", t.proxyOnFocus), t.instance.on("mousedown", t.proxyOnMouseDown), t.instance.on("blur", t.proxyOnBlur), e.getRealMode() !== Qt && t.setValue(t.getValue());
                                var r = t.j.async.throttle(function() {
                                    if (!e.isInDestruct && e.getMode() !== Qt) {
                                        var o = t.instance.isFocused();
                                        "auto" !== e.o.height ? t.instance.setOption("maxLines", e.workplace.offsetHeight / t.instance.renderer.lineHeight) : t.instance.setOption("maxLines", 1 / 0), t.instance.resize(), o && t.focus();
                                    }
                                }, 2 * t.j.defaultTimeout);
                                e.e.on(e, "resize", r).on("afterResize afterSetMode", r), r(), t.onReady();
                            }
                        };
                        e.e.on("afterSetMode", function() {
                            e.getRealMode() !== $t && e.getMode() !== eo || (t.fromWYSIWYG(), o());
                        }), o(), this.aceExists() || Un(e, e.o.sourceEditorCDNUrlsJS).then(function() {
                            e.isInDestruct || o();
                        }).catch(function() {
                            return null;
                        });
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        var e, t;
                        this.instance.off("change", this.toWYSIWYG), this.instance.off("focus", this.proxyOnFocus), this.instance.off("mousedown", this.proxyOnMouseDown), this.instance.destroy(), null === (t = null === (e = this.j) || void 0 === e ? void 0 : e.events) || void 0 === t || t.off("aceInited.source");
                    }
                },
                {
                    key: "setValue",
                    value: function(e) {
                        if (!this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                            var t = this.j.e.fire("beautifyHTML", e);
                            Lo(t) && (e = t);
                        }
                        this.instance.setValue(e), this.instance.clearSelection();
                    }
                },
                {
                    key: "getValue",
                    value: function() {
                        return this.instance.getValue();
                    }
                },
                {
                    key: "setReadOnly",
                    value: function(e) {
                        this.instance.setReadOnly(e);
                    }
                },
                {
                    key: "isFocused",
                    get: function() {
                        return this.instance.isFocused();
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        this.instance.container.focus(), this.instance.focus();
                    }
                },
                {
                    key: "blur",
                    value: function() {
                        this.instance.blur();
                    }
                },
                {
                    key: "getSelectionStart",
                    value: function() {
                        var e = this.instance.selection.getRange();
                        return this.getIndexByRowColumn(e.start.row, e.start.column);
                    }
                },
                {
                    key: "getSelectionEnd",
                    value: function() {
                        var e = this.instance.selection.getRange();
                        return this.getIndexByRowColumn(e.end.row, e.end.column);
                    }
                },
                {
                    key: "selectAll",
                    value: function() {
                        this.instance.selection.selectAll();
                    }
                },
                {
                    key: "insertRaw",
                    value: function(e) {
                        var t = this.instance.selection.getCursor(), o = this.instance.session.insert(t, e);
                        this.instance.selection.setRange({
                            start: t,
                            end: o
                        }, !1);
                    }
                },
                {
                    key: "setSelectionRange",
                    value: function(e, t) {
                        this.setSelectionRangeIndices(e, t);
                    }
                },
                {
                    key: "setPlaceHolder",
                    value: function(e) {}
                },
                {
                    key: "replaceUndoManager",
                    value: function() {
                        var e = this.jodit.history;
                        this.instance.commands.addCommand({
                            name: "Undo",
                            bindKey: {
                                win: "Ctrl-Z",
                                mac: "Command-Z"
                            },
                            exec: function() {
                                e.undo();
                            }
                        }), this.instance.commands.addCommand({
                            name: "Redo",
                            bindKey: {
                                win: "Ctrl-Shift-Z",
                                mac: "Command-Shift-Z"
                            },
                            exec: function() {
                                e.redo();
                            }
                        });
                    }
                }
            ], ix(o.prototype, n), t;
        }(rx);
        function ux(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function dx(e) {
            return dx = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, dx(e);
        }
        function fx(e, t) {
            return fx = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, fx(e, t);
        }
        function px() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (px = function() {
                return !!e;
            })();
        }
        var hx = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = dx(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, px() ? Reflect.construct(t, o || [], dx(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).autosize = e.j.async.debounce(function() {
                    e.instance.style.height = "auto", e.instance.style.height = e.instance.scrollHeight + "px";
                }, e.j.defaultTimeout), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && fx(e, t);
            }(t, e), o = t, n = [
                {
                    key: "init",
                    value: function(e) {
                        var t = this;
                        this.instance = e.c.element("textarea", {
                            class: "jodit-source__mirror",
                            dir: "rtl" === e.o.direction ? "rtl" : void 0
                        }), this.container.appendChild(this.instance), e.e.on(this.instance, "mousedown keydown touchstart input", e.async.debounce(this.toWYSIWYG, e.defaultTimeout)).on("setMinHeight.source", function(e) {
                            Ln(t.instance, "minHeight", e);
                        }).on(this.instance, "change keydown mousedown touchstart input", this.autosize).on("afterSetMode.source", this.autosize).on(this.instance, "mousedown focus", function(t) {
                            e.e.fire(t.type, t);
                        }), this.autosize(), this.onReady();
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        pi.safeRemove(this.instance);
                    }
                },
                {
                    key: "getValue",
                    value: function() {
                        return this.instance.value;
                    }
                },
                {
                    key: "setValue",
                    value: function(e) {
                        this.instance.value = e;
                    }
                },
                {
                    key: "insertRaw",
                    value: function(e) {
                        var t = this.getValue();
                        if (this.getSelectionStart() >= 0) {
                            var o = this.getSelectionStart(), n = this.getSelectionEnd();
                            this.setValue(t.substring(0, o) + e + t.substring(n, t.length));
                        } else this.setValue(t + e);
                    }
                },
                {
                    key: "getSelectionStart",
                    value: function() {
                        return this.instance.selectionStart;
                    }
                },
                {
                    key: "getSelectionEnd",
                    value: function() {
                        return this.instance.selectionEnd;
                    }
                },
                {
                    key: "setSelectionRange",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                        this.instance.setSelectionRange(e, t);
                    }
                },
                {
                    key: "isFocused",
                    get: function() {
                        return this.instance === this.j.od.activeElement;
                    }
                },
                {
                    key: "focus",
                    value: function() {
                        this.instance.focus();
                    }
                },
                {
                    key: "blur",
                    value: function() {
                        this.instance.blur();
                    }
                },
                {
                    key: "setPlaceHolder",
                    value: function(e) {
                        this.instance.setAttribute("placeholder", e);
                    }
                },
                {
                    key: "setReadOnly",
                    value: function(e) {
                        e ? this.instance.setAttribute("readonly", "true") : this.instance.removeAttribute("readonly");
                    }
                },
                {
                    key: "selectAll",
                    value: function() {
                        this.instance.select();
                    }
                },
                {
                    key: "replaceUndoManager",
                    value: function() {
                        var e = this, t = this.jodit.history;
                        this.j.e.on(this.instance, "keydown", function(o) {
                            if ((o.ctrlKey || o.metaKey) && "z" === o.key) return o.shiftKey ? t.redo() : t.undo(), e.setSelectionRange(e.getValue().length), !1;
                        });
                    }
                }
            ], n && ux(o.prototype, n), t;
        }(rx);
        function vx(e, t, o, n, r) {
            var i;
            if (Ro(e)) i = e(t);
            else switch(e){
                case "ace":
                    if (!t.o.shadowRoot) {
                        i = new cx(t, o, n, r);
                        break;
                    }
                default:
                    i = new hx(t, o, n, r);
            }
            return i.init(t), i.onReadyAlways(function() {
                i.setReadOnly(t.o.readonly);
            }), i;
        }
        function gx(e, t, o) {
            return gx = wx() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && yx(r, o.prototype), r;
            }, gx.apply(null, arguments);
        }
        function mx(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function bx(e) {
            return bx = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, bx(e);
        }
        function yx(e, t) {
            return yx = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, yx(e, t);
        }
        function _x(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function jx(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return jx = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return gx(e, arguments, bx(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), yx(n, e);
            }, jx(e);
        }
        function wx() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (wx = function() {
                return !!e;
            })();
        }
        var kx = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : _x(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, Sx = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = bx(t), function(e, t) {
                        return !t || "object" !== _x(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, wx() ? Reflect.construct(t, o || [], bx(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        name: "source",
                        group: "source"
                    }
                ], e.__lock = !1, e.__oldMirrorValue = "", e.tempMarkerStart = "{start-jodit-selection}", e.tempMarkerStartReg = /{start-jodit-selection}/g, e.tempMarkerEnd = "{end-jodit-selection}", e.tempMarkerEndReg = /{end-jodit-selection}/g, e.getSelectionStart = function() {
                    var t, o;
                    return null !== (o = null === (t = e.sourceEditor) || void 0 === t ? void 0 : t.getSelectionStart()) && void 0 !== o ? o : 0;
                }, e.getSelectionEnd = function() {
                    var t, o;
                    return null !== (o = null === (t = e.sourceEditor) || void 0 === t ? void 0 : t.getSelectionEnd()) && void 0 !== o ? o : 0;
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && yx(e, t);
            }(t, e), o = t, n = [
                {
                    key: "onInsertHTML",
                    value: function(e) {
                        var t;
                        if (!this.j.o.readonly && !this.j.isEditorMode()) return null === (t = this.sourceEditor) || void 0 === t || t.insertRaw(e), this.toWYSIWYG(), !1;
                    }
                },
                {
                    key: "fromWYSIWYG",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        if (!this.__lock || !0 === e) {
                            this.__lock = !0;
                            var t = this.j.getEditorValue(!1, So);
                            t !== this.getMirrorValue() && this.setMirrorValue(t), this.__lock = !1;
                        }
                    }
                },
                {
                    key: "toWYSIWYG",
                    value: function() {
                        if (!this.__lock) {
                            var e = this.getMirrorValue();
                            e !== this.__oldMirrorValue && (this.__lock = !0, this.j.value = e, this.__lock = !1, this.__oldMirrorValue = e);
                        }
                    }
                },
                {
                    key: "getNormalPosition",
                    value: function(e, t) {
                        for(t = t.replace(/<(script|style|iframe)[^>]*>[^]*?<\/\1>/im, function(e) {
                            for(var t = "", o = 0; o < e.length; o += 1)t += bt;
                            return t;
                        }); e > 0 && t[e] === bt;)e--;
                        for(var o = e; o > 0;){
                            if ("<" === t[--o] && void 0 !== t[o + 1] && t[o + 1].match(/[\w/]+/i)) return o;
                            if (">" === t[o]) return e;
                        }
                        return e;
                    }
                },
                {
                    key: "clnInv",
                    value: function(e) {
                        return e.replace(_t(), "");
                    }
                },
                {
                    key: "onSelectAll",
                    value: function(e) {
                        var t;
                        if ("selectall" === e.toLowerCase() && this.j.getRealMode() === $t) return null === (t = this.sourceEditor) || void 0 === t || t.selectAll(), !1;
                    }
                },
                {
                    key: "getMirrorValue",
                    value: function() {
                        var e;
                        return (null === (e = this.sourceEditor) || void 0 === e ? void 0 : e.getValue()) || "";
                    }
                },
                {
                    key: "setMirrorValue",
                    value: function(e) {
                        var t;
                        null === (t = this.sourceEditor) || void 0 === t || t.setValue(e);
                    }
                },
                {
                    key: "setFocusToMirror",
                    value: function() {
                        var e;
                        null === (e = this.sourceEditor) || void 0 === e || e.focus();
                    }
                },
                {
                    key: "saveSelection",
                    value: function() {
                        if (this.j.getRealMode() === Qt) this.j.s.save(), this.j.synchronizeValues(), this.fromWYSIWYG(!0);
                        else {
                            if (this.j.o.editHTMLDocumentMode) return;
                            var e = this.getMirrorValue();
                            if (this.getSelectionStart() === this.getSelectionEnd()) {
                                var t = this.j.s.marker(!0), o = this.getNormalPosition(this.getSelectionStart(), this.getMirrorValue());
                                this.setMirrorValue(e.substring(0, o) + this.clnInv(t.outerHTML) + e.substring(o));
                            } else {
                                var n = this.j.s.marker(!0), r = this.j.s.marker(!1), i = this.getNormalPosition(this.getSelectionStart(), e), a = this.getNormalPosition(this.getSelectionEnd(), e);
                                this.setMirrorValue(e.slice(0, i) + this.clnInv(n.outerHTML) + e.slice(i, a) + this.clnInv(r.outerHTML) + e.slice(a));
                            }
                            this.toWYSIWYG();
                        }
                    }
                },
                {
                    key: "removeSelection",
                    value: function() {
                        if (this.j.getRealMode() === Qt) return this.__lock = !0, this.j.s.restore(), void (this.__lock = !1);
                        var e = this.getMirrorValue(), t = 0, o = 0;
                        try {
                            if (e = e.replace(/<span[^>]+data-jodit-selection_marker=(["'])start\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerStart).replace(/<span[^>]+data-jodit-selection_marker=(["'])end\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerEnd), !this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                                var n = this.j.e.fire("beautifyHTML", e);
                                Lo(n) && (e = n);
                            }
                            if (o = t = e.indexOf(this.tempMarkerStart), e = e.replace(this.tempMarkerStartReg, ""), -1 !== t) {
                                var r = e.indexOf(this.tempMarkerEnd);
                                -1 !== r && (o = r);
                            }
                            e = e.replace(this.tempMarkerEndReg, "");
                        } finally{
                            e = e.replace(this.tempMarkerEndReg, "").replace(this.tempMarkerStartReg, "");
                        }
                        this.setMirrorValue(e), this.setMirrorSelectionRange(t, o), this.toWYSIWYG(), this.setFocusToMirror();
                    }
                },
                {
                    key: "setMirrorSelectionRange",
                    value: function(e, t) {
                        var o;
                        null === (o = this.sourceEditor) || void 0 === o || o.setSelectionRange(e, t);
                    }
                },
                {
                    key: "onReadonlyReact",
                    value: function() {
                        var e;
                        null === (e = this.sourceEditor) || void 0 === e || e.setReadOnly(this.j.o.readonly);
                    }
                },
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        if (this.mirrorContainer = e.c.div("jodit-source"), e.workplace.appendChild(this.mirrorContainer), e.e.on("afterAddPlace changePlace afterInit", function() {
                            e.workplace.appendChild(t.mirrorContainer);
                        }), this.sourceEditor = vx("area", e, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG), e.e.on(e.ow, "keydown", function(e) {
                            var o;
                            e.key === Dt && (null === (o = t.sourceEditor) || void 0 === o ? void 0 : o.isFocused) && t.sourceEditor.blur();
                        }), this.onReadonlyReact(), e.e.on("placeholder.source", function(e) {
                            var o;
                            null === (o = t.sourceEditor) || void 0 === o || o.setPlaceHolder(e);
                        }).on("change.source", this.syncValueFromWYSIWYG).on("beautifyHTML", function(e) {
                            return e;
                        }), e.o.beautifyHTML) {
                            var o = function() {
                                var t;
                                if (e.isInDestruct) return !1;
                                var o = e.ow.html_beautify;
                                return !(!o || e.isInDestruct || (null === (t = e.events) || void 0 === t || t.off("beautifyHTML").on("beautifyHTML", function(e) {
                                    return o(e);
                                }), 0));
                            };
                            o() || Un(e, e.o.beautifyHTMLCDNUrlsJS).then(o, function() {
                                return null;
                            });
                        }
                        this.syncValueFromWYSIWYG(!0), this.initSourceEditor(e);
                    }
                },
                {
                    key: "syncValueFromWYSIWYG",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = this.j;
                        t.getMode() !== eo && t.getMode() !== $t || this.fromWYSIWYG(e);
                    }
                },
                {
                    key: "initSourceEditor",
                    value: function(e) {
                        var t, o = this;
                        if ("area" !== e.o.sourceEditor) {
                            var n = vx(e.o.sourceEditor, e, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG);
                            n.onReadyAlways(function() {
                                var t, r;
                                null === (t = o.sourceEditor) || void 0 === t || t.destruct(), o.sourceEditor = n, o.syncValueFromWYSIWYG(!0), null === (r = e.events) || void 0 === r || r.fire("sourceEditorReady", e);
                            });
                        } else null === (t = this.sourceEditor) || void 0 === t || t.onReadyAlways(function() {
                            var t;
                            o.syncValueFromWYSIWYG(!0), null === (t = e.events) || void 0 === t || t.fire("sourceEditorReady", e);
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.sourceEditor && (this.sourceEditor.destruct(), delete this.sourceEditor), pi.safeRemove(this.mirrorContainer);
                    }
                }
            ], n && mx(o.prototype, n), t;
        }(jx(Wp));
        kx([
            Ca(":insertHTML.source")
        ], Sx.prototype, "onInsertHTML", null), kx([
            To
        ], Sx.prototype, "fromWYSIWYG", null), kx([
            To
        ], Sx.prototype, "toWYSIWYG", null), kx([
            To
        ], Sx.prototype, "getNormalPosition", null), kx([
            Ca(":beforeCommand.source")
        ], Sx.prototype, "onSelectAll", null), kx([
            Ca(":beforeSetMode.source")
        ], Sx.prototype, "saveSelection", null), kx([
            Ca(":afterSetMode.source")
        ], Sx.prototype, "removeSelection", null), kx([
            To
        ], Sx.prototype, "setMirrorSelectionRange", null), kx([
            Ca(":readonly.source")
        ], Sx.prototype, "onReadonlyReact", null), kx([
            To
        ], Sx.prototype, "syncValueFromWYSIWYG", null), Ma.add("source", Sx);
        const xx = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89 32h4.18L18.86 6h-3.71L4.93 32h4.18l2.25-6h11.29l2.24 6zM12.86 22L17 10.95 21.14 22h-8.28zm30.31 1.17L27 39.34 19.66 32l-2.83 2.83L27 45l19-19-2.83-2.83z"/> </svg> ';
        rr.prototype.spellcheck = !1, Ol.set("spellcheck", xx), rr.prototype.controls.spellcheck = {
            isActive: function(e) {
                return e.o.spellcheck;
            },
            icon: xx,
            name: "spellcheck",
            command: "toggleSpellcheck",
            tooltip: "Spellcheck"
        };
        const Ox = {
            Spellcheck: "\u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u0625\u0645\u0644\u0627\u0626\u064A"
        }, Cx = {
            Spellcheck: "Kontrola pravopisu"
        }, zx = {
            Spellcheck: "Rechtschreibpr\xfcfung"
        }, Ex = {
            Spellcheck: "Correcci\xf3n ortogr\xe1fica"
        }, Tx = {
            Spellcheck: "\u063A\u0644\u0637\u06CC\u0627\u0628\u06CC \u0627\u0645\u0644\u0627\u06CC\u06CC"
        }, Ix = {
            Spellcheck: "Oikeinkirjoituksen tarkistus"
        }, Px = {
            Spellcheck: "V\xe9rification Orthographique"
        }, Rx = {
            Spellcheck: "\u05D1\u05D3\u05D9\u05E7\u05EA \u05D0\u05D9\u05D5\u05EA"
        }, Ax = {
            Spellcheck: "Helyes\xedr\xe1s-ellen\u0151rz\xe9s"
        }, Lx = {
            Spellcheck: "Spellchecking"
        }, Mx = {
            Spellcheck: "Controllo ortografico"
        }, Bx = {
            Spellcheck: "\u30B9\u30DA\u30EB\u30C1\u30A7\u30C3\u30AF"
        }, Dx = {
            Spellcheck: "\uB9DE\uCDA4\uBC95 \uAC80\uC0AC"
        }, Nx = {
            Spellcheck: "\u0414\u04AF\u0440\u043C\u0438\u0439\u043D \u0430\u043B\u0434\u0430\u0430 \u0448\u0430\u043B\u0433\u0430\u0445"
        }, Hx = {
            Spellcheck: "Spellingcontrole"
        }, Fx = {
            Spellcheck: "Stavekontroll"
        }, qx = {
            Spellcheck: "Sprawdzanie pisowni"
        }, Vx = {
            Spellcheck: "Verifica\xe7\xe3o ortogr\xe1fica"
        }, Wx = {
            Spellcheck: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043E\u0440\u0444\u043E\u0433\u0440\u0430\u0444\u0438\u0438"
        }, Ux = {
            Spellcheck: "Yaz\u0131m denetimi"
        }, Yx = {
            Spellcheck: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u043E\u0440\u0444\u043E\u0433\u0440\u0430\u0444\u0456\u0457"
        }, Kx = {
            Spellcheck: "\u62FC\u5199\u68C0\u67E5"
        }, Gx = {
            Spellcheck: "\u62FC\u5B57\u6AA2\u67E5"
        };
        function Jx(e, t, o) {
            return Jx = tO() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && Qx(r, o.prototype), r;
            }, Jx.apply(null, arguments);
        }
        function Xx(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function Zx(e) {
            return Zx = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Zx(e);
        }
        function Qx(e, t) {
            return Qx = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, Qx(e, t);
        }
        function $x(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function eO(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return eO = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return Jx(e, arguments, Zx(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Qx(n, e);
            }, eO(e);
        }
        function tO() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (tO = function() {
                return !!e;
            })();
        }
        var oO = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = Zx(t), function(e, t) {
                        return !t || "object" !== $x(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, tO() ? Reflect.construct(t, o || [], Zx(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).buttons = [
                    {
                        group: "state",
                        name: "spellcheck"
                    }
                ], Da(le), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Qx(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.e.on("afterInit afterAddPlace prepareWYSIWYGEditor", this.toggleSpellcheck), this.toggleSpellcheck(), e.registerCommand("toggleSpellcheck", function() {
                            t.jodit.o.spellcheck = !t.jodit.o.spellcheck, t.toggleSpellcheck(), t.j.e.fire("updateToolbar");
                        });
                    }
                },
                {
                    key: "toggleSpellcheck",
                    value: function() {
                        er(this.jodit.editor, "spellcheck", this.jodit.o.spellcheck);
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {}
                }
            ], Xx(o.prototype, n), t;
        }(eO(Wp));
        function nO(e, t, o) {
            return nO = cO() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && aO(r, o.prototype), r;
            }, nO.apply(null, arguments);
        }
        function rO(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function iO(e) {
            return iO = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, iO(e);
        }
        function aO(e, t) {
            return aO = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, aO(e, t);
        }
        function lO(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function sO(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return sO = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return nO(e, arguments, iO(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), aO(n, e);
            }, sO(e);
        }
        function cO() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (cO = function() {
                return !!e;
            })();
        }
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : $x(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            To
        ], oO.prototype, "toggleSpellcheck", null), Ma.add("spellcheck", oO), rr.prototype.toolbarSticky = !0, rr.prototype.toolbarDisableStickyForMobile = !0, rr.prototype.toolbarStickyOffset = 0;
        var uO = !dt && to, dO = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = iO(t), function(e, t) {
                        return !t || "object" !== lO(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, cO() ? Reflect.construct(t, o || [], iO(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).__isToolbarStuck = !1, e.__createDummy = function(t) {
                    e.__dummyBox = e.j.c.div(), e.__dummyBox.classList.add("jodit_sticky-dummy_toolbar"), e.j.container.insertBefore(e.__dummyBox, t);
                }, e.addSticky = function(t) {
                    e.__isToolbarStuck || (uO && !e.__dummyBox && e.__createDummy(t), e.j.container.classList.add("jodit_sticky"), e.__isToolbarStuck = !0), Ln(t, {
                        top: e.j.o.toolbarStickyOffset || null,
                        width: e.j.container.offsetWidth - 2
                    }), e.__dummyBox && Ln(e.__dummyBox, {
                        height: t.offsetHeight
                    });
                }, e.removeSticky = function(t) {
                    e.__isToolbarStuck && (Ln(t, {
                        width: "",
                        top: ""
                    }), e.j.container.classList.remove("jodit_sticky"), e.__isToolbarStuck = !1);
                }, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && aO(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.e.on(e.ow, "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky", this.__onScroll).on("getStickyState.sticky", function() {
                            return t.__isToolbarStuck;
                        });
                    }
                },
                {
                    key: "__onScroll",
                    value: function() {
                        var e = this.jodit;
                        if (e.o.toolbarSticky && e.o.toolbar) {
                            var t = e.ow.pageYOffset || e.od.documentElement && e.od.documentElement.scrollTop || 0, o = ta(e.container, e, e.od, !0), n = e.getMode() === Qt && t + e.o.toolbarStickyOffset > o.top && t + e.o.toolbarStickyOffset < o.top + o.height && !(e.o.toolbarDisableStickyForMobile && this.__isMobile());
                            if (this.__isToolbarStuck !== n) {
                                var r = e.toolbarContainer;
                                r && (n ? this.addSticky(r) : this.removeSticky(r)), e.e.fire("toggleSticky", n);
                            }
                        }
                    }
                },
                {
                    key: "__isMobile",
                    value: function() {
                        var e = this.j;
                        return e && e.options && e.container && e.options.sizeSM >= e.container.offsetWidth;
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        pi.safeRemove(this.__dummyBox), e.e.off(e.ow, "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky", this.__onScroll).off(".sticky");
                    }
                }
            ], rO(o.prototype, n), t;
        }(sO(Wp));
        (function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : lO(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            i > 3 && a && Object.defineProperty(t, o, a);
        })([
            el()
        ], dO.prototype, "__onScroll", null), Ma.add("sticky", dO), rr.prototype.usePopupForSpecialCharacters = !1, rr.prototype.specialCharacters = [
            "!",
            "&quot;",
            "#",
            "$",
            "%",
            "&amp;",
            "'",
            "(",
            ")",
            "*",
            "+",
            "-",
            ".",
            "/",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            ":",
            ";",
            "&lt;",
            "=",
            "&gt;",
            "?",
            "@",
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "[",
            "]",
            "^",
            "_",
            "`",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "{",
            "|",
            "}",
            "~",
            "&euro;",
            "&lsquo;",
            "&rsquo;",
            "&ldquo;",
            "&rdquo;",
            "&ndash;",
            "&mdash;",
            "&iexcl;",
            "&cent;",
            "&pound;",
            "&curren;",
            "&yen;",
            "&brvbar;",
            "&sect;",
            "&uml;",
            "&copy;",
            "&ordf;",
            "&laquo;",
            "&raquo;",
            "&not;",
            "&reg;",
            "&macr;",
            "&deg;",
            "&sup2;",
            "&sup3;",
            "&acute;",
            "&micro;",
            "&para;",
            "&middot;",
            "&cedil;",
            "&sup1;",
            "&ordm;",
            "&frac14;",
            "&frac12;",
            "&frac34;",
            "&iquest;",
            "&Agrave;",
            "&Aacute;",
            "&Acirc;",
            "&Atilde;",
            "&Auml;",
            "&Aring;",
            "&AElig;",
            "&Ccedil;",
            "&Egrave;",
            "&Eacute;",
            "&Ecirc;",
            "&Euml;",
            "&Igrave;",
            "&Iacute;",
            "&Icirc;",
            "&Iuml;",
            "&ETH;",
            "&Ntilde;",
            "&Ograve;",
            "&Oacute;",
            "&Ocirc;",
            "&Otilde;",
            "&Ouml;",
            "&times;",
            "&Oslash;",
            "&Ugrave;",
            "&Uacute;",
            "&Ucirc;",
            "&Uuml;",
            "&Yacute;",
            "&THORN;",
            "&szlig;",
            "&agrave;",
            "&aacute;",
            "&acirc;",
            "&atilde;",
            "&auml;",
            "&aring;",
            "&aelig;",
            "&ccedil;",
            "&egrave;",
            "&eacute;",
            "&ecirc;",
            "&euml;",
            "&igrave;",
            "&iacute;",
            "&icirc;",
            "&iuml;",
            "&eth;",
            "&ntilde;",
            "&ograve;",
            "&oacute;",
            "&ocirc;",
            "&otilde;",
            "&ouml;",
            "&divide;",
            "&oslash;",
            "&ugrave;",
            "&uacute;",
            "&ucirc;",
            "&uuml;",
            "&yacute;",
            "&thorn;",
            "&yuml;",
            "&OElig;",
            "&oelig;",
            "&#372;",
            "&#374",
            "&#373",
            "&#375;",
            "&sbquo;",
            "&#8219;",
            "&bdquo;",
            "&hellip;",
            "&trade;",
            "&#9658;",
            "&bull;",
            "&rarr;",
            "&rArr;",
            "&hArr;",
            "&diams;",
            "&asymp;"
        ], Ol.set("symbols", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 270 270"> <path d="m240.443652,220.45085l-47.410809,0l0,-10.342138c13.89973,-8.43655 25.752896,-19.844464 34.686646,-33.469923c11.445525,-17.455846 17.496072,-37.709239 17.496072,-58.570077c0,-59.589197 -49.208516,-108.068714 -109.693558,-108.068714s-109.69263,48.479517 -109.69263,108.069628c0,20.860839 6.050547,41.113316 17.497001,58.570077c8.93375,13.625459 20.787845,25.032458 34.686646,33.469008l0,10.342138l-47.412666,0c-10.256959,0 -18.571354,8.191376 -18.571354,18.296574c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.98402,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574l0,-39.496814c0,-7.073455 -4.137698,-13.51202 -10.626529,-16.537358c-25.24497,-11.772016 -41.557118,-37.145704 -41.557118,-64.643625c0,-39.411735 32.545369,-71.476481 72.549922,-71.476481c40.004553,0 72.550851,32.064746 72.550851,71.476481c0,27.497006 -16.312149,52.87161 -41.557118,64.643625c-6.487902,3.026253 -10.6256,9.464818 -10.6256,16.537358l0,39.496814c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.982163,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574c0,-10.105198 -8.314395,-18.296574 -18.571354,-18.296574z"/> </svg> '), rr.prototype.controls.symbols = {
            hotkeys: [
                "ctrl+shift+i",
                "cmd+shift+i"
            ],
            tooltip: "Insert Special Character",
            popup: function(e, t, o) {
                var n = e.e.fire("generateSpecialCharactersTable.symbols");
                if (n) {
                    if (e.o.usePopupForSpecialCharacters) {
                        var r = e.c.div();
                        return r.classList.add("jodit-symbols"), r.appendChild(n), e.e.on(n, "close_dialog", o), r;
                    }
                    e.alert(n, "Select Special Character", void 0, "jodit-symbols").bindDestruct(e);
                    var i = n.querySelector("a");
                    i && i.focus();
                }
            }
        };
        const fO = {
            symbols: "\u0631\u0645\u0632"
        }, pO = {
            symbols: "symbol"
        }, hO = {
            symbols: "Symbol"
        }, vO = {
            symbols: "S\xedmbolo"
        }, gO = {
            symbols: "\u0633\u0645\u0628\u0644"
        }, mO = {
            symbols: "Symbolit"
        }, bO = {
            symbols: "caract\xe8re"
        }, yO = {
            symbols: "\u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3"
        }, _O = {
            symbols: "Szimb\xf3lum"
        }, jO = {
            symbols: "simbol"
        }, wO = {
            symbols: "Simbolo"
        }, kO = {
            symbols: "symbol"
        }, SO = {
            symbols: "\uAE30\uD638"
        }, xO = {
            symbols: "\u0442\u044D\u043C\u0434\u044D\u0433\u0442"
        }, OO = {
            symbols: "symbool"
        }, CO = {
            symbols: "symbol"
        }, zO = {
            symbols: "S\xedmbolo"
        }, EO = {
            symbols: "\u0441\u0438\u043C\u0432\u043E\u043B"
        }, TO = {
            symbols: "Sembol"
        }, IO = {
            symbols: "\u0441\u0438\u043C\u0432\u043E\u043B"
        }, PO = {
            symbols: "\u7B26\u53F7"
        }, RO = {
            symbols: "\u7B26\u865F"
        };
        function AO(e, t, o) {
            return AO = NO() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && BO(r, o.prototype), r;
            }, AO.apply(null, arguments);
        }
        function LO(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function MO(e) {
            return MO = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, MO(e);
        }
        function BO(e, t) {
            return BO = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, BO(e, t);
        }
        function DO(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return DO = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return AO(e, arguments, MO(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), BO(n, e);
            }, DO(e);
        }
        function NO() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (NO = function() {
                return !!e;
            })();
        }
        var HO = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = MO(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, NO() ? Reflect.construct(t, o || [], MO(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).buttons = [
                    {
                        name: "symbols",
                        group: "insert"
                    }
                ], o.__countInRow = 17, Da(Te), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && BO(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this;
                        e.e.on("generateSpecialCharactersTable.symbols", function() {
                            for(var o = e.c.fromHTML('<div class="jodit-symbols__container">\n\t\t\t\t\t\t<div class="jodit-symbols__container_table">\n\t\t\t\t\t\t\t<table class="jodit-symbols__table"><tbody></tbody></table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jodit-symbols__container_preview">\n\t\t\t\t\t\t\t<div class="jodit-symbols__preview"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>'), n = o.querySelector(".jodit-symbols__preview"), r = o.querySelector("table").tBodies[0], i = [], a = 0; a < e.o.specialCharacters.length;){
                                for(var l = e.c.element("tr"), s = 0; s < t.__countInRow && a < e.o.specialCharacters.length; s += 1, a += 1){
                                    var c = e.c.element("td"), u = e.c.fromHTML('<a\n\t\t\t\t\t\t\t\t\tdata-index="'.concat(a, '"\n\t\t\t\t\t\t\t\t\tdata-index-j="').concat(s, '"\n\t\t\t\t\t\t\t\t\trole="option"\n\t\t\t\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\t\t>').concat(e.o.specialCharacters[a], "</a>"));
                                    i.push(u), c.appendChild(u), l.appendChild(c);
                                }
                                r.appendChild(l);
                            }
                            var d = t;
                            return e.e.on(i, "focus", function() {
                                n.innerHTML = this.innerHTML;
                            }).on(i, "mousedown", function(t) {
                                pi.isTag(this, "a") && (e.s.focus(), e.s.insertHTML(this.innerHTML), (null == t ? void 0 : t.shiftKey) || e.e.fire(this, "close_dialog"), t && t.preventDefault(), t && t.stopImmediatePropagation());
                            }).on(i, "mouseenter", function() {
                                pi.isTag(this, "a") && this.focus();
                            }).on(i, "keydown", function(t) {
                                var o = t.target;
                                if (pi.isTag(o, "a")) {
                                    var n, r = parseInt(er(o, "-index") || "0", 10), a = parseInt(er(o, "data-index-j") || "0", 10);
                                    switch(t.key){
                                        case Ft:
                                        case Vt:
                                            n = t.key === Ft ? r - d.__countInRow : r + d.__countInRow, void 0 === i[n] && (n = t.key === Ft ? Math.floor(i.length / d.__countInRow) * d.__countInRow + a : a) > i.length - 1 && (n -= d.__countInRow), i[n] && i[n].focus();
                                            break;
                                        case qt:
                                        case Ht:
                                            n = t.key === Ht ? r - 1 : r + 1, void 0 === i[n] && (n = t.key === Ht ? i.length - 1 : 0), i[n] && i[n].focus();
                                            break;
                                        case Bt:
                                            e.e.fire(o, "mousedown"), t.stopImmediatePropagation(), t.preventDefault();
                                    }
                                }
                            }), o;
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        e.e.off("generateSpecialCharactersTable.symbols");
                    }
                }
            ], n && LO(o.prototype, n), t;
        }(DO(Wp));
        function FO(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function qO(e) {
            return qO = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, qO(e);
        }
        function VO(e, t) {
            return VO = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, VO(e, t);
        }
        function WO(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function UO() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (UO = function() {
                return !!e;
            })();
        }
        Ma.add("symbols", HO), rr.prototype.aiAssistant = {
            aiCommonPrefixPrompt: "",
            aiCommonSuffixPrompt: "",
            aiImproveWritingPrompt: "It needs to be refined for better clarity, coherence, and overall quality. Please enhance the writing style while keeping the original meaning and language intact.",
            aiMakeShorterPrompt: "Please condense this content to make it more concise, while preserving the key messages, language and information.",
            aiMakeLongerPrompt: "Expand on this content to provide more detail, depth, and richness, without diverging from the original message and language.",
            aiSimplifyLanguagePrompt: "The language used here needs to be simplified for easier understanding, without altering the core information and the original language.",
            aiSummarizePrompt: "Provide a brief summary of this content, capturing the essential points in a concise manner. Preserve the original language and meaning.",
            aiContinuePrompt: "Continue the narrative or discussion from this content seamlessly, maintaining the same language, tone and style.",
            aiChangeToneProfessionalPrompt: "Adjust the tone to be professional, suitable for a formal business or academic setting, while retaining the original message and language.",
            aiChangeToneFriendlyPrompt: "It needs to be rewritten in a friendly tone while maintaining the original message and language. Please modify this content to be warm, approachable, and engaging.",
            aiChangeToneFormalPrompt: "Transform this content to have a formal tone, appropriate for official or serious contexts, without changing the main points and language.",
            aiChangeToneCasualPrompt: "Revise this content to have a casual, relaxed tone, making it feel more personal and less formal, without changing the original meaning and language.",
            aiChangeToneDirectPrompt: "Make the tone more direct, with straightforward language and a clear, assertive approach, without changing the original meaning and language.",
            aiChangeToneConfidentPrompt: "Infuse this content with a confident tone, showcasing assurance and decisiveness, without changing the original meaning and language.",
            aiChangeStyleBusinessPrompt: "Rewrite this content with a business-oriented style, focusing on clarity, efficiency, and professionalism, without changing the original meaning and language.",
            aiChangeStyleLegalPrompt: "Adapt this content to a legal style, incorporating appropriate terminology and formality typical of legal documents, without changing the original meaning and language.",
            aiChangeStyleJournalismPrompt: "Convert this content into a journalistic style, emphasizing factual accuracy, objectivity, and informative reporting, without changing the original meaning and language.",
            aiChangeStylePoeticPrompt: "Recreate this content with a poetic style, using expressive language, rhythm, and imagery to convey the message, without changing the original meaning and language.",
            aiTranslateToSpanishPrompt: "Translate this content into Spanish, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToFrenchPrompt: "Translate this content into French, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToGermanPrompt: "Translate this content into German, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToItalianPrompt: "Translate this content into Italian, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToPortuguesePrompt: "Translate this content into Portuguese, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToEnglishPrompt: "Translate this content into English, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToChinesePrompt: "Translate this content into Chinese, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToJapanesePrompt: "Translate this content into Japanese, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToKoreanPrompt: "Translate this content into Korean, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToRussianPrompt: "Translate this content into Russian, ensuring the translation is accurate and maintains the original meaning.",
            aiTranslateToArabicPrompt: "Translate this content into Arabic, ensuring the translation is accurate and maintains the original meaning."
        }, Ol.set("ai-assistant", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <g transform="scale(1.2 1.2) translate(-2 -0.5)"> <path d="M 22,12.5 A 1.49995,1.49995 0 0 0 20.50006,11 H 20 V 10 A 3,3 0 0 0 17,7 H 13 V 5.7226 a 2,2 0 1 0 -2,0 V 7 H 7 a 3,3 0 0 0 -3,3 v 1 H 3.49994 a 1.5,1.5 0 0 0 0,3 H 4 v 1 A 3.00128,3.00128 0 0 0 6.20251,17.89282 1.03113,1.03113 0 0 1 7,18.86975 v 0.716 a 0.99928,0.99928 0 0 0 1.00726,1.002 0.9792,0.9792 0 0 0 0.69983,-0.29486 l 2,-2 A 1,1 0 0 1 11.41425,18 H 17 a 3,3 0 0 0 3,-3 v -1 h 0.50006 A 1.49995,1.49995 0 0 0 22,12.5 Z M 19,15 a 2.00226,2.00226 0 0 1 -2,2 H 11.41425 A 1.987,1.987 0 0 0 10,17.58575 l -2,2 v -0.716 A 2.02082,2.02082 0 0 0 6.46771,16.92865 2.00439,2.00439 0 0 1 5,15 V 10 A 2.00226,2.00226 0 0 1 7,8 h 10 a 2.00222,2.00222 0 0 1 2,2 z M 10,12.5 A 1.5,1.5 0 1 1 8.5,11 1.5,1.5 0 0 1 10,12.5 Z m 7,0 A 1.5,1.5 0 1 1 15.5,11 1.5,1.5 0 0 1 17,12.5 Z"/> </g> </svg> '), Ol.set("ai-commands", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 270 270"> <path d="M 255.9537,58.150081 237.69527,40.997278 c -1.49414,-1.375593 -3.43653,-2.077427 -5.37891,-2.077427 -1.94239,0 -3.88478,0.701834 -5.37892,2.077427 L 29.919751,226.1128 c -2.988286,2.77926 -2.988286,7.32714 0,10.13447 L 48.148295,253.372 c 1.46426,1.37559 3.406646,2.1055 5.378915,2.1055 1.972268,0 3.884771,-0.72991 5.378914,-2.1055 L 221.34935,100.73732 255.9537,68.284552 c 2.9584,-2.807333 2.9584,-7.355212 0,-10.134471 z M 251.17244,63.79282 221.34935,91.781927 201.89561,73.506191 231.68882,45.48901 c 0.20918,-0.140367 0.38847,-0.224587 0.62754,-0.224587 0.23906,0 0.44824,0.08422 0.59765,0.224587 l 18.25843,17.152803 c 0,0 0.23906,0.33688 0.23906,0.561467 0,0.224586 -0.0896,0.4211 -0.23906,0.58954 z" style="stroke-width:2.8964;stroke-opacity:1" /> <path d="m 48.626421,116.87948 10.578532,23.10435 c 0.83672,1.82477 3.615826,1.85284 4.452546,0 l 10.937126,-23.52545 c 2.629692,-5.69888 7.470715,-10.24676 13.536935,-12.71722 l 25.07172,-10.274833 c 1.94239,-0.786053 1.94239,-3.396873 0,-4.182926 L 88.13156,79.008563 C 82.06534,76.53811 77.224317,71.990231 74.594625,66.291346 L 63.657499,42.737824 c -0.83672,-1.824766 -3.615826,-1.824766 -4.452546,0 L 48.267826,66.291346 C 45.638135,71.990231 40.797112,76.53811 34.730891,79.008563 L 9.6292894,89.311474 c -1.9423859,0.786054 -1.9423859,3.3688 0,4.182926 l 25.5498446,10.61172 c 6.036338,2.49852 10.847478,7.07448 13.477169,12.77336 z" style="stroke-width:2.8964;fill-opacity:1;stroke-opacity:1" /> <path d="m 111.79878,33.136746 13.56682,5.642739 c 3.19747,1.319446 5.76739,3.761826 7.14201,6.793745 l 5.61797,12.268044 c 0.44825,0.982567 1.91251,0.982567 2.36075,0 l 5.79727,-12.492631 c 1.4045,-3.031919 3.97442,-5.446225 7.20177,-6.765672 l 13.29788,-5.446225 c 1.0459,-0.4211 1.0459,-1.796693 0,-2.217793 l -13.29788,-5.446225 c -3.22735,-1.319447 -5.79727,-3.733753 -7.20177,-6.765672 L 140.48633,6.2144248 c -0.44824,-0.9825664 -1.9125,-0.9825664 -2.36075,0 l -5.79727,12.4926312 c -1.4045,3.031919 -3.97442,5.446225 -7.20177,6.765672 l -13.32776,5.474298 c -1.01601,0.4211 -1.0459,1.796693 0,2.217793 z" style="stroke-width:2.8964;fill-opacity:1" /> <path d="m 233.09331,192.98627 -14.13459,-5.7831 c -3.40665,-1.40367 -6.12599,-3.95834 -7.62013,-7.1587 l -6.15587,-13.27868 c -0.47813,-1.03872 -2.03203,-1.03872 -2.51016,0 l -6.15587,13.27868 c -1.49414,3.20036 -4.21348,5.75503 -7.62013,7.1587 l -14.13459,5.81118 c -1.10567,0.44917 -1.10567,1.90898 0,2.35816 l 14.40354,5.97961 c 3.40664,1.40367 6.12598,3.98642 7.59024,7.21485 l 5.97658,13.02602 c 0.47812,1.03872 2.03203,1.03872 2.51016,0 l 6.15586,-13.25061 c 1.49415,-3.20036 4.21349,-5.75503 7.62013,-7.1587 l 14.1346,-5.7831 c 1.10566,-0.44917 1.10566,-1.90899 0,-2.35816 z" style="stroke-width:2.8964;stroke-opacity:1" /> </svg> '), rr.prototype.controls["ai-commands"] = {
            isDisabled: function(e) {
                return !e.o.aiAssistant.aiAssistantCallback;
            },
            tooltip: "AI Commands",
            list: {
                aiImproveWritingPrompt: "Improve writing",
                aiMakeShorterPrompt: "Make shorter",
                aiMakeLongerPrompt: "Make longer",
                aiSimplifyLanguagePrompt: "Simplify language",
                aiSummarizePrompt: "Summarize",
                aiContinuePrompt: "Continue",
                aiChangeToneProfessionalPrompt: "Change tone to professional",
                aiChangeToneFriendlyPrompt: "Change tone to friendly",
                aiChangeToneFormalPrompt: "Change tone to formal",
                aiChangeToneCasualPrompt: "Change tone to casual",
                aiChangeToneDirectPrompt: "Change tone to direct",
                aiChangeToneConfidentPrompt: "Change tone to confident",
                aiChangeStyleBusinessPrompt: "Change style to business",
                aiChangeStyleLegalPrompt: "Change style to legal",
                aiChangeStyleJournalismPrompt: "Change style of journalism",
                aiChangeStylePoeticPrompt: "Change style to poetic",
                aiTranslateToSpanishPrompt: "Translate to Spanish",
                aiTranslateToFrenchPrompt: "Translate to French",
                aiTranslateToGermanPrompt: "Translate to German",
                aiTranslateToItalianPrompt: "Translate to Italian",
                aiTranslateToPortuguesePrompt: "Translate to Portuguese",
                aiTranslateToEnglishPrompt: "Translate to English",
                aiTranslateToChinesePrompt: "Translate to Chinese",
                aiTranslateToJapanesePrompt: "Translate to Japanese",
                aiTranslateToKoreanPrompt: "Translate to Korean",
                aiTranslateToRussianPrompt: "Translate to Russian",
                aiTranslateToArabicPrompt: "Translate to Arabic"
            },
            exec: function(e, t, o) {
                var n = o.control;
                e.e.fire("generateAiAssistantForm.ai-assistant", n.name);
            }
        }, rr.prototype.controls["ai-assistant"] = {
            isDisabled: function(e) {
                return !e.o.aiAssistant.aiAssistantCallback;
            },
            hotkeys: [
                "ctrl+a+i",
                "cmd+a+i"
            ],
            tooltip: "AI Assistant",
            exec: function(e, t, o) {
                e.e.fire("generateAiAssistantForm.ai-assistant");
            }
        };
        var YO = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : WO(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, KO = function(e) {
            function t(e, o) {
                var n, r = o.onInsert, i = o.onInsertAfter;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = qO(t), function(e, t) {
                        return !t || "object" !== WO(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, UO() ? Reflect.construct(t, o || [], qO(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).__aiResult = "", n.__error = n.getElm("error"), n.__body = n.getElm("body"), n.__buttons = n.getElm("buttons"), n.__results = n.getElm("results"), n.__spinner = n.getElm("spinner"), n.__insertButton = Es(e, "", "Insert", "primary").onAction(function() {
                    return r(n.__aiResult);
                }), n.__insertAfterButton = Es(e, "", "Insert After", "initial").onAction(function() {
                    return i(n.__aiResult);
                });
                var a = function() {
                    n.__formAiAssistant.validate() && (n.__formAiAssistant.submit(), n.__toggleInsertButton(!0), n.__toggleSubmitButton(!0));
                };
                n.__submitButton = Es(e, "ai-assistant", "").onAction(a), n.__tryAgainButton = Es(e, "update", "", "initial").onAction(a), n.promptInput = new Nc(e, {
                    name: "prompt",
                    required: !0,
                    label: "Prompt",
                    placeholder: "Ask AI to improve generated text",
                    className: n.getFullElName("prompt-row-input")
                });
                var l = new $s(e, [
                    n.__insertButton,
                    n.__insertAfterButton,
                    n.__tryAgainButton
                ], {
                    className: n.getFullElName("prompt-row")
                });
                return n.__formAiAssistant = new Ec(e, [
                    new $s(e, [
                        n.promptInput,
                        n.__submitButton
                    ], {
                        className: n.getFullElName("prompt-row")
                    })
                ]).onSubmit(function(t) {
                    n.__error.textContent = "", n.setMod("loading", !0), e.e.fire("invokeAiAssistant", t.prompt);
                    var o = n.getFullElName("", "hide", "true");
                    n.__results.classList.remove(o), n.__buttons.classList.remove(o), pi.detach(n.__results), n.__results.appendChild(n.__spinner), n.__insertButton.focus();
                }), n.__buttons.appendChild(l.container), n.__body.appendChild(n.__formAiAssistant.container), n.onChangePromptValue(), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && VO(e, t);
            }(t, e), o = t, n = [
                {
                    key: "className",
                    value: function() {
                        return "UIAiAssistant";
                    }
                },
                {
                    key: "render",
                    value: function() {
                        return '<div>\n\t\t\t\t<div class="&__container">\n\t\t\t\t\t\t<div class="&__error"></div>\n\t\t\t\t\t\t<div class="&__body"></div>\n\t\t\t\t\t\t<div class="&__buttons &_hide_true"></div>\n\t\t\t\t\t\t<div class="&__results &_hide_true">\n\t\t\t\t\t\t\t\t<div class="&__spinner"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>';
                    }
                },
                {
                    key: "setPrompt",
                    value: function(e) {
                        if (e) {
                            var t = this.jodit, o = t.o.aiAssistant[e], n = t.o.aiAssistant, r = n.aiCommonPrefixPrompt, i = n.aiCommonSuffixPrompt;
                            this.promptInput.value = [
                                r,
                                Lo(o) ? o : "",
                                i
                            ].filter(Boolean).join(" "), this.__toggleInsertButton(!0), this.promptInput.value && (this.__formAiAssistant.submit(), this.__toggleSubmitButton(!0));
                        }
                        this.promptInput.focus();
                    }
                },
                {
                    key: "onAiAssistentResponse",
                    value: function(e) {
                        this.setMod("loading", !1), pi.detach(this.__results), this.__aiResult = e, this.__results.appendChild(this.jodit.c.fromHTML(e)), this.__toggleSubmitButton(!1), this.__toggleInsertButton(!1);
                    }
                },
                {
                    key: "onAiAssistentError",
                    value: function(e) {
                        this.__aiResult = "", this.setMod("loading", !1), this.__error.textContent = e, pi.detach(this.__results), this.__toggleSubmitButton(!1);
                        var t = this.getFullElName("", "hide", "true");
                        this.__results.classList.add(t), this.__toggleInsertButton(!0);
                    }
                },
                {
                    key: "onChangePromptValue",
                    value: function() {
                        this.__toggleSubmitButton(!this.promptInput.value);
                    }
                },
                {
                    key: "__toggleSubmitButton",
                    value: function(e) {
                        this.__submitButton.state.disabled = e, this.__tryAgainButton.state.disabled = e;
                    }
                },
                {
                    key: "__toggleInsertButton",
                    value: function(e) {
                        this.__insertButton.state.disabled = e, this.__insertAfterButton.state.disabled = e;
                    }
                }
            ], n && FO(o.prototype, n), t;
        }(Al);
        YO([
            Ca(":ai-assistant-response")
        ], KO.prototype, "onAiAssistentResponse", null), YO([
            Ca(":ai-assistant-error")
        ], KO.prototype, "onAiAssistentError", null), YO([
            Ca("promptInput:change")
        ], KO.prototype, "onChangePromptValue", null), KO = YO([
            ji
        ], KO);
        const GO = {
            aiAssistant: "AI Assistant",
            aiCommands: "AI Commands",
            "AI Assistant": "AI Assistant",
            Prompt: "Prompt",
            "Ask AI to improve generated text": "Ask AI to improve generated text",
            Submit: "Submit"
        }, JO = {
            aiAssistant: "Asistente de IA",
            aiCommands: "Comandos de IA",
            "AI Assistant": "Asistente de IA",
            "AI Commands": "Comandos de IA",
            "Improve writing": "Mejorar escritura",
            "Make shorter": "Hacer m\xe1s corto",
            "Make longer": "Hacer m\xe1s largo",
            "Simplify language": "Simplificar lenguaje",
            Summarize: "Resumir",
            Continue: "Continuar",
            Prompt: "Solicitud",
            Insert: "Insertar",
            "Insert After": "Insertar despu\xe9s",
            "Try Again": "Intentar de nuevo",
            "Ask AI to improve generated text": "Pida a la IA que mejore el texto generado",
            "Change tone to professional": "Cambiar tono a profesional",
            "Change tone to friendly": "Cambiar tono a amigable",
            "Change tone to formal": "Cambiar tono a formal",
            "Change tone to casual": "Cambiar tono a casual",
            "Change tone to direct": "Cambiar tono a directo",
            "Change tone to confident": "Cambiar tono a confiado",
            "Change tone to business": "Cambiar tono a empresarial",
            "Change style to legal": "Cambiar estilo a legal",
            "Change style to journalism": "Cambiar estilo a period\xedstico",
            "Change style to poetic": "Cambiar estilo a po\xe9tico",
            "Translate to Spanish": "Traducir al espa\xf1ol",
            "Translate to French": "Traducir al franc\xe9s",
            "Translate to German": "Traducir al alem\xe1n",
            "Translate to Italian": "Traducir al italiano",
            "Translate to Portuguese": "Traducir al portugu\xe9s",
            "Translate to English": "Traducir al ingl\xe9s",
            "Translate to Chinese": "Traducir al chino",
            "Translate to Japanese": "Traducid al japon\xe9s",
            "Translate to Korean": "Traducir al coreano",
            "Translate to Russian": "Traducir al ruso",
            "Translate to Arabic": "Traducir al \xe1rabe",
            Submit: "Enviar"
        };
        function XO(e, t, o, n, r, i, a) {
            try {
                var l = e[i](a), s = l.value;
            } catch (e) {
                return void o(e);
            }
            l.done ? t(s) : Promise.resolve(s).then(n, r);
        }
        function ZO(e, t, o) {
            return ZO = nC() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && eC(r, o.prototype), r;
            }, ZO.apply(null, arguments);
        }
        function QO(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function $O(e) {
            return $O = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, $O(e);
        }
        function eC(e, t) {
            return eC = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, eC(e, t);
        }
        function tC(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function oC(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return oC = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return ZO(e, arguments, $O(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), eC(n, e);
            }, oC(e);
        }
        function nC() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (nC = function() {
                return !!e;
            })();
        }
        var rC = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : tC(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, iC = function(e) {
            function t(e) {
                var o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (o = function(e, t, o) {
                    return t = $O(t), function(e, t) {
                        return !t || "object" !== tC(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, nC() ? Reflect.construct(t, o || [], $O(e).constructor) : t.apply(e, o));
                }(this, t, [
                    e
                ])).buttons = [
                    {
                        name: "ai-commands",
                        group: "insert"
                    },
                    {
                        name: "ai-assistant",
                        group: "insert"
                    }
                ], Da(Re), o;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && eC(e, t);
            }(t, e), o = t, n = [
                {
                    key: "__dialog",
                    get: function() {
                        return this.jodit.dlg({
                            buttons: [
                                "fullsize",
                                "dialog.close"
                            ],
                            closeOnClickOverlay: !0,
                            closeOnEsc: !0,
                            resizable: !1,
                            draggable: !0,
                            minHeight: 160
                        });
                    }
                },
                {
                    key: "__container",
                    get: function() {
                        var e = this.jodit, t = this.__dialog;
                        return new KO(e, {
                            onInsertAfter: function(o) {
                                e.s.focus(), e.s.setCursorAfter(e.s.current()), e.s.insertHTML(o), t.close();
                            },
                            onInsert: function(o) {
                                e.s.focus(), e.s.insertHTML(o), t.close();
                            }
                        });
                    }
                },
                {
                    key: "afterInit",
                    value: function() {}
                },
                {
                    key: "onGenerateAiAssistantForm",
                    value: function(e) {
                        this.__dialog.open(this.__container, "AI Assistant"), this.__container.setPrompt(e);
                    }
                },
                {
                    key: "onInvokeAiAssistant",
                    value: function(e) {
                        var t = this.jodit;
                        t.s.focus();
                        var o = t.s.html;
                        t.async.promise(function() {
                            var n, r = (n = function(n, r) {
                                var i, a;
                                return function(e, t) {
                                    var o, n, r, i, a = {
                                        label: 0,
                                        sent: function() {
                                            if (1 & r[0]) throw r[1];
                                            return r[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                    return i = {
                                        next: l(0),
                                        throw: l(1),
                                        return: l(2)
                                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                                        return this;
                                    }), i;
                                    function l(i) {
                                        return function(l) {
                                            return function(i) {
                                                if (o) throw new TypeError("Generator is already executing.");
                                                for(; a;)try {
                                                    if (o = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                                    switch(n = 0, r && (i = [
                                                        2 & i[0],
                                                        r.value
                                                    ]), i[0]){
                                                        case 0:
                                                        case 1:
                                                            r = i;
                                                            break;
                                                        case 4:
                                                            return a.label++, {
                                                                value: i[1],
                                                                done: !1
                                                            };
                                                        case 5:
                                                            a.label++, n = i[1], i = [
                                                                0
                                                            ];
                                                            continue;
                                                        case 7:
                                                            i = a.ops.pop(), a.trys.pop();
                                                            continue;
                                                        default:
                                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                                a = 0;
                                                                continue;
                                                            }
                                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                                a.label = i[1];
                                                                break;
                                                            }
                                                            if (6 === i[0] && a.label < r[1]) {
                                                                a.label = r[1], r = i;
                                                                break;
                                                            }
                                                            if (r && a.label < r[2]) {
                                                                a.label = r[2], a.ops.push(i);
                                                                break;
                                                            }
                                                            r[2] && a.ops.pop(), a.trys.pop();
                                                            continue;
                                                    }
                                                    i = t.call(e, a);
                                                } catch (e) {
                                                    i = [
                                                        6,
                                                        e
                                                    ], n = 0;
                                                } finally{
                                                    o = r = 0;
                                                }
                                                if (5 & i[0]) throw i[1];
                                                return {
                                                    value: i[0] ? i[1] : void 0,
                                                    done: !0
                                                };
                                            }([
                                                i,
                                                l
                                            ]);
                                        };
                                    }
                                }(this, function(l) {
                                    switch(l.label){
                                        case 0:
                                            return l.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]), [
                                                4,
                                                t.o.aiAssistant.aiAssistantCallback(e, o)
                                            ];
                                        case 1:
                                            return i = l.sent(), n(i), [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            return a = l.sent(), r(a), [
                                                3,
                                                3
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }, function() {
                                var e = this, t = arguments;
                                return new Promise(function(o, r) {
                                    var i = n.apply(e, t);
                                    function a(e) {
                                        XO(i, o, r, a, l, "next", e);
                                    }
                                    function l(e) {
                                        XO(i, o, r, a, l, "throw", e);
                                    }
                                    a(void 0);
                                });
                            });
                            return function(e, t) {
                                return r.apply(this, arguments);
                            };
                        }()).then(function(e) {
                            t.e.fire("ai-assistant-response", e);
                        }).catch(function(e) {
                            Vo(e) || (t.message.error(e.message), t.e.fire("ai-assistant-error", e.message));
                        });
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        var t, o;
                        null === (t = hi(this, "__container")) || void 0 === t || t.destruct(), null === (o = hi(this, "__dialog")) || void 0 === o || o.destruct();
                    }
                }
            ], n && QO(o.prototype, n), t;
        }(oC(Wp));
        function aC(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        function lC(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            if (!e.o.tab.tabInsideLiInsertNewList) return !1;
            var o = function(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != o) {
                        var n, r, i = [], a = !0, l = !1;
                        try {
                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                        } catch (e) {
                            l = !0, r = e;
                        } finally{
                            try {
                                a || null == o.return || o.return();
                            } finally{
                                if (l) throw r;
                            }
                        }
                        return i;
                    }
                }(e, t) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return aC(e, t);
                        var o = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? aC(e, t) : void 0;
                    }
                }(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }(function(e) {
                var t = e.createInside.fake(), o = e.createInside.fake(), n = e.s.range.cloneRange();
                n.collapse(!0), n.insertNode(t);
                var r = e.s.range.cloneRange();
                return r.collapse(!1), r.insertNode(o), [
                    t,
                    o
                ];
            }(e), 2), n = o[0], r = o[1];
            try {
                var i = function(e, t, o) {
                    var n = pi.closest(t, "li", e.editor);
                    return !!n && !(!o && !pi.isLeaf(n.previousElementSibling)) && !(o && !pi.closest(n, "li", e.editor)) && n;
                }(e, n, t);
                if (!i) return !1;
                if (!function(e, t, o) {
                    var n = pi.closest(o, "li", t.editor);
                    return !(!n || n !== e && !e.contains(n));
                }(i, e, n)) return !1;
                var a = pi.closest(i, [
                    "ol",
                    "ul"
                ], e.editor);
                return !(!a || t && !pi.closest(a, "li", e.editor) || (t ? function(e, t, o) {
                    var n = pi.closest(t, "li", e.editor);
                    $n(n, "tab parentLi is null");
                    var r = Array.from(t.children).filter(function(e) {
                        return pi.isLeaf(e);
                    });
                    pi.after(n, o);
                    var i = r.indexOf(o);
                    if (0 !== i && 1 !== r.length || pi.safeRemove(t), i !== r.length - 1) {
                        var a = t.cloneNode();
                        pi.append(o, a);
                        for(var l = i + 1; l < r.length; l += 1)pi.append(a, r[l]);
                    }
                }(e, a, i) : function(e, t, o) {
                    var n = o.previousElementSibling;
                    $n(n, "tab previousElementSibling is null");
                    var r = n.lastElementChild, i = pi.isTag(r, t.tagName) ? r : e.createInside.element(t.tagName, Array.from(t.attributes).reduce(function(e, t) {
                        return e[t.name] = t.value, e;
                    }, {}));
                    i.appendChild(o), r !== i && n.appendChild(i);
                }(e, a, i), 0));
            } finally{
                var l = e.s.createRange();
                l.setStartAfter(n), l.setEndBefore(r), e.s.selectRange(l), pi.safeRemove(n), pi.safeRemove(r);
            }
            return !1;
        }
        function sC(e, t, o) {
            return sC = hC() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && dC(r, o.prototype), r;
            }, sC.apply(null, arguments);
        }
        function cC(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function uC(e) {
            return uC = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, uC(e);
        }
        function dC(e, t) {
            return dC = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, dC(e, t);
        }
        function fC(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function pC(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return pC = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return sC(e, arguments, uC(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), dC(n, e);
            }, pC(e);
        }
        function hC() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (hC = function() {
                return !!e;
            })();
        }
        rC([
            vi
        ], iC.prototype, "__dialog", null), rC([
            vi
        ], iC.prototype, "__container", null), rC([
            Ca(":generateAiAssistantForm.ai-assistant")
        ], iC.prototype, "onGenerateAiAssistantForm", null), rC([
            Ca(":invokeAiAssistant")
        ], iC.prototype, "onInvokeAiAssistant", null), Ma.add("ai-assistant", iC), rr.prototype.tab = {
            tabInsideLiInsertNewList: !0
        };
        var vC = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : fC(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, gC = function(e) {
            function t() {
                var e, o, n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), e = this, n = arguments, o = uC(o = t), function(e, t) {
                    return !t || "object" !== fC(t) && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }(e, hC() ? Reflect.construct(o, n || [], uC(e).constructor) : o.apply(e, n));
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && dC(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {}
                },
                {
                    key: "__onTab",
                    value: function(e) {
                        if (e.key === Mt && this.__onShift(e.shiftKey)) return !1;
                    }
                },
                {
                    key: "__onCommand",
                    value: function(e) {
                        if (("indent" === e || "outdent" === e) && this.__onShift("outdent" === e)) return !1;
                    }
                },
                {
                    key: "__onShift",
                    value: function(e) {
                        var t = lC(this.j, e);
                        return t && this.j.e.fire("afterTab", e), t;
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {}
                }
            ], cC(o.prototype, n), t;
        }(pC(Wp));
        function mC(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        vC([
            Ca(":keydown.tab")
        ], gC.prototype, "__onTab", null), vC([
            Ca(":beforeCommand.tab")
        ], gC.prototype, "__onCommand", null), Ma.add("tab", gC);
        var bC = new Set([
            Mt,
            Ht,
            qt,
            Ft,
            Vt
        ]);
        function yC(e, t, o) {
            return yC = xC() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && kC(r, o.prototype), r;
            }, yC.apply(null, arguments);
        }
        function _C(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function jC(e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e;
        }
        function wC(e) {
            return wC = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, wC(e);
        }
        function kC(e, t) {
            return kC = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, kC(e, t);
        }
        function SC(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return SC = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return yC(e, arguments, wC(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), kC(n, e);
            }, SC(e);
        }
        function xC() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (xC = function() {
                return !!e;
            })();
        }
        Ma.add("tableKeyboardNavigation", function(e) {
            e.e.off(".tableKeyboardNavigation").on("keydown.tableKeyboardNavigation", function(t) {
                var o = t.key, n = function(e, t) {
                    if (bC.has(t)) {
                        var o = e.s.current();
                        if (o) {
                            var n = pi.up(o, pi.isCell, e.editor);
                            if (n) {
                                var r = e.s.range;
                                if (t !== Mt && o !== n) {
                                    var i = t === qt || t === Vt, a = dr(i ? pi.next : pi.prev, o, function(e) {
                                        return t === Ft || t === Vt ? pi.isTag(e, "br") : Boolean(e);
                                    }, n);
                                    if (!i && (a || t !== Ft && pi.isText(o) && 0 !== r.startOffset) || i && (a || t !== Vt && pi.isText(o) && o.nodeValue && r.startOffset !== o.nodeValue.length)) return;
                                }
                                return n;
                            }
                        }
                    }
                }(e, o);
                if (n) {
                    var r = e.getInstance(wh, e.o), i = pi.closest(n, "table", e.editor), a = null, l = o === Ht || t.shiftKey, s = function() {
                        return dr(l ? pi.prev : pi.next, n, pi.isCell, i);
                    };
                    switch(o){
                        case Mt:
                        case Ht:
                            (a = s()) || (r.appendRow(i, !!l && i.querySelector("tr"), !l), a = s());
                            break;
                        case Ft:
                        case Vt:
                            var c = r.formalMatrix(i), u = function(e, t) {
                                return function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != o) {
                                        var n, r, i = [], a = !0, l = !1;
                                        try {
                                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                        } catch (e) {
                                            l = !0, r = e;
                                        } finally{
                                            try {
                                                a || null == o.return || o.return();
                                            } finally{
                                                if (l) throw r;
                                            }
                                        }
                                        return i;
                                    }
                                }(e, t) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return mC(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? mC(e, t) : void 0;
                                    }
                                }(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(r.formalCoordinate(i, n), 2), d = u[0], f = u[1];
                            o === Ft ? void 0 !== c[d - 1] && (a = c[d - 1][f]) : void 0 !== c[d + 1] && (a = c[d + 1][f]);
                    }
                    if (a) {
                        if (e.e.fire("hidePopup hideResizer"), a.firstChild) o === Mt ? e.s.select(a, !0) : e.s.setCursorIn(a, o === qt || o === Vt);
                        else {
                            var p = e.createInside.element("br");
                            a.appendChild(p), e.s.setCursorBefore(p);
                        }
                        return e.synchronizeValues(), !1;
                    }
                }
            });
        }), rr.prototype.video = {
            parseUrlToVideoEmbed: Sr,
            defaultWidth: 400,
            defaultHeight: 345
        }, Ol.set("video", '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"/> </svg> '), rr.prototype.controls.video = {
            popup: function(e, t, o) {
                var n = new Ec(e, [
                    new $s(e, [
                        new fc(e, {
                            name: "url",
                            required: !0,
                            label: "URL",
                            placeholder: "https://",
                            validators: [
                                "url"
                            ]
                        })
                    ]),
                    new $s(e, [
                        Es(e, "", "Insert", "primary").onAction(function() {
                            return n.submit();
                        })
                    ])
                ]), r = new Ec(e, [
                    new $s(e, [
                        new Nc(e, {
                            name: "code",
                            required: !0,
                            label: "Embed code"
                        })
                    ]),
                    new $s(e, [
                        Es(e, "", "Insert", "primary").onAction(function() {
                            return r.submit();
                        })
                    ])
                ]), i = [], a = function(t) {
                    e.s.restore(), e.s.insertHTML(t), o();
                };
                return e.s.save(), i.push({
                    icon: "link",
                    name: "Link",
                    content: n.container
                }, {
                    icon: "source",
                    name: "Code",
                    content: r.container
                }), n.onSubmit(function(t) {
                    var o, n, r, i;
                    a(dr(null !== (n = null === (o = e.o.video) || void 0 === o ? void 0 : o.parseUrlToVideoEmbed) && void 0 !== n ? n : Sr, t.url, {
                        width: null === (r = e.o.video) || void 0 === r ? void 0 : r.defaultWidth,
                        height: null === (i = e.o.video) || void 0 === i ? void 0 : i.defaultHeight
                    }));
                }), r.onSubmit(function(e) {
                    a(e.code);
                }), em(e, i);
            },
            tags: [
                "iframe"
            ],
            tooltip: "Insert youtube/vimeo video"
        }, Ma.add("video", function(e) {
            e.registerButton({
                name: "video",
                group: "media"
            });
        }), rr.prototype.showXPathInStatusbar = !0;
        var OC = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = wC(t), function(e, t) {
                        var o;
                        return !t || "object" != ((o = t) && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, xC() ? Reflect.construct(t, o || [], wC(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).onContext = function(t, o) {
                    return e.menu || (e.menu = new Sf(e.j)), e.menu.show(o.clientX, o.clientY, [
                        {
                            icon: "bin",
                            title: t === e.j.editor ? "Clear" : "Remove",
                            exec: function() {
                                t !== e.j.editor ? pi.safeRemove(t) : e.j.value = "", e.j.synchronizeValues();
                            }
                        },
                        {
                            icon: "select-all",
                            title: "Select",
                            exec: function() {
                                e.j.s.select(t);
                            }
                        }
                    ]), !1;
                }, e.onSelectPath = function(t, o) {
                    e.j.s.focus();
                    var n = er(o.target, "-path") || "/";
                    if ("/" === n) return e.j.execCommand("selectall"), !1;
                    try {
                        var r = e.j.ed.evaluate(n, e.j.editor, null, XPathResult.ANY_TYPE, null).iterateNext();
                        if (r) return e.j.s.select(r), !1;
                    } catch (e) {}
                    return e.j.s.select(t), !1;
                }, e.tpl = function(t, o, n, r) {
                    var i = e.j.c.fromHTML('<span class="jodit-xpath__item"><a role="button" data-path="'.concat(o, '" title="').concat(r, '" tabindex="-1"\'>').concat(vn(n), "</a></span>")), a = i.firstChild;
                    return e.j.e.on(a, "click", e.onSelectPath.bind(e, t)).on(a, "contextmenu", e.onContext.bind(e, t)), i;
                }, e.removeSelectAll = function() {
                    e.selectAllButton && (e.selectAllButton.destruct(), delete e.selectAllButton);
                }, e.appendSelectAll = function() {
                    e.removeSelectAll(), e.selectAllButton = Wd(e.j, function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
                            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
                                return Object.getOwnPropertyDescriptor(o, e).enumerable;
                            }))), n.forEach(function(t) {
                                jC(e, t, o[t]);
                            });
                        }
                        return e;
                    }({
                        name: "selectall"
                    }, e.j.o.controls.selectall)), e.selectAllButton.state.size = "tiny", e.container && e.container.insertBefore(e.selectAllButton.container, e.container.firstChild);
                }, e.calcPathImd = function() {
                    if (!e.isDestructed) {
                        var t, o, n, r = e.j.s.current();
                        e.container && (e.container.innerHTML = bt), r && pi.up(r, function(r) {
                            !r || e.j.editor === r || pi.isText(r) || pi.isComment(r) || (t = r.nodeName.toLowerCase(), o = $r(r, e.j.editor).replace(/^\//, ""), n = e.tpl(r, o, t, e.j.i18n("Select %s", t)), e.container && e.container.insertBefore(n, e.container.firstChild));
                        }, e.j.editor), e.appendSelectAll();
                    }
                }, e.calcPath = e.j.async.debounce(e.calcPathImd, 2 * e.j.defaultTimeout), e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && kC(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function() {
                        var e = this;
                        this.j.o.showXPathInStatusbar && (this.container = this.j.c.div("jodit-xpath"), this.j.e.off(".xpath").on("mouseup.xpath change.xpath keydown.xpath changeSelection.xpath", this.calcPath).on("afterSetMode.xpath afterInit.xpath changePlace.xpath", function() {
                            e.j.o.showXPathInStatusbar && e.container && (e.j.statusbar.append(e.container), e.j.getRealMode() === Qt ? e.calcPath() : (e.container && (e.container.innerHTML = bt), e.appendSelectAll()));
                        }), this.calcPath());
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function() {
                        this.j && this.j.events && this.j.e.off(".xpath"), this.removeSelectAll(), this.menu && this.menu.destruct(), pi.safeRemove(this.container), delete this.menu, delete this.container;
                    }
                }
            ], _C(o.prototype, n), t;
        }(SC(Wp));
        Ma.add("xpath", OC);
        var CC = Ot ? Ot.SpeechRecognition || Ot.webkitSpeechRecognition : void 0;
        function zC(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function EC(e, t, o) {
            return EC = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, o) {
                var n = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = TC(e)););
                    return e;
                }(e, t);
                if (n) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return r.get ? r.get.call(o || e) : r.value;
                }
            }, EC(e, t, o || e);
        }
        function TC(e) {
            return TC = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, TC(e);
        }
        function IC(e, t) {
            return IC = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, IC(e, t);
        }
        function PC(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function RC() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (RC = function() {
                return !!e;
            })();
        }
        var AC, LC = AC = function(e) {
            function t(e, o) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = function(e, t, o) {
                    return t = TC(t), function(e, t) {
                        return !t || "object" !== PC(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, RC() ? Reflect.construct(t, o || [], TC(e).constructor) : t.apply(e, o));
                }(this, t)).async = e, n._continuous = !1, n._interimResults = !1, n.sound = !0, n._isEnabled = !1, n._restartTimeout = 0, n._onSpeechStart = function(e) {
                    n._isEnabled && (n.async.clearTimeout(n._restartTimeout), n._restartTimeout = n.async.setTimeout(function() {
                        n.restart(), n.emit("pulse", !1), n._makeSound(940);
                    }, 5e3), n.emit("pulse", !0));
                }, n.__interimResults = "", n._api = o, AC._instances.add(n), n;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && IC(e, t);
            }(t, e), o = t, n = [
                {
                    key: "lang",
                    get: function() {
                        return this._lang;
                    },
                    set: function(e) {
                        this._lang = e, this._api.lang = e;
                    }
                },
                {
                    key: "continuous",
                    get: function() {
                        return this._continuous;
                    },
                    set: function(e) {
                        this._continuous = e, this._api.continuous = e;
                    }
                },
                {
                    key: "interimResults",
                    get: function() {
                        return this._interimResults;
                    },
                    set: function(e) {
                        this._interimResults = e, this._api.interimResults = e;
                    }
                },
                {
                    key: "destruct",
                    value: function() {
                        this.stop(), AC._instances.delete(this), EC(TC(t.prototype), "destruct", this).call(this);
                    }
                },
                {
                    key: "isEnabled",
                    get: function() {
                        return this._isEnabled;
                    }
                },
                {
                    key: "start",
                    value: function() {
                        var e = this;
                        if (!this._isEnabled) {
                            this._isEnabled = !0, AC._instances.forEach(function(t) {
                                t !== e && t.stop();
                            });
                            try {
                                this._api.start();
                            } catch (e) {
                                return this._onError(e), void this.stop();
                            }
                            this.__on("speechstart", this._onSpeechStart).__on("error", this._onError).__on("result", this._onProgress).__on("end", this._onResults);
                        }
                    }
                },
                {
                    key: "stop",
                    value: function() {
                        this._isEnabled && (this._api.abort(), this._api.stop(), this.__off("speechstart", this._onSpeechStart).__off("error", this._onError).__off("result", this._onProgress).__off("end", this._onResults), this.async.clearTimeout(this._restartTimeout), this._isEnabled = !1, this.emit("pulse", !1));
                    }
                },
                {
                    key: "toggle",
                    value: function() {
                        this._isEnabled ? this.stop() : this.start();
                    }
                },
                {
                    key: "restart",
                    value: function() {
                        this.stop(), this.start();
                    }
                },
                {
                    key: "__on",
                    value: function(e, t) {
                        return this._api.addEventListener(e, t), this;
                    }
                },
                {
                    key: "__off",
                    value: function(e, t) {
                        return this._api.removeEventListener(e, t), this;
                    }
                },
                {
                    key: "_onResults",
                    value: function(e) {
                        this.emit("pulse", !1), this.emit("result", this.__interimResults), this.__interimResults = "", this._makeSound(440), this.restart();
                    }
                },
                {
                    key: "_onProgress",
                    value: function(e) {
                        if (this._isEnabled && (this.__interimResults = "", e.results)) {
                            for(var t = 0; t < e.results.length; t++){
                                var o = e.results.item(t);
                                if (o.length) {
                                    var n = o.item(0).transcript;
                                    this.__interimResults += n;
                                }
                            }
                            this.__interimResults && this.emit("progress", this.__interimResults);
                        }
                    }
                },
                {
                    key: "_onError",
                    value: function(e) {
                        "voice-unavailable" === e.error && this.emit("error", "Voice unavailable"), "not-allowed" === e.error && this.emit("error", "Not allowed"), "language-unavailable" !== e.error && "language-not-supported" !== e.error || this.emit("error", "Language unavailable"), this._makeSound(940), this.emit("pulse", !1), this.stop();
                    }
                },
                {
                    key: "_makeSound",
                    value: function(e) {
                        this.sound && function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.sec, o = void 0 === t ? .1 : t, n = e.frequency, r = void 0 === n ? 440 : n, i = e.gain, a = void 0 === i ? .1 : i, l = e.type, s = void 0 === l ? "sine" : l;
                            if (Ot && (void 0 !== Ot.AudioContext || void 0 !== Ot.webkitAudioContext)) {
                                var c = new (Ot.AudioContext || Ot.webkitAudioContext), u = c.createGain(), d = c.createOscillator();
                                d.type = s, d.frequency.value = r, d.connect(u), u.connect(c.destination), d.start(), d.stop(c.currentTime + o), u.gain.value = a;
                            }
                        }({
                            frequency: e
                        });
                    }
                }
            ], n && zC(o.prototype, n), t;
        }(_n);
        function MC(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
            return n;
        }
        LC._instances = new Set, LC = AC = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : PC(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }([
            To
        ], LC), rr.prototype.speechRecognize = {
            api: void 0 !== CC ? CC : null,
            sound: !0,
            continuous: !1,
            interimResults: !0,
            commands: {
                "newline|enter": "enter",
                "delete|remove word|delete word": "backspaceWordButton",
                comma: "inserthtml::,",
                underline: "inserthtml::_",
                hyphen: "inserthtml::-",
                space: "inserthtml:: ",
                question: "inserthtml::?",
                dot: "inserthtml::.",
                "quote|quotes|open quote": "inserthtml::'",
                "header|header h1": "formatblock::h1",
                "select all": "selectall"
            }
        }, Ol.set("speech-recognize", '<svg viewBox="0 0 16 16" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"> <path d="M8,11c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3S5,1.343,5,3v5C5,9.657,6.343,11,8,11z"/> <path d="M13,8V6h-1l0,1.844c0,1.92-1.282,3.688-3.164,4.071C6.266,12.438,4,10.479,4,8V6H3v2c0,2.414,1.721,4.434,4,4.899V15H5v1h6 v-1H9v-2.101C11.279,12.434,13,10.414,13,8z"/> </svg> '), rr.prototype.controls.speechRecognize = {
            isVisible: function(e) {
                return Boolean(e.o.speechRecognize.api);
            },
            isActive: function(e, t) {
                var o = cr(e, "speech");
                return Boolean(null == o ? void 0 : o.isEnabled);
            },
            isDisabled: function(e) {
                return !e.o.speechRecognize.api;
            },
            exec: function(e, t, o) {
                var n, r = o.button, i = o.control, a = e.o.speechRecognize, l = a.api, s = a.lang, c = a.continuous, u = a.interimResults, d = a.sound;
                if (l) {
                    var f = cr(e, "speech");
                    if (!f) {
                        var p = new l;
                        (f = new LC(e.async, p)).lang = Lo(s) ? s : null !== (n = er(e.od.documentElement, "lang")) && void 0 !== n ? n : void 0, f.continuous = c, f.interimResults = u, f.sound = d, cr(e, "speech", f), f.on("pulse", function(e) {
                            r.setMod("pulse", e);
                        }), f.on("result", function(t) {
                            return e.e.fire("speechRecognizeResult", t);
                        }), f.on("progress", function(t) {
                            return e.e.fire("speechRecognizeProgressResult", t);
                        }), f.on("error", function(t) {
                            return e.message.error(t);
                        }), r.hookStatus("beforeDestruct", function() {
                            cr(e, "speech", null), f.destruct();
                        });
                    }
                    if (i.args) {
                        var h = i.args[0];
                        if (Wo(f[h])) return f[h] = !f[h], void (f.isEnabled && f.restart());
                    }
                    f.toggle(), f.isEnabled && r.setMod("pulse", !0), r.state.activated = f.isEnabled;
                } else e.alert("Speech recognize API unsupported in your browser");
            },
            name: "speechRecognize",
            command: "toggleSpeechRecognize",
            tooltip: "Speech Recognize",
            list: {
                sound: "Sound",
                interimResults: "Interim Results"
            },
            childTemplate: function(e, t, o) {
                var n, r = cr(e, "speech"), i = null !== (n = null == r ? void 0 : r[t]) && void 0 !== n ? n : e.o.speechRecognize[t];
                return "<span class='jodit-speech-recognize__list-item'><input ".concat(i ? "checked" : "", " class='jodit-checkbox' type='checkbox'>&nbsp;").concat(o, "</span>");
            },
            mods: {
                stroke: !1
            }
        };
        const BC = {
            newline: "\u0627\u0644\u062E\u0637 \u0627\u0644\u062C\u062F\u064A\u062F",
            delete: "\u062D\u0630\u0641",
            space: "\u0627\u0644\u0641\u0636\u0627\u0621",
            "Speech Recognize": "\u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0643\u0644\u0627\u0645",
            Sound: "\u0627\u0644\u0635\u0648\u062A",
            "Interim Results": "\u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0645\u0624\u0642\u062A\u0629"
        }, DC = {
            newline: "\u0159\xe1dek",
            delete: "odstranit",
            space: "prostora",
            "Speech Recognize": "Rozpozn\xe1n\xed \u0158e\u010Di",
            Sound: "Zvuk",
            "Interim Results": "Pr\u016Fb\u011B\u017En\xe9 V\xfdsledky"
        }, NC = {
            newline: "Zeilenumbruch",
            delete: "l\xf6schen",
            space: "Raum",
            "Speech Recognize": "Sprache Erkennen",
            Sound: "Sound",
            "Interim Results": "Zwischenergebnis"
        }, HC = {
            newline: "nueva l\xednea",
            delete: "eliminar",
            space: "espacio",
            "Speech Recognize": "Reconocimiento de Voz",
            Sound: "Sonido",
            "Interim Results": "Resultados Provisionales"
        }, FC = {
            newline: "\u062E\u0637 \u062C\u062F\u06CC\u062F",
            delete: "\u062D\u0630\u0641",
            space: "\u0641\u0636\u0627",
            "Speech Recognize": "\u06AF\u0641\u062A\u0627\u0631 \u0631\u0627 \u062A\u0634\u062E\u06CC\u0635 \u062F\u0647\u06CC\u062F",
            Sound: "\u0635\u062F\u0627",
            "Interim Results": "\u0646\u062A\u0627\u06CC\u062C \u0645\u0648\u0642\u062A"
        }, qC = {
            "Speech Recognize": "Puheentunnistus",
            newline: "uusi rivi",
            delete: "poistaa",
            space: "tilaa",
            Sound: "\xc4\xe4ni",
            "Interim Results": "V\xe4litulokset"
        }, VC = {
            newline: "nouvelle ligne",
            delete: "supprimer",
            space: "espace",
            "Speech Recognize": "Reconnaissance Vocale",
            Sound: "Son",
            "Interim Results": "R\xe9sultats Interm\xe9diaires"
        }, WC = {
            newline: "\u05D7\u05D3\u05E9\u05D5\u05EA",
            delete: "\u05DE\u05D7\u05E7",
            space: "\u05E9\u05D8\u05D7",
            "Speech Recognize": "\u05D3\u05D9\u05D1\u05D5\u05E8 \u05DE\u05D6\u05D4\u05D4",
            Sound: "\u05E7\u05D5\u05DC",
            "Interim Results": "\u05EA\u05D5\u05E6\u05D0\u05D5\u05EA \u05D1\u05D9\u05E0\u05D9\u05D9\u05DD"
        }, UC = {
            newline: "\xfajsor",
            delete: "t\xf6rl\xe9s",
            space: "t\xe9r",
            "Speech Recognize": "A Besz\xe9d Felismeri",
            Sound: "Hang",
            "Interim Results": "Id\u0151k\xf6zi Eredm\xe9nyek"
        }, YC = {
            newline: "newline",
            delete: "Hapus",
            space: "ruang",
            "Speech Recognize": "Pidato Mengenali",
            Sound: "Suara",
            "Interim Results": "Hasil Sementara"
        }, KC = {
            newline: "nuova riga",
            delete: "eliminare",
            space: "spazio",
            "Speech Recognize": "Discorso Riconoscere",
            Sound: "Suono",
            "Interim Results": "Risultati intermedi"
        }, GC = {
            newline: "\u6539\u884C",
            delete: "\u524A\u9664",
            space: "\u30B9\u30DA\u30FC\u30B9",
            "Speech Recognize": "\u97F3\u58F0\u8A8D\u8B58",
            Sound: "\u97F3",
            "Interim Results": "\u4E2D\u9593\u7D50\u679C"
        }, JC = {
            newline: "\uC904 \uBC14\uAFC8",
            delete: "\uC0AD\uC81C",
            space: "\uACF5\uAC04",
            "Speech Recognize": "\uC74C\uC131 \uC778\uC2DD",
            Sound: "\uC18C\uB9AC",
            "Interim Results": "\uC911\uAC04 \uACB0\uACFC"
        }, XC = {
            newline: "\u0428\u0438\u043D\u044D \u043C\u04E9\u0440",
            delete: "\u0423\u0441\u0442\u0433\u0430\u0445",
            space: "\u0417\u0430\u0439",
            "Speech Recognize": "\u0414\u0443\u0443 \u0445\u043E\u043E\u043B\u043E\u0439 \u0442\u0430\u043D\u0438\u0445",
            Sound: "\u0414\u0443\u0443",
            "Interim Results": "\u0422\u04AF\u0440 \u0437\u0443\u0443\u0440\u044B\u043D \u04AF\u0440 \u0434\u04AF\u043D"
        }, ZC = {
            newline: "regel",
            delete: "verwijderen",
            space: "ruimte",
            "Speech Recognize": "Spraak Herkennen",
            Sound: "Geluid",
            "Interim Results": "Tussentijdse Resultaten"
        }, QC = {
            newline: "nylinje",
            delete: "slette",
            space: "rom",
            "Speech Recognize": "Talegjenkjenning",
            Sound: "Lyd",
            "Interim Results": "Midlertidige resultater"
        }, $C = {
            newline: "newline",
            delete: "usun\u0105\u0107",
            space: "przestrze\u0144",
            "Speech Recognize": "Rozpoznawanie Mowy",
            Sound: "D\u017Awi\u0119k",
            "Interim Results": "Wyniki Okresowe"
        }, ez = {
            newline: "linha",
            delete: "excluir",
            space: "espaco",
            "Speech Recognize": "Discurso Reconhecer",
            Sound: "Som",
            "Interim Results": "Resultados Provis\xf3rios"
        }, tz = {
            newline: "\u043D\u043E\u0432\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430|\u043F\u0435\u0440\u0435\u043D\u043E\u0441|\u044D\u043D\u0442\u0435\u0440",
            delete: "\u0443\u0434\u0430\u043B\u0438\u0442\u044C",
            space: "\u043F\u0440\u043E\u0431\u0435\u043B",
            "Speech Recognize": "\u0420\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0447\u0438",
            Sound: "\u0417\u0432\u0443\u043A",
            "Interim Results": "\u041F\u0440\u043E\u043C\u0435\u0436\u0443\u0442\u043E\u0447\u043D\u044B\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B"
        }, oz = {
            newline: "yeni sat\u0131r",
            delete: "silmek",
            space: "uzay",
            "Speech Recognize": "Konu\u015Fma Tan\u0131ma",
            Sound: "Ses",
            "Interim Results": "Ara Sonu\xe7lar"
        }, nz = {
            newline: "\u043D\u043E\u0432\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430|\u043F\u0435\u0440\u0435\u043D\u043E\u0441|\u0435\u043D\u0442\u0435\u0440",
            delete: "\u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
            space: "\u043F\u0440\u043E\u0431\u0435\u043B",
            "Speech Recognize": "\u0420\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0447\u0438",
            Sound: "\u0417\u0432\u0443\u043A",
            "Interim Results": "\u041F\u0440\u043E\u043C\u0456\u0436\u043D\u0456 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438"
        }, rz = {
            newline: "\u65B0\u884C",
            delete: "\u5220\u9664",
            space: "\u7A7A\u95F4",
            "Speech Recognize": "\u8A00\u8BED\u8BC6\u522B",
            Sound: "\u58F0\u97F3",
            "Interim Results": "\u4E2D\u671F\u4E1A\u7EE9"
        }, iz = {
            newline: "\u63DB\u884C",
            delete: "\u522A\u9664",
            space: "\u7A7A\u767D",
            "Speech Recognize": "\u8A9E\u97F3\u8FA8\u8B58",
            Sound: "\u8072\u97F3",
            "Interim Results": "\u968E\u6BB5\u6027\u8FA8\u8B58\u7D50\u679C"
        };
        function az(e, t, o) {
            return az = fz() ? Reflect.construct : function(e, t, o) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var r = new (Function.bind.apply(e, n));
                return o && cz(r, o.prototype), r;
            }, az.apply(null, arguments);
        }
        function lz(e, t) {
            for(var o = 0; o < t.length; o++){
                var n = t[o];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function sz(e) {
            return sz = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, sz(e);
        }
        function cz(e, t) {
            return cz = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, cz(e, t);
        }
        function uz(e) {
            return e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        }
        function dz(e) {
            var t = "function" == typeof Map ? new Map : void 0;
            return dz = function(e) {
                if (null === e || (o = e, -1 === Function.toString.call(o).indexOf("[native code]"))) return e;
                var o;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== t) {
                    if (t.has(e)) return t.get(e);
                    t.set(e, n);
                }
                function n() {
                    return az(e, arguments, sz(this).constructor);
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), cz(n, e);
            }, dz(e);
        }
        function fz() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (fz = function() {
                return !!e;
            })();
        }
        var pz = function(e, t, o, n) {
            var r, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
            if ("object" === ("undefined" == typeof Reflect ? "undefined" : uz(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
            else for(var l = e.length - 1; l >= 0; l--)(r = e[l]) && (a = (i < 3 ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
            return i > 3 && a && Object.defineProperty(t, o, a), a;
        }, hz = function(e) {
            function t() {
                var e;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (e = function(e, t, o) {
                    return t = sz(t), function(e, t) {
                        return !t || "object" !== uz(t) && "function" != typeof t ? function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e) : t;
                    }(e, fz() ? Reflect.construct(t, o || [], sz(e).constructor) : t.apply(e, o));
                }(this, t, arguments)).buttons = [
                    {
                        group: "state",
                        name: "speechRecognize"
                    }
                ], e._commandToWord = {}, e;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && cz(e, t);
            }(t, e), o = t, n = [
                {
                    key: "afterInit",
                    value: function(e) {
                        var t = this, o = e.o.speechRecognize.commands;
                        o && (Da(nt), vr(o, !1).forEach(function(n) {
                            n.split("|").forEach(function(r) {
                                r = r.trim().toLowerCase(), t._commandToWord[r] = o[n];
                                var i = e.i18n(r);
                                i !== r && i.split("|").forEach(function(e) {
                                    t._commandToWord[e.trim().toLowerCase()] = o[n].trim();
                                });
                            });
                        }));
                    }
                },
                {
                    key: "beforeDestruct",
                    value: function(e) {
                        pi.safeRemove(this.messagePopup);
                    }
                },
                {
                    key: "onSpeechRecognizeProgressResult",
                    value: function(e) {
                        var t = this;
                        this.messagePopup || (this.messagePopup = this.j.create.div("jodit-speech-recognize__popup")), this.j.workplace.appendChild(this.messagePopup), this.j.async.clearTimeout(this.__hidePopupTimeout), this.__hidePopupTimeout = this.j.async.setTimeout(function() {
                            pi.safeRemove(t.messagePopup);
                        }, 1e3), this.messagePopup.innerText = e + "|";
                    }
                },
                {
                    key: "onSpeechRecognizeResult",
                    value: function(e) {
                        this.j.async.clearTimeout(this.__hidePopupTimeout), pi.safeRemove(this.messagePopup);
                        var t = this.j, o = t.s;
                        if (!this._checkCommand(e)) {
                            var n = o.range, r = o.current();
                            if (o.isCollapsed() && pi.isText(r) && pi.isOrContains(t.editor, r) && r.nodeValue) {
                                var i = r.nodeValue;
                                r.nodeValue = i + (/[\u00A0 ]\uFEFF*$/.test(i) ? "" : " ") + e, n.setStartAfter(r), o.selectRange(n), t.synchronizeValues();
                            } else o.insertHTML(e);
                        }
                    }
                },
                {
                    key: "_checkCommand",
                    value: function(e) {
                        return e = e.toLowerCase().replace(/\./g, ""), !!this._commandToWord[e] && (function(e, t) {
                            var o = function(e, t) {
                                return function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != o) {
                                        var n, r, i = [], a = !0, l = !1;
                                        try {
                                            for(o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                                        } catch (e) {
                                            l = !0, r = e;
                                        } finally{
                                            try {
                                                a || null == o.return || o.return();
                                            } finally{
                                                if (l) throw r;
                                            }
                                        }
                                        return i;
                                    }
                                }(e, t) || function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return MC(e, t);
                                        var o = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(o) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? MC(e, t) : void 0;
                                    }
                                }(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(t.split("::"), 2), n = o[0], r = o[1];
                            e.execCommand(n, null, r);
                        }(this.j, this._commandToWord[e]), !0);
                    }
                }
            ], n && lz(o.prototype, n), t;
        }(dz(Wp));
        pz([
            Ca(":speechRecognizeProgressResult")
        ], hz.prototype, "onSpeechRecognizeProgressResult", null), pz([
            Ca(":speechRecognizeResult")
        ], hz.prototype, "onSpeechRecognizeResult", null), Jv.plugins.add("speech-recognize", hz);
        var vz = Jv, gz = (0, rt.forwardRef)(function(e, t) {
            var o = e.JoditConstructor, n = void 0 === o ? vz : o, r = e.className, i = e.config, a = e.id, l = e.name, s = e.onBlur, c = e.onChange, u = e.tabIndex, d = e.value, f = e.editorRef, p = (0, rt.useRef)(null), h = (0, rt.useRef)(null);
            (0, rt.useEffect)(function() {
                var e = p.current, t = n.make(e, i);
                return h.current = t, "function" == typeof f && f(t), function() {
                    t.isReady ? t.destruct() : t.waitForReady().then(function(e) {
                        return e.destruct();
                    });
                };
            }, [
                n,
                i,
                f
            ]), (0, rt.useEffect)(function() {
                t && ("function" == typeof t ? t(h.current) : t.current = h.current);
            }, [
                p,
                t,
                h
            ]);
            var v = function(e) {
                var t = (0, rt.useRef)("");
                return (0, rt.useEffect)(function() {
                    t.current = e;
                }, [
                    e
                ]), t.current;
            }(null != r ? r : "");
            return (0, rt.useEffect)(function() {
                var e, t, o = null === (t = h.current) || void 0 === t || null === (e = t.container) || void 0 === e ? void 0 : e.classList;
                v !== r && "string" == typeof v && v.split(/\s+/).filter(Boolean).forEach(function(e) {
                    return null == o ? void 0 : o.remove(e);
                }), r && "string" == typeof r && r.split(/\s+/).filter(Boolean).forEach(function(e) {
                    return null == o ? void 0 : o.add(e);
                });
            }, [
                r,
                v
            ]), (0, rt.useEffect)(function() {
                var e;
                (null === (e = h.current) || void 0 === e ? void 0 : e.workplace) && (h.current.workplace.tabIndex = u || -1);
            }, [
                u
            ]), (0, rt.useEffect)(function() {
                var e = h.current;
                if ((null == e ? void 0 : e.events) && (s || c)) {
                    var t = function(e) {
                        var t, o;
                        return s && s(null !== (o = null == h || null === (t = h.current) || void 0 === t ? void 0 : t.value) && void 0 !== o ? o : "", e);
                    }, o = function(e) {
                        return c && c(e);
                    };
                    return e.events.on("blur", t).on("change", o), function() {
                        var n;
                        null === (n = e.events) || void 0 === n || n.off("blur", t).off("change", o);
                    };
                }
            }, [
                s,
                c
            ]), (0, rt.useEffect)(function() {
                var e = h.current, t = function() {
                    e && void 0 !== d && e.value !== d && (e.value = d);
                };
                e && (e.isReady ? t() : e.waitForReady().then(t));
            }, [
                d
            ]), it().createElement("div", {
                className: "jodit-react-container"
            }, it().createElement("textarea", {
                defaultValue: d,
                name: l,
                id: a,
                ref: p
            }));
        });
        gz.displayName = "JoditEditor";
        const mz = gz;
        return r;
    })());

},{"5e7d119fdf429a8d":"5jT8D","b01e18314089337f":"9njXz"}],"bZDMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterMatchMode", ()=>FilterMatchMode);
parcelHelpers.export(exports, "FilterOperator", ()=>FilterOperator);
parcelHelpers.export(exports, "FilterService", ()=>FilterService);
parcelHelpers.export(exports, "MessageSeverity", ()=>MessageSeverity);
parcelHelpers.export(exports, "PrimeIcons", ()=>PrimeIcons);
parcelHelpers.export(exports, "PrimeReactContext", ()=>PrimeReactContext);
parcelHelpers.export(exports, "PrimeReactProvider", ()=>PrimeReactProvider);
parcelHelpers.export(exports, "SortOrder", ()=>SortOrder);
parcelHelpers.export(exports, "addLocale", ()=>addLocale);
parcelHelpers.export(exports, "ariaLabel", ()=>ariaLabel);
parcelHelpers.export(exports, "default", ()=>PrimeReact);
parcelHelpers.export(exports, "locale", ()=>locale);
parcelHelpers.export(exports, "localeOption", ()=>localeOption);
parcelHelpers.export(exports, "localeOptions", ()=>localeOptions);
parcelHelpers.export(exports, "updateLocaleOption", ()=>updateLocaleOption);
parcelHelpers.export(exports, "updateLocaleOptions", ()=>updateLocaleOptions);
var _utils = require("primereact/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
var FilterMatchMode = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
var FilterOperator = Object.freeze({
    AND: 'and',
    OR: 'or'
});
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var FilterService = {
    filter: function filter(value, fields, filterValue, filterMatchMode, filterLocale) {
        var filteredItems = [];
        if (!value) return filteredItems;
        var _iterator = _createForOfIteratorHelper(value), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (typeof item === 'string') {
                    if (this.filters[filterMatchMode](item, filterValue, filterLocale)) {
                        filteredItems.push(item);
                        continue;
                    }
                } else {
                    var _iterator2 = _createForOfIteratorHelper(fields), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var field = _step2.value;
                            var fieldValue = (0, _utils.ObjectUtils).resolveFieldData(item, field);
                            if (this.filters[filterMatchMode](fieldValue, filterValue, filterLocale)) {
                                filteredItems.push(item);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return filteredItems;
    },
    filters: {
        startsWith: function startsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.slice(0, filterValue.length) === filterValue;
        },
        contains: function contains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) !== -1;
        },
        notContains: function notContains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) === -1;
        },
        endsWith: function endsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue, stringValue.length - filterValue.length) !== -1;
        },
        equals: function equals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() === filter.getTime();
            return (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) === (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        notEquals: function notEquals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return true;
            if (value.getTime && filter.getTime) return value.getTime() !== filter.getTime();
            return (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) !== (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        "in": function _in(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, _utils.ObjectUtils).equals(value, filter[i])) return true;
            }
            return false;
        },
        notIn: function notIn(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, _utils.ObjectUtils).equals(value, filter[i])) return false;
            }
            return true;
        },
        between: function between(value, filter) {
            if (filter == null || filter[0] == null || filter[1] == null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime) return filter[0].getTime() <= value.getTime() && value.getTime() <= filter[1].getTime();
            return filter[0] <= value && value <= filter[1];
        },
        lt: function lt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() < filter.getTime();
            return value < filter;
        },
        lte: function lte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() <= filter.getTime();
            return value <= filter;
        },
        gt: function gt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() > filter.getTime();
            return value > filter;
        },
        gte: function gte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() >= filter.getTime();
            return value >= filter;
        },
        dateIs: function dateIs(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() === filter.toDateString();
        },
        dateIsNot: function dateIsNot(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() !== filter.toDateString();
        },
        dateBefore: function dateBefore(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() < filter.getTime();
        },
        dateAfter: function dateAfter(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() > filter.getTime();
        }
    },
    register: function register(rule, fn) {
        this.filters[rule] = fn;
    }
};
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * @deprecated please use PrimeReactContext
 */ var PrimeReact$1 = /*#__PURE__*/ _createClass(function PrimeReact() {
    _classCallCheck(this, PrimeReact);
});
_defineProperty(PrimeReact$1, "ripple", false);
_defineProperty(PrimeReact$1, "inputStyle", 'outlined');
_defineProperty(PrimeReact$1, "locale", 'en');
_defineProperty(PrimeReact$1, "appendTo", null);
_defineProperty(PrimeReact$1, "cssTransition", true);
_defineProperty(PrimeReact$1, "autoZIndex", true);
_defineProperty(PrimeReact$1, "hideOverlaysOnDocumentScrolling", false);
_defineProperty(PrimeReact$1, "nonce", null);
_defineProperty(PrimeReact$1, "nullSortOrder", 1);
_defineProperty(PrimeReact$1, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
_defineProperty(PrimeReact$1, "pt", undefined);
_defineProperty(PrimeReact$1, "filterMatchModeOptions", {
    text: [
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.CONTAINS,
        FilterMatchMode.NOT_CONTAINS,
        FilterMatchMode.ENDS_WITH,
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        FilterMatchMode.DATE_IS,
        FilterMatchMode.DATE_IS_NOT,
        FilterMatchMode.DATE_BEFORE,
        FilterMatchMode.DATE_AFTER
    ]
});
_defineProperty(PrimeReact$1, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
    var newLinkElement = document.createElement('link');
    newLinkElement.setAttribute('rel', 'stylesheet');
    newLinkElement.setAttribute('id', linkElementId);
    newLinkElement.setAttribute('href', newThemeUrl);
    newLinkElement.addEventListener('load', function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var locales = {
    en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileSizeTypes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
            cancelEdit: 'Cancel Edit',
            close: 'Close',
            collapseRow: 'Row Collapsed',
            editRow: 'Edit Row',
            expandRow: 'Row Expanded',
            falseLabel: 'False',
            filterConstraint: 'Filter Constraint',
            filterOperator: 'Filter Operator',
            firstPageLabel: 'First Page',
            gridView: 'Grid View',
            hideFilterMenu: 'Hide Filter Menu',
            jumpToPageDropdownLabel: 'Jump to Page Dropdown',
            jumpToPageInputLabel: 'Jump to Page Input',
            lastPageLabel: 'Last Page',
            listView: 'List View',
            moveAllToSource: 'Move All to Source',
            moveAllToTarget: 'Move All to Target',
            moveBottom: 'Move Bottom',
            moveDown: 'Move Down',
            moveToSource: 'Move to Source',
            moveToTarget: 'Move to Target',
            moveTop: 'Move Top',
            moveUp: 'Move Up',
            navigation: 'Navigation',
            next: 'Next',
            nextPageLabel: 'Next Page',
            nullLabel: 'Not Selected',
            pageLabel: 'Page {page}',
            otpLabel: 'Please enter one time password character {0}',
            passwordHide: 'Hide Password',
            passwordShow: 'Show Password',
            previous: 'Previous',
            previousPageLabel: 'Previous Page',
            rotateLeft: 'Rotate Left',
            rotateRight: 'Rotate Right',
            rowsPerPageLabel: 'Rows per page',
            saveEdit: 'Save Edit',
            scrollTop: 'Scroll Top',
            selectAll: 'All items selected',
            selectRow: 'Row Selected',
            showFilterMenu: 'Show Filter Menu',
            slide: 'Slide',
            slideNumber: '{slideNumber}',
            star: '1 star',
            stars: '{star} stars',
            trueLabel: 'True',
            unselectAll: 'All items unselected',
            unselectRow: 'Row Unselected',
            zoomImage: 'Zoom Image',
            zoomIn: 'Zoom In',
            zoomOut: 'Zoom Out'
        }
    }
};
function locale(locale) {
    locale && (PrimeReact$1.locale = locale);
    return {
        locale: PrimeReact$1.locale,
        options: locales[PrimeReact$1.locale]
    };
}
function addLocale(locale, options) {
    if (locale.includes('__proto__') || locale.includes('prototype')) throw new Error('Unsafe locale detected');
    locales[locale] = _objectSpread(_objectSpread({}, locales.en), options);
}
function updateLocaleOption(key, value, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    localeOptions(locale)[key] = value;
}
function updateLocaleOptions(options, locale) {
    if (locale.includes('__proto__') || locale.includes('prototype')) throw new Error('Unsafe locale detected');
    var _locale = locale || PrimeReact$1.locale;
    locales[_locale] = _objectSpread(_objectSpread({}, locales[_locale]), options);
}
function localeOption(key, locale) {
    if (key.includes('__proto__') || key.includes('prototype')) throw new Error('Unsafe key detected');
    var _locale = locale || PrimeReact$1.locale;
    try {
        return localeOptions(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function ariaLabel(ariaKey, options) {
    if (ariaKey.includes('__proto__') || ariaKey.includes('prototype')) throw new Error('Unsafe ariaKey detected');
    var _locale = PrimeReact$1.locale;
    try {
        var _ariaLabel = localeOptions(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function localeOptions(locale) {
    var _locale = locale || PrimeReact$1.locale;
    if (_locale.includes('__proto__') || _locale.includes('prototype')) throw new Error('Unsafe locale detected');
    return locales[_locale];
}
var MessageSeverity = Object.freeze({
    SUCCESS: 'success',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
    SECONDARY: 'secondary',
    CONTRAST: 'contrast'
});
var PrimeIcons = Object.freeze({
    ADDRESS_BOOK: 'pi pi-address-book',
    ALIGN_CENTER: 'pi pi-align-center',
    ALIGN_JUSTIFY: 'pi pi-align-justify',
    ALIGN_LEFT: 'pi pi-align-left',
    ALIGN_RIGHT: 'pi pi-align-right',
    AMAZON: 'pi pi-amazon',
    ANDROID: 'pi pi-android',
    ANGLE_DOUBLE_DOWN: 'pi pi-angle-double-down',
    ANGLE_DOUBLE_LEFT: 'pi pi-angle-double-left',
    ANGLE_DOUBLE_RIGHT: 'pi pi-angle-double-right',
    ANGLE_DOUBLE_UP: 'pi pi-angle-double-up',
    ANGLE_DOWN: 'pi pi-angle-down',
    ANGLE_LEFT: 'pi pi-angle-left',
    ANGLE_RIGHT: 'pi pi-angle-right',
    ANGLE_UP: 'pi pi-angle-up',
    APPLE: 'pi pi-apple',
    ARROW_CIRCLE_DOWN: 'pi pi-arrow-circle-down',
    ARROW_CIRCLE_LEFT: 'pi pi-arrow-circle-left',
    ARROW_CIRCLE_RIGHT: 'pi pi-arrow-circle-right',
    ARROW_CIRCLE_UP: 'pi pi-arrow-circle-up',
    ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER: 'pi pi-arrow-down-left-and-arrow-up-right-to-center',
    ARROW_DOWN_LEFT: 'pi pi-arrow-down-left',
    ARROW_DOWN_RIGHT: 'pi pi-arrow-down-right',
    ARROW_DOWN: 'pi pi-arrow-down',
    ARROW_LEFT: 'pi pi-arrow-left',
    ARROW_RIGHT_ARROW_LEFT: 'pi pi-arrow-right-arrow-left',
    ARROW_RIGHT: 'pi pi-arrow-right',
    ARROW_UP_LEFT: 'pi pi-arrow-up-left',
    ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: 'pi pi-arrow-up-right-and-arrow-down-left-from-center',
    ARROW_UP_RIGHT: 'pi pi-arrow-up-right',
    ARROW_UP: 'pi pi-arrow-up',
    ARROWS_ALT: 'pi pi-arrows-alt',
    ARROWS_H: 'pi pi-arrows-h',
    ARROWS_V: 'pi pi-arrows-v',
    ASTERISK: 'pi pi-asterisk',
    AT: 'pi pi-at',
    BACKWARD: 'pi pi-backward',
    BAN: 'pi pi-ban',
    BARCODE: 'pi pi-barcode',
    BARS: 'pi pi-bars',
    BELL_SLASH: 'pi pi-bell-slash',
    BELL: 'pi pi-bell',
    BITCOIN: 'pi pi-bitcoin',
    BOLT: 'pi pi-bolt',
    BOOK: 'pi pi-book',
    BOOKMARK_FILL: 'pi pi-bookmark-fill',
    BOOKMARK: 'pi pi-bookmark',
    BOX: 'pi pi-box',
    BRIEFCASE: 'pi pi-briefcase',
    BUILDING_COLUMNS: 'pi pi-building-columns',
    BUILDING: 'pi pi-building',
    BULLSEYE: 'pi pi-bullseye',
    CALCULATOR: 'pi pi-calculator',
    CALENDAR_CLOCK: 'pi pi-calendar-clock',
    CALENDAR_MINUS: 'pi pi-calendar-minus',
    CALENDAR_PLUS: 'pi pi-calendar-plus',
    CALENDAR_TIMES: 'pi pi-calendar-times',
    CALENDAR: 'pi pi-calendar',
    CAMERA: 'pi pi-camera',
    CAR: 'pi pi-car',
    CARET_DOWN: 'pi pi-caret-down',
    CARET_LEFT: 'pi pi-caret-left',
    CARET_RIGHT: 'pi pi-caret-right',
    CARET_UP: 'pi pi-caret-up',
    CART_ARROW_DOWN: 'pi pi-cart-arrow-down',
    CART_MINUS: 'pi pi-cart-minus',
    CART_PLUS: 'pi pi-cart-plus',
    CHART_BAR: 'pi pi-chart-bar',
    CHART_LINE: 'pi pi-chart-line',
    CHART_PIE: 'pi pi-chart-pie',
    CHART_SCATTER: 'pi pi-chart-scatter',
    CHECK_CIRCLE: 'pi pi-check-circle',
    CHECK_SQUARE: 'pi pi-check-square',
    CHECK: 'pi pi-check',
    CHEVRON_CIRCLE_DOWN: 'pi pi-chevron-circle-down',
    CHEVRON_CIRCLE_LEFT: 'pi pi-chevron-circle-left',
    CHEVRON_CIRCLE_RIGHT: 'pi pi-chevron-circle-right',
    CHEVRON_CIRCLE_UP: 'pi pi-chevron-circle-up',
    CHEVRON_DOWN: 'pi pi-chevron-down',
    CHEVRON_LEFT: 'pi pi-chevron-left',
    CHEVRON_RIGHT: 'pi pi-chevron-right',
    CHEVRON_UP: 'pi pi-chevron-up',
    CIRCLE_FILL: 'pi pi-circle-fill',
    CIRCLE_OFF: 'pi pi-circle-off',
    CIRCLE_ON: 'pi pi-circle-on',
    CIRCLE: 'pi pi-circle',
    CLIPBOARD: 'pi pi-clipboard',
    CLOCK: 'pi pi-clock',
    CLONE: 'pi pi-clone',
    CLOUD_DOWNLOAD: 'pi pi-cloud-download',
    CLOUD_UPLOAD: 'pi pi-cloud-upload',
    CLOUD: 'pi pi-cloud',
    CODE: 'pi pi-code',
    COG: 'pi pi-cog',
    COMMENT: 'pi pi-comment',
    COMMENTS: 'pi pi-comments',
    COMPASS: 'pi pi-compass',
    COPY: 'pi pi-copy',
    CREDIT_CARD: 'pi pi-credit-card',
    CROWN: 'pi pi-crown',
    DATABASE: 'pi pi-database',
    DELETE_LEFT: 'pi pi-delete-left',
    DESKTOP: 'pi pi-desktop',
    DIRECTIONS_ALT: 'pi pi-directions-alt',
    DIRECTIONS: 'pi pi-directions',
    DISCORD: 'pi pi-discord',
    DOLLAR: 'pi pi-dollar',
    DOWNLOAD: 'pi pi-download',
    EJECT: 'pi pi-eject',
    ELLIPSIS_H: 'pi pi-ellipsis-h',
    ELLIPSIS_V: 'pi pi-ellipsis-v',
    ENVELOPE: 'pi pi-envelope',
    EQUALS: 'pi pi-equals',
    ERASER: 'pi pi-eraser',
    ETHEREUM: 'pi pi-ethereum',
    EURO: 'pi pi-euro',
    EXCLAMATION_CIRCLE: 'pi pi-exclamation-circle',
    EXCLAMATION_TRIANGLE: 'pi pi-exclamation-triangle',
    EXPAND: 'pi pi-expand',
    EXTERNAL_LINK: 'pi pi-external-link',
    EYE_SLASH: 'pi pi-eye-slash',
    EYE: 'pi pi-eye',
    FACE_SMILE: 'pi pi-face-smile',
    FACEBOOK: 'pi pi-facebook',
    FAST_BACKWARD: 'pi pi-fast-backward',
    FAST_FORWARD: 'pi pi-fast-forward',
    FILE_ARROW_UP: 'pi pi-file-arrow-up',
    FILE_CHECK: 'pi pi-file-check',
    FILE_EDIT: 'pi pi-file-edit',
    FILE_EXCEL: 'pi pi-file-excel',
    FILE_EXPORT: 'pi pi-file-export',
    FILE_IMPORT: 'pi pi-file-import',
    FILE_O: 'pi pi-file-o',
    FILE_PDF: 'pi pi-file-pdf',
    FILE_PLUS: 'pi pi-file-plus',
    FILE_WORD: 'pi pi-file-word',
    FILE: 'pi pi-file',
    FILTER_FILL: 'pi pi-filter-fill',
    FILTER_SLASH: 'pi pi-filter-slash',
    FILTER: 'pi pi-filter',
    FLAG_FILL: 'pi pi-flag-fill',
    FLAG: 'pi pi-flag',
    FOLDER_OPEN: 'pi pi-folder-open',
    FOLDER_PLUS: 'pi pi-folder-plus',
    FOLDER: 'pi pi-folder',
    FORWARD: 'pi pi-forward',
    GAUGE: 'pi pi-gauge',
    GIFT: 'pi pi-gift',
    GITHUB: 'pi pi-github',
    GLOBE: 'pi pi-globe',
    GOOGLE: 'pi pi-google',
    GRADUATION_CAP: 'pi pi-graduation-cap',
    HAMMER: 'pi pi-hammer',
    HASHTAG: 'pi pi-hashtag',
    HEADPHONES: 'pi pi-headphones',
    HEART_FILL: 'pi pi-heart-fill',
    HEART: 'pi pi-heart',
    HISTORY: 'pi pi-history',
    HOME: 'pi pi-home',
    HOURGLASS: 'pi pi-hourglass',
    ID_CARD: 'pi pi-id-card',
    IMAGE: 'pi pi-image',
    IMAGES: 'pi pi-images',
    INBOX: 'pi pi-inbox',
    INDIAN_RUPEE: 'pi pi-indian-rupee',
    INFO_CIRCLE: 'pi pi-info-circle',
    INFO: 'pi pi-info',
    INSTAGRAM: 'pi pi-instagram',
    KEY: 'pi pi-key',
    LANGUAGE: 'pi pi-language',
    LIGHTBULB: 'pi pi-lightbulb',
    LINK: 'pi pi-link',
    LINKEDIN: 'pi pi-linkedin',
    LIST_CHECK: 'pi pi-list-check',
    LIST: 'pi pi-list',
    LOCK_OPEN: 'pi pi-lock-open',
    LOCK: 'pi pi-lock',
    MAP_MARKER: 'pi pi-map-marker',
    MAP: 'pi pi-map',
    MARS: 'pi pi-mars',
    MEGAPHONE: 'pi pi-megaphone',
    MICROCHIP_AI: 'pi pi-microchip-ai',
    MICROCHIP: 'pi pi-microchip',
    MICROPHONE: 'pi pi-microphone',
    MICROSOFT: 'pi pi-microsoft',
    MINUS_CIRCLE: 'pi pi-minus-circle',
    MINUS: 'pi pi-minus',
    MOBILE: 'pi pi-mobile',
    MONEY_BILL: 'pi pi-money-bill',
    MOON: 'pi pi-moon',
    OBJECTS_COLUMN: 'pi pi-objects-column',
    PALETTE: 'pi pi-palette',
    PAPERCLIP: 'pi pi-paperclip',
    PAUSE_CIRCLE: 'pi pi-pause-circle',
    PAUSE: 'pi pi-pause',
    PAYPAL: 'pi pi-paypal',
    PEN_TO_SQUARE: 'pi pi-pen-to-square',
    PENCIL: 'pi pi-pencil',
    PERCENTAGE: 'pi pi-percentage',
    PHONE: 'pi pi-phone',
    PINTEREST: 'pi pi-pinterest',
    PLAY_CIRCLE: 'pi pi-play-circle',
    PLAY: 'pi pi-play',
    PLUS_CIRCLE: 'pi pi-plus-circle',
    PLUS: 'pi pi-plus',
    POUND: 'pi pi-pound',
    POWER_OFF: 'pi pi-power-off',
    PRIME: 'pi pi-prime',
    PRINT: 'pi pi-print',
    QRCODE: 'pi pi-qrcode',
    QUESTION_CIRCLE: 'pi pi-question-circle',
    QUESTION: 'pi pi-question',
    RECEIPT: 'pi pi-receipt',
    REDDIT: 'pi pi-reddit',
    REFRESH: 'pi pi-refresh',
    REPLAY: 'pi pi-replay',
    REPLY: 'pi pi-reply',
    SAVE: 'pi pi-save',
    SEARCH_MINUS: 'pi pi-search-minus',
    SEARCH_PLUS: 'pi pi-search-plus',
    SEARCH: 'pi pi-search',
    SEND: 'pi pi-send',
    SERVER: 'pi pi-server',
    SHARE_ALT: 'pi pi-share-alt',
    SHIELD: 'pi pi-shield',
    SHOP: 'pi pi-shop',
    SHOPPING_BAG: 'pi pi-shopping-bag',
    SHOPPING_CART: 'pi pi-shopping-cart',
    SIGN_IN: 'pi pi-sign-in',
    SIGN_OUT: 'pi pi-sign-out',
    SITEMAP: 'pi pi-sitemap',
    SLACK: 'pi pi-slack',
    SLIDERS_H: 'pi pi-sliders-h',
    SLIDERS_V: 'pi pi-sliders-v',
    SORT_ALPHA_DOWN_ALT: 'pi pi-sort-alpha-down-alt',
    SORT_ALPHA_DOWN: 'pi pi-sort-alpha-down',
    SORT_ALPHA_UP_ALT: 'pi pi-sort-alpha-up-alt',
    SORT_ALPHA_UP: 'pi pi-sort-alpha-up',
    SORT_ALT_SLASH: 'pi pi-sort-alt-slash',
    SORT_ALT: 'pi pi-sort-alt',
    SORT_AMOUNT_DOWN_ALT: 'pi pi-sort-amount-down-alt',
    SORT_AMOUNT_DOWN: 'pi pi-sort-amount-down',
    SORT_AMOUNT_UP_ALT: 'pi pi-sort-amount-up-alt',
    SORT_AMOUNT_UP: 'pi pi-sort-amount-up',
    SORT_DOWN_FILL: 'pi pi-sort-down-fill',
    SORT_DOWN: 'pi pi-sort-down',
    SORT_NUMERIC_DOWN_ALT: 'pi pi-sort-numeric-down-alt',
    SORT_NUMERIC_DOWN: 'pi pi-sort-numeric-down',
    SORT_NUMERIC_UP_ALT: 'pi pi-sort-numeric-up-alt',
    SORT_NUMERIC_UP: 'pi pi-sort-numeric-up',
    SORT_UP_FILL: 'pi pi-sort-up-fill',
    SORT_UP: 'pi pi-sort-up',
    SORT: 'pi pi-sort',
    SPARKLES: 'pi pi-sparkles',
    SPINNER_DOTTED: 'pi pi-spinner-dotted',
    SPINNER: 'pi pi-spinner',
    STAR_FILL: 'pi pi-star-fill',
    STAR_HALF_FILL: 'pi pi-star-half-fill',
    STAR_HALF: 'pi pi-star-half',
    STAR: 'pi pi-star',
    STEP_BACKWARD_ALT: 'pi pi-step-backward-alt',
    STEP_BACKWARD: 'pi pi-step-backward',
    STEP_FORWARD_ALT: 'pi pi-step-forward-alt',
    STEP_FORWARD: 'pi pi-step-forward',
    STOP_CIRCLE: 'pi pi-stop-circle',
    STOP: 'pi pi-stop',
    STOPWATCH: 'pi pi-stopwatch',
    SUN: 'pi pi-sun',
    SYNC: 'pi pi-sync',
    TABLE: 'pi pi-table',
    TABLET: 'pi pi-tablet',
    TAG: 'pi pi-tag',
    TAGS: 'pi pi-tags',
    TELEGRAM: 'pi pi-telegram',
    TH_LARGE: 'pi pi-th-large',
    THUMBS_DOWN_FILL: 'pi pi-thumbs-down-fill',
    THUMBS_DOWN: 'pi pi-thumbs-down',
    THUMBS_UP_FILL: 'pi pi-thumbs-up-fill',
    THUMBS_UP: 'pi pi-thumbs-up',
    THUMBTACK: 'pi pi-thumbtack',
    TICKET: 'pi pi-ticket',
    TIKTOK: 'pi pi-tiktok',
    TIMES_CIRCLE: 'pi pi-times-circle',
    TIMES: 'pi pi-times',
    TRASH: 'pi pi-trash',
    TROPHY: 'pi pi-trophy',
    TRUCK: 'pi pi-truck',
    TURKISH_LIRA: 'pi pi-turkish-lira',
    TWITCH: 'pi pi-twitch',
    TWITTER: 'pi pi-twitter',
    UNDO: 'pi pi-undo',
    UNLOCK: 'pi pi-unlock',
    UPLOAD: 'pi pi-upload',
    USER_EDIT: 'pi pi-user-edit',
    USER_MINUS: 'pi pi-user-minus',
    USER_PLUS: 'pi pi-user-plus',
    USER: 'pi pi-user',
    USERS: 'pi pi-users',
    VENUS: 'pi pi-venus',
    VERIFIED: 'pi pi-verified',
    VIDEO: 'pi pi-video',
    VIMEO: 'pi pi-vimeo',
    VOLUME_DOWN: 'pi pi-volume-down',
    VOLUME_OFF: 'pi pi-volume-off',
    VOLUME_UP: 'pi pi-volume-up',
    WALLET: 'pi pi-wallet',
    WAREHOUSE: 'pi pi-warehouse',
    WAVE_PULSE: 'pi pi-wave-pulse',
    WHATSAPP: 'pi pi-whatsapp',
    WIFI: 'pi pi-wifi',
    WINDOW_MAXIMIZE: 'pi pi-window-maximize',
    WINDOW_MINIMIZE: 'pi pi-window-minimize',
    WRENCH: 'pi pi-wrench',
    YOUTUBE: 'pi pi-youtube'
});
var SortOrder = Object.freeze({
    DESC: -1,
    UNSORTED: 0,
    ASC: 1
});
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var PrimeReactContext = /*#__PURE__*/ (0, _reactDefault.default).createContext();
var PrimeReactProvider = function PrimeReactProvider(props) {
    var _props$value, _propsValue$ripple, _propsValue$inputStyl, _propsValue$locale, _propsValue$appendTo, _propsValue$styleCont, _propsValue$cssTransi, _propsValue$autoZInde, _propsValue$hideOverl, _propsValue$nonce, _propsValue$nullSortO, _propsValue$zIndex, _propsValue$ptOptions, _propsValue$pt, _propsValue$unstyled, _propsValue$filterMat;
    var propsValue = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : {};
    var _useState = (0, _react.useState)((_propsValue$ripple = propsValue.ripple) !== null && _propsValue$ripple !== void 0 ? _propsValue$ripple : false), _useState2 = _slicedToArray(_useState, 2), ripple = _useState2[0], setRipple = _useState2[1];
    var _useState3 = (0, _react.useState)((_propsValue$inputStyl = propsValue.inputStyle) !== null && _propsValue$inputStyl !== void 0 ? _propsValue$inputStyl : 'outlined'), _useState4 = _slicedToArray(_useState3, 2), inputStyle = _useState4[0], setInputStyle = _useState4[1];
    var _useState5 = (0, _react.useState)((_propsValue$locale = propsValue.locale) !== null && _propsValue$locale !== void 0 ? _propsValue$locale : 'en'), _useState6 = _slicedToArray(_useState5, 2), locale = _useState6[0], setLocale = _useState6[1];
    var _useState7 = (0, _react.useState)((_propsValue$appendTo = propsValue.appendTo) !== null && _propsValue$appendTo !== void 0 ? _propsValue$appendTo : null), _useState8 = _slicedToArray(_useState7, 2), appendTo = _useState8[0], setAppendTo = _useState8[1];
    var _useState9 = (0, _react.useState)((_propsValue$styleCont = propsValue.styleContainer) !== null && _propsValue$styleCont !== void 0 ? _propsValue$styleCont : null), _useState10 = _slicedToArray(_useState9, 2), styleContainer = _useState10[0], setStyleContainer = _useState10[1];
    var _useState11 = (0, _react.useState)((_propsValue$cssTransi = propsValue.cssTransition) !== null && _propsValue$cssTransi !== void 0 ? _propsValue$cssTransi : true), _useState12 = _slicedToArray(_useState11, 2), cssTransition = _useState12[0], setCssTransition = _useState12[1];
    var _useState13 = (0, _react.useState)((_propsValue$autoZInde = propsValue.autoZIndex) !== null && _propsValue$autoZInde !== void 0 ? _propsValue$autoZInde : true), _useState14 = _slicedToArray(_useState13, 2), autoZIndex = _useState14[0], setAutoZIndex = _useState14[1];
    var _useState15 = (0, _react.useState)((_propsValue$hideOverl = propsValue.hideOverlaysOnDocumentScrolling) !== null && _propsValue$hideOverl !== void 0 ? _propsValue$hideOverl : false), _useState16 = _slicedToArray(_useState15, 2), hideOverlaysOnDocumentScrolling = _useState16[0], setHideOverlaysOnDocumentScrolling = _useState16[1];
    var _useState17 = (0, _react.useState)((_propsValue$nonce = propsValue.nonce) !== null && _propsValue$nonce !== void 0 ? _propsValue$nonce : null), _useState18 = _slicedToArray(_useState17, 2), nonce = _useState18[0], setNonce = _useState18[1];
    var _useState19 = (0, _react.useState)((_propsValue$nullSortO = propsValue.nullSortOrder) !== null && _propsValue$nullSortO !== void 0 ? _propsValue$nullSortO : 1), _useState20 = _slicedToArray(_useState19, 2), nullSortOrder = _useState20[0], setNullSortOrder = _useState20[1];
    var _useState21 = (0, _react.useState)((_propsValue$zIndex = propsValue.zIndex) !== null && _propsValue$zIndex !== void 0 ? _propsValue$zIndex : {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100,
        toast: 1200
    }), _useState22 = _slicedToArray(_useState21, 2), zIndex = _useState22[0], setZIndex = _useState22[1];
    var _useState23 = (0, _react.useState)((_propsValue$ptOptions = propsValue.ptOptions) !== null && _propsValue$ptOptions !== void 0 ? _propsValue$ptOptions : {
        mergeSections: true,
        mergeProps: true
    }), _useState24 = _slicedToArray(_useState23, 2), ptOptions = _useState24[0], setPtOptions = _useState24[1];
    var _useState25 = (0, _react.useState)((_propsValue$pt = propsValue.pt) !== null && _propsValue$pt !== void 0 ? _propsValue$pt : undefined), _useState26 = _slicedToArray(_useState25, 2), pt = _useState26[0], setPt = _useState26[1];
    var _useState27 = (0, _react.useState)((_propsValue$unstyled = propsValue.unstyled) !== null && _propsValue$unstyled !== void 0 ? _propsValue$unstyled : false), _useState28 = _slicedToArray(_useState27, 2), unstyled = _useState28[0], setUnstyled = _useState28[1];
    var _useState29 = (0, _react.useState)((_propsValue$filterMat = propsValue.filterMatchModeOptions) !== null && _propsValue$filterMat !== void 0 ? _propsValue$filterMat : {
        text: [
            FilterMatchMode.STARTS_WITH,
            FilterMatchMode.CONTAINS,
            FilterMatchMode.NOT_CONTAINS,
            FilterMatchMode.ENDS_WITH,
            FilterMatchMode.EQUALS,
            FilterMatchMode.NOT_EQUALS
        ],
        numeric: [
            FilterMatchMode.EQUALS,
            FilterMatchMode.NOT_EQUALS,
            FilterMatchMode.LESS_THAN,
            FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
            FilterMatchMode.GREATER_THAN,
            FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
        ],
        date: [
            FilterMatchMode.DATE_IS,
            FilterMatchMode.DATE_IS_NOT,
            FilterMatchMode.DATE_BEFORE,
            FilterMatchMode.DATE_AFTER
        ]
    }), _useState30 = _slicedToArray(_useState29, 2), filterMatchModeOptions = _useState30[0], setFilterMatchModeOptions = _useState30[1];
    var changeTheme = function changeTheme(currentTheme, newTheme, linkElementId, callback) {
        var _linkElement$parentNo;
        var linkElement = document.getElementById(linkElementId);
        if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
        var newThemeUrl = linkElement.getAttribute('href').replace(currentTheme, newTheme);
        var newLinkElement = document.createElement('link');
        newLinkElement.setAttribute('rel', 'stylesheet');
        newLinkElement.setAttribute('id', linkElementId);
        newLinkElement.setAttribute('href', newThemeUrl);
        newLinkElement.addEventListener('load', function() {
            if (callback) callback();
        });
        (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
    };
    /**
   * @deprecated
   */ (0, _reactDefault.default).useEffect(function() {
        PrimeReact$1.ripple = ripple;
    }, [
        ripple
    ]);
    /**
   * @deprecated
   */ (0, _reactDefault.default).useEffect(function() {
        PrimeReact$1.inputStyle = inputStyle;
    }, [
        inputStyle
    ]);
    /**
   * @deprecated
   */ (0, _reactDefault.default).useEffect(function() {
        PrimeReact$1.locale = locale;
    }, [
        locale
    ]);
    var value = {
        changeTheme: changeTheme,
        ripple: ripple,
        setRipple: setRipple,
        inputStyle: inputStyle,
        setInputStyle: setInputStyle,
        locale: locale,
        setLocale: setLocale,
        appendTo: appendTo,
        setAppendTo: setAppendTo,
        styleContainer: styleContainer,
        setStyleContainer: setStyleContainer,
        cssTransition: cssTransition,
        setCssTransition: setCssTransition,
        autoZIndex: autoZIndex,
        setAutoZIndex: setAutoZIndex,
        hideOverlaysOnDocumentScrolling: hideOverlaysOnDocumentScrolling,
        setHideOverlaysOnDocumentScrolling: setHideOverlaysOnDocumentScrolling,
        nonce: nonce,
        setNonce: setNonce,
        nullSortOrder: nullSortOrder,
        setNullSortOrder: setNullSortOrder,
        zIndex: zIndex,
        setZIndex: setZIndex,
        ptOptions: ptOptions,
        setPtOptions: setPtOptions,
        pt: pt,
        setPt: setPt,
        filterMatchModeOptions: filterMatchModeOptions,
        setFilterMatchModeOptions: setFilterMatchModeOptions,
        unstyled: unstyled,
        setUnstyled: setUnstyled
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PrimeReactContext.Provider, {
        value: value
    }, props.children);
};
var PrimeReact = PrimeReact$1;

},{"primereact/utils":"9PV0i","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PV0i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomHandler", ()=>DomHandler);
parcelHelpers.export(exports, "EventBus", ()=>EventBus);
parcelHelpers.export(exports, "IconUtils", ()=>IconUtils);
parcelHelpers.export(exports, "ObjectUtils", ()=>ObjectUtils);
parcelHelpers.export(exports, "UniqueComponentId", ()=>UniqueComponentId);
parcelHelpers.export(exports, "ZIndexUtils", ()=>ZIndexUtils);
parcelHelpers.export(exports, "classNames", ()=>classNames);
parcelHelpers.export(exports, "mask", ()=>mask);
parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
var _react = require("react");
'use client';
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest();
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function classNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args) {
        var classes = [];
        for(var i = 0; i < args.length; i++){
            var className = args[i];
            if (!className) continue;
            var type = _typeof(className);
            if (type === 'string' || type === 'number') classes.push(className);
            else if (type === 'object') {
                var _classes = Array.isArray(className) ? className : Object.entries(className).map(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return value ? key : null;
                });
                classes = _classes.length ? classes.concat(_classes.filter(function(c) {
                    return !!c;
                })) : classes;
            }
        }
        return classes.join(' ').trim();
    }
    return undefined;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread();
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var DomHandler = /*#__PURE__*/ function() {
    function DomHandler() {
        _classCallCheck(this, DomHandler);
    }
    return _createClass(DomHandler, null, [
        {
            key: "innerWidth",
            value: function innerWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width + (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "width",
            value: function width(el) {
                if (el) {
                    var _width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    _width = _width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return _width;
                }
                return 0;
            }
        },
        {
            key: "getBrowserLanguage",
            value: function getBrowserLanguage() {
                return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
            }
        },
        {
            key: "getWindowScrollTop",
            value: function getWindowScrollTop() {
                var doc = document.documentElement;
                return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            }
        },
        {
            key: "getWindowScrollLeft",
            value: function getWindowScrollLeft() {
                var doc = document.documentElement;
                return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            }
        },
        {
            key: "getOuterWidth",
            value: function getOuterWidth(el, margin) {
                if (el) {
                    var width = el.getBoundingClientRect().width || el.offsetWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getOuterHeight",
            value: function getOuterHeight(el, margin) {
                if (el) {
                    var height = el.getBoundingClientRect().height || el.offsetHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight(el, margin) {
                if (el) {
                    var height = el.clientHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth(el, margin) {
                if (el) {
                    var width = el.clientWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getViewport",
            value: function getViewport() {
                var win = window;
                var d = document;
                var e = d.documentElement;
                var g = d.getElementsByTagName('body')[0];
                var w = win.innerWidth || e.clientWidth || g.clientWidth;
                var h = win.innerHeight || e.clientHeight || g.clientHeight;
                return {
                    width: w,
                    height: h
                };
            }
        },
        {
            key: "getOffset",
            value: function getOffset(el) {
                if (el) {
                    var rect = el.getBoundingClientRect();
                    return {
                        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "index",
            value: function index(element) {
                if (element) {
                    var children = element.parentNode.childNodes;
                    var num = 0;
                    for(var i = 0; i < children.length; i++){
                        if (children[i] === element) return num;
                        if (children[i].nodeType === 1) num++;
                    }
                }
                return -1;
            }
        },
        {
            key: "addMultipleClasses",
            value: function addMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.add(styles[i]);
                    } else {
                        var _styles = className.split(' ');
                        for(var _i = 0; _i < _styles.length; _i++)element.className = element.className + (' ' + _styles[_i]);
                    }
                }
            }
        },
        {
            key: "removeMultipleClasses",
            value: function removeMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.remove(styles[i]);
                    } else {
                        var _styles2 = className.split(' ');
                        for(var _i2 = 0; _i2 < _styles2.length; _i2++)element.className = element.className.replace(new RegExp('(^|\\b)' + _styles2[_i2].split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }
                }
            }
        },
        {
            key: "addClass",
            value: function addClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.add(className);
                    else element.className = element.className + (' ' + className);
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.remove(className);
                    else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
            }
        },
        {
            key: "hasClass",
            value: function hasClass(element, className) {
                if (element) {
                    if (element.classList) return element.classList.contains(className);
                    return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
                }
                return false;
            }
        },
        {
            key: "addStyles",
            value: function addStyles(element) {
                var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) Object.entries(styles).forEach(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return element.style[key] = value;
                });
            }
        },
        {
            key: "find",
            value: function find(element, selector) {
                return element ? Array.from(element.querySelectorAll(selector)) : [];
            }
        },
        {
            key: "findSingle",
            value: function findSingle(element, selector) {
                if (element) return element.querySelector(selector);
                return null;
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes(element) {
                var _this = this;
                var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) {
                    var _computedStyles = function computedStyles(rule, value) {
                        var _element$$attrs, _element$$attrs2;
                        var styles = element !== null && element !== void 0 && (_element$$attrs = element.$attrs) !== null && _element$$attrs !== void 0 && _element$$attrs[rule] ? [
                            element === null || element === void 0 || (_element$$attrs2 = element.$attrs) === null || _element$$attrs2 === void 0 ? void 0 : _element$$attrs2[rule]
                        ] : [];
                        return [
                            value
                        ].flat().reduce(function(cv, v) {
                            if (v !== null && v !== undefined) {
                                var type = _typeof(v);
                                if (type === 'string' || type === 'number') cv.push(v);
                                else if (type === 'object') {
                                    var _cv = Array.isArray(v) ? _computedStyles(rule, v) : Object.entries(v).map(function(_ref3) {
                                        var _ref4 = _slicedToArray(_ref3, 2), _k = _ref4[0], _v = _ref4[1];
                                        return rule === 'style' && (!!_v || _v === 0) ? "".concat(_k.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(), ":").concat(_v) : _v ? _k : undefined;
                                    });
                                    cv = _cv.length ? cv.concat(_cv.filter(function(c) {
                                        return !!c;
                                    })) : cv;
                                }
                            }
                            return cv;
                        }, styles);
                    };
                    Object.entries(attributes).forEach(function(_ref5) {
                        var _ref6 = _slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
                        if (value !== undefined && value !== null) {
                            var matchedEvent = key.match(/^on(.+)/);
                            if (matchedEvent) element.addEventListener(matchedEvent[1].toLowerCase(), value);
                            else if (key === 'p-bind') _this.setAttributes(element, value);
                            else {
                                value = key === 'class' ? _toConsumableArray(new Set(_computedStyles('class', value))).join(' ').trim() : key === 'style' ? _computedStyles('style', value).join(';').trim() : value;
                                element.$attrs = element.$attrs || {}, element.$attrs[key] = value;
                                element.setAttribute(key, value);
                            }
                        }
                    });
                }
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(element, name) {
                if (element) {
                    var value = element.getAttribute(name);
                    if (!isNaN(value)) return +value;
                    if (value === 'true' || value === 'false') return value === 'true';
                    return value;
                }
                return undefined;
            }
        },
        {
            key: "isAttributeEquals",
            value: function isAttributeEquals(element, name, value) {
                return element ? this.getAttribute(element, name) === value : false;
            }
        },
        {
            key: "isAttributeNotEquals",
            value: function isAttributeNotEquals(element, name, value) {
                return !this.isAttributeEquals(element, name, value);
            }
        },
        {
            key: "getHeight",
            value: function getHeight(el) {
                if (el) {
                    var height = el.offsetHeight;
                    var style = getComputedStyle(el);
                    height = height - (parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getWidth",
            value: function getWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "alignOverlay",
            value: function alignOverlay(overlay, target, appendTo) {
                var calculateMinWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (overlay && target) {
                    if (appendTo === 'self') this.relativePosition(overlay, target);
                    else {
                        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + 'px');
                        this.absolutePosition(overlay, target);
                    }
                }
            }
        },
        {
            key: "absolutePosition",
            value: function absolutePosition(element, target) {
                var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left';
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var elementOuterHeight = elementDimensions.height;
                    var elementOuterWidth = elementDimensions.width;
                    var targetOuterHeight = target.offsetHeight;
                    var targetOuterWidth = target.offsetWidth;
                    var targetOffset = target.getBoundingClientRect();
                    var windowScrollTop = this.getWindowScrollTop();
                    var windowScrollLeft = this.getWindowScrollLeft();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
                        top = targetOffset.top + windowScrollTop - elementOuterHeight;
                        if (top < 0) top = windowScrollTop;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetOuterHeight + targetOffset.top + windowScrollTop;
                        element.style.transformOrigin = 'top';
                    }
                    var targetOffsetPx = targetOffset.left;
                    var alignOffset = align === 'left' ? 0 : elementOuterWidth - targetOuterWidth;
                    if (targetOffsetPx + targetOuterWidth + elementOuterWidth > viewport.width) left = Math.max(0, targetOffsetPx + windowScrollLeft + targetOuterWidth - elementOuterWidth);
                    else left = targetOffsetPx - alignOffset + windowScrollLeft;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "relativePosition",
            value: function relativePosition(element, target) {
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var targetHeight = target.offsetHeight;
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
                        top = -1 * elementDimensions.height;
                        if (targetOffset.top + top < 0) top = -1 * targetOffset.top;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetHeight;
                        element.style.transformOrigin = 'top';
                    }
                    if (elementDimensions.width > viewport.width) // element wider then viewport and cannot fit on screen (align at left side of viewport)
                    left = targetOffset.left * -1;
                    else if (targetOffset.left + elementDimensions.width > viewport.width) // element wider then viewport but can be fit on screen (align at right side of viewport)
                    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
                    else // element fits on screen (align with target)
                    left = 0;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "flipfitCollision",
            value: function flipfitCollision(element, target) {
                var _this2 = this;
                var my = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left top';
                var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'left bottom';
                var callback = arguments.length > 4 ? arguments[4] : undefined;
                if (element && target) {
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var myArr = my.split(' ');
                    var atArr = at.split(' ');
                    var getPositionValue = function getPositionValue(arr, isOffset) {
                        return isOffset ? +arr.substring(arr.search(/(\+|-)/g)) || 0 : arr.substring(0, arr.search(/(\+|-)/g)) || arr;
                    };
                    var position = {
                        my: {
                            x: getPositionValue(myArr[0]),
                            y: getPositionValue(myArr[1] || myArr[0]),
                            offsetX: getPositionValue(myArr[0], true),
                            offsetY: getPositionValue(myArr[1] || myArr[0], true)
                        },
                        at: {
                            x: getPositionValue(atArr[0]),
                            y: getPositionValue(atArr[1] || atArr[0]),
                            offsetX: getPositionValue(atArr[0], true),
                            offsetY: getPositionValue(atArr[1] || atArr[0], true)
                        }
                    };
                    var myOffset = {
                        left: function left() {
                            var totalOffset = position.my.offsetX + position.at.offsetX;
                            return totalOffset + targetOffset.left + (position.my.x === 'left' ? 0 : -1 * (position.my.x === 'center' ? _this2.getOuterWidth(element) / 2 : _this2.getOuterWidth(element)));
                        },
                        top: function top() {
                            var totalOffset = position.my.offsetY + position.at.offsetY;
                            return totalOffset + targetOffset.top + (position.my.y === 'top' ? 0 : -1 * (position.my.y === 'center' ? _this2.getOuterHeight(element) / 2 : _this2.getOuterHeight(element)));
                        }
                    };
                    var alignWithAt = {
                        count: {
                            x: 0,
                            y: 0
                        },
                        left: function left() {
                            var left = myOffset.left();
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left < 0) {
                                this.count.x++;
                                position.my.x = 'left';
                                position.at.x = 'right';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.right();
                            }
                        },
                        right: function right() {
                            var left = myOffset.left() + DomHandler.getOuterWidth(target);
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = viewport.width - DomHandler.getOuterWidth(element) + scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left + DomHandler.getOuterWidth(element) > viewport.width) {
                                this.count.x++;
                                position.my.x = 'right';
                                position.at.x = 'left';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.left();
                            }
                        },
                        top: function top() {
                            var top = myOffset.top();
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top < 0) {
                                this.count.y++;
                                position.my.y = 'top';
                                position.at.y = 'bottom';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.bottom();
                            }
                        },
                        bottom: function bottom() {
                            var top = myOffset.top() + DomHandler.getOuterHeight(target);
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = viewport.height - DomHandler.getOuterHeight(element) + scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top + DomHandler.getOuterHeight(target) > viewport.height) {
                                this.count.y++;
                                position.my.y = 'bottom';
                                position.at.y = 'top';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.top();
                            }
                        },
                        center: function center(axis) {
                            if (axis === 'y') {
                                var top = myOffset.top() + DomHandler.getOuterHeight(target) / 2;
                                element.style.top = top + DomHandler.getWindowScrollTop() + 'px';
                                if (top < 0) this.bottom();
                                else if (top + DomHandler.getOuterHeight(target) > viewport.height) this.top();
                            } else {
                                var left = myOffset.left() + DomHandler.getOuterWidth(target) / 2;
                                element.style.left = left + DomHandler.getWindowScrollLeft() + 'px';
                                if (left < 0) this.left();
                                else if (left + DomHandler.getOuterWidth(element) > viewport.width) this.right();
                            }
                        }
                    };
                    alignWithAt[position.at.x]('x');
                    alignWithAt[position.at.y]('y');
                    if (this.isFunction(callback)) callback(position);
                }
            }
        },
        {
            key: "findCollisionPosition",
            value: function findCollisionPosition(position) {
                if (position) {
                    var isAxisY = position === 'top' || position === 'bottom';
                    var myXPosition = position === 'left' ? 'right' : 'left';
                    var myYPosition = position === 'top' ? 'bottom' : 'top';
                    if (isAxisY) return {
                        axis: 'y',
                        my: "center ".concat(myYPosition),
                        at: "center ".concat(position)
                    };
                    return {
                        axis: 'x',
                        my: "".concat(myXPosition, " center"),
                        at: "".concat(position, " center")
                    };
                }
            }
        },
        {
            key: "getParents",
            value: function getParents(element) {
                var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return element.parentNode === null ? parents : this.getParents(element.parentNode, parents.concat([
                    element.parentNode
                ]));
            }
        },
        {
            key: "getScrollableParents",
            value: function getScrollableParents(element) {
                var hideOverlaysOnDocumentScrolling = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var scrollableParents = [];
                if (element) {
                    var parents = this.getParents(element);
                    var overflowRegex = /(auto|scroll)/;
                    var overflowCheck = function overflowCheck(node) {
                        var styleDeclaration = node ? getComputedStyle(node) : null;
                        return styleDeclaration && (overflowRegex.test(styleDeclaration.getPropertyValue('overflow')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflow-x')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflow-y')));
                    };
                    var addScrollableParent = function addScrollableParent(node) {
                        if (hideOverlaysOnDocumentScrolling) // nodeType 9 is for document element
                        scrollableParents.push(node.nodeName === 'BODY' || node.nodeName === 'HTML' || node.nodeType === 9 ? window : node);
                        else scrollableParents.push(node);
                    };
                    var _iterator = _createForOfIteratorHelper$1(parents), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var parent = _step.value;
                            var scrollSelectors = parent.nodeType === 1 && parent.dataset.scrollselectors;
                            if (scrollSelectors) {
                                var selectors = scrollSelectors.split(',');
                                var _iterator2 = _createForOfIteratorHelper$1(selectors), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var selector = _step2.value;
                                        var el = this.findSingle(parent, selector);
                                        if (el && overflowCheck(el)) addScrollableParent(el);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            // BODY
                            if (parent.nodeType === 1 && overflowCheck(parent)) addScrollableParent(parent);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                // we should always at least have the body or window
                if (!scrollableParents.some(function(node) {
                    return node === document.body || node === window;
                })) scrollableParents.push(window);
                return scrollableParents;
            }
        },
        {
            key: "getHiddenElementOuterHeight",
            value: function getHiddenElementOuterHeight(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementHeight = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementHeight;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementOuterWidth",
            value: function getHiddenElementOuterWidth(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementWidth = element.offsetWidth;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementWidth;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementDimensions",
            value: function getHiddenElementDimensions(element) {
                var dimensions = {};
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    dimensions.width = element.offsetWidth;
                    dimensions.height = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                }
                return dimensions;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(element, duration) {
                if (element) {
                    element.style.opacity = 0;
                    var last = +new Date();
                    var opacity = 0;
                    var _tick = function tick() {
                        opacity = +element.style.opacity + (new Date().getTime() - last) / duration;
                        element.style.opacity = opacity;
                        last = +new Date();
                        if (+opacity < 1) window.requestAnimationFrame && requestAnimationFrame(_tick) || setTimeout(_tick, 16);
                    };
                    _tick();
                }
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(element, duration) {
                if (element) {
                    var opacity = 1;
                    var interval = 50;
                    var gap = interval / duration;
                    var fading = setInterval(function() {
                        opacity = opacity - gap;
                        if (opacity <= 0) {
                            opacity = 0;
                            clearInterval(fading);
                        }
                        element.style.opacity = opacity;
                    }, interval);
                }
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return navigator.userAgent;
            }
        },
        {
            key: "isIOS",
            value: function isIOS() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }
        },
        {
            key: "isAndroid",
            value: function isAndroid() {
                return /(android)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isChrome",
            value: function isChrome() {
                return /(chrome)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isClient",
            value: function isClient() {
                return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
            }
        },
        {
            key: "isTouchDevice",
            value: function isTouchDevice() {
                return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(element, target) {
                if (this.isElement(target)) target.appendChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.appendChild(element);
                else throw new Error('Cannot append ' + target + ' to ' + element);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(element, target) {
                if (this.isElement(target)) target.removeChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.removeChild(element);
                else throw new Error('Cannot remove ' + element + ' from ' + target);
            }
        },
        {
            key: "isElement",
            value: function isElement(obj) {
                return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && _typeof(obj) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string';
            }
        },
        {
            key: "scrollInView",
            value: function scrollInView(container, item) {
                var borderTopValue = getComputedStyle(container).getPropertyValue('border-top-width');
                var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
                var paddingTopValue = getComputedStyle(container).getPropertyValue('padding-top');
                var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
                var scroll = container.scrollTop;
                var elementHeight = container.clientHeight;
                var itemHeight = this.getOuterHeight(item);
                if (offset < 0) container.scrollTop = scroll + offset;
                else if (offset + itemHeight > elementHeight) container.scrollTop = scroll + offset - elementHeight + itemHeight;
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                if (window.getSelection) {
                    if (window.getSelection().empty) window.getSelection().empty();
                    else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) window.getSelection().removeAllRanges();
                } else if (document.selection && document.selection.empty) try {
                    document.selection.empty();
                } catch (error) {
                //ignore IE bug
                }
            }
        },
        {
            key: "calculateScrollbarWidth",
            value: function calculateScrollbarWidth(el) {
                if (el) {
                    var style = getComputedStyle(el);
                    return el.offsetWidth - el.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
                }
                if (this.calculatedScrollbarWidth != null) return this.calculatedScrollbarWidth;
                var scrollDiv = document.createElement('div');
                scrollDiv.className = 'p-scrollbar-measure';
                document.body.appendChild(scrollDiv);
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                this.calculatedScrollbarWidth = scrollbarWidth;
                return scrollbarWidth;
            }
        },
        {
            key: "calculateBodyScrollbarWidth",
            value: function calculateBodyScrollbarWidth() {
                return window.innerWidth - document.documentElement.offsetWidth;
            }
        },
        {
            key: "getBrowser",
            value: function getBrowser() {
                if (!this.browser) {
                    var matched = this.resolveUserAgent();
                    this.browser = {};
                    if (matched.browser) {
                        this.browser[matched.browser] = true;
                        this.browser.version = matched.version;
                    }
                    if (this.browser.chrome) this.browser.webkit = true;
                    else if (this.browser.webkit) this.browser.safari = true;
                }
                return this.browser;
            }
        },
        {
            key: "resolveUserAgent",
            value: function resolveUserAgent() {
                var ua = navigator.userAgent.toLowerCase();
                var match = /(chrome)[ ]([\w.]+)/.exec(ua) || /(webkit)[ ]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
                return {
                    browser: match[1] || '',
                    version: match[2] || '0'
                };
            }
        },
        {
            key: "blockBodyScroll",
            value: function blockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p-overflow-hidden';
                /* PR Ref: https://github.com/primefaces/primereact/pull/4976
       * @todo This method is called several times after this PR. Refactors will be made to prevent this in future releases.
       */ var hasScrollbarWidth = !!document.body.style.getPropertyValue('--scrollbar-width');
                !hasScrollbarWidth && document.body.style.setProperty('--scrollbar-width', this.calculateBodyScrollbarWidth() + 'px');
                this.addClass(document.body, className);
            }
        },
        {
            key: "unblockBodyScroll",
            value: function unblockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p-overflow-hidden';
                document.body.style.removeProperty('--scrollbar-width');
                this.removeClass(document.body, className);
            }
        },
        {
            key: "isVisible",
            value: function isVisible(element) {
                // https://stackoverflow.com/a/59096915/502366 (in future use IntersectionObserver)
                return element && (element.clientHeight !== 0 || element.getClientRects().length !== 0 || getComputedStyle(element).display !== 'none');
            }
        },
        {
            key: "isExist",
            value: function isExist(element) {
                return !!(element !== null && typeof element !== 'undefined' && element.nodeName && element.parentNode);
            }
        },
        {
            key: "getFocusableElements",
            value: function getFocusableElements(element) {
                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var focusableElements = DomHandler.find(element, "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])".concat(selector, ",\n                [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector));
                var visibleFocusableElements = [];
                var _iterator3 = _createForOfIteratorHelper$1(focusableElements), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var focusableElement = _step3.value;
                        if (getComputedStyle(focusableElement).display !== 'none' && getComputedStyle(focusableElement).visibility !== 'hidden') visibleFocusableElements.push(focusableElement);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return visibleFocusableElements;
            }
        },
        {
            key: "getFirstFocusableElement",
            value: function getFirstFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[0] : null;
            }
        },
        {
            key: "getLastFocusableElement",
            value: function getLastFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
            }
        },
        {
            key: "focus",
            value: function focus(el, scrollTo) {
                var preventScroll = scrollTo === undefined ? true : !scrollTo;
                el && document.activeElement !== el && el.focus({
                    preventScroll: preventScroll
                });
            }
        },
        {
            key: "focusFirstElement",
            value: function focusFirstElement(el, scrollTo) {
                if (!el) return;
                var firstFocusableElement = DomHandler.getFirstFocusableElement(el);
                firstFocusableElement && DomHandler.focus(firstFocusableElement, scrollTo);
                return firstFocusableElement;
            }
        },
        {
            key: "getCursorOffset",
            value: function getCursorOffset(el, prevText, nextText, currentText) {
                if (el) {
                    var style = getComputedStyle(el);
                    var ghostDiv = document.createElement('div');
                    ghostDiv.style.position = 'absolute';
                    ghostDiv.style.top = '0px';
                    ghostDiv.style.left = '0px';
                    ghostDiv.style.visibility = 'hidden';
                    ghostDiv.style.pointerEvents = 'none';
                    ghostDiv.style.overflow = style.overflow;
                    ghostDiv.style.width = style.width;
                    ghostDiv.style.height = style.height;
                    ghostDiv.style.padding = style.padding;
                    ghostDiv.style.border = style.border;
                    ghostDiv.style.overflowWrap = style.overflowWrap;
                    ghostDiv.style.whiteSpace = style.whiteSpace;
                    ghostDiv.style.lineHeight = style.lineHeight;
                    ghostDiv.innerHTML = prevText.replace(/\r\n|\r|\n/g, '<br />');
                    var ghostSpan = document.createElement('span');
                    ghostSpan.textContent = currentText;
                    ghostDiv.appendChild(ghostSpan);
                    var text = document.createTextNode(nextText);
                    ghostDiv.appendChild(text);
                    document.body.appendChild(ghostDiv);
                    var offsetLeft = ghostSpan.offsetLeft, offsetTop = ghostSpan.offsetTop, clientHeight = ghostSpan.clientHeight;
                    document.body.removeChild(ghostDiv);
                    return {
                        left: Math.abs(offsetLeft - el.scrollLeft),
                        top: Math.abs(offsetTop - el.scrollTop) + clientHeight
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "invokeElementMethod",
            value: function invokeElementMethod(element, methodName, args) {
                element[methodName].apply(element, args);
            }
        },
        {
            key: "isClickable",
            value: function isClickable(element) {
                var targetNode = element.nodeName;
                var parentNode = element.parentElement && element.parentElement.nodeName;
                return targetNode === 'INPUT' || targetNode === 'TEXTAREA' || targetNode === 'BUTTON' || targetNode === 'A' || parentNode === 'INPUT' || parentNode === 'TEXTAREA' || parentNode === 'BUTTON' || parentNode === 'A' || this.hasClass(element, 'p-button') || this.hasClass(element.parentElement, 'p-button') || this.hasClass(element.parentElement, 'p-checkbox') || this.hasClass(element.parentElement, 'p-radiobutton');
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(element, style) {
                if (typeof style === 'string') element.style.cssText = style;
                else for(var prop in style)element.style[prop] = style[prop];
            }
        },
        {
            key: "exportCSV",
            value: function exportCSV(csv, filename) {
                var blob = new Blob([
                    csv
                ], {
                    type: 'application/csv;charset=utf-8;'
                });
                if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename + '.csv');
                else {
                    var isDownloaded = DomHandler.saveAs({
                        name: filename + '.csv',
                        src: URL.createObjectURL(blob)
                    });
                    if (!isDownloaded) {
                        csv = 'data:text/csv;charset=utf-8,' + csv;
                        window.open(encodeURI(csv));
                    }
                }
            }
        },
        {
            key: "saveAs",
            value: function saveAs(file) {
                if (file) {
                    var link = document.createElement('a');
                    if (link.download !== undefined) {
                        var name = file.name, src = file.src;
                        link.setAttribute('href', src);
                        link.setAttribute('download', name);
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "createInlineStyle",
            value: function createInlineStyle(nonce, styleContainer) {
                var styleElement = document.createElement('style');
                DomHandler.addNonce(styleElement, nonce);
                if (!styleContainer) styleContainer = document.head;
                styleContainer.appendChild(styleElement);
                return styleElement;
            }
        },
        {
            key: "removeInlineStyle",
            value: function removeInlineStyle(styleElement) {
                if (this.isExist(styleElement)) {
                    try {
                        styleElement.parentNode.removeChild(styleElement);
                    } catch (error) {
                    // style element may have already been removed in a fast refresh
                    }
                    styleElement = null;
                }
                return styleElement;
            }
        },
        {
            key: "addNonce",
            value: function addNonce(styleElement, nonce) {
                try {
                    if (!nonce) nonce = undefined;
                } catch (error) {
                // NOOP
                }
                nonce && styleElement.setAttribute('nonce', nonce);
            }
        },
        {
            key: "getTargetElement",
            value: function getTargetElement(target) {
                if (!target) return null;
                if (target === 'document') return document;
                else if (target === 'window') return window;
                else if (_typeof(target) === 'object' && target.hasOwnProperty('current')) return this.isExist(target.current) ? target.current : null;
                var isFunction = function isFunction(obj) {
                    return !!(obj && obj.constructor && obj.call && obj.apply);
                };
                var element = isFunction(target) ? target() : target;
                return element && element.nodeType === 9 || this.isExist(element) ? element : null;
            }
        },
        {
            key: "getAttributeNames",
            value: function getAttributeNames(node) {
                var index;
                var rv;
                var attrs;
                rv = [];
                attrs = node.attributes;
                for(index = 0; index < attrs.length; ++index)rv.push(attrs[index].nodeName);
                rv.sort();
                return rv;
            }
        },
        {
            key: "isEqualElement",
            value: function isEqualElement(elm1, elm2) {
                var attrs1;
                var attrs2;
                var name;
                var node1;
                var node2;
                // Compare attributes without order sensitivity
                attrs1 = DomHandler.getAttributeNames(elm1);
                attrs2 = DomHandler.getAttributeNames(elm2);
                if (attrs1.join(',') !== attrs2.join(',')) // console.log("Found nodes with different sets of attributes; not equiv");
                return false;
                // ...and values
                // unless you want to compare DOM0 event handlers
                // (onclick="...")
                for(var index = 0; index < attrs1.length; ++index){
                    name = attrs1[index];
                    if (name === 'style') {
                        var astyle = elm1.style;
                        var bstyle = elm2.style;
                        var rexDigitsOnly = /^\d+$/;
                        for(var _i3 = 0, _Object$keys = Object.keys(astyle); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            if (!rexDigitsOnly.test(key) && astyle[key] !== bstyle[key]) // Not equivalent, stop
                            //console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                            return false;
                        }
                    } else if (elm1.getAttribute(name) !== elm2.getAttribute(name)) // console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                    return false;
                }
                // Walk the children
                for(node1 = elm1.firstChild, node2 = elm2.firstChild; node1 && node2; node1 = node1.nextSibling, node2 = node2.nextSibling){
                    if (node1.nodeType !== node2.nodeType) // display("Found nodes of different types; not equiv");
                    return false;
                    if (node1.nodeType === 1) {
                        // Element
                        if (!DomHandler.isEqualElement(node1, node2)) return false;
                    } else if (node1.nodeValue !== node2.nodeValue) // console.log("Found nodes with mis-matched nodeValues; not equiv");
                    return false;
                }
                if (node1 || node2) // One of the elements had more nodes than the other
                // console.log("Found more children of one element than the other; not equivalent");
                return false;
                // Seem the same
                return true;
            }
        },
        {
            key: "hasCSSAnimation",
            value: function hasCSSAnimation(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var animationDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
                    return animationDuration > 0;
                }
                return false;
            }
        },
        {
            key: "hasCSSTransition",
            value: function hasCSSTransition(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var transitionDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
                    return transitionDuration > 0;
                }
                return false;
            }
        }
    ]);
}();
/**
 * All data- properties like data-test-id
 */ _defineProperty(DomHandler, "DATA_PROPS", [
    'data-'
]);
/**
 * All ARIA properties like aria-label and focus-target for https://www.npmjs.com/package/@q42/floating-focus-a11y
 */ _defineProperty(DomHandler, "ARIA_PROPS", [
    'aria',
    'focus-target'
]);
function EventBus() {
    var allHandlers = new Map();
    return {
        on: function on(type, handler) {
            var handlers = allHandlers.get(type);
            if (!handlers) handlers = [
                handler
            ];
            else handlers.push(handler);
            allHandlers.set(type, handlers);
        },
        off: function off(type, handler) {
            var handlers = allHandlers.get(type);
            handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function emit(type, evt) {
            var handlers = allHandlers.get(type);
            handlers && handlers.slice().forEach(function(handler) {
                return handler(evt);
            });
        }
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var ObjectUtils = /*#__PURE__*/ function() {
    function ObjectUtils() {
        _classCallCheck(this, ObjectUtils);
    }
    return _createClass(ObjectUtils, null, [
        {
            key: "equals",
            value: function equals(obj1, obj2, field) {
                if (field && obj1 && _typeof(obj1) === 'object' && obj2 && _typeof(obj2) === 'object') return this.deepEquals(this.resolveFieldData(obj1, field), this.resolveFieldData(obj2, field));
                return this.deepEquals(obj1, obj2);
            }
        },
        {
            key: "deepEquals",
            value: function deepEquals(a, b) {
                if (a === b) return true;
                if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
                    var arrA = Array.isArray(a);
                    var arrB = Array.isArray(b);
                    var i;
                    var length;
                    var key;
                    if (arrA && arrB) {
                        length = a.length;
                        if (length !== b.length) return false;
                        for(i = length; i-- !== 0;){
                            if (!this.deepEquals(a[i], b[i])) return false;
                        }
                        return true;
                    }
                    if (arrA !== arrB) return false;
                    var dateA = a instanceof Date;
                    var dateB = b instanceof Date;
                    if (dateA !== dateB) return false;
                    if (dateA && dateB) return a.getTime() === b.getTime();
                    var regexpA = a instanceof RegExp;
                    var regexpB = b instanceof RegExp;
                    if (regexpA !== regexpB) return false;
                    if (regexpA && regexpB) return a.toString() === b.toString();
                    var keys = Object.keys(a);
                    length = keys.length;
                    if (length !== Object.keys(b).length) return false;
                    for(i = length; i-- !== 0;){
                        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
                    }
                    for(i = length; i-- !== 0;){
                        key = keys[i];
                        if (!this.deepEquals(a[key], b[key])) return false;
                    }
                    return true;
                }
                /*eslint no-self-compare: "off"*/ return a !== a && b !== b;
            }
        },
        {
            key: "resolveFieldData",
            value: function resolveFieldData(data, field) {
                if (!data || !field) // short circuit if there is nothing to resolve
                return null;
                try {
                    var value = data[field];
                    if (this.isNotEmpty(value)) return value;
                } catch (_unused) {
                // Performance optimization: https://github.com/primefaces/primereact/issues/4797
                // do nothing and continue to other methods to resolve field data
                }
                if (Object.keys(data).length) {
                    if (this.isFunction(field)) return field(data);
                    else if (this.isNotEmpty(data[field])) return data[field];
                    else if (field.indexOf('.') === -1) return data[field];
                    var fields = field.split('.');
                    var _value = data;
                    for(var i = 0, len = fields.length; i < len; ++i){
                        if (_value == null) return null;
                        _value = _value[fields[i]];
                    }
                    return _value;
                }
                return null;
            }
        },
        {
            key: "findDiffKeys",
            value: function findDiffKeys(obj1, obj2) {
                if (!obj1 || !obj2) return {};
                return Object.keys(obj1).filter(function(key) {
                    return !obj2.hasOwnProperty(key);
                }).reduce(function(result, current) {
                    result[current] = obj1[current];
                    return result;
                }, {});
            }
        },
        {
            key: "reduceKeys",
            value: function reduceKeys(obj, startsWiths) {
                var result = {};
                if (!obj || !startsWiths || startsWiths.length === 0) return result;
                Object.keys(obj).filter(function(key) {
                    return startsWiths.some(function(value) {
                        return key.startsWith(value);
                    });
                }).forEach(function(key) {
                    result[key] = obj[key];
                    delete obj[key];
                });
                return result;
            }
        },
        {
            key: "reorderArray",
            value: function reorderArray(value, from, to) {
                if (value && from !== to) {
                    if (to >= value.length) {
                        to = to % value.length;
                        from = from % value.length;
                    }
                    value.splice(to, 0, value.splice(from, 1)[0]);
                }
            }
        },
        {
            key: "findIndexInList",
            value: function findIndexInList(value, list, dataKey) {
                var _this = this;
                if (list) return dataKey ? list.findIndex(function(item) {
                    return _this.equals(item, value, dataKey);
                }) : list.findIndex(function(item) {
                    return item === value;
                });
                return -1;
            }
        },
        {
            key: "getJSXElement",
            value: function getJSXElement(obj) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getItemValue",
            value: function getItemValue(obj) {
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getProp",
            value: function getProp(props) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var value = props ? props[prop] : undefined;
                return value === undefined ? defaultProps[prop] : value;
            }
        },
        {
            key: "getPropCaseInsensitive",
            value: function getPropCaseInsensitive(props, prop) {
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var fkey = this.toFlatCase(prop);
                for(var key in props){
                    if (props.hasOwnProperty(key) && this.toFlatCase(key) === fkey) return props[key];
                }
                for(var _key3 in defaultProps){
                    if (defaultProps.hasOwnProperty(_key3) && this.toFlatCase(_key3) === fkey) return defaultProps[_key3];
                }
                return undefined; // Property not found
            }
        },
        {
            key: "getMergedProps",
            value: function getMergedProps(props, defaultProps) {
                return Object.assign({}, defaultProps, props);
            }
        },
        {
            key: "getDiffProps",
            value: function getDiffProps(props, defaultProps) {
                return this.findDiffKeys(props, defaultProps);
            }
        },
        {
            key: "getPropValue",
            value: function getPropValue(obj) {
                for(var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++)params[_key4 - 1] = arguments[_key4];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getComponentProp",
            value: function getComponentProp(component) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.isNotEmpty(component) ? this.getProp(component.props, prop, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentProps",
            value: function getComponentProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getMergedProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentDiffProps",
            value: function getComponentDiffProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getDiffProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "isValidChild",
            value: function isValidChild(child, type, validTypes) {
                /* eslint-disable */ if (child) {
                    var _child$type;
                    var childType = this.getComponentProp(child, '__TYPE') || (child.type ? child.type.displayName : undefined);
                    // for App Router in Next.js ^14,
                    if (!childType && child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && (_child$type = _child$type._payload) !== null && _child$type !== void 0 && _child$type.value) childType = child.type._payload.value.find(function(v) {
                        return v === type;
                    });
                    var isValid = childType === type;
                    try {
                        var messageTypes;
                    } catch (error) {
                    // NOOP
                    }
                    return isValid;
                }
                return false;
            /* eslint-enable */ }
        },
        {
            key: "getRefElement",
            value: function getRefElement(ref) {
                if (ref) return _typeof(ref) === 'object' && ref.hasOwnProperty('current') ? ref.current : ref;
                return null;
            }
        },
        {
            key: "combinedRefs",
            value: function combinedRefs(innerRef, forwardRef) {
                if (innerRef && forwardRef) {
                    if (typeof forwardRef === 'function') forwardRef(innerRef.current);
                    else forwardRef.current = innerRef.current;
                }
            }
        },
        {
            key: "removeAccents",
            value: function removeAccents(str) {
                if (str && str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, 'A').replace(/[\xC6]/g, 'AE').replace(/[\xC7]/g, 'C').replace(/[\xC8-\xCB]/g, 'E').replace(/[\xCC-\xCF]/g, 'I').replace(/[\xD0]/g, 'D').replace(/[\xD1]/g, 'N').replace(/[\xD2-\xD6\xD8]/g, 'O').replace(/[\xD9-\xDC]/g, 'U').replace(/[\xDD]/g, 'Y').replace(/[\xDE]/g, 'P').replace(/[\xE0-\xE5]/g, 'a').replace(/[\xE6]/g, 'ae').replace(/[\xE7]/g, 'c').replace(/[\xE8-\xEB]/g, 'e').replace(/[\xEC-\xEF]/g, 'i').replace(/[\xF1]/g, 'n').replace(/[\xF2-\xF6\xF8]/g, 'o').replace(/[\xF9-\xFC]/g, 'u').replace(/[\xFE]/g, 'p').replace(/[\xFD\xFF]/g, 'y');
                return str;
            }
        },
        {
            key: "toFlatCase",
            value: function toFlatCase(str) {
                // convert snake, kebab, camel and pascal cases to flat case
                return this.isNotEmpty(str) && this.isString(str) ? str.replace(/(-|_)/g, '').toLowerCase() : str;
            }
        },
        {
            key: "toCapitalCase",
            value: function toCapitalCase(str) {
                return this.isNotEmpty(str) && this.isString(str) ? str[0].toUpperCase() + str.slice(1) : str;
            }
        },
        {
            key: "trim",
            value: function trim(value) {
                // trim only if the value is actually a string
                return this.isNotEmpty(value) && this.isString(value) ? value.trim() : value;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0 || !(value instanceof Date) && _typeof(value) === 'object' && Object.keys(value).length === 0;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty(value) {
                return !this.isEmpty(value);
            }
        },
        {
            key: "isFunction",
            value: function isFunction(value) {
                return !!(value && value.constructor && value.call && value.apply);
            }
        },
        {
            key: "isObject",
            value: function isObject(value) {
                return value !== null && value instanceof Object && value.constructor === Object;
            }
        },
        {
            key: "isDate",
            value: function isDate(value) {
                return value !== null && value instanceof Date && value.constructor === Date;
            }
        },
        {
            key: "isArray",
            value: function isArray(value) {
                return value !== null && Array.isArray(value);
            }
        },
        {
            key: "isString",
            value: function isString(value) {
                return value !== null && typeof value === 'string';
            }
        },
        {
            key: "isPrintableCharacter",
            value: function isPrintableCharacter() {
                var _char = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return this.isNotEmpty(_char) && _char.length === 1 && _char.match(/\S| /);
            }
        },
        {
            key: "isLetter",
            value: function isLetter(_char2) {
                return /^[a-zA-Z\u00C0-\u017F]$/.test(_char2);
            }
        },
        {
            key: "isScalar",
            value: function isScalar(value) {
                return value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'bigint' || typeof value === 'boolean');
            }
        },
        {
            key: "findLast",
            value: function findLast(arr, callback) {
                var item;
                if (this.isNotEmpty(arr)) try {
                    item = arr.findLast(callback);
                } catch (_unused2) {
                    item = _toConsumableArray(arr).reverse().find(callback);
                }
                return item;
            }
        },
        {
            key: "findLastIndex",
            value: function findLastIndex(arr, callback) {
                var index = -1;
                if (this.isNotEmpty(arr)) try {
                    index = arr.findLastIndex(callback);
                } catch (_unused3) {
                    index = arr.lastIndexOf(_toConsumableArray(arr).reverse().find(callback));
                }
                return index;
            }
        },
        {
            key: "sort",
            value: function sort(value1, value2) {
                var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var comparator = arguments.length > 3 ? arguments[3] : undefined;
                var nullSortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
                var result = this.compare(value1, value2, comparator, order);
                var finalSortOrder = order;
                // nullSortOrder == 1 means Excel like sort nulls at bottom
                if (this.isEmpty(value1) || this.isEmpty(value2)) finalSortOrder = nullSortOrder === 1 ? order : nullSortOrder;
                return finalSortOrder * result;
            }
        },
        {
            key: "compare",
            value: function compare(value1, value2, comparator) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                var result = -1;
                var emptyValue1 = this.isEmpty(value1);
                var emptyValue2 = this.isEmpty(value2);
                if (emptyValue1 && emptyValue2) result = 0;
                else if (emptyValue1) result = order;
                else if (emptyValue2) result = -order;
                else if (typeof value1 === 'string' && typeof value2 === 'string') result = comparator(value1, value2);
                else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                return result;
            }
        },
        {
            key: "localeComparator",
            value: function localeComparator(locale) {
                //performance gain using Int.Collator. It is not recommended to use localeCompare against large arrays.
                return new Intl.Collator(locale, {
                    numeric: true
                }).compare;
            }
        },
        {
            key: "findChildrenByKey",
            value: function findChildrenByKey(data, key) {
                var _iterator = _createForOfIteratorHelper(data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        if (item.key === key) return item.children || [];
                        else if (item.children) {
                            var result = this.findChildrenByKey(item.children, key);
                            if (result.length > 0) return result;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return [];
            }
        },
        {
            key: "mutateFieldData",
            value: function mutateFieldData(data, field, value) {
                if (_typeof(data) !== 'object' || typeof field !== 'string') // short circuit if there is nothing to resolve
                return;
                var fields = field.split('.');
                var obj = data;
                for(var i = 0, len = fields.length; i < len; ++i){
                    // Check if we are on the last field
                    if (i + 1 - len === 0) {
                        obj[fields[i]] = value;
                        break;
                    }
                    if (!obj[fields[i]]) obj[fields[i]] = {};
                    obj = obj[fields[i]];
                }
            }
        }
    ]);
}();
var lastId = 0;
function UniqueComponentId() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pr_id_';
    lastId++;
    return "".concat(prefix).concat(lastId);
}
function ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$2(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var IconUtils = /*#__PURE__*/ function() {
    function IconUtils() {
        _classCallCheck(this, IconUtils);
    }
    return _createClass(IconUtils, null, [
        {
            key: "getJSXIcon",
            value: function getJSXIcon(icon) {
                var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var content = null;
                if (icon !== null) {
                    var iconType = _typeof(icon);
                    var className = classNames(iconProps.className, iconType === 'string' && icon);
                    content = /*#__PURE__*/ _react.createElement("span", _extends({}, iconProps, {
                        className: className,
                        key: UniqueComponentId('icon')
                    }));
                    if (iconType !== 'string') {
                        var defaultContentOptions = _objectSpread$2({
                            iconProps: iconProps,
                            element: content
                        }, options);
                        return ObjectUtils.getJSXElement(icon, defaultContentOptions);
                    }
                }
                return content;
            }
        }
    ]);
}();
function ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function mask(el, options) {
    var defaultOptions = {
        mask: null,
        slotChar: '_',
        autoClear: true,
        unmask: false,
        readOnly: false,
        onComplete: null,
        onChange: null,
        onFocus: null,
        onBlur: null
    };
    options = _objectSpread$1(_objectSpread$1({}, defaultOptions), options);
    var tests;
    var partialPosition;
    var len;
    var firstNonMaskPos;
    var defs;
    var androidChrome;
    var lastRequiredNonMaskPos;
    var oldVal;
    var focusText;
    var caretTimeoutId;
    var buffer;
    var defaultBuffer;
    var caret = function caret(first, last) {
        var range;
        var begin;
        var end;
        if (!el.offsetParent || el !== document.activeElement) return;
        if (typeof first === 'number') {
            begin = first;
            end = typeof last === 'number' ? last : begin;
            if (el.setSelectionRange) el.setSelectionRange(begin, end);
            else if (el.createTextRange) {
                range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                range.select();
            }
        } else {
            if (el.setSelectionRange) {
                begin = el.selectionStart;
                end = el.selectionEnd;
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                begin = 0 - range.duplicate().moveStart('character', -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++){
            if (tests[i] && buffer[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = function getPlaceholder(i) {
        if (i < options.slotChar.length) return options.slotChar.charAt(i);
        return options.slotChar.charAt(0);
    };
    var getValue = function getValue() {
        return options.unmask ? getUnmaskedValue() : el && el.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len && !tests[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i;
        var j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len; i++)if (tests[i]) {
            if (j < len && tests[i].test(buffer[j])) {
                buffer[i] = buffer[j];
                buffer[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos, begin));
    };
    var shiftR = function shiftR(pos) {
        var i;
        var c;
        var j;
        var t;
        for(i = pos, c = getPlaceholder(pos); i < len; i++)if (tests[i]) {
            j = seekNext(i);
            t = buffer[i];
            buffer[i] = c;
            if (j < len && tests[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = el.value;
        var pos = caret();
        if (oldVal && oldVal.length && oldVal.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var onBlur = function onBlur(e) {
        checkVal();
        options.onBlur && options.onBlur(e);
        updateModel(e);
        if (el.value !== focusText) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            el.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos;
        var begin;
        var end;
        oldVal = el.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || DomHandler.isIOS() && k === 127) {
            pos = caret();
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            el.value = focusText;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos = caret();
        var p;
        var c;
        var next;
        var completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len) {
                c = String.fromCharCode(k);
                if (tests[p].test(c)) {
                    shiftR(p);
                    buffer[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if (DomHandler.isAndroid()) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (options.onComplete && completed) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len; i++)if (tests[i]) buffer[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        el.value = buffer.join('');
    };
    var checkVal = function checkVal(allow) {
        //try to place characters where they belong
        var test = el.value;
        var lastMatch = -1;
        var i;
        var c;
        var pos;
        for(i = 0, pos = 0; i < len; i++)if (tests[i]) {
            buffer[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests[i].test(c)) {
                    buffer[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len);
                break;
            }
        } else {
            if (buffer[i] === test.charAt(pos)) pos++;
            if (i < partialPosition) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition) {
            if (options.autoClear || buffer.join('') === defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (el.value) el.value = '';
                clearBuffer(0, len);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            el.value = el.value.substring(0, lastMatch + 1);
        }
        return partialPosition ? i : firstNonMaskPos;
    };
    var onFocus = function onFocus(e) {
        if (options.readOnly) return;
        clearTimeout(caretTimeoutId);
        var pos;
        focusText = el.value;
        pos = checkVal();
        caretTimeoutId = setTimeout(function() {
            if (el !== document.activeElement) return;
            writeBuffer();
            if (pos === options.mask.replace('?', '').length) caret(0, pos);
            else caret(pos);
        }, 100);
        if (options.onFocus) options.onFocus(e);
    };
    var onInput = function onInput(event) {
        if (androidChrome) handleAndroidInput(event);
        else handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        if (options.readOnly) return;
        var pos = checkVal(true);
        caret(pos);
        updateModel(e);
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = function getUnmaskedValue() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.length; i++){
            var c = buffer[i];
            if (tests[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join('');
    };
    var updateModel = function updateModel(e) {
        if (options.onChange) {
            var val = getValue();
            options.onChange({
                originalEvent: e,
                value: defaultBuffer !== val ? val : '',
                stopPropagation: function stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    e.preventDefault();
                },
                target: {
                    value: defaultBuffer !== val ? val : ''
                }
            });
        }
    };
    var bindEvents = function bindEvents() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', onBlur);
        el.addEventListener('keydown', onKeyDown);
        el.addEventListener('keypress', onKeyPress);
        el.addEventListener('input', onInput);
        el.addEventListener('paste', handleInputChange);
    };
    var unbindEvents = function unbindEvents() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', onBlur);
        el.removeEventListener('keydown', onKeyDown);
        el.removeEventListener('keypress', onKeyPress);
        el.removeEventListener('input', onInput);
        el.removeEventListener('paste', handleInputChange);
    };
    var init = function init() {
        tests = [];
        partialPosition = options.mask.length;
        len = options.mask.length;
        firstNonMaskPos = null;
        defs = {
            9: '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9]'
        };
        androidChrome = DomHandler.isChrome() && DomHandler.isAndroid();
        var maskTokens = options.mask.split('');
        for(var i = 0; i < maskTokens.length; i++){
            var c = maskTokens[i];
            if (c === '?') {
                len--;
                partialPosition = i;
            } else if (defs[c]) {
                tests.push(new RegExp(defs[c]));
                if (firstNonMaskPos === null) firstNonMaskPos = tests.length - 1;
                if (i < partialPosition) lastRequiredNonMaskPos = tests.length - 1;
            } else tests.push(null);
        }
        buffer = [];
        for(var _i = 0; _i < maskTokens.length; _i++){
            var _c = maskTokens[_i];
            if (_c !== '?') {
                if (defs[_c]) buffer.push(getPlaceholder(_i));
                else buffer.push(_c);
            }
        }
        defaultBuffer = buffer.join('');
    };
    if (el && options.mask) {
        init();
        bindEvents();
    }
    return {
        init: init,
        bindEvents: bindEvents,
        unbindEvents: unbindEvents,
        updateModel: updateModel,
        getValue: getValue
    };
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Merges properties together taking an Array of props and merging into one single set of
 * properties. The options can contain a "classNameMergeFunction" which can be something
 * like Tailwind Merge for properly merging Tailwind classes.
 *
 * @param {object[]} props the array of object properties to merge
 * @param {*} options either empty or could contain a custom merge function like TailwindMerge
 * @returns the single properties value after merging
 */ function mergeProps(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!props) return undefined;
    var isFunction = function isFunction(obj) {
        return typeof obj === 'function';
    };
    var classNameMergeFunction = options.classNameMergeFunction;
    var hasMergeFunction = isFunction(classNameMergeFunction);
    return props.reduce(function(merged, ps) {
        if (!ps) return merged;
        var _loop = function _loop() {
            var value = ps[key];
            if (key === 'style') merged.style = _objectSpread(_objectSpread({}, merged.style), ps.style);
            else if (key === 'className') {
                var newClassName = '';
                if (hasMergeFunction) newClassName = classNameMergeFunction(merged.className, ps.className);
                else newClassName = [
                    merged.className,
                    ps.className
                ].join(' ').trim();
                merged.className = newClassName || undefined;
            } else if (isFunction(value)) {
                var existingFn = merged[key];
                merged[key] = existingFn ? function() {
                    existingFn.apply(void 0, arguments);
                    value.apply(void 0, arguments);
                } : value;
            } else merged[key] = value;
        };
        for(var key in ps)_loop();
        return merged;
    }, {});
}
function handler() {
    var zIndexes = [];
    var generateZIndex = function generateZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
        var lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
        var newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
        zIndexes.push({
            key: key,
            value: newZIndex
        });
        return newZIndex;
    };
    var revertZIndex = function revertZIndex(zIndex) {
        zIndexes = zIndexes.filter(function(obj) {
            return obj.value !== zIndex;
        });
    };
    var getCurrentZIndex = function getCurrentZIndex(key, autoZIndex) {
        return getLastZIndex(key, autoZIndex).value;
    };
    var getLastZIndex = function getLastZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return _toConsumableArray(zIndexes).reverse().find(function(obj) {
            return autoZIndex ? true : obj.key === key;
        }) || {
            key: key,
            value: baseZIndex
        };
    };
    var getZIndex = function getZIndex(el) {
        return el ? parseInt(el.style.zIndex, 10) || 0 : 0;
    };
    return {
        get: getZIndex,
        set: function set(key, el, autoZIndex, baseZIndex) {
            if (el) el.style.zIndex = String(generateZIndex(key, autoZIndex, baseZIndex));
        },
        clear: function clear(el) {
            if (el) {
                revertZIndex(ZIndexUtils.get(el));
                el.style.zIndex = '';
            }
        },
        getCurrent: function getCurrent(key, autoZIndex) {
            return getCurrentZIndex(key, autoZIndex);
        }
    };
}
var ZIndexUtils = handler();

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8sNt":[function(require,module,exports,__globalThis) {
/*!
* sweetalert2 v11.15.10
* Released under the MIT License.
*/ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    function _assertClassBrand(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
        return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
        _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
        return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ const globalState = {};
    const focusPreviousActiveElement = ()=>{
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ const restoreActiveElement = (returnFocus)=>{
        return new Promise((resolve)=>{
            if (!returnFocus) return resolve();
            const x = window.scrollX;
            const y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(()=>{
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    const swalPrefix = 'swal2-';
    /**
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ const classNames = [
        'container',
        'shown',
        'height-auto',
        'iosfix',
        'popup',
        'modal',
        'no-backdrop',
        'no-transition',
        'toast',
        'toast-shown',
        'show',
        'hide',
        'close',
        'title',
        'html-container',
        'actions',
        'confirm',
        'deny',
        'cancel',
        'default-outline',
        'footer',
        'icon',
        'icon-content',
        'image',
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'label',
        'textarea',
        'inputerror',
        'input-label',
        'validation-message',
        'progress-steps',
        'active-progress-step',
        'progress-step',
        'progress-step-line',
        'loader',
        'loading',
        'styled',
        'top',
        'top-start',
        'top-end',
        'top-left',
        'top-right',
        'center',
        'center-start',
        'center-end',
        'center-left',
        'center-right',
        'bottom',
        'bottom-start',
        'bottom-end',
        'bottom-left',
        'bottom-right',
        'grow-row',
        'grow-column',
        'grow-fullscreen',
        'rtl',
        'timer-progress-bar',
        'timer-progress-bar-container',
        'scrollbar-measure',
        'icon-success',
        'icon-warning',
        'icon-info',
        'icon-question',
        'icon-error',
        'draggable',
        'dragging'
    ];
    const swalClasses = classNames.reduce((acc, className)=>{
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ const icons = [
        'success',
        'warning',
        'info',
        'question',
        'error'
    ];
    const iconTypes = icons.reduce((acc, icon)=>{
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    const consolePrefix = 'SweetAlert2:';
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ const warn = (message)=>{
        console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ const error = (message)=>{
        console.error(`${consolePrefix} ${message}`);
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ const previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ const warnOnce = (message)=>{
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string?} useInstead
   */ const warnAboutDeprecation = function(deprecatedParam) {
        let useInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {Function | any} arg
   * @returns {any}
   */ const callIfFunction = (arg)=>typeof arg === 'function' ? arg() : arg;
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const hasToPromiseFn = (arg)=>arg && typeof arg.toPromise === 'function';
    /**
   * @param {any} arg
   * @returns {Promise<any>}
   */ const asPromise = (arg)=>hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const isPromise = (arg)=>arg && Promise.resolve(arg) === arg;
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ const getContainer = ()=>document.body.querySelector(`.${swalClasses.container}`);
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ const elementBySelector = (selectorString)=>{
        const container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ const elementByClass = (className)=>{
        return elementBySelector(`.${className}`);
    };
    /**
   * @returns {HTMLElement | null}
   */ const getPopup = ()=>elementByClass(swalClasses.popup);
    /**
   * @returns {HTMLElement | null}
   */ const getIcon = ()=>elementByClass(swalClasses.icon);
    /**
   * @returns {HTMLElement | null}
   */ const getIconContent = ()=>elementByClass(swalClasses['icon-content']);
    /**
   * @returns {HTMLElement | null}
   */ const getTitle = ()=>elementByClass(swalClasses.title);
    /**
   * @returns {HTMLElement | null}
   */ const getHtmlContainer = ()=>elementByClass(swalClasses['html-container']);
    /**
   * @returns {HTMLElement | null}
   */ const getImage = ()=>elementByClass(swalClasses.image);
    /**
   * @returns {HTMLElement | null}
   */ const getProgressSteps = ()=>elementByClass(swalClasses['progress-steps']);
    /**
   * @returns {HTMLElement | null}
   */ const getValidationMessage = ()=>elementByClass(swalClasses['validation-message']);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getConfirmButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getCancelButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getDenyButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`);
    /**
   * @returns {HTMLElement | null}
   */ const getInputLabel = ()=>elementByClass(swalClasses['input-label']);
    /**
   * @returns {HTMLElement | null}
   */ const getLoader = ()=>elementBySelector(`.${swalClasses.loader}`);
    /**
   * @returns {HTMLElement | null}
   */ const getActions = ()=>elementByClass(swalClasses.actions);
    /**
   * @returns {HTMLElement | null}
   */ const getFooter = ()=>elementByClass(swalClasses.footer);
    /**
   * @returns {HTMLElement | null}
   */ const getTimerProgressBar = ()=>elementByClass(swalClasses['timer-progress-bar']);
    /**
   * @returns {HTMLElement | null}
   */ const getCloseButton = ()=>elementByClass(swalClasses.close);
    // https://github.com/jkup/focusable/blob/master/index.js
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    /**
   * @returns {HTMLElement[]}
   */ const getFocusableElements = ()=>{
        const popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort((a, b)=>{
            const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
            const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ const otherFocusableElements = popup.querySelectorAll(focusable);
        const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter((el)=>el.getAttribute('tabindex') !== '-1');
        return [
            ...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))
        ].filter((el)=>isVisible$1(el));
    };
    /**
   * @returns {boolean}
   */ const isModal = ()=>{
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    /**
   * @returns {boolean}
   */ const isToast = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ const isLoading = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute('data-loading');
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ const setInnerHtml = (elem, html)=>{
        elem.textContent = '';
        if (html) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(html, `text/html`);
            const head = parsed.querySelector('head');
            if (head) Array.from(head.childNodes).forEach((child)=>{
                elem.appendChild(child);
            });
            const body = parsed.querySelector('body');
            if (body) Array.from(body.childNodes).forEach((child)=>{
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ const hasClass = (elem, className)=>{
        if (!className) return false;
        const classList = className.split(/\s+/);
        for(let i = 0; i < classList.length; i++){
            if (!elem.classList.contains(classList[i])) return false;
        }
        return true;
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ const removeCustomClasses = (elem, params)=>{
        Array.from(elem.classList).forEach((className)=>{
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ const applyCustomClass = (elem, params, className)=>{
        removeCustomClasses(elem, params);
        if (!params.customClass) return;
        const customClass = params.customClass[/** @type {keyof SweetAlertCustomClass} */ className];
        if (!customClass) return;
        if (typeof customClass !== 'string' && !customClass.forEach) {
            warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
            return;
        }
        addClass(elem, customClass);
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ const getInput$1 = (popup, inputClass)=>{
        if (!inputClass) return null;
        switch(inputClass){
            case 'select':
            case 'textarea':
            case 'file':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
            case 'checkbox':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
            case 'radio':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
            case 'range':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
            default:
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ const focusInput = (input)=>{
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== 'file') {
            // http://stackoverflow.com/a/2345915
            const val = input.value;
            input.value = '';
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ const toggleClass = (target, classList, condition)=>{
        if (!target || !classList) return;
        if (typeof classList === 'string') classList = classList.split(/\s+/).filter(Boolean);
        classList.forEach((className)=>{
            if (Array.isArray(target)) target.forEach((elem)=>{
                if (condition) elem.classList.add(className);
                else elem.classList.remove(className);
            });
            else if (condition) target.classList.add(className);
            else target.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const addClass = (target, classList)=>{
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const removeClass = (target, classList)=>{
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ const getDirectChildByClass = (elem, className)=>{
        const children = Array.from(elem.children);
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child instanceof HTMLElement && hasClass(child, className)) return child;
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {*} value
   */ const applyNumericalStyle = (elem, property, value)=>{
        if (value === `${parseInt(value)}`) value = parseInt(value);
        if (value || parseInt(value) === 0) elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : value);
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const show = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
        if (!elem) return;
        elem.style.display = display;
    };
    /**
   * @param {HTMLElement | null} elem
   */ const hide = (elem)=>{
        if (!elem) return;
        elem.style.display = 'none';
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const showWhenInnerHtmlPresent = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
        if (!elem) return;
        new MutationObserver(()=>{
            toggle(elem, elem.innerHTML, display);
        }).observe(elem, {
            childList: true,
            subtree: true
        });
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ const setStyle = (parent, selector, property, value)=>{
        /** @type {HTMLElement | null} */ const el = parent.querySelector(selector);
        if (el) el.style.setProperty(property, value);
    };
    /**
   * @param {HTMLElement} elem
   * @param {any} condition
   * @param {string} display
   */ const toggle = function(elem, condition) {
        let display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';
        if (condition) show(elem, display);
        else hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ const isVisible$1 = (elem)=>!!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    /**
   * @returns {boolean}
   */ const allButtonsAreHidden = ()=>!isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const isScrollable = (elem)=>!!(elem.scrollHeight > elem.clientHeight);
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const hasCssAnimation = (elem)=>{
        const style = window.getComputedStyle(elem);
        const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
        const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ const animateTimerProgressBar = function(timer) {
        let reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = 'none';
                timerProgressBar.style.width = '100%';
            }
            setTimeout(()=>{
                timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
                timerProgressBar.style.width = '0%';
            }, 10);
        }
    };
    const stopTimerProgressBar = ()=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty('transition');
        timerProgressBar.style.width = '100%';
        const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ const isNodeEnv = ()=>typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    /**
   * @returns {boolean}
   */ const resetOldContainer = ()=>{
        const oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses['no-backdrop'],
            swalClasses['toast-shown'],
            swalClasses['has-column']
        ]);
        return true;
    };
    const resetValidationMessage$1 = ()=>{
        globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = ()=>{
        const popup = getPopup();
        const input = getDirectChildByClass(popup, swalClasses.input);
        const file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement} */ const range = popup.querySelector(`.${swalClasses.range} input`);
        /** @type {HTMLOutputElement} */ const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
        const select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement} */ const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
        const textarea = getDirectChildByClass(popup, swalClasses.textarea);
        input.oninput = resetValidationMessage$1;
        file.onchange = resetValidationMessage$1;
        select.onchange = resetValidationMessage$1;
        checkbox.onchange = resetValidationMessage$1;
        textarea.oninput = resetValidationMessage$1;
        range.oninput = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
        range.onchange = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ const getTarget = (target)=>typeof target === 'string' ? document.querySelector(target) : target;
    /**
   * @param {SweetAlertOptions} params
   */ const setupAccessibility = (params)=>{
        const popup = getPopup();
        popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
        popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
        if (!params.toast) popup.setAttribute('aria-modal', 'true');
    };
    /**
   * @param {HTMLElement} targetElement
   */ const setupRTL = (targetElement)=>{
        if (window.getComputedStyle(targetElement).direction === 'rtl') addClass(getContainer(), swalClasses.rtl);
    };
    /**
   * Add modal + backdrop + no-war message for Russians to DOM
   *
   * @param {SweetAlertOptions} params
   */ const init = (params)=>{
        // Clean up the old popup container if it exists
        const oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error('SweetAlert2 requires document to initialize');
            return;
        }
        const container = document.createElement('div');
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses['no-transition']);
        setInnerHtml(container, sweetHTML);
        const targetElement = getTarget(params.target);
        targetElement.appendChild(container);
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ const parseHtmlToContainer = (param, target)=>{
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (typeof param === 'object') handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {any} param
   * @param {HTMLElement} target
   */ const handleObject = (param, target)=>{
        // JQuery element(s)
        if (param.jquery) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ const handleJqueryElem = (target, elem)=>{
        target.textContent = '';
        if (0 in elem) for(let i = 0; i in elem; i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderActions = (instance, params)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, 'actions');
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || '');
        applyCustomClass(loader, params, 'loader');
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, 'confirm', params);
        renderButton(denyButton, 'deny', params);
        renderButton(cancelButton, 'cancel', params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Buttons background colors
        if (params.confirmButtonColor) {
            confirmButton.style.backgroundColor = params.confirmButtonColor;
            addClass(confirmButton, swalClasses['default-outline']);
        }
        if (params.denyButtonColor) {
            denyButton.style.backgroundColor = params.denyButtonColor;
            addClass(denyButton, swalClasses['default-outline']);
        }
        if (params.cancelButtonColor) {
            cancelButton.style.backgroundColor = params.cancelButtonColor;
            addClass(cancelButton, swalClasses['default-outline']);
        }
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        const buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params[`show${buttonName}Button`], 'inline-block');
        setInnerHtml(button, params[`${buttonType}ButtonText`] || ''); // Set caption text
        button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || ''); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, `${buttonType}Button`);
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderCloseButton = (instance, params)=>{
        const closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || '');
        // Custom class
        applyCustomClass(closeButton, params, 'closeButton');
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContainer = (instance, params)=>{
        const container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, 'container');
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === 'string') container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses['no-backdrop']);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses[`grow-${grow}`]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap()
    };
    /// <reference path="../../../../sweetalert2.d.ts"/>
    /** @type {InputClass[]} */ const inputClasses = [
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'textarea'
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderInput = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        const innerParams = privateProps.innerParams.get(instance);
        const rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach((inputClass)=>{
            const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ const showInput = (params)=>{
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
            return;
        }
        const inputContainer = getInputContainer(params.input);
        if (!inputContainer) return;
        const input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(()=>{
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ const removeAttributes = (input)=>{
        for(let i = 0; i < input.attributes.length; i++){
            const attrName = input.attributes[i].name;
            if (![
                'id',
                'type',
                'value',
                'style'
            ].includes(attrName)) input.removeAttribute(attrName);
        }
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ const setAttributes = (inputClass, inputAttributes)=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getInput$1(popup, inputClass);
        if (!input) return;
        removeAttributes(input);
        for(const attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setCustomClass = (params)=>{
        if (!params.input) return;
        const inputContainer = getInputContainer(params.input);
        if (inputContainer) applyCustomClass(inputContainer, params, 'input');
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ const setInputPlaceholder = (input, params)=>{
        if (!input.placeholder && params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ const setInputLabel = (input, prependTo, params)=>{
        if (params.inputLabel) {
            const label = document.createElement('label');
            const labelClass = swalClasses['input-label'];
            label.setAttribute('for', input.id);
            label.className = labelClass;
            if (typeof params.customClass === 'object') addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement('beforebegin', label);
        }
    };
    /**
   * @param {SweetAlertInput} inputType
   * @returns {HTMLElement | undefined}
   */ const getInputContainer = (inputType)=>{
        const popup = getPopup();
        if (!popup) return;
        return getDirectChildByClass(popup, swalClasses[/** @type {SwalClass} */ inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ const checkAndSetInputValue = (input, inputValue)=>{
        if ([
            'string',
            'number'
        ].includes(typeof inputValue)) input.value = `${inputValue}`;
        else if (!isPromise(inputValue)) warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ const renderInputType = {};
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */ (input, params)=>{
        checkAndSetInputValue(input, params.inputValue);
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        input.type = params.input;
        return input;
    };
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.file = (input, params)=>{
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        return input;
    };
    /**
   * @param {HTMLInputElement} range
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.range = (range, params)=>{
        const rangeInput = range.querySelector('input');
        const rangeOutput = range.querySelector('output');
        checkAndSetInputValue(rangeInput, params.inputValue);
        rangeInput.type = params.input;
        checkAndSetInputValue(rangeOutput, params.inputValue);
        setInputLabel(rangeInput, range, params);
        return range;
    };
    /**
   * @param {HTMLSelectElement} select
   * @param {SweetAlertOptions} params
   * @returns {HTMLSelectElement}
   */ renderInputType.select = (select, params)=>{
        select.textContent = '';
        if (params.inputPlaceholder) {
            const placeholder = document.createElement('option');
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            select.appendChild(placeholder);
        }
        setInputLabel(select, select, params);
        return select;
    };
    /**
   * @param {HTMLInputElement} radio
   * @returns {HTMLInputElement}
   */ renderInputType.radio = (radio)=>{
        radio.textContent = '';
        return radio;
    };
    /**
   * @param {HTMLLabelElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.checkbox = (checkboxContainer, params)=>{
        const checkbox = getInput$1(getPopup(), 'checkbox');
        checkbox.value = '1';
        checkbox.checked = Boolean(params.inputValue);
        const label = checkboxContainer.querySelector('span');
        setInnerHtml(label, params.inputPlaceholder || params.inputLabel);
        return checkbox;
    };
    /**
   * @param {HTMLTextAreaElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {HTMLTextAreaElement}
   */ renderInputType.textarea = (textarea, params)=>{
        checkAndSetInputValue(textarea, params.inputValue);
        setInputPlaceholder(textarea, params);
        setInputLabel(textarea, textarea, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ const getMargin = (el)=>parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(()=>{
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ('MutationObserver' in window) {
                const initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
                const textareaResizeHandler = ()=>{
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textarea)) return;
                    const textareaWidth = textarea.offsetWidth + getMargin(textarea);
                    if (textareaWidth > initialPopupWidth) getPopup().style.width = `${textareaWidth}px`;
                    else applyNumericalStyle(getPopup(), 'width', params.width);
                };
                new MutationObserver(textareaResizeHandler).observe(textarea, {
                    attributes: true,
                    attributeFilter: [
                        'style'
                    ]
                });
            }
        });
        return textarea;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContent = (instance, params)=>{
        const htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        showWhenInnerHtmlPresent(htmlContainer);
        applyCustomClass(htmlContainer, params, 'htmlContainer');
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, 'block');
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, 'block');
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderFooter = (instance, params)=>{
        const footer = getFooter();
        if (!footer) return;
        showWhenInnerHtmlPresent(footer);
        toggle(footer, params.footer, 'block');
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, 'footer');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderIcon = (instance, params)=>{
        const innerParams = privateProps.innerParams.get(instance);
        const icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const applyStyles = (icon, params)=>{
        for (const [iconType, iconClassName] of Object.entries(iconTypes))if (params.icon !== iconType) removeClass(icon, iconClassName);
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, 'icon');
    };
    // Adjust success icon background color to match the popup background color
    const adjustSuccessIconBackgroundColor = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
        /** @type {NodeListOf<HTMLElement>} */ const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
        for(let i = 0; i < successIconParts.length; i++)successIconParts[i].style.backgroundColor = popupBackgroundColor;
    };
    const successIconHtml = `
  <div class="swal2-success-circular-line-left"></div>
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>
  <div class="swal2-success-circular-line-right"></div>
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setContent = (icon, params)=>{
        if (!params.icon && !params.iconHtml) return;
        let oldContent = icon.innerHTML;
        let newContent = '';
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === 'success') {
            newContent = successIconHtml;
            oldContent = oldContent.replace(/ style=".*?"/g, ''); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === 'error') newContent = errorIconHtml;
        else if (params.icon) {
            const defaultIconHtml = {
                question: '?',
                warning: '!',
                info: 'i'
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setColor = (icon, params)=>{
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for (const sel of [
            '.swal2-success-line-tip',
            '.swal2-success-line-long',
            '.swal2-x-mark-line-left',
            '.swal2-x-mark-line-right'
        ])setStyle(icon, sel, 'background-color', params.iconColor);
        setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ const iconContent = (content)=>`<div class="${swalClasses['icon-content']}">${content}</div>`;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderImage = (instance, params)=>{
        const image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, '');
        // Src, alt
        image.setAttribute('src', params.imageUrl);
        image.setAttribute('alt', params.imageAlt || '');
        // Width, height
        applyNumericalStyle(image, 'width', params.imageWidth);
        applyNumericalStyle(image, 'height', params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, 'image');
    };
    let dragging = false;
    let mousedownX = 0;
    let mousedownY = 0;
    let initialX = 0;
    let initialY = 0;
    /**
   * @param {HTMLElement} popup
   */ const addDraggableListeners = (popup)=>{
        popup.addEventListener('mousedown', down);
        document.body.addEventListener('mousemove', move);
        popup.addEventListener('mouseup', up);
        popup.addEventListener('touchstart', down);
        document.body.addEventListener('touchmove', move);
        popup.addEventListener('touchend', up);
    };
    /**
   * @param {HTMLElement} popup
   */ const removeDraggableListeners = (popup)=>{
        popup.removeEventListener('mousedown', down);
        document.body.removeEventListener('mousemove', move);
        popup.removeEventListener('mouseup', up);
        popup.removeEventListener('touchstart', down);
        document.body.removeEventListener('touchmove', move);
        popup.removeEventListener('touchend', up);
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const down = (event)=>{
        const popup = getPopup();
        if (event.target === popup || getIcon().contains(/** @type {HTMLElement} */ event.target)) {
            dragging = true;
            const clientXY = getClientXY(event);
            mousedownX = clientXY.clientX;
            mousedownY = clientXY.clientY;
            initialX = parseInt(popup.style.insetInlineStart) || 0;
            initialY = parseInt(popup.style.insetBlockStart) || 0;
            addClass(popup, 'swal2-dragging');
        }
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const move = (event)=>{
        const popup = getPopup();
        if (dragging) {
            let { clientX, clientY } = getClientXY(event);
            popup.style.insetInlineStart = `${initialX + (clientX - mousedownX)}px`;
            popup.style.insetBlockStart = `${initialY + (clientY - mousedownY)}px`;
        }
    };
    const up = ()=>{
        const popup = getPopup();
        dragging = false;
        removeClass(popup, 'swal2-dragging');
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   * @returns {{ clientX: number, clientY: number }}
   */ const getClientXY = (event)=>{
        let clientX = 0, clientY = 0;
        if (event.type.startsWith('mouse')) {
            clientX = /** @type {MouseEvent} */ event.clientX;
            clientY = /** @type {MouseEvent} */ event.clientY;
        } else if (event.type.startsWith('touch')) {
            clientX = /** @type {TouchEvent} */ event.touches[0].clientX;
            clientY = /** @type {TouchEvent} */ event.touches[0].clientY;
        }
        return {
            clientX,
            clientY
        };
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderPopup = (instance, params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, 'width', params.width);
            popup.style.width = '100%';
            const loader = getLoader();
            if (loader) popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, 'width', params.width);
        // Padding
        applyNumericalStyle(popup, 'padding', params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
        if (params.draggable && !params.toast) {
            addClass(popup, swalClasses.draggable);
            addDraggableListeners(popup);
        } else {
            removeClass(popup, swalClasses.draggable);
            removeDraggableListeners(popup);
        }
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses$1 = (popup, params)=>{
        const showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses['toast-shown']);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, 'popup');
        // TODO: remove in the next major
        if (typeof params.customClass === 'string') addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses[`icon-${params.icon}`]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderProgressSteps = (instance, params)=>{
        const progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        const { progressSteps, currentProgressStep } = params;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = '';
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach((step, index)=>{
            const stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses['active-progress-step']);
            if (index !== progressSteps.length - 1) {
                const lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ const createStepElement = (step)=>{
        const stepEl = document.createElement('li');
        addClass(stepEl, swalClasses['progress-step']);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ const createLineElement = (params)=>{
        const lineEl = document.createElement('li');
        addClass(lineEl, swalClasses['progress-step-line']);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderTitle = (instance, params)=>{
        const title = getTitle();
        if (!title) return;
        showWhenInnerHtmlPresent(title);
        toggle(title, params.title || params.titleText, 'block');
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, 'title');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const render = (instance, params)=>{
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        const popup = getPopup();
        if (typeof params.didRender === 'function' && popup) params.didRender(popup);
        globalState.eventEmitter.emit('didRender', popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ const isVisible = ()=>{
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ const clickConfirm = ()=>{
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ const clickDeny = ()=>{
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ const clickCancel = ()=>{
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @typedef {'cancel' | 'backdrop' | 'close' | 'esc' | 'timer'} DismissReason */ /** @type {Record<DismissReason, DismissReason>} */ const DismissReason = Object.freeze({
        cancel: 'cancel',
        backdrop: 'backdrop',
        close: 'close',
        esc: 'esc',
        timer: 'timer'
    });
    /**
   * @param {GlobalState} globalState
   */ const removeKeydownHandler = (globalState)=>{
        if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
            globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {*} dismissWith
   */ const addKeydownHandler = (globalState, innerParams, dismissWith)=>{
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            globalState.keydownHandler = (e)=>keydownHandler(innerParams, e, dismissWith);
            globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
            globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
            globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = true;
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   */ const setFocus = (index, increment)=>{
        var _dom$getPopup;
        const focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            return;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    const arrowKeysNextButton = [
        'ArrowRight',
        'ArrowDown'
    ];
    const arrowKeysPreviousButton = [
        'ArrowLeft',
        'ArrowUp'
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {Function} dismissWith
   */ const keydownHandler = (innerParams, event, dismissWith)=>{
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === 'Enter') handleEnter(event, innerParams);
        else if (event.key === 'Tab') handleTab(event);
        else if ([
            ...arrowKeysNextButton,
            ...arrowKeysPreviousButton
        ].includes(event.key)) handleArrows(event.key);
        else if (event.key === 'Escape') handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ const handleEnter = (event, innerParams)=>{
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        const input = getInput$1(getPopup(), innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                'textarea',
                'file'
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ const handleTab = (event)=>{
        const targetElement = event.target;
        const focusableElements = getFocusableElements();
        let btnIndex = -1;
        for(let i = 0; i < focusableElements.length; i++)if (targetElement === focusableElements[i]) {
            btnIndex = i;
            break;
        }
        // Cycle to the next button
        if (!event.shiftKey) setFocus(btnIndex, 1);
        else setFocus(btnIndex, -1);
        event.stopPropagation();
        event.preventDefault();
    };
    /**
   * @param {string} key
   */ const handleArrows = (key)=>{
        const actions = getActions();
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ const buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
        let buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(let i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const handleEsc = (event, innerParams, dismissWith)=>{
        if (callIfFunction(innerParams.allowEscapeKey)) {
            event.preventDefault();
            dismissWith(DismissReason.esc);
        }
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    const setAriaHidden = ()=>{
        const container = getContainer();
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.contains(container)) return;
            if (el.hasAttribute('aria-hidden')) el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
            el.setAttribute('aria-hidden', 'true');
        });
    };
    const unsetAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.hasAttribute('data-previous-aria-hidden')) {
                el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
                el.removeAttribute('data-previous-aria-hidden');
            } else el.removeAttribute('aria-hidden');
        });
    };
    // @ts-ignore
    const isSafariOrIOS = typeof window !== 'undefined' && !!window.GestureEvent; // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ const iOSfix = ()=>{
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            const offset = document.body.scrollTop;
            document.body.style.top = `${offset * -1}px`;
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ const lockBodyScroll = ()=>{
        const container = getContainer();
        if (!container) return;
        /** @type {boolean} */ let preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = (event)=>{
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = (event)=>{
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const shouldPreventTouchMove = (event)=>{
        const target = event.target;
        const container = getContainer();
        const htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== 'INPUT' && // #1603
        target.tagName !== 'TEXTAREA' && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {*} event
   * @returns {boolean}
   */ const isStylus = (event)=>{
        return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isZoom = (event)=>{
        return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = ()=>{
        if (hasClass(document.body, swalClasses.iosfix)) {
            const offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = '';
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ const measureScrollbar = ()=>{
        const scrollDiv = document.createElement('div');
        scrollDiv.className = swalClasses['scrollbar-measure'];
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ let previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ const replaceScrollbarWithPadding = (initialBodyOverflow)=>{
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll' // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
            document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
        }
    };
    const undoReplaceScrollbarWithPadding = ()=>{
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = `${previousBodyPadding}px`;
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(()=>triggerDidCloseAndDispose(instance, didClose));
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute('style', 'display:none !important');
            container.removeAttribute('class');
            container.innerHTML = '';
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses['height-auto'],
            swalClasses['no-backdrop'],
            swalClasses['toast-shown']
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {any} resolveValue
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        const didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    const triggerClosePopup = (instance)=>{
        const popup = getPopup();
        if (!popup) return false;
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        const backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {any} error
   */ function rejectPromise(error) {
        const rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ const handleAwaitingPromise = (instance)=>{
        if (instance.isAwaitingPromise) {
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {any} resolveValue
   * @returns {SweetAlertResult}
   */ const prepareResolveValue = (resolveValue)=>{
        // When user calls Swal.close()
        if (typeof resolveValue === 'undefined') return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ const handlePopupAnimation = (instance, popup, innerParams)=>{
        var _globalState$eventEmi;
        const container = getContainer();
        // If animation is supported, animate
        const animationIsSupported = hasCssAnimation(popup);
        if (typeof innerParams.willClose === 'function') innerParams.willClose(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willClose', popup);
        if (animationIsSupported) animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
        else // Otherwise, remove immediately
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ const animatePopup = (instance, popup, container, returnFocus, didClose)=>{
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        /**
     * @param {AnimationEvent | TransitionEvent} e
     */ const swalCloseAnimationFinished = function(e) {
            if (e.target === popup) {
                var _globalState$swalClos;
                (_globalState$swalClos = globalState.swalCloseEventFinishedCallback) === null || _globalState$swalClos === void 0 || _globalState$swalClos.call(globalState);
                delete globalState.swalCloseEventFinishedCallback;
                popup.removeEventListener('animationend', swalCloseAnimationFinished);
                popup.removeEventListener('transitionend', swalCloseAnimationFinished);
            }
        };
        popup.addEventListener('animationend', swalCloseAnimationFinished);
        popup.addEventListener('transitionend', swalCloseAnimationFinished);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} didClose
   */ const triggerDidCloseAndDispose = (instance, didClose)=>{
        setTimeout(()=>{
            var _globalState$eventEmi2;
            if (typeof didClose === 'function') didClose.bind(instance.params)();
            (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didClose');
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const showLoading = (buttonToReplace)=>{
        let popup = getPopup();
        if (!popup) new Swal();
        popup = getPopup();
        if (!popup) return;
        const loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute('data-loading', 'true');
        popup.setAttribute('aria-busy', 'true');
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const replaceButton = (popup, buttonToReplace)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute('data-button-to-replace', buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptionsAndValue = (instance, params)=>{
        if (params.input === 'select' || params.input === 'radio') handleInputOptions(instance, params);
        else if ([
            'text',
            'email',
            'number',
            'tel',
            'textarea'
        ].some((i)=>i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ const getInputValue = (instance, innerParams)=>{
        const input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case 'checkbox':
                return getCheckboxValue(input);
            case 'radio':
                return getRadioValue(input);
            case 'file':
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ const getCheckboxValue = (input)=>input.checked ? 1 : 0;
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ const getRadioValue = (input)=>input.checked ? input.value : null;
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ const getFileValue = (input)=>input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptions = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        /**
     * @param {Record<string, any>} inputOptions
     */ const processInputOptions = (inputOptions)=>{
            if (params.input === 'select') populateSelectOptions(popup, formatInputOptions(inputOptions), params);
            else if (params.input === 'radio') populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then((inputOptions)=>{
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (typeof params.inputOptions === 'object') processInputOptions(params.inputOptions);
        else error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputValue = (instance, params)=>{
        const input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then((inputValue)=>{
            input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
            show(input);
            input.focus();
            instance.hideLoading();
        }).catch((err)=>{
            error(`Error in inputValue promise: ${err}`);
            input.value = '';
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        const select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ const renderOption = (parent, optionLabel, optionValue)=>{
            const option = document.createElement('option');
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach((inputOption)=>{
            const optionValue = inputOption[0];
            const optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                const optgroup = document.createElement('optgroup');
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach((o)=>renderOption(optgroup, o[1], o[0]));
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        const radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach((inputOption)=>{
            const radioValue = inputOption[0];
            const radioLabel = inputOption[1];
            const radioInput = document.createElement('input');
            const radioLabelElement = document.createElement('label');
            radioInput.type = 'radio';
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            const label = document.createElement('span');
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        const radios = radio.querySelectorAll('input');
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {Record<string, any>} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ const formatInputOptions = (inputOptions)=>{
        /** @type {InputOptionFlattened[]} */ const result = [];
        if (inputOptions instanceof Map) inputOptions.forEach((value, key)=>{
            let valueFormatted = value;
            if (typeof valueFormatted === 'object') // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        else Object.keys(inputOptions).forEach((key)=>{
            let valueFormatted = inputOptions[key];
            if (typeof valueFormatted === 'object') // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        return result;
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ const isSelected = (optionValue, inputValue)=>{
        return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    /**
   * @param {SweetAlert} instance
   */ const handleConfirmButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, 'confirm');
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ const handleDenyButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, 'deny');
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} dismissWith
   */ const handleCancelButtonClick = (instance, dismissWith)=>{
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ const handleConfirmOrDenyWithInput = (instance, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
            return;
        }
        const input = instance.getInput();
        const inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
        } else if (type === 'deny') deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ const handleInputValidator = (instance, inputValue, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        const validationPromise = Promise.resolve().then(()=>asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
        validationPromise.then((validationMessage)=>{
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === 'deny') deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const deny = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            const preDenyPromise = Promise.resolve().then(()=>asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
            preDenyPromise.then((preDenyValue)=>{
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close({
                    isDenied: true,
                    value: typeof preDenyValue === 'undefined' ? value : preDenyValue
                });
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else instance.close({
            isDenied: true,
            value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const succeedWith = (instance, value)=>{
        instance.close({
            isConfirmed: true,
            value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ const rejectWith = (instance, error)=>{
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {any} value
   */ const confirm = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            const preConfirmPromise = Promise.resolve().then(()=>asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
            preConfirmPromise.then((preConfirmValue)=>{
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */ function hideLoading() {
        // do nothing if popup is closed
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        const domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute('aria-busy');
        domCache.popup.removeAttribute('data-loading');
        domCache.confirmButton.disabled = false;
        domCache.denyButton.disabled = false;
        domCache.cancelButton.disabled = false;
    }
    const showRelatedButton = (domCache)=>{
        const buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
        if (buttonToReplace.length) show(buttonToReplace[0], 'inline-block');
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   */ function getInput() {
        const innerParams = privateProps.innerParams.get(this);
        const domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        const domCache = privateProps.domCache.get(instance);
        buttons.forEach((button)=>{
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        const popup = getPopup();
        if (!popup || !input) return;
        if (input.type === 'radio') {
            /** @type {NodeListOf<HTMLInputElement>} */ const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
            for(let i = 0; i < radios.length; i++)radios[i].disabled = disabled;
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], false);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        const domCache = privateProps.domCache.get(this);
        const params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses['validation-message'];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', swalClasses['validation-message']);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        const domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
            removeClass(input, swalClasses.inputerror);
        }
    }
    const defaultParams = {
        title: '',
        titleText: '',
        text: '',
        html: '',
        footer: '',
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        draggable: false,
        animation: true,
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
            icon: 'swal2-icon-show'
        },
        hideClass: {
            popup: 'swal2-hide',
            backdrop: 'swal2-backdrop-hide',
            icon: 'swal2-icon-hide'
        },
        customClass: {},
        target: 'body',
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: '',
        confirmButtonColor: undefined,
        denyButtonText: 'No',
        denyButtonAriaLabel: '',
        denyButtonColor: undefined,
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: '',
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: '&times;',
        closeButtonAriaLabel: 'Close this dialog',
        loaderHtml: '',
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: '',
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: '',
        inputLabel: '',
        inputValue: '',
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: 'center',
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true
    };
    const updatableParams = [
        'allowEscapeKey',
        'allowOutsideClick',
        'background',
        'buttonsStyling',
        'cancelButtonAriaLabel',
        'cancelButtonColor',
        'cancelButtonText',
        'closeButtonAriaLabel',
        'closeButtonHtml',
        'color',
        'confirmButtonAriaLabel',
        'confirmButtonColor',
        'confirmButtonText',
        'currentProgressStep',
        'customClass',
        'denyButtonAriaLabel',
        'denyButtonColor',
        'denyButtonText',
        'didClose',
        'didDestroy',
        'draggable',
        'footer',
        'hideClass',
        'html',
        'icon',
        'iconColor',
        'iconHtml',
        'imageAlt',
        'imageHeight',
        'imageUrl',
        'imageWidth',
        'preConfirm',
        'preDeny',
        'progressSteps',
        'returnFocus',
        'reverseButtons',
        'showCancelButton',
        'showCloseButton',
        'showConfirmButton',
        'showDenyButton',
        'text',
        'title',
        'titleText',
        'willClose'
    ];
    /** @type {Record<string, string | undefined>} */ const deprecatedParams = {
        allowEnterKey: undefined
    };
    const toastIncompatibleParams = [
        'allowOutsideClick',
        'allowEnterKey',
        'backdrop',
        'draggable',
        'focusConfirm',
        'focusDeny',
        'focusCancel',
        'returnFocus',
        'heightAuto',
        'keydownListenerCapture'
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isValidParameter = (paramName)=>{
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isUpdatableParameter = (paramName)=>{
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ const isDeprecatedParameter = (paramName)=>{
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ const checkIfParamIsValid = (param)=>{
        if (!isValidParameter(param)) warn(`Unknown parameter "${param}"`);
    };
    /**
   * @param {string} param
   */ const checkIfToastParamIsValid = (param)=>{
        if (toastIncompatibleParams.includes(param)) warn(`The parameter "${param}" is incompatible with toasts`);
    };
    /**
   * @param {string} param
   */ const checkIfParamIsDeprecated = (param)=>{
        const isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ const showWarningsForParams = (params)=>{
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        for(const param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @param {SweetAlertOptions} params
   */ function update(params) {
        const popup = getPopup();
        const innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
            return;
        }
        const validUpdatableParams = filterValidParams(params);
        const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const filterValidParams = (params)=>{
        const validUpdatableParams = {};
        Object.keys(params).forEach((param)=>{
            if (isUpdatableParameter(param)) validUpdatableParams[param] = params[param];
            else warn(`Invalid parameter to update: ${param}`);
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   */ function _destroy() {
        const domCache = privateProps.domCache.get(this);
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === 'function') innerParams.didDestroy();
        globalState.eventEmitter.emit('didDestroy');
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ const disposeSwal = (instance)=>{
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ const disposeWeakMaps = (instance)=>{
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            delete instance.isAwaitingPromise;
            // Unset instance methods
            delete instance.disableButtons;
            delete instance.enableButtons;
            delete instance.getInput;
            delete instance.disableInput;
            delete instance.enableInput;
            delete instance.hideLoading;
            delete instance.disableLoading;
            delete instance.showValidationMessage;
            delete instance.resetValidationMessage;
            delete instance.close;
            delete instance.closePopup;
            delete instance.closeModal;
            delete instance.closeToast;
            delete instance.rejectPromise;
            delete instance.update;
            delete instance._destroy;
        }
    };
    /**
   * @param {object} obj
   * @param {SweetAlert} instance
   */ const unsetWeakMaps = (obj, instance)=>{
        for(const i in obj)obj[i].delete(instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handlePopupClick = (innerParams, domCache, dismissWith)=>{
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleToastClick = (innerParams, domCache, dismissWith)=>{
        // Closing toast by internal click
        domCache.popup.onclick = ()=>{
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const isAnyButtonShown = (innerParams)=>{
        return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ const handleModalMousedown = (domCache)=>{
        domCache.popup.onmousedown = ()=>{
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = ()=>{};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ const handleContainerMousedown = (domCache)=>{
        domCache.container.onmousedown = (e)=>{
            // prevent the modal text from being selected on double click on the container (allowOutsideClick: false)
            if (e.target === domCache.container) e.preventDefault();
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = ()=>{};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleModalClick = (innerParams, domCache, dismissWith)=>{
        domCache.container.onclick = (e)=>{
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    const isJqueryElement = (elem)=>typeof elem === 'object' && elem.jquery;
    const isElement = (elem)=>elem instanceof Element || isJqueryElement(elem);
    const argsToParams = (args)=>{
        const params = {};
        if (typeof args[0] === 'object' && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            'title',
            'html',
            'icon'
        ].forEach((name, index)=>{
            const arg = args[index];
            if (typeof arg === 'string' || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
        });
        return params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return new this(...args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   */ function mixin(mixinParams) {
        class MixinSwal extends this {
            _main(params, priorityMixinParams) {
                return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
            }
        }
        // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ const getTimerLeft = ()=>{
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const stopTimer = ()=>{
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const resumeTimer = ()=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const toggleTimer = ()=>{
        const timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ const increaseTimer = (ms)=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ const isTimerRunning = ()=>{
        return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    const clickHandlers = {};
    /**
   * @param {string} attr
   */ function bindClickHandler() {
        let attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener('click', bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    const bodyClickListener = (event)=>{
        for(let el = event.target; el && el !== document; el = el.parentNode)for(const attr in clickHandlers){
            const template = el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template
                });
                return;
            }
        }
    };
    // Source: https://gist.github.com/mudge/5830382?permalink_comment_id=2691957#gistcomment-2691957
    class EventEmitter {
        constructor(){
            /** @type {Events} */ this.events = {};
        }
        /**
     * @param {string} eventName
     * @returns {EventHandlers}
     */ _getHandlersByEventName(eventName) {
            if (typeof this.events[eventName] === 'undefined') // not Set because we need to keep the FIFO order
            // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1748990334
            this.events[eventName] = [];
            return this.events[eventName];
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ on(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            if (!currentHandlers.includes(eventHandler)) currentHandlers.push(eventHandler);
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ once(eventName, eventHandler) {
            var _this = this;
            /**
       * @param {Array} args
       */ const onceFn = function() {
                _this.removeListener(eventName, onceFn);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                eventHandler.apply(_this, args);
            };
            this.on(eventName, onceFn);
        }
        /**
     * @param {string} eventName
     * @param {Array} args
     */ emit(eventName) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            this._getHandlersByEventName(eventName).forEach(/**
       * @param {EventHandler} eventHandler
       */ (eventHandler)=>{
                try {
                    eventHandler.apply(this, args);
                } catch (error) {
                    console.error(error);
                }
            });
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ removeListener(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            const index = currentHandlers.indexOf(eventHandler);
            if (index > -1) currentHandlers.splice(index, 1);
        }
        /**
     * @param {string} eventName
     */ removeAllListeners(eventName) {
            if (this.events[eventName] !== undefined) // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1749239222
            this.events[eventName].length = 0;
        }
        reset() {
            this.events = {};
        }
    }
    globalState.eventEmitter = new EventEmitter();
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const on = (eventName, eventHandler)=>{
        globalState.eventEmitter.on(eventName, eventHandler);
    };
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const once = (eventName, eventHandler)=>{
        globalState.eventEmitter.once(eventName, eventHandler);
    };
    /**
   * @param {string} [eventName]
   * @param {EventHandler} [eventHandler]
   */ const off = (eventName, eventHandler)=>{
        // Remove all handlers for all events
        if (!eventName) {
            globalState.eventEmitter.reset();
            return;
        }
        if (eventHandler) // Remove a specific handler
        globalState.eventEmitter.removeListener(eventName, eventHandler);
        else // Remove all handlers for a specific event
        globalState.eventEmitter.removeAllListeners(eventName);
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        off: off,
        on: on,
        once: once,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    class Timer {
        /**
     * @param {Function} callback
     * @param {number} delay
     */ constructor(callback, delay){
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ start() {
            if (!this.running) {
                this.running = true;
                this.started = new Date();
                this.id = setTimeout(this.callback, this.remaining);
            }
            return this.remaining;
        }
        /**
     * @returns {number}
     */ stop() {
            if (this.started && this.running) {
                this.running = false;
                clearTimeout(this.id);
                this.remaining -= new Date().getTime() - this.started.getTime();
            }
            return this.remaining;
        }
        /**
     * @param {number} n
     * @returns {number}
     */ increase(n) {
            const running = this.running;
            if (running) this.stop();
            this.remaining += n;
            if (running) this.start();
            return this.remaining;
        }
        /**
     * @returns {number}
     */ getTimerLeft() {
            if (this.running) {
                this.stop();
                this.start();
            }
            return this.remaining;
        }
        /**
     * @returns {boolean}
     */ isRunning() {
            return this.running;
        }
    }
    const swalStringParams = [
        'swal-title',
        'swal-html',
        'swal-footer'
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const getTemplateParams = (params)=>{
        const template = typeof params.template === 'string' ? /** @type {HTMLTemplateElement} */ document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ const templateContent = template.content;
        showWarningsForElements(templateContent);
        const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalParams = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
        swalParams.forEach((param)=>{
            showWarningsForAttributes(param, [
                'name',
                'value'
            ]);
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            if (typeof defaultParams[paramName] === 'boolean') result[paramName] = value !== 'false';
            else if (typeof defaultParams[paramName] === 'object') result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalFunctionParams = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
        swalFunctions.forEach((param)=>{
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            result[paramName] = new Function(`return ${value}`)();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalButtons = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
        swalButtons.forEach((button)=>{
            showWarningsForAttributes(button, [
                'type',
                'color',
                'aria-label'
            ]);
            const type = button.getAttribute('type');
            if (!type || ![
                'confirm',
                'cancel',
                'deny'
            ].includes(type)) return;
            result[`${type}ButtonText`] = button.innerHTML;
            result[`show${capitalizeFirstLetter(type)}Button`] = true;
            if (button.hasAttribute('color')) result[`${type}ButtonColor`] = button.getAttribute('color');
            if (button.hasAttribute('aria-label')) result[`${type}ButtonAriaLabel`] = button.getAttribute('aria-label');
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Pick<SweetAlertOptions, 'imageUrl' | 'imageWidth' | 'imageHeight' | 'imageAlt'>}
   */ const getSwalImage = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const image = templateContent.querySelector('swal-image');
        if (image) {
            showWarningsForAttributes(image, [
                'src',
                'width',
                'height',
                'alt'
            ]);
            if (image.hasAttribute('src')) result.imageUrl = image.getAttribute('src') || undefined;
            if (image.hasAttribute('width')) result.imageWidth = image.getAttribute('width') || undefined;
            if (image.hasAttribute('height')) result.imageHeight = image.getAttribute('height') || undefined;
            if (image.hasAttribute('alt')) result.imageAlt = image.getAttribute('alt') || undefined;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalIcon = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const icon = templateContent.querySelector('swal-icon');
        if (icon) {
            showWarningsForAttributes(icon, [
                'type',
                'color'
            ]);
            if (icon.hasAttribute('type')) result.icon = icon.getAttribute('type');
            if (icon.hasAttribute('color')) result.iconColor = icon.getAttribute('color');
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalInput = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement | null} */ const input = templateContent.querySelector('swal-input');
        if (input) {
            showWarningsForAttributes(input, [
                'type',
                'label',
                'placeholder',
                'value'
            ]);
            result.input = input.getAttribute('type') || 'text';
            if (input.hasAttribute('label')) result.inputLabel = input.getAttribute('label');
            if (input.hasAttribute('placeholder')) result.inputPlaceholder = input.getAttribute('placeholder');
            if (input.hasAttribute('value')) result.inputValue = input.getAttribute('value');
        }
        /** @type {HTMLElement[]} */ const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach((option)=>{
                showWarningsForAttributes(option, [
                    'value'
                ]);
                const optionValue = option.getAttribute('value');
                if (!optionValue) return;
                const optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {Record<string, any>}
   */ const getSwalStringParams = (templateContent, paramNames)=>{
        /** @type {Record<string, any>} */ const result = {};
        for(const i in paramNames){
            const paramName = paramNames[i];
            /** @type {HTMLElement | null} */ const tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ const showWarningsForElements = (templateContent)=>{
        const allowedElements = swalStringParams.concat([
            'swal-param',
            'swal-function-param',
            'swal-button',
            'swal-image',
            'swal-icon',
            'swal-input',
            'swal-input-option'
        ]);
        Array.from(templateContent.children).forEach((el)=>{
            const tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn(`Unrecognized element <${tagName}>`);
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ const showWarningsForAttributes = (el, allowedAttributes)=>{
        Array.from(el.attributes).forEach((attribute)=>{
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                `Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`,
                `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`
            ]);
        });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ const openPopup = (params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (typeof params.willOpen === 'function') params.willOpen(popup);
        globalState.eventEmitter.emit('willOpen', popup);
        const bodyStyles = window.getComputedStyle(document.body);
        const initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(()=>{
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
            setAriaHidden();
        }
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === 'function') setTimeout(()=>params.didOpen(popup));
        globalState.eventEmitter.emit('didOpen', popup);
        removeClass(container, swalClasses['no-transition']);
    };
    /**
   * @param {AnimationEvent} event
   */ const swalOpenAnimationFinished = (event)=>{
        const popup = getPopup();
        if (event.target !== popup) return;
        const container = getContainer();
        popup.removeEventListener('animationend', swalOpenAnimationFinished);
        popup.removeEventListener('transitionend', swalOpenAnimationFinished);
        container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ const setScrollingVisibility = (container, popup)=>{
        if (hasCssAnimation(popup)) {
            container.style.overflowY = 'hidden';
            popup.addEventListener('animationend', swalOpenAnimationFinished);
            popup.addEventListener('transitionend', swalOpenAnimationFinished);
        } else container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow)=>{
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== 'hidden') replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(()=>{
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses = (container, popup, params)=>{
        addClass(container, params.showClass.backdrop);
        if (params.animation) {
            // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
            popup.style.setProperty('opacity', '0', 'important');
            show(popup, 'grid');
            setTimeout(()=>{
                // Animate popup right after showing it
                addClass(popup, params.showClass.popup);
                // and remove the opacity workaround
                popup.style.removeProperty('opacity');
            }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        } else show(popup, 'grid');
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses['height-auto']);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: (string, validationMessage)=>{
            return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: (string, validationMessage)=>{
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === 'email') params.inputValidator = defaultInputValidators['email'];
        if (params.input === 'url') params.inputValidator = defaultInputValidators['url'];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = 'body';
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === 'string') params.title = params.title.split('\n').join('<br />');
        init(params);
    }
    /** @type {SweetAlert} */ let currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    class SweetAlert {
        /**
     * @param {...any} args
     * @this {SweetAlert}
     */ constructor(){
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, void 0);
            // Prevent run in Node env
            if (typeof window === 'undefined') return;
            currentInstance = this;
            // @ts-ignore
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
        }
        _main(userParams) {
            let mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            showWarningsForParams(Object.assign({}, mixinParams, userParams));
            if (globalState.currentInstance) {
                const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
                const { isAwaitingPromise } = globalState.currentInstance;
                globalState.currentInstance._destroy();
                if (!isAwaitingPromise) swalPromiseResolve({
                    isDismissed: true
                });
                if (isModal()) unsetAriaHidden();
            }
            globalState.currentInstance = currentInstance;
            const innerParams = prepareParams(userParams, mixinParams);
            setParameters(innerParams);
            Object.freeze(innerParams);
            // clear the previous timer
            if (globalState.timeout) {
                globalState.timeout.stop();
                delete globalState.timeout;
            }
            // clear the restore focus timeout
            clearTimeout(globalState.restoreFocusTimeout);
            const domCache = populateDomCache(currentInstance);
            render(currentInstance, innerParams);
            privateProps.innerParams.set(currentInstance, innerParams);
            return swalPromise(currentInstance, domCache, innerParams);
        }
        // `catch` cannot be the name of a module export, so we define our thenable methods here instead
        then(onFulfilled) {
            return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
        }
        finally(onFinally) {
            return _classPrivateFieldGet2(_promise, this).finally(onFinally);
        }
    }
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise}
   */ const swalPromise = (instance, domCache, innerParams)=>{
        return new Promise((resolve, reject)=>{
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ const dismissWith = (dismiss)=>{
                instance.close({
                    isDismissed: true,
                    dismiss
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = ()=>{
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = ()=>{
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = ()=>{
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = ()=>{
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(()=>{
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ const prepareParams = (userParams, mixinParams)=>{
        const templateParams = getTemplateParams(userParams);
        const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        if (params.animation === false) {
            params.showClass = {
                backdrop: 'swal2-noanimation'
            };
            params.hideClass = {};
        }
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ const populateDomCache = (instance)=>{
        const domCache = {
            popup: getPopup(),
            container: getContainer(),
            actions: getActions(),
            confirmButton: getConfirmButton(),
            denyButton: getDenyButton(),
            cancelButton: getCancelButton(),
            loader: getLoader(),
            closeButton: getCloseButton(),
            validationMessage: getValidationMessage(),
            progressSteps: getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const setupTimer = (globalState, innerParams, dismissWith)=>{
        const timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(()=>{
                dismissWith('timer');
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
                setTimeout(()=>{
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(innerParams.timer);
                });
            }
        }
    };
    /**
   * Initialize focus in the popup:
   *
   * 1. If `toast` is `true`, don't steal focus from the document.
   * 2. Else if there is an [autofocus] element, focus it.
   * 3. Else if `focusConfirm` is `true` and confirm button is visible, focus it.
   * 4. Else if `focusDeny` is `true` and deny button is visible, focus it.
   * 5. Else if `focusCancel` is `true` and cancel button is visible, focus it.
   * 6. Else focus the first focusable element in a popup (if any).
   *
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ const initFocus = (domCache, innerParams)=>{
        if (innerParams.toast) return;
        // TODO: this is dumb, remove `allowEnterKey` param in the next major version
        if (!callIfFunction(innerParams.allowEnterKey)) {
            warnAboutDeprecation('allowEnterKey');
            blurActiveElement();
            return;
        }
        if (focusAutofocus(domCache)) return;
        if (focusButton(domCache, innerParams)) return;
        setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @returns {boolean}
   */ const focusAutofocus = (domCache)=>{
        const autofocusElements = Array.from(domCache.popup.querySelectorAll('[autofocus]'));
        for (const autofocusElement of autofocusElements)if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
            autofocusElement.focus();
            return true;
        }
        return false;
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const focusButton = (domCache, innerParams)=>{
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    const blurActiveElement = ()=>{
        if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
    };
    // Dear russian users visiting russian sites. Let's have fun.
    if (typeof window !== 'undefined' && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
        const now = new Date();
        const initiationDate = localStorage.getItem('swal-initiation');
        if (!initiationDate) localStorage.setItem('swal-initiation', `${now}`);
        else if ((now.getTime() - Date.parse(initiationDate)) / 86400000 > 3) setTimeout(()=>{
            document.body.style.pointerEvents = 'none';
            const ukrainianAnthem = document.createElement('audio');
            ukrainianAnthem.src = 'https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3';
            ukrainianAnthem.loop = true;
            document.body.appendChild(ukrainianAnthem);
            setTimeout(()=>{
                ukrainianAnthem.play().catch(()=>{
                // ignore
                });
            }, 2500);
        }, 500);
    }
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach((key)=>{
        /**
     * @param {...any} args
     * @returns {any | undefined}
     */ SweetAlert[key] = function() {
            if (currentInstance && currentInstance[key]) return currentInstance[key](...arguments);
            return null;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.15.10';
    const Swal = SweetAlert;
    // @ts-ignore
    Swal.default = Swal;
    return Swal;
});
if (typeof this !== 'undefined' && this.Sweetalert2) this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, "body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:rgba(0,0,0,.4)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):focus-visible{box-shadow:0 0 0 3px rgba(112,102,224,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):focus-visible{box-shadow:0 0 0 3px rgba(220,55,65,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):focus-visible{box-shadow:0 0 0 3px rgba(110,120,129,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-default-outline:focus-visible{box-shadow:0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:none;background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:1em 1.6em .3em;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:#fff}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}");

},{}]},["1Glst"], "1Glst", "parcelRequire94c2")

//# sourceMappingURL=react.e6926ce1.js.map
